(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.o3.lz === region.qc.lz)
	{
		return 'on line ' + region.o3.lz;
	}
	return 'on lines ' + region.o3.lz + ' through ' + region.qc.lz;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.zX,
		impl.H6,
		impl.G2,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		Cv: func(record.Cv),
		sZ: record.sZ,
		r5: record.r5
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.Cv;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.sZ;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.r5) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.zX,
		impl.H6,
		impl.G2,
		function(sendToApp, initialModel) {
			var view = impl.Im;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.zX,
		impl.H6,
		impl.G2,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.oW && impl.oW(sendToApp)
			var view = impl.Im;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.ks);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.HI) && (_VirtualDom_doc.title = title = doc.HI);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.C8;
	var onUrlRequest = impl.C9;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		oW: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.sd === next.sd
							&& curr.qC === next.qC
							&& curr.j3.a === next.j3.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		zX: function(flags)
		{
			return A3(impl.zX, flags, _Browser_getUrl(), key);
		},
		Im: impl.Im,
		H6: impl.H6,
		G2: impl.G2
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { zs: 'hidden', vP: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { zs: 'mozHidden', vP: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { zs: 'msHidden', vP: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { zs: 'webkitHidden', vP: 'webkitvisibilitychange' }
		: { zs: 'hidden', vP: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		F8: _Browser_getScene(),
		In: {
			tD: _Browser_window.pageXOffset,
			IE: _Browser_window.pageYOffset,
			m2: _Browser_doc.documentElement.clientWidth,
			A: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		m2: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		A: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			F8: {
				m2: node.scrollWidth,
				A: node.scrollHeight
			},
			In: {
				tD: node.scrollLeft,
				IE: node.scrollTop,
				m2: node.clientWidth,
				A: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			F8: _Browser_getScene(),
			In: {
				tD: x,
				IE: y,
				m2: _Browser_doc.documentElement.clientWidth,
				A: _Browser_doc.documentElement.clientHeight
			},
			yH: {
				tD: x + rect.left,
				IE: y + rect.top,
				m2: rect.width,
				A: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.j9.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.j9.b, xhr)); });
		$elm$core$Maybe$isJust(request.th) && _Http_track(router, xhr, request.th.a);

		try {
			xhr.open(request.lC, request.jW, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.jW));
		}

		_Http_configureRequest(xhr, request);

		request.ks.a && xhr.setRequestHeader('Content-Type', request.ks.a);
		xhr.send(request.ks.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.lt; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.lV.a || 0;
	xhr.responseType = request.j9.d;
	xhr.withCredentials = request.t9;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		jW: xhr.responseURL,
		GU: xhr.status,
		GV: xhr.statusText,
		lt: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			Gr: event.loaded,
			sS: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			Ft: event.loaded,
			sS: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.CE) { flags += 'm'; }
	if (options.vO) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $author$project$Messages$Booking = function (a) {
	return {$: 0, a: a};
};
var $author$project$Messages$GotSingleSignOnToken = function (a) {
	return {$: 5, a: a};
};
var $author$project$Messages$Offline = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$UrlChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Messages$UrlRequest = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.x) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.z),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.z);
		} else {
			var treeLen = builder.x * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.B) : builder.B;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.x);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.z) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.z);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{B: nodeList, x: (len / $elm$core$Array$branchFactor) | 0, z: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {y8: fragment, qC: host, Eh: path, j3: port_, sd: protocol, Fo: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Ports$gotSingleSignOnToken = _Platform_incomingPort(
	'gotSingleSignOnToken',
	A2(
		$elm$json$Json$Decode$andThen,
		function (token) {
			return $elm$json$Json$Decode$succeed(
				{o9: token});
		},
		A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string)));
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Common$Modal$Model$Closed = {$: 2};
var $author$project$Messages$GotServerConfig = function (a) {
	return {$: 0, a: a};
};
var $author$project$Messages$GotTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$UrlRoute$HotelLinks = {$: 19};
var $author$project$Messages$Initial = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Initial = function (a) {
	return {$: 0, a: a};
};
var $author$project$UrlRoute$Root = {$: 0};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Utils$List$appendIf = F3(
	function (condition, bList, aList) {
		return condition ? _Utils_ap(aList, bList) : aList;
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {kv: frag, kE: params, kn: unvisited, Ib: value, kM: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.kn;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.Ib);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.Ib);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.Eh),
					$elm$url$Url$Parser$prepareQuery(url.Fo),
					url.y8,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.kM;
		var unvisited = _v1.kn;
		var params = _v1.kE;
		var frag = _v1.kv;
		var value = _v1.Ib;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $author$project$UrlRoute$BookingParams = function (experimental) {
	return function (resToken) {
		return function (protractor) {
			return function (date) {
				return function (_native) {
					return function (blockBackButton) {
						return function (from) {
							return function (to) {
								return function (voyageType) {
									return function (bookingType) {
										return function (eveningDeparture) {
											return function (overnightCruise) {
												return function (isWithVehicle) {
													return function (isPaymentRejected) {
														return function (adults) {
															return function (children) {
																return function (juniors) {
																	return function (youth) {
																		return function (locale) {
																			return function (country) {
																				return function (travelClassCode) {
																					return function (travelClassAmount) {
																						return function (voucherId) {
																							return function (cabinSurprise) {
																								return function (meals) {
																									return function (redirectUrl) {
																										return function (returnUrl) {
																											return function (modal) {
																												return function (addonCodes) {
																													return function (sailPackageCode) {
																														return function (enableOvernightInDefaultSelection) {
																															return {tQ: addonCodes, pn: adults, ux: blockBackButton, vk: bookingType, l8: cabinSurprise, vV: children, nm: country, nn: date, yK: enableOvernightInDefaultSelection, yR: eveningDeparture, qi: experimental, kS: from, nT: isPaymentRejected, Az: isWithVehicle, AJ: juniors, n0: locale, rv: meals, CC: modal, oi: _native, DE: overnightCruise, se: protractor, Fv: redirectUrl, mS: resToken, sz: returnUrl, F4: sailPackageCode, le: to, H$: travelClassAmount, m$: travelClassCode, Iv: voucherId, tx: voyageType, IF: youth};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $author$project$UrlRoute$apply = F2(
	function (argParser, funcParser) {
		return A3($elm$url$Url$Parser$Query$map2, $elm$core$Basics$apL, funcParser, argParser);
	});
var $author$project$Types$VoyageType$HotelPackage = 1;
var $author$project$Types$VoyageType$bookingTypeFromString = function (input) {
	if (input === 'HOTELROUTETRIP') {
		return $elm$core$Maybe$Just(1);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Common$Modal$Model$BackToDesktop = {$: 1};
var $author$project$Types$FromTo$From = 0;
var $author$project$Common$Modal$Model$FromTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Modal$Model$MealPackage = {$: 2};
var $author$project$Common$Modal$Model$NonRefundableTerms = {$: 11};
var $author$project$Common$Modal$Model$NonRefundableWarning = {$: 12};
var $author$project$Common$Modal$Model$ResetBooking = {$: 3};
var $author$project$Common$Modal$Model$SelectVehicle = {$: 10};
var $author$project$Common$Modal$Model$SessionError = {$: 4};
var $author$project$Common$Modal$Model$ShoppingCruise = {$: 5};
var $author$project$Common$Modal$Model$SuggestAddingVehicleToOtherLeg = {$: 8};
var $author$project$Common$Modal$Model$SuggestBuyingMeals = {$: 7};
var $author$project$Common$Modal$Model$SuggestTravellingViaDifferentCity = {$: 9};
var $author$project$Common$Modal$Model$SummaryWarning = {$: 6};
var $author$project$Types$FromTo$To = 1;
var $author$project$Common$Modal$Model$fromString = function (modal) {
	switch (modal) {
		case 'from':
			return $elm$core$Maybe$Just(
				$author$project$Common$Modal$Model$FromTo(0));
		case 'to':
			return $elm$core$Maybe$Just(
				$author$project$Common$Modal$Model$FromTo(1));
		case 'backToDesktop':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$BackToDesktop);
		case 'mealPackage':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$MealPackage);
		case 'resetBooking':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$ResetBooking);
		case 'sessionError':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$SessionError);
		case 'shoppingCruise':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$ShoppingCruise);
		case 'summaryWarning':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$SummaryWarning);
		case 'suggestBuyingMeals':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$SuggestBuyingMeals);
		case 'suggestAddingVehicleToOtherLeg':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$SuggestAddingVehicleToOtherLeg);
		case 'suggestTravellingViaDifferentCity':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$SuggestTravellingViaDifferentCity);
		case 'selectVehicle':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$SelectVehicle);
		case 'nonRefundableTerms':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$NonRefundableTerms);
		case 'nonRefundableWarning':
			return $elm$core$Maybe$Just($author$project$Common$Modal$Model$NonRefundableWarning);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Port$ALA = 3;
var $author$project$Types$Port$HEL = 2;
var $author$project$Types$Port$HND = 15;
var $author$project$Types$Port$KAP = 13;
var $author$project$Types$Port$MUG = 8;
var $author$project$Types$Port$PAL = 12;
var $author$project$Types$Port$PARTY = 17;
var $author$project$Types$Port$RIG = 4;
var $author$project$Types$Port$SAS = 11;
var $author$project$Types$Port$SMA = 14;
var $author$project$Types$Port$SPE = 9;
var $author$project$Types$Port$STO = 1;
var $author$project$Types$Port$TAL = 0;
var $author$project$Types$Port$TUR = 5;
var $author$project$Types$Port$VIS = 6;
var $author$project$Types$Port$VNT = 10;
var $author$project$Types$Port$VSS = 7;
var $author$project$Types$Port$YST = 16;
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Types$Port$fromString = function (portString) {
	var _v0 = $elm$core$String$toUpper(portString);
	switch (_v0) {
		case 'TAL':
			return $elm$core$Maybe$Just(0);
		case 'STO':
			return $elm$core$Maybe$Just(1);
		case 'HEL':
			return $elm$core$Maybe$Just(2);
		case 'ALA':
			return $elm$core$Maybe$Just(3);
		case 'RIG':
			return $elm$core$Maybe$Just(4);
		case 'TUR':
			return $elm$core$Maybe$Just(5);
		case 'VIS':
			return $elm$core$Maybe$Just(6);
		case 'VSS':
			return $elm$core$Maybe$Just(7);
		case 'MUG':
			return $elm$core$Maybe$Just(8);
		case 'SPE':
			return $elm$core$Maybe$Just(9);
		case 'VNT':
			return $elm$core$Maybe$Just(10);
		case 'SAS':
			return $elm$core$Maybe$Just(11);
		case 'PAL':
			return $elm$core$Maybe$Just(12);
		case 'KAP':
			return $elm$core$Maybe$Just(13);
		case 'SMA':
			return $elm$core$Maybe$Just(14);
		case 'HND':
			return $elm$core$Maybe$Just(15);
		case 'YST':
			return $elm$core$Maybe$Just(16);
		case 'PARTY':
			return $elm$core$Maybe$Just(17);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$VoyageType$Cruise = {$: 0};
var $author$project$Types$VoyageType$CruiseMultiDeparture = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$VoyageType$CruiseMultiship = {$: 4};
var $author$project$Types$VoyageType$CruiseMultistop = {$: 5};
var $author$project$Types$VoyageType$CruiseParty = {$: 1};
var $author$project$Types$VoyageType$RouteTrip = {$: 3};
var $author$project$Types$VoyageType$ShoppingCruise = 1;
var $author$project$Types$VoyageType$Shuttle = {$: 2};
var $author$project$Types$VoyageType$fromString = function (input) {
	switch (input) {
		case 'CRUISE_PARTY':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$CruiseParty);
		case 'CRUISE':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$Cruise);
		case 'DAYCRUISE':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$Shuttle);
		case 'SHUTTLE':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$Shuttle);
		case 'CRUISE_MEGASTAR':
			return $elm$core$Maybe$Just(
				$author$project$Types$VoyageType$CruiseMultiDeparture(1));
		case 'DAYCRUISE_SHOPPING':
			return $elm$core$Maybe$Just(
				$author$project$Types$VoyageType$CruiseMultiDeparture(1));
		case 'CRUISE_MULTISHIP':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$CruiseMultiship);
		case 'ROUTETRIP':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$RouteTrip);
		case 'CRUISE_MULTI_STOP':
			return $elm$core$Maybe$Just($author$project$Types$VoyageType$CruiseMultistop);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$Query$map = F2(
	function (func, _v0) {
		var a = _v0;
		return function (dict) {
			return func(
				a(dict));
		};
	});
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Types$Ticket$TicketCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Ticket$ticketCodesQueryParser = A2(
	$elm$url$Url$Parser$Query$custom,
	'shorexCode',
	$elm$core$List$map($author$project$Types$Ticket$TicketCode));
var $elm$core$String$toLower = _String_toLower;
var $author$project$Utils$String$toBool = function (str) {
	return ($elm$core$String$toLower(str) === 'true') ? $elm$core$Maybe$Just(true) : (($elm$core$String$toLower(str) === 'false') ? $elm$core$Maybe$Just(false) : $elm$core$Maybe$Nothing);
};
var $author$project$Utils$String$toPositiveInt = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$andThen(
		function (_int) {
			return (_int <= 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(_int);
		}));
var $author$project$UrlRoute$queryParser = A2(
	$author$project$UrlRoute$apply,
	A2(
		$elm$url$Url$Parser$Query$map,
		$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
		$elm$url$Url$Parser$Query$string('enableOvernightInDefaultSelection')),
	A2(
		$author$project$UrlRoute$apply,
		$elm$url$Url$Parser$Query$string('sailPackageCode'),
		A2(
			$author$project$UrlRoute$apply,
			$author$project$Types$Ticket$ticketCodesQueryParser,
			A2(
				$author$project$UrlRoute$apply,
				A2(
					$elm$url$Url$Parser$Query$map,
					$elm$core$Maybe$andThen($author$project$Common$Modal$Model$fromString),
					$elm$url$Url$Parser$Query$string('modal')),
				A2(
					$author$project$UrlRoute$apply,
					A2(
						$elm$url$Url$Parser$Query$map,
						$elm$core$Maybe$andThen(
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$percentDecode,
								$elm$core$Maybe$andThen($elm$url$Url$fromString))),
						$elm$url$Url$Parser$Query$string('returnUrl')),
					A2(
						$author$project$UrlRoute$apply,
						$elm$url$Url$Parser$Query$string('redirectUrl'),
						A2(
							$author$project$UrlRoute$apply,
							$elm$url$Url$Parser$Query$string('meals'),
							A2(
								$author$project$UrlRoute$apply,
								$elm$url$Url$Parser$Query$string('cabinSurprise'),
								A2(
									$author$project$UrlRoute$apply,
									$elm$url$Url$Parser$Query$string('voucherId'),
									A2(
										$author$project$UrlRoute$apply,
										A2(
											$elm$url$Url$Parser$Query$map,
											$elm$core$Maybe$andThen($author$project$Utils$String$toPositiveInt),
											$elm$url$Url$Parser$Query$string('travelClassAmount')),
										A2(
											$author$project$UrlRoute$apply,
											$elm$url$Url$Parser$Query$string('travelClass'),
											A2(
												$author$project$UrlRoute$apply,
												$elm$url$Url$Parser$Query$string('country'),
												A2(
													$author$project$UrlRoute$apply,
													$elm$url$Url$Parser$Query$string('locale'),
													A2(
														$author$project$UrlRoute$apply,
														$elm$url$Url$Parser$Query$int('youths'),
														A2(
															$author$project$UrlRoute$apply,
															$elm$url$Url$Parser$Query$int('juniors'),
															A2(
																$author$project$UrlRoute$apply,
																$elm$url$Url$Parser$Query$int('children'),
																A2(
																	$author$project$UrlRoute$apply,
																	$elm$url$Url$Parser$Query$int('adults'),
																	A2(
																		$author$project$UrlRoute$apply,
																		A2(
																			$elm$url$Url$Parser$Query$map,
																			$elm$core$Maybe$andThen(
																				function (a) {
																					return (a === 'paymentRejected') ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing;
																				}),
																			$elm$url$Url$Parser$Query$string('backendError')),
																		A2(
																			$author$project$UrlRoute$apply,
																			A2(
																				$elm$url$Url$Parser$Query$map,
																				$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																				$elm$url$Url$Parser$Query$string('withVehicle')),
																			A2(
																				$author$project$UrlRoute$apply,
																				A2(
																					$elm$url$Url$Parser$Query$map,
																					$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																					$elm$url$Url$Parser$Query$string('overnightCruise')),
																				A2(
																					$author$project$UrlRoute$apply,
																					A2(
																						$elm$url$Url$Parser$Query$map,
																						$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																						$elm$url$Url$Parser$Query$string('eveningDeparture')),
																					A2(
																						$author$project$UrlRoute$apply,
																						A2(
																							$elm$url$Url$Parser$Query$map,
																							$elm$core$Maybe$andThen($author$project$Types$VoyageType$bookingTypeFromString),
																							$elm$url$Url$Parser$Query$string('voyageType')),
																						A2(
																							$author$project$UrlRoute$apply,
																							A2(
																								$elm$url$Url$Parser$Query$map,
																								$elm$core$Maybe$andThen($author$project$Types$VoyageType$fromString),
																								$elm$url$Url$Parser$Query$string('voyageType')),
																							A2(
																								$author$project$UrlRoute$apply,
																								A2(
																									$elm$url$Url$Parser$Query$map,
																									$elm$core$Maybe$andThen($author$project$Types$Port$fromString),
																									$elm$url$Url$Parser$Query$string('to')),
																								A2(
																									$author$project$UrlRoute$apply,
																									A2(
																										$elm$url$Url$Parser$Query$map,
																										$elm$core$Maybe$andThen($author$project$Types$Port$fromString),
																										$elm$url$Url$Parser$Query$string('from')),
																									A2(
																										$author$project$UrlRoute$apply,
																										A2(
																											$elm$url$Url$Parser$Query$map,
																											$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																											$elm$url$Url$Parser$Query$string('blockBackButton')),
																										A2(
																											$author$project$UrlRoute$apply,
																											A2(
																												$elm$url$Url$Parser$Query$map,
																												$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																												$elm$url$Url$Parser$Query$string('native')),
																											A2(
																												$author$project$UrlRoute$apply,
																												$elm$url$Url$Parser$Query$string('date'),
																												A2(
																													$author$project$UrlRoute$apply,
																													A2(
																														$elm$url$Url$Parser$Query$map,
																														$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																														$elm$url$Url$Parser$Query$string('protractor')),
																													A2(
																														$author$project$UrlRoute$apply,
																														$elm$url$Url$Parser$Query$string('resToken'),
																														A2(
																															$elm$url$Url$Parser$Query$map,
																															$author$project$UrlRoute$BookingParams,
																															A2(
																																$elm$url$Url$Parser$Query$map,
																																$elm$core$Maybe$andThen($author$project$Utils$String$toBool),
																																$elm$url$Url$Parser$Query$string('experimental')))))))))))))))))))))))))))))))));
var $author$project$UrlRoute$bookingParamsFromLocation = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		{tQ: _List_Nil, pn: $elm$core$Maybe$Nothing, ux: $elm$core$Maybe$Nothing, vk: $elm$core$Maybe$Nothing, l8: $elm$core$Maybe$Nothing, vV: $elm$core$Maybe$Nothing, nm: $elm$core$Maybe$Nothing, nn: $elm$core$Maybe$Nothing, yK: $elm$core$Maybe$Nothing, yR: $elm$core$Maybe$Nothing, qi: $elm$core$Maybe$Nothing, kS: $elm$core$Maybe$Nothing, nT: $elm$core$Maybe$Nothing, Az: $elm$core$Maybe$Nothing, AJ: $elm$core$Maybe$Nothing, n0: $elm$core$Maybe$Nothing, rv: $elm$core$Maybe$Nothing, CC: $elm$core$Maybe$Nothing, oi: $elm$core$Maybe$Nothing, DE: $elm$core$Maybe$Nothing, se: $elm$core$Maybe$Nothing, Fv: $elm$core$Maybe$Nothing, mS: $elm$core$Maybe$Nothing, sz: $elm$core$Maybe$Nothing, F4: $elm$core$Maybe$Nothing, le: $elm$core$Maybe$Nothing, H$: $elm$core$Maybe$Nothing, m$: $elm$core$Maybe$Nothing, Iv: $elm$core$Maybe$Nothing, tx: $elm$core$Maybe$Nothing, IF: $elm$core$Maybe$Nothing},
		A2(
			$elm$url$Url$Parser$parse,
			$elm$url$Url$Parser$query($author$project$UrlRoute$queryParser),
			_Utils_update(
				url,
				{Eh: ''})));
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Types$ServerConfig$ServerConfig = function (iki3) {
	return function (sso) {
		return function (bookingChange) {
			return function (crab) {
				return function (myJourney) {
					return function (beaver) {
						return function (liferay) {
							return function (hobs) {
								return function (paymentService) {
									return function (cookieConsent) {
										return function (showGoToDesktopButton) {
											return function (isNative) {
												return {nc: beaver, px: bookingChange, nl: cookieConsent, x7: crab, zu: hobs, d: iki3, qV: isNative, Ba: liferay, og: myJourney, ou: paymentService, GC: showGoToDesktopButton, o2: sso};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Types$ServerConfig$decoder = function (isNative) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		isNative,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'showGoToDesktopButton',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cookieConsent',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paymentService',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'hobs',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'liferay',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'beaver',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'myJourney',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'crab',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bookingChange',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sso',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'iki3',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Types$ServerConfig$ServerConfig)))))))))))));
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.GU));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {sm: reqs, s3: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.th;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.sm));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.s3)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					t9: r.t9,
					ks: r.ks,
					j9: A2(_Http_mapExpect, func, r.j9),
					lt: r.lt,
					lC: r.lC,
					lV: r.lV,
					th: r.th,
					jW: r.jW
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{t9: false, ks: r.ks, j9: r.j9, lt: r.lt, lC: r.lC, lV: r.lV, th: r.th, jW: r.jW}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{ks: $elm$http$Http$emptyBody, j9: r.j9, lt: _List_Nil, lC: 'GET', lV: $elm$core$Maybe$Nothing, th: $elm$core$Maybe$Nothing, jW: r.jW});
};
var $author$project$Api$ServerConfig$fetchConfig = F2(
	function (isNative, msg) {
		return $elm$http$Http$get(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					msg,
					$author$project$Types$ServerConfig$decoder(isNative)),
				jW: '/settings'
			});
	});
var $author$project$Types$Language$SV = 4;
var $author$project$Types$Language$default = 4;
var $author$project$Types$Market$LV = 2;
var $author$project$Types$Market$fromLocale = function (locale) {
	var _v0 = $elm$core$String$toUpper(locale);
	if (_v0 === 'LT') {
		return $elm$core$Maybe$Just(2);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Market$SE = 4;
var $author$project$Types$Market$default = 4;
var $author$project$Types$Market$DE = 6;
var $author$project$Types$Market$EE = 0;
var $author$project$Types$Market$FI = 1;
var $author$project$Types$Market$XZ = 5;
var $author$project$Types$Market$fromLanguage = function (language) {
	switch (language) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 5:
			return 0;
		case 4:
			return 4;
		case 8:
			return 6;
		case 0:
			return 5;
		case 6:
			return 5;
		case 7:
			return 5;
		default:
			return 5;
	}
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Types$Market$fromMaybeMarketAndMaybeLanguage = F2(
	function (maybeMarket, maybeLanguage) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$Market$default,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2($elm$core$Maybe$map, $author$project$Types$Market$fromLanguage, maybeLanguage),
				maybeMarket));
	});
var $author$project$Types$Language$DE = 8;
var $author$project$Types$Language$EN = 0;
var $author$project$Types$Language$ET = 1;
var $author$project$Types$Language$FI = 2;
var $author$project$Types$Language$JA = 7;
var $author$project$Types$Language$KO = 9;
var $author$project$Types$Language$LV = 3;
var $author$project$Types$Language$RU = 5;
var $author$project$Types$Language$ZH = 6;
var $author$project$Types$Language$fromString = function (input) {
	var _v0 = $elm$core$String$toUpper(input);
	switch (_v0) {
		case 'EN':
			return $elm$core$Maybe$Just(0);
		case 'ET':
			return $elm$core$Maybe$Just(1);
		case 'FI':
			return $elm$core$Maybe$Just(2);
		case 'LV':
			return $elm$core$Maybe$Just(3);
		case 'SV':
			return $elm$core$Maybe$Just(4);
		case 'RU':
			return $elm$core$Maybe$Just(5);
		case 'LT':
			return $elm$core$Maybe$Just(0);
		case 'ZH':
			return $elm$core$Maybe$Just(6);
		case 'JA':
			return $elm$core$Maybe$Just(7);
		case 'DE':
			return $elm$core$Maybe$Just(8);
		case 'KO':
			return $elm$core$Maybe$Just(9);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Market$DK = 7;
var $author$project$Types$Market$NO = 3;
var $author$project$Types$Market$fromString = function (input) {
	var _v0 = $elm$core$String$toUpper(input);
	switch (_v0) {
		case 'EE':
			return $elm$core$Maybe$Just(0);
		case 'FI':
			return $elm$core$Maybe$Just(1);
		case 'LV':
			return $elm$core$Maybe$Just(2);
		case 'NO':
			return $elm$core$Maybe$Just(3);
		case 'RU':
			return $elm$core$Maybe$Just(0);
		case 'SE':
			return $elm$core$Maybe$Just(4);
		case 'XZ':
			return $elm$core$Maybe$Just(5);
		case 'DE':
			return $elm$core$Maybe$Just(6);
		case 'DK':
			return $elm$core$Maybe$Just(7);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UrlRoute$toKeyValuePair = F2(
	function (delimiter, segment) {
		var _v0 = A2($elm$core$String$split, delimiter, segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var key = _v0.a;
			var _v1 = _v0.b;
			var value = _v1.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(key, value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$UrlRoute$getLocaleFromLocaleParamInDashedFormat = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$andThen(
		$author$project$UrlRoute$toKeyValuePair('-')),
	$elm$core$Maybe$map(
		function (_v0) {
			var languageString = _v0.a;
			var marketString = _v0.b;
			var maybeMarket = $author$project$Types$Market$fromString(marketString);
			var maybeLanguage = $author$project$Types$Language$fromString(languageString);
			return {
				A_: A2($elm$core$Maybe$withDefault, $author$project$Types$Language$default, maybeLanguage),
				rb: A2($author$project$Types$Market$fromMaybeMarketAndMaybeLanguage, maybeMarket, maybeLanguage)
			};
		}));
var $author$project$UrlRoute$getLocaleFromQueryParams = function (_v0) {
	var locale = _v0.n0;
	var country = _v0.nm;
	var maybeMarketFromLocale = A2($elm$core$Maybe$andThen, $author$project$Types$Market$fromLocale, locale);
	var maybeMarket = A2($elm$core$Maybe$andThen, $author$project$Types$Market$fromString, country);
	var maybeLanguage = A2($elm$core$Maybe$andThen, $author$project$Types$Language$fromString, locale);
	return A2(
		$elm$core$Maybe$withDefault,
		{
			A_: A2($elm$core$Maybe$withDefault, $author$project$Types$Language$default, maybeLanguage),
			rb: A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$Types$Market$fromMaybeMarketAndMaybeLanguage, maybeMarket, maybeLanguage),
				maybeMarketFromLocale)
		},
		$author$project$UrlRoute$getLocaleFromLocaleParamInDashedFormat(locale));
};
var $author$project$DataTracking$Model$init = F2(
	function (url, userAgent) {
		return {
			nf: _List_fromArray(
				[url]),
			pd: userAgent
		};
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Basics$not = _Basics_not;
var $author$project$UrlRoute$BusTransfer = {$: 6};
var $author$project$UrlRoute$BusTransferList = {$: 5};
var $author$project$UrlRoute$CompanyCustomer = {$: 14};
var $author$project$UrlRoute$ConnectionProblem = {$: 13};
var $author$project$UrlRoute$ContactPerson = {$: 11};
var $author$project$UrlRoute$Discount = {$: 17};
var $author$project$UrlRoute$ExtraServices = {$: 16};
var $author$project$UrlRoute$Hotel = function (a) {
	return {$: 21, a: a};
};
var $author$project$UrlRoute$HotelList = {$: 20};
var $author$project$UrlRoute$KlarnaPayment = {$: 12};
var $author$project$UrlRoute$LandService = {$: 18};
var $author$project$UrlRoute$Meal = {$: 10};
var $author$project$UrlRoute$OnboardServices = {$: 15};
var $author$project$UrlRoute$PassengerDetails = function (a) {
	return {$: 7, a: a};
};
var $author$project$UrlRoute$PassengerList = {$: 8};
var $author$project$UrlRoute$Payment = {$: 4};
var $author$project$UrlRoute$Timetable = function (a) {
	return {$: 1, a: a};
};
var $author$project$UrlRoute$TravelClass = {$: 9};
var $author$project$UrlRoute$Vehicle = {$: 2};
var $author$project$UrlRoute$VehicleList = {$: 3};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.kM;
			var unvisited = _v0.kn;
			var params = _v0.kE;
			var frag = _v0.kv;
			var value = _v0.Ib;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.kM;
		var unvisited = _v0.kn;
		var params = _v0.kE;
		var frag = _v0.kv;
		var value = _v0.Ib;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.kM;
			var unvisited = _v1.kn;
			var params = _v1.kE;
			var frag = _v1.kv;
			var value = _v1.Ib;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.kM;
		var unvisited = _v0.kn;
		var params = _v0.kE;
		var frag = _v0.kv;
		var value = _v0.Ib;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$UrlRoute$Cruise = {$: 0};
var $author$project$UrlRoute$CruiseMultiDeparture = {$: 1};
var $author$project$UrlRoute$CruiseMultiDepartureCalendar = {$: 2};
var $author$project$UrlRoute$RouteTrip = function (a) {
	return {$: 4, a: a};
};
var $author$project$UrlRoute$Shuttle = function (a) {
	return {$: 3, a: a};
};
var $author$project$UrlRoute$Outward = 0;
var $author$project$UrlRoute$OutwardCalendar = 1;
var $author$project$UrlRoute$Return = 2;
var $author$project$UrlRoute$ReturnCalendar = 3;
var $author$project$UrlRoute$timetableDirectionMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			0,
			$elm$url$Url$Parser$s('outward')),
			A2(
			$elm$url$Url$Parser$map,
			2,
			$elm$url$Url$Parser$s('return')),
			A2(
			$elm$url$Url$Parser$map,
			1,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('outward'),
				$elm$url$Url$Parser$s('calendar'))),
			A2(
			$elm$url$Url$Parser$map,
			3,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('return'),
				$elm$url$Url$Parser$s('calendar')))
		]));
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$UrlRoute$timetableMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Cruise,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cruise'),
				$elm$url$Url$Parser$top)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$CruiseMultiDeparture,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cruiseMultiDeparture'),
				$elm$url$Url$Parser$top)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$CruiseMultiDepartureCalendar,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cruiseMultiDeparture'),
				$elm$url$Url$Parser$s('calendar'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Shuttle,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('shuttle'),
				$author$project$UrlRoute$timetableDirectionMatcher)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$RouteTrip,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('routetrip'),
				$author$project$UrlRoute$timetableDirectionMatcher))
		]));
var $author$project$UrlRoute$matchers = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$UrlRoute$Root, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Timetable,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('timetable'),
				$author$project$UrlRoute$timetableMatcher)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Vehicle,
			$elm$url$Url$Parser$s('vehicle')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$VehicleList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('vehicle'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Payment,
			$elm$url$Url$Parser$s('paymentMethod')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$KlarnaPayment,
			$elm$url$Url$Parser$s('klarnaPage')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$BusTransferList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('busTransfer'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$BusTransfer,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('busTransfer'),
				$elm$url$Url$Parser$s('busStopInformation'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$PassengerList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('passenger'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$PassengerDetails,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('passenger'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('details'),
					$elm$url$Url$Parser$int))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$TravelClass,
			$elm$url$Url$Parser$s('travelClass')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Meal,
			$elm$url$Url$Parser$s('meal')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$ContactPerson,
			$elm$url$Url$Parser$s('contactPerson')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$ConnectionProblem,
			$elm$url$Url$Parser$s('connectionProblem')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$CompanyCustomer,
			$elm$url$Url$Parser$s('companyCustomer')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$OnboardServices,
			$elm$url$Url$Parser$s('onboardServices')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$ExtraServices,
			$elm$url$Url$Parser$s('extraServices')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Discount,
			$elm$url$Url$Parser$s('discount')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$LandService,
			$elm$url$Url$Parser$s('landService')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$HotelLinks,
			$elm$url$Url$Parser$s('hotelLinks')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$HotelList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hotel'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$UrlRoute$Hotel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hotel'),
				A2($elm$url$Url$Parser$custom, 'HOTEL CODE AS STRING', $elm$url$Url$percentDecode)))
		]));
var $author$project$UrlRoute$parseLocation = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$Parser$parse($author$project$UrlRoute$matchers),
	$elm$core$Maybe$withDefault($author$project$UrlRoute$Root));
var $author$project$Init$isValidEntryPointUrl = F2(
	function (maybeResToken, url) {
		var _v0 = $author$project$UrlRoute$parseLocation(url);
		switch (_v0.$) {
			case 4:
				return !_Utils_eq(maybeResToken, $elm$core$Maybe$Nothing);
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$contains('modal'),
							$elm$core$Basics$not),
						url.Fo));
			case 19:
				return true;
			default:
				return false;
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Utils$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $author$project$Utils$Url$absolute = F2(
	function (_v0, pathSegments) {
		var query = _v0.Fo;
		var fragment = _v0.y8;
		return A3(
			$author$project$Utils$Url$addPrefixed,
			'#',
			fragment,
			A3(
				$author$project$Utils$Url$addPrefixed,
				'?',
				query,
				'/' + A2($elm$core$String$join, '/', pathSegments)));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$UrlRoute$routeToPathSegments = function (route) {
	var directionRouteToPathSegments = function (timetableDirectionRoute) {
		switch (timetableDirectionRoute) {
			case 0:
				return _List_fromArray(
					['outward']);
			case 1:
				return _List_fromArray(
					['outward', 'calendar']);
			case 2:
				return _List_fromArray(
					['return']);
			default:
				return _List_fromArray(
					['return', 'calendar']);
		}
	};
	switch (route.$) {
		case 0:
			return _List_Nil;
		case 1:
			switch (route.a.$) {
				case 0:
					var _v1 = route.a;
					return _List_fromArray(
						['timetable', 'cruise']);
				case 1:
					var _v2 = route.a;
					return _List_fromArray(
						['timetable', 'cruiseMultiDeparture']);
				case 2:
					var _v3 = route.a;
					return _List_fromArray(
						['timetable', 'cruiseMultiDeparture', 'calendar']);
				case 3:
					var timetableDirectionRoute = route.a.a;
					return _Utils_ap(
						_List_fromArray(
							['timetable', 'shuttle']),
						directionRouteToPathSegments(timetableDirectionRoute));
				default:
					var timetableDirectionRoute = route.a.a;
					return _Utils_ap(
						_List_fromArray(
							['timetable', 'routetrip']),
						directionRouteToPathSegments(timetableDirectionRoute));
			}
		case 2:
			return _List_fromArray(
				['vehicle']);
		case 3:
			return _List_fromArray(
				['vehicle', 'list']);
		case 4:
			return _List_fromArray(
				['paymentMethod']);
		case 12:
			return _List_fromArray(
				['klarnaPage']);
		case 5:
			return _List_fromArray(
				['busTransfer', 'list']);
		case 6:
			return _List_fromArray(
				['busTransfer', 'busStopInformation']);
		case 8:
			return _List_fromArray(
				['passenger', 'list']);
		case 7:
			var seqN = route.a;
			return _List_fromArray(
				[
					'passenger',
					'details',
					$elm$core$String$fromInt(seqN)
				]);
		case 9:
			return _List_fromArray(
				['travelClass']);
		case 10:
			return _List_fromArray(
				['meal']);
		case 11:
			return _List_fromArray(
				['contactPerson']);
		case 13:
			return _List_fromArray(
				['connectionProblem']);
		case 14:
			return _List_fromArray(
				['companyCustomer']);
		case 15:
			return _List_fromArray(
				['onboardServices']);
		case 16:
			return _List_fromArray(
				['extraServices']);
		case 17:
			return _List_fromArray(
				['discount']);
		case 18:
			return _List_fromArray(
				['landService']);
		case 20:
			return _List_fromArray(
				['hotel', 'list']);
		case 21:
			var code = route.a;
			return _List_fromArray(
				['hotel', code]);
		default:
			return _List_fromArray(
				['hotelLinks']);
	}
};
var $author$project$UrlRoute$pushUrl = F3(
	function (navKey, url, route) {
		if (!navKey.$) {
			var key = navKey.a;
			return A2(
				$elm$browser$Browser$Navigation$pushUrl,
				key,
				A2(
					$author$project$Utils$Url$absolute,
					url,
					$author$project$UrlRoute$routeToPathSegments(route)));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$UrlRoute$replaceUrl = F3(
	function (navKey, url, route) {
		if (!navKey.$) {
			var key = navKey.a;
			return A2(
				$elm$browser$Browser$Navigation$replaceUrl,
				key,
				A2(
					$author$project$Utils$Url$absolute,
					url,
					$author$project$UrlRoute$routeToPathSegments(route)));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$UrlRoute$redirectToPaymentMethodPage = F3(
	function (navKey, url, _v0) {
		var resToken = _v0.mS;
		var additionalQueryParams = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2('blockBackButton', 'true')),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('resToken'),
					resToken)
				]));
		return function (a) {
			return A3(
				$author$project$UrlRoute$replaceUrl,
				navKey,
				_Utils_update(
					url,
					{
						Fo: $elm$core$Maybe$Just(a)
					}),
				$author$project$UrlRoute$Payment);
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, acc) {
						var key = _v1.a;
						var val = _v1.b;
						return (acc === '') ? (key + ('=' + val)) : (A2($elm$core$String$contains, key, acc) ? acc : (acc + ('&' + (key + ('=' + val)))));
					}),
				A2($elm$core$Maybe$withDefault, '', url.Fo),
				additionalQueryParams));
	});
var $author$project$UrlRoute$modalParam = 'modal=\\w+';
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {qH: index, BJ: match, k$: number, s2: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{vO: false, CE: false},
		string);
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$UrlRoute$removeParam = F2(
	function (url, param) {
		return function (a) {
			return _Utils_update(
				url,
				{Fo: a});
		}(
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (regex, query) {
						return A3(
							$elm$regex$Regex$replace,
							regex,
							function (_v0) {
								return '';
							},
							query);
					}),
				$elm$regex$Regex$fromString('[&]?' + param),
				url.Fo));
	});
var $author$project$UrlRoute$removeModalParam = function (url) {
	return A2($author$project$UrlRoute$removeParam, url, $author$project$UrlRoute$modalParam);
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.sd;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.y8,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.Fo,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.j3,
					_Utils_ap(http, url.qC)),
				url.Eh)));
};
var $author$project$UrlRoute$replaceUrlCrossOrigin = function (url) {
	return $elm$browser$Browser$Navigation$load(
		$elm$url$Url$toString(url));
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Types$Language$supportsHotels = function (language) {
	return !A2(
		$elm$core$List$member,
		language,
		_List_fromArray(
			[9, 7, 6]));
};
var $author$project$UrlRoute$shouldRedirectToHotelsPage = F2(
	function (url, language) {
		var voyageType = A2(
			$elm$url$Url$Parser$parse,
			$elm$url$Url$Parser$query(
				$elm$url$Url$Parser$Query$string('voyageType')),
			url);
		return _Utils_eq(
			voyageType,
			$elm$core$Maybe$Just(
				$elm$core$Maybe$Just('HOTEL'))) && $author$project$Types$Language$supportsHotels(language);
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Init$init = F3(
	function (flags, url, navKey) {
		var userAgent = A2(
			$elm$core$Result$withDefault,
			'',
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'userAgent', $elm$json$Json$Decode$string),
				flags));
		var urlParams = $author$project$UrlRoute$bookingParamsFromLocation(url);
		var isPaymentRejected = A2($elm$core$Maybe$withDefault, false, urlParams.nT);
		var isNative = A2(
			$elm$core$Result$withDefault,
			false,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'isNative', $elm$json$Json$Decode$bool),
				flags));
		var isExperimental = A2($elm$core$Maybe$withDefault, false, urlParams.qi);
		var _v0 = $author$project$UrlRoute$getLocaleFromQueryParams(urlParams);
		var language = _v0.A_;
		var market = _v0.rb;
		return _Utils_Tuple2(
			$author$project$Model$Initial(
				{
					l1: A2($author$project$DataTracking$Model$init, url, userAgent),
					y3: flags,
					Aa: isExperimental,
					AK: navKey,
					A_: language,
					rb: market,
					mI: $elm$core$Maybe$Nothing,
					CC: $author$project$Common$Modal$Model$Closed,
					oF: $elm$core$Maybe$Nothing,
					mR: false,
					Gs: $elm$core$Maybe$Nothing,
					Gt: $elm$core$Maybe$Nothing,
					kJ: $elm$core$Maybe$Nothing,
					o9: $elm$core$Maybe$Nothing,
					jW: url
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$Initial,
				$elm$core$Platform$Cmd$batch(
					function () {
						var _v1 = A2($elm$core$Maybe$andThen, $elm$url$Url$fromString, urlParams.Fv);
						if (!_v1.$) {
							var redirectUrl = _v1.a;
							return function (_v2) {
								return _List_fromArray(
									[
										$author$project$UrlRoute$replaceUrlCrossOrigin(redirectUrl)
									]);
							};
						} else {
							return isPaymentRejected ? $elm$core$List$cons(
								A3(
									$author$project$UrlRoute$redirectToPaymentMethodPage,
									navKey,
									url,
									{mS: $elm$core$Maybe$Nothing})) : (A2($author$project$Init$isValidEntryPointUrl, urlParams.mS, url) ? $elm$core$Basics$identity : $elm$core$List$cons(
								A3(
									$author$project$UrlRoute$pushUrl,
									navKey,
									$author$project$UrlRoute$removeModalParam(url),
									$author$project$UrlRoute$Root)));
						}
					}()(
						A3(
							$author$project$Utils$List$appendIf,
							A2($author$project$UrlRoute$shouldRedirectToHotelsPage, url, language),
							_List_fromArray(
								[
									A3($author$project$UrlRoute$replaceUrl, navKey, url, $author$project$UrlRoute$HotelLinks)
								]),
							_List_fromArray(
								[
									A2($author$project$Api$ServerConfig$fetchConfig, isNative, $author$project$Messages$GotServerConfig),
									A2($elm$core$Task$perform, $author$project$Messages$GotTime, $elm$time$Time$now)
								]))))));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Types$NavKey$Real = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$NavKey$realKey = function (key) {
	return $author$project$Types$NavKey$Real(key);
};
var $author$project$Messages$CalculatedSafeAreaInsetTop = function (a) {
	return {$: 127, a: a};
};
var $author$project$Messages$GotRecaptcha = function (a) {
	return {$: 136, a: a};
};
var $author$project$TravelClassPage$Messages$HideTravelClassDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$TravelClassPage$Messages$ShowTravelClassDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$SignedOut = {$: 95};
var $author$project$Messages$TravelClassPageMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Messages$UpdatedBodyWidthOnVehiclePage = function (a) {
	return {$: 92, a: a};
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Ports$calculatedSafeAreaInsetTop = _Platform_incomingPort('calculatedSafeAreaInsetTop', $elm$json$Json$Decode$int);
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Ports$onGotRecaptcha = _Platform_incomingPort('onGotRecaptcha', $elm$json$Json$Decode$value);
var $author$project$Subscriptions$onGotRecaptcha = $author$project$Ports$onGotRecaptcha(
	$elm$json$Json$Decode$decodeValue($elm$json$Json$Decode$string));
var $author$project$Ports$onHideTravelClassDescription = _Platform_incomingPort('onHideTravelClassDescription', $elm$json$Json$Decode$string);
var $author$project$Subscriptions$onHideTravelClassDescription = $author$project$Ports$onHideTravelClassDescription($elm$core$Basics$identity);
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {r2: pids, s3: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {qf: event, AK: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.r2,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.AK;
		var event = _v0.qf;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.s3);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Ports$onShowTravelClassDescription = _Platform_incomingPort('onShowTravelClassDescription', $elm$json$Json$Decode$string);
var $author$project$Subscriptions$onShowTravelClassDescription = $author$project$Ports$onShowTravelClassDescription($elm$core$Basics$identity);
var $author$project$Ports$onSignOut = _Platform_incomingPort('onSignOut', $elm$json$Json$Decode$value);
var $author$project$Subscriptions$onSignOut = $author$project$Ports$onSignOut(
	$elm$json$Json$Decode$decodeValue($elm$json$Json$Decode$bool));
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Subscriptions$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				function (_v1) {
					return $author$project$Messages$SignedOut;
				},
				$author$project$Subscriptions$onSignOut),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Messages$TravelClassPageMsg, $author$project$TravelClassPage$Messages$ShowTravelClassDescription),
				$author$project$Subscriptions$onShowTravelClassDescription),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Messages$TravelClassPageMsg, $author$project$TravelClassPage$Messages$HideTravelClassDescription),
				$author$project$Subscriptions$onHideTravelClassDescription),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (width, _v2) {
						return $author$project$Messages$UpdatedBodyWidthOnVehiclePage(width);
					})),
				$author$project$Ports$calculatedSafeAreaInsetTop($author$project$Messages$CalculatedSafeAreaInsetTop),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Messages$GotRecaptcha, $elm$core$Result$toMaybe),
				$author$project$Subscriptions$onGotRecaptcha)
			]));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Model$Booking = function (a) {
	return {$: 1, a: a};
};
var $author$project$Model$Offline = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$UrlChanged = function (a) {
	return {$: 57, a: a};
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Update$Util$andThen = F2(
	function (update, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (a) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[a, cmd]));
			},
			update(model));
	});
var $author$project$Update$RequestTimes$create = function (startTime) {
	return {F4: $elm$core$Maybe$Nothing, ld: startTime, mZ: $elm$core$Maybe$Nothing};
};
var $author$project$ConnectionProblemPage$Messages$ReceivedSessionGuid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$List$addIf = F3(
	function (condition, a, aList) {
		return condition ? _Utils_ap(
			aList,
			_List_fromArray(
				[a])) : aList;
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Api$Util$addExperimentalParamIf = function (condition) {
	return A2(
		$author$project$Utils$List$addIf,
		condition,
		A2($elm$url$Url$Builder$string, 'experimental', 'true'));
};
var $author$project$Types$Language$toString = function (locale) {
	switch (locale) {
		case 0:
			return 'EN';
		case 1:
			return 'ET';
		case 2:
			return 'FI';
		case 3:
			return 'LV';
		case 4:
			return 'SV';
		case 5:
			return 'RU';
		case 6:
			return 'ZH';
		case 7:
			return 'JA';
		case 8:
			return 'DE';
		default:
			return 'KO';
	}
};
var $author$project$Api$Util$localeParam = function (input) {
	return _Utils_Tuple2(
		'locale',
		$elm$core$String$toLower(
			$author$project$Types$Language$toString(input)));
};
var $author$project$Types$Market$toString = function (market) {
	switch (market) {
		case 0:
			return 'EE';
		case 1:
			return 'FI';
		case 2:
			return 'LV';
		case 3:
			return 'NO';
		case 4:
			return 'SE';
		case 6:
			return 'DE';
		case 7:
			return 'DK';
		default:
			return 'XZ';
	}
};
var $author$project$Api$Util$marketParam = function (input) {
	return _Utils_Tuple2(
		'country',
		$elm$core$String$toUpper(
			$author$project$Types$Market$toString(input)));
};
var $author$project$Api$Endpoint$Endpoint = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$Endpoint$nativeAppApiKeyQueryParam = A2($elm$url$Url$Builder$string, 'apiKey', 'APP');
var $author$project$Api$Endpoint$url = F5(
	function (config, prePath, pathSegments, queryParams, maybeTracker) {
		return A2(
			$author$project$Api$Endpoint$Endpoint,
			maybeTracker,
			A3(
				$elm$url$Url$Builder$crossOrigin,
				prePath,
				A2($elm$core$List$cons, 'api', pathSegments),
				A3(
					$author$project$Utils$List$addIf,
					config.qV,
					$author$project$Api$Endpoint$nativeAppApiKeyQueryParam,
					A2(
						$elm$core$List$cons,
						A2($elm$url$Url$Builder$string, 'mobile', 'true'),
						queryParams))));
	});
var $author$project$Api$Endpoint$openSession = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['session', 'open']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{t9: true, ks: r.ks, j9: r.j9, lt: r.lt, lC: r.lC, lV: r.lV, th: r.th, jW: r.jW}));
};
var $author$project$Api$Endpoint$unwrapTracker = function (_v0) {
	var tracker = _v0;
	return tracker;
};
var $author$project$Api$Endpoint$unwrapTrackerFromEndpoint = function (_v0) {
	var tracker = _v0.a;
	return A2($elm$core$Maybe$map, $author$project$Api$Endpoint$unwrapTracker, tracker);
};
var $author$project$Api$Endpoint$unwrapUrl = function (_v0) {
	var string = _v0.b;
	return string;
};
var $author$project$Api$Endpoint$riskyRequest = function (config) {
	return $elm$http$Http$riskyRequest(
		{
			ks: config.ks,
			j9: config.j9,
			lt: config.lt,
			lC: config.lC,
			lV: config.lV,
			th: $author$project$Api$Endpoint$unwrapTrackerFromEndpoint(config.jW),
			jW: $author$project$Api$Endpoint$unwrapUrl(config.jW)
		});
};
var $author$project$Api$postWithCredentials = function (r) {
	return $author$project$Api$Endpoint$riskyRequest(
		{ks: r.ks, j9: r.j9, lt: _List_Nil, lC: 'POST', lV: $elm$core$Maybe$Nothing, jW: r.jW});
};
var $author$project$Api$Guid$createGuid = F3(
	function (toMsg, serverConfig, _v0) {
		var language = _v0.A_;
		var market = _v0.rb;
		var isExperimental = _v0.Aa;
		return $author$project$Api$postWithCredentials(
			{
				ks: $elm$http$Http$emptyBody,
				j9: A2(
					$elm$http$Http$expectJson,
					toMsg,
					A2($elm$json$Json$Decode$field, 'guid', $elm$json$Json$Decode$string)),
				jW: A2(
					$author$project$Api$Endpoint$openSession,
					serverConfig,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						isExperimental,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_List_fromArray(
								[
									$author$project$Api$Util$localeParam(language),
									$author$project$Api$Util$marketParam(market)
								]))))
			});
	});
var $author$project$ConnectionProblemPage$Update$createGuid = function (_v0) {
	var httpConfig = _v0.zM;
	var language = _v0.A_;
	var market = _v0.rb;
	var isExperimental = _v0.Aa;
	return A3(
		$author$project$Api$Guid$createGuid,
		$author$project$ConnectionProblemPage$Messages$ReceivedSessionGuid,
		httpConfig.Gs,
		{Aa: isExperimental, A_: language, rb: market});
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Messages$GotClient = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Endpoint$clientLogin = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['client', 'login']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Types$Client$Client = function (firstName) {
	return function (lastName) {
		return function (clientId) {
			return function (maybeBirthday) {
				return function (citizenship) {
					return function (email) {
						return function (maybeGender) {
							return function (phone) {
								return function (zip) {
									return function (maybeClubOne) {
										return {v_: citizenship, v5: clientId, yI: email, y2: firstName, A6: lastName, re: maybeBirthday, BP: maybeClubOne, rg: maybeGender, ox: phone, jX: zip};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Client$ClubOne = F4(
	function (number, level, points, affiliates) {
		return {tX: affiliates, A8: level, k$: number, E0: points};
	});
var $author$project$Types$Client$Affiliate = F6(
	function (birthday, clientId, firstName, lastName, level, number) {
		return {uw: birthday, v5: clientId, y2: firstName, A6: lastName, A8: level, k$: number};
	});
var $author$project$Types$ClubOneLevel$Bronze = 1;
var $author$project$Types$ClubOneLevel$Club = 0;
var $author$project$Types$ClubOneLevel$Gold = 3;
var $author$project$Types$ClubOneLevel$Inactive = 5;
var $author$project$Types$ClubOneLevel$Platinum = 4;
var $author$project$Types$ClubOneLevel$Silver = 2;
var $author$project$Types$ClubOneLevel$stringToDecoder = function (input) {
	var _v0 = $elm$core$String$toLower(input);
	switch (_v0) {
		case 'gold':
			return $elm$json$Json$Decode$succeed(3);
		case 'bronze':
			return $elm$json$Json$Decode$succeed(1);
		case 'silver':
			return $elm$json$Json$Decode$succeed(2);
		case 'club':
			return $elm$json$Json$Decode$succeed(0);
		case 'platinum':
			return $elm$json$Json$Decode$succeed(4);
		case 'inactive':
			return $elm$json$Json$Decode$succeed(5);
		default:
			var randomShit = _v0;
			return $elm$json$Json$Decode$fail('Some random string: ' + randomShit);
	}
};
var $author$project$Types$ClubOneLevel$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Types$ClubOneLevel$stringToDecoder, $elm$json$Json$Decode$string);
var $author$project$Types$Date$errorToString = function (error) {
	switch (error.$) {
		case 0:
			var string = error.a;
			return 'Invalid day characters: ' + (string + '.');
		case 1:
			return 'Empty day string.';
		case 2:
			var _int = error.a;
			return 'Invalid day: ' + ($elm$core$String$fromInt(_int) + '.');
		case 3:
			var string = error.a;
			return 'Invalid month characters: ' + (string + '.');
		case 4:
			return 'Empty month string.';
		case 5:
			var _int = error.a;
			return 'Invalid month: ' + ($elm$core$String$fromInt(_int) + '.');
		case 6:
			var string = error.a;
			return 'Invalid year characters: ' + (string + '.');
		case 7:
			return 'Empty year string.';
		case 8:
			var _int = error.a;
			return 'Year number too large: ' + ($elm$core$String$fromInt(_int) + '.');
		default:
			var _int = error.a;
			return 'Year number too small: ' + ($elm$core$String$fromInt(_int) + '.');
	}
};
var $author$project$Types$Date$Date = $elm$core$Basics$identity;
var $author$project$Types$Date$InvalidDay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Date$InvalidMonth = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Types$Date$EmptyDayString = {$: 1};
var $author$project$Types$Date$InvalidDayCharacters = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$filter = _String_filter;
var $author$project$Types$Date$intFromString = function (string) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Result$Err(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, string)),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Result$Ok,
			$elm$core$String$toInt(string)));
};
var $author$project$Types$Date$dayIntFromString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Result$Err($author$project$Types$Date$EmptyDayString) : A2(
		$elm$core$Result$andThen,
		function (_int) {
			return (_int > 31) ? $elm$core$Result$Err(
				$author$project$Types$Date$InvalidDay(_int)) : $elm$core$Result$Ok(_int);
		},
		A2(
			$elm$core$Result$mapError,
			$author$project$Types$Date$InvalidDayCharacters,
			$author$project$Types$Date$intFromString(string)));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Utils$Time$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $author$project$Utils$Time$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $author$project$Utils$Time$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Types$Date$isValidDay = function (_v0) {
	var day = _v0.q;
	var month = _v0.s;
	var year = _v0.h;
	return (_Utils_cmp(
		day,
		A2($author$project$Utils$Time$daysInMonth, year, month)) < 1) && (day >= 1);
};
var $elm$core$Result$map3 = F4(
	function (func, ra, rb, rc) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				if (rc.$ === 1) {
					var x = rc.a;
					return $elm$core$Result$Err(x);
				} else {
					var c = rc.a;
					return $elm$core$Result$Ok(
						A3(func, a, b, c));
				}
			}
		}
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $author$project$Utils$Time$monthFromInt = function (_int) {
	switch (_int) {
		case 1:
			return $elm$core$Maybe$Just(0);
		case 2:
			return $elm$core$Maybe$Just(1);
		case 3:
			return $elm$core$Maybe$Just(2);
		case 4:
			return $elm$core$Maybe$Just(3);
		case 5:
			return $elm$core$Maybe$Just(4);
		case 6:
			return $elm$core$Maybe$Just(5);
		case 7:
			return $elm$core$Maybe$Just(6);
		case 8:
			return $elm$core$Maybe$Just(7);
		case 9:
			return $elm$core$Maybe$Just(8);
		case 10:
			return $elm$core$Maybe$Just(9);
		case 11:
			return $elm$core$Maybe$Just(10);
		case 12:
			return $elm$core$Maybe$Just(11);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Date$EmptyMonthString = {$: 4};
var $author$project$Types$Date$InvalidMonthCharacters = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Date$monthIntFromString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Result$Err($author$project$Types$Date$EmptyMonthString) : A2(
		$elm$core$Result$mapError,
		$author$project$Types$Date$InvalidMonthCharacters,
		$author$project$Types$Date$intFromString(string));
};
var $author$project$Types$Date$EmptyYearString = {$: 7};
var $author$project$Types$Date$InvalidYearCharacters = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$Date$yearIntFromString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Result$Err($author$project$Types$Date$EmptyYearString) : A2(
		$elm$core$Result$mapError,
		$author$project$Types$Date$InvalidYearCharacters,
		$author$project$Types$Date$intFromString(string));
};
var $author$project$Types$Date$fromStringValues = function (form) {
	return A2(
		$elm$core$Result$andThen,
		function (_v0) {
			var dayInt = _v0.a;
			var monthInt = _v0.b;
			var yearInt = _v0.c;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Result$Err(
					$author$project$Types$Date$InvalidMonth(monthInt)),
				A2(
					$elm$core$Maybe$map,
					function (date) {
						return (!$author$project$Types$Date$isValidDay(date)) ? $elm$core$Result$Err(
							$author$project$Types$Date$InvalidDay(date.q)) : $elm$core$Result$Ok(date);
					},
					A2(
						$elm$core$Maybe$map,
						function (month) {
							return {q: dayInt, s: month, h: yearInt};
						},
						$author$project$Utils$Time$monthFromInt(monthInt))));
		},
		A4(
			$elm$core$Result$map3,
			F3(
				function (a, b, c) {
					return _Utils_Tuple3(a, b, c);
				}),
			$author$project$Types$Date$dayIntFromString(form.q),
			$author$project$Types$Date$monthIntFromString(form.s),
			$author$project$Types$Date$yearIntFromString(form.h)));
};
var $author$project$Types$Date$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Types$Date$fromStringValues,
		function (result) {
			if (!result.$) {
				var date = result.a;
				return $elm$json$Json$Decode$succeed(date);
			} else {
				var error = result.a;
				return $elm$json$Json$Decode$fail(
					$author$project$Types$Date$errorToString(error));
			}
		}),
	A2(
		$elm$json$Json$Decode$map,
		function (birthdayDateList) {
			if (((birthdayDateList.b && birthdayDateList.b.b) && birthdayDateList.b.b.b) && (!birthdayDateList.b.b.b.b)) {
				var year = birthdayDateList.a;
				var _v1 = birthdayDateList.b;
				var month = _v1.a;
				var _v2 = _v1.b;
				var day = _v2.a;
				return {q: day, s: month, h: year};
			} else {
				return {q: '', s: '', h: ''};
			}
		},
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split('-'),
				$elm$json$Json$Decode$succeed),
			$elm$json$Json$Decode$string)));
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Types$Client$decodeAffiliate = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'clubOneNumber',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clubOneLevel',
		$elm$json$Json$Decode$maybe($author$project$Types$ClubOneLevel$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'lastName',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'firstName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'clientId',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'birthday',
						$author$project$Types$Date$decoder,
						$elm$json$Json$Decode$succeed($author$project$Types$Client$Affiliate)))))));
var $author$project$Utils$String$decodeNonEmpty = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return $elm$core$String$isEmpty(string) ? $elm$json$Json$Decode$fail(string) : $elm$json$Json$Decode$succeed(string);
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Gender$F = 0;
var $author$project$Types$Gender$M = 1;
var $author$project$Types$Gender$stringToGender = function (input) {
	switch (input) {
		case 'F':
			return $elm$json$Json$Decode$succeed(0);
		case 'M':
			return $elm$json$Json$Decode$succeed(1);
		default:
			var randomShit = input;
			return $elm$json$Json$Decode$fail('Some random string: ' + randomShit);
	}
};
var $author$project$Types$Gender$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Types$Gender$stringToGender, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Types$Client$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$maybe(
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'household',
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$map,
					function (affiliate) {
						return _Utils_update(
							affiliate,
							{
								y2: $elm$core$String$toLower(affiliate.y2),
								A6: $elm$core$String$toLower(affiliate.A6)
							});
					},
					$author$project$Types$Client$decodeAffiliate)),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clubOnePoints',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'clubOneLevel',
					$author$project$Types$ClubOneLevel$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'clubOneNumber',
						$author$project$Utils$String$decodeNonEmpty,
						$elm$json$Json$Decode$succeed($author$project$Types$Client$ClubOne)))))),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'zip',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'gender',
				$elm$json$Json$Decode$maybe($author$project$Types$Gender$decoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'citizenship',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'birthday',
							$elm$json$Json$Decode$maybe($author$project$Types$Date$decoder),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'clientId',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'lastName',
									A2($elm$json$Json$Decode$map, $elm$core$String$toLower, $elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'firstName',
										A2($elm$json$Json$Decode$map, $elm$core$String$toLower, $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Types$Client$Client)))))))))));
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Api$getWithCredentials = function (r) {
	return $author$project$Api$Endpoint$riskyRequest(
		{ks: $elm$http$Http$emptyBody, j9: r.j9, lt: _List_Nil, lC: 'GET', lV: $elm$core$Maybe$Nothing, jW: r.jW});
};
var $author$project$Api$Util$guidParam = function (input) {
	return _Utils_Tuple2('sessionGUID', input);
};
var $author$project$Api$Util$ssoTokenParam = function (input) {
	return _Utils_Tuple2('ssoToken', input);
};
var $author$project$Api$Client$fetchWithToken = F3(
	function (params, ssoToken, _v0) {
		var serverConfig = _v0.Gs;
		var sessionGuid = _v0.Gt;
		var queryParams = A2(
			$author$project$Api$Util$addExperimentalParamIf,
			params.Aa,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				_List_fromArray(
					[
						$author$project$Api$Util$guidParam(sessionGuid),
						$author$project$Api$Util$localeParam(params.A_),
						$author$project$Api$Util$marketParam(params.rb),
						$author$project$Api$Util$ssoTokenParam(ssoToken)
					])));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Messages$GotClient),
					$author$project$Types$Client$decoder),
				jW: A2($author$project$Api$Endpoint$clientLogin, serverConfig, queryParams)
			});
	});
var $author$project$Update$User$updateUser = F2(
	function (user, model) {
		var session = model.j;
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{Ia: user})
			});
	});
var $author$project$Update$User$fetchClient = F2(
	function (model, token) {
		return _Utils_Tuple2(
			A2(
				$author$project$Update$User$updateUser,
				{
					v4: $krisajenkins$remotedata$RemoteData$Loading,
					Cb: $elm$core$Maybe$Just(token)
				},
				model),
			A3($author$project$Api$Client$fetchWithToken, model.j, token, model.j.zM));
	});
var $author$project$Types$Trips$Loading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$GotCruiseMultiDepartureTrips = function (a) {
	return {$: 20, a: a};
};
var $author$project$Messages$GotTrips = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Types$Direction$OUTWARD = 0;
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {q: d, s: m, h: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		op: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		h: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.h, 0, date.op);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.h - 1)) + ($justinmimbs$date$Date$monthToNumber(date.s) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.q,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.o3, posixMinutes) < 0) {
					return posixMinutes + era.c;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		q: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		s: month,
		h: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).q;
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).s;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).h;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $author$project$Api$Timetable$amountOfWeeksToFetch = 4;
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $justinmimbs$time_extra$Time$Extra$Hour = 12;
var $author$project$Constants$arrivalTimeHoursShift = -5;
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			q: A2($elm$time$Time$toDay, zone, posix),
			nE: A2($elm$time$Time$toHour, zone, posix),
			oc: A2($elm$time$Time$toMillis, zone, posix),
			oe: A2($elm$time$Time$toMinute, zone, posix),
			s: A2($elm$time$Time$toMonth, zone, posix),
			oO: A2($elm$time$Time$toSecond, zone, posix),
			h: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Types$RouteTripSails$haveNightBetweenSails = F2(
	function (outwardSail, returnSail) {
		var returnParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, $elm$time$Time$utc, returnSail.nr);
		var arrivalTimeWithShift = A4($justinmimbs$time_extra$Time$Extra$add, 12, $author$project$Constants$arrivalTimeHoursShift, $elm$time$Time$utc, outwardSail.ps);
		var outwardParts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, $elm$time$Time$utc, arrivalTimeWithShift);
		return (_Utils_cmp(
			$elm$time$Time$posixToMillis(outwardSail.ps),
			$elm$time$Time$posixToMillis(returnSail.nr)) < 0) && ((!_Utils_eq(outwardParts.q, returnParts.q)) || ((!_Utils_eq(outwardParts.s, returnParts.s)) || (!_Utils_eq(outwardParts.h, returnParts.h))));
	});
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.s;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 14:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000) | 0;
				case 13:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000) | 0;
				case 12:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000) | 0;
				case 11:
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 2:
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 0:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12) | 0;
				case 1:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3) | 0;
				case 3:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = 3,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnoughHelper = F3(
	function (outwardSail, returnSail, gap) {
		return _Utils_cmp(
			A4($justinmimbs$time_extra$Time$Extra$diff, 13, $elm$time$Time$utc, outwardSail.ps, returnSail.nr),
			gap) > -1;
	});
var $author$project$Types$RouteTripSails$isTimeGapBetweenFakeAndRealSailsLargeEnough = F2(
	function (outwardSail, returnSail) {
		return A3($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnoughHelper, outwardSail, returnSail, 120);
	});
var $author$project$Utils$Route$isAlaRoute = F2(
	function (firstPort, secondPort) {
		return (firstPort === 3) || (secondPort === 3);
	});
var $author$project$Utils$Route$isMugVssRoute = function (from) {
	return (from === 8) || (from === 7);
};
var $author$project$Utils$Route$isStoAlaRoute = F2(
	function (firstPort, secondPort) {
		return ((firstPort === 1) && (secondPort === 3)) || ((firstPort === 3) && (secondPort === 1));
	});
var $author$project$Utils$Route$isStoTurRoute = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return ((from === 1) && (to === 5)) || ((from === 5) && (to === 1));
};
var $author$project$Utils$Route$isTalHelRoute = F2(
	function (firstPort, secondPort) {
		return ((!firstPort) && (secondPort === 2)) || ((firstPort === 2) && (!secondPort));
	});
var $author$project$Utils$Route$minimumShuttleSailGapWithPiersInMinutes = F2(
	function (firstPier, secondPier) {
		return (((firstPier === 'LSAT') && (secondPier === 'LSA2')) || ((firstPier === 'LSA2') && (secondPier === 'LSAT'))) ? 31 : 30;
	});
var $author$project$Utils$Route$minimumRouteTripGapInMinutes = F4(
	function (firstPort, secondPort, firstPier, secondPier) {
		return A2($author$project$Utils$Route$isStoAlaRoute, firstPort, secondPort) ? 90 : ($author$project$Utils$Route$isMugVssRoute(firstPort) ? 10 : (A2($author$project$Utils$Route$isTalHelRoute, firstPort, secondPort) ? A2($author$project$Utils$Route$minimumShuttleSailGapWithPiersInMinutes, firstPier, secondPier) : (A2($author$project$Utils$Route$isAlaRoute, firstPort, secondPort) ? 90 : ($author$project$Utils$Route$isStoTurRoute(
			{kS: firstPort, le: secondPort}) ? 120 : 1440))));
	});
var $author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough = F2(
	function (outwardSail, returnSail) {
		var gap = A4($author$project$Utils$Route$minimumRouteTripGapInMinutes, outwardSail.v1, returnSail.v1, outwardSail.EX, returnSail.EJ);
		return A3($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnoughHelper, outwardSail, returnSail, gap);
	});
var $author$project$Types$RouteTripSail$toDates = function (routeTripSail) {
	if (!routeTripSail.$) {
		var realRouteTripSail = routeTripSail.a;
		return {ps: realRouteTripSail.ps, nr: realRouteTripSail.nr};
	} else {
		var fakeRouteTripSail = routeTripSail.a;
		return {ps: fakeRouteTripSail.ps, nr: fakeRouteTripSail.nr};
	}
};
var $author$project$Types$RouteTripSails$getOnlyAvailableReturnSails = F3(
	function (bookingType, selectedOutwardSail, returnSails) {
		return A2(
			$elm$core$List$filter,
			function (returnSail) {
				if (bookingType === 1) {
					return A2(
						$author$project$Types$RouteTripSails$haveNightBetweenSails,
						selectedOutwardSail,
						$author$project$Types$RouteTripSail$toDates(returnSail));
				} else {
					if (returnSail.$ === 1) {
						var fakeReturnSail = returnSail.a;
						return A2($author$project$Types$RouteTripSails$isTimeGapBetweenFakeAndRealSailsLargeEnough, selectedOutwardSail, fakeReturnSail);
					} else {
						var realReturnSail = returnSail.a;
						return A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, selectedOutwardSail, realReturnSail);
					}
				}
			},
			returnSails);
	});
var $author$project$Types$RouteTripSail$isDisabled = function (fakeOrRealRouteTripSail) {
	if (!fakeOrRealRouteTripSail.$) {
		var routeTripSail = fakeOrRealRouteTripSail.a;
		return routeTripSail.mA;
	} else {
		return false;
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Types$RouteTripSail$toDepartureIsoDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$RouteTripSail$toDates,
	function ($) {
		return $.nr;
	});
var $author$project$Types$RouteTripSails$sortByDepartureDate = function (routeTripSails) {
	return A2(
		$elm$core$List$sortBy,
		A2($elm$core$Basics$composeR, $author$project$Types$RouteTripSail$toDepartureIsoDate, $elm$time$Time$posixToMillis),
		routeTripSails);
};
var $author$project$Types$RouteTripSails$available = F2(
	function (bookingType, _v0) {
		var outward = _v0.Ds;
		var _return = _v0.FL;
		return _Utils_Tuple2(
			$author$project$Types$RouteTripSails$sortByDepartureDate(
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$RouteTripSail$isDisabled),
					outward.H)),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.H;
					},
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Types$RouteTripSails$getOnlyAvailableReturnSails, bookingType, outward.Gg),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$RouteTripSail$isDisabled)),
							$author$project$Types$RouteTripSails$sortByDepartureDate))),
				_return));
	});
var $author$project$Messages$SequentialCmds = F2(
	function (a, b) {
		return {$: 106, a: a, b: b};
	});
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$Api$Endpoint$cancel = A2($elm$core$Basics$composeR, $author$project$Api$Endpoint$unwrapTracker, $elm$http$Http$cancel);
var $author$project$Update$Util$cancelRequestAndRunCmd = F2(
	function (tracker, cmd) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return A2(
					$author$project$Messages$SequentialCmds,
					$author$project$Api$Endpoint$cancel(tracker),
					_List_fromArray(
						[cmd]));
			},
			$elm$core$Task$succeed(0));
	});
var $author$project$Types$CruiseSails$createMetadata = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var cruiseTripType = _v0.mm;
	return {mm: cruiseTripType, kS: from, le: to, tx: voyageType};
};
var $author$project$Types$SailsData$Cruise = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$CruiseSail$Available = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$CruiseSail$Disabled = {$: 1};
var $author$project$Types$CruiseSail$HotelTrip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$CruiseSail$SoldOut = {$: 2};
var $author$project$Types$AshorePeriod$AshorePeriod = F2(
	function (hours, minutes) {
		return {zJ: hours, Cy: minutes};
	});
var $author$project$Types$CruiseSail$AvailableCruiseSail = function (canExitShip) {
	return function (isBookedThroughThirdParty) {
		return function (isMealPriceHidden) {
			return function (isSpecialCruise) {
				return function (isVoucherApplicable) {
					return function (marketingMessage) {
						return function (personPrice) {
							return function (sailId) {
								return function (sailPackageCode) {
									return function (sailPackageName) {
										return function (outwardSail) {
											return function (intermediateSail) {
												return function (returnSail) {
													return function (vehiclePrice) {
														return function (outwardShipCode) {
															return function (returnShipCode) {
																return function (ashorePeriod) {
																	return {pt: ashorePeriod, vL: canExitShip, z2: intermediateSail, z6: isBookedThroughThirdParty, Ah: isMealPriceHidden, Au: isSpecialCruise, q0: isVoucherApplicable, rc: marketingMessage, rS: outwardSail, Dz: outwardShipCode, ov: personPrice, sw: returnSail, FS: returnShipCode, F3: sailId, F4: sailPackageCode, F5: sailPackageName, pe: vehiclePrice};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Types$ShipCode$BalticPrincess = {$: 4};
var $author$project$Types$ShipCode$BalticQueen = {$: 5};
var $author$project$Types$ShipCode$Galaxy = {$: 1};
var $author$project$Types$ShipCode$Isabelle = {$: 2};
var $author$project$Types$ShipCode$Megastar = {$: 3};
var $author$project$Types$ShipCode$MyStar = {$: 15};
var $author$project$Types$ShipCode$RegalStar = {$: 14};
var $author$project$Types$ShipCode$Romantika = {$: 6};
var $author$project$Types$ShipCode$Sailor = {$: 13};
var $author$project$Types$ShipCode$SeaWind = {$: 7};
var $author$project$Types$ShipCode$ShipCode = function (a) {
	return {$: 17, a: a};
};
var $author$project$Types$ShipCode$SiljaEuropa = {$: 0};
var $author$project$Types$ShipCode$SiljaSerenade = {$: 8};
var $author$project$Types$ShipCode$SiljaSymphony = {$: 11};
var $author$project$Types$ShipCode$Star = {$: 9};
var $author$project$Types$ShipCode$SuperfastIX = {$: 16};
var $author$project$Types$ShipCode$Superstar = {$: 10};
var $author$project$Types$ShipCode$VictoriaI = {$: 12};
var $author$project$Types$ShipCode$fromString = function (string) {
	switch (string) {
		case 'EUROPA':
			return $author$project$Types$ShipCode$SiljaEuropa;
		case 'GALAXY':
			return $author$project$Types$ShipCode$Galaxy;
		case 'ISABELLE':
			return $author$project$Types$ShipCode$Isabelle;
		case 'MEGASTAR':
			return $author$project$Types$ShipCode$Megastar;
		case 'PRINCESS':
			return $author$project$Types$ShipCode$BalticPrincess;
		case 'QUEEN':
			return $author$project$Types$ShipCode$BalticQueen;
		case 'ROMANTIKA':
			return $author$project$Types$ShipCode$Romantika;
		case 'SEAWIND':
			return $author$project$Types$ShipCode$SeaWind;
		case 'SERENADE':
			return $author$project$Types$ShipCode$SiljaSerenade;
		case 'STAR':
			return $author$project$Types$ShipCode$Star;
		case 'SUPER':
			return $author$project$Types$ShipCode$Superstar;
		case 'SYMPHONY':
			return $author$project$Types$ShipCode$SiljaSymphony;
		case 'VICTORIA':
			return $author$project$Types$ShipCode$VictoriaI;
		case 'SAILOR':
			return $author$project$Types$ShipCode$Sailor;
		case 'REGAL STAR':
			return $author$project$Types$ShipCode$RegalStar;
		case 'MYSTAR':
			return $author$project$Types$ShipCode$MyStar;
		case 'SFIX':
			return $author$project$Types$ShipCode$SuperfastIX;
		default:
			return $author$project$Types$ShipCode$ShipCode(string);
	}
};
var $author$project$Types$ShipCode$decode = A2($elm$json$Json$Decode$map, $author$project$Types$ShipCode$fromString, $elm$json$Json$Decode$string);
var $author$project$Types$CruiseSail$decodeIsSpecialCruise = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (isSpecialCruise, isCabinAndMealPricesHidden) {
			return isSpecialCruise || isCabinAndMealPricesHidden;
		}),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2(
			$elm$json$Json$Decode$field,
			'isSpecialCruise',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(false),
		A2(
			$elm$json$Json$Decode$field,
			'isCabinAndMealPricesHidden',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))));
var $author$project$Types$CruiseSail$decodeSailId = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
		$elm$core$Maybe$withDefault(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['outwardSail', 'sailId']),
				$elm$json$Json$Decode$int))),
	A2(
		$elm$json$Json$Decode$field,
		'sailId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)));
var $author$project$Types$AshorePeriod$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$AshorePeriod$AshorePeriod,
	A2($elm$json$Json$Decode$field, 'hours', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'minutes', $elm$json$Json$Decode$int));
var $author$project$Types$MarketingMessage$MarketingMessage = F3(
	function (name, description, imageUrl) {
		return {nt: description, zP: imageUrl, oh: name};
	});
var $author$project$Types$MarketingMessage$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'imageUrl',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Types$MarketingMessage$MarketingMessage))));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Types$CruiseSail$positiveFloatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (decodedFloat) {
		return (decodedFloat > 0) ? $elm$json$Json$Decode$succeed(decodedFloat) : $elm$json$Json$Decode$fail(
			'Trying to decode positive float, but float ' + ($elm$core$String$fromFloat(decodedFloat) + ' is not positive.'));
	},
	$elm$json$Json$Decode$float);
var $author$project$Types$CruiseSail$Sail = F5(
	function (arrivalIsoDate, departureIsoDate, from, to, sailId) {
		return {ps: arrivalIsoDate, nr: departureIsoDate, kS: from, F3: sailId, le: to};
	});
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {pS: col, x2: contextStack, r8: problem, sA: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.sA, s.pS, x, s.f));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.GP),
			s.c) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.GP);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{pS: col, f: s0.f, l: s0.l, c: offset, sA: row, GP: s0.GP});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.sA, s.pS, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.GP),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.GP);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{pS: 1, f: s.f, l: s.l, c: s.c + 1, sA: s.sA + 1, GP: s.GP}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{pS: s.pS + 1, f: s.f, l: s.l, c: newOffset, sA: s.sA, GP: s.GP}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.sA, s.pS, s.GP);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{pS: newCol, f: s.f, l: s.l, c: newOffset, sA: newRow, GP: s.GP});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {pS: col, r8: problem, sA: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.sA, p.pS, p.r8);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{pS: 1, f: _List_Nil, l: 1, c: 0, sA: 1, GP: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $author$project$Utils$Time$fromString = function (input) {
	var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(input);
	if (!_v0.$) {
		var result = _v0.a;
		return $elm$core$Maybe$Just(result);
	} else {
		return $elm$core$Result$toMaybe(
			$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(
				A2($elm$core$String$append, input, ':00Z')));
	}
};
var $author$project$Utils$Time$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Time$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('dateDecoder')))),
	$elm$json$Json$Decode$string);
var $author$project$Types$Port$Location = F2(
	function (port_, pier) {
		return {kg: pier, j3: port_};
	});
var $author$project$Types$Port$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Types$Port$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('unknown port')))),
	$elm$json$Json$Decode$string);
var $author$project$Types$Port$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Port$Location,
	A2($elm$json$Json$Decode$field, 'port', $author$project$Types$Port$decoder),
	A2($elm$json$Json$Decode$field, 'pier', $elm$json$Json$Decode$string));
var $author$project$Types$CruiseSail$sailDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sailId',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'to',
		$author$project$Types$Port$locationDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'from',
			$author$project$Types$Port$locationDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'departureIsoDate',
				$author$project$Utils$Time$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'arrivalIsoDate',
					$author$project$Utils$Time$decoder,
					$elm$json$Json$Decode$succeed($author$project$Types$CruiseSail$Sail))))));
var $author$project$Types$CruiseSail$availableCruiseSailDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'ashorePeriod',
	$author$project$Types$AshorePeriod$decoder,
	A2($author$project$Types$AshorePeriod$AshorePeriod, 0, 0),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['returnSail', 'shipCode']),
					$author$project$Types$ShipCode$decode),
					A2($elm$json$Json$Decode$field, 'shipCode', $author$project$Types$ShipCode$decode)
				])),
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['outwardSail', 'shipCode']),
						$author$project$Types$ShipCode$decode),
						A2($elm$json$Json$Decode$field, 'shipCode', $author$project$Types$ShipCode$decode)
					])),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'vehiclePrice',
				$elm$json$Json$Decode$maybe($author$project$Types$CruiseSail$positiveFloatDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'returnSail',
					$author$project$Types$CruiseSail$sailDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'outwardSail2',
						$elm$json$Json$Decode$maybe($author$project$Types$CruiseSail$sailDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'outwardSail',
							$author$project$Types$CruiseSail$sailDecoder,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'sailPackageName',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'sailPackageCode',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$author$project$Types$CruiseSail$decodeSailId,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'personPrice',
											$elm$json$Json$Decode$float,
											0,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'marketingMessage',
												$elm$json$Json$Decode$maybe($author$project$Types$MarketingMessage$decoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'isVoucherApplicable',
													$elm$json$Json$Decode$bool,
													false,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
														$author$project$Types$CruiseSail$decodeIsSpecialCruise,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'isCabinAndMealPricesHidden',
															$elm$json$Json$Decode$bool,
															false,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'isPanelsHidden',
																$elm$json$Json$Decode$bool,
																false,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'canExitShip',
																	$elm$json$Json$Decode$bool,
																	true,
																	$elm$json$Json$Decode$succeed($author$project$Types$CruiseSail$AvailableCruiseSail))))))))))))))))));
var $author$project$Types$CruiseSail$HotelTripCruiseSail = F2(
	function (departureIsoDate, sailPackageCode) {
		return {nr: departureIsoDate, F4: sailPackageCode};
	});
var $author$project$Types$CruiseSail$hotelTripCruiseSailDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sailPackageCode',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outwardSail',
		A2($elm$json$Json$Decode$field, 'departureIsoDate', $author$project$Utils$Time$decoder),
		$elm$json$Json$Decode$succeed($author$project$Types$CruiseSail$HotelTripCruiseSail)));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Types$CruiseSail$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var disabled = _v0.p8;
		var hasRoom = _v0.zr;
		var hasNoCruise = _v0.kT;
		return hasNoCruise ? A2($elm$json$Json$Decode$map, $author$project$Types$CruiseSail$HotelTrip, $author$project$Types$CruiseSail$hotelTripCruiseSailDecoder) : (disabled ? $elm$json$Json$Decode$succeed($author$project$Types$CruiseSail$Disabled) : ((!hasRoom) ? $elm$json$Json$Decode$succeed($author$project$Types$CruiseSail$SoldOut) : A2($elm$json$Json$Decode$map, $author$project$Types$CruiseSail$Available, $author$project$Types$CruiseSail$availableCruiseSailDecoder)));
	},
	A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (disabled, hasRoom, hasNoCruise) {
				return {p8: disabled, kT: hasNoCruise, zr: hasRoom};
			}),
		A2($elm$json$Json$Decode$field, 'disabled', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(false),
			A2(
				$elm$json$Json$Decode$field,
				'hasRoom',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(false),
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'hasNoCruise', $elm$json$Json$Decode$bool)))));
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Types$SailsData$decodeCruiseSailsTrips = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$core$Dict$foldl,
			F3(
				function (key, value, _v0) {
					var trips = _v0.tp;
					var errors = _v0.ku;
					var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$CruiseSail$decoder, value);
					if (!_v1.$) {
						var cruiseSail = _v1.a;
						return {
							ku: errors,
							tp: A3($elm$core$Dict$insert, key, cruiseSail, trips)
						};
					} else {
						var error = _v1.a;
						return {
							ku: A2($elm$core$List$cons, error, errors),
							tp: trips
						};
					}
				}),
			{ku: _List_Nil, tp: $elm$core$Dict$empty}),
		$elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$value));
var $author$project$Types$SailsData$decodeIsClubOneOnlyPromotion = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(false),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool));
var $author$project$Types$SailsData$cruiseResponseDecoder = function (metadata) {
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (_v0, clubOneOnlyPromotion) {
				var trips = _v0.tp;
				var errors = _v0.ku;
				return $author$project$Types$SailsData$Cruise(
					{mg: clubOneOnlyPromotion, ku: errors, mL: metadata, tp: trips});
			}),
		A2($elm$json$Json$Decode$field, 'trips', $author$project$Types$SailsData$decodeCruiseSailsTrips),
		A2($elm$json$Json$Decode$field, 'isClubOneOnlyPromotion', $author$project$Types$SailsData$decodeIsClubOneOnlyPromotion));
};
var $author$project$Api$Endpoint$Tracker = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$trackers = {pD: 'cabinSurprises', pN: 'clubOne', p4: 'detailedTransfers', qk: 'extraServices', qE: 'hotelPackages', q4: 'joinClubOne', q8: 'land', rs: 'mealPackages', rv: 'meals', rI: 'onboardServices', r_: 'payment', s4: 'summary', m_: 'timetables', tj: 'transfersList', pc: 'travelclasses', tt: 'vehicles'};
var $author$project$Api$Endpoint$cruiseTimetables = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['cruise', 'timetables']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.m_));
	});
var $author$project$Types$CruiseSails$AfternoonDeparture = 1;
var $author$project$Types$CruiseSails$OvernightAtDestination = 2;
var $author$project$Types$Vehicle$ROUNDTRIP = 0;
var $author$project$Utils$Route$areMorningAndEveningCruisesAvailable = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var _v1 = _Utils_Tuple3(from, to, voyageType);
	return false;
};
var $author$project$Utils$Route$areVehiclesSupported = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var _v1 = _Utils_Tuple3(from, to, voyageType);
	_v1$26:
	while (true) {
		switch (_v1.c.$) {
			case 0:
				switch (_v1.a) {
					case 3:
						switch (_v1.b) {
							case 2:
								var _v14 = _v1.a;
								var _v15 = _v1.b;
								var _v16 = _v1.c;
								return true;
							case 4:
								var _v20 = _v1.a;
								var _v21 = _v1.b;
								var _v22 = _v1.c;
								return true;
							case 0:
								var _v35 = _v1.a;
								var _v36 = _v1.b;
								var _v37 = _v1.c;
								return true;
							default:
								break _v1$26;
						}
					case 5:
						switch (_v1.b) {
							case 0:
								var _v56 = _v1.a;
								var _v57 = _v1.b;
								var _v58 = _v1.c;
								return true;
							case 13:
								var _v59 = _v1.a;
								var _v60 = _v1.b;
								var _v61 = _v1.c;
								return true;
							case 1:
								var _v62 = _v1.a;
								var _v63 = _v1.b;
								var _v64 = _v1.c;
								return true;
							default:
								break _v1$26;
						}
					case 0:
						switch (_v1.b) {
							case 6:
								var _v29 = _v1.a;
								var _v30 = _v1.b;
								var _v31 = _v1.c;
								return true;
							case 3:
								var _v32 = _v1.a;
								var _v33 = _v1.b;
								var _v34 = _v1.c;
								return true;
							case 1:
								var _v38 = _v1.a;
								var _v39 = _v1.b;
								var _v40 = _v1.c;
								return true;
							case 5:
								var _v53 = _v1.a;
								var _v54 = _v1.b;
								var _v55 = _v1.c;
								return true;
							case 4:
								var _v65 = _v1.a;
								var _v66 = _v1.b;
								var _v67 = _v1.c;
								return true;
							default:
								break _v1$26;
						}
					case 2:
						switch (_v1.b) {
							case 0:
								var _v2 = _v1.a;
								var _v3 = _v1.b;
								var _v4 = _v1.c;
								return true;
							case 4:
								var _v5 = _v1.a;
								var _v6 = _v1.b;
								var _v7 = _v1.c;
								return true;
							case 3:
								var _v11 = _v1.a;
								var _v12 = _v1.b;
								var _v13 = _v1.c;
								return true;
							case 14:
								var _v23 = _v1.a;
								var _v24 = _v1.b;
								var _v25 = _v1.c;
								return true;
							case 6:
								var _v26 = _v1.a;
								var _v27 = _v1.b;
								var _v28 = _v1.c;
								return true;
							case 1:
								var _v68 = _v1.a;
								var _v69 = _v1.b;
								var _v70 = _v1.c;
								return true;
							default:
								break _v1$26;
						}
					case 4:
						switch (_v1.b) {
							case 2:
								var _v8 = _v1.a;
								var _v9 = _v1.b;
								var _v10 = _v1.c;
								return true;
							case 3:
								var _v17 = _v1.a;
								var _v18 = _v1.b;
								var _v19 = _v1.c;
								return true;
							case 1:
								var _v74 = _v1.a;
								var _v75 = _v1.b;
								var _v76 = _v1.c;
								return true;
							default:
								break _v1$26;
						}
					case 1:
						switch (_v1.b) {
							case 6:
								var _v41 = _v1.a;
								var _v42 = _v1.b;
								var _v43 = _v1.c;
								return true;
							case 0:
								var _v44 = _v1.a;
								var _v45 = _v1.b;
								var _v46 = _v1.c;
								return true;
							case 5:
								var _v47 = _v1.a;
								var _v48 = _v1.b;
								var _v49 = _v1.c;
								return true;
							case 15:
								var _v50 = _v1.a;
								var _v51 = _v1.b;
								var _v52 = _v1.c;
								return true;
							case 2:
								var _v71 = _v1.a;
								var _v72 = _v1.b;
								var _v73 = _v1.c;
								return true;
							case 4:
								var _v77 = _v1.a;
								var _v78 = _v1.b;
								var _v79 = _v1.c;
								return true;
							default:
								break _v1$26;
						}
					default:
						break _v1$26;
				}
			case 2:
				var _v81 = _v1.c;
				return true;
			case 6:
				if (_v1.c.a === 1) {
					var _v82 = _v1.c.a;
					return true;
				} else {
					var _v83 = _v1.c.a;
					return false;
				}
			case 3:
				var _v84 = _v1.c;
				return true;
			case 4:
				var _v85 = _v1.c;
				return false;
			case 5:
				var _v86 = _v1.c;
				return true;
			default:
				var _v87 = _v1.c;
				return false;
		}
	}
	var _v80 = _v1.c;
	return false;
};
var $author$project$Types$ClubOneLevel$toString = function (clubOneLevel) {
	switch (clubOneLevel) {
		case 3:
			return 'gold';
		case 2:
			return 'silver';
		case 0:
			return 'club';
		case 1:
			return 'bronze';
		case 4:
			return 'platinum';
		default:
			return 'inactive';
	}
};
var $author$project$Api$Util$clubOneLevelParam = function (clubOneLevel) {
	return _Utils_Tuple2(
		'clubOneLevel',
		$elm$core$String$toUpper(
			$author$project$Types$ClubOneLevel$toString(clubOneLevel)));
};
var $author$project$Api$Util$dateFromParam = function (input) {
	return _Utils_Tuple2('dateFrom', input);
};
var $author$project$Api$Util$dateToParam = function (input) {
	return _Utils_Tuple2('dateTo', input);
};
var $author$project$Utils$String$fromBool = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Api$Util$eveningDepartureParam = function (isEveningDeparture) {
	return _Utils_Tuple2(
		'eveningDeparture',
		$author$project$Utils$String$fromBool(isEveningDeparture));
};
var $author$project$Types$ClubOneLevel$compare = F2(
	function (a, b) {
		var toInt = function (level) {
			switch (level) {
				case 4:
					return 4;
				case 3:
					return 3;
				case 2:
					return 2;
				case 0:
					return 1;
				case 1:
					return 1;
				default:
					return 0;
			}
		};
		return A2(
			$elm$core$Basics$compare,
			toInt(a),
			toInt(b));
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $author$project$Types$Passenger$findWithHighestLevel = A2(
	$elm$core$Array$foldl,
	F2(
		function (passenger, maybePassengerWithHighestLevel) {
			var _v0 = _Utils_Tuple2(
				passenger.pO,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.pO;
					},
					maybePassengerWithHighestLevel));
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var level = _v0.a.a;
					var highestLevel = _v0.b.a;
					return (A2($author$project$Types$ClubOneLevel$compare, level, highestLevel) === 2) ? $elm$core$Maybe$Just(passenger) : maybePassengerWithHighestLevel;
				} else {
					return $elm$core$Maybe$Just(passenger);
				}
			} else {
				return maybePassengerWithHighestLevel;
			}
		}),
	$elm$core$Maybe$Nothing);
var $author$project$Types$Port$toString = function (input) {
	switch (input) {
		case 0:
			return 'TAL';
		case 1:
			return 'STO';
		case 2:
			return 'HEL';
		case 3:
			return 'ALA';
		case 4:
			return 'RIG';
		case 5:
			return 'TUR';
		case 6:
			return 'VIS';
		case 16:
			return 'YST';
		case 8:
			return 'MUG';
		case 7:
			return 'VSS';
		case 9:
			return 'SPE';
		case 10:
			return 'VNT';
		case 11:
			return 'SAS';
		case 12:
			return 'PAL';
		case 13:
			return 'KAP';
		case 14:
			return 'SMA';
		case 15:
			return 'HND';
		default:
			return 'PARTY';
	}
};
var $author$project$Types$Port$toRequestString = function (input) {
	if (input === 16) {
		return 'VIS';
	} else {
		return $author$project$Types$Port$toString(input);
	}
};
var $author$project$Api$Util$fromParam = function (input) {
	return _Utils_Tuple2(
		'from',
		$author$project$Types$Port$toRequestString(input));
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Timetable$isHndStoCruise = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return (from === 15) && ((to === 1) && _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Utils$List$maybeAdd = F2(
	function (maybeA, aList) {
		return A2(
			$elm$core$Maybe$withDefault,
			aList,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					$elm$core$Basics$append(aList)),
				maybeA));
	});
var $author$project$Types$Maybe$Util$orElse = F2(
	function (maybeDefault, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(value);
		} else {
			return maybeDefault;
		}
	});
var $author$project$Api$Util$searchFutureSailsParam = function (searchFutureSails) {
	return _Utils_Tuple2(
		'searchFutureSails',
		$author$project$Utils$String$fromBool(searchFutureSails));
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {HJ: toAmPm, HK: toMonthAbbreviation, HL: toMonthName, lf: toOrdinalSuffix, HM: toWeekdayAbbreviation, HN: toWeekdayName};
	});
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.HJ(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.lf(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.HK(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.HL(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.lf(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.lf(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.lf(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.lf(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.HM(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.HN(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.lf(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$format = $ryan_haskell$date_format$DateFormat$formatWithLanguage($ryan_haskell$date_format$DateFormat$Language$english);
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Utils$Time$toDateString = function (dateTime) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
			]),
		$elm$time$Time$utc,
		dateTime);
};
var $author$project$Api$Util$toParam = function (input) {
	return _Utils_Tuple2(
		'to',
		$author$project$Types$Port$toRequestString(input));
};
var $author$project$Types$Vehicle$vehicleVoyageTypeToString = function (voyageType) {
	if (!voyageType.$) {
		switch (voyageType.a) {
			case 0:
				var _v1 = voyageType.a;
				return 'ROUNDTRIP';
			case 1:
				var _v2 = voyageType.a;
				return 'OUTWARD';
			default:
				var _v3 = voyageType.a;
				return 'RETURN';
		}
	} else {
		return '';
	}
};
var $author$project$Api$Util$vehicleVoyageTypeParam = function (input) {
	if (!input.$) {
		var vehicleVoyageType = input.a;
		return _Utils_Tuple2(
			'vehicleVoyageType',
			$author$project$Types$Vehicle$vehicleVoyageTypeToString(
				$elm$core$Maybe$Just(vehicleVoyageType)));
	} else {
		return _Utils_Tuple2('vehicleVoyageType', '');
	}
};
var $author$project$Api$Util$voucherIdParam = function (voucherId) {
	return _Utils_Tuple2(
		'voucherId',
		$elm$core$String$toUpper(voucherId));
};
var $author$project$Types$VoyageType$toString = function (voyageType) {
	switch (voyageType.$) {
		case 1:
			return 'CRUISE_PARTY';
		case 0:
			return 'CRUISE';
		case 2:
			return 'SHUTTLE';
		case 3:
			return 'ROUTETRIP';
		case 4:
			return 'CRUISE_MULTISHIP';
		case 6:
			return 'CRUISE';
		default:
			return 'CRUISE_MULTI_STOP';
	}
};
var $author$project$Types$VoyageType$toStringWithBookingType = F2(
	function (bookingType, voyageType) {
		if (!bookingType) {
			return $author$project$Types$VoyageType$toString(voyageType);
		} else {
			return 'HOTELROUTETRIP';
		}
	});
var $author$project$Api$Util$voyageTypeParam = F2(
	function (bookingType, voyageType) {
		return _Utils_Tuple2(
			'voyageType',
			A2($author$project$Types$VoyageType$toStringWithBookingType, bookingType, voyageType));
	});
var $author$project$Api$Timetable$getCruiseSailsUrlParameters = F5(
	function (httpConfig, session, dateFrom, numberOfMonthsToFetch, maybeVoucherId) {
		var dateTo = A4(
			$justinmimbs$time_extra$Time$Extra$add,
			11,
			-1,
			$elm$time$Time$utc,
			A3(
				$justinmimbs$time_extra$Time$Extra$floor,
				2,
				$elm$time$Time$utc,
				A4($justinmimbs$time_extra$Time$Extra$add, 2, numberOfMonthsToFetch, $elm$time$Time$utc, dateFrom)));
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			session.Aa,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var a = _v0.a;
					var b = _v0.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A2(
					$elm$core$List$filter,
					function (a) {
						return !$elm$core$String$isEmpty(a.b);
					},
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$author$project$Types$Maybe$Util$orElse,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.pQ;
									},
									$author$project$Api$Util$voucherIdParam),
								$elm$core$List$head(session.tw)),
							A2($elm$core$Maybe$map, $author$project$Api$Util$voucherIdParam, maybeVoucherId)),
						function (params) {
							return $author$project$Utils$Route$areMorningAndEveningCruisesAvailable(session) ? _Utils_ap(
								params,
								_List_fromArray(
									[
										$author$project$Api$Util$eveningDepartureParam(session.mm === 1)
									])) : ($author$project$Api$Timetable$isHndStoCruise(session) ? _Utils_ap(
								params,
								_List_fromArray(
									[
										$author$project$Api$Util$eveningDepartureParam(false)
									])) : params);
						}(
							A3(
								$author$project$Utils$List$addIf,
								session.mm === 2,
								_Utils_Tuple2('overnightCruise', 'true'),
								A3(
									$author$project$Utils$List$addIf,
									_Utils_eq(session.tx, $author$project$Types$VoyageType$CruiseParty),
									_Utils_Tuple2('showFakeSails', 'false'),
									A2(
										$author$project$Utils$List$maybeAdd,
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Util$clubOneLevelParam,
											A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.pO;
												},
												$author$project$Types$Passenger$findWithHighestLevel(session.Eg))),
										_List_fromArray(
											[
												$author$project$Api$Util$guidParam(httpConfig.Gt),
												$author$project$Api$Util$localeParam(session.A_),
												$author$project$Api$Util$marketParam(session.rb),
												$author$project$Api$Util$fromParam(session.kS),
												$author$project$Api$Util$toParam(session.le),
												$author$project$Api$Util$dateFromParam(
												$author$project$Utils$Time$toDateString(dateFrom)),
												$author$project$Api$Util$dateToParam(
												$author$project$Utils$Time$toDateString(dateTo)),
												A2($author$project$Api$Util$voyageTypeParam, session.vk, session.tx),
												$author$project$Api$Util$vehicleVoyageTypeParam(
												$author$project$Utils$Route$areVehiclesSupported(session) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing),
												$author$project$Api$Util$searchFutureSailsParam(false)
											])))))))));
	});
var $author$project$Api$Timetable$createCruiseSailsRequest = F6(
	function (httpConfig, session, dateFrom, numberOfMonthsToFetch, maybeVoucherId, resultToMsg) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.m_,
			$author$project$Api$getWithCredentials(
				{
					j9: A2(
						$elm$http$Http$expectJson,
						resultToMsg,
						$author$project$Types$SailsData$cruiseResponseDecoder(
							$author$project$Types$CruiseSails$createMetadata(session))),
					jW: A2(
						$author$project$Api$Endpoint$cruiseTimetables,
						httpConfig.Gs,
						A5($author$project$Api$Timetable$getCruiseSailsUrlParameters, httpConfig, session, dateFrom, numberOfMonthsToFetch, maybeVoucherId))
				}));
	});
var $author$project$Api$Util$includeOvernightParam = function (input) {
	return _Utils_Tuple2(
		'includeOvernight',
		$author$project$Utils$String$fromBool(input));
};
var $author$project$Api$Util$isOneWayParam = function (input) {
	return _Utils_Tuple2(
		'oneWay',
		$author$project$Utils$String$fromBool(input));
};
var $author$project$Types$Vehicle$OUTWARD = 1;
var $author$project$Types$Vehicle$RETURN = 2;
var $author$project$Types$SelectedVehicles$getVehicleVoyageTypeFromList = function (selectedVehicles) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (selectedVehicle, vehicleVoyageType) {
				if (vehicleVoyageType.$ === 1) {
					return selectedVehicle.tx;
				} else {
					switch (vehicleVoyageType.a) {
						case 2:
							var _v1 = vehicleVoyageType.a;
							return (_Utils_eq(
								selectedVehicle.tx,
								$elm$core$Maybe$Just(1)) || _Utils_eq(
								selectedVehicle.tx,
								$elm$core$Maybe$Just(0))) ? $elm$core$Maybe$Just(0) : vehicleVoyageType;
						case 1:
							var _v2 = vehicleVoyageType.a;
							return (_Utils_eq(
								selectedVehicle.tx,
								$elm$core$Maybe$Just(2)) || _Utils_eq(
								selectedVehicle.tx,
								$elm$core$Maybe$Just(0))) ? $elm$core$Maybe$Just(0) : vehicleVoyageType;
						default:
							var _v3 = vehicleVoyageType.a;
							return vehicleVoyageType;
					}
				}
			}),
		$elm$core$Maybe$Nothing,
		selectedVehicles);
};
var $author$project$Utils$Route$isExactlyOneVehicleRequiredForSail = function (_v0) {
	var portFrom = _v0.kF;
	var portTo = _v0.oB;
	var voyageType = _v0.tx;
	var _v1 = _Utils_Tuple3(portFrom, portTo, voyageType);
	_v1$4:
	while (true) {
		switch (_v1.a) {
			case 8:
				var _v2 = _v1.a;
				return true;
			case 7:
				var _v3 = _v1.a;
				return true;
			case 12:
				if ((_v1.b === 1) && (_v1.c.$ === 3)) {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					var _v6 = _v1.c;
					return true;
				} else {
					break _v1$4;
				}
			case 1:
				if ((_v1.b === 12) && (_v1.c.$ === 3)) {
					var _v7 = _v1.a;
					var _v8 = _v1.b;
					var _v9 = _v1.c;
					return true;
				} else {
					break _v1$4;
				}
			default:
				break _v1$4;
		}
	}
	return false;
};
var $author$project$Utils$Route$isVehicleRequiredForPassengersForSail = function (_v0) {
	var portFrom = _v0.kF;
	var portTo = _v0.oB;
	var voyageType = _v0.tx;
	var isOneWay = _v0.qW;
	var _v1 = _Utils_Tuple3(portFrom, portTo, voyageType);
	_v1$6:
	while (true) {
		if (_v1.c.$ === 3) {
			switch (_v1.a) {
				case 3:
					if (_v1.b === 13) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var _v4 = _v1.c;
						return true;
					} else {
						break _v1$6;
					}
				case 12:
					if (_v1.b === 13) {
						var _v11 = _v1.a;
						var _v12 = _v1.b;
						var _v13 = _v1.c;
						return true;
					} else {
						break _v1$6;
					}
				case 13:
					switch (_v1.b) {
						case 3:
							var _v5 = _v1.a;
							var _v6 = _v1.b;
							var _v7 = _v1.c;
							return true;
						case 5:
							var _v8 = _v1.a;
							var _v9 = _v1.b;
							var _v10 = _v1.c;
							return true;
						case 12:
							var _v14 = _v1.a;
							var _v15 = _v1.b;
							var _v16 = _v1.c;
							return true;
						default:
							break _v1$6;
					}
				case 5:
					if (_v1.b === 13) {
						var _v17 = _v1.a;
						var _v18 = _v1.b;
						var _v19 = _v1.c;
						return isOneWay ? false : true;
					} else {
						break _v1$6;
					}
				default:
					break _v1$6;
			}
		} else {
			break _v1$6;
		}
	}
	return false;
};
var $author$project$Utils$Route$isVehicleRequiredHelper = function (_arguments) {
	return $author$project$Utils$Route$isVehicleRequiredForPassengersForSail(_arguments) || $author$project$Utils$Route$isExactlyOneVehicleRequiredForSail(_arguments);
};
var $author$project$Utils$Route$outwardRequiredArguments = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var isOneWay = _v0.qW;
	return {qW: isOneWay, kF: from, oB: to, tx: voyageType};
};
var $author$project$Utils$Route$isVehicleRequiredForOutward = A2($elm$core$Basics$composeR, $author$project$Utils$Route$outwardRequiredArguments, $author$project$Utils$Route$isVehicleRequiredHelper);
var $author$project$Utils$Route$returnRequiredArguments = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var isOneWay = _v0.qW;
	return {qW: isOneWay, kF: to, oB: from, tx: voyageType};
};
var $author$project$Utils$Route$isVehicleRequiredForReturn = A2($elm$core$Basics$composeR, $author$project$Utils$Route$returnRequiredArguments, $author$project$Utils$Route$isVehicleRequiredHelper);
var $author$project$Session$vehicleVoyageType = function (session) {
	var desiredVehicles = session.yq;
	var isOneWay = session.qW;
	var vehicleRequiredForReturn = $author$project$Utils$Route$isVehicleRequiredForReturn(session);
	var vehicleRequiredForOutward = $author$project$Utils$Route$isVehicleRequiredForOutward(session);
	var desiredVehiclesVoyageType = $author$project$Types$SelectedVehicles$getVehicleVoyageTypeFromList(desiredVehicles);
	return (isOneWay && vehicleRequiredForOutward) ? $elm$core$Maybe$Just(1) : ((isOneWay && (_Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(1)) || _Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(0)))) ? $elm$core$Maybe$Just(1) : (((vehicleRequiredForOutward && vehicleRequiredForReturn) || ((vehicleRequiredForOutward && _Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(2))) || ((vehicleRequiredForReturn && _Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(1))) || _Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(0))))) ? $elm$core$Maybe$Just(0) : ((vehicleRequiredForOutward || _Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(1))) ? $elm$core$Maybe$Just(1) : ((vehicleRequiredForReturn || _Utils_eq(
		desiredVehiclesVoyageType,
		$elm$core$Maybe$Just(2))) ? $elm$core$Maybe$Just(2) : $elm$core$Maybe$Nothing))));
};
var $author$project$Api$Timetable$getUrlParams = F5(
	function (httpConfig, session, dateFrom, dateTo, maybeVoucherId) {
		var _v0 = session;
		var isOneWay = _v0.qW;
		var from = _v0.kS;
		var to = _v0.le;
		var voyageType = _v0.tx;
		var language = _v0.A_;
		var market = _v0.rb;
		var bookingType = _v0.vk;
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			session.Aa,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A2(
					$elm$core$List$filter,
					function (a) {
						return !$elm$core$String$isEmpty(a.b);
					},
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$author$project$Types$Maybe$Util$orElse,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.pQ;
									},
									$author$project$Api$Util$voucherIdParam),
								$elm$core$List$head(session.tw)),
							A2($elm$core$Maybe$map, $author$project$Api$Util$voucherIdParam, maybeVoucherId)),
						A2(
							$author$project$Utils$List$maybeAdd,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Util$clubOneLevelParam,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.pO;
									},
									$author$project$Types$Passenger$findWithHighestLevel(session.Eg))),
							_List_fromArray(
								[
									$author$project$Api$Util$guidParam(httpConfig.Gt),
									$author$project$Api$Util$localeParam(language),
									$author$project$Api$Util$marketParam(market),
									A2($author$project$Api$Util$voyageTypeParam, bookingType, voyageType),
									$author$project$Api$Util$dateFromParam(
									$author$project$Utils$Time$toDateString(dateFrom)),
									$author$project$Api$Util$dateToParam(
									$author$project$Utils$Time$toDateString(dateTo)),
									$author$project$Api$Util$fromParam(from),
									$author$project$Api$Util$toParam(to),
									$author$project$Api$Util$isOneWayParam(isOneWay),
									$author$project$Api$Util$vehicleVoyageTypeParam(
									$author$project$Session$vehicleVoyageType(session)),
									$author$project$Api$Util$includeOvernightParam(true)
								]))))));
	});
var $author$project$Types$SailsData$RouteTrip = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Types$RouteTripSail$Fake = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$RouteTripSail$Real = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$FakeRouteTripSail$FakeRouteTripSail = F2(
	function (arrivalIsoDate, departureIsoDate) {
		return {ps: arrivalIsoDate, nr: departureIsoDate};
	});
var $author$project$Types$FakeRouteTripSail$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'departureIsoDate',
	$author$project$Utils$Time$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'arrivalIsoDate',
		$author$project$Utils$Time$decoder,
		$elm$json$Json$Decode$succeed($author$project$Types$FakeRouteTripSail$FakeRouteTripSail)));
var $author$project$Types$RealRouteTripSail$RealRouteTripSail = function (arrivalIsoDate) {
	return function (cityFrom) {
		return function (cityTo) {
			return function (departureIsoDate) {
				return function (duration) {
					return function (hasNoCruise) {
						return function (hasRoom) {
							return function (isDisabled) {
								return function (isOvernight) {
									return function (isVoucherApplicable) {
										return function (marketingMessage) {
											return function (personPrice) {
												return function (pierFrom) {
													return function (pierTo) {
														return function (sailId) {
															return function (sailPackageCode) {
																return function (sailPackageName) {
																	return function (shipCode) {
																		return function (shoppingCruiseEligibleSailId) {
																			return function (vehiclePrice) {
																				return {ps: arrivalIsoDate, v1: cityFrom, v2: cityTo, nr: departureIsoDate, nv: duration, kT: hasNoCruise, zr: hasRoom, mA: isDisabled, qY: isOvernight, q0: isVoucherApplicable, rc: marketingMessage, ov: personPrice, EJ: pierFrom, EX: pierTo, F3: sailId, F4: sailPackageCode, F5: sailPackageName, oX: shipCode, Gx: shoppingCruiseEligibleSailId, pe: vehiclePrice};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$RealRouteTripSail$decodeStringToFloat = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Failed to decode string to float.')))),
	$elm$json$Json$Decode$string);
var $author$project$Types$RealRouteTripSail$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'vehiclePrice',
	$elm$json$Json$Decode$maybe($author$project$Types$RealRouteTripSail$decodeStringToFloat),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'shoppingCruiseEligibleSailId',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'shipCode',
			$author$project$Types$ShipCode$decode,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'sailPackageName',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sailPackageCode',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sailId',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pierTo',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'pierFrom',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'personPrice',
									$author$project$Types$RealRouteTripSail$decodeStringToFloat,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'marketingMessage',
										$elm$json$Json$Decode$maybe($author$project$Types$MarketingMessage$decoder),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'isVoucherApplicable',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'isOvernight',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'isDisabled',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'hasRoom',
														$elm$json$Json$Decode$bool,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'hasNoCruise',
															$elm$json$Json$Decode$bool,
															false,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'duration',
																$elm$json$Json$Decode$float,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'departureIsoDate',
																	$author$project$Utils$Time$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'cityTo',
																		$author$project$Types$Port$decoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'cityFrom',
																			$author$project$Types$Port$decoder,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'arrivalIsoDate',
																				$author$project$Utils$Time$decoder,
																				$elm$json$Json$Decode$succeed($author$project$Types$RealRouteTripSail$RealRouteTripSail)))))))))))))))))))));
var $author$project$Types$RouteTripSail$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Types$RouteTripSail$Real, $author$project$Types$RealRouteTripSail$decoder),
			A2($elm$json$Json$Decode$map, $author$project$Types$RouteTripSail$Fake, $author$project$Types$FakeRouteTripSail$decoder)
		]));
var $author$project$Types$SailsData$decodeRouteTripSailsByKey = function (key) {
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$Dict$foldl,
				F3(
					function (_v0, value, _v1) {
						var sails = _v1.F6;
						var decodingErrors = _v1.F;
						var _v2 = A2(
							$elm$json$Json$Decode$decodeValue,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									[key]),
								$elm$json$Json$Decode$list($author$project$Types$RouteTripSail$decoder)),
							value);
						if (!_v2.$) {
							var decodedSails = _v2.a;
							return {
								F: decodingErrors,
								F6: $elm$core$List$concat(
									_List_fromArray(
										[decodedSails, sails]))
							};
						} else {
							var error = _v2.a;
							return {
								F: _Utils_eq(
									$elm$core$List$head(decodingErrors),
									$elm$core$Maybe$Just(error)) ? decodingErrors : A2($elm$core$List$cons, error, decodingErrors),
								F6: sails
							};
						}
					}),
				{F: _List_Nil, F6: _List_Nil}),
			$elm$json$Json$Decode$succeed),
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$value));
};
var $author$project$Types$RouteTripSails$RouteTripSails = $elm$core$Basics$identity;
var $author$project$Utils$Time$differenceInDays = F2(
	function (a, b) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$diff,
			11,
			$elm$time$Time$utc,
			A3($justinmimbs$time_extra$Time$Extra$floor, 11, $elm$time$Time$utc, a),
			A3($justinmimbs$time_extra$Time$Extra$floor, 11, $elm$time$Time$utc, b));
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Types$RouteTripSails$isSailSelectableByDefault = F2(
	function (maybeIsTurStoOvernightTrip, _v0) {
		var isDisabled = _v0.mA;
		var isOvernight = _v0.qY;
		var hasRoom = _v0.zr;
		var hasNoCruise = _v0.kT;
		return hasNoCruise ? false : A2(
			$elm$core$Maybe$withDefault,
			(!isDisabled) && hasRoom,
			A2(
				$elm$core$Maybe$map,
				function (isTurStoOvernightTrip) {
					return isTurStoOvernightTrip ? ((!isDisabled) && (isOvernight && hasRoom)) : ((!isDisabled) && ((!isOvernight) && hasRoom));
				},
				maybeIsTurStoOvernightTrip));
	});
var $author$project$Types$RouteTripSail$toReal = function (routeTripSail) {
	if (!routeTripSail.$) {
		var realRouteTripSail = routeTripSail.a;
		return $elm$core$Maybe$Just(realRouteTripSail);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$RouteTripSails$findDefaultSelectedSails = function (_arguments) {
	var _v0 = _arguments;
	var bookingType = _v0.vk;
	var maybePreviousOutwardSail = _v0.rj;
	var maybePreviousReturnSail = _v0.rk;
	var outwardSails = _v0.lJ;
	var maybeReturnSails = _v0.oa;
	var maybeIsTurStoOvernightTrip = _v0.rh;
	var hasSameDepartureTime = F2(
		function (departureTime, sail) {
			return _Utils_eq(sail.nr, departureTime) && A2($author$project$Types$RouteTripSails$isSailSelectableByDefault, maybeIsTurStoOvernightTrip, sail);
		});
	var hasSameSailId = F2(
		function (sailId, sail) {
			return _Utils_eq(sail.F3, sailId) && A2($author$project$Types$RouteTripSails$isSailSelectableByDefault, maybeIsTurStoOvernightTrip, sail);
		});
	var maybeExactPreviousOutwardSail = A2(
		$elm$core$Maybe$andThen,
		function (_v4) {
			var sailId = _v4.F3;
			var departureTime = _v4.p3;
			return A2(
				$elm_community$list_extra$List$Extra$find,
				function (sail) {
					return A2(hasSameSailId, sailId, sail) && A2(hasSameDepartureTime, departureTime, sail);
				},
				A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, outwardSails));
		},
		maybePreviousOutwardSail);
	var maybePreviousOutwardSailLikeSail = A2(
		$elm$core$Maybe$andThen,
		function (departureTime) {
			return A2(
				$elm_community$list_extra$List$Extra$find,
				hasSameDepartureTime(departureTime),
				A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, outwardSails));
		},
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.p3;
			},
			maybePreviousOutwardSail));
	var maybeOutwardSail = A2(
		$elm_community$maybe_extra$Maybe$Extra$orElse,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$Types$RouteTripSails$isSailSelectableByDefault(maybeIsTurStoOvernightTrip),
				A2(
					$elm$core$List$filterMap,
					$author$project$Types$RouteTripSail$toReal,
					$author$project$Types$RouteTripSails$sortByDepartureDate(outwardSails)))),
		A2($elm_community$maybe_extra$Maybe$Extra$orElse, maybePreviousOutwardSailLikeSail, maybeExactPreviousOutwardSail));
	var maybeExactPreviousReturnSail = function () {
		var _v3 = _Utils_Tuple3(maybeReturnSails, maybePreviousReturnSail, maybeOutwardSail);
		if (((!_v3.a.$) && (!_v3.b.$)) && (!_v3.c.$)) {
			var returnSails = _v3.a.a;
			var previousReturnSail = _v3.b.a;
			var outwardSail = _v3.c.a;
			return A2(
				$elm_community$list_extra$List$Extra$find,
				function (sail) {
					return A2(hasSameSailId, previousReturnSail.F3, sail) && (A2(hasSameDepartureTime, previousReturnSail.p3, sail) && A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, outwardSail, sail));
				},
				A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, returnSails));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var maybePreviousReturnSailLikeSail = function () {
		var _v2 = _Utils_Tuple3(maybeReturnSails, maybePreviousReturnSail, maybeOutwardSail);
		if (((!_v2.a.$) && (!_v2.b.$)) && (!_v2.c.$)) {
			var returnSails = _v2.a.a;
			var previousReturnSail = _v2.b.a;
			var outwardSail = _v2.c.a;
			return A2(
				$elm_community$list_extra$List$Extra$find,
				function (sail) {
					return A2(hasSameDepartureTime, previousReturnSail.p3, sail) && A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, outwardSail, sail);
				},
				A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, returnSails));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var maybeReturnSail = A2(
		$elm_community$maybe_extra$Maybe$Extra$orElse,
		function () {
			var _v1 = _Utils_Tuple2(maybeOutwardSail, maybeReturnSails);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var outwardSail = _v1.a.a;
				var returnSails = _v1.b.a;
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (returnSail) {
							return (_Utils_eq(maybePreviousReturnSail, $elm$core$Maybe$Nothing) || (bookingType === 1)) ? (A2($author$project$Types$RouteTripSails$isSailSelectableByDefault, $elm$core$Maybe$Nothing, returnSail) && (A2($author$project$Utils$Time$differenceInDays, outwardSail.ps, returnSail.nr) > 0)) : (A2($author$project$Types$RouteTripSails$isSailSelectableByDefault, $elm$core$Maybe$Nothing, returnSail) && A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, outwardSail, returnSail));
						},
						A2(
							$elm$core$List$filterMap,
							$author$project$Types$RouteTripSail$toReal,
							$author$project$Types$RouteTripSails$sortByDepartureDate(returnSails))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		A2($elm_community$maybe_extra$Maybe$Extra$orElse, maybePreviousReturnSailLikeSail, maybeExactPreviousReturnSail));
	return _Utils_Tuple2(maybeOutwardSail, maybeReturnSail);
};
var $author$project$Types$RouteTripSails$init = function (_arguments) {
	var _v0 = $author$project$Types$RouteTripSails$findDefaultSelectedSails(_arguments);
	var maybeOutwardSail = _v0.a;
	var maybeReturnSail = _v0.b;
	var _v1 = _Utils_Tuple2(maybeOutwardSail, maybeReturnSail);
	if (!_v1.a.$) {
		if (!_v1.b.$) {
			var outwardSail = _v1.a.a;
			var returnSail = _v1.b.a;
			return $elm$core$Maybe$Just(
				{
					mg: _arguments.mg,
					Ds: {H: _arguments.lJ, Gg: outwardSail},
					FL: A2(
						$elm$core$Maybe$map,
						function (returnSails) {
							return {H: returnSails, Gg: returnSail};
						},
						_arguments.oa)
				});
		} else {
			var outwardSail = _v1.a.a;
			var _v2 = _v1.b;
			return $elm$core$Maybe$Just(
				{
					mg: _arguments.mg,
					Ds: {H: _arguments.lJ, Gg: outwardSail},
					FL: $elm$core$Maybe$Nothing
				});
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $author$project$Types$SailsData$decodeRouteTripSailsTrips = F2(
	function (_v0, clubOneOnlyPromotion) {
		var bookingType = _v0.vk;
		var maybePreviousSelectedSails = _v0.rl;
		var maybeIsTurStoOvernightTrip = _v0.rh;
		return A2(
			$elm$json$Json$Decode$andThen,
			function (a) {
				var returns = A2(
					$elm$json$Json$Decode$decodeValue,
					$author$project$Types$SailsData$decodeRouteTripSailsByKey('returns'),
					a);
				var outwards = A2(
					$elm$json$Json$Decode$decodeValue,
					$author$project$Types$SailsData$decodeRouteTripSailsByKey('outwards'),
					a);
				var errors = A2(
					$elm$core$Result$withDefault,
					_List_Nil,
					A3(
						$elm$core$Result$map2,
						F2(
							function (outwardResult, returnResult) {
								return $elm$core$List$concat(
									_List_fromArray(
										[outwardResult.F, returnResult.F]));
							}),
						outwards,
						returns));
				var emptyListToMaybe = function (list) {
					return $elm$core$List$isEmpty(list) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(list);
				};
				var maybeRouteTripSails = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Basics$identity,
					$elm$core$Result$toMaybe(
						A3(
							$elm$core$Result$map2,
							F2(
								function (outward, _return) {
									return $author$project$Types$RouteTripSails$init(
										{
											vk: bookingType,
											mg: clubOneOnlyPromotion,
											rh: maybeIsTurStoOvernightTrip,
											rj: A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybePreviousSelectedSails),
											rk: A2($elm$core$Maybe$andThen, $elm$core$Tuple$second, maybePreviousSelectedSails),
											oa: _return,
											lJ: outward
										});
								}),
							A2(
								$elm$core$Result$map,
								function ($) {
									return $.F6;
								},
								outwards),
							A2(
								$elm$core$Result$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.F6;
									},
									emptyListToMaybe),
								returns))));
				return $elm$json$Json$Decode$succeed(
					{F: errors, lA: maybeRouteTripSails});
			},
			$elm$json$Json$Decode$value);
	});
var $author$project$Types$SailsData$routeTripSailsDecoder = function (_arguments) {
	var direction = _arguments.p7;
	return A2(
		$elm$json$Json$Decode$map,
		function (_v0) {
			var maybeSails = _v0.lA;
			var decodingErrors = _v0.F;
			return A2(
				$author$project$Types$SailsData$RouteTrip,
				direction,
				{F: decodingErrors, lA: maybeSails});
		},
		A2(
			$elm$json$Json$Decode$andThen,
			function (clubOneOnlyPromotion) {
				return A2(
					$elm$json$Json$Decode$field,
					'trips',
					A2($author$project$Types$SailsData$decodeRouteTripSailsTrips, _arguments, clubOneOnlyPromotion));
			},
			A2($elm$json$Json$Decode$field, 'isClubOneOnlyPromotion', $author$project$Types$SailsData$decodeIsClubOneOnlyPromotion)));
};
var $author$project$Api$Endpoint$timetables = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['timetables']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.m_));
	});
var $author$project$Api$Timetable$createRouteTripSailsRequest = F8(
	function (session, dateFrom, dateTo, direction, maybePreviousSelectedSails, maybeIsTurStoOvernightTrip, maybeVoucherId, resultToMsg) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.m_,
			$author$project$Api$getWithCredentials(
				{
					j9: A2(
						$elm$http$Http$expectJson,
						resultToMsg,
						$author$project$Types$SailsData$routeTripSailsDecoder(
							{vk: session.vk, p7: direction, rh: maybeIsTurStoOvernightTrip, rl: maybePreviousSelectedSails})),
					jW: A2(
						$author$project$Api$Endpoint$timetables,
						session.zM.Gs,
						A5($author$project$Api$Timetable$getUrlParams, session.zM, session, dateFrom, dateTo, maybeVoucherId))
				}));
	});
var $author$project$Api$Endpoint$cruiseMultiDepartureTimetables = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['timetable', 'cruises']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.m_));
	});
var $author$project$Types$CruiseMultiDepartureTrips$decodeIsClubOneOnlyPromotion = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(false),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool));
var $author$project$Types$CruiseMultiDepartureTrip$Ok = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$CruiseMultiDepartureTrip$SoldOut = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$CruiseMultiDepartureTrip$SoldOutTrip = F3(
	function (shipCode, outwardDepartureTime, returnArrivalTime) {
		return {rO: outwardDepartureTime, sr: returnArrivalTime, oX: shipCode};
	});
var $author$project$Types$CruiseMultiDepartureTrip$decodeSoldOutTrip = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'returnSail',
	A2($elm$json$Json$Decode$field, 'arrivalIsoDate', $author$project$Utils$Time$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outwardSail',
		A2($elm$json$Json$Decode$field, 'departureIsoDate', $author$project$Utils$Time$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'shipCode',
			$author$project$Types$ShipCode$decode,
			$elm$json$Json$Decode$succeed($author$project$Types$CruiseMultiDepartureTrip$SoldOutTrip))));
var $author$project$Types$CruiseMultiDepartureTrip$CruiseMultiDepartureTrip = function (id) {
	return function (vehiclePrice) {
		return function (personPrice) {
			return function (shipCode) {
				return function (isOvernight) {
					return function (isVoucherApplicable) {
						return function (ashorePeriod) {
							return function (marketingMessage) {
								return function (outwardSail) {
									return function (returnSail) {
										return function (sailPackageName) {
											return {pt: ashorePeriod, zN: id, qY: isOvernight, q0: isVoucherApplicable, rc: marketingMessage, rS: outwardSail, ov: personPrice, sw: returnSail, F5: sailPackageName, oX: shipCode, pe: vehiclePrice};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$CruiseMultiDepartureTrip$CruiseMultiDepartureSail = F6(
	function (departureTime, arrivalTime, portFrom, pierFrom, portTo, pierTo) {
		return {lm: arrivalTime, p3: departureTime, EJ: pierFrom, EX: pierTo, kF: portFrom, oB: portTo};
	});
var $author$project$Types$CruiseMultiDepartureTrip$sailDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to',
	A2($elm$json$Json$Decode$field, 'pier', $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'to',
		A2($elm$json$Json$Decode$field, 'port', $author$project$Types$Port$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'from',
			A2($elm$json$Json$Decode$field, 'pier', $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'from',
				A2($elm$json$Json$Decode$field, 'port', $author$project$Types$Port$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'arrivalIsoDate',
					$author$project$Utils$Time$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'departureIsoDate',
						$author$project$Utils$Time$decoder,
						$elm$json$Json$Decode$succeed($author$project$Types$CruiseMultiDepartureTrip$CruiseMultiDepartureSail)))))));
var $author$project$Types$CruiseMultiDepartureTrip$tripDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sailPackageName',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'returnSail',
		$author$project$Types$CruiseMultiDepartureTrip$sailDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'outwardSail',
			$author$project$Types$CruiseMultiDepartureTrip$sailDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'marketingMessage',
				$elm$json$Json$Decode$maybe($author$project$Types$MarketingMessage$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ashorePeriod',
					$author$project$Types$AshorePeriod$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'isVoucherApplicable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'isOvernight',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'shipCode',
								$author$project$Types$ShipCode$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'personPrice',
									$elm$json$Json$Decode$float,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'vehiclePrice',
										$elm$json$Json$Decode$float,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'sailId',
											$elm$json$Json$Decode$int,
											$elm$json$Json$Decode$succeed($author$project$Types$CruiseMultiDepartureTrip$CruiseMultiDepartureTrip))))))))))));
var $author$project$Types$CruiseMultiDepartureTrip$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (disabled) {
		return disabled ? $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing) : A2(
			$elm$json$Json$Decode$andThen,
			function (hasRoom) {
				return hasRoom ? A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$map, $author$project$Types$CruiseMultiDepartureTrip$Ok, $author$project$Types$CruiseMultiDepartureTrip$tripDecoder)) : A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$map, $author$project$Types$CruiseMultiDepartureTrip$SoldOut, $author$project$Types$CruiseMultiDepartureTrip$decodeSoldOutTrip));
			},
			A2($elm$json$Json$Decode$field, 'hasRoom', $elm$json$Json$Decode$bool));
	},
	A2($elm$json$Json$Decode$field, 'disabled', $elm$json$Json$Decode$bool));
var $author$project$Types$CruiseMultiDepartureTrips$decodeSails = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list($author$project$Types$CruiseMultiDepartureTrip$decoder));
var $author$project$Types$CruiseMultiDepartureTrips$voyageTypeParam = function (voyageType) {
	if (voyageType.$ === 6) {
		var cruiseType = voyageType.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				'voyageType',
				function () {
					if (!cruiseType) {
						return 'CRUISE';
					} else {
						return 'SHOPPING_CRUISE';
					}
				}()));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$CruiseMultiDepartureTrips$getUrlParameters = F2(
	function (_v0, session) {
		var dateFrom = _v0.a;
		var dateTo = _v0.b;
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			session.Aa,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A2(
					$elm$core$List$filter,
					function (a) {
						return !$elm$core$String$isEmpty(a.b);
					},
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pQ;
								},
								$author$project$Api$Util$voucherIdParam),
							$elm$core$List$head(session.tw)),
						A2(
							$author$project$Utils$List$maybeAdd,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Util$clubOneLevelParam,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.pO;
									},
									$author$project$Types$Passenger$findWithHighestLevel(session.Eg))),
							A2(
								$author$project$Utils$List$maybeAdd,
								$author$project$Types$CruiseMultiDepartureTrips$voyageTypeParam(session.tx),
								_List_fromArray(
									[
										$author$project$Api$Util$guidParam(session.zM.Gt),
										$author$project$Api$Util$localeParam(session.A_),
										$author$project$Api$Util$marketParam(session.rb),
										$author$project$Api$Util$fromParam(session.kS),
										$author$project$Api$Util$toParam(session.le),
										$author$project$Api$Util$dateFromParam(
										$author$project$Utils$Time$toDateString(dateFrom)),
										$author$project$Api$Util$dateToParam(
										$author$project$Utils$Time$toDateString(dateTo)),
										$author$project$Api$Util$vehicleVoyageTypeParam(
										($elm$core$List$length(session.yq) > 0) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing),
										$author$project$Api$Util$searchFutureSailsParam(false)
									])))))));
	});
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {q: day, nE: hour, oc: millisecond, oe: minute, s: month, oO: second, h: year};
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.h;
		var month = _v0.s;
		var day = _v0.q;
		var hour = _v0.nE;
		var minute = _v0.oe;
		var second = _v0.oO;
		var millisecond = _v0.oc;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Types$Date$toPosix = function (_v0) {
	var year = _v0.h;
	var month = _v0.s;
	var day = _v0.q;
	return A2(
		$justinmimbs$time_extra$Time$Extra$partsToPosix,
		$elm$time$Time$utc,
		A7($justinmimbs$time_extra$Time$Extra$Parts, year, month, day, 0, 0, 0, 0));
};
var $author$project$Types$CruiseMultiDepartureTrips$fetch = F2(
	function (dateFrom, session) {
		var dateTo = A4(
			$justinmimbs$time_extra$Time$Extra$add,
			3,
			2,
			$elm$time$Time$utc,
			$author$project$Types$Date$toPosix(dateFrom));
		var expect = A2(
			$elm$http$Http$expectJson,
			$elm$core$Basics$identity,
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (statuses, clubOneOnlyPromotion) {
						return _Utils_Tuple3(dateTo, statuses, clubOneOnlyPromotion);
					}),
				A2($elm$json$Json$Decode$field, 'sails', $author$project$Types$CruiseMultiDepartureTrips$decodeSails),
				A2($elm$json$Json$Decode$field, 'isClubOneOnlyPromotion', $author$project$Types$CruiseMultiDepartureTrips$decodeIsClubOneOnlyPromotion)));
		var url = A2(
			$author$project$Api$Endpoint$cruiseMultiDepartureTimetables,
			session.zM.Gs,
			A2(
				$author$project$Types$CruiseMultiDepartureTrips$getUrlParameters,
				_Utils_Tuple2(
					$author$project$Types$Date$toPosix(dateFrom),
					dateTo),
				session));
		return $author$project$Api$getWithCredentials(
			{j9: expect, jW: url});
	});
var $author$project$Types$Date$fromPosix = function (time) {
	return {
		q: A2($elm$time$Time$toDay, $elm$time$Time$utc, time),
		s: A2($elm$time$Time$toMonth, $elm$time$Time$utc, time),
		h: A2($elm$time$Time$toYear, $elm$time$Time$utc, time)
	};
};
var $author$project$Types$CruiseMultiDepartureTrips$selected = function (_v0) {
	var trips = _v0;
	return trips.Gg;
};
var $author$project$Types$RouteTripSails$selected = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return _Utils_Tuple2(
		outward.Gg,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Gg;
			},
			_return));
};
var $author$project$Types$CruiseSails$selectedDepartureAndArrivalTimes = function (_v0) {
	var cruiseSails = _v0;
	return _Utils_Tuple2(cruiseSails.Gg.b.rS.nr, cruiseSails.Gg.b.sw.ps);
};
var $author$project$Api$Timetable$getCruiseSailDateToRestore = function (session) {
	var time = function () {
		var _v0 = session.tp;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var cruise = _v0.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Types$CruiseSails$selectedDepartureAndArrivalTimes(cruise).a);
				case 1:
					var route = _v0.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Types$RouteTripSails$selected(route).a.nr);
				default:
					var cruiseMultiDeparture = _v0.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture).rS.p3);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return A2(
		$elm$core$Maybe$map,
		A2($justinmimbs$time_extra$Time$Extra$floor, 11, $elm$time$Time$utc),
		time);
};
var $author$project$Api$Timetable$getNumberOfMonthsToRequest = F2(
	function (dateFrom, dateTo) {
		return A2(
			$elm$core$Basics$max,
			2,
			1 + function (a) {
				return A4($justinmimbs$time_extra$Time$Extra$diff, 2, $elm$time$Time$utc, a, dateTo);
			}(
				A3($justinmimbs$time_extra$Time$Extra$floor, 2, $elm$time$Time$utc, dateFrom)));
	});
var $author$project$Utils$Route$isTurStoOvernightTrip = F4(
	function (url, cruiseTripType, from, to) {
		return A2(
			$elm$core$Maybe$map,
			function (isEvening) {
				return isEvening && (((from === 5) || (to === 5)) && (((from === 1) || (to === 1)) && (cruiseTripType === 1)));
			},
			$author$project$UrlRoute$bookingParamsFromLocation(url).yR);
	});
var $author$project$Types$CruiseMultiDepartureTrips$toArrivalTime = function (status) {
	if (!status.$) {
		var returnSail = status.a.sw;
		return returnSail.lm;
	} else {
		var returnArrivalTime = status.a.sr;
		return returnArrivalTime;
	}
};
var $author$project$Types$CruiseMultiDepartureTrips$toDepartureTime = function (status) {
	if (!status.$) {
		var outwardSail = status.a.rS;
		return outwardSail.p3;
	} else {
		var outwardDepartureTime = status.a.rO;
		return outwardDepartureTime;
	}
};
var $author$project$Types$CruiseMultiDepartureTrips$compareTripByDepartureAndArrivalTime = F2(
	function (a, b) {
		var compareTime = F2(
			function (timeA, timeB) {
				return (_Utils_cmp(
					$elm$time$Time$posixToMillis(timeA),
					$elm$time$Time$posixToMillis(timeB)) < 0) ? 0 : ((_Utils_cmp(
					$elm$time$Time$posixToMillis(timeA),
					$elm$time$Time$posixToMillis(timeB)) > 0) ? 2 : 1);
			});
		var hasSameDepartureTime = A2(
			compareTime,
			$author$project$Types$CruiseMultiDepartureTrips$toDepartureTime(a),
			$author$project$Types$CruiseMultiDepartureTrips$toDepartureTime(b)) === 1;
		return hasSameDepartureTime ? A2(
			compareTime,
			$author$project$Types$CruiseMultiDepartureTrips$toArrivalTime(a),
			$author$project$Types$CruiseMultiDepartureTrips$toArrivalTime(b)) : A2(
			compareTime,
			$author$project$Types$CruiseMultiDepartureTrips$toDepartureTime(a),
			$author$project$Types$CruiseMultiDepartureTrips$toDepartureTime(b));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Types$CruiseMultiDepartureTrips$toStatusList = function (_v0) {
	var trips = _v0;
	return A2(
		$elm$core$List$sortWith,
		$author$project$Types$CruiseMultiDepartureTrips$compareTripByDepartureAndArrivalTime,
		A2(
			$elm$core$List$cons,
			$author$project$Types$CruiseMultiDepartureTrip$Ok(trips.Gg),
			trips.lH));
};
var $author$project$Types$CruiseMultiDepartureTrips$toList = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$CruiseMultiDepartureTrips$toStatusList,
	$elm$core$List$filterMap(
		function (status) {
			if (!status.$) {
				var trip = status.a;
				return $elm$core$Maybe$Just(trip);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}));
var $author$project$Types$CruiseMultiDepartureTrips$toPreviousSail = function (trips) {
	return {
		p3: A3(
			$elm$core$Basics$composeR,
			$author$project$Types$CruiseMultiDepartureTrips$selected,
			function ($) {
				return $.rS;
			},
			trips).p3,
		F3: $author$project$Types$CruiseMultiDepartureTrips$selected(trips).zN
	};
};
var $author$project$Types$RouteTripSails$toPreviousSail = function (_v0) {
	var sailId = _v0.F3;
	var departureIsoDate = _v0.nr;
	return {p3: departureIsoDate, F3: sailId};
};
var $author$project$Types$RouteTripSails$toPreviousSails = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return _Utils_Tuple2(
		$author$project$Types$RouteTripSails$toPreviousSail(outward.Gg),
		A2(
			$elm$core$Maybe$map,
			$author$project$Types$RouteTripSails$toPreviousSail,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Gg;
				},
				_return)));
};
var $author$project$Api$Timetable$fetch = F2(
	function (times, model) {
		var session = model.j;
		var routeTripSails = function () {
			var _v7 = session.tp;
			_v7$2:
			while (true) {
				switch (_v7.$) {
					case 2:
						if ((!_v7.a.$) && (_v7.a.a.$ === 1)) {
							var route = _v7.a.a.a;
							return $elm$core$Maybe$Just(route);
						} else {
							break _v7$2;
						}
					case 0:
						if (_v7.a.$ === 1) {
							var route = _v7.a.a;
							return $elm$core$Maybe$Just(route);
						} else {
							break _v7$2;
						}
					default:
						break _v7$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var maybeVoucherId = $author$project$UrlRoute$bookingParamsFromLocation(model.n1).Iv;
		var maybeRouteTripPreviousSails = function () {
			var _v6 = session.tp;
			_v6$4:
			while (true) {
				switch (_v6.$) {
					case 0:
						switch (_v6.a.$) {
							case 1:
								var route = _v6.a.a;
								return $elm$core$Maybe$Just(
									$author$project$Types$RouteTripSails$toPreviousSails(route));
							case 2:
								var cruiseMultiDeparture = _v6.a.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Types$CruiseMultiDepartureTrips$toPreviousSail(cruiseMultiDeparture),
										$elm$core$Maybe$Nothing));
							default:
								break _v6$4;
						}
					case 2:
						if (!_v6.a.$) {
							switch (_v6.a.a.$) {
								case 1:
									var route = _v6.a.a.a;
									return $elm$core$Maybe$Just(
										$author$project$Types$RouteTripSails$toPreviousSails(route));
								case 2:
									var cruiseMultiDeparture = _v6.a.a.a;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$Types$CruiseMultiDepartureTrips$toPreviousSail(cruiseMultiDeparture),
											$elm$core$Maybe$Nothing));
								default:
									break _v6$4;
							}
						} else {
							break _v6$4;
						}
					default:
						break _v6$4;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var lazyRouteTripRequest = function (_v5) {
			var startDate = A2(
				$elm$core$Maybe$withDefault,
				A2($elm$core$Maybe$withDefault, times.ld, times.mZ),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$RouteTripSails$available(session.vk),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$filterMap($author$project$Types$RouteTripSail$toReal),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$head,
									$elm$core$Maybe$map(
										function ($) {
											return $.nr;
										}))))),
					routeTripSails));
			return A8(
				$author$project$Api$Timetable$createRouteTripSailsRequest,
				session,
				startDate,
				A4($justinmimbs$time_extra$Time$Extra$add, 3, $author$project$Api$Timetable$amountOfWeeksToFetch, $elm$time$Time$utc, startDate),
				0,
				maybeRouteTripPreviousSails,
				A4($author$project$Utils$Route$isTurStoOvernightTrip, model.n1, session.mm, session.kS, session.le),
				maybeVoucherId,
				$author$project$Messages$GotTrips(
					$author$project$Update$RequestTimes$create(startDate)));
		};
		var lazyCruiseRequest = function (_v4) {
			var sailDateToRestore = A2(
				$elm$core$Maybe$withDefault,
				times.ld,
				A2(
					$author$project$Types$Maybe$Util$orElse,
					$author$project$Api$Timetable$getCruiseSailDateToRestore(session),
					times.mZ));
			var numberOfMonthsToFetch = function () {
				var _v3 = times.F4;
				if (!_v3.$) {
					return 4;
				} else {
					return A2($author$project$Api$Timetable$getNumberOfMonthsToRequest, times.ld, sailDateToRestore);
				}
			}();
			return A6(
				$author$project$Api$Timetable$createCruiseSailsRequest,
				session.zM,
				session,
				times.ld,
				numberOfMonthsToFetch,
				maybeVoucherId,
				$author$project$Messages$GotTrips(times));
		};
		var cruiseMultiDepartureTrips = function () {
			var _v2 = session.tp;
			_v2$2:
			while (true) {
				switch (_v2.$) {
					case 2:
						if ((!_v2.a.$) && (_v2.a.a.$ === 2)) {
							var trips = _v2.a.a.a;
							return $elm$core$Maybe$Just(trips);
						} else {
							break _v2$2;
						}
					case 0:
						if (_v2.a.$ === 2) {
							var trips = _v2.a.a;
							return $elm$core$Maybe$Just(trips);
						} else {
							break _v2$2;
						}
					default:
						break _v2$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var lazyCruiseMultiDepartureRequest = function (_v1) {
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$GotCruiseMultiDepartureTrips,
				A2(
					$author$project$Types$CruiseMultiDepartureTrips$fetch,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Types$Date$fromPosix(
							A2($elm$core$Maybe$withDefault, times.ld, times.mZ)),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.rS;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.p3;
									},
									$author$project$Types$Date$fromPosix)),
							A2(
								$elm$core$Maybe$andThen,
								A2($elm$core$Basics$composeR, $author$project$Types$CruiseMultiDepartureTrips$toList, $elm$core$List$head),
								cruiseMultiDepartureTrips))),
					session));
		};
		var _v0 = session.tx;
		switch (_v0.$) {
			case 0:
				return lazyCruiseRequest(0);
			case 1:
				return lazyCruiseRequest(0);
			case 5:
				return lazyCruiseRequest(0);
			case 2:
				return lazyRouteTripRequest(0);
			case 3:
				return lazyRouteTripRequest(0);
			case 4:
				return lazyCruiseRequest(0);
			default:
				return lazyCruiseMultiDepartureRequest(0);
		}
	});
var $author$project$Types$Trips$statusToMaybe = function (status) {
	if (!status.$) {
		var trips = status.a;
		return $elm$core$Maybe$Just(trips);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Update$Trips$fetchTripsWithTimes = F2(
	function (times, model) {
		var session = model.j;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: _Utils_update(
						session,
						{
							pr: false,
							Ad: false,
							Af: true,
							B7: $elm$core$Maybe$Nothing,
							B8: $elm$core$Maybe$Nothing,
							tp: $author$project$Types$Trips$Loading(
								$author$project$Types$Trips$statusToMaybe(session.tp))
						})
				}),
			A2($author$project$Api$Timetable$fetch, times, model));
	});
var $author$project$Main$getKey = function (model) {
	switch (model.$) {
		case 2:
			var key = model.a.AK;
			return key;
		case 0:
			var key = model.a.AK;
			return key;
		default:
			var key = model.a.AK;
			return key;
	}
};
var $author$project$Model$OfflineBooking = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$OfflineInitial = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$initOffline = function (model) {
	switch (model.$) {
		case 1:
			var bookingModel = model.a;
			return $author$project$Model$Offline(
				{
					AK: bookingModel.AK,
					A_: bookingModel.j.A_,
					rb: bookingModel.j.rb,
					F7: $author$project$Model$OfflineBooking(bookingModel),
					Gt: $elm$core$Maybe$Nothing
				});
		case 0:
			var initialModel = model.a;
			return $author$project$Model$Offline(
				{
					AK: initialModel.AK,
					A_: initialModel.A_,
					rb: initialModel.rb,
					F7: $author$project$Model$OfflineInitial(initialModel),
					Gt: $elm$core$Maybe$Nothing
				});
		default:
			return model;
	}
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Update$replaceSessionGuid = F2(
	function (guid, model) {
		var httpConfig = function (a) {
			return _Utils_update(
				a,
				{Gt: guid});
		}(model.j.zM);
		return _Utils_update(
			model,
			{
				j: function (a) {
					return _Utils_update(
						a,
						{zM: httpConfig});
				}(model.j)
			});
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$sendAppLoadedMessageToNativeWrapper = _Platform_outgoingPort(
	'sendAppLoadedMessageToNativeWrapper',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$ConnectionProblemPage$Update$urlFromSavedModel = function (model) {
	if (!model.$) {
		var location = model.a.n1;
		return location;
	} else {
		var url = model.a.jW;
		return url;
	}
};
var $author$project$ConnectionProblemPage$Update$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.F7);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var bookingModel = _v0.b.a;
				return _Utils_Tuple2(
					model,
					$author$project$ConnectionProblemPage$Update$createGuid(bookingModel.j));
			} else {
				var _v2 = _v0.a;
				var savedModel = _v0.b.a;
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$UrlRoute$replaceUrl,
						model.AK,
						$author$project$ConnectionProblemPage$Update$urlFromSavedModel(
							$author$project$Model$OfflineInitial(savedModel)),
						$author$project$UrlRoute$Root));
			}
		} else {
			var result = _v0.a.a;
			var savedModel = _v0.b;
			if (!result.$) {
				var sessionGuid = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Gt: $elm$core$Maybe$Just(sessionGuid)
						}),
					A3(
						$author$project$UrlRoute$replaceUrl,
						model.AK,
						$author$project$ConnectionProblemPage$Update$urlFromSavedModel(savedModel),
						$author$project$UrlRoute$Root));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Messages$DebouncedSummaryRequest = function (a) {
	return {$: 115, a: a};
};
var $author$project$Update$Summary$debounceTimeout = 1000;
var $author$project$Types$ClubOneSlider$toMaybeEnabled = function (maybeClubOneSlider) {
	if ((!maybeClubOneSlider.$) && (!maybeClubOneSlider.a.$)) {
		var enabledClubOneSlider = maybeClubOneSlider.a.a;
		return $elm$core$Maybe$Just(enabledClubOneSlider);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$SummaryRequestValues$fromSession = function (session) {
	return {
		vk: session.vk,
		pD: session.Gh,
		wf: A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.E0;
				},
				$author$project$Types$ClubOneSlider$toMaybeEnabled(session.n8))),
		xA: session.xA,
		qk: session.qk,
		AE: session.AE,
		AZ: A2(
			$elm$core$List$filter,
			function (_v0) {
				var count = _v0.a;
				return count > 0;
			},
			session.Gl),
		B0: session.B0,
		B2: session.B2,
		rp: session.rp,
		rI: session.rI,
		Eg: session.Eg,
		Gi: session.Gi,
		Gk: session.Gk,
		Gm: session.Gm,
		Gn: session.Gn,
		Go: session.Go,
		to: session.to,
		tp: session.tp,
		Ia: session.Ia,
		Iw: A2(
			$elm$core$List$map,
			function ($) {
				return $.pQ;
			},
			session.tw),
		tx: session.tx
	};
};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Update$Summary$addSummaryRequest = F2(
	function (_v0, newBody) {
		var model = _v0.a;
		var session = model.j;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					pz: function (a) {
						return _Utils_update(
							a,
							{GD: true});
					}(model.pz),
					j: _Utils_update(
						session,
						{
							Af: true,
							B7: session.Ez ? session.B7 : $elm$core$Maybe$Nothing,
							B8: $elm$core$Maybe$Just(
								$author$project$Types$SummaryRequestValues$fromSession(session))
						})
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$Api$Endpoint$cancel($author$project$Api$Endpoint$trackers.s4),
						A2(
						$elm$core$Task$perform,
						function (_v1) {
							return $author$project$Messages$DebouncedSummaryRequest(newBody);
						},
						$elm$core$Process$sleep($author$project$Update$Summary$debounceTimeout))
					])));
	});
var $author$project$Update$Summary$cancelSummaryRequest = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{Af: false, B7: $elm$core$Maybe$Nothing, B8: $elm$core$Maybe$Nothing})
			}),
		$author$project$Api$Endpoint$cancel($author$project$Api$Endpoint$trackers.s4));
};
var $author$project$Types$JoinClubOneState$Joining = {$: 5};
var $author$project$Types$Passenger$getAllAgeCategories = function (passengers) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.tY;
		},
		$elm$core$Array$toList(passengers));
};
var $author$project$Types$TravelClasses$getTravelClass = function (code) {
	return $elm_community$list_extra$List$Extra$find(
		function (_v0) {
			var outwardTravelClass = _v0.DA;
			var returnTravelClass = _v0.FT;
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(code)),
					outwardTravelClass)) || A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(code)),
					returnTravelClass));
		});
};
var $author$project$Types$TravelClasses$getPetCodeAndCountPairs = F2(
	function (_v0, getDirectionInfo) {
		var petPlace = _v0.r1;
		var petCabins = _v0.EB;
		var isCabinCodeForPetPlace = function (code) {
			return !_Utils_eq(
				A2($author$project$Types$TravelClasses$getTravelClass, code, petCabins),
				$elm$core$Maybe$Nothing);
		};
		return A2(
			$elm$core$Dict$foldl,
			F3(
				function (code, count, accumulator) {
					return isCabinCodeForPetPlace(code) ? A2(
						$elm$core$Maybe$withDefault,
						accumulator,
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return A2($elm$core$List$cons, a, accumulator);
							},
							A2(
								$elm$core$Maybe$map,
								function (info) {
									return _Utils_Tuple2(info.pQ, count);
								},
								A2($elm$core$Maybe$andThen, getDirectionInfo, petPlace)))) : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(code, count),
						accumulator);
				}),
			_List_Nil);
	});
var $author$project$Types$TravelClasses$getSelectedCodeCountPairLists = function (travelClasses) {
	switch (travelClasses.$) {
		case 0:
			var selected = travelClasses.a.Gg;
			var pets = travelClasses.a.k;
			var available = travelClasses.a.nb;
			var petPairs = A3(
				$author$project$Types$TravelClasses$getPetCodeAndCountPairs,
				available,
				function ($) {
					return $.Ds;
				},
				pets);
			return {
				zT: _List_Nil,
				Dr: _Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(selected, 1)
						]),
					petPairs)
			};
		case 1:
			var outward = travelClasses.a.Ds;
			var _return = travelClasses.a.FL;
			var outwardPets = travelClasses.a.m;
			var returnPets = travelClasses.a.t;
			var available = travelClasses.a.nb;
			var returnPetPairs = A3(
				$author$project$Types$TravelClasses$getPetCodeAndCountPairs,
				available,
				function ($) {
					return $.FL;
				},
				returnPets);
			var outwardPetPairs = A3(
				$author$project$Types$TravelClasses$getPetCodeAndCountPairs,
				available,
				function ($) {
					return $.Ds;
				},
				outwardPets);
			return {
				zT: _Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(_return, 1)
						]),
					returnPetPairs),
				Dr: _Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(outward, 1)
						]),
					outwardPetPairs)
			};
		case 2:
			var selected = travelClasses.a.Gg;
			var pets = travelClasses.a.k;
			var available = travelClasses.a.nb;
			var petPairs = A3(
				$author$project$Types$TravelClasses$getPetCodeAndCountPairs,
				available,
				function ($) {
					return $.Ds;
				},
				pets);
			return {
				zT: _List_Nil,
				Dr: _Utils_ap(selected, petPairs)
			};
		default:
			var outward = travelClasses.a.Ds;
			var _return = travelClasses.a.FL;
			var outwardPets = travelClasses.a.m;
			var returnPets = travelClasses.a.t;
			var available = travelClasses.a.nb;
			var returnPetPairs = A3(
				$author$project$Types$TravelClasses$getPetCodeAndCountPairs,
				available,
				function ($) {
					return $.FL;
				},
				returnPets);
			var outwardPetPairs = A3(
				$author$project$Types$TravelClasses$getPetCodeAndCountPairs,
				available,
				function ($) {
					return $.Ds;
				},
				outwardPets);
			return {
				zT: _Utils_ap(_return, returnPetPairs),
				Dr: _Utils_ap(outward, outwardPetPairs)
			};
	}
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Types$SelectedVehicles$toList = function (_v0) {
	var first = _v0.nx;
	var others = _v0.lH;
	return A2(
		$elm$core$List$cons,
		first,
		$elm$core$Array$toList(others));
};
var $author$project$Types$SelectedVehicles$selectedVehiclesWithVoyageTypeList = function (vehicles) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.tx;
			},
			$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
		$author$project$Types$SelectedVehicles$toList(vehicles));
};
var $author$project$Update$Summary$haveSummaryValuesChanged = F2(
	function (_new, old) {
		var hasChanged = function (selector) {
			return !_Utils_eq(
				selector(old),
				selector(_new));
		};
		return hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Ia;
				},
				function ($) {
					return $.v4;
				})) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.to;
				},
				$elm$core$Maybe$map($author$project$Types$TravelClasses$getSelectedCodeCountPairLists))) || (hasChanged(
			function ($) {
				return $.pD;
			}) || (hasChanged(
			function ($) {
				return $.B2;
			}) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rp;
				},
				$elm$core$Maybe$map($author$project$Types$SelectedVehicles$selectedVehiclesWithVoyageTypeList))) || (hasChanged(
			function ($) {
				return $.Gn;
			}) || (hasChanged(
			function ($) {
				return $.Go;
			}) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Eg;
				},
				$elm$core$Array$length)) || (hasChanged(
			function ($) {
				return $.Iw;
			}) || (hasChanged(
			function ($) {
				return $.Gm;
			}) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Gi;
				},
				function ($) {
					return $.DC;
				})) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Gi;
				},
				function ($) {
					return $.FV;
				})) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Eg;
				},
				$author$project$Types$Passenger$getAllAgeCategories)) || (hasChanged(
			function ($) {
				return $.B0;
			}) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.AE;
				},
				$elm$core$Basics$eq($author$project$Types$JoinClubOneState$Joining))) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.xA;
				},
				$elm$core$Maybe$map(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.yt;
						},
						function ($) {
							return $.zN;
						})))) || (hasChanged(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.xA;
				},
				$elm$core$Maybe$andThen(
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.tZ;
						},
						$elm$core$Maybe$map(
							function ($) {
								return $.zN;
							}))))) || (hasChanged(
			function ($) {
				return $.AZ;
			}) || (hasChanged(
			function ($) {
				return $.Gk;
			}) || hasChanged(
			function ($) {
				return $.wf;
			})))))))))))))))))));
	});
var $author$project$Types$CruiseSails$selected = function (_v0) {
	var cruiseSails = _v0;
	return cruiseSails.Gg;
};
var $author$project$Types$CruiseSails$getSailIds = function (cruiseSails) {
	return function (_v0) {
		var sailId = _v0.F3;
		var outwardSail = _v0.rS;
		var returnSail = _v0.sw;
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(sailId, returnSail.F3),
			A2(
				$elm$core$Maybe$map,
				function (outwardSailId) {
					return _Utils_Tuple2(outwardSailId, returnSail.F3);
				},
				outwardSail.F3));
	}(
		$author$project$Types$CruiseSails$selected(cruiseSails).b);
};
var $author$project$Types$RouteTripSails$getSailIds = function (trips) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Maybe$map(
			function ($) {
				return $.F3;
			}),
		A2(
			$elm$core$Tuple$mapFirst,
			function ($) {
				return $.F3;
			},
			$author$project$Types$RouteTripSails$selected(trips)));
};
var $author$project$Types$Trips$sailIds = function (trips) {
	switch (trips.$) {
		case 0:
			var cruise = trips.a;
			return $author$project$Types$CruiseSails$getSailIds(cruise);
		case 1:
			var route = trips.a;
			return $author$project$Types$RouteTripSails$getSailIds(route);
		default:
			var cruiseMultiDeparture = trips.a;
			return _Utils_Tuple2(
				$author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture).zN,
				$elm$core$Maybe$Nothing);
	}
};
var $author$project$Update$Summary$isRequiredTravelClassSelected = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$Trips$sailIds,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$Basics$eq($elm$core$Maybe$Nothing))),
				function (isOneWay) {
					var travelClasses = A2(
						$elm$core$Maybe$withDefault,
						{zT: _List_Nil, Dr: _List_Nil},
						A2($elm$core$Maybe$map, $author$project$Types$TravelClasses$getSelectedCodeCountPairLists, model.j.to));
					return isOneWay ? ((!$elm$core$List$isEmpty(travelClasses.Dr)) && $elm$core$List$isEmpty(travelClasses.zT)) : ((!$elm$core$List$isEmpty(travelClasses.Dr)) && (!$elm$core$List$isEmpty(travelClasses.zT)));
				}),
			$author$project$Types$Trips$statusToMaybe(model.j.tp)));
};
var $author$project$Types$SelectedVehicles$isOutwardSelected = function (_v0) {
	var voyageType = _v0.tx;
	return _Utils_eq(
		voyageType,
		$elm$core$Maybe$Just(0)) || _Utils_eq(
		voyageType,
		$elm$core$Maybe$Just(1));
};
var $author$project$Types$SelectedVehicles$isReturnSelected = function (_v0) {
	var voyageType = _v0.tx;
	return _Utils_eq(
		voyageType,
		$elm$core$Maybe$Just(0)) || _Utils_eq(
		voyageType,
		$elm$core$Maybe$Just(2));
};
var $author$project$Types$SelectedVehicles$getVehicleCodes = F2(
	function (direction, selectedVehicles) {
		var isSelected = function () {
			if (!direction) {
				return $author$project$Types$SelectedVehicles$isOutwardSelected;
			} else {
				return $author$project$Types$SelectedVehicles$isReturnSelected;
			}
		}();
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.jZ;
			},
			A2(
				$elm$core$List$filter,
				isSelected,
				$author$project$Types$SelectedVehicles$toList(selectedVehicles)));
	});
var $author$project$Utils$Number$Positive$toNumber = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Types$SelectedVehicles$isEveryPassengerWithSeat = F3(
	function (passengerCount, vehicles, carCategories) {
		return function (seats) {
			return _Utils_cmp(seats, passengerCount) > -1;
		}(
			$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.vM;
						},
						$author$project$Utils$Number$Positive$toNumber),
					A2(
						$elm$core$List$filterMap,
						function (a) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.jZ;
									},
									$elm$core$Basics$eq(a)),
								vehicles);
						},
						carCategories))));
	});
var $author$project$Types$SelectedVehicles$isEveryPassengerWithOutwardSeat = F3(
	function (passengerCount, vehicles, selectedVehicles) {
		return A3(
			$author$project$Types$SelectedVehicles$isEveryPassengerWithSeat,
			passengerCount,
			vehicles,
			A2($author$project$Types$SelectedVehicles$getVehicleCodes, 0, selectedVehicles));
	});
var $author$project$Types$Direction$RETURN = 1;
var $author$project$Types$SelectedVehicles$isEveryPassengerWithReturnSeat = F3(
	function (passengerCount, vehicles, selectedVehicles) {
		return A3(
			$author$project$Types$SelectedVehicles$isEveryPassengerWithSeat,
			passengerCount,
			vehicles,
			A2($author$project$Types$SelectedVehicles$getVehicleCodes, 1, selectedVehicles));
	});
var $author$project$Utils$Route$isRequiredHelper = F2(
	function (requiredCondition, session) {
		var isOneWay = session.qW;
		return (isOneWay && requiredCondition(
			$author$project$Utils$Route$outwardRequiredArguments(session))) || ((!isOneWay) && (requiredCondition(
			$author$project$Utils$Route$outwardRequiredArguments(session)) || requiredCondition(
			$author$project$Utils$Route$returnRequiredArguments(session))));
	});
var $author$project$Utils$Route$isVehicleRequired = $author$project$Utils$Route$isRequiredHelper($author$project$Utils$Route$isVehicleRequiredHelper);
var $author$project$Session$isEveryPassengerWithVehicleSeat = function (session) {
	var vehicleRequiredForReturn = $author$project$Utils$Route$isVehicleRequiredForReturn(session);
	var vehicleRequiredForOutward = $author$project$Utils$Route$isVehicleRequiredForOutward(session);
	var passengerCount = $elm$core$Array$length(session.Eg);
	return $author$project$Utils$Route$isVehicleRequired(session) ? A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (selectedVehicles) {
				return session.qW ? ((!vehicleRequiredForOutward) || A3($author$project$Types$SelectedVehicles$isEveryPassengerWithOutwardSeat, passengerCount, session.tt, selectedVehicles)) : (((!vehicleRequiredForOutward) || A3($author$project$Types$SelectedVehicles$isEveryPassengerWithOutwardSeat, passengerCount, session.tt, selectedVehicles)) && ((!vehicleRequiredForReturn) || A3($author$project$Types$SelectedVehicles$isEveryPassengerWithReturnSeat, passengerCount, session.tt, selectedVehicles)));
			},
			session.rp)) : true;
};
var $author$project$Update$Summary$isSummaryRequestBlocked = function (model) {
	return (!model.j.pr) || ((!$author$project$Update$Summary$isRequiredTravelClassSelected(model)) || (!$author$project$Session$isEveryPassengerWithVehicleSeat(model.j)));
};
var $author$project$Common$Ports$digiData = _Platform_outgoingPort('digiData', $elm$core$Basics$identity);
var $author$project$DataTracking$Util$bookingMapping = _List_fromArray(
	[
		_Utils_Tuple3('^/clubOnePage', 'club-one', 'club-one-login'),
		_Utils_Tuple3('^/connectionProblem', 'connection-problem', 'connection-problem'),
		_Utils_Tuple3('^/contactPerson', 'contact-person', 'contact-person'),
		_Utils_Tuple3('^/meal', 'dinings-onboard', 'dinings-onboard'),
		_Utils_Tuple3('^/passenger/?$', 'passengers-list', 'passengers'),
		_Utils_Tuple3('^/passengerDetails', 'passenger-details', 'passengers'),
		_Utils_Tuple3('^/bank', 'bank', 'payment'),
		_Utils_Tuple3('^/creditCard', 'credit-card', 'payment'),
		_Utils_Tuple3('^/klarnaPage', 'klarna', 'payment'),
		_Utils_Tuple3('^/klarnaTermsAndConditions', 'klarna-terms', 'payment'),
		_Utils_Tuple3('^/paymentMethod', 'payment-method', 'payment'),
		_Utils_Tuple3('^/timetable/routetrip/outward/calendar', 'outward-routetrip-calendar', 'timetable'),
		_Utils_Tuple3('^/timetable/routetrip/outward$', 'outward-routetrip-timetable', 'timetable'),
		_Utils_Tuple3('^/timetable/routetrip/return/calendar', 'return-routetrip-calendar', 'timetable'),
		_Utils_Tuple3('^/timetable/routetrip/return$', 'return-routetrip-timetable', 'timetable'),
		_Utils_Tuple3('^/timetable/shuttle/outward/calendar', 'outward-shuttle-calendar', 'timetable'),
		_Utils_Tuple3('^/timetable/shuttle/outward$', 'outward-shuttle-timetable', 'timetable'),
		_Utils_Tuple3('^/timetable/shuttle/return/calendar', 'return-shuttle-calendar', 'timetable'),
		_Utils_Tuple3('^/timetable/shuttle/return$', 'return-shuttle-timetable', 'timetable'),
		_Utils_Tuple3('^/timetable/cruise', 'cruise-timetable', 'timetable'),
		_Utils_Tuple3('^/timetable/megastar', 'cruise-megastar-timetable', 'timetable'),
		_Utils_Tuple3('^/travelClass', 'travel-class', 'travel-class'),
		_Utils_Tuple3('^/vehicle/?$', 'vehicles', 'vehicle'),
		_Utils_Tuple3('^/vehicleList', 'vehicle-list', 'vehicle'),
		_Utils_Tuple3('^/companyCustomer', 'campaign', 'campaign'),
		_Utils_Tuple3('^/busTransfer', 'transfer', 'transfer'),
		_Utils_Tuple3('^/onboardServices', 'onboard-services', 'onboard-services'),
		_Utils_Tuple3('^/extraServices', 'extra-services', 'extra-services'),
		_Utils_Tuple3('^/confirmation/passengers/?$', 'confirmation-passengers-list', 'confirmation'),
		_Utils_Tuple3('^/confirmation/passengers/\\d', 'confirmation-passenger-details', 'confirmation'),
		_Utils_Tuple3('^/confirmation/vehicles/', 'confirmation-vehicles', 'confirmation'),
		_Utils_Tuple3('^/confirmation/?$', 'confirmation', 'confirmation'),
		_Utils_Tuple3('^/$', 'frontpage', 'frontpage')
	]);
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$never = _Regex_never;
var $author$project$DataTracking$Util$titleAndCategory = function (url) {
	var pathBase = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$String$split,
				'/',
				A2($elm$core$String$dropLeft, 1, url))));
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple3(pathBase, pathBase, pathBase),
		A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v0) {
				var str = _v0.a;
				return A2(
					$elm$regex$Regex$contains,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$regex$Regex$never,
						$elm$regex$Regex$fromString(str)),
					url);
			},
			$author$project$DataTracking$Util$bookingMapping));
};
var $author$project$DataTracking$Util$category = function (url) {
	return function (_v0) {
		var c = _v0.c;
		return $elm$json$Json$Encode$string(c);
	}(
		$author$project$DataTracking$Util$titleAndCategory(url));
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Types$PassengerCount$encodeCustomers = function (passengerCount) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'adults',
				$elm$json$Json$Encode$int(passengerCount.tV)),
				_Utils_Tuple2(
				'children',
				$elm$json$Json$Encode$int(passengerCount.vU)),
				_Utils_Tuple2(
				'juniors',
				$elm$json$Json$Encode$int(passengerCount.AI)),
				_Utils_Tuple2(
				'infants',
				$elm$json$Json$Encode$int(passengerCount.IF))
			]));
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$DataTracking$Model$encodeTravelClassService = F3(
	function (code, count, _v0) {
		var name = _v0.oh;
		var price = _v0.lN;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(
						$elm$core$String$toLower(code))),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(
						$elm$core$String$toLower(
							A3($elm$core$String$replace, ' ', '-', name)))),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(count)),
					_Utils_Tuple2(
					'price',
					$elm$json$Json$Encode$float(price))
				]));
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Types$TravelClasses$allFromAvailable = function (_v0) {
	var regular = _v0.Fx;
	var special = _v0.GN;
	var petCabins = _v0.EB;
	var shared = _v0.kI;
	return _Utils_ap(
		regular,
		_Utils_ap(
			special,
			_Utils_ap(petCabins, shared)));
};
var $author$project$Types$TravelClasses$availableTravelClasses = function (travelClasses) {
	switch (travelClasses.$) {
		case 0:
			var available = travelClasses.a.nb;
			return available;
		case 1:
			var available = travelClasses.a.nb;
			return available;
		case 2:
			var available = travelClasses.a.nb;
			return available;
		default:
			var available = travelClasses.a.nb;
			return available;
	}
};
var $author$project$Types$TravelClasses$all = function (travelClasses) {
	return $author$project$Types$TravelClasses$allFromAvailable(
		$author$project$Types$TravelClasses$availableTravelClasses(travelClasses));
};
var $author$project$Types$TravelClasses$petTravelClasses = function (_v0) {
	var petCages = _v0.EC;
	var petPlace = _v0.r1;
	var petInBag = _v0.ED;
	var petInCar = _v0.EE;
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[petCages, petPlace, petInBag, petInCar]));
};
var $author$project$Types$TravelClasses$getPetTravelClassByCode = F2(
	function (travelClasses, code) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v0) {
				var outward = _v0.Ds;
				var _return = _v0.FL;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(code)),
						outward)) || A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(code)),
						_return));
			},
			$author$project$Types$TravelClasses$petTravelClasses(
				$author$project$Types$TravelClasses$availableTravelClasses(travelClasses)));
	});
var $author$project$DataTracking$Model$outwardTravelClassInfo = F2(
	function (code, travelClasses) {
		return A2(
			$author$project$Types$Maybe$Util$orElse,
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2(
						$elm$core$Maybe$map,
						function (price) {
							return {oh: a.oh, lN: price};
						},
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lN;
							},
							a.Ds));
				},
				A2($author$project$Types$TravelClasses$getPetTravelClassByCode, travelClasses, code)),
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2(
						$elm$core$Maybe$map,
						function (price) {
							return {oh: a.oh, lN: price};
						},
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lN;
							},
							a.DA));
				},
				A2(
					$author$project$Types$TravelClasses$getTravelClass,
					code,
					$author$project$Types$TravelClasses$all(travelClasses))));
	});
var $author$project$DataTracking$Model$encodeOutwardTravelClassServices = function (session) {
	return A2(
		$elm$json$Json$Encode$list,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var code = _v0.a;
				var count = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$author$project$DataTracking$Model$outwardTravelClassInfo(code),
						$elm$core$Maybe$map(
							A2($author$project$DataTracking$Model$encodeTravelClassService, code, count))),
					session.to);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Dr;
						},
						A2($elm$core$Maybe$map, $author$project$Types$TravelClasses$getSelectedCodeCountPairLists, session.to)),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.DB;
							},
							$elm$core$Maybe$Just),
						session.B7)))));
};
var $author$project$DataTracking$Model$returnTravelClassInfo = F2(
	function (code, travelClasses) {
		return A2(
			$author$project$Types$Maybe$Util$orElse,
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2(
						$elm$core$Maybe$map,
						function (price) {
							return {oh: a.oh, lN: price};
						},
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lN;
							},
							a.FL));
				},
				A2($author$project$Types$TravelClasses$getPetTravelClassByCode, travelClasses, code)),
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2(
						$elm$core$Maybe$map,
						function (price) {
							return {oh: a.oh, lN: price};
						},
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lN;
							},
							a.FT));
				},
				A2(
					$author$project$Types$TravelClasses$getTravelClass,
					code,
					$author$project$Types$TravelClasses$all(travelClasses))));
	});
var $author$project$DataTracking$Model$encodeReturnTravelClassServices = function (session) {
	return A2(
		$elm$json$Json$Encode$list,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var code = _v0.a;
				var count = _v0.b;
				return A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$author$project$DataTracking$Model$returnTravelClassInfo(code),
						$elm$core$Maybe$map(
							A2($author$project$DataTracking$Model$encodeTravelClassService, code, count))),
					session.to);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.zT;
						},
						A2($elm$core$Maybe$map, $author$project$Types$TravelClasses$getSelectedCodeCountPairLists, session.to)),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.FU;
							},
							$elm$core$Maybe$Just),
						session.B7)))));
};
var $author$project$DataTracking$Model$outwardPackageType = F2(
	function (from, to) {
		return $elm$core$String$toLower(
			$author$project$Types$Port$toString(from) + ('-' + $author$project$Types$Port$toString(to)));
	});
var $author$project$Types$ExtraService$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$DataTracking$Util$encodeMaybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $author$project$Utils$Time$toDigiDataString = function (dateTime) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('T'),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		$elm$time$Time$utc,
		dateTime);
};
var $author$project$DataTracking$Util$encodeTime = function (time) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'serviceDateTime',
				$elm$json$Json$Encode$string(
					$author$project$Utils$Time$toDigiDataString(time)))
			]));
};
var $elm$core$String$trim = _String_trim;
var $author$project$DataTracking$Util$normalizeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$trim,
	A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('\\s+')),
			function (_v0) {
				return '-';
			}),
		$elm$core$String$toLower));
var $author$project$DataTracking$Model$addonList = F4(
	function (direction, departure, extraServices, summary) {
		var selected = function () {
			if (!direction) {
				return summary.qk.rP;
			} else {
				return summary.qk.st;
			}
		}();
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var code = _v0.pQ;
				var count = _v0.pZ;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'service',
							$elm$json$Json$Encode$string('addon')),
							_Utils_Tuple2(
							'serviceCategory',
							$elm$json$Json$Encode$string(
								$author$project$DataTracking$Util$normalizeString(
									$author$project$Types$ExtraService$codeToString(code)))),
							_Utils_Tuple2(
							'quantity',
							$elm$json$Json$Encode$int(count)),
							_Utils_Tuple2(
							'price',
							A2(
								$author$project$DataTracking$Util$encodeMaybe,
								$elm$json$Json$Encode$float,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.Dx;
									},
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.pQ;
											},
											$elm$core$Basics$eq(code)),
										extraServices)))),
							_Utils_Tuple2(
							'meta',
							$author$project$DataTracking$Util$encodeTime(departure))
						]));
			},
			selected);
	});
var $author$project$Types$Meals$toList = function (_v0) {
	var breakfasts = _v0.vv;
	var brunches = _v0.vy;
	var buffets = _v0.vA;
	var tableReservations = _v0.G5;
	return _Utils_ap(
		breakfasts,
		_Utils_ap(
			brunches,
			_Utils_ap(buffets, tableReservations)));
};
var $author$project$Types$Meals$allOutwardSittings = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$Meals$toList,
	$elm$core$List$concatMap(
		function ($) {
			return $.kC;
		}));
var $author$project$Types$MealType$Breakfast = 0;
var $author$project$Types$MealType$Brunch = 1;
var $author$project$Types$MealType$Dinner = 3;
var $author$project$Types$MealType$Lunch = 2;
var $author$project$Types$MealType$fromPosix = function (time) {
	var hours = A2($elm$time$Time$toHour, $elm$time$Time$utc, time);
	return ((hours > 0) && (hours < 10)) ? 0 : (((hours >= 10) && (hours < 12)) ? 1 : (((hours >= 12) && (hours < 15)) ? 2 : 3));
};
var $author$project$Types$MealType$toString = function (mealType) {
	switch (mealType) {
		case 0:
			return 'BREAKFAST';
		case 1:
			return 'BRUNCH';
		case 2:
			return 'LUNCH';
		default:
			return 'DINNER';
	}
};
var $author$project$DataTracking$Model$encodeSitting = F2(
	function (session, _v0) {
		var beginDateTime = _v0.ut;
		var price = _v0.lN;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'service',
					$elm$json$Json$Encode$string('dining')),
					_Utils_Tuple2(
					'serviceCategory',
					$elm$json$Json$Encode$string(
						$author$project$DataTracking$Util$normalizeString(
							$author$project$Types$MealType$toString(
								$author$project$Types$MealType$fromPosix(beginDateTime))))),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(
						$elm$core$Array$length(session.Eg))),
					_Utils_Tuple2(
					'price',
					$elm$json$Json$Encode$float(price)),
					_Utils_Tuple2(
					'meta',
					$author$project$DataTracking$Util$encodeTime(beginDateTime))
				]));
	});
var $author$project$Types$Meals$isSameSitting = F2(
	function (a, b) {
		return _Utils_eq(a.ut, b.ut) && _Utils_eq(a.FJ, b.FJ);
	});
var $author$project$Types$SelectedMeals$toList = function (_v0) {
	var breakfast = _v0.vu;
	var brunch = _v0.vx;
	var lunch = _v0.Bz;
	var dinner = _v0.yw;
	return $elm$core$List$concat(
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not),
			_List_fromArray(
				[breakfast, brunch, lunch, dinner])));
};
var $author$project$DataTracking$Model$encodeOutwardMealSubServices = function (session) {
	var selectedMeals = $author$project$Types$SelectedMeals$toList(session.Gn);
	var mealsList = A2(
		$elm$core$List$filter,
		function (a) {
			return !_Utils_eq(
				A2(
					$elm_community$list_extra$List$Extra$find,
					$author$project$Types$Meals$isSameSitting(a),
					selectedMeals),
				$elm$core$Maybe$Nothing);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Types$Meals$allOutwardSittings, session.ri)));
	return A2(
		$elm$core$List$map,
		$author$project$DataTracking$Model$encodeSitting(session),
		mealsList);
};
var $author$project$Types$CabinSurprise$defaultSurprises = {DC: $elm$core$Dict$empty, FV: $elm$core$Dict$empty};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = A2(
						$elm$core$List$partition,
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					return A2(
						helper,
						remaining,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered));
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEquals = function (list) {
	return A2($elm_community$list_extra$List$Extra$gatherWith, $elm$core$Basics$eq, list);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$DataTracking$Model$encodeOutwardSurpriseSubServices = F2(
	function (session, departureTime) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var code = _v0.a;
				var l = _v0.b;
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var price = _v1.lN;
						var name = _v1.oh;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'service',
									$elm$json$Json$Encode$string('cabin-surprise')),
									_Utils_Tuple2(
									'serviceCategory',
									$elm$json$Json$Encode$string(
										$author$project$DataTracking$Util$normalizeString(name))),
									_Utils_Tuple2(
									'quantity',
									$elm$json$Json$Encode$int(
										$elm$core$List$length(l) + 1)),
									_Utils_Tuple2(
									'price',
									$elm$json$Json$Encode$float(price)),
									_Utils_Tuple2(
									'meta',
									$author$project$DataTracking$Util$encodeTime(departureTime))
								]));
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(code)),
						$elm$core$List$concat(
							$elm$core$Dict$values(
								A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Types$CabinSurprise$defaultSurprises, session.pD).DC))));
			},
			$elm_community$list_extra$List$Extra$gatherEquals(
				$elm$core$List$concat(
					$elm$core$Dict$values(session.Gh.DC))));
	});
var $author$project$DataTracking$Model$encodeBusTransfer = function (_v0) {
	var ageGroupCounts = _v0.po;
	var price = _v0.lN;
	var departureDateTime = _v0.nq;
	return A3(
		$author$project$Utils$List$addIf,
		ageGroupCounts.zV > 0,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'service',
					$elm$json$Json$Encode$string('transfer')),
					_Utils_Tuple2('serviceCategory', $elm$json$Json$Encode$null),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(ageGroupCounts.zV)),
					_Utils_Tuple2(
					'price',
					$elm$json$Json$Encode$float(0)),
					_Utils_Tuple2(
					'meta',
					$author$project$DataTracking$Util$encodeTime(departureDateTime))
				])),
		A3(
			$author$project$Utils$List$addIf,
			ageGroupCounts.H4 > 0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'service',
						$elm$json$Json$Encode$string('transfer')),
						_Utils_Tuple2('serviceCategory', $elm$json$Json$Encode$null),
						_Utils_Tuple2(
						'quantity',
						$elm$json$Json$Encode$int(ageGroupCounts.H4)),
						_Utils_Tuple2(
						'price',
						$elm$json$Json$Encode$float(price / 2)),
						_Utils_Tuple2(
						'meta',
						$author$project$DataTracking$Util$encodeTime(departureDateTime))
					])),
			_List_fromArray(
				[
					$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'service',
							$elm$json$Json$Encode$string('transfer')),
							_Utils_Tuple2('serviceCategory', $elm$json$Json$Encode$null),
							_Utils_Tuple2(
							'quantity',
							$elm$json$Json$Encode$int(ageGroupCounts.pn)),
							_Utils_Tuple2(
							'price',
							$elm$json$Json$Encode$float(price)),
							_Utils_Tuple2(
							'meta',
							$author$project$DataTracking$Util$encodeTime(departureDateTime))
						]))
				])));
};
var $author$project$Types$Bus$SelectedTransferPair$selectedOutward = function (_v0) {
	var _v1 = _v0;
	var maybeOutward = _v1.a;
	return maybeOutward;
};
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.z)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.z, tail);
		return (notAppended < 0) ? {
			B: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.B),
			x: builder.x + 1,
			z: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			B: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.B),
			x: builder.x + 1,
			z: $elm$core$Elm$JsArray$empty
		} : {B: builder.B, x: builder.x, z: appended});
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		B: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		x: (len / $elm$core$Array$branchFactor) | 0,
		z: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $author$project$Types$Bus$SelectedTransfers$toArray = function (_v0) {
	var first = _v0.nx;
	var others = _v0.lH;
	return A2(
		$elm$core$Array$append,
		A2(
			$elm$core$Array$initialize,
			1,
			function (_v1) {
				return first;
			}),
		others);
};
var $author$project$DataTracking$Model$encodeOutwardTransferSubServices = function (session) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$DataTracking$Model$encodeBusTransfer,
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.po;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pn;
					},
					$elm$core$Basics$neq(0))),
			A2(
				$elm$core$List$filterMap,
				$author$project$Types$Bus$SelectedTransferPair$selectedOutward,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Types$Bus$SelectedTransfers$toArray, $elm$core$Array$toList),
						session.B0)))));
};
var $author$project$Types$Vehicle$carCategoryToString = function (carCategory) {
	switch (carCategory) {
		case 0:
			return 'BICYCLE';
		case 1:
			return 'CAR';
		case 2:
			return 'CAR ALA OVNGT';
		case 3:
			return 'CAR XL';
		case 4:
			return 'MOTORCYCLE';
		case 5:
			return 'MOTORCYCLE WITH SIDECAR';
		case 6:
			return 'PARKED CAR';
		case 7:
			return 'PARKED CAR 2';
		case 10:
			return 'PARKED VAN';
		case 8:
			return 'SHOPPER CAR';
		case 9:
			return 'SHOPPER VAN';
		case 11:
			return 'VAN';
		case 12:
			return 'VAN HIGH';
		case 13:
			return 'VEHICLE LONG & HIGH';
		case 14:
			return 'VEHICLE EXTRA LONG & HIGH';
		case 15:
			return 'VEHICLE LONG & LOW';
		default:
			return 'VEHICLE LONG & MEDIUM';
	}
};
var $author$project$DataTracking$Model$encodeCardeckSubService = F4(
	function (departure, price, code, quantity) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'service',
					$elm$json$Json$Encode$string('cardeck')),
					_Utils_Tuple2(
					'serviceCategory',
					$elm$json$Json$Encode$string(
						$author$project$DataTracking$Util$normalizeString(
							$author$project$Types$Vehicle$carCategoryToString(code)))),
					_Utils_Tuple2(
					'quantity',
					$elm$json$Json$Encode$int(quantity)),
					_Utils_Tuple2(
					'price',
					$elm$json$Json$Encode$float(price)),
					_Utils_Tuple2(
					'meta',
					$author$project$DataTracking$Util$encodeTime(departure))
				]));
	});
var $author$project$DataTracking$Model$directionDetails = function (direction) {
	return (!direction) ? A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Du;
		},
		$elm$core$Maybe$Just) : function ($) {
		return $.FN;
	};
};
var $author$project$DataTracking$Model$isAcceptableVoyageType = F2(
	function (direction, _v0) {
		var voyageType = _v0.tx;
		return (!direction) ? (_Utils_eq(
			voyageType,
			$elm$core$Maybe$Just(0)) || _Utils_eq(
			voyageType,
			$elm$core$Maybe$Just(1))) : (_Utils_eq(
			voyageType,
			$elm$core$Maybe$Just(0)) || _Utils_eq(
			voyageType,
			$elm$core$Maybe$Just(2)));
	});
var $author$project$DataTracking$Model$groupVehiclesByCategories = F2(
	function (availableVehicles, direction) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Types$SelectedVehicles$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filter(
					$author$project$DataTracking$Model$isAcceptableVoyageType(direction)),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function (_v0) {
							var carCategory = _v0.jZ;
							return _Utils_Tuple2(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.lN;
										},
										A2(
											$elm$core$Maybe$andThen,
											$author$project$DataTracking$Model$directionDetails(direction),
											A2(
												$elm_community$list_extra$List$Extra$find,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.jZ;
													},
													$elm$core$Basics$eq(carCategory)),
												availableVehicles)))),
								carCategory);
						}),
					$elm_community$list_extra$List$Extra$gatherWith($elm$core$Basics$eq))));
	});
var $author$project$DataTracking$Model$getEncodedVehicleSubserviceList = F4(
	function (direction, departure, maybeSelectedVehicles, availableVehicles) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var _v1 = _v0.a;
				var price = _v1.a;
				var code = _v1.b;
				var group = _v0.b;
				return A4(
					$author$project$DataTracking$Model$encodeCardeckSubService,
					departure,
					price,
					code,
					$elm$core$List$length(group) + 1);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$DataTracking$Model$groupVehiclesByCategories, availableVehicles, direction),
					maybeSelectedVehicles)));
	});
var $author$project$DataTracking$Model$outwardSubServices = F2(
	function (session, departure) {
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_Utils_ap(
				$author$project$DataTracking$Model$encodeOutwardTransferSubServices(session),
				_Utils_ap(
					A4($author$project$DataTracking$Model$getEncodedVehicleSubserviceList, 0, departure, session.rp, session.tt),
					_Utils_ap(
						$author$project$DataTracking$Model$encodeOutwardMealSubServices(session),
						_Utils_ap(
							A2($author$project$DataTracking$Model$encodeOutwardSurpriseSubServices, session, departure),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A3($author$project$DataTracking$Model$addonList, 0, departure, session.qk),
									session.B7)))))));
	});
var $author$project$Common$Passengers$countByAgeCategory = F2(
	function (previous, current) {
		var addUp = function (property) {
			return property(previous) + property(current);
		};
		return {
			tV: addUp(
				function ($) {
					return $.tV;
				}),
			vU: addUp(
				function ($) {
					return $.vU;
				}),
			AI: addUp(
				function ($) {
					return $.AI;
				}),
			IF: addUp(
				function ($) {
					return $.IF;
				})
		};
	});
var $author$project$Types$PassengerCount$init = {tV: 0, vU: 0, AI: 0, IF: 0};
var $author$project$Common$Passengers$passengerToCount = function (ageCategory) {
	var model = $author$project$Types$PassengerCount$init;
	switch (ageCategory) {
		case 0:
			return _Utils_update(
				model,
				{tV: 1});
		case 3:
			return _Utils_update(
				model,
				{AI: 1});
		case 1:
			return _Utils_update(
				model,
				{IF: 1});
		default:
			return _Utils_update(
				model,
				{vU: 1});
	}
};
var $author$project$Common$Passengers$passengerCount = function (ageCategories) {
	return A3(
		$elm$core$List$foldl,
		$author$project$Common$Passengers$countByAgeCategory,
		$author$project$Types$PassengerCount$init,
		A2($elm$core$List$map, $author$project$Common$Passengers$passengerToCount, ageCategories));
};
var $author$project$DataTracking$Model$returnPackageType = F2(
	function (from, to) {
		return $elm$core$String$toLower(
			$author$project$Types$Port$toString(to) + ('-' + $author$project$Types$Port$toString(from)));
	});
var $author$project$Types$Meals$allReturnSittings = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$Meals$toList,
	$elm$core$List$concatMap(
		function ($) {
			return $.k4;
		}));
var $author$project$DataTracking$Model$encodeReturnMealSubServices = function (session) {
	var selectedMeals = $author$project$Types$SelectedMeals$toList(session.Go);
	var mealsList = A2(
		$elm$core$List$filter,
		function (a) {
			return !_Utils_eq(
				A2(
					$elm_community$list_extra$List$Extra$find,
					$author$project$Types$Meals$isSameSitting(a),
					selectedMeals),
				$elm$core$Maybe$Nothing);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Types$Meals$allReturnSittings, session.ri)));
	return A2(
		$elm$core$List$map,
		$author$project$DataTracking$Model$encodeSitting(session),
		mealsList);
};
var $author$project$Types$Bus$SelectedTransferPair$selectedReturn = function (_v0) {
	var _v1 = _v0;
	var maybeReturn = _v1.b;
	return maybeReturn;
};
var $author$project$DataTracking$Model$encodeReturnTransferSubServices = function (session) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$DataTracking$Model$encodeBusTransfer,
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.po;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pn;
					},
					$elm$core$Basics$neq(0))),
			A2(
				$elm$core$List$filterMap,
				$author$project$Types$Bus$SelectedTransferPair$selectedReturn,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Types$Bus$SelectedTransfers$toArray, $elm$core$Array$toList),
						session.B0)))));
};
var $author$project$DataTracking$Model$returnSubServices = F2(
	function (session, departure) {
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_Utils_ap(
				$author$project$DataTracking$Model$encodeReturnTransferSubServices(session),
				_Utils_ap(
					A4($author$project$DataTracking$Model$getEncodedVehicleSubserviceList, 1, departure, session.rp, session.tt),
					_Utils_ap(
						$author$project$DataTracking$Model$encodeReturnMealSubServices(session),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A3($author$project$DataTracking$Model$addonList, 1, departure, session.qk),
								session.B7))))));
	});
var $author$project$Types$ShipCode$toString = function (shipCode) {
	switch (shipCode.$) {
		case 0:
			return 'EUROPA';
		case 1:
			return 'GALAXY';
		case 2:
			return 'ISABELLE';
		case 3:
			return 'MEGASTAR';
		case 4:
			return 'PRINCESS';
		case 5:
			return 'QUEEN';
		case 6:
			return 'ROMANTIKA';
		case 7:
			return 'SEAWIND';
		case 8:
			return 'SERENADE';
		case 9:
			return 'STAR';
		case 10:
			return 'SUPER';
		case 11:
			return 'SYMPHONY';
		case 12:
			return 'VICTORIA';
		case 13:
			return 'SAILOR';
		case 14:
			return 'REGAL STAR';
		case 15:
			return 'MYSTAR';
		case 16:
			return 'SFIX';
		default:
			var string = shipCode.a;
			return string;
	}
};
var $author$project$DataTracking$Model$shipCodeAndDeparture = function (session) {
	var _v0 = $author$project$Types$Trips$statusToMaybe(session.tp);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var cruise = _v0.a.a;
				var sail = $author$project$Types$CruiseSails$selected(cruise).b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							sail.rS.nr,
							$author$project$Types$ShipCode$toString(sail.Dz))),
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							sail.sw.nr,
							$author$project$Types$ShipCode$toString(sail.FS))));
			case 1:
				var route = _v0.a.a;
				var _v1 = $author$project$Types$RouteTripSails$selected(route);
				var outward = _v1.a;
				var maybeReturn = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							outward.nr,
							$author$project$Types$ShipCode$toString(outward.oX))),
					session.qW ? $elm$core$Maybe$Nothing : A2(
						$elm$core$Maybe$map,
						function (a) {
							return _Utils_Tuple2(
								a.nr,
								$author$project$Types$ShipCode$toString(a.oX));
						},
						maybeReturn));
			default:
				var cruiseMultiDeparture = _v0.a.a;
				var trip = $author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture);
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							trip.rS.p3,
							$author$project$Types$ShipCode$toString(trip.oX))),
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							trip.sw.p3,
							$author$project$Types$ShipCode$toString(trip.oX))));
		}
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	}
};
var $author$project$DataTracking$Model$services = function (session) {
	var voyageType = session.tx;
	var isOneWay = session.qW;
	var passengers = session.Eg;
	var from = session.kS;
	var to = session.le;
	var passengerCount = $author$project$Common$Passengers$passengerCount(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.tY;
			},
			$elm$core$Array$toList(passengers)));
	return function (_v0) {
		var outward = _v0.a;
		var _return = _v0.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var time = _v1.a;
							var ship = _v1.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'packageDirection',
										$elm$json$Json$Encode$string('forward')),
										_Utils_Tuple2(
										'packageType',
										$elm$json$Json$Encode$string(
											A2($author$project$DataTracking$Model$outwardPackageType, from, to))),
										_Utils_Tuple2(
										'shipCode',
										$elm$json$Json$Encode$string(
											$elm$core$String$toLower(ship))),
										_Utils_Tuple2(
										'travelClass',
										$author$project$DataTracking$Model$encodeOutwardTravelClassServices(session)),
										_Utils_Tuple2(
										'meta',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'departureDate',
													$elm$json$Json$Encode$string(
														$author$project$Utils$Time$toDigiDataString(time))),
													_Utils_Tuple2(
													'customers',
													$author$project$Types$PassengerCount$encodeCustomers(passengerCount))
												]))),
										_Utils_Tuple2(
										'subservices',
										A2($author$project$DataTracking$Model$outwardSubServices, session, time))
									]));
						},
						outward),
						A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var time = _v2.a;
							var ship = _v2.b;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'packageDirection',
										$elm$json$Json$Encode$string('return')),
										_Utils_Tuple2(
										'packageType',
										$elm$json$Json$Encode$string(
											A2($author$project$DataTracking$Model$returnPackageType, from, to))),
										_Utils_Tuple2(
										'shipCode',
										$elm$json$Json$Encode$string(
											$elm$core$String$toLower(ship))),
										_Utils_Tuple2(
										'travelClass',
										$author$project$DataTracking$Model$encodeReturnTravelClassServices(session)),
										_Utils_Tuple2(
										'meta',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'departureDate',
													$elm$json$Json$Encode$string(
														$author$project$Utils$Time$toDigiDataString(time))),
													_Utils_Tuple2(
													'customers',
													$author$project$Types$PassengerCount$encodeCustomers(passengerCount))
												]))),
										_Utils_Tuple2(
										'subservices',
										A2($author$project$DataTracking$Model$returnSubServices, session, time))
									]));
						},
						_return)
					])));
	}(
		$author$project$DataTracking$Model$shipCodeAndDeparture(session));
};
var $author$project$Utils$Time$isSameDay = F2(
	function (a, b) {
		return _Utils_eq(
			A2($elm$time$Time$toYear, $elm$time$Time$utc, a),
			A2($elm$time$Time$toYear, $elm$time$Time$utc, b)) && (_Utils_eq(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, a),
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, b)) && _Utils_eq(
			A2($elm$time$Time$toDay, $elm$time$Time$utc, a),
			A2($elm$time$Time$toDay, $elm$time$Time$utc, b)));
	});
var $author$project$DataTracking$Model$bookingIsDayTrip = F3(
	function (arrivalIsoDate, departureIsoDate, isOneWay) {
		var _v0 = _Utils_Tuple2(arrivalIsoDate, departureIsoDate);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var arrival = _v0.a.a;
			var departure = _v0.b.a;
			return (!isOneWay) && A2($author$project$Utils$Time$isSameDay, arrival, departure);
		} else {
			return false;
		}
	});
var $author$project$DataTracking$Model$isCruiseLikeVoyageType = function (voyageType) {
	return _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) || (_Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultiship) || _Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultistop));
};
var $author$project$DataTracking$Model$travelSegment = function (session) {
	var bookingType = session.vk;
	var voyageType = session.tx;
	var isOneWay = session.qW;
	var bookingSegment = F2(
		function (arrivalIsoDate, departureIsoDate) {
			return (bookingType === 1) ? 'hotel-package' : ($author$project$DataTracking$Model$isCruiseLikeVoyageType(voyageType) ? 'cruise' : (isOneWay ? 'one-way' : (A3($author$project$DataTracking$Model$bookingIsDayTrip, arrivalIsoDate, departureIsoDate, isOneWay) ? 'day-ticket' : 'return')));
		});
	var _v0 = $author$project$Types$Trips$statusToMaybe(session.tp);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var route = _v0.a.a;
		return function (_v1) {
			var arrivalIsoDate = _v1.a.ps;
			var maybeReturn = _v1.b;
			return A2(
				bookingSegment,
				$elm$core$Maybe$Just(arrivalIsoDate),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.nr;
					},
					maybeReturn));
		}(
			$author$project$Types$RouteTripSails$selected(route));
	} else {
		return A2(bookingSegment, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	}
};
var $author$project$DataTracking$Model$encodeBooking = function (session) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'routeCode',
				A3(
					$elm$core$Basics$composeR,
					$elm$core$String$join('-'),
					A2($elm$core$Basics$composeR, $elm$core$String$toLower, $elm$json$Json$Encode$string),
					A2(
						$elm$core$List$map,
						$author$project$Types$Port$toString,
						_List_fromArray(
							[session.kS, session.le])))),
				_Utils_Tuple2(
				'travelSegment',
				$elm$json$Json$Encode$string(
					$author$project$DataTracking$Model$travelSegment(session))),
				_Utils_Tuple2(
				'hasCar',
				$elm$json$Json$Encode$bool(
					!_Utils_eq(session.rp, $elm$core$Maybe$Nothing))),
				_Utils_Tuple2(
				'hasHotel',
				$elm$json$Json$Encode$bool(false)),
				_Utils_Tuple2(
				'totalMoney',
				$elm$json$Json$Encode$float(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lN;
							},
							session.B7)))),
				_Utils_Tuple2(
				'totalPoints',
				$elm$json$Json$Encode$int(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.oA;
							},
							session.B7)))),
				_Utils_Tuple2(
				'services',
				$author$project$DataTracking$Model$services(session))
			]));
};
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$DataTracking$Model$encodeAuthSource = F2(
	function (model, passenger) {
		var isPassengerWithClientId = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.v5;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				passenger));
		var isAutoLogin = $krisajenkins$remotedata$RemoteData$isSuccess(model.j.Ia.v4) && (!model.j.zn);
		var hasClubOneNumberInUrl = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$contains('clubOneAccountNumber'),
				model.n1.Fo));
		return isPassengerWithClientId ? $elm$json$Json$Encode$null : (hasClubOneNumberInUrl ? $elm$json$Json$Encode$string('e-mail') : (isAutoLogin ? $elm$json$Json$Encode$string('session') : $elm$json$Json$Encode$string('mobile')));
	});
var $author$project$DataTracking$Model$encodeIsGroupReservation = function (model) {
	return $elm$json$Json$Encode$bool(
		A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Ab;
				},
				model.j.Fz)));
};
var $author$project$DataTracking$Model$encodeUserStatus = F2(
	function (model, passenger) {
		var isPassengerWithClientId = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.v5;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				passenger));
		return $krisajenkins$remotedata$RemoteData$isSuccess(model.j.Ia.v4) ? $elm$json$Json$Encode$string('logged-in') : (isPassengerWithClientId ? $elm$json$Json$Encode$string('logged-out') : $elm$json$Json$Encode$string('anonymous'));
	});
var $author$project$DataTracking$Model$encodeUser = function (model) {
	var passenger = $author$project$Types$Passenger$findWithHighestLevel(model.j.Eg);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.v5;
							},
							$elm$core$Maybe$map($elm$json$Json$Encode$int)),
						passenger))),
				_Utils_Tuple2(
				'number',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.we;
							},
							$elm$core$Maybe$map($elm$json$Json$Encode$string)),
						passenger))),
				_Utils_Tuple2(
				'points',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.wf;
							},
							$elm$core$Maybe$map($elm$json$Json$Encode$int)),
						passenger))),
				_Utils_Tuple2(
				'level',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'regular',
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pO;
								},
								$elm$core$Maybe$map($author$project$Types$ClubOneLevel$toString)),
							passenger)))),
				_Utils_Tuple2(
				'status',
				A2($author$project$DataTracking$Model$encodeUserStatus, model, passenger)),
				_Utils_Tuple2(
				'authSource',
				A2($author$project$DataTracking$Model$encodeAuthSource, model, passenger)),
				_Utils_Tuple2(
				'business',
				$author$project$DataTracking$Model$encodeIsGroupReservation(model)),
				_Utils_Tuple2(
				'policy',
				$elm$json$Json$Encode$bool(true)),
				_Utils_Tuple2(
				'profiling',
				$elm$json$Json$Encode$bool(false)),
				_Utils_Tuple2(
				'coJoin',
				$elm$json$Json$Encode$bool(
					_Utils_eq(model.j.AE, $author$project$Types$JoinClubOneState$Joining)))
			]));
};
var $author$project$Types$Market$encodeCountry = function (market) {
	return $elm$json$Json$Encode$string(
		$elm$core$String$toLower(
			$author$project$Types$Market$toString(market)));
};
var $author$project$Types$Language$encodeLanguage = function (locale) {
	return $elm$json$Json$Encode$string(
		$elm$core$String$toLower(
			$author$project$Types$Language$toString(locale)));
};
var $author$project$Utils$UserAgent$isMobileBrowser = function (userAgent) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{vO: true, CE: false},
				'mobile')),
		userAgent);
};
var $author$project$Utils$UserAgent$isAndroidTablet = function (userAgent) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{vO: true, CE: false},
				'Android')),
		userAgent) && (!$author$project$Utils$UserAgent$isMobileBrowser(userAgent));
};
var $author$project$Utils$UserAgent$isAppleTablet = function (userAgent) {
	return A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{vO: true, CE: false},
				'iPad|Tablet')),
		userAgent);
};
var $author$project$Utils$UserAgent$isTablet = function (userAgent) {
	return $author$project$Utils$UserAgent$isAppleTablet(userAgent) || $author$project$Utils$UserAgent$isAndroidTablet(userAgent);
};
var $author$project$DataTracking$Util$title = function (url) {
	return function (_v0) {
		var b = _v0.b;
		return $elm$json$Json$Encode$string(b);
	}(
		$author$project$DataTracking$Util$titleAndCategory(url));
};
var $author$project$Types$Currency$EUR = 0;
var $author$project$Types$Currency$SEK = 1;
var $author$project$Types$Market$toCurrency = function (market) {
	return A2(
		$elm$core$List$member,
		market,
		_List_fromArray(
			[4, 3, 7])) ? 1 : 0;
};
var $author$project$Types$Currency$toIsoCodeString = function (currency) {
	if (!currency) {
		return 'eur';
	} else {
		return 'sek';
	}
};
var $author$project$DataTracking$Util$encodeWebsite = F5(
	function (isNative, userAgent, breadcrumbs, language, market) {
		var websiteType = isNative ? 'app' : ($author$project$Utils$UserAgent$isTablet(userAgent) ? 'tablet' : ($author$project$Utils$UserAgent$isMobileBrowser(userAgent) ? 'mobile' : 'desktop'));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'locale',
					$author$project$Types$Language$encodeLanguage(language)),
					_Utils_Tuple2(
					'country',
					$author$project$Types$Market$encodeCountry(market)),
					_Utils_Tuple2(
					'currency',
					$elm$json$Json$Encode$string(
						$author$project$Types$Currency$toIsoCodeString(
							$author$project$Types$Market$toCurrency(market)))),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(websiteType)),
					_Utils_Tuple2(
					'breadcrumbs',
					A2(
						$elm$json$Json$Encode$list,
						function (url) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$author$project$DataTracking$Util$title(url.Eh)),
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string(
											$elm$url$Url$toString(url)))
									]));
						},
						breadcrumbs)),
					_Utils_Tuple2(
					'errors',
					A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil))
				]));
	});
var $author$project$DataTracking$Model$encode = F4(
	function (session, _v0, location, isNative) {
		var userAgent = _v0.pd;
		var breadcrumbs = _v0.nf;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'website',
					A5($author$project$DataTracking$Util$encodeWebsite, isNative, userAgent, breadcrumbs, session.A_, session.rb)),
					_Utils_Tuple2(
					'page',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('section', $elm$json$Json$Encode$null),
								_Utils_Tuple2('version', $elm$json$Json$Encode$null),
								_Utils_Tuple2('sectionActive', $elm$json$Json$Encode$null),
								_Utils_Tuple2(
								'category',
								$author$project$DataTracking$Util$category(location.Eh))
							]))),
					_Utils_Tuple2(
					'user',
					$author$project$DataTracking$Model$encodeUser(
						{n1: location, j: session})),
					_Utils_Tuple2(
					'booking',
					$author$project$DataTracking$Model$encodeBooking(session)),
					_Utils_Tuple2('transaction', $elm$json$Json$Encode$null)
				]));
	});
var $author$project$Tracking$logDigiData = function (model) {
	return $author$project$Common$Ports$digiData(
		A4($author$project$DataTracking$Model$encode, model.j, model.l1, model.n1, model.qV));
};
var $author$project$Types$CruiseMultiDepartureTrips$selectedDepartureAndArrivalTimes = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$CruiseMultiDepartureTrips$selected,
	function (a) {
		return _Utils_Tuple2(a.rS.p3, a.sw.lm);
	});
var $author$project$Types$RouteTripSails$selectedDepartureAndArrivalTimes = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return _Utils_Tuple2(
		outward.Gg.nr,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Gg;
				},
				function ($) {
					return $.ps;
				}),
			_return));
};
var $author$project$Types$Trips$selectedDepartureAndArrivalTimes = function (trips) {
	switch (trips.$) {
		case 0:
			var cruise = trips.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Maybe$Just,
				$author$project$Types$CruiseSails$selectedDepartureAndArrivalTimes(cruise));
		case 1:
			var route = trips.a;
			return $author$project$Types$RouteTripSails$selectedDepartureAndArrivalTimes(route);
		default:
			var cruiseMultiDeparture = trips.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Maybe$Just,
				$author$project$Types$CruiseMultiDepartureTrips$selectedDepartureAndArrivalTimes(cruiseMultiDeparture));
	}
};
var $author$project$Main$getDepartureTime = function (_v0) {
	var session = _v0.j;
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
		$author$project$Types$Trips$statusToMaybe(session.tp));
};
var $author$project$Types$AgeCategory$Adult = 0;
var $author$project$Common$Toast$Notification = 0;
var $author$project$Messages$ToastMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Common$Toast$performImmediately = function (msg) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return msg;
		},
		$elm$core$Task$succeed(0));
};
var $author$project$Common$Toast$Show = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Common$Toast$showToastMsg = F5(
	function (toastType, translate, isPermanent, containsHtml, params) {
		return A2(
			$author$project$Common$Toast$Show,
			{nj: containsHtml, DH: params, o8: toastType, pa: translate},
			isPermanent);
	});
var $author$project$Common$Toast$showToastCmd = F3(
	function (toastType, translate, isPermanent) {
		return $author$project$Common$Toast$performImmediately(
			A5($author$project$Common$Toast$showToastMsg, toastType, translate, isPermanent, false, _List_Nil));
	});
var $author$project$Update$Passengers$addedAdultToBookingToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Messages$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		0,
		function ($) {
			return $.g$;
		},
		false));
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{B: nodeList, x: nodeListSize, z: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$filter = F2(
	function (isGood, array) {
		return $elm$core$Array$fromList(
			A3(
				$elm$core$Array$foldr,
				F2(
					function (x, xs) {
						return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
					}),
				_List_Nil,
				array));
	});
var $author$project$Types$Passenger$Util$countPassengersOfAgeCategory = F2(
	function (passengers, ageCategoryToCount) {
		return $elm$core$Array$length(
			A2(
				$elm$core$Array$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$Basics$eq(ageCategoryToCount)),
				passengers));
	});
var $author$project$Types$Passenger$Util$countAdultPassengers = function (passengers) {
	return A2($author$project$Types$Passenger$Util$countPassengersOfAgeCategory, passengers, 0);
};
var $justinmimbs$time_extra$Time$Extra$Year = 0;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Utils$Time$differenceOfDatesInYears = F2(
	function (a, b) {
		return $elm$core$Basics$abs(
			A4($justinmimbs$time_extra$Time$Extra$diff, 0, $elm$time$Time$utc, a, b));
	});
var $author$project$Types$AgeCategory$Child = 2;
var $author$project$Types$AgeCategory$Junior = 3;
var $author$project$Types$AgeCategory$Youth = 1;
var $author$project$Types$AgeCategory$fromAge = function (age) {
	return (age >= 18) ? 0 : (((age >= 12) && (age <= 17)) ? 1 : (((age >= 6) && (age <= 11)) ? 3 : 2));
};
var $author$project$Types$Passenger$init = function (ageCategory) {
	return {tY: ageCategory, uw: $elm$core$Maybe$Nothing, v_: $elm$core$Maybe$Nothing, v5: $elm$core$Maybe$Nothing, pO: $elm$core$Maybe$Nothing, we: $elm$core$Maybe$Nothing, wf: $elm$core$Maybe$Nothing, yI: $elm$core$Maybe$Nothing, y2: '', zf: $elm$core$Maybe$Nothing, A6: '', ox: $elm$core$Maybe$Nothing, jX: $elm$core$Maybe$Nothing};
};
var $author$project$Types$VoyageType$Regular = 0;
var $author$project$Update$Passengers$isSoloYouthAllowed = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var bookingType = _v0.vk;
	var voyageType = _v0.tx;
	return (!bookingType) && (A2($author$project$Utils$Route$isTalHelRoute, from, to) && A2(
		$elm$core$List$member,
		voyageType,
		_List_fromArray(
			[
				$author$project$Types$VoyageType$Shuttle,
				$author$project$Types$VoyageType$RouteTrip,
				$author$project$Types$VoyageType$CruiseMultiDeparture(1)
			])));
};
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $author$project$Update$Passengers$remapAgeCategories = F2(
	function (departureTime, session) {
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$Array$map(
				function (passenger) {
					return function (a) {
						return _Utils_update(
							passenger,
							{tY: a});
					}(
						A2(
							$elm$core$Maybe$withDefault,
							passenger.tY,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Types$Date$toPosix,
									A2(
										$elm$core$Basics$composeR,
										function (a) {
											return A2($author$project$Utils$Time$differenceOfDatesInYears, a, departureTime);
										},
										$author$project$Types$AgeCategory$fromAge)),
								passenger.uw)));
				}),
			function (a) {
				return ((!$author$project$Types$Passenger$Util$countAdultPassengers(a)) && (!$author$project$Update$Passengers$isSoloYouthAllowed(session))) ? _Utils_Tuple2(
					A2(
						$elm$core$Array$push,
						$author$project$Types$Passenger$init(0),
						a),
					$elm$core$Maybe$Just($author$project$Update$Passengers$addedAdultToBookingToast)) : _Utils_Tuple2(a, $elm$core$Maybe$Nothing);
			},
			session.Eg);
	});
var $author$project$Main$remapPassengerAgeCategories = F2(
	function (oldModel, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return (!_Utils_eq(
			$author$project$Main$getDepartureTime(oldModel),
			$author$project$Main$getDepartureTime(model))) ? A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, cmd),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function (a) {
						return A2($author$project$Update$Passengers$remapAgeCategories, a, model.j);
					},
					function (_v1) {
						var passengers = _v1.a;
						var maybeCmd = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									j: function (session) {
										return _Utils_update(
											session,
											{Eg: passengers});
									}(model.j)
								}),
							A2(
								$elm$core$Maybe$withDefault,
								cmd,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											$elm$core$Platform$Cmd$batch,
											$elm$core$List$cons(cmd)),
										$elm$core$List$singleton),
									maybeCmd)));
					}),
				$author$project$Main$getDepartureTime(model))) : _Utils_Tuple2(model, cmd);
	});
var $author$project$Messages$AddedPassenger = function (a) {
	return {$: 77, a: a};
};
var $author$project$Messages$ChangedLocation = function (a) {
	return {$: 58, a: a};
};
var $author$project$Messages$ChangedVehicleVoyageType = F2(
	function (a, b) {
		return {$: 84, a: a, b: b};
	});
var $author$project$Messages$ChangedVoyage = function (a) {
	return {$: 125, a: a};
};
var $author$project$Messages$ChangedVoyageType = function (a) {
	return {$: 53, a: a};
};
var $author$project$Messages$ClosedModal = {$: 120};
var $author$project$Messages$ClosedModalAndBack = {$: 121};
var $author$project$Model$CompanyCustomer = function (a) {
	return {$: 13, a: a};
};
var $author$project$Messages$CompanyCustomerMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Messages$DiscountMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Model$DiscountPage = function (a) {
	return {$: 16, a: a};
};
var $author$project$VehiclePage$Model$Enter = 0;
var $author$project$Api$Reservation$FreeTrip = {$: 1};
var $author$project$Messages$GotReservationConfirmation = function (a) {
	return {$: 12, a: a};
};
var $author$project$Model$Hotel = function (a) {
	return {$: 20, a: a};
};
var $author$project$Model$HotelLinks = function (a) {
	return {$: 18, a: a};
};
var $author$project$Messages$HotelLinksMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Model$HotelList = function (a) {
	return {$: 19, a: a};
};
var $author$project$Messages$HotelListMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Messages$HotelMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Api$Reservation$Invoice = {$: 2};
var $author$project$VehiclePage$Model$Leave = 1;
var $author$project$Model$MealPage = function (a) {
	return {$: 10, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Messages$OnboardServiceMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Common$Modal$Model$Opened = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Messages$OpenedSuggestAddingVehicleToOtherLegModal = {$: 61};
var $author$project$Model$PassengerDetailsPage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Messages$PaymentPageMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$Reservation$PaymentService = function (a) {
	return {$: 0, a: a};
};
var $author$project$Messages$ReceivedNewSessionGuid = function (a) {
	return {$: 17, a: a};
};
var $author$project$Messages$RemovedPassenger = F2(
	function (a, b) {
		return {$: 80, a: a, b: b};
	});
var $author$project$Messages$RemovedSelectedVehicle = function (a) {
	return {$: 81, a: a};
};
var $author$project$Messages$RemovedVehicleAnimation = {$: 83};
var $author$project$Messages$SelectedCalendarDay = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Model$Timetable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Messages$TimetableHeaderMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Messages$TimetableMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Common$Toast$Warning = 1;
var $author$project$PassengerPage$Model$Model = F2(
	function (addedElementIndex, animationElement) {
		return {tP: addedElementIndex, ud: animationElement};
	});
var $author$project$Utils$Route$getMaxNumberOfPassengers = function (_v0) {
	var from = _v0.kS;
	return $author$project$Utils$Route$isMugVssRoute(from) ? 5 : 24;
};
var $author$project$Update$Passengers$hasMealsOrMealPackage = function (model) {
	return (!$elm$core$List$isEmpty(
		$author$project$Types$SelectedMeals$toList(model.j.Gn))) || ((!$elm$core$List$isEmpty(
		$author$project$Types$SelectedMeals$toList(model.j.Go))) || (!_Utils_eq(model.j.B2, $elm$core$Maybe$Nothing)));
};
var $author$project$Common$Toast$Information = 2;
var $author$project$Update$Passengers$showMealsWereAddedToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Messages$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		2,
		function ($) {
			return $.hg;
		},
		false));
var $author$project$Update$Passengers$addAffiliatePassenger = F4(
	function (model, _v0, clubOneInfo, ageCategory) {
		var birthday = _v0.uw;
		var clientId = _v0.v5;
		var firstName = _v0.y2;
		var lastName = _v0.A6;
		var level = _v0.A8;
		var number = _v0.k$;
		var _v1 = model;
		var session = _v1.j;
		var _v2 = clubOneInfo;
		var points = _v2.E0;
		if (_Utils_eq(
			$elm$core$Array$length(session.Eg),
			$author$project$Utils$Route$getMaxNumberOfPassengers(session))) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Messages$ToastMsg,
					A3(
						$author$project$Common$Toast$showToastCmd,
						0,
						function ($) {
							return $.hf;
						},
						false)));
		} else {
			var emptyPassenger = $author$project$Types$Passenger$init(ageCategory);
			var passengers = A2(
				$elm$core$Array$push,
				_Utils_update(
					emptyPassenger,
					{
						uw: $elm$core$Maybe$Just(birthday),
						v5: $elm$core$Maybe$Just(clientId),
						pO: level,
						we: A2(
							$elm_community$maybe_extra$Maybe$Extra$orElse,
							$elm$core$Maybe$Just(clubOneInfo.k$),
							number),
						wf: $elm$core$Maybe$Just(points),
						y2: firstName,
						A6: lastName
					}),
				session.Eg);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ea: A2($author$project$PassengerPage$Model$Model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
						j: _Utils_update(
							session,
							{Eg: passengers})
					}),
				$author$project$Update$Passengers$hasMealsOrMealPackage(model) ? $author$project$Update$Passengers$showMealsWereAddedToast : $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$TravelClassPage$Messages$ClearCabinSurpriseAnimationStates = {$: 5};
var $author$project$TravelClassPage$CabinSurpriseList$Closing = 1;
var $author$project$TravelClassPage$CabinSurpriseList$Opening = 0;
var $author$project$Types$TravelClasses$deckCode = 'DECK';
var $author$project$Types$TravelClasses$shuttleDeckCodes = _List_fromArray(
	['DSC', 'DCC', 'DFC', 'DSC_SHUTTLE_LIGHT', 'DPC']);
var $author$project$Types$TravelClasses$isDeckCode = function (code) {
	return _Utils_eq(code, $author$project$Types$TravelClasses$deckCode) || A2($elm$core$List$member, code, $author$project$Types$TravelClasses$shuttleDeckCodes);
};
var $author$project$TravelClassPage$Update$travelClassesWithAnimation = function (_v0) {
	var animation = _v0.m7;
	var possibleTravelClasses = _v0.oD;
	var changedSelectedStatus = _v0.ng;
	var newTravelClassesWithOppositeDirection = _v0.ok;
	var hasSurprisesForSameDirection = _v0.nA;
	var hasSurprisesForOppositeDirection = _v0.kU;
	return A2(
		$elm$core$List$map,
		function (a) {
			return _Utils_Tuple2(a, animation);
		},
		A2(
			$elm$core$List$filter,
			function (a) {
				var isSameTravelClassSelectedOnOppositeDirection = A2($elm$core$List$member, a, newTravelClassesWithOppositeDirection);
				var canHaveCabinSurprises = !$author$project$Types$TravelClasses$isDeckCode(a);
				return canHaveCabinSurprises && (hasSurprisesForSameDirection && (changedSelectedStatus(a) && ((!isSameTravelClassSelectedOnOppositeDirection) || (isSameTravelClassSelectedOnOppositeDirection && (!hasSurprisesForOppositeDirection)))));
			},
			possibleTravelClasses));
};
var $author$project$TravelClassPage$Update$travelClassesWithOpeningAndClosingAnimation = function (_v0) {
	var hasSurprisesForCurrentDirection = _v0.nz;
	var hasSurprisesForOppositeDirection = _v0.kU;
	var mapCurrentTravelClasses = _v0.n3;
	var mapOppositeTravelClasses = _v0.n4;
	var oldAndNewTravelClasses = _v0.om;
	var travelClassesCodes = F2(
		function (travelClasses, mapTravelClasses) {
			return A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				mapTravelClasses(
					$author$project$Types$TravelClasses$getSelectedCodeCountPairLists(travelClasses)));
		});
	var _v1 = oldAndNewTravelClasses;
	var old = _v1.C4;
	var _new = _v1.CG;
	var newTravelClassesWithCurrentDirection = A2(travelClassesCodes, _new, mapCurrentTravelClasses);
	var newTravelClassesWithOppositeDirection = A2(travelClassesCodes, _new, mapOppositeTravelClasses);
	var oldTravelClassesWithCurrentDirection = A2(travelClassesCodes, old, mapCurrentTravelClasses);
	var travelClassesWithClosingAnimation = $author$project$TravelClassPage$Update$travelClassesWithAnimation(
		{
			m7: 1,
			ng: function (a) {
				return !A2($elm$core$List$member, a, newTravelClassesWithCurrentDirection);
			},
			kU: hasSurprisesForOppositeDirection,
			nA: hasSurprisesForCurrentDirection,
			ok: newTravelClassesWithOppositeDirection,
			oD: oldTravelClassesWithCurrentDirection
		});
	var travelClassesWithOpeningAnimation = $author$project$TravelClassPage$Update$travelClassesWithAnimation(
		{
			m7: 0,
			ng: function (a) {
				return !A2($elm$core$List$member, a, oldTravelClassesWithCurrentDirection);
			},
			kU: hasSurprisesForOppositeDirection,
			nA: hasSurprisesForCurrentDirection,
			ok: newTravelClassesWithOppositeDirection,
			oD: newTravelClassesWithCurrentDirection
		});
	return _Utils_ap(travelClassesWithOpeningAnimation, travelClassesWithClosingAnimation);
};
var $author$project$TravelClassPage$Update$addCabinSurpriseAnimations = F3(
	function (oldAndNewTravelClasses, _v0, model) {
		var hasOutwardCabinSurprises = _v0.zo;
		var hasReturnCabinSurprises = _v0.zq;
		var returnTravelClassesWithAnimation = $author$project$TravelClassPage$Update$travelClassesWithOpeningAndClosingAnimation(
			{
				nz: hasReturnCabinSurprises,
				kU: hasOutwardCabinSurprises,
				n3: function ($) {
					return $.zT;
				},
				n4: function ($) {
					return $.Dr;
				},
				om: oldAndNewTravelClasses
			});
		var outwardTravelClassesWithAnimation = $author$project$TravelClassPage$Update$travelClassesWithOpeningAndClosingAnimation(
			{
				nz: hasOutwardCabinSurprises,
				kU: hasReturnCabinSurprises,
				n3: function ($) {
					return $.Dr;
				},
				n4: function ($) {
					return $.zT;
				},
				om: oldAndNewTravelClasses
			});
		return function (a) {
			return _Utils_Tuple2(
				a,
				A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always($author$project$TravelClassPage$Messages$ClearCabinSurpriseAnimationStates),
					$elm$core$Process$sleep(400)));
		}(
			function (a) {
				return _Utils_update(
					model,
					{pB: a});
			}(
				$elm$core$Dict$fromList(
					_Utils_ap(outwardTravelClassesWithAnimation, returnTravelClassesWithAnimation))));
	});
var $author$project$Update$addRequestFactory = F2(
	function (fetchRequest, tracker) {
		return function (model) {
			var session = model.j;
			return A2(
				$elm$core$Tuple$pair,
				model,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						$author$project$Update$Util$cancelRequestAndRunCmd(tracker),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								fetchRequest(session),
								$author$project$Types$Trips$sailIds),
							$author$project$Types$Trips$statusToMaybe(session.tp)))));
		};
	});
var $author$project$Messages$GotCabinSurprises = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Endpoint$cabinSurprises = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['travelClasses', 'services', 'v2']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.pD));
	});
var $author$project$Types$CabinSurprise$CabinSurprise = F6(
	function (code, name, description, thumbnailUrl, price, availability) {
		return {uk: availability, pQ: code, nt: description, oh: name, lN: price, Ht: thumbnailUrl};
	});
var $author$project$Types$CabinSurprise$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'availability',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price',
		$elm$json$Json$Decode$float,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'thumbNailUrl',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Types$CabinSurprise$CabinSurprise)))))));
var $author$project$Api$CabinSurprises$decoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (outwardServices, returnServices) {
			return {DC: outwardServices, FV: returnServices};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'outwardTravelClassServices',
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($author$project$Types$CabinSurprise$decoder))),
	A2(
		$elm$json$Json$Decode$field,
		'returnTravelClassServices',
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($author$project$Types$CabinSurprise$decoder))));
var $author$project$Api$CabinSurprises$getCabinSurprises = function (_v0) {
	var httpConfig = _v0.zM;
	var passengers = _v0.Eg;
	var language = _v0.A_;
	var queryParams = A2(
		$elm$core$List$map,
		function (_v2) {
			var a = _v2.a;
			var b = _v2.b;
			return A2($elm$url$Url$Builder$string, a, b);
		},
		_List_fromArray(
			[
				$author$project$Api$Util$guidParam(httpConfig.Gt),
				$author$project$Api$Util$localeParam(language)
			]));
	var _v1 = A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$core$Array$foldl,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tY;
				},
				$elm$core$List$cons),
			_List_Nil),
		$author$project$Common$Passengers$passengerCount)(passengers);
	var adult = _v1.tV;
	var youth = _v1.IF;
	var junior = _v1.AI;
	var child = _v1.vU;
	return $author$project$Api$getWithCredentials(
		{
			j9: A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Messages$GotCabinSurprises),
				$author$project$Api$CabinSurprises$decoder),
			jW: A2($author$project$Api$Endpoint$cabinSurprises, httpConfig.Gs, queryParams)
		});
};
var $author$project$Update$fetchCabinSurprises = F2(
	function (session, _v0) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.pD,
			$author$project$Api$CabinSurprises$getCabinSurprises(session));
	});
var $author$project$Update$addCabinSurprisesRequest = function (model) {
	return A3($author$project$Update$addRequestFactory, $author$project$Update$fetchCabinSurprises, $author$project$Api$Endpoint$trackers.pD, model);
};
var $author$project$Messages$GotExtraServices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$SelectedVehicles$encodeVehicleCodes = F2(
	function (direction, maybeSelectedVehicles) {
		var encodeCarCategory = function (carCategory) {
			var carCategoryString = function () {
				var _v0 = _Utils_Tuple2(carCategory, direction);
				if ((_v0.a === 2) && (_v0.b === 1)) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return 'CAR';
				} else {
					return $author$project$Types$Vehicle$carCategoryToString(carCategory);
				}
			}();
			return $elm$json$Json$Encode$string(carCategoryString);
		};
		return A2(
			$elm$json$Json$Encode$list,
			encodeCarCategory,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$author$project$Types$SelectedVehicles$getVehicleCodes(direction),
					maybeSelectedVehicles)));
	});
var $author$project$Session$getClubOneClientId = F2(
	function (client, passengers) {
		if (client.$ === 3) {
			var clientId = client.a.v5;
			return $elm$core$Maybe$Just(clientId);
		} else {
			return A2(
				$elm$core$Maybe$andThen,
				function (_v1) {
					var clubOneLevel = _v1.pO;
					var clientId = _v1.v5;
					return A2(
						$elm$core$Maybe$andThen,
						function (_v2) {
							return clientId;
						},
						clubOneLevel);
				},
				$elm$core$List$head(
					$elm$core$Array$toList(passengers)));
		}
	});
var $author$project$Api$ExtraServices$encodeExtraServiceBody = function (session) {
	var sailIds = A2(
		$elm$core$Maybe$map,
		$author$project$Types$Trips$sailIds,
		function () {
			var _v3 = session.tp;
			if (_v3.$ === 2) {
				var sails = _v3.a;
				return sails;
			} else {
				return $author$project$Types$Trips$statusToMaybe(session.tp);
			}
		}());
	var _v0 = session;
	var passengers = _v0.Eg;
	var user = _v0.Ia;
	return $elm$json$Json$Encode$object(
		A2(
			$author$project$Utils$List$maybeAdd,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					$elm$core$Maybe$map(
						function (sailId) {
							return _Utils_Tuple2(
								'returnSailId',
								$elm$json$Json$Encode$int(sailId));
						})),
				sailIds),
			A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					function (sailId) {
						return _Utils_Tuple2(
							'outwardSailId',
							$elm$json$Json$Encode$int(sailId));
					},
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, sailIds)),
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						function (clientId) {
							return _Utils_Tuple2(
								'clientId',
								$elm$json$Json$Encode$int(clientId));
						},
						A2($author$project$Session$getClubOneClientId, user.v4, passengers)),
					_List_fromArray(
						[
							_Utils_Tuple2(
							'returnVehicleCodes',
							A2($author$project$Types$SelectedVehicles$encodeVehicleCodes, 1, session.rp)),
							_Utils_Tuple2(
							'outwardVehicleCodes',
							A2($author$project$Types$SelectedVehicles$encodeVehicleCodes, 0, session.rp)),
							_Utils_Tuple2(
							'outwardTravelClasses',
							A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (travelClasses) {
											return session.pr ? function (_v1) {
												var outbound = _v1.Dr;
												return A2($elm$core$List$map, $elm$core$Tuple$first, outbound);
											}(
												$author$project$Types$TravelClasses$getSelectedCodeCountPairLists(travelClasses)) : _List_Nil;
										},
										session.to)))),
							_Utils_Tuple2(
							'returnTravelClasses',
							A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (travelClasses) {
											return session.pr ? function (_v2) {
												var inbound = _v2.zT;
												return A2($elm$core$List$map, $elm$core$Tuple$first, inbound);
											}(
												$author$project$Types$TravelClasses$getSelectedCodeCountPairLists(travelClasses)) : _List_Nil;
										},
										session.to)))),
							_Utils_Tuple2(
							'isPackageReservation',
							$elm$json$Json$Encode$bool(session.vk === 1))
						])))));
};
var $author$project$Types$ExtraService$ExtraService = function (isOutwardAvailable) {
	return function (isReturnAvailable) {
		return function (code) {
			return function (name) {
				return function (imageUrl) {
					return function (description) {
						return function (notification) {
							return function (outwardPrice) {
								return function (outwardPointsPrice) {
									return function (returnPrice) {
										return function (returnPointsPrice) {
											return {pQ: code, nt: description, zP: imageUrl, nS: isOutwardAvailable, Aq: isReturnAvailable, oh: name, C$: notification, Dw: outwardPointsPrice, Dx: outwardPrice, FP: returnPointsPrice, FQ: returnPrice};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$ExtraService$Code = $elm$core$Basics$identity;
var $author$project$Types$ExtraService$codeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Types$ExtraService$extraServiceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['prices', 'returnPointsPrice']),
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['prices', 'returnPrice']),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['prices', 'outwardPointsPrice']),
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['prices', 'outwardPrice']),
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'notification',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'imageUrl',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'code',
									$author$project$Types$ExtraService$codeDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['availableLegs', 'returnSail']),
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['availableLegs', 'outwardSail']),
											$elm$json$Json$Decode$bool,
											$elm$json$Json$Decode$succeed($author$project$Types$ExtraService$ExtraService))))))))))));
var $author$project$Api$Endpoint$extraServices = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['extraServices']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.qk));
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Api$ExtraServices$getExtraServices = function (session) {
	var queryParams = A2(
		$author$project$Api$Util$addExperimentalParamIf,
		session.Aa,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var a = _v0.a;
				var b = _v0.b;
				return A2($elm$url$Url$Builder$string, a, b);
			},
			_List_fromArray(
				[
					$author$project$Api$Util$localeParam(session.A_),
					$author$project$Api$Util$marketParam(session.rb),
					$author$project$Api$Util$guidParam(session.zM.Gt)
				])));
	return $author$project$Api$postWithCredentials(
		{
			ks: $elm$http$Http$jsonBody(
				$author$project$Api$ExtraServices$encodeExtraServiceBody(session)),
			j9: A2(
				$elm$http$Http$expectJson,
				$author$project$Messages$GotExtraServices,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['extraServices']),
					$elm$json$Json$Decode$list($author$project$Types$ExtraService$extraServiceDecoder))),
			jW: A2($author$project$Api$Endpoint$extraServices, session.zM.Gs, queryParams)
		});
};
var $author$project$Api$ExtraServices$fetch = F2(
	function (session, _v0) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.qk,
			$author$project$Api$ExtraServices$getExtraServices(session));
	});
var $author$project$Update$addExtraServicesRequest = function (model) {
	return A3($author$project$Update$addRequestFactory, $author$project$Api$ExtraServices$fetch, $author$project$Api$Endpoint$trackers.qk, model);
};
var $author$project$Messages$GotOnboardServices = function (a) {
	return {$: 19, a: a};
};
var $author$project$Types$OnboardServices$OnboardServices = F9(
	function (bubbleFairServices, covidServices, dining, friendshipBracelets, kidBracelets, massages, maybeShipMoney, priorityBoardings, vehicleIncompatibleServices) {
		return {vz: bubbleFairServices, x5: covidServices, yv: dining, y9: friendshipBracelets, AL: kidBracelets, BI: massages, B3: maybeShipMoney, Fm: priorityBoardings, Ig: vehicleIncompatibleServices};
	});
var $author$project$Types$OnboardServices$BUBBLE_FAIR = 0;
var $author$project$Types$OnboardServices$BubbleFairService$BubbleFairService = F6(
	function (code, description, imageUrl, name, outwardInfo, returnInfo) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name, rQ: outwardInfo, su: returnInfo};
	});
var $author$project$Types$OnboardServices$BubbleFairService$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$BubbleFairService$codeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$Info$Available = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$OnboardServices$Info$Unavailable = {$: 1};
var $author$project$Types$OnboardServices$Info$RawInfo = F3(
	function (isAvailable, beginDateTime, maybePrice) {
		return {ut: beginDateTime, kV: isAvailable, rm: maybePrice};
	});
var $author$project$Types$OnboardServices$Info$rawInfoDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$OnboardServices$Info$RawInfo,
	A2($elm$json$Json$Decode$field, 'available', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'beginDateTime',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'price',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)));
var $author$project$Types$OnboardServices$Info$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Types$OnboardServices$Info$rawInfoDecoder),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$toMaybe,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					function (_v0) {
						var isAvailable = _v0.kV;
						var maybePrice = _v0.rm;
						var beginDateTime = _v0.ut;
						return isAvailable ? A2(
							$elm$core$Maybe$map,
							function (price) {
								return $elm$json$Json$Decode$succeed(
									$author$project$Types$OnboardServices$Info$Available(
										{ut: beginDateTime, lN: price}));
							},
							maybePrice) : $elm$core$Maybe$Nothing;
					}),
				$elm$core$Maybe$withDefault(
					$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$Info$Unavailable))))),
	$elm$json$Json$Decode$value);
var $author$project$Types$OnboardServices$BubbleFairService$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'returnService',
	$author$project$Types$OnboardServices$Info$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outwardService',
		$author$project$Types$OnboardServices$Info$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'imageUrl',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$author$project$Types$OnboardServices$BubbleFairService$codeDecoder,
						$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$BubbleFairService$BubbleFairService)))))));
var $author$project$Types$OnboardServices$COVID = 1;
var $author$project$Types$OnboardServices$DINING = 2;
var $author$project$Types$OnboardServices$FAST_TRACK = 3;
var $author$project$Types$OnboardServices$FRIENDSHIP_BRACELET = 4;
var $author$project$Types$OnboardServices$KID_BRACELET = 5;
var $author$project$Types$OnboardServices$MASSAGE = 6;
var $author$project$Types$OnboardServices$SHIP_MONEY = 7;
var $author$project$Types$OnboardServices$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'BUBBLE_FAIR':
				return $elm$json$Json$Decode$succeed(0);
			case 'COVID':
				return $elm$json$Json$Decode$succeed(1);
			case 'DINING':
				return $elm$json$Json$Decode$succeed(2);
			case 'FAST_TRACK':
				return $elm$json$Json$Decode$succeed(3);
			case 'FRIENDSHIP_BRACELET':
				return $elm$json$Json$Decode$succeed(4);
			case 'KID_BRACELET':
				return $elm$json$Json$Decode$succeed(5);
			case 'MASSAGE':
				return $elm$json$Json$Decode$succeed(6);
			case 'SHIP_MONEY':
				return $elm$json$Json$Decode$succeed(7);
			default:
				var serviceTypeString = string;
				return $elm$json$Json$Decode$fail('Unknown type of onboard service: ' + (serviceTypeString + '.'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$isServiceTypeInValue = function (serviceType) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue(
			A2($elm$json$Json$Decode$field, 'type', $author$project$Types$OnboardServices$typeDecoder)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$map(
				$elm$core$Basics$eq(serviceType)),
			$elm$core$Result$withDefault(false)));
};
var $author$project$Types$OnboardServices$servicesInListDecoder = F2(
	function (serviceDecoder, serviceType) {
		return A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filter(
					$author$project$Types$OnboardServices$isServiceTypeInValue(serviceType)),
				$elm$core$List$filterMap(
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Decode$decodeValue(serviceDecoder),
						$elm$core$Result$toMaybe))),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
	});
var $author$project$Types$OnboardServices$bubbleFairServicesInServicesListDecoder = A2($author$project$Types$OnboardServices$servicesInListDecoder, $author$project$Types$OnboardServices$BubbleFairService$decoder, 0);
var $author$project$Types$OnboardServices$CovidService$CovidService = F7(
	function (code, serviceType, description, imageUrl, name, outwardInfo, returnInfo) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name, rQ: outwardInfo, su: returnInfo, j4: serviceType};
	});
var $author$project$Types$OnboardServices$CovidService$Test = 0;
var $author$project$Types$OnboardServices$CovidService$Vaccine = 1;
var $author$project$Types$OnboardServices$CovidService$serviceTypeFromString = function (string) {
	switch (string) {
		case 'COVID GRP':
			return $elm$core$Maybe$Just(0);
		case 'VACCINE GRP':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$OnboardServices$CovidService$classificationCodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unknown classificationCode'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Types$OnboardServices$CovidService$serviceTypeFromString(string)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$CovidService$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$CovidService$codeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Types$OnboardServices$CovidService$decoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Types$OnboardServices$CovidService$CovidService,
	A2($elm$json$Json$Decode$field, 'code', $author$project$Types$OnboardServices$CovidService$codeDecoder),
	A2($elm$json$Json$Decode$field, 'classificationCode', $author$project$Types$OnboardServices$CovidService$classificationCodeDecoder),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'imageUrl',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'outwardService', $author$project$Types$OnboardServices$Info$decoder),
	A2($elm$json$Json$Decode$field, 'returnService', $author$project$Types$OnboardServices$Info$decoder));
var $author$project$Types$OnboardServices$covidServicesInServicesListDecoder = A2($author$project$Types$OnboardServices$servicesInListDecoder, $author$project$Types$OnboardServices$CovidService$decoder, 1);
var $author$project$Types$OnboardServices$Massage$Massage = F6(
	function (code, description, imageUrl, name, price, timeSlots) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name, lN: price, mY: timeSlots};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Types$OnboardServices$Massage$TimeSlot = F2(
	function (startTime, duration) {
		return {nv: duration, ld: startTime};
	});
var $author$project$Types$OnboardServices$Massage$timeSlotDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$OnboardServices$Massage$TimeSlot,
	A2($elm$json$Json$Decode$field, 'startTime', $author$project$Utils$Time$decoder),
	A2($elm$json$Json$Decode$field, 'duration', $elm$json$Json$Decode$int));
var $author$project$Types$OnboardServices$Massage$decoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Types$OnboardServices$Massage$Massage,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'imageUrl',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$field,
		'timeSlots',
		$elm$json$Json$Decode$list($author$project$Types$OnboardServices$Massage$timeSlotDecoder)));
var $author$project$Types$OnboardServices$Dining = F6(
	function (code, description, imageUrl, name, outwardServices, returnServices) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name, ot: outwardServices, oL: returnServices};
	});
var $author$project$Types$OnboardServices$DiningCode = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$DiningService = F4(
	function (isAvailable, beginTime, endTime, price) {
		return {nd: beginTime, yN: endTime, kV: isAvailable, lN: price};
	});
var $author$project$Utils$Number$Positive$Positive = $elm$core$Basics$identity;
var $author$project$Utils$Number$Positive$fromNumber = function (a) {
	return (a > 0) ? $elm$core$Maybe$Just(a) : $elm$core$Maybe$Nothing;
};
var $author$project$Types$OnboardServices$diningServiceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$andThen($author$project$Utils$Number$Positive$fromNumber),
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'endDateTime',
		$elm$json$Json$Decode$maybe($author$project$Utils$Time$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'beginDateTime',
			$author$project$Utils$Time$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'available',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$DiningService)))));
var $author$project$Types$OnboardServices$diningDecoder = function (a) {
	var decodePaidAddons = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$concat,
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$field,
				'paidAddons',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$value))));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (list) {
			return $elm$core$List$isEmpty(list) ? a : $elm$json$Json$Decode$fail('has paid addons');
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$append,
			A2($elm$json$Json$Decode$field, 'outwardTableReservations', decodePaidAddons),
			A2($elm$json$Json$Decode$field, 'returnTableReservations', decodePaidAddons)));
}(
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'returnTableReservations',
		$elm$json$Json$Decode$list($author$project$Types$OnboardServices$diningServiceDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'outwardTableReservations',
			$elm$json$Json$Decode$list($author$project$Types$OnboardServices$diningServiceDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'imageUrl',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$Dining))))))));
var $author$project$Types$OnboardServices$FriendshipBracelet$FriendshipBracelet = F6(
	function (code, description, imageUrl, name, outwardInfo, returnInfo) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name, rQ: outwardInfo, su: returnInfo};
	});
var $author$project$Types$OnboardServices$FriendshipBracelet$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$FriendshipBracelet$codeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$InfoWithAddons$Available = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$OnboardServices$InfoWithAddons$Unavailable = {$: 1};
var $author$project$Types$OnboardServices$InfoWithAddons$RawInfoWithAddons = function (addons) {
	return {tS: addons};
};
var $author$project$Types$OnboardServices$Addon$Addon = F3(
	function (code, name, price) {
		return {pQ: code, oh: name, lN: price};
	});
var $author$project$Types$OnboardServices$Addon$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$Addon$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$OnboardServices$Addon$Addon,
	A2(
		$elm$json$Json$Decode$field,
		'code',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float));
var $author$project$Types$OnboardServices$InfoWithAddons$rawInfoDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Types$OnboardServices$InfoWithAddons$RawInfoWithAddons,
	A2(
		$elm$json$Json$Decode$field,
		'paidAddons',
		$elm$json$Json$Decode$list($author$project$Types$OnboardServices$Addon$decoder)));
var $author$project$Types$OnboardServices$InfoWithAddons$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$elm$json$Json$Decode$decodeValue($author$project$Types$OnboardServices$InfoWithAddons$rawInfoDecoder),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$toMaybe,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					function (_v0) {
						var addons = _v0.tS;
						return (!$elm$core$List$isEmpty(addons)) ? $elm$json$Json$Decode$succeed(
							$author$project$Types$OnboardServices$InfoWithAddons$Available(addons)) : $elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$InfoWithAddons$Unavailable);
					}),
				$elm$core$Maybe$withDefault(
					$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$InfoWithAddons$Unavailable))))),
	$elm$json$Json$Decode$value);
var $author$project$Types$OnboardServices$FriendshipBracelet$decoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Types$OnboardServices$FriendshipBracelet$FriendshipBracelet,
	A2($elm$json$Json$Decode$field, 'code', $author$project$Types$OnboardServices$FriendshipBracelet$codeDecoder),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'imageUrl',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'outwardService', $author$project$Types$OnboardServices$InfoWithAddons$decoder),
	A2($elm$json$Json$Decode$field, 'returnService', $author$project$Types$OnboardServices$InfoWithAddons$decoder));
var $author$project$Types$OnboardServices$friendshipBraceletsInServicesListDecoder = A2($author$project$Types$OnboardServices$servicesInListDecoder, $author$project$Types$OnboardServices$FriendshipBracelet$decoder, 4);
var $author$project$Types$OnboardServices$KidBracelet$KidBracelet = F7(
	function (code, ageCategory, description, imageUrl, name, outwardInfo, returnInfo) {
		return {tY: ageCategory, pQ: code, nt: description, zP: imageUrl, oh: name, rQ: outwardInfo, su: returnInfo};
	});
var $author$project$Types$OnboardServices$KidBracelet$ageCategoryFromString = function (string) {
	switch (string) {
		case 'BRACELET TEEN':
			return $elm$core$Maybe$Just(1);
		case 'BRACELET JUN':
			return $elm$core$Maybe$Just(3);
		case 'BRACELET KID':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$OnboardServices$KidBracelet$classificationCodeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unknown classificationCode'),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Types$OnboardServices$KidBracelet$ageCategoryFromString(string)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$KidBracelet$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$KidBracelet$codeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$KidBracelet$decoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Types$OnboardServices$KidBracelet$KidBracelet,
	A2($elm$json$Json$Decode$field, 'code', $author$project$Types$OnboardServices$KidBracelet$codeDecoder),
	A2($elm$json$Json$Decode$field, 'classificationCode', $author$project$Types$OnboardServices$KidBracelet$classificationCodeDecoder),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'imageUrl',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'outwardService', $author$project$Types$OnboardServices$Info$decoder),
	A2($elm$json$Json$Decode$field, 'returnService', $author$project$Types$OnboardServices$Info$decoder));
var $author$project$Types$OnboardServices$kidBraceletsInServicesListDecoder = A2($author$project$Types$OnboardServices$servicesInListDecoder, $author$project$Types$OnboardServices$KidBracelet$decoder, 5);
var $author$project$Types$OnboardServices$PriorityBoarding$PriorityBoarding = F6(
	function (code, description, imageUrl, name, outwardInfo, returnInfo) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name, rQ: outwardInfo, su: returnInfo};
	});
var $author$project$Types$OnboardServices$PriorityBoarding$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$PriorityBoarding$codeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$OnboardServices$PriorityBoarding$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'returnService',
	$author$project$Types$OnboardServices$Info$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outwardService',
		$author$project$Types$OnboardServices$Info$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'imageUrl',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$author$project$Types$OnboardServices$PriorityBoarding$codeDecoder,
						$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$PriorityBoarding$PriorityBoarding)))))));
var $author$project$Types$OnboardServices$priorityBoardingsInServicesListDecoder = A2($author$project$Types$OnboardServices$servicesInListDecoder, $author$project$Types$OnboardServices$PriorityBoarding$decoder, 3);
var $author$project$Types$OnboardServices$ShipMoney$Code = $elm$core$Basics$identity;
var $author$project$Types$OnboardServices$ShipMoney$ShipMoney = F5(
	function (code, name, description, imageUrl, coupons) {
		return {pQ: code, x3: coupons, nt: description, zP: imageUrl, oh: name};
	});
var $author$project$Types$OnboardServices$ShipMoney$OneWay = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$OnboardServices$ShipMoney$TwoWay = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$OnboardServices$ShipMoney$availabilityFromMaybes = function (_v0) {
	var maybeOutward = _v0.a;
	var maybeReturn = _v0.b;
	var _v1 = _Utils_Tuple2(maybeOutward, maybeReturn);
	if (!_v1.a.$) {
		if (!_v1.b.$) {
			var outward = _v1.a.a;
			var _return = _v1.b.a;
			return $elm$core$Maybe$Just(
				$author$project$Types$OnboardServices$ShipMoney$TwoWay(
					{Ds: outward, FL: _return}));
		} else {
			var outward = _v1.a.a;
			return $elm$core$Maybe$Just(
				$author$project$Types$OnboardServices$ShipMoney$OneWay(outward));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$OnboardServices$ShipMoney$Coupon = F3(
	function (code, name, price) {
		return {pQ: code, oh: name, lN: price};
	});
var $author$project$Types$OnboardServices$ShipMoney$couponDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$OnboardServices$ShipMoney$Coupon,
	A2(
		$elm$json$Json$Decode$field,
		'code',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float));
var $author$project$Types$OnboardServices$ShipMoney$couponsDecoder = function () {
	var decodeService = A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var isAvailable = _v0.a;
			var coupons = _v0.b;
			if (isAvailable) {
				if (coupons.b) {
					var first = coupons.a;
					var others = coupons.b;
					return $elm$json$Json$Decode$succeed(
						{nx: first, lH: others});
				} else {
					return $elm$json$Json$Decode$fail('Missing coupons.');
				}
			} else {
				return $elm$json$Json$Decode$fail('Unavailable coupons');
			}
		},
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paidAddons',
			$elm$json$Json$Decode$list($author$project$Types$OnboardServices$ShipMoney$couponDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'available',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($elm$core$Tuple$pair))));
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Types$OnboardServices$ShipMoney$availabilityFromMaybes,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
				$elm$core$Maybe$withDefault(
					$elm$json$Json$Decode$fail('No coupons in service.')))),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'returnService',
			$elm$json$Json$Decode$maybe(decodeService),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'outwardService',
				$elm$json$Json$Decode$maybe(decodeService),
				$elm$json$Json$Decode$succeed($elm$core$Tuple$pair))));
}();
var $author$project$Types$OnboardServices$ShipMoney$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_Nil,
	$author$project$Types$OnboardServices$ShipMoney$couponsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'imageUrl',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$ShipMoney$ShipMoney))))));
var $author$project$Types$OnboardServices$serviceTypeToString = function (serviceType) {
	switch (serviceType) {
		case 0:
			return 'BUBBLE_FAIR';
		case 1:
			return 'COVID';
		case 2:
			return 'DINING';
		case 3:
			return 'FAST_TRACK';
		case 4:
			return 'FRIENDSHIP_BRACELET';
		case 5:
			return 'KID_BRACELET';
		case 6:
			return 'MASSAGE';
		default:
			return 'SHIP_MONEY';
	}
};
var $author$project$Types$OnboardServices$singleServiceInListDecoder = F2(
	function (serviceDecoder, serviceType) {
		return A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$list_extra$List$Extra$find(
					$author$project$Types$OnboardServices$isServiceTypeInValue(serviceType)),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							$elm$json$Json$Decode$decodeValue(serviceDecoder),
							function (result) {
								if (!result.$) {
									var a = result.a;
									return $elm$json$Json$Decode$succeed(a);
								} else {
									var error = result.a;
									return $elm$json$Json$Decode$fail(
										$elm$json$Json$Decode$errorToString(error));
								}
							})),
					$elm$core$Maybe$withDefault(
						$elm$json$Json$Decode$fail(
							'No ' + ($author$project$Types$OnboardServices$serviceTypeToString(serviceType) + ' service.'))))),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
	});
var $author$project$Types$OnboardServices$shipMoneyInServicesListDecoder = A2($author$project$Types$OnboardServices$singleServiceInListDecoder, $author$project$Types$OnboardServices$ShipMoney$decoder, 7);
var $author$project$Types$OnboardServices$vehicleIncompatibleServicesDecoder = function () {
	var rawDecoder = A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vehicleCompatible',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed(
					F3(
						function (code, name, vehicleCompatible) {
							return {pQ: code, oh: name, ts: vehicleCompatible};
						})))));
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap(
			function (_v0) {
				var code = _v0.pQ;
				var name = _v0.oh;
				var vehicleCompatible = _v0.ts;
				return (!vehicleCompatible) ? $elm$core$Maybe$Just(
					{pQ: code, oh: name}) : $elm$core$Maybe$Nothing;
			}),
		$elm$json$Json$Decode$list(rawDecoder));
}();
var $author$project$Types$OnboardServices$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'services',
	$author$project$Types$OnboardServices$vehicleIncompatibleServicesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'services',
		$author$project$Types$OnboardServices$priorityBoardingsInServicesListDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'services',
			$elm$json$Json$Decode$maybe($author$project$Types$OnboardServices$shipMoneyInServicesListDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'massages',
				$elm$json$Json$Decode$list($author$project$Types$OnboardServices$Massage$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'services',
					$author$project$Types$OnboardServices$kidBraceletsInServicesListDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'services',
						$author$project$Types$OnboardServices$friendshipBraceletsInServicesListDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'restaurants',
							A2(
								$elm$json$Json$Decode$map,
								$elm$core$List$filterMap($elm$core$Basics$identity),
								$elm$json$Json$Decode$list(
									$elm$json$Json$Decode$maybe($author$project$Types$OnboardServices$diningDecoder))),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'services',
								$author$project$Types$OnboardServices$covidServicesInServicesListDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'services',
									$author$project$Types$OnboardServices$bubbleFairServicesInServicesListDecoder,
									$elm$json$Json$Decode$succeed($author$project$Types$OnboardServices$OnboardServices))))))))));
var $author$project$Api$Endpoint$onboardServices = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['onboardServices', 'v2']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.rI));
	});
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Types$OnboardServices$requestParams = function (request) {
	var adults = request.pn;
	var juniors = request.AJ;
	var youths = request.tG;
	var children = request.vV;
	var outwardTravelClasses = request.DB;
	var returnTravelClasses = request.FU;
	var hasOutwardVehicle = request.qx;
	var hasReturnVehicle = request.qy;
	return A2(
		$author$project$Utils$List$maybeAdd,
		A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$int('returnSailId'),
			request.sx),
		A2(
			$author$project$Utils$List$maybeAdd,
			A2(
				$elm$core$Maybe$map,
				$elm$url$Url$Builder$string('clubOneSsoToken'),
				request.pP),
			A3(
				$author$project$Utils$List$addIf,
				!$elm$core$List$isEmpty(returnTravelClasses),
				A2(
					$elm$url$Url$Builder$string,
					'returnTravelClasses',
					A2($elm$core$String$join, ',', returnTravelClasses)),
				A3(
					$author$project$Utils$List$addIf,
					!$elm$core$List$isEmpty(outwardTravelClasses),
					A2(
						$elm$url$Url$Builder$string,
						'outwardTravelClasses',
						A2($elm$core$String$join, ',', outwardTravelClasses)),
					A3(
						$author$project$Utils$List$addIf,
						children > 0,
						A2($elm$url$Url$Builder$int, 'children', children),
						A3(
							$author$project$Utils$List$addIf,
							youths > 0,
							A2($elm$url$Url$Builder$int, 'youths', youths),
							A3(
								$author$project$Utils$List$addIf,
								juniors > 0,
								A2($elm$url$Url$Builder$int, 'juniors', juniors),
								A3(
									$author$project$Utils$List$addIf,
									hasReturnVehicle,
									A2($elm$url$Url$Builder$string, 'hasReturnVehicle', 'true'),
									A3(
										$author$project$Utils$List$addIf,
										hasOutwardVehicle,
										A2($elm$url$Url$Builder$string, 'hasOutwardVehicle', 'true'),
										_List_fromArray(
											[
												A2($elm$url$Url$Builder$int, 'outwardSailId', request.rU),
												A2($elm$url$Url$Builder$int, 'adults', adults)
											]))))))))));
};
var $author$project$Types$OnboardServices$fetch = F2(
	function (_v0, request) {
		var language = _v0.A_;
		var market = _v0.rb;
		var isExperimental = _v0.Aa;
		var httpConfig = _v0.zM;
		var bookingType = _v0.vk;
		var genericParams = A2(
			$author$project$Api$Util$addExperimentalParamIf,
			isExperimental,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A3(
					$author$project$Utils$List$addIf,
					bookingType === 1,
					_Utils_Tuple2('voyageType', 'HOTEL'),
					_List_fromArray(
						[
							$author$project$Api$Util$localeParam(language),
							$author$project$Api$Util$marketParam(market),
							$author$project$Api$Util$guidParam(httpConfig.Gt)
						]))));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, $elm$core$Basics$identity, $author$project$Types$OnboardServices$decoder),
				jW: A2(
					$author$project$Api$Endpoint$onboardServices,
					httpConfig.Gs,
					_Utils_ap(
						genericParams,
						$author$project$Types$OnboardServices$requestParams(request)))
			});
	});
var $author$project$Types$SelectedVehicles$hasSelectedVehicle = F2(
	function (direction, maybeSelectedVehicles) {
		return function (length) {
			return length > 0;
		}(
			$elm$core$List$length(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Types$SelectedVehicles$getVehicleCodes(direction),
						maybeSelectedVehicles))));
	});
var $author$project$Update$Trips$fetchOnboardServices = F2(
	function (session, _v0) {
		var outwardSailId = _v0.a;
		var returnSailId = _v0.b;
		var _v1 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$getSelectedCodeCountPairLists,
					function (_v2) {
						var outbound = _v2.Dr;
						var inbound = _v2.zT;
						return _Utils_Tuple2(
							A2($elm$core$List$map, $elm$core$Tuple$first, outbound),
							A2($elm$core$List$map, $elm$core$Tuple$first, inbound));
					}),
				session.to));
		var outwardTravelClasses = _v1.a;
		var returnTravelClasses = _v1.b;
		var _v3 = _Utils_Tuple2(
			A2($author$project$Types$SelectedVehicles$hasSelectedVehicle, 0, session.rp),
			A2($author$project$Types$SelectedVehicles$hasSelectedVehicle, 1, session.rp));
		var hasOutwardVehicle = _v3.a;
		var hasReturnSVehicle = _v3.b;
		var _v4 = $author$project$Common$Passengers$passengerCount(
			A3(
				$elm$core$Array$foldl,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$List$cons),
				_List_Nil,
				session.Eg));
		var adult = _v4.tV;
		var junior = _v4.AI;
		var youth = _v4.IF;
		var child = _v4.vU;
		var request = {pn: adult, vV: child, pP: session.Ia.Cb, qx: hasOutwardVehicle, qy: hasReturnSVehicle, AJ: junior, rU: outwardSailId, DB: outwardTravelClasses, sx: returnSailId, FU: returnTravelClasses, tG: youth};
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.rI,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$GotOnboardServices,
				A2($author$project$Types$OnboardServices$fetch, session, request)));
	});
var $author$project$Update$addOnboardServicesRequest = function (model) {
	return A3($author$project$Update$addRequestFactory, $author$project$Update$Trips$fetchOnboardServices, $author$project$Api$Endpoint$trackers.rI, model);
};
var $author$project$Types$TravelClasses$OneWay = $elm$core$Basics$identity;
var $author$project$Types$TravelClasses$OneWayMultiple = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$TravelClasses$OneWaySingle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$TravelClasses$TwoWay = $elm$core$Basics$identity;
var $author$project$Types$TravelClasses$TwoWayMultiple = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$TravelClasses$TwoWaySingle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$TravelClasses$removeTravelClassIfNotAllPassengerCovered = F2(
	function (selectedCodesAndCounts, newPassengers) {
		var newAdultsCount = $author$project$Types$Passenger$Util$countAdultPassengers(newPassengers);
		var isDeckSelected = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
			selectedCodesAndCounts);
		var count = (isDeckSelected ? $elm$core$List$length : A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($elm$core$Tuple$second),
			$elm$core$List$sum))(selectedCodesAndCounts);
		var remapedSelections = A2(
			$elm$core$Maybe$withDefault,
			selectedCodesAndCounts,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var currentSelectedCode = _v0.a;
					return A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							$elm$core$Basics$neq(0)),
						A2(
							$elm$core$List$map,
							function (codeAndCount) {
								return (_Utils_eq(codeAndCount.a, currentSelectedCode) && (_Utils_cmp(newAdultsCount, count) < 0)) ? A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$Basics$add(-1),
									codeAndCount) : codeAndCount;
							},
							selectedCodesAndCounts));
				},
				$elm$core$List$head(selectedCodesAndCounts)));
		var selectionsWithoutDeck = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$neq($author$project$Types$TravelClasses$deckCode)),
					remapedSelections)));
		return A2(
			$elm$core$List$map,
			function (codeAndCount) {
				return _Utils_eq(codeAndCount.a, $author$project$Types$TravelClasses$deckCode) ? _Utils_Tuple2(
					$author$project$Types$TravelClasses$deckCode,
					$elm$core$Array$length(newPassengers) - selectionsWithoutDeck) : codeAndCount;
			},
			remapedSelections);
	});
var $author$project$Types$TravelClasses$getDirectionTravelClassInfo = function (direction) {
	if (!direction) {
		return function ($) {
			return $.DA;
		};
	} else {
		return function ($) {
			return $.FT;
		};
	}
};
var $author$project$Types$TravelClasses$setAllPassengersInAlaDeck = F4(
	function (selections, available, passengers, direction) {
		var selectionsWithoutDeck = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$neq($author$project$Types$TravelClasses$deckCode)),
					selections)));
		var passengersCount = $elm$core$Array$length(passengers);
		var count = $elm$core$List$isEmpty(selections) ? passengersCount : (passengersCount - selectionsWithoutDeck);
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (travelClass) {
					return A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								var availability = _v0.uk;
								var selectedTravelClasses = $elm$core$List$isEmpty(selections) ? _List_fromArray(
									[
										_Utils_Tuple2($author$project$Types$TravelClasses$deckCode, count)
									]) : A2(
									$elm$core$List$map,
									function (selection) {
										return _Utils_eq(selection.a, $author$project$Types$TravelClasses$deckCode) ? _Utils_Tuple2($author$project$Types$TravelClasses$deckCode, count) : selection;
									},
									selections);
								return (_Utils_cmp(availability, count) > -1) ? selectedTravelClasses : _List_Nil;
							},
							A2($author$project$Types$TravelClasses$getDirectionTravelClassInfo, direction, travelClass)));
				},
				A2($author$project$Types$TravelClasses$getTravelClass, $author$project$Types$TravelClasses$deckCode, available)));
	});
var $author$project$Types$TravelClasses$getDirectionChangedTravelClassesAfterPassengerChange = F5(
	function (travelClasses, dict, direction, currentPassengers, newPassengers) {
		var newPassengersCount = $elm$core$Array$length(newPassengers);
		var currentSelectedCodesAndCounts = function () {
			if (travelClasses.$ === 3) {
				var outward = travelClasses.a.Ds;
				var _return = travelClasses.a.FL;
				if (!direction) {
					return outward;
				} else {
					return _return;
				}
			} else {
				return _List_Nil;
			}
		}();
		var isDeckSelected = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
			currentSelectedCodesAndCounts);
		var currentPassengersCount = $elm$core$Array$length(currentPassengers);
		return ((!$elm$core$List$isEmpty(currentSelectedCodesAndCounts)) && (_Utils_cmp(newPassengersCount, currentPassengersCount) < 0)) ? A2($author$project$Types$TravelClasses$removeTravelClassIfNotAllPassengerCovered, currentSelectedCodesAndCounts, newPassengers) : (((_Utils_cmp(newPassengersCount, currentPassengersCount) > 0) && isDeckSelected) ? A4($author$project$Types$TravelClasses$setAllPassengersInAlaDeck, currentSelectedCodesAndCounts, dict, newPassengers, direction) : currentSelectedCodesAndCounts);
	});
var $author$project$Types$TravelClasses$getFirstAvailableTravelClassCode = F2(
	function (travelClasses, direction) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$getDirectionTravelClassInfo(direction),
					$elm$core$Maybe$map(
						function ($) {
							return $.pQ;
						})),
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$TravelClasses$getDirectionTravelClassInfo(direction),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.uk;
									},
									$elm$core$Basics$lt(0))),
							$elm$core$Maybe$withDefault(false))),
					travelClasses)));
	});
var $author$project$Types$TravelClasses$starDeckCode = 'DSC';
var $author$project$Types$TravelClasses$findPreselectedTravelClassCode = F2(
	function (travelClasses, direction) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Types$TravelClasses$getFirstAvailableTravelClassCode, travelClasses, direction),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$getDirectionTravelClassInfo(direction),
					$elm$core$Maybe$map(
						function ($) {
							return $.pQ;
						})),
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (travelClass) {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function (_v0) {
									var code = _v0.pQ;
									var availability = _v0.uk;
									return (_Utils_eq(code, $author$project$Types$TravelClasses$deckCode) || _Utils_eq(code, $author$project$Types$TravelClasses$starDeckCode)) && (availability > 0);
								},
								A2($author$project$Types$TravelClasses$getDirectionTravelClassInfo, direction, travelClass)));
					},
					travelClasses)));
	});
var $author$project$Types$TravelClasses$getUpdatedShuttleTravelClasses = F5(
	function (selectedCode, travelClasses, passengers, direction, from) {
		var spotsAvailableInInfo = function (_v1) {
			var availability = _v1.uk;
			var maxAvailableCapacity = _v1.mJ;
			return availability * maxAvailableCapacity;
		};
		var isMugVssRouteAndOnePassenger = $author$project$Utils$Route$isMugVssRoute(from) && ($elm$core$Array$length(passengers) === 1);
		var availableSpotsInDirection = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				function () {
					if (!direction) {
						return A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.DA;
							},
							$elm$core$Maybe$map(spotsAvailableInInfo));
					} else {
						return A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.FT;
							},
							$elm$core$Maybe$map(spotsAvailableInInfo));
					}
				}(),
				A2($author$project$Types$TravelClasses$getTravelClass, selectedCode, travelClasses)));
		return ((_Utils_cmp(
			availableSpotsInDirection,
			$elm$core$Array$length(passengers)) > -1) && (!isMugVssRouteAndOnePassenger)) ? selectedCode : A2($author$project$Types$TravelClasses$findPreselectedTravelClassCode, travelClasses, direction);
	});
var $author$project$Types$TravelClasses$maxPetsPerCabin = 3;
var $author$project$Types$TravelClasses$remapWhenPassengersChanged = F4(
	function (from, currentPassengers, newPassengers, travelClasses) {
		var newPets = F2(
			function (selected, pets) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (_v1, accumulator) {
							var code = _v1.a;
							var count = _v1.b;
							return A2(
								$elm$core$Maybe$withDefault,
								accumulator,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Basics$min(count * $author$project$Types$TravelClasses$maxPetsPerCabin),
										function (petCount) {
											return (!petCount) ? accumulator : A3($elm$core$Dict$insert, code, petCount, accumulator);
										}),
									A2($elm$core$Dict$get, code, pets)));
						}),
					$elm$core$Dict$empty,
					selected);
			});
		var newPassengersCount = $elm$core$Array$length(newPassengers);
		var currentPassengersCount = $elm$core$Array$length(currentPassengers);
		switch (travelClasses.$) {
			case 0:
				var oneWay = travelClasses.a;
				return $author$project$Types$TravelClasses$OneWaySingle(
					_Utils_update(
						oneWay,
						{
							Gg: A5(
								$author$project$Types$TravelClasses$getUpdatedShuttleTravelClasses,
								oneWay.Gg,
								$author$project$Types$TravelClasses$allFromAvailable(oneWay.nb),
								newPassengers,
								0,
								from)
						}));
			case 1:
				var twoWay = travelClasses.a;
				return $author$project$Types$TravelClasses$TwoWaySingle(
					_Utils_update(
						twoWay,
						{
							Ds: A5(
								$author$project$Types$TravelClasses$getUpdatedShuttleTravelClasses,
								twoWay.Ds,
								$author$project$Types$TravelClasses$all(travelClasses),
								newPassengers,
								0,
								from),
							FL: A5(
								$author$project$Types$TravelClasses$getUpdatedShuttleTravelClasses,
								twoWay.FL,
								$author$project$Types$TravelClasses$all(travelClasses),
								newPassengers,
								1,
								from)
						}));
			case 2:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				var available = travelClasses.a.nb;
				var isDeckSelected = A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
					selected);
				var newSelected = ((!$elm$core$List$isEmpty(selected)) && (_Utils_cmp(newPassengersCount, currentPassengersCount) < 0)) ? A2($author$project$Types$TravelClasses$removeTravelClassIfNotAllPassengerCovered, selected, newPassengers) : (((_Utils_cmp(newPassengersCount, currentPassengersCount) > 0) && isDeckSelected) ? A4(
					$author$project$Types$TravelClasses$setAllPassengersInAlaDeck,
					selected,
					$author$project$Types$TravelClasses$allFromAvailable(available),
					newPassengers,
					0) : selected);
				return $author$project$Types$TravelClasses$OneWayMultiple(
					{
						nb: available,
						k: A2(newPets, newSelected, pets),
						Gg: newSelected
					});
			default:
				var twoWay = travelClasses.a;
				var newReturnSelected = A5(
					$author$project$Types$TravelClasses$getDirectionChangedTravelClassesAfterPassengerChange,
					travelClasses,
					$author$project$Types$TravelClasses$allFromAvailable(twoWay.nb),
					1,
					currentPassengers,
					newPassengers);
				var newOutwardSelected = A5(
					$author$project$Types$TravelClasses$getDirectionChangedTravelClassesAfterPassengerChange,
					travelClasses,
					$author$project$Types$TravelClasses$allFromAvailable(twoWay.nb),
					0,
					currentPassengers,
					newPassengers);
				return $author$project$Types$TravelClasses$TwoWayMultiple(
					_Utils_update(
						twoWay,
						{
							Ds: newOutwardSelected,
							m: A2(newPets, newOutwardSelected, twoWay.m),
							FL: newReturnSelected,
							t: A2(newPets, newReturnSelected, twoWay.t)
						}));
		}
	});
var $author$project$Messages$RemovedPassengerAnimation = {$: 79};
var $author$project$Update$Passengers$removeAnimationCmd = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Messages$RemovedPassengerAnimation;
	},
	$elm$core$Process$sleep(500));
var $author$project$Update$Passengers$addPassenger = F2(
	function (model, ageCategory) {
		var _v0 = model;
		var session = _v0.j;
		if (_Utils_eq(
			$elm$core$Array$length(session.Eg),
			$author$project$Utils$Route$getMaxNumberOfPassengers(session))) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Messages$ToastMsg,
					A3(
						$author$project$Common$Toast$showToastCmd,
						0,
						function ($) {
							return $.hf;
						},
						false)));
		} else {
			var passengers = A2(
				$elm$core$Array$push,
				$author$project$Types$Passenger$init(ageCategory),
				session.Eg);
			var passengerPage = A2(
				$author$project$PassengerPage$Model$Model,
				$elm$core$Maybe$Just(
					$elm$core$Array$length(session.Eg)),
				$elm$core$Maybe$Nothing);
			var maybeTravelClasses = A2(
				$elm$core$Maybe$map,
				A3($author$project$Types$TravelClasses$remapWhenPassengersChanged, session.kS, session.Eg, passengers),
				session.to);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						Ea: passengerPage,
						j: _Utils_update(
							session,
							{Eg: passengers, to: maybeTravelClasses})
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Update$Passengers$hasMealsOrMealPackage(model) ? $author$project$Update$Passengers$showMealsWereAddedToast : $elm$core$Platform$Cmd$none,
							$author$project$Update$Passengers$removeAnimationCmd
						])));
		}
	});
var $author$project$Types$TravelClasses$updatePetsBasedOnDirection = F3(
	function (direction, _function, travelClasses) {
		switch (travelClasses.$) {
			case 0:
				var oneWay = travelClasses.a;
				return $author$project$Types$TravelClasses$OneWaySingle(
					_Utils_update(
						oneWay,
						{
							k: _function(oneWay.k)
						}));
			case 1:
				var twoWay = travelClasses.a;
				if (!direction) {
					return $author$project$Types$TravelClasses$TwoWaySingle(
						_Utils_update(
							twoWay,
							{
								m: _function(twoWay.m)
							}));
				} else {
					return $author$project$Types$TravelClasses$TwoWaySingle(
						_Utils_update(
							twoWay,
							{
								t: _function(twoWay.t)
							}));
				}
			case 2:
				var oneWay = travelClasses.a;
				return $author$project$Types$TravelClasses$OneWayMultiple(
					_Utils_update(
						oneWay,
						{
							k: _function(oneWay.k)
						}));
			default:
				var twoWay = travelClasses.a;
				if (!direction) {
					return $author$project$Types$TravelClasses$TwoWayMultiple(
						_Utils_update(
							twoWay,
							{
								m: _function(twoWay.m)
							}));
				} else {
					return $author$project$Types$TravelClasses$TwoWayMultiple(
						_Utils_update(
							twoWay,
							{
								t: _function(twoWay.t)
							}));
				}
		}
	});
var $author$project$Types$TravelClasses$addPetTravelClass = F3(
	function (code, direction, travelClasses) {
		return A3(
			$author$project$Types$TravelClasses$updatePetsBasedOnDirection,
			direction,
			A2(
				$elm$core$Dict$update,
				code,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$add(1),
							$elm$core$Maybe$Just)),
					$elm$core$Maybe$withDefault(
						$elm$core$Maybe$Just(1)))),
			travelClasses);
	});
var $author$project$Update$Trips$fetchTrips = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						pr: false,
						Ad: false,
						Af: true,
						B7: $elm$core$Maybe$Nothing,
						B8: $elm$core$Maybe$Nothing,
						tp: function () {
							var _v0 = session.tp;
							if (_v0.$ === 2) {
								var trips = _v0.a;
								return $author$project$Types$Trips$Loading(trips);
							} else {
								return $author$project$Types$Trips$Loading(
									$author$project$Types$Trips$statusToMaybe(session.tp));
							}
						}()
					})
			}),
		A2(
			$author$project$Api$Timetable$fetch,
			$author$project$Update$RequestTimes$create(session.kJ),
			model));
};
var $author$project$Utils$Route$isCruiseLikeVoyageType = function (voyageType) {
	return A2(
		$elm$core$List$member,
		voyageType,
		_List_fromArray(
			[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$CruiseMultiship, $author$project$Types$VoyageType$CruiseMultistop]));
};
var $author$project$Update$addRequestsForDataAffectedByVehicleModification = function (model) {
	if (!$author$project$Utils$Route$isCruiseLikeVoyageType(model.j.tx)) {
		var maybeSailIds = A2(
			$elm$core$Maybe$map,
			$author$project$Types$Trips$sailIds,
			function () {
				var _v0 = model.j.tp;
				if (_v0.$ === 2) {
					var sails = _v0.a;
					return sails;
				} else {
					return $author$project$Types$Trips$statusToMaybe(model.j.tp);
				}
			}());
		return A2(
			$author$project$Update$Util$andThen,
			function (newModel) {
				return _Utils_Tuple2(
					newModel,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							$author$project$Update$Trips$fetchOnboardServices(newModel.j),
							maybeSailIds)));
			},
			$author$project$Update$Trips$fetchTrips(model));
	} else {
		return $author$project$Update$addOnboardServicesRequest(model);
	}
};
var $author$project$Utils$Route$isPalStoRoute = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return ((from === 12) && (to === 1)) || ((from === 1) && (to === 12));
};
var $author$project$Update$TravelClass$isSpecialTravelClassRequestSupported = function (session) {
	return !($author$project$Utils$Route$isMugVssRoute(session.kS) || ($author$project$Utils$Route$isPalStoRoute(session) || ((session.kS === 1) && (session.le === 15))));
};
var $author$project$Types$Trips$sailIdsFromStatus = function (status) {
	switch (status.$) {
		case 0:
			var trips = status.a;
			return $elm$core$Maybe$Just(
				$author$project$Types$Trips$sailIds(trips));
		case 2:
			var trips = status.a;
			return A2($elm$core$Maybe$map, $author$project$Types$Trips$sailIds, trips);
		default:
			var trips = status.a;
			return A2($elm$core$Maybe$map, $author$project$Types$Trips$sailIds, trips);
	}
};
var $author$project$Update$TravelClass$vehiclesAndSailsOf = function (session) {
	return {
		F6: $author$project$Types$Trips$sailIdsFromStatus(session.tp),
		tt: A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$SelectedVehicles$selectedVehiclesWithVoyageTypeList,
					$elm$core$List$map(
						function (vehicle) {
							return _Utils_Tuple2(vehicle.jZ, vehicle.tx);
						})),
				session.rp))
	};
};
var $author$project$Update$TravelClass$canRefreshSpecialTravelClasses = function (session) {
	return (!_Utils_eq(
		session.Ij,
		$author$project$Update$TravelClass$vehiclesAndSailsOf(session))) && (session.pr && $author$project$Update$TravelClass$isSpecialTravelClassRequestSupported(session));
};
var $author$project$Messages$GotTravelClasses = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$TravelClass$Special = 1;
var $author$project$Api$TravelClass$Regular = 0;
var $author$project$Api$TravelClass$createQueryParams = F3(
	function (session, _v0, requestType) {
		var outwardSailId = _v0.a;
		var maybeReturnSailId = _v0.b;
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			session.Aa,
			A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$url$Url$Builder$string('voucherId')),
					$elm$core$List$head(session.tw)),
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$elm$url$Url$Builder$string('returnSailId'),
							$elm$core$String$fromInt),
						maybeReturnSailId),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							A2(
								$author$project$Utils$List$maybeAdd,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Util$clubOneLevelParam,
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.pO;
										},
										$author$project$Types$Passenger$findWithHighestLevel(session.Eg))),
								_List_fromArray(
									[
										$author$project$Api$Util$localeParam(session.A_),
										$author$project$Api$Util$marketParam(session.rb),
										$author$project$Api$Util$fromParam(session.kS),
										$author$project$Api$Util$toParam(session.le),
										A2($author$project$Api$Util$voyageTypeParam, session.vk, session.tx),
										$author$project$Api$Util$guidParam(session.zM.Gt)
									]))),
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'includeSharedCabins',
								$author$project$Utils$String$fromBool(!(!requestType))),
								A2(
								$elm$url$Url$Builder$string,
								'outwardSailId',
								$elm$core$String$fromInt(outwardSailId)),
								A2(
								$elm$url$Url$Builder$string,
								'includePetCabins',
								$author$project$Utils$String$fromBool(!(!requestType))),
								A2(
								$elm$url$Url$Builder$string,
								'includeRegularCabins',
								$author$project$Utils$String$fromBool(requestType !== 1)),
								A2(
								$elm$url$Url$Builder$string,
								'includeSpecialCabins',
								$author$project$Utils$String$fromBool(!(!requestType)))
							])))));
	});
var $author$project$Types$TravelClasses$AvailableTravelClasses = F8(
	function (regular, shared, special, petCabins, petCages, petPlace, petInBag, petInCar) {
		return {EB: petCabins, EC: petCages, ED: petInBag, EE: petInCar, r1: petPlace, Fx: regular, kI: shared, GN: special};
	});
var $author$project$Types$TravelClasses$PetCage = 3;
var $author$project$Types$TravelClasses$PetInBag = 0;
var $author$project$Types$TravelClasses$PetInCar = 1;
var $author$project$Types$TravelClasses$PetPlace = 2;
var $author$project$Types$TravelClasses$TravelClass = function (description) {
	return function (gender) {
		return function (imageUrl) {
			return function (images) {
				return function (longDescription) {
					return function (maxOccupancy) {
						return function (name) {
							return function (outwardTravelClass) {
								return function (reserveType) {
									return function (returnTravelClass) {
										return {nt: description, zf: gender, zP: imageUrl, zQ: images, Bx: longDescription, BL: maxOccupancy, oh: name, DA: outwardTravelClass, FC: reserveType, FT: returnTravelClass};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$TravelClasses$Allergy = 1;
var $author$project$Types$TravelClasses$Handicap = 2;
var $author$project$Types$TravelClasses$Pet = 0;
var $author$project$Types$TravelClasses$decodeReserveType = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $elm$core$String$toUpper(string);
		switch (_v0) {
			case 'PET':
				return $elm$json$Json$Decode$succeed(0);
			case 'ALLERGY':
				return $elm$json$Json$Decode$succeed(1);
			case 'HANDICAP':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid ReserveType');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$TravelClasses$TravelClassInfo = function (availability) {
	return function (capacity) {
		return function (maxAvailableCapacity) {
			return function (code) {
				return function (isVoucherApplicable) {
					return function (isVoucherApplicableForPoints) {
						return function (price) {
							return function (pricePerPerson) {
								return function (priceCabinSurcharge) {
									return function (priceUnit) {
										return {uk: availability, vM: capacity, pQ: code, q0: isVoucherApplicable, q1: isVoucherApplicableForPoints, mJ: maxAvailableCapacity, lN: price, jS: priceCabinSurcharge, r6: pricePerPerson, r7: priceUnit};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$TravelClasses$PersonPrice = 1;
var $author$project$Types$TravelClasses$TravelClassPrice = 0;
var $author$project$Types$TravelClasses$decodePriceUnit = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $elm$core$String$toUpper(string);
		switch (_v0) {
			case 'PRICE_PER_TRAVEL_CLASS':
				return $elm$json$Json$Decode$succeed(0);
			case 'PRICE_PER_PERSON':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid PriceUnit');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$TravelClasses$decodeTravelClassInfo = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'priceUnit',
	$author$project$Types$TravelClasses$decodePriceUnit,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'priceCabinSurcharge',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pricePerPerson',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'isVoucherApplicableForPoints',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'isVoucherApplicable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'maxAvailableCapacity',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'capacity',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'availability',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Types$TravelClasses$TravelClassInfo)))))))))));
var $author$project$Types$TravelClasses$decodeTravelClass = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'returnTravelClass',
	$elm$json$Json$Decode$maybe($author$project$Types$TravelClasses$decodeTravelClassInfo),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'reserveType',
		$elm$json$Json$Decode$maybe($author$project$Types$TravelClasses$decodeReserveType),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'outwardTravelClass',
			$elm$json$Json$Decode$maybe($author$project$Types$TravelClasses$decodeTravelClassInfo),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'maxOccupancy',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'longDescription',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'images',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'imageUrl',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'gender',
									$elm$json$Json$Decode$maybe($author$project$Types$Gender$decoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'description',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										$elm$json$Json$Decode$succeed($author$project$Types$TravelClasses$TravelClass)))))))))));
var $author$project$Api$TravelClass$decodeListAt = function (s) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['travelClasses', s]),
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				A2(
					$elm$core$List$foldr,
					F2(
						function (value, travelClasses) {
							return A2(
								$elm$core$Result$withDefault,
								travelClasses,
								A2(
									$elm$core$Result$map,
									function (travelClass) {
										return A2($elm$core$List$cons, travelClass, travelClasses);
									},
									A2($elm$json$Json$Decode$decodeValue, $author$project$Types$TravelClasses$decodeTravelClass, value)));
						}),
					_List_Nil),
				$elm$json$Json$Decode$succeed),
			$elm$json$Json$Decode$list($elm$json$Json$Decode$value)));
};
var $author$project$Types$TravelClasses$PetTravelClass = F6(
	function (description, name, imageUrl, outward, _return, kind) {
		return {nt: description, zP: imageUrl, AM: kind, oh: name, Ds: outward, FL: _return};
	});
var $author$project$Types$TravelClasses$PetTravelClassInfo = F4(
	function (code, price, isVoucherApplicable, isVoucherApplicableForPoints) {
		return {pQ: code, q0: isVoucherApplicable, q1: isVoucherApplicableForPoints, lN: price};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Types$TravelClasses$decodePetTravelClass = function (kind) {
	var decodeInfo = A5(
		$elm$json$Json$Decode$map4,
		$author$project$Types$TravelClasses$PetTravelClassInfo,
		A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'isVoucherApplicable', $elm$json$Json$Decode$bool),
		A2($elm$json$Json$Decode$field, 'isVoucherApplicableForPoints', $elm$json$Json$Decode$bool));
	return A7(
		$elm$json$Json$Decode$map6,
		$author$project$Types$TravelClasses$PetTravelClass,
		A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'imageUrl', $elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$field,
			'outwardTravelClass',
			$elm$json$Json$Decode$maybe(decodeInfo)),
		A2(
			$elm$json$Json$Decode$field,
			'returnTravelClass',
			$elm$json$Json$Decode$maybe(decodeInfo)),
		$elm$json$Json$Decode$succeed(kind));
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Api$TravelClass$decodeAvailableTravelClasses = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Types$TravelClasses$AvailableTravelClasses,
	$author$project$Api$TravelClass$decodeListAt('regular'),
	$author$project$Api$TravelClass$decodeListAt('shared'),
	$author$project$Api$TravelClass$decodeListAt('special'),
	$author$project$Api$TravelClass$decodeListAt('petCabins'),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['travelClasses', 'petCages']),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$index,
				0,
				$author$project$Types$TravelClasses$decodePetTravelClass(3)))),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['travelClasses', 'petPlace']),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$index,
				0,
				$author$project$Types$TravelClasses$decodePetTravelClass(2)))),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['travelClasses', 'petInBag']),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$index,
				0,
				$author$project$Types$TravelClasses$decodePetTravelClass(0)))),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['travelClasses', 'petInCar']),
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$index,
				0,
				$author$project$Types$TravelClasses$decodePetTravelClass(1)))));
var $author$project$Api$Endpoint$travelClasses = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['travelclasses']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.pc));
	});
var $author$project$Api$TravelClass$getTravelClasses = F4(
	function (session, sailIds, requestType, resultToMsg) {
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					resultToMsg,
					A2(
						$elm$json$Json$Decode$map,
						function (b) {
							return _Utils_Tuple2(requestType, b);
						},
						A2(
							$elm$json$Json$Decode$andThen,
							function (value) {
								var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Api$TravelClass$decodeAvailableTravelClasses, value);
								if (!_v0.$) {
									var availableTravelClasses = _v0.a;
									return $elm$json$Json$Decode$succeed(
										{yk: availableTravelClasses, Ib: value});
								} else {
									var error = _v0.a;
									return $elm$json$Json$Decode$fail(
										$elm$json$Json$Decode$errorToString(error));
								}
							},
							$elm$json$Json$Decode$value))),
				jW: A2(
					$author$project$Api$Endpoint$travelClasses,
					session.zM.Gs,
					A3($author$project$Api$TravelClass$createQueryParams, session, sailIds, requestType))
			});
	});
var $author$project$Update$TravelClass$getSpecialTravelClasses = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (sailIds) {
			return A4($author$project$Api$TravelClass$getTravelClasses, model.j, sailIds, 1, $author$project$Messages$GotTravelClasses);
		},
		A2(
			$elm$core$Maybe$map,
			$author$project$Types$Trips$sailIds,
			$author$project$Types$Trips$statusToMaybe(model.j.tp)));
};
var $author$project$Update$addSpecialTravelClassesRequestAfterSummary = F2(
	function (summaryResponse, model) {
		if (!summaryResponse.$) {
			return _Utils_Tuple2(
				model,
				$author$project$Update$TravelClass$canRefreshSpecialTravelClasses(model.j) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					$author$project$Update$TravelClass$getSpecialTravelClasses(model)) : $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$Ticket$areTicketsEqual = F2(
	function (ticketA, ticketB) {
		return _Utils_eq(ticketA.zN, ticketB.zN) && (_Utils_eq(ticketA.m4, ticketB.m4) && _Utils_eq(ticketA.oh, ticketB.oh));
	});
var $author$project$Session$addToTicketCount = function (ticket) {
	return $elm$core$List$map(
		function (pair) {
			return A2($author$project$Types$Ticket$areTicketsEqual, pair.b, ticket) ? A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Basics$add(1),
				pair) : pair;
		});
};
var $author$project$Types$LandService$maxTicketCount = 24;
var $author$project$Types$LandService$getTicketsFromEvent = function (_v0) {
	var ticketGroups = _v0.Hu;
	var ticketsWithoutGroup = _v0.Hw;
	return _Utils_ap(
		ticketsWithoutGroup,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.Hv;
				},
				ticketGroups)));
};
var $author$project$Session$isEventWithTicket = function (ticket) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$LandService$getTicketsFromEvent,
		$elm$core$List$any(
			$author$project$Types$Ticket$areTicketsEqual(ticket)));
};
var $author$project$Types$LandService$getTickets = function (landService) {
	var _v0 = landService.mq;
	var x = _v0.a;
	var xs = _v0.b;
	return _Utils_ap(
		$author$project$Types$LandService$getTicketsFromEvent(x),
		A2($elm$core$List$concatMap, $author$project$Types$LandService$getTicketsFromEvent, xs));
};
var $author$project$Session$isLandServiceWithTicket = function (ticket) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$LandService$getTickets,
		$elm$core$List$any(
			$author$project$Types$Ticket$areTicketsEqual(ticket)));
};
var $author$project$Session$removeTicketsFromOtherEventsForService = F2(
	function (ticket, session) {
		var ticketsFromOtherEvents = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$concatMap($author$project$Types$LandService$getTicketsFromEvent),
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var x = _v1.a;
						var xs = _v1.b;
						return A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								$author$project$Session$isEventWithTicket(ticket)),
							A2($elm$core$List$cons, x, xs));
					},
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.mq;
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							$author$project$Session$isLandServiceWithTicket(ticket),
							A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, session.AZ))))));
		return _Utils_update(
			session,
			{
				Gl: A2(
					$elm$core$List$filter,
					function (_v0) {
						var a = _v0.b;
						return !A2($elm$core$List$member, a, ticketsFromOtherEvents);
					},
					session.Gl)
			});
	});
var $author$project$Session$addTicket = F2(
	function (session, ticket) {
		return A2(
			$author$project$Session$removeTicketsFromOtherEventsForService,
			ticket,
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_update(
					session,
					{
						Gl: A2(
							$elm$core$List$cons,
							_Utils_Tuple2(1, ticket),
							session.Gl)
					}),
				A2(
					$elm$core$Maybe$map,
					function (pair) {
						return _Utils_eq(pair.a, $author$project$Types$LandService$maxTicketCount) ? session : _Utils_update(
							session,
							{
								Gl: A2($author$project$Session$addToTicketCount, ticket, session.Gl)
							});
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							$author$project$Types$Ticket$areTicketsEqual(ticket)),
						session.Gl))));
	});
var $author$project$Session$addTicketWithAddonCode = F2(
	function (code, session) {
		return A2(
			$elm$core$Maybe$withDefault,
			session,
			A2(
				$elm$core$Maybe$map,
				$author$project$Session$addTicket(session),
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.zN;
						},
						$elm$core$Basics$eq(code)),
					A2(
						$elm$core$List$concatMap,
						$author$project$Types$LandService$getTickets,
						A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, session.AZ)))));
	});
var $author$project$Update$Util$andThenIf = F3(
	function (predicate, update, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return predicate ? A2(
			$author$project$Update$Util$andThen,
			update,
			_Utils_Tuple2(model, cmd)) : _Utils_Tuple2(model, cmd);
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $author$project$UrlRoute$back = function (navKey) {
	if (!navKey.$) {
		var key = navKey.a;
		return A2($elm$browser$Browser$Navigation$back, key, 1);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Types$AgeCategory$compare = F2(
	function (a, b) {
		var toInt = function (ageCategory) {
			switch (ageCategory) {
				case 0:
					return 3;
				case 1:
					return 2;
				case 3:
					return 1;
				default:
					return 0;
			}
		};
		return A2(
			$elm$core$Basics$compare,
			toInt(a),
			toInt(b));
	});
var $author$project$Types$Passenger$getUniqueAgeCategories = function (passengers) {
	return A2(
		$elm$core$List$sortWith,
		$author$project$Types$AgeCategory$compare,
		A3(
			$elm$core$Array$foldl,
			F2(
				function (_v0, accumulator) {
					var ageCategory = _v0.tY;
					return A2($elm$core$List$member, ageCategory, accumulator) ? accumulator : A2($elm$core$List$cons, ageCategory, accumulator);
				}),
			_List_Nil,
			passengers));
};
var $author$project$Utils$Route$isStoHelRoute = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return ((from === 1) && (to === 2)) || ((from === 2) && (to === 1));
};
var $author$project$Update$cancelServicesRequestIfAgeCategoriesChangedOnStoHelRoute = F2(
	function (oldModel, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return ((!_Utils_eq(
			$author$project$Types$Passenger$getUniqueAgeCategories(oldModel.j.Eg),
			$author$project$Types$Passenger$getUniqueAgeCategories(model.j.Eg))) && $author$project$Utils$Route$isStoHelRoute(model.j)) ? _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$Api$Endpoint$cancel($author$project$Api$Endpoint$trackers.rI)
					]))) : _Utils_Tuple2(model, cmd);
	});
var $author$project$Types$SelectedVehicles$SelectedVehicles = $elm$core$Basics$identity;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$Types$SelectedVehicles$maxLicensePlateLength = 20;
var $author$project$Types$SelectedVehicles$transformLicensePlateInput = A2(
	$elm$core$Basics$composeL,
	$elm$core$String$toUpper,
	$elm$core$String$left($author$project$Types$SelectedVehicles$maxLicensePlateLength));
var $author$project$Types$SelectedVehicles$updateSelectedVehicleLicensePlate = F3(
	function (licensePlateString, licensePlateType, selectedVehicle) {
		var newLicensePlate = $author$project$Types$SelectedVehicles$transformLicensePlateInput(licensePlateString);
		if (!licensePlateType) {
			return _Utils_update(
				selectedVehicle,
				{
					Aj: true,
					n_: $elm$core$Maybe$Just(newLicensePlate)
				});
		} else {
			return _Utils_update(
				selectedVehicle,
				{
					Aj: true,
					n$: $elm$core$Maybe$Just(newLicensePlate)
				});
		}
	});
var $author$project$Types$SelectedVehicles$changeLicensePlate = F4(
	function (index, licensePlateType, licensePlateString, _v0) {
		var first = _v0.nx;
		var others = _v0.lH;
		return (!index) ? {
			nx: A3($author$project$Types$SelectedVehicles$updateSelectedVehicleLicensePlate, licensePlateString, licensePlateType, first),
			lH: others
		} : A2(
			$elm$core$Maybe$withDefault,
			{nx: first, lH: others},
			A2(
				$elm$core$Maybe$map,
				function (selectedVehicle) {
					return A3(
						$elm$core$Basics$composeR,
						A2(
							$elm$core$Array$set,
							index - 1,
							A3($author$project$Types$SelectedVehicles$updateSelectedVehicleLicensePlate, licensePlateString, licensePlateType, selectedVehicle)),
						function (newOthers) {
							return {nx: first, lH: newOthers};
						},
						others);
				},
				A2($elm$core$Array$get, index - 1, others)));
	});
var $author$project$Types$SelectedVehicles$maybeEmptyStringToNothing = function (maybeString) {
	if ((!maybeString.$) && (maybeString.a === '')) {
		return $elm$core$Maybe$Nothing;
	} else {
		return maybeString;
	}
};
var $author$project$Types$SelectedVehicles$licensePlateRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[^0-9A-ZÖÄÅ]'));
var $author$project$Types$SelectedVehicles$sanitizeLicensePlateInput = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$regex$Regex$replace,
		$author$project$Types$SelectedVehicles$licensePlateRegex,
		function (_v0) {
			return '';
		}),
	$author$project$Types$SelectedVehicles$transformLicensePlateInput);
var $author$project$Types$SelectedVehicles$sanitizeSelectedVehicleLicensePlates = function (selectedVehicle) {
	return _Utils_update(
		selectedVehicle,
		{
			n_: $author$project$Types$SelectedVehicles$maybeEmptyStringToNothing(
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$sanitizeLicensePlateInput, selectedVehicle.n_)),
			n$: $author$project$Types$SelectedVehicles$maybeEmptyStringToNothing(
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$sanitizeLicensePlateInput, selectedVehicle.n$))
		});
};
var $author$project$Types$SelectedVehicles$sanitizeLicensePlates = function (_v0) {
	var first = _v0.nx;
	var others = _v0.lH;
	return {
		nx: $author$project$Types$SelectedVehicles$sanitizeSelectedVehicleLicensePlates(first),
		lH: A2($elm$core$Array$map, $author$project$Types$SelectedVehicles$sanitizeSelectedVehicleLicensePlates, others)
	};
};
var $author$project$Update$Vehicles$setSelectedVehiclesToSession = F2(
	function (session, selectedVehicles) {
		return _Utils_update(
			session,
			{
				yq: A2(
					$elm$core$List$map,
					function (selectedVehicle) {
						return session.qW ? _Utils_update(
							selectedVehicle,
							{
								tx: $elm$core$Maybe$Just(0)
							}) : selectedVehicle;
					},
					$author$project$Types$SelectedVehicles$toList(
						$author$project$Types$SelectedVehicles$sanitizeLicensePlates(selectedVehicles))),
				rp: $elm$core$Maybe$Just(selectedVehicles)
			});
	});
var $author$project$Update$Vehicles$changeLicensePlate = F4(
	function (model, index, licensePlateType, licensePlateString) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A3($author$project$Types$SelectedVehicles$changeLicensePlate, index, licensePlateType, licensePlateString),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Update$Vehicles$setSelectedVehiclesToSession(model.j),
						function (newSession) {
							return _Utils_update(
								model,
								{j: newSession});
						})),
				model.j.rp));
	});
var $author$project$Types$SelectedVehicles$fromList = function (selectedVehicleList) {
	if (selectedVehicleList.b) {
		var first = selectedVehicleList.a;
		var others = selectedVehicleList.b;
		return $elm$core$Maybe$Just(
			{
				nx: first,
				lH: $elm$core$Array$fromList(others)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$SelectedVehicles$removeVehiclesWithoutSelectedLegs = function (selectedVehicles) {
	return $author$project$Types$SelectedVehicles$fromList(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tx;
				},
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			$author$project$Types$SelectedVehicles$toList(selectedVehicles)));
};
var $author$project$Update$cleanVehiclesInModel = function (model) {
	var _v0 = model;
	var session = _v0.j;
	var vehiclePage = _v0.Ih;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{
					yq: A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.tx;
							},
							$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
						session.yq),
					rp: A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Types$SelectedVehicles$sanitizeLicensePlates, $author$project$Types$SelectedVehicles$removeVehiclesWithoutSelectedLegs),
						session.rp)
				}),
			Ih: _Utils_update(
				vehiclePage,
				{ty: false})
		});
};
var $author$project$Types$Validation$Util$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{vO: true, CE: false},
		'^[_a-z0-9+-]+(\\.[_a-z0-9+-]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,})$'));
var $author$project$Types$Validation$Util$maxEmailLength = 80;
var $author$project$Types$Validation$Util$isEmailValid = function (email) {
	return A2($elm$regex$Regex$contains, $author$project$Types$Validation$Util$emailRegex, email) && (_Utils_cmp(
		$elm$core$String$length(email),
		$author$project$Types$Validation$Util$maxEmailLength) < 1);
};
var $author$project$Types$Market$enum = function () {
	var nextMarket = function (market) {
		switch (market) {
			case 0:
				return $elm$core$Maybe$Just(1);
			case 1:
				return $elm$core$Maybe$Just(2);
			case 2:
				return $elm$core$Maybe$Just(3);
			case 3:
				return $elm$core$Maybe$Just(4);
			case 4:
				return $elm$core$Maybe$Just(5);
			case 5:
				return $elm$core$Maybe$Just(6);
			case 6:
				return $elm$core$Maybe$Just(7);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var enumerate = F2(
		function (toNext, value) {
			var _v0 = toNext(value);
			if (!_v0.$) {
				var next = _v0.a;
				return A2(
					$elm$core$List$cons,
					value,
					A2(enumerate, toNext, next));
			} else {
				return _List_fromArray(
					[value]);
			}
		});
	return A2(enumerate, nextMarket, 0);
}();
var $author$project$Types$Phone$getInfo = function (market) {
	switch (market) {
		case 0:
			return {pQ: '+372', BM: 10, Cx: 5, EF: '5500000'};
		case 1:
			return {pQ: '+358', BM: 10, Cx: 5, EF: '501234567'};
		case 2:
			return {pQ: '+371', BM: 10, Cx: 5, EF: '23456789'};
		case 3:
			return {pQ: '+47', BM: 11, Cx: 8, EF: '90123456'};
		case 4:
			return {pQ: '+46', BM: 12, Cx: 7, EF: '701234567'};
		case 5:
			return {pQ: '+', BM: 20, Cx: 6, EF: '400346544'};
		case 6:
			return {pQ: '+49', BM: 12, Cx: 5, EF: '61234567'};
		default:
			return {pQ: '+45', BM: 12, Cx: 7, EF: '701234567'};
	}
};
var $author$project$Types$Phone$getNumberWithoutCountryCode = F2(
	function (countryCode, phoneNumber) {
		var countryCodeLength = $elm$core$String$length(countryCode);
		return A2($elm$core$String$contains, countryCode, phoneNumber) ? A2($elm$core$String$dropLeft, countryCodeLength, phoneNumber) : phoneNumber;
	});
var $author$project$Types$Phone$isNumberLengthValid = F2(
	function (countryCode, phoneNumber) {
		var phoneNumberLength = $elm$core$String$length(
			A2($author$project$Types$Phone$getNumberWithoutCountryCode, countryCode, phoneNumber));
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (phone) {
					return (_Utils_cmp(phoneNumberLength, phone.Cx) > -1) && (_Utils_cmp(phoneNumberLength, phone.BM) < 1);
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(countryCode)),
					A2($elm$core$List$map, $author$project$Types$Phone$getInfo, $author$project$Types$Market$enum))));
	});
var $author$project$Types$Phone$isNumberValid = F2(
	function (phoneNumber, countryCode) {
		return (!$elm$core$String$isEmpty(phoneNumber)) && (A2($author$project$Types$Phone$isNumberLengthValid, countryCode, phoneNumber) && A2(
			$elm$regex$Regex$contains,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^[0-9]*$')),
			phoneNumber));
	});
var $author$project$Constants$seawareChars = 'a-zöäüõžšŠåąčęėįšųūžāčēģīķļņūžōŗéáàë';
var $author$project$Utils$String$isSeawareCharsOnly = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{vO: true, CE: false},
			'^[' + ($author$project$Constants$seawareChars + ' -]*$'))));
var $author$project$Utils$String$isSeawareCharsOnlyAndWithoutUnwantedSymbols = function (input) {
	return $author$project$Utils$String$isSeawareCharsOnly(input) && A2(
		$elm$regex$Regex$contains,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{vO: true, CE: false},
				'^.*[^-\\s]$')),
		input);
};
var $author$project$Types$Validation$Util$isDigit = function (input) {
	return A2($elm$core$String$all, $elm$core$Char$isDigit, input);
};
var $author$project$ContactPersonPage$Util$maxZipCodeLength = 7;
var $author$project$ContactPersonPage$Util$minZipCodeLength = 5;
var $author$project$ContactPersonPage$Util$isZipCodeValid = function (input) {
	var inputLength = $elm$core$String$length(input);
	return $author$project$Types$Validation$Util$isDigit(input) && ((_Utils_cmp(inputLength, $author$project$ContactPersonPage$Util$minZipCodeLength) > -1) && (_Utils_cmp(inputLength, $author$project$ContactPersonPage$Util$maxZipCodeLength) < 1));
};
var $author$project$ContactPersonPage$Util$removeCountryCode = F2(
	function (currentCountryCode, phoneNumber) {
		var countryCodeLength = $elm$core$String$length(currentCountryCode);
		return A2($elm$core$String$startsWith, currentCountryCode, phoneNumber) ? A2($elm$core$String$dropLeft, countryCodeLength, phoneNumber) : phoneNumber;
	});
var $author$project$ContactPersonPage$Model$isAllDataValid = F2(
	function (model, market) {
		var phoneNumberWithoutCountryCode = A2($author$project$ContactPersonPage$Util$removeCountryCode, model.p$, model.ox);
		return $author$project$Utils$String$isSeawareCharsOnlyAndWithoutUnwantedSymbols(model.y2) && ($author$project$Utils$String$isSeawareCharsOnlyAndWithoutUnwantedSymbols(model.A6) && ($author$project$Types$Validation$Util$isEmailValid(model.yI) && (A2($author$project$Types$Phone$isNumberValid, phoneNumberWithoutCountryCode, model.p$) && (((market === 4) && $author$project$ContactPersonPage$Util$isZipCodeValid(model.jX)) || (market !== 4)))));
	});
var $author$project$ContactPersonPage$Model$isSomeDataEmpty = F2(
	function (_v0, market) {
		var firstName = _v0.y2;
		var lastName = _v0.A6;
		var email = _v0.yI;
		var phone = _v0.ox;
		var zip = _v0.jX;
		return A2(
			$elm$core$List$any,
			$elm$core$String$isEmpty,
			_Utils_ap(
				_List_fromArray(
					[firstName, lastName, email, phone]),
				(market === 4) ? _List_fromArray(
					[zip]) : _List_Nil));
	});
var $author$project$Utils$String$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Types$SelectedVehicle$encoder = function (vehicle) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(
					$author$project$Types$Vehicle$carCategoryToString(vehicle.jZ))),
				_Utils_Tuple2(
				'licensePlate',
				A2($author$project$Utils$String$maybe, $elm$json$Json$Encode$string, vehicle.n_)),
				_Utils_Tuple2(
				'licensePlateTrailer',
				A2($author$project$Utils$String$maybe, $elm$json$Json$Encode$string, vehicle.n$)),
				_Utils_Tuple2(
				'voyageType',
				$elm$json$Json$Encode$string(
					$author$project$Types$Vehicle$vehicleVoyageTypeToString(vehicle.tx)))
			]));
};
var $author$project$Types$SelectedVehicles$firstValidForSaving = function (selectedVehicles) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.n_;
			},
			$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
		$author$project$Types$SelectedVehicles$toList(selectedVehicles));
};
var $author$project$Utils$String$isBlank = $elm$regex$Regex$contains(
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('^\\s*$')));
var $author$project$Common$Ports$saveFirstVehicleToLocalStorage = _Platform_outgoingPort('saveFirstVehicleToLocalStorage', $elm$core$Basics$identity);
var $author$project$Types$ContactPerson$ContactPerson = F5(
	function (email, firstName, lastName, phone, zip) {
		return {yI: email, y2: firstName, A6: lastName, ox: phone, jX: zip};
	});
var $author$project$ContactPersonPage$Model$toContactPerson = function (model) {
	return A5($author$project$Types$ContactPerson$ContactPerson, model.yI, model.y2, model.A6, model.ox, model.jX);
};
var $author$project$Types$Passenger$areNamesEqualIgnoringCapitalization = F2(
	function (record, passenger2) {
		return _Utils_eq(
			$elm$core$String$toLower(record.y2),
			$elm$core$String$toLower(passenger2.y2));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$ContactPersonPage$Update$hasPassengerFirstAndLastName = F2(
	function (firstName, lastName) {
		return (!$elm$core$String$isEmpty(firstName)) && (!$elm$core$String$isEmpty(lastName));
	});
var $author$project$ContactPersonPage$Update$isFirstPassengerNotContactPerson = F3(
	function (passengersList, firstName, lastName) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (passenger) {
					return ((!_Utils_eq(
						$elm$core$String$toLower(passenger.y2),
						$elm$core$String$toLower(firstName))) && (!$elm$core$String$isEmpty(passenger.y2))) || ((!_Utils_eq(
						$elm$core$String$toLower(passenger.A6),
						$elm$core$String$toLower(lastName))) && (!$elm$core$String$isEmpty(passenger.A6)));
				},
				$elm$core$List$head(passengersList)));
	});
var $author$project$ContactPersonPage$Update$updatePassenger = F3(
	function (model, contactPerson, passenger) {
		var adjustedPhoneNumber = A2($elm$core$String$contains, model.p$, model.ox) ? model.ox : _Utils_ap(model.p$, model.ox);
		return (_Utils_eq(passenger.y2, contactPerson.y2) && _Utils_eq(passenger.A6, contactPerson.A6)) ? _Utils_update(
			passenger,
			{
				yI: $elm$core$Maybe$Just(model.yI),
				y2: model.y2,
				A6: model.A6,
				ox: $elm$core$Maybe$Just(adjustedPhoneNumber),
				jX: $elm$core$Maybe$Just(model.jX)
			}) : passenger;
	});
var $author$project$ContactPersonPage$Update$updatePassengersList = F2(
	function (model, passengers) {
		var maybeContactPerson = A2(
			$elm_community$list_extra$List$Extra$find,
			$author$project$Types$Passenger$areNamesEqualIgnoringCapitalization(model),
			passengers);
		if (!maybeContactPerson.$) {
			var contactPerson = maybeContactPerson.a;
			return A2(
				$elm$core$List$map,
				A2($author$project$ContactPersonPage$Update$updatePassenger, model, contactPerson),
				passengers);
		} else {
			var firstPassenger = $elm$core$List$head(passengers);
			if (!firstPassenger.$) {
				var contactPerson = firstPassenger.a;
				if (A3($author$project$ContactPersonPage$Update$isFirstPassengerNotContactPerson, passengers, model.y2, model.A6) && A2($author$project$ContactPersonPage$Update$hasPassengerFirstAndLastName, model.y2, model.A6)) {
					return passengers;
				} else {
					var passengersWithoutFirst = A2($elm$core$List$drop, 1, passengers);
					return $elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (passenger) {
								return A2(
									$elm$core$List$cons,
									A3($author$project$ContactPersonPage$Update$updatePassenger, model, contactPerson, passenger),
									passengersWithoutFirst);
							},
							A2($elm$core$List$take, 1, passengers)));
				}
			} else {
				return passengers;
			}
		}
	});
var $author$project$ContactPersonPage$Update$save = F2(
	function (session, pageModel) {
		var saveFirstVehicleToLocalStorageIfNeeded = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$SelectedVehicles$firstValidForSaving,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function (a) {
								return _Utils_update(
									a,
									{
										tx: $elm$core$Maybe$Just(0)
									});
							},
							A2($elm$core$Basics$composeR, $author$project$Types$SelectedVehicle$encoder, $author$project$Common$Ports$saveFirstVehicleToLocalStorage)))),
				session.rp));
		var phoneNumberWithoutCountryCode = A2($author$project$ContactPersonPage$Util$removeCountryCode, pageModel.p$, pageModel.ox);
		var updatedPageModel = $author$project$Utils$String$isBlank(phoneNumberWithoutCountryCode) ? _Utils_update(
			pageModel,
			{ox: ''}) : _Utils_update(
			pageModel,
			{
				ox: _Utils_ap(pageModel.p$, phoneNumberWithoutCountryCode)
			});
		var hasNoAgent = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tZ;
					},
					$elm$core$Maybe$map(
						$elm$core$Basics$always(false))),
				session.xA));
		var passengersList = hasNoAgent ? A2(
			$author$project$ContactPersonPage$Update$updatePassengersList,
			updatedPageModel,
			$elm$core$Array$toList(session.Eg)) : $elm$core$Array$toList(session.Eg);
		var contactPerson = $author$project$ContactPersonPage$Model$toContactPerson(updatedPageModel);
		return _Utils_Tuple2(
			_Utils_update(
				session,
				{
					BQ: $elm$core$Maybe$Just(contactPerson),
					Eg: $elm$core$Array$fromList(passengersList)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						saveFirstVehicleToLocalStorageIfNeeded,
						$author$project$Api$Endpoint$cancel($author$project$Api$Endpoint$trackers.q4)
					])));
	});
var $author$project$ContactPersonPage$Update$exit = F2(
	function (session, pageModel) {
		return (A2($author$project$ContactPersonPage$Model$isAllDataValid, pageModel, session.rb) && (!A2($author$project$ContactPersonPage$Model$isSomeDataEmpty, pageModel, session.rb))) ? A2($author$project$ContactPersonPage$Update$save, session, pageModel) : _Utils_Tuple2(session, $elm$core$Platform$Cmd$none);
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$MealPage$Common$isCommentValid = function (string) {
	var commentAllowedCharsRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{vO: true, CE: false},
			'^[' + ($author$project$Constants$seawareChars + '0-9_.,!?:\\s]*$')));
	return A2($elm$regex$Regex$contains, commentAllowedCharsRegex, string);
};
var $author$project$MealPage$Update$findMealsFromSitting = F2(
	function (selectedMeals, sitting) {
		return A2(
			$elm$core$List$filter,
			$author$project$Types$Meals$isSameSitting(sitting),
			selectedMeals);
	});
var $author$project$MealPage$Update$areMealsInSitting = F2(
	function (a, b) {
		return !$elm$core$List$isEmpty(
			A2($author$project$MealPage$Update$findMealsFromSitting, a, b));
	});
var $author$project$MealPage$Update$setComment = F2(
	function (comment, meal) {
		return _Utils_update(
			meal,
			{wo: comment});
	});
var $author$project$MealPage$Update$saveComment = F3(
	function (comment, sitting, selected) {
		var breakfast = selected.vu;
		var brunch = selected.vx;
		var lunch = selected.Bz;
		var dinner = selected.yw;
		return A2($author$project$MealPage$Update$areMealsInSitting, breakfast, sitting) ? _Utils_update(
			selected,
			{
				vu: A2(
					$elm$core$List$map,
					$author$project$MealPage$Update$setComment(comment),
					A2($author$project$MealPage$Update$findMealsFromSitting, breakfast, sitting))
			}) : (A2($author$project$MealPage$Update$areMealsInSitting, brunch, sitting) ? _Utils_update(
			selected,
			{
				vx: A2(
					$elm$core$List$map,
					$author$project$MealPage$Update$setComment(comment),
					A2($author$project$MealPage$Update$findMealsFromSitting, brunch, sitting))
			}) : (A2($author$project$MealPage$Update$areMealsInSitting, lunch, sitting) ? _Utils_update(
			selected,
			{
				Bz: A2(
					$elm$core$List$map,
					$author$project$MealPage$Update$setComment(comment),
					A2($author$project$MealPage$Update$findMealsFromSitting, lunch, sitting))
			}) : (A2($author$project$MealPage$Update$areMealsInSitting, dinner, sitting) ? _Utils_update(
			selected,
			{
				yw: A2(
					$elm$core$List$map,
					$author$project$MealPage$Update$setComment(comment),
					A2($author$project$MealPage$Update$findMealsFromSitting, dinner, sitting))
			}) : selected)));
	});
var $author$project$MealPage$Update$exit = F2(
	function (session, model) {
		var maybeSaveComment = F3(
			function (toMaybeSitting, menu, selectedMeals) {
				var _v1 = toMaybeSitting(menu);
				if (!_v1.$) {
					var sitting = _v1.a;
					return A3($author$project$MealPage$Update$saveComment, menu.wo, sitting, selectedMeals);
				} else {
					return selectedMeals;
				}
			});
		var filteredModel = A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, v) {
					return $author$project$MealPage$Common$isCommentValid(v.wo);
				}),
			model);
		var updateSelectedMeals = F2(
			function (toMaybeSitting, selectedMeals) {
				return A3(
					$elm$core$Dict$foldl,
					$elm$core$Basics$always(
						maybeSaveComment(toMaybeSitting)),
					selectedMeals,
					filteredModel);
			});
		return _Utils_update(
			session,
			{
				Gn: A2(
					updateSelectedMeals,
					function ($) {
						return $.BY;
					},
					session.Gn),
				Go: A2(
					updateSelectedMeals,
					function ($) {
						return $.B$;
					},
					session.Go)
			});
	});
var $author$project$Types$Company$Company = F2(
	function (details, agent) {
		return {tZ: agent, yt: details};
	});
var $author$project$Types$JoinClubOneState$NotJoining = {$: 0};
var $author$project$Types$Client$getAffiliateIds = function (client) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tX;
				},
				$elm$core$List$map(
					function ($) {
						return $.v5;
					})),
			client.BP));
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $author$project$Session$isAnAffiliate = F2(
	function (client, clientId) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$Client$getAffiliateIds,
					$elm$core$List$any(
						$elm$core$Basics$eq(clientId))),
				$krisajenkins$remotedata$RemoteData$toMaybe(client)));
	});
var $author$project$Session$passengersWithoutAffiliates = F2(
	function (client, passengers) {
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (passenger, newPassengers) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2($elm$core$Array$push, passenger, newPassengers),
						A2(
							$elm$core$Maybe$map,
							function (clientId) {
								return A2($author$project$Session$isAnAffiliate, client, clientId) ? newPassengers : A2($elm$core$Array$push, passenger, newPassengers);
							},
							passenger.v5));
				}),
			$elm$core$Array$empty,
			passengers);
	});
var $author$project$Session$removeAffiliatesFromPassengers = function (session) {
	return _Utils_update(
		session,
		{
			Eg: A2($author$project$Session$passengersWithoutAffiliates, session.Ia.v4, session.Eg)
		});
};
var $author$project$Page$Company$exit = F2(
	function (session, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			session,
			A2(
				$elm$core$Maybe$map,
				function (company) {
					return $author$project$Session$removeAffiliatesFromPassengers(
						_Utils_update(
							session,
							{
								xA: $elm$core$Maybe$Just(company),
								AE: $author$project$Types$JoinClubOneState$NotJoining
							}));
				},
				function () {
					if (!model.$) {
						var details = model.a.yt;
						return A2(
							$elm$core$Maybe$andThen,
							function (a) {
								return (a.mw || a.qR) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2($author$project$Types$Company$Company, a, $elm$core$Maybe$Nothing));
							},
							$krisajenkins$remotedata$RemoteData$toMaybe(details));
					} else {
						var details = model.a.yt;
						var agent = model.a.tZ;
						return (details.mw && (!$krisajenkins$remotedata$RemoteData$isSuccess(agent))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								$author$project$Types$Company$Company,
								details,
								$krisajenkins$remotedata$RemoteData$toMaybe(agent)));
					}
				}()));
	});
var $author$project$PassengerDetailsPage$Model$exit = F2(
	function (a, _v0) {
		return _Utils_Tuple2(
			a,
			$author$project$Api$Endpoint$cancel($author$project$Api$Endpoint$trackers.pN));
	});
var $author$project$UrlRoute$isBusTransferRoute = function (route) {
	return _Utils_eq(route, $author$project$UrlRoute$BusTransfer) || _Utils_eq(route, $author$project$UrlRoute$BusTransferList);
};
var $author$project$Types$Bus$SelectedTransfers$SelectedBusTransfers = $elm$core$Basics$identity;
var $author$project$Types$Bus$SelectedTransfers$fromArray = function (array) {
	var _v0 = $elm$core$Array$toList(array);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = _v0.a;
		var others = _v0.b;
		return $elm$core$Maybe$Just(
			{
				nx: first,
				lH: $elm$core$Array$fromList(others)
			});
	}
};
var $author$project$Types$Bus$AgeGroup$sumAgeGroupCounts = function (_v0) {
	var adults = _v0.pn;
	var underages = _v0.H4;
	var infants = _v0.zV;
	return (adults + underages) + infants;
};
var $author$project$Types$Bus$SelectedTransferPair$hasPassengers = function (_v0) {
	var _v1 = _v0;
	var maybeOutward = _v1.a;
	var maybeReturn = _v1.b;
	var hasPassengersInOneDirection = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.po;
		},
		A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Bus$AgeGroup$sumAgeGroupCounts,
			$elm$core$Basics$neq(0)));
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, hasPassengersInOneDirection, maybeReturn)) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, hasPassengersInOneDirection, maybeOutward));
};
var $author$project$Types$Bus$AgeGroup$AgeGroupCounts = F3(
	function (adults, underages, infants) {
		return {pn: adults, zV: infants, H4: underages};
	});
var $author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups = function (passengers) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (passenger, counts) {
				var _v0 = passenger.tY;
				switch (_v0) {
					case 0:
						return _Utils_update(
							counts,
							{pn: counts.pn + 1});
					case 1:
						return _Utils_update(
							counts,
							{pn: counts.pn + 1});
					case 3:
						return _Utils_update(
							counts,
							{H4: counts.H4 + 1});
					default:
						return _Utils_update(
							counts,
							{zV: counts.zV + 1});
				}
			}),
		A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, 0),
		passengers);
};
var $author$project$Types$Bus$SelectedTransferPair$SelectedBusTransferPair = $elm$core$Basics$identity;
var $author$project$Types$Bus$AgeGroup$hasAdultPassengers = function (_v0) {
	var ageGroupCounts = _v0.po;
	return ageGroupCounts.pn > 0;
};
var $author$project$Types$Bus$AgeGroup$initAgeGroupCountsIfNoAdults = function (recordWithAgeGroupCounts) {
	return (!$author$project$Types$Bus$AgeGroup$hasAdultPassengers(recordWithAgeGroupCounts)) ? _Utils_update(
		recordWithAgeGroupCounts,
		{
			po: A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, 0)
		}) : recordWithAgeGroupCounts;
};
var $author$project$Types$Bus$SelectedTransferPair$mapBothTupleValues = F2(
	function (func, tuple) {
		return A2(
			$elm$core$Tuple$mapSecond,
			func,
			A2($elm$core$Tuple$mapFirst, func, tuple));
	});
var $author$project$Types$Bus$SelectedTransferPair$maybeInitSelectedBusTransferPair = function (_v0) {
	var maybeOutward = _v0.a;
	var maybeReturn = _v0.b;
	return ((!_Utils_eq(maybeReturn, $elm$core$Maybe$Nothing)) || (!_Utils_eq(maybeOutward, $elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Just(
		A2(
			$author$project$Types$Bus$SelectedTransferPair$mapBothTupleValues,
			$elm$core$Maybe$map($author$project$Types$Bus$AgeGroup$initAgeGroupCountsIfNoAdults),
			_Utils_Tuple2(maybeOutward, maybeReturn))) : $elm$core$Maybe$Nothing;
};
var $author$project$Types$Bus$AgeGroup$addPassengerCounts = F2(
	function (first, second) {
		return {pn: first.pn + second.pn, zV: first.zV + second.zV, H4: first.H4 + second.H4};
	});
var $author$project$Types$Bus$AgeGroup$turnValuesIntoZeroWhen = F2(
	function (_v0, foo) {
		var adults = _v0.pn;
		var underages = _v0.H4;
		var infants = _v0.zV;
		var toZeroIfNeeded = function (_int) {
			return foo(_int) ? 0 : _int;
		};
		return A3(
			$author$project$Types$Bus$AgeGroup$AgeGroupCounts,
			toZeroIfNeeded(adults),
			toZeroIfNeeded(underages),
			toZeroIfNeeded(infants));
	});
var $author$project$Types$Bus$AgeGroup$removeNegativeValues = function (ageGroupCounts) {
	return A2(
		$author$project$Types$Bus$AgeGroup$turnValuesIntoZeroWhen,
		ageGroupCounts,
		$elm$core$Basics$gt(0));
};
var $author$project$Types$Bus$AgeGroup$removePositiveValues = function (ageGroupCounts) {
	return A2(
		$author$project$Types$Bus$AgeGroup$turnValuesIntoZeroWhen,
		ageGroupCounts,
		$elm$core$Basics$lt(0));
};
var $author$project$Types$Bus$AgeGroup$removeAgeGroupCountsWithDiffs = F2(
	function (ageGroupCountsDiff, recordWithAgeGroupCounts) {
		var newAgeGroupCounts = A2($author$project$Types$Bus$AgeGroup$addPassengerCounts, recordWithAgeGroupCounts.po, ageGroupCountsDiff);
		return _Utils_Tuple2(
			$author$project$Types$Bus$AgeGroup$initAgeGroupCountsIfNoAdults(
				_Utils_update(
					recordWithAgeGroupCounts,
					{
						po: $author$project$Types$Bus$AgeGroup$removeNegativeValues(newAgeGroupCounts)
					})),
			$author$project$Types$Bus$AgeGroup$removePositiveValues(newAgeGroupCounts));
	});
var $author$project$Types$Bus$SelectedTransfers$removeDiffsFromTransfer = F2(
	function (selectedBusTransferPair, _v0) {
		var selectedBusTransferArray = _v0.a;
		var _v1 = _v0.b;
		var outwardCountsDiff = _v1.a;
		var returnCountsDiff = _v1.b;
		var _v2 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, returnCountsDiff),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$Bus$AgeGroup$removeAgeGroupCountsWithDiffs(returnCountsDiff),
					$elm$core$Tuple$mapFirst($elm$core$Maybe$Just)),
				$author$project$Types$Bus$SelectedTransferPair$selectedReturn(selectedBusTransferPair)));
		var maybeNewReturn = _v2.a;
		var newReturnCountsDiff = _v2.b;
		var _v3 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, outwardCountsDiff),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$Bus$AgeGroup$removeAgeGroupCountsWithDiffs(outwardCountsDiff),
					$elm$core$Tuple$mapFirst($elm$core$Maybe$Just)),
				$author$project$Types$Bus$SelectedTransferPair$selectedOutward(selectedBusTransferPair)));
		var maybeNewOutward = _v3.a;
		var newOutwardCountsDiff = _v3.b;
		var newSelectedBusTransfer = $author$project$Types$Bus$SelectedTransferPair$maybeInitSelectedBusTransferPair(
			_Utils_Tuple2(maybeNewOutward, maybeNewReturn));
		return _Utils_Tuple2(
			A2(
				$elm$core$Array$append,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Array$empty,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A2(
								$elm$core$Array$initialize,
								1,
								function (_v4) {
									return a;
								});
						},
						newSelectedBusTransfer)),
				selectedBusTransferArray),
			_Utils_Tuple2(newOutwardCountsDiff, newReturnCountsDiff));
	});
var $author$project$Types$Bus$AgeGroup$subtractPassengerCounts = F2(
	function (first, second) {
		return {pn: first.pn - second.pn, zV: first.zV - second.zV, H4: first.H4 - second.H4};
	});
var $author$project$Types$Bus$SelectedTransfers$sumOutwardCounts = function (selectedBusTransferArray) {
	return A3(
		$elm$core$Array$foldl,
		F2(
			function (current, sum) {
				return A2(
					$elm$core$Maybe$withDefault,
					sum,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.po;
							},
							$author$project$Types$Bus$AgeGroup$addPassengerCounts(sum)),
						$author$project$Types$Bus$SelectedTransferPair$selectedOutward(current)));
			}),
		A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, 0),
		selectedBusTransferArray);
};
var $author$project$Types$Bus$SelectedTransfers$sumReturnCounts = function (selectedBusTransferArray) {
	return A3(
		$elm$core$Array$foldl,
		F2(
			function (current, sum) {
				return A2(
					$elm$core$Maybe$withDefault,
					sum,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.po;
							},
							$author$project$Types$Bus$AgeGroup$addPassengerCounts(sum)),
						$author$project$Types$Bus$SelectedTransferPair$selectedReturn(current)));
			}),
		A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, 0),
		selectedBusTransferArray);
};
var $author$project$Types$Bus$SelectedTransfers$purgeArray = F2(
	function (passengers, selectedBusTransferArray) {
		var countsDiff = function (sumCounts) {
			return $author$project$Types$Bus$AgeGroup$removePositiveValues(
				A2(
					$author$project$Types$Bus$AgeGroup$subtractPassengerCounts,
					$author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(passengers),
					sumCounts(selectedBusTransferArray)));
		};
		return A3(
			$elm$core$Array$foldr,
			$author$project$Types$Bus$SelectedTransfers$removeDiffsFromTransfer,
			_Utils_Tuple2(
				$elm$core$Array$empty,
				_Utils_Tuple2(
					countsDiff($author$project$Types$Bus$SelectedTransfers$sumOutwardCounts),
					countsDiff($author$project$Types$Bus$SelectedTransfers$sumReturnCounts))),
			selectedBusTransferArray).a;
	});
var $author$project$Types$Bus$SelectedTransfers$purge = F2(
	function (passengers, selectedBusTransfers) {
		return $author$project$Types$Bus$SelectedTransfers$fromArray(
			A2(
				$elm$core$Array$filter,
				$author$project$Types$Bus$SelectedTransferPair$hasPassengers,
				A2(
					$author$project$Types$Bus$SelectedTransfers$purgeArray,
					passengers,
					$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers))));
	});
var $author$project$Update$BusTransfers$purgeBusTransfers = function (session) {
	var maybePurgedSelectedBusTransfers = A2(
		$elm$core$Maybe$andThen,
		$author$project$Types$Bus$SelectedTransfers$purge(
			$elm$core$Array$toList(session.Eg)),
		session.B0);
	return _Utils_update(
		session,
		{B0: maybePurgedSelectedBusTransfers});
};
var $author$project$Update$exitBusTransferPage = function (model) {
	return $author$project$UrlRoute$isBusTransferRoute(
		$author$project$UrlRoute$parseLocation(model.n1)) ? model : _Utils_update(
		model,
		{
			j: $author$project$Update$BusTransfers$purgeBusTransfers(model.j)
		});
};
var $author$project$Messages$GotReservationData = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Reservation$countryParam = function (market) {
	return A2(
		$elm$url$Url$Builder$string,
		'country',
		$author$project$Types$Market$toString(market));
};
var $author$project$Api$Reservation$localeParam = function (language) {
	return A2(
		$elm$url$Url$Builder$string,
		'locale',
		$elm$core$String$toLower(
			$author$project$Types$Language$toString(language)));
};
var $author$project$Api$Endpoint$plan = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['confirmation', 'plan']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Reservation$resTokenParam = function (token) {
	return A2($elm$url$Url$Builder$string, 'resToken', token);
};
var $author$project$Types$TermsAndConditions$DEFAULT = 0;
var $author$project$Types$ReservationData$OneDeparture = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$ReservationData$ReservationData = function (resId) {
	return function (sails) {
		return function (passengers) {
			return function (pin) {
				return function (contactPerson) {
					return function (isReservationChangeSupported) {
						return function (isGroupReservation) {
							return function (hasChange) {
								return function (price) {
									return function (pointsPrice) {
										return function (vouchers) {
											return function (transfers) {
												return function (landServices) {
													return function (hotel) {
														return function (currency) {
															return function (paymentMethod) {
																return function (paidTotal) {
																	return function (productType) {
																		return function (termsAndConditionsType) {
																			return function (isBookingSession) {
																				return function (isMyJourneySupported) {
																					return function (mealPackage) {
																						return function (mealCoupons) {
																							return function (meetingRoom) {
																								return function (externalAgencyBooking) {
																									return function (travelClassServices) {
																										return function (digiDataTransactionType) {
																											return function (refNumber) {
																												return function (country) {
																													return function (maybeTargetOffer) {
																														return function (requireDocuments) {
																															return function (automaticRefund) {
																																return function (servicesAvailability) {
																																	return function (onboardServices) {
																																		return function (hasDietaryRestrictions) {
																																			return function (isInHouseBooking) {
																																				return {pv: automaticRefund, xU: contactPerson, nm: country, yd: currency, p5: digiDataTransactionType, qj: externalAgencyBooking, qu: hasChange, qv: hasDietaryRestrictions, zv: hotel, qN: isBookingSession, Ab: isGroupReservation, lw: isInHouseBooking, qU: isMyJourneySupported, qZ: isReservationChangeSupported, AZ: landServices, rq: maybeTargetOffer, Ce: mealCoupons, lB: mealPackage, et: meetingRoom, rI: onboardServices, DG: paidTotal, Eg: passengers, r$: paymentMethod, oy: pin, oA: pointsPrice, lN: price, Fn: productType, si: refNumber, k3: requireDocuments, oG: resId, F6: sails, sM: servicesAvailability, s9: termsAndConditionsType, H_: transfers, tn: travelClassServices, tw: vouchers};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$ReservationData$ThreeDepartures = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$ReservationData$TwoDepartures = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$ReservationData$servicesAvailabilityDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return a || b;
		}),
	A2($elm$json$Json$Decode$field, 'outwardDirection', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'returnDirection', $elm$json$Json$Decode$bool));
var $author$project$Types$ReservationData$availabilityDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return {qk: a, rI: b};
		}),
	A2($elm$json$Json$Decode$field, 'extraServices', $author$project$Types$ReservationData$servicesAvailabilityDecoder),
	A2($elm$json$Json$Decode$field, 'onboardServices', $author$project$Types$ReservationData$servicesAvailabilityDecoder));
var $author$project$Types$ReservationData$ContactPerson = function (clubOneNumber) {
	return function (clubOnePoints) {
		return function (clubOneLevel) {
			return function (firstName) {
				return function (lastName) {
					return function (clientId) {
						return function (company) {
							return function (email) {
								return function (profiling) {
									return function (phone) {
										return function (isMarketingAllowed) {
											return {v5: clientId, pO: clubOneLevel, we: clubOneNumber, wf: clubOnePoints, xA: company, yI: email, y2: firstName, qT: isMarketingAllowed, A6: lastName, ox: phone, sc: profiling};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$ReservationData$Company = F4(
	function (name, address, isInvoiceEnabled, secondaryEmail) {
		return {tT: address, qR: isInvoiceEnabled, oh: name, Gd: secondaryEmail};
	});
var $author$project$Types$Company$Address = F3(
	function (street, zipCode, city) {
		return {v0: city, G0: street, IG: zipCode};
	});
var $author$project$Types$Company$addressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'city',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'zipCode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'street',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$Company$Address))));
var $author$project$Types$ReservationData$decodeCompany = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'secondaryEmail',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hasAgent',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$author$project$Types$Company$addressDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Company)))));
var $author$project$Types$ReservationData$emptyStringToMaybeString = function (input) {
	if (input === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var anyOtherValue = input;
		return $elm$core$Maybe$Just(anyOtherValue);
	}
};
var $author$project$Types$ReservationData$Phone = F2(
	function (countryCallingCode, phoneNumber) {
		return {p_: countryCallingCode, jR: phoneNumber};
	});
var $author$project$Types$ReservationData$phoneDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$ReservationData$Phone,
	A2(
		$elm$json$Json$Decode$field,
		'intlCode',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'phoneNumber', $elm$json$Json$Decode$string));
var $author$project$Types$ReservationData$contactPersonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'marketingAllowed',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phone',
		$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$phoneDecoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'profiling',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'company',
					$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$decodeCompany),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'clientId',
						$elm$json$Json$Decode$int,
						0,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lastName',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'firstName',
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'clubOneLevel',
									$elm$json$Json$Decode$maybe($author$project$Types$ClubOneLevel$decoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'clubOnePoints',
										$elm$json$Json$Decode$int,
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'clubOneNumber',
											A2($elm$json$Json$Decode$map, $author$project$Types$ReservationData$emptyStringToMaybeString, $elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$ContactPerson))))))))))));
var $author$project$Types$Market$decoderFromString = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$json$Json$Decode$fail('Some random string: ' + input),
		A2(
			$elm$core$Maybe$map,
			$elm$json$Json$Decode$succeed,
			$author$project$Types$Market$fromString(input)));
};
var $author$project$Types$Market$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Types$Market$decoderFromString, $elm$json$Json$Decode$string);
var $author$project$Types$ReservationData$Meal$Coupon$Model = F3(
	function (title, code, count) {
		return {pQ: code, pZ: count, HI: title};
	});
var $author$project$Types$ReservationData$Meal$Coupon$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$ReservationData$Meal$Coupon$Model,
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int));
var $author$project$Types$TermsAndConditions$EU_REGULATION = 3;
var $author$project$Types$TermsAndConditions$TALLINK_GROUP_AS = 1;
var $author$project$Types$TermsAndConditions$TALLINK_SILJA_OY = 2;
var $author$project$Types$TermsAndConditions$stringToTermsAndConditionsDecoder = function (input) {
	switch (input) {
		case 'TALLINK_GROUP_AS':
			return $elm$json$Json$Decode$succeed(1);
		case 'TALLINK_SILJA_OY':
			return $elm$json$Json$Decode$succeed(2);
		case 'EU_REGULATION':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$succeed(0);
	}
};
var $author$project$Types$TermsAndConditions$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Types$TermsAndConditions$stringToTermsAndConditionsDecoder, $elm$json$Json$Decode$string);
var $author$project$Types$TravelClassService$Service = F3(
	function (code, count, name) {
		return {pQ: code, pZ: count, oh: name};
	});
var $author$project$Types$TravelClassService$decodeService = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$TravelClassService$Service))));
var $author$project$Types$TravelClassService$decoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return {DC: a, FV: b};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'outwards',
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($author$project$Types$TravelClassService$decodeService))),
	A2(
		$elm$json$Json$Decode$field,
		'returns',
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$list($author$project$Types$TravelClassService$decodeService))));
var $author$project$Types$ReservationData$TargetOffer = F2(
	function (campaignName, companyId) {
		return {pE: campaignName, pW: companyId};
	});
var $author$project$Types$ReservationData$decoderTargetOffer = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$ReservationData$TargetOffer,
	A2($elm$json$Json$Decode$field, 'campaignName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'companyId', $elm$json$Json$Decode$int));
var $author$project$Types$Currency$fromString = function (string) {
	var _v0 = $elm$core$String$toLower(string);
	switch (_v0) {
		case 'eur':
			return 0;
		case 'sek':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Types$ReservationData$Hotel = F5(
	function (checkInTime, checkOutTime, cityCode, name, rooms) {
		return {mb: checkInTime, mc: checkOutTime, pK: cityCode, oh: name, F_: rooms};
	});
var $author$project$Types$ReservationData$Room = F6(
	function (checkInDate, checkOutDate, name, nightCount, roomCount, price) {
		return {ln: checkInDate, lo: checkOutDate, oh: name, CH: nightCount, lN: price, FZ: roomCount};
	});
var $author$project$Types$ReservationData$decodeRoom = function (_v0) {
	var checkInTime = _v0.mb;
	var checkOutTime = _v0.mc;
	var decodeDateWithTime = function (time) {
		return A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Utils$Time$fromString,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
					$elm$core$Maybe$withDefault(
						$elm$json$Json$Decode$fail('dateDecoder')))),
			A2(
				$elm$json$Json$Decode$map,
				function (a) {
					return a + ('T' + time);
				},
				$elm$json$Json$Decode$string));
	};
	return A7(
		$elm$json$Json$Decode$map6,
		$author$project$Types$ReservationData$Room,
		A2(
			$elm$json$Json$Decode$field,
			'checkInDate',
			decodeDateWithTime(checkInTime)),
		A2(
			$elm$json$Json$Decode$field,
			'checkOutDate',
			decodeDateWithTime(checkOutTime)),
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'nightCount', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'roomCount', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float));
};
var $author$project$Types$ReservationData$hotelDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var checkInTime = _v0.mb;
		var checkOutTime = _v0.mc;
		return A4(
			$elm$json$Json$Decode$map3,
			A2($author$project$Types$ReservationData$Hotel, checkInTime, checkOutTime),
			A2($elm$json$Json$Decode$field, 'cityCode', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
			A2(
				$elm$json$Json$Decode$field,
				'rooms',
				$elm$json$Json$Decode$list(
					$author$project$Types$ReservationData$decodeRoom(
						{mb: checkInTime, mc: checkOutTime}))));
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return {mb: a, mc: b};
			}),
		A2($elm$json$Json$Decode$field, 'checkInTime', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'checkOutTime', $elm$json$Json$Decode$string)));
var $author$project$Types$ReservationData$isInHouseDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$eq('IN HOUSE'),
	$elm$json$Json$Decode$string);
var $author$project$Types$ReservationData$LandService = F3(
	function (title, code, eventTimes) {
		return {pQ: code, qg: eventTimes, HI: title};
	});
var $author$project$Types$ReservationData$Event = F2(
	function (dateTime, tickets) {
		return {mo: dateTime, Hv: tickets};
	});
var $author$project$Types$ReservationData$Ticket = F4(
	function (ageCategory, count, maybeGroupTitle, name) {
		return {tY: ageCategory, pZ: count, BR: maybeGroupTitle, oh: name};
	});
var $author$project$Types$Ticket$nameDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'name',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$String$decodeNonEmpty)),
			$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$Types$ReservationData$BasicTicket = {$: 0};
var $author$project$Types$ReservationData$Children = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$ReservationData$ticketTypeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$map, $author$project$Types$ReservationData$Children, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$null($author$project$Types$ReservationData$BasicTicket)
		]));
var $author$project$Types$ReservationData$ticketDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Types$ReservationData$Ticket,
	A2($elm$json$Json$Decode$field, 'ageCategory', $author$project$Types$ReservationData$ticketTypeDecoder),
	A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'groupTitle',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	$author$project$Types$Ticket$nameDecoder);
var $author$project$Types$ReservationData$eventDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$ReservationData$Event,
	A2(
		$elm$json$Json$Decode$field,
		'dateTime',
		$elm$json$Json$Decode$maybe($author$project$Utils$Time$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'tickets',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$ticketDecoder)));
var $author$project$Types$ReservationData$landServiceDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$ReservationData$LandService,
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'eventTimes',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$eventDecoder)));
var $author$project$Types$ReservationData$Meal$MealPackage$MealPackage = F3(
	function (code, name, passengers) {
		return {pQ: code, oh: name, Eg: passengers};
	});
var $author$project$Types$ReservationData$Passenger$Passengers = F2(
	function (adults, underages) {
		return {pn: adults, H4: underages};
	});
var $author$project$Types$ReservationData$Passenger$passengersDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'underages',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'adults',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Passenger$Passengers)));
var $author$project$Types$ReservationData$Meal$MealPackage$mealPackageDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$ReservationData$Meal$MealPackage$MealPackage,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'passengers', $author$project$Types$ReservationData$Passenger$passengersDecoder));
var $author$project$Types$ReservationData$MeetingRoom = F9(
	function (name, facilityType, layout, shipCode, dateTime, duration, partySize, catering, cateringMandatory) {
		return {pG: catering, pH: cateringMandatory, mo: dateTime, nv: duration, ql: facilityType, q9: layout, oh: name, rY: partySize, oX: shipCode};
	});
var $author$project$Types$ReservationData$RoomCatering = F3(
	function (code, name, count) {
		return {pQ: code, pZ: count, oh: name};
	});
var $author$project$Types$ReservationData$roomCateringDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$RoomCatering))));
var $author$project$Types$ReservationData$RoomLayout = F2(
	function (code, name) {
		return {pQ: code, oh: name};
	});
var $author$project$Types$ReservationData$roomLayoutDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$RoomLayout)));
var $author$project$Types$ReservationData$meetingRoomDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cateringMandatory',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'catering',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$roomCateringDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partySize',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'duration',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'dateTime',
					$author$project$Utils$Time$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'shipCode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'layout',
							$author$project$Types$ReservationData$roomLayoutDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'facilityType',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$MeetingRoom))))))))));
var $author$project$Types$SelectedOnboardServices$OnboardService = F8(
	function (code, count, duration, name, beginDateTime, type_, freeAddons, paidAddons) {
		return {ut: beginDateTime, pQ: code, pZ: count, nv: duration, ms: freeAddons, oh: name, kD: paidAddons, km: type_};
	});
var $author$project$Types$SelectedOnboardServices$Addon = F3(
	function (code, name, count) {
		return {pQ: code, pZ: count, oh: name};
	});
var $author$project$Types$SelectedOnboardServices$addonDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$SelectedOnboardServices$Addon))));
var $author$project$Types$SelectedOnboardServices$onboardServiceDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'paidAddons',
	$elm$json$Json$Decode$list($author$project$Types$SelectedOnboardServices$addonDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'freeAddons',
		$elm$json$Json$Decode$list($author$project$Types$SelectedOnboardServices$addonDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Types$OnboardServices$typeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'beginDateTime',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'duration',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'count',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'code',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Types$SelectedOnboardServices$OnboardService)))))))));
var $author$project$Types$Summary$onboardServicesDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return {ot: a, oL: b};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'outwardServices',
		$elm$json$Json$Decode$list($author$project$Types$SelectedOnboardServices$onboardServiceDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'returnServices',
		$elm$json$Json$Decode$list($author$project$Types$SelectedOnboardServices$onboardServiceDecoder)));
var $author$project$Types$ReservationData$Passenger$Passenger = function (ageCategory) {
	return function (firstName) {
		return function (lastName) {
			return function (birthday) {
				return function (clientId) {
					return function (seqN) {
						return function (gender) {
							return function (countryOfBirth) {
								return function (citizenship) {
									return function (email) {
										return function (phoneNumber) {
											return function (clubOneNumber) {
												return function (clubOnePoints) {
													return function (clubOneLevel) {
														return function (readOnly) {
															return function (checkedIn) {
																return function (phoneMutable) {
																	return function (emailMutable) {
																		return function (documentTypes) {
																			return function (maybeDisability) {
																				return function (kplusMember) {
																					return function (joinedClubOne) {
																						return function (isClubOneDataMissing) {
																							return function (address) {
																								return function (marketingAllowedInfo) {
																									return function (preferenceLanguage) {
																										return {tT: address, tY: ageCategory, uw: birthday, vT: checkedIn, v_: citizenship, v5: clientId, pO: clubOneLevel, we: clubOneNumber, wf: clubOnePoints, j$: countryOfBirth, v: documentTypes, yI: email, yJ: emailMutable, y2: firstName, zf: gender, mz: isClubOneDataMissing, q5: joinedClubOne, AY: kplusMember, A6: lastName, n5: marketingAllowedInfo, kA: maybeDisability, EG: phoneMutable, jR: phoneNumber, r4: preferenceLanguage, Fq: readOnly, oV: seqN};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$ReservationData$Passenger$addressDecoder = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (street, zipCode, city, country) {
			return {v0: city, nm: country, G0: street, IG: zipCode};
		}),
	A2($elm$json$Json$Decode$field, 'street', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'zipCode', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'city', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'country', $elm$json$Json$Decode$string));
var $author$project$Types$AgeCategory$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (input) {
		var _v0 = $elm$core$String$toLower(input);
		switch (_v0) {
			case 'adult':
				return $elm$json$Json$Decode$succeed(0);
			case 'youth':
				return $elm$json$Json$Decode$succeed(1);
			case 'child':
				return $elm$json$Json$Decode$succeed(2);
			case 'junior':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var randomShit = _v0;
				return $elm$json$Json$Decode$fail('Some random string: ' + randomShit);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Document$Document = F6(
	function (code, name, number, country, issuedDate, expiryDate) {
		return {pQ: code, nm: country, I: expiryDate, kW: issuedDate, oh: name, k$: number};
	});
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Types$Document$toDayMonthYear = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('-'),
	function (dateParts) {
		if (((dateParts.b && dateParts.b.b) && dateParts.b.b.b) && (!dateParts.b.b.b.b)) {
			var year = dateParts.a;
			var _v1 = dateParts.b;
			var month = _v1.a;
			var _v2 = _v1.b;
			var day = _v2.a;
			return {q: day, s: month, h: year};
		} else {
			return {q: '', s: '', h: ''};
		}
	});
var $author$project$Types$Document$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'expirationDate',
	A2(
		$elm$json$Json$Decode$andThen,
		A2($elm$core$Basics$composeR, $author$project$Types$Document$toDayMonthYear, $elm$json$Json$Decode$succeed),
		$elm$json$Json$Decode$string),
	{q: '', s: '', h: ''},
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'issuedDate',
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, $author$project$Types$Document$toDayMonthYear, $elm$json$Json$Decode$succeed),
			$elm$json$Json$Decode$string),
		{q: '', s: '', h: ''},
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'issuedCountry',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number',
				A2(
					$elm$json$Json$Decode$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault(''),
						$elm$json$Json$Decode$succeed),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'typeName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'typeCode',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Types$Document$Document)))))));
var $author$project$Types$ReservationData$Passenger$marketingAllowedInfoDecoder = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (email, sms, mail) {
			return {yI: email, BB: mail, sU: sms};
		}),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$bool)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'sms', $elm$json$Json$Decode$bool)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'mail', $elm$json$Json$Decode$bool)));
var $author$project$Types$ReservationData$Passenger$passengerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'preferenceLanguage',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'marketingAllowedInfo',
		$author$project$Types$ReservationData$Passenger$marketingAllowedInfoDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$author$project$Types$ReservationData$Passenger$addressDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'coDataMissing',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'joinedClubOne',
					$elm$json$Json$Decode$bool,
					false,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'kplusMember',
						$elm$json$Json$Decode$bool,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'disability',
							$elm$json$Json$Decode$maybe($author$project$Utils$String$decodeNonEmpty),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'documentTypes',
								$elm$json$Json$Decode$list($author$project$Types$Document$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'emailMutable',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'phoneMutable',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'checkedIn',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'readOnly',
												$elm$json$Json$Decode$bool,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'clubOneLevel',
													$elm$json$Json$Decode$maybe($author$project$Types$ClubOneLevel$decoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'clubOnePoints',
														$elm$json$Json$Decode$int,
														0,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'clubOneNumber',
															$elm$json$Json$Decode$string,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'phoneNumber',
																$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'email',
																	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'citizenship',
																		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'countryOfBirth',
																			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'gender',
																				$author$project$Types$Gender$decoder,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'seqN',
																					$elm$json$Json$Decode$int,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'clientId',
																						$elm$json$Json$Decode$int,
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'birthday',
																							$elm$json$Json$Decode$string,
																							'',
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'lastName',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'firstName',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'ageCategory',
																										$author$project$Types$AgeCategory$decoder,
																										$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Passenger$Passenger)))))))))))))))))))))))))));
var $author$project$Types$ReservationData$CRUISE = 1;
var $author$project$Types$ReservationData$SHOPPING_CRUISE = 2;
var $author$project$Types$ReservationData$TRANSPORTATION = 0;
var $author$project$Types$ReservationData$UNKNOWN = 3;
var $author$project$Types$ReservationData$productTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'TRANSPORTATION':
				return $elm$json$Json$Decode$succeed(0);
			case 'SHOPPING_CRUISE':
				return $elm$json$Json$Decode$succeed(2);
			case 'CRUISE':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(3);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$ReservationData$replacePortForMugVssInLocation = function (location) {
	return (location.kg === 'MUUG') ? _Utils_update(
		location,
		{j3: 8}) : ((location.kg === 'VSAA') ? _Utils_update(
		location,
		{j3: 7}) : location);
};
var $author$project$Types$ReservationData$replacePortForMugVssInSail = function (sail) {
	return _Utils_update(
		sail,
		{
			kS: $author$project$Types$ReservationData$replacePortForMugVssInLocation(sail.kS),
			le: $author$project$Types$ReservationData$replacePortForMugVssInLocation(sail.le)
		});
};
var $author$project$Types$ReservationData$RawSails = F3(
	function (rawOutwardSail, rawIntermediateSail, rawReturnSail) {
		return {sf: rawIntermediateSail, sg: rawOutwardSail, sh: rawReturnSail};
	});
var $author$project$Types$ReservationData$rawSailsDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$ReservationData$RawSails,
	A2($elm$json$Json$Decode$field, 'outwardSail', $elm$json$Json$Decode$value),
	A2($elm$json$Json$Decode$field, 'outwardSail2', $elm$json$Json$Decode$value),
	A2($elm$json$Json$Decode$field, 'returnSail', $elm$json$Json$Decode$value));
var $author$project$Types$ReservationData$Sail = function (sailRefId) {
	return function (shipCode) {
		return function (from) {
			return function (to) {
				return function (departureDateTime) {
					return function (arrivalDateTime) {
						return function (vehiclesDetailed) {
							return function (travelClasses) {
								return function (meals) {
									return function (freeAddons) {
										return function (freeMealPackages) {
											return function (extraServices) {
												return function (passengers) {
													return function (sailPackageName) {
														return {na: arrivalDateTime, nq: departureDateTime, qk: extraServices, ms: freeAddons, qo: freeMealPackages, kS: from, rv: meals, Eg: passengers, F5: sailPackageName, k8: sailRefId, oX: shipCode, le: to, to: travelClasses, kL: vehiclesDetailed};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$ReservationData$Meal$Meal$Meal = F7(
	function (beginDateTime, title, maybeType, passengers, price, restaurantCode, addons) {
		return {tS: addons, ut: beginDateTime, Cc: maybeType, Eg: passengers, lN: price, FJ: restaurantCode, HI: title};
	});
var $author$project$Types$MealType$fromString = function (mealType) {
	switch (mealType) {
		case 'BREAKFAST':
			return $elm$core$Maybe$Just(0);
		case 'BRUNCH':
			return $elm$core$Maybe$Just(1);
		case 'LUNCH':
			return $elm$core$Maybe$Just(2);
		case 'DINNER':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$MealType$decode = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$andThen($author$project$Types$MealType$fromString),
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Types$ReservationData$Meal$Addons$Addons = F6(
	function (starters, mainCourses, desserts, foodPackages, drinkPackages, coupons) {
		return {x3: coupons, ys: desserts, yE: drinkPackages, y6: foodPackages, BD: mainCourses, GR: starters};
	});
var $author$project$Types$ReservationData$Meal$Addon$Addon = F4(
	function (count, description, included, price) {
		return {pZ: count, nt: description, zU: included, lN: price};
	});
var $author$project$Types$ReservationData$Meal$Addon$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'included',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Meal$Addon$Addon)))));
var $author$project$Types$ReservationData$Meal$Addons$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coupons',
	$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Addon$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'drinkPackages',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Addon$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'foodPackages',
			$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Addon$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'desserts',
				$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Addon$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mainCourses',
					$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Addon$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'starters',
						$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Addon$decode),
						$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Meal$Addons$Addons)))))));
var $author$project$Types$ReservationData$Meal$Meal$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'addons',
	$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$Meal$Addons$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'restaurantCode',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'price',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'passengers',
				$author$project$Types$ReservationData$Passenger$passengersDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type',
					$author$project$Types$MealType$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'beginDateTime',
							$author$project$Utils$Time$decoder,
							$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Meal$Meal$Meal))))))));
var $author$project$Types$ReservationData$TravelClass$TravelClass = F6(
	function (code, gender, maxOccupancy, name, count, price) {
		return {pQ: code, pZ: count, zf: gender, BL: maxOccupancy, oh: name, lN: price};
	});
var $author$project$Types$ReservationData$TravelClass$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'price',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'maxOccupancy',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'gender',
					$elm$json$Json$Decode$maybe($author$project$Types$Gender$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$TravelClass$TravelClass)))))));
var $author$project$Types$ReservationData$ExtraService = F3(
	function (name, count, code) {
		return {pQ: code, pZ: count, oh: name};
	});
var $author$project$Types$ReservationData$extraServiceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'code',
	$author$project$Types$ExtraService$codeDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$ExtraService))));
var $author$project$Types$ReservationData$FreeAddon = F2(
	function (name, passengers) {
		return {oh: name, Eg: passengers};
	});
var $author$project$Types$ReservationData$freeAddon = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'passengers',
	$author$project$Types$ReservationData$Passenger$passengersDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$FreeAddon)));
var $author$project$Types$ReservationData$FreeMealPackage = F3(
	function (name, code, passengers) {
		return {pQ: code, oh: name, Eg: passengers};
	});
var $author$project$Types$ReservationData$freeMealPackage = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'passengers',
	$author$project$Types$ReservationData$Passenger$passengersDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$FreeMealPackage))));
var $author$project$Types$ReservationData$Vehicle = F7(
	function (requestId, code, licensePlate, licensePlateTrailer, nrOfLicensePlates, addons, price) {
		return {tS: addons, pQ: code, n_: licensePlate, n$: licensePlateTrailer, lD: nrOfLicensePlates, lN: price, lO: requestId};
	});
var $author$project$Types$ReservationData$Addon = F2(
	function (translation, code) {
		return {pQ: code, pb: translation};
	});
var $author$project$Types$ReservationData$addonDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$ReservationData$Addon,
	A2($elm$json$Json$Decode$field, 'translation', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string));
var $author$project$Types$Vehicle$BICYCLE = 0;
var $author$project$Types$Vehicle$CAR = 1;
var $author$project$Types$Vehicle$CAR_ALA_OVNGT = 2;
var $author$project$Types$Vehicle$CAR_XL = 3;
var $author$project$Types$Vehicle$MOTORCYCLE = 4;
var $author$project$Types$Vehicle$MOTORCYCLE_WITH_SIDECAR = 5;
var $author$project$Types$Vehicle$PARKED_CAR = 6;
var $author$project$Types$Vehicle$PARKED_CAR_2 = 7;
var $author$project$Types$Vehicle$PARKED_VAN = 10;
var $author$project$Types$Vehicle$SHOPPER_CAR = 8;
var $author$project$Types$Vehicle$SHOPPER_VAN = 9;
var $author$project$Types$Vehicle$VAN = 11;
var $author$project$Types$Vehicle$VAN_HIGH = 12;
var $author$project$Types$Vehicle$VEHICLE_EXTRA_LONG_AND_HIGH = 14;
var $author$project$Types$Vehicle$VEHICLE_LONG_AND_HIGH = 13;
var $author$project$Types$Vehicle$VEHICLE_LONG_AND_LOW = 15;
var $author$project$Types$Vehicle$VEHICLE_LONG_AND_MEDIUM = 16;
var $author$project$Types$Vehicle$stringToCarCategory = function (input) {
	switch (input) {
		case 'BICYCLE':
			return $elm$json$Json$Decode$succeed(0);
		case 'CAR':
			return $elm$json$Json$Decode$succeed(1);
		case 'CAR ALA OVNGT':
			return $elm$json$Json$Decode$succeed(2);
		case 'CAR XL':
			return $elm$json$Json$Decode$succeed(3);
		case 'MOTORCYCLE':
			return $elm$json$Json$Decode$succeed(4);
		case 'MOTORCYCLE WITH SIDECAR':
			return $elm$json$Json$Decode$succeed(5);
		case 'PARKED CAR':
			return $elm$json$Json$Decode$succeed(6);
		case 'PARKED CAR 2':
			return $elm$json$Json$Decode$succeed(7);
		case 'PARKED VAN':
			return $elm$json$Json$Decode$succeed(10);
		case 'SHOPPER CAR':
			return $elm$json$Json$Decode$succeed(8);
		case 'SHOPPER VAN':
			return $elm$json$Json$Decode$succeed(9);
		case 'VAN':
			return $elm$json$Json$Decode$succeed(11);
		case 'VAN HIGH':
			return $elm$json$Json$Decode$succeed(12);
		case 'VEHICLE LONG & HIGH':
			return $elm$json$Json$Decode$succeed(13);
		case 'VEHICLE EXTRA LONG & HIGH':
			return $elm$json$Json$Decode$succeed(14);
		case 'VEHICLE LONG & LOW':
			return $elm$json$Json$Decode$succeed(15);
		case 'VEHICLE LONG & MEDIUM':
			return $elm$json$Json$Decode$succeed(16);
		default:
			var unknownString = input;
			return $elm$json$Json$Decode$fail(unknownString);
	}
};
var $author$project$Types$Vehicle$carCategoryDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Types$Vehicle$stringToCarCategory, $elm$json$Json$Decode$string);
var $author$project$Types$ReservationData$vehicleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'addons',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$addonDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nrOfLicensePlates',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'licensePlateTrailer',
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
							A2($elm$json$Json$Decode$map, $author$project$Types$ReservationData$emptyStringToMaybeString, $elm$json$Json$Decode$string)
						])),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'licensePlate',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $author$project$Types$ReservationData$emptyStringToMaybeString, $elm$json$Json$Decode$string)
							])),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$author$project$Types$Vehicle$carCategoryDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'requestId',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Vehicle))))))));
var $author$project$Types$ReservationData$sailDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sailPackageName',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'passengers',
		$author$project$Types$ReservationData$Passenger$passengersDecoder,
		{pn: 0, H4: 0},
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'extraServices',
			$elm$json$Json$Decode$list($author$project$Types$ReservationData$extraServiceDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'freeMealPackages',
				$elm$json$Json$Decode$list($author$project$Types$ReservationData$freeMealPackage),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'freeAddons',
					$elm$json$Json$Decode$list($author$project$Types$ReservationData$freeAddon),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'meals',
						$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Meal$decode),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'travelClasses',
							$elm$json$Json$Decode$list($author$project$Types$ReservationData$TravelClass$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'vehiclesDetailed',
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$list($author$project$Types$ReservationData$vehicleDecoder),
											$elm$json$Json$Decode$null(_List_Nil)
										])),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'arrivalDateTime',
									$author$project$Utils$Time$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'departureDateTime',
										$author$project$Utils$Time$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'to',
											$author$project$Types$Port$locationDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'from',
												$author$project$Types$Port$locationDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'shipCode',
													$author$project$Types$ShipCode$decode,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'sailRefId',
														$elm$json$Json$Decode$int,
														$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Sail)))))))))))))));
var $author$project$Types$ReservationData$sailsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var rawOutwardSail = _v0.sg;
		var rawIntermediateSail = _v0.sf;
		var rawReturnSail = _v0.sh;
		var returnSailDecodeResult = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$ReservationData$sailDecoder, rawReturnSail);
		var outwardSailDecodeResult = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$ReservationData$sailDecoder, rawOutwardSail);
		var itermediateSailResult = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$ReservationData$sailDecoder, rawIntermediateSail);
		var _v1 = _Utils_Tuple3(outwardSailDecodeResult, itermediateSailResult, returnSailDecodeResult);
		if (!_v1.a.$) {
			if (!_v1.c.$) {
				if (!_v1.b.$) {
					var outwardSail = _v1.a.a;
					var intermediateSail = _v1.b.a;
					var returnSail = _v1.c.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Types$ReservationData$ThreeDepartures(
							{z1: intermediateSail, Ds: outwardSail, FL: returnSail}));
				} else {
					var outwardSail = _v1.a.a;
					var returnSail = _v1.c.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Types$ReservationData$TwoDepartures(
							{Ds: outwardSail, FL: returnSail}));
				}
			} else {
				var outwardSail = _v1.a.a;
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$ReservationData$OneDeparture(outwardSail));
			}
		} else {
			if (!_v1.c.$) {
				var error = _v1.a.a;
				return $elm$json$Json$Decode$fail(
					$elm$json$Json$Decode$errorToString(error));
			} else {
				var error = _v1.a.a;
				return $elm$json$Json$Decode$fail(
					$elm$json$Json$Decode$errorToString(error));
			}
		}
	},
	$author$project$Types$ReservationData$rawSailsDecoder);
var $author$project$Types$ReservationData$Transfers = F2(
	function (outwardTransfers, returnTransfers) {
		return {rV: outwardTransfers, sy: returnTransfers};
	});
var $author$project$Types$ReservationData$Transfer = F8(
	function (departureDateTime, arrivalDateTime, passengerTypes, passengers, stopFrom, stopTo, code, price) {
		return {na: arrivalDateTime, pQ: code, nq: departureDateTime, rZ: passengerTypes, Eg: passengers, lN: price, sY: stopFrom, s_: stopTo};
	});
var $author$project$Types$Bus$AgeGroup$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'infants',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'underages',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'adults',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Types$Bus$AgeGroup$AgeGroupCounts))));
var $author$project$Types$ReservationData$transferDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'stopTo',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'stopFrom',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'passengers',
					$author$project$Types$ReservationData$Passenger$passengersDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'passengerTypes',
						$author$project$Types$Bus$AgeGroup$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'arrivalDateTime',
							$author$project$Utils$Time$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'departureDateTime',
								$author$project$Utils$Time$decoder,
								$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Transfer)))))))));
var $author$project$Types$ReservationData$transfersDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'returnTransfers',
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$transferDecoder)),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'outwardTransfers',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$transferDecoder)),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$Transfers)));
var $author$project$Types$ReservationData$reservationDataDecoder = A2(
	$elm$json$Json$Decode$map,
	function (reservationData) {
		return function (sails) {
			return _Utils_update(
				reservationData,
				{F6: sails});
		}(
			function (sails) {
				switch (sails.$) {
					case 0:
						var sail = sails.a;
						return $author$project$Types$ReservationData$OneDeparture(
							$author$project$Types$ReservationData$replacePortForMugVssInSail(sail));
					case 1:
						var outward = sails.a.Ds;
						var _return = sails.a.FL;
						return $author$project$Types$ReservationData$TwoDepartures(
							{
								Ds: $author$project$Types$ReservationData$replacePortForMugVssInSail(outward),
								FL: $author$project$Types$ReservationData$replacePortForMugVssInSail(_return)
							});
					default:
						var a = sails.a;
						return $author$project$Types$ReservationData$ThreeDepartures(a);
				}
			}(reservationData.F6));
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(false),
			$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$isInHouseDecoder)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hasDietaryRestrictions',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'onboardServices',
				$author$project$Types$Summary$onboardServicesDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'availability',
					$author$project$Types$ReservationData$availabilityDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'automaticRefund',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'requireDocuments',
							$elm$json$Json$Decode$bool,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'targetOffer',
								$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$decoderTargetOffer),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'country',
									$author$project$Types$Market$decoder,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'refNumber',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'digiDataTransactionType',
											$elm$json$Json$Decode$value,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'travelClassServices',
												$author$project$Types$TravelClassService$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'externalAgencyBooking',
													$elm$json$Json$Decode$bool,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'meetingRoom',
														$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$meetingRoomDecoder),
														$elm$core$Maybe$Nothing,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'mealCoupons',
															$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Coupon$decoder),
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'mealPackage',
																$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$Meal$MealPackage$mealPackageDecoder),
																$elm$core$Maybe$Nothing,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'myJourneySupported',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'bookingSession',
																		$elm$json$Json$Decode$bool,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'termsAndConditionsType',
																			$author$project$Types$TermsAndConditions$decoder,
																			0,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'productType',
																				$author$project$Types$ReservationData$productTypeDecoder,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'paidTotal',
																					$elm$json$Json$Decode$float,
																					0,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'paymentMethod',
																						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																						$elm$core$Maybe$Nothing,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'currency',
																							A2($elm$json$Json$Decode$map, $author$project$Types$Currency$fromString, $elm$json$Json$Decode$string),
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'hotel',
																								$elm$json$Json$Decode$maybe($author$project$Types$ReservationData$hotelDecoder),
																								$elm$core$Maybe$Nothing,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'landServices',
																									$elm$json$Json$Decode$list($author$project$Types$ReservationData$landServiceDecoder),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'transfers',
																										$author$project$Types$ReservationData$transfersDecoder,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'vouchers',
																											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'pointsPrice',
																												$elm$json$Json$Decode$int,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'price',
																													$elm$json$Json$Decode$float,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'hasChange',
																														$elm$json$Json$Decode$bool,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'groupReservation',
																															$elm$json$Json$Decode$bool,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'reservationChangeSupported',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'contactPerson',
																																	$author$project$Types$ReservationData$contactPersonDecoder,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'pin',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'passengers',
																																			$elm$json$Json$Decode$list($author$project$Types$ReservationData$Passenger$passengerDecoder),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'sails',
																																				$author$project$Types$ReservationData$sailsDecoder,
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'resId',
																																					$elm$json$Json$Decode$int,
																																					$elm$json$Json$Decode$succeed($author$project$Types$ReservationData$ReservationData))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Reservation$sessionGUIDParam = function (_v0) {
	var sessionGuid = _v0.Gt;
	return A2($elm$url$Url$Builder$string, 'sessionGUID', sessionGuid);
};
var $author$project$Api$Reservation$withCheckInTrueParam = A2($elm$url$Url$Builder$string, 'withCheckIn', 'true');
var $author$project$Api$Reservation$fetchReservation = F4(
	function (_v0, resToken, webDataToMsg, httpConfig) {
		var language = _v0.A_;
		var market = _v0.rb;
		var isExperimental = _v0.Aa;
		var queryParams = A2(
			$author$project$Api$Util$addExperimentalParamIf,
			isExperimental,
			_List_fromArray(
				[
					$author$project$Api$Reservation$resTokenParam(resToken),
					$author$project$Api$Reservation$sessionGUIDParam(httpConfig),
					$author$project$Api$Reservation$withCheckInTrueParam,
					$author$project$Api$Reservation$localeParam(language),
					$author$project$Api$Reservation$countryParam(market)
				]));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, webDataToMsg),
					$author$project$Types$ReservationData$reservationDataDecoder),
				jW: A2($author$project$Api$Endpoint$plan, httpConfig.Gs, queryParams)
			});
	});
var $author$project$Update$fetchReservation = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: function (a) {
					return _Utils_update(
						a,
						{z5: true, Ao: false});
				}(model.j)
			}),
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (resToken) {
					return A4($author$project$Api$Reservation$fetchReservation, model.j, resToken, $author$project$Messages$GotReservationData, model.j.zM);
				},
				model.j.B_)));
};
var $author$project$Common$Ports$hideBackButton = _Platform_outgoingPort(
	'hideBackButton',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Common$Toast$StartedRemove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Common$Toast$hideToastCmd = function (id) {
	return $author$project$Common$Toast$performImmediately(
		$author$project$Common$Toast$StartedRemove(id));
};
var $author$project$UrlRoute$ignoreHistoryParam = 'ignoreHistoryOnNativeBackButtonClick';
var $author$project$UrlRoute$removeIgnoreHistoryParam = function (url) {
	return A2($author$project$UrlRoute$removeParam, url, $author$project$UrlRoute$ignoreHistoryParam);
};
var $author$project$Page$Hotel$save = F2(
	function (session, model) {
		return _Utils_update(
			session,
			{Gk: model.Gk});
	});
var $author$project$Page$HotelList$save = F2(
	function (session, model) {
		return _Utils_update(
			session,
			{
				zw: $elm$core$Maybe$Just(model.w.o),
				Gk: model.Gk
			});
	});
var $author$project$Update$exit = F2(
	function (newUrl, model) {
		var session = model.j;
		var _v0 = model.DF;
		switch (_v0.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A3(
							$author$project$Utils$List$addIf,
							!_Utils_eq(
								$author$project$UrlRoute$parseLocation(newUrl),
								$author$project$UrlRoute$Root),
							A3(
								$author$project$UrlRoute$replaceUrl,
								model.AK,
								$author$project$UrlRoute$removeIgnoreHistoryParam(newUrl),
								$author$project$UrlRoute$parseLocation(newUrl)),
							_List_fromArray(
								[
									$author$project$Common$Ports$hideBackButton(0)
								]))));
			case 1:
				var pageModel = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							DF: $author$project$Model$Timetable(
								_Utils_update(
									pageModel,
									{oP: $elm$core$Maybe$Nothing}))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					$author$project$Update$cleanVehiclesInModel(model),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					$author$project$Update$exitBusTransferPage(model),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					$author$project$Update$exitBusTransferPage(model),
					$elm$core$Platform$Cmd$none);
			case 7:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							model,
							{j: a});
					},
					A2($author$project$PassengerDetailsPage$Model$exit, model.j, pageModel));
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 10:
				var pageModel = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A2($author$project$MealPage$Update$exit, session, pageModel)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							model,
							{j: a});
					},
					A2($author$project$ContactPersonPage$Update$exit, model.j, pageModel));
			case 12:
				return _Utils_eq(
					$author$project$UrlRoute$parseLocation(newUrl),
					$author$project$UrlRoute$Payment) ? $author$project$Update$fetchReservation(model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 13:
				var pageModel = _v0.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							model,
							{j: a});
					},
					_Utils_Tuple2(
						A2($author$project$Page$Company$exit, model.j, pageModel),
						$elm$core$Platform$Cmd$none));
			case 14:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Messages$ToastMsg,
						$author$project$Common$Toast$hideToastCmd(model.HT.zN)));
			case 15:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 18:
				return _Utils_Tuple2(
					model,
					$author$project$Common$Ports$hideBackButton(0));
			case 19:
				var pageModel = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A2($author$project$Page$HotelList$save, session, pageModel)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var pageModel = _v0.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A2($author$project$Page$Hotel$save, session, pageModel)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Model$BusTransfer = {$: 6};
var $author$project$Model$ExtraServices = {$: 15};
var $author$project$Model$LandService = {$: 17};
var $author$project$Model$OnboardService = {$: 14};
var $author$project$Model$PassengerList = {$: 8};
var $author$project$Model$Payment = {$: 4};
var $author$project$Model$Vehicle = {$: 2};
var $author$project$Model$VehicleList = {$: 3};
var $author$project$Page$Company$CompanyForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Company$init = $author$project$Page$Company$CompanyForm(
	{yt: $krisajenkins$remotedata$RemoteData$NotAsked, zN: ''});
var $author$project$Page$Discount$Update$init = {pQ: '', ko: $krisajenkins$remotedata$RemoteData$NotAsked, Ix: $elm$core$Maybe$Nothing};
var $author$project$Page$HotelLinks$GotHotelTranslations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$HotelLinks$HotelTallinkCity = 3;
var $author$project$Page$HotelLinks$HotelTallinkExpress = 1;
var $author$project$Page$HotelLinks$HotelTallinkRiga = 0;
var $author$project$Page$HotelLinks$HotelTallinkSPA = 2;
var $author$project$Page$HotelLinks$hotelIdToString = function (hotelId) {
	switch (hotelId) {
		case 0:
			return 'HOTEL_TALLINK_RIGA';
		case 1:
			return 'HOTEL_TALLINK_EXPRESS';
		case 2:
			return 'HOTEL_TALLINK_SPA';
		default:
			return 'HOTEL_TALLINK_CITY';
	}
};
var $author$project$Api$Endpoint$liferayTranslations = F3(
	function (config, itemId, params) {
		return A2(
			$author$project$Api$Endpoint$Endpoint,
			$elm$core$Maybe$Nothing,
			A3(
				$elm$url$Url$Builder$crossOrigin,
				config.Ba,
				_List_fromArray(
					['api', 'jsonws', 'liferay-translation-portlet.translation', 'get-dynamic-translation', 'item-id', itemId]),
				A3(
					$author$project$Utils$List$addIf,
					config.qV,
					$author$project$Api$Endpoint$nativeAppApiKeyQueryParam,
					A2(
						$elm$core$List$cons,
						A2($elm$url$Url$Builder$string, 'mobile', 'true'),
						params))));
	});
var $author$project$Page$HotelLinks$HotelTranslations = F4(
	function (id, title, longDescription, pictureLarge) {
		return {zN: id, Bx: longDescription, k2: pictureLarge, HI: title};
	});
var $author$project$Page$HotelLinks$hotelIdFromString = function (string) {
	switch (string) {
		case 'HOTEL_TALLINK_RIGA':
			return $elm$core$Maybe$Just(0);
		case 'HOTEL_TALLINK_EXPRESS':
			return $elm$core$Maybe$Just(1);
		case 'HOTEL_TALLINK_SPA':
			return $elm$core$Maybe$Just(2);
		case 'HOTEL_TALLINK_CITY':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$HotelLinks$translationsDecoder = function () {
	var idDecoder = A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Page$HotelLinks$hotelIdFromString,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
				$elm$core$Maybe$withDefault(
					$elm$json$Json$Decode$fail('Unknown id')))),
		$elm$json$Json$Decode$string);
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'picture-large',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'long-description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subtitle',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'item-id',
					idDecoder,
					$elm$json$Json$Decode$succeed($author$project$Page$HotelLinks$HotelTranslations)))));
}();
var $author$project$Page$HotelLinks$fetchHotelTranslations = F3(
	function (language, serverConfig, hotelId) {
		var supportedLanguage = A2(
			$elm$core$List$member,
			language,
			_List_fromArray(
				[6, 9, 7])) ? 0 : language;
		var localeParam = A2(
			$elm$url$Url$Builder$string,
			'locale',
			$elm$core$String$toLower(
				$author$project$Types$Language$toString(supportedLanguage)));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, $elm$core$Basics$identity, $author$project$Page$HotelLinks$translationsDecoder),
				jW: A3(
					$author$project$Api$Endpoint$liferayTranslations,
					serverConfig,
					$author$project$Page$HotelLinks$hotelIdToString(hotelId),
					_List_fromArray(
						[localeParam]))
			});
	});
var $author$project$Page$HotelLinks$init = F3(
	function (navKey, url, session) {
		return _Utils_Tuple2(
			{nh: session.zM.Gs, kx: $elm$core$Maybe$Nothing, zH: $elm$core$Dict$empty, AK: navKey, A_: session.A_, rb: session.rb, jW: url},
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						A2($author$project$Page$HotelLinks$fetchHotelTranslations, session.A_, session.zM.Gs),
						$elm$core$Platform$Cmd$map($author$project$Page$HotelLinks$GotHotelTranslations)),
					_List_fromArray(
						[0, 1, 2, 3]))));
	});
var $author$project$Page$HotelList$DraggedCities = {$: 13};
var $author$project$Types$Hotel$cityCodeToString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Page$HotelList$citiesCountToShow = 4;
var $author$project$Page$HotelList$citiesToVisibleAndOther = function (cities) {
	var visible = A2($elm$core$List$take, $author$project$Page$HotelList$citiesCountToShow, cities);
	var other = A3(
		$elm$core$List$foldl,
		F2(
			function (a, acc) {
				return A2($elm$core$List$member, a, visible) ? acc : A2($elm$core$List$cons, a, acc);
			}),
		_List_Nil,
		cities);
	return {Dp: other, pf: visible};
};
var $author$project$Types$Hotel$CityCode = $elm$core$Basics$identity;
var $author$project$Types$Hotel$otherCityCode = 'OTHER';
var $author$project$Page$HotelList$cityCodeToVisibleCityCode = F2(
	function (cities, city) {
		return A2(
			$elm$core$List$member,
			city,
			$author$project$Page$HotelList$citiesToVisibleAndOther(cities).Dp) ? $author$project$Types$Hotel$otherCityCode : city;
	});
var $author$project$Types$Hotel$filterCitiesByHotels = F2(
	function (hotels, cities) {
		var anyCertainHotelIsFromThisCity = function (cityCode) {
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pK;
					},
					$elm$core$Basics$eq(cityCode)),
				hotels);
		};
		return A2($elm$core$List$filter, anyCertainHotelIsFromThisCity, cities);
	});
var $author$project$Utils$Time$AIsAfterB = 1;
var $author$project$Utils$Time$AIsBeforeB = 0;
var $author$project$Utils$Time$SameDays = 2;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Utils$Time$isBefore = F2(
	function (date1, date2) {
		return A2($author$project$Utils$Time$differenceInDays, date1, date2) > 0;
	});
var $author$project$Utils$Time$daysStatus = F2(
	function (a, b) {
		return A2($author$project$Utils$Time$isSameDay, a, b) ? 2 : (A2($author$project$Utils$Time$isBefore, a, b) ? 0 : 1);
	});
var $author$project$Utils$OneOrMore$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $author$project$Types$Hotel$hasAvailableRooms = F2(
	function (_v0, hotel) {
		var checkInDate = _v0.ln;
		var checkOutDate = _v0.lo;
		var nightsBetweenCheckInAndCheckOutDate = function (room) {
			return A2(
				$elm$core$List$filter,
				function (_v1) {
					var date = _v1.nn;
					var isCheckIn = A2($author$project$Utils$Time$daysStatus, date, checkInDate) === 2;
					var isBetweenCheckInAndCheckOut = (A2($author$project$Utils$Time$daysStatus, date, checkInDate) === 1) && (!A2($author$project$Utils$Time$daysStatus, date, checkOutDate));
					return isCheckIn || isBetweenCheckInAndCheckOut;
				},
				$author$project$Utils$OneOrMore$toList(room.CI));
		};
		var isAvailable = function (room) {
			return A2(
				$elm$core$List$all,
				function (night) {
					return !night.At;
				},
				nightsBetweenCheckInAndCheckOutDate(room));
		};
		return hotel.zr && A2(
			$elm$core$List$any,
			isAvailable,
			$author$project$Utils$OneOrMore$toList(hotel.F_));
	});
var $elm_community$maybe_extra$Maybe$Extra$orList = function (maybes) {
	orList:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (maybes.a.$ === 1) {
				var _v1 = maybes.a;
				var rest = maybes.b;
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue orList;
			} else {
				var answer = maybes.a.a;
				return $elm$core$Maybe$Just(answer);
			}
		}
	}
};
var $author$project$Types$Hotel$selectedHotelCity = function (_v0) {
	var dict = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.pK;
		},
		$elm$core$List$head(
			$elm$core$Dict$values(dict)));
};
var $author$project$Page$HotelList$getSelectedCity = F3(
	function (maybeSelectedCityFromHotelPage, _v0, selectedDates) {
		var hotelsAndCities = _v0.zI;
		var selectedHotelRooms = _v0.Gk;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Page$HotelList$cityCodeToVisibleCityCode(hotelsAndCities.vZ),
			$elm_community$maybe_extra$Maybe$Extra$orList(
				_List_fromArray(
					[
						maybeSelectedCityFromHotelPage,
						$author$project$Types$Hotel$selectedHotelCity(selectedHotelRooms),
						function () {
						var hotelsWithAvailableRooms = A2(
							$elm$core$List$filter,
							$author$project$Types$Hotel$hasAvailableRooms(selectedDates),
							hotelsAndCities.zH);
						return $elm$core$List$head(
							A2($author$project$Types$Hotel$filterCitiesByHotels, hotelsWithAvailableRooms, hotelsAndCities.vZ));
					}()
					])));
	});
var $author$project$Page$HotelList$CheckIn = 0;
var $author$project$Types$RouteTripSails$isOutwardOvernightSail = function (_v0) {
	var outward = _v0.Ds;
	return outward.Gg.qY;
};
var $author$project$Types$RouteTripSails$isReturnOvernightSail = function (_v0) {
	var _return = _v0.FL;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Gg;
				},
				function ($) {
					return $.qY;
				}),
			_return));
};
var $author$project$Types$CruiseMultiDepartureTrips$selectedArrivalAndDepartureTimes = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$CruiseMultiDepartureTrips$selected,
	function (a) {
		return _Utils_Tuple2(a.rS.lm, a.sw.p3);
	});
var $author$project$Types$CruiseSails$selectedArrivalAndDepartureTimes = function (_v0) {
	var cruiseSails = _v0;
	return _Utils_Tuple2(cruiseSails.Gg.b.rS.ps, cruiseSails.Gg.b.sw.nr);
};
var $author$project$Types$RouteTripSails$selectedArrivalAndDepartureTimes = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return _Utils_Tuple2(
		outward.Gg.ps,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Gg;
				},
				function ($) {
					return $.nr;
				}),
			_return));
};
var $author$project$Types$Trips$selectedArrivalAndDepartureTimes = function (trips) {
	switch (trips.$) {
		case 0:
			var cruise = trips.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Maybe$Just,
				$author$project$Types$CruiseSails$selectedArrivalAndDepartureTimes(cruise));
		case 1:
			var route = trips.a;
			return $author$project$Types$RouteTripSails$selectedArrivalAndDepartureTimes(route);
		default:
			var cruiseMultiDeparture = trips.a;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Maybe$Just,
				$author$project$Types$CruiseMultiDepartureTrips$selectedArrivalAndDepartureTimes(cruiseMultiDeparture));
	}
};
var $author$project$Types$Trips$toMaybeSuccessRouteTripSails = function (tripsStatus) {
	if ((!tripsStatus.$) && (tripsStatus.a.$ === 1)) {
		var route = tripsStatus.a.a;
		return $elm$core$Maybe$Just(route);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$HotelList$hotelBookingDates = function (session) {
	var returnOvernight = A2(
		$elm$core$Maybe$map,
		$author$project$Types$RouteTripSails$isReturnOvernightSail,
		$author$project$Types$Trips$toMaybeSuccessRouteTripSails(session.tp));
	var returnDate = A2(
		$elm$core$Maybe$andThen,
		A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedArrivalAndDepartureTimes, $elm$core$Tuple$second),
		$author$project$Types$Trips$statusToMaybe(session.tp));
	var outwardOvernight = A2(
		$elm$core$Maybe$map,
		$author$project$Types$RouteTripSails$isOutwardOvernightSail,
		$author$project$Types$Trips$toMaybeSuccessRouteTripSails(session.tp));
	var outwardDate = A2(
		$elm$core$Maybe$map,
		A3($justinmimbs$time_extra$Time$Extra$add, 12, $author$project$Constants$arrivalTimeHoursShift, $elm$time$Time$utc),
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedArrivalAndDepartureTimes, $elm$core$Tuple$first),
			$author$project$Types$Trips$statusToMaybe(session.tp)));
	return {jP: outwardDate, lI: outwardOvernight, jU: returnDate, lP: returnOvernight};
};
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Page$HotelList$initCalendar = function (session) {
	return A5(
		$elm$core$Maybe$map4,
		F4(
			function (outwardDate, outwardOvernight, returnDate, returnOvernight) {
				return {
					s: A2($elm$time$Time$toMonth, $elm$time$Time$utc, outwardDate),
					jP: outwardDate,
					lI: outwardOvernight,
					jU: returnDate,
					lP: returnOvernight,
					o: A2(
						$elm$core$Maybe$withDefault,
						{ln: outwardDate, lo: returnDate},
						A2(
							$elm$core$Maybe$map,
							function (previousBookingDates) {
								var checkInDate = previousBookingDates.ln;
								var checkOutDate = previousBookingDates.lo;
								var newReturnDateIsBeforePreviousCheckOutDate = A2($author$project$Utils$Time$differenceInDays, returnDate, checkOutDate) > 0;
								var newOutwardDateIsAfterPreviousCheckInDate = A2($author$project$Utils$Time$differenceInDays, outwardDate, checkInDate) < 0;
								return (newOutwardDateIsAfterPreviousCheckInDate || newReturnDateIsBeforePreviousCheckOutDate) ? {ln: outwardDate, lo: returnDate} : previousBookingDates;
							},
							session.zw)),
					kl: 0,
					lg: $elm$core$Maybe$Nothing,
					h: A2($elm$time$Time$toYear, $elm$time$Time$utc, outwardDate)
				};
			}),
		$author$project$Page$HotelList$hotelBookingDates(session).jP,
		$author$project$Page$HotelList$hotelBookingDates(session).lI,
		$author$project$Page$HotelList$hotelBookingDates(session).jU,
		$author$project$Page$HotelList$hotelBookingDates(session).lP);
};
var $author$project$Ports$scrollIntoView = _Platform_outgoingPort(
	'scrollIntoView',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'alignToTop',
					$elm$json$Json$Encode$bool($.t7)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.Gq))
				]));
	});
var $author$project$Page$HotelList$init = F2(
	function (maybeSelectedCityFromHotelPage, session) {
		return A2(
			$elm$core$Maybe$map,
			function (calendar) {
				var selectedCity = A3($author$project$Page$HotelList$getSelectedCity, maybeSelectedCityFromHotelPage, session, calendar.o);
				return _Utils_Tuple2(
					{
						w: calendar,
						md: {lR: false, lS: false},
						kx: $elm$core$Maybe$Nothing,
						lu: $elm$core$Maybe$Nothing,
						kH: selectedCity,
						Gk: session.Gk
					},
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									function (a) {
										return $author$project$Ports$scrollIntoView(
											{
												t7: false,
												Gq: '[data-city=\'' + ($author$project$Types$Hotel$cityCodeToString(a) + '\']')
											});
									},
									selectedCity)),
								A2(
								$elm$core$Task$perform,
								function (_v0) {
									return $author$project$Page$HotelList$DraggedCities;
								},
								$elm$core$Process$sleep(0))
							])));
			},
			$author$project$Page$HotelList$initCalendar(session));
	});
var $author$project$Model$BusTransferList = {$: 5};
var $author$project$Messages$BusTransfersMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Messages$GotTransfers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Bus$Transfer$BusTransfer = F3(
	function (codeFrom, city, station) {
		return {v0: city, wn: codeFrom, GS: station};
	});
var $author$project$Types$Bus$Transfer$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translation',
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(','),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$drop(1),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$join(','),
					A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$json$Json$Decode$succeed)))),
		$elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translation',
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split(','),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$take(1),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$join(''),
						A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$json$Json$Decode$succeed)))),
			$elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'codeFrom',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Types$Bus$Transfer$BusTransfer))));
var $author$project$Api$Endpoint$transfersList = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['transfers', 'list']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.tj));
	});
var $author$project$Api$BusTransfer$getTransfers = F3(
	function (_v0, httpConfig, resultToMsg) {
		var language = _v0.A_;
		var isExperimental = _v0.Aa;
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					resultToMsg,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['transfers']),
						$elm$json$Json$Decode$list($author$project$Types$Bus$Transfer$decoder))),
				jW: A2(
					$author$project$Api$Endpoint$transfersList,
					httpConfig.Gs,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						isExperimental,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_List_fromArray(
								[
									$author$project$Api$Util$guidParam(httpConfig.Gt),
									$author$project$Api$Util$localeParam(language)
								]))))
			});
	});
var $author$project$Messages$NoOp = {$: 139};
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Update$scrollToTop = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Messages$NoOp;
	},
	A2($elm$browser$Browser$Dom$setViewport, 0, 0));
var $author$project$Update$initBusTransferListPage = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{DF: $author$project$Model$BusTransferList}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$elm$core$List$isEmpty(session.H_) ? A2(
					$author$project$Update$Util$cancelRequestAndRunCmd,
					$author$project$Api$Endpoint$trackers.tj,
					A3(
						$author$project$Api$BusTransfer$getTransfers,
						model.j,
						session.zM,
						A2($elm$core$Basics$composeL, $author$project$Messages$BusTransfersMsg, $author$project$Messages$GotTransfers))) : $elm$core$Platform$Cmd$none,
					$author$project$Update$scrollToTop
				])));
};
var $author$project$Update$scrollToTopAndHideToast = function (model) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Update$scrollToTop,
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$ToastMsg,
				$author$project$Common$Toast$hideToastCmd(model.HT.zN))
			]));
};
var $author$project$Common$Ports$showBackButton = _Platform_outgoingPort(
	'showBackButton',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Update$initConnectionProblemPage = function (model) {
	var session = model.j;
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				(!session.Am) ? $author$project$Common$Ports$showBackButton(0) : $author$project$Common$Ports$hideBackButton(0),
				$author$project$Update$scrollToTopAndHideToast(model)
			]));
};
var $author$project$Model$ContactPersonPage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Types$Phone$infoList = A2($elm$core$List$map, $author$project$Types$Phone$getInfo, $author$project$Types$Market$enum);
var $author$project$ContactPersonPage$Model$countryCodeByPhoneOrDefaultByMarket = F2(
	function (phoneNumber, market) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$Phone$getInfo(market).pQ,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.pQ;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						function (a) {
							return A2($elm$core$String$startsWith, a, phoneNumber);
						}),
					$author$project$Types$Phone$infoList)));
	});
var $author$project$ContactPersonPage$Model$modelFromAgent = F3(
	function (market, _v0, _v1) {
		var details = _v0.yt;
		var firstName = _v1.y2;
		var lastName = _v1.A6;
		var email = _v1.yI;
		var phone = _v1.ox;
		return {
			p$: A2($author$project$ContactPersonPage$Model$countryCodeByPhoneOrDefaultByMarket, phone, market),
			yI: email,
			y2: firstName,
			A6: lastName,
			ox: phone,
			jX: details.tT.IG
		};
	});
var $author$project$ContactPersonPage$Model$initUsingAgent = function (session) {
	return A3(
		$elm$core$Maybe$map2,
		$author$project$ContactPersonPage$Model$modelFromAgent(session.rb),
		session.xA,
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.tZ;
			},
			session.xA));
};
var $author$project$ContactPersonPage$Model$findClubOnePassenger = function (ageCategory) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm_community$list_extra$List$Extra$find(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pO;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$Basics$eq(ageCategory)))),
		$elm$core$Array$toList);
};
var $author$project$ContactPersonPage$Model$modelFromPassenger = F2(
	function (market, contactPerson) {
		return {
			p$: A2(
				$author$project$ContactPersonPage$Model$countryCodeByPhoneOrDefaultByMarket,
				A2($elm$core$Maybe$withDefault, '', contactPerson.ox),
				market),
			yI: A2($elm$core$Maybe$withDefault, '', contactPerson.yI),
			y2: contactPerson.y2,
			A6: contactPerson.A6,
			ox: A2($elm$core$Maybe$withDefault, '', contactPerson.ox),
			jX: A2($elm$core$Maybe$withDefault, '', contactPerson.jX)
		};
	});
var $author$project$ContactPersonPage$Model$initUsingClubOnePassenger = F2(
	function (ageCategory, session) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$ContactPersonPage$Model$modelFromPassenger(session.rb),
			A2($author$project$ContactPersonPage$Model$findClubOnePassenger, ageCategory, session.Eg));
	});
var $author$project$ContactPersonPage$Model$findFirstPassenger = function (ageCategory) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$List$head,
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$Basics$eq(ageCategory)))),
		$elm$core$Array$toList);
};
var $author$project$ContactPersonPage$Model$initUsingPassenger = F2(
	function (ageCategory, session) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$ContactPersonPage$Model$modelFromPassenger(session.rb),
			A2($author$project$ContactPersonPage$Model$findFirstPassenger, ageCategory, session.Eg));
	});
var $author$project$ContactPersonPage$Model$modelFromContactPerson = F2(
	function (market, contactPerson) {
		return function (countryCode) {
			return {
				p$: countryCode,
				yI: contactPerson.yI,
				y2: contactPerson.y2,
				A6: contactPerson.A6,
				ox: A2($author$project$ContactPersonPage$Util$removeCountryCode, countryCode, contactPerson.ox),
				jX: contactPerson.jX
			};
		}(
			A2($author$project$ContactPersonPage$Model$countryCodeByPhoneOrDefaultByMarket, contactPerson.ox, market));
	});
var $author$project$ContactPersonPage$Model$initUsingPassengerJoiningClubOne = function (session) {
	return _Utils_eq(session.AE, $author$project$Types$JoinClubOneState$Joining) ? A2(
		$elm$core$Maybe$map,
		$author$project$ContactPersonPage$Model$modelFromContactPerson(session.rb),
		session.BQ) : $elm$core$Maybe$Nothing;
};
var $author$project$ContactPersonPage$Model$findPassengerWithName = function (ageCategory) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm_community$list_extra$List$Extra$find(
				function (_v0) {
					var firstName = _v0.y2;
					var lastName = _v0.A6;
					return (!$elm$core$String$isEmpty(firstName)) || (!$elm$core$String$isEmpty(lastName));
				}),
			$elm$core$List$filter(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$Basics$eq(ageCategory)))),
		$elm$core$Array$toList);
};
var $author$project$ContactPersonPage$Model$initUsingPassengerWithName = F2(
	function (ageCategory, session) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$ContactPersonPage$Model$modelFromPassenger(session.rb),
			A2($author$project$ContactPersonPage$Model$findPassengerWithName, ageCategory, session.Eg));
	});
var $author$project$ContactPersonPage$Model$modelFromMarket = function (market) {
	return {
		p$: A2($author$project$ContactPersonPage$Model$countryCodeByPhoneOrDefaultByMarket, '', market),
		yI: '',
		y2: '',
		A6: '',
		ox: '',
		jX: ''
	};
};
var $author$project$ContactPersonPage$Model$init = function (session) {
	var market = session.rb;
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$ContactPersonPage$Model$modelFromMarket(market),
		A2(
			$author$project$Types$Maybe$Util$orElse,
			A2($author$project$ContactPersonPage$Model$initUsingPassenger, 1, session),
			A2(
				$author$project$Types$Maybe$Util$orElse,
				A2($author$project$ContactPersonPage$Model$initUsingPassenger, 0, session),
				A2(
					$author$project$Types$Maybe$Util$orElse,
					A2($author$project$ContactPersonPage$Model$initUsingPassengerWithName, 1, session),
					A2(
						$author$project$Types$Maybe$Util$orElse,
						A2($author$project$ContactPersonPage$Model$initUsingPassengerWithName, 0, session),
						A2(
							$author$project$Types$Maybe$Util$orElse,
							A2($author$project$ContactPersonPage$Model$initUsingClubOnePassenger, 1, session),
							A2(
								$author$project$Types$Maybe$Util$orElse,
								A2($author$project$ContactPersonPage$Model$initUsingClubOnePassenger, 0, session),
								A2(
									$author$project$Types$Maybe$Util$orElse,
									$author$project$ContactPersonPage$Model$initUsingPassengerJoiningClubOne(session),
									$author$project$ContactPersonPage$Model$initUsingAgent(session)))))))));
};
var $author$project$Types$JoinClubOneState$resetErrorStates = function (state) {
	return (!_Utils_eq(state, $author$project$Types$JoinClubOneState$Joining)) ? $author$project$Types$JoinClubOneState$NotJoining : state;
};
var $author$project$Update$initContactPersonPage = function (model) {
	var session = model.j;
	var resetJoinClubOneErrorStates = function (a) {
		return _Utils_update(
			a,
			{
				AE: $author$project$Types$JoinClubOneState$resetErrorStates(session.AE)
			});
	};
	return _Utils_Tuple2(
		function (a) {
			return _Utils_update(
				a,
				{
					j: resetJoinClubOneErrorStates(a.j)
				});
		}(
			function (a) {
				return _Utils_update(
					model,
					{
						DF: $author$project$Model$ContactPersonPage(a)
					});
			}(
				$author$project$ContactPersonPage$Model$init(model.j))),
		$author$project$Update$scrollToTopAndHideToast(model));
};
var $author$project$Types$Hotel$HotelCode = $elm$core$Basics$identity;
var $author$project$Types$Hotel$hotelCodeFromString = function (str) {
	return str;
};
var $author$project$Page$Hotel$init = F3(
	function (toastModel, session, hotelCode) {
		var selectedHotel = A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.pQ;
				},
				$elm$core$Basics$eq(hotelCode)),
			session.zI.zH);
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (hotel, hotelBookingDates) {
					return {zv: hotel, zw: hotelBookingDates, lv: false, k6: $elm$core$Maybe$Nothing, Gk: session.Gk, HT: toastModel};
				}),
			selectedHotel,
			session.zw);
	});
var $author$project$Update$initHotelPage = F2(
	function (code, model) {
		var session = model.j;
		var toastModel = model.HT;
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				model,
				A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$Root)),
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								DF: $author$project$Model$Hotel(a)
							}),
						$author$project$Update$scrollToTopAndHideToast(model));
				},
				A3(
					$author$project$Page$Hotel$init,
					toastModel,
					session,
					$author$project$Types$Hotel$hotelCodeFromString(code))));
	});
var $author$project$Model$KlarnaPayment = {$: 12};
var $author$project$Ports$renderKlarnaSnippet = _Platform_outgoingPort('renderKlarnaSnippet', $elm$core$Basics$identity);
var $author$project$Update$initKlarnaPaymentPage = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{DF: $author$project$Model$KlarnaPayment}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					session.Am ? $elm$core$Platform$Cmd$none : $author$project$UrlRoute$back(model.AK),
					A2($elm$core$Maybe$map, $author$project$Ports$renderKlarnaSnippet, session.BS)),
					$author$project$Update$scrollToTopAndHideToast(model)
				])));
};
var $author$project$MealPage$Update$findSelectedMealForOneOfTheSittings = function (sittings) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$SelectedMeals$toList,
		$elm_community$list_extra$List$Extra$find(
			function (a) {
				return A2(
					$elm$core$List$any,
					$author$project$Types$Meals$isSameSitting(a),
					sittings);
			}));
};
var $author$project$MealPage$Update$toSitting = function (_v0) {
	var restaurantCode = _v0.FJ;
	var beginDateTime = _v0.ut;
	return {ut: beginDateTime, FJ: restaurantCode};
};
var $author$project$MealPage$Update$initMenu = F2(
	function (maybeOutwardSelectedMeal, maybeReturnSelectedMeal) {
		var maybeSelectedMeal = A2($elm_community$maybe_extra$Maybe$Extra$orElse, maybeReturnSelectedMeal, maybeOutwardSelectedMeal);
		return A2(
			$elm$core$Maybe$map,
			function (selectedMeal) {
				return {
					wo: selectedMeal.wo,
					p7: _Utils_eq(maybeSelectedMeal, maybeOutwardSelectedMeal) ? 0 : 1,
					BY: A2($elm$core$Maybe$map, $author$project$MealPage$Update$toSitting, maybeOutwardSelectedMeal),
					B$: A2($elm$core$Maybe$map, $author$project$MealPage$Update$toSitting, maybeReturnSelectedMeal),
					HI: selectedMeal.HI
				};
			},
			maybeSelectedMeal);
	});
var $author$project$Types$Meals$isMenuSupported = function (meal) {
	return !_Utils_eq(meal.BN, $elm$core$Maybe$Nothing);
};
var $author$project$MealPage$Update$init = function (_v0) {
	var meals = _v0.rv;
	var selectedOutwardMeals = _v0.Gn;
	var selectedReturnMeals = _v0.Go;
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(a.HI, a);
			},
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var outwardSittings = _v1.kC;
						var returnSittings = _v1.k4;
						return A2(
							$author$project$MealPage$Update$initMenu,
							A2($author$project$MealPage$Update$findSelectedMealForOneOfTheSittings, outwardSittings, selectedOutwardMeals),
							A2($author$project$MealPage$Update$findSelectedMealForOneOfTheSittings, returnSittings, selectedReturnMeals));
					},
					A2(
						$elm$core$List$filter,
						$author$project$Types$Meals$isMenuSupported,
						$author$project$Types$Meals$toList(meals))))));
};
var $author$project$Update$initMealPage = function (model) {
	var session = model.j;
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(
			_Utils_update(
				model,
				{
					DF: $author$project$Model$MealPage($elm$core$Dict$empty)
				}),
			$elm$core$Platform$Cmd$none),
		A2(
			$elm$core$Maybe$map,
			function (meals) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							DF: $author$project$Model$MealPage(
								$author$project$MealPage$Update$init(
									{rv: meals, Gn: session.Gn, Go: session.Go}))
						}),
					$author$project$Update$scrollToTopAndHideToast(model));
			},
			session.ri));
};
var $author$project$Messages$GotCitizenships = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Endpoint$citizenships = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['citizenships']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Types$Citizenship$Citizenship = F3(
	function (code, name, popular) {
		return {pQ: code, oh: name, E1: popular};
	});
var $author$project$Types$Citizenship$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Citizenship$Citizenship,
	A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'popular', $elm$json$Json$Decode$bool));
var $author$project$Update$fetchCitizenships = F4(
	function (toMsg, language, market, config) {
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, toMsg),
					A2(
						$elm$json$Json$Decode$map,
						function (values) {
							return A2(
								$elm$core$List$filterMap,
								A2(
									$elm$core$Basics$composeR,
									$elm$json$Json$Decode$decodeValue($author$project$Types$Citizenship$decoder),
									$elm$core$Result$toMaybe),
								values);
						},
						$elm$json$Json$Decode$list($elm$json$Json$Decode$value))),
				jW: A2(
					$author$project$Api$Endpoint$citizenships,
					config,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var a = _v0.a;
							var b = _v0.b;
							return A2($elm$url$Url$Builder$string, a, b);
						},
						_List_fromArray(
							[
								$author$project$Api$Util$localeParam(language),
								$author$project$Api$Util$marketParam(market)
							])))
			});
	});
var $author$project$Update$addCitizenshipsRequest = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: function (a) {
					return _Utils_update(
						a,
						{v$: $krisajenkins$remotedata$RemoteData$Loading});
				}(model.j)
			}),
		A4($author$project$Update$fetchCitizenships, $author$project$Messages$GotCitizenships, session.A_, session.rb, session.zM.Gs));
};
var $author$project$Utils$Time$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$Types$Date$toDay = function (_v0) {
	var day = _v0.q;
	return day;
};
var $author$project$Types$Date$toMonth = function (_v0) {
	var month = _v0.s;
	return month;
};
var $author$project$Types$Date$toYear = function (_v0) {
	var year = _v0.h;
	return year;
};
var $author$project$PassengerDetailsPage$Model$init = F5(
	function (isSoloYouthAllowed, i, market, passengers, passenger) {
		return {
			l4: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Types$Date$toDay, $elm$core$String$fromInt),
					passenger.uw)),
			l5: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$Date$toMonth,
						A2($elm$core$Basics$composeR, $author$project$Utils$Time$monthToInt, $elm$core$String$fromInt)),
					passenger.uw)),
			l6: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Types$Date$toYear, $elm$core$String$fromInt),
					passenger.uw)),
			v_: A2(
				$elm$core$Maybe$withDefault,
				(market === 5) ? A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.v_;
							},
							$elm$core$Array$toList(passengers)))) : $author$project$Types$Market$toString(market),
				passenger.v_),
			we: A2($elm$core$Maybe$withDefault, '', passenger.we),
			mr: passenger.A6,
			zf: A2($elm$core$Maybe$withDefault, 1, passenger.zf),
			zj: passenger.y2,
			qH: i,
			qP: false,
			q$: isSoloYouthAllowed,
			rf: $elm$core$Maybe$Nothing,
			rr: $elm$core$Maybe$Nothing,
			a: passenger,
			tq: 0
		};
	});
var $author$project$Update$initPassengerDetailsPage = F2(
	function (i, model) {
		var session = model.j;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (a) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							a,
							$author$project$Update$scrollToTopAndHideToast(model)
						]));
			},
			((!$krisajenkins$remotedata$RemoteData$isSuccess(session.v$)) ? $author$project$Update$addCitizenshipsRequest : function (a) {
				return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
			})(
				A2(
					$elm$core$Maybe$withDefault,
					model,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return _Utils_update(
								model,
								{
									DF: $author$project$Model$PassengerDetailsPage(a)
								});
						},
						A2(
							$elm$core$Maybe$map,
							A4(
								$author$project$PassengerDetailsPage$Model$init,
								$author$project$Update$Passengers$isSoloYouthAllowed(model.j),
								i,
								model.j.rb,
								session.Eg),
							A2($elm$core$Array$get, i, session.Eg))))));
	});
var $author$project$Model$Root = {$: 0};
var $author$project$UrlRoute$addParam = F2(
	function (url, param) {
		return _Utils_update(
			url,
			{
				Fo: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						param,
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return a + ('&' + param);
							},
							url.Fo)))
			});
	});
var $author$project$UrlRoute$addIgnoreHistoryParam = function (url) {
	return A2($author$project$UrlRoute$addParam, url, $author$project$UrlRoute$ignoreHistoryParam);
};
var $author$project$Utils$SelectedMeals$isMealWithRestaurantCode = F2(
	function (meal, _v0) {
		var outwardSittings = _v0.kC;
		var returnSittings = _v0.k4;
		var sittings = _Utils_ap(outwardSittings, returnSittings);
		return A2(
			$elm$core$List$any,
			function (_v1) {
				var restaurantCode = _v1.FJ;
				var beginDateTime = _v1.ut;
				return _Utils_eq(restaurantCode, meal.FJ) && _Utils_eq(beginDateTime, meal.ut);
			},
			sittings);
	});
var $author$project$Utils$SelectedMeals$findCorrespondingMeal = F2(
	function (meals, selectedMeal) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (meal) {
				return A2($author$project$Utils$SelectedMeals$isMealWithRestaurantCode, selectedMeal, meal);
			},
			$author$project$Types$Meals$toList(meals));
	});
var $author$project$Types$Meals$getNonEmptyCategoriesCount = function (_v0) {
	var starters = _v0.GR;
	var mainCourses = _v0.BD;
	var desserts = _v0.ys;
	var foodPackages = _v0.y6;
	var drinkPackages = _v0.yE;
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$elm$core$Basics$eq(false),
			A2(
				$elm$core$List$map,
				$elm$core$List$isEmpty,
				_List_fromArray(
					[starters, mainCourses, desserts, foodPackages, drinkPackages]))));
};
var $author$project$Types$Passenger$Util$countYouthsPassengers = function (passengers) {
	return A2($author$project$Types$Passenger$Util$countPassengersOfAgeCategory, passengers, 1);
};
var $author$project$MealPage$Menu$Util$isGroupMenuAllowed = F2(
	function (session, _v0) {
		var isGroupMenuSupported = _v0.qQ;
		var minGroupMenuPassengers = _v0.rw;
		var maybeAddons = _v0.BN;
		if (!maybeAddons.$) {
			return isGroupMenuSupported && (_Utils_cmp(
				$elm$core$Array$length(session.Eg),
				minGroupMenuPassengers) > -1);
		} else {
			return false;
		}
	});
var $author$project$MealPage$Menu$Util$isWithAverageMenu = function (_v0) {
	var isGroupMenuSupported = _v0.qQ;
	var minGroupMenuPassengers = _v0.rw;
	var maybeAddons = _v0.BN;
	if (!maybeAddons.$) {
		return !isGroupMenuSupported;
	} else {
		return false;
	}
};
var $author$project$MealPage$Menu$Util$getPassengersWithMenuCount = F2(
	function (session, meal) {
		return A2($author$project$MealPage$Menu$Util$isGroupMenuAllowed, session, meal) ? $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg) : ($author$project$MealPage$Menu$Util$isWithAverageMenu(meal) ? ($author$project$Types$Passenger$Util$countAdultPassengers(session.Eg) + $author$project$Types$Passenger$Util$countYouthsPassengers(session.Eg)) : 0);
	});
var $author$project$Utils$SelectedMeals$isWithIncompleteSelection = F3(
	function (session, meals, selectedMeal) {
		var maybeCorrespondingMeal = A2($author$project$Utils$SelectedMeals$findCorrespondingMeal, meals, selectedMeal);
		var maybeCorrespondingMenu = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.BN;
			},
			maybeCorrespondingMeal);
		var getRequiredAddonsCount = F2(
			function (meal, menu) {
				var passengersWithMenuCount = A2($author$project$MealPage$Menu$Util$getPassengersWithMenuCount, session, meal);
				var nonEmptyCategoriesCount = $author$project$Types$Meals$getNonEmptyCategoriesCount(menu);
				return passengersWithMenuCount * nonEmptyCategoriesCount;
			});
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (meal, menu) {
						return _Utils_cmp(
							$elm$core$List$length(selectedMeal.tS),
							A2(getRequiredAddonsCount, meal, menu)) < 0;
					}),
				maybeCorrespondingMeal,
				maybeCorrespondingMenu));
	});
var $author$project$Utils$SelectedMeals$findMealWithIncompleteSelection = function (session) {
	var maybeMeals = session.ri;
	var selectedOutwardMeals = session.Gn;
	var selectedReturnMeals = session.Go;
	return A2(
		$elm$core$Maybe$andThen,
		function (meals) {
			return A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$SelectedMeals$findCorrespondingMeal(meals),
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2($author$project$Utils$SelectedMeals$isWithIncompleteSelection, session, meals),
					_Utils_ap(
						$author$project$Types$SelectedMeals$toList(selectedOutwardMeals),
						$author$project$Types$SelectedMeals$toList(selectedReturnMeals))));
		},
		maybeMeals);
};
var $author$project$Ports$scrollTo = _Platform_outgoingPort(
	'scrollTo',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.zN))
				]));
	});
var $author$project$Ports$scrollToTop = _Platform_outgoingPort(
	'scrollToTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$UrlRoute$scrollOnNavigationToRoot = function (previousRoute) {
	var scrollTo = function (id) {
		return $author$project$Ports$scrollTo(
			{zN: id});
	};
	return _Utils_eq(previousRoute, $author$project$UrlRoute$Root) ? $elm$core$Platform$Cmd$none : A2(
		$elm$core$Maybe$withDefault,
		$author$project$Ports$scrollToTop(0),
		A2(
			$elm$core$Maybe$map,
			scrollTo,
			function () {
				switch (previousRoute.$) {
					case 1:
						return $elm$core$Maybe$Just('itinerary-panel');
					case 2:
						return $elm$core$Maybe$Just('vehicle-panel');
					case 6:
						return $elm$core$Maybe$Just('bustransfer-panel');
					case 5:
						return $elm$core$Maybe$Just('bustransfer-panel');
					case 8:
						return $elm$core$Maybe$Just('passenger-panel');
					case 9:
						return $elm$core$Maybe$Just('travelclass-panel');
					case 10:
						return $elm$core$Maybe$Just('meal-panel');
					case 16:
						return $elm$core$Maybe$Just('extraservices-panel');
					case 15:
						return $elm$core$Maybe$Just('onboardservices-panel');
					case 17:
						return $elm$core$Maybe$Just('voucher-panel');
					case 18:
						return $elm$core$Maybe$Just('land-service-panel');
					case 20:
						return $elm$core$Maybe$Just('hotel-panel');
					case 21:
						return $elm$core$Maybe$Just('hotel-panel');
					default:
						return $elm$core$Maybe$Nothing;
				}
			}()));
};
var $author$project$Common$Toast$showToastCmdWithParams = F4(
	function (toastType, translate, isPermanent, params) {
		return $author$project$Common$Toast$performImmediately(
			A5($author$project$Common$Toast$showToastMsg, toastType, translate, isPermanent, false, params));
	});
var $author$project$Update$initRootPage = function (model) {
	var session = model.j;
	var location = model.n1;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{DF: $author$project$Model$Root}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$String$contains,
					$author$project$UrlRoute$ignoreHistoryParam,
					A2($elm$core$Maybe$withDefault, '', location.Fo)) ? $elm$core$Platform$Cmd$none : A3(
					$author$project$UrlRoute$replaceUrl,
					model.AK,
					$author$project$UrlRoute$addIgnoreHistoryParam(location),
					$author$project$UrlRoute$Root),
					(!session.Am) ? $author$project$Common$Ports$showBackButton(0) : $author$project$Common$Ports$hideBackButton(0),
					function () {
					var _v0 = $author$project$Utils$SelectedMeals$findMealWithIncompleteSelection(model.j);
					if (!_v0.$) {
						var meal = _v0.a;
						var translationKey = $author$project$MealPage$Menu$Util$isWithAverageMenu(meal) ? function ($) {
							return $.dE;
						} : function ($) {
							return $.dD;
						};
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Messages$ToastMsg,
							A4(
								$author$project$Common$Toast$showToastCmdWithParams,
								2,
								translationKey,
								true,
								_List_fromArray(
									[
										_Utils_Tuple2('restaurant', meal.HI)
									])));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}(),
					_Utils_eq(model.DF, $author$project$Model$BusTransfer) ? A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Messages$ToastMsg,
					$author$project$Common$Toast$hideToastCmd(model.HT.zN)) : $elm$core$Platform$Cmd$none,
					$author$project$UrlRoute$scrollOnNavigationToRoot(
					$author$project$UrlRoute$parseLocation(location))
				])));
};
var $author$project$TimetablePage$Model$routeDirection = function (route) {
	switch (route) {
		case 2:
			return 1;
		case 0:
			return 0;
		case 3:
			return 1;
		default:
			return 0;
	}
};
var $author$project$TimetablePage$Model$maybeCurrentTimetableLeg = function (route) {
	switch (route.$) {
		case 3:
			var timetableDirectionRoute = route.a;
			return $elm$core$Maybe$Just(
				$author$project$TimetablePage$Model$routeDirection(timetableDirectionRoute));
		case 4:
			var timetableDirectionRoute = route.a;
			return $elm$core$Maybe$Just(
				$author$project$TimetablePage$Model$routeDirection(timetableDirectionRoute));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$TimetablePage$Model$init = F2(
	function (route, previousModel) {
		return {
			pk: A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$TimetablePage$Model$maybeCurrentTimetableLeg(route)),
			qb: '',
			qX: true,
			nY: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.nY;
					},
					previousModel)),
			oP: A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.oP;
					},
					previousModel)),
			Gp: A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Gp;
					},
					previousModel)),
			GA: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.GA;
					},
					previousModel)),
			sQ: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.sQ;
					},
					previousModel))
		};
	});
var $author$project$Update$initTimetablePage = F2(
	function (timetableRoute, model) {
		return A2(
			$elm$core$Tuple$mapFirst,
			function (a) {
				return _Utils_update(
					model,
					{
						DF: $author$project$Model$Timetable(a)
					});
			},
			function () {
				var _v0 = model.DF;
				if (_v0.$ === 1) {
					var pageModel = _v0.a;
					return _Utils_Tuple2(
						A2(
							$author$project$TimetablePage$Model$init,
							timetableRoute,
							$elm$core$Maybe$Just(pageModel)),
						$author$project$Update$scrollToTop);
				} else {
					return _Utils_Tuple2(
						A2($author$project$TimetablePage$Model$init, timetableRoute, $elm$core$Maybe$Nothing),
						$author$project$Update$scrollToTopAndHideToast(model));
				}
			}());
	});
var $author$project$Model$TravelClass = {$: 9};
var $author$project$TravelClassPage$Model$init = {pB: $elm$core$Dict$empty, pC: $elm$core$Dict$empty, rJ: _List_Nil};
var $author$project$TravelClassPage$View$selectedTravelClassId = 'first-selected-travelclass';
var $author$project$Update$initTravelClassPage = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{DF: $author$project$Model$TravelClass, H0: $author$project$TravelClassPage$Model$init}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always($author$project$Messages$NoOp),
					A2($elm$browser$Browser$Dom$setViewport, 0, 0)),
					$author$project$Ports$scrollTo(
					{zN: $author$project$TravelClassPage$View$selectedTravelClassId})
				])));
};
var $author$project$Update$initPage = F2(
	function (url, model) {
		var session = model.j;
		var route = $author$project$UrlRoute$parseLocation(url);
		switch (route.$) {
			case 0:
				return $author$project$Update$initRootPage(model);
			case 1:
				var timetableRoute = route.a;
				return A2($author$project$Update$initTimetablePage, timetableRoute, model);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$Vehicle}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$VehicleList}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$Payment}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$BusTransfer}),
					$author$project$Update$scrollToTop);
			case 5:
				return $author$project$Update$initBusTransferListPage(model);
			case 7:
				var i = route.a;
				return A2($author$project$Update$initPassengerDetailsPage, i, model);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$PassengerList}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 9:
				return $author$project$Update$initTravelClassPage(model);
			case 10:
				return $author$project$Update$initMealPage(model);
			case 11:
				return $author$project$Update$initContactPersonPage(model);
			case 12:
				return $author$project$Update$initKlarnaPaymentPage(model);
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							DF: $author$project$Model$CompanyCustomer($author$project$Page$Company$init)
						}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$OnboardService}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$ExtraServices}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							DF: $author$project$Model$DiscountPage($author$project$Page$Discount$Update$init)
						}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{DF: $author$project$Model$LandService}),
					$author$project$Update$scrollToTopAndHideToast(model));
			case 20:
				var maybeSelectedCityFromHotelPage = function () {
					var _v2 = model.DF;
					if (_v2.$ === 20) {
						var a = _v2.a;
						return $elm$core$Maybe$Just(a.zv.pK);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						model,
						A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$Root)),
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var a = _v1.a;
							var b = _v1.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										DF: $author$project$Model$HotelList(a)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Messages$HotelListMsg, b),
											$author$project$Update$scrollToTopAndHideToast(model)
										])));
						},
						A2($author$project$Page$HotelList$init, maybeSelectedCityFromHotelPage, session)));
			case 21:
				var code = route.a;
				return A2($author$project$Update$initHotelPage, code, model);
			case 13:
				return _Utils_Tuple2(
					model,
					$author$project$Update$initConnectionProblemPage(model));
			default:
				return A2(
					$elm$core$Tuple$mapSecond,
					function (a) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Messages$HotelLinksMsg, a),
									$author$project$Common$Ports$showBackButton(0)
								]));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						function (a) {
							return _Utils_update(
								model,
								{
									DF: $author$project$Model$HotelLinks(a)
								});
						},
						A3($author$project$Page$HotelLinks$init, model.AK, model.n1, model.j)));
		}
	});
var $author$project$Update$changeLocationTo = F2(
	function (url, model) {
		return A2(
			$elm$core$Tuple$mapFirst,
			function (a) {
				return _Utils_update(
					a,
					{
						pz: function (page) {
							return _Utils_update(
								page,
								{GD: true});
						}(a.pz),
						n1: url
					});
			},
			A2(
				$author$project$Update$Util$andThen,
				$author$project$Update$initPage(url),
				A2($author$project$Update$exit, url, model)));
	});
var $author$project$UrlRoute$changeToOutwardTimetableRoute = function (route) {
	_v0$4:
	while (true) {
		if (route.$ === 1) {
			switch (route.a.$) {
				case 3:
					switch (route.a.a) {
						case 2:
							var _v1 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$Shuttle(0));
						case 3:
							var _v3 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$Shuttle(1));
						default:
							break _v0$4;
					}
				case 4:
					switch (route.a.a) {
						case 2:
							var _v2 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$RouteTrip(0));
						case 3:
							var _v4 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$RouteTrip(1));
						default:
							break _v0$4;
					}
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return route;
};
var $author$project$UrlRoute$changeToReturnTimetableRoute = function (route) {
	_v0$4:
	while (true) {
		if (route.$ === 1) {
			switch (route.a.$) {
				case 3:
					switch (route.a.a) {
						case 0:
							var _v1 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$Shuttle(2));
						case 1:
							var _v3 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$Shuttle(3));
						default:
							break _v0$4;
					}
				case 4:
					switch (route.a.a) {
						case 0:
							var _v2 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$RouteTrip(2));
						case 1:
							var _v4 = route.a.a;
							return $author$project$UrlRoute$Timetable(
								$author$project$UrlRoute$RouteTrip(3));
						default:
							break _v0$4;
					}
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return route;
};
var $author$project$Types$SelectedVehicles$changeVehicleVoyageType = F3(
	function (index, maybeVehicleVoyageType, _v0) {
		var first = _v0.nx;
		var others = _v0.lH;
		return (!index) ? {
			nx: _Utils_update(
				first,
				{Aj: true, tx: maybeVehicleVoyageType}),
			lH: others
		} : A2(
			$elm$core$Maybe$withDefault,
			{nx: first, lH: others},
			A2(
				$elm$core$Maybe$map,
				function (selectedVehicle) {
					return A3(
						$elm$core$Basics$composeR,
						A2(
							$elm$core$Array$set,
							index - 1,
							_Utils_update(
								selectedVehicle,
								{Aj: true, tx: maybeVehicleVoyageType})),
						function (newOthers) {
							return {nx: first, lH: newOthers};
						},
						others);
				},
				A2($elm$core$Array$get, index - 1, others)));
	});
var $author$project$Update$Vehicles$changeVehicleVoyageType = F3(
	function (model, index, maybeVehicleVoyageType) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Types$SelectedVehicles$changeVehicleVoyageType, index, maybeVehicleVoyageType),
					A2(
						$elm$core$Basics$composeR,
						$author$project$Update$Vehicles$setSelectedVehiclesToSession(model.j),
						function (newSession) {
							return _Utils_update(
								model,
								{j: newSession});
						})),
				model.j.rp));
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Update$Passengers$isEmptyPassengerWithAgeCategory = F2(
	function (ageCategory, passenger) {
		return _Utils_eq(passenger.tY, ageCategory) && ($elm$core$String$isEmpty(passenger.y2) && $elm$core$String$isEmpty(passenger.A6));
	});
var $author$project$Update$Passengers$isSamePassenger = F2(
	function (newPassenger, passenger) {
		return A2($author$project$Types$Passenger$areNamesEqualIgnoringCapitalization, passenger, newPassenger) && _Utils_eq(passenger.we, newPassenger.we);
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var tail = $elm$core$List$tail(
				A2($elm$core$List$drop, index, l));
			var head = A2($elm$core$List$take, index, l);
			if (tail.$ === 1) {
				return l;
			} else {
				var t = tail.a;
				return A2($elm$core$List$append, head, t);
			}
		}
	});
var $author$project$Update$Passengers$addClubOneClient = F4(
	function (soloYouthAllowed, outwardSailDate, passengers, client) {
		var hasNoChildren = A2(
			$elm$core$List$all,
			function (p) {
				return (p.tY !== 3) && (p.tY !== 2);
			},
			passengers);
		var ageCategory = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return $author$project$Types$AgeCategory$fromAge(
						A2($author$project$Utils$Time$differenceOfDatesInYears, a, outwardSailDate));
				},
				A2($elm$core$Maybe$map, $author$project$Types$Date$toPosix, client.re)));
		var newPassenger = {
			tY: ageCategory,
			uw: client.re,
			v_: $elm$core$Maybe$Just(client.v_),
			v5: $elm$core$Maybe$Just(client.v5),
			pO: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.A8;
				},
				client.BP),
			we: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.k$;
				},
				client.BP),
			wf: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.E0;
				},
				client.BP),
			yI: $elm$core$Maybe$Just(client.yI),
			y2: client.y2,
			zf: client.rg,
			A6: client.A6,
			ox: $elm$core$Maybe$Just(client.ox),
			jX: $elm$core$Maybe$Just(client.jX)
		};
		var maybePassengerIndexToRemove = A2(
			$author$project$Types$Maybe$Util$orElse,
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				$author$project$Update$Passengers$isEmptyPassengerWithAgeCategory(
					((ageCategory === 1) && (hasNoChildren && soloYouthAllowed)) ? 0 : newPassenger.tY),
				passengers),
			A2(
				$author$project$Types$Maybe$Util$orElse,
				A2(
					$elm_community$list_extra$List$Extra$findIndex,
					$author$project$Update$Passengers$isEmptyPassengerWithAgeCategory(newPassenger.tY),
					passengers),
				A2(
					$elm_community$list_extra$List$Extra$findIndex,
					$author$project$Update$Passengers$isSamePassenger(newPassenger),
					passengers)));
		return $elm$core$Array$fromList(
			A2(
				$elm$core$List$cons,
				newPassenger,
				A2(
					$elm$core$Maybe$withDefault,
					passengers,
					A2(
						$elm$core$Maybe$map,
						function (i) {
							return A2($elm_community$list_extra$List$Extra$removeAt, i, passengers);
						},
						maybePassengerIndexToRemove))));
	});
var $author$project$Update$User$addClubOneClient = F2(
	function (session, client) {
		var outwardSailDate = A2(
			$elm$core$Maybe$withDefault,
			session.kJ,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
				$author$project$Types$Trips$statusToMaybe(session.tp)));
		return _Utils_update(
			session,
			{
				Eg: A4(
					$author$project$Update$Passengers$addClubOneClient,
					$author$project$Update$Passengers$isSoloYouthAllowed(session),
					outwardSailDate,
					$elm$core$Array$toList(session.Eg),
					client)
			});
	});
var $author$project$Utils$Time$fromDateString = function (dateString) {
	var dateParts = A2(
		$elm$core$List$filterMap,
		$elm$core$String$toInt,
		A2($elm$core$String$split, '-', dateString));
	if (((dateParts.b && dateParts.b.b) && dateParts.b.b.b) && (!dateParts.b.b.b.b)) {
		var year = dateParts.a;
		var _v1 = dateParts.b;
		var monthNumber = _v1.a;
		var _v2 = _v1.b;
		var day = _v2.a;
		return A2(
			$elm$core$Maybe$map,
			function (month) {
				return A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$elm$time$Time$utc,
					A7($justinmimbs$time_extra$Time$Extra$Parts, year, month, day, 0, 0, 0, 0));
			},
			$author$project$Utils$Time$monthFromInt(monthNumber));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Client$isCluboneClient = function (client) {
	return !_Utils_eq(client.BP, $elm$core$Maybe$Nothing);
};
var $author$project$Types$Trips$isLoadingNothing = function (status) {
	if ((status.$ === 2) && (status.a.$ === 1)) {
		var _v1 = status.a;
		return true;
	} else {
		return false;
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$Char$toUpper = _Char_toUpper;
var $author$project$Tracking$capitalizeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split(' '),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (str) {
				var _v0 = $elm$core$String$uncons(str);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var firstLetter = _v1.a;
					var others = _v1.b;
					return A2(
						$elm$core$String$cons,
						$elm$core$Char$toUpper(firstLetter),
						others);
				} else {
					return str;
				}
			}),
		$elm$core$String$join(' ')));
var $author$project$Tracking$encodeHttpError = F2(
	function (type_, error) {
		return function (message) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string('HttpError')),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(message))
					]));
		}(
			function () {
				switch (error.$) {
					case 0:
						var message = error.a;
						return $author$project$Tracking$capitalizeString(type_) + (' BadUrl: ' + message);
					case 1:
						return $author$project$Tracking$capitalizeString(type_) + ' Timeout';
					case 2:
						return $author$project$Tracking$capitalizeString(type_) + ' NetworkError';
					case 3:
						var status = error.a;
						return $author$project$Tracking$capitalizeString(type_) + (' BadStatus: ' + $elm$core$String$fromInt(status));
					default:
						var message = error.a;
						return $author$project$Tracking$capitalizeString(type_) + (' BadBody: ' + message);
				}
			}());
	});
var $author$project$Tracking$logError = _Platform_outgoingPort('logError', $elm$core$Basics$identity);
var $author$project$Tracking$logHttpError = F2(
	function (kind, error) {
		return $author$project$Tracking$logError(
			A2($author$project$Tracking$encodeHttpError, kind, error));
	});
var $author$project$Utils$Time$nothingIfBefore = F2(
	function (threshold, date) {
		return A2($author$project$Utils$Time$isBefore, date, threshold) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(date);
	});
var $author$project$Utils$String$capitalize = function (string) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, string)),
		$elm$core$String$toLower(
			A2($elm$core$String$dropLeft, 1, string)));
};
var $author$project$Utils$String$capitalizeFirstLetters = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[^\\s\\-]+')),
	function (_v0) {
		var match = _v0.BJ;
		return $author$project$Utils$String$capitalize(match);
	});
var $author$project$Common$Toast$showClubOneLoginSuccessToast = function (_v0) {
	var givenName = _v0.zj;
	return A4(
		$author$project$Common$Toast$showToastCmdWithParams,
		0,
		function ($) {
			return $.HQ;
		},
		false,
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$author$project$Utils$String$capitalizeFirstLetters(givenName))
			]));
};
var $author$project$Update$User$updateClient = F2(
	function (client, model) {
		return A2(
			$author$project$Update$User$updateUser,
			{v4: client, Cb: model.j.Ia.Cb},
			model);
	});
var $author$project$Update$User$clientResponse = F2(
	function (model, response) {
		var newModel = A2($author$project$Update$User$updateClient, response, model);
		var session = newModel.j;
		switch (response.$) {
			case 3:
				var client = response.a;
				return $author$project$Types$Client$isCluboneClient(client) ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$List$singleton,
					A3(
						$author$project$Update$Util$andThenIf,
						!session.vk,
						$author$project$Update$Trips$fetchTripsWithTimes(
							{
								F4: $elm$core$Maybe$Nothing,
								ld: session.kJ,
								mZ: $author$project$Types$Trips$isLoadingNothing(session.tp) ? A2(
									$elm$core$Maybe$andThen,
									$author$project$Utils$Time$nothingIfBefore(session.kJ),
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Utils$Time$fromDateString,
										$author$project$UrlRoute$bookingParamsFromLocation(model.n1).nn)) : A2(
									$elm$core$Maybe$map,
									A3($justinmimbs$time_extra$Time$Extra$add, 13, -91, $elm$time$Time$utc),
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
										$author$project$Types$Trips$statusToMaybe(session.tp)))
							}),
						_Utils_Tuple2(
							_Utils_update(
								newModel,
								{
									j: A2($author$project$Update$User$addClubOneClient, session, client)
								}),
							$elm$core$Platform$Cmd$batch(
								A3(
									$author$project$Utils$List$addIf,
									!model.qV,
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Messages$ToastMsg,
										$author$project$Common$Toast$showClubOneLoginSuccessToast(
											{zj: client.y2})),
									_List_Nil))))) : _Utils_Tuple2(newModel, _List_Nil);
			case 2:
				var error = response.a;
				return _Utils_Tuple2(
					newModel,
					(_Utils_eq(error, $elm$http$Http$NetworkError) ? $elm$core$List$cons(
						A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$ConnectionProblem)) : $elm$core$Basics$identity)(
						_List_fromArray(
							[
								A2($author$project$Tracking$logHttpError, 'clientResponse', error)
							])));
			case 0:
				return _Utils_Tuple2(newModel, _List_Nil);
			default:
				return _Utils_Tuple2(newModel, _List_Nil);
		}
	});
var $author$project$Common$Modal$Model$Closing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Messages$FinishedClosingModal = {$: 122};
var $author$project$Update$Modal$close = function (model) {
	var modal = model.CC;
	if (!modal.$) {
		var modalType = modal.a;
		var position = modal.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					CC: $author$project$Common$Modal$Model$Closing(modalType)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Task$perform,
						function (_v1) {
							return $author$project$Messages$FinishedClosingModal;
						},
						$elm$core$Task$succeed(0)),
						A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Messages$NoOp),
						A2($elm$browser$Browser$Dom$setViewport, 0, position))
					])));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$UrlRoute$closeModal = F2(
	function (navKey, url) {
		if (!navKey.$) {
			var key = navKey.a;
			return A2(
				$elm$browser$Browser$Navigation$replaceUrl,
				key,
				$elm$url$Url$toString(
					$author$project$UrlRoute$removeModalParam(url)));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm_community$list_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$Messages$GotHotelPackages = function (a) {
	return {$: 22, a: a};
};
var $author$project$Api$Timetable$getUrlParamsForHotelPackages = F5(
	function (httpConfig, bookingParams, session, dateFrom, dateTo) {
		var _v0 = session;
		var isOneWay = _v0.qW;
		var from = _v0.kS;
		var to = _v0.le;
		var voyageType = _v0.tx;
		var language = _v0.A_;
		var market = _v0.rb;
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			session.Aa,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A2(
					$elm$core$List$filter,
					function (a) {
						return !$elm$core$String$isEmpty(a.b);
					},
					_List_fromArray(
						[
							$author$project$Api$Util$guidParam(httpConfig.Gt),
							$author$project$Api$Util$localeParam(language),
							$author$project$Api$Util$marketParam(market),
							$author$project$Api$Util$dateFromParam(
							$author$project$Utils$Time$toDateString(dateFrom)),
							$author$project$Api$Util$dateToParam(
							$author$project$Utils$Time$toDateString(dateTo)),
							_Utils_Tuple2(
							'portFrom',
							$author$project$Types$Port$toString(from)),
							_Utils_Tuple2(
							'portTo',
							$author$project$Types$Port$toString(to)),
							_Utils_Tuple2(
							'enableOvernightInDefaultSelection',
							$author$project$Utils$String$fromBool(
								A2($elm$core$Maybe$withDefault, false, bookingParams.yK)))
						]))));
	});
var $author$project$Api$Endpoint$hotelPackages = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['hotelpackages']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.qE));
	});
var $author$project$Types$Hotel$cityCodeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$Hotel$Hotel = function (code) {
	return function (cityCode) {
		return function (location) {
			return function (rating) {
				return function (name) {
					return function (description) {
						return function (imageUrl) {
							return function (hasRoom) {
								return function (checkInTime) {
									return function (checkOutTime) {
										return function (rooms) {
											return {mb: checkInTime, mc: checkOutTime, pK: cityCode, pQ: code, nt: description, zr: hasRoom, zP: imageUrl, n1: location, oh: name, mQ: rating, F_: rooms};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$OneOrMore$OneOrMore = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$OneOrMore$checkList = function (list) {
	if (!list.b) {
		return $elm$json$Json$Decode$fail('An array with one or more elements.');
	} else {
		var x = list.a;
		var xs = list.b;
		return $elm$json$Json$Decode$succeed(
			A2($author$project$Utils$OneOrMore$OneOrMore, x, xs));
	}
};
var $author$project$Utils$OneOrMore$decoder = function (entryDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Utils$OneOrMore$checkList,
		$elm$json$Json$Decode$list(entryDecoder));
};
var $author$project$Types$Hotel$hotelCodeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$Hotel$Room = F7(
	function (code, name, description, longDescription, imageUrl, thumbnailUrl, nights) {
		return {pQ: code, nt: description, zP: imageUrl, Bx: longDescription, oh: name, CI: nights, Ht: thumbnailUrl};
	});
var $author$project$Types$Hotel$Night = F3(
	function (date, isSoldOut, isVoucherApplicable) {
		return {nn: date, At: isSoldOut, q0: isVoucherApplicable};
	});
var $author$project$Types$Hotel$nightDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'isVoucherApplicable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'isSoldOut',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'date',
			$author$project$Utils$Time$decoder,
			$elm$json$Json$Decode$succeed($author$project$Types$Hotel$Night))));
var $author$project$Types$Hotel$RoomCode = $elm$core$Basics$identity;
var $author$project$Types$Hotel$roomCodeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Types$Hotel$roomDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nights',
	$author$project$Utils$OneOrMore$decoder($author$project$Types$Hotel$nightDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'thumbnailUrl',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'imageUrl',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'longDescription',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$author$project$Types$Hotel$roomCodeDecoder,
							$elm$json$Json$Decode$succeed($author$project$Types$Hotel$Room))))))));
var $author$project$Types$Hotel$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rooms',
	$author$project$Utils$OneOrMore$decoder($author$project$Types$Hotel$roomDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'checkOutTime',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'checkInTime',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hasRoom',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'imageUrl',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'rating',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'district',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'cityCode',
										$author$project$Types$Hotel$cityCodeDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'code',
											$author$project$Types$Hotel$hotelCodeDecoder,
											$elm$json$Json$Decode$succeed($author$project$Types$Hotel$Hotel))))))))))));
var $author$project$Types$SailsData$DefaultSelections = F2(
	function (outward, _return) {
		return {Ds: outward, FL: _return};
	});
var $author$project$Types$SailsData$defaultSelectionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'returnSail',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outwardSail',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Types$SailsData$DefaultSelections)));
var $author$project$Types$RouteTripSails$findSelectableReturnSail = F2(
	function (bookingType, outwardSail) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Types$RouteTripSails$sortByDepartureDate,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap($author$project$Types$RouteTripSail$toReal),
				$elm_community$list_extra$List$Extra$find(
					function (returnSail) {
						return ((bookingType === 1) ? A2($author$project$Types$RouteTripSails$haveNightBetweenSails, outwardSail, returnSail) : (A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, outwardSail, returnSail) && (!_Utils_eq(
							outwardSail.Gx,
							$elm$core$Maybe$Just(returnSail.F3))))) && ((!returnSail.mA) && returnSail.zr);
					})));
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Hotel$getHotelAvailabilityBorder = F2(
	function (from, hotels) {
		var rooms = A2(
			$elm$core$List$map,
			function (room) {
				return A2(
					$elm$core$List$filter,
					function (_v1) {
						var date = _v1.nn;
						return _Utils_cmp(
							date,
							$elm$time$Time$posixToMillis(from)) > 0;
					},
					A2(
						$elm$core$List$map,
						function (_v0) {
							var isSoldOut = _v0.At;
							var date = _v0.nn;
							return {
								nb: !isSoldOut,
								nn: $elm$time$Time$posixToMillis(date) + (((24 * 60) * 60) * 1000)
							};
						},
						$author$project$Utils$OneOrMore$toList(room.CI)));
			},
			A3(
				$elm$core$List$foldl,
				F2(
					function (hotel, acc) {
						return _Utils_ap(
							acc,
							$author$project$Utils$OneOrMore$toList(hotel.F_));
					}),
				_List_Nil,
				hotels));
		var indexesOfFirstUnavailableNight = A2(
			$elm$core$List$map,
			$elm_community$list_extra$List$Extra$findIndex(
				function (a) {
					return !a.nb;
				}),
			rooms);
		if (A2($elm$core$List$member, $elm$core$Maybe$Nothing, indexesOfFirstUnavailableNight)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var longestAvailableRoomIndex = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$maximum(
					A2(
						$elm$core$List$map,
						$elm$core$Maybe$withDefault(0),
						indexesOfFirstUnavailableNight)));
			return $elm$core$Maybe$Just(
				$elm$time$Time$millisToPosix(
					A2(
						$elm$core$Maybe$withDefault,
						{
							nb: true,
							nn: $elm$time$Time$posixToMillis(from)
						},
						A2(
							$elm$core$Array$get,
							longestAvailableRoomIndex,
							$elm$core$Array$fromList(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$elm$core$List$head(rooms))))).nn));
		}
	});
var $author$project$Types$RouteTripSails$initTripsFromHotelPackages = function (_v0) {
	var outwardSail = _v0.rS;
	var defaultReturnSailId = _v0.ym;
	var outwardSails = _v0.lJ;
	var returnSails = _v0.FR;
	var direction = _v0.p7;
	var targetDate = _v0.Hd;
	var outwardSailHotelAvailabilityBorder = _v0.Dy;
	var _v1 = function () {
		if (!direction) {
			return _Utils_Tuple2(
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.F3;
							},
							$elm$core$Basics$eq(defaultReturnSailId)),
						A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, returnSails))),
				$elm$core$Maybe$Nothing);
		} else {
			var returnSailAfterTargetDate = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v3) {
						var departureIsoDate = _v3.nr;
						return _Utils_cmp(
							$elm$time$Time$posixToMillis(departureIsoDate),
							$elm$time$Time$posixToMillis(targetDate)) > 0;
					},
					A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return (_Utils_cmp(
									$elm$time$Time$posixToMillis(a.nr),
									$elm$time$Time$posixToMillis(b.nr)) > 0) ? 2 : 0;
							}),
						A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, returnSails))));
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(returnSailAfterTargetDate, $elm$core$Maybe$Nothing),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (border, sailAfterTargetDate) {
							return (_Utils_cmp(
								$elm$time$Time$posixToMillis(sailAfterTargetDate.nr),
								$elm$time$Time$posixToMillis(border)) > 0) ? _Utils_Tuple2(
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (_v2) {
											var departureIsoDate = _v2.nr;
											return _Utils_cmp(
												$elm$time$Time$posixToMillis(departureIsoDate),
												$elm$time$Time$posixToMillis(border)) < 0;
										},
										A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, returnSails))),
								returnSailAfterTargetDate) : _Utils_Tuple2(returnSailAfterTargetDate, $elm$core$Maybe$Nothing);
						}),
					outwardSailHotelAvailabilityBorder,
					returnSailAfterTargetDate));
		}
	}();
	var returnSail = _v1.a;
	var selectedSailWithoutHotels = _v1.b;
	var _v4 = _Utils_Tuple2(outwardSail, returnSail);
	if ((!_v4.a.$) && (!_v4.b.$)) {
		var a = _v4.a.a;
		var b = _v4.b.a;
		return {
			F6: $elm$core$Maybe$Just(
				{
					mg: false,
					Ds: {H: outwardSails, Gg: a},
					FL: $elm$core$Maybe$Just(
						{H: returnSails, Gg: b})
				}),
			Gp: selectedSailWithoutHotels
		};
	} else {
		return {F6: $elm$core$Maybe$Nothing, Gp: $elm$core$Maybe$Nothing};
	}
};
var $author$project$Types$RouteTripSails$isReturnSailSuitableForHotelPackage = F3(
	function (hotels, outwardSail, returnSail) {
		var hotelAvailabilityBorder = A2(
			$author$project$Types$Hotel$getHotelAvailabilityBorder,
			A4($justinmimbs$time_extra$Time$Extra$add, 12, $author$project$Constants$arrivalTimeHoursShift, $elm$time$Time$utc, outwardSail.ps),
			hotels);
		var beforeHotelAvailabilityBorder = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (border) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(returnSail.nr),
						$elm$time$Time$posixToMillis(border)) < 0;
				},
				hotelAvailabilityBorder));
		return A2($author$project$Types$RouteTripSails$haveNightBetweenSails, outwardSail, returnSail) && beforeHotelAvailabilityBorder;
	});
var $author$project$Types$SailsData$hotelPackagesDecoder = function (_v0) {
	var bookingType = _v0.vk;
	var direction = _v0.p7;
	var maybePreviousSelectedSails = _v0.rl;
	var maybeIsTurStoOvernightTrip = _v0.rh;
	var targetDate = _v0.Hd;
	return A5(
		$elm$json$Json$Decode$map4,
		F4(
			function (hotels, defaultSelections, cities, timetable) {
				var outwardSail = (!direction) ? $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.F3;
							},
							$elm$core$Basics$eq(defaultSelections.Ds)),
						A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, timetable.DC))) : A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybePreviousSelectedSails);
				var hotelsWithRoom = A2(
					$elm$core$List$filter,
					function ($) {
						return $.zr;
					},
					hotels);
				var outwardSailHotelAvailabilityBorder = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A2(
								$author$project$Types$Hotel$getHotelAvailabilityBorder,
								A4($justinmimbs$time_extra$Time$Extra$add, 12, $author$project$Constants$arrivalTimeHoursShift, $elm$time$Time$utc, a.ps),
								hotelsWithRoom);
						},
						outwardSail));
				var disabledOutwardSails = A2(
					$elm$core$List$filter,
					function (a) {
						var nextSelectableReturnSail = A3($author$project$Types$RouteTripSails$findSelectableReturnSail, 1, a, timetable.FV);
						return A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									A2($author$project$Types$RouteTripSails$isReturnSailSuitableForHotelPackage, hotelsWithRoom, a),
									$elm$core$Basics$not),
								nextSelectableReturnSail));
					},
					A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, timetable.DC));
				var _v1 = $author$project$Types$RouteTripSails$initTripsFromHotelPackages(
					{ym: defaultSelections.FL, p7: direction, rS: outwardSail, Dy: outwardSailHotelAvailabilityBorder, lJ: timetable.DC, FR: timetable.FV, Hd: targetDate});
				var sails = _v1.F6;
				var selectedSailWithoutHotels = _v1.Gp;
				return {
					vZ: cities,
					yx: disabledOutwardSails,
					zH: hotelsWithRoom,
					Dy: outwardSailHotelAvailabilityBorder,
					Gp: selectedSailWithoutHotels,
					tc: {F: timetable.F, lA: sails}
				};
			}),
		A2(
			$elm$json$Json$Decode$field,
			'hotels',
			$elm$json$Json$Decode$list($author$project$Types$Hotel$decoder)),
		A2($elm$json$Json$Decode$field, 'defaultSelections', $author$project$Types$SailsData$defaultSelectionsDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'cities',
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['code']),
					$author$project$Types$Hotel$cityCodeDecoder))),
		A2(
			$elm$json$Json$Decode$field,
			'timetable',
			A2(
				$elm$json$Json$Decode$map,
				function (a) {
					var returns = A2(
						$elm$json$Json$Decode$decodeValue,
						$author$project$Types$SailsData$decodeRouteTripSailsByKey('returns'),
						a);
					var outwards = A2(
						$elm$json$Json$Decode$decodeValue,
						$author$project$Types$SailsData$decodeRouteTripSailsByKey('outwards'),
						a);
					var errors = A2(
						$elm$core$Result$withDefault,
						_List_Nil,
						A3(
							$elm$core$Result$map2,
							F2(
								function (outwardResult, returnResult) {
									return $elm$core$List$concat(
										_List_fromArray(
											[outwardResult.F, returnResult.F]));
								}),
							outwards,
							returns));
					return {
						F: errors,
						DC: A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.F6;
								},
								$elm$core$Result$toMaybe(outwards))),
						FV: A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.F6;
								},
								$elm$core$Result$toMaybe(returns)))
					};
				},
				$elm$json$Json$Decode$value)));
};
var $author$project$Api$Timetable$createHotelPackagesRequest = F8(
	function (bookingParams, session, dateFrom, dateTo, targetDate, direction, maybePreviousSelectedSails, maybeIsTurStoOvernightTrip) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.qE,
			$author$project$Api$getWithCredentials(
				{
					j9: A2(
						$elm$http$Http$expectJson,
						$author$project$Messages$GotHotelPackages,
						$author$project$Types$SailsData$hotelPackagesDecoder(
							{vk: session.vk, p7: direction, rh: maybeIsTurStoOvernightTrip, rl: maybePreviousSelectedSails, Hd: targetDate})),
					jW: A2(
						$author$project$Api$Endpoint$hotelPackages,
						session.zM.Gs,
						A5($author$project$Api$Timetable$getUrlParamsForHotelPackages, session.zM, bookingParams, session, dateFrom, dateTo))
				}));
	});
var $author$project$Types$CabinSurprise$defaultSelectedSurprises = {DC: $elm$core$Dict$empty, FV: $elm$core$Dict$empty};
var $author$project$Ports$executeRecaptcha = _Platform_outgoingPort(
	'executeRecaptcha',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Api$Timetable$fetchHotelPackages = F2(
	function (times, model) {
		var session = model.j;
		var routeTripSails = function () {
			var _v0 = session.tp;
			if ((!_v0.$) && (_v0.a.$ === 1)) {
				var route = _v0.a.a;
				return $elm$core$Maybe$Just(route);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var startDate = A2(
			$elm$core$Maybe$withDefault,
			A2($elm$core$Maybe$withDefault, times.ld, times.mZ),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$RouteTripSails$available(session.vk),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filterMap($author$project$Types$RouteTripSail$toReal),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$head,
								$elm$core$Maybe$map(
									function ($) {
										return $.nr;
									}))))),
				routeTripSails));
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.qE,
			A8(
				$author$project$Api$Timetable$createHotelPackagesRequest,
				$author$project$UrlRoute$bookingParamsFromLocation(model.n1),
				session,
				startDate,
				A4($justinmimbs$time_extra$Time$Extra$add, 3, $author$project$Api$Timetable$amountOfWeeksToFetch, $elm$time$Time$utc, startDate),
				startDate,
				0,
				$elm$core$Maybe$Nothing,
				A4($author$project$Utils$Route$isTurStoOvernightTrip, model.n1, session.mm, session.kS, session.le)));
	});
var $author$project$Update$Trips$fetchHotelPackages = function (model) {
	var session = model.j;
	var timeFrom = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$Time$nothingIfBefore(session.kJ),
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$Time$fromDateString,
			$author$project$UrlRoute$bookingParamsFromLocation(model.n1).nn));
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						pr: false,
						Ad: false,
						Af: true,
						B7: $elm$core$Maybe$Nothing,
						B8: $elm$core$Maybe$Nothing,
						tp: function () {
							var _v0 = session.tp;
							if (_v0.$ === 2) {
								var trips = _v0.a;
								return $author$project$Types$Trips$Loading(trips);
							} else {
								return $author$project$Types$Trips$Loading(
									$author$project$Types$Trips$statusToMaybe(session.tp));
							}
						}()
					})
			}),
		A2(
			$author$project$Api$Timetable$fetchHotelPackages,
			{F4: $elm$core$Maybe$Nothing, ld: session.kJ, mZ: timeFrom},
			model));
};
var $author$project$Utils$OneOrMore$fromList = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A2($author$project$Utils$OneOrMore$OneOrMore, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$CruiseMultiDepartureTrips$getDepartureTimeFromDestination = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$CruiseMultiDepartureTrips$selected,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.sw;
		},
		function ($) {
			return $.p3;
		}));
var $author$project$Types$CruiseSails$getDepartureTimeFromDestination = function (_v0) {
	var cruiseSails = _v0;
	return cruiseSails.Gg.b.sw.nr;
};
var $author$project$Types$RouteTripSails$getDepartureTimeFromDestination = function (_v0) {
	var _return = _v0.FL;
	return A2(
		$elm$core$Maybe$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Gg;
			},
			function ($) {
				return $.nr;
			}),
		_return);
};
var $author$project$Types$Trips$getOnshoreEndTime = function (trips) {
	switch (trips.$) {
		case 0:
			var cruise = trips.a;
			return $elm$core$Maybe$Just(
				$author$project$Types$CruiseSails$getDepartureTimeFromDestination(cruise));
		case 1:
			var route = trips.a;
			return $author$project$Types$RouteTripSails$getDepartureTimeFromDestination(route);
		default:
			var cruiseMultiDeparture = trips.a;
			return $elm$core$Maybe$Just(
				$author$project$Types$CruiseMultiDepartureTrips$getDepartureTimeFromDestination(cruiseMultiDeparture));
	}
};
var $author$project$Types$CruiseMultiDepartureTrips$getArrivalTimeAtDestination = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$CruiseMultiDepartureTrips$selected,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.rS;
		},
		function ($) {
			return $.lm;
		}));
var $author$project$Types$CruiseSails$getArrivalTimeAtDestination = function (_v0) {
	var cruiseSails = _v0;
	return cruiseSails.Gg.b.rS.ps;
};
var $author$project$Types$RouteTripSails$getArrivalTimeAtDestination = function (_v0) {
	var outward = _v0.Ds;
	return outward.Gg.ps;
};
var $author$project$Types$Trips$getOnshoreStartTime = function (trips) {
	switch (trips.$) {
		case 0:
			var cruise = trips.a;
			return $author$project$Types$CruiseSails$getArrivalTimeAtDestination(cruise);
		case 1:
			var route = trips.a;
			return $author$project$Types$RouteTripSails$getArrivalTimeAtDestination(route);
		default:
			var cruiseMultiDeparture = trips.a;
			return $author$project$Types$CruiseMultiDepartureTrips$getArrivalTimeAtDestination(cruiseMultiDeparture);
	}
};
var $author$project$Session$keepLandServiceWithAnyAvailableEvent = F2(
	function (session, service) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							$author$project$Types$Trips$getOnshoreStartTime(a)),
						$author$project$Types$Trips$getOnshoreEndTime(a));
				},
				$author$project$Types$Trips$statusToMaybe(session.tp)));
		var onshoreStart = _v0.a;
		var onshoreEnd = _v0.b;
		var isStartBeforeOnshoreEnd = function (event) {
			return A2(
				$elm$core$Maybe$withDefault,
				true,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (startPosix, onshoreEndPosix) {
							return _Utils_cmp(startPosix, onshoreEndPosix) < 0;
						}),
					A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, event.o5),
					A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, onshoreEnd)));
		};
		var isEndAfterOnshoreStart = function (event) {
			return A2(
				$elm$core$Maybe$withDefault,
				true,
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (endPosix, onshoreStartPosix) {
							return _Utils_cmp(endPosix, onshoreStartPosix) > -1;
						}),
					A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, event.yN),
					A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, onshoreStart)));
		};
		return A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_update(
					service,
					{mq: a});
			},
			$author$project$Utils$OneOrMore$fromList(
				A2(
					$elm$core$List$filter,
					function (a) {
						return isStartBeforeOnshoreEnd(a) && isEndAfterOnshoreStart(a);
					},
					$author$project$Utils$OneOrMore$toList(service.mq))));
	});
var $author$project$Session$filterLandServiceEventsOutsideOfOnshoreTime = function (session) {
	var filter = $elm$core$List$filterMap(
		$author$project$Session$keepLandServiceWithAnyAvailableEvent(session));
	return _Utils_update(
		session,
		{
			AZ: A2($krisajenkins$remotedata$RemoteData$map, filter, session.AZ)
		});
};
var $author$project$Types$PaymentServiceProvider$findServiceProviderByCode = F2(
	function (code, providers) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (provider) {
				return _Utils_eq(provider.pQ, code);
			},
			providers);
	});
var $author$project$Types$PaymentServiceProviderCode$Adyen = 1;
var $author$project$PaymentPage$Model$Invoice = {$: 1};
var $author$project$Types$PaymentServiceProviderCode$Klarna = 2;
var $author$project$PaymentPage$Model$PaymentService = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$PaymentServiceProviderCode$Swedbank = 0;
var $author$project$PaymentPage$Model$paymentMethodsOrder = _List_fromArray(
	[
		$author$project$PaymentPage$Model$PaymentService(0),
		$author$project$PaymentPage$Model$PaymentService(1),
		$author$project$PaymentPage$Model$PaymentService(2),
		$author$project$PaymentPage$Model$Invoice
	]);
var $author$project$PaymentPage$Model$findDefaultPaymentMethod = function (_v0) {
	var paymentServiceProviders = _v0.Ey;
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$first,
		A2(
			$elm_community$list_extra$List$Extra$find,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$map,
				function (paymentMethod) {
					var available = function () {
						if (!paymentMethod.$) {
							var code = paymentMethod.a;
							return !_Utils_eq(
								A2($author$project$Types$PaymentServiceProvider$findServiceProviderByCode, code, paymentServiceProviders),
								$elm$core$Maybe$Nothing);
						} else {
							return false;
						}
					}();
					return _Utils_Tuple2(paymentMethod, available);
				},
				$author$project$PaymentPage$Model$paymentMethodsOrder)));
};
var $author$project$PaymentPage$Model$findSelectedPaymentMethod = F2(
	function (market, paymentMethods) {
		return (market === 1) ? $elm$core$Maybe$Nothing : $author$project$PaymentPage$Model$findDefaultPaymentMethod(paymentMethods);
	});
var $author$project$Translations$Generated$de = {P: 'Lesen Sie unsere Barrierefreiheitserklärung', Q: 'https://www.tallink.com/de/barrierefreiheit', tJ: 'hinzufügen', R: 'Weiteren Rabattcode hinzufügen', S: 'Um Fahrzeuge hinzuzufügen, füge bitte mehr erwachsene Passagiere hinzu. Fahrräder können auch für Kinder von 6-17 Jahren hinzugefügt werden.', tK: 'Fügen Sie Räume für alle Passagiere hinzu', pl: 'Hinzu', tM: 'Travelling on route {route} is possible only with a vehicle.', tN: 'Would you like to add a vehicle to {route} route aswell?', tO: 'Add route?', T: 'Åland', t_: 'Åland (Långnäs)', t$: 'Åland (Mariehamn)', ue: 'Sie haben bereits Zimmer in einem anderen Hotel ausgewählt. Um einen Raum in diesem zu wählen, müssen Sie zuerst Ihre aktuelle Auswahl löschen.', uj: 'Minikreuzfahrt', ul: 'Abbruch & Buchung fortführen', um: 'Weiter mit Desktop Version', un: 'Wenn Du zur Desktop Ansicht wechselst, musst Du folgende Angaben noch einmal machen: <span class=\"bodyBold\">Passagierdaten, Kabinenkategorie, Mahlzeiten</span>.', uo: 'Einige Auswahlen gehen verloren.', up: 'Wenn Du mit der Desktop-Version fortfährst, verlierst Du folgende Auswahlmöglichkeiten: <span class = \"bodyBold\"> Passagierinformationen und Mahlzeiten </ span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Bank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'Banking', aa: 'Wähle Deine Bank aus, um fortzufahren.', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click Login oder Handynummer', ah: 'Zuletzt ausgewählt', ai: 'Säästöpankki', aj: 'SEB', ak: 'Bank auswählen', al: 'S-Pankki', am: 'Swedbank', uB: 'Abendessen buchen', uC: 'Buche diese Reisen separat:', uD: 'Onboard-Services hinzufügen', uE: 'Zum Desktop &rarr;', uF: 'Benötigst Du noch etwas, was hier nicht zur Auswahl steht?', uG: 'Fügen Sie Bustransfers hinzu', uH: 'Zum und vom Hafen', uI: 'Buchung mit Firmen-ID', ao: 'Buche einfacher, nutze Deine Rabatte', ap: 'Ausloggen &rarr;', uJ: 'Einloggen', aq: 'Hast Du einen einen Club One Account?', ar: 'Zeige mögliche Daten', uK: 'Der Rabattcode kann für die ausgewählte Reise nicht verwendet werden. Bitte wähle ein anderes Abreisedatum, eine andere Route oder eine andere Reiseklasse.', as: 'Überprüfe den Code und versuche es nochmal', uL: 'Schließen', at: 'Der Buchungscode wird angewendet.', au: 'Der Code ist korrekt', uM: 'Bitte überprüfe den Code und versuche es erneut. Der Code wird gesperrt, wenn Du ihn gerade verwendet hast. Du kannst es in 20 Minuten erneut versuchen.', av: 'Code kann geblockt werden. Sollte dies der Fall sein warte 30 Min. und versuchen es noch einmal.', aw: 'Der Rabatt ist eingesetzt', ax: 'Rabattcode', ay: 'Dieser Code ist für das gewählte Reisedatum nicht wählbar', az: 'Du kannst ihn für andere Daten verwenden', aA: 'Der ursprüngliche Preis  {oldPrice}wurde in {discountedPrice} geändert', aB: 'Der ursprüngliche Preis {oldPrice} ist jetzt auf {discountedPrice} reduziert', aC: 'Entfernen', uN: 'Der Code ist korrekt. Bitte wähle zuerst Deine Kabine aus, um einen Rabatt zu erhalten.', uO: 'Um eine Geschenkkarte zu verwenden, rufe bitte +49 40 547 541 222 an', aD: 'Rabattcode aktiviert', aE: 'Ich habe einen Gutscheincode', aF: 'Punkte', uP: 'Zusätzliche Dienste hinzufügen', aG: 'Fast track', aH: 'Garage', aI: 'Versicherung', uQ: 'Plane mit Zuversicht', aJ: 'Priority Car', uR: 'Wählen Sie den Abfahrtsort', uS: 'NachWählen Sie Ihre Destination', aK: 'Reise buchen', uT: '22-Stunden MiniCruise', uU: 'Cruise', uV: 'Cruise', uW: 'Kein Landgang in der Destination', py: 'Kein Landgang in der Destination', uX: 'Tag in Helsinki Cruise', uY: 'Tag in Riga Kreuzfahrt', uZ: 'Tag in Stockholm Minikreuzfahrt', u_: 'Abfahrt am', u$: 'Bitte beachte, dass das Schiff nicht die Bedürfnisse von Passagieren mit Behinderungen erfüllt.', aL: 'Keine Ausschiffung in Tallinn', u0: 'Zürück an', u1: 'Einfache Überfahrt', u2: 'Round Trip', aM: 'Megastar Shopping- Cruise', u3: 'Einfache Überfahrt', u4: 'Roundtrip', ne: 'Datum', aN: 'Reisekategorie', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Wähle Deine Sprache', aV: 'Deutsch', aW: 'Möchtest Du die Sprache ändern?', u5: 'Mahlzeiten auswählen', aX: 'Mahlzeiten können an Bord gebucht werden', u6: 'Keine Mahlzeiten verfügbar', u7: 'Bestelle Mahlzeiten im Voraus spare', u8: 'Mahlzeiten', aY: 'Ich habe einen Gutscheincode', u9: 'Weitere Services', aZ: 'Die Buchung muss genau ein Fahrzeug haben.', va: 'Covid-19', a_: 'Covid-19 Test', vb: 'Kinder Armbänder', vc: 'Massage', vd: 'Passagiere', ve: 'Registriere Dich beim Club One &rarr;', vf: 'https://clubone.tallink.com/de/mitglied-werden', vg: 'Ausloggen &rarr;', vh: 'Erhalte Club One Rabatte und buche noch einfacher', a$: 'Kabine wählen', vi: 'Reiseklasse', vj: 'Kabinen', a0: 'Fahrrad, E-Scooter', a1: 'PKW', a2: 'PKW XL', vl: 'Wähle ein Fahrzeug', vm: 'Trage das Kennzeichen ein', a3: 'Preise werden geladen', a4: 'Motorrad', a5: 'Motorrad mit Beiwagen', a6: 'Geparktes Auto', a7: 'Das Nummernschild war bereits ausgefüllt', a8: 'Shopping Auto', a9: 'Shopping Van', ba: 'Alles anzeigen', bb: 'VAN', bc: 'VAN/Hoch', bd: 'Fahrzeug mit Überlänge & Höhe', be: 'PKW mit Anhänger', bf: 'PKW mit Anhänger', bg: 'PKW mit Anhänger', vB: 'Füge einen anderen Bus hinzu\r\nTransfer', bh: 'Füge eine Kabinenüberraschung hinzu', bi: 'Gratis-Geschenk', bj: '{count} Überraschungen ausgewählt', bk: '{count} Überraschung ausgewählt', vC: 'Mehr laden', bl: 'Vorherige laden', bm: 'Datum', vD: 'Special Cruise', bn: 'bitte beachten Sie', vE: 'Preis ab {price}', vF: 'Keine verfügbaren Abfahrten', vG: 'Keine Abfahrt für das gewählte Datum verfügbar.', bo: 'Alle Preise in Kronen', bp: 'Kabine ab  {price} Punkte', bq: 'Ab {price} Punkte p. Person', br: 'Ab {price} p. Person', bs: 'ab {price} pro Kabine', bt: 'Abbruch', bu: 'Weiter', bv: 'Wenn Du weiter machst, wird Deine Kabinenauswahl zurückgesetzt. Die passagierdaten beleiben erhalten.', bw: 'Diese Kabinenkategorie ist am gewählten Datum nicht auswählbar', vH: 'Special<br/>Cruise', vI: 'Auto ab {price}', bx: 'Auverkauft', by: 'Emissionszuschlag', bz: 'Der Emissionszuschlag wird für Passagiere ab 6 Jahren erhoben.', bA: 'Emissionszuschlag zur Unterstützung von Klimaschutzmaßnahmen und zur Kostendeckung im Rahmen des EU-Emissionshandelssystems.', vQ: '{chars} Zeichen übrig', vR: 'Check in:', vS: 'Check out:', vW: 'Wählen Sie & rarr;', vX: 'Wählen Sie Ihr Zimmer', vY: 'Wählen Sie Ihren Aufenthalt, um den endgültigen Preis zu sehen', v3: 'löschen & auswählen', bB: 'Bronze Level', bC: 'Club Level', wd: 'Club one discount:', bD: 'Gold Level', bE: 'Inaktiver Club One', bF: 'Club One Nummer', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One Mitgliedskonto reaktivieren\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One Mitgliedskonto reaktivieren\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One Mitgliedskonto reaktivieren\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=CClub One Mitgliedskonto reaktivieren\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One Mitgliedskonto reaktivieren\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Обновление статуса (inactive) карты Club One\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One Mitgliedskonto reaktivieren\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: 'Email:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One Mitgliedskonto reaktivieren\">international.sales@tallinksilja.com\n</a>', bP: '<a href=ʺmailto:international.sales@tallinksilja.com?subject=Club One Konto Reaktivierung ʺ> Ihr Club One-Konto ist inaktiv. Bitte kontaktiere uns.\n</a>', bQ: 'Ihr Club One-Konto ist inaktiv. Bitte kontaktieren Sie uns:', bR: '<a href=\"tel:+4940547541222\">+4940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Telefon:', b_: 'Platinum Level', wg: '<a>Melde Dich an</a> oder <a>trete Club One bei</a>, um Rabatte zu erhalten, Punkte einzulösen und einfacher zu buchen.', b$: 'Silber Level', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Die maximale Punktzahl, die Du verwenden kannst, wird dynamisch berechnet und basiert auf den Artikeln und Dienstleistungen in Deiner Buchung.', wj: 'Verfügbare Club One-Punkte verwenden', wk: 'Club One-Punkte können mit diesem Gutscheincode nicht eingelöst werden.', wl: 'Du hast nicht genug Club One-Punkte, die Du nutzen kannst.', b0: 'Du kannst Deine Club One-Punkte für die Zahlung in <a>einem Slider unten</a> verwenden.', wm: 'Club One-Punkte können nicht eingelöst werden ({reason}).', pQ: 'Code', wp: 'Ihr eingegebener Text enthält nicht zulässige Sonderzeichen.', wr: 'Geburtsdatum', ws: 'tt', wt: 'mm', wu: 'jjjj', wv: '{count} {count, plural, one{Erwachsener} other{Erwachsene}}', ww: '({range} J.)', wx: 'Ankunft um {time}', pT: '{count} {count, plural, one{Kind} other{Kinder}}', wy: 'Gratis', wz: 'Weniger', wA: 'Mehr', wB: 'Nationalität', wC: 'Beliebt', b1: 'Der Preis ist inkl. Deines Club One {level} Rabattes.', wD: 'Du kannst kannst  die Passagierdaten jetzt oder nach der Buchung aufüllen. Bitte beachte, dass Deine Club One Informationen vor der Buchung hinzugefügt werden müssen!', b2: 'p', b3: 'Verwende Club One-Punkte', b4: 'Demnächst', wE: 'Bitte gebe Deine Club One Nummer vor der Buchung ein', wF: 'Fertig', wG: 'Ändern &rarr;', b5: 'Für ein schnelleres Einchecken und einfaches Teilen von Buchungsinformationen und Bordkarten, fülle ergänze Telefonnummer und E-Mail für alle Passagiere.', wH: 'Vorname', wI: 'Geschlecht', wJ: 'Frau', wK: 'Mann', wL: 'Im Preis inbegriffen', mh: 'Überprüfen Sie Ihre Eingabe', wM: 'Diese E-Mail gehört der Kontaktperson oder einem anderen Passagier', wN: 'Diese Telefonnummer gehört der Kontaktperson oder einem anderen Passagier', wO: 'Nachname', wP: 'Fülle alle Pflichtfelder (mit * markiert) zum Speichern aus', wQ: 'Frühstück', wR: 'Brunch', wS: 'Buffet', wT: 'Mittagessen', wU: 'Lunch', wV: 'À la carte Reservierung', wW: 'Mahlzeiten können an Bod gebucht werden', wX: 'Name darf nur lateinische Buchstaben enthalten', wY: 'Nicht verfügbar', b6: 'Nicht verfügbar für diese Reise', wZ: 'Nicht benötigt', b7: 'Erwachsen\n18+', b8: 'Kind\n0 - 5', b9: 'Kind\n6 -11', ca: 'Kind\n12 - 17', cb: 'Banken', w_: 'Bezahlen {price}', cc: 'Bezahlung {price}', cd: 'Karten', w$: 'Buchung bestätigen {price}', w0: 'Bestätigung {price}', ce: 'Bezahlen mit Klarna {price}', cf: 'Die Zahlung wird bearbeitet ...', w1: '<p>Die Kombination der Dir angebotenen Reiseleistungen ist eine Pauschalreise im Sinne der Richtlinie (EU) 2015/2302. </p>\n<p>Daher kommst du in den Genuss aller EU-Rechte, die für Pauschalreisen gelten. AS Tallink Grupp ist für die ordnungsgemäße Durchführung der Pauschalreise insgesamt verantwortlich. </p>\n<p>Darüber hinaus verfügt AS Tallink Grupp gemäß den gesetzlichen Bestimmungen über einen Schutzmechanismus, um Ihre Zahlungen zurückzuerstatten und, sofern die Beförderung im Pauschalangebot enthalten ist, Ihre Rückreise zu gewährleisten, falls dies erforderlich wird. </p>\n<p><a href=\"https://www.tallink.com/de/gut-zu-wissen/pauschalreisen\" target=\"_blank\">Siehe Bedingungen für Pauschalreisen</a>.</p>', pU: '<p> Die Kombination von Reiseleistungen, die IDir angeboten werden, ist ein Paket im Sinne der Richtlinie (EU) 2015/2302. </ p>\n<p> Daher profitierst Du von allen EU-Rechten, die für Pakete gelten. {name} ist für die ordnungsgemäße Durchführung des gesamten Pakets verantwortlich. </ P>\n<p> Darüber hinaus hat {name}, wie gesetzlich vorgeschrieben, Schutz für die Rückerstattung Deiner Zahlungen und, sofern der Transport im Paket enthalten ist, um Deine Rückführung zu gewährleisten, falls dies der Fall ist. </ p>\n<a href=\"{url}\" target=\"_blank\"> Sieh Dir die Reisebedingungen an </a>.', w2: 'Durch Klicken auf die Schaltfläche „Bezahlen“ erklärst Du Dich mit den <a href=\"https://www.tallink.com/de/gut-zu-wissen/fahrgastrechte-im-details\" targe=\"_blank\">Allgemeinen Geschäftsbedingungen</a> und den Regeln und Bestimmungen in Bezug auf das <a href=\"https://www.tallink.com/de/gut-zu-wissen/club-one\" targe=\"_blank\">Club One-Treueprogramm</a> ein.', w3: 'Durch Klicken auf die Schaltfläche „Zahlung“ akzeptierst Du die <a href=\"https://www.tallink.com/de/gut-zu-wissen/sahlungs-und-stornobedingungen\" target=\"_blank\" >Zahlungs- und Stornierungsbedingungen</a> sowie die <a href=\"https://www.tallink.com/de/gut-zu-wissen/fahrgastrechte-im-detail\" target=\"_blank\" >Sicherheitsbestimmungen von Tallink</a> und bestätigst, dass Du die <a href=\"https://www.tallink.com/de/datenschutzbestimmungen\" target=\"_blank\" >Datenschutzbestimmungen</a> gelesen hast.', w4: 'AS Tallink Grupp', w5: 'https://www.tallinksilja.de/paketinformationen-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://de.tallink.com/paketinformationen-tallink-silja', w8: 'Unter 18 Jahren sollten Sie die <a href=\"https://www.tallink.com/de/gut-zu-wissen/altersvorgaben\" target=\"_blank\"> Altersbestimmungen </a> lesen.', w9: 'Alipay', xa: 'Apple Pay', xb: 'Lokale Bank', xc: 'Karten', xd: 'Google Pay', xe: 'Mobile Pay', xf: 'Debit- / Kreditkarte', xg: 'WeChat Pay', xh: 'Online Bank & Debit- / Kreditkarte', xi: 'Lokale Bank', xj: 'Online Bank', cg: 'Ab {price}', xk: 'Für Einstellungen nach oben scrollen', xl: 'Auswählen', xm: 'Ausgewählt', xn: 'Schiff', xo: '{date} und {time}', xp: '{count} {count, plural, one{Passagier} other{Passagiere}}', xq: 'Erwachsen\n18+', xr: 'Kind\n0 - 5', xs: 'Kind\n6 -17', xt: 'Bitte wählen zuerst Deine Kabine aus', xu: 'Ankunftshafen in Åland ist Långnäs Hafen (30 km von Mariehamn)', xv: 'Ankunft in Långnäs', xw: 'Start- und Zielhafen in Åland ist Långnäs Hafen (30 km von Mariehamn)', xx: 'Starthafen in Åland ist Långnäs Hafen (30 km von Mariehamn)', xy: 'Abfahrt von Långnäs', pV: 'Fahrzeug', xz: 'Fahrzeuge', ch: '22Std. Minikreuzfahrt mit Baltic Queen', ci: 'MiniCruise', cj: 'Hin- und Rückfahrt', ck: 'Routenausflug', cl: 'Hin -, Rückweg- und Tageskarten', xB: 'Firmenkunde', xC: 'Agenturnummer', xD: 'Agent mit diesen Daten wurde nicht gefunden', xE: 'Achtung! Agenten-ID ist optional.', xF: 'Sie werden vorübergehend von Ihrem persönlichen Konto abgemeldet', xG: 'Firmen-ID', xH: 'Firmenkunde mit diesen Daten wurde nicht gefunden', cm: 'Eine Bestätigung wurde gesendet an', cn: 'Buchung ist abgeschlossen, eine tolle Reise Ihnen!', co: 'Du erhältst {refund} zurück!', cp: 'Bitte rufen Sie unseren Kundenservice an, um Rückerstattungsoptionen zu erhalten!', cq: 'Ihre Reservierung wurde aktualisiert', xI: 'Erwachsene', xJ: 'Name der Stadt', xK: 'Keine Ergebnisse', xL: 'Suche nach Bushaltestelle', xM: 'Bustransfer', cr: 'Kinder (6-17 Jahre)', cs: 'Buchung ändern', xN: 'Ticket', xO: 'Kinder {range} Jahre', ct: 'Freizeitangebote an Land', cu: 'Nein', cv: 'Ja, gerne!', cw: 'Möchtest Du  Spezialangebote per E-Mail erhalten?', cx: 'Vielen Dank für Ihre Anmeldung zum Newsletter.', cy: 'Anruf Reservierungsteam', cz: 'Abbruch', xP: 'Das eingegebene Geburtsdatum stimmt nicht mit der zuvor ausgewählten Alterskategorie überein. Bitte geben Sie das korrekte Geburtsdatum ein oder kontaktieren Sie unseren Kundenservice für die Änderung der Alterskategorie:', cA: 'Ändern der Alterskategorie', cB: 'Dienstleistungen kaufen', cC: 'Dienste ändern', cD: 'Adresse', cE: 'Firma', cF: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich bitte an unseren <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contactss\"> Kundenservice </a>.', cG: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich bitte an unseren <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\"> Kundenservice </a>.', cH: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich an unseren <a href=\"https://ee.tallink.com/et/kontaktid\"> Kundenservice </a>.', cI: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich bitte an unseren <a href=\"https://www.tallinksilja.fi/palvelunumerot\"> Kundenservice </a>.', cJ: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich an unseren <a href=\"https://www.tallink.lv/lv/contacts\"> Kundenservice </a>.', cK: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich an unseren <a href=\"https://www.tallinksilja.com/contact-us\"> Kundenservice </a>.', cL: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich bitte an unseren <a href=\"https://www.tallinksilja.ru/agents\"> Kundenservice </a>.', cM: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich bitte an unseren <a href=\"https://www.tallinksilja.se/kontakta-oss\"> Kundenservice </a>.', cN: 'Um Änderungen an Ihrer Buchung vorzunehmen, wenden Sie sich an unseren <a href=\"https://www.tallinksilja.com/contact-us\"> Kundenservice </a>.', cO: 'Kontakt', cP: 'Kontaktperson', cQ: 'To make changes to your booking, please contact your travel agency.', cR: 'E-mail', cS: 'Club One beitreten', cT: 'Buchungsbestätigung', cU: 'Der Check-in beginnt 2 Stunden vor der Abfahrt. Bitte beachten Sie, dass der Check-in mindestens 45 Minuten vor Abfahrt im Check-in-Bereich des Fahrzeugs erfolgen muss.', cV: 'Bitte tragen Sie Ihre vollständigen Passagierdaten ein.', cW: 'Abbruch', cX: 'Fortsetzen', cY: 'Eingegebene Änderungen gehen verloren. Möchten Sie trotzdem fortfahren?', cZ: 'Änderungen werden nicht gespeichert', c_: 'Bestätigung als PDF anzeigen', c$: 'Die Zahlungsinformationen können Sie der Bestätigungs-email (PDF) entnehmen.', c0: 'Zahlungs- und Stornierungsbedingungen anzeigen', c1: 'https://www.tallink.com/de/gut-zu-wissen/allg-befoerderungsbedingungen', xQ: 'Gesamt', c2: 'Telefonnummer', c3: 'Buchungsnummer', c4: 'Sicherheitscode', c5: 'Bestätigung', c6: 'Abfahrts- und Ankunftszeiten der Schiffe werden stets in Ortszeit angegeben.', c7: 'Um unnötige Warteschlangen zu vermeiden, empfehlen wir die Verwendung der Self-Check-in- Automaten am Terminal. Sie benötigen nur Ihre Buchungs- und Sicherheitsnummer.', c8: 'Passagiere werden gebeten, rechtzeitig an Bord zu gehen.', c9: 'Passagiere ohne Fahrzeug müssen spätestens 30 Minuten vor der Abfahrt einchecken. Passagiere mit Fahrzeugen müssen mindestens 1 Stunde vor Abfahrt am Auto-Check-in einchecken.', da: 'Tallink Silja storniert die Reise, wenn vor der Abreise kein Check-in stattgefunden hat. Im Falle eines Tagestrips oder einer Cruise wird die gesamte Reise storniert, wenn der Passagier das Ticket nicht im Hafen der ersten Abfahrt eingecheckt hat.', db: 'Bitte denken Sie daran Ihr offizielles und gültiges Ausweisdokument mitzuführen. (Personalausweiß oder Reisepass)', dc: 'Die Ankunfts- und Abfahrtszeiten des Schiffes sind jeweils in Ortszeit angegeben. <br>\nDu kannst online, in der Tallink Silja Line-App oder am Serviceschalter im Terminal einchecken. <br>\nIn den Häfen Paldiski und Kapellskär schließt der Check-In für Fahrzeugpassagiere 75 Min. vor der Abfahrt der Superfast-Fähre. Wir empfehlen daher eine frühzeitige Ankunft am Hafen. <br>\nDie Kabinenkarten werden beim Check-in ausgegeben. <br>\nJeder Passagier (auch Kinder) muss ein gültiges Reisedokument und alle anderen notwendigen Papiere, wie z. B. ein Visum, falls erforderlich, für die gesamte Reise mit sich führen. <br>\nDie Passagiere sind für die Gültigkeit und Richtigkeit ihrer Dokumente verantwortlich.', dd: 'Reiseinformationen', de: 'Gut zu wissen', df: 'Rückerstattung', dg: 'Du erhältst eine Rückerstattung von {erstatten}! Bitte rufe unseren Kundenservice an, um die Rückerstattung zu erhalten.', dh: 'Rufen an, um eine Rückerstattung zu erhalten', di: 'Schon angerufen? Keine Sorge, diese Benachrichtigung verschwindet, sobald wir Ihre Erstattung bearbeitet haben.', dj: 'Erhalte Deine Rückerstattung', xR: 'Sollte der Verbindungsfehler weiterhin bestehen, wenden Sie sich bitte an den Kundenservice. Tel. +49(0)40 547 541 222', xS: 'Verbindungsfehler: Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut', xT: 'Bitte erneut versuchen', xV: 'Weiter', xW: 'Weiter zur Zahlung', pX: 'Email Adresse', xX: 'Beispiel:', dk: 'Ländercode und Telefonnummer', xY: 'Kontaktinformation', xZ: 'Teilen Sie uns Ihren Namen mit, so dass wir Ihnen Ihre Buchungsbestätigung zusenden können. Beachten Sie, dass Ihre Club One-Nummer in der vorherigen Phase zum Feld \"Passagier\" hinzugefügt werden muss.', x_: 'Diese Informationen werden unter Ihrem Club One Konto gespeichert', pY: 'Telefonnummer', dl: 'Beispiel: 400346544', x$: 'Sonstige', x0: 'Eine Kopie der Buchungsbestätigung wird an E-Mail {email} gesendet', dm: 'Weitere E-Mail', dn: 'Postleitzahl', x6: '{price} / Test', x8: 'Buche diese Reise schneller mit unserem <b>neuen Buchungsablauf</b>.', dp: 'Karteninhaber', dq: 'Kreditkarte', dr: 'mm', ds: 'Kreditkartennummer', dt: 'Bezahlmethode', du: 'Sicherheitscode', dv: 'Wählen Sie Ihre Kreditkarte', dw: 'Gültig bis', dx: 'jj', dy: 'Cruise Stockholm(Kappellskär)-Turku-Stockholm(Kappellskär)', ya: 'Cruise nach Helsinki', yb: 'Cruise nach Visby', dz: 'Cruise Turku-Stockholm(Kappellskär)-Turku', yc: 'Cruise with visiting Ystad', dA: 'Tag in Helsinki Minikreuzfahrt', dB: 'Tag in Riga Minikreuzfahrt', no: 'Tag in Tallinn Minikreuzfahrt', yj: 'Tag in Turku Cruise', yr: 'Dessert', dC: 'Rabatt:', yy: 'Aktiviert', yz: 'Promotional code or gift card:', p9: 'Rabatte & Geschenkkarten', dD: 'Don’t forget to select one menu option for each adult passenger in {restaurant} reservation.', dE: 'Don’t forget to select one menu option for each 12 years and older passenger in {restaurant} reservation.', yB: 'Verpassen Sie keine Gelegenheit!', yD: 'Getränkepaket wählen', dF: 'Wir haben eine noch unbezahlte Buchung für diese Abfahrt gefunden. Ref. Nummer: {resId}, price: {price} {unit}. Willst Du die alte Buchung stornieren und die Bezahlung für die neuen Buchungs bestätigen? <a href=\"{link}\">Alte Buchung öffnen und bezahlen →</a> Für weitere Infos kontaktiere bitte das Reservierungsteam.', yF: 'Zimmer ändern', yG: 'Räume ändern', yO: 'Entertainment an Land', yP: 'Unterhaltung an Land und in Hotels', yS: 'Jeder Passagier muss einen Sitz in einem Fahrzeug haben.', dK: 'https://clubone.tallink.com/sv', yY: 'Extraservices', dL: 'Feedback hinterlassen', y_: 'Schiff', y$: 'Schiff + Hotel', y5: 'Menü wählen', y7: 'Nahrungsmittelallergien / diätetische Einschränkungen:', kS: 'Von', za: 'Emissions- und Treibstoffzuschlag', zb: 'Treibstoff- und Emissionszuschläge werden für Passagiere ab 6 Jahren erhoben.', zc: 'Treibstoff- und Emissionszuschläge fallen für Passagiere ab 12 Jahren an. Bis zu drei Kinder im Alter von 6 bis 11 Jahren pro Buchung sind von diesen Zuschlägen befreit.', zd: 'Kraftstoff- und Emissionszuschläge zur Unterstützung von Klimaschutzmaßnahmen und zur Deckung der Kosten des EU-Emissionshandelssystems.', dM: 'Treibstoffzuschlag', dN: 'Der Treibstoffzuschlag wird für Passagiere ab 6 Jahren erhoben.', dO: 'Der Treibstoffzuschlag beträgt {price} pro Passagier ab 6 Jahre.', dP: 'Der Treibstoffzuschlag beträgt {price} pro Strecke für Passagiere ab 6 Jahren.', zh: 'Geschenkkarte:', zi: 'Die Geschenkkarte kann für mehrere Einkäufe verwendet werden, bis das Geld aufgebraucht ist.\nDie Geschenkkarte hat {priceLeft} €.', dQ: 'Gruppenmenü verfügbar', zm: 'Bei Buchungen mit 12 oder mehr Erwachsenen bitten wir Dich, für jeden erwachsenen Passagier eine Menüvariante in der Buchung auszuwählen. Jüngere Passagiere erhalten automatisch einen Gutschein für ein Kindermenü im Wert von 25 €.', dR: 'Helsinki', dS: '2 Nächte an Bord <br> und ein Tag in Riga', dT: '22 Stunden Cruise nach Tallinn <br> 4 Stunden Zeit an Land', dU: 'Cruise to Tallinn.<br> 5 hours onshore in Tallinn.', dV: 'Visby Minikreuzfahrt', dW: 'Summer-Special Cruiese - Minikreuzfahrt zur magischen Insel Gotland', dX: 'Härnösand', zv: 'Hotel', zy: 'Um ein Datum außerhalb des auswählbaren Bereichs <a> auszuwählen, ändern Sie Ihre Reisedaten </a> entsprechend.', dY: 'Check-In', dZ: 'Check-In um', d_: 'Check-out', d$: 'Check-Out um', d0: 'Nächte', d1: 'Nacht', zz: 'Buchungen nur für Hotels sind derzeit in einer separaten Anwendung möglich.', zA: 'Für die ausgewählten Daten sind keine Hotelzimmer verfügbar. Bitte wählen Sie andere Reisedaten.', zB: 'Sie können nach dem Auschecken nicht mehr einchecken. Sie können Ihr Auscheckdatum auf der Registerkarte Auschecken ändern.', zC: 'Sie können nicht vor dem Einchecken auschecken. Sie können Ihr Eincheckdatum auf der Registerkarte Einchecken ändern.', zD: 'Dies ist Ihr Check-in-Datum. Um dies zu ändern, gehen Sie zur Registerkarte Einchecken.', zE: 'Dies ist Ihr Checkout-Datum. Um es zu ändern, gehen Sie zur Registerkarte Auschecken.', qF: 'Dieses Datum liegt außerhalb Ihrer ausgewählten Reisedaten. Um es auszuwählen, ändern Sie bitte Ihre Reisedaten.', zF: 'Hinfahrt mit Übernachtung: Übernachtung an Bord inbegriffen.', zG: 'Rückfahrt mit Übernachtung: Übernachtung an Bord inbegriffen.', zW: 'Informationen über Nahrungsmittelallergien / diätetische Einschränkungen wurden an die Schiffsbesatzung weitergeleitet.', q4: 'Club One beitreten', AB: 'Erhalten Sie Rabatte bei der Buchung, sammeln Sie Punkte, die für die Buchung von Bonusreisen verwendet werden können, und profitieren Sie von Rabatten an Bord und bei unseren Onshore-Partnern.', d2: 'Straße und Hausnummer', d3: 'Stadt', d4: 'Land', d5: 'Club One Details fehlen', AC: 'Postleitzahl', AD: 'Club One-Mitglied muss einer der Passagiere sein.', d6: 'Per E-Mail', d7: 'Per Post', d8: 'Per SMS', d9: 'Bervorzugte Sprache', ea: 'Ich möchte Angebote und Neuigkeiten von Club One erhalten', eb: 'Nein', ec: 'Sichern und schließen', ed: 'Ja', AF: 'Willkommen im Club One! Sie können den Rest Ihrer Daten nach der Buchung eingeben.', AG: 'Willkommen im Club One. Mit Ihrer Teilnahme haben Sie einen Mitgliederrabatt erhalten. Der ursprüngliche Preis {priceBefore} wurde in {currentPrice} geändert.', AH: 'Wir haben ein vorhandenes Club One-Konto mit diesen Daten gefunden.', ee: 'Kapellskär', ef: 'KInder Menü Voucher', AN: 'Mit der Bestätigung dieser Buchung stimmen Sie zu, dass Ihre Reservierungsdaten an Klarna weitergeleitet werden, um die verfügbaren Zahlungsoptionen zu überprüfen. Lesen Sie mehr', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: 'über die Verwendung Ihrer Daten durch Klarna', AQ: 'Klarna & Swish', AR: 'Rechnung, Ratenzahlung', AS: 'Klarna', AT: 'Rechnungszahlung', AU: 'Ratenzahlung', AV: 'Swish', AW: 'Die verfügbaren Zahlungsoptionen hängen von Ihrer Buchung ab. Die gängigsten Optionen sind:', eg: 'Klarna Kasse', eh: 'Mit Klarna bezahlen Sie einfach und sicher mit Ihrem Mobiltelefon', ei: 'Klaipeda', ej: 'Hinflug oder Hin- und Rückfahrt. <br> Tägliche Abfahrt um 19:00 Uhr.', A$: 'Deutsch', A0: 'Angļu valoda', A1: 'Igauņu valoda', A2: 'Somu valoda', ek: 'Litauisch', A3: 'Lettisch', A4: 'Krievu valoda', A5: 'Zviedru valoda', Bb: 'Lädt...', Bc: 'Helsinki', Bd: 'Jurmala', Be: 'Kolmården', Bf: 'Kuressaare', Bg: 'Laulasmaa', Bh: 'Mariehamn', Bi: 'Narva', Bj: 'Norrkoping', Bk: 'Otepää', Bl: 'Parnu', Bm: 'Rakvere', Bn: 'Riga', Bo: 'Sodertalje', Bp: 'Stockholm', Bq: 'Tartu', Br: 'Turku', Bs: 'Tallinn', Bt: 'Tampere', Bu: 'Uppsala', Bv: 'Vantaa', Bw: 'Vihula', BC: 'Hauptgang', BE: 'Add another', BF: 'Date:', BG: '{price} / treatment', BH: 'Time:', Cf: 'Essen wird nicht serviert zwischen {direction}', Cg: 'Das Mahlzeitenpaket beinhaltet Mahlzeiten für die gesamte Reise.', Ch: 'Wähle Sie das Mahlzeitenpaket', el: 'Nicht ausgewählt', em: '<span class=\"data\">{count}</span> {count, plural, one{# Frühstück} other{# Frühstück}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# Dinner} other{# Dinner}}', rt: 'Sie können die Mahlzeitenvoucher für das Buffet oder als Bezahlung in den anderen Resturants einsetzen', Ci: '{price} / 18+ g.v.', Cj: '{price} / Erwachsener', Ck: '{price} / Person', Cl: '<span class=\"save bodySmall\">vorbuchen</span><span class=\"bodySmall\">und</span><span class=\"bodyLarge percentage\">sparen</span>', Cm: 'Essenspaket', Cn: '{count, plural, one{# Person} andere{# Personen}}', Co: 'Pro Person', Cp: 'Reservierung', ru: 'Sparen Sie & kaufen Sie ein Mahlzeitpaket', eo: 'Tisch reservieren', ep: 'ausverkauft', eq: 'Frühstück', er: 'Dinner', Cq: 'Mahlzeiten', es: 'Gutschein', Cr: 'Die Mahlzeiten sind für die gesamte Reise inbegriffen', Cs: 'Sind Sie sicher, dass Sie keine Mahlzeiten mit <b>bis zu 10% Rabatt</b> hinzufügen möchten? Das Angebot ist nur gültig, wenn Sie online buchen.', et: 'Konferenzraum', eu: '{date} um {time} für {duration} h', Ct: 'Menü verfügbar', Cu: 'Bitte wähle bei der Buchung für jeden Fahrgast ab 12 Jahren eine Menüvariante aus. Fahrgäste unter 12 Jahren erhalten mit ihrer Reservierung einen Essensgutschein und können ihre Mahlzeit an Bord auswählen. Kinder erhalten mindestens 50% Rabatt auf den Normalpreis.', ew: 'Bitte Passagierinfo ausfüllen', ex: 'Anzeigen Passagierdaten', ey: 'Club One', CA: 'Club One Passagier können derzeit nicht nach der Buchung bearbeitet werden. Um Club One Passagiere zu ändern rufen Sie bitte das Reservierungsteam unter der:', ez: 'Passagierdaten fehlen', eA: 'Kein Ausdruck erforderlich. Gehen Sie einfach zum Self-Check-In mit Ihrer Reservierungsnummer und Ihrem Sicherheitscode.', eB: 'Falsche Alterskategorie', eC: 'Fehlende Passagierinformationen', eD: 'Zahlung unvollständig', eE: 'Bearbeiten Sie Nummernschilder', eF: 'Nummernschild fehlt', eG: 'Nummernschild nicht eingetragen', eH: 'Erhalten Sie Ihre Reservierung auf Ihr Handy', eI: 'Herunterladen', eJ: 'Öffnen', eK: 'Link senden', eL: 'Tallink & Silja Line App', eN: 'Muuga', CJ: 'Kein Landgang in der Destination', CK: 'Am Ziel kann das Auto nicht nach draußen gefahren werden.', CL: 'Derzeit sind keine Abfahrten mit dem ausgewählten Reisetyp verfügbar. Bitte ändern Sie den Reisetyp.', CM: 'Es gab ein Problem mit Ihrer Bezahlung. Versuchen Sie es erneut oder kontaktieren Sie uns per Telefon {phone}', ol: 'Nein, danke', CU: 'Mit diesem Gutscheincode ist Dein Ticket nicht mehr erstattungsfähig. Weitere Informationen zu den spezifischen <a href=\"\"#>Bedingungen →</a> findest Du hier.', CV: '<ul>\n<li>Es ist nicht gestattet, die Richtung und/oder Route, das Abreisedatum oder die Abreisezeit des Tickets zu ändern.</li>\n<li>Die persönlichen Daten des Passagiers, die Kabinenklasse, das Fahrzeug und der Bordservice können geändert werden. Bei solchen Änderungen muss die Preisdifferenz zwischen der ursprünglich gebuchten Leistung und der geänderten Leistung bezahlt werden.</li>\n<li>Wenn der Passagier das Ticket storniert, behält Tallink Silja Line 100 % des Ticketpreises als Vertragsstrafe ein.</li>\n<li>In allen anderen Angelegenheiten gelten die Reisebedingungen der AS Tallink Grupp, die unter www.tallink.com/de/gut-zu-wissen/allg-befoerderungsbedingungen verfügbar sind. </li>\n</ul>', CW: 'Allgemeine Geschäftsbedingungen', CX: 'Ja, ich akzeptiere', CY: 'Gutscheincode entfernen', CZ: 'Du erwirbst ein Ticket mit einem nicht erstattungsfähigen Gutscheinode <b>{code}</b>. Nach dem Kauf kann dieses Ticket unter keinerlei Umständen erstattet werden. Du kannst nur die persönlichen Daten des Passagiers, die Kabinenklasse und die Serviceleistungen ändern. Änderungen der Richtung, der Route, des Abflugdatums oder der Abflugzeit sind nicht zulässig. Bitte bestätige, dass Du diese Bedingungen verstanden hast und akzeptierst, bevor Du mit der Zahlung fortfährst.', C_: 'Nicht erstattungsfähiges Ticket', eO: 'Nicht genug Punkte', C0: 'Buchung fortsetzen', C1: 'Buchung zurücksetzen', C2: 'Wenn Sie zurückgehen, geht Ihre Auswahl verloren und Sie müssen neu beginnen. Wollen Sie trotzdem zurückgehen?', C3: 'Möchten Sie Ihre Buchung zurücksetzen?', eP: 'Arrival harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', eQ: 'Departure harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', eR: 'Departure and Arrival harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', Da: 'Bubble fair', eS: 'Insurance', Db: 'FriendSHIP Abenteuer-Paket', Dc: 'Kinder-Pakete', Dd: 'Priority boarding', De: 'Onboard-Dienste', Df: 'Schiffsgeld', Dg: 'Coupon', Dh: 'Schiffsgeldcoupons', Di: 'Platz', Dj: 'Service not available between {route}', Dk: 'Ein Tag', eT: 'Einzelfahrt oder Hin-und Rückfahrt. <br> Tägliche Abfahrten.', Do: 'oder', Dp: 'Andere', eU: 'Other payment method', eX: 'Ab 12 J.', eY: 'Paldiski', eZ: 'Geparkter Van', DI: 'Party auf der Ostsee', DJ: 'Ostsee - Tallinn', e_: 'Altersgruppe des Passagiers kann nicht geändert werden', DM: 'Falsche Altersgruppe. Vergewissere Dich, dass das Geburtsdatum einem Erwachsenen entspricht.', DN: 'Falsche Altersgruppe. Vergewissere Dich, dass das Geburtsdatum einem Erwachsenen oder einem Jugendlichen entspricht.', DO: 'Bitte überprüfe ob das Datum im TT-MM-JJJJ Format eingegeben haben.', DP: 'Es werden nur Zahlen im Geburtstagsfeld erkannt', DQ: 'Später ausfüllen', DR: 'Speichern', DS: 'Bitte überprüfe Namen und Club One Nummer', DT: 'Club One Nummer', DU: 'wurde bereits hinzugefügt.', DV: 'Bearbeite die Details oder', DW: 'Von vorn anfangen', DX: 'Informationen zum Reisedokument werden dem Club One-Konto hinzugefügt.', DY: 'Ausstellender Staat des Dokumentes*', DZ: 'Ablaufdatum des Dokuments *', D_: 'Ausstellungsdatum des Dokuments *', D$: 'Dokumentnummer *', D0: 'Dokumentenart *', D1: 'Geburtsland', D2: 'Besondere Unterstützung', D3: 'Weitere Informationen erhältst Du telefonisch beim Reservierungsteam: 040-547 541 222', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Passagier hinzufügen', Ec: '<span class=\"data\">{count}</span> {count, plural, one{Passagier} other{Passagiere}} ausgewählt', Ed: 'Jetzt oder später ausfüllen', Ee: 'Passagierinfos komplett', Ef: 'Passagiere', e0: 'In Kürze verfügbar.', e1: 'Buchungsnummer', e2: 'Kreditkarte', e3: 'Remove', Ei: 'Bezahlen', e4: 'Zahlungsmethode auswählen', Ej: 'Rechnung', Ek: 'Rechnungsadresse', e5: 'Zahlen Sie mit einer Unternehmensrechnung', El: 'Referenznummer', e6: 'Später bezahlen', e7: 'Einfach Mobile Bezahlung', e8: 'Zahlen Sie jetzt, um Ihre Buchung zu sichern.', e9: 'Bank', fa: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', fb: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', fc: '0,85 Cento pro Anruf + Gebühren Ihres Netzbetreibers', fd: '8,35 cent pro Anruf + 16,69 cent pro Minute', fe: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', ff: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', fg: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', fh: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', fi: 'Es fallen ledigliche die Gebühren Ihres Netzbetreibers an.', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Kundenservice anrufen', fk: 'Unbezahlte Reservierungen werden automatisch innerhalb von 24 Stunden storniert', fl: 'Bei der Zahlung ist ein Problem aufgetreten. Du kannst es erneut versuchen oder uns anrufen.', fm: 'Ändere die <u> Ländereinstellungen </ u> in den ursprünglichen Markt, um die Zahlung abzuschließen.', fn: 'Die Buchung wurde auf einem anderen Markt vorgenommen.', Ex: 'und {points} Punkte', r0: 'Person', EA: 'Personen', EH: 'D-Terminal', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs', EM: 'West Terminal 2', EN: 'West Terminal', EO: 'West Terminal', EP: 'Peterburi', EQ: 'Mariehamn', ER: 'Muuga Hafen', ES: 'Olympia Terminal', ET: 'Paldiski', EU: 'Riga Terminal', EV: 'Sassnitz', EW: 'Turku Hafen', EY: 'Värtahamnen', EZ: 'Visby', E_: 'Ventspils', E$: 'Vuosaari Hafen', E5: 'Vorausgewählt', E6: 'Reise buchen', E7: 'Abbruch', E8: 'Fortsetzen', E9: 'Fertig', fo: 'Nächste', Fa: 'Günstigste Kabine:', Fb: 'Günstigste Kabine mit Club One:', Fc: 'Club One price', Fd: 'Bitte weitere Kabinen hinzufügen', Fe: 'Wähle eine Kabine, um den endgültigen Preis zu sehen', fp: 'Wähle die Kabinenkategorie zur Fortführung aus', Ff: 'Subtotal:', Fg: 'Total:', fq: 'Preis mit Club One:', Fh: 'Preis wird kontolliert...', Fj: 'Ab-Preis pro Passagier/Fahrzeug inkl. Emissions- und Treibstoffzuschlag.', Fl: '{price} / Stück', sa: 'Proceed', fr: 'Weiter zur Bezahlung', Fs: 'Diese Seite ist geschützt durch reCAPTCHA und Google <a target=\"_blank\" href=\"https://policies.google.com/privacy?hl=de \">Privacy Policy</a>. Es gelten die <a target=\"_blank\" href=\"https://policies.google.com/terms?hl=de\">Nutzungsbedingungen</a>.', ft: 'Änderungen bei den Borddiensten: <br>\r\nDie Abfahrten von Freitag bis Samstag sind voller Freude, z. Live-Musik, Karaoke und Bingo. <br>\r\nSo-Do-Abfahrten haben weniger Dienste.', fu: 'Regulärer Preis:', Fy: 'Um diese Option auszuwählen, entfernen Sie die vorherige Auswahl', FA: 'Die Reservierungsgebühr {fee} pro Person wird von der Restaurantrechnung an Bord abgezogen.', FB: 'Die Reservierungsgebühr entfällt für Kinder bis zu 5 Jahren.', sq: 'Schließen', FD: 'Es ist etwas schief gelaufen, bitte aktualisiere die Seite oder starte erneut mit der Buchung.', FE: 'Wir konnten keine bevorstehenden Abfahrten finden', fv: 'Von vorn anfangen', fw: 'Wir entschuldigen uns für die Unannehmlichkeiten. Ihre aktuelle Buchung wird automatisch storniert.', fx: 'Deine Sitzung ist abgelaufen', FF: 'Von vorn anfangen', FG: 'Leider musst Du von vorne beginnen. Wir entschuldigen uns für die Unannehmlichkeiten.', FH: 'Verzeihung! Ein Fehler ist aufgetreten', fz: 'Riga', fA: 'Zwei Nächte an Bord und ein Tag in Klaipeda.', fB: 'Hinflug oder Hin- und Rückfahrt. <br> Tägliche Abfahrt um 17:00 Uhr.', fC: 'Stockholm-Turku-Turku-Stockholm(Kappellskär)', fD: 'Stockholm(Kappellskär)-Turku', fE: 'Stockholm(Kappellskär)-Turku-Turku-Stockholm', fF: 'Turku-Stockholm-Stockholm(Kappellskär)-Turku', fG: 'Turku-Stockholm(Kappellskär)', fH: 'Turku-Stockholm(Kappellskär)-Stockholm-Turku', fI: 'Zurück zur Liste', fJ: 'Leider haben wir keine Bank gefunden, nach der Du gesucht hast. Versuche es stattdessen mit der Liste.', fK: 'Suchen', fL: 'Sassnitz', fN: 'Bitte wähle mindestens ein Fahrzeug aus', Ge: 'Adding a car <b>will remove {service}</b> service. You sure you want to proceed?', Gf: 'Bist Du sicher?', Gv: 'Shopping Minikreuzfahrt', Gw: 'Mehrere tägliche Abfahrten von Helsinki. Die Gesamtdauer der Reise beträgt 5 Stunden und es gibt keine Ausschiffung in Tallinn. Bei großen Einkäufen erältst Du einen Rabatt.\nWenn Du sehr große Einkäufe tätigen möchtest, ist es am einfachsten, mit einem Auto zu kommen. Auf Megastar kann das Auto während der Fahrt von der Garage neben dem Traveller Superstore auf Deck 7 aus erreicht werden. Auf Star werden Autos auf dem Autodeck geparkt.', Gy: 'Diese Rückfahrzeit ist einer 5-stündigen Minikreuzfahrt zugeordnet. Du wirst auf die entsprechende Seite weitergeleitet.', fO: '5h Einkaufstour mit oder ohne Auto\r\nMegastar oder Stern', GE: 'Tischreservierung anzeigen', fP: 'Saaremaa', GK: 'Als 15-17-Jähriger kannst Du ohne Begleitung eines Erwachsenen reisen. Denken Sie daran, Deine <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\"> Reiseerlaubnis</a> mitzubringen. Gute Reise!', fQ: 'St. Petersburg', GQ: 'Vorspeise', fR: 'Stockholm', GY: 'Buche Stockholm-Helsinki', GZ: 'Es gibt keine direkte Verbindung von Tallinn nach Stockholm an dem gewählten Datum, aber Du kannst über Helsinki reisen.', G_: 'Bitte beachte! Du musst vom Olympia-Terminal zum Westterminal 2 wechseln, um die Schiffe zu tauschen.', G$: 'Stockholm -> Tallinn <br/> via Helsinki', fS: 'Neue Regeln für den Alkoholkonsum vom 20. November 2020 bis 28. Februar 2021: <br>\r\nAlkohol wird nur zu bestimmten Zeiten serviert.', fT: 'Zwei Nächte auf See, ein Tag in Visby - diesen Sommer wird Silja Symphony wundervolle Kreuzfahrten zwischen Stockholm und Visby unternehmen', fU: 'Zwei Nächte auf See, zwei Tage in Visby - eine zusätzliche Nacht an Bord in Visby und zwei Tage, um Gotland zu entdecken. Nutzen Sie die Gelegenheit, in unseren Geschäften einzukaufen, und das während der gesamten Reise zollfrei.', fV: 'Stockholm (Kappellskär)', fW: 'Drei Nächte auf See, einen Tag in Ystad und einen Tag in Visby.', fX: 'Zuschlag', fY: 'Tallinn', G8: 'Tallinn - Ostsee', fZ: 'Tallinn - Ostsee - Tallinn', f_: '2 Nächte an Bord <br> und ein Tag in Riga', G9: 'Buche TAL-HEL.', Ha: 'Es gibt keine direkte Verbindung von Tallinn nach Stockholm am gewählten Datum, aber Du kannst über Helsinki reisen und von dort aus mit der Silja Serenade/Silja Symphony weiterfreisen.', Hb: 'Wichtig! Du musst vom Westterminal 2 zum Olympiaterminal wechseln, um das Schiff zu wechseln. <b>Wenn Du die Abfahrt um 13:30 Uhr wählst, könnte die Zeit für den Transfer mit öffentlichen Verkehrsmitteln nicht ausreichen.</b>', Hc: 'Tallinn -> Stockholm <br/> via Helsinki', f$: 'Zwei Nächte an Bord und ein Tag in Turku.', f0: 'Einfache Fahrt oder Rückfahrt. <br> Tägliche Abfahrten Turku.', f1: 'Visby Minikreuzfahrt', f2: 'Summer-Special Cruiese - Minikreuzfahrt zur magischen Insel Gotland', tb: 'Danke für die Information', td: 'Rückfahrt hinzu', f3: 'Buche eine Rückfahrkarte und erhalte bis zu 30% Rabatt', f4: 'Deine Hin-und Rückfahrt liegen am gleichen Tag. Du kannst den günstigen TagesCruisepreis wählen', o6: 'Ankunft', f5: 'Du möchtest an einem späteren Termin reisen?', f6: 'Auswahldatum für {direction}', f7: 'Zurücksetzen', Hx: 'Datum wählen', f8: '23-Stunden Minikreuzfahrt (Abends)', f9: '23-Stunden Minikreuzfahrt (Morgens)', ga: 'Tag in Stockholm Minikreuzfahrt', gb: 'Tag in Turku MiniCruise', o7: 'Abfahrt', Hy: 'Nachmittags', Hz: 'Morgens', te: 'Dauer', tf: 'Stunden', HA: 'Verbringe die erste Nacht an Bord und verlasse das Schiff zwischen 8-11 Uhr.', HB: 'Erste Nacht an Bord', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'Auf Anfrage', gc: 'Entferne das Rückfahrticket', gd: 'Megastar 5Std. Shopping-Minikreuzfahrt', ge: 'Schließen', gf: 'Die sofortige Rückfahrt mit Megastar oder Star beinhaltet einen Einkaufsrabatt für Passagiere und Fahrzeuge. Keine Ausschiffung in Tallinn.', gg: 'MegastarshoppingCruise', gh: 'Verbringe eine Nacht an Bord, genieße 4 Stunden in Tallinn', gi: 'Abfahrt am Abend von Stockholm, keine Zeit an Land', gj: 'Abfahrt am Morgen von Stockholm, keine Zeit an Land', gk: 'Verbringe zwei Nächte an Bord, genieße einen Tag in Turku', gl: 'Abfahrt am Abend von Turku, keine Zeit an Land', gm: 'Abfahrt von Turku morgens, keine Zeit an Land', gn: 'Rundreise Helsinki - Stockholm - Helsinki', go: 'Einfache Überfahrt Helsinki nach Stockholm', gp: 'Rundreise Helsinki - Tallinn - Helsinki', gq: 'Tag in Tallinn MiniCruise', gr: 'Einfache Überfahrt Helsinki nach Tallinn', gs: 'Megastar ShoppingCruise', gt: 'Minikreuzfahrt Riga - Stockholm - Riga', gu: 'Einfache Überfahrt von Riga nach Stockholm', gv: 'Minikreuzfahrt Stockholm - Helsinki - Stockholm', gw: 'Einfache Überfahrt Stockholmnach Helsinki', gx: 'Minikreuzfahrt Stockholm - Riga - Stockholm', gy: 'Einfache Überfahrt von Stockholm nach Riga', gz: 'Minikreuzfahrt Stockholm - Tallinn - Stockholm', gA: 'Einfache Überfahrt von Stockholm nach Tallinn', gB: 'Minikreuzfahrt Stockholm - Turku - Stockholm', gC: 'Einfache Überfahrt Stockholm nach Turku', gD: 'Minikreuzfahrt Tallinn - Helsinki - Tallinn', gE: 'Tag in Helsinki MiniCruise', gF: 'Einfache Überfahrt von Tallinn nach Helsinki', gG: 'Minikreuzfahrt Tallinn - Stockholm - Tallinn', gH: 'Einfache Überfahrt von Tallinn nach Stockholm', gI: 'Minikreuzfahrt Turku - Stockholm - Turku', gJ: 'Einfach Überfahrt von Turku nach Stockholm', HH: 'Mit Hotel', tg: 'Minikreuzfahrt', gK: 'Tag in Helsinki Minikreuzfahrt', gL: 'Tag in Tallinn Minikreuzfahrt', gM: 'Tag auf Åland Minikreuzfahrt', gN: 'Tag in Stockholm MiniCruise', gO: 'Minikreuzfahrt', gP: '9 Std. Minikreuzfahrt', gQ: 'Tag in Stockholm Minikreuzfahrt', gR: 'Minikreuzfahrt', gS: 'Tag auf Åland Minikreuzfahrt', gT: 'Cruise to Helsinki', gU: 'Tag in Stockholm Minikreuzfahrt', gV: '22 h Minikreuzfahrt', gW: 'Minikreuzfahrt', gX: 'Cruise two outwards', gY: 'Verstecke & uarr;', gZ: 'Mehr & darr;', g_: 'Überfahrt', le: 'Nach', g$: 'Wir haben einen Erwachsenen zu Deiner Buchung hinzugefügt. Pro Buchung ist mindestens ein Erwachsener erforderlich.', g0: 'Garage wurde aus der Buchung entfernt. Priority Car ist im Preis der Business Class enthalten', g1: 'Priority Car ist im Preis der Business Class enthalten', g2: 'Dieser Kabinentyp ist nicht mehr verfügbar. Bitte wähle eine andere Kabinenkategorie', HP: 'Das Nummernschild ist bereits ausgefüllt', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Der ausgewählte Bustransfer ist zu den aktuellen Reisedaten nicht verfügbar.', g5: 'Ausgewählte Bustransfers sind nicht verfügbar und wurden entfernt.', HQ: 'Hallo, {name}!', g6: 'Um diese Reise mit Club One Punkten zu bezahlen, bräuchtest Du\nmindestens {clubOnePoints} Punkte.', g7: 'Einige Details des vorherigen Passagiers blieben unausgefüllt. Überprüfe bitte, ob alle Felder ausgefüllt sind.', g8: 'Da keine Internetverbindung besteht, konnten die Informationen nicht gespeichert werden. Bitte erneut verbinden und es erneut versuchen.', g9: 'Einige Passagierinformationen fehlen. Bitte fülle alle Felder aus, um die Informationen zu speichern.', HR: 'Nicht alle Fahrgäste wurden der Busverbindung hinzugefügt.', HS: 'Du musst mindestens einen Erwachsenen pro Zimmer auswählen', ha: 'Um diese Mahlzeit zu wählen, lösche bitte die vorherige Auswahl.', HU: 'Ein Erwachserer ist pro Buchung benötigt.', hb: 'Überprüfen die Netzwerkverbindung und versuche es erneut', hc: 'Wir haben die Alterskategorie von \"{alt}\" in \"{neu}\" geändert', hd: 'Wir mussten eine Kabine entfernen, weil Du den Passagier entfernt hast. Es muss mindestens einen Erwachsenen pro Kabine geben.', he: 'ClubOne für {Name} hinzugefügt!', hf: 'Du hast die maximale Anzahl von Passagieren pro Reservierung erreicht', hg: 'Wir haben zu Deiner Reservierung weitere Mahlzeiten für neue Passagiere hinzugefügt', hh: 'Wir haben von Deiner Reservierung Mahlzeiten für entfernte Passagiere gelöscht', hi: 'Wir mussten ein Fahrzeug entfernen, weil Du einen Passagier entfernt hast und Du mindestens einen Erwachsenen pro Fahrzeug auswählen musst.', hj: 'Achtung! Bisherige Passagieranzahl wurde entfernt. Maximal 5 Passagiere für die Strecke Muuga-Vuosaari erlaubt.', hk: 'Tagesrabatt Rabatt inbegriffen!', hl: 'Beim Abrufen der Fahrpläne ist ein Fehler aufgetreten.', hm: 'Mit Übernachtung an Bord', hn: 'Tag in Turku Rabatt hinzugefügt', ho: 'Tag in Stockholm Rabatt hinzugefügt', HV: 'Lange Wartezeit in Stockholm', hp: 'Du hast die letzte verfügbare Kabine \"{Name}\" hinzugefügt', hq: 'Du brauchst min. einen Erwachsenen pro Kabine', hr: 'Die Kabinenklasse \"{Name}\" ist nicht verfügbar. Ausverkauft.', hs: 'Das letzte Fahrzeug wurde gebucht.', ht: 'Es können keine weiteren Fahrzeuge hinzugefügt werden. Nur 1 Fahrzeug pro Erwachsenen erlaubt.', hu: 'Das Fahrzeug darf in Tallinn nicht von Bord', hv: 'Fahrzeug nur auf dem Hinweg verfügbar.', hw: 'Fahrzeug nur auf dem Rückweg verfügbar.', hx: 'Ausgewähltes Fahrzeug nicht für die Abfahrt verfügbar.', hy: '+ Tier', hz: 'Allergie', hA: 'Käfig', hB: 'Käfige', hC: 'Behinderte', hD: 'Kabine', hE: 'Kabinen', hF: 'Erwachsene\n18+', H1: 'Auverkauft', hG: 'Nur noch {capacity} Personenkabinen frei', hH: 'Nur noch {capacity} Personenkabienn frei für {from}-{to}', hI: 'Reisen mit Haustier', hJ: 'Read more', hK: 'Geteilte Plätze', hL: 'Frauenplatz', hM: 'Herrenplatz', hN: '{name}, {genderPlace} von {maxOccupancy} Personen Kabine', hO: '{price} / Kabine', tm: '{price} / Person', hP: 'Reiseklasse', hQ: 'Spezial Kabinen', H2: 'Kabinen', hR: 'Tier', hS: 'Tiere', hT: 'Mit Haustier', hU: 'Erlebe fantastische Unterhaltung und mache günstige steuerfreie Einkäufe. Genieße die vielfältigen und köstlichen Speisen in den Restaurants an Bord.', hV: '22 Stunden Minikreuzfahrt an Bord der neu renovierten Europa. Abfahrt täglich um 18:30 Uhr von Helsinki nach Tallinn.\r\n4 Stunden an Land in Tallinn am nächsten Tag (08:00 -12: 10).', hW: 'Verbringe zwei Nächte an Bord der Romantika oder Isabelle. Erkunde Stockholm für ca. 6 Stunden. Kehre mit demselben Schiff in derselben Kabine zurück, in der Du angekommen bist.\nSpeise gut, shoppe mit günstigen steuerfreien Preisen und genieße die abendliche Unterhaltung.', hX: 'Abfahrt um 07:10 Uhr von Stockholm. Resie an Bord der Baltic Princess nach Åland, wo Du das Schiff nach Galaxy wechselst. Gegen 18:15 Uhr Rückkehr in Stockholm.', hY: 'Du kannst die Nacht an Bord der Baltischen Königin oder Victoria I. Ankunft in Stockholm am nächsten Morgen sehen. Buche eine Einweg- oder Hin- und Rückfahrt.\nSpare Geld, shoppe mit günstigen steuerfreien Preisen und entspanne Dich in der Sauna oder im Whirlpool im Entspannungsbereich. Darüber hinaus kannst Du die abendliche Unterhaltung genießen.', hZ: 'Verbringe zwei Nächte an Bord der Romantika oder Isabelle. Erkunde Riga für ca. 6 Stunden. Kehre mit demselben Schiff in derselben Kabine zurück, in der Du angekommen bist. Die Gesamtlänge der Reise beträgt 40 Stunden.\nSpeise gut, shoppe mit günstigen steuerfreien Preisen und genieße die abendliche Unterhaltung.', h_: 'Speisen Sie gut, shoppen Sie mit billigen steuerfreien Preisen und entspannen Sie in der Sauna oder im Whirlpool im Entspannungsbereich. Darüber hinaus können Sie die abendliche Unterhaltung genießen.', h$: 'Abfahrt um 19:30 Uhr von Stockholm. Verbringen Sie eine Nacht an Bord der Galaxy. Keine Landzeit in Turku. Kehre am nächsten Tag nach Stockholm zurück.\nSpeise gut, shoppe mit günstigen steuerfreien Preisen und genieße die abendliche Unterhaltung.', h0: 'Speise gut, shoppe mit günstigen steuerfreien Preisen und entspanne in der Sauna oder im Whirlpool im Entspannungsbereich. Darüber hinaus kannst Du die abendliche Unterhaltung genießen.', h1: 'Abfahrt um 08:15 von Turku. Reise an Bord der Galaxy nach Åland, wo Du in die Baltic Princess wechselst. Gegen 19:15 Uhr Rückkehr in Turku.', h2: 'Abfahrt um 20:15 von Turku. Verbringen Sie eine Nacht an Bord der Baltic Princess. Keine Landzeit in Stockholm. Kehre am nächsten Tag nach Turku zurück.\r\nSpeisen Sie gut, shoppen Sie mit günstigen steuerfreien Preisen und genießen Sie die abendliche Unterhaltung.', h3: 'Reisen Sie mit Silja Serenade oder Silja Symphony nach Åland.', h4: 'Verbringen Sie die Nacht an Bord der Silja Symphony oder Silja Serenade. Ankunft in Stockholm am nächsten Morgen. Buchen Sie eine Einweg- oder Hin- und Rückfahrt.', h5: 'Mehrere Abfahrten pro Tag. Reisen Sie bequem und schnell. Dauer an Bord Star und Megastar ist nur 2 Stunden und an Bord Victoria I 3,5 Stunden.', h6: 'Reisen Sie täglich zwischen Helsinki West Terminal 2 nach Tallinn schnell und bequem mit Tallink Shuttle Schiffen Star und Megastar Nur 2 Stunden pro Strecke.', h7: 'Zwei tägliche Abfahrten von Helsinki: 10:30 und 16:30 Uhr. Die Gesamtdauer der Reise beträgt 5 Stunden und es gibt keine Ausschiffung in Tallinn.\r\nSie können einen Rabatt erhalten, wenn Sie große Einkäufe tätigen. Wenn Sie sehr große Einkäufe tätigen möchten, ist es am einfachsten, mit einem Auto zu kommen und es in der Autogarage zu lassen, die sich neben dem Traveller Superstore auf Deck 7 befindet.', h8: 'Verbringen Sie die Nacht an Bord von Romantika oder Isabelle. Ankunft in Stockholm am nächsten Morgen. Buchen Sie eine Einweg- oder Hin- und Rückfahrt.\r\nSpeisen Sie gut, shoppen Sie mit günstigen steuerfreien Preisen und genießen Sie die abendliche Unterhaltung.', h9: '4 tägliche Abfahrten nach Åland. Reisen Sie an Bord der Baltic Princess, Galaxy, Silja Serenade, Silja Symphonie, Victoria I oder Baltic Queen.', ia: 'Verbringen Sie die Nacht an Bord der Silja Symphony oder Silja Serenade. Ankunft in Helsinki am nächsten Morgen. Buchen Sie eine Einweg- oder Hin- und Rückfahrt.\r\nErleben Sie fantastische Unterhaltung und machen Sie günstige steuerfreie Einkäufe. Genießen Sie die vielfältigen und köstlichen Speisen in den Restaurants an Bord.', ib: 'Verbringen Sie die Nacht an Bord von Romantika oder Isabelle. Ankunft in Riga am nächsten Morgen. Buchen Sie eine Einweg- oder Hin- und Rückfahrt.\r\nSpeisen Sie gut, shoppen Sie mit günstigen steuerfreien Preisen und genießen Sie die abendliche Unterhaltung.', ic: 'Speisen Sie gut, shoppen Sie mit billigen steuerfreien Preisen und entspannen Sie in der Sauna oder im Whirlpool im Entspannungsbereich. Darüber hinaus können Sie die abendliche Unterhaltung genießen.', id: 'Verbringen Sie einen halben Tag oder eine Nacht an Bord der Baltic Princess oder Galaxy.\r\nSpeisen Sie gut, shoppen Sie mit günstigen steuerfreien Preisen und genießen Sie die abendliche Unterhaltung.', ie: 'Reisen Sie nach Åland mit Baltic Queen oder Victoria I.', $8: 'Mehrere Abfahrten pro Tag von Tallinn D-Terminal. Reisen Sie bequem und schnell. Dauer an Bord Star und Megastar ist nur 2 Stunden und an Bord Victoria I 3,5 Stunden.', ig: 'Reisen Sie täglich zwischen Helsinki West Terminal 2 nach Helsinki schnell und bequem mit Tallink Shuttle Schiffen Star und Megastar Nur 2 Stunden pro Strecke.', ih: 'Verbringen Sie die Nacht an Bord der Baltic Queen oder Victoria I. Ankunft in Stockholm am nächsten Morgen. Buchen Sie eine Einweg- oder Hin- und Rückfahrt.', ii: 'Reisen Sie nach Åland mit Baltic Princess oder Galaxy.', ij: 'Verbringen Sie einen halben Tag oder eine Nacht an Bord der Baltic Princess oder Galaxy.\r\nSpeisen Sie gut, shoppen Sie mit günstigen steuerfreien Preisen und genießen Sie die abendliche Unterhaltung.', ik: '2 Nächte an Bord und ein Tag in Helsinki', il: '2 Nächte an Bord und ein Tag in Tallinn', im: '2 Nächte an Bord und ein Tag auf Aland', $9: '22 Stunden Cruise nach Tallinn <br> 4 Stunden Zeit an Land', io: 'Eine entspannte Mini-Auszeit am Meer.', ip: 'Kreuzfahrt nach Åland und zurück. Kein Landgang.', iq: '2 Nächste an Bord <br> und ein Tag in Helsinki', ir: '2 Nächte an Bord <br> und ein Tag in Riga', is: '2 Nächte an Bord <br> und ein Tag in Tallinn', it: 'Eine Nacht an Bord.<br>Abfahrt am Abend mit der Galaxy.', iu: 'Genießen Sie die 23-stündige Kreuzfahrt an Bord der Baltic Princess', iv: '11-stündige Kreuzfahrt nach Åland und zurück. <br> Abfahrt von Turku um 8.15.', iw: 'Eine Nacht an Bord.<br>Abfahrt am Abend mit der Baltic Princess', ix: 'Genießen Sie die 23-stündige Kreuzfahrt an Bord der Baltic Princess', iy: 'Ein Tag an Bord <br> Abfahrt am Morgen mit der Galaxy', iz: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Åland und Helsinki', iA: 'Einzelfahrt oder Hin-und Rückfahrt', iB: 'Einfache Fahrt oder Rückfahrt. <br> Tägliche Abfahrten von Åland.', iC: 'Einzelfahrt oder Hin-und Rückfahrt <br> 4 Abfahrten täglich', iD: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Åland und Tallinn', iE: 'Einzelfahrt oder Hin-und Rückfahrt.', iF: 'Einzelfahrt oder Hin-und Rückfahrt <br> Tägliche Abfahrt um 17 Uhr', iG: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Helsinki und Stockholm', iH: 'Hin- und Rückfahrt am selben Tag. <br> Holen Sie sich das günstige Tagesticket.', iI: 'Einzelfahrt oder Hin-und Rückfahrt <br> Dauer 2 Stunden und an Bord der Victoria I 3,5 Stunden', iJ: '5 Stunden Shopping Cruise mit oder ohne Auto. <br> Sparen Sie Zeit, Geld und Mühe.', iK: 'Einzelfahrt oder Hin-und Rückfahrt', iL: 'Einzelfahrt oder Hin-und Rückfahrt', iM: 'Einfache Fahrt oder Hin- und Rückfahrt mit Sea Wind. <br> Zwei tägliche Abfahrten', iN: 'Einfache Fahrt oder Rückfahrt. <br> Tägliche Abfahrten von Riga.', iO: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Riga und Stockholm', iP: 'Einzelfahrt oder Hin-und Rückfahrt <br> 4 tägliche Abfahrten von Stockholm', iQ: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Stockholm und Helsinki', iR: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Stockholm und Riga', iS: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Stockholm und Tallinn', iT: 'Einzelfahrt oder Hin-und Rückfahrt', iU: 'Hinflug oder Hin- und Rückfahrt. <br> Tägliche Abfahrt um 18:00 Uhr.', iV: 'Einzelfahrt oder Hin-und Rückfahrt <br> Dauer 2 Stunden und an Bord der Victoria I 3,5 Stunden', iW: 'Hin- und Rückfahrt am selben Tag. <br> Holen Sie sich das günstige Tagesticket.', iX: 'Einzelfahrt oder Hin-und Rückfahrt <br> tägliche Abfahrten von Tallinn und Stockholm', iY: 'Einzelfahrt oder Hin-und Rückfahrt.', iZ: 'Einzelfahrt oder Hin-und Rückfahrt', i_: 'Einzelfahrt oder Hin-und Rückfahrt', i$: 'Einfache Fahrt oder Hin- und Rückfahrt mit Sea Wind. <br> Zwei tägliche Abfahrten', i0: 'Turku', i1: 'Zwei Nächte an Bord und ein Tag in Tallinn.', i2: 'Einfache Fahrt oder Rückfahrt. <br> Tägliche Abfahrten von Tallinn.', H3: 'Zweit Tage', i3: 'Zwei Nächte auf See, zwei Tage in Härnösand - eine zusätzliche Nacht an Bord in Härnosand und zwei Tage, um das Ziel zu entdecken. Nutze die Gelegenheit, in unseren Geschäften einzukaufen, und während der gesamten Reise kannst Du zollfrei einkaufen.', i4: 'Zwei Nächte auf See, zwei Tage in Helsinki - eine zusätzliche Nacht an Bord in Helsinki und zwei Tage, um Finnland zu entdecken. Nutze die Gelegenheit, in unseren Geschäften einzukaufen, und während der gesamten Reise kannt Du zollfrei einkaufen.', i5: '2 Nächte an Bord und ein Tag auf Aland', i6: 'Zwei Nächte an Bord und ein Tag in Härnösand.', i7: 'Verbringe zwei Nächte an Bord, genieße einen Tag in Helsinki', i8: 'Verbringe zwei Nächte an Bord, genieße einen Tag in Riga', i9: 'Zwei Nächte an Bord und ein Tag in Saaremaa', ja: 'Verbringe zwei Nächte an Bord, genieße einen Tag in Stockholm', jb: 'Verbringe zwei Nächte an Bord, genieße einen Tag in Tallinn', H7: 'Code nutzen', jc: 'Emissionszuschlag für Fahrzeuge', jd: 'Der Emissionszuschlag gilt für das in der Reservierung gebuchte Fahrzeug.', Id: 'Emissions- und Treibstoffzuschlag', Ie: 'Der Emissions- und Treibstoffzuschlag gilt für das in der Reservierung gebuchte Fahrzeug.', je: 'Bis zu 1,5 m hoch und bis zu 3.0 m lang', jf: 'Bis zu 1,9 m hoch und 5,0 m lang', jg: 'Füge einen Garagenplatz hinzu und parke bequem neben dem Traveller Superstore &rarr;', jh: 'Möchtest Du unter den Ersten an Deinem Zielort aussteigen? Priority Car hinzufügen &rarr;', ji: 'Über 2,4 m hoch und bis zu 8,0 m lang', jj: 'm', jk: 'Bis zu 1,9 m hoch und bis zu 5,0 m lang.\r\nAm Zielort kann das Auto nicht nach draußen gefahren werden.', jl: 'Bitte gebe die Kfz-Kennzeichen für alle Fahrzeuge ein', Ii: 'Entfernen', jm: 'Wähle ein Fahrzeug aus Deiner vorherigen Reise aus:', jn: 'Bis zu 2,3 m hoch und bis zu 7,0 m lang', jo: 'Bis zu 1,9 m hoch und bis zu 12 m lang', jp: 'Kennzeichen des Anhängers', jq: 'Die Registrierungsnummer darf nur Ziffern und lateinische Buchstaben enthalten', jr: 'Bis zu 2,4 m hoch und bis zu 7,0 m lang', js: 'Fahrzeuginformationen fehlen', jt: 'Kfz-Kennzeichen', ju: 'Fahrzeuge hinzugefügt:', jv: 'Fahrzeugverfügbarkeit prüfen', Il: 'Überfahrt via Helsinki', jw: 'Visby', jx: 'Ystad/Visby', jy: 'Ventspils', Ip: 'Gutschein:', Iq: 'Please log-in with your Club One account to see the availability of the offer.', Ir: 'Verzeihung, diese Geschenkkarte wurde bereits hinzugefügt.', Is: 'Entschuldigung, diese Geschenkkarte ist abgelaufen.', It: 'Entschuldigung, diese Geschenkkarte hat eine andere Währung.', Iu: 'Leider ist für diese Geschenkkarte kein Guthaben verfügbar.', jz: 'Vuosaari', IA: 'Minikreuzfahrt', IC: 'wow', tE: 'Tagesausflug', jA: 'Ystad'};
var $author$project$Translations$Generated$en = {P: 'Read our accessibility statement', Q: 'https://www.tallink.com/en/accessibility', tJ: 'add', R: 'Add another code', S: 'To add vehicles, please add more adult passengers. Bicycles can also be added for 6-17 y/o children.', tK: 'Add rooms for all passengers', pl: 'add seats', tM: 'Travelling on route {route} is possible only with a vehicle.', tN: 'Would you like to add a vehicle to {route} route aswell?', tO: 'Add route?', T: 'Åland', t_: 'Åland (Långnäs)', t$: 'Åland (Mariehamn)', ue: 'You have already selected room(s) in another hotel. To choose a room in this one you need to clear your current selection first.', uj: 'Cruise', ul: 'Cancel & Continue booking', um: 'Continue to desktop version', un: 'If you continue to desktop version, you will lose the following selections: <span class=\"bodyBold\">passenger information, cabin class, meals</span>.', uo: 'You will lose some selections', up: 'If you continue to desktop version, you will lose the following selections: <span class=\"bodyBold\">passenger information and meals</span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Bank', X: 'Danske Pank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'Bank', aa: 'Select your bank to continue', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click login or mobile phone number', ah: 'Last selected', ai: 'Säästöpankki', aj: 'SEB', ak: 'Select bank:', al: 'S-Pankki', am: 'Swedbank', uB: 'book meals', uC: 'Book these trips separately:', uD: 'Add onboard services', uE: 'Go to desktop &rarr;', uF: 'Do you need some features that are not available here?', uG: 'Add bus transfers', uH: 'To and from the harbour', uI: 'Book a trip using company id', ao: 'Book easier, use your discounts', ap: 'Log out &rarr;', uJ: 'Sign in', aq: 'Do you have Club One account?', ar: 'Show available dates', uK: 'The discount cannot be used on the selected trip. Try selecting another date, route or travel class.', as: 'Check the code and try again', uL: 'Cancel', at: 'The booking code is applied', au: 'The code is correct', uM: 'Check the code and try again. If you have recently used the code, it might be locked. You can wait for 20 minutes and try again.', av: 'Also note that your code may sometimes get locked. In this case wait 30 minutes and try again', aw: 'The discount is applied', ax: 'Discount code', ay: 'The code is not valid for the selected date', az: 'However you can use it for other dates', aA: 'The original price {oldPrice} has changed to {discountedPrice}', aB: 'The original price {oldPrice} is now reduced to {discountedPrice}', aC: 'Remove', uN: 'The code is correct. Please choose your cabin first in order to get a discount.', uO: 'To use a gift card, please call +49 40 547 541 222', aD: 'Discount Code Enabled', aE: 'I have a discount code', aF: 'points', uP: 'Add extra services', aG: 'Fast track', aH: 'Garage', aI: 'Insurance', uQ: 'Plan with Confidence', aJ: 'Priority Car', uR: 'Choose departure location', uS: 'Choose destination', aK: 'Book a trip', uT: '22h cruise trip', uU: 'Cruises', uV: 'Cruises', uW: 'No ashore time in destination', py: 'No ashore time in destination', uX: 'Day in Helsinki cruise', uY: 'Day in Riga cruise', uZ: 'Day in Stockholm cruise', u_: 'Departure On', u$: 'Please note that the ship may not meet the needs of passengers with disabilities.', aL: 'No disembarkation during the cruise', u0: 'Return On', u1: 'One-Way Trip', u2: 'Round Trip', aM: 'Megastar 5h cruise', u3: 'One-Way Trip', u4: 'Round Trip', ne: 'Trip', aN: 'Trip type', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Select your language', aV: 'English', aW: 'Do you want to change the language?', u5: 'Choose the meals', aX: 'Meals can be booked onboard', u6: 'No meals available', u7: 'Book meals in advance and save money', u8: 'Meals', aY: 'I have a discount code', u9: 'Optional services', aZ: 'Booking must have exactly one vehicle.', va: 'Covid-19', a_: 'Covid-19 test', vb: 'Kids bracelets', vc: 'Massage', vd: 'Passengers', ve: 'Join Club One &rarr;', vf: 'https://clubone.tallink.com/join', vg: 'Sign out &rarr;', vh: 'Get Club One discounts and book easier', a$: 'Choose a cabin', vi: 'Travel Class', vj: 'Cabins', a0: 'Bicycle, electric scooter', a1: 'Passenger car', a2: 'Passenger car', vl: 'Choose a vehicle', vm: 'Fill in licence plate number', a3: 'Loading prices', a4: 'Motor&shy;cycle', a5: 'Motor&shy;cycle with side&shy;car', a6: 'Parked car', a7: 'Licence plate number was pre-filled', a8: 'Shopping car', a9: 'Shopping van', ba: 'Show all', bb: 'Van', bc: 'High\nVan', bd: 'Vehicle extra long & high', be: 'Car and\ntrailer', bf: 'Car and\ntrailer', bg: 'Car and\ntrailer', vB: 'Add another bus \ntransfer', bh: 'Add a cabin surprise', bi: 'Free gift', bj: '{count} surprises selected', bk: '{count} surprise selected', vC: 'Load More', bl: 'Load Previous', bm: 'Date', vD: 'Special Cruise', bn: 'Please note', vE: 'Price starting from {price}', vF: 'No available departures', vG: 'No departures on the selected date.', bo: 'all prices are in krona', bp: 'Cabin from {price} p', bq: 'from {price} points per person', br: 'from {price} per person', bs: 'Cabin from {price}', bt: 'Cancel', bu: 'Continue', bv: 'If you continue, your cabin selection will be reset. The passenger details will remain.', bw: 'Your cabin class is unavailable on the selected date', vH: 'Special<br/>Cruise', vI: 'Car from {price}', bx: 'Sold out', by: 'Emissions surcharge', bz: 'Emissions surcharge is applied to passengers from age 6 to adult.', bA: 'Emissions surcharge to support climate action and cover costs from the EU Emissions Trading System', vQ: '{chars} characters left', vR: 'Check in:', vS: 'Check out:', vW: 'Choose &rarr;', vX: 'Choose your room', vY: 'Choose your stay to see final price', v3: 'clear & select', bB: 'Bronze level', bC: 'Club level', wd: 'Club one discount:', bD: 'Gold level', bE: 'Inactive club one', bF: 'Club one number', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One account reactivation\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One account reactivation\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Club One account reactivation\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One account reactivation\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Club One account reactivation\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One account reactivation\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: 'E-mail:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">Your Club One account is inactive. Please contact us.\n</a>', bQ: 'Your Club One account is inactive. Please contact us:', bR: '<a href=\"tel:+494940547541222\">+494940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Phone:', b_: 'Platinum level', wg: '<a>Sign in</a> or <a>join Club One</a> to get discounts, use points and book easier.', b$: 'Silver level', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Maximum points you can use is calculated dynamically and based on items and services in your booking.', wj: 'Use available Club One points', wk: 'Club One points cannot be redeemed with this voucher code.', wl: 'Club One points can’t be used for this trip.', b0: 'You can now use your Club One points for payment in <a>a slider below</a>.', wm: 'Club One points cannot be redeemed ({reason}).', pQ: 'Code', wp: 'Your entered text contains not allowed special characters.', wr: 'Date of birth', ws: 'dd', wt: 'mm', wu: 'yyyy', wv: '{count} {count, plural, one{adult} other{adults}}', ww: '({range} yrs)', wx: 'Arrives at {time}', pT: '{count} {count, plural, one{child} other{children}}', wy: 'Free', wz: 'Less', wA: 'More', wB: 'Citizenship', wC: 'Popular', b1: 'The prices include your Club One {level} discount.', wD: 'Club One passengers need to be filled now, others can be filled later.', b2: 'p', b3: 'Use Club One points', b4: 'Coming soon', wE: 'Add Club One number before booking', wF: 'Done', wG: 'Change &rarr;', b5: 'For faster check-in and easy sharing of booking info and boarding passes, fill in phone and e-mail for all passengers.', wH: 'First name', wI: 'Gender', wJ: 'Female', wK: 'Male', wL: 'Included in price', mh: 'Check your input', wM: 'This e-mail belongs to contact person or another passenger', wN: 'This phone number belongs to contact person or another passenger', wO: 'Last name', wP: 'Fill all mandatory fields (marked with *) to save', wQ: 'Breakfast', wR: 'Brunch', wS: 'Buffet', wT: 'Dinner', wU: 'Lunch', wV: 'À la carte reservations', wW: 'Meals can be booked on board', wX: 'Name should only contain latin characters.', wY: 'Not available', b6: 'Unavailable for this trip', wZ: 'Not required', b7: 'Adult\n18+', b8: 'Child\n0-5', b9: 'Child\n6-11', ca: 'Child\n12-17', cb: 'Banks', w_: 'Pay {price}', cc: 'Paying {price}', cd: 'Cards', w$: 'Confirm booking {price}', w0: 'Confirming {price}', ce: 'Pay with Klarna {price}', cf: 'Payment is being processed...', w1: '<p>The combination of travel services offered to you is a package within the meaning of Directive (EU) 2015/2302. </p>\n<p>Therefore, you will benefit from all EU rights applying to packages. AS Tallink Grupp will be fully responsible for the proper performance of the package as a whole.</p>\n<p>Additionally, as required by law, AS Tallink Grupp has protection in place to refund your payments and, where transport is included in the package, to ensure your repatriation in the event that it becomes.</p>\n<p><a href=\"https://www.tallink.com/good-to-know/package-travel\" target=\"_blank\">View the terms of travel packages</a>.</p>', pU: '<p>The combination of travel services offered to you is a package within the meaning of Directive (EU) 2015/2302.</p>\n<p>Therefore, you will benefit from all EU rights applying to packages. {name} will be fully responsible for the proper performance of the package as a whole.</p>\n<p>Additionally, as required by law, {name}  has protection in place to refund your payments and, where transport is included in the package, to ensure your repatriation in the event that it becomes.</p>\n<a href=\"{url}\" target=\"_blank\">View the terms of travel packages</a>.', w2: 'By pressing the payment button, you agree with <a href=\"https://www.tallink.com/good-to-know/payment-and-cancellation-policies\" target=\"_blank\"\">terms and conditions</a>, <a href=\"https://www.tallink.com/good-to-know/rights-of-passengers\" target=\"_blank\">security regulations</a> and the rules and regulations related to <a href=\"https://www.tallink.com/good-to-know/club-one\" target=\"_blank\">Club One loyalty program</a>.', w3: 'By clicking the payment button, you agree to Tallink\'s <a href=\"https://www.tallink.com/good-to-know/payment-and-cancellation-policies\" target=\"_blank\" >payment and cancellation terms</a> and <a href=\"https://www.tallink.com/good-to-know/rights-of-passengers\" target=\"_blank\" >security regulations</a> and confirm that you have read the <a href=\"https://www.tallink.com/privacy-policy\" target=\"_blank\" >privacy policy</a>.', w4: 'AS Tallink Grupp', w5: 'https://www.tallinksilja.com/packaged-tours-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://en.tallink.com/packaged-tours-tallink-silja', w8: 'Under 18 years old passenger, please remember to read the <a href=\"https://www.tallink.com/good-to-know/age-regulations\" target=\"_blank\">age regulations</a>.', w9: 'Alipay', xa: 'Apple Pay', xb: 'local banks', xc: 'cards', xd: 'Google Pay', xe: 'Mobile Pay', xf: 'Debit/credit card', xg: 'WeChat Pay', xh: 'Online bank & Debit/credit card', xi: 'Local banks', xj: 'Online bank', cg: 'From {price}', xk: 'Scroll up for settings', xl: 'Select', xm: 'Selected', xn: 'Ship', xo: '{date} at {time}', xp: '{count} {count, plural, one{passenger} other{passengers}}', xq: 'Adult\n18+', xr: 'Child\n0-5', xs: 'Child\n6-17', xt: 'Please select your cabin first', xu: 'Arrival harbour in Åland is Långnäs harbour (30 km from Mariehamn)', xv: 'Arrival in Långnäs', xw: 'Departure and arrival harbour in Åland is Långnäs harbour (30 km from Mariehamn)', xx: 'Departure harbour in Åland is Långnäs harbour (30 km from Mariehamn)', xy: 'Departure from Långnäs', pV: 'Vehicle', xz: 'Vehicles', ch: '22 h Cruise with Baltic Queen', ci: 'Cruise', cj: 'One-way and return trip', ck: 'Route trip', cl: 'One-way, return and day tickets', xB: 'Company customer', xC: 'Agent id', xD: 'Agent with given credentials cannot be found', xE: 'NB! Agent ID is optional', xF: 'You will be logged out from your personal account temporarily', xG: 'Company id', xH: 'Company customer with given credentials cannot be found', cm: 'A confirmation has been sent to', cn: 'Booking is complete, have a great trip!', co: 'You will get {refund} back!', cp: 'Please call our customer support for refund options!', cq: 'Your reservation has been updated!', xI: 'Adult', xJ: 'Name of city or town', xK: 'No results', xL: 'Search for bus stop', xM: 'Bus transfers', cr: 'Children 6 - 17 yrs.', cs: 'Change booking', xN: 'Basic ticket', xO: 'Children {range} yrs', ct: 'Onshore activities', cu: 'No', cv: 'Of course', cw: 'Would you like to receive the best Tallink & Silja Line offers via e-mail?', cx: 'Thank you for signing up for our newsletter!', cy: 'Call sales support', cz: 'Cancel', xP: 'Entered birthdate doesn\'t match previously selected age category. Please enter correct birthdate or contact our sales office for changing age category:', cA: 'Change age category?', cB: 'Buy services', cC: 'Change services', cD: 'Address', cE: 'Company', cF: 'To make changes to your booking, please contact our <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contacts\">customer service</a>.', cG: 'To make changes to your booking, please contact our <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-osss\">customer service</a>.', cH: 'To make changes to your booking, please contact our <a href=\"https://www.tallink.com/ee-et/hea-teada/kontaktid\">customer service</a>.', cI: 'To make changes to your booking, please contact our <a href=\"https://www.tallinksilja.fi/palvelunumerot\">customer service</a>.', cJ: 'To make changes to your booking, please contact our <a href=\"https://www.tallink.lv/lv/contacts\">customer service</a>.', cK: 'To make changes to your booking, please contact our <a href=\"https://www.tallinksilja.com/contact-us\">customer service</a>.', cL: 'To make changes to your booking, please contact our <a href=\"https://www.tallinksilja.ru/agents\">customer service</a>.', cM: 'To make changes to your booking, please contact our <a href=\"https://www.tallinksilja.se/kontakta-oss\">customer service</a>.', cN: 'To make changes to your booking, please contact our <a href=\"https://www.tallink.com/good-to-know/contacts\">customer service</a>.', cO: 'Contact name', cP: 'Contact person', cQ: 'To make changes to your booking, please contact your travel agency.', cR: 'E-mail', cS: 'Join Club One', cT: 'Booking confirmation', cU: 'Check-in will start 2h before departure. Please note that check-in must be done at the vehicle check-in area at least 45min before departure.', cV: 'Please fill in all fields of individual passengers.', cW: 'Cancel', cX: 'Continue', cY: 'If you continue, the changes you have done to the passenger information will not be saved', cZ: 'Changes will not be saved', c_: 'Show confirmation as PDF', c$: 'See PDF receipt from your confirmation e-mail for payment details', c0: 'Show terms and conditions', c1: 'https://www.tallink.com/good-to-know/general-travel-conditions', xQ: 'Total', c2: 'Phone number', c3: 'Booking number', c4: 'Security code', c5: 'Confirmation', c6: 'Arrival and departure times are always indicated in local time.', c7: 'Boarding cards can be obtained from the terminal self check-in with booking number and security code.', c8: 'We recommend to arrive at the check-in well in advance.', c9: 'Passengers travelling without a vehicle must be at check-in latest 30 minutes prior to departure. Passengers travelling with a vehicle are advised to be at check-in latest 1 hour prior to departure. NB! Passengers travelling with a vehicle from Tallinn or Stockholm to Mariehamn must be at car check-in latest 1,5 hour prior to departure.', da: 'In case of day trip or cruise Tallink cancels the whole trip, if the passenger has not registered the ticket in the port of first departure.', db: 'Please remember to have a valid passport or national ID with you when travelling (required also for children). If you are not sure if a visa is required, please contact the embassy of the country of your travel destination.', dc: 'The ship\'s arrival and departure times are always shown in local time. <br>\nYou can check in online, in the Tallink Silja Line app, or at the terminal. <br>\nAt Paldiski and Kapellskär ports, check-in for vehicle passengers closes 75 minutes before the Superfast ferry\'s departure. We recommend arriving at the port early. <br>\nCabin cards will be issued on the check-in. <br>\nEvery passenger (including children must carry a valid travel document and any other \nnecessary papers, such as a visa if required, for the entire journey. <br>\nPassengers are responsible for the validity and accuracy of their documents.', dd: 'Information about your trip', de: 'Trip advice', df: 'Refund', dg: 'You will get a refund of {refund}! Please call our customer support to get your refund.', dh: 'Call to get a refund', di: 'Called already? Don’t worry, this notification will disappear once we have processed your refund.', dj: 'Get your refund', xR: 'If the connectivity issue persists, contact our customer support', xS: 'No Internet connection, please reconnect and try again.', xT: 'Try again', xV: 'Continue', xW: 'Continue to pay', pX: 'E-mail address', xX: 'Example:', dk: 'Country code and phone number', xY: 'Contact information', xZ: 'Add your contact info so we can send you the booking confirmation. To use Club One benefits, log in or enter your Club One number in the passenger page before booking.', x_: 'This information will be updated on your Club One account', pY: 'Phone Number', dl: 'Example: 400346544', x$: 'Other', x0: 'A copy of the booking confirmation will be sent to {email}', dm: 'Additional E-mail', dn: 'ZIP code', x6: '{price} / test', x8: 'Book this trip faster with our <b> new booking flow</b>.', dp: 'Full name', dq: 'Credit card', dr: 'mm', ds: 'Credit card number', dt: 'Payment method', du: 'Security code', dv: 'Select your credit card:', dw: 'Valid Through', dx: 'yy', dy: 'Cruise Stockholm(Kappellskär)-Turku-Stockholm(Kappellskär)', ya: 'Cruise to Helsinki', yb: 'Cruise to Visby', dz: 'Cruise Turku-Stockholm(Kappellskär)-Turku', yc: 'Cruise with visiting Ystad', dA: 'Day in Helsinki cruise', dB: 'Day in Riga Cruise', no: 'Day in Tallinn cruise', yj: 'Day in Turku cruise', yr: 'Dessert', dC: 'Discount:', yy: 'Applied', yz: 'Promotional code or gift card:', p9: 'Discounts & Gift Cards', dD: 'Don’t forget to select one menu option for each adult passenger in {restaurant} reservation.', dE: 'Don’t forget to select one menu option for each 12 years and older passenger in {restaurant} reservation.', yB: 'Don’t miss an opportunity!', yD: 'Choose drink package', dF: 'We have found an unpaid booking for the same departure. Ref. number: {resId}, price: {price} {unit}.  Would you like to cancel the old booking and confirm payment for the new booking? <a href=\"{link}\">Open and pay old booking →</a> For further details please contact customer support', yF: 'Edit your room', yG: 'Edit your rooms', yO: 'Onshore activities', yP: 'Onshore and hotels activities', yS: 'Every passenger must have a seat in a vehicle.', dK: 'https://clubone.tallink.com', yY: 'Extra services', dL: 'Leave feedback', y_: 'SHIP', y$: 'SHIP + Hotel', y5: 'Choose menu', y7: 'Food allergies / dietary restrictions:', kS: 'From', za: 'Emission and fuel surcharge', zb: 'Fuel and emissions surcharges are applied to passengers from age 6 to adult.', zc: 'Fuel and emissions surcharges apply to passengers aged 12 and over. Up to three children aged 6–11 per booking are exempt.', zd: 'Fuel and emissions surcharges to support climate action and cover costs from the EU Emissions Trading System.', dM: 'Fuel surcharge', dN: 'Fuel surcharge is applied to passengers from age 6 to adult.', dO: 'Fuel surcharge is {price} for passenger from age 6 to adult.', dP: 'Fuel surcharge is {price} per route for passenger from age 6 to adult.', zh: 'Gift Card:', zi: 'The gift card can be used on multiple purchases until the funds are used up.\nThe gift card has {priceLeft} €.', dQ: 'Group menu available', zm: 'For bookings with 12 or more adult passengers, we kindly ask you to select one menu option for each adult passenger in the booking. Younger passengers will automatically get a kids menu voucher worth 25 €.', dR: 'Helsinki', dS: 'Two nights onboard and a day in Riga.', dT: '22 hour cruise to Tallinn.<br>4 hours onshore in Tallinn.', dU: 'Cruise to Tallinn.<br> 5 hours onshore in Tallinn.', dV: 'Visby cruises', dW: 'Summer special cruises to the magical Gotland island', dX: 'Härnösand', zv: 'Hotel', zy: 'To choose a date outside selectable area <a>change your trip dates</a> accordingly.', dY: 'Check-in', dZ: 'Check-in at', d_: 'Check-out', d$: 'Check-out at', d0: 'nights', d1: 'night', zz: 'Hotel only booking is currently available in a separate application.', zA: 'There are no hotel rooms available for selected dates. Please choose different trip dates.', zB: 'You cannot check in after the check out. You can change your check out date in the check out tab.', zC: 'You cannot check out before the check in. You can change your check in date in the check in tab.', zD: 'This is your checkin date. To change it go to check in tab.', zE: 'This is your checkout date. To change it go to check out tab.', qF: 'This date is outside your selected trip dates. To select it please change your trip dates.', zF: 'Overnight trip: night on board included.', zG: 'Overnight trip: night on board included.', zW: 'Info about food allergies / dietary restrictions has been forwarded to the ship’s crew.', q4: 'Join Club One', AB: 'Get discounts when booking, collect points that can be used for booking bonus trips, and enjoy discounts onboard and at our onshore partners.', d2: 'Street address', d3: 'City/district', d4: 'Country', d5: 'Finish Club One joining', AC: 'Postal code', AD: 'To join Club One, contact person must be one of the passengers', d6: 'By email', d7: 'By mail', d8: 'By SMS', d9: 'Preferred language', ea: 'I would like to receive Club One offers and news', eb: 'No', ec: 'Save and close', ed: 'Yes', AF: 'Welcome to Club One! You can fill in the rest of your details after booking.', AG: 'Welcome to Club One. By joining in you were given a member discount. The original price {priceBefore} has changed to {currentPrice}.', AH: 'We found an existing Club One account with these details.', ee: 'Kapellskär', ef: 'Kid menu voucher', AN: 'By confirming this booking you agree that your reservation data will be transferred to Klarna for checking available payment options. Read more', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: 'about Klarna\'s use of your data', AQ: 'Klarna & Swish', AR: 'Invoice, part payment', AS: 'Klarna', AT: 'Invoice payment', AU: 'Part payment', AV: 'Swish', AW: 'The available payment options depend on your booking, the most common options are:', eg: 'Klarna checkout', eh: 'Klarna lets you pay easily and securely with your mobile phone', ei: 'Klaipeda', ej: 'One-way or return.<br>Departure at 19:00.', A$: 'German', A0: 'English', A1: 'Estonian', A2: 'Finnish', ek: 'Lithuanian', A3: 'Latvian', A4: 'Russian', A5: 'Swedish', Bb: 'Loading...', Bc: 'Helsinki', Bd: 'Jurmala', Be: 'Kolmården', Bf: 'Kuressaare', Bg: 'Laulasmaa', Bh: 'Mariehamn', Bi: 'Narva', Bj: 'Norrkoping', Bk: 'Otepää', Bl: 'Parnu', Bm: 'Rakvere', Bn: 'Riga', Bo: 'Sodertalje', Bp: 'Stockholm', Bq: 'Tartu', Br: 'Turku', Bs: 'Tallinn', Bt: 'Tampere', Bu: 'Uppsala', Bv: 'Vantaa', Bw: 'Vihula', BC: 'Main course', BE: 'Add another', BF: 'Date:', BG: '{price} / treatment', BH: 'Time:', Cf: 'Meal not served between {direction}', Cg: 'Meal package includes meals for the whole trip.', Ch: 'Choose meal package', el: 'Not selected', em: '<span class=\"data\">{count}</span> {count, plural, one{# breakfast} other{# breakfasts}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# dinner} other{# dinners}}', rt: 'Children get a discount and 0-5 year olds eat for free with parent.\n\nYou can use the dinner vouchers for buffet dinner or as a means of payment in other restaurants', Ci: '{price} / 18+ y.o.', Cj: '{price} / adult', Ck: '{price} / person', Cl: '<span class=\"save bodySmall\">Pre-book</span><span class=\"bodySmall\">and</span><span class=\"bodyLarge percentage\">save</span>', Cm: 'Meal package', Cn: '{count, plural, one{# person} other{# people}}', Co: 'per person', Cp: 'Reservation', ru: 'Save & buy meal package', eo: 'Book a table', ep: 'Sold out', eq: 'Breakfast', er: 'Dinner', Cq: 'Meals', es: 'Voucher', Cr: 'Meals are included for the whole trip', Cs: 'Are you sure you don\'t want to add meals with <b>up to 10% discount</b>? The offer is only valid when booking online.', et: 'Meeting room', eu: '{date} at {time} for {duration} h', Ct: 'Menu available', Cu: 'We kindly ask you to select one menu option for each passenger aged 12 and older in the booking. Passengers under 12 will get a meal coupon with their reservation and can choose their meal onboard. Children get at least 50% discount from the normal price.', ew: 'Fill in passenger info', ex: 'Show passenger data', ey: 'Club One', CA: 'To change Club One passenger’s personal data, please call our sales support:', ez: 'passenger info missing', eA: 'You don’t have to print anything. Just go to the self check-in with your reservation number and security code.', eB: 'Wrong age group', eC: 'Missing passenger info', eD: 'Payment incomplete', eE: 'Edit licence plate numbers', eF: 'Licence plate no. missing', eG: 'Licence plate no. not given', eH: 'Get your booking to your phone', eI: 'Get', eJ: 'Open', eK: 'Send link', eL: 'Tallink & Silja Line app', eN: 'Muuga', CJ: 'No ashore time in destination', CK: 'At the destination car can\'t be driven outside.', CL: 'There are currently no departures available with selected trip type. Please change the trip type.', CM: 'There was a problem with your payment. You can try again or contact us by email <a href=\"mailto:international.sales@tallinksilja.com\" target=\"_blank\">international.sales@tallinksilja.com</a>', ol: 'No, thanks', CU: 'This code makes your ticket non-refundable. Read more about the specific <a href=\"#\">terms →</a>.', CV: '<ul>\n<li>It is not permitted to change the direction and/or route, departure date or time of the ticket.</li>\n<li>The passenger´s personal data, cabin class, vehicle and onboard service may be changed. When making such changes, the price difference between the originally purchased service and the amended service must be paid.</li>\n<li>If the passenger cancels the ticket, Tallink Silja Line will retain 100% of the ticket price as a contractual penalty.</li>\n<li>In all other matters, the travel conditions of AS Tallink Grupp apply, which are available at <a target=\"_blank\" href=\"https://www.tallink.com/terms\">terms page</a>.</li>\n</ul>', CW: 'Terms & Conditions', CX: 'yes, I Accept', CY: 'remove code', CZ: 'You are buying a non-refundable ticket using code <b>{code}</b>. After purchase, this ticket cannot be refunded under any circumstances. You can only change the passenger’s personal details, cabin class and services. Changes to direction, route, departure date or time are not available. Please confirm that you understand and accept these terms before proceeding to payment.', C_: 'Non-Refundable Ticket', eO: 'Not enough points', C0: 'Continue booking', C1: 'Reset booking', C2: 'Going back from this screen will reset your booking. Are you sure you want to start from the beginning?', C3: 'Reset the booking?', eP: 'Arrival harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', eQ: 'Departure harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', eR: 'Departure and Arrival harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', Da: 'Special cruise additional services', eS: 'Insurance', Db: 'Friendship adventure package', Dc: 'Kids packages', Dd: 'Priority boarding', De: 'Onboard services', Df: 'ship money', Dg: 'coupon', Dh: 'Ship money coupons', Di: 'seat', Dj: 'Service not available between {route}', Dk: 'One day', eT: 'One-way or return.<br>Daily departures.', Do: 'or', Dp: 'Other', eU: 'Other payment method', eX: '12+ y.o.', eY: 'Paldiski', eZ: 'Parked van', DI: 'Summer night cruise', DJ: 'Baltic Sea - Tallinn', e_: 'Can\'t change passenger\'s age category', DM: 'Incorrect age group – make sure the date of birth corresponds to an adult.', DN: 'Incorrect age group – make sure the date of birth corresponds to an adult or a youth.', DO: 'Check that you have entered date in DD-MM-YYYY format', DP: 'Only numbers are supported in birthday inputs', DQ: 'Fill out later', DR: 'Save', DS: 'Please check your name and Club One number.', DT: 'Club one number', DU: 'has already been added.', DV: 'Edit the details or', DW: 'start over', DX: 'Information about the travel document will be added to the Club One account.', DY: 'Document issuing state *', DZ: 'Document expiry date *', D_: 'Document issuing date *', D$: 'Document number *', D0: 'Document type *', D1: 'Country of birth *', D2: 'Special assistance', D3: 'Please provide more details via <a href=\"https://www.tallink.com/ee-en/good-to-know/special-needs-and-assistance\" target=\"_blank\">our website</a> or by calling the sales support:', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Add passenger', Ec: '<span class=\"data\">{count}</span> {count, plural, one{passenger} other{passengers}} selected', Ed: 'Fill out now or later', Ee: 'Passenger info completed', Ef: 'Passengers', e0: 'Coming soon!', e1: 'Your booking number', e2: 'Credit card', e3: 'Remove', Ei: 'Payment', e4: 'Select payment method:', Ej: 'Invoice', Ek: 'Invoice address', e5: 'Pay with a company invoice', El: 'Your reference number', e6: 'Pay Later', e7: 'Easy mobile payment', e8: 'Pay now to secure your booking.', e9: 'Bank', fa: 'Regular network charges', fb: 'Regular network charges', fc: 'Call price is 85 cent/call + operator fees.', fd: 'Call price is 0,0835 €/call + 0,167 €/minute', fe: 'Regular network charges', ff: 'Regular network charges', fg: 'Regular network charges', fh: 'Regular network charges', fi: 'Regular network charges', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Call customer support', fk: 'Unpaid reservations will be cancelled automatically.', fl: 'There was a problem with your payment. You can try again or call us.', fm: 'Change your <u>country settings</u> to the original market to finalize the payment.', fn: 'Booking was made in a different market.', Ex: 'and {points} points', r0: 'person', EA: 'persons', EH: 'D-Terminal', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs', EM: 'West terminal 2', EN: 'West terminal', EO: 'West terminal', EP: 'St. Petersburg', EQ: 'Mariehamn', ER: 'Muuga Harbour', ES: 'Olympia terminal', ET: 'Paldiski', EU: 'Riga terminal', EV: 'Sassnitz', EW: 'Turku harbour', EY: 'Värtahamnen', EZ: 'Visby', E_: 'Ventspils', E$: 'Vuosaari Harbour', E5: 'Preselected', E6: 'Book the trip', E7: 'Cancel', E8: 'Continue', E9: 'Done', fo: 'Next', Fa: 'Cheapest cabin:', Fb: 'Cheapest cabin with Club One:', Fc: 'Club One price', Fd: 'Please add more cabins', Fe: 'You will see the final price after adding the cabin', fp: 'Select the cabin class to continue', Ff: 'Subtotal:', Fg: 'Total:', fq: 'Price with Club One:', Fh: 'Checking the price...', Fj: 'Price starting from per traveller/vehicle, includes emission and fuel surcharge.', Fl: '{price} / item', sa: 'Proceed', fr: 'Proceed to payment', Fs: 'This site is protected by reCAPTCHA and the Google\n<a target=\"_blank\" href=\"https://policies.google.com/privacy\">Privacy Policy</a> and\n<a target=\"_blank\" href=\"https://policies.google.com/terms\">Terms of Service</a> apply.', ft: 'Changes in onboard services:<br>\nFri-Sat departures are full of joy, eg. live music and bingo.<br>\nSun-Thu departures have decreased services.', fu: 'Regular price:', Fy: 'To select this option remove the previous selection', FA: 'Reservation fee {fee} per person will be deducted from the restaurant bill onboard.', FB: 'The reservation fee does not apply to children up to 5 years old.', sq: 'Close', FD: 'Something went wrong, please refresh page or start booking from very beginning.', FE: 'We couldn\'t find any upcoming departures', fv: 'Start over', fw: 'We’re sorry for the inconvenience. Your current booking will be cancelled automatically.', fx: 'Your session expired', FF: 'START OVER', FG: 'Unfortunately you will need to start over. We’re sorry for the inconvenience.', FH: 'Error occurred', fz: 'Riga', fA: 'Two nights onboard and a day in Klaipeda.', fB: 'One-way or return.<br>Departure at 17:00.', fC: 'Stockholm-Turku-Turku-Stockholm(Kappellskär)', fD: 'Stockholm(Kappellskär)-Turku', fE: 'Stockholm(Kappellskär)-Turku-Turku-Stockholm', fF: 'Turku-Stockholm-Stockholm(Kappellskär)-Turku', fG: 'Turku-Stockholm(Kappellskär)', fH: 'Turku-Stockholm(Kappellskär)-Stockholm-Turku', fI: 'Back to the list', fJ: 'Sadly we haven\'t found bank you were searching for. Try to find it in the list instead.', fK: 'Search', fL: 'Sassnitz', fN: 'Please select at least one vehicle', Ge: 'Adding a car <b>will remove {service}</b> service. You sure you want to proceed?', Gf: 'Are you sure?', Gv: '5h cruise', Gw: 'Multiple daily departures from Helsinki. Total duration of the trip is 5 hours and there is no disembarkation at Tallinn. You can get a rebate when making large purchases.\nIf you are planning on making very large purchases, it is easiest to come with a car. On Megastar, the car can be accessed during the trip from the garage next to the Traveller Superstore on deck 7. On Star, cars are parked on the car deck.', Gy: 'This return time is assigned to 5h cruise. You will be redirected to appropriate page.', fO: 'The nicest time for yourself', GE: 'show table reservations', fP: 'Saaremaa', GK: 'As a 15-17 year old you can travel without being accompanied by an adult. Remember to bring your <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\">travel permit</a> with you. Safe travels!', fQ: 'St. Petersburg', GQ: 'Starter', fR: 'Stockholm', GY: 'Buy Stockholm-Helsinki', GZ: 'There is no direct connection from Tallinn to Stockholm on selected date, but you can travel via Helsinki and take the ship from there.', G_: 'Important! You will need to transfer from Olympia Terminal to West Terminal 2 to switch ships.', G$: 'Stockholm -> Tallinn <br/> via Helsinki', fS: 'Please, pay attention that alcohol is served during limited hours.', fT: 'Two nights at sea, one day in Visby. Silja Symphony will make wonderful cruises between Stockholm and Visby', fU: 'Two nights at sea, two days in Visby - an extra night aboard in Visby and two days to discover Gotland. Take the opportunity to shop in our stores and duty-free shopping is possible throughout the trip.', fV: 'Stockholm (Kappellskär)', fW: 'Three nights at sea, one day in Ystad and one day in Visby.', fX: 'surcharge', fY: 'Tallinn', G8: 'Tallinn - Baltic Sea', fZ: 'Tallinn - Baltic Sea - Tallinn', f_: 'Two nights onboard and a day in Riga.', G9: 'Buy Tallinn-Helsinki', Ha: 'There is no direct connection from Stockholm to Tallinn on selected date, but you can travel via Helsinki and take the ship from there.', Hb: 'Important! You will need to transfer from West Terminal 2 to Olympia Terminal to switch ships. <b>If you choose the 13:30 departure, you might not have enough time to make the transfer using public transportation.</b>', Hc: 'Tallinn -> Stockholm <br/> via Helsinki', f$: 'Two nights onboard<br>and a day in Turku.', f0: 'One-way or return.<br>Daily departures Turku.', f1: 'Visby cruises', f2: 'Summer special cruises to the magical Gotland island', tb: 'thanks for the info', td: 'Add return', f3: 'Book a return ticket and get up to 30% discount', f4: 'Your outward and return leg are on same day, you can get affordable Day cruise price.', o6: 'Arrival', f5: 'Looking for a later departure date?', f6: 'Pick date for {direction}', f7: 'Reset', Hx: 'Choose date', f8: '23 h Cruise (evening)', f9: '23 h Cruise (morning)', ga: 'Day in Stockholm', gb: 'Day in Turku', o7: 'Departure', Hy: 'Afternoon', Hz: 'Morning', te: 'Duration', tf: 'h', HA: 'Spend the first night onboard ship and leave as you wish between 8–11.', HB: 'First night on ship', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'Come back later', gc: 'Remove return ticket', gd: 'Megastar 5h cruise', ge: 'Close', gf: 'Immediate return trip includes a 5h cruise discount for passengers and vehicles. No disembarkation during the cruise.', gg: 'Megastar 5h cruise', gh: 'Spend one night onboard, enjoy 4 h in Tallinn', gi: 'Departure in the evening from Stockholm, no time ashore', gj: 'Departure in the morning from Stockholm, no time onshore', gk: 'Spend two nights onboard, enjoy one day in Turku', gl: 'Departure in the evening from Turku, no time onshore', gm: 'Departure in the morning from Turku, no time onshore', gn: 'Round trip Helsinki - Stockholm - Helsinki', go: 'One way from Helsinki to Stockholm', gp: 'Round trip Helsinki - Tallinn - Helsinki', gq: 'Day in Tallinn', gr: 'One way from Helsinki to Tallinn', gs: 'Megastar 5h cruise', gt: 'Round trip Riga - Stockholm - Riga', gu: 'One way from Riga to Stockholm', gv: 'Round trip Stockholm - Helsinki - Stockholm', gw: 'One way from Stockholm to Helsinki', gx: 'Round trip Stockholm - Riga - Stockholm', gy: 'One way from Stockholm to Riga', gz: 'Round trip Stockholm - Tallinn - Stockholm', gA: 'One way from Stockholm to Tallinn', gB: 'Round trip Stockholm - Turku - Stockholm', gC: 'One way from Stockholm to Turku', gD: 'Round trip Tallinn - Helsinki - Tallinn', gE: 'Day in Helsinki', gF: 'One way from Tallinn to Helsinki', gG: 'Round trip Tallinn - Stockholm - Tallinn', gH: 'One way from Tallinn to Stockholm', gI: 'Round trip Turku - Stockholm - Turku', gJ: 'One way from Turku to Stockholm', HH: 'With hotel', tg: 'Cruise', gK: 'Day in Helsinki Cruise', gL: 'Day in Tallinn Cruise', gM: 'Day in Åland Cruise', gN: 'Day in Stockholm Cruise', gO: 'Cruise to Tallinn', gP: '9h Cruise', gQ: 'Day in Stockholm Cruise', gR: 'Cruise', gS: 'Day in Åland Cruise', gT: 'Cruise to Helsinki', gU: 'Day in Stockholm Cruise', gV: '22 h Cruise', gW: 'Cruise', gX: 'Cruise two outwards', gY: 'Hide &uarr;', gZ: 'More &darr;', g_: 'Route trip', le: 'To', g$: 'We added an adult to your booking. At least one adult is required per booking.', g0: 'Garage was removed from the booking. Priority car is included in the price of Business Class', g1: 'Priority car is included in the price of Business Class', g2: 'Selected travel class is no longer available. Please choose another type of travel class.', HP: 'Licence plate number was pre-filled', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Selected bus transfer is not available on current travel dates.', g5: 'Selected bus transfers are not available and have been removed.', HQ: 'Hi, {name}!', g6: 'To pay for this trip with Club One points, you would need \nat least {clubOnePoints} points.', g7: 'Some details of the previous passenger were left unfilled. Check that you have filled in all fields.', g8: 'Because of no internet connection, the information could not be saved. Please reconnect and try again.', g9: 'Some passenger info is missing. Please fill in all fields to save the information.', HR: 'Not all passengers are included', HS: 'You need to have at least one adult per each room', ha: 'To select this meal, remove the previous selection.', HU: 'One adult per transfer required.', hb: 'Please check your network connection and try again', hc: 'We changed the age category from \"{old}\" to \"{new}\"', hd: 'We had to remove one cabin because each cabin requires an adult.', he: 'Added ClubOne for {name}!', hf: 'You have reached the maximum number of passengers per reservation', hg: 'We added to your reservation more meals for new passengers', hh: 'We removed from your reservation meals for removed passengers', hi: 'We had to remove one vehicle because you removed a passenger and you are suppose to have at least one adult per vehicle.', hj: 'NB! Previous amount of passengers was removed. Max 5 passengers allowed for Muuga-Vuosaari route.', hk: 'Day trip discount included!', hl: 'An error occurred while fetching timetables.', hm: 'With overnight stay onboard.', hn: 'Day in Turku discount added', ho: 'Day in Stockholm discount added', HV: 'Long waiting time in Stockholm.', hp: 'You added the last available cabin \"{name}\"', hq: 'You have already selected the maximum number of cabins. At least one adult per cabin required.', hr: 'Cabin class \"{name}\" is unavailable. It is sold out.', hs: 'Last vehicle was booked.', ht: 'Cannot add more vehicles. Only 1 vehicle per adult allowed.', hu: 'Vehicle is not allowed to disembark in Tallinn', hv: 'Vehicle available only on outward route.', hw: 'Vehicle available only on return route.', hx: 'Selected vehicle not available for the departure.', hy: 'Add pet', hz: 'Allergy', hA: 'cage', hB: 'cages', hC: 'Disabled', hD: 'cabin', hE: 'cabins', hF: 'You need to have at least one adult per each cabin', H1: 'Sold out', hG: 'Only {capacity} person cabins left', hH: 'Only {capacity} person cabins left for {from}-{to}', hI: 'Traveling with pets', hJ: 'Read more', hK: 'Shared places', hL: 'female place', hM: 'male place', hN: '{name}, {genderPlace} in shared {maxOccupancy} person cabin', hO: '{price} / cabin', tm: '{price} / person', hP: 'Travel Class', hQ: 'Special cabins', H2: 'Cabins', hR: 'pet', hS: 'pets', hT: 'With pets', hU: 'Spend two nights onboard Silja Symphony or Silja Serenade. Explore Stockholm for around 6 hours. Return with the same ship in the same cabin you arrived in.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', hV: '22 hour mini cruise onboard the newly renovated Europa. Departure daily from Helsinki to Tallinn at 18:30.\n4 hours onshore in Tallinn during the next day (08:00 -12:10).', hW: 'Spend two nights onboard Romantika or Isabelle. Explore Stockholm for around 6 hours. Return with the same ship in the same cabin you arrived in.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', hX: 'Departure at 07:10 from Stockholm. Sail onboard Baltic Princess to Åland where you will change ship to Galaxy. Arrival back in Stockholm at around 18:15.', hY: 'Spend two nights onboard Silja Symphony or Silja Serenade. Explore Helsinki for around 7 hours. Return with the same ship in the same cabin you arrived in. Total length of the trip is 40 hours.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', hZ: 'Spend two nights onboard Romantika or Isabelle. Explore Riga for around 6 hours. Return with the same ship in the same cabin you arrived in. Total length of the trip is 40 hours.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h_: 'Spend two nights onboard Baltic Queen or Victoria I. Explore Tallinn for around 7 hours. Total length of the trip is 40 hours.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', h$: 'Departure at 19:30 from Stockholm. Spend one night onboard Galaxy. No ashore time in Turku. Return to Stockholm the next day.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h0: 'Spend two nights onboard Baltic Queen or Victoria I. Explore Stockholm for around 7 hours.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', h1: 'Departure at 08:15 from Turku. Sail onboard Galaxy to Åland where you will change ship to Baltic Princess. Arrival back in Turku at around 19:15.', h2: 'Departure at 20:15 from Turku. Spend one night onboard Baltic Princess. No ashore time in Stockholm. Return to Turku the next day.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h3: 'Travel to Åland with Silja Serenade or Silja Symphony.', h4: 'Spend the night onboard Silja Symphony or Silja Serenade. Arrival in Stockholm the next morning. Book either a one-way or return trip.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', h5: 'Multiple departures per day. Travel comfortably and quickly. Duration onboard Star and Megastar is only 2 hours, and onboard Victoria I 3,5 hours.', h6: 'Travel daily between Helsinki West Terminal 2 to Tallinn fast and conveniently with Tallink Shuttle ships Star and Megastar Only 2 hours per way.', h7: 'Two daily departures from Helsinki: 10:30 and 16:30. Total duration of the trip is 5 hours and there is no disembarkation at Tallinn.\nYou can get a rebate when making large purchases. If you are planning on making very large purchases, it is easiest to come with a car and leave it in the car garage which is located next to the Traveller Superstore on deck 7.', h8: 'Spend the night onboard Romantika or Isabelle. Arrival in Stockholm the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h9: '4 daily departures to Åland. Travel onboard Baltic Princess, Galaxy, Silja Serenade, Silja Symphony, Victoria I or Baltic Queen.', ia: 'Spend the night onboard Silja Symphony or Silja Serenade. Arrival in Helsinki the next morning. Book either a one-way or return trip.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', ib: 'Spend the night onboard Romantika or Isabelle. Arrival in Riga the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', ic: 'Spend the night onboard Baltic Queen or Victoria I. Arrival in Tallinn the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', id: 'Spend half a day or one night onboard Baltic Princess or Galaxy.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', ie: 'Travel to Åland with Baltic Queen or Victoria I.', $8: 'Multiple departures per day from Tallinn D-terminal. Travel comfortably and quickly. Duration onboard Star and Megastar is only 2 hours, and onboard Victoria I 3,5 hours.', ig: 'Travel daily between Helsinki West Terminal 2 to Helsinki fast and conveniently with Tallink Shuttle ships Star and Megastar Only 2 hours per way.', ih: 'Spend the night onboard Baltic Queen or Victoria I. Arrival in Stockholm the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', ii: 'Travel to Åland with Baltic Princess or Galaxy.', ij: 'Spend half a day or one night onboard Baltic Princess or Galaxy.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', ik: 'Two nights onboard and a day in Helsinki', il: 'Two nights onboard and a day in Tallinn', im: 'Two nights onboard and a day in Åland', $9: '22 hour cruise to Tallinn.<br>4 hours onshore in Tallinn.', io: 'A relaxing mini-break on the sea', ip: 'Cruise to Åland and back. No time onshore.', iq: 'Two nights onboard.<br>Time onshore around 7 hours.', ir: 'Two nights onboard.<br>Time onshore around 6 hours.', is: 'Two nights onboard.<br>Time onshore around 7 hours.', it: 'One night onboard, no time onshore.<br>Evening departure onboard Galaxy.', iu: 'Enjoy the 23-hour cruise on board with Baltic Princess', iv: '11 hour cruise to Åland and back.<br>Departure from Turku at 8.15.', iw: 'One night onboard, no time onshore.<br>Evening departure onboard Baltic Princess.', ix: 'Enjoy the 23-hour cruise on board with Baltic Princess', iy: 'One day onboard, no time onshore.<br> Morning departure onboard Galaxy.', iz: 'One-way or return.<br>Daily departures from Åland & Helsinki.', iA: 'One-way or return.', iB: 'One-way or return.<br>Daily departures from Åland.', iC: 'One-way or return trip.<br>Four daily departures.', iD: 'One-way or return.<br>Daily departures from Åland & Tallinn.', iE: 'One-way or return.', iF: 'One-way or return.<br>Daily departure at 17:00.', iG: 'One-way or return.<br>Daily departures from Helsinki & Stockholm.', iH: 'Discounted price for same day return.<br>2 hours per way.', iI: 'One-way or return.<br>2 hours per way and onboard Victoria I 3,5 hours per way', iJ: '5h cruise with or without a car.<br>Save time, money and effort.', iK: 'One-way or return.', iL: 'One-way or return.', iM: 'One-way or return trip with Sea Wind. <br> Two daily departures', iN: 'One-way or return.<br>Daily departures from Riga.', iO: 'One-way or return.<br>Daily departures from Riga & Stockholm.', iP: 'One-way or return.<br>Four daily departures from Stockholm.', iQ: 'One-way or return.<br>Daily departures from Stockholm & Helsinki.', iR: 'One-way or return.<br>Daily departures from Stockholm & Riga.', iS: 'One-way or return.<br>Daily departures from Stockholm & Tallinn.', iT: 'One-way or return.', iU: 'One-way or return.<br>Departure at 18:00.', iV: 'One-way or return.<br>2 hours per direction and onboard Victoria I 3,5 hours.', iW: 'Discounted price for same day return.<br>2 hours per way.', iX: 'One-way or return.<br>Daily departures from Tallinn & Stockholm.', iY: 'One-way or return.', iZ: 'One-way or return.', i_: 'One-way or return.', i$: 'One-way or return trip with Sea Wind. <br> Two daily departures', i0: 'Turku', i1: 'Two nights onboard and a day in Tallinn.', i2: 'One-way or return.<br>Daily departures from Tallinn.', H3: 'Two days', i3: 'Two nights at sea, two days in Härnösand - an extra night aboard in Härnosand and two days to discover the destination. Take the opportunity to shop in our stores and duty-free shopping is possible throughout the trip.', i4: 'Two nights at sea, two days in Helsinki - an extra night aboard in Helsinki and two days to discover Finland. Take the opportunity to shop in our stores and duty-free shopping is possible throughout the trip.', i5: 'Two nights onboard and a day in Åland', i6: 'Two nights onboard and a day in Härnösand.', i7: 'Spend two nights onboard, enjoy one day in Helsinki', i8: 'Spend two nights onboard, enjoy one day in Riga', i9: 'Two nights onboard and a day in Saaremaa', ja: 'Spend two nights onboard, enjoy one day in Stockholm', jb: 'Spend two nights onboard, enjoy one day in Tallinn', H7: 'Use code', jc: 'Vehicle emissions surcharge', jd: 'The vehicle emission surcharge applies to the vehicle specified in the reservation.', Id: 'Vehicle emission and fuel surcharge', Ie: 'The vehicle emission and fuel surcharge applies to the vehicle specified in the reservation.', je: 'Up to 1.5 m high and up to 3.0 m long', jf: 'Up to 1.9 m high and 5.0 m long', jg: 'Add garage and park conviniently next to the Traveller Superstore &rarr;', jh: 'Want to exit among the first ones at your destination? Add priority car &rarr;', ji: 'Over 2.4 m high and up to 8.0 m long', jj: 'm', jk: 'Up to 1.9 m high and up to 5.0 m long. \nAt the destination car can\'t be driven outside.', jl: 'Please fill in licence plate number for all vehicles', Ii: 'Remove', jm: 'Select a vehicle from your previous trip:', jn: 'Up to 2.3 m high and up to 7.0 m long', jo: 'Up to 1.9 m high and up to 12 m long', jp: 'Trailer licence plate number', jq: 'Licence plate number should only contain digits and latin characters.', jr: 'Up to 2.4 m high and up to 7.0 m long', js: 'Vehicle info missing', jt: 'Vehicle licence plate number', ju: 'Vehicles added:', jv: 'Checking vehicle availability', Il: 'Travel via Helsinki', jw: 'Visby', jx: 'Ystad/Visby', jy: 'Ventspils', Ip: 'Voucher:', Iq: 'Please log-in with your Club One account to see the availability of the offer.', Ir: 'Sorry, this gift card has already been added.', Is: 'Sorry, this gift card is expired.', It: 'Sorry, this gift card has another currency.', Iu: 'Sorry, this gift card has no available funds.', jz: 'Vuosaari', IA: 'Cruise', IC: 'wow', tE: 'Day cruise', jA: 'Ystad'};
var $author$project$Translations$Generated$et = {P: 'Loe meie ligipääsetavuse avaldust', Q: 'https://www.tallink.com/et/ligipaasetavus', tJ: 'lisa', R: 'Lisa uus sooduskood', S: 'Selleks, et lisada rohkem sõidukeid, lisage broneeringule rohkem täiskasvanud reisijaid. Jalgrattaid saab lisada ka lastele vanuses 6-17 aastat.', tK: 'Lisa toad kõikidele reisijatele', pl: 'Lisa', tM: 'Reisimine {route} suunal on võimalik vaid sõidukiga.', tN: 'Kas soovid lisada sõiduki ka {route} suunale?', tO: 'Kas soovid suuna lisada?', T: 'Ahvenamaa', t_: 'Ahvenamaa (Långnäs)', t$: 'Ahvenamaa (Mariehamn)', ue: 'Oled juba valinud toa(d) teises hotellis. Kui soovid tuba selles hotellis, palun tühista eelnev valik.', uj: 'Kruiis', ul: 'Tühista ja jätka broneerimist', um: 'Jätka tavavaates', un: 'Jätkates tavavaates, peate uuesti lisama: <span class=\"bodyBold\">reisijate info, reisiklassi ja söögid</span>.', uo: 'Mõned valitud teenused eemaldatakse', up: 'Jätkates tavavaates, peate uuesti lisama: <span class=\"bodyBold\">reisijate info ja söögid</span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop pank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'Pank', aa: 'Valige pank', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click sisse logimine või mobiiltelefoni number', ah: 'Viimane valitud', ai: 'Säästöpankki', aj: 'SEB', ak: 'Vali pank', al: 'S-Pankki', am: 'Swedbank', uB: 'broneeri', uC: 'Broneeri need reisid eraldi:', uD: 'Lisa teenuseid laeval', uE: 'Mine täisversiooni &rarr;', uF: 'Kas Teil on vaja tooteid/teenuseid mida siin ei ole?', uG: 'Lisa transfeer', uH: 'Sadamasse ja sadamast', uI: 'Broneeri reis ärikliendina', ao: 'Broneeri lihtsalt ja saa soodustusi', ap: 'Logi välja &rarr;', uJ: 'Logi sisse', aq: 'Kas Sa oled Club One liige?', ar: 'Näita saadaolevaid kuupäevi', uK: 'Sooduskood ei ole antud väljumisel/reisiklassil kehtiv või valitud väljumise sooduskoodiga reisid on väljamüüdud.', as: 'Kontrollige sooduskoodi ja proovige uuesti', uL: 'Tühista', at: 'Broneerimiskood on lisatud', au: 'Sisestatud sooduskood on õige', uM: 'Oled koodi sisestamisel teinud vea. Kontrolli koodi ja proovi uuesti. Kui oled hiljuti sama koodi kasutanud, võib see olla broneeringus lukustatud. Sellisel juhul oota 20 minutit ja proovi uuesti.', av: 'Sooduskoodi ei saa hetkel kasutada. Proovige uuesti broneerida sooduskoodiga 30 minuti pärast', aw: 'Soodustus on lisatud', ax: 'Sooduskood', ay: 'Sooduskood ei ole antud väljumisele kehtiv', az: 'Kasutage sooduskoodi mõnele teisel kuupäeval', aA: 'Reisi algne hind oli {oldPrice}, peale koodi lisamist on reisi maksumus {discountedPrice}', aB: 'Reisi algne hind oli {oldPrice}, peale sooduskoodi lisamist on reisi maksumus {discountedPrice}', aC: 'Eemalda', uN: 'Sisestatud sooduskood on õige. Soodustuse saamiseks valige kõigepealt soovitud reisiklass/kajut.', uO: 'Kinkekaardi kasutamiseks võtke ühendust kõnekeskusega telefonil +372 640 9808', aD: 'Sooduskood on lisatud', aE: 'Mul on sooduskood', aF: 'punktid', uP: 'Vali lisateenuseid', aG: 'Fast track', aH: 'Garaaž', aI: 'Kindlustus', uQ: 'Planeeri muretult', aJ: 'Priority Car', uR: 'Valige väljumine', uS: 'Valige sihtkoht', aK: 'Broneeri reis', uT: '22h kruiis Helsingist', uU: 'Kruiisid', uV: 'Kruiisid', uW: 'Sihtkohas maaleminekut ei toimu', py: 'Sihtkohas maaleminekut ei toimu', uX: 'Kruiis Helsingisse', uY: 'Kruiis Riiga', uZ: 'Kruiis Stockholmi', u_: 'Väljumine', u$: 'Tähelepanu! Laev ei pruugi olla sobilik liikumispuudega reisijatele.', aL: 'Tähelepanu! Reisi ajal maaleminekut ei toimu', u0: 'Tagasisõit', u1: 'Üks suund', u2: 'Edasi-tagasireis', aM: '5h kruiis', u3: 'Üks suund', u4: 'Edasi-tagasireis', ne: 'Kuupäev', aN: 'Reisitüüp', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Vali keel', aV: 'Eesti keel', aW: 'Kas soovite keeleeelistust valida', u5: 'Lisa söögid', aX: 'Sööke saab tellida laevalt', u6: 'Sööke ei ole saadaval', u7: 'Osta toidud ette ja säästa raha', u8: 'Restoranid', aY: 'Mul on sooduskood', u9: 'Lisateenused', aZ: 'Broneeringus peab olema üks sõiduk.', va: 'COVID-19', a_: 'COVID-19 test', vb: 'laste käepaelad', vc: 'Massaaž', vd: 'Reisijad', ve: 'Liitu Club One\'iga &rarr;', vf: 'https://clubone.tallink.com/et/liitumine', vg: 'Logi välja &rarr;', vh: 'Saa Club One soodustusi ja broneeri lihtsamalt', a$: 'Vali kajut', vi: 'Reisiklass', vj: 'Kajutid', a0: 'Jalg&shy;ratas, elektri&shy;tõukeratas', a1: 'Sõidu&shy;auto', a2: 'Sõidu&shy;auto', vl: 'Lisa sõiduk', vm: 'Sisesta sõiduki registreerimistunnus', a3: 'Hinda arvutatakse', a4: 'Mootor&shy;ratas', a5: 'Külg&shy;korviga mootor&shy;ratas', a6: 'Pargitud auto', a7: 'Sõiduki registreerimistunnus on eeltäidetud', a8: 'Sõidu&shy;auto garaaži&shy;kohaga', a9: 'Sõidu&shy;auto või väike&shy;buss garaaži&shy;kohaga', ba: 'Näita kõiki', bb: 'Väike&shy;buss', bc: 'Kõrge\nsõiduk', bd: 'Sõiduk koos järelkäruga', be: 'Sõidu&shy;auto koos järel&shy;käruga', bf: 'Sõiduk koos järelkäruga', bg: 'Sõiduk koos järelkäruga', vB: 'Lisa transfeer', bh: 'Lisa kajutiüllatus', bi: 'Kingitus', bj: '{count} kajutiüllatust valitud', bk: '{count} kajutiüllatus valitud', vC: 'Kuva rohkem kuupäevi', bl: 'Kuva eelnevaid kuupäevi', bm: 'Kuupäev', vD: 'Erikruiis', bn: 'Tähelepanu', vE: 'Hind alates {price}', vF: 'Vabu väljumisi ei ole', vG: 'Valitud kuupäeval väljumisi pole.', bo: 'Kõik hinnad on Rootsi kroonides', bp: 'Kajut alates {price} punkti', bq: 'alates {price} punkti inimese kohta', br: 'alates {price} inimese kohta', bs: 'Kajut alates {price}', bt: 'Tühista', bu: 'Jätka broneerimist?', bv: 'Kui jätkate, tühistatakse Sinu kajuti valik. Reisijate andmed säiluvad', bw: 'Kajutiklass ei ole valitud kuupäeval saadaval', vH: 'Eri-<br/>kruiis', vI: 'Auto alates {price}', bx: 'Välja müüdud', by: 'Emissiooni lisatasu', bz: 'Emissiooni lisatasu kehtib reisijatele alates 6. eluaastast.', bA: 'Emissiooni lisatasu, et toetada kliimameetmeid ja katta ELi emissiooniga kauplemise süsteemist tulenevaid kulusid.', vQ: '{chars} tähemärki alles', vR: 'Saabumine', vS: 'Lahkumine', vW: 'Vali &rarr;', vX: 'Vali tuba', vY: 'Paketi hinna nägemiseks vali majutus', v3: 'Tühista & vali uus', bB: 'Bronze level', bC: 'Club tase', wd: 'Club one discount:', bD: 'Gold tase', bE: 'Mitteaktiivne Club One', bF: 'Club One\'i number', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One konto uuendamine\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One konto uuendamine\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One konto uuendamine\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Club One konto uuendamine\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One konto uuendamine\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Club One konto uuendamine\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One konto uuendamine\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: 'E-post', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One konto uuendamine\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:clubone@tallink.ee?subject=Club One konto uuendamine\">Sinu konto vajab uuendamist. Palun võta meiega ühendust!\n</a>', bQ: 'Club One\'i konto ei ole aktiivne. Palun võtke meiega ühendust:', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Telefon:', b_: 'Platinum tase', wg: '<a>Logi sisse</a> või <a>liitu Club One\'iga</a>, et saada soodustusi, kasutada punkte ja broneerida mugavamalt.', b$: 'Silver tase', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Maksimaalne kasutatav punktisumma arvutatakse dünaamiliselt broneeringus olevate toodete ja teenuste põhjal.', wj: 'Kasuta olemasolevaid Club One\'i punkte', wk: 'Selle sooduskoodiga ei saa Club One\'i punkte kasutada.', wl: 'Sul ei ole kasutamiseks piisavalt Club One\'i punkte.', b0: '<a>Alloleval liuguril</a> saad tasumiseks kasutada oma Club One\'i punkte.', wm: 'Club One\'i punkte ei saa kasutada ({reason}).', pQ: 'Kood', wp: 'Lisatud tekst sisaldab eri tähemärke.', wr: 'Sünniaeg', ws: 'pp', wt: 'kk', wu: 'aaaa', wv: '{count} {count, plural, one{täiskasvanu} other{täiskasvanut}}', ww: '({range} a.)', wx: 'Saabub kell {time}', pT: '{count} {count, plural, one{laps} other{last}}', wy: 'Tasuta', wz: 'Vähem', wA: 'Rohkem', wB: 'Kodakondsus', wC: 'Populaarsemad', b1: 'Hind sisaldab Club One {level} taseme soodustust.', wD: 'Club One\'i liikmete andmed lisa kohe, teised reisijad saad täita ka hiljem.', b2: 'p', b3: 'Kasuta Club One\'i punkte', b4: 'Peagi tulekul', wE: 'Lisa Club One\'i number enne broneerimist', wF: 'Valmis', wG: 'Muuda &rarr;', b5: 'Kiiremaks Pileti registreerimiseks ning reisikaaslastega broneeringu info jagamiseks, lisage kõikide reisijate telefoninumbrid ja e-posti aadressid.', wH: 'Eesnimi', wI: 'Sugu', wJ: 'Naine', wK: 'Mees', wL: 'Sisaldub hinnas', mh: 'Kontrolli sisendit', wM: 'E-posti aadress on vale. Lisa teine e-posti aadress', wN: 'Telefoninumber on vale. Lisa teine telefoni number', wO: 'Perekonnanimi', wP: 'Tärn (*) tähistab kohustuslikku välja', wQ: 'Hommikusöök', wR: 'Brunch', wS: 'Buffet', wT: 'Õhtusöök', wU: 'Lõunasöök', wV: 'À la carte laua broneerimine', wW: 'Sööke saab broneerida laeval', wX: 'Nime sisestamiseks kasutage ladina tähestikku.', wY: 'Pole saadaval', b6: 'Ei ole saadaval', wZ: 'Ei vaja', b7: 'Reisija\n18+', b8: 'Laps\n0-5 a', b9: 'Laps\n6-11 a', ca: 'Laps\n12-17 a', cb: 'Pangad', w_: 'Maksa {price}', cc: 'Maksta {price}', cd: 'Kaardid', w$: 'Kinnita broneering {price}', w0: 'Kinnitamine {price}', ce: 'Maksa Klarnaga {price}', cf: 'Makset teostatakse...', w1: '<p>Sulle pakutavate reisiteenuste kogum on pakettreis direktiivi (EL) 2015/2302 tähenduses.</p>\n<p>Seetõttu on Sul kõik õigused, mis reisijal on ELi õiguse järgi pakettreisi korral. Ettevõtja AS Tallink Grupp vastutab täielikult pakettreisi kui terviku teenuste nõuetekohase osutamise eest.</p>\n<p>Lisaks sellele on seaduse alusel nõutav, et ettevõtjal AS Tallink Grupp on tagatis, et maksta, kui ta ei suuda maksevõime tõttu oma kohustusi täita, tagasi sinu tehtud maksed ja kui pakettreis sisaldab reisijavedu, tagada Sinu tagasisõit lähtekohta või muusse kokkulepitud kohta.</p>\n<p><a href=\"https://www.tallink.com/et/hea-teada/pakettreisi-tingimused\" target=\"_blank\">Vaata pakettreisi tingimusi.</a></p>', pU: '<p>Sulle pakutavate reisiteenuste kogum on pakettreis direktiivi (EL) 2015/2302 tähenduses.</p>\n<p>Seetõttu on Sul kõik õigused, mis reisijal on ELi õiguse järgi pakettreisi korral. Ettevõtja {name} vastutab täielikult pakettreisi kui terviku teenuste nõuetekohase osutamise eest.</p>\n<p>Lisaks sellele on seaduse alusel nõutav, et ettevõtjal {name} on tagatis, et maksta, kui ta ei suuda maksevõime tõttu oma kohustusi täita, tagasi Sinu tehtud maksed ja kui pakettreis sisaldab reisijavedu, tagada Sinu tagasisõit lähtekohta või muusse kokkulepitud kohta.</p>\n<a href=\"{url}\" target=\"_blank\">Vaata pakettreisi tingimusi</a>.', w2: 'Kui vajutad maksmise nuppu, nõustud <a href=\"https://www.tallink.ee/et/reisitingimused-uksikreisijatele\" target=\"_blank\">Tallinki makse- ja annulleerimistingimuste</a>, <a href=\"https://ee.tallink.com/et/turvalisus\" target=\"_blank\">turvaeeskirjade</a>, <a href=\"https://ee.tallink.com/privaatsuspoliitika\" target=\"_blank\">privaatsuspoliitika</a>ning <a href=\"https://www.tallink.ee/et/club-one-reeglid\" target=\"_blank\">Club One\'i reeglitega</a>.', w3: 'Kui vajutad maksmise nuppu, nõustud Tallinki <a href=\"https://www.tallink.com/et/hea-teada/maksetingimused-tuhistamistingimused\" target=\"_blank\" >makse- ja annulleerimistingimuste</a> ja <a href=\"https://www.tallink.com/et/hea-teada/reisijate-oigused-kohustused\" target=\"_blank\" >turvaeeskirjadega</a> ning kinnitad, et oled tutvunud <a href=\"https://www.tallink.com/et/privaatsuspoliitika\" target=\"_blank\" >privaatsuspoliitikaga</a>.', w4: 'AS Tallink Grupp', w5: 'https://www.tallink.ee/et/pakettreisi-teabeleht-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://ee.tallink.com/et/pakettreisi-teabeleht-tallink-silja', w8: 'Oled noorem kui 18? <a href=\"https://www.tallink.com/ee-et/hea-teada/vanusepiirangud\" target=\"_blank\">Tutvu meie laevade vanusepiirangutega</a>.', w9: 'Alipay', xa: 'Apple Pay', xb: 'kohalikud pangad', xc: 'kaardid', xd: 'Google Pay', xe: 'Mobile Pay', xf: 'Deebet/krediitkaart', xg: 'WeChat Pay', xh: 'Internetipank & deebet/krediitkaart', xi: 'Kohalikud pangad', xj: 'Internetipank', cg: 'Hind alates {price}', xk: 'Tagasi reisivaliku juurde', xl: 'Vali', xm: 'Valitud', xn: 'Laev', xo: '{date} kell {time}', xp: '{count} {count, plural, one{reisija} other{reisijat}}', xq: 'Reisija\n18+', xr: 'Laps\n0-5 a', xs: 'Laps\n6-17 a', xt: 'Palun valige kõigepealt kajut', xu: 'Laev saabub Långnäsi sadamasse (30 km Mariehamnist)', xv: 'Saabumine Långnäsi sadamasse', xw: 'Laev väljumine ja saabumine on Långnäsi sadam (30 km Mariehamnist)', xx: 'Laev väljub Långnäsi sadamast (30 km Mariehamnist)', xy: 'Väljumine Långnäsi sadamast', pV: 'Sõiduk', xz: 'Sõidukid', ch: '22h kruiis Baltic Queeniga', ci: 'Kruiis', cj: 'Liinireis või edasi-tagasireis', ck: 'Liinireis', cl: 'Edasi-tagasireis või päevareis', xB: 'Lepinguline klient', xC: 'Agendikood', xD: 'Kliendikoodi ei leitud', xE: 'NB! Agendikoodi sisestamine ei ole nõutud', xF: 'Logime Sind ajutiselt isiklikult kontolt välja', xG: 'Kliendikood', xH: 'Kliendikoodi ei leitud', cm: 'Broneeringu kinnitus on saadetud aadressile', cn: 'Broneeringu eest on tasutud! Soovime Sulle meeldivat merereisi!', co: '{refund} kuulub tagastamisele!', cp: 'Palun helistage meie kõnekeskusesse, et tutvuda raha tagastamise võimaluste kohta!', cq: 'Sinu broneering on muudetud!', xI: 'Täiskasvanu', xJ: 'Asukoha nimi', xK: 'Ühtegi vastet ei leitud', xL: 'Otsi transfeere', xM: 'Bussitransfeer', cr: 'Noorukid 6-17 a', cs: 'Muuda broneeringut', xN: 'Tavapilet', xO: 'Lapsed {range} a.', ct: 'Tegevused maal', cu: 'Ei', cv: 'Jah, muidugi!', cw: 'Kas soovid saada Tallinki ja Silja Line\'i parimaid pakkumisi oma e-posti aadressile?', cx: 'Aitäh, et liitusid uudiskirjaga!', cy: 'Helistage kõnekeskusesse', cz: 'Tühista', xP: 'Eelnevalt sisestatud vanusekategooria ei ühti sisestatud sünniajaga. Palun sisestage õige sünniaeg või võtke ühendust meie kõnekeskusega, et muuta vanusekategooriat:', cA: 'Muuda vanusekategooriat?', cB: 'Osta teenuseid', cC: 'Muuda teenuseid', cD: 'Aadress', cE: 'Ettevõte', cF: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallinksilja.de/kontaktieren-sie-uns\">klienditeenindusega</a>', cG: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\">klienditeenindusega</a>', cH: 'Broneeringu muutmiseks võta ühendust <a href=\"https://ee.tallink.com/et/kontaktid\">klienditeenindusega</a>', cI: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallinksilja.fi/palvelunumerot\">klienditeenindusega</a>', cJ: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallink.lv/lv/contacts\">klienditeenindusega</a>', cK: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallinksilja.com/contact-us\">klienditeenindusega</a>', cL: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallinksilja.ru/agents\">klienditeenindusega</a>', cM: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallinksilja.se/kontakta-oss\">klienditeenindusega</a>', cN: 'Broneeringu muutmiseks võta ühendust <a href=\"https://www.tallinksilja.com/contact-us\">klienditeenindusega</a>', cO: 'Kontaktisik', cP: 'Kontaktisik', cQ: 'Broneeringu muutmiseks võta ühendust broneeringu vormistanud reisibürooga', cR: 'E-post', cS: 'Liitu Club One\'iga', cT: 'Reisikinnitus', cU: 'Pileti registreerimine avatakse 2 tundi enne väljumist. Tähelepanu! Piletite registreerimine lõpeb autode check-in\'is 45 min enne laeva väljumist.', cV: 'Palun sisestage kõikide reisijate andmed', cW: 'Tühista', cX: 'Jätka', cY: 'Kui jätkate, siis Seie poolt tehtud reisijate andmete muudatused ei salvestu', cZ: 'Muudatust ei salvestata', c_: 'Näita broneeringu PDF kinnitust', c$: 'Makseinfo leiad e-postis olevalt broneeringu kinnituselt (PDF).', c0: 'Näita makse-ja annulleerimistingimused', c1: 'https://www.tallink.com/ee-et/hea-teada/reisitingimused', xQ: 'Kokku', c2: 'Telefoninumber', c3: 'Broneeringu number', c4: 'Turvakood', c5: 'Kinnitus', c6: 'Laevade saabumis- ja väljumisajad on alati märgitud kohaliku aja järgi.', c7: 'Teil on võimalik Pilet registreerida (check-in) iseteeninduslikes check-in terminalides, mis asuvad sadamates. Pileti registreerimiseks vajate broneeringu numbrit ja turvakoodi.', c8: 'Soovitame sadamasse tulla varakult enne laeva väljumist.', c9: 'Piletite registreerimine sõidukita reisijatele lõpetatakse 30 minutit enne laeva väljumist. Sõidukiga reisijatel tuleb olla sõidukite check-in alas hiljemalt 45 minutit enne laeva väljumist. NB! Tallinnast ja Stockholmist Ahvenamaale sõites peavad sõidukiga reisijad olema terminalis hiljemalt 1,5 tundi enne laeva väljumist.', da: 'Päevareisi või kruiisi puhul tühistab Tallink kogu reisi, juhul kui reisija ei ole registreerinud Piletit esmaväljumise sadamas.', db: 'Reisijal (kaasa arvatud lapsel) peab kogu reisi vältel olema kaasas kehtiv reisidokument ja muud vajalikud dokumendid, sealhulgas vajadusel ka viisa, ning reisija vastutab kõikide dokumentide kehtivuse ja õigsuse eest.', dc: 'Laeva saabumis- ja väljumisajad on alati märgitud kohaliku aja järgi. <br>\nPileti saab registreerida internetis, Tallink Silja Line äpis või terminalis. <br>\nPaldiski ja Kapellskäri sadamates lõpeb autoga reisijatele pileti registreerimine 75 minutit enne Superfast väljumist. Soovitame sadamasse tulla aegsasti. <br>\nKajutikaart väljastatakse check-in\'is. <br>\nReisijal (kaasa arvatud lapsel) peab kogu reisi vältel olema kaasas kehtiv reisidokument ja muud vajalikud dokumendid, sealhulgas vajadusel ka viisa. <br>\nReisija vastutab kõikide dokumentide kehtivuse ja õigsuses eest.', dd: 'Info reisi kohta', de: 'Reisiinfo', df: 'Tagasimakse', dg: 'Tagasimakmisele kuulub {refund}! Helista kõnekeskusesse, et saada tagasimakse.', dh: 'Helista, et saada tagasimakse', di: 'Helistasid juba? See teade kaob ära, kui oleme Sinu tagasimakse vormistanud.', dj: 'Saa tagasimakse', xR: 'Kui ühenduse saamine ei õnnestu, palun helista numbril +372 640 9808.', xS: 'Internetiühendusega on probleeme. Proovige uuesti', xT: 'Proovige uuesti', xV: 'Jätka', xW: 'Jätka maksmist', pX: 'E-maili aadress', xX: 'Näiteks:', dk: 'Suunakood ja telefoninumber', xY: 'Kontaktinfo', xZ: 'Lisa oma kontaktinfo, et saaksime Sulle broneeringu kinnituse saata. Club One eeliste kasutamiseks tuleb enne broneerimist sisse logida või oma Club One\'i number reisijate lehele lisada.', x_: 'Seda infot uuendatakse Sinu Club One\'i kontol', pY: 'Telefoninumber', dl: 'Näiteks:3725500000', x$: 'Muu', x0: 'Broneeringu kokkuvõte saadetakse koopiana aadressile {email}', dm: 'Lisa e-post', dn: 'Postikood', x6: '{price} / test', x8: 'Broneeri see reis kiiremini meie <b>uues broneerimissüsteemis.</b>', dp: 'Kaardiomaniku nimi', dq: 'Krediitkaart', dr: 'kk', ds: 'Krediitkaardi number', dt: 'Makseviis', du: 'Turvakood', dv: 'Vali sobiv krediitkaardimakse', dw: 'Kehtiv kuni', dx: 'aa', dy: 'Kruiis Stockholm(Kappellskär)-Turu-Stockholm(Kappellskär)', ya: 'Kruiis Helsingisse', yb: 'Kruiis Visbysse', dz: 'Kruiis Turu-Stockholm(Kappellskär)-Turu', yc: 'Kruiis Ystadi ja Visbysse', dA: 'Kruiis Helsingisse', dB: 'Kruiis Riiga', no: 'Kruiis Tallinna', yj: 'Kruiis Turusse', yr: 'Magustoit', dC: 'Soodustus:', yy: 'Rakendatud', yz: 'Sooduskood või kinkekaart:', p9: 'Soodustused & kinkekaardid', dD: 'Ära unusta valida ühte menüüd iga täiskasvanud reisija kohta {restaurant} broneeringus.', dE: 'Ära unusta valida menüüd kõikidele üle 12-aastastele reisijatele {restaurant} broneeringus.', yB: 'Kasuta võimalust!', yD: 'Vali joogipakett', dF: 'Sellele väljumisele on Sulle juba broneering vormistatud. Broneeringu number on: {resId}, hinnaga {price} {unit}. Kas soovid vana broneeringu tühistada ning sooritada makset uuele vormistatud broneeringule? <a href=\"{link}\">Soovin näha ja maksta vana broneeringu eest →</a> Täpsema info saamiseks võta ühendust klienditeenindusega', yF: 'Muuda tuba', yG: 'Muuda tube', yO: 'Tegevused maal', yP: 'Tegevused maal ja hotellis', yS: 'Kõikidel reisijatel peab olema sõidukis istekoht.', dK: 'https://clubone.tallink.com/et', yY: 'Lisateenused', dL: 'Tagasiside', y_: 'Laevareis', y$: 'Reisipakett', y5: 'Vali menüü', y7: 'Toiduallergiad/ eridieedi info:', kS: 'Kust', za: 'Emissiooni- ja kütuse lisatasu', zb: 'Kütuse- ja emissiooni lisatasud kehtivad reisijatele alates 6. eluaastast.', zc: 'Kütuse- ja emissioonilisatasu kehtib alates 12. eluaastast. Broneeringu kohta on lisatasust vabastatud kuni kolm 6–11 a last.', zd: 'Kütuse- ja emissiooni lisatasu kliimameetmete toetamiseks ja ELi heitkogustega kauplemise süsteemi kulude katmiseks.', dM: 'Kütuse lisatasu', dN: 'Kütuse lisatasu kehtib reisijatele alates 6. eluaastast.', dO: 'Kütuse lisatasu on {price} reisijatele alates 6. eluaastast', dP: 'Kütuse lisatasu on {price} reisisuuna kohta reisijatele alates 6. eluaastast.', zh: 'Kinkekaart:', zi: 'Kinkekaarti on võimalik kasutada mitmel ostul kuni kaardil olevate vahendite lõppemiseni.\nKinkekaardil on {priceLeft} €.', dQ: 'Grupimenüü saadaval', zm: '12 või enama täiskasvanud reisija broneerimisel palume teha iga täiskasvanud reisija kohta üks menüüvalik. Nooremad reisijad saavad automaatselt lastemenüü kupongi väärtusega 25 €.', dR: 'Helsingi', dS: '2 ööd laeval ja päev Riias', dT: '22h kruiis Tallinnasse Helsingist', dU: 'Kruiis Tallinna.<br> 5 tundi Tallinnas.', dV: 'Visby kruiisid Helsingist', dW: 'Suvised erikruiisiid maagilisele Gotlandi saarele', dX: 'Härnösand', zv: 'Hotell', zy: 'Reisist erineva ööbimise perioodi korral <a>muuda oma valikut</a>', dY: 'Saabumine', dZ: 'Saabumine', d_: 'Lahkumine', d$: 'Lahkumine', d0: 'ööd', d1: 'öö', zz: 'Pärast hotelli valikut suunatakse Sind eraldi rakendusse', zA: 'Valitud kuupäevadel ei ole hotelle saadaval, palun muuda kuupäeva', zB: 'Pärast väljaregistreerimist ei saa enam sisseregistreerida. Muuda oma lahkumise aega lahtris \"Saabumine\"', zC: 'Sa ei saa enne saabumiskuupäeva lahkuda. Kuupäeva saad muuta lahtris \"Saabumine\"', zD: 'See on saabumiskuupäev. Seda saad muuta lahtris \"Saabumine\"', zE: 'See on lahkumiskuupäev. Seda saad muuta lahtris \"Lahkumine\"', qF: 'Hotelli kuupäev on erinev reisikuupäevast. Selle kuupäeva valimiseks muuda oma reisi aega', zF: 'Ööbimine laeval', zG: 'Ööbimine laeval', zW: 'Laeva restorani saadeti info allergiate/eridieedi kohta', q4: 'Liitu Club One\'iga', AB: 'Broneeri soodsamalt, kasuta kogutud punkte boonusreiside ostmiseks ning naudi soodustusi nii laeval kui ka meie partnerite juures.', d2: 'Tänav', d3: 'Linn/maakond', d4: 'Riik', d5: 'Vii liitumine lõpule', AC: 'Postiindeks', AD: 'Club One\'iga liitumiseks peab kontaktisik olema üks reisijatest.', d6: 'E-postiga', d7: 'Postiga', d8: 'SMS\'iga', d9: 'Eelistatud suhtluskeel', ea: 'Soovin saada Club One\'i pakkumisi ja uudiskirju', eb: 'Ei', ec: 'Salvesta ja sulge', ed: 'Jah', AF: 'Tere tulemas Club One\'i liikmeks! Lisa puuduolevad andmed peale broneeringu vormistamist.', AG: 'Tere tulemast Club One\'i liikmeks. Liitumisel anti Sulle liikmesoodustus. Algne hind oli {priceBefore}, peale Club One\'iga liitumist on hind sulle {currentPrice}.', AH: 'Leidsime eksisteeriva Club One\'i konto samade andmetega.', ee: 'Kapellskär', ef: 'Laste söögikupong', AN: 'Broneeringut kinnitades nõustute, et Sinu broneeringu andmed saadetakse Klarnasse. Loe rohkem Klarnast', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: 'siit', AQ: 'Klarna & Swish', AR: 'Arve, osaline makse', AS: 'Klarna', AT: 'Arvega makse', AU: 'Osaline makse', AV: 'Swish', AW: 'Maksmisvõimalused olenevad Teie broneeringust. Kõige levinumad võimlused on:', eg: 'Klarna makse', eh: 'Soorita Klarna makse kergelt ja turvaliselt otse mobiilist.', ei: 'Klaipeda', ej: 'Ühesuunareis või edasi-tagasireis.', A$: 'Saksa keel', A0: 'Inglise keel', A1: 'Eesti keel', A2: 'Soome keel', ek: 'Leedu keel', A3: 'Läti keel', A4: 'Vene keel', A5: 'Rootsi keel', Bb: 'Laadib...', Bc: 'Helsingi', Bd: 'Jurmala', Be: 'Kolmården', Bf: 'Kuressaare', Bg: 'Laulasmaa', Bh: 'Mariehamn', Bi: 'Narva', Bj: 'Norrkoping', Bk: 'Otepää', Bl: 'Pärnu', Bm: 'Rakvere', Bn: 'Riia', Bo: 'Södertälje', Bp: 'Stockholm', Bq: 'Tartu', Br: 'Turu', Bs: 'Tallinn', Bt: 'Tampere', Bu: 'Uppsala', Bv: 'Vantaa', Bw: 'Vihula', BC: 'Pearoog', BE: 'Lisa veel', BF: 'Kuupäev:', BG: '{price} / hoolitsus', BH: 'Aeg:', Cf: 'Einet ei serveerita {direction} suunal', Cg: 'Toidupakett sisaldab toite kogu reisi ajaks.', Ch: 'Vali toidupakett', el: 'Ei ole valitud', em: '<span class=\"data\">{count}</span> {count, plural, one{# hommikusöök} other{# hommikusööki}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# õhtusöök} other{# õhtusööki}}', rt: 'Lapsed saavad soodustust ja alla 6-aastased lapsed söövad tasuta, kui lapsevanem on ostnud toidupaketi.\n\nKui restorani katted on välja müüdud lisatakse broneeringule kupong, millega võib tasuda toidu eest ka kõikides teistes laeva restoranides.', Ci: '{price} / 18+ a', Cj: '{price} / täiskasvanu', Ck: '{price}/inim.', Cl: '<span class=\"save bodySmall\">Säästke</span><span class=\"bodySmall\">kuni</span><span class=\"bodyLarge percentage\">15%</span>', Cm: 'Toidupakett', Cn: '{count, plural, one{# inimene} other{# inimesele}}', Co: 'inimese kohta', Cp: 'Broneering', ru: 'Säästa & osta toidupakett', eo: 'Broneeri laud', ep: 'Välja müüdud', eq: 'Hommikusöök', er: 'Õhtusöök', Cq: 'Restoranid', es: 'Söögikupong', Cr: 'Toitlustus on kehtiv kogu reisi vältel', Cs: 'Oled kindel, et ei soovi toitlustust <b>kuni 10% soodustusega</b>? Pakkumine kehtib ainult online\'is.', et: 'Koosolekuruum', eu: '{date} kell {time} kestvusega {duration} h', Ct: 'Menüü saadaval', Cu: 'Palun vali kala-, liha- või veganmenüü igale 12-aastasele ja vanemale reisijale. Alla 12-aastased reisijad saavad pärast broneeringu tegemist söögikupongi, mille alusel teha toiduvalik pardal. Lastele on soodustus vähemalt 50%', ew: 'Lisa reisijate andmed', ex: 'Vaata reisijate andmeid', ey: 'Club One', CA: 'Club One\'i andmete muutmiseks võta ühendust meie klienditeenindusega:', ez: 'reisija info on puudu', eA: 'Te ei pea kinnitust välja printima. Kasutage broneerimisnumbrit ja turvakoodi meie iseteenindujaamades pileti registreerimiseks.', eB: 'Vale vanusegrupp on valitud', eC: 'Lisa puuduv info', eD: 'Makse on teostamata', eE: 'Muuda sõiduki reg.number', eF: 'Sõiduki reg. number on puudu', eG: 'Sõiduki reg. numbrit ei ole lisatud', eH: 'Broneering mugavalt telefoni', eI: 'Lae alla', eJ: 'Ava', eK: 'Saada link', eL: 'Tallink & Silja Line äpp', eN: 'Muuga', CJ: 'Sihtkohas maaleminekut ei toimu', CK: 'Sihtpunktis ei saa sõidukiga välja sõita.', CL: 'Valitud reisile ei ole hetkel väljumisi. Muuda reisi valikut.', CM: 'Maksmine ebaõnnestus. Palun proovi uuesti. Kui broneeringut ei õnnestu kinnitada palun helista numbril {phone}. Vabandame võimalike ebamugavuste pärast.', ol: 'ei, tänan', CU: 'See kood muudab pileti tagastamatuks. Palun tutvu <a href=\"#\">tingimustega &rarr;</a>.', CV: '<ul>\n<li>Piletil ei ole lubatud muuta reisi suunda ja/või marsruuti, väljumise kuupäeva või kellaaega.</li>\n<li>Piletil võib muuta reisija isikuandmeid, kajutiklassi, sõidukit ja pardateenust, kusjuures eelnimetatud teenuste muutmisel tuleb tasuda hind, mis tekib esialgselt ostetud teenuse ja muudetud teenuse hinnavahest.</li>\n<li>Reisija poolt pileti tühistamisel peab Tallink Silja Line kinni tasutud summast leppetrahvina 100% pileti hinnast.</li>\n<li>Kõigis ülejäänud küsimustes kohaldatakse AS-i Tallink Grupp reisitingimusi, millega saab tutvuda <a target=\"_blank\" href=\"https://www.tallink.com/ee-et/hea-teada/maksetingimused-tuhistamistingimused\">siin</a>.</li>\n</ul>', CW: 'Tingimused', CX: 'Jah, nõustun', CY: 'Eemalda kood', CZ: 'Ostad tagastamise võimaluseta pileti koodiga <b>{code}</b>. Peale ostu ei ole võimalik piletit tagastada. Saad muuta ainult reisijate isikuandmeid, reisiklassi ja pardateenuseid. Reisisuuna, marsruudi, väljumise kuupäeva ja kellaaja muutmine ei ole võimalik. Palun kinnita enne maksmist, et mõistad ja aktsepteerid neid tingimusi.', C_: 'Tagastuseta pilet', eO: 'Ei ole piisavalt punkte', C0: 'Jätka broneerimist', C1: 'Alusta uuesti broneerimist?', C2: 'Lehelt lahkudes tühistatakse vormistatud broneering. Olete kindel, et soovite uut broneeringut vormistada?', C3: 'Alusta uuesti broneerimist?', eP: 'Saabumise sadam Stockholmis on Kappellskäri sadam (90 km Stockholmist)', eQ: 'Väljumise sadam Stockholmis on Kappellskäri sadam (90 km Stockholmist)', eR: 'Saabumise ja väljumise sadam Stockholmis on Kappellskäri sadam (90 km Stockholmist)', Da: 'Mulliveini mess', eS: 'Insurance', Db: 'Friendship elamuspakett', Dc: 'Lastepakett', Dd: 'Priority boarding', De: 'Teenused laeval', Df: 'laevaraha', Dg: 'kupong', Dh: 'Laevaraha kupongid', Di: 'istekoht', Dj: 'Teenus ei ole saadaval liinil {route}', Dk: 'Üks päev', eT: 'Ühesuunareis või edasi-tagasireis.', Do: 'või', Dp: 'Muud', eU: 'Muu makseviis', eX: '12 + a.', eY: 'Paldiski', eZ: 'Pargitud sõidu&shy;auto või väike&shy;buss', DI: 'Suveöö erikruiis', DJ: 'Läänemeri - Tallinn', e_: 'Ei saa muuta reisja vanusegruppi', DM: 'Olete valinud vale vanusegrupi. Palun kontrollige, et olete kõikidele reisijatele valinud korrektsed vanusegrupid.', DN: 'Vale vanuserühm – veendu, et sünniaeg vastaks täiskasvanule või noorukile.', DO: 'Palun lisage sünniaeg pp-kk-aaaa formaadis.', DP: 'Vanuseid saab lisada ainult numbrites', DQ: 'Täida hiljem', DR: 'Salvesta', DS: 'Palun kontrollige oma nime ja Club One\'i numbrit.', DT: 'Club One\'i number', DU: 'on juba lisatud.', DV: 'Muutke andmeid või', DW: 'alustage uuesti', DX: 'Dokumendi info lisatakse Sinu Club One\'i kontole', DY: 'Dokumendi väljaandja riik *', DZ: 'Dokument kehtib kuni *', D_: 'Välja antud *', D$: 'Dokumendi number *', D0: 'Dokumendi tüüp *', D1: 'Sünnikoht *', D2: 'Eriabi vajadus', D3: 'Abiteenuse tellimiseks võtke ühendust meie klienditeenindusega:', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Lisa reisija', Ec: '<span class=\"data\">{count}</span> {count, plural, one{reisija} other{reisijat}} valitud', Ed: 'Täitke andmed praegu või hiljem', Ee: 'Reisija andmed lisatud', Ef: 'Reisijad', e0: 'Peagi tulekul', e1: 'Broneeringu number', e2: 'Krediitkaart', e3: 'Eemalda', Ei: 'Makse', e4: 'Valige makseviis:', Ej: 'Arve', Ek: 'Arve aadress', e5: 'Maksa arvega', El: 'Viitenumber', e6: 'Maksa hiljem', e7: 'Kasuta lihtsalt mobiilimakset', e8: 'Palun soorita makse, et kinnitada oma broneering.', e9: 'Pank', fa: 'Tavaline operaatoritasu', fb: 'Tavaline operaatoritasu', fc: 'Kõne hind 85 senti/kõne + operaatoritasu.', fd: 'Kõne hind 8,35 senti/kõne + 16,69 senti/minut.', fe: 'Tavaline operaatoritasu', ff: 'Tavaline operaatoritasu', fg: 'Tavaline operaatoritasu', fh: 'Tavaline operaatoritasu', fi: 'Tavaline operaatoritasu', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Helista klienditeenindusse', fk: 'Maksmata broneeringud tühistatakse automaatselt.', fl: 'Maksmine ebaõnnestus. Palun proovige uuesti. Kui broneeringut ei õnnestu teostada palun helistage meie klienditeenindusse. Vabandame võimalike ebamugavuste pärast.', fm: 'Muuda seadete alt <u>riik</u> algse vastu, et lõpetada broneeringu makse.', fn: 'Broneering on vormistatud teise riigi maksevahendiga.', Ex: 'ja {points} punkti', r0: 'reisija', EA: 'reisijat', EH: 'D-Terminal', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs', EM: 'Läänesadam 2', EN: 'Läänesadam 1', EO: 'Läänesadam 1', EP: 'Peterburi', EQ: 'Mariehamn', ER: 'Muuga sadam', ES: 'Olympia terminal', ET: 'Paldiski', EU: 'Riia terminal', EV: 'Sassnitz', EW: 'Turu sadam', EY: 'Värtahamnen', EZ: 'Visby', E_: 'Ventspils', E$: 'Vuosaari sadam', E5: 'Valitud', E6: 'Osta reis', E7: 'Tühista', E8: 'Jätka', E9: 'Valmis', fo: 'Jätka', Fa: 'Soodsaim hind:', Fb: 'Soodsaim hind Club One\'iga:', Fc: 'Club One\'i hind', Fd: 'Lisage kajuteid', Fe: 'Lõplik hind on nähtav peale kajuti lisamist', fp: 'Valige kajut, et jätkata broneerimisega', Ff: 'Vahesumma:', Fg: 'Kokku:', fq: 'Club One\'i soodushind:', Fh: 'Hinda arvutatakse..', Fj: 'Hind alates reisija/sõiduki kohta, sisaldades emissiooni- ja kütusetasu.', Fl: '{price} / tk', sa: 'Jätka', fr: 'Proceed to payment', Fs: 'Seda lehekülge kaitseb reCAPTCHA ja kehtivad Google\'i\n<a target=\"_blank\" href=\"https://policies.google.com/privacy?hl=ET\">privaatsuspoliitika</a> ning\n<a target=\"_blank\" href=\"https://policies.google.com/terms?hl=ET\">kasutustingimused</a>.', ft: 'Muudatused laeva meelelahutusaegades:<br>\nReede-laupäev väljumistel on olemas kogu meelelahutus<br>\nPühapäevast-neljapäevani väljumistel on vähendatud meelelahutuse valik.', fu: 'Tavahind:', Fy: 'Eemalda eelnev valik, et valida uus', FA: 'Broneeringutasu {fee} inimese kohta arvestatakse laeval restorani lõpparvest maha.', FB: 'Broneerimistasu ei kehti kuni 5-aastastele lastele.', sq: 'Sulge', FD: 'Midagi läks valesti. Palun laadige leht uuesti. <br>Vabandame.', FE: 'Tulevaid reise ei leitud', fv: 'Alusta uuesti', fw: 'Vabandame ebamugavuste pärast! Sinu broneering tühistatakse automaatselt.', fx: 'Sessioon on läbi saanud', FF: 'Alusta uuesti', FG: 'Pead kahjuks uuesti alustama. Vabandame ebamugavuste pärast', FH: 'Broneeringu vormistamisel tekkis viga', fz: 'Riia', fA: '2 ööd laevas ja päev Klaipedas', fB: 'Ühesuunareis või edasi-tagasireis.', fC: 'Stockholm-Turu-Turu-Stockholm(Kappellskär)', fD: 'Stockholm(Kappellskär)-Turu', fE: 'Stockholm(Kappellskär)-Turu-Turu-Stockholm', fF: 'Turu-Stockholm-Stockholm(Kappellskär)-Turu', fG: 'Turu-Stockholm(Kappellskär)', fH: 'Turu-Stockholm(Kappellskär)-Stockholm-Turu', fI: 'Tagasi pankade nimekirja', fJ: 'Kahjuks ei leidnud me Sinu otsitud panka. Proovi otsida soovitud panka nimekrijast.', fK: 'Otsi', fL: 'Sassnitz', fN: 'Vali vähemalt üks sõiduk', Ge: 'Adding a car <b>will remove {service}</b> service. You sure you want to proceed?', Gf: 'Oled kindel?', Gv: '5h kruiis', Gw: 'Kruiis väljub mitmeid kordi päevas. Reisi kogupikkus on 5 tundi ning reisi ajal maaleminekut ei toimu. Suurtelt ostudelt saab soodustust! Kui soovid suuremalt ostelda, broneeri ka sõiduk. Megastaril on võimalik parkida sõiduk kohe Traveller Superstore poe kõrvale ning garaaz on avatud kogu reisi vältel.', Gy: 'See tagasisõiduaeg kehtib 5h kruiisile. Sind suunatakse vastavale lehele.', fO: 'Mõnus aeg iseendale.', GE: 'Showbaari lauabroneeringud', fP: 'Saaremaa', GK: '15–17-aastasena võid reisida üksi päevasel ühesuunareisil või päevareisil. Kindlasti võta kaasa <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\">reisiluba</a>. Turvalist reisi.', fQ: 'Peterburi', GQ: 'Eelroog', fR: 'Stockholm', GY: 'Osta Stockholm-Helsingi', GZ: 'Valitud kuupäeval ei ole otsereisi Stockholmist Tallinnasse kuid saad reisida Helsingi kaudu ja sealt laevaga edasi.', G_: 'Pane tähele! Helsingis tuleb arvestada sadamavahetusega. Laev saabub Helsingisse Olympia terminali ning Helsingi-Tallinn liini laevad väljuvad Lääneterminal 2.', G$: 'Stockholm -> Tallinn <br/> Helsingi kaudu', fS: 'Laeva baarides serveeritakse alkoholi limiteeritud tundidel.', fT: '2 ööd laevas ja päev Visbys.', fU: 'Kaks ööd merel, üks öö Visbys laeval ning Sulle jääb kaks päeva Gotlandi avastamiseks. Kasuta võimalust šopinguks meie laeva poes kogu reisi vältel.', fV: 'Stockholm (Kappellskär)', fW: '3 ööd merel, 1 päev Ystadis ja 1 päev Visbys', fX: 'lisatasu', fY: 'Tallinn', G8: 'Tallinn - Läänemeri', fZ: 'Tallinn - Läänemeri - Tallinn', f_: '2 ööd laeval ja päev Riias', G9: 'Osta Tallinn-Helsingi', Ha: 'Valitud kuupäeval ei ole otsereisi Tallinnast Stockholmi, kuid saad reisida Helsingi kaudu ja sealt laevaga edasi', Hb: 'Oluline! Laevavahetuseks tuleb minna Lääneterminalist 2 Olümpia terminali. <b>Kui valid väljumisajaks kell 13:30, ei pruugi sul ühistranspordiga liikudes olla piisavalt aega sadamavahetuseks.</b>', Hc: 'Tallinn -> Stockholm <br/> Helsingi kaudu', f$: '2 ööd laevas ja<br> päev Turus.', f0: 'Ühesuunareis või edasi-tagasireis algusega Turust.', f1: 'Visby kruiisid Tallinnast', f2: 'Suvised erikruiisiid maagilisele Gotlandi saarele', tb: 'aitäh info eest', td: 'Lisa tagasisõit', f3: 'Broneeri tagasisõidupilet ja saa soodustusi', f4: 'Kuna väljumine ja tagasitulek on samal päeval, saate Päevakruiisi hinna.', o6: 'Saabumine', f5: 'Otsid hilisemat väljumist?', f6: 'Vali kuupäev', f7: 'Tühjenda väljad', Hx: 'Vali päev', f8: '23h kruiis (õhtune väljumine)', f9: '23h kruiis (hommikune väljumine)', ga: 'Päev Stockholmis kruiis', gb: 'Päev Turus kruiis', o7: 'Väljumine', Hy: 'Õhtune', Hz: 'Hommikune', te: 'Aeg', tf: 'h', HA: 'Veeda esimene öö laeval ja lahku nagu soovid ajavahemikus 8–11.', HB: 'Esimene öö laeval', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'Hetkel ei ole', gc: 'Tagasisõidu piletit ei ole vaja', gd: '5h kruiis', ge: 'Sulge', gf: 'Kohese tagasitulekuga reis sisaldab 5h kruiisi soodustust reisijatele ja sõidukitele. Reisi ajal maaleminekut ei toimu.', gg: '5h kruiis', gh: 'Veetke öö laevas ja nautige 4 h Tallinnas', gi: 'Õhtune väljumine Stockholmist. Sihkohas maaleminekut ei toimu', gj: 'Hommikune väljumine Stockholmist. Sihtkohas maaleminekut ei toimu', gk: 'Nautige 2 ööd laevas ja päeva Turus', gl: 'Õhtune väljumine Turust. Sihtkohas maaleminekut ei toimu', gm: 'Hommikune väljumine Turust. Sihtkohas maaleminekut ei toimu', gn: 'Edasi-tagasireis Helsingi - Stockholm - Helsingi', go: 'Ühesuunareis Helsingist Stockholmi', gp: 'Edasi-tagasireis Helsingi - Tallinn - Helsingi', gq: 'Päevareis Tallinnasse', gr: 'Ühesuunareis Helsingist Tallinna', gs: '5h kruiis', gt: 'Edasi-tagasireis Riga - Stockholm - Riga', gu: 'Ühesuunareis Riiast Stockholmi', gv: 'Edasi-tagasireis Stockholm - Helsingi - Stockholm', gw: 'Ühesuunareis Stockholmist Helsingisse', gx: 'Edasi-tagasireis Stockholm - Riga - Stockholm', gy: 'Ühesuunareis Stockholmist Riiga', gz: 'Edasi-tagasireis Stockholm - Tallinn - Stockholm', gA: 'Ühesuunareis Stockholmist Tallinnasse', gB: 'Edasi-tagasireis Stockholm - Turu - Stockholm', gC: 'Ühesuunareis Stockholmist Turusse', gD: 'Edasi-tagasireis Tallinn - Helsingi - Tallinn', gE: 'Päevareis Helsingisse', gF: 'Ühesuunareis Tallinnast Helsingisse', gG: 'Edasi-tagasireis Tallinn - Stockholm - Tallinn', gH: 'Ühesuunareis Tallinnast Stockholmi', gI: 'Edasi-tagasireis Turu - Stockholm - Turu', gJ: 'Ühesuunareis Turust Stockholmi', HH: 'Hotelliga', tg: 'Kruiis', gK: 'Kruiis Helsingisse', gL: 'Kruiis Tallinnasse', gM: 'Kruiis Ahvenamaale', gN: 'Kruiis Stockholm', gO: 'Kruiis Tallinna', gP: '9H kruiis', gQ: 'Kruiis Stockholmi', gR: 'Kruiisid', gS: 'Kruiis Ahvenamaale', gT: 'Cruise to Helsinki', gU: 'Kruiis Stockholmi', gV: '22 h kruiis', gW: 'Kruiisid', gX: 'Kruiis kahe sihtkohaga', gY: 'Näita vähem &uarr;', gZ: 'Näita rohkem  &darr;', g_: 'Edasi-tagasireis', le: 'Kuhu', g$: 'Lisasime täiskasvanud reisija broneeringusse. Igas broneeringus peab olema vähemalt üks täiskasvanud reisija.', g0: 'Garaaž eemaldati broneeringust. Priority Car sisaldub Business Lounge hinnas', g1: 'Priority Car sisaldub Business Lounge hinnas', g2: 'Valitud reisiklass ei ole enam saadaval. Palun vali mõni teine reisiklass', HP: 'Sõiduki registreerimistunnus on eeltäidetud', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Transfeer ei ole valitud kuupäevadel saadaval.', g5: 'Valitud transfeerid ei ole saadaval.', HQ: 'Tere, {name}!', g6: 'Selle reisi eest tasumiseks Club One punktide eest on Teil vaja \nvähemalt {clubOnePoints} punkti.', g7: 'Kõikide reisijate andmeid ei ole lisatud. Vaata üle, et olete täitnud kõik nõutavad väljad.', g8: 'Kuna hetkel puudub sul Interneti ühendus, ei salvestatud sinu muudatusi. Proovi uuesti kui Internetiühendus on tagasi.', g9: 'Osa reisijate infost on puudu. Palun täida puuduvad väljad, et kõik andmed säiliks', HR: 'Osadele reisijatele ei ole lisatud transfeeri', HS: 'Igas toas peab olema vähemalt üks täiskasvanud', ha: 'Selle toidukorra broneerimiseks pead eelmisest valikust loobuma. Klõpsa ristil ja vali sobivam aeg.', HU: 'Igas transfeeris peab olema täiskasvanu.', hb: 'Palun kontrollige oma Internetiühendust ja proovige uuesti', hc: 'Reisija vanus \"{old}\" on muudetud \"{new}\"', hd: 'Igas kajutis peab olema vähemalt üks täiskasvanud reisija. Muutsime kajutite arvu vastavalt täiskasvanute arvule broneeringus.', he: '{name} Club One lisatud!', hf: 'Maksimaalne arv reisijaid on lisatud broneeringusse', hg: 'Lisasime söögid ka uutele reisijatele', hh: 'Muutsime söökide arvu vastavalt reisijate arvule', hi: 'Muutsime sõidukite arvu vastavalt täiskasvanute arvule broneeringus', hj: 'NB! Valitud reisijate arv tühistati. Sellel liinil on lubatud maksimaalselt 5 reisijat.', hk: 'Päevareisi soodustus on lisatud broneeringule.', hl: 'Reisiplaani päringul ilmnes viga.', hm: 'Ööbimine laeval', hn: 'Päev Turkus soodustus lisatud', ho: 'Päev Stockholmis soodustus lisatud', HV: 'Pikk ooteaeg Stockholmis.', hp: 'Lisasite viimase vaba \"{name}\" kajuti', hq: 'Oled juba valinud maksimaalse arvu kajuteid. Igas kajutis peab olema vähemalt üks täiskasvanud reisija.', hr: '\"{name}\"  kajut on väla müüdud.', hs: 'Lisasite viimase sõiduki', ht: 'Olete valinud juba maksimaalse arvu sõidukeid. Sõidukeid ei saa olla rohkem kui täiskasvanud reisijaid.', hu: 'Tallinnas ei saa sõidukiga laevast väljuda', hv: 'Sõiduki kohti on ainult minekusuunal', hw: 'Sõiduki kohti on ainult tagasisuunal', hx: 'Valitud sõiduk pole valitud väljumisele saadav', hy: '+ Loom', hz: 'Allergikutele', hA: 'puur', hB: 'puuri', hC: 'Liikumispuudega reisijatele', hD: 'kajut', hE: 'kajutit', hF: 'Igas kajutis peab olema vähemalt üks täiskasvanud reisija', H1: 'Välja müüdud', hG: 'Ainult {capacity}-kohalised kajutid on alles', hH: 'Ainult {capacity}-kohalised kajutid on alles reisile {from}-{to}', hI: 'Lemmikloomaga reisimine', hJ: 'Loe rohkem', hK: 'Jagatud kajutikohad', hL: 'naiskoht', hM: 'meeskoht', hN: '{name}, {genderPlace} {maxOccupancy}-kohalises jagatud kajutis', hO: '{price} / kajut', tm: '{price} / inim.', hP: 'Reisiklass', hQ: 'Eritüüpi kajutid', H2: 'Kajutid', hR: 'loom', hS: 'looma', hT: 'Lemmikloomadega  reisijatele', hU: 'Veeda 2 ööd laeval Silja Symphony või Silja Serenade. Naudi päeva Stockholmi avastades. Tagasitulek on sama laeva ja kajutiga. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides.', hV: '22h kruiis renoveeritud Europal. Väljumised toimuvad iga päev Helsingist kell 18:30. Maaleminek Tallinnas on 08:00-12:10.', hW: 'Veeda 2 ööd laeval Romantika või Isabelle. Naudi päeva Stockholmi avastades. Tagasitulek on sama laeva ja kajutiga. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides.', hX: 'Väljuminne 07:10 Stockholmist. Sõida Baltic Princess\'iga Ahvenamaale ja vaheta laeva ning sõida tagasi Galaxy\'ga. Laev on tagasi Stockholmis kell 18:15', hY: 'Veeda 2 ööd laeval Silja Symphony või Silja Serenade. Naudi päeva Helsingit avastades. Tagasitulek on sama laeva ja kajutiga. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides.', hZ: 'Veeda 2 ööd laeval Romantika või Isabelle. Naudi päeva Riiat avastades. Tagasitulek on sama laeva ja kajutiga. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides.', h_: 'Veeda 2 ööd laeval Baltic Queen või Victoria I. Naudi päeva Tallinna avastades. Tagasitulek on sama laeva ja kajutiga. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides.', h$: 'Väljumine kell 19:30 Stockholmist. Veeda öö laeval Galaxy. Maaleminekut Turus ei toimu. Stockholmi saabumine on järgmisel päeval. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides', h0: 'Veeda 2 ööd laeval Baltic Queen või Victoria I. Naudi päeva Stockholmi avastades. Tagasitulek on sama laeva ja kajutiga. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides.', h1: 'Väljumine 08:15 Turust Galaxy\'ga ja muuda laeva Ahvenamaal ja sõida tagasi Turusse Baltic Princess\'iga. Laev on tagasi Turus 19:15', h2: 'Väljumine kell 20:15 Turust. Veeda öö laeval Baltic Princess. Maaleminekut Stockholmis ei toimu. Turusse saabumine on järgmisel päeval. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides', h3: 'Reisi Ahvenamaale Silja Serenade või Silja Symphony\'ga', h4: 'Veeda öö laeval Silja Symphony või Silja Serenade. Saabumine Stockholmi on järgmisel hommikul. Broneeri kas ühesuunareis või edasi-tagasireis. Naudi laeval meelelahutust, odavat ostlemise võimalust tax-free poes ja naudi erinevaid restorane laeval.', h5: 'Reisi kiirelt ja mugavalt iga päev Helsingist Tallinnasse. Star ja Megastar sõidavad ainult 2 tundi ja Victoria I 3,5 tundi.', h6: 'Päevareise väljub Helsingist iga päev mitmeid. Reisi Tallinnasse kiirelt ja mugavalt. Star ja Megastar sõidavad Tallinnasse 2 tunniga, Victoria 3,5 tundi', h7: 'Kaks igapäevast väljumist Helsingist: 10:30 ja 16:30. Reisi kogukestus on 5 tundi ja Tallinnas ei toimu maaleminekut.\nSuuremate ostude sooritamisel saad allahindlust. Kui plaanid teha väga suuri oste, on kõige lihtsam tulla autoga ja jätta see autogaraaži, mis asub Traveller Superstore\'i kõrval 7. tekil.', h8: 'Veeda öö laeval Romantika või Isabelle. Saabumine Stockholi on järgmisel hommikul. Broneeri kas ühesuunareis või edasi-tagasireis. Naudi laeval meelelahutust, odavat ostlemise võimalust tax-free poes ja naudi erinevaid restorane laeval.', h9: 'Iga päev 4 väljumist Ahvenamaale laevadega Baltic Princess, Galaxy, Silja Serenade, Silja Symphony, Victoria ja Baltic Queen', ia: 'Veeda öö laeval Silja Symphony või Silja Serenade. Saabumine Helsingisse on järgmisel hommikul. Broneeri kas ühesuunareis või edasi-tagasireis. Naudi laeval meelelahutust,odavat ostlemise võimalust tax-free poes ja naudi erinevaid restorane laeval.', ib: 'Veeda öö laeval Romantika või Isabelle. Saabumine Riiga on järgmisel hommikul. Broneeri kas ühesuunareis või edasi-tagasireis. Naudi laeval meelelahutust, odavat ostlemise võimalust tax-free poes ja naudi erinevaid restorane laeval.', ic: 'Veeda öö laeval Baltic Queen või Victoria I. Saabumine Tallinna on järgmisel hommikul. Broneeri kas ühesuunareis või edasi-tagasireis. Naudi laeval meelelahutust, odavat ostlemise võimalust tax-free poes ja naudi erinevaid restorane laeval.', id: 'Veeda pool päeva või öö laeval Baltic Princess või Galaxy. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides', ie: 'Reisi Ahvenamaale Baltic Queen\'i või Victoriaga', $8: 'Päevareise väljub Tallinna D-terminalist iga päev mitmeid. Reisi Helsingisse kiirelt ja mugavalt. Star ja Megastar sõidavad Helsingisse 2 tunniga, Victoria I 3,5 tundi.', ig: 'Reisi kiirelt ja mugavalt iga päev Tallinnast Helsingisse. Star ja Megastar sõidavad ainult 2 tundi ja Viktoria 3,5 tundi.', ih: 'Veeda öö laeval Baltic Queen või Victoria I. Saabumine Stockholmi on järgmisel hommikul. Broneeri kas ühesuunareis või edasi-tagasireis. Naudi laeval meelelahutust, odavat ostlemise võimalust tax-free poes ja naudi erinevaid restorane laeval.', ii: 'Reisi Ahvenamaale Baltic Princess\'i või Galaxy\'ga', ij: 'Veeda pool päeva või öö laeval Baltic Princess või Galaxy. Saa osa laeval pakutavast meelelahutusest, ostle tax-free poes ja proovi uusi põnevaid maitseid laeva erinevates restoranides', ik: '2 ööd laevas ja päev Helsingis', il: '2 ööd laevas ja päev Tallinnas', im: '2 ööd laevas ja päev Ahvenamaal', $9: '22h kruiis Tallinnasse Helsingist', io: 'Kosutav minipuhkus merel', ip: 'Kruiis Ahvenamaale ja tagasi. Maabumiseta.', iq: '2 ööd laevas ja päev Helsingis', ir: '2 ööd laeval ja päev Riias', is: '2 ööd laeval ja päev Tallinnas', it: 'Üks öö laeval, õhtune väljumine Galaxyga. Maaleminekut ei toimu!', iu: 'Naudi 23-tunnist kruiisi Baltic Princessi pardal', iv: '11h kruiis Ahvenamaale väljumisega Turust kell 08:15', iw: 'Üks öö laeval, õhtune väljumine Baltic Princessiga. Maaleminekut ei toimu!', ix: 'Naudi 23-tunnist kruiisi Baltic Princessi pardal', iy: 'Üks päev laeval, hommikune väljumine laevaga Galaxy.<br> Maaleminekut ei toimu!', iz: 'Ühesuunareis ja edasi-tagasireis väljumisega Ahvenamaalt ja Helsingist.', iA: 'Ühesuunareis või edasi-tagasi reis', iB: 'Ühesuunareis ja edasi-tagasireis väljumisega Ahvenamaalt', iC: 'Ühesuunareis ja edasi-tagasireis väljumisega Ahvenamaalt ja Stockholmist.', iD: 'Ühesuunareis ja edasi-tagasireis väljumisega Ahvenamaalt ja Tallinnast.', iE: 'Ühesuunareis ja edasi-tagasireis väljumisega Ahvenamaalt ja Turust.', iF: 'Ühesuunareis või edasi-tagasireis väljumisega kell 17:00 iga päev', iG: 'Ühesuunareis või edasi-tagasireis', iH: 'Ühesuunareis või edasi-tagasireis', iI: 'Ühesuunareis või edasi-tagasireis', iJ: '5h kruiis Helsingist Megastariga <br> Reisi autoga või ilma.', iK: 'Ühesuunareis või edasi-tagasi reis', iL: 'Ühesuunareis või edasi-tagasi reis', iM: 'Ühesuunareis või edasi-tagasireis Sea Windiga. <br>2 väljumist päevas Muugalt', iN: 'Ühesuunareis ja edasi-tagasireis väljumisega Riiast', iO: 'Ühesuunareis või edasi-tagasireis', iP: 'Ühesuunareisi või edasi-tagasireisi 4 väljumist päevas algusega Stockholmist', iQ: 'Ühesuunareis või edasi-tagasireis', iR: 'Ühesuunareis või edasi-tagasireis', iS: 'Ühesuunareis või edasi-tagasireis', iT: 'Ühesuunareis  ja edasi-tagasireis väljumisega Stockholmist ja Turust.', iU: 'Ühesuunareis või edasi-tagasireis.', iV: 'Ühesuunareis või edasi-tagasireis', iW: 'Päevareis väljumisega ja tagasitulekuga samal päeval', iX: 'Ühesuunareis või edasi-tagasireis', iY: 'Ühesuunareis või edasi-tagasireis algusega Turust', iZ: 'Ühesuunareis või edasi-tagasi reis', i_: 'Ühesuunareis  ja edasi-tagasireis väljumisega Turust ja Stockholmist', i$: 'Ühesuunareis või edasi-tagasireis Sea Windiga. <br>2 väljumist päevas Vuosaarist', i0: 'Turu', i1: '2 ööd laevas ja<br> päev Tallinnas.', i2: 'Ühesuunareis või edasi-tagasireis algusega Tallinnast.', H3: 'Kaks päeva', i3: 'Kaks ööd merel, üks öö laeval ning Sulle jääb kaks päeva Härnösandi avastamiseks. Kasuta võimalust šopinguks meie laeva poes kogu reisi vältel.', i4: 'Kaks ööd merel, üks öö laeval ning Sulle jääb kaks päeva Helsingi avastamiseks. Kasuta võimalust šopinguks meie laeva poes kogu reisi vältel.', i5: '2 ööd laevas ja päev Ahvenamaal', i6: '2 ööd laevas ja päev Härnösandis', i7: 'Nautige 2 ööd laevas ja päeva Helsingis', i8: '2 ööd laevas ja päev Riias', i9: '2 ööd laevas ja päev Saaremaal', ja: '2 ööd laevas ja päev Stockholmis', jb: 'Nautige 2 ööd laevas ja päeva Tallinnas', H7: 'Kasuta koodi', jc: 'Sõiduki emissiooni lisatasu', jd: 'Sõiduki emissiooni lisatasu kehtib broneeringus olevale sõidukile.', Id: 'Emissiooni- ja kütuse lisatasu', Ie: 'Sõiduki emissiooni- ja kütuse lisatasu lisatasu kehtib broneeringus olevale sõidukile.', je: 'kuni 1.5 m kõrge ja kuni 3.0 m lai', jf: 'Kuni 1.9 m kõrge ja 5.0 m pikk', jg: 'Lisa garaaž broneeringule ja pargi mugavalt Traveller Superstore kõrval &rarr;', jh: 'Soovid väljuda sihtkohas esimeste seas? Lisa broneeringule Priority Car teenus', ji: 'Üle 2.4 m kõrge ja kuni 8 m pikk', jj: 'm', jk: 'Kuni 1.9 m kõrge ja kuni 5.0 m pikk. Sihtkohas pole võimalik autoga laevast välja sõita.', jl: 'Lisa registreerimisnumber kõikidele sõidukitele', Ii: 'Eemalda', jm: 'Vali sõiduk, millega eelmisel reisil sõitsid:', jn: 'Kuni 2.3 m kõrge ja kuni 7 m pikk', jo: 'Kuni 1.9 m kõrge ja kuni 12 m pikk', jp: 'Järelkäru registreerimisnumber', jq: 'Registreerimisnumber võib sisaldada vaid numbreid ja ladina tähti.', jr: 'Kuni 2.4 m kõrge ja kuni 7 m pikk', js: 'Registreerimisnumber on puudu', jt: 'Sõiduki registreerimistunnus', ju: 'Lisatud sõidukid:', jv: 'Saadavuse kontrollimine', Il: 'Reisi Helsingi kaudu', jw: 'Visby', jx: 'Ystad/Visby', jy: 'Ventspils', Ip: 'Sooduskood:', Iq: 'Pakkumise saadavuse nägemiseks logi sisse oma Club One\'i kontoga.', Ir: 'Vabandust, seda kinkekaart on  juba kasutatud.', Is: 'Vabandust, aga kinkekaart on aegunud.', It: 'Vabandust, see kinkekaart on teises raha kursis.', Iu: 'Kinkekaardil puuduvad vabad vahendid.', jz: 'Vuosaari', IA: 'Kruiis', IC: 'wow', tE: 'Päevakruiis', jA: 'Ystad'};
var $author$project$Translations$Generated$fi = {P: 'Lue saavutettavuuslauselmamme', Q: 'https://www.tallink.com/fi/saavutettavuus', tJ: 'lisää', R: 'Lisää uusi alennuskoodi', S: 'Lisätäksesi varaukseen enemmän ajoneuvoja, lisää ensin uusi aikuinen matkustaja. Polkupyörän voi lisätä myös 6-17 v. lapselle.', tK: 'Lisää huoneet kaikille matkustajille', pl: 'Varaa paikat', tM: 'Reitillä {route} matkustaminen on mahdollista vain ajoneuvolla.', tN: 'Haluatko lisätä myös ajoneuvon reitille {route}?', tO: 'Lisätäänkö reitti?', T: 'Ahvenanmaa', t_: 'Ahvenanmaa (Långnäs)', t$: 'Ahvenanmaa (Maarianhamina)', ue: 'Olet valinnut huoneen toisesta hotellista. Valitaksesi huoneen tästä hotellista, sinun tulee poistaa edellinen valinta.', uj: 'Risteily', ul: 'Peruuta', um: 'Siirry täysversioon', un: 'Jos siirryt täysversioon, sinun tulee tehdä seuraavat valinnat uudelleen: <span class=\"bodyBold\">matkustajatiedot, matkustusluokka, ateriat</span>.', uo: 'Kaikkia valintoja ei voida säilyttää', up: 'Jos siirryt täysversioon, sinun tulee tehdä seuraavat valinnat uudelleen: <span class=\"bodyBold\">matkustajatiedot ja ateriat</span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Pank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'Pankki', aa: 'Valitse pankki', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click kirjautuminen tai mobiilinumero', ah: 'Viimeksi valitut', ai: 'Säästöpankki', aj: 'SEB', ak: 'Select bank:', al: 'S-Pankki', am: 'Swedbank', uB: 'varaa ruokailut', uC: 'Varaa nämä matkat erikseen:', uD: 'Lisää laivapalveluita', uE: 'Siirry täysversioon &rarr;', uF: 'Etkö löydä haluamaasi tuotetta?', uG: 'Lisää bussikuljetus', uH: 'Matkat satamaan ja takaisin', uI: 'Varaa matka yritysasiakkaana', ao: 'Varaa helpommin, hyödynnä alennukset', ap: 'Kirjaudu ulos &rarr;', uJ: 'Kirjaudu sisään', aq: 'Oletko Club One -asiakas?', ar: 'Näytä saatavilla olevat lähdöt', uK: 'Alennuskoodia ei voi hyödyntää valittuun matkaan. Ole hyvä ja valitse toinen lähtöpäivä, reitti tai matkustusluokka.', as: 'Tarkista koodi ja yritä uudelleen', uL: 'Peruuta', at: 'Varauskoodi lisätty', au: 'Koodi hyväksytty', uM: 'Tarkista koodi ja yritä uudelleen. Koodi voi myös olla lukittu, jos olet juuri käyttänyt sitä. Voit odottaa 20 minuuttia ja yrittää uudelleen.', av: 'Alennuskoodi on hetkellisesti lukossa. Odota 15 minuuttia ja yritä uudelleen.', aw: 'Alennus laskettu', ax: 'Alennuskoodi', ay: 'Koodi ei ole voimassa valitulla lähdöllä tai alennuspaikat on loppuunmyyty', az: 'Voit kuitenkin käyttää sen toisena lähtöpäivänä', aA: 'Alkuperäinen hinta {oldPrice} on muuttunut hinnaksi {discountedPrice}', aB: 'Alkuperäinen hinta {oldPrice}, koodin lisäämisen jälkeen {discountedPrice}', aC: 'Poista', uN: 'Koodi hyväksytty. Ole hyvä ja valitse hytti aktivoidaksesi alennuskoodin.', uO: 'Käyttääksesi lahjakortin, soita +358 9 887 53121.', aD: 'Alennuskoodi hyväksytty', aE: 'Minulla on alennuskoodi', aF: 'pisteet', uP: 'Valitse lisäpalvelu', aG: 'Fast track', aH: 'Laivaparkki', aI: 'Vakuutus', uQ: 'Varaa luottavaisin mielin', aJ: 'Priority Car -autopaikka', uR: 'Valitse lähtökaupunki', uS: 'Valitse matkakohde', aK: 'Varaa matka', uT: '22 h -risteily', uU: 'Risteilyt', uV: 'Risteilyt', uW: 'Ei maissaoloaikaa kohteessa', py: 'Ei maissaoloaikaa kohteessa', uX: 'Päivä Helsingissä -risteily', uY: 'Päivä Riiassa -risteily', uZ: 'Päivä Tukholmassa -risteily', u_: 'Lähtöpäivä', u$: 'Huomioithan, että liikuntarajoitteita tai muita toimintaesteitä ei välttämättä pystytä huomioimaan laivalla.', aL: 'Huomioithan, että matkalla ei ole pääsyä maihin', u0: 'Paluupäivä', u1: 'Yhdensuuntainen matka', u2: 'Meno-paluu', aM: 'Megastarin 5 h -risteily', u3: 'Yhdensuuntainen matka', u4: 'Meno-paluu', ne: 'Matka', aN: 'Matkatyyppi', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Valitse kieli', aV: 'Suomeksi', aW: 'Haluatko vaihtaa kielen?', u5: 'Valitse ruokailut', aX: 'Ruokailut varattavissa laivalta', u6: 'Ruokailuja ei ole saatavilla', u7: 'Osta ateriat ennakkoon ja säästä rahaa', u8: 'Ruokailut', aY: 'Minulla on alennuskoodi', u9: 'Lisäpalvelut', aZ: 'Varauksella tulee olla 1 ajoneuvo.', va: 'COVID-19', a_: 'Koronaviruspikatesti', vb: 'Lasten rannekkeet', vc: 'Hieronta', vd: 'Matkustajat', ve: 'Liity Club One -asiakkaaksi &rarr;', vf: 'https://clubone.tallink.com/fi/liity-club-one-asiakkaaksi', vg: 'Kirjaudu ulos &rarr;', vh: 'Kirjautumalla saat Club One -edut käyttöösi ja varaat nopeammin', a$: 'Valitse hytti', vi: 'Matkustusluokka', vj: 'Hytit', a0: 'Polku&shy;pyörä, sähköpotkulauta', a1: 'Henkilö&shy;auto', a2: 'Korkea henkilö&shy;auto', vl: 'Valitse ajoneuvo', vm: 'Ole hyvä ja lisää rekisteritunnus', a3: 'Ladataan hintoja', a4: 'Moottori&shy;pyörä / mopo', a5: 'Moottori&shy;pyörä sivu&shy;vaunulla', a6: 'Auto parkkiin laivalle', a7: 'Rekisteritunnus on valmiiksi esitäytetty', a8: 'Henkilöauto laivan ostosparkkiin', a9: 'Pakettiauto laivan ostosparkkiin', ba: 'Näytä kaikki', bb: 'Paketti&shy;auto', bc: 'Korkea paketti&shy;auto', bd: 'Erityispitkä ajoneuvoyhdistelmä', be: 'Korkea pakettiauto ja perävaunu', bf: 'Auto ja perä&shy;vaunu', bg: 'Pakettiauto ja perävaunu', vB: 'Lisää uusi kuljetus', bh: 'Lisää hyttitervehdys', bi: 'Lahja sinulle', bj: '{count} hyttitervehdystä valittu', bk: '{count} hyttitervehdys valittu', vC: 'Näytä lisää', bl: 'Näytä edelliset', bm: 'Lähtöpäivä', vD: 'Erikoisristeily', bn: 'Huom.', vE: 'Hinta alkaen {price}', vF: 'Ei saatavilla olevia lähtöjä', vG: 'Ei saatavilla olevia lähtöjä', bo: 'kaikki hinnat euroissa', bp: 'Hytti alk. {price} pistettä', bq: 'alk. {price} pistettä / henkilö', br: 'alk. {price} / henkilö', bs: 'Hytti alk. {price}', bt: 'Peruuta', bu: 'Jatka', bv: 'Jos jatkat, hyttivalintasi poistetaan. Syöttämäsi matkustajatiedot säilyvät.', bw: 'Valitsemasi hyttiluokka ei ole saatavilla tällä lähdöllä', vH: 'Erikois-<br/>risteily', vI: 'Auto alk. {price}', bx: 'Täynnä', by: 'Päästölisämaksu', bz: 'Päästölisämaksut koskevat matkustajia 6-vuotiaasta ylöspäin.', bA: 'Päästölisämaksu, jolla tuetaan ilmastotoimia ja katetaan EU:n päästökauppajärjestelmän kustannuksia.', vQ: '{chars} merkkiä jäljellä', vR: 'Sisäänkirjautuminen', vS: 'Uloskirjautuminen', vW: 'Valitse &rarr;', vX: 'Valitse hotellihuone', vY: 'Valitse majoitus nähdäksesi lopullisen hinnan', v3: 'Poista aiempi valinta ja valitse', bB: 'Bronze level', bC: 'Club-taso', wd: 'Club one discount:', bD: 'Gold-taso', bE: 'Club One -tili ei ole aktiivinen', bF: 'Club One -numero', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One -tilin aktivointi\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One -tilin aktivointi\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Club One -tilin aktivointi\">clubone@tallink.lv</a>', bK: '\"<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One -tilin aktivointi\">tallinksilja@tallinksilja.no\n</a>\"', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Club One -tilin aktivointi\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One -tilin aktivointi\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: 'Sähköpostilla:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One -tilin aktivointi\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One -tilin aktivointi\">Club One -tilisi ei ole tällä hetkellä aktiivinen. Ole hyvä ja ota meihin yhteyttä.\n</a>', bQ: 'Club One -tilisi ei ole tällä hetkellä aktiivinen. Ole hyvä ja ota meihin yhteyttä, jotta voimme aktivoida tilisi uudelleen.', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Puhelimitse (avoinna ma-pe 8-20, la 9-17, su 10-18):', b_: 'Platinum-taso', wg: '<a>Kirjaudu sisään</a> tai <a>liity Club One -jäseneksi</a> saadaksesi alennuksia, käyttääksesi pisteitä ja sujuvoittaaksesi varauksen tekoa.', b$: 'Silver-taso', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Enintään käytettävissä oleva pistemäärä on laskettu dynaamisesti ja pohjautuu varauksella oleviin palveluihin ja tuotteisiin.', wj: 'Käytä Club One -pisteitä', wk: 'Club One -pisteitä ei voi hyödyntää tällä alennuskoodilla.', wl: 'Sinulla ei ole tarpeeksi Club One pisteitä käytettäväksi.', b0: 'Voit käyttää Club One -pisteitä joustavasti matkavarauksellesi <a>alla olevalla liukusäätimellä</a>.', wm: 'Pisteitä ei voi hyödyntää tarjouksen yhteydessä ({reason}).', pQ: 'Alennuskoodi', wp: 'Lisätyssä tekstissä on tunnistamattomia erikoismerkkejä.', wr: 'Syntymäaika', ws: 'pp', wt: 'kk', wu: 'vvvv', wv: '{count} {count, plural, one{aikuinen} other{aikuista}}', ww: '({range} v.)', wx: 'Perillä klo {time}', pT: '{count} {count, plural, one{lapsi} other{lasta}}', wy: 'Ilmainen', wz: 'Sulje', wA: 'Näytä', wB: 'Kansalaisuus', wC: 'Yleisimmät', b1: 'Hinnat ovat Club One {level} -asiakkaan etuhintoja.', wD: 'Voit syöttää matkustajien tiedot nyt tai lisätä ne myöhemmin. Club One -asiakasnumero tulee kuitenkin lisätä jo tässä vaiheessa.', b2: 'p', b3: 'Käytä Club One -pisteitä', b4: 'Tulossa pian', wE: 'Lisää Club One -numero ennen varaamista', wF: 'Valmis', wG: 'Muokkaa &rarr;', b5: 'Nopeuttaaksesi lähtöselvitystä ja helpottaaksesi varaustietojen jakamista matkakumppaneidesi kanssa, lisääthän kaikkien matkustajien puhelinnumeron ja sähköpostiosoitteen.', wH: 'Etunimi', wI: 'Sukupuoli', wJ: 'Nainen', wK: 'Mies', wL: 'Sisältyy hintaan', mh: 'Tarkista oikeinkirjoitus', wM: 'Tämä sähköposti kuuluu yhteyshenkilölle tai toiselle matkustajalle. Ole hyvä ja lisää toinen sähköpostiosoite.', wN: 'Tämä puhelinnumero kuuluu yhteyshenkilölle tai toiselle matkustajalle. Ole hyvä ja lisää toinen puhelinnumero.', wO: 'Sukunimi', wP: 'Täytä pakolliset tähdellä (*) merkityt kentät', wQ: 'Aamiainen', wR: 'Brunssi', wS: 'Buffet', wT: 'Illallinen', wU: 'Lounas', wV: 'Pöytävaraus', wW: 'Kattaukset voit varata laivalla', wX: 'Nimi ei saa sisältää erikoismerkkejä.', wY: 'Ei saatavilla', b6: 'Ei saatavilla tälle matkalle', wZ: 'Ei rajoitetta', b7: 'Aikuinen\n18+', b8: 'Lapsi\n0-5', b9: 'Lapsi\n6-11', ca: 'Lapsi\n12–17', cb: 'Pankit', w_: 'Maksa {price}', cc: 'Suoritetaan maksua {price}', cd: 'Kortit', w$: 'Vahvista varaus {price}', w0: 'Vahvistetaan {price}', ce: 'Maksa Klarnalla {price}', cf: 'Varaustasi käsitellään...', w1: '<p>Sinulle tarjottava matkapalvelukokonaisuus on direktiivin (EU) 2015/2302 mukainen pakettimatka.</p>\n<p>Siksi sinulla on kaikki EU-lainsäädännön mukaiset oikeudet, jotka matkustajalla on pakettimatkan yhteydessä. AS Tallink Grupp on täysin vastuussa pakettimatkan palvelujen asianmukaisuudesta kokonaisuutena.</p>\n<p>Tämän lisäksi laissa edellytetään, että AS Tallink Grupp -yrityksellä on takuu maksaa maksamasi maksut takaisin, jos se ei maksukykynsä vuoksi pysty täyttämään velvoitteitaan ja jos valmismatkaan sisältyy matkustajakuljetus, takaamaan paluunne lähtöpaikkaan tai muuhun sovittuun paikkaan.</p>\n<p><a href=\"https://www.tallink.com/fi/hyva-tietaa/pakettimatkat\" target=\"_blank\">Katso pakettimatkan ehdot.</a></p>', pU: '<p>Sinulle tarjottu matkapalvelujen yhdistelmä on direktiivissä (EU) 2015/2302 tarkoitettu matkapaketti.</p>\n<p>Näin ollen sinuun sovelletaan kaikkia matkapaketteja koskevia EU-oikeuksia. {name} on täysin vastuussa koko matkapaketin asianmukaisesta toteuttamisesta.</p>\n<p>Lisäksi yritys {name} on hankkinut suojan palauttaakseen suorittamasi maksut ja, jos kuljetus sisältyy matkapakettiin, turvatakseen paluukuljetuksesi siltä varalta, että yrityksestä tulee maksukyvytön.</p>\n<a href=\"{url}\" target=\"_blank\">Lisätietoja direktiivin (EU) 2015/2301 mukaisista tärkeimmistä oikeuksista</a>.', w2: 'Painamalla maksupainiketta hyväksyt <a href=\"https://www.tallink.com/fi/hyva-tietaa/maksu-ja-peruutusehdot\" target=\"_blank\">Tallinkin maksun ja peruutuksen ehdot</a> sekä <a href=\"https://fi.tallink.com/club-one-ehdot-ja-rekisteriseloste#tabs-content-1\" target=\"_blank\">Club One -kanta-asiakasohjelmaan</a> liittyvät säännöt ja määräykset.', w3: 'Maksamalla / vahvistamalla varauksen hyväksyt Tallinkin <a href=\"https://www.tallink.com/fi/hyva-tietaa/maksu-ja-peruutusehdot\" target=\"_blank\">maksu- ja peruutusehdot</a> ja <a href=\"https://www.tallink.com/fi/hyva-tietaa/matkustajan-oikeudet-eu-asetus\" target=\"_blank\">turvallisuusohjeet</a> ja vahvistat lukeneesi <a href=\"https://www.tallink.com/fi/tietosuojaohjelma\" target=\"_blank\">tietosuojakäytännön</a>.', w4: 'AS Tallink Grupp', w5: 'https://www.tallinksilja.fi/matkapakettien-oikeudet-tietolomake-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://fi.tallink.com/matkapakettien-oikeudet-tietolomake-tallink-silja', w8: 'Alle 18-v. matkustaja, muista tarkistaa <a href=\"https://www.tallink.com/fi/hyva-tietaa/ikarajat\" target=\"_blank\">ikäsäännöt ja tarvittavat matkustusluvat</a>', w9: 'Alipay', xa: 'Apple Pay', xb: 'paikalliset pankit', xc: 'kortit', xd: 'Google Pay', xe: 'Mobile Pay', xf: 'Pankki/luottokortti', xg: 'WeChat Pay', xh: 'Verkkopankki ja pankki/luottokortti', xi: 'Paikalliset pankit', xj: 'Verkkopankki ja kortit', cg: 'Alk. {price}', xk: 'Takaisin matkan valintaan', xl: 'Valitse', xm: 'Valittu', xn: 'Laiva', xo: '{date} klo {time}', xp: '{count} {count, plural, one{matkustaja} other{matkustajaa}}', xq: 'Aikuinen\n18+', xr: 'Lapsi\n0-5', xs: 'Lapsi\n6-17', xt: 'Ole hyvä ja valitse ensin hytti', xu: 'Tulosatama Ahvenanmaalla on Långnäs (30 km Maarianhaminasta)', xv: 'Saapuminen Långnäsiin', xw: 'Lähtö- ja tulosatama Ahvenanmaalla on Långnäs (30 km Maarianhaminasta)', xx: 'Lähtösatama Ahvenanmaalla on Långnäs (30 km Maarianhaminasta)', xy: 'Lähtö Långnäsistä', pV: 'Ajoneuvo', xz: 'Ajoneuvot', ch: '22 h -risteily Helsingistä Tallinnaan', ci: 'Risteily', cj: 'Meno- ja meno-paluumatkat', ck: 'Reittimatka', cl: 'Meno-, meno-paluu- ja päivämatkat', xB: 'Yritysasiakas', xC: 'Agenttinumero', xD: 'Syöttämääsi agenttinumeroa ei löydy', xE: 'Huom! Agenttinumero ei ole pakollinen', xF: 'Sinut kirjataan hetkellisesti ulos henkilökohtaiselta tililtäsi', xG: 'Yritysnumero', xH: 'Syöttämääsi yritysnumeroa ei löydy', cm: 'Lähetimme sinulle varausvahvistuksen osoitteeseen', cn: 'Varaus vahvistettu, mukavaa matkaa!', co: 'Palautettavaa yhteensä {refund}', cp: 'Ole hyvä ja ota yhteyttä asiakaspalveluumme palautukseen liittyen.', cq: 'Varauksesi on päivitetty!', xI: 'Aikuinen', xJ: 'Kaupungin nimi', xK: 'Ei hakutuloksia', xL: 'Etsi pysäkki', xM: 'Bussikuljetukset', cr: '6 - 17-v. lapset', cs: 'Muuta varausta', xN: 'Peruslippu', xO: 'Lapsi {range} v.', ct: 'Palvelut maissa', cu: 'Ei kiitos', cv: 'Tottakai!', cw: 'Haluaisitko saada tarjouksia sähköpostilla?', cx: 'Kiitos, että tilasit uutiskirjeen!', cy: 'Soita Online-tukeen', cz: 'Peruuta', xP: 'Syötetty syntymäaika ei vastaa aiemmin valittua ikäkategoriaa. Ole hyvä ja muuta syntymäaika tai ota yhteyttä Online-tukeen muuttaaksesi ikäkategorian:', cA: 'Haluatko muuttaa ikäryhmää?', cB: 'Osta palveluita', cC: 'Muuta palveluita', cD: 'Osoite', cE: 'Yritys', cF: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallinksilja.de/kontaktieren-sie-uns\">asiakaspalveluumme</a>.', cG: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\">asiakaspalveluumme</a>.', cH: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://ee.tallink.com/et/kontaktid\">asiakaspalveluumme</a>.', cI: 'Mikäli haluat muuttaa varausta, olethan meihin yhteydessä. Yhteystiedot näet <a href=\"https://www.tallinksilja.fi/palvelunumerot\">täältä</a>.', cJ: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallink.lv/lv/contacts\">asiakaspalveluumme</a>.', cK: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallinksilja.com/contact-us\">asiakaspalveluumme</a>.', cL: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallinksilja.ru/agents\">asiakaspalveluumme</a>.', cM: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallinksilja.se/kontakta-oss\">asiakaspalveluumme</a>.', cN: 'Mikäli haluat tehdä muutoksia varaukseesi, olethan yhteydessä <a href=\"https://www.tallinksilja.com/contact-us\">asiakaspalveluumme</a>.', cO: 'Yhteyshenkilö', cP: 'Yhteyshenkilö', cQ: 'Mikäli haluat tehdä muutoksia varaukseen, olethan yhteydessä matkatoimistoosi.', cR: 'Sähköpostiosoite', cS: 'Liity Club One -jäseneksi', cT: 'Matkavahvistus', cU: 'Lähtöselvitys alkaa 2 tuntia ennen lähtöä. Huomioithan, että lähtöselvitys on tehtävä autolähtöselvityksellä ja viimeistään 45 minuuttia ennen lähtöä.', cV: 'Ole hyvä ja täytä kaikki matkustajatiedot', cW: 'Peruuta', cX: 'Jatka', cY: 'Haluatko jatkaa pois sivulta? Tällöin tekemiäsi matkustajatietojen muutoksia ei tallenneta.', cZ: 'Muutoksia ei tallenneta', c_: 'Näytä vahvistus PDF-tiedostona', c$: 'Näet maksutiedot (pankin tili- ja viitenumeron) sähköpostitse toimitetusta varausvahvistuksesta (PDF)', c0: 'Näytä maksu- ja peruutusehdot', c1: 'https://www.tallink.com/fi/hyva-tietaa/yleiset-matkaehdot', xQ: 'Yhteensä', c2: 'Matkapuhelin', c3: 'Varausnumero', c4: 'Turvanumero', c5: 'Vahvistus', c6: 'Kaikki ajat ovat paikallisia aikoja.', c7: 'Välttääksesi turhaa jonottamista, suosittelemme käyttämään lähtöselvitysautomaatteja terminaalissa. Tarvitset lähtöselvitystä varten varausnumeron ja turvanumeron.', c8: 'Suosittelemme saapumaan lähtöselvitykselle ajoissa.', c9: 'Ilman ajoneuvoa matkustavien asiakkaiden tulee olla lähtöselvityksessä viimeistään 30 minuuttia ennen lähtöä. Ajoneuvon kanssa matkustettaessa autolähtöselvityksellä tulee olla viimeistään tuntia ennen lähtöä. HUOM! Autolla Tallinnasta tai Tukholmasta Maarianhaminaan matkustavien tulee olla autolähtöselvityksellä viimeistään 1,5 tuntia ennen lähtöä.', da: 'Tallink Silja peruu matkavarauksen, jos lähtöselvitystä ei ole tehty ennen lähtöä. Päivämatkojen ja risteilyjen osalta Tallink Silja peruu koko matkan, jos matkustaja ei ole tehnyt lähtöselvitystä ensimmäisessä lähtösatamassa.', db: 'Muista ottaa mukaan passi tai uudenmallinen henkilökortti.', dc: 'Laivan saapumis- ja lähtöajat ovat aina paikallista aikaa. <br>\nVoit kirjautua sisään netissä, Tallink Silja Line -sovelluksessa tai terminaalin. <br>\nPaldiskin ja Kapellskärin satamissa ajoneuvomatkustajien lähtöselvitys sulkeutuu 75 minuuttia ennen Superfast laivan lähtöä. Suosittelemme saapumaan satamaan ajoissa. <br>\nHyttikortit saat sisäänkirjautumisen yhteydessä. <br>\nJokaisella matkustajalla (mukaan lukien lapset) on oltava voimassa oleva matkustusasiakirja ja muut tarvittavat asiakirjat, kuten tarvittaessa viisumi, koko matkan ajan. <br>\nMatkustajat ovat vastuussa asiakirjojensa oikeellisuudesta ja voimassaolosta.', dd: 'Matkan tiedot', de: 'Hyvä tietää', df: 'Palautettavaa', dg: 'Sinulle jäi saatavaa {refund}! Ylimääräisen maksun palautus onnistuu myyntipalvelumme kautta.', dh: 'Soita myyntipalveluun', di: 'Joko ehdit soittaa? Ei hätää, tämä viesti katoaa, kunhan saamme palautuksesi käsiteltyä.', dj: 'Maksun palautus', xR: 'Jos yhteysongelmat jatkuvat, olethan yhteydessä Online-tukeen 010 804 133 (0,0835 €/puhelu + 0,167 €/min)', xS: 'Ei Internet-yhteyttä, ole hyvä tarkista yhteys ja yritä uudelleen', xT: 'Yritä uudelleen', xV: 'Jatka', xW: 'Jatka maksamaan', pX: 'Sähköpostiosoite', xX: 'Esim.', dk: 'Maatunnus ja puhelinnumero', xY: 'Varauksen yhteyshenkilö', xZ: 'Lisää yhteystietosi, jotta voimme lähettää sinulle varausvahvistuksen. Käyttääksesi Club One -etuja kirjaudu sisään tai lisää tietosi Matkustajat-osiossa ennen varauksen tekoa.', x_: 'Tiedot tallennetaan Club One -yhteystietoihin', pY: 'Matkapuhelin', dl: 'Esim. 50 1234567', x$: 'Muu', x0: 'Kopio varausvahvistuksesta lähetetään sähköpostiosoitteeseen {email}', dm: 'Vaihtoehtoinen sähköpostiosoite', dn: 'Postinumero', x6: '{price} / testi', x8: 'Varaa tämä matka nopeammin <b>uudella varauspalvelullamme.</b>', dp: 'Kortinhaltijan nimi', dq: 'Luottokortti', dr: 'kk', ds: 'Luottokortin numero', dt: 'Maksutapa', du: 'Turvanumero', dv: 'Valitse luottokortti:', dw: 'Voimassaoloaika', dx: 'vv', dy: '22 h -risteily Tukholma (Kappellskär)-Turku-Tukholma (Kappellskär)', ya: 'Risteily Helsinkiin', yb: 'Risteily Visbyhyn', dz: '22 h -risteily Turku-Tukholma (Kappellskär)-Turku', yc: 'Risteily Ystadiin ja Visbyhyn', dA: 'Päivä Helsingissä -risteily', dB: 'Päivä Riiassa -risteily', no: 'Päivä Tallinnassa -risteily', yj: 'Päivä Turussa -risteily', yr: 'Jälkiruoka', dC: 'Alennus:', yy: 'Käytössä', yz: 'Alennuskoodi ja lahjakortti:', p9: 'Alennukset & lahjakortit', dD: 'Muista valita yksi menu kaikille aikuisille varatessasi {restaurant} -ravintolaa.', dE: 'Muista valita yksi menu kaikille yli 12-vuotiaille varatessasi {restaurant} -ravintolaa.', yB: 'Älä missaa tilaisuutta!', yD: 'Valitse juomapaketti', dF: 'Samoilla tiedoilla löytyy jo varaus (varausnumero {resId}, yht. {price} {unit} ). Haluatko perua vanhan varauksen ja vahvistaa maksun uudesta varauksesta? <a href=\"{link}\">Avaa ja maksa vanhempi varaus →</a> Tarvittaessa ota yhteyttä Tallink Siljan Online-tukeen 010 80 41 33.', yF: 'Muokkaa huonevalintaa', yG: 'Muokkaa hotellihuoneita', yO: 'Palvelut maissa', yP: 'Palvelut maissa ja hotelleissa', yS: 'Kaikilla matkustajilla on oltava istuinpaikka ajoneuvossa.', dK: 'https://clubone.tallink.com/fi', yY: 'Lisäpalvelut', dL: 'Anna palautetta', y_: 'Laiva', y$: 'HOTELLIMATKAT', y5: 'Valitse menu', y7: 'Ruoka-allergiat / erityisruokavaliot:', kS: 'Mistä', za: 'Polttoaine- ja päästölisämaksu', zb: 'Polttoaine- ja päästölisämaksut koskevat matkustajia 6-vuotiaasta ylöspäin.', zc: 'Polttoaine- ja päästölisämaksut koskevat 12 v täyttäneitä matkustajia. Enintään kolme 6–11-v. lasta per varaus ilman lisämaksuja.', zd: 'Polttoainelisämaksu määräytyy merenkulun globaalin polttoainehinnan vaihtelun perusteella. Päästölisämaksu tukee ilmastotoimia ja kattaa Euroopan Unionin päästökauppajärjestelmän kustannuksia.', dM: 'Polttoainelisämaksu', dN: 'Polttoainelisämaksu koskee matkustajia 6-vuotiaasta ylöspäin.', dO: 'Polttoainelisämaksu on {price} matkustajille 6-vuotiaasta ylöspäin.', dP: 'Polttoainelisämaksu on {price} yhteen suuntaan matkustajille 6-vuotiaasta ylöspäin.', zh: 'Lahjakortti:', zi: 'Lahjakortin arvon voi käyttää useassa osassa, kunnes lahjakortin arvo on käytetty loppuun.\nLahjakortilla on {priceLeft} €.', dQ: 'Ryhmämenu saatavilla', zm: '12 tai useamman aikuisen matkustajan varauksissa pyydämme ystävällisesti valitsemaan yhden menuvaihtoehdon jokaiselle varauksen aikuiselle matkustajalle. Nuoremmat matkustajat saavat automaattisesti 25 € arvoisen lastenmenukupongin.', dR: 'Helsinki', dS: 'Kaksi yötä laivalla <br>ja päivä Riiassa.', dT: '22 h -risteily Tallinnaan.', dU: 'Risteily Tallinnaan.<br>Aikaa maissa n. 5 h.', dV: 'Visby-risteilyt Helsingistä', dW: 'Kesän erikoisristeilyt taianomaiselle Gotlannin saarelle', dX: 'Härnösand', zv: 'Hotelli', zy: 'Valitaksesi päivän valittavissa olevien päivämäärien ulkopuolelta, sinun tulee <a>muuttaa matkustuspäiviäsi</a>.', dY: 'Sisäänkirjautuminen', dZ: 'Sisäänkirjautuminen:', d_: 'Uloskirjautuminen', d$: 'Uloskirjautuminen:', d0: 'yötä', d1: 'yö', zz: 'Voit varata pelkän hotellin erillisessä sovelluksessa.', zA: 'Valittuina päivinä ei ole hotellihuoneita vapaana. Ole hyvä ja valitse eri matkapäivät.', zB: 'Et voi kirjautua sisään uloskirjautumisen jälkeen. Voit muuttaa päivän uloskirjautuminen-välilehdellä.', zC: 'Et voi kirjautua ulos ennen sisäänkirjautumista. Voit muuttaa päivän sisäänkirjautuminen-välilehdellä.', zD: 'Tämä on sisäänkirjautumispäiväsi. Muuttaaksesi päivän palaa takaisin sisäänkirjautumisen valintaan.', zE: 'Tämä on uloskirjautumispäiväsi. Muuttaaksesi päivän palaa takaisin uloskirjautumisen valintaan.', qF: 'Päivä ei ole valittujen matkustuspäivien sisällä. Valitaksesi päivän muuta matkustuspäiviäsi.', zF: 'Risteily- ja hotellimatka, sisältäen ensimmäisen yön laivalla', zG: 'Yöpyminen laivalla, laivasta poistuminen klo 6.00', zW: 'Tieto ruoka-aineallergioista / erityisruokavalioista on välitettu laivan henkilökunnalle.', q4: 'Liity Club One -jäseneksi', AB: 'Club One -jäsenenä saat alennusta matkoista, ansaitset pisteitä ja nautit erilaisista jäseneduista maissa ja merellä. Jäsenyys on maksuton.', d2: 'Osoite', d3: 'Postitoimipaikka', d4: 'Maa', d5: 'Viimeistele liittyminen Club One -jäseneksi', AC: 'Postinumero', AD: 'Club One -jäsenen tulee olla yksi matkustajista.', d6: 'Sähköpostilla', d7: 'Postitse', d8: 'Tekstiviestillä', d9: 'Postituskieli', ea: 'Haluan Club One -etuja ja uutisia', eb: 'Ei', ec: 'Tallenna ja sulje', ed: 'Kyllä', AF: 'Tervetuloa Club One -jäseneksi! Voit täyttää loput tietosi varauksen jälkeen.', AG: 'Tervetuloa Club One -jäseneksi! Liittyessäsi jäseneksi saat kanta-asiakasalennuksen. Alkuperäinen hinta oli {priceBefore} ja uusi hinta on {currentPrice}.', AH: 'Löysimme antamillasi tiedoilla jo olemassa olevan Club One -tilin.', ee: 'Kapellskär', ef: 'Menukuponki lapselle', AN: 'Vahvistamalla varauksen hyväksyt varaustietojen luovutuksen Klarnalle maksutapojen mahdollistamista varten. Lue lisää', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/fi_fi/privacy_statement.pdf', AP: 'Klarnan tietosuojaperiaatteista', AQ: 'Klarna & Swish', AR: 'Laskutus, osamaksu', AS: 'Klarna', AT: 'Laskutus', AU: 'Osamaksu', AV: 'Swish', AW: 'Saatavilla olevat maksutavat riippuvat varauksestasi, yleisimmät maksutavat ovat:', eg: 'Klarna', eh: 'Maksa helposti mobiilissa', ei: 'Klaipeda', ej: 'Yksi suunta tai meno-paluu. <br>Lähtö klo 19:00.', A$: 'Saksan kieli', A0: 'Englannin kieli', A1: 'Eestin kieli', A2: 'Suomen kieli', ek: 'Liettuan kieli', A3: 'Latvian kieli', A4: 'Venäjän kieli', A5: 'Ruotsin kieli', Bb: 'Ladataan...', Bc: 'Helsinki', Bd: 'Jurmala', Be: 'Kolmården', Bf: 'Kuressaare', Bg: 'Laulasmaa', Bh: 'Maarianhamina', Bi: 'Narva', Bj: 'Norrköping', Bk: 'Otepää', Bl: 'Pärnu', Bm: 'Rakvere', Bn: 'Riika', Bo: 'Södertälje', Bp: 'Tukholma', Bq: 'Tartto', Br: 'Turku', Bs: 'Tallinna', Bt: 'Tampere', Bu: 'Uppsala', Bv: 'Vantaa', Bw: 'Vihula', BC: 'Valitse pääruoka', BE: 'Lisää uusi', BF: 'Päivämäärä:', BG: '{price} / hoito', BH: 'Aika:', Cf: 'Tätä ruokailua ei ole tarjolla välillä {direction}', Cg: 'Ateriapaketti sisältää ruokailut koko matkalle', Ch: 'Valitse ateriapaketti', el: 'Ei valittu', em: '<span class=\"data\">{count}</span> {count, plural, one{# aamiainen} other{# aamiaista}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# illallinen} other{# illallista}}', rt: 'Lapset saavat paketista alennusta ja 0-5 v. syövät maksutta aikuisen seurassa. \n\nVoit käyttää paketin ateriakupongit Buffet-ravintolassa tai halutessasi maksuna laivan muissa ravintoloissa.', Ci: '{price} / yli 18-v.', Cj: '{price} / aikuinen', Ck: '{price} / hlö', Cl: '<span class=\"save bodySmall\">Osta</span><span class=\"bodySmall\">ja</span><span class=\"bodyLarge percentage\">säästa</span>', Cm: 'Ateriapaketti', Cn: '{count, plural, one{# henkilö} other{# henkilöä}}', Co: 'per henkilö', Cp: 'Pöytävaraus', ru: 'Osta ateriapaketti ja säästä', eo: 'Varaa pöytä', ep: 'Täynnä', eq: 'Aamiainen', er: 'Illallinen', Cq: 'Ruokailut', es: 'Ateriakuponki', Cr: 'Ateriat sisältyvät matkan hintaan.', Cs: 'Oletko varma, että et halua lisätä ruokailuja varauksellesi <b>jopa 10 % alennuksella</b>? Tarjous on voimassa vain varatessasi verkkosivujemme kautta.', et: 'Kokoushuone', eu: '{date} klo {time} varaus {duration} h', Ct: 'Menu saatavilla', Cu: 'Valitse yksi menuvaihtoehto kaikille varaukseen kuuluville yli 12-vuotiaille. Alle 12-vuotiaat matkustajat saavat aterialipun varauksen yhteydessä ja voivat varata ateriansa laivalla. Lapset saavat alennusta vähintään 50 % normaalihinnasta.', ew: 'Lisää matkustajatiedot', ex: 'Näytä matkustajatiedot', ey: 'Club One', CA: 'Mikäli haluat muuttaa Club One -tietoja, ole hyvä ja ota yhteyttä Online-tukeen:', ez: 'matkustajan tiedot puuttuvat', eA: 'Täytettyäsi matkustajatiedot, voit mennä suoraan terminaaliin varausnumeron kanssa.', eB: 'Väärä ikäryhmä', eC: 'Puuttuva matkustajatieto', eD: 'Lisää puuttuva maksu', eE: 'Muuta rekisteritunnusta', eF: 'Lisää ajoneuvon rekisterinumero', eG: 'Rekisteritunnus puuttuu', eH: 'Matkavaraukset puhelimeesi', eI: 'Lataa', eJ: 'Avaa', eK: 'Lähetä linkki', eL: 'Tallink & Silja Line -sovellus', eN: 'Muuga', CJ: 'Ei maissaoloaikaa kohteessa', CK: 'Ajoneuvoa ei voi ajaa ulos matkakohteessa.', CL: 'Valitulla matkalla ei ole tällä hetkellä lähtöjä. Muuta matkan valintaa.', CM: 'Valitettavasti varauksenne maksu epäonnistui. Yritäthän uudelleen. Jos et silti saa varausta tehtyä, soita myyntipalveluumme 010 804 133 (0,0835 €/puhelu + 0,167 €/min).', ol: 'Ei kiitos', CU: 'Käyttäessäsi tätä koodia ei hyvitysmahdollisuutta varauksesta. <a href=\"#\">Lue ehdot →</a>', CV: '<ul>\n<li>Laivamatkan suuntaa ja/tai reittiä, lähtöpäivää tai -aikaa ei ole sallittua muuttaa.</li>\n<li>Matkustajan henkilötietoja, hyttiluokkaa, ajoneuvoa ja laivapalveluja voidaan muuttaa. Tällöin tulee maksaa alkuperäisen ja muutetun palvelun välinen hinnan erotus.</li>\n<li>Jos matkustaja peruu varauksen, Tallink Silja Line pidättää 100 % lipun hinnasta.</li>\n<li>Kaikilta muilta osin noudatetaan <a target=\"_blank\" href=\"https://www.tallink.com/fi/hyva-tietaa/yleiset-matkaehdot\">AS Tallink Gruppin matkaehtoja</a>.</li>\n</ul>', CW: 'Ehdot', CX: 'Kyllä, hyväksyn.', CY: 'Poista koodi', CZ: 'Olet varaamassa matkaa, josta ei koodin {code} takia saa hyvitystä muutos- tai peruutustapauksissa. Matkustajan henkilötietoja, hyttiluokkaa ja palveluita voidaan kuitenkin muuttaa. Laivamatkan suuntaa ja/tai reittiä, lähtöpäivää tai -aikaa ei ole sallittua muuttaa. Ole hyvä ja vahvista, että olet ymmärtänyt ja hyväksynyt ehdot ennen maksun suorittamista.', C_: 'Ei hyvitysmahdollisuutta', eO: 'Pisteitä ei ole tarpeeksi', C0: 'Jatka varausta', C1: 'Aloita alusta', C2: 'Mikäli palaat taaksepäin, menetät tekemäsi valinnat ja joudut aloittamaan varauksesi alusta. Haluatko aloittaa alusta?', C3: 'Aloita alusta?', eP: 'Saapumissatama Tukholman sijasta on Kapellskärin satama (90 km Tukholmasta)', eQ: 'Lähtösatama Tukholman sijasta on Kapellskärin satama (90 km Tukholmasta)', eR: 'Lähtö- ja saapumissatama Tukholman sijasta on Kapellskärin satama (90 km Tukholmasta)', Da: 'Erikoisristeilyn lisäpalvelut', eS: 'Insurance', Db: 'FriendSHIP-seikkailupaketti', Dc: 'Lasten paketit', Dd: 'Priority boarding', De: 'Lisäpalvelut laivalla', Df: 'ostosrahakuponki', Dg: 'kuponki', Dh: 'Ostosraha', Di: 'paikka', Dj: 'Palvelu ei ole saatavilla välillä {route}', Dk: 'Yksi päivä', eT: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', Do: 'tai', Dp: 'Muut', eU: 'Muu maksutapa', eX: 'yli 12 v', eY: 'Paldiski', eZ: 'Pakettiauto parkkiin laivalle', DI: 'Bileet itämerellä', DJ: 'Itämeri - Tallinna', e_: 'Ikäkategoria ja syntymäaika eivät täsmää', DM: 'Väärä ikäryhmä – aikuiselle on syötettävä täysi-ikäisen syntymäaika.', DN: 'Väärä ikäryhmä – varmista, että syntymäaika vastaa aikuista tai nuorta.', DO: 'Tarkista, että syntymäaika on muodossa PP-KK-VVVV.', DP: 'Syötä tiedot numeroina', DQ: 'Syötä tiedot myöhemmin', DR: 'Tallenna', DS: 'Tarkista Club One -tiedot ja varmista, että ne ovat samassa muodossa kuin kortissasi. Tarvittaessa ota yhteyttä Online-tukeen <a href=\"tel:+35810804133\">010 80 41 33</a>', DT: 'Club One -numero', DU: 'on jo lisätty.', DV: 'Muuta tietoja tai', DW: 'aloita alusta', DX: 'Matkustusasiakirjan tiedot lisätään Club One-tietoihin.', DY: 'Asiakirjan myöntänyt maa *', DZ: 'Voimassa *', D_: 'Myönnetty *', D$: 'Asiakirjanumero *', D0: 'Matkustusasiakirja *', D1: 'Syntymämaa *', D2: 'Liikunta tai muu rajoite', D3: 'Mikäli tarvitset avustamispalvelun, voit tilata sen <a href=\"https://www.tallink.com/fi/hyva-tietaa/esteeton-matkailu\" target=\"_blank\">yhteydenottolomakkeella</a> tai soittamalla Myyntipalveluumme', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Lisää matkustaja', Ec: '<span class=\"data\">{count}</span> {count, plural, one{matkustaja} other{matkustajaa}} valittu', Ed: 'Lisää tiedot nyt tai myöhemmin', Ee: 'Matkustajatiedot lisätty', Ef: 'Matkustajat', e0: 'Tulossa pian!', e1: 'Varausnumerosi', e2: 'Luottokortti', e3: 'Poista', Ei: 'Maksu', e4: 'Valitse maksutapa:', Ej: 'Lasku', Ek: 'Laskutusosoite', e5: 'Maksa yrityslaskulla', El: 'Viitenumero', e6: 'Maksa myöhemmin', e7: 'Klarnan tarjoama vaivaton mobiilimaksu', e8: 'Maksamalla vahvistat varauksen.', e9: 'Pankki', fa: 'Operaattorisi veloittama matkapuhelinmaksu.', fb: 'Operaattorisi veloittama matkapuhelinmaksu.', fc: 'Hinta 0,85 €/vastattu puhelu + aina pvm/mpm.', fd: 'Hinta 0,0835 €/puhelu + 0,167 €/min.', fe: 'Operaattorisi veloittama matkapuhelinmaksu.', ff: 'Operaattorisi veloittama matkapuhelinmaksu.', fg: 'Operaattorisi veloittama matkapuhelinmaksu.', fh: 'Operaattorisi veloittama matkapuhelinmaksu.', fi: 'Operaattorisi veloittama matkapuhelinmaksu.', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Ota yhteyttä Online-tukeen', fk: 'Maksamattomat varaukset peruuntuvat automaattisesti.', fl: 'Maksun kanssa ilmeni ongelma. Voit yrittää uudelleen tai soittaa meille.', fm: 'Muokkaa <u>maa-asetuksia</u> alkuperäiseen markkina-alueeseen viimeistelläksesi maksusuorituksen.', fn: 'Varaus tehtiin eri markkina-alueella.', Ex: 'ja {points} pistettä', r0: 'henkilö', EA: 'henkilöä', EH: 'D-terminaali', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs', EM: 'Länsiterminaali 2', EN: 'Länsiterminaali 1', EO: 'Länsiterminaali 1', EP: 'Pietari', EQ: 'Maarianhamina', ER: 'Muugan satama', ES: 'Olympiaterminaali', ET: 'Paldiski', EU: 'Riian terminaali', EV: 'Sassnitz', EW: 'Turun satama', EY: 'Värtahamnen', EZ: 'Visby', E_: 'Ventspils', E$: 'Vuosaaren satama', E5: 'Esivalitut', E6: 'Osta matka', E7: 'Peruuta', E8: 'Jatka', E9: 'Valmis', fo: 'Jatka', Fa: 'Edullisin hytti:', Fb: 'Edullisin hytti (Club One):', Fc: 'Club One hinta', Fd: 'Ole hyvä ja lisää hytti', Fe: 'Näet matkan kokonaishinnan lisättyäsi hytin', fp: 'Valitse hytti voidaksesi jatkaa', Ff: 'Välisumma:', Fg: 'Yhteensä:', fq: 'Yhteensä (Club One):', Fh: 'Tarkistetaan hintaa...', Fj: 'Alkaen-hinta aikuiselle/ajoneuvolle sis. polttoaine- ja päästölisämaksut.', Fl: '{price} / kpl', sa: 'Jatka', fr: 'Jatka maksamaan', Fs: 'Tämä sivusto on suojattu reCAPTCHAlla ja\n<a target=\"_blank\" href=\"https://policies.google.com/privacy?hl=FI\">Googlen tietosuojakäytäntö</a> ja\n<a target=\"_blank\" href=\"https://policies.google.com/terms?hl=FI\">palveluehdot</a> ovat voimassa.', ft: 'Muutoksia laivan palveluissa:<br>\nPe-la-lähdöillä iloa viikonloppuun mm. livemusiikin ja bingon siivittämänä.<br>\nSu-to-lähdöillä supistetut palvelut.', fu: 'Normaalihinta:', Fy: 'Valitaksesi tämän ajan, poista edellinen valinta.', FA: 'Varausmaksu {fee} per henkilö vähennetään ravintolan laskusta laivalla.', FB: 'Varauksen maksua ei tarvitse maksaa alle 5-vuotiailta lapsilta.', sq: 'Sulje', FD: 'Jokin meni vikaan. Kokeile päivittää sivu tai aloita varaus alusta.', FE: 'Emme löytäneet tulevia lähtöjä.', fv: 'Aloita alusta', fw: 'Valitettavasti joudut aloittamaan varaamisen alusta. Pahoittelut vaivasta. Jo varaamasi palvelut peruuntuvat automaattisesti.', fx: 'Istuntosi on vanhentunut', FF: 'Aloita alusta', FG: 'Valitettavasti joudut aloittamaan alusta. Pahoittelut ylimääräisestä vaivasta.', FH: 'Varauksen kanssa ilmeni ongelma', fz: 'Riika', fA: 'Kaksi yötä laivalla <br>ja päivä Klaipedassa.', fB: 'Yksi suunta tai meno-paluu. <br>Lähtö klo 17:00.', fC: 'Tukholma-Turku-Turku-Tukholma(Kappellskär)', fD: 'Tukholma (Kappellskär)-Turku', fE: 'Tukholma(Kappellskär)-Turku-Turku-Tukholma', fF: 'Turku-Tukholma-Tukholma(Kappellskär)-Turku', fG: 'Turku-Tukholma(Kappellskär)', fH: 'Turku-Tukholma(Kappellskär)-Tukholma-Turku', fI: 'Takaisin pankkilistaukseen', fJ: 'Sadly we haven\'t found bank you were searching for. Try to find it in the list instead.', fK: 'Etsi', fL: 'Sassnitz', fN: 'Ole hyvä ja valitse vähintään 1 ajoneuvo', Ge: 'Auton lisääminen <b>poistaa {service}</b> -palvelun. Oletko varma, että haluat jatkaa?', Gf: 'Oletko varma?', Gv: '5 h -ostosristeily', Gw: 'Tee kaikki ostokset vaivattomasti kerralla! Viisi tuntia kestävän risteilyn aikana ei ole maissa käyntiä, paluu Tallinnasta on välittömästi seuraavalla laivavuorolla. Kun ostosten määrä on suurempi, kannattaa matkaan lähteä autolla. Ostaessasi enemmän saat myös ostohyvityksen. MyStarilla ja Megastarilla saat auton kätevästi ostosparkkiin aivan Traveller Superstore -myymälän viereen kannelle 7, jolloin autossa voi vierailla risteilyn aikana.', Gy: 'Paluuaika koskee 5 h -risteilyä. Sinut ohjataan oikealle sivulle.', fO: 'Kivointa aikaa itsellesi', GE: 'Starlight-pöytävaraus', fP: 'Saarenmaa', GK: '15–17-vuotias voi matkustaa ilman aikuista. Muista ottaa <a href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\" target=\"_blank\">matkustuslupa</a> mukaasi. Turvallista matkaa!', fQ: 'Pietari', GQ: 'Alkuruoka', fR: 'Tukholma', GY: 'Lähtö Tukholmasta', GZ: 'Tallinnasta Tukholmaan ei ole kyseisenä päivänä suoraa yhteyttä, mutta voit matkustaa Helsingin kautta.', G_: 'Huom! Sinun täytyy siirtyä Länsiterminaali 2:sta Olympiaterminaaliin vaihtaaksesi laivaa.', G$: 'Tukholma -> Tallinna <br/> Helsingin kautta', fS: 'Huomioithan, että alkoholin anniskeluaikoja on rajoitettu.', fT: 'Kaksi yötä merellä, yksi päivä Visbyssä. Tänä kesänä Silja Symphony tekee risteilyitä Tukholmasta Visbyhyn.', fU: 'Kaksi yötä merellä, yksi yö laivalla Visbyssä ja kaksi kokonaista päivää tutustua Gotlantiin. Tee myös ostoksia myymälöissämme, tax free -ostoksia voit tehdä koko matkan ajan.', fV: 'Tukholma (Kappellskär)', fW: 'Kolme yötä merellä, yksi päivä Ystadissa ja yksi päivä Visbyssä.', fX: 'lisämaksu', fY: 'Tallinna', G8: 'Tallinna - Itämeri', fZ: 'Tallinna - Itämeri - Tallinna', f_: 'Kaksi yötä laivalla <br>ja päivä Riiassa.', G9: 'Lähtö Tallinnasta', Ha: 'Tallinnasta Tukholmaan ei ole suoraa yhteyttä kyseisenä päivänä, mutta voit matkustaa Helsinkiin ja jatkaa matkaa laivalla sieltä.', Hb: 'Huom! Sinun täytyy siirtyä Länsiterminaali 2:sta Olympiaterminaaliin vaihtaaksesi laivaa. <b>Jos valitset klo 13.30 lähdön, et välttämättä ehdi siirtymään käyttäen julkista liikennettä.</b>', Hc: 'Tallinna -> Tukholma <br/> Helsingin kautta', f$: 'Kaksi yötä laivalla<br>ja päivä Turussa.', f0: 'Yksi suunta tai meno-paluu.<br>Lähdöt päivittäin.', f1: 'Visby-risteilyt Tallinnasta', f2: 'Kesän erikoisristeilyt taianomaiselle Gotlannin saarelle', tb: 'Kiitos tiedosta!', td: 'Lisää paluu', f3: 'Varaa myös paluumatka, jolloin saat sen edullisemmin', f4: 'Valitsemasi meno ja paluu ovat samana päivänä, saat edullisen saaristoristeilyhinnan.', o6: 'Perillä', f5: 'Haluatko matkustaa myöhäisempänä ajankohtana?', f6: 'Valitse lähtöpäivä matkalle {direction}', f7: 'Poista valinta', Hx: 'Valitse päivä', f8: '23 h -risteily (iltalähtö)', f9: '23 h -risteily (aamulähtö)', ga: 'Päivä Tukholmassa -risteily', gb: 'Päivä Turussa -risteily', o7: 'Lähtö', Hy: 'Iltalähtö', Hz: 'Aamulähtö', te: 'Kesto', tf: 'h', HA: 'Ensimmäinen yö Victorialla, maihinnousu seuraavana aamuna klo 8.00-11.00.', HB: 'Risteily + hotellimatka', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'Ei saatavilla', gc: 'Poista paluumatka', gd: 'Megastarin 5 h -risteily', ge: 'Sulje', gf: 'Välitön paluu samalla laivalla sisältää automaattisesti alennetun 5 h -risteilyhinnan matkustajille ja autolle. Matkalla ei ole pääsyä maihin.', gg: 'Megastarin 5 h -risteily', gh: 'Matkusta yön yli laivalla ja vietä 4 tuntia Tallinnassa', gi: 'Lähtö illalla Tukholmasta, ei maihinnousua', gj: 'Lähtö aamulla Tukholmasta, ei maihinnousua', gk: 'Vietä kaksi yötä laivalla ja yksi päivä Turussa', gl: 'Lähtö illalla Turusta, ei maihinnousua', gm: 'Lähtö aamulla Turusta, ei maihinnousua', gn: 'Menopaluumatka Helsinki - Tukholma - Helsinki', go: 'Yhdensuuntainen matka Helsingistä Tukholmaan', gp: 'Menopaluumatka Helsinki - Tallinna - Helsinki', gq: 'Päiväristeily Helsingistä Tallinnaan', gr: 'Yhdensuuntainen matka Helsingistä Tallinnaan', gs: 'Megastarin 5 h -risteily', gt: 'Menopaluumatka Riika - Tukholma - Riika', gu: 'Yhdensuuntainen matka Riiasta Tukholmaan', gv: 'Menopaluumatka Tukholma - Helsinki - Tukholma', gw: 'Yhdensuuntainen matka Tukholmasta Helsinkiin', gx: 'Menopaluumatka Tukholma - Riika - Tukholma', gy: 'Yhdensuuntainen matka Tukholmasta Riikaan', gz: 'Menopaluumatka Tukholma - Tallinna - Tukholma', gA: 'Yhdensuuntainen matka Tukholmasta Tallinnaan', gB: 'Menopaluumatka Tukholma - Turku - Tukholma', gC: 'Yhdensuuntainen matka Tukholmasta Turkuun', gD: 'Menopaluumatka Tallinna - Helsinki - Tallinna', gE: 'Päivämatka Helsinkiin', gF: 'Yhdensuuntainen matka Tallinnasta Helsinkiin', gG: 'Menopaluumatka Tallinna - Tukholma - Tallinna', gH: 'Yhdensuuntainen matka Tallinnasta Tukholmaan', gI: 'Menopaluumatka Turku - Tukholma - Turku', gJ: 'Yhdensuuntainen matka Turusta Tukholmaan', HH: 'Hotellimatka', tg: 'Risteily', gK: 'Päivä Helsingissä -risteily Ahvenanmaalta', gL: 'Päivä Tallinnassa -risteily Ahvenanmaalta', gM: 'Päivä Ahvenanmaalla -risteily Helsingistä', gN: 'Päivä Tukholmassa -risteily Helsingistä', gO: '22 h -risteily', gP: '9 h -risteily', gQ: 'Päivä Tukholmassa -risteily Riiasta', gR: 'Risteilyt', gS: 'Päivä Ahvenanmaalla -risteily Tallinnasta', gT: 'Risteily Helsinkiin', gU: 'Päivä Tukholmassa -risteily', gV: '22 h -risteily', gW: 'Risteilyt', gX: 'Risteily kahteen kohteeseen', gY: 'Piilota tiedot &uarr;', gZ: 'Näytä lisää &darr;', g_: 'Reittimatka / päiväristeily', le: 'Minne', g$: 'Varauksella tulee olla vähintään 1 aikuinen. Aikuinen matkustaja on lisätty varaukseen.', g0: 'Laivan ostosparkki korvattiin Priority Car -autopaikalla, joka sisältyy Business Lounge -matkustusluokkaan.', g1: 'Priority Car -autopaikka sisältyy Business Lounge -matkustusluokkaan', g2: 'Valitsemaasi matkustusluokkaa ei ole enää saatavilla. Ole hyvä ja valitse toinen matkustusluokka.', HP: 'Rekisteritunnus on valmiiksi esitäytetty', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Bussikuljetus on täynnä kyseisenä matkustuspäivänä.', g5: 'Bussikuljetuksia ei ole saatavilla valitulle matkalle.', HQ: 'Hei, {name}!', g6: 'Varataksesi matkan Club One -pisteillä, tarvitset {clubOnePoints} pistettä.', g7: 'Edellisen henkilön matkustajatietoja puuttuu. Ole hyvä ja tarkista, että kaikki kentät on täytetty.', g8: 'Ei internet-yhteyttä, joten tietoja ei voitu tallentaa. Tarkista yhteys ja yritä uudelleen.', g9: 'Matkustajatietoja puuttuu. Ole hyvä ja täydennä puuttuvat tiedot.', HR: 'Kuljetusta ei ole lisätty kaikille matkustajille', HS: 'Jokaisessa huoneessa on oltava vähintään yksi aikuinen.', ha: 'Valitaksesi tämän aterian, poista edellinen valinta.', HU: 'Matkalla tulee olla vähintään 1 aikuinen.', hb: 'Tarkista verkkoyhteytesi ja yritä uudelleen', hc: 'Matkustajan ikäryhmäksi päivitettiin \"{new}\"', hd: 'Poistit varaukselta matkustajia, joten poistimme varaukselta yhden valitsemistasi hyteistä', he: 'Club One -asiakas {name} lisätty varaukselle!', hf: 'Et voi lisätä varaukselle enempää matkustajia', hg: 'Valitsemasi ruokailut lisättiin automaattisesti myös uusille matkustajille', hh: 'Valitsemasi ruokailut poistettiin automaattisesti varaukselta poistetuilta matkustajilta', hi: 'Ajoneuvo jouduttiin poistamaan kun matkustajia vähennettiin. Vähintään yksi aikuinen per ajoneuvo.', hj: 'Huom! Aiemmin tehdyt valinnat on poistettu. Ole hyvä ja tee matkustajamäärän valinta uudelleen lisäämällä korkeintaan 5 matkustajaa tälle reitille ja varaukselle.', hk: 'Saat edullisen päivämatkahinnan!', hl: 'Lähtöjä haettaessa tapahtui virhe.', hm: 'Yöpyminen laivalla', hn: 'Saat edullisen Päivä Turussa -risteilyhinnan!', ho: 'Saat edullisen Päivä Tukholmassa -risteilyhinnan!', HV: 'Huomioi pitkä odotusaika Tukholmassa.', hp: 'Lisäsit viimeisen vapaan hytin luokasta \"{name}\"', hq: 'Olet jo lisännyt maksimimäärän hyttejä. Jokaisessa hytissä on oltava vähintään yksi aikuinen.', hr: 'Matkustusluokka \"{name}\" on loppuunmyyty.', hs: 'Lisäsit viimeisen vapaan ajoneuvopaikan.', ht: 'Olet lisännyt maksimimäärän ajoneuvoja. 1 ajoneuvo per aikuinen sallittu.', hu: 'Ajoneuvoa ei voi ajaa maihin Tallinnassa', hv: 'Ajoneuvo on mahdollista varata vain menomatkalle.', hw: 'Ajoneuvo on mahdollista varata vain paluumatkalle.', hx: 'Valitsemasi ajoneuvo ei varattavissa tälle lähdölle.', hy: 'Lisää eläin', hz: 'Allergiahytit', hA: 'häkki', hB: 'häkkiä', hC: 'Invahytit', hD: 'hytti', hE: 'hyttiä', hF: 'Matkalla tulee olla vähintään 1 aikuinen hyttiä kohti', H1: 'Täynnä', hG: 'Vain {capacity} hengen hyttejä jäljellä', hH: 'Vain {capacity} hengen hyttejä jäljellä {from}-{to}', hI: 'Lemmikin kanssa matkustaminen', hJ: 'Lue lisää', hK: 'Paikat jaetuista hyteistä', hL: 'naispaikka', hM: 'miespaikka', hN: '{name}, {genderPlace} {maxOccupancy}-hengen hytistä', hO: '{price} / hytti', tm: '{price} / hlö', hP: 'Matkustusluokka', hQ: 'Erikoishytit', H2: 'Hytit', hR: 'eläin', hS: 'eläintä', hT: 'Lemmikit', hU: 'Spend two nights onboard Silja Symphony or Silja Serenade. Explore Stockholm for around 6 hours. Return with the same ship in the same cabin you arrived in.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', hV: '22 hour mini cruise onboard the newly renovated Europa. Departure daily from Helsinki to Tallinn at 18:30.\n4 hours onshore in Tallinn during the next day (08:00 -12:10).', hW: 'Spend two nights onboard Romantika or Isabelle. Explore Stockholm for around 6 hours. Return with the same ship in the same cabin you arrived in.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', hX: 'Departure at 07:10 from Stockholm. Sail onboard Baltic Princess to Åland where you will change ship to Galaxy. Arrival back in Stockholm at around 18:15.', hY: 'Spend two nights onboard Silja Symphony or Silja Serenade. Explore Helsinki for around 7 hours. Return with the same ship in the same cabin you arrived in. Total length of the trip is 40 hours.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', hZ: 'Spend two nights onboard Romantika or Isabelle. Explore Riga for around 6 hours. Return with the same ship in the same cabin you arrived in. Total length of the trip is 40 hours.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h_: 'Spend two nights onboard Baltic Queen or Victoria I. Explore Tallinn for around 7 hours. Total length of the trip is 40 hours.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', h$: 'Departure at 19:30 from Stockholm. Spend one night onboard Galaxy. No ashore time in Turku. Return to Stockholm the next day.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h0: 'Spend two nights onboard Baltic Queen or Victoria I. Explore Stockholm for around 7 hours.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', h1: 'Departure at 08:15 from Turku. Sail onboard Galaxy to Åland where you will change ship to Baltic Princess. Arrival back in Turku at around 19:15.', h2: 'Departure at 20:15 from Turku. Spend one night onboard Baltic Princess. No ashore time in Stockholm. Return to Turku the next day.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h3: 'Travel to Åland with Silja Serenade or Silja Symphony.', h4: 'Spend the night onboard Silja Symphony or Silja Serenade. Arrival in Stockholm the next morning. Book either a one-way or return trip.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', h5: 'Matkusta mukavasti ja nopeasti Helsingistä Tallinnaan. Päivässä useita lähtöjä, joista valita itselle se sopivin.', h6: 'Matkusta saman päivän aikana mukavasti ja nopeasti Helsingistä Tallinnaan ja takaisin.', h7: 'Kaksi päivittäistä lähtöä Helsingistä: klo 10.30 ja 16.30. Viisi tuntia kestävän risteilyn aikana ei ole maissakäyntiä, paluu Tallinnasta on välittömästi seuraavalla laivavuorolla. \nKun ostosten määrä on suurempi, kannattaa matkaan lähteä autolla. Ostaessasi enemmän saat myös ostohyvityksen. Auton saat kätevästi ostosparkkiin aivan Traveller Superstore -myymälän viereen kannelle 7.', h8: 'Spend the night onboard Romantika or Isabelle. Arrival in Stockholm the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', h9: '4 daily departures to Åland. Travel onboard Baltic Princess, Galaxy, Silja Serenade, Silja Symphony, Victoria I or Baltic Queen.', ia: 'Spend the night onboard Silja Symphony or Silja Serenade. Arrival in Helsinki the next morning. Book either a one-way or return trip.\nExperience fantastic entertainment and make cheap tax-free purchases. Enjoy the diverse and delicious meal at the onboard restaurants.', ib: 'Spend the night onboard Romantika or Isabelle. Arrival in Riga the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', ic: 'Spend the night onboard Baltic Queen or Victoria I. Arrival in Tallinn the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', id: 'Spend half a day or one night onboard Baltic Princess or Galaxy.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', ie: 'Travel to Åland with Baltic Queen or Victoria I.', $8: 'Multiple departures per day from Tallinn D-terminal. Travel comfortably and quickly. Duration onboard Star and Megastar is only 2 hours, and onboard Victoria I 3,5 hours.', ig: 'Travel daily between Helsinki West Terminal 2 to Helsinki fast and conveniently with Tallink Shuttle ships Star and Megastar Only 2 hours per way.', ih: 'Spend the night onboard Baltic Queen or Victoria I. Arrival in Stockholm the next morning. Book either a one-way or return trip.\nDine well, shop with cheap tax-free prices and unwind in the sauna or the Jacuzzi in the relaxation area. In addition, you can enjoy the nightly entertainment.', ii: 'Travel to Åland with Baltic Princess or Galaxy.', ij: 'Spend half a day or one night onboard Baltic Princess or Galaxy.\nDine well, shop with cheap tax-free prices and enjoy the nightly entertainment.', ik: 'Kaksi yötä laivalla ja päivä Helsingissä Ahvenanmaalta', il: 'Kaksi yötä laivalla ja päivä Tallinnassa Ahvenanmaalta', im: 'Kaksi yötä laivalla ja päivä Ahvenanmaalla Helsingistä', $9: '22 h -risteily Tallinnaan.', io: 'Rentouttava miniloma merellä', ip: 'Risteily Ahvenanmaalle ja takaisin. Ei maihinnousua.', iq: 'Kaksi yötä laivalla <br>ja päivä Helsingissä.', ir: 'Kaksi yötä laivalla <br>ja päivä Riiassa.', is: 'Kaksi yötä laivalla <br>ja päivä Tallinnassa.', it: 'Lähtö illalla Tukholmasta. <br>Ei maihinnousua Turussa.', iu: '23 h -risteilyt Turusta (ei maihinnousua Tukholmassa)', iv: '11 h -risteily aamulla Turusta.<br>Laivanvaihto Ahvenanmaalla.', iw: 'Lähtö illalla Turusta. <br>Ei maihinnousua Kapellskärissa.', ix: '23 h -risteilyt Turusta (ei maihinnousua Tukholmassa)', iy: 'Lähtö aamulla Turusta. <br>Ei maihinnousua Tukholmassa.', iz: 'Yksi suunta tai meno-paluu Ahvenanmaalta ja Helsingistä.', iA: 'Yksi suunta tai meno-paluu.', iB: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin Ahvenanmaalta.', iC: 'Yksi suunta tai meno-paluu. <br>Useita lähtöjä päivässä.', iD: 'Yksi suunta tai meno-paluu Ahvenanmaalta ja Tallinnasta.', iE: 'Yksi suunta tai meno-paluu.', iF: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iG: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iH: 'Kun meno ja paluu on samana päivänä, <br>saat edullisen päivämatkahinnan.', iI: 'Yksi suunta tai meno-paluu.<br>', iJ: '5 h -risteily Megastarilla. <br>Matkusta auton kanssa tai ilman.', iK: 'Yksi suunta tai meno-paluu.', iL: 'Yksi suunta tai meno-paluu.', iM: 'Yksi suunta tai meno-paluu Sea Windillä. <br>Kaksi lähtöä päivässä.', iN: 'Yksi suunta tai meno-paluu.<br>Lähdöt päivittäin Riiasta.', iO: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iP: 'Yksi suunta tai meno-paluu. <br>Useita lähtöjä päivässä.', iQ: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iR: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iS: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iT: 'Yksi suunta tai meno-paluu.', iU: 'Yksi suunta tai meno-paluu. <br>Lähtö klo 18:00.', iV: 'Yksi suunta tai meno-paluu.<br>', iW: 'Meno ja paluu samana päivänä. <br>Saat edullisen päivämatkahinnan.', iX: 'Yksi suunta tai meno-paluu. <br>Lähdöt päivittäin.', iY: 'Yksi suunta tai meno-paluu.', iZ: 'Yksi suunta tai meno-paluu.', i_: 'Yksi suunta tai meno-paluu.', i$: 'Yksi suunta tai meno-paluu Sea Windillä. <br>Kaksi lähtöä päivässä.', i0: 'Turku', i1: 'Kaksi yötä laivalla<br>ja päivä Tallinnassa.', i2: 'Yksi suunta tai meno-paluu.<br>Lähdöt päivittäin.', H3: 'Kaksi päivää', i3: 'Kaksi yötä merellä, kaksi päivää Härnösandissa. Yö laivalla Härnösandissa ja kaksi päivää aikaa tutustua nähtävyyksiin. Tee myös ostoksia myymälöissämme, tax free -ostoksia voit tehdä koko matkan ajan.', i4: 'Kaksi yötä merellä, kaksi päivää Helsingissä. Yö laivalla Helsingissä ja kaksi päivää aikaa tutustua Suomeen. Tee myös ostoksia myymälöissämme, tax free -ostoksia voit tehdä koko matkan ajan.', i5: 'Kaksi yötä laivalla ja päivä Ahvenanmaalla', i6: 'Kaksi yötä laivalla ja päivä Härnösandissa', i7: 'Vietä kaksi yötä laivalla ja yksi päivä Helsingissä', i8: 'Vietä kaksi yötä laivalla ja yksi päivä Riiassa', i9: 'Kaksi yötä laivalla ja päivä Saarenmaalla', ja: 'Vietä kaksi yötä laivalla ja yksi päivä Tukholmassa', jb: 'Vietä kaksi yötä laivalla ja yksi päivä Tallinnassa', H7: 'Käytä alennuskoodia', jc: 'Ajoneuvon päästölisämaksu', jd: 'Ajoneuvon päästölisämaksu koskee varauksen ajoneuvoa', Id: 'Ajoneuvon polttoaine- ja päästölisämaksu', Ie: 'Ajoneuvon polttoaine- ja päästölisämaksu koskee varauksen ajoneuvoa', je: 'Maks. 1,5 m korkea ja maks. 3,0 m pitkä', jf: 'Maks. 1,9 m korkea ja maks. 5,0 m pitkä', jg: 'Lisää ostosparkkipaikka kätevästi Traveller Superstore -myymälän viereen &rarr;', jh: 'Nouse maihin ensimmäisten joukossa laivan saavuttua satamaan. Lisää Priority Car -autopaikka &rarr;', ji: 'Yli 2,4 m korkea ja maks. 8,0 m pitkä', jj: 'm', jk: 'Maks. 1,9 m korkea ja maks. 5,0 m pitkä. \nAutoa ei voi ajaa ulos määräsatamassa.', jl: 'Ole hyvä ja lisää rekisteritunnus kaikille ajoneuvoille', Ii: 'Poista', jm: 'Valitse ajoneuvo edelliseltä matkalta:', jn: 'Maks. 2,3 m korkea ja maks. 7,0 m pitkä', jo: 'Maks. 1,9 m korkea ja maks. 12,0 m pitkä', jp: 'Perävaunun rekisteritunnus', jq: 'Rekisteritunnus ei saa sisältää erikoismerkkejä', jr: 'Maks. 2,4 m korkea ja maks. 7,0 m pitkä', js: 'Ajoneuvon tietoja puuttuu', jt: 'Ajoneuvon rekisteritunnus', ju: 'Ajoneuvoja lisätty:', jv: 'Tarkistetaan saatavuutta...', Il: 'Matkusta Helsingin kautta', jw: 'Visby', jx: 'Ystad/Visby', jy: 'Ventspils', Ip: 'Alennuskuponki:', Iq: 'Kirjaudu Club One -tililläsi nähdäksesi tarjouksen saatavuuden.', Ir: 'Lahjakortti on jo lisätty.', Is: 'Lahjakortti on vanhentunut.', It: 'Lahjakortilla on eri valuuttaa.', Iu: 'Lahjakortilla ei ole arvoa.', jz: 'Vuosaari', IA: 'Risteily', IC: 'wow', tE: '11 h -saaristoristeily', jA: 'Ystad'};
var $author$project$Translations$Generated$ja = {P: 'Read our accessibility statement', Q: 'https://www.tallink.com/en/accessibility', tJ: '追加', R: '別コードを入力', S: '車両を追加するには、大人のお客様の追加が必要です。自転車のご予約は、6～17歳のお子様でも可能です。', tK: 'ご乗船者全員へ客室を追加してください', pl: '座席を追加', tM: 'こちらの運航ルート {route} は車両のご予約が必要です', tN: '{route} 運航ルートへ車両を追加しますか？', tO: '運航ルートを追加しますか？', T: 'オーランド諸島', t_: 'オーランド諸島（ローングネース）', t$: 'オーランド諸島（マリエハムン）', ue: '既に別ホテルにて客室を選択済みです。こちらの客室を選択するには、まず選択済みの項目を削除してください。', uj: 'クルーズ', ul: 'モバイル版で予約を続ける', um: 'デスクトップ版へ変更', un: 'デスクトップ版で続ける場合、以下の情報の再入力が必要となります : <span class=\"bodyBold\">ご乗船者の情報、キャビンクラス、お食事</span>', uo: '全項目の保存はできません', up: 'デスクトップ版で続ける場合、以下の情報の再入力が必要となります : <span class=\"bodyBold\">ご乗船者の情報、お食事</span>', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Bank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'インターネットバンキング', aa: '銀行を選択し続ける', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click ログインまたは携帯電話番号を入力', ah: '最後に選択した項目', ai: 'Säästöpankki', aj: 'SEB', ak: '銀行を選択 :', al: 'S-Pankki', am: 'Swedbank', uB: '食事を予約する', uC: 'これらの旅は別途予約する', uD: '船内サービスを追加', uE: 'デスクトップ版へ移動 &rarr;', uF: 'その他のサービスをお探しですか ?', uG: 'シャトルバスサービスを追加', uH: 'ターミナル発着', uI: '法人IDご利用の予約はこちら', ao: '簡単ご予約＆お得な割引価格！', ap: 'ログアウト &rarr;', uJ: 'サインイン', aq: 'お客様はクラブワン会員ですか？', ar: 'ご予約可能な日を表示', uK: 'ご選択日では割引コードが利用できません。申し訳ございませんが、他の運航日または他の運航ルートやトラベルクラスでお試しください。', as: 'コードを再確認し、もう一度やり直してください', uL: 'キャンセル', at: '予約コードが入力されました', au: '正しいコードが入力されました', uM: '入力コードをもう一度お確めください。同入力コードを続けてご使用された場合は一時的にロックされた可能性があります。申し訳ございませんが、約20分後にやり直してください。', av: 'ご入力コードがロックされた場合は、大変申し訳ございませんが、約30分後にもう一度やり直してください', aw: '割引価格となりました！', ax: '割引コード', ay: '入力コードは選択日ではご利用いただけません', az: '別の出発日ではご利用いただけます', aA: '通常価格 {oldPrice} から{discountedPrice} へ変更されました', aB: '通常価格 {oldPrice} から{discountedPrice} へ割引されました', aC: '削除', uN: '正しいコードが入力されました。キャビンタイプのご選択後、割引が適用されます。', uO: 'ギフトカードをご利用する場合は、弊社お客様サポートへご連絡ください : +49(0)40 547 541 222', aD: '割引コードが適用されました', aE: '割引コードを入力', aF: 'ポイント', uP: '追加サービスを予約', aG: '優先乗船', aH: 'ガレージ', aI: '保険', uQ: '自信を持って計画を立てる', aJ: 'プライオリティ・サービス（車両）', uR: '出発地を選択', uS: '目的地を選択', aK: 'ご予約', uT: '22時間の往復クルーズ', uU: 'Cruises', uV: 'Cruises', uW: 'タリンでの滞在時間はありません', py: 'タリンでの滞在時間はありません', uX: 'ヘルシンキ日中滞在の往復クルーズ', uY: 'リガ日中滞在の往復クルーズ', uZ: 'ストックホルム日中滞在の往復クルーズ', u_: '出発日', u$: '重要 : こちらの運航船内では、お体の不自由な方がご利用できる施設・サービスに制限がございます。', aL: 'こちらのクルーズでは下船はできません', u0: '復路日', u1: '片道', u2: '往復', aM: 'メガスター号の5時間クルーズ', u3: '片道', u4: '往復', ne: 'ご旅行内容', aN: 'ご旅行タイプ', aO: '英語', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'ご使用言語を選択', aV: '日本語', aW: '使用言語を変更しますか？', u5: 'お食事を選択', aX: 'お食事は船内にてご予約できます', u6: 'お食事はご利用できません', u7: '事前予約にて、ご利用料金が約10％もお得に！', u8: 'お食事', aY: '割引コードを入力', u9: '追加サービス', aZ: 'こちらの運航便では車両1台のご予約が必要です。', va: 'Covid-19', a_: 'Covid-19 検査', vb: 'キッズ リストバンド', vc: 'マッサージ', vd: 'ご乗船者', ve: 'クラブワン会員へ入会 &rarr;', vf: 'https://clubone.tallink.com/ja/join', vg: 'サインアウト &rarr;', vh: 'クラブワン会員様はこちらからお得に予約', a$: 'キャビンを選択', vi: 'トラベルクラス', vj: 'キャビン', a0: '自転車｜電動キックボード', a1: '乗用車', a2: '乗用車', vl: '車両を選択', vm: '車両のナンバープレートをご入力', a3: '料金を確認中', a4: 'オートバイ', a5: 'サイドカー付きバイク', a6: '乗用車（船内駐車）', a7: '車両のナンバープレートはご入力済み', a8: '乗用車（船内駐車）', a9: 'バン（船内駐車）', ba: 'すべて表示', bb: 'バン', bc: '大型バン', bd: '非常に長くて高い車両', be: '乗用車＆トレーラー', bf: '乗用車＆トレーラー', bg: '乗用車＆トレーラー', vB: 'シャトルバスサービスを\nさらに追加', bh: 'キャビンサービスを追加', bi: 'フリーギフト', bj: '{count}つのサービス追加済', bk: '{count}つのサービス追加済', vC: 'さらに表示', bl: '前の項目を表示', bm: '旅行日程', vD: '特別クルーズ', bn: '重要！', vE: '最安値 {price}', vF: 'ご利用不可', vG: '選択された日付の出発はありません。', bo: '料金 : スウェーデン・クローナ表記', bp: '最安キャビン {price} ポイント', bq: '最低 {price} ポイント / 人', br: '最安値 {price} / 人', bs: '最安キャビン {price}', bt: 'キャンセル', bu: '続ける', bv: 'このまま続けるとご選択済みのキャビン情報が削除されます。（※ご乗船者の情報はそのまま残ります。）', bw: '選択日ではご希望のキャビンクラスは満室です', vH: '特別<br/>クルーズ', vI: '最安車両 {price}', bx: '完売', by: 'CO2排出追加料金', bz: '6歳以上のお客様にCO2排出追加料金が適用されます。', bA: 'CO2排出追加料金は、欧州連合域内排出量取引システムで定められている費用を埋め合わせ、気候変動対策を支えるための追加料金です。', vQ: '{chars} 文字（英数字）まで', vR: 'チェックイン :', vS: 'チェックアウト :', vW: '選択 &rarr;', vX: '客室タイプを選択', vY: 'ホテルをご選択後、ご利用料金を確認できます', v3: '削除後こちらを選択', bB: 'ボロンズレベル', bC: 'クラブレベル', wd: 'Club one discount:', bD: 'ゴールドレベル', bE: '無効なクラブワン', bF: 'クラブワン会員番号', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=クラブワン会員アカウントの再有効化\">international.sales@tallinksilja.com\n </a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=クラブワン会員アカウントの再有効化\">clubone@tallink.ee\n </a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=クラブワン会員アカウントの再有効化\">ClubOne@tallinksilja.com\n </a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=クラブワン会員アカウントの再有効化\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=クラブワン会員アカウントの再有効化\">tallinksilja@tallinksilja.no\n </a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=クラブワン会員アカウントの再有効化\">clubone@tallink.ee\n </a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=クラブワン会員アカウントの再有効化\">ClubOne.Sweden@tallinksilja.com\n </a>', bN: 'メールアドレス :', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=クラブワン会員アカウントの再有効化\">international.sales@tallinksilja.com\n </a>', bP: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">クラブワン会員のアカウントが無効です。弊社お客様サポートまでご連絡ください。\n </a>', bQ: 'クラブワン会員のアカウントが無効です。弊社お客様サポートまでご連絡ください :', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">+358 10 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: '電話番号 :', b_: 'プラチナレベル', wg: 'クラブワンに<a>サインイン</a> もしくは <a>ご登録</a>いただくことで、ポイントを集めたり、よりお得な値段で簡単にご予約いただくことができます。', b$: 'シルバーレベル', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'ご利用いただける最大ポイント数はご予約されようとしているアイテムやサービスによって変動します。', wj: 'クラブワン保有ポイントを利用する。', wk: 'このバウチャーコードではクラブワンポイントはご利用いただけません。', wl: 'クラブワンポイントが不足しています。', b0: '<a>下のスライド</a>からお支払いに充てるクラブワンポイント数をご指定いただけます。', wm: 'クラブワンポイントはご利用いただけません。 ({理由})', pQ: 'コード', wp: 'ご入力には半角英字をご使用ください。', wr: '生年月日', ws: '日', wt: '月', wu: '年（西暦）', wv: '{count} {count, plural, one{大人} other{大人}}', ww: '({range} 歳)', wx: '到着時刻 {time}', pT: '{count} {count, plural, one{子供} other{子供}}', wy: '無料', wz: '閉じる', wA: '詳細', wB: '国籍', wC: 'ご利用者多数', b1: 'こちらの料金はクラブワン{level} 会員割引後の価格です', wD: 'ご乗船者の情報は今すぐまたは後からでもご入力できます。ただし、クラブワン会員情報は必ずご予約の完了前に入力してください。', b2: 'ポイント', b3: 'クラブワン会員のポイントを使用', b4: '近日中に開始', wE: 'クラブワン会員番号を事前に入力', wF: '完了', wG: '変更 &rarr;', b5: 'ご乗船されるお客様全員の電話番号とメールアドレスを入力すると、より簡単にチェックイン、または同予約グループ内での搭乗券やご予約情報のシェアが簡単になります', wH: '名', wI: '性別', wJ: '女性', wK: '男性', wL: '料金に含む', mh: 'ご入力内容を確認してください', wM: '入力されたメールアドレスは連絡人またはその他のご乗船者のアドレスです', wN: '入力された電話番号は連絡人またはその他のご乗船者の番号です', wO: '姓', wP: '* が付いた項目は必須入力です', wQ: 'ご朝食', wR: 'ブランチ', wS: 'ビュッフェ', wT: 'ディナー', wU: 'ランチ', wV: 'テーブル席のみご予約', wW: 'ご乗船後、船内にてお食事をご予約いただけます。', wX: '入力には半角英字をご使用ください', wY: 'ご利用不可', b6: 'こちらの旅行ではご利用できません', wZ: '不要', b7: '大人\n 18+', b8: '子供\n 0-5', b9: '子供\n 6-11', ca: '子供\n12-17', cb: 'ネットバンク', w_: 'お支払い : {price}', cc: 'お支払い中 {price}', cd: 'カード', w$: 'ご予約を確定 {price}', w0: '予約中 {price}', ce: 'Klarnaにて支払い {price}', cf: 'お支払い中…', w1: '<p>旅行サービス全般は欧州指令（EU Directive） 2015/2302に基づくものとします。</p>\n<p>つまり、欧州連合の定める消費者権利が旅行パッケージに適用されることになります。AS Tallink Grupp はパッケージ全般の実現に責任を負うものとします。</p>\n<p> 尚、AS Tallink Grupp は、法律に従い旅費の返金、または必要時には帰還の責任を負うこととします。</p>\n<p><a href=\"https://www.tallink.com/good-to-know/package-travel\" target=\"_blank\">旅行パッケージの規約について</a></p>', pU: '<p>旅行サービス全般は欧州指令（EU Directive） 2015/2302に基づくものとします。</p>\n<p>お客様は旅行に関わるEU全権を有し、{name}様はそれに関わる全責任を負うものとします。</p>\n<p>また必要時には、{name}様へ法律に従い旅費の返金を行い、帰還の責任も負うこととする。</p>\n<a href=\"{url}\" target=\"\"_blank\"\">旅行パッケージに関する規定を確認</a>', w2: 'お支払いを確定した場合、次の規則へ同意いただくものとします : <a href=\"https://www.tallink.com/good-to-know/rights-of-passengers\" target=\"_blank\">旅行に関わる規則・規定</a>クラブワン会員規約<a href=\"https://www.tallink.com/good-to-know/club-one\" target=\"_blank\"></a>', w3: 'お支払いを確定した場合、次の運送約款へ同意いただくものとします : <a href=\"https://www.tallink.com/good-to-know/payment-and-cancellation-policies\" target=\"_blank\">運送約款｜個人のお客様</a>', w4: 'ASタリンクグループ', w5: 'https://www.tallinksilja.com/packaged-tours-tallink-grupp', w6: 'タリンク・シリヤ', w7: 'https://en.tallink.com/packaged-tours-tallink-silja', w8: '18歳以下のお客様は必ずご確認ください : <a href=\"https://www.tallink.com/good-to-know/age-regulations\" target=\"_blank\">年齢制限の規定</a>', w9: 'Alipay', xa: 'アップルペイ', xb: '地方銀行', xc: 'カード', xd: 'グーグルペイ', xe: 'モバイルペイ', xf: 'デビット/クレジットカード', xg: 'WeChat Pay', xh: 'オンラインバンク＆デビット/クレジットカード', xi: '地方銀行', xj: 'オンラインバンク', cg: '最安値 {price}', xk: '上に戻る', xl: '選択', xm: '選択済', xn: '運航船', xo: '出発日時{date}, {time}', xp: '{count} {count, plural, other{名様}}', xq: '大人\n 18+', xr: '子供\n 0-5', xs: '子供\n 6-17', xt: '最初にキャビンを選択してください', xu: 'ご到着ターミナルは、オーランド諸島 ローングネースです（※マリエハムンからは30km離れています）', xv: 'ローングネースへご到着', xw: 'ご出発＆到着ターミナルは、オーランド諸島 ローングネースです（※マリエハムンからは30km離れています）', xx: 'ご出発ターミナルは、オーランド諸島 ローングネースです（※マリエハムンからは30km離れています）', xy: 'ローングネースからのご出発', pV: '車両', xz: '車両', ch: '22時間クルーズ（バルティック・クイーン号）', ci: 'クルーズ', cj: '片道 / 往復', ck: '片道 / 往復', cl: '片道 / 往復 / 日帰り', xB: '法人のお客様', xC: 'Agent ID', xD: '入力されたAgent IDが見つかりませんでした。', xE: '※Agent IDは必須入力項目ではありません。', xF: '一時的に個人アカウントからログアウトします。', xG: '法人ID', xH: '入力された法人IDが見つかりませんでした。', cm: '予約確定書がこちらへ送付されました', cn: 'ご予約が完了しました。素敵なご旅行となりますように！', co: 'お客様への返金額: {refund}', cp: 'ご旅行代金の返金オプションについて、弊社お客様サポートまでご連絡ください。', cq: 'ご予約が更新されました！', xI: '大人', xJ: '市町村名', xK: '検索結果がありません', xL: 'バス停を探す', xM: 'シャトルバスサービス', cr: '子供 6 - 17 歳', cs: 'ご予約の変更', xN: 'チケット', xO: '子供 {range} 歳', ct: '目的地の観光サービス', cu: 'いいえ', cv: 'はい', cw: 'タリンク＆シリヤラインからご登録メールアドレスへ、お得なチケットなどの情報配信を希望されますか？', cx: 'ニュースレター配信のお申込みをありがとうございました！', cy: '弊社お客様サポートへお電話ください', cz: 'キャンセル', xP: '入力された生年月日は、お客様が選択した年齢カテゴリーに合いません。正しい生年月日を入力するか、年齢カテゴリーの変更について弊社お客様サポートまでご連絡ください :', cA: '年齢カテゴリーを変更しますか ?', cB: 'サービスの購入', cC: 'サービス内容の変更', cD: '住所', cE: '法人', cF: '申し訳ございませんが、ご予約の変更は  <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contacts\">弊社お客様サポート</a>までご連絡をお願いいたします。', cG: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\">弊社お客様サポート</a>までご連絡をお願いいたします。', cH: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallink.com/ee-et/hea-teada/kontaktid\">弊社お客様サポート</a>までご連絡をお願いいたします。', cI: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallinksilja.fi/palvelunumerot\">弊社お客様サポート</a>までご連絡をお願いいたします。', cJ: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallink.lv/lv/contacts\">弊社お客様サポート</a>までご連絡をお願いいたします。', cK: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallinksilja.com/contact-us\">弊社お客様サポート</a>までご連絡をお願いいたします。', cL: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallinksilja.ru/agents\">弊社お客様サポート</a>までご連絡をお願いいたします。', cM: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallinksilja.se/kontakta-oss\">弊社お客様サポート</a>までご連絡をお願いいたします。', cN: '申し訳ございませんが、ご予約の変更は <a href=\"https://www.tallinksilja.com/ja/contact-us\">弊社お客様サポート</a>までご連絡をお願いいたします。', cO: '連絡人名', cP: '連絡人', cQ: 'ご予約内容を変更される場合は、お申し込み先の旅行代理店までお問い合わせください。', cR: 'メールアドレス', cS: 'クラブワン会員へ入会', cT: '予約確定書', cU: 'チェックインはご出発時刻の2時間前～45分前まで、車両チェックインエリアにて受付します。', cV: 'ご乗船者全員の全項目をご入力ください。', cW: 'キャンセル', cX: '続ける', cY: 'このまま続ける場合、ご乗船者情報の変更点は保存されません', cZ: '変更点は保存されません', c_: '予約確定書（PDFファイル）を表示', c$: 'ご登録メールアドレスに送付された、予約確定書（PDFファイル）にて、お支払い情報をご確認ください。', c0: '旅行に関わる規則・規定を表示', c1: 'https://www.tallink.com/ja/good-to-know/general-travel-conditions', xQ: '合計', c2: '電話番号', c3: '予約番号', c4: 'セキュリティー<wbr>コード', c5: '確定', c6: '発着時刻は各都市の現地時間で表示されています。', c7: 'ターミナルの自動チェックイン機にて、予約番号とセキュリティーコードをご入力後、搭乗券を発券できます。', c8: 'ターミナルのチェックインには時間に余裕を持ってお越しください。', c9: '出発予定時刻の30分前まで（車両を預ける場合は1時間前まで）チェックインを受け付けます。※タリンまたはストックホルム発→マリエハムン行きクルーズをご利用で車両を預ける方は、ご出発の1.5時間前までにチェックインを完了させてください。', da: 'お客様が受付時間内にチェックインをされなかった場合、チケットはキャンセルされます。往復クルーズをご利用の場合も、往路便のチェックインがない場合は、全チケットがキャンセルされます。予めご了承ください。', db: 'ご乗船者の年齢に関わらず、ご旅行の際は必ずパスポートをご持参ください。', dc: '船の発着時刻は常に現地時間で表示されています。<br>\nチェックインはオンライン、タリンクアプリ、またはターミナルサービスデスクで行うことができます。<br>\nパルディスキ港とカペルシャー港では、車両乗客のチェックインはスーパーファストの出港75分前に締め切られます。早めに港に到着されることをお勧めします。<br>\nキャビンカードはチェックインの際に発行されます。<br>\nすべての乗客（お子様を含む）は、全旅程において有効な旅券と、必要な場合はビザなどその他の必要書類を携帯する必要があります。旅券の有効性、正確性についてはお客様の責任となります。<br>', dd: 'お客様のご旅行について', de: 'お役立ち情報', df: '返金額', dg: 'お客様へ {refund} の返金がございます。弊社お客様サポートまでご連絡ください。', dh: 'お客様サポートへお電話', di: '既に弊社お客様サポートへお電話いただいたお客様へも、こちらのメッセージは表示されます。※弊社にて返金プロセスを開始後、非表示となります。', dj: '返金額のお受取り', xR: '接続環境の問題が続く場合、弊社お客様サポートまでご連絡ください: TEL +49(0)40 547 541 222', xS: 'インターネット接続がありません。接続環境をご確認後、もう一度やり直してください。', xT: 'もう一度やり直す', xV: '続ける', xW: 'お支払へ進む', pX: 'メールアドレス', xX: '例:', dk: '国名コード＆電話番号', xY: '連絡先', xZ: 'お客様情報をご入力されると、弊社よりお客様の予約確定書をお送りできます。※クラブワン会員情報は必ずご予約の完了前に入力してください。', x_: 'こちらの情報はクラブワン会員アカウントへ保存されます', pY: '電話番号', dl: '例: 09012345678', x$: 'その他', x0: '予約確定書のコピーが {email}へ送信されます。', dm: '追加メールアドレス', dn: '郵便番号', x6: '{price} / 検査', x8: '<b>新しい予約システム</b>でこの旅行をより早く予約できます。', dp: 'カード名義', dq: 'クレジットカード', dr: '月', ds: 'クレジットカード番号', dt: 'お支払方法', du: 'セキュリティーコード', dv: 'クレジットカード選択 :', dw: '有効期限', dx: '年', dy: 'ストックホルム (Kappellskär)-トゥルク - ストックホルム (Kappellskär) 往復', ya: 'ヘルシンキ行クルーズ', yb: 'ヴィスビー行クルーズ', dz: 'トゥルク -ストックホルム (Kappellskär) -トゥルク 往復', yc: 'イースタッドを訪れるクルーズ', dA: 'ヘルシンキ日帰りクルーズ', dB: 'リガ日帰りクルーズ', no: 'タリン日中滞在の往復クルーズ', yj: 'トゥルク日中滞在の往復クルーズ', yr: 'デザート', dC: '割引:', yy: '適用済み', yz: 'プロモーションコード又はギフトコード', p9: '割引＆ギフトカード', dD: 'レストランをご予約の際は、大人お一人様につき1つのメニューをお選びください。', dE: 'Don’t forget to select one menu option for each 12 years and older passenger in {restaurant} reservation.', yB: 'チャンスをお見逃しなく！', yD: 'ドリンクパッケージをお選びください', dF: 'こちらの内容と同様の未払い予約がみつかりました : 予約番号: {resId}, ご利用料金 : {price} {unit} ｜未払いのご予約をキャンセルされ、こちらの新しいご予約の支払いを確定されますか？<a href=\"{link}\">未払い予約のお支払い手続きへ →</a> ご不明な点は弊社カスタマーサービスへご連絡ください', yF: '客室タイプを変更', yG: '客室タイプを変更', yO: '目的地の観光サービス', yP: '目的地の観光サービス＆ホテル', yS: 'ご乗船者全員分の車両座席があることをご確認ください。', dK: 'https://clubone.tallink.com/', yY: '追加サービス', dL: 'フィードバックを送信', y_: '運航船', y$: '運航船+ホテル', y5: 'メニューをお選びください', y7: 'お食物アレルゲンやお食事制限について:', kS: '出発地', za: '排ガスおよび燃料サーチャージ', zb: '6歳以上のお客様に燃料追加料金とCO2排出追加料金が適用されます。', zc: 'Fuel and emissions surcharges apply to passengers aged 12 and over. Up to three children aged 6–11 per booking are exempt.', zd: 'Fuel and emissions surcharges to support climate action and cover costs from the EU Emissions Trading System.', dM: '燃料追加料金', dN: '6歳以上のお客様に燃料追加料金が適用されます。', dO: '6歳以上のお客様には{price}の燃料追加料金が加算されます。', dP: '6歳以上のお客様には片道ごとに{price} の燃料追加料金が加算されます。', zh: 'ギフトカード :', zi: 'こちらのギフトカードは、残額がある限り、複数のご予約へ何度でもご利用いただけます。\nギフトカードの残額 : {priceLeft} €.', dQ: 'グループ・メニューあり', zm: '大人12名様以上のご予約の場合、大人お一人様につき1つのメニューをお選びください。小さなお子様には25ユーロ分のキッズ・メニュー・バウチャーをご提供させて頂きます。', dR: 'ヘルシンキ', dS: '船内2泊＆リガの日中滞在を満喫！', dT: 'タリン行き往復22時間クルーズ<br>タリンにて4時間滞在！', dU: 'タリン行き往復クルーズ<br> タリンにて5時間滞在！', dV: 'ヴィスビュー・クルーズ', dW: 'ゴットランド島への夏のスペシャルクルーズ', dX: 'ヘルネサンド', zv: 'ホテル', zy: 'こちらの範囲以外の日付を選択するには <a>お客様のご旅行日を変更してください</a>', dY: 'チェックイン', dZ: 'チェックイン時刻', d_: 'チェックアウト', d$: 'チェックアウト時刻', d0: '泊', d1: '泊', zz: 'ホテルのみのご予約は、別ページにてご利用いただけます。', zA: 'こちらの選択日ではホテルの空室がございません。ご旅行日の変更をお願いいたします。', zB: 'チェックアウト後にチェックインはできません。チェックアウト日の変更はチェックアウトタブにて可能です。', zC: 'チェックイン前にチェックアウトはできません。チェックイン日の変更はチェックインタブにて可能です。', zD: 'こちらはお客様のチェックイン日です。変更はチェックインタブにて可能です。', zE: 'こちらはお客様のチェックアウト日です。変更はチェックアウトタブにて可能です。', qF: 'こちらはお客様が選択されたご旅行日の範囲外です。新しくこちらを選択するには、お客様のご旅行日を変更してください', zF: 'そこは往路の夜間航海です。そこで寝ることができます', zG: 'そこは往路の夜間航海です。そこで寝ることができます', zW: '食物アレルゲンやお食事制限に関する情報を船内の担当へお伝えいたしました。', q4: 'クラブワン会員へ入会', AB: 'クラブワン会員様は、会員専用の割引の他、ボーナスポイントを貯めて、ご旅行代金のお支払いへもご利用いただけます！', d2: '市区町村以下の住所', d3: '都道府県', d4: '国', d5: '必要なクラブワン会員情報をすべてご入力ください', AC: '郵便番号', AD: 'クラブワン会員のお客様がご乗船者ではないため無効です。', d6: 'メール', d7: '郵送', d8: 'SMS', d9: 'ご使用言語を選択', ea: 'クラブワン会員の特典に関わるニュースレター配信を希望する', eb: 'いいえ', ec: '保存して終了', ed: 'はい', AF: 'クラブワンへようこそ！ご予約確定後、その他の必要な会員情報をご入力ください。', AG: 'クラブワンへようこそ！今すぐ会員専用割引が適用されます。通常価格 : {priceBefore}から、クラブワン会員価格 : {currentPrice}へと割引されます。', AH: 'こちらの情報と同様のお客様が既にクラブワン会員にご入会済みです。', ee: 'カペルシャー', ef: 'キッズメニューのクーポン', AN: 'ご予約を確定されると、Klarna へお客様の予約に関わるデータが転送され、ご利用可能なお支払い方法を確認します。詳しくはこちら :', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: 'Klarna 利用規約', AQ: 'クラマ＆スウィッシュ', AR: '請求書、一部支払い', AS: 'クラルナ', AT: '請求書払い', AU: '一部支払い', AV: 'スウィッシュ', AW: 'ご利用可能のお支払い方法は予約内容により異なります。通常のお支払い方法 :', eg: 'Klarna 終了', eh: 'Klarnaのご利用で簡単・安全なモバイル決済', ei: 'クライペダ', ej: '片道または往復<br>19:00 出航！', A$: 'ドイツ語', A0: '英語', A1: 'エストニア語', A2: 'フィンランド語', ek: 'リトアニア語', A3: 'ラトビア語', A4: 'ロシア語', A5: 'スウェーデン語', Bb: '読み込み中...', Bc: 'ヘルシンキ', Bd: 'ユルマラ', Be: 'コールモーデン', Bf: 'クレサーレ', Bg: 'ラウラスマア', Bh: 'マリエハムン', Bi: 'ナルヴァ', Bj: 'ノルショーピン', Bk: 'オテパー', Bl: 'パルヌ', Bm: 'ラクヴェレ', Bn: 'リガ', Bo: 'セーデルテリエ', Bp: 'ストックホルム', Bq: 'タルトゥ', Br: 'トゥルク', Bs: 'タリン', Bt: 'タンペレ', Bu: 'ウプサラ', Bv: 'ヴァンタ―', Bw: 'ヴィフラ', BC: 'Main course', BE: 'さらに追加', BF: '日付:', BG: '{price} / サービス', BH: '時刻:', Cf: '{direction}間はこちらのお食事サービスはございません', Cg: 'お食事セットにはクルーズ中のお食事全てが含まれます。', Ch: 'お食事セットを選択', el: '未選択', em: '<span class=\"data\">{count}</span> {count, plural, other{# 朝食}}', en: '<span class=\"data\">{count}</span> {count, plural, other{# ディナー}}', rt: '大人のお客様に付き添いの5歳以下のお子様は無料です。6～17歳のお子様も割引価格となります。\n\nお食事クーポンは船内の他レストランにて金券としてご利用いただけます。', Ci: '{price} / 18歳以上', Cj: '{price} / 大人', Ck: '{price} / 人', Cl: '<span class=\"save bodySmall\">最大で</span><span class=\"bodyLarge percentage\">15%</span><span class=\"bodySmall\">割引</span>', Cm: 'お食事セット', Cn: '{count, plural, one{# 名様} other{# 名様}}', Co: '1名様につき', Cp: 'ご予約', ru: 'お得なお食事セット', eo: 'テーブル予約', ep: '完売', eq: 'ご朝食', er: 'ディナー', Cq: 'お食事', es: 'お食事クーポン', Cr: 'お食事はご利用料金に含まれます', Cs: 'お食事<b>最大10% のディスカウント</b>をご利用になりませんか。オファーはオンラインご予約時のみ有効です。', et: '会議室', eu: '{date} {time} ご利用{duration} 時間', Ct: 'Menu available', Cu: 'ご予約の際、12歳以上のお客様お一人につき1つのメニューをお選びください。12歳未満のお客様にはミールクーポンをお渡しいたします。お子様は通常料金の50％割引となります。', ew: 'ご乗船者についてご入力', ex: 'ご乗船者情報を表示', ey: 'クラブワン会員', CA: 'クラブワン会員情報の変更は、弊社お客様サポートまでご連絡ください :', ez: 'ご乗船者の情報が不足しています', eA: 'プリントアウトは不要です！ターミナルの自動チェックイン機で簡単に搭乗券が受け取れます（予約番号とセキュリティーコードが必要です）', eB: '年齢カテゴリーが適していません', eC: 'ご乗船者の情報が不足しています', eD: '決済に失敗しました', eE: '車両のナンバープレートを変更', eF: 'ナンバープレート情報を入力してください', eG: 'ナンバープレート情報が入力されていません', eH: 'モバイル搭乗券を取得', eI: '取得', eJ: '開く', eK: 'リンクを送信', eL: 'タリンク＆シリヤライン アプリ', eN: 'ムーガ', CJ: 'タリンでの滞在時間はありません', CK: '目的地にて車のご利用はできません。', CL: '現在、ご選択のご旅行内容では、出発便がございません。申し訳ございませんが、別のご旅行タイプをご選択ください', CM: 'お支払い方法に問題があるため決済ができません。もう一度やり直すか、弊社お客様サポートまでご連絡ください。Email : <a href=\"mailto:international.sales@tallinksilja.com\" target=\"_blank\">international.sales@tallinksilja.com</a>', ol: 'いいえ、結構です', CU: '返金不可のバウチャーの説明', CV: '<ul>\n<li>チケットの行き先・経路、出発日または出発時刻の変更は認められません。</li>\n<li>乗客の個人情報、客室クラス、車両、船内サービスは変更可能です。変更時には、当初購入したサービスと変更後のサービス間の差額を支払う必要があります。</li>\n<li>乗客がチケットをキャンセルした場合、Tallink Silja Lineは契約上の違約金としてチケット代金の100%を差し引きます。</li>\n<li>その他の事項については、AS Tallink Gruppの旅行条件が適用されます。詳細は <a href=\"https://www.tallink.com/terms\" target=\"_blank\">利用規約ページ</a>でご確認ください。</li>\n</ul>', CW: '返金不可バウチャー利用規約モーダルタイトル', CX: '返金不可バウチャー警告モーダル 承諾', CY: '返金不可のバウチャーに関する警告モーダル（拒否時）', CZ: '返金不可のバウチャーに関する警告モーダル説明', C_: '返金不可のバウチャーに関する警告モーダル タイトル', eO: 'ポイント数が足りません', C0: 'ご予約を続ける', C1: 'ご予約を削除', C2: 'こちらのページを離れ、前のページへ戻ると現在のご予約が取り消されます。もう一度最初からやり直しますか？', C3: '現在のご予約を削除しますか？', eP: '到着港はストックホルムより90㎞の距離にあるKapellskär となります。', eQ: '出発港はストックホルムより90㎞の距離にあるKapellskär となります。', eR: '出発及び到着港はストックホルムより90㎞の距離にあるKapellskär となります。', Da: 'バブルフェア', eS: 'Insurance', Db: 'フレンドシップ・アドベンチャーパッケージ', Dc: 'キッズパッケージ', Dd: '優先搭乗', De: '船内サービス', Df: '船内マネー', Dg: '船内クーポン', Dh: '船内マネー・クーポン', Di: '席', Dj: 'ルート}間のサービスは利用できません', Dk: '1日', eT: '片道または往復<br>毎日運航', Do: 'または', Dp: 'その他', eU: 'その他のお支払い方法', eX: '12歳以上', eY: 'パルディスキ', eZ: 'バン（船内駐車）', DI: 'バルト海でのパーティー', DJ: 'バルト海 - タリン', e_: 'ご乗船者の年齢カテゴリーの変更はできません', DM: 'ご乗船者（大人）の年齢カテゴリーに誤りがあります – 年齢をご確認ください。', DN: '年齢に誤りがあります。- 生年月日が大人かユースが再確認ください。', DO: '入力された生年月日は無効です。日→ 月→ 年の順にご入力ください（例 1975年12月5日の場合 : 05.12.1975）', DP: '番号入力は生年月日欄のみ可能です', DQ: '後で入力する', DR: '保存', DS: 'お客様の氏名とクラブワン会員番号についてご確認ください', DT: 'クラブワン会員番号', DU: 'すでに追加済み', DV: '情報を変更または', DW: '最初からやり直す', DX: 'お客様の身分証の情報がクラブワン会員アカウントへ保存されます。', DY: '発行国 *', DZ: '有効期間満了日 *', D_: '発行年月日 *', D$: '旅券番号 *', D0: '身分証明書 *', D1: '出生国 *', D2: '特別サポート', D3: 'お体の不自由なお客様がご乗船時などにサポートが必要な場合、特別サポートの事前ご予約を<a href=\"https://www.tallink.com/good-to-know/special-needs-and-assistance\" target=\"_blank\">オンライン申請</a>または、お電話にて承ります。お客様サポート TEL:', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'ご乗船者を追加', Ec: '<span class=\"data\">{count}</span> {count, plural, one{名様} other{名様}} 選択済', Ed: 'ご乗船者情報を今すぐ入力', Ee: 'ご乗船者情報の入力が完了', Ef: 'ご乗船者', e0: '近日中に開始！', e1: 'お客様の予約番号', e2: 'クレジットカード', e3: '削除', Ei: 'お支払い', e4: 'お支払方法を選択 :', Ej: '請求書払い', Ek: '請求書住所', e5: '請求書払い（法人向け）', El: 'お客様のリファレンスナンバー', e6: '後で支払う', e7: 'モバイル決済', e8: '今すぐのお支払いでご予約を確約', e9: 'インターネットバンキング', fa: '通常の通信料金', fb: '通常の通信料金', fc: '通話料金 : 85 セント / 回 + 通信料金', fd: '通話料金 : 8,35 セント / 回 + 16,69 セント / 分', fe: '通常の通信料金', ff: '通常の通信料金', fg: '通常の通信料金', fh: '通常の通信料金', fi: '通常の通信料金', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '00358 10804133', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '0049 40547541222', Eu: 'お客様サポートへ電話', fk: '未払いのご予約は自動的にキャンセルされます', fl: 'お支払い方法に問題があるため決済ができません。もう一度やり直すか、弊社お客様サポートまでご連絡ください。', fm: '最初にご利用いただいた<u>国・言語設定</u> へ変更後、お支払いを完了させてください。', fn: 'こちらのご予約は別の言語ページで行われました。', Ex: 'と {points} ポイント', r0: '人', EA: '人', EH: 'D-ターミナル', EI: 'フリーハムネン', EK: 'カペルシャー', EL: 'ローングネース', EM: '西港ターミナル２', EN: '西港ターミナル1', EO: '西港ターミナル１', EP: 'サンクトペテルブルク', EQ: 'マリエハムン', ER: 'ムーガ港', ES: 'オリンピアターミナル', ET: 'パルディスキ', EU: 'リガターミナル', EV: 'ザズニッツ', EW: 'トゥルクターミナル', EY: 'ヴァルタハムネン', EZ: 'ヴィズビー', E_: 'ヴェンツピルス', E$: 'ヴオサーリ港', E5: '選択済み', E6: 'ご予約', E7: 'キャンセル', E8: '続ける', E9: '完了', fo: '次へ', Fa: '最安キャビン :', Fb: '最安キャビン（クラブワン会員価格）:', Fc: 'Club One price', Fd: 'キャビン数を追加してください', Fe: '合計金額はキャビン追加後に表示されます', fp: 'まずキャビンクラスを選択してください', Ff: 'Subtotal:', Fg: '合計 :', fq: 'クラブワン会員価格 :', Fh: 'ご利用料金を確認中...', Fj: '料金は1名様/1台から、排気ガスと燃料サーチャージが含まれます。', Fl: '{price} / 1個あたり', sa: '続ける', fr: 'お支払い手続きへ', Fs: 'こちらのページは reCAPTCHAにより保護されており、Googleの\n<a target=\"\"_blank\"\" href=\"\"https://policies.google.com/privacy\"\">プライバシーポリシー</a>と\n<a target=\"\"_blank\"\" href=\"\"https://policies.google.com/terms\"\">サービス利用規約</a>が適用されます。', ft: '船内サービスの変更:</br>\n金＆土の出発便では、ライブ演奏やカラオケ、ビンゴゲームなどをお楽しみいただけます。</br>\n\n日～木の出発便ではエンターテインメントやサービスに限りがございます。ご了承ください。', fu: '通常価格 :', Fy: 'こちらを選択するには、まず選択済の項目を削除してください', FA: 'ご予約手数料は最終ご請求額から差し引かせていただきます。', FB: 'また大人のお客様に付き添いの5歳以下のお子様は無料です。', sq: '終了', FD: '予期せぬエラーが発生しました。恐れ入りますが、ページの再読み込みまたはもう一度最初からやり直してください。', FE: '出発便が見つかりませんでした', fv: 'もう一度やり直す', fw: 'ご不便をおかけし大変申し訳ございませんが、現在のご予約は自動的にキャンセルされます。', fx: 'セッションの期限が切れました', FF: 'もう一度やり直す', FG: '大変申し訳ございませんが、もう一度最初からやり直してください。', FH: 'エラーが発生しました', fz: 'リガ', fA: '船内2泊＆クライペダの日中滞在を満喫！', fB: '片道または往復<br>17:00 出航！', fC: 'ストックホルム -トゥルク - トゥルク - ストックホルム (Kappellskär)', fD: 'ストックホルム (Kappellskär) -トゥルク', fE: 'ストックホルム (Kappellskär) -トゥルク - トゥルク - ストックホルム', fF: 'トゥルク -ストックホルム -ストックホルム (Kappellskär) -トゥルク', fG: 'トゥルク -ストックホルム(Kappellskär)', fH: 'トゥルク -ストックホルム(Kappellskär) -ストックホルム -トゥルク', fI: 'リストへ戻る', fJ: '申し訳ございませんが、お探しの銀行はございません。リストからお選びください。', fK: '検索', fL: 'ザズニッツ', fN: 'こちらのご利用には車両1台のご予約が必要です。', Ge: 'Adding a car <b>will remove {service}</b> service. You sure you want to proceed?', Gf: '承諾されますか？', Gv: '5時間クルーズ', Gw: 'ヘルシンキ発の5時間クルーズ。（※タリンでの下船はできません）多くの商品をご購入される場合は、車両予約が便利です。メガスター号では、デッキ7のトラベラー・スーパーストアへすぐアクセス可能なガレージに駐車していただけ、運航中も車両へのアクセスが可能です。スター号では、カーデッキでの駐車となります。', Gy: 'こちらの便は5時間クルーズに追加されました。5時間クルーズのウェブページへ移動します。', fO: '自分だけのための最高のひととき', GE: 'テーブル予約を表示', fP: 'サーレマー', GK: '5 ～ 17 歳のお客様は、大人の同伴なしで旅行できます。 <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\">渡航許可</a>を忘れずにご持参ください。安全なご旅行をお楽しみください！', fQ: 'サンクトペテルブルク', GQ: '前菜', fR: 'ストックホルム', GY: 'ストックホルム-ヘルシンキ購入', GZ: '冬のバルト海を航行するマイスター号はタリンからストックホルムへの直行便はありませんが、ヘルシンキを経由し、そこからシリヤセレナーデ号に乗ることができます。', G_: '重要！船を乗り換えるには、オリンピア ターミナルから西ターミナル 2 への乗り換えが必要です。', G$: 'ストックホルム -> タリン <br/> ヘルシンキ経由', fS: '政府の新規制により、船内レストランやバーでのアルコール飲料の販売時間が規制されています。', fT: '船内2泊＆ヴィスビー日中滞在を満喫－シリヤ・シンフォニー号がストックホルム－ヴィスビー間を運航します。', fU: '船内計2泊＋ヴィスビー1泊（船内泊）の旅では、ゴットランドの散策を丸二日間ご満喫ください。\r\nクルーズ中は、船内にて免税ショッピングもお楽しみいただけます。', fV: 'ストックホルム（カペルシャー）', fW: '船内3泊＆ヴィスビーとユースタッドでそれぞれ日中滞在を満喫！', fX: '追加料金', fY: 'タリン', G8: 'タリン - バルト海', fZ: 'タリン - バルト海 - タリン', f_: '船内計2泊＆リガの日中滞在を満喫！', G9: 'タリン - ヘルシンキを購入', Ha: '選択した日付にはタリンからストックホルムへの直通便はありませんが、ヘルシンキ経由で移動し、そこから船に乗ることができます。', Hb: '重要！船を乗り換えるには、西ターミナル 2 からオリンピア ターミナルへの乗り換えが必要です。13:30 出発を選択した場合、公共交通機関で乗り換える時間が足りない可能性があります。', Hc: 'タリンからストックホルム<br/> ヘルシンキ経由', f$: '船内計2泊<br>トゥルクでの日中滞在', f0: '片道または往復<br>毎日運航！', f1: 'Visby cruises', f2: 'ゴットランド島への夏のスペシャルクルーズ', tb: 'こちらの銃砲提供ありがとうございます。', td: '復路を追加', f3: '復路の同時ご予約で最大30％割引！', f4: '往復の旅行日が同日の場合、日帰り往復クルーズとしてお得な割引価格となります！', o6: '到着', f5: '別の出発便をお探しですか？', f6: '日付を選択 : {direction}行き', f7: '選択を解除', Hx: '日付を選択', f8: '23時間の往復クルーズ (夜発便)', f9: '23時間の往復クルーズ (朝発便)', ga: 'ストックホルム日中滞在の往復クルーズ', gb: 'トゥルク日中滞在の往復クルーズ', o7: '出発', Hy: '午後発', Hz: '午前発', te: '所要時間', tf: '時間', HA: 'Spend the first night onboard ship and leave as you wish between 8–11.', HB: 'First night on ship', HC: 'この出発便を選択すると、クルーズ+ホテルパッケージの適用はできません。', HD: '申し訳ございませんが、帰路のクルーズを選択された場合、全体の期間において船＋ホテルのサービスを提供することはできません。', HE: '予約可能な最終日を表示', HF: '船のみの選択', HG: 'ご利用不可', gc: '復路を削除', gd: 'メガスター号の5時間クルーズ', ge: '終了', gf: '車両ご予約の方へは割引特典付きの5時間クルーズ。（※こちらのクルーズでは下船はできません）', gg: 'メガスター号の5時間クルーズ', gh: '船内で1泊＆タリンにて4時間の滞在を満喫！', gi: 'ストックホルム夜発（※下船はできません）', gj: 'ストックホルム朝発（※下船はできません）', gk: '船内計2泊＆トゥルクの日中滞在を満喫！', gl: 'トゥルク夜発（※下船はできません）', gm: 'トゥルク朝発（※下船はできません）', gn: '往復（ヘルシンキ－ストックホルム－ヘルシンキ）', go: '片道（ヘルシンキ発 → ストックホルム行き）', gp: '往復（ヘルシンキ－タリン－ヘルシンキ）', gq: 'タリン日中滞在の往復クルーズ', gr: '片道（ヘルシンキ発 → タリン行き）', gs: 'メガスター号の5時間クルーズ', gt: '往復（リガ－ストックホルム－リガ）', gu: '片道（リガ発 → ストックホルム行き）', gv: '往復（ストックホルム－ヘルシンキ－ストックホルム）', gw: '片道（ストックホルム発 → ヘルシンキ行き）', gx: '往復（ストックホルム－リガ－ストックホルム）', gy: '片道（ストックホルム発 → リガ行き）', gz: '往復（ストックホルム－タリン－ストックホルム）', gA: '片道（ストックホルム発 → タリン行き）', gB: '往復（ストックホルム－トゥルク－ストックホルム）', gC: '片道（ストックホルム発 → トゥルク行き）', gD: '往復（タリン－ヘルシンキ－タリン）', gE: 'ヘルシンキ日中滞在の往復クルーズ', gF: '片道（タリン発 → ヘルシンキ行き）', gG: '往復（タリン－ストックホルム－タリン）', gH: '片道（タリン発 → ストックホルム行き）', gI: '往復（トゥルク－ストックホルム－トゥルク）', gJ: '片道（トゥルク発 → ストックホルム行き）', HH: 'ホテル付き', tg: 'クルーズ', gK: 'ヘルシンキ日帰りクルーズ', gL: 'タリン日帰りクルーズ', gM: 'オーランド日帰りクルーズ', gN: 'ストックホルム日中滞在の往復クルーズ', gO: 'タリン行き往復クルーズ', gP: '9h Cruise', gQ: 'ストックホルム日中滞在の往復クルーズ', gR: 'Cruises', gS: 'オーランド日帰りクルーズ', gT: 'Cruise to Helsinki', gU: 'ストックホルム日中滞在の往復クルーズ', gV: '22時間クルーズ', gW: 'Cruises', gX: '2回の寄港を含むクルーズ', gY: '表示しない &uarr;', gZ: 'さらに表示&darr;', g_: '片道 / 往復', le: '目的地', g$: 'ご予約には大人1名様以上が必要です。大人のお客様が自動で追加されました。', g0: 'ガレージのご予約が削除されました。ビジネスラウンジをご利用のお客様は、プライオリティ・サービス（車両）を無料でご利用いただけます。', g1: 'ビジネスラウンジご利用のお客様はプライオリティ・サービス（車両）を無料でご利用いただけます。', g2: 'こちらのトラベルクラスはご利用いただけません。申し訳ございませんが、他のトラベルクラスをお選びください。', HP: '車両のナンバープレートはご入力済み', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: '選択されたシャトルバスサービスはお客様のご旅行日では利用できません。', g5: '選択されたシャトルバスサービスはご利用できないため、削除されました', HQ: 'ようこそ, {name}さん！', g6: 'クラブワン会員ポイントをお支払いに利用するためには {clubOnePoints} ポイント以上が必要です', g7: 'お客様情報の入力項目に空白がございます。全必須項目の入力をしてください。', g8: 'インターネット接続がないため、お客様の情報が保存されませんでした。接続環境を確認後、もう一度やり直してください。', g9: 'お客様情報の入力項目に空白があります。全必須項目のご入力後、保存してください。', HR: 'ご乗船者全員が追加されていません', HS: '各客室に必ず大人1名様以上のご滞在が必要です', ha: 'こちらのお食事をご予約するには、選択済のお食事をまず削除してください。', HU: 'ご予約には大人1名様以上が必要です。', hb: 'インターネット接続環境を確認後、もう一度やり直してください', hc: '年齢カテゴリーを \"{old}\" から \"{new}\"へ変更しました。', hd: '乗船者が削除されたためキャビン1室が削除されました。各キャビンのご予約には必ず大人1名様以上が必要です。', he: '{name}さんのご予約へクラブワン情報を追加しました', hf: '一度にご予約できる最大人数を超えました。', hg: '新しく追加されたお客様分のお食事予約も追加されました。', hh: '削除されたお客様分のお食事予約も取り消されました。', hi: '乗船者が削除されたため車両予約が削除されました。各車両予約には必ず大人各1名様以上が必要です。', hj: 'ご入力された乗船者数が削除されました。こちらの運航ルートでは、一度にご予約できる最大人数は５名様までです。', hk: '日帰り往復クルーズの割引が適用されました！', hl: '運航時刻の表示エラーが発生しました', hm: '船内1泊', hn: 'トゥルク日中滞在往復クルーズの割引が適用されました！', ho: 'ストックホルム日中滞在往復クルーズの割引が適用されました！', HV: 'ストックホルムでの待機時間が長時間となります。予めご了承ください。', hp: '残室1室の \"{name}\"を追加！', hq: 'こちらのクルーズでご予約できる最大キャビン数を超えました。ご予約には1室に1名様以上の大人のお客様が必要です。', hr: '\"{name}\"キャビンは満室です', hs: '最後の車両空スペースが追加されました', ht: '車両の追加はできません。各車両1台のご予約には、必ず大人各1名様が必要です。', hu: 'タリンにて車両のご利用はできません（※船内駐車）', hv: '車両ご予約は往路のみ可能です', hw: '車両ご予約は復路のみ可能です', hx: 'こちらの運航便では選択された車両のご予約はできません', hy: 'ペットを追加', hz: 'アレルギーのある方', hA: 'ケージ', hB: 'ケージ', hC: 'お体の不自由な方', hD: '室', hE: '室', hF: '各キャビンに必ず大人1名様以上のご滞在が必要です', H1: '完売', hG: '{capacity} 名様用の客室のみ空室があります', hH: '{from}-{to}便は{capacity} 名様用の客室のみ空室があります', hI: 'ペット同伴のご旅行', hJ: '続きを読む', hK: 'シェアキャビン', hL: '女性専用', hM: '男性専用', hN: '{name}, {genderPlace} シェアキャビン : {maxOccupancy} 人用客室', hO: '{price} / 室', tm: '{price} / 人', hP: 'トラベルクラス', hQ: '専用キャビン', H2: 'キャビン', hR: 'ペット', hS: 'ペット', hT: 'ペット同伴', hU: 'ヘルシンキ発ストックホルム行きの往復クルーズは、ストックホルムで約6時間の滞在ができる船内2泊の往復クルーズ！2泊とも同キャビンご宿泊のため、荷物をキャビンに置いて身軽にストックホルム観光ができます。出航後はシリヤ・セレナーデ号＆シリヤ・シンフォニー号船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫。', hV: 'ヘルシンキータリン間の往復22時間クルーズはリニューアルされたエウロパ号が毎日運航！ヘルシンキ18:30発 → タリン22:00に到着後は船内に1泊し、翌朝タリン滞在を約4時間ご満喫（タリン滞在 : 8:00 -12:10）', hW: 'リガ発ストックホルム行きの往復クルーズは、ストックホルムで約6時間の滞在ができる船内2泊の往復クルーズ！2泊とも同キャビンご宿泊のため、荷物をキャビンに置いて身軽にリガ観光ができます。出航後はイザベル号＆ロマンチカ号船内の無料エンターテインメントショーや美味しいお食事、お得なショッピングをご満喫。', hX: 'ストックホルム 7:10 発 のオーランド諸島行き日中の往復クルーズはバルティック・プリンセス号が運航！オーランド諸島にてギャラクシー号に乗り換え、ストックホルムへは18:15頃ご到着', hY: 'ストックホルム発ヘルシンキ行きの往復40時間クルーズは、ヘルシンキで約7時間の滞在ができる船内2泊のクルーズ！2泊とも同キャビンご宿泊のため、荷物をキャビンに置いて身軽にヘルシンキ観光ができます。出航後はシリヤ・セレナーデ号＆シリヤ・シンフォニー号船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫。', hZ: 'ストックホルム発リガ行きの往復40時間クルーズは、リガで約6時間の滞在ができる船内2泊のクルーズ！2泊とも同キャビンご宿泊のため、荷物をキャビンに置いて身軽にリガ観光ができます。出航後はイザベル号＆ロマンチカ号船内の無料エンターテインメントショーや美味しいお食事、お得なショッピングをご満喫。', h_: 'ストックホルム発タリン行きの往復40時間クルーズは、タリンで約7時間の滞在ができる船内2泊のクルーズ！2泊とも同キャビンご宿泊のため、荷物をキャビンに置いて身軽にタリン観光ができます。出航後はバルティック・クイーン号＆ヴィクトリア Ⅰ 号船内の無料エンターテインメントショーや美味しいお食事、サウナ＆スパ施設、免税ショッピングをご満喫。', h$: 'ストックホルム 19:30 発 船内1泊の往復23時間クルーズはギャラクシー号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫。※トゥルクでの下船はできません', h0: 'タリン発ストックホルム行きの往復クルーズは、ストックホルムで約7時間の滞在ができる船内2泊の往復クルーズ！2泊とも同キャビンご宿泊のため、荷物をキャビンに置いて身軽にストックホルム観光ができます。出航後はバルティック・クイーン号＆ヴィクトリア Ⅰ 号船内の無料エンターテインメントショーや美味しいお食事、サウナ＆スパ施設、免税ショッピングをご満喫。', h1: 'トゥルク 8:15 発 のオーランド諸島行き日中の往復クルーズはギャラクシー号が運航！オーランド諸島にてバルティック・プリンセス号に乗り換え、トゥルクへは19:15頃ご到着', h2: 'トゥルク 20:15 発 船内1泊の往復23時間クルーズはバルティック・プリンセス号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫。※ストックホルムでの下船はできません', h3: 'シリヤ・セレナーデ号＆シリヤ・シンフォニー号でオーランド諸島へ！', h4: 'ヘルシンキ夕方発の船内1泊、翌朝ストックホルム到着のクルーズはシリヤ・セレナーデ号＆シリヤ・シンフォニー号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫。翌朝にはあっという間にストックホルムへご到着！片道＆往復どちらもご予約いただけます。', h5: 'ヘルシンキータリン間の運航便は年中・毎日、多数運航！お客様のご予定に合わせてご出発便をお選びいただけます。メガスター号＆スター号は片道2時間、エウロパ号は3.5時間で目的地へ到着！', h6: 'ヘルシンキータリン間を行き来するタリンクシャトルは毎日運航！ 快適な高速メガスター号＆スター号では片道2時間で目的地へ到着！', h7: '合計5時間のショッピングクルーズはヘルシンキ 10:30 & 16:30発の毎日2便運航しています。車両ご予約の場合は、デッキ7のトラベラー・スーパーストアのすぐ隣のガレージに駐車できるためとても便利！※下船はできません', h8: 'リガ夕方発の船内1泊、翌朝ストックホルム到着のクルーズはイザベル号＆ロマンチカ号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、お得なショッピングをご満喫。翌朝にはあっという間にストックホルムへご到着！片道＆往復どちらもご予約いただけます。', h9: 'オーランド諸島へは毎日4便運航！オーランド諸島寄港の運航船はこちら : バルティック・プリンセス号、ギャラクシー号、シリヤ・シンフォニー号、シリヤ・セレナーデ号、ヴィクトリア Ⅰ 号、バルティック・クイーン号', ia: 'ストックホルム夕方発の船内1泊、翌朝ヘルシンキ到着のクルーズはシリヤ・セレナーデ号＆シリヤ・シンフォニー号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫。翌朝にはあっという間にヘルシンキへご到着！片道＆往復どちらもご予約いただけます。', ib: 'ストックホルム夕方発の船内1泊、翌朝リガ到着のクルーズはイザベル号＆ロマンチカ号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、お得なショッピングをご満喫。翌朝にはあっという間にリガへご到着！片道＆往復どちらもご予約いただけます。', ic: 'ストックホルム夕方発の船内1泊、翌朝タリン到着のクルーズはバルティック・クイーン号＆ヴィクトリア Ⅰ 号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピング、サウナ＆スパをご満喫。翌朝にはあっという間にタリンへご到着！片道＆往復どちらもご予約いただけます。', id: 'バルティック・プリンセス号＆ギャラクシー号で、日中クルーズまたは船内1泊クルーズ！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫し、あっという間に目的地へご到着！', ie: 'バルティック・クイーン号＆ヴィクトリア Ⅰ 号でオーランド諸島へ！', $8: 'タリン発 → ヘルシンキ行きの運航便は年中・毎日、多数運航！お客様のご予定に合わせてご出発便をお選びいただけます。メガスター号＆スター号は片道2時間、エウロパ号は3.5時間で目的地へ到着！', ig: 'ヘルシンキータリン間を行き来するタリンクシャトルは毎日運航！ 快適な高速メガスター号＆スター号では片道2時間で目的地へ到着！', ih: 'タリン夕方発の船内1泊、翌朝ストックホルム到着のクルーズはバルティック・クイーン号＆ヴィクトリア Ⅰ 号が運航！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピング、サウナ＆スパをご満喫。翌朝にはあっという間にストックホルムへご到着！片道＆往復どちらもご予約いただけます。', ii: 'バルティック・プリンセス号＆ギャラクシー号でオーランド諸島へ！', ij: 'バルティック・プリンセス号＆ギャラクシー号で、日中クルーズまたは船内1泊クルーズ！出航後は、船内の無料エンターテインメントショーや美味しいお食事、免税ショッピングをご満喫し、あっという間に目的地へご到着！', ik: '船上で2泊、ヘルシンキで1日', il: '船上で2泊、タリンで1日', im: '船内計2泊＆オーランド諸島での日中滞在', $9: 'タリン行き往復22時間クルーズ<br>タリンにて4時間滞在！', io: 'A relaxing mini-break on the sea', ip: 'オーランド諸島行き 往復11時間クルーズ<br>ストックホルム 7:10発！', iq: '船内2泊の2泊3日クルーズ<br>目的地にて約7時間滞在！', ir: '船内2泊の2泊3日クルーズ<br>目的地にて約6時間滞在！', is: '船内2泊の2泊3日クルーズ<br>目的地にて約7時間滞在！', it: '夜発便 ギャラクシー号<br>船内1泊の往復クルーズ（※下船なし）', iu: 'Baltic Princessで過ごす23時間のクルーズをお楽しみください。', iv: 'オーランド諸島行き 往復11時間クルーズ<br>トゥルク8:15発！', iw: '夜発便 バルティック・プリンセス号<br>船内1泊の往復クルーズ（※下船なし）', ix: 'Baltic Princessで過ごす23時間のクルーズをお楽しみください。', iy: '朝発便 ギャラクシー号<br>船内1泊の往復クルーズ（※下船なし）', iz: '片道または往復<br>オーランド諸島－ヘルシンキ間を毎日運航！', iA: '片道または往復', iB: '片道または往復<br>オーランド諸島より毎日運航！', iC: '片道または往復<br>毎日4便運航！', iD: '片道または往復<br>オーランド諸島－タリン間を毎日運航！', iE: '片道または往復！', iF: '片道または往復<br>毎日17:00 出航！', iG: '片道または往復<br>ヘルシンキ－ストックホルム間を毎日運航！', iH: '日帰り往復クルーズでお得な割引価格<br>片道たったの2時間！', iI: '片道または往復<br>ヘルシンキ－タリン間は片道2時間！<br>※エウロパ号のみ3,5時間', iJ: '5時間クルーズ（車両有または無）<br>お得にショッピング！', iK: '片道または往復', iL: '片道または往復', iM: '片道または往復<br>毎日2便運航！', iN: '片道または往復<br>リガより毎日運航！', iO: '片道または往復<br>リガ－ストックホルム間を毎日運航！', iP: '片道または往復<br>ストックホルム発便は毎日4便運航！', iQ: '片道または往復<br>ストックホルム－ヘルシンキ間を毎日運航！', iR: '片道または往復<br>ストックホルム－リガ間を毎日運航！', iS: '片道または往復<br>ストックホルム－タリン間を毎日運航！', iT: '片道または往復', iU: '片道または往復<br>18:00 出航！', iV: '片道または往復<br>ヘルシンキ－タリン間たったの2時間（※エウロパ号のみ3,5時間）', iW: '日帰り往復クルーズでお得な割引価格<br>片道たったの2時間！', iX: '片道または往復<br>タリン－ストックホルム間を毎日運航！', iY: '片道または往復<br>トゥルク発便を毎日2便運航！', iZ: '片道または往復', i_: '片道または往復', i$: '片道または往復<br>毎日2便運航！', i0: 'トゥルク', i1: '船内計2泊＆タリンでの日中滞在', i2: '片道または往復<br>タリンより毎日運航！', H3: '2日', i3: '船内計2泊＋ヘルネサンド1泊（船内泊）の旅では、ヘルネサンドの散策を丸二日間ご満喫ください。\nクルーズ中は、船内にて免税ショッピングもお楽しみいただけます。', i4: '船内2泊＋ヘルシンキ1泊（船内泊）の旅では、ヘルシンキの散策を丸二日間ご満喫ください。\nクルーズ中は、船内にて免税ショッピングもお楽しみいただけます。', i5: '船内計2泊＆オーランド諸島の日中滞在を満喫！', i6: '船内計2泊＆ヘルネサンドの日中滞在を満喫！', i7: '船内計2泊＆ヘルシンキの日中滞在を満喫！', i8: '船内計2泊＆リガの日中滞在を満喫！', i9: '船内計2泊＆サーレマーの日中滞在を満喫！', ja: '船内計2泊＆ストックホルムの日中滞在を満喫！', jb: '船内計2泊＆タリンの日中滞在を満喫！', H7: 'コードを利用', jc: '自動車排出ガス追加料金', jd: '排出ガス追加料金は、予約時に指定された車両に適用されます。', Id: '排ガスおよび燃料サーチャージ', Ie: '予約に指定された車両には、車両排出および燃料サーチャージが適用されます。', je: '最大で高さ1.5 m ＆全長3.0 m', jf: '最大で高さ1.9 m ＆全長5.0 m', jg: 'ショッピングに便利！トラベラー・スーパーストアすぐ隣に駐車できるガレージをご予約 &rarr;', jh: '優先的に下船できる便利なプライオリティ・サービス（車両）のご予約 &rarr;', ji: '高さ2.4 m 以上＆最大8.0 m の全長', jj: 'm', jk: '最大で高さ1.9 m ＆全長5.0 m \n ※目的地でも乗用車は船内駐車となります', jl: '全車両のナンバープレートをご入力ください', Ii: '削除', jm: '前回の旅行と同じ車両を選択 :', jn: '最大で高さ2.3 m ＆全長 7.0 m', jo: '最大で高さ1.9 m ＆全長12 m', jp: 'トレーラーのナンバープレート', jq: 'ナンバープレートの番号は半角英字でご入力ください', jr: '最大で高さ2.4 m ＆全長7.0 m', js: '車両情報が不足しています', jt: '車両のナンバープレート', ju: '追加された車両 :', jv: '空き状況を確認中...', Il: 'ヘルシンキ経由でのご旅行', jw: 'ヴィスビー', jx: 'ユースタッド/ヴィスビー', jy: 'ヴェンツピルス', Ip: '割引 :', Iq: 'クラブワン会員ページにログインし、割引の有無をご確認下さい。', Ir: '申し訳ございませんが、こちらのギフトカードはご使用済みです。', Is: '申し訳ございませんが、こちらのギフトカードは有効期限切れです。', It: '申し訳ございませんが、こちらのギフトカードへは別通貨のご利用となります。', Iu: '申し訳ございませんが、こちらのギフトカードには残金がございません。', jz: 'ヴオサーリ', IA: 'クルーズ', IC: 'ワオタグ', tE: '11時間の往復クルーズ', jA: 'ユースタッド'};
var $author$project$Translations$Generated$ko = {P: 'Read our accessibility statement', Q: 'https://www.tallink.com/en/accessibility', tJ: '추가', R: '다른 코드 추가', S: '차량을 추가하시려면 성인 수를 늘려주십시오. 만 6-17의 아동은 자전거를 추가할 수 있습니다.', tK: '모든 승객 방 배정하기', pl: '좌석 추가', tM: '{route} 구간에는 차량 승객분들만 허용됩니다.', tN: '{route} 구간에 차량을 추가하시겠습니까?', tO: '노선을 추가하시겠습니까?', T: '올란드', t_: '올란드(롱내스)', t$: '올란드(마리함)', ue: '다른 호텔에 방이 배정되어 있는 상태입니다. 본 객실을 선택하시려면 기존의 선택지를 삭제하여 주십시오.', uj: '크루즈', ul: '취소 & 예매 진행', um: '데스크탑 버전으로 진행', un: '데스크탑으로 계속하시면 다음 정보를 잃으실 수 있습니다: <span class=\"bodyBold\">승객 정보, 선실 등급, 식사 내역</span>', uo: '선택하신 정보를 잃으실 수 있습니다.', up: '데스크탑 버전으로 계속하시면 다음 정보를 잃을 수 있습니다: <span class=\"bodyBold\">승객 정보, 식사 내역</span>', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Bank', X: 'Danske Pank', Y: 'Danske Bank', Z: 'Handelsbanken', _: '온라인 뱅크', aa: '계속하시려면 은행을 선택하세요.', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click 로그인 또는 휴대폰 번호를 입력', ah: '마지막 선택', ai: 'Säästöpankki', aj: 'SEB', ak: '은행 선택하기', al: 'S-Pankki', am: 'Swedbank', uB: '식사 예매하기', uC: '다음 여행을 별도로 예약하세요.', uD: '선상 서비스 추가', uE: '데스크탑으로 가기 &rarr;', uF: '현재창에 필요하신 기능이 없으신가요?', uG: '버스편 추가하기', uH: '항구 왕복편', uI: '회사 아이디로 예매하기', ao: '간편한 예매 & 할인 혜택을 누리세요!', ap: '로그아웃 &rarr;', uJ: '로그인', aq: '클럽원 계정이 있으십니까?', ar: '가능한 날짜 보기', uK: '선택하신 여정에는 할인이 적용되지 않습니다. 다른 날짜, 구간, 선실 등급을 선택해주십시오.', as: '코드를 확인하시고 재시도해 주십시오.', uL: '취소', at: '부킹 코드가 적용되었습니다.', au: '코드가 확인되었습니다.', uM: '코드를 확인하고 재시도해 주십시오. 코드를 최근에 사용하신 경우 잠금 설정이 되어있을 수 있습니다. 20분 후 다시 시도해 주십시오.', av: '코드가 잠금 설정이 되어있을 수 있습니다. 30분 후 다시 시도해 주십시오.', aw: '할인이 적용되었습니다.', ax: '할인 코드', ay: '코드가 선택된 날짜에 적용 불가합니다.', az: '하지만 다른 날짜에는 사용 가능합니다.', aA: '원 가격{oldPrice}이 할인 가격{discountedPrice}으로 변경되었습니다.', aB: '원 가격{oldPrice}이 할인 가격{discountedPrice}으로 인하되었습니다.', aC: '삭제', uN: '코드가 확인되었습니다. 선실 등급을 먼저 선택하셔서 할인을 받으세요.', uO: '기프트카드를 사용하시려면 +49(0)40 547 541 222로 전화하십시오.', aD: '할인 코드가 활성화되었습니다.', aE: '할인 코드 입력하기', aF: '포인트', uP: '기타 서비스 추가', aG: '승선 우대', aH: '차고', aI: '보험', uQ: 'Plan with Confidence', aJ: '우대 차량', uR: '출발지 선택', uS: '도착지 선택', aK: '예매하기', uT: '22시간 크루즈 여행', uU: 'Cruises', uV: 'Cruises', uW: '상륙 시간 없음', py: '상륙 시간 없음', uX: '데이 인 헬싱키 크루즈', uY: '데이 인 리가 크루즈', uZ: '데이 인 스톡홀름 크루즈', u_: '출발 일자', u$: '본 선박은 장애가 있는 승객의 편의를 보장할 수 없습니다.', aL: '탈린에서 상륙 시간 없음', u0: '도착 일자', u1: '편도 크루즈', u2: '왕복 크루즈', aM: '메가스타 쇼핑 크루즈', u3: '편도 크루즈', u4: '왕복 크루즈', ne: '크루즈', aN: '크루즈 유형', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: '언어 선택하기', aV: '한국어', aW: '언어 설정을 변경하시겠습니까?', u5: '식사 선택하기', aX: '식사는 선내에서 현장구매가 가능합니다.', u6: '식사권이 매진되었습니다.', u7: '지금 식사 결제를 하시면 10%를 절약하실 수 있습니다.', u8: '식사', aY: '할인 코드 입력하기', u9: '선택 서비스', aZ: '예약에는 단 하나의 차량만 허용됩니다.', va: '코로나', a_: '코로나 테스트', vb: '아동 팔찌', vc: '마사지', vd: '승객', ve: '클럽원 가입 &rarr;', vf: 'https://clubone.tallink.com/join', vg: '로그아웃 &rarr;', vh: '클럽원 할인을 받고 간편하게 예매하세요.', a$: '선실 선택', vi: '선실 유형', vj: '선실', a0: '자전거, 전동 스쿠터', a1: '차량', a2: '차량', vl: '차량 선택', vm: '번호판 입력하기', a3: '요금 검색 중', a4: '오토바이', a5: '사이드카 포함 오토바이', a6: '주차 차량', a7: '번호판 정보는 기입력되었습니다.', a8: '쇼핑 차량', a9: '쇼핑 밴', ba: '모두 보기', bb: '밴', bc: '유개 화물차', bd: '길고 높은 차량 또는 트레일러 조합.', be: '트레일러 포함 차량', bf: '트레일러 포함 차량', bg: '트레일러 포함 차량', vB: '다른 버스편 추가', bh: '선실 서비스 예약하기', bi: 'Free gift', bj: '{count}개 서비스 선택', bk: '{count}개 서비스 선택', vC: '더 보기', bl: '이전 결과 보기', bm: '날짜', vD: '스페셜 크루즈', bn: '공지:', vE: '최저 가격 {price}', vF: '출항편 매진', vG: 'No departures on the selected date.', bo: '금액은 스웨덴 크로나로 표시됩니다.', bp: '선실 최저 가격 {price} 포인트', bq: '1인당 {price} 포인트 이상', br: '1인당 {price} 이상', bs: '선실 가격 {price} 부터', bt: '취소', bu: '계속', bv: '계속하시면 선실 설정이 초기화됩니다. 승객 정보는 저장됩니다.', bw: '선택하신 날짜에는 본 선실 유형이 매진되었습니다.', vH: '스페셜<br/>크루즈', vI: '차량 가격 {price} 부터', bx: '매진', by: 'Emission surcharge', bz: 'Emission surcharge is applied to passengers from age 6 to adult.', bA: 'Emissions surcharge to support climate action and cover costs from the EU Emissions Trading System', vQ: '{chars} 영문자 남음', vR: '체크인', vS: '체크아웃', vW: '선택 &rarr;', vX: '객실 선택', vY: '선택 후 최종 가격 보기', v3: '초기화 및 선택', bB: 'Bronze level', bC: 'Club level', wd: '클럽원 할인:', bD: 'Gold level', bE: 'Inactive club one', bF: '클럽원 번호', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=클럽원 계정 재활성화\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=클럽원 계정 재활성화\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=클럽원 계정 재활성화\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=클럽원 계정 재활성화\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=클럽원 계정 재활성화\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=클럽원 계정 재활성화\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=클럽원 계정 재활성화\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: '이메일:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=클럽원 계정 재활성화\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:international.sales@tallinksilja.com?subject=클럽원 계정 재활성화\">고객님의 클럽원 계정은 비활성화 상태입니다. 고객센터로 연락하시기 바랍니다.\n</a>', bQ: '클럽원 계정이 비활성화되었습니다. 고객센터에 연락하시기 바랍니다.', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: '전화번호:', b_: 'Platinum level', wg: '<a>로그인</a> 또는 <a>클럽원 가입</a>을 하셔서 할인과 포인트 적립 혜택도 받고, 쉽게 예매하세요.', b$: 'Silver level', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: '포인트 최대 사용 금액은 구매하시는 항목과 서비스에 따라 달라집니다.', wj: '가능한 클럽원 포인트 사용하기', wk: '클럽원 포인트는 바우처 코드와 동시 사용이 불가합니다.', wl: '사용 가능한 클럽원 포인트가 부족합니다.', b0: '아래 슬라이더에서<a>클럽원 포인트로 결제하실 수 있습니다</a>.', wm: '클럽원 포인트는 ({reason})로 인해 사용 불가합니다.', pQ: '코드', wp: '입력하신 문자 중 허용되지 않는 특수 기호가 있습니다.', wr: '생년월일', ws: '일', wt: '월', wu: '년', wv: '{count} {count, plural, one{성인} other{성인}}', ww: '({range}세)', wx: '도착 시간 {time}', pT: '{count} {count, plural, one{아동} other{아동}}', wy: '무료', wz: '접기', wA: '펼치기', wB: '국적', wC: '상용', b1: '본 요금은 클럽원 {level} 할인이 적용되었습니다.', wD: '클럽원 승객은 지금 입력되어야 하며, 나머지 승객 정보는 추후에도 입력 가능합니다.', b2: '포인트', b3: '클럽원 포인트 사용하기', b4: '준비 중 입니다.', wE: '예매 전 클럽원 번호를 추가하세요.', wF: '완료', wG: '변경 &rarr;', b5: '신속한 체크인과 예매 내역 및 탑승권 공유를 위해 모든 승객의 전화번호와 이메일을 입력해 주십시오.', wH: '이름', wI: '성별', wJ: '여성', wK: '남성', wL: '가격에 포함', mh: '입력 사항을 확인하십시오.', wM: '본 이메일은 비상연락처 또는 다른 승객으로 등록되어 있습니다.', wN: '본 전화번호는 비상연락처 또는 다른 승객으로 등록되어 있습니다.', wO: '성', wP: '필수 입력 사항(*)을 입력하시고 저장하세요.', wQ: '조식', wR: '브런치', wS: '뷔페', wT: '석식', wU: '중식', wV: '알라카르트 예약', wW: '식사는 선내에서 현장구매가 가능합니다.', wX: '이름은 영문으로 입력해 주십시오.', wY: '불가', b6: '본 여정에는 불가', wZ: '불필요', b7: '성인\n만 18세 이상', b8: '아동\n만 0-5세', b9: '아동\n만 6-11세', ca: '아동\n만 12-17세', cb: '은행', w_: '{price} 결제', cc: '{price} 결제 중', cd: '카드', w$: '{price} 예매 확인', w0: '{price} 예매 확인 중', ce: '{price} 클라르나(Klarna)로 결제', cf: '결제가 진행 중입니다.', w1: '<p>The combination of travel services offered to you is a package within the meaning of Directive (EU) 2015/2302. </p>\n<p>Therefore, you will benefit from all EU rights applying to packages. AS Tallink Grupp will be fully responsible for the proper performance of the package as a whole.</p>\n<p>Additionally, as required by law, AS Tallink Grupp has protection in place to refund your payments and, where transport is included in the package, to ensure your repatriation in the event that it becomes.</p>\n<p><a href=\"https://www.tallink.com/good-to-know/package-travel\" target=\"_blank\">View the terms of travel packages</a>.</p>', pU: '<p>제시되는 여행 서비스는 유럽 연합 지침 Directive (EU) 2015/2302이 적용되는 패키지입니다.</p>\n<p>그러므로 패키지에 해당되는 유럽연합의 권리를 누리실 수 있습니다. 패키지 전반적인 운영에 {name}가 전적으로 책임을 집니다.</p>\n<p>추가적으로, 법에 명시된 바와 같이 {name}에 의해 환불 제도를 시행하고 있으며, 패키지에 교통 수단이 포함되어 있을 경우에는 유사시 무사히 해당 목적지로 도착하도록 보장하고 있습니다.</p>\n<a href=\"{url}\" target=\"_blank\">여행 패키지 규정 보기 (영문)</a>.', w2: 'By pressing the payment button, you agree with <a href=\"https://www.tallink.com/good-to-know/rights-of-passengers\" targe=\"_blank\">terms and conditions</a> and the rules and regulations related to <a href=\"https://www.tallink.com/good-to-know/club-one\" targe=\"_blank\">Club One loyalty program</a>.', w3: '결제 버튼을 누름으로써, <a href=\"https://www.tallink.com/good-to-know/payment-and-cancellation-policies\" target=\"_blank\">크루즈의 규정과 조건</a>에 동의하게 됩니다.', w4: '탈린크 그룹 주식회사', w5: 'https://www.tallinksilja.com/packaged-tours-tallink-grupp', w6: '탈린크 실야 주식회사', w7: 'https://en.tallink.com/packaged-tours-tallink-silja', w8: '만 18세 이하의 승객께서는 <a href=\"https://www.tallink.com/good-to-know/age-regulations\" target=\"_blank\">연령 제한 규정</a>을 숙지하여 주십시오.', w9: 'Alipay', xa: 'Apple Pay', xb: '지역 은행', xc: '카드', xd: 'Google Pay', xe: '모바일 페이', xf: '직불/신용 카드', xg: 'WeChat Pay', xh: '온라인 뱅킹 및 직불/신용 카드', xi: '지역 은행', xj: '온라인 뱅킹', cg: '가격 {price} 부터', xk: '설정은 상단에 있습니다.', xl: '선택', xm: '선택됨', xn: '선박', xo: '날짜 {date} 시간 {time}', xp: '{count} {count, plural, one{승객} other{승객}}', xq: '성인\n만 18세 이상', xr: '아동\n만 0-5세', xs: '아동\n만 6-17세', xt: '선실을 먼저 선정해 주십시오.', xu: '올란드의 도착 지점은 롱내스 항구입니다. (마리함에서 30 km 거리)', xv: '롱내스 도착', xw: '올란드의 출발 및 도착 지점은 롱내스 항구입니다. (마리함에서 30 km 거리)', xx: '올란드의 출발 지점은 롱내스 항구입니다. (마리함에서 30 km 거리)', xy: '롱내스에서 출발', pV: '차량', xz: '차량', ch: '발틱 퀸 22시간 크루즈', ci: '크루즈', cj: '왕복 크루즈', ck: '구간 크루즈', cl: '편도, 왕복, 데이 티켓', xB: '회사 고객', xC: '에이전트 아이디', xD: '입력된 정보로는 에이전트를 찾을 수 없습니다.', xE: '알림: 에이전트 아이디는 필수 항목입니다.', xF: '개인 계정에서 임시적으로 로그아웃됩니다.', xG: '회사 아이디', xH: '입력된 정보로는 회사 고객을 찾을 수 없습니다.', cm: '예약 확인서가 전송되었습니다.', cn: '예약이 확정되었습니다. 즐거운 여행 되세요!', co: '환불 금액 {refund}가 지급됩니다.', cp: '환불 진행을 위해서는 고객 센터로 연락주십시오.', cq: '예매 내역이 업데이트 되었습니다.', xI: '성인', xJ: '도시명', xK: '결과 없음', xL: '버스 환승지 찾기', xM: '버스 환승', cr: '아동 만 6 - 17세', cs: '예약 변경', xN: '기본 티켓', xO: '아동 만 {range}세', ct: '지상 엔터테인먼트', cu: '아니오', cv: '네', cw: '탈린크 실야 프로모션을 이메일로 수신하시겠습니까?', cx: '뉴스레터를 구독해주셔서 감사합니다.', cy: '고객 센터로 전화', cz: '취소', xP: '입력하신 생년월일이 기존의 연령대와 불일치합니다. 출생일을 수정하시거나 고객 센터에서 연령대를 변경하시기 바랍니다.', cA: '연령대를 변경하시겠습니까?', cB: '서비스 구매하기', cC: '서비스 변경하기', cD: '주소', cE: '회사', cF: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contactss\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cG: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cH: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallink.com/ee-et/hea-teada/kontaktid\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cI: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallinksilja.fi/palvelunumerot\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cJ: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallink.lv/lv/contacts\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cK: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallinksilja.com/contact-us\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cL: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallinksilja.ru/agents\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cM: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallinksilja.se/kontakta-oss\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cN: '예매 내역을 변경하시려면, 본사의 <a href=\"https://www.tallinksilja.com/contact-us\">고객 서비스 센터</a>로 연락하시기 바랍니다.', cO: '연락처 이름', cP: '연락처', cQ: '예매 내역을 변경하시려면 여행사에 연락하십시오.', cR: '이메일', cS: '클럽원 가입하기', cT: '예매 확인서', cU: '체크인은 출발 전 2시간부터 가능합니다. 차량 체크인은 출발 전 45분 전에 종료됩니다.', cV: '개인 승객의 모든 항목을 입력해주시기 바랍니다.', cW: '취소', cX: '계속', cY: '계속하시면 승객 정보 변경내역이 저장되지 않습니다.', cZ: '변경사항이 저장되지 않습니다.', c_: '확인서 PDF로 보기', c$: '이메일 PDF 영수증에서 결제 내역을 확인하세요.', c0: '규정과 조건 보기', c1: 'https://www.tallink.com/good-to-know/general-travel-conditions', xQ: '총 금액', c2: '전화번호', c3: '예매 번호', c4: '보안 번호', c5: '확인서', c6: '출발 및 도착 시간은 항상 현지 시간으로 표기됩니다.', c7: '탑승권은 터미널 셀프 체크인에서 수령하실 수 있습니다. 8자리 예약번호와 보안코드를 준비하세요.', c8: '체크인 데스크에 미리 도착하시기를 권장합니다.', c9: '일반 승객께서는 출항 30분 전까지, 차량을 동반하는 승객께서는 출항 1시간 전까지 체크인 데스크에 도착하셔야 합니다. 단, 탈린/스톡홀름에서 마리함까지 가시는 차량 동반 승객께서는 출항 1.5시간까지 체크인하셔야 합니다.', da: '체크인 전 탑승권을 수령하지 않은 상태에서 탈린크 본사 측에서 크루즈가 취소된 경우', db: '여행 중에는 여권을 항상 소지하여야 합니다(아동 포함). 비자 필요 여부를 확인하고자 하실 경우 해당 국가의 대사관에 의뢰하시기 바랍니다.', dc: 'The ship\'s arrival and departure times are always shown in local time. <br>\nYou can check in online, in the Tallink Silja Line app, or at the terminal. <br>\nAt Paldiski and Kapellskär ports, check-in for vehicle passengers closes 75 minutes before the Superfast ferry\'s departure. We recommend arriving at the port early. <br>\nCabin cards will be issued on the check-in. <br>\nEvery passenger (including children must carry a valid travel document and any other \nnecessary papers, such as a visa if required, for the entire journey. <br>\nPassengers are responsible for the validity and accuracy of their documents.', dd: '고객님의 여행 정보', de: '알아두면 좋은 팁', df: '환불', dg: '환불 금액 {refund}가 지급됩니다. 고객 센터로 환불 요청을 하십시오.', dh: '전화로 환불 요청을 하십시오.', di: '환불이 진행되면 공지문이 뜨지 않습니다.', dj: '환불 요청을 하십시오.', xR: '연결 문제가 계속되면 고객 센터에 연락주십시오.', xS: '인터넷 연결이 안될 때는 초기 화면에서 재시도하시기 바랍니다.', xT: '재시도', xV: '계속', xW: '진행 및 결제', pX: '이메일 주소', xX: '예시', dk: '국가코드 및 전화번호', xY: '연락처 정보', xZ: '예약 확인서를 받으실 연락처를 기입하십시오. 클럽원 혜택을 사용하시려면 로그인하시거나 결제 전 승객 정보 창에서 클럽원 멤버십 번호를 입력하십시오.', x_: '본 정보는 고객님의 클럽원 계정에 반영됩니다.', pY: '전화번호', dl: '예시: 1012345678', x$: '기타', x0: '예매 확인서가 {email}로 전송되었습니다.', dm: '추가 이메일', dn: '우편번호', x6: '테스트 당 {price}', x8: '<b>新しい予約システム</b>でこの旅行をより早く予約できます。', dp: '성명', dq: '신용카드', dr: '월', ds: '신용카드 번호', dt: '결제 방식', du: '보안 코드', dv: '신용카드 선택', dw: '유효기간', dx: '년', dy: '스톡홀름(카펠샤)-투르쿠-스톡홀름(카펠샤) 크루즈', ya: '헬싱키 크루즈', yb: '비즈비 크루즈', dz: '투르쿠-스톡홀름(카펠샤)-투르쿠 크루즈', yc: '의스타드 경유 크루즈', dA: '데이 인 헬싱키 크루즈', dB: '데이 인 리가 크루즈', no: '데이 인 탈린 크루즈', yj: '데이 인 투르쿠 크루즈', yr: '디저트', dC: '할인', yy: '적용됨', yz: '프로모션 코드 또는 기프트 카드', p9: '할인 및 기프트 카드', dD: 'Don’t forget to select one menu option for each adult passenger in {restaurant} reservation.', dE: 'Don’t forget to select one menu option for each 12 years and older passenger in {restaurant} reservation.', yB: '이 기회를 놓치지 마세요!', yD: 'Choose drink package', dF: '같은 구간의 미결제된 예약건이 발견되었습니다. 참조번호: {resId}, 가격: {price} {unit}. 이전 예약건을 취소하고 새 예약건 결제를 진행하시겠습니까? <a href=\"{link}\">이전 예약 내역 열고 결제하기  →</a> 자세한 사항은 고객 지원 센터로 연락주시기 바랍니다.', yF: '객실 수정', yG: '객실 수정', yO: '지상 엔터테인먼트', yP: '지상 및 호텔 엔터테인먼트', yS: '승객 전원이 차량에 탑승할 수 있어야 합니다.', dK: 'https://clubone.tallink.com/', yY: '기타 서비스', dL: '피드백 남기기', y_: '선박', y$: '선박 + 호텔', y5: 'Choose menu', y7: '음식 알레르기 / 식단 제한', kS: '출발지', za: 'Emission and fuel surcharge', zb: 'Fuel and emissions surcharges are applied to passengers from age 6 to adult.', zc: 'Fuel and emissions surcharges apply to passengers aged 12 and over. Up to three children aged 6–11 per booking are exempt.', zd: 'Fuel and emissions surcharges to support climate action and cover costs from the EU Emissions Trading System.', dM: '유류할증료', dN: 'Fuel surcharge is applied to passengers from age 6 to adult.', dO: '만 6세 이상의 승객 당 부과되는 크루즈 유류할증료는 {price}입니다.', dP: '만 6세 이상의 승객 당 부과되는 구간당 유류할증료는 {price}입니다.', zh: '기프트 카드 :', zi: '기프트 카드는 금액이 소진될 때까지 여러번 사용하실 수 있습니다.\n기프트 카드 잔여 금액은 {priceLeft} €입니다.', dQ: '단체 메뉴 가능', zm: '성인 단체 12인 이상 예매 시에는 개별 메뉴를 선택해주시기 바랍니다. 어린이 승객 분들은 키즈 메뉴 (25€)가 자동으로 배정됩니다.', dR: '헬싱키', dS: '선상에서의 2박 &<br>리가에서의 주간 관광', dT: '22시간 탈린 왕복 크루즈 &<br>4시간 탈린 도심 관광', dU: '탈린 크루즈<br> 탈린 관광시간이 5 시간 주어집니다.', dV: 'Visby cruises', dW: 'Summer special cruises to the magical Gotland island', dX: '해르뇌산드 (Härnösand)', zv: '호텔', zy: '이외의 날짜를 선택하시려면 <a>여행 날짜 변경</a>을 해주십시오.', dY: '체크인', dZ: '체크인 시간', d_: '체크아웃', d$: '체크아웃 시간', d0: '박', d1: '박', zz: '호텔만 예매하시려면 별도의 양식을 작성해 주십시오.', zA: '선택된 날짜에는 호텔 룸이 없습니다. 다른 날짜를 선택해주십시오.', zB: '체크아웃 하신 후에는 체크인이 불가능합니다. 체크인 탭에서 날짜를 조정해주십시오.', zC: '체크인을 하셔야 체크아웃이 가능합니다. 체크인 탭에서 날짜를 조정해주십시오.', zD: '체크인 날짜입니다. 변경하시려면 체크인 텝을 이용해주십시오.', zE: '체크아웃 날짜입니다. 변경하시려면 체크아웃 탭을 이용해주십시오.', qF: '여행 날짜와 일치하지 않습니다. 선택하시려면 여행 날짜를 먼저 변경해주십시오.', zF: '1박 여행: 선상 숙박 포함.', zG: '1박 여행: 선상 숙박 포함.', zW: '음식 알레르기와 식이 제한 내용은 선내 직원에게 전달되었습니다.', q4: '클럽원 가입', AB: '예매시 할인 혜택, 포인트 적립', d2: '도로명 주소', d3: '도시', d4: '국가', d5: '클럽원 가입 마치기', AC: '우편번호', AD: '클럽원에 가입하시려면 가입자가 승객 명단에 포함되어야 합니다.', d6: '이메일', d7: '우편', d8: 'SMS', d9: '선호 언어', ea: '클럽원 프로모션과 뉴스를 수신하겠습니다.', eb: '아니오', ec: '저장 및 창닫기', ed: '네', AF: '클럽원 가입을 환영합니다! 예매 후 나머지 정보를 입력하시면 됩니다.', AG: '클럽원에 오신 것을 환영합니다. 가입과 동시에 회원 할인을 받으셨습니다. 일반 가격 {priceBefore} → 할인 가격 {currentPrice}', AH: '기존의 클럽원 계정이 존재합니다.', ee: '카펠샤 (Kapellskär)', ef: '어린이 메뉴 바우처', AN: '본 예매를 확정함으로써 고객님의 정보가 클라르나로 전송되어 결제됨에 동의하시게 됩니다. 더 읽기:', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: '클라르나의 개인 정보 사용', AQ: 'Klarna & Swish', AR: 'Invoice, part payment', AS: '클라르나 (Klarna)', AT: '청구서 결제', AU: '부분 결제', AV: 'Swish', AW: '결제 수단은 예약 종류에 따라 달라집니다. 자주 이용되는 결제 수단은:다음과 같습니다.', eg: '클라르나 체크아웃', eh: '클라르나는 모바일 결제를 보다 빠르고 안전하게 합니다.', ei: '클라이페다 (Klaipeda)', ej: '편도 또는 왕복 크루즈<br>매일 19:00 출항', A$: '독일어', A0: '영어', A1: '에스토니아어', A2: '핀란드어', ek: '리투아니아어', A3: '라트비아어', A4: '러시아어', A5: '스웨덴어', Bb: '검색 중', Bc: '헬싱키', Bd: '유르말라', Be: '콜모르덴', Bf: '쿠레사아레', Bg: '라우라스마아', Bh: '마리함', Bi: '나르바', Bj: '노르쇠핑', Bk: '오테패애', Bl: '파르누', Bm: '라크베레', Bn: '리가', Bo: '쇠데르탤리에', Bp: '스톡홀름', Bq: '타르투', Br: '투르쿠', Bs: '탈린', Bt: '탐페레', Bu: '웁살라', Bv: '반타', Bw: '비훌라', BC: '메인 코스', BE: '추가하기', BF: '일자:', BG: '{price} / 트리트먼트', BH: '시각:', Cf: '{direction} 구간에는 식사 제공되지 않음', Cg: '식사 패키지는 항해 전반의 식사를 포함합니다.', Ch: '식사 패키지 선택하기', el: '선택되지 않음', em: '<span class=\"data\">{count}</span> {count, plural, one{# 조식} other{# 조식}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# 석식} other{# 석식}}', rt: '아동 할인이 있으며 성인을 동반한 만 0-5세의 유아는 무료 입장입니다. \n\n석식 바우처는 그랜드 뷔페나 기타 식당에서 사용하실 수 있습니다.', Ci: '{price} / 18세 이상', Cj: '{price} / 성인', Ck: '{price} / 인', Cl: '<span class=\"bodySmall\">최대</span><span class=\"bodyLarge percentage\">15%</span><span class=\"save bodySmall\">할인 받으세요</span>', Cm: '식사 패키지', Cn: '{count, plural, one{#인} other{#인}}', Co: '인당', Cp: '예약', ru: '식사 패키지 혜택을 누리세요.', eo: '테이블 예약하기', ep: '매진', eq: '조식', er: '석식', Cq: '식사', es: '바우처', Cr: '항해 중 식사 포함', Cs: '온라인 예매 특별가로 <b>식사 가격 최대 10% </b>할인을 받으세요!', et: '회의실', eu: '{date} {time}부터 {duration} 시간', Ct: 'Menu available', Cu: 'We kindly ask you to select one menu option for each passenger aged 12 and older in the booking. Passengers under 12 will get a meal coupon with their reservation and can choose their meal onboard. Children get at least 50% discount from the normal price.', ew: '승객 정보 입력하기', ex: '승객 정보 보기', ey: '클럽원', CA: '클럽원 정보를 변경하시려면 고객 센터로 연락하십시오.', ez: '승객 정보 누락', eA: '8자리 예약 번호와 보안 코드를 체크인 데스크에 제시하십시오. (인쇄 불필요)', eB: '연령대 오류', eC: '승객 정보 누락', eD: '미결제', eE: '번호판 수정', eF: '번호판 정보 누락', eG: '번호판 정보 미입력', eH: '휴대폰으로 예매 내역 받기', eI: '받기', eJ: '열기', eK: '링크 보내기', eL: '탈린크 실야 앱', eN: '무우가', CJ: '상륙 시간 없음', CK: '목적지 내에서 차량 이용이 불가합니다', CL: '선택하신 크루즈 유형에 적합한 출항 계획이 없습니다. 다른 크루즈를 선택해 주십시오.', CM: '결제 중에 오류가 발생하였습니다. 재시도 하시거나 이메일 <a href=\"mailto:international.sales@tallinksilja.com\" target=\"_blank\">international.sales@tallinksilja.com</a>로 연락주십시오.', ol: '괜찮습니다', CU: 'This code makes your ticket non-refundable. Read more about the specific <a href=\"#\">terms →</a>.', CV: '<ul>\n<li>It is not permitted to change the direction and/or route, departure date or time of the ticket.</li>\n<li>The passenger´s personal data, cabin class, vehicle and onboard service may be changed. When making such changes, the price difference between the originally purchased service and the amended service must be paid.</li>\n<li>If the passenger cancels the ticket, Tallink Silja Line will retain 100% of the ticket price as a contractual penalty.</li>\n<li>In all other matters, the travel conditions of AS Tallink Grupp apply, which are available at <a target=\"_blank\" href=\"https://www.tallink.com/terms\">terms page</a>.</li>\n</ul>', CW: 'Terms & Conditions', CX: 'yes, I Accept', CY: 'remove code', CZ: 'You are buying a non-refundable ticket using code <b>{code}</b>. After purchase, this ticket cannot be refunded under any circumstances. You can only change the passenger’s personal details, cabin class and services. Changes to direction, route, departure date or time are not available. Please confirm that you understand and accept these terms before proceeding to payment.', C_: 'Non-Refundable Ticket', eO: '포인트 부족', C0: '예매 진행하기', C1: '예매 초기화', C2: '뒤로 가기를 누르시면 예매가 초기화됩니다. 처음부터 시작하시겠습니까?', C3: '예매를 초기화 하시겠습니까?', eP: '착항 항구는 스톡홀름에서 90km 거리인 카펠샤 항구입니다.', eQ: '출항 항구는 스톡홀름에서 90km 거리인 카펠샤 항구입니다.', eR: '출항 및 착항 항구는 스톡홀름에서 90km 거리인 카펠샤 항구입니다.', Da: 'Bubble fair', eS: 'Insurance', Db: '프렌드십 팔찌', Dc: '어린이 패키지', Dd: '탑승 우대', De: '선상 서비스', Df: '크루즈 머니', Dg: '쿠폰', Dh: '크루즈 머니 쿠폰', Di: '좌석', Dj: '선상 서비스', Dk: '1일', eT: '편도 또는 왕복 크루즈<br>매일 출항', Do: '또는', Dp: '기타', eU: '기타 결제 수단', eX: '12세 이상', eY: '팔디스키 (Paldiski)', eZ: '주차 차량 (밴)', DI: 'Party on Baltic Sea', DJ: 'Baltic Sea - Tallinn', e_: '승객의 연령대는 변경할 수 없습니다.', DM: '올바르지 않은 연령대입니다 – 성인의 생년월일을 입력해 주십시오.', DN: 'Incorrect age group – make sure the date of birth corresponds to an adult or a youth.', DO: '일-월-년의 순으로 날짜를 입력해 주십시오. (예시: 1980년 5월 15일 → 15.05.1980)', DP: '생년월일은 숫자로 입력해 주십시오.', DQ: '나중에 입력하기', DR: '저장', DS: '성함과 클럽원 번호를 확인해 주십시오.', DT: '클럽원 번호', DU: '이미 입력되었습니다.', DV: '내역 수정 또는', DW: '처음부터 시작하기', DX: '여권 정보는 클럽원 계정에 추가됩니다.', DY: '발행관청', DZ: '기간만료일', D_: '발급일', D$: '여권번호', D0: '여권종류', D1: '국적', D2: '특수 보조', D3: '<a href=\"https://www.tallink.com/good-to-know/special-needs-and-assistance\" target=\"_blank\">본사 홈페이지</a>에 상세 정보를 기입하시거나 고객 센터에 전화하시기 바랍니다.', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: '승객 추가', Ec: '<span class=\"data\">{count}</span> {count, plural, one{승객} other{승객}} 선택됨', Ed: '즉시 또는 추후에 입력하세요.', Ee: '승객 정보 기입 완료', Ef: '승객', e0: '준비 중', e1: '예약 번호 (booking number)', e2: '신용 카드', e3: '제거', Ei: '결제', e4: '결제 수단 선택', Ej: '청구서', Ek: '청구서 주소', e5: '회사 청구서로 결제하기', El: '참조 번호 (reference number)', e6: '추후에 결제', e7: '간편한 모바일 결제', e8: '예액 내역을 보존하시려면 지금 결제하세요.', e9: '온라인 뱅크', fa: '일반 네트워크 비용', fb: '일반 네트워크 요금 부과', fc: '전화 요금: 85 센트/1회 + 통신 요금', fd: '전화 요금은 8.35 센트/1호 + 16.69 센트/분', fe: '일반 네트워크 요금 부과', ff: '일반 네트워크 요금 부과', fg: '일반 네트워크 요금 부과', fh: '일반 네트워크 요금 부과', fi: '일반 네트워크 요금 부과', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: '고객 센터 전화하기', fk: '미결제된 예약은 자동으로 취소됩니다.', fl: '결제에 문제가 발생하였습니다. 재시도하시거나 전화 바랍니다.', fm: '<u>국가 설정</u>을 원상태로 변경하고 결제를 진행해주시기 바랍니다.', fn: '예매가 다른 지역 설정에서 이루어졌습니다.', Ex: '그리고 {points} 포인트', r0: '인', EA: '인', EH: 'D 터미널', EI: '프리함넨', EK: '카펠샤', EL: '롱내스', EM: '서부 터미널 2', EN: '서부 터미널', EO: '서부 터미널', EP: '상트페테르부르크', EQ: '마리함', ER: '무우가 항구', ES: '올림피아 터미널', ET: '팔디스키', EU: '리가 터미널', EV: '사스니츠', EW: '투르쿠 항구', EY: '배르타함넨', EZ: '비즈비', E_: '벤츠필스', E$: '부오사아리 항구', E5: '사전 선택', E6: '예매하기', E7: '취소', E8: '계속', E9: '완료', fo: '다음', Fa: '최저 가격 선실', Fb: '최저 가격 선실 (클럽원 회원가)', Fc: 'Club One price', Fd: '선실을 추가하여 주십시오.', Fe: '선실 추가 후에 최종 가격이 제시됩니다.', fp: '선실 유형을 선택해주십시오.', Ff: 'Subtotal:', Fg: '총 금액', fq: '클럽원 가격', Fh: '가격 확인', Fj: 'Price starting from per traveller/vehicle, includes emission and fuel surcharge.', Fl: '{price} / 개', sa: '진행하기', fr: '결제 진행하기', Fs: '본 사이트는 reCAPTCHA와 Google에 의해 보호받고 있습니다. \n<a target=\"_blank\" href=\"https://policies.google.com/privacy?hl=KO\">프라이버시 방침</a>과\n<a target=\"_blank\" href=\"https://policies.google.com/terms?hl=KO\">서비스 규정</a>이 적용됩니다.', ft: '선상 서비스 변경:<br>\n금-토 출항편에는 라이브 음악, 노래방, 빙고가 있습니다.<br>\n일-목 출항편에는 서비스가 제한됩니다.', fu: '일반 가격', Fy: '현재 시간 설정을 해지하시고 이것을 선택해주십시오.', FA: 'Reservation fee {fee} will be deducted from the final bill.', FB: 'The reservation fee does not apply to children up to 5 years old.', sq: '닫기', FD: '오류가 발생하였습니다. 페이지를 새로고침하시거나 처음부터 예약을 진행해주십시오.', FE: '해당 기간의 크루즈를 찾지 못했습니다.', fv: '초기화', fw: '불편을 끼쳐드려 죄송합니다. 현재의 예약 내역은 자동으로 취소됩니다.', fx: '페이지가 만료되었습니다.', FF: '초기화', FG: '처음부터 다시 시작하셔야 합니다. 불편을 끼쳐드려서 죄송합니다.', FH: '오류 발생', fz: '리가', fA: '선상에서의 2박 &<br>클라이페다에서의 주간 관광', fB: '편도 또는 왕복 크루즈<br>매일 17:00 출항', fC: '스톡홀름-투르쿠-투르쿠-스톡홀름(카펠샤)', fD: '스톡홀름(카펠샤)-투르쿠', fE: '스톡홀름(카펠샤-투르쿠-투르쿠-스톡홀름', fF: '투르쿠-스톡홀름-스톡홀름(카펠샤)-투르쿠', fG: '투르쿠-스톡홀름(카펠샤)', fH: '투르쿠-스톡홀름(카펠샤)-스톡홀름-투르쿠', fI: '목록으로 돌아가기', fJ: '요청하신 은행을 찾지 못하였습니다. 목록에서 찾아보시기 바랍니다.', fK: '검색', fL: '사스니츠 (Sassnitz)', fN: '최소 한 대의 차량을 선택해 주십시오.', Ge: '차량을 추가하시면 <b>{service} 서비스가 </b>제거됩니다. 진행하시겠습니까?', Gf: '수락하시겠습니까?', Gv: '쇼핑 크루즈', Gw: '매일 헬싱키에서 연속으로 출항하는 쇼핑 크루즈 셔틀입니다. 총 왕복 항해 시간은 5시간이며 탈린에서 하선하지 않습니다. 선내에서 대량 구매시 할인을 받으실 수 있습니다. 구매량이 많은 경우 차량을 동반하실 것을 권해드립니다. 메가스타에서는 항해 중 차량을 데크 7의 트래블러 슈퍼스토어 근처로 이동할 수 있습니다. 스타에서는 차량 데크에 주차합니다.', Gy: '본 소요 시간은 5시간 쇼핑 크루즈에 적용됩니다. 해당 페이지로 이동합니다.', fO: '5시간 쇼핑 크루즈 (차량 허용) \n메가스타 또는 스타', GE: '테이블 예약 보기', fP: '사아레마아 (Saaremaa)', GK: 'As a 15-17 year old you can travel without being accompanied by an adult. Remember to bring your <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\">travel permit</a> with you. Safe travels!', fQ: '상트페테르부르크', GQ: '스타터', fR: '스톡홀름', GY: '스톡홀름-헬싱키 구매', GZ: '선택한 날짜에 스톡홀름에서 탈린으로 가는 직항 노선은 없지만 헬싱키를 경유하여 그곳에서 배를 탈 수 있습니다.', G_: '중요! 배를 갈아타려면 올림피아 터미널에서 서쪽 터미널 2로 환승해야 합니다.', G$: '스톡홀름 -> 탈린 <br/> 헬싱키 경유', fS: '알콜성 음료는 시간 제한이 있음에 유념해 주십시오.', fT: '선상에서의 2박 및 비즈비에서의 주간 관광 - 실야 심포니는 올 여름 스톡홀름-비즈비 구간을 운항합니다.', fU: '선상에서의 2박 및 비즈비에서의 2일 - 비즈비에서의 숙박과 고트랜드 관광 시간이 추가된 크루즈 일정입니다. 선상에서는 면세 가격의 다양한 상품들을 구매하실 수 있습니다.', fV: '스톡홀름(카펠샤)', fW: '선상에서 3박 일정으로 의스타드와 비즈븨를 하루씩 구경하세요.', fX: '추가 요금', fY: '탈린', G8: 'Tallinn - Baltic Sea', fZ: 'Tallinn - Baltic Sea - Tallinn', f_: '선상에서의 2박 &<br>리가에서의 주간 관광', G9: '헬싱키-탈린 구매', Ha: '선택한 날짜에 탈린에서 스톡홀름으로 가는 직항 노선은 없지만 헬싱키를 경유하여 그곳에서 배를 탈 수 있습니다.', Hb: '중요! 배를 갈아타려면 서쪽 터미널 2에서 올림피아 터미널로 환승해야 합니다. <b>13:30 출발을 선택하면 대중교통을 이용해 환승할 시간이 충분하지 않을 수 있습니다.</b>', Hc: '탈린 -> 스톡홀름 <br/> 헬싱키 경유', f$: '선상에서의 2박<br>투르쿠 주간 관광', f0: '편도 또는 왕복 크루즈<br>투르쿠 매일 출항', f1: 'Visby cruises', f2: 'Summer special cruises to the magical Gotland island', tb: '정보 감사합니다', td: '귀항편 추가', f3: '귀항편을 예약하시고 최대 30% 할인을 받으세요.', f4: '출항과 귀항편이 같은 날짜입니다. 데이 크루즈 할인 가격이 적용됩니다.', o6: '도착', f5: '이후의 출발 일자를 원하십니까?', f6: '{direction} 구간 날짜 정하기', f7: '초기화', Hx: '날짜 선택하기', f8: '23시간 크루즈 (저녁)', f9: '23시간 크루즈 (아침)', ga: '데이 인 스톡홀름', gb: '데이 인 투르쿠', o7: '출항', Hy: '오후', Hz: '오전', te: '소요 시간', tf: '시간', HA: 'Spend the first night onboard ship and leave as you wish between 8–11.', HB: 'First night on ship', HC: '본 출항편을 선택하시면 크루즈+호텔 패키지 적용이 불가합니다.', HD: '본 귀항편을 선택하시면 크루즈+호텔 패키지 적용이 불가합니다.', HE: '마지막 선택가능한 날짜로 가기', HF: '선박만 선택하기', HG: '예매 불가', gc: '귀항편 삭제하기', gd: '메가스타 쇼핑 크루즈', ge: '닫기', gf: '메가스타 또는 스타 호 쇼핑 크루즈는 승객 및 차량 할인이 적용됩니다. 탈린에서 하선하지 않습니다.', gg: '메가스타 쇼핑 크루즈', gh: '선상에서의 1박 & 탈린에서의 4시간 관광', gi: '스톡홀름 저녁 출항, 상륙 시간 없음', gj: '스톡홀름 아침 출항, 상륙 시간 없음', gk: '선상에서의 2박 & 투르쿠에서의 주간 관광', gl: '투르쿠 저녁 출항, 상륙 시간 없음', gm: '투르쿠 아침 출항, 상륙 시간 없음', gn: '왕복 크루즈 헬싱키-스톡홀름-헬싱키', go: '헬싱키-스톡홀름 편도행', gp: '왕복 크루즈 헬싱키-탈린-헬싱키', gq: '데이 인 탈린', gr: '헬싱키-탈린 편도 크루즈', gs: '메가스타 쇼핑 크루즈', gt: '리가-스톡홀름-리가 왕복 크루즈', gu: '리가-스톡홀름 편도 크루즈', gv: '스톡홀름-헬싱키-스톡홀름 왕복 크루즈', gw: '스톡홀름-헬싱키 편도 크루즈', gx: '왕복 크루즈 스톡홀름-리가-스톡홀름', gy: '스톡홀름-리가 편도 크루즈', gz: '스톡홀름-탈린-스톡홀름 왕복 크루즈', gA: '스톡홀름-탈린 편도 크루즈', gB: '스톡홀름-투르쿠-스톡홀름 왕복 크루즈', gC: '스톡홀름-투르쿠 편도 크루즈', gD: '탈린-헬싱키-탈린 왕복 크루즈', gE: '데이 인 헬싱키', gF: '탈린-헬싱키 편도 크루즈', gG: '탈린-스톡홀름-탈린 왕복 크루즈', gH: '탈린-스톡홀름 편도 크루즈', gI: '투르쿠-스톡홀름-투르쿠 왕복 크루즈', gJ: '투르쿠-스톡홀름 편도 크루즈', HH: '호텔 포함', tg: '크루즈', gK: '데이 인 헬싱키 크루즈', gL: '데이 인 탈린 크루즈', gM: '데이 인 올란드 크루즈', gN: '데이 인 스톡홀름 크루즈', gO: '탈린 크루즈', gP: '9h Cruise', gQ: '데이 인 스톡홀름 크루즈', gR: 'Cruises', gS: '데이 인 올란드 크루즈', gT: 'Cruise to Helsinki', gU: '데이 인 스톡홀름 크루즈', gV: '22 h Cruise', gW: 'Cruises', gX: '이중 목적지 크루즈', gY: '숨기기 &uarr;', gZ: '더 보기 &darr;', g_: '구간 크루즈', le: '도착지', g$: '성인이 자동 추가되었습니다. 예매 건당 성인이 포함되어야 합니다.', g0: '차고 예약이 삭제되었습니다. 비즈니스 라운지에는 차량 우선 하선권(Priority car)이 자동 포함됩니다.', g1: '차량 우선 하선권(Priority car)은 비즈니스 클래스에 포함되어 있는 혜택입니다.', g2: '선택된 티켓 유형이 매진되었습니다. 선택을 달리해주시기 바랍니다.', HP: '차량 번호판 정보가 이미 입력되었습니다.', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: '본 버스편은 해당 일자에 예약이 불가합니다.', g5: '본 버스편은 예약이 불가하므로 자동 삭제되었습니다.', HQ: '{name}님 안녕하세요.', g6: '본 예약건을 클럽원 포인트로 결제하시려면 {clubOnePoints} 포인트가 필요합니다.', g7: '이전의 승객 정보가 누락되었습니다. 모든 필수 항목을 입력해주십시오.', g8: '인터넷 접속 상태에 오류가 있어 정보를 저장할 수 없습니다. 연결 후 재시도하시기 바랍니다.', g9: '승객 정보가 미완성 상태입니다. 필수 항목을 모두 입력한 후 저장하십시오.', HR: '누락된 승객이 있습니다.', HS: '각 방에는 성인이 포함되어야 합니다.', ha: '본 식사 예약을 원하시면 이전 선택을 제거해 주십시오.', HU: '성인을 포함하여 주십시오.', hb: '인터넷 접속 상태를 확인해 주십시오.', hc: '연령대를 \"{old}\"에서 \"{new}\"로 변경하였습니다.', hd: '성인이 포함되지 않은 선실은 자동 삭제됩니다.', he: '{name} 고객님 클럽원 로그인을 하였습니다.', hf: '예약 한도 인원에 도달하였습니다.', hg: '신규 추가된 승객분들을 위한 식사가 추가되었습니다.', hh: '삭제된 승객분들의 식사가 제거되었습니다.', hi: '각 차량에는 성인이 동반되어야 하며 성인의 수가 부족할 경우에는 차량이 삭제됩니다.', hj: '이전의 승객 수가 제거되었습니다. 무우가-부오사아리 구간에는 최대 5인이 허용됩니다.', hk: '데이 크루즈 할인이 적용되었습니다.', hl: '운항 시간표 로딩에 실패하였습니다.', hm: '선상에서의 숙박을 포함합니다.', hn: '데이 인 투르쿠 할인이 적용되었습니다.', ho: '데이 인 스톡홀름 할인이 적용되었습니다.', HV: '스톡홀름 대기 시간이 지연되고 있습니다.', hp: '마지막으로 남은 선실 \"{name}\"을 추가하셨습니다.', hq: '각 선실에는 성인이 포함되어야 합니다.', hr: '\"{name}\" 선실 유형이 매진되었습니다.', hs: '마지막 차량이 예약되었습니다.', ht: '차량을 추가할 수 없습니다. 성인 한 명당 1대가 허용됩니다.', hu: '차량은 탈린에서 하선할 수 없습니다.', hv: '차량은 출항편(편도)에만 가능합니다.', hw: '차량은 귀항편(편도)에만 가능합니다.', hx: '선택된 차량은 본 크루즈에 예약 불가합니다.', hy: '애완동물 추가', hz: '알레르기', hA: '우리', hB: '우리', hC: '신체 장애', hD: '선실', hE: '선실', hF: '각 선실에는 성인이 포함되어야 합니다.', H1: '매진', hG: '{capacity}인 선실만 예약 가능합니다.', hH: '{from}-{to} 구간의 {capacity}인 선실만 예약 가능합니다.', hI: '애완동물 동반', hJ: '추가 정보', hK: '공동 선실', hL: '여성 전용', hM: '남성 전용', hN: '{name}, {genderPlace}, 공동 {maxOccupancy}', hO: '{price} / 선실', tm: '{price} / 인', hP: '선실 유형', hQ: '특수 선실', H2: '선실', hR: '애완동물', hS: '애완동물', hT: '애완동물 동반', hU: '실야 심포니 또는 실야 세레나데에서의 원점 크루즈(2박)를 체험하세요. 스톡홀름 주간 관광을 위한 6시간도 주어집니다. 선실에 짐을 놓고 편하게 도심 관광을 즐기세요. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', hV: '새단장된 에우로파 호로 22시간 미니 크루즈를 체험하세요. 헬싱키 & 탈린에서 매일 18:30에 출항합니다. 익일 탈린에 도착하며 4시간의 관광 시간(08:00~12:10)이 주어집니다.', hW: '로만티카 또는 이사벨에서의 원점 크루즈(2박)를 체험하세요. 스톡홀름 주간 관광을 위한 6시간도 주어집니다. 선실에 짐을 놓고 편하게 도심 관광을 즐기세요. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', hX: '스톡홀름 07:10 출항편입니다. 발틱 프린세스에 탑승하여 올란드에서 갤럭시호로 환승할 수 있습니다. 당일 18:15에 스톡홀름에 귀항합니다.', hY: '실야 심포니 또는 실야 세레나데에서의 원점 크루즈(2박)를 체험하세요. 헬싱키 주간 관광을 위한 7시간도 주어집니다. 선실에 짐을 놓고 편하게 도심 관광을 즐기세요. 본 원점 크루즈는 총 40시간이 소요됩니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', hZ: '로만티카 또는 이사벨에서의 원점 크루즈(2박)를 체험하세요. 리가 주간 관광을 위한 6시간도 주어집니다. 선실에 짐을 놓고 편하게 도심 관광을 즐기세요. 본 원점 크루즈는 총 40시간이 소요됩니다.\n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h_: '발틱 퀸 또는 빅토리아 I에서의 원점 크루즈(2박)를 체험하세요. 탈린 주간 관광을 위한 7시간도 주어집니다. 선실에 짐을 놓고 편하게 도심 관광을 즐기세요. 본 원점 크루즈는 총 40시간이 소요됩니다.\n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h$: '스톡홀름 19:30 출항편입니다. 갤럭시 호에서 1박이며 투르쿠에서 상륙 시간이 주어지지 않습니다. 익일 스톡홀름으로 귀항합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h0: '발틱 퀸 또는 빅토리아 I에서의 원점 크루즈(2박)를 체험하세요. 스톡홀름 주간 관광을 위한 7시간도 주어집니다. 선실에 짐을 놓고 편하게 도심 관광을 즐기세요. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h1: '투르쿠 08:15 출항편입니다. 갤럭시에 탑승하여 올란드에서 발틱 프린세스 호로 환승할 수 있습니다. 당일 19:15에 투르쿠에 귀항합니다.', h2: '투르쿠 20:15 출항편입니다. 발틱 프린세스 호에서 1박이며 스톡홀름에서 상륙 시간이 주어지지 않습니다. 익일 투르쿠로 귀항합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h3: '실야 세레나데 또는 실야 심포니로 올란드 관광의 기회를 잡으세요.', h4: '실야 심포니 또는 실야 세레나데에서의 크루즈를 체험하세요. 익일 아침에 스톡홀름에 도착하며 편도나 왕복 일정 모두 가능합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h5: '매일 출항편이 다수 있습니다. 빠르고 편안하게 발트해를 건너세요. 셔틀 메가스타와 스타로는 편도 2시간 소요되며 에우로파로는 3.5시간이 소요됩니다.', h6: '헬싱키 서부 터미널에서 탈린까지 빠르고 편안하게 발트해를 건너세요. 셔틀 메가스타와 스타로는 편도 2시간 소요되며 에우로파로는 3.5시간이 소요됩니다.', h7: '헬싱키 출항편 10:30, 16:30이 매일 운행합니다. 총 5시간이 소요되며 탈린에서 상륙 시간이 없습니다. \n차량을 동반하여 쇼핑을 목적으로 하는 승객께서는 별도 주차지(garage)를 예매하셔서 트래블러 슈퍼스토어 근처에 편리하게 주차하실 수 있습니다.', h8: '로만티카 또는 이사벨에서의 크루즈를 체험하세요. 익일 아침에 스톡홀름에 도착하며 편도나 왕복 일정 모두 가능합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', h9: '올란드로는 매일 4회 출항편이 있습니다: 실야 세레나데, 실야 심포니, 발틱 프린세스, 갤럭시, 발틱 퀸, 빅토리아 I로 여행하세요.', ia: '실야 심포니 또는 실야 세레나데에서의 크루즈를 체험하세요. 익일 아침에 헬싱키에 도착하며 편도나 왕복 일정 모두 가능합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', ib: '로만티카 또는 이사벨에서의 크루즈를 체험하세요. 익일 아침에 리가에 도착하며 편도나 왕복 일정 모두 가능합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', ic: '발틱 퀸 또는 빅토리아 I에서의 크루즈를 체험하세요. 익일 아침에 탈린에 도착하며 편도나 왕복 일정 모두 가능합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', id: '발틱 프린세스 또는 갤럭시에서 반나절 또는 1박을 체험하세요. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', ie: '발틱 퀸이나 빅토리아 I로 올란드 관광의 기회를 잡으세요.', $8: '탈린 D 터미널에서의 출항편이 매일 다수 있습니다. 빠르고 편안하게 발트해를 건너세요. 셔틀 메가스타와 스타로는 편도 2시간 소요되며 에우로파로는 3.5시간이 소요됩니다.', ig: '헬싱키 서부 터미널에서 탈린까지 빠르고 편안하게 발트해를 건너세요. 셔틀 메가스타와 스타로는 편도 2시간 소요됩니다.', ih: '발틱 퀸 또는 빅토리아 I에서의 크루즈를 체험하세요. 익일 아침에 스톡홀름에 도착하며 편도나 왕복 일정 모두 가능합니다. \n선상에는 화려한 엔터테인먼트와 면세 가격의 쇼핑, 맛있는 해산물과 유럽식 식사가 펼쳐집니다.', ii: '발틱 프린세스나 갤럭시로 올란드 관광의 기회를 잡으세요.', ij: '반나절이나 하룻밤을 발틱 프린세스 또는 갤럭시 호에서 보내세요. \n훌륭한 음식과 면세 쇼핑, 화려한 엔터테인먼트가 펼쳐집니다.', ik: '선상에서의 2박 & 헬싱키에서의 주간 관광', il: '선상에서의 2박 & 탈린에서의 주간 관광', im: '선상에서의 2박 &<br>올란드에서의 주간 관광', $9: '22시간 탈린 원점 크루즈 &<br>4시간 탈린 도심 관광', io: 'A relaxing mini-break on the sea', ip: '11시간 올란드 원점 크루즈<br>스톡홀름 출항 07:10', iq: '선상에서의 2박 &<br>7시간 도심 관광', ir: '선상에서의 2박 &<br>6시간 도심 관광', is: '선상에서의 2박 &<br>7시간 도심 관광', it: '선상에서의 1박, 상륙 시간 없음<br>갤럭시 저녁 출항', iu: 'Baltic Princess에서 즐기는 23시간 크루즈를 만끽하세요.', iv: '11시간 올란드 원점 크루즈<br>투르쿠 출항 8:15', iw: '선상에서의 1박, 상륙 시간 없음<br>발틱 프린세스 저녁 출항', ix: 'Baltic Princess에서 즐기는 23시간 크루즈를 만끽하세요.', iy: '선상에서의 1박, 상륙 시간 없음<br>갤럭시 아침 출항', iz: '편도 또는 왕복 크루즈<br>올란드 & 헬싱키에서 매일 출항', iA: '편도 또는 왕복 크루즈', iB: '편도 또는 왕복 크루즈<br>올란드 매일 출항', iC: '편도 또는 왕복 크루즈<br>매일 4회 출항', iD: '편도 또는 왕복 크루즈<br>올란드 & 탈린 매일 출항', iE: '편도 또는 왕복 크루즈<br>매일 2회 출항', iF: '편도 또는 왕복 크루즈<br>매일 17:00 출항', iG: '편도 또는 왕복 크루즈<br>헬싱키 & 스톡홀름 매일 출항', iH: '당일 귀항시 할인 적용<br>편도 2시간 소요', iI: '편도 또는 왕복 크루즈<br>셔틀 편도 2시간 소요, 에우로파 편도 3.5 시간 소요', iJ: '5시간 쇼핑 크루즈 (차량 동반 가능)<br>시간과 노력을 절약하고 알뜰하게 쇼핑하세요.', iK: '편도 또는 왕복 크루즈', iL: '편도 또는 왕복 크루즈', iM: '시윈드 편도 또는 왕복 크루즈<br>매일 2회 출항', iN: '편도 또는 왕복 크루즈<br>리가 매일 출항', iO: '편도 또는 왕복 크루즈<br>리가 & 스톡홀름 매일 출항', iP: '편도 또는 왕복 크루즈<br>스톡홀름 4회 출항', iQ: '편도 또는 왕복 크루즈<br>스톡홀름 & 헬싱키 매일 출항', iR: '편도 또는 왕복 크루즈<br>스톡홀름 & 리가 매일 출항', iS: '편도 또는 왕복 크루즈<br>스톡홀름 & 탈린 매일 출항', iT: '편도 또는 왕복 크루즈', iU: '편도 또는 왕복 크루즈<br>매일 18:00 출항', iV: '편도 또는 왕복 크루즈<br>셔틀 편도 2시간 소요, 에우로파 3.5시간 소요', iW: '당일 귀항시 할인 적용<br>편도 2시간 소요', iX: '편도 또는 왕복 크루즈<br>탈린 & 스톡홀름 매일 출항', iY: '편도 또는 왕복 크루즈<br>투르쿠 매일 2회 출항', iZ: '편도 또는 왕복 크루즈', i_: '편도 또는 왕복 크루즈', i$: '시윈드 편도 또는 왕복 크루즈<br>매일 2회 출항', i0: '투르쿠', i1: '선상에서의 2박과 탈린 주간 관광', i2: '편도 또는 왕복 크루즈<br>탈린 매일 출항', H3: '2일', i3: '해상에서의 이틀 숙박에 더해 해르뇌산드에서 한 밤을 지내며 이틀 간 관광을 하실 수 있습니다. 크루즈에서는 선상 면세 쇼핑 혜택을 누리세요.', i4: '해상에서의 이틀 숙박에 더해 헬싱키 항구 선상에서 한 밤을 지내며 이틀 간 관광을 하실 수 있습니다. 크루즈에서는 선상 면세 쇼핑 혜택을 누리세요.', i5: '선상에서의 2박 &<br>올란드에서의 주간 관광', i6: '선상에서의 2박 &<br>해르뇌산드에서의 주간 관광', i7: '선상에서의 2박 & 헬싱키에서의 주간 관광', i8: '선상에서의 2박 & 리가에서의 주간 관광', i9: '선상에서의 2박 &<br>사아레마아에서의 주간 관광', ja: '선상에서의 1박 & 스톡홀름에서의 주간 관광', jb: '선상에서의 2박 & 탈린에서의 주간 관광', H7: '코드 사용하기', jc: 'Vehicle emissions surcharge', jd: 'The vehicle emission surcharge applies to the vehicle specified in the reservation.', Id: 'Emission and fuel surcharge', Ie: '차량 배출 가스 및 유류 할증료는 예약 내역에 반영된 차량에 해당합니다.', je: '최대 높이 1.5 m, 최대 길이 3.0 m', jf: '최대 높이 1.9 m, 최대 길이 5.0 m', jg: '차고 추가(garage)를 하시면 트래블러 슈퍼스토어 근처에 편리하게 주차하실 수 있습니다.', jh: '목적지에서 대기 시간 없이 이동할 수 있는 \"차량 우선 하선권(priority car)\"을 예매하세요. &rarr;', ji: '높이 2.4 m 이상, 최대 길이 8.0 m', jj: 'm', jk: '최대 높이 1.9 m, 최대 길이 5.0 m \n출발지로 돌아올 때까지 차량은 선내에 주차되어 있어야 합니다.', jl: '모든 차량의 번호판을 입력해 주십시오.', Ii: '삭제', jm: '이전 여정에서의 차량을 선택하세요:', jn: '최대 높이 2.3 m, 최대 길이 7.0 m', jo: '최대 높이 1.9 m, 최대 길이 12 m', jp: '트레일러 번호판', jq: '차량 번호판은 숫자와 라틴 문자로만 입력 가능합니다.', jr: '최대 높이 2.4 m, 최대 길이 7.0 m', js: '차량 정보 누락', jt: '차량 번호판', ju: '차량 추가', jv: '차량 잔여석 확인 중', Il: '헬싱키 경유 여행', jw: '비즈븨 (Visby)', jx: '의스타드/비즈븨 (Ystad/Visby)', jy: '벤츠필스 (Ventspils)', Ip: '바우처', Iq: '할인 내역을 보시려면 클럽원 계정으로 로그인해주십시오.', Ir: '해당 기프트 카드는 이미 추가되었습니다.', Is: '해당 기프트 카드는 만료되었습니다.', It: '해당 기프트 카드의 화폐 단위가 다릅니다.', Iu: '해당 기프트 카드에는 잔여 금액이 없습니다.', jz: '부오사아리', IA: '크루즈', IC: 'wow', tE: '데이 크루즈', jA: '의스타드 (Ystad)'};
var $author$project$Translations$Generated$lv = {P: 'Izlasi mūsu paziņojumu par piekļūstamību', Q: 'https://www.tallink.com/lv/pieejamiba', tJ: 'Pievienot', R: 'Pievienot citu kodu', S: 'Lai pievienotu transportlīdzekļus, pievienojiet vairāk pieaugušos pasažierus. Var pievienot arī velosipēdus bērniem vecumā no 6-17 gadiem.', tK: 'Pievienot numurus visiem pasažieriem', pl: 'Pievienot', tM: 'Ceļojums maršrutā {route} ir iespējams tikai ar transportlīdzekli.', tN: 'Vai vēlaties pievienot transportlīdzekli arī {route} maršrutam?', tO: 'Pievienot maršrutu?', T: 'Ālandu salas', t_: 'Diena Tallinas kruīzā', t$: 'Ālandu salas (Mariehamna)', ue: 'Jūs jau esat izvēlējies numuru (us) citā viesnīcā. Lai izvēlētos numuru šajā, Jums vispirms jāizdzēš esošā izvēle', uj: 'Kruīzs', ul: 'Atcelt un turpināt rezervāciju', um: 'Turpināt pilnajā versijā', un: 'Ja turpināsiet mājaslapas pilnajā versijā, Jums no jauna būs jāaizpilda: <span class=\"bodyBold\">informāciju par pasažieriem, kajītes klase, ēdināšana</span>.', uo: 'Dažas no Jūsu izvēlēm tiks dzēstas', up: 'Ja turpināsiet mājaslapas pilnajā versijā, Jums no jauna būs jāaizpilda: <span class=\"bodyBold\">informāciju par pasažieriem, ēdināšana</span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Bank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'Banka', aa: 'Izvēlieties banku, lai turpinātu', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click lietotājvārds vai mobilā tālruņa numurs', ah: 'Pēdējais izvēlētais', ai: 'Säästöpankki', aj: 'SEB', ak: 'Lūdzu, izvēlieties banku:', al: 'S-Pankki', am: 'Swedbank', uB: 'Pievienot ēdināšanu', uC: 'Rezervējiet šos maršrutus atsevišķi:', uD: 'Pievienot pakalpojumus uz kuģa', uE: 'Doties uz mājaslapas pilno versiju &rarr;', uF: 'Vai Jums ir nepieciešamas kādas funkcijas, kas šeit nav pieejamas?', uG: 'Pievienot autobusa transfēru', uH: 'Uz un no ostas', uI: 'Rezervējiet ceļojumu, izmantojot uzņēmuma ID', ao: 'Rezervējiet ērtāk, izmantojiet atlaides', ap: 'Beigt sesiju &rarr;', uJ: 'Pierakstīties', aq: 'Vai Jums ir Club One konts?', ar: 'Rādīt pieejamos datumus', uK: 'Atlaide netiek piemērota izvēlētajam ceļojumam. Izvēlieties citu datumu, maršrutu vai ceļošanas klasi', as: 'Pārbaudiet kodu un mēģiniet vēlreiz.', uL: 'Atcelt', at: 'Rezervācijas kods ir piemērots!', au: 'Kods ir pareizs', uM: 'Pārbaudiet kodu un mēģiniet vēlreiz. Ja nesen esat šo kodu jau lietojis/-usi, tad iespējams, ka tas ir bloķēts. Nogaidiet 20 minūtes un mēģiniet atkārtoti.', av: 'Var būt situācijas, kad sistēma bloķē Jūsu kodu. Šādā gadījumā, nogaidiet 30 minūtes un mēģiniet vēlreiz.', aw: 'Atlaide tika piemērota', ax: 'Atlaižu kods', ay: 'Kods nav derīgs ceļojumam izvēlētajā datumā', az: 'Jūs varat izmantot kodu ceļojumam citā sev vēlamā datumā', aA: 'Iepriekšējā cena {discountedPrice}, jaunā cena {oldPrice}.', aB: 'Ceļojuma sākotnējā cena: {oldPrice}. Cena ar atlaidi: {discountedPrice}', aC: 'Noņemt', uN: 'Kods ir pareizs. Lūdzu, vispirms izvēlieties kajīti, lai saņemtu atlaidi.', uO: 'Lai izmantotu dāvanu karti, lūdzu zvaniet +372 640 9808', aD: 'Atlaižu kods ir pievienots', aE: 'Man ir atlaižu kods', aF: 'punkti', uP: 'Pievienojiet papildu pakalpojumus', aG: 'Ātrā līnija', aH: 'Garāža', aI: 'Apdrošināšana', uQ: 'Plāno ar pārliecību', aJ: 'Prioritāte automašīnai', uR: 'Izvēlieties ceļojuma sākumu', uS: 'Izvēlieties galamērķi', aK: 'Rezervēt ceļojumu', uT: '22 st. kruīzs', uU: 'Kruīzs', uV: 'Kruīzs', uW: 'Galamērķī, nav paredzēts laiks krastā', py: 'Galamērķī, nav paredzēts laiks krastā', uX: 'Kruīzs uz Helsinkiem', uY: 'Kruīzs uz Rīgu', uZ: 'Kruīzs uz Stokholmu', u_: 'Atiešana', u$: 'Lūdzu ņemiet vērā, ka kuģis var neatbilst pasažieriem ar kustību traucējumiem.', aL: 'Kruīzā nav paredzēta nokāpšana', u0: 'Atgriešanās', u1: 'Ceļojums vienā virzienā', u2: 'Turp un atpakaļ', aM: '5h kruīzs', u3: 'Ceļojums vienā virzienā', u4: 'Turp un atpakaļ', ne: 'Ceļojums', aN: 'Ceļojuma veids', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Izvēlieties valodu', aV: 'Latviešu', aW: 'Vai vēlaties mainīt valodu?', u5: 'Izvēlieties ēdināšanu', aX: 'Ēdināšanu var rezervēt uz kuģa', u6: 'Nav pieejama ēdināšana', u7: 'Pasūtiet maltītes iepriekš un ietaupiet', u8: 'Ēdināšana', aY: 'Man ir atlaižu kods', u9: 'Papildu pakalpojumi', aZ: 'Rezervācijā jābūt precīzi vienam transportlīdzeklim.', va: 'Covid-19', a_: 'Covid-19 tests', vb: 'Bērnu aproces', vc: 'Masāža', vd: 'Pasažieri', ve: 'Pievienojieties Club One &rarr;', vf: 'https://clubone.tallink.com/lv/pievienoties', vg: 'Beigt sesiju &rarr;', vh: 'Club One atlaides un ērtāka ceļojumu rezervēšana', a$: 'Izvēlieties kajīti', vi: 'Ceļošanas klase', vj: 'Kajītes', a0: 'Velosipēds, elektriskais skrejritenis', a1: 'Vieglais auto', a2: 'Vieglais auto', vl: 'Izvēlieties autotransportu', vm: 'Aizpildiet reģistrācijas ID', a3: 'Cena tiek aprēķināta', a4: 'Motocikls', a5: 'Motocikls ar blakusvāģi', a6: 'Novietota auto', a7: 'Reģistrācijas ID aizpildīts', a8: 'Pircēja auto', a9: 'Pircēja autofurgons', ba: 'Parādīt visu', bb: 'Auto&shy;furgons', bc: 'Augsts auto&shy;furgons', bd: 'Transportlīdzeklis ar piekabi', be: 'Transportlīdzeklis ar piekabi', bf: 'Transportlīdzeklis ar piekabi', bg: 'Transportlīdzeklis ar piekabi', vB: 'Pievienot vēl vienu autobusa transfēru', bh: 'Pievienot pārsteigumu kajītē', bi: 'Bezmaksas dāvana', bj: '{count} pārsteigumi izvēlēti', bk: '{count} pārsteigums izvēlēts', vC: 'Rādīt vairāk', bl: 'Rādīt iepriekšējo', bm: 'Datums', vD: 'Īpašais kruīzs', bn: 'Lūdzu, atzīmējiet', vE: 'Cena no {price}', vF: 'Nav pieejamas atiešanas', vG: 'Izvēlētajā datumā nav reiss.', bo: 'visas cenas norādītas eiro', bp: 'Kajīte no {price} punktiem', bq: 'no {price} punktiem par personu', br: 'no {price} par personu', bs: 'Kajīte no {price}', bt: 'Atcelt', bu: 'Turpināt', bv: 'Ja turpināsiet, Jūsu izvēlētā kajīte tiks dzēsta. Pasažieru dati tiks saglabāti.', bw: 'Jūsu izvēlētā kajītes klase nav pieejama izvēlētajā datumā', vH: 'Īpašais<br/>kruīzs', vI: 'Auto no {price}', bx: 'Izpārdots', by: 'Emisiju piemaksa', bz: 'Emisiju piemaksa tiek piemērota pasažieriem no 6 gadu vecuma.', bA: 'Emisiju piemaksa, lai atbalstītu klimata pasākumus un segtu ES emisijas kvotu sistēmas maksu.', vQ: '{chars} zīmes atlikušas', vR: 'Reģistrācija:', vS: 'Izrakstīšanās:', vW: 'Izvēlēties &rarr;', vX: 'Izvēlies numuru', vY: 'Izvēlies savu uzturēšanos, lai redzētu gala cenu', v3: 'Dzēst izvēli un izvēlēties citu numuru šajā viesnīcā', bB: 'Bronze līmenis', bC: 'Club līmenis', wd: 'Club one discount:', bD: 'Gold līmenis', bE: 'Neaktīvs Club One', bF: 'Club One numurs', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One konta atjaunošana\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One konta atjaunošana\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One konta atjaunošana\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Club One konta atjaunošana\">clubone@tallink.lv</a>', bK: '\"<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One konta atjaunošana\">tallinksilja@tallinksilja.no\n</a>\"', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Обновление статуса (inactive) карты Club One\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One konta atjaunošana\">ClubOne.Sweden@tallinksilja.com </a>', bN: 'E-pasts:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One konta atjaunošana\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:clubone@tallin.lv?subject=Club One account reactivation\">Jūsu Club One karte ir neaktīva. Lūdzu, sazinieties ar mums. </a>', bQ: 'Jūsu Club One karte ir neaktīva. Lūdzu, sazinieties ar mus:', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\"+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Tālrunis:', b_: 'Platinum līmenis', wg: '<a>Autorizēties</a> vai <a>Pievienoties Club One</a> lai saņemtu atlaidi, izmantotu punktus vai ērtāk veiktu rezervāciju.', b$: 'Silver līmenis', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Maksimālais punktu skaits, ko iespējams izmantot, tiek aprēķināts pamatojoties uz pakalpojumiem, kas izvēlēti Jūsu rezervācijā.', wj: 'Izmantot pieejamos Club One punktus', wk: 'Club One punktus nav iespējams izmantot kopā ar šo atlaižu kodu.', wl: 'Jums nav pietiekami daudz Club One punktu, lai tos izmantotu.', b0: 'Tagad variet izmantot Jūsu Club One punktus apmaksai šeit <a>a slider below</a>.', wm: 'Club One punktus nav iespējams izmantot ({reason}).', pQ: 'Kods', wp: 'Ievadītais teksts satur neatļautas zīmes.', wr: 'Dzimšanas datums', ws: 'dd', wt: 'mm', wu: 'gggg', wv: '{count} {count, plural, one{pieaugušais} other{pieaugušie}}', ww: '({range} g.)', wx: 'Pienāk plkst. {time}', pT: '{count} {count, plural, one{bērns} other{bērni}}', wy: 'Bezmaksas', wz: 'Mazāk', wA: 'Vairāk', wB: 'Pavalstniecība', wC: 'Populārs', b1: 'Cenā ir iekļauta Jūsu Club One {level} atlaide.', wD: 'Informācija par Club One pasažieriem ir jāaizpilda šobrīd. Informāciju par citiem pasažieriem var aizpildīt vēlāk.', b2: 'p.', b3: 'Izmantot Club One punktus', b4: 'Drīzumā', wE: 'Pievienojiet Club One numuru pirms rezervācijas', wF: 'Paveikts', wG: 'Izmainīt &rarr;', b5: 'Ievadiet visu pasažieru telefona numurus un e-pastus, lai varētu ātrāk reģistrēties ceļojuma (check-in), kā arī ērtai piekļūt ceļojuma rezervācijai un kuģa iekāpšanas kartēm.', wH: 'Vārds', wI: 'Dzimums', wJ: 'Sieviete', wK: 'Vīrietis', wL: 'Iekļauts cenā', mh: 'Pārbaudiet ievadītos datus', wM: 'Šis e-pasts ir jau norādīts kontaktpersonai vai citam pasažierim', wN: 'Šis mobilais tālrunis ir jau norādīts kontaktpersonai vai citam pasažierim', wO: 'Uzvārds', wP: 'Obligāti aizpildāmie lauki atzīmēti ar (*)', wQ: 'Brokastis', wR: 'Brančs', wS: 'Zviedru galds', wT: 'Vakariņas', wU: 'Pusdienas', wV: 'Galdiņa rezervācija à la carte restorānā', wW: 'Ēdināšanu var rezervēt uz kuģa', wX: 'Vārds un uzvārds jānorāda latīņu burtiem.', wY: 'Nav pieejams', b6: 'Nav pieejams šim braucienam', wZ: 'Nav nepieciešams', b7: 'Pieaug.\n18+', b8: 'Bērns\n0-5', b9: 'Bērns\n6-11', ca: 'Bērns\n12-17', cb: 'Banka', w_: 'Maksāt {price}', cc: 'Maksā {price}', cd: 'Bankas karte', w$: 'Apstiprināt rezervāciju {price}', w0: 'Apstiprina {price}', ce: 'Maksāt ar Klarna {price}', cf: 'Maksājums tiek apstrādāts...', w1: '<p>Jums piedāvātais pakalpojums ir kompleksais ceļojums Direktīvas (ES) 2015/2302 izpratnē. </p>\n<p>Tādējādi uz Jūsu pakalpojumu attiecas visi ES komplekso ceļojumu noteikumi. AS Tallink Grupp ir pilnībā atbildīga par visa kompleksā pakalpojuma pareizu nodrošināšanu.</p>\n<p>Papildus, kā likumā noteikts, AS Tallink Grupp atlīdzinās pakalpojuma maksu un nodrošinās repatriāciju, gadījumā, ja transports ir iekļauts pakalpojumā.</p>\n<p><a href=\"https://www.tallink.com/lv/svarigi/kompleksie-celojumi\" target=\"_blank\">Iepazīties ar komplekso ceļojumu noteikumiem</a>.</p>', pU: '<p>Jums piedāvātais ceļojumu pakalpojumu kopums ir komplekss pakalpojums <a href=\"{url}\" target=\"_blank\">Direktīvas (ES) 2015/2302 nozīmē</a>.</p>\n<p>Tāpēc Jūs varēsiet izmantot visas ES tiesības,kas attiecas uz kompleksiem pakalpojumiem.</p>\n<p>Uzņēmums {name} būs pilnībā atbildīgs (atbildīgi) par kompleksā pakalpojuma pienācīgu sniegšanu kopumā.</p>\nTurklāt saskaņā ar tiesību aktu prasībām uzņēmumam {name}, lai maksātnespējas gadījumā atlīdzinātu Jūsu maksājumus un, ja kompleksajā pakalpojumā ir ietverts transports, – nodrošinātu Jūsu repatriāciju.', w2: 'Nospiežot maksājuma pogu, Jūs piekrītat <a href=\"https://lv.tallink.com/lv/good-to-know#20841318\" targe=\"_blank\">Tallink noteikumiem un nosacījumiem</a> un noteikumiem, kas attiecināmi uz dalību <a href=\"https://lv.tallink.com/club-one-rules\" targe=\"_blank\">Club One lojalitātes programmā</a>.', w3: 'Nospiežot maksājuma pogu, jūs piekrītat Tallink <a href=\"https://www.tallink.com/lv/svarigi/apmaksas-un-atcelsanas-noteikumi\" target=\"_blank\" >apmaksas un atcelšanas noteikumiem</a>, <a href=\"https://www.tallink.com/lv/svarigi/pasazieru_zinasanai\" target=\"_blank\" >drošības noteikumiem</a> un apstiprināt, ka esat iepazinies ar <a href=\"https://www.tallink.com/lv/privatuma-politika\" target=\"_blank\" >privātuma politiku</a>.', w4: 'AS Tallink Grupp', w5: 'https://www.tallink.lv/lv/celojumu-paketes-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://lv.tallink.com/lv/celojumu-paketes-tallink-silja', w8: 'Uzmanību pasažieriem, jaunākiem par 18 gadiem. Lūdzu, izlasiet <a href=\"https://www.tallink.com/lv-lv/svarigi/vecuma-ierobezojumi\" target=\"_blank\"> noteikumus par vecuma ierobežojumiem</a>.', w9: 'Alipay', xa: 'Apple Pay', xb: 'Vietējā internetbanka', xc: 'Maksājumu karte', xd: 'Google Pay', xe: 'Mobile Pay', xf: 'Debetkarte/ Kredītkarte', xg: 'WeChat Pay', xh: 'Internetbanka & Debetkarte/ Kredītkarte', xi: 'Vietējā internetbanka', xj: 'Internetbanka', cg: 'No {price}', xk: 'Paritiniet uz augšu, lai skatītu iestatījumus', xl: 'Izvēlēties', xm: 'Izvēlēts', xn: 'Kuģis', xo: '{date} plkst. {time}', xp: '{count} {count, plural, one{pasažieris} other{pasažieri}}', xq: 'Pieaug.\n18+', xr: 'Bērns\n0-5', xs: 'Bērns\n6-17', xt: 'Vispirms, lūdzu, izvēlieties kajīti', xu: 'Kuģa pienākšana Ālandu salās ir Långnäs ostā (30 km no Mariehamnas)', xv: 'Pienāk Långnäs ostā', xw: 'Pienākšana un atiešana Ālandu salās ir no Långnäs ostas (30 km no Mariehamnas)', xx: 'Atiešana Ālandu salās ir no Långnäs ostas (30 km no Mariehamnas)', xy: 'Attiet no Långnäs ostas', pV: 'Transportlīdzeklis', xz: 'Transportlīdzekļi', ch: '22 st. kruīzs ar Baltic Queen', ci: 'Kruīzs', cj: 'Ceļojums vienā virzienā', ck: 'Ceļojums vienā virzienā', cl: 'Ceļojums vienā virzienā', xB: 'Uzņēmums', xC: 'Lietotāja ID', xD: 'Lietotājs ar norādītajiem datiem nav atrodams', xE: 'NB! Lietotāja ID nav nepieciešams obligāti norādīt', xF: 'Jūs īslaicīgi tiksit izrakstīts no personīgā konta', xG: 'Uzņēmuma ID', xH: 'Uzņēmuma klients ar norādītajiem datiem nav atrodams', cm: 'Rezervācijas apstiprinājums ir nosūtīts uz', cn: 'Rezervācijas ir veikta. Lai Jums jauks ceļojums!', co: 'Jūs saņemsiet atpakaļ {refund}!', cp: 'Lūdzu, zvaniet uz klientu servisu par naudas atgriešanas iespējām.', cq: 'Jūsu rezervācija ir papildināta!', xI: 'Pieaugušie', xJ: 'Pilsētas nosaukums', xK: 'Nav rezultātu', xL: 'Meklēt autobusa pieturu', xM: 'Autobusa transfērs', cr: 'Bērni vecumā no 6-17 g', cs: 'Mainīt rezervāciju', xN: 'Pamatcenas biļete', xO: 'Bērni {range} gadi', ct: 'Izklaide krastā', cu: 'Nē', cv: 'Protams', cw: 'Vai Jūs vēlaties saņemt labākos Tallink & Silja Line piedāvājumus e-pastā?', cx: 'Paldies, ka pieteicāties jaunumiem!', cy: 'Sazināties ar Tallink klientu servisu', cz: 'Atcelt', xP: 'Ievadītais dzimšanas datums neatbilst iepriekš izvēlētajai vecuma kategorijai. Lūdzu ievadiet pareizu dzimšanas datumu vai arī sazinieties ar klientu servisu, lai nomainītu vecuma kategoriju:', cA: 'Mainīt vecuma kategoriju?', cB: 'Pirkt pakalpojumus', cC: 'Mainīt pakalpojumus', cD: 'Adrese', cE: 'Uzņēmums', cF: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contacts\">klientu servisu</a>.', cG: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\">klientu servisu</a>.', cH: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://ee.tallink.com/et/kontaktid\">klientu servisu</a>.', cI: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallinksilja.fi/palvelunumerot\">klientu servisu</a>.', cJ: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallink.lv/lv/contacts\">klientu servisu</a>.', cK: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallinksilja.com/contact-us\">klientu servisu</a>.', cL: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallinksilja.ru/agents\">klientu servisu</a>.', cM: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallinksilja.se/kontakta-oss\">klientu servisu</a>.', cN: 'Lai veiktu izmaiņas rezervācijā, lūdzu sazinies ar <a href=\"https://www.tallinksilja.com/contact-us\">klientu servisu</a>.', cO: 'Kontaktpersona', cP: 'Kontaktpersona', cQ: 'Lai veiktu izmaiņas rezerācijā, lūdzu, sazinieties ar Jūsu tūrisma aģentūru.', cR: 'E-pasts', cS: 'Pievienojies Club One', cT: 'Ceļojuma apstiprinājums', cU: 'Reģistrācija sāksies 2 stundas pirms atiešanas. Lūdzu, ņemiet vērā, ka reģistrācija ir jāveic transportlīdzekļu reģistrēšanās vietā vismaz 45 minūtes pirms atiešanas.', cV: 'Lūdzu aizpildiet visu informāciju par individuāliem ceļotājiem', cW: 'Atcelt', cX: 'Turpināt', cY: 'Ja turpināsiet, ievadītā informācija par pasažieriem netiks saglabāta', cZ: 'Izmaiņas netiks saglabātas', c_: 'Parādīt apstiprinājumu kā PDF dokumentu', c$: 'Maksājuma info skatiet rezervācijas apstiprinājumā (PDF) Jūsu e-pastā.', c0: 'Parādīt noteikumus', c1: 'https://www.tallink.com/lv-lv/svarigi/celosanas-noteikumi', xQ: 'Kopā', c2: 'Tālruņa numurs', c3: 'Rezervācijas numurs', c4: 'Drošības kods', c5: 'Apstiprinājums', c6: 'Visi rezervācijā minētie laiki norādīti pēc vietējā laika.', c7: 'Aicinām izmantot pašreģistrācijas terminālus, kas atrodas ostās. Lūdzam lietot savu rezervācijas numuru un drošības kodu.', c8: 'Mēs iesakām ierasties laicīgi, lai reģistrētos ceļojumam.', c9: 'Pasažieriem, kas ceļo bez transportlīdzekļiem, reģistratūrā jāierodas vēlākais 30 minūtes pirms kuģa atiešanas. Pasažieriem ar transportlīdzekli mēs iesakām reģistratūrā ierasties vēlākais 1 stundu pirms kuģa attiešanas. NB! Pasažieriem, kuri no Tallinas vai Stokholmas ceļo uz Mariehamnu ar transportlīdzekli, ir jābūt automašīnu reģistratūrā vēlakais pusotru stundu pirms atiešanas.', da: 'Kruīza vai vienas dienas ceļojuma gadījumā, Tallink atcels visu ceļojumu, ja pasažieris nav reģistrējis biļeti ceļojumam pirmajā izbraukšanas ostā.', db: 'Lūdzu, atcerieties ceļojumā līdzi ņemt derīgu pasi vai ID karti. Ja neesat pārliecināts vai nepieciešama vīza, lūdzam sazināties ar ceļojuma galamērķa valsts vēstniecību.', dc: 'Kuģa pienākšanas un atiešanas laiki vienmēr norādīti pēc vietējā laika. <br>\nReģistrēšanās ceļojumam tiešsaistē, Tallink Silja Line aplikācijā vai terminālī. <br>\nPaldiski un Kapellskär ostās pasažieru transportlīdzekļu reģistrācija beidzas 75 minūtes pirms kuģa Superfast atiešanas. Iesakām ostā ierasties laicīgi. <br>\nKajīšu atslēgas kartes tiks izsniegtas reģistrēšanās laikā <br>\nKatram pasažierim (ieskaitot bērnus) visa ceļojuma laikā līdzi jābūt derīgam ceļošanas dokumentam un citiem nepieciešamiem dokumentiem, piemēram, vīzai, ja tāda ir nepieciešama. <br>\nPasažieri ir atbildīgi par savu dokumentu derīgumu un pareizību.', dd: 'Informācija par ceļojumu', de: 'Ceļojuma ieteikumi', df: 'Naudas atmaksa', dg: 'Jūs saņemsiet kompensāciju {refund}! Lūdzu, sazinieties ar mūsu klientu atbalsta dienestu, lai saņemtu kompensāciju.', dh: 'Zvaniet, lai saņemtu kompensāciju', di: 'Jau piezvanījāt? Nesatraucieties, šis paziņojums pazudīs, tiklīdz kompesācija būs saņemta.', dj: 'Saņemiet kompensāciju', xR: 'Ja problēmas ar interneta savienojumu turpinās, lūdzu, sazinieties ar Tallink klientu servisu tel. +371 670 997 00', xS: 'Nav internets. Lūdzu, atkārtoti izveidojiet savienojumu un mēģiniet vēlreiz.', xT: 'Mēģiniet vēlreiz', xV: 'Turpināt', xW: 'Turpināt maksāt', pX: 'E-pasts', xX: 'Piemērs:', dk: 'Valsts kods un tālruņa numurs', xY: 'Kontaktinformācija', xZ: 'Aizpildiet informāciju par sevi, lai varam Jums nosūtīt rezervācijas apstiprinājumu. Lai saņemtu Club One priekšrocības, autorizējaties vai ievadiet savu Club One numuru pasažieru laukā pirms rezervācijas', x_: 'Informācija tiks papildināta Jūsu Club One kontā', pY: 'Tālruņa numurs', dl: 'Piemērs: 12345678', x$: 'Cits', x0: 'Rezervācijas apstiprinājuma kopija tiks nosūtīta uz {email}', dm: 'Papildu e-pasts', dn: 'Pasta indekss', x6: '{price} / par 1 testu', x8: 'Rezervējiet šo ceļojumu ātrāk mūsu <b>jaunajā rezervēšanas sistēmā.</b>', dp: 'Vārds un uzvārds', dq: 'Kredītkarte', dr: 'mm', ds: 'Kredītkartes numurs', dt: 'Maksāšanas veids', du: 'Drošības kods', dv: 'Izvēlieties maksājumu karti', dw: 'Derīga līdz', dx: 'gg', dy: 'Kruīzs Stokholma(Kapelšēra)-Turku-Stokholma(Kapelšēra)', ya: 'Kruīzs uz Helsinkiem', yb: 'Kruīzs uz Visbiju', dz: 'Kruīzs Turku-Stokholma(Kapelšēra)-Turku', yc: 'Kruīzs ar Īstadas apmeklējumu', dA: 'Kruīzs uz Helsinkiem', dB: 'Kruīzs uz Rīgu', no: 'Dienas kruīzs uz Tallinu', yj: 'Diena Turku kruīzā', yr: 'Deserts', dC: 'Atlaide:', yy: 'Piemērots', yz: 'Atlaižu kods vai dāvanu karte:', p9: 'Atlaižu kods & Dāvanu kartes', dD: 'Neaizmirstiet izvēlēties vienu ēdinkartes variantu visiem pieaugušajiem {restaurant} rezervācijā.', dE: 'Neaizmirstiet izvēlēties vienu ēdienkartes variantu visiem pasažieriem no 12 gadu vecuma {restaurant} rezervācijā.', yB: 'Nepalaidiet garām iespēju!', yD: 'Izvēlēties dzērienu piedāvājumu', dF: 'Uz šo datumu ir atrasta neapmaksāta rezervācija. Rezervācijas nr. {resId}, summa: {price} {unit}. Vai vēlaties atcelt iepriekš izveidoto rezervāciju un apstiprināt maksājumu jaunajai rezervācijai? <a href=\"{link}\">Atvērt un veikt maksājumu par iepriekš veikto rezervāciju →</a> Lai precizētu detalizētu informāciju, lūdzam sazināties ar klientu apkalpošanas centru', yF: 'Mainīt numuru', yG: 'Mainīt numurus', yO: 'Izklaide krastā', yP: 'Izklaide krastā un viesnīcās', yS: 'Katram pasažierim jābūt vietai transportlīdzeklī.', dK: 'https://clubone.tallink.com/lv', yY: 'Papildu pakalpojumi', dL: 'Atstāt komentārus', y_: 'Kuģis', y$: 'Kuģis + viesnīca', y5: 'Izvēlēties ēdienkarti', y7: 'Ēdienu alerģijas / diētas ierobežojumi:', kS: 'No', za: 'Degvielas un emisiju piemaksa', zb: 'Degvielas un emisiju piemaksa tiek piemērota pasažieriem no 6 gadu vecuma.', zc: 'Degvielas un izmešu piemaksas tiek piemērotas pasažieriem no 12 gadu vecuma. No šīs piemaksas ir atbrīvoti līdz trim bērniem vecumā no 6 līdz 11 gadiem vienā rezervācijā.', zd: 'Degvielas un emisiju piemaksa, lai atbalstītu klimata pasākumus un segtu ES emisijas kvotu sistēmas maksu', dM: 'Degvielas piemaksa', dN: 'Degvielas emisiju piemaksa tiek piemērota pasažieriem no 6 gadu vecuma.', dO: 'Degvielas emisiju piemaksa ir {price} personai no 6g.v.', dP: 'Degvielas emisiju piemaksa ir {price} vienā virzienā vienai persona no 6g.v.', zh: 'Dāvanu karte:', zi: 'Dāvanu karti var lietot vairākiem pirkumiem, līdz kamēr ir pieejami līdzekļi.\nDāvanu kartē ir palikuši {priceLeft} €.', dQ: 'Pieejama grupu ēdienkarte', zm: 'Rezvācijās ar 12 vai vairāk pilngadīgiem pasažieriem, lūdzam izvēlēties vienu ēdienkartes variantu katram pieaugušajam. Nepilngadīgie pasažieri automātiski saņems bērnu ēdienkartes kuponu 25 € vērtībā.', dR: 'Helsinki', dS: 'Baudiet 2 dienas ceļojumā <br>un 1 dienu Rīgā', dT: '22 st. kruīzs uz Tallinu.<br>Tallinā laiks krastā 4 st.', dU: 'Kruīzs uz Tallinu.<br> 5 stundas Tallinā', dV: 'Visbijas kruīzi', dW: 'Vasaras īpašie kruīzi uz maģisko Gotlandes salu', dX: 'Hernesanda', zv: 'Viesnīca', zy: 'Lai izvēlētos datumu ārpus izvēlnes <a>izmainiet savu ceļojumu datumu</a> attiecīgi.', dY: 'Pierakstīties', dZ: 'Reģistrēšanās', d_: 'Izrakstīties', d$: 'Izrakstīšanās', d0: 'naktis', d1: 'nakts', zz: 'Viesnīcas rezervācija šobrīd ir pieejama atsevišķā aplikācijā', zA: 'Izvēlētajos datumos numuri viesnīcā nav pieejami. Lūdzu, izvēlieties citus ceļojuma datumus.', zB: 'Jūs nevarat reģistrēties pēc izrakstīšanās. Jūs varat pārbaudīt savu izrakstīšanās datumu izrakstīšanās ailītē.', zC: 'Jūs nevarat izreģistrēties pirms reģistrēšanās. Jūs varat mainīt savu reģistrēšanās datumu, reģistrācijas ailītē.', zD: 'Šis ir Jūsu reģistrēšanās datums. Lai to mainītu, ejiet uz reģistrēšanās ailīti.', zE: 'Šis ir Jūsu izrakstīšanās datums. Lai to mainītu, ejiet uz izrakstīšanās ailīti.', qF: 'Šis datums ir ārpus Jūsu izvēlētajiem ceļojumu datumiem. Lai to izvēlētos, lūdzu, izmainiet savus ceļojuma datumus.', zF: 'Overnight trip: night on board included.', zG: 'Overnight trip: night on board included.', zW: 'Info par alerģijām pret ēdienu / diētas ierobežojumiem ir nodota kuģa komandai', q4: 'Pievienojies Club One', AB: 'Saņem atlaides rezervējot ceļojumus, krāj punktus, ko izmantot bonusa ceļojumiem, un saņem atlaides uz kuģa un pie mūsu sadarbības partneriem krastā.', d2: 'Adrese', d3: 'Pilsēta/rajona', d4: 'Valsts', d5: 'Pabeigt pievienošanos Club One', AC: 'Pasta indekss', AD: 'Club One dalībniekam ir jābūt vienam no pasažieriem.', d6: 'E-pastā', d7: 'Pa pastu', d8: 'SMS veidā', d9: 'Prioritātes valoda', ea: 'Es gribētu saņemt Club One piedāvājumus un jaunumus', eb: 'Nē', ec: 'Saglabāt un aizvērt', ed: 'Jā', AF: 'Laipni lūdzam Club One. Jūs varat pievienot pārējo informāciju pēc rezervācijas.', AG: 'Laipni lūdzam Club One. Pievienojoties Jūs saņēmāt dalībnieka atlaidi. Oriģinālā cena {priceBefore} ir mainījusies uz esošo cenu {currentPrice}.', AH: 'Mēs atradām jau eksistējošu Club One kontu ar šīm detaļām.', ee: 'Kapelšēra', ef: 'Bērnu ēdienkartes kupons', AN: 'Apstiprinot šo rezervāciju, Jūs piekrītat, ka Jūsu rezervācijas dati tiek nosūtīti Klarna, lai pārbaudītu iespējamos apmaksas veidus. Uzziniet vairāk', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: 'par Klarna pieeju Jūsu datiem', AQ: 'Klarna & Swish', AR: 'Rēķins, daļēja apmaksa', AS: 'Klarna', AT: 'Rēķins', AU: 'Daļēja apmaksa', AV: 'Swish', AW: 'Iespējamie apmaksas veidi var atšķirties atkarībā no Jūsu izvēlētās rezervācijas, populārākās ir:', eg: 'Doties uz Klarna maksājumu', eh: 'Klarna ļau Jums ērti un droši norēķināties izmantojot viedtālruni', ei: 'Klaipēda', ej: 'Viena virziena ceļojums vai turp un atpakaļ.<br>Kuģis atiet plkst. 19:00.', A$: 'Deutsch', A0: 'Englisch', A1: 'Estnisch', A2: 'Finnisch', ek: 'Litauisch', A3: 'Lettisch', A4: 'Russisch', A5: 'Schwedisch', Bb: 'Ielādējas...', Bc: 'Helsinki', Bd: 'Jūrmala', Be: 'Kolmardena', Bf: 'Kuresāre', Bg: 'Laulasmā', Bh: 'Mariehamna', Bi: 'Narva', Bj: 'Noršēpinga', Bk: 'Otepē', Bl: 'Pērnava', Bm: 'Rakvere', Bn: 'Rīga', Bo: 'Sodertālje', Bp: 'Stokholma', Bq: 'Tartu', Br: 'Turku', Bs: 'Tallina', Bt: 'Tampere', Bu: 'Upsala', Bv: 'Vanta', Bw: 'Vihula', BC: 'Pamatēdiens', BE: 'Pievienot vēl', BF: 'Datums:', BG: '{price} / procedūra', BH: 'Laiks:', Cf: 'Ēdināšana netiek piedāvāta {direction} maršrutā', Cg: 'Ēdināšanas komplekts ietver ēdienreizes visa ceļojuma laikā', Ch: 'Izvēlies ēdināšanas komplektu', el: 'Nav izvēlēts', em: '<span class=\"data\">{count}</span> {count, plural, one{# brokastis} other{# brokastis}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# vakariņas} other{# vakariņas}}', rt: 'Bērniem ir atlaide, un vecumā līdz 5 gadiem ir bezmaksas ēdināšana kopā ar vecāku. \n\nKā maksāšanas līdzekli restorānos var izmantot ēdināšanas kuponus.', Ci: '{price} / 18+ g.v.', Cj: '{price} / pieaugušais', Ck: '{price} / pers.', Cl: '<span class=\"save bodySmall\">Ietaupiet</span><span class=\"bodySmall\">līdz pat</span><span class=\"bodyLarge percentage\">15%</span>', Cm: 'Ēdināšanas komplekts', Cn: '{count, plural, one{# pers.} other{# pers.}}', Co: 'pers.', Cp: 'Rezervācija', ru: 'Rezervē un iegādājies ēdināšanas komplektu', eo: 'Rezervēt galdiņu', ep: 'Izpārdots', eq: 'Brokastis', er: 'Pusdienas', Cq: 'Ēdināšana', es: 'Kupons', Cr: 'Ēdināšana ir iekļauta visu ceļojumu', Cs: 'Vai tiešām nevēlaties pievienot ēdināšanu tagad un tādējādi <b> ietaupīt līdz 10% </b>? Piedāvājums ir spēkā, iegādājoties tiešsaistē.', et: 'Konferenču telpa', eu: '{date} plkst. {time} cik {duration} h', Ct: 'Ēdienkarte', Cu: 'Lūdzam izvēlēties vienu ēdienkartes variantu visiem pasažieriem no 12 gadu vecuma. Bērniem līdz 12 gadu vecumam tiek piemērota 50% atlaide. Pasažieri, kuri ir jaunāki par 12 gadiem, saņems ēdināšanas kuponu un varēs izvēlēties maltīti uz kuģa.', ew: 'Aizpildiet pasažieru datus', ex: 'Rādīt pasažieru datus', ey: 'Club One', CA: 'Lai veiktu izmaiņas Club One pasažiera norādītajos datos, lūdzu, sazinieties ar Tallink klientu servisu:', ez: 'trūkst pasažieru datu', eA: 'Jums nekas nav jādrukā. Jums ir jādodas uz automātiskās reģistrācijas terminālu ar savu rezervācijas numuru un drošības kodu.', eB: 'Nepareiza vecuma kategorija', eC: 'Trūkst pasažieru datu', eD: 'maksājums nav pabeigts', eE: 'Labot transportlīdz. reģ. nr.', eF: 'trūkst auto reģistrācijas nr.', eG: 'auto reģistrācijas nr. nav ievadīts', eH: 'Rezervējiet ceļojumus telefonā', eI: 'Lejupielādēt', eJ: 'Atvērt', eK: 'Sūtīt saiti', eL: 'Tallink un Silja Line aplikācija', eN: 'Mūga', CJ: 'Galamērķī, nav paredzēts laiks krastā', CK: 'Bez iespējas nobraukt no kuģa galamērķī.', CL: 'Pašreiz nav atiešanas ar izvēlēto ceļojuma veidu. Lūdzu, mainiet ceļojuma veidu.', CM: 'Jūsu maksājums nav izdevies. Lūdzu, mēģiniet vēlreiz. Ja vēl joprojām nevarat apstiprināt rezervāciju, lūdzu, sazinieties ar mums {phone}.', ol: 'Nē, paldies', CU: 'Ja tiek izmantots šis kods, biļete būs neatmaksājama. Iepazīties ar <a href=\"#\">noteikumiem un nosacījumiem →</a>.', CV: '<ul>\n<li>Biļetē nav atļauts mainīt ceļojuma virzienu un/vai maršrutu, izbraukšanas datumu vai laiku.</li>\n<li>Var mainīt pasažieru datus, kajītes klasi, transportlīdzekli un pakalpojumus uz kuģa. Veicot šādas izmaiņas ir jāapmaksā summa, kas rodas no cenas starpības starp sākotnēji iegādāto un mainīto pakalpojumu.</li>\n<li>Ja pasažieris atceļ Biļeti, Tallink Silja Line ietur Līgumsodu 100% apmērā no Biļetes cenas.</li>\n<li>Visos citos gadījumos tiek piemēroti <a target=\"_blank\" href=\"https://www.tallink.com/lv-lv/svarigi/celosanas-noteikumi\">AS Tallink Grupp ceļošanas noteikumi</a>.</li>\n</ul>', CW: 'Noteikumi un nosacījumi', CX: 'Jā, es piekrītu', CY: 'Noņemt kodu', CZ: 'Jūs iegādājaties biļeti, izmantojot kodu <b>{code</b>, kas neparedz biļetes atcelšanu. Pēc iegādes šī biļete netiek atmaksāta nekādos apstākļos. Jūs varat mainīt tikai pasažieru personas datus, kajītes klasi un iegādātos papildpakalpojumus. Virziena, maršruta, izbraukšanas datuma vai laika maiņa nav iespējama. Pirms maksājuma veikšanas, lūdzu, apstipriniet, ka saprotat un piekrītat šiem noteikumiem.', C_: 'Neatmaksājama biļete', eO: 'Nepietiek punktu', C0: 'Turpināt rezervāciju', C1: 'Dzēst rezervāciju', C2: 'Pametot šo lapu, tiks dzēsta Jūsu rezervācija. Vai Jūs patiešām vēlaties sākt rezervāciju no jauna?', C3: 'Vēlaties sākt rezervāciju no jauna?', eP: 'Pienākšanas osta Stokholmā ir Kapelšēras osta (90 km no Stokholmas)', eQ: 'Atiešanas osta Stokholmā ir Kapelšēras osta (90 km no Stokholmas)', eR: 'Atiešanas un pienākšanas osta Stokholmā ir Kapelšēras osta (90 km no Stokholmas)', Da: 'Burbuļu festivāls', eS: 'Insurance', Db: 'FriendShip piedzīvojumu komplekts', Dc: 'Bērnu komplekts', Dd: 'Prioritārā uzkāpšana', De: 'Pakalpojumi uz kuģa', Df: 'Kuģa nauda', Dg: 'kupons', Dh: 'Kuģa naudas kuponi', Di: 'vieta', Dj: 'Pakalpojums nav pieejams, ceļojot maršrutā {route}', Dk: 'Viena diena', eT: 'Vienā virzienā vai turp atpakaļ.<br>Atiešanas ik dienu.', Do: 'Vai', Dp: 'Cits', eU: 'Cits maksājuma veids', eX: '12+ g.v.', eY: 'Paldiski', eZ: 'Novietots transportlīdzeklis', DI: 'Ballīte baltijas jūrā', DJ: 'Baltijas jūra - Tallina', e_: 'Pasažiera vecuma katogoriju nav iespējams mainīt', DM: 'Nepareiza vecuma grupa – pārliecinieties, ka ievadītais vecums atbilst pieaugušajam.', DN: 'Nepareiza vecuma grupa – pārliecinieties, ka ievadītie dzimšanas dati atbilst pieaugušajam vai jaunietim.', DO: 'Pārbaudiet, vai esat ievadījis datus DD-MM-GGGG laukā', DP: 'Ievadot vecumu, drīkst izmantot tikai skaitļus', DQ: 'Aizpildīt vēlāk', DR: 'Saglabāt', DS: 'Lūdzu, pārbaudiet vārdu, uzvārdu un Club One numuru.', DT: 'Club One numurs', DU: 'jau ir pievienots.', DV: 'Rediģējiet datus vai', DW: 'aizpildiet no jauna', DX: 'Informācija par ceļošanas dokumentu tiks pievienota Club One kontam.', DY: 'Dokumenta izdošanas valsts *', DZ: 'Dokumenta derīguma termiņš *', D_: 'Dokumenta izdošanas datums *', D$: 'Dokumenta numurs *', D0: 'Dokumenta veids *', D1: 'Dzimšanas valsts*', D2: 'Speciālā palīdzība', D3: 'Lūdzu norādiet papildu informāciju pa telefonu:', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Pievienot pasažieri', Ec: '<span class=\"data\">{count}</span> {count, plural, one{pasažieris} other{pasažieri}} izvēlēts/-i', Ed: 'Aizpildīt tagad vai vēlāk', Ee: 'Pasažieru dati ievadīti', Ef: 'Pasažieri', e0: 'Drīzumā!', e1: 'Jūsu rezervācijas numurs', e2: 'Kredītkarte', e3: 'Noņemt', Ei: 'Apmaksa', e4: 'Izvēlieties apmaksas veidu', Ej: 'Rēķins', Ek: 'Rēķina adrese', e5: 'Maksāt ar uzņēmuma rēķinu', El: 'Jūsu atsauces numurs', e6: 'Maksāt vēlāk', e7: 'Ērts mobilais maksājums', e8: 'Maksāt tagad, lai apstiprinātu rezervāciju', e9: 'Bankas pārskaitījums', fa: 'Operatora noteiktie tarifi', fb: 'Operatora noteiktie tarifi', fc: 'Maksa par zvanu ir 85 centi/zvans + telefonoperātora izmaksas.', fd: 'Maksa par zvanu: 8,35 centi/zvans + 16,69 centi/minūtē.', fe: 'Operatora noteiktie tarifi', ff: 'Operatora noteiktie tarifi', fg: 'Operatora noteiktie tarifi', fh: 'Operatora noteiktie tarifi', fi: 'Zvans ir bezmaksas.', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Zvaniet klientu servisam', fk: 'Neapmaksātās rezervācijas tiks automātiski atceltas.', fl: 'Maksājums netika veikts. Mēģiniet vēlreiz vai arī sazinieties ar mums.', fm: 'Izmainiet savu<u>atzīmēto valsti</u> uz oriģinālo, lai pabeigtu maksājumu.', fn: 'Rezervācija tika veikta citā tirgū.', Ex: 'un {points} punkti', r0: 'pers.', EA: 'pers.', EH: 'D-Terminal', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs', EM: 'West terminal 2', EN: 'West Terminal', EO: 'West Terminal', EP: 'St.Pēterburga', EQ: 'Mariehamna', ER: 'Mūgas osta', ES: 'Olympia Terminal', ET: 'Paldiski', EU: 'Rīgas pasažieru osta', EV: 'Sassnitz', EW: 'Turku osta', EY: 'Värtahamnen', EZ: 'Visbija', E_: 'Ventspils', E$: 'Vuosāri osta', E5: 'Iepriekš izvēlēts', E6: 'Rezervēt ceļojumu', E7: 'Atcelt', E8: 'Turpināt', E9: 'Paveikts', fo: 'Nākamais', Fa: 'Labākā cena:', Fb: 'Labākā cena ar Club One:', Fc: 'Club One cena', Fd: 'Lūdzu, pievienojiet papildu kajītes', Fe: 'Gala cenu Jūs redzēsiet, kad pievienosiet kajīti', fp: 'Izvēlieties kajītes klasi, lai turpinātu', Ff: 'Summa:', Fg: 'Kopā:', fq: 'Cena ar Club One:', Fh: 'Tiek pārbaudīta cena...', Fj: 'Cena pasažierim/transportlīdzeklim ar iekļautu degvielas un emisiju piemaksu sākot no.', Fl: '{price} / gb.', sa: 'Turpināt', fr: 'Veikt apmaksu', Fs: 'Šo vietni aizsargā reCAPTCHA un Google\n<a target=\"_blank\" href=\"https://policies.google.com/privacy\">Privātuma politika</a> un\n<a target=\"_blank\" href=\"https://policies.google.com/terms\">Pakalpojumu sniegšanas noteikumi</a>.', ft: 'Izmaiņas pakalpojumos uz kuģa:<br>\nPk-S uz kuģa skan dzīvā mūzika un notiek bingo spēle.<br>\nSv-C uz kuģa ierobežota izklaides un atpūtas programma.', fu: 'Standarta cena:', Fy: 'Noņemiet esošo laika izvēli, lai izvēlētos šo', FA: 'Rezervācijas maksa {fee} tiks atrēķināta no kopējās rēķina summas.', FB: 'Rezervācijas maksa netiek piemērota bērniem līdz 5 gadu vecumam.', sq: 'Aizvērt', FD: 'Ir radusies kļūda. Lūdzu, atkārtoti ielādējiet lapu un sāciet rezervāciju no sākuma.', FE: 'Neatradām nevienu gaidāmo ceļojumu', fv: 'Sākt no jauna', fw: 'Atvainojamies par sagādātajām neērtībām. Jūsu rezervācija tiks automātiski atcelta.', fx: 'Jūsu sesijas laiks ir beidzies', FF: 'Sākt no jauna', FG: 'Lūdzu, sāciet no jauna. Atvainojamies par sagādātajām neērtībām.', FH: 'Kļūda', fz: 'Rīga', fA: 'Divas naktis uz kuģa un diena Klaipēdā.', fB: 'Viena virziena ceļojums vai turp un atpakaļ.<br>Kuģis atiet plkst. 17:00.', fC: 'Stokholma-Turku-Turku-Stokholma(Kapelšēra)', fD: 'Stokholma(Kapelšēra)-Turku', fE: 'Stokholma(Kapelšēra)-Turku-Turku-Stokholma', fF: 'Turku-Stokholmas-Stokholmas (Kappellskär)-Turku', fG: 'Turku-Stokholma(Kapelšēra)', fH: 'Turku-Stokholmas (Kappellskär)-Stokholmas-Turku', fI: 'Atpakaļ uz sarakstu', fJ: 'Diemžēl nevaram atrast banku, ko Jūs meklējat. Mēģiniet to atrast sarakstā.', fK: 'Meklēt', fL: 'Zasnica', fN: 'Lūdzu, izvēlieties vismaz vienu transportlīdzekli', Ge: 'Pievienojot transportlīdzekli,<b>tiks atcelts {service}</b> pakalpojums. Vai esat pārliecināts, ka vēlaties turpināt?', Gf: 'Vai esat pārliecināts?', Gv: '5h kruīzs', Gw: 'Vairākas atiešanas dienā no Helsinkiem. Kopumā ceļojums ilgs 5 stundas. Tallinā nav nokāpšana. Iespējams saņemt atlaides lieliem pirkumiem. Ja plānojat lielus pirkumus, ērtāk ir ceļot ar auto. Uz Megastar pieeja auto ir no garāžas blakus Traveller Superstore uz 7. klāja. Uz kuģa Star automašīnas atrodas uz auto klāja.', Gy: 'Izvēlētais atpakaļceļa laiks ir atbilstošs 5h kruīzam. Jūs tiksiet pārvirzīts uz attiecīgo lapu.', fO: 'Lielisks brīdis sev pašam', GE: 'Parādīt galdiņu rezervācijas', fP: 'Sāremā', GK: '15-17 gadu vecumā atļauts ceļot bez pieaugušā pavadības. Neaizmirsti paņemt līdzi <a href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf/7a0c8141-c394-42b5-a6db-29469450ddc6\" target=\"_blank\">ceļošanas atļauju</a> . Drošus ceļojumus!', fQ: 'St.Pēterburga', GQ: 'Uzkoda', fR: 'Stokholma', GY: 'Lai sāktu, iegādājieties STO-HEL', GZ: 'No Stokholmas uz Tallinu izvēlētajā datumā nav tiešā reisa, taču jūs varat ceļot caur Helsinkiem un no turienes doties ar kuģi uz Tallinu.', G_: 'Svarīgi! Lai mainītu kuģi, jums būs jādodas no Olympia Terminal uz West Terminal 2.', G$: 'Stokholma -> Tallina <br/> caur Helsinkiem', fS: 'Jauna kārtība alkohola tirdzniecībai<br>\nSaskaņā ar valdības jauno regulējumu mēs pasniedzam alkoholu līdz 22:00. Mūsu kuģa restorāni, bāri un krodziņi būs atvērti līdz 22:30. Tas ir spēkā no 20.11.2020. līdz 28.02.2021.', fT: 'Divas naktis uz kuģa, viena diena Visbijā - šovasar Silja Symphony veiks četrus kruīzus no Stokholmas uz Visbiju', fU: 'Divas naktis uz kuģa, divas dienas Visbijā, lai atklātu Gotlandi. Uz kuģa izdevīgi iepērcies duty-free.', fV: 'Stokholmas (Kappellskär)', fW: 'Trīs naktis uz kuģa, viena diena Īstadā un viena diena Visbijā.', fX: 'Piemaksa', fY: 'Tallina', G8: 'Tallina - Baltijas jūra', fZ: 'Tallina - Baltijas jūra - Tallina', f_: '2 dienas uz kuģa un 1 diena Rīgā', G9: 'Lai sāktu, iegādājieties TAL-HEL', Ha: 'No Tallinas uz Stokholmu izvēlētajā datumā nav tiešā reisa, taču jūs varat ceļot caur Helsinkiem un no turienes doties ar kuģi uz Stokholmu.', Hb: 'Svarīgi! Lai mainītu kuģi, jums būs jādodas no West Terminal 2 uz Olympia Terminal. <b>Ja izvēlaties atiešanas laiku plkst. 13:30, iespējams, jums nepietiks laika, lai veiktu pārsēšanos, izmantojot sabiedrisko transportu.</b>', Hc: 'Tallina -> Stokholma <br/> caur Helsinkiem', f$: 'Divas naktis uz kuģa<br> un diena Turku.', f0: 'Vienā virzienā vai turp atpakaļ.<br>Atiešanas uz Turku ik dienu.', f1: 'Visbijas kruīzi', f2: 'Vasaras īpašie kruīzi uz maģisko Gotlandes salu', tb: 'paldies par informāciju', td: 'Atpakaļceļš', f3: 'Rezervējiet atpakaļceļu un saņemiet līdz 30% atlaidi', f4: 'Jūsu turpceļš un atpakaļceļs ir vienā dienā. Pērkot dienas kruīzu, saņemsiet atlaidi.', o6: 'Pienākšana', f5: 'Vai meklējat vēlāku ceļošanas datumu?', f6: 'Izvēlēties datumu', f7: 'Atiestatīt', Hx: 'Izvēlēties datumu', f8: '23 st. kruīzs (vakars)', f9: '23 st. kruīzs (rīts)', ga: 'Kruīzs uz Stokholmu', gb: 'Kruīzs uz Turku', o7: 'Atiešana', Hy: 'Vakars', Hz: 'Rīts', te: 'Ilgums', tf: 'st.', HA: 'Pavadiet pirmo nakti uz kuģa un dodieties projām sev ērtā laikā no 8.00-11.00.', HB: 'Pirmā nakts uz kuģa', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'Nav pieejams', gc: 'Dzēst atpakaļceļa biļeti', gd: '5h kruīzs ar kuģi Megastar', ge: 'Slēgts', gf: 'Kruīzs ar atgriešanos uzreiz, ietver 5h kruīza atlaidi pasažieriem un transportlīdzekļiem. Kruīza laikā nav paredzēta nokāpšana.', gg: '5h kruīzs ar kuģi Megastar', gh: 'Baudiet 1 dienu uz kuģa un 4 st. Tallinā', gi: 'Ceļojiet no Stokholmas vakarā, 23 st.', gj: 'Ceļojiet no Stokholmas no rīta, 23 st.', gk: 'Baudiet 2 dienas ceļojumā un 1 dienu Turku', gl: 'Ceļojiet no Turku vakarā, 23 st.', gm: 'Ceļojiet no Turku no rīta, 23 st.', gn: 'Kruīzs Helsinki–Stokholma–Helsinki', go: 'Ceļojums no Helsinkiem uz Stokholmu', gp: 'Kruīzs Helsinki–Tallina–Helsinki', gq: 'Diena Tallinā', gr: 'Ceļojums no Helsinkiem uz Tallinu', gs: '5h kruīzs ar kuģi Megastar', gt: 'Kruīzs Rīga–Stokholma–Rīga', gu: 'Ceļojums no Rīgas uz Stokholmu', gv: 'Kruīzs Stokholma–Helsinki–Stokholma', gw: 'Ceļojums no Stokholmas uz Helsinkiem', gx: 'Kruīzs Stokholma–Rīga–Stokholma', gy: 'Ceļojums no Stokholmas uz Rīgu', gz: 'Kruīzs Stokholma–Tallina–Stokholma', gA: 'Ceļojums no Stokholmas uz Tallinu', gB: 'Kruīzs Stokholma–Turku–Stokholma', gC: 'Vienā virzienā no Stokholmas uz Turku', gD: 'Kruīzs Tallina–Helsinki–Tallina', gE: 'Diena Helsinkos', gF: 'Ceļojums no Tallinas uz Helsinkiem', gG: 'Kruīzs Tallina–Stokholma–Tallina', gH: 'Ceļojums no Tallinas uz Stokholmu', gI: 'Kruīzs Turku–Stokholma–Turku', gJ: 'Ceļojums no Turku uz Stokholmu', HH: 'Ar viesnīcu', tg: 'Kruīzs', gK: 'Dienas kruīzs uz Helsinkiem', gL: 'Dienas kruīzs uz Tallinu', gM: 'Dienas kruīzs uz Ālandu salām', gN: 'Kruīzs uz Stokholmu', gO: 'Kruīzs', gP: '9h kruīzs', gQ: 'Kruīzs uz Stokholmu', gR: 'Kruīzs', gS: 'Dienas kruīzs uz Ālandu salām', gT: 'Cruise to Helsinki', gU: 'Kruīzs uz Stokholmu', gV: '22 h kruīzs', gW: 'Kruīzs', gX: 'Kruīzs uz divām pilsētām', gY: 'Paslēpt &uarr;', gZ: 'Vairāk &darr;', g_: 'Ceļojums vienā virzienā', le: 'Uz', g$: 'Mēs pievienojām vienu pieaugušo Jūsu rezervācijai. Rezervācijā ir nepieciešams vismaz viens pieaugušais.', g0: 'Garāža ir noņemta no rezervācijas. Prioritātes automašīna ir iekļauta Biznesa klases cenā.', g1: 'Prioritātes automašīna ir iekļauta Biznesa klases cenā.', g2: 'Šīs klases kajīte vairs nav pieejama. Lūdzu, izvēlieties citas klases kajīti.', HP: 'Reģistrācijas ID aizpildīts', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Izvēlētais transfērs šajos datumos ir izpārdots', g5: 'Izvēlētie autobusa transfēri nav pieejami un ir atvienoti.', HQ: 'Labdien, {name}!', g6: 'Lai ceļojumu iegādātos ar Club One punktiem, Jums ir nepieciešami vismaz {clubOnePoints} punkti.', g7: 'Trūkst dati par iepriekšējo pasažieri. Pārbaudiet, vai esat aizpildījis visus nepieciešamos laukus.', g8: 'Informāciju nav iespējams saglabāt, jo ir pazudis interneta pieslēgums. Pieslēdziet internetu un mēginiet vēlreiz.', g9: 'Trūkst dati par pasažieriem. Lūdzu, aizpildiet visus laukus, lai saglabātu informāciju.', HR: 'Nav iekļauti visi pasažieri', HS: 'Katrā numurā ir jābūt vismaz vienam pieaugušajam', ha: 'Lai izvēlētos šo ēdināšanu, atceliet iepriekšējo.', HU: 'Nepieciešams viens pieaugušais transfēra rezervācijai.', hb: 'Lūdzu, pārbaudiet savu interneta pieslēgumu un mēģiniet vēlreiz', hc: 'Vecuma kategorija tika mainīta no \"{old}\" uz \"{new}\"', hd: 'Viena kajīte tika atcelta, jo Jūs noņēmāt vienu pasažieri. Katrā kajītē ir jābūt vismaz vienam pieaugušajam.', he: '{name} pievienots Club One', hf: 'Jūs esat sasniedzis vienas rezervācijas maksimālo pasažieru skaitu', hg: 'Rezervācijā tika pievienota ēdināšana jaunajiem pasažieriem', hh: 'No rezervācijas tika noņemta ēdināšana dzēstajiem pasažieriem', hi: 'No rezervācijas tika noņemts auto, jo Jūs dzēsāt pasažieri. Katrā auto ir jābūt vismaz vienam pieaugušajam.', hj: 'NB! Iepriekšējais pasažieru skaits ir noņemts. Maršrutā Mūga-Vuosāri maksimālais pasažieru skaits uz vienu rezervāciju ir 5 personas.', hk: 'Dienas ceļojuma atlaide ir iekļauta!', hl: 'Apstrādājot kursēšanas grafikus, ir radusies kļūda.', hm: 'Ar nakšņošanu uz kuģa', hn: 'Atlaide dienas ceļojumam uz Turku pievienota', ho: 'Atlaide dienas ceļojumam uz Stokholmu pievienota', HV: 'Ilgs gaidīšanas laiks Stokholmā.', hp: 'Jūs pievienojāt pēdējo pieejamo kajīti \"{name}\"', hq: 'Jūs jau esat izvēlējies maksimālo kajīšu skaitu. Ir jābūt vismaz 1 pieaugušajam katrā kajītē', hr: '\"{name}\" kajītes ir izpārdotas.', hs: 'Tika pievienots pēdējais auto', ht: 'Nav iespējams pievienot papildu auto. Uz 1 pieaugušo var pievienot tikai 1 auto.', hu: 'Tallinā ar auto krastā izbraukt nevar', hv: 'Ceļojums ar auto ir iespējams tikai turpceļā', hw: 'Ceļojums ar auto ir pieejams tikai atpakaļceļā', hx: 'Ceļojumā nav iespējams pievienot izvēlēto transportlīdzekli', hy: '+ dzīvn.', hz: 'Alerģija', hA: 'Būris', hB: 'Būris', hC: 'Ar ierobežojumiem', hD: 'kajīte', hE: 'kajītes', hF: 'Ir jābūt vismaz 1 pieaugušajam katrā kajītē', H1: 'Izpārdots', hG: 'Tikai {capacity} personām palikušas kajītes', hH: 'Tikai {capacity} personām palikušas kajītes {from}-{to}', hI: 'Ceļojums ar mājdzīvniekiem', hJ: 'Atklāj vairāk', hK: 'Dalītā vieta kajītē', hL: 'siev.', hM: 'vīr.', hN: '{name}, {genderPlace} dalītajā {maxOccupancy} - vietīgajā kajītē', hO: '{price} / kajīte', tm: '{price} / pers.', hP: 'Ceļojuma klase', hQ: 'Speciālās kajītes', H2: 'Kajītes', hR: 'dzīvn.', hS: 'dzīvn.', hT: 'Ar mājdzīvniekiem', hU: 'Pavadiet divas naktis uz Silja Symphony vai Silja Serenade. Ciemojieties Stokholmā apmēram 6 st. Atpakaļceļā dodieties ar to pašu kuģi un tajā pat kajītē.\nPiedzīvojiet fantastisku izklaides programmu, veiciet izdevīgus tax-free pirkumus un baudiet gardus ēdienus kuģa restorānos.', hV: '22 st. mini kruīzs ar nesen renovēto Europa. Atiet kattru dienu no Helsinkiem uz Tallinu plkst. 18:30.\nNākamajā dienā 4 st. krastā Tallinā (08:00–12:10).', hW: 'Pavadiet divas naktis uz Isabelle vai Romantika. Ciemojieties Stokholmā apmēram 6 st. Atpakaļceļā dodieties ar to pašu kuģi un tajā pat kajītē.\nPērciet ceļojumu vienā virzienā vai turp un atpakaļ. Baudiet gardus ēdienus, izdevīgus pirkumus un vakara izklaides programmu.', hX: 'Atiešana no Stokholmas plkst. 07:10. Ceļojiet ar Baltic Princess uz Ālandu salām, no kurienes tālāk ceļojiet ar Galaxy. Atgriešanās Stokholmā apmēram plkst. 18:15.', hY: 'Pavadiet divas naktis uz Silja Symphony vai Silja Serenade. Ciemojieties Helsinkos apmēram 7 st. Atpakaļceļā dodieties ar to pašu kuģi un tajā pat kajītē. Ceļojumā pavadītais laiks 40 st.\nPiedzīvojiet fantastisku izklaides programmu, veiciet izdevīgus tax-free pirkumus un baudiet gardus ēdienus kuģa restorānos.', hZ: 'Pavadiet divas naktis uz Isabelle vai Romantika. Ciemošanās Rīgā apmēram 6 st. Atpakaļceļā dodieties ar to pašu kuģi un tajā pat kajītē. Ceļojumā pavadītais laiks 40 st.\nBaudiet gardus ēdienus, izdevīgus pirkumus un vakara izklaides programmu.', h_: 'Pavadiet divas naktis uz Baltic Queen vai Victoria I. Ciemojieties Tallinā apmēram 7 st. Kopējias ceļojuma ilgums 40 st.\nBaudiet gardus ēdienus un izdevīgus tax-free pirkumus, relaksējieties saunā vai džakuzi. Un baudiet vakara izklaides programmu.', h$: 'Atiešana no Stokholmas plkst. 19:30. Pavadiet vienu nakti uz Galaxy. Turku bez izkāpšanas krastā. Atgriezieties Stokholmā jau nākamajā dienā. \nBaudiet gardus ēdienus, izdevīgus tax-free pirkumus, kā arī atklājiet vakara izklaides programmu.', h0: 'Pavadiet divas naktis uz Baltic Queen vai Victoria I. Ciemojieties Stokholmā apmēram 7 st. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nBaudiet gardus ēdienus un izdevīgus tax-free pirkumus, relaksējieties saunā vai džakuzi. Un baudiet vakara izklaides programmu.', h1: 'Atiešana no Turku 08:15. Ceļo ar Galaxy uz Ālandu salām, kur jānomaina kuģis uz Baltic Princess. Atgriešanās Turku plkst. 19:15.', h2: 'Atiešana no Turku plkst. 20:15. Pavadiet vienu nakti uz Baltic Princess. Stokholmā bez izkāpšanas krastā. Atgriezieties Turku jau nākamajā dienā. Baudiet gardus ēdienus, izdevīgus tax-free pirkumus, kā arī atklājiet vakara izklaides programmu.', h3: 'Ceļojiet uz Ālandu salām ar Silja Serenade vai Silja Symphony.', h4: 'Pavadiet nakti uz Silja Symphony vai Silja Serenade. Ierašanās Stokholmā nākamajā rītā. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nPiedzīvojiet fantastisku izklaides programmu, veiciet izdevīgus tax-free pirkumus un baudiet gardus ēdienus kuģa restorānos.', h5: 'Vairāki reisi dienā. Ceļojiet komfortabli un ātri. Ceļā pavadītais laiks uz Star un Megastar tikai 2 st. un uz Victoria I 3.5 st.', h6: 'Ceļojiet katru dienu starp Helsinkiem (West Terminal 2) un Tallinu. Ātri un ērti ar Tallink Shuttle kuģiem Star un Megastar. Ceļā tikai 2 st.', h7: 'Divi reisi dienā no Helsinkiem: 10:30 un 16:30. Kopējais ceļojuma laiks ir 5 st. un Tallinā nav iespējams izkāpt krastā.\nLielu pirkumu gadījumā Jūs varat saņemt atlaides. Ja plānojat veikt lielus pirkumus, ir ērtāk ceļot ar auto, to atstājot auto garāžā, kas atrodas blakus Traveller Superstore uz 7. klāja.', h8: 'Pavadiet nakti uz Isabelle vai Romantika. Ierašanās Stokholmā nākamajā rītā. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nBaudiet gardus ēdienus, izdevīgus pirkumus un vakara izklaides programmu.', h9: 'Atiešana uz Ālandu salām četras reizes dienā. Ceļojiet ar  Baltic Princess, Galaxy, Silja Serenade, Silja Symphony, Victoria I vai Baltic Queen.', ia: 'Pavadiet nakti uz Silja Symphony vai Silja Serenade. Ierašanās Helsinkos nākamajā rītā. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nPiedzīvojiet fantastisku izklaides programmu, veiciet izdevīgus tax-free pirkumus un baudiet gardus ēdienus kuģa restorānos.', ib: 'Pavadiet nakti uz Isabelle vai Romantika. Ierašanās Rīgā nākamajā rītā. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nBaudiet gardus ēdienus, izdevīgus pirkumus un vakara izklaides programmu.', ic: 'Pavadiet vienu nakti uz Baltic Queen vai Victoria I. Ierašanās Tallinā nākamajā rītā. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nBaudiet gardus ēdienus un izdevīgus tax-free pirkumus, relaksējieties saunā vai džakuzi. Un baudiet vakara izklaides programmu.', id: 'Pavadiet pusi dienas vai vienu nakti uz Baltic Princess vai Galaxy.\nBaudiet gardus ēdienus, izdevīgus tax-free pirkumus, kā arī atklājiet vakara izklaides programmu.', ie: 'Ceļojiet uz Ālandu salām ar Baltic Queen vai Victory I.', $8: 'Vairāki reisi dienā no Tallinas (D-terminal). Ceļojiet komfortabli un ātri. Ceļā pavadītais laiks uz Star un Megastar tikai 2 st. un uz Victoria I 3.5 st.', ig: 'Ceļojiet katru dienu starp Tallinu un Helsinkiem (West Terminal 2). Ātri un ērti ar Tallink Shuttle kuģiem star un Megastar. Ceļā tikai 2 st.', ih: 'Pavadiet vienu nakti uz Baltic Queen vai Victoria I. Ierašanās Stokholmā nākamajā rītā. Pērciet ceļojumu vienā virzienā vai turp un atpakaļ.\nBaudiet gardus ēdienus un izdevīgus tax-free pirkumus, relaksējieties saunā vai džakuzi. Un baudiet vakara izklaides programmu.', ii: 'Ceļojiet uz Ālandu salām ar Baltic Princess vai Galaxy.', ij: 'Pavadiet pusi dienas vai vienu nakti uz Baltic Princess vai Galaxy.\nBaudiet gardus ēdienus, izdevīgus tax-free pirkumus, kā arī atklājiet vakara izklaides programmu.', ik: '2 naktis uz kuģa un diena Helsinkos', il: '2 naktis uz kuģa un diena Tallinā', im: 'Baudiet 2 dienas ceļojumā un vienu dienu Ālandu salās', $9: '22 st. kruīzs uz Tallinu.<br>Tallinā laiks krastā 4 st.', io: 'Relaksējoša mini-atpūta jūrā', ip: 'Kruīza ceļojums uz Ālandu salām un atpakaļ.<br>Bez nokāpšanas.', iq: 'Divas naktis uz kuģa.<br>Laiks krastā apmēram 7 st.', ir: 'Divas naktis uz kuģa.<br>Laiks krastā apmēram 6 st', is: 'Divas naktis uz kuģa.<br>Laiks krastā apmēram 7 st', it: 'Viena naktis uz kuģa, bez nokāpšanas krastā.<br>Ceļošana vakarā ar Galaxy.', iu: 'Izbaudi 23 stundu kruīzu uz Baltic Princess klāja', iv: '11 st. kruīzs uz Ālandu salām un atpakaļ.<br>Atiešana no Turku plkst. 08:15.', iw: 'Viena naktis uz kuģa, bez nokāpšanas krastā.<br>Ceļošana vakarā ar Baltic Princess.', ix: 'Izbaudi 23 stundu kruīzu uz Baltic Princess klāja', iy: 'Viena naktis uz kuģa, bez nokāpšanas krastā.<br>Ceļošana vakarā ar Galaxy.', iz: 'Viena virziena vai turp un atpakaļ ceļojums.<br>Izbraukšana no Ālandu salām & Helsinkiem.', iA: 'Viena virziena ceļojums vai turp un atpakaļ.', iB: 'Vienā virzienā vai turp atpakaļ.<br>Atiešanas no Ālandu salām ik dienu.', iC: 'Viena virzienā vai turp un atpakaļ ceļojums.<br>Četras izbraukšanas dienā.', iD: 'Viena virziena vai turp un atpakaļ ceļojums.<br>Izbraukšana no Ālandu salām & Tallinas.', iE: 'Viena virziena vai turp un atpakaļ ceļojums.', iF: 'Viena virziena ceļojums vai turp un atpakaļ.<br>Kuģis atiet katru dienu plkst. 17:00.', iG: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Helsinkiem un Stokholmas kuģis atiet katru dienu.', iH: 'Cena ar atlaidi, dodoties atpakaļceļā tajā pat dienā.<br>2 st. vienā virzienā.', iI: 'Ceļojums vienā virzienā vai turp un atpakaļ.<br>2 st. vienā virzienā, ceļojot ar Victoria I 3.5 st.', iJ: '5h kruīzs ar vai bez auto.<br>Ietaupi laiku, enerģiju un naudu.', iK: 'Viena virziena ceļojums vai turp un atpakaļ.', iL: 'Viena virziena ceļojums vai turp un atpakaļ.', iM: 'Viena virziena vai kruīza ceļojums ar Sea Wind. <br> Divas atiešanas dienā', iN: 'Vienā virzienā vai turp atpakaļ.<br>Atiešanas no Rīgas ik dienu.', iO: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Rīgas un Stokholmas kuģis atiet katru dienu.', iP: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Stokholmas kuģis atiet četras reizes dienā.', iQ: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Stokholmas un Helsinkiem kuģis atiet katru dienu.', iR: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Stokholmas un Rīgas kuģis atiet katru dienu.', iS: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Stokholmas un Tallinas kuģis atiet katru dienu.', iT: 'Viena virziena ceļojums vai turp un atpakaļ.', iU: 'Viena virziena ceļojums vai turp un atpakaļ.<br>Kuģis atiet katru dienu plkst. 18:00.', iV: 'Viena virziena ceļojums vai turp un atpakaļ.<br>2 st. vienā virzienā, ceļojot ar Victoria I 3.5 st.', iW: 'Cena ar atlaidi, dodoties atpakaļceļā tajā pat dienā.<br>2 st. vienā virzienā.', iX: 'Viena virziena ceļojums vai turp un atpakaļ.<br>No Tallinas un Stokholmas kuģis atiet katru dienu.', iY: 'Viena virziena ceļojums vai turp un atpakaļ.', iZ: 'Viena virziena ceļojums vai turp un atpakaļ.', i_: 'Viena virziena ceļojums vai turp un atpakaļ.', i$: 'Viena virziena vai kruīza ceļojums ar Sea Wind. <br> Divas atiešanas dienā', i0: 'Turku', i1: 'Divas naktis uz kuģa un diena Talllinā.', i2: 'Vienā virzienā vai turp atpakaļ.<br>Atiešanas no Tallinas katru dienu.', H3: 'Divas dienas', i3: 'Divas naktis uz kuģa, divas dienas Hernesandā - papildus nakts uz kuģa Hārnosandā un divas dienas, lai iepazītu galamērķi. Iepērcies mūsu veikalos, kā arī izmanto duty-free iepirkšanos.', i4: 'Divas naktis uz kuģa, divas dienas Helsinkos - papildus nakts uz kuģa Helsinkos un divas dienas, lai iepazītu Somiju. Iepērcies mūsu veikalos, kā arī izmanto duty-free iepirkšanos.', i5: 'Baudiet 2 dienas ceļojumā un vienu dienu Ālandu salās', i6: 'Divas naktis uz kuģa un 1 diena Hernosandā', i7: 'Baudiet 2 dienas ceļojumā un 1 dienu Helsinkos', i8: 'Baudiet 2 dienas ceļojumā un 1 dienu Rīgā', i9: 'Divas naktis uz kuģa un diena Sāremā', ja: 'Baudiet 2 dienas ceļojumā un 1 dienu Stokholmā', jb: 'Baudiet 2 dienas ceļojumā un 1 dienu Tallinā', H7: 'Izmantot kodu', jc: 'Emisiju piemaksa par transportlīdzekļa pārvadājumu', jd: 'Rezervācijā norādītajam transportlīdzeklim tiek piemērota emisiju piemaksa par transportlīdzekļa pārvadājumu.', Id: 'Degvielas un emisiju piemaksa', Ie: 'Rezervācijā norādītajam transportlīdzeklim tiek piemērota degvielas un emisiju piemaksa par transportlīdzekļa pārvadājumu', je: 'Augstums līdz 1.5 m un garums līdz 3.0 m', jf: 'Augstums līdz 1.9 m un garums līdz 5.0 m', jg: 'Pievieno garāžu un ērti novieto auto blakus Traveller Superstore &rarr;', jh: 'Gribi būt viens no pirmajiem savā galamērķi? Pievieno prioritāti automašīnai un &rarr;', ji: 'Augstums virs 2.4 m un garums līdz 8.0 m', jj: 'm', jk: 'Augstums līdz 1.9 m un garums līdz 5.0 m. Ceļojuma galamērķī ar auto no kuģa nobraukt nav iespējams.', jl: 'Lūdzu, ievadiet reģistrācijas nr. visiem transportlīdzekļiem', Ii: 'Noņemt', jm: 'Izvēlieties transportlīdzekli no iepriekšējā ceļojuma:', jn: 'Augstums līdz 2.3 m un garums līdz 7.0 m', jo: 'Augstums līdz 1.9 m un garums līdz 12.0 m', jp: 'Piekabes reģistrācijas numurs', jq: 'Lūdzu, izmantojiet tikai latīņu burtus, bez mīkstinājuma zīmēm un garumzīmēm.', jr: 'Augstums līdz 2.4 m un garums līdz 7.0 m', js: 'Trūkst info par transportlīdzekli', jt: 'Auto reģistrācijas numurs', ju: 'Pievienotais autotransports:', jv: 'Tiek pārbaudīta auto pieejamība', Il: 'Ceļojums caur Helsinkiem', jw: 'Visbija', jx: 'Īstada/Visbija', jy: 'Ventspils', Ip: 'Vaučers:', Iq: 'Lūdzam autorizēties Club One kontā, lai apskatītu piedāvājuma pieejamību.', Ir: 'Atvainojiet, šī dāvanu karte jau ir pievienota.', Is: 'Atvainojiet, šīs dāvanu kartes termiņš ir beidzies.', It: 'Atvainojiet, šai dāvanu kartei ir cita valūta.', Iu: 'Atvainojiet, šajā dāvanu kartē nav līdzekļu.', jz: 'Vuosāri', IA: 'Kruīzs', IC: 'wow', tE: 'Dienas kruīzs', jA: 'Īstada'};
var $author$project$Translations$Generated$ru = {P: 'Прочитайте нашу декларацию о доступности', Q: 'https://www.tallink.com/ru/dostupnost', tJ: 'добавить', R: 'Добавить еще один промокод', S: 'Чтобы добавить ТС, пожалуйста, добавьте в бронирование взрослых пассажиров. Велосипеды возможно добавить также и на детей 6-17 лет.', tK: 'Добавьте, пожалуйста, номера для всех пассажиров', pl: 'Добавить', tM: 'Travelling on route {route} is possible only with a vehicle.', tN: 'Would you like to add a vehicle to {route} route aswell?', tO: 'Add route?', T: 'Аландские острова', t_: 'Åland (Långnäs)', t$: 'Åland (Mariehamn)', ue: 'Вы уже добавили номер(а) в другом отеле. Чтобы выбрать этот отель, Вам необходимо сначала отменить предыдущий выбор номера(ов).', uj: 'Круиз', ul: 'Продолжить бронирование', um: 'Перейти на полную версию', un: 'При переходе на полную версию сайта Вам необходимо будет заново ввести следующие данные: <span class=\"bodyBold\">информацию о пассажирах, класс каюты, питание</span>.', uo: 'Данные Вашего выбора будут частично утеряны', up: 'При переходе на полную версию сайта часть информации будет утеряна: <span class=\"bodyBold\">информация о пассажирах и выбранное питание</span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Bank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'банкинг', aa: 'Выберите Ваш банк', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Логин Альфа-Клик или номер моб. телефона', ah: 'Последний выбранный', ai: 'Säästöpankki', aj: 'SEB', ak: 'Выберите банк:', al: 'S-Pankki', am: 'Swedbank', uB: 'добавить питание', uC: 'Забронируйте эти поездки отдельно:', uD: 'Добавить услуги на борту', uE: 'Вернуться на главную страницу &rarr;', uF: 'Вас интересуют дополнительные услуги, которых нет в списке?', uG: 'Добавить трансфер', uH: 'До и из порта', uI: 'Бронируйте билеты как бизнес-клиент', ao: 'Бронируйте легче, воспользуйтесь скидкой!', ap: 'Выйти &rarr;', uJ: 'Войти', aq: 'Вы являетесь клиентом Club One?', ar: 'Показать возможные даты', uK: 'Промокод не действует. Пожалуйста, выберите другую дату, рейс или класс каюты.', as: 'Проверьте промокод и попробуйте еще раз', uL: 'Отменить', at: 'Код бронирования применен', au: 'Промокод верен', uM: 'Ошибка в промокоде. Если Вы использовали код для проверки цены несколько раз, пожалуйста, подождите около 20 мин. и попробуйте снова.', av: 'Промокод временно заблокирован. Пожалуйста, подождите 30 мин. и попробуйте снова.', aw: 'Цена со скидкой по промокоду', ax: 'Промокод', ay: 'Промокод не действует на выбранную дату', az: 'Вы можете использовать промокод на другую дату отправления', aA: 'Цена c {oldPrice} изменилась на {discountedPrice}', aB: 'Изначальная цена: {oldPrice}, цена с учетом скидки: {discountedPrice}', aC: 'Удалить', uN: 'Промокод верен. Пожалуйста, выберите каюту, чтобы увидеть цену со скидкой', uO: 'Чтобы воспользоваться подарочной картой, пожалуйста, свяжитесь с поддержкой по телефону +372 640 9808', aD: 'Промокод учтен', aE: 'Добавить скидку', aF: 'пункты', uP: 'Добавить доп. услуги', aG: 'Fast track', aH: 'Гараж', aI: 'Страховка', uQ: 'Plan with Confidence', aJ: 'Priority Car', uR: 'Выберите пункт отправления', uS: 'Выберите пункт прибытия', aK: 'Забронировать рейс', uT: '22-хчасовой круиз из Хельсинки', uU: 'Круиз', uV: 'Круиз', uW: 'Пребывание на суше в пункте назначения не предусмотрено', py: 'Пребывание на суше в пункте назначения не предусмотрено', uX: 'Круиз \"День в Хельсинки\"', uY: 'Круиз \"День в Риге\"', uZ: 'Круиз \"День в Стокгольме\"', u_: 'Отправление', u$: 'Обратите внимание, что паром может не соответствовать потребностям пассажиров с инвалидностью.', aL: 'Круиз без схода на берег', u0: 'Возврат', u1: 'В одном направлении', u2: 'Туда-обратно', aM: 'Megastar шопинг-круиз', u3: 'В одном направлении', u4: 'Туда-обратно', ne: 'Дата', aN: 'Тип рейса', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Выберите язык', aV: 'Русский', aW: 'Изменить язык', u5: 'Выберите питание', aX: 'Питание можно приобрести на борту', u6: 'Питание на это отправление недоступно', u7: 'Заказывайте еду заранее и экономьте деньги', u8: 'Питание', aY: 'Промокод для получения скидки', u9: 'Дополнительные услуги', aZ: 'В бронировании должно быть только одно транспортное средство.', va: 'Covid-19', a_: 'Тест на Covid-19', vb: 'Браслеты FriendSHIP', vc: 'Massage', vd: 'Пассажиры', ve: 'Присоединяйтесь к Club One &rarr;', vf: 'https://clubone.tallink.com/join', vg: 'Выйти &rarr;', vh: 'Получить скидки Club One и ускорить процесс бронирования.', a$: 'Выберите класс каюты', vi: 'Класс', vj: 'Каюты', a0: 'Вело&shy;сипед, электросамокат', a1: 'Легковой автомобиль', a2: 'Легковой автомобиль', vl: 'Выбор транспортного средства', vm: 'Укажите гос. номер ТС', a3: 'Загрузка цен', a4: 'Мото&shy;цикл', a5: 'Мото&shy;цикл с коляс&shy;кой', a6: 'Припаркованный автомобиль', a7: 'Номер ТС заполнен автоматически', a8: 'Автомобиль для шопинга', a9: 'Микроавтобус для шопинга', ba: 'Пока&shy;зать все', bb: 'Легко&shy;вое ТС или микро&shy;авт.', bc: 'ТС выше 2.4 м', bd: 'ТС с прице&shy;пом', be: 'ТС с прице&shy;пом', bf: 'ТС с прице&shy;пом', bg: 'ТС с прице&shy;пом', vB: 'Добавить трансфер', bh: 'Добавить сюрприз в каюту', bi: 'Free gift', bj: '{count} сюрприза(ов) добавлено', bk: '{count} сюприз добавлен', vC: 'Загрузить ещё', bl: 'Загрузить предыдущие', bm: 'Дата', vD: 'Специальный круиз', bn: 'Внимание!', vE: 'Стоимость от {price}', vF: 'Нет доступных отправлений', vG: 'No departures on the selected date.', bo: 'Цены указаны в шведских кронах', bp: 'Стоимость каюты от {price} б.п.', bq: 'от {price} б.п. за человека', br: 'от {price} за человека', bs: 'Стоимость каюты от {price}', bt: 'Отменить', bu: 'Продолжить', bv: 'При переходе данные о каюте не будут сохранены. Информация о пассажирах сохранится.', bw: 'Выбранного Вами класса кают нет на дату отправления', vH: 'Спец.<br/>круиз', vI: 'Стоимость ТС от {price}', bx: 'Нет в наличии', by: 'эмиссионный сборы', bz: 'Сбор за выбросы применяется для пассажиров от 6 лет и старше.', bA: 'Эмиссионный сбор для поддержки климатических инициатив и покрытия расходов в рамках Системы торговли квотами на выбросы ЕС.', vQ: '{chars} символов осталось', vR: 'Заезд:', vS: 'Отъезд:', vW: 'Выбрать &rarr;', vX: 'Выбрать номер', vY: 'Выберите отель, чтобы увидеть общую стоимость пакета', v3: 'Отменить и выбрать новый', bB: 'Bronze level', bC: 'Club level', wd: 'Club one discount:', bD: 'Gold level', bE: 'Inactive club one', bF: 'Номер Club One', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Обновление статуса (inactive) карты Club One\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Обновление статуса (inactive) карты Club One\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Обновление статуса (inactive) карты Club One\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Обновление статуса (inactive) карты Club One\">clubone@tallink.lv', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Обновление статуса (inactive) карты Club One\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Обновление статуса (inactive) карты Club One\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Обновление статуса (inactive) карты Club One\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: 'Эл.почта:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Обновление статуса (inactive) карты Club One\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:clubone@tallink.ee?subject=Обновление статуса (inactive) карты Club One\"> Ваша учетная запись Club One требует обновления. Пожалуйста, свяжитесь с нами.</a>', bQ: 'Ваша учетная запись Club One требует обновления. Пожалуйста, свяжитесь с нами:', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Телефон:', b_: 'Platinum level', wg: '<a>Авторизуйтесь </a> или <a>присоединитесь к Club One</a>, чтобы получать скидки, использовать пункты и удобнее бронировать билеты.', b$: 'Silver level', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Максимальная сумма используемых бонусных пунктов рассчитывается автоматически в зависимости от заказанных при бронировании товаров и услуг.', wj: 'Используйте накопленные пункты Club One', wk: 'Club One points cannot be redeemed with this voucher code.', wl: 'Club One points can’t be used for this trip.', b0: '<a>Выберите</a> количество пунктов Club One для оплаты.', wm: 'Club One points cannot be redeemed ({reason}).', pQ: 'Промокод', wp: 'Введенный текст содержит недопустимые символы.', wr: 'Дата рождения', ws: 'дд', wt: 'мм', wu: 'гггг', wv: '{count} {count, plural, one{взрослый} other{взрослых}}', ww: '({range} лeт)', wx: 'Прибытие в {time}', pT: '{count} {count, plural, one{ребенок} other{детей}}', wy: 'Бесплатно', wz: 'Скрыть', wA: 'Ещё', wB: 'Гражданство', wC: 'Часто выбираемые', b1: 'В стоимость включена скидка клиента Club One уровня{level} .', wD: 'Пожалуйста, заполните информацию о владельцах карт Club One сейчас. Данные остальных пассажиров можно заполнить позже.', b2: 'б.п.', b3: 'Используйте бонусы Club One', b4: 'Скоро', wE: 'Добавьте карту Club One перед бронированием', wF: 'Готово', wG: 'Изменить &rarr;', b5: 'Укажите телефоны и эл. почту всех пассажиров, чтобы быстро и легко пройти регистрацию, делиться информацией о бронировании и посадочными билетами.', wH: 'Имя', wI: 'Пол', wJ: 'Жен.', wK: 'Муж.', wL: 'Добавлен', mh: 'Пожалуйста, проверьте написание', wM: 'Эта эл. почта указана почтой контактного лица или другого пассажира.', wN: 'Этот номер указан телефоном контактного лица или другого пассажира.', wO: 'Фамилия', wP: 'Чтобы сохранить, пожалуйста, заполните поля обозначенные (*)', wQ: 'Завтрак', wR: 'Бранч', wS: 'Ресторан Buffet', wT: 'Ужин', wU: 'Обед', wV: 'Ресторан À la carte', wW: 'Питание возможно забронировать на борту', wX: 'Данные должны содержать только латинские буквы', wY: 'Не доступен', b6: 'Не доступно на это отправление', wZ: 'Не требуется', b7: 'Взр.\n18+', b8: 'Реб.\n0-5', b9: 'Реб.\n6-11', ca: 'Реб.\n12-17', cb: 'Банк', w_: 'К оплате {price}', cc: 'Оплатить {price}', cd: 'Карта', w$: 'Подтвердить бронь {price}', w0: 'Подтверждаю {price}', ce: 'Оплатить системой Klarna {price}', cf: 'Платёж обрабатывается...', w1: '<p>Предлагаемый вам пакет туристических услуг - это пакетный тур в значении Директивы (EU) 2015/2302. </p><p>Таким образом, у вас есть все права, которые есть у пассажира в соответствии с законодательством ЕС в случае пакетного тура. Предприниматель AS Tallink Grupp несёт полную ответственность за пакетный тур как надлежащее представление услуг в целом.</p>\n<p>Кроме того, по закону требуется, чтобы у предпринимателя AS Tallink Grupp была гарантия, если он не в состоянии выполнить свои обязательства в связи с платёжеспособностью, возместить произведённые вами платежи и, если пакетный тур включает в себя перевозку пассажиров, обеспечить ваше возвращение в пункт отправления или другое согласованное место. </p>\n<p><a href=\"https://www.tallink.com/ru/polezno/turpakety\" target=\"_blank\">Ознакомиться с условиями пакетных туров</a>.</p>', pU: '<p>Предлагаемый вам пакет туристических услуг - это пакетный тур в значении Директивы (EU) 2015/2302. </p> \n<p>Таким образом, у вас есть все права, которые есть у пассажира в соответствии с законодательством ЕС в случае пакетного тура. Предприниматель {name} несёт полную ответственность за пакетный тур как надлежащее представление услуг в целом.</p>\n<p>Кроме того, по закону требуется, чтобы у предпринимателя {name} была гарантия, если он не в состоянии выполнить свои обязательства в связи с платёжеспособностью, возместить произведённые вами платежи и, если пакетный тур включает в себя перевозку пассажиров, обеспечить ваше возвращение в пункт отправления или другое согласованное место.</p>\n<a href=\"{url}\" target=\"_blank\">Ознакомиться с условиями пакетных туров</a>.', w2: 'Нажав на кнопку оплаты, Вы соглашаетесь с условиями <a href=\"https://www.tallink.com/lv-ru/polezno/oplata-annulirovanie\" target=\"_blank\">перевозки пассажиров</a>, а также с правилами программы лояльности <a href=\"https://www.tallink.com/good-to-know/club-one\" target=\"_blank\">Club One</a>.', w3: 'Нажимая кнопку оплаты, вы соглашаетесь с <a href=\"https://www.tallink.com/ru/polezno/oplata-annulirovanie\" target=\"_blank\">условиями оплаты и отмены</a> компании Tallink и <a href=\"https://www.tallink.com/ru/polezno/prava-i-objazannosti-passazhirov\" target=\"_blank\">правилами безопасности</a>, а также подтверждаете, что вы ознакомились с <a href=\"https://www.tallink.com/ru/politika-konfidencialnosti\" target=\"_blank\">политикой конфиденциальности</a>.', w4: 'AS Tallink Grupp', w5: 'https://www.tallink.ee/ru/pakettreisi-teabeleht-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://ee.tallink.com/ru/pakettreisi-teabeleht-tallink-silja', w8: 'Если Вам менее 18 лет, пожалуйста, ознакомьтесь с <a href=\"https://www.tallink.com/ee-ru/polezno/vozrastnye-ogranicenia\" target=\"_blank\"> возрастными ограничениями</a>.', w9: 'Alipay', xa: 'Apple Pay', xb: 'местные банки', xc: 'карты', xd: 'Google Pay', xe: 'Mobile Pay', xf: 'Дебетовая/кредитная карта', xg: 'WeChat Pay', xh: 'Интернет-банк и дебетовая/кредитная карта', xi: 'Местные банки', xj: 'Интернет-банк', cg: 'От {price}', xk: 'Обратно к выбору рейса', xl: 'Выбрать', xm: 'Выбрано', xn: 'Паром', xo: '{date} в {time}', xp: '{count} {count, plural, one{пассажир} other{пассажира/ов}}', xq: 'Взр.\n18+', xr: 'Реб.\n0-5', xs: 'Реб.\n6-17', xt: 'Пожалуйста, сначала выберите каюту', xu: 'Прибытие на Аландские о-ва в порт Лонгнес (Långnäs, 30 км от Мариехамн)', xv: 'Прибытие в порт Лонгнес (Långnäs)', xw: 'Отправление и прибытие с/на Аландские о-ва в порт Лонгнес (Långnäs, 30 км от Мариехамн)', xx: 'Отправление с Аландских о-вов из порта Лонгнес (Långnäs, 30 км от Мариехамн)', xy: 'Отправление из порта Лонгнес (Långnäs)', pV: 'ТС', xz: 'ТС', ch: '22-хчасовой круиз на Baltic Queen', ci: 'Круиз', cj: 'В одном направлении или туда-обратно', ck: 'Линейный рейс', cl: 'В одном направлении, туда-обратно, дневной круиз', xB: 'Бизнес клиент', xC: 'ID агента', xD: 'Агента с указанными учетными данными не найдено', xE: 'NB! ID агента не обязательно к заполнению', xF: 'Вы временно выйдете из своей личной учетной записи', xG: 'ID компании', xH: 'Компании с указанными учетными данными не найдено', cm: 'Подтверждение было отправлено на почту', cn: 'Бронирование завершено. Приятного путешествия!', co: 'К возврату {refund}.', cp: 'Пожалуйста, обратитесь в поддержку для возврата средств.', cq: 'Ваше бронирование изменено!', xI: 'Взрослые', xJ: 'Название места или города', xK: 'Не найдено', xL: 'Поиск остановки', xM: 'Трансферы', cr: 'Дети от 6 до 17', cs: 'Изменить бронирование', xN: 'Обычный билет', xO: 'Дети {range} лет', ct: 'Развлечения на берегу', cu: 'Нет', cv: 'Конечно', cw: 'Хотели бы Вы получать наши специальные предложения по e-mail?', cx: 'Благодарим Вас за подписку на нашу рассылку!', cy: 'Позвоните в службу поддержки', cz: 'Отменить', xP: 'Дата рождения не соответствует ранее выбранной возрастной категории. Пожалуйста, внесите правильную дату рождения или обратитесь в поддержку для изменения возрастной категории:', cA: 'Изменить возраст?', cB: 'Купить услуги', cC: 'Изменить услуги', cD: 'Адрес', cE: 'Компания', cF: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contacts\">клиентской поддержкой</a>.', cG: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss\">клиентской поддержкой</a>.', cH: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallink.com/ee-et/hea-teada/kontaktid\">клиентской поддержкой</a>.', cI: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallinksilja.fi/palvelunumerot\">клиентской поддержкой</a>.', cJ: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallink.lv/lv/contacts\">клиентской поддержкой</a>.', cK: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallinksilja.com/contact-us\">клиентской поддержкой</a>.', cL: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallinksilja.ru/agents\">клиентской поддержкой</a>.', cM: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallinksilja.se/kontakta-oss\">клиентской поддержкой</a>.', cN: 'Для изменения бронирования, пожалуйста, свяжитесь с <a href=\"https://www.tallinksilja.com/contact-us\">клиентской поддержкой</a>.', cO: 'Контактное лицо', cP: 'Контактное лицо', cQ: 'Для изменения бронирования, пожалуйста, свяжитесь с Вашим туристическим агентством.', cR: 'Электронная почта', cS: 'Присоединиться к Club One', cT: 'Подтверждение бронирования', cU: 'Регистрация (check-in) начинается за 2 часа до отправления. Пожалуйста, обратите внимание, что регистрация должна быть пройдена не позднее, чем за 45 минут до отправления.', cV: 'Пожалуйста, внесите данные всех пассажиров', cW: 'Отменить', cX: 'Далее', cY: 'Если нажать \"Продолжить\" - внесённые данные пассажиров не будут сохранены', cZ: 'Изменения не будут сохранены', c_: 'Открыть подтверждение бронирования в PDF', c$: 'Информацию о платежах Вы найдете в высланном на эл. почту подтверждении бронирования (PDF).', c0: 'Посмотреть условия оплаты и отмены бронирования', c1: 'https://www.tallink.com/lv-ru/polezno/uslovia-perevozki', xQ: 'Итого', c2: 'Номер телефона', c3: 'Номер брони', c4: 'Защитный код', c5: 'Подтверждение', c6: 'Прибытие и отправление указаны по местному времени.', c7: 'Вы можете зарегистрировать билет в киоске самообслуживания (self check-in) в терминалах отправлений. При регистрации укажите номер брони и защитный код.', c8: 'Рекомендуем прибыть на регистрацию заранее.', c9: 'Регистрация пассажиров без транспортных средств заканчивается за 30 минут до отправления парома. Рекомендуемое время прибытия в порт для пассажиров с транспортными средствами - за 1 час до отправления. Внимание! При путешествии на Аландские о-ва из Стокгольма или \nТаллинна, пожалуйста, будьте на автомобильной регистрации за 1,5 часа до отправления.', da: 'В случае дневного рейса или круиза: Tallink аннулирует весь рейс, если пассажир не зарегистрировал Билет в первом порту отправления.', db: 'Пожалуйста, проверьте наличие и сроки действия проездных документов (в том числе у детей). Если у Вас возникли сомнения в необходимости наличия визы, пожалуйста, свяжитесь с консульством или посольством страны назначения.', dc: 'Прибытие и отправление судна всегда указаны по местному времени. <br>\nЗарегистрироваться на рейс можно на сайте, в приложении Tallink Silja Line или в терминале. <br>\nВ портах Палдиски и Капельшера регистрация для пассажиров с транспортными средствами заканчивается за 75 минут до отправления парома Superfast. Рекомендуем прибыть в порт заранее.\nКлюч-карты от кают выдаются при регистрации. <br>\nКаждый пассажир (включая детей) обязан иметь при себе в течение всей поездки действительный рейсовый документ и другие требуемые документы, такие как виза при необходимости. <br>\nПассажиры несут ответственность за актуальность и точность своих документов.', dd: 'Информация о поездке', de: 'Информация для путешествия', df: 'Возврат', dg: 'К возврату {refund}! Пожалуйста, свяжитесь с поддержкой ,чтобы оформить возврат.', dh: 'Позвоните, чтобы оформить возврат', di: 'Уже обратились? Данное оповещение будет убрано, как только возврат будет оформлен с нашей стороны.', dj: 'Оформить возврат', xR: 'Если проблемы соединения с Интернетом невозможно решить, пожалуйста, свяжитесь с нашей службой поддержки для бронирования билетов по телефону + 372 6409808.', xS: 'Нет соединения с Интернетом, пожалуйста, проверьте и попробуйте снова.', xT: 'Попробуйте снова', xV: 'Продолжить', xW: 'Перейти к оплате', pX: 'Электронная почта', xX: 'Пример:', dk: 'Код страны и номер телефона', xY: 'Контактная ифнормация', xZ: 'Предоставьте нам Ваши контактные данные, чтобы мы смогли отправить подтверждение бронирования. Чтобы воспользоваться привилегиями Club One, войдите в личный кабинет или внесите номер карты Club One в данные пассажиров перед бронированием.', x_: 'Данная информация будет обновлена в учетной записи Club One', pY: 'Номер телефона', dl: 'Пример: 071234567', x$: 'Другое', x0: 'Копия подтверждения бронирования будет отправлена на {email}', dm: 'Дополнительная эл. почта', dn: 'Почтовый индекс', x6: '{price} / за 1 тест', x8: 'Забронируйте эту поездку быстрее с нашим новым <b>процессом бронирования</b>.', dp: 'Полное имя', dq: 'Кредитная карта', dr: 'мм', ds: 'Номер кредитной карты', dt: 'Способ оплаты', du: 'VPN - номер', dv: 'Выберите тип карты:', dw: 'Срок действия', dx: 'гг', dy: 'Cruise Stockholm(Kappellskär)-Turku-Stockholm(Kappellskär)', ya: 'Круиз в Хельсинки', yb: 'Круиз в Висбю', dz: 'Cruise Turku-Stockholm(Kappellskär)-Turku', yc: 'Круиз с посещением Истада', dA: 'Круиз \"День в Хельсинки\"', dB: 'Круиз \"День в Риге\"', no: 'Круиз \"День в Таллинне\"', yj: 'Круиз \"День в Турку\"', yr: 'Десерт', dC: 'Скидка:', yy: 'Применён', yz: 'Promotional code or gift card:', p9: 'Скидки и подарочные сертификаты', dD: 'Don’t forget to select one menu option for each adult passenger in {restaurant} reservation.', dE: 'Don’t forget to select one menu option for each 12 years and older passenger in {restaurant} reservation.', yB: 'Не упустите возможность!', yD: 'Выбрать пакет напитков', dF: 'Мы нашли неоплаченное бронирование на данную дату отправления. Номер брони: {resId}, стоимость: {price} {unit}. Вы хотите аннулировать старое бронирование и подтвердить оплату текущего? <a href=\"{link}\">Откройте и оплатите прошлое бронирование →</a> Чтобы продолжить, пожалуйста, обратитесь в службу поддержки', yF: 'Изменить номер', yG: 'Изменить номера', yO: 'Развлечения на берегу', yP: 'Развлечения на берегу и в отелях', yS: 'У каждого пассажира должно быть место в транспортном средстве.', dK: 'https://clubone.tallink.com/', yY: 'Доп. услуги', dL: 'Обратная связь', y_: 'Билеты на паром', y$: 'Гостиничный тур', y5: 'Выбрать меню', y7: 'Пищевые аллергии/ограничения питания:', kS: 'Из', za: 'Топливный и эмиссионный сборы', zb: 'Топливный и эмиссионный сборы применяются для пассажиров от 6 лет и старше.', zc: 'Топливный и экологический сборы взимаются с пассажиров в возрасте 12 лет и старше. От сбора освобождаются до трех детей в возрасте от 6 до 11 лет на одно бронирование.', zd: 'Топливный и эмиссионный сборы направлены на поддержку климатических инициатив и покрытие расходов в рамках Системы торговли квотами на выбросы ЕС.', dM: 'Топливный сбор', dN: 'Топливный сбор применяется для пассажиров от 6 лет и старше.', dO: 'Топливный сбор {price} с каждого пассажира от 6 лет.', dP: 'Топливный сбор {price} с каждого пассажира от 6 лет, на каждое отправление.', zh: 'Сертификат:', zi: 'Подарочный сертификат можно использовать для нескольких покупок, пока средства не будут израсходованы.\nНа счете подарочного сертификата {priceLeft} €.', dQ: 'Group menu available', zm: 'Для бронирований на 12 или более взрослых пассажиров, мы просим вас выбрать один вариант меню для каждого взрослого пассажира в бронировании. Младшим пассажирам автоматически будет выдан ваучер на детское меню стоимостью 25 евро.', dR: 'Хельсинки', dS: 'Две ночи на борту и день в Риге.', dT: '22-часовой круиз в Таллинн. <br>4 часа для пребывания на суше в Таллинне.', dU: 'Круиз в Таллинн.<br> 5 часов на суше в Таллинне.', dV: 'Visby cruises', dW: 'Summer special cruises to the magical Gotland island', dX: 'Хернёсанд', zv: 'Отель', zy: 'Чтобы выбрать дату за пределами выбранного диапозона, пожалуйста, <a>измените даты путешествия</a>.', dY: 'Заезд', dZ: 'Заезд', d_: 'Отъезд', d$: 'Отъезд', d0: 'ночи', d1: 'ночь', zz: 'После выбора отеля, откроется отдельное приложение для бронирования.', zA: 'Нет свободных номеров на выбранные даты. Пожалуйста, выберите новые даты путешествия.', zB: 'Вы не можете оформить заезд после даты отъезда. Вы можете поменять дату отъезда во вкладке Отъезд.', zC: 'Вы не можете оформить отъезд до даты заезда. Вы можете поменять дату заезда во вкладке Заезд.', zD: 'Это дата Вашего заезда. Чтобы поменять ее, пожалуйста, перейдите во вкладку Заезд.', zE: 'Это дата Вашего отъезда. Чтобы поменять ее, пожалуйста, перейдите во вкладку Отъезд.', qF: 'Эта дата за пределами выбранного Вами диапозона дат путешествия. Чтобы выбрать эту дату, пожалуйста, измените даты путешествия.', zF: 'Ночь на борту включена.', zG: 'Ночь на борту включена.', zW: 'Информация о пищевой аллергии/диетических ограничениях была передана экипажу судна.', q4: 'Присоединиться к Club One', AB: 'Получайте скидки на билеты, в магазинах на борту и у партнеров компании, а также используйте накопленные баллы для бронирования бонусных путешествий.', d2: 'Адрес', d3: 'Город/район', d4: 'Страна', d5: 'Завершить оформление Club One', AC: 'Индекс', AD: 'Один из пассажиров должен быть участником Club One.', d6: 'По электронной почте', d7: 'По почте', d8: 'По смс', d9: 'Предпочтительный язык', ea: 'Я хотел бы получать предложения и новости от Club One', eb: 'Нет', ec: 'Сохранить и закрыть', ed: 'Да', AF: 'Добро пожаловать в Club One! Остальные личные данные Вы можете внести после оформления бронирования.', AG: 'Добро пожаловать в Club One. Присоединившись к программе, Вы получили скидку! Стоимость с {priceBefore} изменилась на {currentPrice}.', AH: 'Мы нашли существующую учетную запись Club One с этими данными.', ee: 'Капельшер', ef: 'Купон на  детское меню', AN: 'Подтверждая это бронирование, Вы соглашаетесь с тем, что данные Вашего бронирования будут переданы сервису онлайн-платежей Klarna для подтверждения оплаты. Подробнее', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: 'об использовании данных банком Klarna', AQ: 'Klarna & Swish', AR: 'Invoice, part payment', AS: 'Klarna', AT: 'оплата по счёту', AU: 'частичная оплата', AV: 'Swish', AW: 'Способы оплаты зависят от Вашего бронирования, самые популярные способы:', eg: 'Оплата сервисом Klarna', eh: 'Klarna позволяет проводить оплату просто и безопасно с помощью Вашего мобильного телефона', ei: 'Клайпеда', ej: 'В одну сторону или туда-обратно.<br>Отправление в 19:00.', A$: 'Немецкий язык', A0: 'Английский язык', A1: 'Эстонский язык', A2: 'Финский язык', ek: 'Литовский язык', A3: 'Латышский язык', A4: 'Русский язык', A5: 'Шведский язык', Bb: 'Загружается...', Bc: 'Хельсинки', Bd: 'Юрмала', Be: 'Кольморден', Bf: 'Курессааре', Bg: 'Лауласмаа', Bh: 'Мариенхамен', Bi: 'Нарва', Bj: 'Норрчёпинг', Bk: 'Отепя', Bl: 'Пярну', Bm: 'Раквере', Bn: 'Рига', Bo: 'Сёдертелье', Bp: 'Стокгольм', Bq: 'Тарту', Br: 'Турку', Bs: 'Таллинн', Bt: 'Тампере', Bu: 'Упсала', Bv: 'Ванта', Bw: 'Вихула', BC: 'Основное блюдо', BE: 'Add another', BF: 'Date:', BG: '{price} / treatment', BH: 'Time:', Cf: 'Питание не сервируется на линии {direction}', Cg: 'В комплекте питания включено питание на весь круиз.', Ch: 'Добавить комплекты питания', el: 'Не выбрано', em: '<span class=\"data\">{count}</span> {count, plural, one{# завтрак} other{# завтраков}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# ужин} other{# ужинов}}', rt: 'Детям 6-17 лет предоставляются скидки, дети 0-5 лет - бесплатно, если родители приобрели комплект питания. \n\nКупоны на ужин возможно использовать для оплаты входа в буфет, а также для оплаты счета во всех ресторанах на борту.', Ci: '{price} / 18+ лет', Cj: '{price} / взрослый', Ck: '{price} / чел.', Cl: '<span class=\"save bodySmall\">Сэкономьте</span><span class=\"bodySmall\">до</span><span class=\"bodyLarge percentage\">15%</span>', Cm: 'Комплект питания', Cn: '{count, plural, one{# чел.} other{# чел.}}', Co: 'на одного человека', Cp: 'Бронирование', ru: 'Экономьте при покупке комплекта питания!', eo: 'Забронировать столик', ep: 'Нет в наличии', eq: 'Завтрак', er: 'Ужин', Cq: 'Питание', es: 'Купон', Cr: 'Питание включено на время всего рейса', Cs: 'Вы уверены, что не хотите добавить питание сейчас и <b>сэкономить до 10%</b>? Предложение действует только при покупке онлайн.', et: 'Конференц-зал', eu: '{date} в {time} на {duration} ч', Ct: 'Доступно меню', Cu: 'Пожалуйста, выберите вариант меню для каждого пассажира в возрасте 12 лет и старше.  Пассажиры младше 12 лет получат купон на питание с билетом и смогут выбрать блюда на борту. Детям полагаются скидки минимум 50%.', ew: 'Внести данные', ex: 'Информация о пассажирах', ey: 'Club One', CA: 'Для корректировки данных пассажира, участника программы Club One, просьба связаться со службой поддержки по телефону:', ez: 'Нет информации о пассажирах', eA: 'Подтверждение брони распечатывать не обязательно. Для регистрации в киоске самообслуживания (Self check-in) воспользуйтесь номером бронирования и защитным кодом.', eB: 'Некорректная возрастная группа', eC: 'Данные отсутствуют', eD: 'Оплата незавершена', eE: 'Изменить гос. номер ТС', eF: 'Гос. номер т/с не внесен', eG: 'Гос. номер т/с не указан', eH: 'Твоё бронирование в телефоне!', eI: 'Скачать', eJ: 'Открыть', eK: 'Отправить ссылку', eL: 'Приложение Tallink & Silja Line', eN: 'Мууга', CJ: 'Пребывание на суше в пункте назначения не предусмотрено', CK: 'Без возможности съезда с судна в пункте назначения.', CL: 'На данный момент нет доступных отправлений выбранного типа. Пожалуйста, смените тип путешествия.', CM: 'Проблема с оплатой! Пожалуйста, попробуйте снова. Если Вам не удалось произвести оплату бронирования, свяжитесь с нами по телефону +372 640 9808. Приносим извинения за возможные неудобства.', ol: 'нет, спасибо', CU: 'This code makes your ticket non-refundable. Read more about the specific <a href=\"#\">terms →</a>.', CV: '<ul>\n<li>It is not permitted to change the direction and/or route, departure date or time of the ticket.</li>\n<li>The passenger´s personal data, cabin class, vehicle and onboard service may be changed. When making such changes, the price difference between the originally purchased service and the amended service must be paid.</li>\n<li>If the passenger cancels the ticket, Tallink Silja Line will retain 100% of the ticket price as a contractual penalty.</li>\n<li>In all other matters, the travel conditions of AS Tallink Grupp apply, which are available at <a target=\"_blank\" href=\"https://www.tallink.com/terms\">terms page</a>.</li>\n</ul>', CW: 'Terms & Conditions', CX: 'yes, I Accept', CY: 'remove code', CZ: 'You are buying a non-refundable ticket using code <b>{code}</b>. After purchase, this ticket cannot be refunded under any circumstances. You can only change the passenger’s personal details, cabin class and services. Changes to direction, route, departure date or time are not available. Please confirm that you understand and accept these terms before proceeding to payment.', C_: 'Non-Refundable Ticket', eO: 'Недостаточное количество бонусных пунктов', C0: 'Продолжить бронирование', C1: 'Начать бронирование с начала', C2: 'Нажав \"назад\" с этой страницы - бронирование будет аннулировано. Вы уверены, что хотите начать с начала?', C3: 'Начать бронирование с начала?', eP: 'Arrival harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', eQ: 'Departure harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', eR: 'Departure and Arrival harbour in Stockholm is Kapellskär harbour (90 km from Stockholm)', Da: 'Bubble fair', eS: 'Insurance', Db: 'Браслеты Friendship', Dc: 'Детские пакеты', Dd: 'Priority boarding', De: 'Услуги на борту', Df: 'cудовые деньги', Dg: 'купон', Dh: 'Купоны на cудовые деньги', Di: 'место', Dj: 'Service not available between {route}', Dk: 'Один день', eT: 'В одну сторону или туда-обратно.<br>Отправления ежедневно.', Do: 'или', Dp: 'Другое', eU: 'Другой способ оплаты', eX: '12+ лет', eY: 'Палдиски', eZ: 'Припаркованный микроавтобус', DI: 'Спецкруиз в летнюю ночь', DJ: 'Море – Таллинн', e_: 'Невозможно изменить возрастную категорию пассажира', DM: 'Некорректно выбрана возрастная группа пассажиров. Проверьте дату рождения.', DN: 'Incorrect age group – make sure the date of birth corresponds to an adult or a youth.', DO: 'Проверьте правильно ли Вы ввели дату (дд.мм.гггг.)', DP: 'Необходимо использовать только цифры при вводе даты рождения', DQ: 'Заполнить позднее', DR: 'Сохранить', DS: 'Пожалуйста, проверьте данные и номер Club One', DT: 'Номер карты Club One', DU: 'уже добавлен/а.', DV: 'Измените данные или', DW: 'начните сначала', DX: 'Данные о документе будут добавлены в учетную запись Club One.', DY: 'Страна выдачи *', DZ: 'Действителен до *', D_: 'Дата выдачи *', D$: 'Номер документа *', D0: 'Тип документа *', D1: 'Место рождения *', D2: 'Специальная помощь', D3: 'Пожалуйста, предоставьте уточняющую информацию по Вашему запросу в поддержку по телефону:', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Добавить пассажира', Ec: '<span class=\"data\">{count}</span> {count, plural, one{пассажир} other{пассажиры}} выбран/ы', Ed: 'Заполните сейчас или позже', Ee: 'Данные внесены', Ef: 'Пассажиры', e0: 'Скоро', e1: 'Номер брони', e2: 'Кредитная карта', e3: 'Удалить', Ei: 'Оплата', e4: 'Выбрать способ оплаты', Ej: 'Счет', Ek: 'Адрес для выставления счета', e5: 'Оплатить по счету', El: 'Ваш номер ссылки', e6: 'Оплатить позже', e7: 'Оплата системой Klarna', e8: 'Оплатите сейчас, чтобы подтвердить бронирование.', e9: 'банкинг', fa: 'Стоимость в соответствии с тарифами оператора', fb: 'Стоимость в соответствии с тарифами оператора', fc: 'Стоимость звонка 85 центов/звонок + плата за услугу оператора.', fd: 'Стоимость звонка 8,35 центов/звонок + 16,69 центов/минута.', fe: 'Стоимость в соответствии с тарифами оператора', ff: 'Стоимость в соответствии с тарифами оператора', fg: 'Стоимость в соответствии с тарифами оператора', fh: 'Стоимость в соответствии с тарифами оператора', fi: 'Стоимость в соответствии с тарифами оператора', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Позвоните в поддержку', fk: 'Неоплаченные брони будут аннулированы автоматически.', fl: 'Возникла проблема с платежом. Попробуйте еще раз или позвоните в поддержку.', fm: 'Поменяйте <u>настройки страны</u> на изначальный рынок, чтобы завершить оплату.', fn: 'Бронирование было оформлено на другом рынке.', Ex: 'и {points} пунктов', r0: 'чел.', EA: 'чел.', EH: 'D-терминал', EI: 'Фрихамн (Frihamnen)', EK: 'Kapellskär', EL: 'Лонгнес', EM: 'Западный терминал 2', EN: 'Западный терминал 1', EO: 'Западный терминал 1', EP: 'Морской вокзал', EQ: 'Мариехамн', ER: 'Порт Мууга', ES: 'Южный порт (Olympia терминал)', ET: 'Paldiski', EU: 'Рижский пассажирский порт', EV: 'Sassnitz', EW: 'Порт Турку', EY: 'Вяртахамн (Värtahamnen)', EZ: 'Висбю', E_: 'Ventspils', E$: 'Порт Вуосаари', E5: 'Выбрано', E6: 'Забронировать рейс', E7: 'Отменить', E8: 'Далее', E9: 'Готово', fo: 'Далее', Fa: 'Лучшая цена за каюту:', Fb: 'Лучшая цена с картой Club One', Fc: 'Club One price', Fd: 'Пожалуйста, добавьте каюты', Fe: 'Стоимость будет показана после выбора каюты', fp: 'Чтобы продолжить, выберите каюты', Ff: 'Subtotal:', Fg: 'Итого:', fq: 'Цена с учётом карты Club One:', Fh: 'Загрузка цены...', Fj: 'Начальные цены за пассажира/автомобиль, включая топливно-эмиссионный сбор.', Fl: '{price} / шт.', sa: 'Proceed', fr: 'Перейти к оплате', Fs: 'Данный сайт защищен системой reCAPTCHA и на нем действуют \n<a target=\"_blank\" href=\"https://policies.google.com/privacy?hl=ru\">Политика конфиденциальности</a> и\n<a target=\"_blank\" href=\"https://policies.google.com/terms?hl=ru\">Условия Использования</a> Google.', ft: 'Изменения в услугах на борту:</br>\nОтправления в пятницы и субботы наполнены разнообразной развлекательной программой, в том числе живой музыкой, караоке и бинго.</br>\nОтправления с воскресенья по четверг с ограниченной развлекательной программой.', fu: 'Обычная цена:', Fy: 'Чтобы выбрать новое время, пожалуйста, удалите предыдущий выбор.', FA: 'Reservation fee {fee} will be deducted from the final bill.', FB: 'При бронировании детей до 5 лет комиссия не взимается.', sq: 'Закрыть', FD: 'Возникла ошибка, пожалуйста, обновите страницу или начните процедуру бронирования с начала.', FE: 'Мы не смогли найти предстоящих поездок', fv: 'Начать с начала', fw: 'Просим прощения за неудобство, Ваше бронирование будет аннулировано автоматически.', fx: 'Истекло время сессии', FF: 'Начать с начала', FG: 'Пожалуйста, начните заново. Мы приносим извинения за причиненные неудобства.', FH: 'Возникла ошибка', fz: 'Рига', fA: 'Две ночи на борту и день в Клайпеда.', fB: 'В одну сторону или туда-обратно.<br>Отправление в 17:00.', fC: 'Stockholm-Turku-Turku-Stockholm(Kappellskär)', fD: 'Stockholm(Kappellskär)-Turku', fE: 'Stockholm(Kappellskär)-Turku-Turku-Stockholm', fF: 'Turku-Stockholm-Stockholm(Kappellskär)-Turku', fG: 'Turku-Stockholm(Kappellskär)', fH: 'Turku-Stockholm(Kappellskär)-Stockholm-Turku', fI: 'Назад к списку банков', fJ: 'К сожалению, мы не смогли найти банк, который Вы искали. Попробуйте найти его в списке.', fK: 'Поиск', fL: 'Засниц', fN: 'Пожалуйста, выберите хотя бы одно т/с.', Ge: 'Adding a car <b>will remove {service}</b> service. You sure you want to proceed?', Gf: 'Are you sure?', Gv: 'Шопинг-круиз', Gw: 'Несколько ежедневных отправлений из Хельсинки. Общая продолжительность поездки составляет 5 часов, схода на берег в Таллинне нет. Вы можете получить скидку при совершении крупных покупок. Если вы планируете купить много товаров, рекомендуем Вам отправиться в шопинг-круиз с машиной. На борту Megastar Вы можете оставить свой автомобиль в гараже рядом с магазином Traveller Superstore на 7 палубе и иметь доступ к нему на протяжении всей поездки. На борту Star автомобили запаркованы на автопалубе.', Gy: 'This return time is assigned to 5h cruise. You will be redirected to appropriate page.', fO: 'Самое приятное время для себя', GE: 'Бронирование столика на шоу', fP: 'Сааремаа', GK: 'As a 15-17 year old you can travel without being accompanied by an adult. Remember to bring your <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\">travel permit</a> with you. Safe travels!', fQ: 'Санкт-Петербург', GQ: 'Закуска', fR: 'Стокгольм', GY: 'Купить билеты', GZ: 'В выбранную дату нет прямого сообщения из Стокгольма в Таллинн, но вы можете ехать через Хельсинки и сесть на корабль оттуда.', G_: 'Важно! Вам нужно будет пересесть с терминала Олимпия на Западный терминал 2, чтобы сменить корабль.', G$: 'Стокгольм -> Таллинн<br/> через Хельсинки', fS: 'Пожалуйста, обратите внимание, что алкоголь в барах продается в ограниченные часы.', fT: 'Две ночи на борту и день в Висбю.', fU: 'Две ночи на борту в море, ночевка на борту в Висбю и у Вас будет 2 дня для исследования острова Готланд. Воспользуйтесь возможностью duty-free шопинга на протяжении всего путешествия.', fV: 'Stockholm (Kappellskär)', fW: 'Три ночи на борту, день в Истад и день в Висбю.', fX: 'доплата', fY: 'Таллинн', G8: 'Таллинн – Море', fZ: 'Таллинн – Море – Таллинн', f_: 'Две ночи на борту и день в Риге.', G9: 'Купить билеты', Ha: 'В выбранную дату нет прямого сообщения из Таллинна в Стокгольм, но вы можете ехать через Хельсинки и сесть на корабль оттуда.', Hb: 'Внимание! Вам нужно будет добраться из терминала Олимпия в Западный терминал 2, чтобы сменить судно. <b>Если выберете рейс в 13:30, времени на дорогу общественным транспортом может не хватить.</b>', Hc: 'Таллинн -> Стокгольм <br/> через Хельсинки', f$: 'Две ночи на борту <br>и день в Турку.', f0: 'В одну сторону или туда-обратно.<br>Ежедневные отправления.', f1: 'Visby cruises', f2: 'Summer special cruises to the magical Gotland island', tb: 'спасибо за информацию', td: 'Добавить путь', f3: 'Забронируйте обратный билет и сэкономьте до 30%!', f4: 'Отправление и возрат в один день. Дневной круиз со скидкой.', o6: 'Приб.', f5: 'Ищете более позднее отправление?', f6: 'Выбрать дату для {direction}', f7: 'Сбросить', Hx: 'Выбрать дату', f8: '23-хчасовой круиз (вечернее отправление)', f9: '23-хчасовой круиз (утреннее отправление)', ga: 'Круиз \"День в Стокгольме\"', gb: 'Круиз \"День в Турку\"', o7: 'Отпр.', Hy: 'Вечером', Hz: 'Утром', te: 'В пути', tf: 'ч.', HA: 'Проведите первую ночь на борту корабля и покиньте его в удобное для вас время — с 8:00 до 11:00.', HB: 'Первая ночь на корабле', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'Нет в наличии', gc: 'Обратный билет не требуется', gd: 'Megastar шопинг-круиз', ge: 'Закрыть', gf: 'Незамедлительный возврат включает скидку шопинг-круиза для пассажиров и автомобиля. Круиз без возможности схода на берег.', gg: 'Megastar шопинг-круиз', gh: 'Проведите ночь на борту и насладитесь 4-хчасовой прогулкой по Таллинну', gi: 'Вечернее отправление из Стокгольма, без схода на берег', gj: 'Утреннее отправление из Стокгольма, без схода на берег', gk: 'Насладитесь двумя ночами на борту и одним днём в Турку', gl: 'Вечернее отправление из Турку, без схода на берег', gm: 'Утреннее отправление из Турку, без схода на берег', gn: 'Туда-обратно Хельсинки-Стокгольм-Хельсинки', go: 'Рейс в одну сторону Хельсинки-Стокгольм', gp: 'Туда-обратно Хельсинки-Таллинн-Хельсинки', gq: 'Дневной круиз в Таллинн', gr: 'Рейс в одну сторону Хельсинки-Таллинн', gs: 'Megastar шопинг-круиз', gt: 'Туда-обратно Рига-Стокгольм-Рига', gu: 'Рейс в одну сторону Рига-Стокгольм', gv: 'Туда-обратно Стокгольм-Хельсинки-Стокгольм', gw: 'Рейс в одну сторону Стокгольм-Хельсинки', gx: 'Туда-обратно Стокгольм-Рига-Стокгольм', gy: 'Рейс в одну сторону Стокгольм-Рига', gz: 'Туда-обратно Стокгольм-Таллинн-Стокгольм', gA: 'Рейс в одну сторону Стокгольм-Таллинн', gB: 'Туда-обратно Стокгольм-Турку-Стокгольм', gC: 'Рейс в одну сторону Стокгольм-Турку', gD: 'Туда-обратно Таллинн-Хельсинки-Таллинн', gE: 'Дневной круиз в Хельсинки', gF: 'Рейс в одну сторону Таллинн-Хельсинки', gG: 'Туда-обратно Таллинн-Стокгольм-Таллинн', gH: 'Рейс в одну сторону Таллинн-Стокгольм', gI: 'Туда-обратно Турку-Стокгольм-Турку', gJ: 'Рейс в одну сторону Турку-Стокгольм', HH: 'С отелем', tg: 'Круиз', gK: 'Круиз \"День в Хельсинки\"', gL: 'Круиз \"День в Таллинне\"', gM: 'Круиз \"День на Аландах\"', gN: 'Круиз \"День в Стокгольме\"', gO: 'Круиз', gP: '9-часовой круиз', gQ: 'Круиз \"День в Стокгольме\"', gR: 'Круиз', gS: 'Круиз \"День на Аландах\"', gT: 'Cruise to Helsinki', gU: 'Круиз \"День в Стокгольме\"', gV: '22-часовой круиз', gW: 'Круиз', gX: 'Круиз в два города', gY: 'Скрыть &uarr;', gZ: 'Ещё &darr;', g_: 'Туда-обратно', le: 'В', g$: 'В бронирование добавлен взрослый пассажир. Как минимум один из пассажиров в бронировании должен быть старше 18 лет.', g0: 'Место в гараже было удалено. Услуга Priority car включена в стоимость билета Business Lounge.', g1: 'Услуга Priority car включена в стоимость билета Business Lounge.', g2: 'Выбранный класс путешествия более не доступен. Пожалуйста, выберите другой.', HP: 'Номер ТС заполнен автоматически', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Места на выбранный трансфер распроданы.', g5: 'Выбранный трансфер недоступен и был удален.', HQ: 'Здравствуйте, {name}!', g6: 'Для оплаты Вашей поездки бонусными пунктами Club One, Вам необходимо {clubOnePoints} пунктов.', g7: 'Некоторые данные пассажира отсутствуют. Пожалуйста, заполните все требуемые поля.', g8: 'Отсутствует подключение к сети - информация не может быть сохранена. Пожалуйста, обновите соединение и попробуйте снова.', g9: 'Данные некоторых пассажиров отсутствуют. Пожалуйста, заполните и сохраните.', HR: 'Трансферы добавлены не на всех пассажиров', HS: 'В каждом номере должен быть как минимум один взрослый гость.', ha: 'Чтобы забронировать это время, удалите ранее выбранное.', HU: 'Трансфер должен быть добавлен минимум для одного взрослого.', hb: 'Пожалуйста, проверьте Ваше интернет-соединение и попробуйте снова.', hc: 'Мы изменили возрастную категорию с  \"{old}\" на \"{new}\"', hd: 'Мы удалили одну каюту, так как Вы удалили пассажира. Согласно правилам: в каюте должен быть размещен минимум один взрослый пассажир.', he: 'Добавлен номер карты ClubOne для {name}!', hf: 'Вы достигли максимального количества пассажиров в рамках одного бронирования.', hg: 'Мы добавили в Ваше бронирование питание для новых пассажиров.', hh: 'Мы удалили из Вашего бронирования питание для удаленных Вами пассажиров.', hi: 'Мы удалили транспортное средство, так как Вы удалили пассажира. Согласно правилам: на одно ТС в бронировании должен быть один взрослый пассажир.', hj: 'NB! Предыдущее количество пассажиров было удалено. Максимум 5 пассажиров в бронировании на линии Мууга-Вуосаари.', hk: 'Скидка за дневной круиз добавлена!', hl: 'Произошла ошибка при обработке запроса', hm: 'C ночевкой на борту', hn: 'Скидка за круиз \"День в Турку\" добавлена', ho: 'Скидка за круиз \"День в Стокгольме\" добавлена', HV: 'Долгое ожидание в Стокгольме', hp: 'Вы добавили последнюю доступную каюту \"{name}\"', hq: 'В каждой каюте должен быть как минимум один взрослый пассажир.', hr: 'Категория каюты \"{name}\" распродана на это отправление.', hs: 'Вы добавили последнее доступное ТС', ht: 'Вы выбрали максимальное кол-во ТС. В бронировании не может быть больше ТС, чем взрослых пассажиров.', hu: 'Выгрузки транспортного средства с парома в Таллинне нет', hv: 'Транспортное средство доступно только на пути туда', hw: 'Транспортное средство доступно только на обратном пути', hx: 'Выбранная категория ТС не доступна на это отправление', hy: '+ д.ж.', hz: 'Для аллергиков', hA: 'клетка', hB: 'клетки', hC: 'Для пассажиров с инвалидностью', hD: 'каюта', hE: 'кают', hF: 'В каждой каюте должен быть как минимум один взрослый пассажир.', H1: 'Нет в наличии', hG: 'В наличии остались каюты только для {capacity} человек', hH: 'На отправление {from}-{to} в наличии остались каюты только для {capacity} человек', hI: 'Путешествие с животными', hJ: 'Read more', hK: 'Одиночные места в каюте', hL: 'женское место', hM: 'мужское место', hN: '{name}, {genderPlace}  в {maxOccupancy}-х местной общей каюте', hO: '{price} / каюта', tm: '{price} / чел.', hP: 'Класс', hQ: 'Специальные каюты', H2: 'Каюты', hR: 'д.ж.', hS: 'д.ж.', hT: 'С дом. животными', hU: 'Проведите две ночи на борту Silja Symphony или Silja Serenade. Для изучения Стокгольма у Вас около 6 часов. Во время путешествия Вас ждут новые впечатления: увлекательная программа развлечений и отличный шопинг tax-free, а также великолепные и разнообразные рестораны. Возвращение на том же пароме и в той же каюте.', hV: '22-часовой мини-круиз на борту парома Europa. Отправления ежедневно из Хельсинки в Таллинн в 18:30. Время пребывания на суше в Таллинне около 4 часов, с 08:00-12:10 следующего дня.', hW: 'Проведите две ночи на борту Romantika или Isabelle. Для изучения Стокгольма около 6 часов, всего путешествие длится 40 часов. Возвращение на том же пароме и в той же каюте. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и конечно же увлекательная вечерняя программа.', hX: 'Отправление в 07:10 из Стокгольма. Путешествуйе на борту Baltic Princess на Аландские о-ва, где необходимо пересесть на паром Galaxy. Прибытие в Стокгольм в 18:15.', hY: 'Проведите две ночи на борту Silja Symphony или Silja Serenade. Для изучения Хельсинки у Вас около 7 часов. Во время путешествия Вас ждут новые впечатления: увлекательная программа развлечений и отличный шопинг tax-free, а также великолепные и разнообразные рестораны. Возвращение на том же пароме и в той же каюте.', hZ: 'Проведите две ночи на борту Romantika или Isabelle. Для изучения Риги около 6 часов, всего путешествие длится 40 часов. Возвращение на том же пароме и в той же каюте. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и конечно же увлекательная вечерняя программа.', h_: 'Проведите две ночи на борту Baltic Queen или Victoria I. Для изучения Таллинна около 7 часов, всего путешествие длится 40 часов.\nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и расслабляющая спа-зона. И конечно же увлекательная вечерняя программа.', h$: 'Отправление в 19:30 из Стокгольма. Проведите ночь на борту Galaxy. Схода на берег в Турку нет. Отправление обратно в Стокгольм на следующий день. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, \nмагазины с ценами tax-free и конечно же увлекательная вечерняя \nпрограмма.', h0: 'Проведите две ночи на борту Baltic Queen или Victoria I. Для изучения Стокгольма около 7 часов.\nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и расслабляющая спа-зона. И конечно же увлекательная вечерняя программа.', h1: 'Отправление в 08:15 из Турку. Путешествуйте на борту Galaxy на Аландские о-ва, где необходимо пересесть на паром Baltic Princess. Прибытие в Турку в 19:15.', h2: 'Отправление в 20:15 из Турку. Проведите ночь на борту Baltic Princess. Схода на берег в Стокгольме нет. Отправление обратно в Турку на следующий день. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, \nмагазины с ценами tax-free и конечно же увлекательная вечерняя \nпрограмма.', h3: 'Отправляйтесь на паромах Silja Serenade или Silja Symphony на Аландские о-ва.', h4: 'Проведите ночь на борту Silja Symphony или Silja Serenade. Прибытие в Стокгольм на следующее утро. Бронируйте отправления как в одну сторону, так и туда-обратно. Во время путешествия Вас ждут новые впечатления: увлекательная программа развлечений и отличный шопинг tax-free, а также великолепные и разнообразные рестораны.', h5: 'Множество отправлений ежедневно. Путешествуйте быстро и с комфортом. Паромы Star и Megastar идут всего 2 часа, а паром Victoria I - 3,5 часа.', h6: 'Путешествуйте ежедневно, быстро и удобно между Хельсинки (Западный терминал 2) и Таллинном на паромах Tallink Shuttle: Star и Megastar. Всего 2 часа пути в одну сторону.', h7: '2 отправления ежедневно из Хельсинки: 10:30 и 16:30. Путешествие длится 5 часов, схода на берег в Таллинне нет.\nПри совершении крупных покупок Вы можете получить дополнительные скидки. Если Вы планируете большие закупки, то советуем Вам путешествовать с автомобилем, который, для удобства, можно оставить в гараже, который расположен рядом с магазином Traveller Superstore на палубе 7.', h8: 'Проведите ночь на борту Romantika или Isabelle. Прибытие в Стокгольм на следующее утро. Бронируйте отправления как в одну сторону, так и туда-обратно. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и конечно же увлекательная вечерняя программа.', h9: '4 отправления ежедневно на Аландские о-ва. Путешествуйте на паромах Baltic Princess, Galaxy, Silja Serenade, Silja Symphony, Victoria I или Baltic Queen.', ia: 'Проведите ночь на борту Silja Symphony или Silja Serenade. Прибытие в Хельсинки на следующее утро. Бронируйте отправления как в одну сторону, так и туда-обратно. Во время путешествия Вас ждут новые впечатления: увлекательная программа развлечений и отличный шопинг tax-free, а также великолепные и разнообразные рестораны.', ib: 'Проведите ночь на борту Romantika или Isabelle. Прибытие в Ригу на следующее утро. Бронируйте отправления как в одну сторону, так и туда-обратно. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и конечно же увлекательная вечерняя программа.', ic: 'Проведите ночь на борту Baltic Queen или Victoria I. Прибытие в Таллинн на следующее утро. Бронируйте отправления как в одну сторону, так и туда-обратно. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и расслабляющая спа-зона. И конечно же увлекательная вечерняя программа.', id: 'Проведите половину дня или ночь на борту Baltic Princess или Galaxy.\nНа борту Вас ждут разнообразные развлечения: интересные места питания, \nмагазины с ценами tax-free и конечно же увлекательная вечерняя \nпрограмма.', ie: 'Путешествуйте на Аландские о-ва на паромах Baltic Queen и Victoria I.', $8: 'Множество отправлений ежедневно из Таллинна (D-терминал). Путешествуйте быстро и с комфортом.  Паромы Star и Megastar идут всего 2 часа, а паром Victoria I - 3,5 часа.', ig: 'Путешествуйте ежедневно, быстро и удобно между Таллинном и Хельсинки (Западный терминал 2) на паромах Tallink Shuttle: Star и Megastar. Всего 2 часа пути в одну сторону.', ih: 'Проведите ночь на борту Baltic Queen или Victoria I. Прибытие в Стокгольм на следующее утро. Бронируйте отправления как в одну сторону, так и туда-обратно. \nНа борту Вас ждут разнообразные развлечения: интересные места питания, магазины с ценами tax-free и расслабляющая спа-зона. И конечно же увлекательная вечерняя программа.', ii: 'Путешествуйте на Аландские о-ва на паромах Baltic Princess и Galaxy.', ij: 'Проведите половину дня или ночь на борту Baltic Princess или Galaxy.\nНа борту Вас ждут разнообразные развлечения: интересные места питания, \nмагазины с ценами tax-free и конечно же увлекательная вечерняя \nпрограмма.', ik: 'Две ночи на борту и день в Хельсинки', il: 'Две ночи на борту и день в Таллинне', im: 'Две ночи на борту и день на Аландских о-вах.', $9: '22-часовой круиз в Таллинн. <br>4 часа для пребывания на суше в Таллинне.', io: 'Расслабляющий мини-отдых на море', ip: '11-часовой круиз на Аландские о-ва и обратно.<br>Отправление из Стокгольма в 07:10.', iq: 'Две ночи на борту.<br>Около 7 часов пребывания на суше.', ir: 'Две ночи на борту.<br>Около 6 часов пребывания на суше.', is: 'Две ночи на борту.<br>Около 7 часов пребывания на суше.', it: 'Одна ночь на борту, без схода на берег. <br>Вечернее отправление на борту Galaxy.', iu: 'Насладитесь 23-часовым круизом на борту Baltic Princess', iv: '11-часовой круиз на Аландские о-ва и обратно.<br>Отправление из Турку 08:15.', iw: 'Одна ночь на борту, без схода на берег. <br>Вечернее отправление на борту Baltic Princess.', ix: 'Насладитесь 23-часовым круизом на борту Baltic Princess', iy: 'Один день на борту, без схода на берег. <br>Дневное отправление на борту Galaxy.', iz: 'В одну сторону или туда-обратно Аландские о-ва - Хельсинки', iA: 'В одну сторону или туда-обратно', iB: 'В одну сторону или туда-обратно.<br>Ежедневные отправления с Аландских о-вов.', iC: 'В одну сторону или туда-обратно с Аландских о-вов в Стокгольм.', iD: 'В одну сторону или туда-обратно с Аландских о-вов в Таллинн.', iE: 'В одну сторону или туда-обратно с Аландских о-вов в Турку.', iF: 'В одну сторону или туда-обратно.<br>Ежедневные отправления в 17:00.', iG: 'В одну сторону или туда-обратно. <br>Ежедневные отправления из Хельсинки и Стокгольма.', iH: 'Стоимость со скидкой для путешествия туда-обратно в один день.<br> 2 часа пути в одну сторону.', iI: 'В одну сторону или туда-обратно.<br>2 часа пути в одну сторону.', iJ: '5-часовой круиз с машиной или без. <br>Экономьте время, силы и деньги.', iK: 'В одну сторону или туда-обратно', iL: 'В одну сторону или туда-обратно', iM: 'В одну сторону или туда-обратно на пароме Sea Wind.<br>Ежедневно 2 отправления.', iN: 'В одну сторону или туда-обратно.<br>Ежедневные отправления из Риги.', iO: 'В одну сторону или туда-обратно. <br>Ежедневные отправления из Риги и Стокгольма.', iP: 'В одну сторону или туда-обратно.<br>Ежедневно 4 отправления из Стокгольма.', iQ: 'В одну сторону или туда-обратно. <br>Ежедневные отправления из Стокгольма и Хельсинки.', iR: 'В одну сторону или туда-обратно. <br>Ежедневные отправления из Стокгольма и Риги.', iS: 'В одну сторону или туда-обратно. <br>Ежедневные отправления из Стокгольма и Таллинна.', iT: 'В одну сторону или туда-обратно.', iU: 'В одну сторону или туда-обратно.<br>Отправление в 18:00.', iV: 'В одну сторону или туда-обратно.<br>2 часа пути в одну сторону.', iW: 'Стоимость со скидкой для путешествия туда-обратно в один день.<br> 2 часа пути в одну сторону.', iX: 'В одну сторону или туда-обратно. <br>Ежедневные отправления из Таллинна и Стокгольма.', iY: 'В одну сторону или туда-обратно.', iZ: 'В одну сторону или туда-обратно.', i_: 'В одну сторону или туда-обратно.', i$: 'В одну сторону или туда-обратно на пароме Sea Wind.<br>Ежедневно 2 отправления.', i0: 'Турку', i1: 'Две ночи на борту и день в Таллинне.', i2: 'В одну сторону или туда-обратно.<br>Ежедневные отправления из Таллинна.', H3: 'Два дня', i3: 'Две ночи на борту в море, ночевка на борту в Хернёсанд и 2 дня для исследования города и окрестностей. Воспользуйтесь возможностью шопинга на борту - duty-free магазины доступны на протяжении всего путешествия.', i4: 'Две ночи на борту в море, ночевка на борту в Хельсинки и 2 полных дня для исследования города и окрестностей. Воспользуйтесь возможностью шопинга на борту - duty-free магазины доступны на протяжении всего путешествия.', i5: 'Две ночи на борту и день на Аландских о-вах.', i6: 'Две ночи на борту и день в Хернёсанд.', i7: 'Насладитесь двумя ночами на борту и одним днём в Хельсинки', i8: 'Две ночи на пароме и один день в Риге', i9: 'Две ночи на борту и день на Сааремаа.', ja: 'Две ночи на пароме и один день в Стокгольме', jb: 'Насладитесь двумя ночами на борту и одним днём в Таллинне', H7: 'Применить промокод', jc: 'Сбор за выбросы транспортных средств.', jd: 'Сбор за выбросы транспортных средств взимается за транспортное средство, указанное в бронировании.', Id: 'Эмиссионный и топливный сборы', Ie: 'Топливно-эмиссионный сбор на транспорт взимается за транспортное средство, указанное в бронировании.', je: 'длина до 3,0 и высота до 1,5 м', jf: 'длина до 5,0 м и высота до 1,9 м', jg: 'Добавьте услугу Гараж и припаркуйте машину у магазина Traveller Superstore &rarr;', jh: 'Хотели бы в пункте назначения выехать с автопалубы в числе первых? Добавьте услугу Priority car &rarr;', ji: 'длина до 8,0 м и высота свыше 2,4 м', jj: 'м', jk: 'длина до 5,0 м и высота до 1,9 м\nВ пункте назначения выезд с автопалубы невозможен', jl: 'Пожалуйста, заполните гос. номера всех ТС', Ii: 'Удалить', jm: 'Выбрать ТС из предыдущей поездки:', jn: 'длина до 7,0 м и высота до 2,3 м', jo: 'длина до 12,0 м и высота до 1,9 м', jp: 'Гос. номер прицепа', jq: 'Гос. номер ТС может содержать только латинские буквы, цифры и тире', jr: 'длина до 7,0 м и высота до 2,4 м', js: 'Нет данных ТС', jt: 'Гос. номер ТС', ju: 'Добавлено ТС:', jv: 'Проверка наличия мест для ТС', Il: 'Путешествие через Хельсинки', jw: 'Висбю', jx: 'Истад/Висбю', jy: 'Вентспилс', Ip: 'Купон:', Iq: 'Please log-in with your Club One account to see the availability of the offer.', Ir: 'Простите, подарочный сертификат уже добавлен', Is: 'Простите, истек срок действия подарочного сертификата.', It: 'Простите, подарочный сертификат в другой валюте.', Iu: 'Простите, на данном подарочном сертификате нет средств.', jz: 'Вуосаари', IA: 'Круиз', IC: 'wow', tE: 'Круиз одного дня', jA: 'Истад'};
var $author$project$Translations$Generated$sv = {P: 'Läs vårt tillgänglighetsuttalande', Q: 'https://www.tallink.com/sv/tillganglighet', tJ: 'lägg till', R: 'Lägg till en annan kod', S: 'För att lägga till fordon, vänligen lägg till fler vuxna passagerare. Cyklar kan också läggas till för barn (6-17 år).', tK: 'Lägg till rum för alla passagerare', pl: 'Lägg till', tM: 'Att resa på linjen {route} är endast möjligt med fordon.', tN: 'Vill du lägga till fordon på linjen {route} också?', tO: 'Vill du lägga till linje?', T: 'Åland', t_: 'Åland (Långnäs)', t$: 'Åland (Mariehamn)', ue: 'Du har redan valt rum på ett annat hotell. Du behöver ta bort nuvarande val för att välja rum på detta hotell.', uj: 'Kryssning, 3 nätter', ul: 'Avbryt och fortsätt boka', um: 'Fortsätt till desktopversion', un: 'Om du fortsätter till desktopversionen, måste du göra om följande val: <span class=\"bodyBold\">passagerarinformation, hytter, måltider</span>.', uo: 'Några av dina val kommer att försvinna', up: 'Om du fortsätter till desktopversionen, måste du göra om följande val: <span class=\"bodyBold\">passagerarinformation och måltider</span>.', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Pank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: 'Bank', aa: 'Välj bank för att fortsätta', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click login eller mobiltelefonnummer', ah: 'Senast vald', ai: 'Säästöpankki', aj: 'SEB', ak: 'Välj bank:', al: 'S-Pankki', am: 'Swedbank', uB: 'boka måltider', uC: 'Boka dessa resor separat:', uD: 'Lägg till tillval ombord', uE: 'Gå till vår desktopversion &rarr;', uF: 'Saknar du någon tjänst?', uG: 'Lägg till bussanslutning', uH: 'Till och från hamnen', uI: 'Boka resa som företagskund', ao: 'Boka med medlemsrabatt', ap: 'Logga ut &rarr;', uJ: 'Logga in', aq: 'Är du Club One-medlem?', ar: 'Visa tillgängliga datum', uK: 'Bokningskoden gäller inte denna resa. Försök med ett annat datum, rutt eller typ av hytt.', as: 'Kontrollera koden och försök igen', uL: 'Avbryt', at: 'Bokningskoden är tillagd', au: 'Koden är korrekt', uM: 'Dubbelkolla bokningskoden och försök igen. Om du nyligen använt koden kan den vara låst. Vänligen vänta 20 minuter och försök sen igen.', av: 'Tänk på att din kod ibland kan bli låst. I detta fall vänta i 20 minuter och försök igen.', aw: 'Rabatten har lagts till', ax: 'Bokningskod', ay: 'Koden är inte giltig för valt datum', az: 'Men du kan använda den för andra datum', aA: 'Ordinarie pris {oldPrice} har ändrats till {discountedPrice}', aB: 'Ordinarie pris {oldPrice} har nu ändrats till rabatterat pris {discountedPrice}', aC: 'Ta bort', uN: 'Koden är korrekt. Du måste först välja hytt för att få rabatt.', uO: 'Ring 08 - 22 21 40 för att använda presentkortet', aD: 'Bokningskod aktiverad', aE: 'Jag har en bokningskod', aF: 'poäng', uP: 'Lägg till extra tillval', aG: 'Fast Track', aH: 'Garage', aI: 'Försäkring', uQ: 'Boka med trygghet', aJ: 'Priority Car', uR: 'Välj din avgångsdestination', uS: 'Välj din destination', aK: 'Boka resa', uT: '22-timmars kryssning', uU: 'Kryssning', uV: 'Kryssning', uW: 'Ingen tid i land på destinationen', py: 'Ingen tid i land på destinationen', uX: 'Helsingforskryssning', uY: 'Rigakryssning', uZ: 'Stockholmskryssning', u_: 'Avgår', u$: 'Observera att fartyget kanske inte uppfyller behoven hos passagerare med funktionsnedsättning.', aL: 'Ingen avstigning i Tallinn', u0: 'Återresa', u1: 'Enkelresa', u2: 'Tur och retur-resa', aM: 'Megastar 5h kryssning', u3: 'Enkelresa', u4: 'Tur och retur-resa', ne: 'Resa', aN: 'Resetyp', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: 'Välj språk', aV: 'Svenska', aW: 'Vill du ändra språk?', u5: 'Välj måltider', aX: 'Måltider kan bokas ombord', u6: 'Inga måltider finns tillgängliga', u7: 'Köp måltider i förväg och spara pengar', u8: 'Måltider', aY: 'Jag har en bokningskod', u9: 'Valfria tilläggstjänster', aZ: 'Bokningen måste ha 1 fordon.', va: 'Covid-19', a_: 'Test för covid-19', vb: 'FriendSHIP-äventyrspaket', vc: 'Massage', vd: 'Passagerare', ve: 'Gå med i Club One &rarr;', vf: 'https://clubone.tallink.com/sv/bli-medlem', vg: 'Logga ut &rarr;', vh: 'För en smidigare bokning & tillgång till dina Club One-rabatter:', a$: 'Välj hytt', vi: 'Reseklass', vj: 'Hytter', a0: 'Cykel, elsparkcykel', a1: 'Personbil', a2: 'Personbil', vl: 'Välj ett fordon', vm: 'Fyll i ditt registreringsnummer', a3: 'Ladda priser', a4: 'Motor&shy;cykel', a5: 'Motor&shy;cykel med sido&shy;vagn', a6: 'Parkerad bil', a7: 'Registreringsnummer förifyllt', a8: 'Bil för shopping', a9: 'Mini&shy;buss/ person&shy;bil för shopping', ba: 'Visa alla', bb: 'Skåp&shy;bil', bc: 'Hög skåp&shy;bil', bd: 'Fordon (extra långt och högt)', be: 'Bil med släp', bf: 'Bil med släp', bg: 'Bil med släp', vB: 'Lägg till fler bussanslutningar', bh: 'Lägg till hyttservice', bi: 'Gratis gåva', bj: '{count} produkter tillagda', bk: '{count} produkter tillagd', vC: 'Ladda mer', bl: 'Ladda föregående', bm: 'Datum', vD: 'Specialkryssning', bn: 'Obs', vE: 'Lägsta pris {price}', vF: 'Inga tillgängliga avgångar', vG: 'Inga avgångar på valt datum.', bo: 'alla priser i SEK', bp: 'Hytt från {price} poäng', bq: 'från {price} poäng per person', br: 'från {price} per person', bs: 'Hytt från {price}', bt: 'Avbryt', bu: 'Fortsätt', bv: 'Om du fortsätter kommer ditt val av hytt återställas. Detaljerna för passagerare förblir.', bw: 'Vald hytt är inte tillgänglig för valt datum', vH: 'Special-<br/>kryss', vI: 'Bil från {price}', bx: 'Slutsåld', by: 'Utsläppstillägg', bz: 'Utsläppstillägg läggs till för alla passagerare från 6 år.', bA: 'Utsläppstillägg som bidrar till utvecklingen mot att nå EU:s klimatmål inom ramen för systemet för handel med utsläppsrätter', vQ: '{chars} tecken kvar', vR: 'Checka in:', vS: 'Checka ut:', vW: 'Välj &rarr;', vX: 'Välj rum', vY: 'Välj boende för att se slutpris', v3: 'ta bort & välj', bB: 'Bronze', bC: 'Club', wd: 'Club One rabatt:', bD: 'Gold', bE: 'Club One-kontot är inte aktivt', bF: 'Club One-nummer', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One återaktivering av konto\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One återaktivering av konto\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One återaktivering av konto\">ClubOne@tallinksilja.com\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Club One återaktivering av konto\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One återaktivering av konto\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Club One återaktivering av konto\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One återaktivering av konto\">ClubOne.Sweden@tallinksilja.com\n</a>', bN: 'Email:', bO: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One återaktivering av konto\">international.sales@tallinksilja.com\n</a>', bP: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One återaktivering av konto\">Ditt Club One-konto är avaktiverat. Vänligen kontakta oss.</a>', bQ: 'Ditt Club One-konto är inaktivt. Vänligen kontakta oss:', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: 'Telefon:', b_: 'Platinum', wg: '<a>Logga in</a> eller <a>bli medlem i Club One</a> och få rabatt, använda poäng och boka enklare.', b$: 'Silver', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: 'Högsta antal poäng som du kan använda räknas ut dynamiskt och baseras på produkter och tjänster i bokningen.', wj: 'Använd tillgängliga Club One-poäng', wk: 'Club One-poäng kan inte användas tillsammans med koden.', wl: 'Du har inte tillräckligt med Club One-poäng.', b0: 'Använd dina Club One-poäng som <a>betalning</a>.', wm: 'Club One-poäng kan inte användas ({reason}).', pQ: 'Kod', wp: 'Texten innehåller otillåtna tecken.', wr: 'Födelsedatum', ws: 'dd', wt: 'mm', wu: 'åååå', wv: '{count} {count, plural, one{vuxen} other{vuxna}}', ww: '({range} år)', wx: 'Ankomst klockan {time}', pT: '{count} {count, plural, one{barn} other{barn}}', wy: 'Gratis', wz: 'Mindre', wA: 'Mer', wB: 'Nationalitet', wC: 'Populära', b1: 'Priserna inkluderar din Club One {level} rabatt.', wD: 'Club One-passagerare behöver fyllas i nu, andra kan fyllas i senare.', b2: 'p', b3: 'Använd Club One-poäng', b4: 'Kommer snart', wE: 'Lägg till Club One-nummer innan bokning', wF: 'Klar', wG: 'Ändra &rarr;', b5: 'För snabbare incheckning och smidig delning av bokningsinformation och boardingkort med ditt resesällskap, fyll i telefonnummer och e-post för alla passagerare.', wH: 'Förnamn', wI: 'Kön', wJ: 'Kvinna', wK: 'Man', wL: 'Ingår i priset', mh: 'Kontrollera stavningen', wM: 'E-postadressen tillhör kontaktperson eller medresenär', wN: 'Telefonnumret tillhör kontaktperson eller medresenär', wO: 'Efternamn', wP: 'Fyll i alla obligatoriska fält (markerade med *) för att spara', wQ: 'Frukost', wR: 'Brunch', wS: 'Buffé', wT: 'Middag', wU: 'Lunch', wV: 'Bordsbokning för à la carte', wW: 'Måltider kan bokas ombord', wX: 'Namn bör endast innehålla latinska tecken.', wY: 'Inte tillgänglig', b6: 'Inte möjligt för vald resa', wZ: 'Behövs inte', b7: 'Vuxen\n18+', b8: 'Barn\n0-5', b9: 'Barn\n6-11', ca: 'Barn\n12-17', cb: 'Bank', w_: 'Betala {price}', cc: 'Betalar {price}', cd: 'Kontokort', w$: 'Bekräfta bokning {price}', w0: 'Bekräftar {price}', ce: 'Fortsätt {price}', cf: 'Betalningen bearbetas', w1: '<p>De kombinerade resetjänster du erbjuds utgör en paketresa i den mening som avses i direktiv (EU) 2015/2302.</p> <p>Därför omfattas du av alla EU-rättigheter som gäller för paketresor. AS Tallink Grupp kommer att ansvara fullt ut för att paketresan som helhet fullgörs korrekt.</p> <p>Dessutom har AS Tallink Grupp, enligt lag, ett skydd för att återbetala dina betalningar och, när transport ingår i paketresan, säkerställa din hemtransport om det eller de hamnar på obestånd.</p> <p><a href=\"https://www.tallink.com/sv/bra-att-veta/allmanna-villkor-for-paketresor\" target=\"_blank\">Visa villkoren för paketresor</a>.</p>', pU: '<p>De kombinerade resetjänster du erbjuds utgör en paketresa i den mening som avses i direktiv (EU) 2015/2302.</p>\n<p>Därför omfattas du av alla EU-rättigheter som gäller för paketresor. Företag {name} kommer att ansvara fullt ut för att paketresan som helhet fullgörs korrekt.</p>\n<p>Dessutom har företag {name}, enligt lag, ett skydd för att återbetala dina betalningar och, när transport ingår i paketresan, säkerställa din hemtransport om det eller de hamnar på obestånd.</p>\n<a href=\"{url}\" target=\"_blank\">Se hela Informationsformuläret för paketresor - {name}</a>', w2: 'Genom att slutföra bokningen godkänner du våra <a href=\"https://se.tallink.com/bra-att-veta/resevillkor\" target=\"_blank\">villkor</a> och <a href=\"https://se.tallink.com/bra-att-veta/ordningsregler\" target=\"_blank\">ordningsregler</a> samt regler gällande vår <a href=\"https://se.tallink.com/club-one-regler\" target=\"_blank\">kundklubb Club One</a>.', w3: 'Genom att slutföra bokningen godkänner du Tallink Silja Lines <a href=\"https://www.tallink.com/sv/bra-att-veta/betalnings-och-avbestallningsvillkor\" target=\"_blank\" >betalnings- och avbokningsvillkor</a> och <a href=\"https://www.tallink.com/sv/bra-att-veta/rattigheter\" target=\"_blank\" >säkerhetsregler</a> samt bekräftar att du har läst <a href=\"https://www.tallink.com/sv/personuppgiftspolicy\" target=\"_blank\" >personuppgiftspolicyn</a>.', w4: 'AS Tallink Grupp', w5: 'https://www.tallinksilja.se/informationsformular-paketresor-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://se.tallink.com/informationsformular-paketresor-tallink-silja', w8: 'Passagerare under 18 år, vänligen kom ihåg att läsa våra <a href=\"https://www.tallink.com/sv/bra-att-veta/aldersregler\" target=\"_blank\">åldersregler</a>.', w9: 'Alipay', xa: 'Apple Pay', xb: 'internetbank', xc: 'kort', xd: 'Google Pay', xe: 'Mobil Pay', xf: 'Bankkort & kreditkort', xg: 'WeChat Pay', xh: 'Digitala betalsätt & bank-/kreditkort', xi: 'Internetbank', xj: 'Digitala betalsätt', cg: 'Från {price}', xk: 'Ändra restyp', xl: 'Välj', xm: 'Vald', xn: 'Fartyg', xo: '{date} kl. {time}', xp: '{count} {count, plural, one{passagerare} other{passagerare}}', xq: 'Vuxen\n18+', xr: 'Barn\n0–5', xs: 'Barn\n6–17', xt: 'Vänligen välj din hytt först', xu: 'Hamn för ankomst till Åland är Långnäs hamn (30 km från Mariehamn)', xv: 'Ankomst till Långnäs', xw: 'Hamn för avresa och ankomst på Åland är Långnäs hamn (30 km från Mariehamn)', xx: 'Hamn för avresa från Åland är Långnäs hamn (30 km från Mariehamn)', xy: 'Avgång från Långnäs', pV: 'Fordon', xz: 'Fordon', ch: '22-timmars kryssning med Baltic Queen', ci: 'Kryssning', cj: 'Tur/retur och rundtur', ck: 'Regul&shy;järresa', cl: 'Tur/retur, rundtur och dagskryssning', xB: 'Företagskund', xC: 'Agentnummer', xD: 'Agent med angivna uppgifter kunde inte hittas', xE: 'Obs! Det är inte obligatoriskt att fylla i Agentnummer', xF: 'Du kommer tillfälligt att loggas ut från ditt personliga konto', xG: 'Företagsnummer', xH: 'Företagskund med angivna uppgifter kunde inte hittas', cm: 'Tack för din bokning. En bekräftelse har skickats till', cn: 'Bokningen är klar! Ha en trevlig resa!', co: 'Du får {refund} tillbaka!', cp: 'Ring vår kundservice för återbetalningsalternativ.', cq: 'Din bokning har uppdateras!', xI: 'Vuxen', xJ: 'Namn på stad', xK: 'Inga sökresultat', xL: 'Sök efter busshållplats', xM: 'Bussanslutning', cr: 'Barn 6–11 år', cs: 'Ändra din bokning', xN: 'Ordinarie', xO: 'Barn {range} år', ct: 'Tillval i land', cu: 'Nej tack', cv: 'Självklart!', cw: 'Skulle du vilja få fina erbjudanden från Tallink Silja Line via e-post?', cx: 'Tack för att du prenumerarar på vårt nyhetsbrev!', cy: 'Ring kundsupport', cz: 'Avbryt', xP: 'Födelsedatum matchar inte med vald ålderskategori. Vänligen ange korrekt födelsedatum eller kontakta vår support för att ändra ålderskategori på:', cA: 'Ändra kategori', cB: 'Köp tillval', cC: 'Byt tillval', cD: 'Adress', cE: 'Företag', cF: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contacts\">kundtjänst</a>.', cG: 'För att göra ändringar i din bokning vänligen kontakta vår kundtjänst: +46 (0)8-22 21 40 eller info.sweden@tallinksilja.com.', cH: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://ee.tallink.com/et/kontaktid\">kundtjänst</a>.', cI: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://www.tallinksilja.fi/palvelunumerot\">kundtjänst</a>.', cJ: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://www.tallink.lv/lv/contacts\">kundtjänst</a>.', cK: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://www.tallinksilja.com/contact-us\">kundtjänst</a>.', cL: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://www.tallinksilja.ru/agents\">kundtjänst</a>.', cM: 'För att göra ändringar i din bokning vänligen kontakta vår kundtjänst: +46 (0)8-22 21 40 eller info.sweden@tallinksilja.com.', cN: 'För att göra ändringar i din bokning vänligen kontakta vår <a href=\"https://www.tallinksilja.com/contact-us\">kundtjänst</a>.', cO: 'Kontaktnamn', cP: 'Kontaktperson', cQ: 'För att göra ändringar gällande din bokning, vänligen kontakta din researrangör.', cR: 'E-post', cS: 'Bli medlem i Club One', cT: 'Bokningsbekräftelse', cU: 'Incheckning börjar 2 timme före avgång. Observera att incheckning vid fordonsincheckningen måste vara klar minst 45 minuter före avgång.', cV: 'Vänligen fyll i alla fält för varje passagerare', cW: 'Avbryt', cX: 'Fortsätt', cY: 'Om du fortsätter kommer ändringarna inte att sparas.', cZ: 'Ändringar kommer inte att sparas', c_: 'Visa bekräftelsen som PDF', c$: 'Se ditt kvitto (PDF) i ditt bekräftelsemail för betalningsdetaljer', c0: 'Visa villkor', c1: 'https://www.tallink.com/sv/bra-att-veta/generella-resevillkor', xQ: 'Totalt', c2: 'Telefonnummer', c3: 'Bekräftelsenummer', c4: 'Kontrollnummer', c5: 'Bekräftelse', c6: 'Angivna tider ombord och på destination är lokala tider.', c7: 'Boardingkort kan hämtas vid incheckningsautomat i terminalen på avresedagen. Glöm inte ditt boknings- och kontrollnummer.', c8: 'Vi rekommenderar att komma i god tid till incheckningen.', c9: 'Passagerare utan fordon måste checka in senast 30 minuter före avgång. Passagerare med fordon rekommenderas checka in senast 1 timme före avgång. Obs! Passagerare med fordon från Tallinn eller Stockholm till Mariehamn måste checka in senast 1,5 timme före avresa.', da: 'Vid kryssning anses biljetten vara förbrukad om utresa ej påbörjats i avgångshamnen.', db: 'Kom ihåg att ha giltiga resehandlingar. Samtliga passagerare ska kunna legitimera sig med giltig ID-handling. För resor till Estland/Lettland krävs giltigt pass eller nationellt ID-kort utfärdat av polisen (gäller även barn).', dc: 'Fartygets avgång- och ankomsttider visas alltid i lokal tid. <br>\nDu kan checka in online, i Tallink Silja Lines app eller i terminalen.\nFordonsincheckningen i Kapellskär och Paldiski stänger 75 minuter innan Superfast avgår. Vi rekommenderar att vara på plats tidigt. <br>\nHyttnycklar skrivs ut vid incheckningen. <br>\nVarje passagerare (inklusive barn) måste ha giltig resehandling och eventuella nödvändiga dokument, såsom visum, under hela resan. <br>\nPassagerare ansvarar själva för att ha giltiga och korrekta handlingar.', dd: 'Reseinformation', de: 'Reseinfo', df: 'Återbetalning', dg: 'Du kommer att få en återbetalning på {refund}! Ring vår kundservice för att få din återbetalning.', dh: 'Ring för återbetalning', di: 'Redan ringt? Ingen fara, denna information försvinner när din återbetalning har gått igenom.', dj: 'Få din återbetalning', xR: 'Om anslutningsproblemen kvarstår, vänligen kontakta vår kundtjänst tel. +46(08) 22 21 40', xS: 'Ingen internetanslutning, var god försök igen', xT: 'Försök igen', xV: 'Fortsätt', xW: 'Fortsätt till betalning', pX: 'E-postadress', xX: 'Exempel:', dk: 'Landskod och telefonnummer', xY: 'Kontaktinformation', xZ: 'Lägg till dina kontaktuppgifter så skickar vi bokningsbekräftelsen till dig. Logga in på ditt Club One-konto eller skriv in ditt medlemsnummer på passagerarsidan innan du bokar för att ta del av medlemsförmånerna.', x_: 'Informationen kommer uppdateras till ditt Club One-konto', pY: 'Telefonnummer', dl: 'Exempel: 701234567', x$: 'Övriga', x0: 'En kopia av bokningsbekräftelsen skickas till {email}', dm: 'Alternativ e-post', dn: 'Postnummer', x6: '{price} / test', x8: 'Boka den här resan snabbare i vår <b>nya bokning.</b>', dp: 'Fullständigt namn', dq: 'Kreditkort', dr: 'mm', ds: 'Kreditkortsnummer', dt: 'Betalningsmetod', du: 'Säkherhetskod', dv: 'Välj ditt kreditkort:', dw: 'Giltigt till', dx: 'åå', dy: 'Kryssning Stockholm (Kapellskär) - Åbo - Stockholm (Kapellskär)', ya: 'Helsingforskryssning', yb: 'Visbykryssning', dz: 'Kryssning Åbo - Stockholm (Kapellskär) - Åbo', yc: 'Kryssning till Ystad och Visby', dA: 'Helsingforskryssning', dB: 'Rigakryssning', no: 'Tallinnkryssning', yj: 'Åbokryssning', yr: 'Dessert', dC: 'Rabatt:', yy: 'Tillagd', yz: 'Bokningskod eller presentkort', p9: 'Bokningskod & presentkort', dD: 'Glöm inte att välja meny till varje vuxen för bokningen i {restaurant}.', dE: 'Välj måltid för varje passagerare från 12 år för bokningen i {restaurant}.', yB: 'Missa inte chansen!', yD: 'Välj dryckespaket', dF: 'Vi har hittat en obetald bokning för samma avgång. Ref. number: {resId}, pris: {price} {unit}. Vill du avboka den gamla bokningen och bekräfta betalningen för den nya bokningen? <a href=\"{link}\">Öppna och betala den gamla bokningen →</a> För mer information vänligen kontakta kundtjänst', yF: 'Ändra rum', yG: 'Ändra rum', yO: 'Tillval i land', yP: 'Tillval i land och hotell', yS: 'Alla passagerare måste ha sittplats i fordonet.', dK: 'https://clubone.tallink.com/sv', yY: 'Extra tillval', dL: 'Lämna kommentar', y_: 'BÅT', y$: 'BÅT + Hotell', y5: 'Välj meny', y7: 'Matallergier / matavvikelser:', kS: 'Från', za: 'Emission and fuel surcharge', zb: 'Tillägg för bränsle och utsläpp läggs till för alla passagerare från 6 år.', zc: 'Tillägg för bränsle och utsläpp läggs till för alla passagerare från 12 år. Upp till tre barn 6–11 år reser utan tilläggsavgifter.', zd: 'Kostnader relaterade till ökade marina bränslepriser, samt CO2-utsläpp enligt EU:s system för handel med utsläppsrätter (ETS).', dM: 'Bränsletillägg', dN: 'Bränsletillägg läggs till för alla passagerare från 6 år.', dO: 'Bränsletillägget kostar {price} för passagerare från 6 år.', dP: 'Bränsletillägget kostar {price} per enkelresa för passagerare från 6 år.', zh: 'Presentkort:', zi: 'Presentkortet kan användas flera gånger tills värdet är slut.\nPresenkortets värde är {priceLeft} kr.', dQ: 'Gruppmeny finns tillgänglig', zm: 'Bokar du för 12 vuxna eller fler ber vi dig att välja ett menyalternativ för varje vuxen passagerare. Yngre passagerare blir automatiskt tilldelade var sin middagskupong till ett värde av 25 €.', dR: 'Helsingfors', dS: 'Två nätter ombord, en dag i Riga.', dT: '22-timmarskryssning till Tallinn.<br />4 timmar i land i Tallinn.', dU: 'Tallinnkryssning.<br> 5 timmar i land i Tallinn.', dV: 'Kryssning till Visby', dW: 'Sommarkryssning till magiska Gotland', dX: 'Härnösand', zv: 'Hotell', zy: '<a>Ändra dina resedatum</a> för att välja datum utanför valbart område.', dY: 'Incheckning', dZ: 'Checka in', d_: 'Utcheckning', d$: 'Checka ut', d0: 'nätter', d1: 'natt', zz: 'Du som vill boka endast hotell kommer skickas vidare till webbokningen i ett nytt fönster.', zA: 'Inga tillgängliga hotellrum på valda datum. Ändra resedatum.', zB: 'Incheckningsdatum måste vara innan utcheckningsdatum. Ändra under fliken för utcheckning.', zC: 'Utcheckningsdatum måste vara efter incheckningsdatum. Ändra under fliken för incheckning.', zD: 'Detta är valt incheckningsdatum. Ändra under fliken för incheckning.', zE: 'Detta är valt utcheckningsdatum. Ändra under fliken för utcheckning.', qF: 'Datumet stämmer inte med valda resedatum. Ändra resedatum för att välja detta datum.', zF: 'Övernattning ombord ingår.', zG: 'Övernattning ombord ingår.', zW: 'Information om allergier/matavvikelser har skickats vidare till besättningen ombord.', q4: 'Bli medlem i Club One', AB: 'Få rabatt när du bokar resor, samla poäng som kan användas för att boka bonusresor. Få även rabatt ombord och hos våra partners i land.', d2: 'Gatuadress', d3: 'Stad', d4: 'Land', d5: 'Club One-uppgifter saknas', AC: 'Postnummer', AD: 'En av passagerarna behöver vara Club One-medlem.', d6: 'Via e-post', d7: 'Via post', d8: 'Via SMS', d9: 'Språk', ea: 'Jag vill få erbjudanden och nyheter från Club One', eb: 'Nej', ec: 'Spara och stäng', ed: 'Ja', AF: 'Välkommen till Club One! Det går bra att fylla i resten av uppgifterna efter bokningen.', AG: 'Välkommen till Club One. Genom att bli medlem fick du medlemsrabatt. Originalpriset {priceBefore} har ändrats till {currentPrice}.', AH: 'Vi hittade ett Club One-konto med dessa uppgifter som redan finns.', ee: 'Kapellskär', ef: 'Måltidskupong för barn', AN: 'Genom att bekräfta denna bokning godkänner du att bokningsdatan överförs till Klarna för att kunna ge dig olika betalningsmöjligheter. Läs mer', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/sv_se/privacy_statement.pdf', AP: 'om hur Klarna använder din data', AQ: 'Klarna & Swish', AR: 'Faktura, delbetalning', AS: 'Swish & faktura', AT: 'Faktura 30 dagar', AU: 'Delbetalning', AV: 'Swish', AW: 'Klarna erbjuder följande betalningsalternativ:', eg: 'Betala med Klarna', eh: 'Betala enkelt i mobilen', ei: 'Klaipeda', ej: 'Enkelresa eller tur och retur.<br />Avgår kl. 19:00.', A$: 'Tyska', A0: 'Engelska', A1: 'Estniska', A2: 'Finska', ek: 'Litauiska', A3: 'Lettiska', A4: 'Ryska', A5: 'Svenska', Bb: 'Laddar...', Bc: 'Helsingfors', Bd: 'Jurmala', Be: 'Kolmården', Bf: 'Kuressaare', Bg: 'Laulasmaa', Bh: 'Mariehamn', Bi: 'Narva', Bj: 'Norrköping', Bk: 'Otepää', Bl: 'Pärnu', Bm: 'Rakvere', Bn: 'Riga', Bo: 'Södertälje', Bp: 'Stockholm', Bq: 'Tartu', Br: 'Åbo', Bs: 'Tallinn', Bt: 'Tammerfors', Bu: 'Uppsala', Bv: 'Vanda', Bw: 'Vihula', BC: 'Huvudrätt', BE: 'Lägg till fler', BF: 'Datum:', BG: '{price} / behandling', BH: 'Tid:', Cf: 'Inga måltider serveras mellan {direction}', Cg: 'I måltidspaket ingår mat för hela resan.', Ch: 'Välj måltidspaket', el: 'Ej vald', em: '<span class=\"data\">{count}</span> {count, plural, one{# frukost} other{# frukostar}}', en: '<span class=\"data\">{count}</span> {count, plural, one{# middag} other{# middagar}}', rt: 'Barn (6–17 år) äter till rabatterat pris och barn (0–5 år) äter gratis i Grande Buffet med betalande vuxen.\n\nÄr middagen utsåld läggs kuponger till på bokningen. Måltidskupongen kan användas till middagsbuffén eller som betalning i andra restauranger.', Ci: '{price} / 18+ år', Cj: '{price} / vuxen', Ck: '{price} / person', Cl: '<span class=\"save bodySmall\">Förboka</span><span class=\"bodySmall\">för bättre</span><span class=\"bodyLarge percentage\">pris</span>', Cm: 'Måltidspaket', Cn: '{count, plural, one{# pers} other{# pers}}', Co: 'per person', Cp: 'Bordsbokning', ru: 'Köp måltidspaket och spara pengar', eo: 'Boka bord', ep: 'Slutsåld', eq: 'Frukost', er: 'Middag', Cq: 'Måltider', es: 'Måltidskupong', Cr: 'Måltid är inkluderad för hela resan', Cs: 'Är du säker på att du inte vill lägga till måltider med <b>upp till 10% rabatt</b>? Erbjudandet gäller bara när du bokar online.', et: 'Mötesrum', eu: '{date} kl {time} i {duration} h', Ct: 'Tillgänglig meny', Cu: 'Välj en meny för varje passagerare som är 12 år och äldre. Barn får minst 50% rabatt. Passagerare under 12 år tilldelas en måltidskupong och väljer måltid ombord.', ew: 'Fyll i passagerarinfo', ex: 'Passagerarinformation', ey: 'Club One', CA: 'För att ändra Club One passagerares personliga information, vänligen kontakta kundservice:', ez: 'passagerarinfo saknas', eA: 'Du behöver inte skriva ut någonting. Gå till självincheckning med ditt bokningsnummer och kontrollnummer.', eB: 'Felaktig ålderskategori', eC: 'Passagerarinfo saknas', eD: 'Betalning ej genomförd', eE: 'Uppdatera fordonsuppgifter', eF: 'Registreringsnummer saknas', eG: 'Registreringsnummer ej ifyllt', eH: 'Få din bokning till telefonen', eI: 'Ladda ner', eJ: 'Öppna', eK: 'Skicka länk', eL: 'Tallink Silja Lines app', eN: 'Muuga', CJ: 'Ingen tid i land på destinationen', CK: 'Fordon kan inte köras av vid destinationen.', CL: 'Inga tillgängliga avgångar för vald resetyp för tillfället. Vänligen ändra resetyp.', CM: 'Betalning kan ej genomföras. Vänligen försök igen. Om samma problem uppstår, vänligen kontakta oss på telefon {phone}.', ol: 'Nej tack', CU: 'Bokningen kan <b>inte återbetalas</b> med koden. Läs mer om <a href=\"#\">villkoren →</a>.', CV: '<ul>\n<li>Det är inte tillåtet att ändra färdriktning och/eller rutt, avresedatum eller avresetid.</li>\n<li>Passagerarens personuppgifter, hyttkategori, fordon och förbeställda tjänster ombord kan ändras. Vid sådana ändringar måste prisskillnaden mellan den ursprungliga tjänsten och den ändrade tjänsten betalas.</li>\n<li>Om passageraren avbokar bokningen behåller Tallink Silja Line 100 % av beloppet som avtalsvite.</li>\n<li>I alla övriga avseenden gäller AS Tallink Grupps resevillkor. Läs våra <a target=\"_blank\" href=\"https://www.tallink.com/sv/bra-att-veta/bokning-och-andring#terms-and-regulations\">villkor</a>.</li>\n</ul>', CW: 'Villkor', CX: 'ja, jag godkänner', CY: 'ta bort kod', CZ: 'Bokningen kan inte återbetalas med koden <b>{code}</b>. Om du efter köp ombokar eller avbokar bokningen får du inte pengarna tillbaka. Du kan endast ändra passageraruppgifter, hyttkategori och tjänster. Ändring av färdriktning, rutt, avgångdatum och avgångstid är inte möjlig. Bekräfta att du förstår och godkänn villkoren innan du går vidare till betalning.', C_: 'Inte återbetalningsbar bokning', eO: 'Inte tillräckligt med poäng', C0: 'Fortsätt boka', C1: 'Börja om', C2: 'Genom att klicka ”Börja om” återställs din bokning. Är du säker på att du vill börja om från början?', C3: 'Börja om?', eP: 'Ankomsthamn i Stockholm är Kapellskär (90 km från Stockholm)', eQ: 'Avgångshamn i Stockholm är Kapellskär (90 km från Stockholm)', eR: 'Avgångs- och ankomsthamn i Stockholm är Kapellskär (90 km från Stockholm)', Da: 'Bubble fair', eS: 'Insurance', Db: 'FriendSHIP-äventyrspaket', Dc: 'För barn', Dd: 'Priority Boarding', De: 'Tillval ombord', Df: 'Ship Money', Dg: '-kupong', Dh: 'Ship Money-kuponger', Di: 'sittplats', Dj: 'Service not available between {route}', Dk: 'Kryssning 2 nätter', eT: 'Enkelresa eller tur och retur.<br>Dagliga avgångar.', Do: 'eller', Dp: 'Övriga', eU: 'Annat betalsätt', eX: '12+ år', eY: 'Paldiski', eZ: 'Parkerad skåpbil', DI: 'Party on Baltic Sea', DJ: 'Baltic Sea – Tallinn', e_: 'Kan inte ändra passagerares ålderskategori', DM: 'Felaktig åldersgrupp – se till att födelsedatum motsvarar vuxen.', DN: 'Felaktig åldersgrupp – se till att födelsedatum motsvarar vuxen eller ungdom.', DO: 'Kontrollera att du har skrivit in datumet i formatet DD-MM-ÅÅÅÅ', DP: 'Endast nummer kan användas för att ange födelsedag', DQ: 'Fyll i senare', DR: 'Spara', DS: 'Vänligen kontrollera ditt namn och Club One-nummer. Om du fortfarande har problem kan du ringa oss på: <a href=\"tel:+468222140\">08-22 21 40</a>', DT: 'Club One-nummer', DU: 'har redan lagts till.', DV: 'Ändra uppgifter eller', DW: 'börja om', DX: 'Detaljer om resedokumenten läggs till på Club One-kontot.', DY: 'Resehandlingens utfärdandeland *', DZ: 'Resehandlingens giltighetstid *', D_: 'Resehandlingens utfärdandedatum *', D$: 'Resehandlingsnummer *', D0: 'Typ av resehandling *', D1: 'Födelseland', D2: 'Särskild assistans', D3: 'Vänligen lämna fler uppgifter genom att ringa vår kundtjänst:', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: 'Lägg till passagerare', Ec: '<span class=\"data\">{count}</span> {count, plural, one{passagerare} other{passagerare}} vald', Ed: 'Fyll i nu eller senare', Ee: 'Sparat', Ef: 'Passagerare', e0: 'Kommer snart!', e1: 'Bokningsnummer', e2: 'Kreditkort', e3: 'Ta bort', Ei: 'Betalning', e4: 'Välj betalningssätt:', Ej: 'Faktura', Ek: 'Faktureringsadress', e5: 'Betala med företagsfaktura', El: 'Referensnummer', e6: 'Swish & faktura', e7: 'Enkel betalning med mobilen', e8: 'Betala nu för att säkerställa din bokning.', e9: 'Bank', fa: 'Vanlig nätverkskostnad.', fb: 'Vanlig nätverkskostnad.', fc: 'Pris 0.85 €/samtal + avgifter.', fd: 'Pris 8,35 cent/samtal + 16,69 cent/minut.', fe: 'Vanlig nätverkskostnad.', ff: 'Vanlig nätverkskostnad.', fg: 'Vanlig nätverkskostnad.', fh: 'Vanlig nätverkskostnad.', fi: 'Samtalen är kostnadsfria.', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: 'Ring kundservice', fk: 'Obetalda bokningar tas bort automatiskt.', fl: 'Ett problem uppstod med betalningen. Du kan försöka igen eller ringa oss.', fm: 'Ändra dina <u>landsinställningar</u> till den ursprungliga marknaden för att slutföra betalningen.', fn: 'Bokningen gjordes mot en annan marknad.', Ex: 'och {points} poäng', r0: 'pers', EA: 'pers', EH: 'D-Terminalen', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs', EM: 'Västra terminalen 2', EN: 'Västra terminalen 1', EO: 'Västra terminalen 1', EP: 'S:t Petersburg', EQ: 'Mariehamn', ER: 'Muuga hamn', ES: 'Olympia terminalen', ET: 'Paldiski', EU: 'Riga terminalen', EV: 'Sassnitz', EW: 'Åbo hamn', EY: 'Värtahamnen', EZ: 'Visby', E_: 'Ventspils', E$: 'Nordsjö hamn', E5: 'Förvald', E6: 'Boka resan', E7: 'Avbryt', E8: 'Fortsätt', E9: 'Klar', fo: 'Nästa', Fa: 'Billigast hytt:', Fb: 'Billigast hytt (med Club One):', Fc: 'Club One-pris', Fd: 'Vänligen välj fler hytter', Fe: 'Välj hytt för att se totalpris', fp: 'Välj hytt och fortsätt', Ff: 'Summa:', Fg: 'Totalt:', fq: 'Totalt (med Club One):', Fh: 'Kontrollerar priset...', Fj: 'Frånpris inkl. bränsle- och utsläppstillägg för 1 person.', Fl: '{price} / styck', sa: 'Gå vidare', fr: 'Gå till betalning', Fs: 'Denna webbplats skyddas av reCAPTCHA och Googles <a target=\"_blank\" href=\"https://policies.google.com/privacy?hl=sv\">integritetspolicy</a> och <a target=\"_blank\" href=\"https://policies.google.com/terms?hl=sv\">användarvillkor</a> gäller.', ft: 'Förändringar i utbudet ombord:<br>\nFredags- och lördagsavgångar erbjuder bl a livemusik och bingo.<br>\nUtbudet är begränsat på avgångar söndag till torsdag.', fu: 'Ordinarie pris:', Fy: 'Ta bort den nuvarande tiden för att välja denna.', FA: 'Bokningsavgift på {fee} per person dras av på restaurangnotan ombord.', FB: 'Bokningsavgiften gäller inte barn 0–5 år', sq: 'Stäng', FD: 'Något gick fel, var vänlig uppdatera sidan eller starta om bokningen från början.', FE: 'Vi hittade tyvärr inga kommande avresor', fv: 'Börja om', fw: 'Vi ber om ursäkt för besväret. Din nuvarande bokning kommer att annulleras automatiskt.', fx: 'Din session har gått ut', FF: 'Börja om', FG: 'Du behöver tyvärr söka igen. Vi ber så mycket om ursäkt.', FH: 'Ooops... Något gick fel', fz: 'Riga', fA: 'Två nätter ombord, en dag i Klaipeda.', fB: 'Enkelresa eller tur och retur.<br />Avgår kl. 17:00.', fC: 'Stockholm-Åbo-Åbo-Stockholm (Kapellskär)', fD: 'Stockholm (Kapellskär)-Åbo', fE: 'Stockholm (Kapellskär)-Åbo-Åbo-Stockholm', fF: 'Åbo-Stockholm-Stockholm (Kapellskär)-Åbo', fG: 'Åbo - Stockholm (Kapellskär)', fH: 'Åbo-Stockholm (Kapellskär) -Stockholm-Åbo', fI: 'Tillbaka till listan', fJ: 'Vi hittar inte banken du letar efter. Vänligen välj ur listan.', fK: 'Sök', fL: 'Sassnitz', fN: 'Välj minst ett fordon', Ge: '<b>{service} kommer tas bort</b> om du lägger till fordon. Vill du fortsätta?', Gf: 'Är du säker?', Gv: '5h kryssning', Gw: 'Flera dagliga avgångar från Helsingfors. Kryssningen är fem timmar, ingen tid i land i Tallinn. Du kan få rabatt om du gör stora inköp. Om du planerar att göra väldigt stora inköp, är det lättast att ta med bilen. På Megastar har du under resan tillgång till bilen i garaget från Traveller Superstore på däck 7. På Star parkeras bilen på bildäck.', Gy: 'Avgången gäller 5h kryssning. Du omdirigeras till korrekt sida.', fO: '5h kryssning med eller utan bil', GE: 'Bordsbokning för showen', fP: 'Ösel', GK: 'Du som är 15–17 år kan resa utan medföljande vuxen. Kom ihåg att ta med ditt <a href=\"https://se.tallink.com/documents/10192/65608302/RESETILLSTA%CC%8AND_15-17+a%CC%8Ar_2017.pdf\" target=\"_blank\">resetillstånd</a>. Trevlig resa!', fQ: 'S:t Petersburg', GQ: 'Förrätt', fR: 'Stockholm', GY: 'Boka Stockholm–Helsingfors', GZ: 'Det finns ingen direktavgång från Stockholm till Tallinn på det datumet du har valt, res via Helsingfors och ta fartyget därifrån.', G_: 'Obs! Du behöver ta dig från Olympiaterminalen till Västra hamnen terminal 2 för att byta fartyg.', G$: 'Stockholm -> Tallinn <br/> via Helsingfors', fS: 'Vänligen notera att tiderna för alkoholservering är begränsade.', fT: 'Två nätter till havs, en dag dag i Visby. Ombord väntar god mat och underhållning. Shoppa loss i våra butiker, taxfreeshopping är möjlig under hela resan.', fU: 'Två nätter till havs, två dagar i Visby – en extra natt ombord i Visby och två dagar att upptäcka Gotland. Ombord väntar god mat och underhållning. Shoppa loss i våra butiker, taxfreeshopping är möjlig under hela resan.', fV: 'Stockholm (Kapellskär)', fW: 'Tre nätter till havs, en dag i Ystad och en dag i Visby. Följ med på en sommarkryssning till Ystad och Visby. Ombord väntar god mat, sommarunderhållning och taxfreeshopping.', fX: 'tilläggsavgift', fY: 'Tallinn', G8: 'Tallinn – Baltic Sea', fZ: 'Tallinn – Baltic Sea – Tallinn', f_: 'Två nätter ombord, en dag i Riga.', G9: 'Boka Tallinn–Helsingfors', Ha: 'Det finns ingen direktavgång från Tallinn till Stockholm på det datumet du har valt, res via Helsingfors och ta fartyget därifrån.', Hb: 'Obs! Du behöver ta dig från Västra hamnen terminal 2 till Olympiaterminalen för att byta fartyg. <b>Åker du med kollektivtrafiken finns risk att inte hinna med avgången kl 13.30.</b>', Hc: 'Tallinn -> Stockholm <br/> via Helsingfors', f$: 'Två nätter ombord<br/>och en dag i Åbo.', f0: 'Enkelresa eller tur och retur.<br/>Dagliga avgångar från Åbo.', f1: 'Kryssning till Visby', f2: 'Sommarkryssning till magiska Gotland', tb: 'tack för infon', td: 'Lägg till retur', f3: 'Boka returbiljett och spara upp till 30 %', f4: 'Rabatterat pris för en Dagskryssning (ut- och hemresa samma dag)', o6: 'Ankomst', f5: 'Letar du efter en senare avgång?', f6: 'Välj datum för {direction}', f7: 'Rensa val', Hx: 'Välj datum', f8: '23-timmars kryssning (kväll)', f9: '23-timmars kryssning (morgon)', ga: 'Stockholmkryssning', gb: 'En dag i Åbo-kryssning', o7: 'Avgång', Hy: 'Eftermiddag', Hz: 'Morgon', te: 'Restid', tf: 'h', HA: 'Du kan övernatta ombord på fartyget och kan kliva av när du vill mellan kl 8 och 11.', HB: 'Första natten ombord', HC: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this outward sail', HD: 'Sorry, we won\'t be able to provide you ship+hotel service for the whole period of time if you select this return sail', HE: 'Go to last available date', HF: 'Select only ship', HG: 'F.n. fullbokat', gc: 'Ta bort returbiljett', gd: 'Megastar 5h kryssning', ge: 'Stäng', gf: 'Direkt hemresa inkluderar rabatt för 5h kryssning för passagerare och fordon. Ingen tid i land.', gg: 'Megastar 5h kryssning', gh: 'En natt ombord, 4 timmar i Tallinn', gi: 'Kvällskryssning från Stockholm, 23 timmar', gj: 'Morgonkryssning från Stockholm, 23 timmar', gk: 'Två nätter ombord, en dag i Åbo', gl: 'Kvällskryssning från Åbo, 23 timmar', gm: 'Morgonkryssning från Åbo, 23 timmar', gn: 'Tur/retur Helsingfors - Stockholm - Helsingfors', go: 'Enkelresa Helsingfors - Stockholm', gp: 'Tur/retur Helsingfors - Tallinn - Helsingfors', gq: 'Tallinnkryssning', gr: 'Enkelresa Helsingfors - Tallinn', gs: 'Megastar 5h kryssning', gt: 'Tur/retur Riga - Stockholm - Riga', gu: 'Enkelresa Riga - Stockholm', gv: 'Tur/retur Stockholm - Helsingfors - Stockholm', gw: 'Enkelresa Stockholm - Helsingfors', gx: 'Tur/retur Stockholm - Riga - Stockholm', gy: 'Enkelresa Stockholm - Riga', gz: 'Tur/retur Stockholm - Tallinn - Stockholm', gA: 'Enkelresa Stockholm - Tallinn', gB: 'Tur/retur Stockholm - Åbo - Stockholm', gC: 'Enkelresa Stockholm - Åbo', gD: 'Tur/retur Tallinn - Helsingfors - Tallinn', gE: 'Helsingforskryssning', gF: 'Enkelresa Tallinn - Helsinki', gG: 'Tur/retur Tallinn - Stockholm - Tallinn', gH: 'Enkelresa Tallinn - Stockholm', gI: 'Tur/retur Åbo - Stockholm - Åbo', gJ: 'Enkelresa Åbo - Stockholm', HH: 'Med hotell', tg: 'Kryssning', gK: 'Helsingforskryssning', gL: 'Tallinnkryssning', gM: 'Ålandskryssning', gN: 'Stockholmkryssning', gO: 'Kryssning till Tallinn', gP: '9h kryssning', gQ: 'Stockholmkryssning', gR: 'Kryssning', gS: 'Ålandskryssning', gT: 'Cruise to Helsinki', gU: 'Stockholmkryssning', gV: '22h kryssning', gW: 'Kryssning', gX: 'Kryssning med två destinationer', gY: 'Dölj &uarr;', gZ: 'Visa mer &darr;', g_: 'Regul&shy;järresa', le: 'Till', g$: 'Vi har lagt till en vuxen till din bokning. Minst en vuxen krävs per bokning.', g0: 'Garage har tagits bort från bokningen. Priority Car ingår i priset för Business Lounge.', g1: 'Priority Car ingår i priset för Business Lounge.', g2: 'Denna reseklass är inte längre tillgänglig. Vänligen välj en annan reseklass.', HP: 'Registreringsnummer förifyllt', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: 'Vald bussavgång är inte tillgänglig.', g5: 'Valda bussavgångar är inte tillgängliga och har tagits bort.', HQ: 'Hej, {name}!', g6: 'För att betala denna resa med Club One-poäng, behöver du minst {clubOnePoints} poäng.', g7: 'Viss information var ej ifylld. Dubbelkolla att du fyllt i alla fält.', g8: 'Tyvärr kunde vi inte spara din information. Vänligen kontrollera att du har uppkoppling eller täckning.', g9: 'Vissa passageraruppgifter saknas. Fyll i samtliga fält för att spara din information.', HR: 'Bussanslutning har inte lagts till för alla passagerare', HS: 'Du måste ha minst en vuxen per rum', ha: 'För att välja den här måltiden, ta bort tidigare val.', HU: 'Minst en vuxen per bussanslutning krävs.', hb: 'Vänligen kontrollera din internetanslutning och försök igen', hc: 'Vi ändrade ålderskategori från \"{old}\" till \"{new}\"', hd: 'Vi tog bort en hytt eftersom du tog bort en resenär och du behöver ha minst en vuxen resenär per hytt', he: 'Club One lades till för {name}!', hf: 'Du har uppnått det maximala antalet passagerare per bokning', hg: 'Vi har lagt till måltider för alla nya passagerare till din bokning', hh: 'Vi tog bort måltider för borttagna passagerare från din bokning', hi: 'Vi tog bort ett fordon, då antal passagerare blev färre. Minst en vuxen per fordon.', hj: 'OBS! Tidigare passagerarantal togs bort. Max 5 passagerare gäller för linjen Muuga-Nordsjö.', hk: 'Rabatt för Dagskryssning är tilllagd', hl: 'Något gick fel vid hämtningen av tidtabellerna.', hm: 'Med övernattning ombord', hn: 'Rabatt för En dag i Åbo är tilllagd', ho: 'Rabatt för En dag i Stockholm är tilllagd', HV: 'Observera lång väntetid i Stockholm.', hp: 'Du la till den sista lediga hytten \"{name}\"', hq: 'Du har redan valt maximalt antal hytter. Minst en vuxen per hytt krävs.', hr: '\"{name}\" hytt inte tillgänglig för denna avgång. Slutsåld.', hs: 'Sista bilen bokades', ht: 'Det går inte att lägga till fler fordon. Endast ett fordon per vuxen.', hu: 'Fordon får inte köra iland i Tallinn', hv: 'Bil finns tillgängligt endast på utresan', hw: 'Bil finns tillgängligt endast på hemresan', hx: 'Valt fordon är inte tillgänglig för denna avgång.', hy: '+ Djur', hz: 'Allergi', hA: 'bur', hB: 'burar', hC: 'Rörelsehinder', hD: 'hytt', hE: 'hytter', hF: 'Du måste ha minst en vuxen per hytt', H1: 'Slutsåld', hG: 'Endast {capacity}-bäddshytter lediga', hH: 'Endast {capacity}-bäddshytter lediga för {from}-{to}', hI: 'Reser med husdjur', hJ: 'Read more', hK: 'Plats i delad hytt', hL: 'damplatser', hM: 'herrplatser', hN: '{name}, {genderPlace} för delad {maxOccupancy} personers hytt', hO: '{price} / hytt', tm: '{price} / person', hP: 'Hyttkategori', hQ: 'Specialhytter', H2: 'Hytter', hR: 'husdjur', hS: 'husdjur', hT: 'Med husdjur', hU: 'Spendera två nätter ombord Silja Symphony eller Silja Serenade. Du får ungefär 6 timmar iland till att upptäcka Stockholm. När du är klar med upptäckandet så återvänder du till samma fartyg och samma hytt som du anlände i. Upplev fantastisk underhållning ombord och gör prisvärda tax-free fynd. Njut sedan av god mat i någon av de populära restaurangerna ombord.', hV: '22-timmarskryssning med Europa. Dagliga avgångar från Helsingfors till Tallinn kl. 18:30. Dagen därpå får du 4 timmar iland i Tallinn (08:00-12:10).', hW: 'Spendera två nätter ombord Romantika eller Isabelle. Få ungefär 6 timmar till att upptäcka Stockholm. När du är klar med upptäckandet så återvänder du till samma fartyg och samma hytt som du anlände i. Den totala reslängden blir 40 timmar. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna och ta sedan del av all underhållning vi erbjuder ombord.', hX: 'Avgång kl. 07:10 från Stockholm. Res med Baltic Princess till Åland för att sedan byta fartyg och gå ombord Galaxy istället. Ankomst i Stockholm igen blir ungefär kl. 18:15.', hY: 'Spendera två nätter ombord Silja Symphony eller Silja Serenade. Du får ungefär 7 timmar iland till att upptäcka Helsingfors. När du är klar med upptäckandet så återvänder du till samma fartyg och samma hytt som du anlände i. Den totala reslängden blir 40 timmar. Upplev fantastisk underhållning ombord och gör prisvärda tax-free fynd. Njut sedan av god mat i någon av de populära restaurangerna ombord.', hZ: 'Spendera två nätter ombord Romantika eller Isabelle. Få ungefär 6 timmar till att upptäcka Riga. När du är klar med upptäckandet så återvänder du till samma fartyg och samma hytt som du anlände i. Den totala reslängden blir 40 timmar. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna och ta sedan del av all underhållning vi erbjuder ombord.', h_: 'Spendera två nätter ombord Baltic Queen eller Victoria I. Få ungefär 7 timmar till att upptäcka Tallinn. Den totala reslängden blir 40 timmar. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna och koppla sedan av i relaxavdelningen med ett dopp i jacuzzin eller ett besök i bastun. Ta sedan del av all underhållning vi erbjuder ombord.', h$: 'Avgång kl. 19:30 från Stockholm. Tillbringa en natt ombord Galaxy. Ingen tid iland i Åbo. Återvänd till Stockholm dagen därpå. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna o ta sedan del av all underhållning vi erbjuder ombord.', h0: 'Spendera två nätter ombord Baltic Queen eller Victoria I. Få ungefär 7 timmar till att upptäcka Stockholm. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna och koppla sedan av i relaxavdelningen med ett dopp i jacuzzin eller ett besök i bastun. Ta sedan del av all underhållning vi erbjuder ombord.', h1: 'Avgång kl. 08:15 från Åbo. Res med Galaxy till Åland för att sedan byta fartyg och gå ombord Baltic Princess istället. Ankomst i Åbo igen blir ungefär kl. 19:15.', h2: 'Avgång kl. 20:15 från Åbo. Tillbringa en natt ombord Baltic Princess. Ingen tid iland i Stockholm. Återvänd till Åbo dagen därpå. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna o ta sedan del av all underhållning vi erbjuder ombord.', h3: 'Res till Åland med Silja Serenade eller Silja Symphony.', h4: 'Tillbringa en natt ombord Silja Symphony eller Silja Serenade och anländ sedan till Stockholm morgonen därpå. Boka antingen en enkelresa eller tur och retur. Upplev fantastisk underhållning ombord och gör prisvärda tax-free fynd. Njut sedan av god mat i någon av de populära restaurangerna ombord.', h5: 'Flera avgångar om dagen. Res snabbt och bekvämt. Tiden för resan med Star och Megastar är endast 2 timmar per resväg, med Victoria I blir det istället 3,5 timmar per resväg.', h6: 'Res dagligen på ett snabbt och smidigt sätt mellan Helsingfors (Västra terminalen 2) till Tallinn med Tallink Shuttle-fartygen Star och Megastar. Endast två timmar per resväg.', h7: 'Två dagliga avgångar från Helsingfors: 10:30 och 16:30. Total restid blir 5 timmar och det är ingen avstigning i Tallinn. Vid stora inköp ombord så kan du få rabatt. Planerar du att göra väldigt stora inköp så rekommenderar vi att du reser med bil och att du parkerar bilen nära Traveller Superstore som ligger på däck 7.', h8: 'Tillbringa en natt ombord Romantika eller Isabelle och anländ sedan till Stockholm morgonen därpå. Boka antingen en enkelresa eller tur och retur. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna o ta sedan del av all underhållning vi erbjuder ombord.', h9: '4 dagliga avgångar till Åland. Res med Baltic Princess, Galaxy, Silja Serenade, Silja Symphony, Victoria I eller Baltic Queen.', ia: 'Tillbringa en natt ombord Silja Symphony eller Silja Serenade och anländ sedan till Helsingfors morgonen därpå. Boka antingen en enkelresa eller tur och retur. Upplev fantastisk underhållning ombord och gör prisvärda tax-free fynd. Njut sedan av god mat i någon av de populära restaurangerna ombord.', ib: 'Tillbringa en natt ombord Romantika eller Isabelle och anländ sedan till Riga morgonen därpå. Boka antingen en enkelresa eller tur och retur. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna o ta sedan del av all underhållning vi erbjuder ombord.', ic: 'Tillbringa en natt ombord Baltic Queen eller Victoria I och anländ sedan till Tallinn morgonen därpå. Boka antingen en enkelresa eller tur och retur. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna och koppla sedan av i relaxavdelningen med ett dopp i jacuzzin eller ett besök i bastun. Ta sedan del av all underhållning vi erbjuder ombord.', id: 'Spendera en halvdag eller en natt ombord Baltic Princess eller Galaxy. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna o ta sedan del av all underhållning vi erbjuder ombord.', ie: 'Res till Åland med Baltic Queen eller Victoria I.', $8: 'Flera avgångar om dagen. Res snabbt och bekvämt. Tiden för resan med Star och Megastar är endast 2 timmar per resväg, med Victoria I blir det istället 3,5 timmar per resväg.', ig: 'Dagliga avgångar mellan Tallinn och Helsingfors. Res snabbt och smidigt med Tallink Shuttle-fartygen Star och Megastar. Endast 2 timmar per resväg.', ih: 'Tillbringa en natt ombord Baltic Queen eller Victoria I och anländ sedan till Stockholm morgonen därpå. Boka antingen en enkelresa eller tur och retur. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna och koppla sedan av i relaxavdelningen med ett dopp i jacuzzin eller ett besök i bastun. Ta sedan del av all underhållning vi erbjuder ombord.', ii: 'Res till Åland med Baltic Princess eller Galaxy.', ij: 'Spendera en halvdag eller en natt ombord Baltic Princess eller Galaxy. Ät gott, shoppa loss till förmånliga tax-free priser i butikerna o ta sedan del av all underhållning vi erbjuder ombord.', ik: 'Två nätter ombord, en dag i Helsingfors', il: 'Två nätter ombord, en dag i Tallinn', im: 'Två nätter ombord, en dag på Åland.', $9: '22-timmarskryssning till Tallinn.<br />4 timmar i land i Tallinn.', io: 'En avkopplande resa på havet.', ip: 'Kryssning till Åland och tillbaka. Ingen tid i land.', iq: 'Två nätter ombord.<br />Ungefär 7 timmar i land.', ir: 'Två nätter ombord.<br />Ungefär 6 timmar i land.', is: 'Två nätter ombord.<br />Ungefär 7 timmar i land.', it: 'En natt ombord, ingen tid i land.<br />Kvällsavgång med Galaxy.', iu: 'Njut av en 23 timmar lång kryssning ombord på Baltic Princess', iv: 'Kryssning till Åland och tillbaka.<br/>Avgång från Åbo kl 8.15', iw: 'En natt ombord, ingen tid i land.<br />Kvällsavgång med Baltic Princess.', ix: 'Njut av en 23-timmars kryssning ombord på Baltic Princess', iy: 'En natt ombord, ingen tid i land.<br />Morgonavgång med Galaxy.', iz: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Åland & Helsingfors.', iA: 'Enkelresa eller tur och retur.', iB: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Åland.', iC: 'Enkelresa eller tur och retur.<br />Fyra dagliga avgångar.', iD: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Åland & Tallinn.', iE: 'Enkelresa eller tur och retur.', iF: 'Enkelresa eller tur och retur.<br />Daglig avgång kl. 17:00', iG: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Helsingfors & Stockholm.', iH: 'Rabatterat pris för returresa som sker samma dag.<br />2 timmar per resväg.', iI: 'Enkelresa eller tur och retur.<br />2 timmar per resväg.', iJ: '5h kryssning med eller utan bil.<br>Ett smidigt sätt att spara både tid och pengar.', iK: 'Enkelresa eller tur och retur.', iL: 'Enkelresa eller tur och retur.', iM: 'Enkelresa eller tur och retur med Sea Wind. <br> Två dagliga avgångar', iN: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Riga.', iO: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Riga & Stockholm.', iP: 'Enkelresa eller tur och retur.<br />Fyra dagliga avgångar från Stockholm.', iQ: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Stockholm och Helsingfors.', iR: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Stockholm & Riga.', iS: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Stockholm & Tallinn.', iT: 'Enkelresa eller tur och retur.', iU: 'Enkelresa eller tur och retur.<br />Avgår kl. 18:00.', iV: 'Enkelresa eller tur och retur.<br />2 timmar per resväg.', iW: 'Rabatterat pris för returresa som sker samma dag.<br />2 timmar per resväg.', iX: 'Enkelresa eller tur och retur.<br />Dagliga avgångar från Tallinn & Stockholm.', iY: 'Enkelresa eller tur och retur.', iZ: 'Enkelresa eller tur och retur.', i_: 'Enkelresa eller tur och retur.', i$: 'Enkelresa eller tur och retur med Sea Wind. <br> Två dagliga avgångar', i0: 'Åbo', i1: 'Två nätter ombord och en dag i Tallinn.', i2: 'Enkelresa eller tur och retur.<br/>Dagliga avgångar från Tallinn.', H3: 'Kryssning 3 nätter', i3: 'Ni får två nätter till havs och ett helt dygn i land, med övernattning ombord i Härnösands hamn.', i4: 'Två nätter till havs, två dagar i Helsingfors – övernattning ombord i Helsingfors och två dagar att upptäcka Finland.\r\nShoppa loss i våra butiker, taxfreeshopping är möjlig under hela resan.', i5: 'Två nätter ombord, en dag på Åland.', i6: 'Två nätter till havs, 4,5 timmar i Härnösand. Upplev världens högsta kustlinje från vattnet när vi seglar inomskärs i Höga Kustens vackra skärgård.', i7: 'Två nätter ombord, en dag i Helsingfors', i8: 'Två nätter ombord, en dag i Riga', i9: 'Två nätter ombord, en dag på Ösel.', ja: 'Två nätter ombord, en dag i Stockholm', jb: 'Två nätter ombord, en dag i Tallinn', H7: 'Använd koden', jc: 'Utsläppstillägg för fordon', jd: 'Fordonets utsläppsavgift gäller för det fordon som anges i bokningen.', Id: 'Bränsle- och utsläppstillägg', Ie: 'Fordonets bränsle- och utsläppstillägg gäller för det fordon som anges i bokningen.', je: 'Max 1,5 m hög och 3 m lång', jf: 'Upp till 1,9 m hög och 5 meter lång', jg: 'Lägg till garage och parkera bekvämt bredvid Traveller Superstore &rarr;', jh: 'Vill du vara bland de första att köra av fartyget i hamn? Lägg till Priority Car &rarr;', ji: 'Över 2,4 m hög och 7 meter lång', jj: 'm', jk: 'Max 1,9 m hög och 5 m lång. \nBilen kan inte köras ut från fartyget.', jl: 'Vänligen fyll i registreringsnr för alla fordon', Ii: 'Ta bort', jm: 'Välj ett fordon från tidigare resa:', jn: 'Upp till 2,3 m hög och 7 meter lång', jo: 'Upp till 1,9 m hög och 5 meter lång', jp: 'Registreringsnummer för släp', jq: 'Registreringsnummer får endast innehålla siffror och latinska bokstäver', jr: 'Upp till 2,4 m hög och 7 meter lång', js: 'Fordonsuppgifter saknas', jt: 'Registreringsnummer för fordon', ju: 'Tillagda fordon:', jv: 'Kollar tillgängligheten', Il: 'Res via Helsingfors', jw: 'Visby', jx: 'Ystad/Visby', jy: 'Ventspils', Ip: 'Bokningskod:', Iq: 'Logga in på ditt Club One-konto för att ta del av erbjudandet.', Ir: 'Presentkortet har redan lagts till.', Is: 'Presentkortets giltighetstid har gått ut.', It: 'Presentkortet har en annan valuta.', Iu: 'Presentkortets värde är slut.', jz: 'Nordsjö', IA: 'Kryssning till Höga Kusten', IC: 'wow', tE: 'Dagskryssning', jA: 'Ystad'};
var $author$project$Translations$Generated$zh = {P: 'Read our accessibility statement', Q: 'https://www.tallink.com/en/accessibility', tJ: '添加', R: '添加另一个优惠券代码', S: '若需要添加车位预订，请添加更多成人乘客。自行车车位预订可添加至6-17岁乘客。', tK: '为所有乘客添加房间', pl: '添加座位', tM: '此线路{route}需要随车登船', tN: '将车辆添加至{route}路线？', tO: '你想添加航线吗？', T: '奥兰岛', t_: '奥兰岛（Långnäs）', t$: '奥兰岛（Mariehamn）', ue: '你已经在其他酒店选择了房间。选择此房间需要先清除之前的选择。', uj: '巡游', ul: '取消 & 继续预订', um: '继续至桌面版本', un: '若继续操作至桌面版本，您将需要重新填写以下选项：<span class=\"bodyBold\">乘客信息、客舱等级、船上用餐</span>。', uo: '部分已选择的信息将丢失', up: '若继续操作至桌面版本，您将会丢失以下信息：<span class=\"bodyBold\">乘客信息和船上用餐</span>。', U: 'Aktia', V: 'Ålandsbanken', W: 'Coop Pank', X: 'Danske Bank', Y: 'Danske Bank', Z: 'Handelsbanken', _: '网上银行', aa: '选择银行并继续', ab: 'Osuuspankki', ac: 'LähiTapiola', ad: 'LHV', ae: 'Luminor', af: 'Nordea', ag: 'Alpha-Click 登入或电话号码', ah: '最近选择的银行', ai: 'Säästöpankki', aj: 'SEB', ak: '选择银行', al: 'S-Pankki', am: 'Swedbank', uB: '预订餐食', uC: '单独预订这些行程：', uD: '添加船上服务', uE: '前往桌面 &rarr;', uF: '是否需要预订其他游轮服务？', uG: '添加巴士接送服务', uH: '港口下车上车点', uI: '公司账号预订行程', ao: '使用优惠积分，预订更便捷！', ap: '退出', uJ: '登录', aq: '是否有Club One会员账号？', ar: '显示有效日期', uK: '已选择行程无法使用该优惠代码。请重新选择出发日期、航线或是船票等级。', as: '请检查优惠券代码并重新输入。', uL: '取消', at: '预订代码已被使用', au: '代码正确', uM: '请检查优惠券代码并重新输入。若您近期已使用过该代码，代码可能已被系统锁定。请等待20分钟后再重新操作。', av: '请注意，您的优惠代码有时会被系统锁定。若出现该情况，请稍等30分钟后再重新操作。', aw: '已获取优惠价格', ax: '优惠代码', ay: '所选择日期的出发邮轮无法使用该优惠代码。', az: '您可以使用于其他日期', aA: '原价{oldPrice} 已优惠至{discountedPrice}', aB: '原价{oldPrice} 已降低至{discountedPrice}', aC: '清除', uN: '代码输入正确。请选择您的客舱等级，从而获取优惠。', uO: '使用礼品券，请致电 +49(0)40 547 541 222', aD: '优惠券代码已激活', aE: '使用优惠券代码', aF: '积分', uP: '添加额外服务', aG: '快速通道', aH: '车库', aI: '保险', uQ: 'Plan with Confidence', aJ: '优先车辆', uR: '选择出发地点', uS: '选择目的地', aK: '立即预订', uT: '22小时巡游', uU: 'Cruises', uV: 'Cruises', uW: '在目的地无岸上游玩时间', py: '在目的地无岸上游玩时间', uX: '赫尔辛基一日巡游', uY: '里加一日巡游', uZ: '斯德哥尔摩一日巡游', u_: '出发日期', u$: '重要提示：该游轮暂时无法提供适合残障人士出行的服务和设备。', aL: '无下船时间', u0: '回程日期', u1: '单程', u2: '往返', aM: 'Megastar号五小时专线游轮', u3: '单程', u4: '往返', ne: '订单', aN: '行程选择', aO: 'In English', aP: 'Eesti keeles', aQ: 'Suomeksi', aR: 'Latviski', aS: 'На русском', aT: 'På svenska', aU: '选择语言', aV: '中文', aW: '更改语言设置？', u5: '选择用餐', aX: '可在船上预订餐饮服务', u6: '无餐饮服务', u7: '提前预订餐食，畅享美味更优惠！', u8: '船上用餐', aY: '有优惠券代码', u9: '其他服务', aZ: '该预订中必须且只能有一辆车辆。', va: '新冠', a_: '新冠检测', vb: '儿童手环', vc: '按摩', vd: '乘客', ve: '加入Club One 会员', vf: 'https://clubone.tallink.com/zh/join', vg: '退出', vh: '获取Club One 会员特惠，预订更便捷。', a$: '选择客舱', vi: '船票等级', vj: '客舱', a0: '自行车，电动滑板车', a1: '私家车', a2: '大型私家车', vl: '选择车型', vm: '请输入车牌号', a3: '正在更新价格', a4: '摩托车', a5: '摩托车加边车', a6: '已停车辆', a7: '车牌号已预先输入', a8: '购物专线私家车', a9: '购物专线商务车', ba: '显示全部', bb: '商务车', bc: '大型商务车', bd: '大型超规格汽车，或者加拖车的车位预订。', be: '私家车加拖车', bf: '私家车加拖车', bg: '私家车加拖车', vB: '添加更多的巴士接送服务', bh: '添加客房惊喜礼遇', bi: 'Free gift', bj: '惊喜礼遇已选择', bk: '惊喜礼遇已选择', vC: '显示更多', bl: '先前信息', bm: '日期', vD: '专线游轮', bn: '请注意！', vE: '起价 {price}', vF: '无出发航班', vG: 'No departures on the selected date.', bo: '所有价格为欧元', bp: '客舱积分{price}点起', bq: '每人{price}点积分起', br: '每人{price}起', bs: '客舱起价{price}', bt: '取消', bu: '继续', bv: '若继续操作，您的客舱选择将重设，乘客信息将保留。', bw: '所选择日期的出发游轮无法提供该客舱等级。', vH: '专线主题<br/>游轮', vI: '车位起价{price}', bx: '已售罄', by: '排放附加费', bz: '排放附加费适用于 6 岁及以上的乘客', bA: '排放附加费，用以支持气候行动并支付欧盟排放交易系统的成本', vQ: '{chars} 字符剩余', vR: '办理入住', vS: '办理退房', vW: '选择  &rarr;', vX: '选择您的房间', vY: '选择你的住宿查看最终价格', v3: '删除&选择', bB: '铜卡等级', bC: 'Club 等级', wd: 'Club one discount:', bD: '金卡等级', bE: '未激活Club One等级', bF: 'Club One会员号', bG: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">international.sales@tallinksilja.com\n</a>', bH: '<a href=\"mailto:clubone@tallink.ee?subject=Club One account reactivation\">clubone@tallink.ee\n</a>', bI: '<a href=\"mailto:ClubOne@tallinksilja.com?subject=Club One account reactivation\">ClubOne@tallinksilja.com\r\n</a>', bJ: '<a href=\"mailto:clubone@tallink.lv?subject=Club One account reactivation\">clubone@tallink.lv</a>', bK: '<a href=\"mailto:tallinksilja@tallinksilja.no?subject=Club One account reactivation\">tallinksilja@tallinksilja.no\n</a>', bL: '<a href=\"mailto:clubone@tallink.ee?subject=Club One account reactivation\">clubone@tallink.ee\n</a>', bM: '<a href=\"mailto:ClubOne.Sweden@tallinksilja.com?subject=Club One account reactivation\">ClubOne.Sweden@tallinksilja.com\r\n</a>', bN: '电子邮箱：', bO: '\"<a href=\"\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\"\">international.sales@tallinksilja.com\n</a>\"', bP: '<a href=\"mailto:international.sales@tallinksilja.com?subject=Club One account reactivation\">您的Club One会员账号已关闭，请联系我们客服中心。\n</a>', bQ: '您的Club One会员账号已关闭，请联系我们：', bR: '<a href=\"tel:004940547541222\">004940547541222</a>', bS: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bT: '<a href=\"tel:010 804 133\">010 804 133</a>', bU: '<a href=\"tel:+37167099700\">+371 67099700</a>', bV: '<a href=\"tel:+4781533250\">+47815 33 250</a>', bW: '<a href=\"tel:+3726409808\">+372 640 9808</a>', bX: '<a href=\"tel:+468222140\">+468 22 21 40</a>', bY: '<a href=\"tel:004940547541222\">004940547541222</a>', bZ: '电话：', b_: '铂金卡等级', wg: '<a>登录</a>或<a>加入Club One</a>以获得折扣，使用积分并轻松的预订您的行程。', b$: '银卡等级', wh: 'Club One points cannot be used, because the main account holder has disabled their use.', wi: '您可以使用的积分是根据您预订的项目和服务动态计算的。', wj: '使用会员积分', wk: '会员积分无法被此优惠码激活。', wl: '您没有足够的会员积分可使用。', b0: '您现在可以在<a>下方的滑块</a>中使用您的会员积分进行支付。', wm: '会员积分无法激活 ({reason}).', pQ: '优惠代码：', wp: '您输入的内容包含不可识别的特殊字符。', wr: '出生日期', ws: '日', wt: '月', wu: '年', wv: '{count} {count, plural, one{成人} other{成人}}', ww: '({range} 岁)', wx: '到达时间为 {time}', pT: '{count} {count, plural, one{儿童} other{儿童}}', wy: '免费', wz: '更少', wA: '更多', wB: '国籍', wC: '常用', b1: '该价格是您Club One {level}会员的优惠价格。', wD: 'Club One会员请在当前页面输入乘客信息，其他乘客可稍后操作。', b2: '点', b3: '使用Club One会员积分', b4: '即将推出', wE: '输入Club One会员号，获取会员积分。', wF: '完成', wG: '更改&rarr;', b5: '填写所有乘客的电话号码和电子邮箱地址，更方便快捷的办理登船、共享行程信息以及获取登船卡。', wH: '名', wI: '性别', wJ: '女', wK: '男', wL: '已包含至价格', mh: '请检查您输入的信息', wM: '此电子邮箱地址为联系人或其他乘客所有', wN: '此电话号码为联系人或其他乘客所有', wO: '姓', wP: '填写所有必填选项（*）并保存', wQ: '早餐', wR: '早午餐', wS: '自助餐', wT: '晚餐', wU: '午餐', wV: '餐厅订位', wW: '可在游轮餐厅预订用餐服务', wX: '姓名应只包含拉丁字符', wY: '无该服务', b6: '无法提供该服务', wZ: '不需要', b7: '成人\r\n18+', b8: '儿童\n0-5', b9: '少儿\n6-11', ca: '青少年\n12-17', cb: '银行', w_: '支付 {price}', cc: '支付中 {price}', cd: '银行卡', w$: '确认预订 {price}', w0: '确认中{price}', ce: '使用Klarna方式支付 {price}', cf: '支付正在进行...', w1: '</p>我们为您提供的一系列旅行服务产品套餐在指令（欧盟）2015/2302的框架内。<br>\n因此，您将享有所有适用于该产品套餐的欧盟权益。AS Tallink Grupp 塔林客集团将对该旅行产品套餐的执行全权负责。<br>\n此外，根据法律规定，AS Tallink Grupp 塔林客集团将全权保障您的退款，若产品套餐中包含交通运输服务，从而确保您可能面临的遣送回国的情况。<br>\n<a href=\"https://www.tallink.com/good-to-know/package-travel\" target=\"_blank\">阅读旅行产品套餐条例规定</a>。</p>', pU: '<p>我们为您提供的一系列旅行服务产品套餐在指令（欧盟）2015/2302的框架内。</p>\n<p> 因此，您将享有所有适用于该产品套餐的欧盟权益。{name} 塔林客集团将对该旅行产品套餐的执行全权负责。</p>\n<p>此外，根据法律规定，{name} 塔林客集团将全权保障您的退款，若产品套餐中包含交通运输服务，从而确保您可能面临的遣送回国的情况。</p>\n<a href=\"https://www.tallinksilja.com/packaged-tours-tallink-grupp\" target=\"_blank\">阅读旅行产品套餐条例规定</a>。', w2: '按下付款按钮，即表示您同意<a href=\"https://www.tallink.com/good-to-know/rights-of-passengers\" target=\"_blank\">政策和条款</a> 以及与<a href=\"https://www.tallink.com/good-to-know/club-one\" target=\"_blank\">相关的Club One会员计划条款。</a>', w3: '点击\"支付\" ，您已同意<a href=\"https://www.tallinksilja.com/travel-terms-and-conditions-for-individuals\" target=\"_blank\">该条款和规定</a>。', w4: 'AS Tallink Grupp', w5: 'https://www.tallinksilja.com/packaged-tours-tallink-grupp', w6: 'Tallink Silja Oy', w7: 'https://en.tallink.com/packaged-tours-tallink-silja', w8: '18岁以下的乘客，请仔细阅读<a href=\"https://www.tallink.com/good-to-know/age-regulations\" target=\"_blank\">年龄限制规定</a>。', w9: 'アリペイ', xa: 'Apple Pay', xb: '本地银行', xc: '卡', xd: 'Google Pay', xe: '移动支付', xf: '借记卡/信用卡', xg: 'ウィーチャットペイ', xh: '网上银行和借记卡/信用卡', xi: '本地银行', xj: '网上银行', cg: '起价{price}', xk: '向上滚动至设置', xl: '选择', xm: '已选择', xn: '游轮', xo: '日期{date} 时间{time}', xp: '{count} {count, plural, other{乘客}}', xq: '成人\n18+', xr: '儿童\n0-5', xs: '少儿\n6-17', xt: '请先选择入住客舱', xu: '奥兰岛的到达港口是Långnäs码头（距离玛丽港30千米）', xv: '到达Långnäs港口', xw: '奥兰岛的出发和到达港口均为Långnäs码头（距离玛丽港30千米）', xx: '奥兰岛的出发港口是Långnäs码头（距离玛丽港30千米）', xy: '从Långnäs港口出发', pV: '驾车登船', xz: '车辆', ch: '22小时波罗的海女王号巡游', ci: '当天往返巡游', cj: '单程和往返', ck: '往返', cl: '单程，往返以及当天往返', xB: '企业客户', xC: '协议代理账号', xD: '无法找到该代理账号', xE: '请注意！协议代理账号一栏为必填选项。', xF: '您将临时退出当前已登录的个人账号。', xG: '公司账号', xH: '无法找到该公司账号', cm: '预订确认单已发送至', cn: '预订已完成，祝您旅途愉快！', co: '您将获得{refund}的退款！', cp: '请致电我们客服中心，咨询退款事宜！', cq: '您的预订已更新！', xI: '成人', xJ: '城市名称', xK: '无搜索结果', xL: '搜索巴士站点', xM: '巴士接送', cr: '未成年6-17岁', cs: '更改预订', xN: '基本票价', xO: '未成年 {range} 岁', ct: '岸上娱乐活动', cu: '不希望', cv: '希望', cw: '您是否希望通过电子邮箱来接收Tallink&Silja Line塔林客诗丽雅游轮的限时特惠活动信息？', cx: '感谢您订阅我们的电子新闻周报！', cy: '致电客服中心', cz: '取消', xP: '您输入的出生日期与已选择的年龄组别不符。请输入正确的出生日期，或是致电我们客服中心更改年龄组别：', cA: '更改年龄组别？', cB: '购买服务', cC: '更换服务', cD: '地址', cE: '公司', cF: '如需更改您的预订，请联系我们的<a href=\"https://www.tallink.com/de/gut-zu-wissen/kontakt#germany-contacts\">客服中心</a>.', cG: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallink.com/sv/bra-att-veta/kontakta-oss>客服中心</a>。', cH: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallink.com/ee-et/hea-teada/kontaktid\">客服中心</a>。', cI: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallinksilja.fi/palvelunumerot\">客服中心</a>。', cJ: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallink.lv/lv/contacts\">客服中心</a>。', cK: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallinksilja.com/contact-us\">客服中心</a>。', cL: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallinksilja.ru/agents\">客服中心</a>。', cM: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallinksilja.se/kontakta-oss\">客服中心</a>。', cN: '如需更改您的预订，请联系我们的 <a href=\"https://www.tallinksilja.com/contact-us\">客服中心</a>。', cO: '联系人姓名', cP: '联系人', cQ: '若要更改您的预订，请联系您的旅行社。', cR: '电子邮箱', cS: '加入Club One会员', cT: '预订确认信息', cU: '登船手续将于游轮出发前2小时开始办理。重要提示：驾车登船的乘客，最晚要在游轮出发前45分钟，在车辆登船口办理车登船手续。', cV: '请填写乘客信息的所有选项。', cW: '取消', cX: '继续', cY: '若您继续操作，您在乘客信息选项所做的更改将不会保存。', cZ: '不保存所做的更改', c_: '以PDF格式显示确认信息', c$: '请从您确认电子邮箱的PDF账单中查阅付款信息。', c0: '显示条款和规定', c1: 'https://www.tallink.com/zh/good-to-know/general-travel-conditions', xQ: '总计', c2: '电话号码', c3: '预订号', c4: '安全码', c5: '确认信息', c6: '游轮到达和出发时间始终是当地时间。', c7: '您可以在游轮码头，使用自助取票机（输入预订号和安全码）获取登船卡。', c8: '我们建议您至少提前1小时抵达码头。', c9: '不驾车登船的乘客，我们建议您最晚要在游轮出发前30分钟办理登船手续。驾车登船的乘客，最晚要在游轮出发前1小时抵达码头。附注：从塔林或斯德哥尔摩驾车登船，前往奥兰岛玛丽港的乘客，请务必要在游轮出发前1个半小时抵达码头。', da: '预订当天往返或是一日巡游的乘客，若第一个去程没有在码头注册、办理登船手续，Tallink集团将会取消整个行程的预订。', db: '旅途中，请随身携带有效的护照或是身份证（儿童亦是）。如果您不确定您是否需要签证，请向您旅行目的地的大使馆进行咨询。', dc: 'The ship\'s arrival and departure times are always shown in local time. <br>\nYou can check in online, in the Tallink Silja Line app, or at the terminal. <br>\nAt Paldiski and Kapellskär ports, check-in for vehicle passengers closes 75 minutes before the Superfast ferry\'s departure. We recommend arriving at the port early. <br>\nCabin cards will be issued on the check-in. <br>\nEvery passenger (including children must carry a valid travel document and any other \nnecessary papers, such as a visa if required, for the entire journey. <br>\nPassengers are responsible for the validity and accuracy of their documents.', dd: '您的行程信息', de: '行程小贴士', df: '退款', dg: '您将收到退款{refund}！请致电我们的客服中心，来获取您的退款。', dh: '致电退款事宜', di: '已致电？别担心，该提示信息将在我们开始处理您的退款需求时自动消失。', dj: '获取您的退款', xR: '若网络链接问题依然存在，您可以致电我们的客服中心：+49(0)40 547 541 222。', xS: '无网络连接，请检查网络并重试。', xT: '重试', xV: '继续', xW: '继续支付', pX: '电子邮箱', xX: '例如：', dk: '国家代码和电话号码', xY: '联系方式', xZ: '请输入您的联系方式，获取游轮预订确认单。Club One会员请登录账号或输入会员信息，获取会员积分。', x_: '以上信息将会更新至您的Club One账号', pY: '电话号码', dl: '例如：400346544', x$: '其他', x0: '预订确认单的复制版本将发送至 {email}', dm: '其他电子邮箱', dn: '邮政编码', x6: '{price} / 测试', x8: '使用我们的<b>全新预订系统</b>更快地预订此行程。', dp: '全名', dq: '信用卡支付', dr: '月', ds: '信用卡卡号', dt: '支付方式', du: '安全码', dv: '选择您的信用卡：', dw: '有效至', dx: '年', dy: '巡游斯德哥尔摩(Kappellskär)-图尔库-斯德哥尔摩(Kappellskär)', ya: '赫尔辛基专线游轮', yb: '维斯比专线游轮', dz: '巡游图尔库-斯德哥尔摩(Kappellskär)-图尔库', yc: 'Ystad巡游之旅', dA: '赫尔辛基一日巡游', dB: '里加一日巡游', no: '塔林一日巡游', yj: '图尔库一日巡游', yr: '甜点', dC: '优惠折扣：', yy: '已使用', yz: 'Promotional code or gift card:', p9: '折扣 & 礼品券', dD: 'Don’t forget to select one menu option for each adult passenger in {restaurant} reservation.', dE: 'Don’t forget to select one menu option for each 12 years and older passenger in {restaurant} reservation.', yB: '不要错过任何机会！', yD: 'Choose drink package', dF: '同一出发航班，您有一个未支付的订单。预订号： {resId}，价格：{price} {unit}。您是否希望取消已有预订，并确认支付新的预订？<a href=\"{link}\">打开并支付预订 →</a> 更多详情，请联系我们的客服中心。', yF: '更改您的房间', yG: '更改您的房间', yO: '岸上游', yP: '岸上游加宾馆住宿', yS: '随船的车辆，须确保所有的乘客都有座位。', dK: 'https://clubone.tallink.com/', yY: '额外服务', dL: '给出反馈', y_: '游轮', y$: '游轮+酒店', y5: 'Choose menu', y7: '食物过敏 / 饮食限制：', kS: '出发', za: 'Emission and fuel surcharge', zb: '燃油和排放附加费适用于 6 岁及以上的乘客', zc: 'Fuel and emissions surcharges apply to passengers aged 12 and over. Up to three children aged 6–11 per booking are exempt.', zd: 'Fuel and emissions surcharges to support climate action and cover costs from the EU Emissions Trading System.', dM: '燃油附加税', dN: '燃油附加费适用于 6 岁及以上的乘客', dO: '燃油附加税 {price} 对6岁以上乘客收取。', dP: '燃油附加税 {price} 对每段航线6岁以上乘客收取。', zh: '礼品券：', zi: '礼品券可以多次使用直至余额用完。\n礼品券还剩余{priceLeft} €。', dQ: 'Group menu available', zm: 'For bookings with 12 or more adult passengers, we kindly ask you to select one menu option for each adult passenger in the booking. Younger passengers will automatically get a kids menu voucher worth 25 €.', dR: '赫尔辛基', dS: '两晚夜宿游轮，日游里加。', dT: '22小时游轮之旅前往中世纪古城塔林！<br>塔林岸上游览时间为4小时。', dU: '塔林专线游轮。<br>在塔林的岸上游览时间为5小时。', dV: 'Visby cruises', dW: 'Summer special cruises to the magical Gotland island', dX: 'Härnösand', zv: '酒店', zy: '要在可选区域之外选择日期，请<a>相应地更改旅行日期</a>。', dY: '入住', dZ: '入住时间', d_: '退房', d$: '退房时间', d0: '晚', d1: '晚', zz: '当前酒店预定仅可在单独的应用程序中进行。', zA: '您选择的时间福段没有空房，请选择其他日期', zB: '入住日期必须在退房日期之前，您可以在退房选项里更改退房日期。', zC: '退房日期必须在入住日期之后，您可以在入住选项里更改入住日期。', zD: '这是您的入住日期，需要更改请前往入住选项。', zE: '这是您的退房日期，需要更改请前往退房选项。', qF: '您选择的日期超出旅行日期。如需继续选择此日期，请更改您的旅行日期。', zF: '過夜之旅，船上住宿包含在內。', zG: '過夜之旅，船上住宿包含在內。', zW: '食物过敏以及饮食禁忌信息已告知游轮工作人员。', q4: '加入Club One会员', AB: '专享会员船票优惠，收集积分购买奖励旅程，获取会员合作伙伴专属优惠。', d2: '街道地址', d3: '市/区', d4: '国家', d5: '完成加入Club One会员的手续', AC: '邮政编码', AD: '乘客中需有一名为Club One会员。', d6: '电子邮箱', d7: '邮寄', d8: '短信', d9: '优选语言', ea: '我希望获取Club One会员优惠信息和新闻。', eb: '否', ec: '保存并关闭', ed: '是', AF: '欢迎加入Club One 会员！您可以在预订完成后，再继续填写相关信息。', AG: '欢迎加入Club One 大家庭！立即享受会员优惠价格。原价{priceBefore}已优惠至{currentPrice}。', AH: '已有Club One会员使用该信息。', ee: 'Kapellskär', ef: '儿童套餐餐券', AN: '确认此预订，您已同意将您的预订数据转移至Klarna来查询可用的支付方式。阅读更多', AO: 'https://cdn.klarna.com/1.0/shared/content/policy/data/en_fi/privacy_statement.pdf', AP: '有关Klarna使用您的数据权限', AQ: 'Klarna & Swish', AR: 'Invoice, part payment', AS: 'Klarna', AT: '账单支付', AU: '部分支付', AV: 'Swish', AW: '可用的支付方式取决于您的订单，最常用的方式为：', eg: 'Klarna退出', eh: 'Klarna让您更加便捷、安全的使用手机支付。', ei: '克莱佩达', ej: '单程或往返<br>每天出发，时间为19:00。', A$: '德语', A0: '英语', A1: '爱沙尼亚语', A2: '芬兰', ek: '立陶宛', A3: '拉脱维亚', A4: '俄语', A5: '瑞典', Bb: '下载中...', Bc: '赫尔辛基', Bd: '尤尔马拉', Be: 'Kolmården', Bf: '库雷萨雷', Bg: 'Laulasmaa', Bh: '玛丽港', Bi: '纳尔瓦', Bj: '北雪平', Bk: '奥泰佩', Bl: '派尔努', Bm: '拉克韦雷', Bn: '里加', Bo: '南泰利耶', Bp: '斯德哥尔摩', Bq: '塔尔图', Br: '图尔库', Bs: '塔林', Bt: '坦佩雷', Bu: '乌普萨拉', Bv: '万塔', Bw: 'Vihula', BC: 'Main course', BE: '添加其他时间', BF: '日期：', BG: '{price} / 单次', BH: '时间：', Cf: '{direction}期间无餐饮服务', Cg: '该美食套餐包含全程餐饮', Ch: '选择美食套餐', el: '未选择', em: '<span class=\"data\">{count}</span> {count, plural, other{# 早餐}}', en: '<span class=\"data\">{count}</span> {count, plural, other{# 晚餐}}', rt: '儿童乘客可享用美食套餐特惠政策，5岁以下儿童在父母陪同下用餐免费。\r\n\r\n在其他餐厅用餐时，您可以将自助晚餐的餐券当作现金来支付账单。', Ci: '{price} / 18岁以上', Cj: '{price} / 成人', Ck: '{price} / 人', Cl: '<span class=\"save bodySmall\">节省</span><span class=\"bodySmall\">至</span><span class=\"bodyLarge percentage\">15%</span>', Cm: '美食套餐', Cn: '{count, plural, other{# 人}}', Co: '每人', Cp: '订位', ru: '尊享套餐优惠', eo: '预订座位', ep: '已售罄', eq: '早餐', er: '晚餐', Cq: '船上用餐', es: '餐券', Cr: '全程的用餐已包含至票价中。', Cs: '确定不需要添加餐食， <b>即可享受10%折扣？ <b>此优惠只有在线预订时可享受。', et: '会议室', eu: '{date}，{time} ， {duration} 小时', Ct: 'Menu available', Cu: '请为预订中每位12岁及以上的乘客选择一个用餐菜单选项。未成年乘客至少可享受高达50%的惠价。12岁以下的儿童将在预订时获得一张餐券，并可在船上餐厅内选择他们喜欢的餐点。', ew: '填写乘客信息', ex: '显示乘客信息', ey: 'Club One会员', CA: '若需更改Club One会员的个人信息，请致电我们客服中心：', ez: '乘客信息不完整', eA: '您不需要打印纸质版的确认信，只需在自助取票机上输入预订号和安全码即可打印船票。', eB: '年龄分组不正确', eC: '乘客信息不完整', eD: '支付未完成', eE: '输入车牌号码', eF: '车牌号信息不完整', eG: '车牌号未输入', eH: '将预订信息下载至手机', eI: '获取', eJ: '打开', eK: '发送链接', eL: 'Tallink & Silja Line App', eN: 'Muuga', CJ: '在目的地无岸上游玩时间', CK: '到达目的地时车辆禁止开出', CL: '在选择的旅行类型里没有出发航班。请更改旅行类型', CM: '支付过程中出现问题！请重试，或致电我们客服中心{phone}。', ol: '不需要，谢谢', CU: 'This code makes your ticket non-refundable. Read more about the specific <a href=\"#\">terms →</a>.', CV: '<ul>\n<li>It is not permitted to change the direction and/or route, departure date or time of the ticket.</li>\n<li>The passenger´s personal data, cabin class, vehicle and onboard service may be changed. When making such changes, the price difference between the originally purchased service and the amended service must be paid.</li>\n<li>If the passenger cancels the ticket, Tallink Silja Line will retain 100% of the ticket price as a contractual penalty.</li>\n<li>In all other matters, the travel conditions of AS Tallink Grupp apply, which are available at <a target=\"_blank\" href=\"https://www.tallink.com/terms\">terms page</a>.</li>\n</ul>', CW: 'Terms & Conditions', CX: 'yes, I Accept', CY: 'remove code', CZ: 'You are buying a non-refundable ticket using code <b>{code}</b>. After purchase, this ticket cannot be refunded under any circumstances. You can only change the passenger’s personal details, cabin class and services. Changes to direction, route, departure date or time are not available. Please confirm that you understand and accept these terms before proceeding to payment.', C_: 'Non-Refundable Ticket', eO: '没有足够的积分', C0: '继续预订', C1: '重设预订', C2: '退出该界面将会重设您的预订，确定重新开始预订？', C3: '重设预订？', eP: '斯德哥尔摩到达港口是Kapellskär（距离斯德哥尔摩90公里）', eQ: '斯德哥尔摩出发港口是Kapellskär（距离斯德哥尔摩90公里）', eR: '斯德哥尔摩的出发和到达港口是Kapellskär（距斯德哥尔摩90公里）', Da: '香槟酒会', eS: 'Insurance', Db: '友谊手环', Dc: '儿童套餐', Dd: 'Priority boarding', De: '船上服务', Df: '游轮现金券', Dg: '现金券', Dh: '游轮现金券', Di: '位', Dj: 'ルート}間のサービスはご利用できません', Dk: '一天', eT: '单程或往返<br>每天出发。', Do: '或', Dp: '其他', eU: '其他支付方式', eX: '12岁以上', eY: 'Paldiski', eZ: '已停商务车', DI: '波罗的海海上派对', DJ: 'Baltic Sea - Tallinn', e_: '无法更改乘客的年龄分组', DM: '年龄分组不正确 - 请确认您填写的出生日期。', DN: 'Incorrect age group – make sure the date of birth corresponds to an adult or a youth.', DO: '请检查您填写的日期格式为：日-月-年', DP: '出生日期的输入格式只支持数字。', DQ: '稍后填写', DR: '保存', DS: '请检查您的姓名和Club One会员号。', DT: 'Club One会员号', DU: '已添加', DV: '编辑信息或者', DW: '重新开始', DX: '旅行证件的相关信息将会添加至Club One会员账号。', DY: '证件签发地点 *', DZ: '证件有效期至 *', D_: '证件签发日期 *', D$: '证件号码 *', D0: '证件类型 *', D1: '出生国家 *', D2: '特别协助', D3: '请参阅 <a href=\"https://www.tallink.com/good-to-know/special-needs-and-assistance\" target=\"_blank\">我们官方网站</a>上的链接来提供详细的信息，或致电我们客服中心：', D4: '004940547541222', D5: '+46 8 22 21 40', D6: '+372 640 9808', D7: '+358 10 804 133', D8: '+371 67099700', e$: '+372 640 9808', D9: '+46 8 22 21 40', Eb: '添加乘客', Ec: '<span class=\"data\">{count}</span> {count, plural, other{乘客}} 已选择', Ed: '现在填写信息或稍后操作', Ee: '乘客信息已完整', Ef: '乘客', e0: '即将推出！', e1: '您的预订号码', e2: '信用卡', e3: '移除', Ei: '支付', e4: '选择支付方式：', Ej: '账单', Ek: '账单地址', e5: '公司账单支付', El: '您的预订参考号码', e6: '稍后付款', e7: '手机支付', e8: '立即支付来锁定预订', e9: '网上银行', fa: '移动电话费', fb: '移动电话费', fc: '致电费用：85分/次 + 移动电话费。', fd: '致电费用：8,35分/次 + 16,69 分/分钟。', fe: '移动电话费', ff: '移动电话费', fg: '移动电话费', fh: '移动电话费', fi: '移动电话费', Em: '004940547541222', En: '004686663370', Eo: '00372 6409808', Ep: '010 80 41 33', Eq: '00371 67099700', Er: '004686663370', fj: '00372 6409808', Es: '004686663370', Et: '004940547541222', Eu: '致电客服中心', fk: '未支付的预订将会自动取消。', fl: '支付出现问题，请重试或者致电客服。', fm: '请将当前的 <u>国家设置</u> 切换至您之前操作订单的国家页面，已确保支付完成。', fn: '当前预订是在官网其他国家市场的页面操作完成的。', Ex: '和 {points} 积分', r0: '人', EA: '人', EH: 'D-码头', EI: 'Frihamnen', EK: 'Kapellskär', EL: 'Långnäs码头', EM: '西码头 2号', EN: 'West terminal西码头', EO: '西码头', EP: '圣彼得堡', EQ: '玛丽港', ER: 'Muuga 码头', ES: '奥林匹亚码头', ET: 'Paldiski', EU: '里加码头', EV: 'Sassnitz', EW: '图尔库码头', EY: 'Värtahamnen码头', EZ: '维斯比', E_: 'Ventspils', E$: 'Vuosaari 码头', E5: '提前选购', E6: '确认预订', E7: '取消', E8: '继续', E9: '完成', fo: '下一步', Fa: '客舱最低价：', Fb: 'Club One会员客舱最低价：', Fc: 'Club One会员价', Fd: '请添加入住客舱', Fe: '添加客舱后将显示最终价格', fp: '选择客舱等级，继续下一步', Ff: '小计:', Fg: '总价：', fq: 'Club One会员价：', Fh: '查询价格...', Fj: '价格每位旅客/车辆起，已含排放和燃油附加费', Fl: '{price} / 件', sa: '继续', fr: '继续付款', Fs: '该网站受reCAPTCHA保护，并适用于谷歌的\r\n<a target=\"_blank\" href=\"https://policies.google.com/privacy\">隐私政策</a> 和\r\n<a target=\"_blank\" href=\"https://policies.google.com/terms\">服务条例</a> 。', ft: '航线信息更新：<br>\n周五至周六出发航班娱乐活动丰富，如，音乐会和bingo.<br>\n周日至周四出发航线减少相应服务。.', fu: '原价：', Fy: '请先删除当前已选择的时间段，再重新确认。', FA: 'Reservation fee {fee} will be deducted from the final bill.', FB: 'The reservation fee does not apply to children up to 5 years old.', sq: '关闭', FD: '出现错误，请刷新页面或者重新开始预订。', FE: '无法找到近期的出发航班', fv: '重新开始', fw: '很抱歉，您现有的预订将会自动取消。', fx: '您的操作已过期', FF: '重新开始', FG: '我们很抱歉，您需要重新开始预订。', FH: '出现错误', fz: '里加', fA: '两晚夜宿游轮，日游克莱佩达。', fB: '单程或往返<br>每天出发，时间为17:00。', fC: '斯德哥尔摩-图尔库-图尔库-斯德哥尔摩(Kappellskär)', fD: '斯德哥尔摩(Kappellskär)-图尔库', fE: '斯德哥尔摩(Kappellskär)-图尔库-图尔库-斯德哥尔摩', fF: '图尔库-斯德哥尔摩-斯德哥尔摩(Kappellskär)-图尔库', fG: '图尔库-斯德哥尔摩(Kappellskär)', fH: '图尔库-斯德哥尔摩(Kappellskär)-斯德哥尔摩-图尔库', fI: '返回列表', fJ: '很遗憾我们没有找到您搜索的银行。请在列表中查询。', fK: '搜索', fL: 'Sassnitz', fN: '请至少选择一种类型车辆。', Ge: 'Adding a car <b>will remove {service}</b> service. You sure you want to proceed?', Gf: 'Are you sure?', Gv: '五小时专线游轮', Gw: '每天有多个航班从赫尔辛基出发。全程历时5小时，在塔林无下船时间。若您在游轮上的消费金额超过一定额度，还将获得多种优惠。\n若您计划在游轮上消费较大的额度，建议您驾车登船。在Megastar游轮上，您可以随时通过甲板7层的Traveller Superstore商店前往停车库。在Star游轮上，汽车将停靠在汽车甲板。', Gy: '此回程被设定为五小时专线。您将前往合适的页面。', fO: '宠爱自己的美妙时光', GE: '显示餐桌预定', fP: 'Saaremaa岛', GK: 'As a 15-17 year old you can travel without being accompanied by an adult. Remember to bring your <a target=\"_blank\" href=\"https://ee.tallink.com/documents/10192/65371006/Permission_to_travel_alone_15_17_EN.pdf\">travel permit</a> with you. Safe travels!', fQ: '圣彼得堡', GQ: '前餐', fR: '斯德哥尔摩', GY: '购买斯德哥尔摩-赫尔辛基', GZ: '选定日期没有从斯德哥尔摩到塔林的直达航班，但您可以经赫尔辛基旅行并从那里乘船。', G_: '重要提示！您需要从奥林匹亚航站楼转乘到西航站楼 2 才能换乘船只。', G$: '斯德哥尔摩 -> 塔林 <br/> 经赫尔辛基', fS: '请注意，限时提供含酒精饮料。', fT: '两晚夜宿游轮，一日游玩维斯比！这个夏天，诗丽雅交响曲号（Silja Symphony）将执行特殊的专线游轮，往返于斯德哥尔摩和维斯比之间。', fU: '两晚夜宿游轮，两日游玩维斯比 - 多一晚入住游轮（停靠在维斯比），两日游玩哥特兰岛。在造访这个梦幻古城的同时，您还可以专享独家的游轮免税购物。', fV: '斯德哥尔摩（Kappellskär）', fW: 'Three nights at sea, one day in Ystad and one day in Visby.', fX: '额外费用', fY: '塔林', G8: 'Tallinn - Baltic Sea', fZ: 'Tallinn - Baltic Sea - Tallinn', f_: '两晚夜宿游轮，日游里加。', G9: '购买塔林-赫尔辛基', Ha: '选定日期没有从塔林到斯德哥尔摩的直达航班，但您可以经赫尔辛基旅行并从那里乘船。', Hb: '重要提示！您需要从西航站楼 2 转乘到奥林匹亚航站楼才能换乘船只。<b>如果您选择 13:30 出发，您可能没有足够的时间使用公共交通工具进行换乘。</b>', Hc: '塔林 -> 斯德哥尔摩 <br/> 经赫尔辛基', f$: '两晚夜宿游轮<br>一日游玩图尔库。', f0: '单程或往返。<br>每天从图尔库出发。', f1: 'タリンからのヴィスビュークルーズ', f2: 'Summer special cruises to the magical Gotland island', tb: '感谢提供信息', td: '添加回程', f3: '预订回程，专享更多至30%的优惠！', f4: '您的去程和回程在同一天，请查询一日游优惠价格。', o6: '到达', f5: '查询稍后的出发日期？', f6: '选择日期 {direction}', f7: '重设', Hx: '选择日期', f8: '23小时巡游（夜船）', f9: '23小时巡游（日船）', ga: '斯德哥尔摩日游', gb: '图尔库日游', o7: '出发', Hy: '下午', Hz: '早上', te: '行程时间', tf: '小时', HA: 'Spend the first night onboard ship and leave as you wish between 8–11.', HB: 'First night on ship', HC: '如果您选择此出发航班，我们将无法为您提供游轮+酒店服务', HD: '如果您选择此回程航班，我们将无法为您提供游轮+酒店服务', HE: '转到最后可预订日期', HF: '仅选择游轮', HG: '已售罄', gc: '取消回程预订', gd: 'Megastar号五小时专线之旅', ge: '关闭', gf: '即刻回程航线包括乘客和车辆的五小时游轮折扣。 巡航期间没有下船。', gg: 'Megastar号五小时专线之旅', gh: '一晚夜宿豪华游轮，尽享塔林4小时之旅！', gi: '夜班船从斯德哥尔摩出发，无岸上游时间。', gj: '早班船从斯德哥尔摩出发，无岸上游时间。', gk: '两晚夜宿豪华游轮，尽享图尔库一日游！', gl: '夜班船从图尔库出发，无岸上游时间。', gm: '早班船从图尔库出发，无岸上游时间。', gn: '往返：赫尔辛基 - 斯德哥尔摩 - 赫尔辛基', go: '单程：赫尔辛基前往斯德哥尔摩', gp: '往返：赫尔辛基 - 塔林 - 赫尔辛基', gq: '塔林一日巡游', gr: '单程：赫尔辛基前往塔林', gs: 'Megastar号五小时专线之旅', gt: '往返：里加 - 斯德哥尔摩 - 里加', gu: '单程：里加前往斯德哥尔摩', gv: '往返：斯德哥尔摩 - 赫尔辛基 - 斯德哥尔摩', gw: '单程：斯德哥尔摩前往赫尔辛基', gx: '往返：斯德哥尔摩 - 里加 - 斯德哥尔摩', gy: '单程：斯德哥尔摩前往里加', gz: '往返：斯德哥尔摩 - 塔林 - 斯德哥尔摩', gA: '单程：斯德哥尔摩前往塔林', gB: '往返：斯德哥尔摩 - 图尔库 - 斯德哥尔摩', gC: '单程：斯德哥尔摩前往图尔库', gD: '往返：塔林 - 赫尔辛基 - 塔林', gE: '赫尔辛基一日巡游', gF: '单程：塔林前往赫尔辛基', gG: '往返：塔林 - 斯德哥尔摩 - 塔林', gH: '单程：塔林前往斯德哥尔摩', gI: '往返：图尔库 - 斯德哥尔摩 - 图尔库', gJ: '单程：图尔库前往斯德哥尔摩', HH: '含酒店', tg: '巡游', gK: '赫尔辛基一日巡游', gL: '塔林一日巡游', gM: '奥兰岛一日巡游', gN: '斯德哥尔摩一日巡游', gO: '塔林巡游之旅', gP: '9小时巡游', gQ: '斯德哥尔摩一日巡游', gR: 'Cruises', gS: '奥兰岛一日巡游', gT: '赫尔辛基巡游之旅', gU: '斯德哥尔摩一日巡游', gV: '22小时巡游', gW: 'Cruises', gX: 'Cruise two outwards', gY: '隐藏 &uarr;', gZ: '显示更多 &darr;', g_: '往返', le: '到达', g$: '成人乘客已添加至您的预订。每个预订至少需要一名成人乘客。', g0: '订单中的车库停车位已删除。Business Lounge商务贵宾区船票已包含优先车辆服务。', g1: 'Business Lounge商务贵宾区船票已包含优先车辆服务。', g2: '已选择等级的船票已售罄，请选择其他等级船票。', HP: '车牌号已预先输入', g3: '22h cruise takes you shopping onboard. You can also take a car on this cruise. When you spend at least 500 €, you get 30 € back, and when you spend at least 600 €, you get 40 € back. <a href=\"https://onliner.by\">Link</a>', g4: '当天出发日期的已选择巴士接送服务已售罄。', g5: '无法提供已选择的大巴接送服务，已删除', HQ: '您好，{name}！', g6: '使用Club One积分来支付该预订，您至少需要 {clubOnePoints}点积分。', g7: '上一名乘客的信息尚未填写完整，请确认您已填写所有选项。', g8: '由于互联网信号不稳定，无法保存该信息。请连接网络并重试。', g9: '乘客信息不完整，请填写所有选项并保存。', HR: '不包含所有乘客', HS: '每间客舱至少需要一位成人乘客入住', ha: '预订该用餐服务，请先删除之前已选择的选项。', HU: '每次搭乘大巴都需要一名成人乘客。', hb: '请检查您的网络连接并重试。', hc: '年龄分组已从\"{old}\" 更改至\"{new}\"。', hd: '一个客舱已移除，因为您已删除了一名乘客，但是每间客舱至少需要有一名成人入住。', he: '已将ClubOne会员添加至{name}！', hf: '乘客数已达到了每份预订可操作的乘客数上限。', hg: '新添加乘客的船上订餐已添加。', hh: '已删除乘客的船上订餐已清除。', hi: '一个车辆已移除，因为您已删除了一名乘客，但是每一个车辆至少需要有一名成人驾车预订。', hj: '重要提示！之前的乘客数已删除。该Muuga-Vuosaari航线，最多可预订5位乘客。', hk: '当天往返优惠已获取！', hl: '查询时刻表时，出现错误。', hm: '晚上入住游轮客舱', hn: '图尔库一日巡游优惠已添加！', ho: '斯德哥尔摩一日巡游优惠已添加！', HV: '斯德哥尔摩转乘等待时间较长。', hp: '您已添加了最后剩余的客舱\"{name}\"', hq: '每间客舱至少需要一位成人乘客入住', hr: '客舱等级 \"{name}\"已售罄。', hs: '最后一个车位已预订。', ht: '无法添加更多的车辆。每位成人只允许预订一个车位。', hu: '车辆不允许在塔林下船。', hv: '只有去程还有剩余车位。', hw: '只有回程还有剩余车位。', hx: '已选择的车辆无法在该出发航班上预订车位。', hy: '添加宠物', hz: '过敏体质', hA: '宠物笼', hB: '宠物笼', hC: '残障人士', hD: '客舱', hE: '客舱', hF: '每间客舱至少需要一位成人乘客入住', H1: '已售罄', hG: '只剩 {capacity}人客舱', hH: '只剩 {capacity}人客舱，可入住 {from}-{to}人', hI: '携带宠物登船', hJ: '阅读更多', hK: '拼舱床位', hL: '女士拼舱床位', hM: '男士拼舱床位', hN: '{name}, {genderPlace}  {maxOccupancy} 人客舱', hO: '{price} / 客舱', tm: '{price} / 人', hP: '船票等级', hQ: '专用客舱', H2: '客舱', hR: '宠物', hS: '宠物', hT: '携带宠物', hU: '两晚夜宿诗丽雅交响曲号(Silja Symphony)或小夜曲号(Silja Serenade) 豪华游轮。6小时斯德哥尔摩岸上游览时间，往返搭乘同一游轮，入住同一客舱，总行程时间为40小时。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', hV: '22小时迷你游轮之旅，体验全新的欧罗巴号(Europa)游轮！每天从赫尔辛基出发前往塔林，时间为18:30。\r\n次日有4小时的塔林岸上游览时间：08:00 -12:10。', hW: '两晚夜宿罗曼蒂克号(Romantika)或伊莎贝拉号(Isabelle) 豪华游轮。6小时斯德哥尔摩岸上游览时间，往返搭乘同一游轮，入住同一客舱，总行程时间为40小时。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', hX: '从斯德哥尔摩出发，时间为07:10。搭乘波罗的海公主号(Baltic Princess)游轮前往奥兰岛，并在奥兰岛更换至银河号(Galaxy)游轮返回斯德哥尔摩，到达时间为18:15。', hY: '两晚夜宿诗丽雅交响曲号(Silja Symphony)或小夜曲号(Silja Serenade) 豪华游轮。7小时赫尔辛基岸上游览时间，往返搭乘同一游轮，入住同一客舱，总行程时间为40小时。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', hZ: '两晚夜宿罗曼蒂克号(Romantika)或伊莎贝拉号(Isabelle) 豪华游轮。6小时里加岸上游览时间，往返搭乘同一游轮，入住同一客舱，总行程时间为40小时。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', h_: '两晚夜宿波罗的海女王号(Baltic Queen)或维多利亚号(Victoria I) 豪华游轮。7小时塔林岸上游览时间，往返搭乘同一游轮，入住同一客舱，总行程时间为40小时。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物、体验北欧式桑拿以及品尝来自世界各地的美食盛宴。', h$: '从斯德哥尔摩出发，时间为19:30。夜宿游轮银河号(Galaxy)，无图尔库岸上游览时间，次日返回斯德哥尔摩。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', h0: '两晚夜宿波罗的海女王号(Baltic Queen)或维多利亚号(Victoria I) 豪华游轮。7小时斯德哥尔摩岸上游览时间，往返搭乘同一游轮，入住同一客舱，总行程时间为40小时。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物、体验北欧式桑拿以及品尝来自世界各地的美食盛宴。', h1: '从图尔库出发，时间为08:15。搭乘银河号(Galaxy)游轮前往奥兰岛，并在奥兰岛更换至波罗的海公主号(Baltic Princess)游轮返回图尔库，到达时间为19:15。', h2: '从图尔库出发，时间为20:15。夜宿游轮波罗的海公主号(Baltic Princess)，无斯德哥尔摩岸上游览时间，次日返回图尔库。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', h3: '搭乘诗丽雅小夜曲号(Silja Serenade)或诗丽雅交响曲号(Silja Symphony)游轮前往奥兰岛。', h4: '夜宿诗丽雅交响曲号(Silja Symphony)或小夜曲号(Silja Serenade) 豪华游轮，次日早上抵达斯德哥尔摩。可预订单程或往返。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', h5: '每天多次出发航班。星际号(Star)和浩瀚星际号(Megastar)的航行时间为2小时，欧罗巴号(Victoria I)的航行时间为3.5小时，让您的渡轮体验更舒适、更便捷。', h6: '搭乘塔林客穿梭渡轮：星际号(Star)和浩瀚星际号(Megastar)，更快速便捷的往返于赫尔辛基西码头T2和塔林之间。一年四季，每天出发，单程航行时间只需2小时。', h7: '赫尔辛基出发，每天2次航班：10:30 and 16:30。全程航行时间为5小时，无塔林下船时间。\r\n当您在游轮上购物数额较大时，您还可以获得一定的现金折扣券。若您打算在游轮上进行大量采购，我们建议您驾车登船，车辆可停放在位于甲板7层Traveller Superstore购物中心旁边的车库。', h8: '夜宿罗曼蒂克号(Romantika)或伊莎贝拉号(Isabelle) 豪华游轮，次日早上抵达斯德哥尔摩。可预订单程或往返。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', h9: '每天4次航班出发前往奥兰岛，搭乘游轮波罗的海公主号(Baltic Princess)、银河号(Galaxy)、诗丽雅小夜曲号(Silja Serenade)、诗丽雅交响曲号(Silja Symphony)、维多利亚号(Victoria I)以及波罗的海女王号(Baltic Queen)。', ia: '夜宿诗丽雅交响曲号(Silja Symphony)或小夜曲号(Silja Serenade) 豪华游轮，次日早上抵达赫尔辛基。可预订单程或往返。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', ib: '夜宿罗曼蒂克号(Romantika)或伊莎贝拉号(Isabelle) 豪华游轮，次日早上抵达里加。可预订单程或往返。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', ic: '夜宿波罗的海女王号(Baltic Queen)或维多利亚号(Victoria I) 豪华游轮，次日早上抵达塔林。可预订单程或往返。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物、体验北欧式桑拿以及品尝来自世界各地的美食盛宴。', id: '半天搭乘或夜宿游轮波罗的海公主号(Baltic Princess)或银河号(Galaxy)。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', ie: '搭乘维多利亚号(Victoria I)或波罗的海女王号(Baltic Queen)游轮前往奥兰岛。', $8: '每天多次航班，从塔林D码头出发。星际号(Star)和浩瀚星际号(Megastar)的航行时间为2小时，欧罗巴号(Victoria I)的航行时间为3.5小时，让您的渡轮体验更舒适、更便捷。', ig: '搭乘塔林客穿梭渡轮：星际号(Star)和浩瀚星际号(Megastar)，更快速便捷的往返于塔林D码头和赫尔辛基之间。一年四季，每天出发，单程航行时间只需2小时。', ih: '夜宿波罗的海女王号(Baltic Queen)或维多利亚号(Victoria I) 豪华游轮，次日早上抵达斯德哥尔摩。可预订单程或往返。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物、体验北欧式桑拿以及品尝来自世界各地的美食盛宴。', ii: '搭乘波罗的海公主号(Baltic Princess)或银河号(Galaxy)游轮前往奥兰岛。', ij: '半天搭乘或夜宿游轮波罗的海公主号(Baltic Princess)或银河号(Galaxy)。\n在波罗的海上观看精彩的娱乐表演、尽享免税购物以及品尝来自世界各地的美食盛宴。', ik: '两晚夜宿游轮，日游赫尔辛基', il: '两晚夜宿游轮，日游塔林', im: '两晚夜宿游轮，日游奥兰岛。', $9: '22小时游轮之旅前往中世纪古城塔林！<br>塔林岸上游览时间为4小时。', io: '海上放松小假期', ip: '11小时游轮之旅往返奥兰岛。<br>斯德哥尔摩出发时间为 07:10。', iq: '两晚夜宿游轮<br>岸上游览时间约7小时。', ir: '两晚夜宿游轮<br>岸上游览时间约6小时。', is: '两晚夜宿游轮<br>岸上游览时间约7小时。', it: '一晚夜宿游轮，无岸上游览时间。<br> 夜船出发游轮为银河号(Galaxy)。', iu: '尽享 Baltic Princess 号上的 23 小时邮轮之旅', iv: '11小时游轮之旅往返奥兰岛。<br>图尔库出发时间为 08:15。', iw: '一晚夜宿游轮，无岸上游览时间。<br> 夜船出发游轮为波罗的海公主号(Baltic Princess)。', ix: '尽享 Baltic Princess 号上的 23 小时邮轮之旅', iy: '一日游船，无岸上游览时间。<br>早上出发游轮为银河号(Galaxy)。', iz: '单程或往返<br>每天从奥兰岛和赫尔辛基出发。', iA: '单程或返程', iB: '单程或往返<br>每天从奥兰岛出发。', iC: '单程或往返<br>每天出发四班。', iD: '单程或往返<br>每天从奥兰岛和塔林出发。', iE: '单程或往返。', iF: '单程或往返<br>每天出发，时间为17:00。', iG: '单程或往返<br>赫尔辛基和斯德哥尔摩，每天出发一班。', iH: '当天往返，享受一日游优惠价格。<br>单程航行2小时。', iI: '单程或往返<br>单程航行2小时，欧罗巴号(Victoria I)游轮单程3.5小时。', iJ: '五小时购物专线游轮，可选择是否驾车登船。<br> 让您的游轮购物之旅更便捷、更优惠！', iK: '单程或返程', iL: '单程或返程', iM: '单程或往返，搭乘Sea Wind。<br> 每天出发两班。', iN: '单程或往返<br>每天从里加出发。', iO: '单程或往返<br>里加和斯德哥尔摩，每天出发一班。', iP: '单程或往返<br>斯德哥尔摩，每天出发四班。', iQ: '单程或往返<br>赫尔辛基和斯德哥尔摩，每天出发一班。', iR: '单程或往返<br>斯德哥尔摩和里加，每天出发一班。', iS: '单程或往返<br>斯德哥尔摩和塔林，每天出发一班。', iT: '单程或往返', iU: '单程或往返<br>每天出发，时间为18:00。', iV: '单程或往返<br>单程航行2小时，欧罗巴号(Victoria I)游轮单程3.5小时。', iW: '当天往返，享受一日游优惠价格。<br>单程航行2小时。', iX: '单程或往返<br>塔林和斯德哥尔摩，每天出发一班。', iY: '单程或往返<br>图尔库。', iZ: '单程或返程', i_: '单程或往返', i$: '单程或往返，搭乘Sea Wind。<br> 每天出发两班。', i0: '图尔库', i1: '两晚夜宿游轮，一日游玩塔林。', i2: '单程或往返。<br>每天从塔林出发。', H3: '两天', i3: '两晚夜宿游轮，两日游玩Härnösand -多一晚入住游轮(停靠在Härnösand)，两日游玩目的地。在游玩的同时，你还可以享受独家的游轮免税购物。', i4: '两晚夜宿游轮，两日游玩赫尔辛基—多一晚入住游轮（停靠在赫尔辛基），两天游玩芬兰。游玩的同时您还可以享受船上免税商品购物体验。', i5: '两晚夜宿游轮，日游奥兰岛。', i6: '两晚夜宿游轮，日游Härnösand岛', i7: '两晚夜宿豪华游轮，尽享赫尔辛基一日游！', i8: '两晚夜宿豪华游轮，尽享里加一日游！', i9: '两晚夜宿游轮，日游Saaremaa岛。', ja: '两晚夜宿豪华游轮，尽享斯德哥尔摩一日游！', jb: '两晚夜宿豪华游轮，尽享塔林一日游！', H7: '使用优惠代码', jc: '车辆排放附加费', jd: '车辆排放附加费适用于预订中指定的车辆。', Id: '燃油附加费和排放附加费', Ie: '车辆排放及燃油附加费适用于预订中指定的车辆。', je: '高至1.5米，长至3.0米', jf: '高至1.9米，长至5.0米', jg: '添加车库停车位，快捷通往Traveller Superstore购物中心 &rarr;', jh: '您是否希望在抵达目的地后优先驾车下船呢？添加优先车辆服务 &rarr;', ji: '高于2.4米，长至8.0米', jj: 'm', jk: '高至1.9米，长至5.0米\n抵达目的地后，车辆不可驶出游轮。', jl: '请输入所有车辆的车牌号码', Ii: '删除', jm: '从之前搭乘游轮的行程中选择车辆', jn: '高至2.3米，长至7.0米', jo: '高至1.9米，长至12米', jp: '拖车车牌号码', jq: '车牌号码应只包含数字和拉丁字符。', jr: '高至2.4米，长至7.0米', js: '车辆信息缺失', jt: '车牌号码', ju: '汽车已添加：', jv: '查询车位', Il: '经赫尔辛基旅行', jw: '维斯比', jx: 'Ystad/维斯比', jy: 'Ventspils', Ip: '优惠券：', Iq: '查看优惠券可用性，请使用您的Club One会员账户登入。', Ir: '很抱歉，该礼品券已添加。', Is: '很抱歉，该礼品券已逾期。', It: '很抱歉，该礼品券适用其他货币。', Iu: '很抱歉，该礼品券无可用余额。', jz: 'Vuosaari', IA: '巡游', IC: 'wow', tE: '日船', jA: 'Ystad'};
var $author$project$Translations$forLanguage = function (language) {
	switch (language) {
		case 0:
			return $author$project$Translations$Generated$en;
		case 1:
			return $author$project$Translations$Generated$et;
		case 2:
			return $author$project$Translations$Generated$fi;
		case 3:
			return $author$project$Translations$Generated$lv;
		case 4:
			return $author$project$Translations$Generated$sv;
		case 5:
			return $author$project$Translations$Generated$ru;
		case 6:
			return $author$project$Translations$Generated$zh;
		case 7:
			return $author$project$Translations$Generated$ja;
		case 8:
			return $author$project$Translations$Generated$de;
		default:
			return $author$project$Translations$Generated$ko;
	}
};
var $author$project$Types$CabinSurprise$getCabinSurprisesPerTravelClass = F2(
	function (travelClassCode, cabinSurprises) {
		return {
			DC: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, travelClassCode, cabinSurprises.DC)),
			FV: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, travelClassCode, cabinSurprises.FV))
		};
	});
var $author$project$Types$CabinSurprise$getCabinSurprisesAvailabilityFlags = F2(
	function (_v0, travelClassCode) {
		var cabinSurprises = _v0.pD;
		return {
			zo: !$elm$core$List$isEmpty(
				A2(
					$author$project$Types$CabinSurprise$getCabinSurprisesPerTravelClass,
					travelClassCode,
					A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Types$CabinSurprise$defaultSurprises, cabinSurprises)).DC),
			zq: !$elm$core$List$isEmpty(
				A2(
					$author$project$Types$CabinSurprise$getCabinSurprisesPerTravelClass,
					travelClassCode,
					A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Types$CabinSurprise$defaultSurprises, cabinSurprises)).FV)
		};
	});
var $author$project$Update$getCruiseMultiDepartureTrips = F2(
	function (time, model) {
		var session = model.j;
		var page = function () {
			var _v0 = model.DF;
			if (_v0.$ === 1) {
				var pageModel = _v0.a;
				return $author$project$Model$Timetable(
					function (a) {
						return _Utils_update(
							a,
							{
								oP: $elm$core$Maybe$Just(time)
							});
					}(pageModel));
			} else {
				return model.DF;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					DF: page,
					j: _Utils_update(
						session,
						{
							pr: false,
							Ad: false,
							Af: true,
							B7: $elm$core$Maybe$Nothing,
							B8: $elm$core$Maybe$Nothing,
							tp: $author$project$Types$Trips$Loading(
								$author$project$Types$Trips$statusToMaybe(session.tp))
						})
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$GotCruiseMultiDepartureTrips,
				A2(
					$author$project$Types$CruiseMultiDepartureTrips$fetch,
					$author$project$Types$Date$fromPosix(time),
					session)));
	});
var $author$project$Api$Timetable$getCruiseSailFromDate = F2(
	function (model, dateFrom) {
		return A6(
			$author$project$Api$Timetable$createCruiseSailsRequest,
			model.j.zM,
			model.j,
			dateFrom,
			2,
			$elm$core$Maybe$Nothing,
			$author$project$Messages$GotTrips(
				$author$project$Update$RequestTimes$create(dateFrom)));
	});
var $author$project$PassengerDetailsPage$Update$getLastErrors = F3(
	function (translations, newModel, oldModel) {
		var loginError = _Utils_eq(newModel.rf, oldModel.rf) ? $elm$core$Maybe$Nothing : newModel.rf;
		return _Utils_Tuple2(
			function () {
				if (!_Utils_eq(loginError, $elm$core$Maybe$Nothing)) {
					return $elm$core$Maybe$Just(translations.DS);
				} else {
					if (_Utils_eq(newModel.rr, oldModel.rr)) {
						return $elm$core$Maybe$Nothing;
					} else {
						var _v0 = newModel.rr;
						_v0$8:
						while (true) {
							if (!_v0.$) {
								switch (_v0.a.$) {
									case 4:
										var _v1 = _v0.a;
										return $elm$core$Maybe$Just(translations.DU);
									case 2:
										switch (_v0.a.a.$) {
											case 0:
												return $elm$core$Maybe$Just(translations.DP);
											case 3:
												return $elm$core$Maybe$Just(translations.DP);
											case 6:
												return $elm$core$Maybe$Just(translations.DP);
											default:
												return $elm$core$Maybe$Just(translations.DO);
										}
									case 3:
										switch (_v0.a.a.$) {
											case 5:
												var _v2 = _v0.a.a;
												return $elm$core$Maybe$Just(translations.DM);
											case 6:
												var _v3 = _v0.a.a;
												return $elm$core$Maybe$Just(translations.DM);
											default:
												break _v0$8;
										}
									case 0:
										return $elm$core$Maybe$Just(translations.wX);
									default:
										break _v0$8;
								}
							} else {
								break _v0$8;
							}
						}
						return $elm$core$Maybe$Nothing;
					}
				}
			}(),
			loginError);
	});
var $author$project$Types$SelectedOnboardServices$getSelectedOnboardServicesCodes = function (_v0) {
	var selected = _v0;
	var codesInDict = function (dict) {
		return $elm$core$Dict$keys(dict);
	};
	return _Utils_ap(
		codesInDict(selected.DC),
		_Utils_ap(
			codesInDict(selected.FV),
			_Utils_ap(
				codesInDict(selected.ke),
				_Utils_ap(
					codesInDict(selected.kj),
					_Utils_ap(
						codesInDict(selected.jO),
						_Utils_ap(
							codesInDict(selected.jT),
							_Utils_ap(
								codesInDict(selected.eV),
								_Utils_ap(
									codesInDict(selected.fy),
									_Utils_ap(
										codesInDict(selected.eW),
										_Utils_ap(
											codesInDict(selected.N),
											_Utils_ap(
												codesInDict(selected.kf),
												_Utils_ap(
													codesInDict(selected.kk),
													_Utils_ap(
														codesInDict(selected.G5),
														codesInDict(selected.y))))))))))))));
};
var $author$project$Types$SelectedOnboardServices$getMaybeFirstSelectedVehicleIncompatibleOnboardService = F2(
	function (incompatibleServices, selected) {
		var selectedCodes = $author$project$Types$SelectedOnboardServices$getSelectedOnboardServicesCodes(selected);
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v0) {
				var code = _v0.pQ;
				return A2($elm$core$List$member, code, selectedCodes);
			},
			incompatibleServices);
	});
var $author$project$Update$getModalTypeFromUrl = function (url) {
	return $author$project$UrlRoute$bookingParamsFromLocation(url).CC;
};
var $author$project$Update$addIfNotSelected = F3(
	function (travelClass, code, currentSelected) {
		var selected = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, travelClass, currentSelected));
		return A2($elm$core$List$member, code, selected) ? currentSelected : A3(
			$elm$core$Dict$update,
			travelClass,
			function (_v0) {
				return $elm$core$Maybe$Just(
					A2($elm$core$List$cons, code, selected));
			},
			currentSelected);
	});
var $author$project$Update$findCabinSurprise = F2(
	function (code, availableSurprises) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var travelClass = _v0.a;
					var surprises = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (cs) {
							return _Utils_Tuple2(travelClass, cs);
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (cs) {
								return _Utils_eq(
									$elm$core$String$toUpper(cs.pQ),
									$elm$core$String$toUpper(code)) && (cs.uk > 0);
							},
							surprises));
				},
				$elm$core$Dict$toList(availableSurprises)));
	});
var $author$project$Update$addCabinSurpriseFromBookingParamsIfNeeded = F4(
	function (isFirstLoad, bookingParams, availableCabinSurprises, currentSelected) {
		return (!isFirstLoad) ? currentSelected : A2(
			$elm$core$Maybe$withDefault,
			currentSelected,
			A2(
				$elm$core$Maybe$andThen,
				function (code) {
					return A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var travelClass = _v0.a;
							var surprise = _v0.b;
							return A3($author$project$Update$addIfNotSelected, travelClass, surprise.pQ, currentSelected);
						},
						A2(
							$author$project$Update$findCabinSurprise,
							$elm$core$String$toUpper(code),
							availableCabinSurprises));
				},
				bookingParams.l8));
	});
var $author$project$Update$removeUnavailableCabinSurprises = F2(
	function (selectedCabinSurprises, cabinSurprises) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (travelClassCode, selectedSurpriseCodes, selectedSurprises) {
					return function (availableSurprises) {
						return $elm$core$List$isEmpty(availableSurprises) ? selectedSurprises : A3($elm$core$Dict$insert, travelClassCode, availableSurprises, selectedSurprises);
					}(
						A3(
							$elm$core$List$foldl,
							F2(
								function (surpriseCode, availableSurprises) {
									var limit = A2(
										$elm$core$Maybe$withDefault,
										0,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.uk;
											},
											A2(
												$elm_community$list_extra$List$Extra$find,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.pQ;
													},
													$elm$core$Basics$eq(surpriseCode)),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2($elm$core$Dict$get, travelClassCode, cabinSurprises)))));
									var count = A2(
										$elm_community$list_extra$List$Extra$count,
										$elm$core$Basics$eq(surpriseCode),
										availableSurprises);
									return (_Utils_cmp(count, limit) < 0) ? _Utils_ap(
										availableSurprises,
										_List_fromArray(
											[surpriseCode])) : availableSurprises;
								}),
							_List_Nil,
							selectedSurpriseCodes));
				}),
			$elm$core$Dict$empty,
			selectedCabinSurprises);
	});
var $author$project$Update$getSelectedCabinSurpises = F4(
	function (isFirstLoad, selectedCabinSurprises, bookingParams, cabinSurprises) {
		return {
			DC: A4(
				$author$project$Update$addCabinSurpriseFromBookingParamsIfNeeded,
				isFirstLoad,
				bookingParams,
				cabinSurprises.DC,
				A2($author$project$Update$removeUnavailableCabinSurprises, selectedCabinSurprises.DC, cabinSurprises.DC)),
			FV: A4(
				$author$project$Update$addCabinSurpriseFromBookingParamsIfNeeded,
				isFirstLoad,
				bookingParams,
				cabinSurprises.FV,
				A2($author$project$Update$removeUnavailableCabinSurprises, selectedCabinSurprises.FV, cabinSurprises.FV))
		};
	});
var $author$project$Common$Ports$goBack = _Platform_outgoingPort(
	'goBack',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Api$Util$adultParam = function (adultsCount) {
	return _Utils_Tuple2(
		'adults',
		$elm$core$String$fromInt(adultsCount));
};
var $author$project$UrlRoute$buildUrl = F2(
	function (defaultValue, parameters) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, params) {
					var key = _v0.a;
					var value = _v0.b;
					return params + ('&' + (key + ('=' + value)));
				}),
			defaultValue,
			parameters);
	});
var $author$project$Api$Util$childrenParam = function (chieldsCount) {
	return _Utils_Tuple2(
		'children',
		$elm$core$String$fromInt(chieldsCount));
};
var $author$project$Types$TravelClasses$oneWaySelection = function (_v0) {
	var selected = _v0.Gg;
	return selected;
};
var $author$project$Types$TravelClasses$twoWaySelection = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return {Ds: outward, FL: _return};
};
var $author$project$BookingPage$BackToDesktop$Update$getTravelClassUrlParams = F3(
	function (passengers, voyageType, travelClasses) {
		var passengersAmount = $elm$core$String$fromInt(
			$elm$core$Array$length(passengers));
		switch (travelClasses.$) {
			case 0:
				var oneWay = travelClasses.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'travelClass',
						$author$project$Types$TravelClasses$oneWaySelection(oneWay)),
						_Utils_Tuple2('travelClassAmount', passengersAmount)
					]);
			case 1:
				var twoWay = travelClasses.a;
				var _return = $author$project$Types$TravelClasses$twoWaySelection(twoWay).FL;
				var outward = $author$project$Types$TravelClasses$twoWaySelection(twoWay).Ds;
				return _Utils_eq(outward, _return) ? _List_fromArray(
					[
						_Utils_Tuple2('travelClass', outward),
						_Utils_Tuple2('travelClassAmount', passengersAmount)
					]) : _List_Nil;
			case 2:
				var oneWay = travelClasses.a;
				return (($elm$core$List$length(
					$author$project$Types$TravelClasses$oneWaySelection(oneWay)) === 1) && _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise)) ? A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var code = _v1.a;
							var count = _v1.b;
							return _List_fromArray(
								[
									_Utils_Tuple2('travelClass', code),
									_Utils_Tuple2(
									'travelClassAmount',
									$elm$core$String$fromInt(count))
								]);
						},
						$elm$core$List$head(
							$author$project$Types$TravelClasses$oneWaySelection(oneWay)))) : _List_Nil;
			default:
				return _List_Nil;
		}
	});
var $author$project$Api$Util$juniorParam = function (juniorsCount) {
	return _Utils_Tuple2(
		'juniors',
		$elm$core$String$fromInt(juniorsCount));
};
var $author$project$Api$Util$withVehicleParam = function (withVehicle) {
	return _Utils_Tuple2(
		'withVehicle',
		$author$project$Utils$String$fromBool(withVehicle));
};
var $author$project$Api$Util$youthParam = function (youthsCount) {
	return _Utils_Tuple2(
		'youths',
		$elm$core$String$fromInt(youthsCount));
};
var $author$project$BookingPage$BackToDesktop$Update$getBackToDesktopParams = function (model) {
	var _v0 = model;
	var session = _v0.j;
	var _v1 = $author$project$Common$Passengers$passengerCount(
		A3(
			$elm$core$Array$foldl,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tY;
				},
				$elm$core$List$cons),
			_List_Nil,
			session.Eg));
	var adult = _v1.tV;
	var junior = _v1.AI;
	var youth = _v1.IF;
	var child = _v1.vU;
	return A2(
		$author$project$UrlRoute$buildUrl,
		'batman=true',
		A3(
			$author$project$Utils$List$addIf,
			$author$project$Utils$Route$areMorningAndEveningCruisesAvailable(session),
			_Utils_Tuple2(
				'eveningDeparture',
				$author$project$Utils$String$fromBool(session.mm === 1)),
			A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$author$project$Api$Util$voucherIdParam),
					$elm$core$List$head(session.tw)),
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Types$Trips$selectedDepartureAndArrivalTimes,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Utils$Time$toDateString,
									function (b) {
										return _Utils_Tuple2('date', b);
									}))),
						$author$project$Types$Trips$statusToMaybe(model.j.tp)),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Api$Util$adultParam(adult),
								$author$project$Api$Util$childrenParam(child),
								$author$project$Api$Util$juniorParam(junior),
								$author$project$Api$Util$youthParam(youth),
								$author$project$Api$Util$localeParam(session.A_),
								$author$project$Api$Util$marketParam(session.rb),
								$author$project$Api$Util$fromParam(session.kS),
								$author$project$Api$Util$toParam(session.le),
								A2($author$project$Api$Util$voyageTypeParam, session.vk, session.tx),
								$author$project$Api$Util$withVehicleParam(
								!$elm$core$List$isEmpty(session.yq)),
								$author$project$Api$Util$guidParam(model.j.zM.Gt)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($author$project$BookingPage$BackToDesktop$Update$getTravelClassUrlParams, session.Eg, session.tx),
								session.to)))))));
};
var $author$project$BookingPage$BackToDesktop$Update$goBackToDesktopCmd = function (model) {
	return $elm$browser$Browser$Navigation$load(
		model.j.zM.Gs.d + ('?' + $author$project$BookingPage$BackToDesktop$Update$getBackToDesktopParams(model)));
};
var $author$project$Ports$goToSignInPage = _Platform_outgoingPort(
	'goToSignInPage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Update$User$removeUserData = function (model) {
	var paymentPage = model.Ew;
	return A2(
		$author$project$Update$User$updateUser,
		{v4: $krisajenkins$remotedata$RemoteData$NotAsked, Cb: $elm$core$Maybe$Nothing},
		model);
};
var $author$project$Update$User$goToSignInPage = function (model) {
	return _Utils_Tuple2(
		$author$project$Update$User$removeUserData(
			_Utils_update(
				model,
				{
					j: function (a) {
						return _Utils_update(
							a,
							{zn: true});
					}(model.j)
				})),
		$author$project$Ports$goToSignInPage(0));
};
var $author$project$Types$OnboardServices$init = {vz: _List_Nil, x5: _List_Nil, yv: _List_Nil, y9: _List_Nil, AL: _List_Nil, BI: _List_Nil, B3: $elm$core$Maybe$Nothing, Fm: _List_Nil, Ig: _List_Nil};
var $author$project$Types$SelectedOnboardServices$SelectedOnboardServices = $elm$core$Basics$identity;
var $author$project$Types$SelectedOnboardServices$init = {y: $elm$core$Dict$empty, jO: $elm$core$Dict$empty, ke: $elm$core$Dict$empty, eV: $elm$core$Dict$empty, kf: $elm$core$Dict$empty, eW: $elm$core$Dict$empty, DC: $elm$core$Dict$empty, jT: $elm$core$Dict$empty, kj: $elm$core$Dict$empty, fy: $elm$core$Dict$empty, kk: $elm$core$Dict$empty, N: $elm$core$Dict$empty, FV: $elm$core$Dict$empty, G5: $elm$core$Dict$empty};
var $author$project$Update$gotOnboardServicesFailure = F2(
	function (error, model) {
		var session = model.j;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: _Utils_update(
						session,
						{rI: $author$project$Types$OnboardServices$init, Gm: $author$project$Types$SelectedOnboardServices$init})
				}),
			A2($author$project$Tracking$logHttpError, 'onboardingServicesDataResponse', error));
	});
var $author$project$Types$OnboardServices$Info$isInfoAvailable = function (info) {
	if (!info.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Types$SelectedOnboardServices$removeUnavailableBubbleFairServices = F2(
	function (availableBubbleFairServices, _v0) {
		var selected = _v0;
		var isAvailable = F2(
			function (code, toInfo) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, toInfo, $author$project$Types$OnboardServices$Info$isInfoAvailable),
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pQ;
								},
								$elm$core$Basics$eq(code)),
							availableBubbleFairServices)));
			});
		return _Utils_update(
			selected,
			{
				jO: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v1, _v2) {
							var code = _v2.a;
							return A2(
								isAvailable,
								code,
								function ($) {
									return $.rQ;
								});
						}),
					selected.jO),
				jT: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v3, _v4) {
							var code = _v4.a;
							return A2(
								isAvailable,
								code,
								function ($) {
									return $.su;
								});
						}),
					selected.jT)
			});
	});
var $author$project$Types$OnboardServices$InfoWithAddons$toMaybeAddons = function (infoWithAddons) {
	if (!infoWithAddons.$) {
		var addons = infoWithAddons.a;
		return $elm$core$Maybe$Just(addons);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$SelectedOnboardServices$removeUnavailableFriendshipBracelets = F2(
	function (availableFriendshipBracelets, _v0) {
		var selected = _v0;
		var isAvailable = F2(
			function (addon, toInfoWithAddons) {
				return A2(
					$elm$core$List$any,
					function (a) {
						return _Utils_eq(a, addon);
					},
					A2(
						$elm$core$List$concatMap,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Types$OnboardServices$InfoWithAddons$toMaybeAddons,
							$elm$core$Maybe$withDefault(_List_Nil)),
						A2($elm$core$List$map, toInfoWithAddons, availableFriendshipBracelets)));
			});
		return _Utils_update(
			selected,
			{
				eV: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v1, _v2) {
							var addon = _v2.a;
							return A2(
								isAvailable,
								addon,
								function ($) {
									return $.rQ;
								});
						}),
					selected.eV),
				fy: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v3, _v4) {
							var addon = _v4.a;
							return A2(
								isAvailable,
								addon,
								function ($) {
									return $.su;
								});
						}),
					selected.fy)
			});
	});
var $author$project$Types$SelectedOnboardServices$hasPassengerWithAgeCategory = F2(
	function (passengerList, ageCategory) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tY;
				},
				$elm$core$Basics$eq(ageCategory)),
			passengerList);
	});
var $author$project$Types$SelectedOnboardServices$removeUnavailableKidBracelets = F3(
	function (passengers, services, _v0) {
		var selected = _v0;
		var isWithCodeAndAvailable = F3(
			function (code, toInfo, service) {
				return (_Utils_eq(service.pQ, code) && (!_Utils_eq(
					toInfo(service),
					$author$project$Types$OnboardServices$Info$Unavailable))) && A2($author$project$Types$SelectedOnboardServices$hasPassengerWithAgeCategory, passengers, service.tY);
			});
		var filterSelectedServices = function (toInfo) {
			return $elm$core$Dict$filter(
				F2(
					function (_v2, _v3) {
						var code = _v3.pQ;
						return A2(
							$elm$core$List$any,
							A2(isWithCodeAndAvailable, code, toInfo),
							services);
					}));
		};
		var _v1 = selected;
		var outwards = _v1.DC;
		var returns = _v1.FV;
		return _Utils_update(
			selected,
			{
				DC: A2(
					filterSelectedServices,
					function ($) {
						return $.rQ;
					},
					outwards),
				FV: A2(
					filterSelectedServices,
					function ($) {
						return $.su;
					},
					returns)
			});
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Types$SelectedOnboardServices$removeUnavailableMassages = F2(
	function (availableMassages, _v0) {
		var selected = _v0;
		return _Utils_update(
			selected,
			{
				y: A2(
					$elm$core$Dict$map,
					F2(
						function (code, timeSlots) {
							return A2(
								$elm$core$List$filter,
								function (timeSlot) {
									return A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.mY;
												},
												$elm$core$List$member(timeSlot)),
											A2(
												$elm_community$list_extra$List$Extra$find,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.pQ;
													},
													$elm$core$Basics$eq(code)),
												availableMassages)));
								},
								timeSlots);
						}),
					A2(
						$elm$core$Dict$filter,
						F2(
							function (code, _v1) {
								return A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$always(true),
										A2(
											$elm_community$list_extra$List$Extra$find,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pQ;
												},
												$elm$core$Basics$eq(code)),
											availableMassages)));
							}),
						selected.y))
			});
	});
var $author$project$Types$SelectedOnboardServices$couponsFromShipMoney = function (shipMoney) {
	var _v0 = shipMoney.x3;
	if (!_v0.$) {
		var a = _v0.a;
		return _Utils_Tuple2(
			A2($elm$core$List$cons, a.nx, a.lH),
			_List_Nil);
	} else {
		var outward = _v0.a.Ds;
		var _return = _v0.a.FL;
		return _Utils_Tuple2(
			A2($elm$core$List$cons, outward.nx, outward.lH),
			A2($elm$core$List$cons, _return.nx, _return.lH));
	}
};
var $author$project$Types$SelectedOnboardServices$removeUnavailableShipMoney = F2(
	function (maybeShipMoney, _v0) {
		var selected = _v0;
		var filterSelectedServices = function (coupons) {
			return $elm$core$Dict$filter(
				F2(
					function (_v2, _v3) {
						var code = _v3.a;
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pQ;
								},
								$elm$core$Basics$eq(code)),
							coupons);
					}));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_update(
				selected,
				{eW: $elm$core$Dict$empty, N: $elm$core$Dict$empty}),
			A2(
				$elm$core$Maybe$map,
				function (shipMoney) {
					var _v1 = $author$project$Types$SelectedOnboardServices$couponsFromShipMoney(shipMoney);
					var outwards = _v1.a;
					var returns = _v1.b;
					return _Utils_update(
						selected,
						{
							eW: A2(filterSelectedServices, outwards, selected.eW),
							N: A2(filterSelectedServices, returns, selected.N)
						});
				},
				maybeShipMoney));
	});
var $author$project$Types$SelectedOnboardServices$removeUnavailableTableReservations = F2(
	function (dinings, _v0) {
		var selected = _v0;
		var allAvailable = A2(
			$elm$core$List$concatMap,
			function (_v2) {
				var code = _v2.pQ;
				var outwardServices = _v2.ot;
				var returnServices = _v2.oL;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v3) {
							var beginTime = _v3.nd;
							return _Utils_Tuple2(code, beginTime);
						},
						outwardServices),
					A2(
						$elm$core$List$map,
						function (_v4) {
							var beginTime = _v4.nd;
							return _Utils_Tuple2(code, beginTime);
						},
						returnServices));
			},
			dinings);
		var reservations = A2(
			$elm$core$Dict$filter,
			F2(
				function (_v1, v) {
					return A2($elm$core$List$member, v, allAvailable);
				}),
			selected.G5);
		return _Utils_update(
			selected,
			{G5: reservations});
	});
var $author$project$Update$gotOnboardServicesSuccess = F2(
	function (services, model) {
		var session = model.j;
		var selectedOnboardServices = A2(
			$author$project$Types$SelectedOnboardServices$removeUnavailableFriendshipBracelets,
			services.y9,
			A2(
				$author$project$Types$SelectedOnboardServices$removeUnavailableBubbleFairServices,
				services.vz,
				A2(
					$author$project$Types$SelectedOnboardServices$removeUnavailableMassages,
					services.BI,
					A2(
						$author$project$Types$SelectedOnboardServices$removeUnavailableTableReservations,
						services.yv,
						A2(
							$author$project$Types$SelectedOnboardServices$removeUnavailableShipMoney,
							services.B3,
							A3(
								$author$project$Types$SelectedOnboardServices$removeUnavailableKidBracelets,
								$elm$core$Array$toList(session.Eg),
								services.AL,
								session.Gm))))));
		var newSession = _Utils_update(
			session,
			{rI: services, Gm: selectedOnboardServices});
		return _Utils_update(
			model,
			{j: newSession});
	});
var $author$project$Update$gotOnboardServices = F2(
	function (model, result) {
		if (!result.$) {
			var onboardServices = result.a;
			return _Utils_Tuple2(
				A2($author$project$Update$gotOnboardServicesSuccess, onboardServices, model),
				$elm$core$Platform$Cmd$none);
		} else {
			var error = result.a;
			return A2($author$project$Update$gotOnboardServicesFailure, error, model);
		}
	});
var $author$project$Types$Trips$CruiseMultiDeparture = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Trips$Failure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Trips$Success = function (a) {
	return {$: 0, a: a};
};
var $author$project$Messages$GotMealPackages = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$MealPackage$Included = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$MealPackage$Regular = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$VoyageType$RegularCruise = 0;
var $author$project$Types$MealPackage$Code = $elm$core$Basics$identity;
var $author$project$Types$MealPackage$MealPackage = F7(
	function (code, description, name, price, breakfasts, lunches, buffets) {
		return {vv: breakfasts, vA: buffets, pQ: code, nt: description, BA: lunches, oh: name, lN: price};
	});
var $author$project$Types$MealPackage$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['defaultSelection', 'buffets']),
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['defaultSelection', 'lunches']),
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['defaultSelection', 'breakfasts']),
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Types$MealPackage$MealPackage))))))));
var $author$project$Types$MealPackage$IncludedMealPackage = F4(
	function (code, description, name, imageUrl) {
		return {pQ: code, nt: description, zP: imageUrl, oh: name};
	});
var $author$project$Types$MealPackage$includedMealPackageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'imageUrl',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$nullable(
					A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed($author$project$Types$MealPackage$IncludedMealPackage)))));
var $author$project$Api$Endpoint$mealPackages = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['mealPackages']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.rs));
	});
var $author$project$Api$Util$outwardSailIdParam = function (sailId) {
	return _Utils_Tuple2(
		'outwardSailId',
		$elm$core$String$fromInt(sailId));
};
var $author$project$Api$Util$returnSailIdParam = function (sailId) {
	return _Utils_Tuple2(
		'returnSailId',
		$elm$core$String$fromInt(sailId));
};
var $author$project$Api$Meals$getMealPackages = F3(
	function (params, _v0, resultToMsg) {
		var outwardSailId = _v0.a;
		var maybeReturnSailId = _v0.b;
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					resultToMsg,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$map,
								$author$project$Types$MealPackage$Regular,
								$elm$json$Json$Decode$list($author$project$Types$MealPackage$decoder)),
								A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$head,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$map($author$project$Types$MealPackage$Included),
										$elm$core$Maybe$withDefault(
											$author$project$Types$MealPackage$Regular(_List_Nil)))),
								$elm$json$Json$Decode$list($author$project$Types$MealPackage$includedMealPackageDecoder))
							]))),
				jW: A2(
					$author$project$Api$Endpoint$mealPackages,
					params.zM.Gs,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						params.Aa,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							A3(
								$elm$core$Basics$apR,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Api$Util$returnSailIdParam,
										A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$core$Basics$append)),
									maybeReturnSailId),
								$elm$core$Maybe$withDefault(
									A2(
										$elm$core$List$member,
										params.tx,
										_List_fromArray(
											[
												$author$project$Types$VoyageType$Cruise,
												$author$project$Types$VoyageType$CruiseMultistop,
												$author$project$Types$VoyageType$CruiseMultiDeparture(0)
											])) ? $elm$core$Basics$append(
										_List_fromArray(
											[
												$author$project$Api$Util$returnSailIdParam(outwardSailId)
											])) : $elm$core$Basics$identity),
								_List_fromArray(
									[
										$author$project$Api$Util$localeParam(params.A_),
										$author$project$Api$Util$marketParam(params.rb),
										$author$project$Api$Util$guidParam(params.zM.Gt),
										$author$project$Api$Util$outwardSailIdParam(outwardSailId)
									])))))
			});
	});
var $author$project$Update$Trips$fetchMealPackages = F2(
	function (session, sailIds) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.rs,
			A3($author$project$Api$Meals$getMealPackages, session, sailIds, $author$project$Messages$GotMealPackages));
	});
var $author$project$Messages$GotMeals = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Meals$Meals = F6(
	function (breakfasts, brunches, buffets, tableReservations, outwardCanBeBookedOnline, returnCanBeBookedOnline) {
		return {vv: breakfasts, vy: brunches, vA: buffets, Dt: outwardCanBeBookedOnline, FM: returnCanBeBookedOnline, G5: tableReservations};
	});
var $author$project$Types$Meals$Meal = function (description) {
	return function (imageUrl) {
		return function (name) {
			return function (title) {
				return function (isGroupMenuSupported) {
					return function (minGroupMenuPassengers) {
						return function (isReservationFeeDisclaimerHidden) {
							return function (outwardSittings) {
								return function (returnSittings) {
									return function (maybeAddons) {
										return {nt: description, zP: imageUrl, qQ: isGroupMenuSupported, Ap: isReservationFeeDisclaimerHidden, BN: maybeAddons, rw: minGroupMenuPassengers, oh: name, kC: outwardSittings, k4: returnSittings, HI: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Meals$Addons = F5(
	function (starters, mainCourses, desserts, foodPackages, drinkPackages) {
		return {ys: desserts, yE: drinkPackages, y6: foodPackages, BD: mainCourses, GR: starters};
	});
var $author$project$Types$Meals$Addon = F4(
	function (code, description, included, adultOnly) {
		return {tW: adultOnly, pQ: code, nt: description, zU: included};
	});
var $author$project$Types$Meals$AddonCode = $elm$core$Basics$identity;
var $author$project$Types$Meals$decodeAddon = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'adultOnly',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'included',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				A2(
					$elm$json$Json$Decode$andThen,
					function (a) {
						return $elm$json$Json$Decode$succeed(a);
					},
					$elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Types$Meals$Addon)))));
var $author$project$Types$Meals$decodeAddons = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'drinkPackages',
	$elm$json$Json$Decode$list($author$project$Types$Meals$decodeAddon),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'foodPackages',
		$elm$json$Json$Decode$list($author$project$Types$Meals$decodeAddon),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'desserts',
			$elm$json$Json$Decode$list($author$project$Types$Meals$decodeAddon),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'mainCourses',
				$elm$json$Json$Decode$list($author$project$Types$Meals$decodeAddon),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'starters',
					$elm$json$Json$Decode$list($author$project$Types$Meals$decodeAddon),
					$elm$json$Json$Decode$succeed($author$project$Types$Meals$Addons))))));
var $author$project$Types$Meals$Sitting = function (beginDateTime) {
	return function (endDateTime) {
		return function (maybeMealType) {
			return function (isEvent) {
				return function (hasRoom) {
					return function (originalPrice) {
						return function (price) {
							return function (restaurantCode) {
								return function (title) {
									return function (hideEndTime) {
										return {ut: beginDateTime, yM: endDateTime, zr: hasRoom, zt: hideEndTime, z8: isEvent, BU: maybeMealType, rL: originalPrice, lN: price, FJ: restaurantCode, HI: title};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Meals$decodeSitting = function (title) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hideEndTime',
		$elm$json$Json$Decode$bool,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			title,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'restaurantCode',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'price',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'originalPrice',
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'hasRoom',
							$elm$json$Json$Decode$bool,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'diningKind',
								A2(
									$elm$json$Json$Decode$map,
									function (kind) {
										return kind === 'EVENT';
									},
									$elm$json$Json$Decode$string),
								false,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'diningKind',
									$author$project$Types$MealType$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'endDateTime',
										$author$project$Utils$Time$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'beginDateTime',
											$author$project$Utils$Time$decoder,
											$elm$json$Json$Decode$succeed($author$project$Types$Meals$Sitting)))))))))));
};
var $author$project$Types$Meals$decodeMeal = A2(
	$elm$json$Json$Decode$andThen,
	function (title) {
		return A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'addons',
			$elm$json$Json$Decode$maybe($author$project$Types$Meals$decodeAddons),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'returnSittings',
				$elm$json$Json$Decode$list(
					$author$project$Types$Meals$decodeSitting(title)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'outwardSittings',
					$elm$json$Json$Decode$list(
						$author$project$Types$Meals$decodeSitting(title)),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'hideReservationFeeDisclaimer',
						$elm$json$Json$Decode$bool,
						false,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'minGroupMenuPassengers',
							$elm$json$Json$Decode$int,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'supportGroupMenu',
								$elm$json$Json$Decode$bool,
								false,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'title',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'imageUrl',
											$elm$json$Json$Decode$string,
											'',
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'description',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Types$Meals$Meal)))))))))));
	},
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string));
var $author$project$Types$Meals$decodeMeals = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'returnMealsCanBeBookedOnline',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outwardMealsCanBeBookedOnline',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['meals', 'tableReservations']),
			$elm$json$Json$Decode$list($author$project$Types$Meals$decodeMeal),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['meals', 'buffets']),
				$elm$json$Json$Decode$list($author$project$Types$Meals$decodeMeal),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['meals', 'brunches']),
					$elm$json$Json$Decode$list($author$project$Types$Meals$decodeMeal),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['meals', 'breakfasts']),
						$elm$json$Json$Decode$list($author$project$Types$Meals$decodeMeal),
						$elm$json$Json$Decode$succeed($author$project$Types$Meals$Meals)))))));
var $author$project$Api$Endpoint$meals = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['meals']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.rv));
	});
var $author$project$Api$Meals$getMeals = F3(
	function (params, _v0, resultToMsg) {
		var outwardSailId = _v0.a;
		var maybeReturnSailId = _v0.b;
		var queryParams = A2(
			$author$project$Api$Util$addExperimentalParamIf,
			params.Aa,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A3(
					$elm$core$Basics$apR,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Util$returnSailIdParam,
							A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$core$Basics$append)),
						maybeReturnSailId),
					$elm$core$Maybe$withDefault(
						A2(
							$elm$core$List$member,
							params.tx,
							_List_fromArray(
								[
									$author$project$Types$VoyageType$Cruise,
									$author$project$Types$VoyageType$CruiseMultistop,
									$author$project$Types$VoyageType$CruiseMultiDeparture(1),
									$author$project$Types$VoyageType$CruiseMultiDeparture(0),
									$author$project$Types$VoyageType$CruiseParty
								])) ? $elm$core$Basics$append(
							_List_fromArray(
								[
									$author$project$Api$Util$returnSailIdParam(outwardSailId)
								])) : $elm$core$Basics$identity),
					_List_fromArray(
						[
							$author$project$Api$Util$localeParam(params.A_),
							$author$project$Api$Util$marketParam(params.rb),
							$author$project$Api$Util$guidParam(params.zM.Gt),
							$author$project$Api$Util$outwardSailIdParam(outwardSailId)
						]))));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, resultToMsg, $author$project$Types$Meals$decodeMeals),
				jW: A2($author$project$Api$Endpoint$meals, params.zM.Gs, queryParams)
			});
	});
var $author$project$Update$Trips$fetchMeals = F2(
	function (session, sailIds) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.rv,
			A3($author$project$Api$Meals$getMeals, session, sailIds, $author$project$Messages$GotMeals));
	});
var $author$project$Api$TravelClass$Both = 2;
var $author$project$Types$TravelClasses$getAllTravelClassCodes = A2(
	$elm$core$List$foldl,
	F2(
		function (_v0, accumulator) {
			var outwardTravelClass = _v0.DA;
			var returnTravelClass = _v0.FT;
			return A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.pQ;
					},
					returnTravelClass),
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.pQ;
						},
						outwardTravelClass),
					accumulator));
		}),
	_List_Nil);
var $author$project$Types$TravelClasses$isSpecialTravelClassSelected = function (travelClasses) {
	var petCageCode = function (getDiretionInfo) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$andThen(
				A2(
					$elm$core$Basics$composeR,
					getDiretionInfo,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$List$singleton)))),
			$elm$core$Maybe$withDefault(_List_Nil));
	};
	var isSelectionInSpecialCabins = F2(
		function (_v1, selectedCabinCodes) {
			var special = _v1.GN;
			var petCabins = _v1.EB;
			var petCages = _v1.EC;
			return !_Utils_eq(
				$elm$core$Maybe$Nothing,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (a) {
						return A2($elm$core$List$member, a, selectedCabinCodes);
					},
					_Utils_ap(
						A2(
							petCageCode,
							function ($) {
								return $.FL;
							},
							petCages),
						_Utils_ap(
							A2(
								petCageCode,
								function ($) {
									return $.Ds;
								},
								petCages),
							$author$project$Types$TravelClasses$getAllTravelClassCodes(
								_Utils_ap(special, petCabins))))));
		});
	switch (travelClasses.$) {
		case 0:
			var selected = travelClasses.a.Gg;
			var available = travelClasses.a.nb;
			var pets = travelClasses.a.k;
			return A2(
				isSelectionInSpecialCabins,
				available,
				_Utils_ap(
					_List_fromArray(
						[selected]),
					$elm$core$Dict$keys(pets)));
		case 1:
			var outward = travelClasses.a.Ds;
			var _return = travelClasses.a.FL;
			var available = travelClasses.a.nb;
			var outwardPets = travelClasses.a.m;
			var returnPets = travelClasses.a.t;
			return A2(
				isSelectionInSpecialCabins,
				available,
				_Utils_ap(
					_List_fromArray(
						[outward, _return]),
					_Utils_ap(
						$elm$core$Dict$keys(outwardPets),
						$elm$core$Dict$keys(returnPets))));
		case 2:
			var selected = travelClasses.a.Gg;
			var available = travelClasses.a.nb;
			var pets = travelClasses.a.k;
			return A2(
				isSelectionInSpecialCabins,
				available,
				_Utils_ap(
					$elm$core$Dict$keys(pets),
					A2($elm$core$List$map, $elm$core$Tuple$first, selected)));
		default:
			var outward = travelClasses.a.Ds;
			var _return = travelClasses.a.FL;
			var available = travelClasses.a.nb;
			var outwardPets = travelClasses.a.m;
			var returnPets = travelClasses.a.t;
			return A2(
				isSelectionInSpecialCabins,
				available,
				_Utils_ap(
					_Utils_ap(
						$elm$core$Dict$keys(outwardPets),
						$elm$core$Dict$keys(returnPets)),
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						_Utils_ap(outward, _return))));
	}
};
var $author$project$Update$Trips$fetchTravelClasses = F2(
	function (session, sailIds) {
		var requestType = function (isSpecialTravelClassSelected) {
			return (isSpecialTravelClassSelected && (!$author$project$Utils$Route$isMugVssRoute(session.kS))) ? 2 : 0;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Types$TravelClasses$isSpecialTravelClassSelected, session.to)));
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.pc,
			A4($author$project$Api$TravelClass$getTravelClasses, session, sailIds, requestType, $author$project$Messages$GotTravelClasses));
	});
var $author$project$Messages$GotLandServices = function (a) {
	return {$: 21, a: a};
};
var $author$project$Types$LandService$Event = F5(
	function (time, endTime, hasPlaces, ticketGroups, ticketsWithoutGroup) {
		return {yN: endTime, zp: hasPlaces, Hu: ticketGroups, Hw: ticketsWithoutGroup, o5: time};
	});
var $author$project$Types$LandService$LandService = F5(
	function (id, title, imageUrl, description, events) {
		return {nt: description, mq: events, zN: id, zP: imageUrl, HI: title};
	});
var $author$project$Types$LandService$decodeListIgnoringFailures = function (d) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, d),
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
					]))));
};
var $author$project$Types$Ticket$Ticket = F8(
	function (id, name, ageRange, price, clubAccountPrice, selectedHotelRequired, ageCategory, otherAgeCategories) {
		return {tY: ageCategory, m4: ageRange, wc: clubAccountPrice, zN: id, oh: name, Dq: otherAgeCategories, lN: price, Gj: selectedHotelRequired};
	});
var $author$project$Utils$Range$infinity = $elm$core$Basics$floor(1 / 0);
var $author$project$Types$Ticket$maxAge = 99;
var $author$project$Types$Ticket$maxAgeToInfinity = function (age) {
	return _Utils_eq(age, $author$project$Types$Ticket$maxAge) ? $author$project$Utils$Range$infinity : age;
};
var $author$project$Types$Ticket$ageRangeDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (from, to) {
			return _Utils_Tuple2(from, to);
		}),
	A2($elm$json$Json$Decode$field, 'ageFrom', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Types$Ticket$maxAgeToInfinity,
		A2($elm$json$Json$Decode$field, 'ageTo', $elm$json$Json$Decode$int)));
var $author$project$Types$Ticket$PackageId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Ticket$codeDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'addonCode',
			A2($elm$json$Json$Decode$map, $author$project$Types$Ticket$TicketCode, $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$field,
			'packageId',
			A2($elm$json$Json$Decode$map, $author$project$Types$Ticket$PackageId, $elm$json$Json$Decode$int))
		]));
var $author$project$Types$Ticket$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'otherAgeCategories',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ageCategory',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'requiresTallinkHotel',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'clubAccountPrice',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'price',
					$elm$json$Json$Decode$float,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Types$Ticket$ageRangeDecoder,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Types$Ticket$nameDecoder,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$author$project$Types$Ticket$codeDecoder,
								$elm$json$Json$Decode$succeed($author$project$Types$Ticket$Ticket)))))))));
var $author$project$Types$LandService$TicketGroup = F3(
	function (id, title, tickets) {
		return {zN: id, Hv: tickets, HI: title};
	});
var $author$project$Types$LandService$ticketGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tickets',
	$elm$json$Json$Decode$list($author$project$Types$Ticket$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'groupTitle',
		$elm$json$Json$Decode$string,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			0,
			$elm$json$Json$Decode$succeed($author$project$Types$LandService$TicketGroup))));
var $author$project$Types$LandService$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eventTimes',
	$author$project$Utils$OneOrMore$decoder(
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'items',
			$author$project$Types$LandService$decodeListIgnoringFailures($author$project$Types$Ticket$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'items',
				$author$project$Types$LandService$decodeListIgnoringFailures($author$project$Types$LandService$ticketGroupDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'hasPlaces',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'endDateTime',
						$elm$json$Json$Decode$maybe($author$project$Utils$Time$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'dateTime',
							$elm$json$Json$Decode$maybe($author$project$Utils$Time$decoder),
							$elm$json$Json$Decode$succeed($author$project$Types$LandService$Event))))))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'imageUrl',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					0,
					$elm$json$Json$Decode$succeed($author$project$Types$LandService$LandService))))));
var $author$project$Utils$List$maybeAddWithMap = F3(
	function (maybeB, map, aList) {
		return A2(
			$elm$core$Maybe$withDefault,
			aList,
			A2(
				$elm$core$Maybe$map,
				function (b) {
					return _Utils_ap(
						aList,
						_List_fromArray(
							[
								map(b)
							]));
				},
				maybeB));
	});
var $author$project$Types$LandService$getUrlParameters = F2(
	function (session, _v0) {
		var outwardSailId = _v0.a;
		var maybeReturnSailId = _v0.b;
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			session.Aa,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A2(
					$elm$core$List$filter,
					function (a) {
						return !$elm$core$String$isEmpty(a.b);
					},
					A3(
						$author$project$Utils$List$maybeAddWithMap,
						maybeReturnSailId,
						function (returnSailId) {
							return _Utils_Tuple2(
								'returnSailId',
								$elm$core$String$fromInt(returnSailId));
						},
						_List_fromArray(
							[
								$author$project$Api$Util$guidParam(session.zM.Gt),
								$author$project$Api$Util$localeParam(session.A_),
								$author$project$Api$Util$marketParam(session.rb),
								_Utils_Tuple2(
								'outwardSailId',
								$elm$core$String$fromInt(outwardSailId))
							])))));
	});
var $author$project$Api$Endpoint$land = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['land-services']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.q8));
	});
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			B: _List_Nil,
			x: 0,
			z: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.x * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						B: A2($elm$core$List$cons, mappedLeaf, builder.B),
						x: builder.x + 1,
						z: builder.z
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $author$project$Utils$OneOrMore$map = F2(
	function (func, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return A2(
			$author$project$Utils$OneOrMore$OneOrMore,
			func(x),
			A2($elm$core$List$map, func, xs));
	});
var $author$project$Types$LandService$setCorrectIds = function (landServices) {
	return $elm$core$Array$toList(
		A2(
			$elm$core$Array$indexedMap,
			F2(
				function (landServiceIndex, landService) {
					return _Utils_update(
						landService,
						{
							mq: A2(
								$author$project$Utils$OneOrMore$map,
								function (event) {
									return _Utils_update(
										event,
										{
											Hu: $elm$core$Array$toList(
												A2(
													$elm$core$Array$indexedMap,
													F2(
														function (ticketGroupIndex, ticketGroup) {
															return _Utils_update(
																ticketGroup,
																{zN: (landServiceIndex * 100) + ticketGroupIndex});
														}),
													$elm$core$Array$fromList(event.Hu)))
										});
								},
								landService.mq),
							zN: landServiceIndex
						});
				}),
			$elm$core$Array$fromList(landServices)));
};
var $author$project$Types$LandService$fetch = F2(
	function (session, sailIds) {
		var url = A2(
			$author$project$Api$Endpoint$land,
			session.zM.Gs,
			A2($author$project$Types$LandService$getUrlParameters, session, sailIds));
		var expect = A2(
			$elm$core$Basics$composeL,
			$elm$http$Http$expectJson($elm$core$Basics$identity),
			$elm$json$Json$Decode$field('landServices'))(
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Types$LandService$setCorrectIds,
				$elm$json$Json$Decode$list($author$project$Types$LandService$decoder)));
		return $author$project$Api$getWithCredentials(
			{j9: expect, jW: url});
	});
var $author$project$Update$Trips$fetchLandServices = F2(
	function (session, sailIds) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.q8,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$GotLandServices,
				A2($author$project$Types$LandService$fetch, session, sailIds)));
	});
var $author$project$Update$Trips$requestLandServices = F2(
	function (sailIds, model) {
		return _Utils_Tuple2(
			function (a) {
				return _Utils_update(
					model,
					{j: a});
			}(
				function (a) {
					return _Utils_update(
						a,
						{AZ: $krisajenkins$remotedata$RemoteData$Loading, Gl: _List_Nil});
				}(model.j)),
			A2($author$project$Update$Trips$fetchLandServices, model.j, sailIds));
	});
var $author$project$Utils$Route$isExactlyOneVehicleRequired = $author$project$Utils$Route$isRequiredHelper($author$project$Utils$Route$isExactlyOneVehicleRequiredForSail);
var $author$project$Messages$GotVehicles = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Endpoint$vehicles = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['vehicles']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.tt));
	});
var $author$project$Types$Vehicle$Vehicle = F5(
	function (carCategory, outwardDetails, returnDetails, licensePlates, capacity) {
		return {vM: capacity, jZ: carCategory, A9: licensePlates, Du: outwardDetails, FN: returnDetails};
	});
var $author$project$Types$Vehicle$decodePositiveInt = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Number$Positive$fromNumber,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('not a positive int')))),
	$elm$json$Json$Decode$int);
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Types$Vehicle$VehicleDetails = F2(
	function (availability, price) {
		return {uk: availability, lN: price};
	});
var $author$project$Types$Vehicle$vehicleDetailsDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Vehicle$VehicleDetails,
	A2($elm$json$Json$Decode$field, 'availability', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$float));
var $author$project$Types$Vehicle$vehicleDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Types$Vehicle$Vehicle,
	A2($elm$json$Json$Decode$field, 'carCategory', $author$project$Types$Vehicle$carCategoryDecoder),
	A2($elm$json$Json$Decode$field, 'outwardDetails', $author$project$Types$Vehicle$vehicleDetailsDecoder),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'returnDetails', $author$project$Types$Vehicle$vehicleDetailsDecoder)),
	A2($elm$json$Json$Decode$field, 'licensePlates', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'capacity', $author$project$Types$Vehicle$decodePositiveInt));
var $author$project$Types$Vehicle$vehiclesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$maybe($author$project$Types$Vehicle$vehicleDecoder)));
var $author$project$Api$Vehicles$getVehicles = F4(
	function (params, _v0, config, resultToMsg) {
		var outwardSailId = _v0.a;
		var maybeReturnSailId = _v0.b;
		var _v1 = params;
		var language = _v1.A_;
		var market = _v1.rb;
		var voyageType = _v1.tx;
		var from = _v1.kS;
		var to = _v1.le;
		var isExperimental = _v1.Aa;
		var queryParams = A2(
			$author$project$Api$Util$addExperimentalParamIf,
			isExperimental,
			A2(
				$elm$core$List$map,
				function (_v2) {
					var a = _v2.a;
					var b = _v2.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$author$project$Api$Util$voucherIdParam),
						$elm$core$List$head(params.tw)),
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Util$clubOneLevelParam,
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.pO;
								},
								$author$project$Types$Passenger$findWithHighestLevel(params.Eg))),
						A2(
							$author$project$Utils$List$maybeAdd,
							A2($elm$core$Maybe$map, $author$project$Api$Util$returnSailIdParam, maybeReturnSailId),
							_List_fromArray(
								[
									$author$project$Api$Util$localeParam(language),
									$author$project$Api$Util$marketParam(market),
									$author$project$Api$Util$outwardSailIdParam(outwardSailId)
								]))))));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					resultToMsg,
					A2($elm$json$Json$Decode$field, 'vehicles', $author$project$Types$Vehicle$vehiclesDecoder)),
				jW: A2($author$project$Api$Endpoint$vehicles, config, queryParams)
			});
	});
var $author$project$Update$Trips$fetchVehicles = F2(
	function (session, sailIds) {
		var httpConfig = session.zM;
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.tt,
			A4($author$project$Api$Vehicles$getVehicles, session, sailIds, httpConfig.Gs, $author$project$Messages$GotVehicles));
	});
var $author$project$Update$Trips$requestVehicles = F2(
	function (sailIds, model) {
		var session = model.j;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: _Utils_update(
						session,
						{Ag: true})
				}),
			A2($author$project$Update$Trips$fetchVehicles, session, sailIds));
	});
var $author$project$Update$Util$cancelRequest = function (tracker) {
	return A2($author$project$Update$Util$cancelRequestAndRunCmd, tracker, $elm$core$Platform$Cmd$none);
};
var $author$project$Update$Trips$resetVehicles = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{Ag: false, tt: _List_Nil})
			}),
		$author$project$Update$Util$cancelRequest($author$project$Api$Endpoint$trackers.tt));
};
var $author$project$Update$Trips$requestOrResetVehicles = F2(
	function (sailIds, model) {
		var session = model.j;
		var shouldRequestVehicles = $author$project$Utils$Route$areVehiclesSupported(session) && ((!_Utils_eq(session.rp, $elm$core$Maybe$Nothing)) || ($author$project$Utils$Route$isVehicleRequired(session) || $author$project$Utils$Route$isExactlyOneVehicleRequired(session)));
		return shouldRequestVehicles ? A2($author$project$Update$Trips$requestVehicles, sailIds, model) : $author$project$Update$Trips$resetVehicles(model);
	});
var $author$project$Update$Trips$addSelectedSailRequestsWithSailIds = F2(
	function (sailIds, model) {
		var session = model.j;
		var newSession = _Utils_update(
			session,
			{pr: false, Af: true, B7: $elm$core$Maybe$Nothing, B8: $elm$core$Maybe$Nothing});
		var newModel = _Utils_update(
			model,
			{j: newSession});
		var areMealPackagesSupported = !A2(
			$elm$core$List$member,
			session.tx,
			_List_fromArray(
				[
					$author$project$Types$VoyageType$Shuttle,
					$author$project$Types$VoyageType$CruiseMultiDeparture(1)
				]));
		return A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$requestLandServices(sailIds),
			A2(
				$author$project$Update$Util$andThen,
				$author$project$Update$Trips$requestOrResetVehicles(sailIds),
				_Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Update$Trips$fetchTravelClasses, newSession, sailIds),
								A2($author$project$Update$Trips$fetchMeals, newSession, sailIds),
								A2($author$project$Update$Trips$fetchOnboardServices, newSession, sailIds),
								areMealPackagesSupported ? A2($author$project$Update$Trips$fetchMealPackages, newSession, sailIds) : $elm$core$Platform$Cmd$none
							])))));
	});
var $author$project$Update$Trips$addSelectedSailRequests = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		A2(
			$elm$core$Maybe$map,
			function (sailIds) {
				return A2($author$project$Update$Trips$addSelectedSailRequestsWithSailIds, sailIds, model);
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$Trips$sailIds,
				$author$project$Types$Trips$statusToMaybe(model.j.tp))));
};
var $author$project$Update$Trips$areSailIdsDifferent = F2(
	function (model1, model2) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (a, b) {
						return !_Utils_eq(a, b);
					}),
				$author$project$Types$Trips$sailIdsFromStatus(model1.j.tp),
				$author$project$Types$Trips$sailIdsFromStatus(model2.j.tp)));
	});
var $author$project$UrlRoute$maybeCloseCalendarRouteFromRoute = function (route) {
	_v0$5:
	while (true) {
		if (route.$ === 1) {
			switch (route.a.$) {
				case 3:
					switch (route.a.a) {
						case 1:
							var _v1 = route.a.a;
							return $elm$core$Maybe$Just(
								$author$project$UrlRoute$Timetable(
									$author$project$UrlRoute$Shuttle(0)));
						case 3:
							var _v2 = route.a.a;
							return $elm$core$Maybe$Just(
								$author$project$UrlRoute$Timetable(
									$author$project$UrlRoute$Shuttle(2)));
						default:
							break _v0$5;
					}
				case 4:
					switch (route.a.a) {
						case 1:
							var _v3 = route.a.a;
							return $elm$core$Maybe$Just(
								$author$project$UrlRoute$Timetable(
									$author$project$UrlRoute$RouteTrip(0)));
						case 3:
							var _v4 = route.a.a;
							return $elm$core$Maybe$Just(
								$author$project$UrlRoute$Timetable(
									$author$project$UrlRoute$RouteTrip(2)));
						default:
							break _v0$5;
					}
				case 2:
					var _v5 = route.a;
					return $elm$core$Maybe$Just(
						$author$project$UrlRoute$Timetable($author$project$UrlRoute$CruiseMultiDeparture));
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Update$Trips$closeCalendar = function (model) {
	return A2(
		$elm$core$Maybe$map,
		A2($author$project$UrlRoute$replaceUrl, model.AK, model.n1),
		$author$project$UrlRoute$maybeCloseCalendarRouteFromRoute(
			$author$project$UrlRoute$parseLocation(model.n1)));
};
var $author$project$Types$CruiseMultiDepartureTrips$CruiseMultiDepartureTrips = $elm$core$Basics$identity;
var $author$project$Types$CruiseMultiDepartureTrips$init = F3(
	function (outwardSailId, statuses, clubOneOnlyPromotion) {
		var trips = A2(
			$elm$core$List$filterMap,
			function (status) {
				if (!status.$) {
					var trip = status.a;
					return $elm$core$Maybe$Just(trip);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			statuses);
		var initTrips = function (selectedTrip) {
			return {
				mg: clubOneOnlyPromotion,
				lH: A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(
						$author$project$Types$CruiseMultiDepartureTrip$Ok(selectedTrip)),
					statuses),
				Gg: selectedTrip
			};
		};
		return A2(
			$elm$core$Maybe$map,
			initTrips,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$List$head(trips),
				A2(
					$elm$core$Maybe$map,
					$elm$core$Maybe$Just,
					A2(
						$elm$core$Maybe$andThen,
						function (a) {
							return A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.zN;
									},
									$elm$core$Basics$eq(a)),
								trips);
						},
						outwardSailId))));
	});
var $author$project$Update$Trips$resetSelectedCalendarDate = function (model) {
	var _v0 = model.DF;
	if (_v0.$ === 1) {
		var page = _v0.a;
		return _Utils_update(
			model,
			{
				DF: $author$project$Model$Timetable(
					_Utils_update(
						page,
						{oP: $elm$core$Maybe$Nothing}))
			});
	} else {
		return model;
	}
};
var $author$project$Ports$scrollToSelectedSail = _Platform_outgoingPort(
	'scrollToSelectedSail',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Update$Trips$handleCruiseMultiDepartureTripsSuccess = F3(
	function (model, statuses, clubOneOnlyPromotion) {
		var session = model.j;
		var sailIdFromCruiseMultiDepartureTrips = A2(
			$elm$core$Basics$composeR,
			$author$project$Types$CruiseMultiDepartureTrips$selected,
			function ($) {
				return $.zN;
			});
		var maybeSailIdFromRouteTrips = function (route) {
			var departureTime = $author$project$Types$RouteTripSails$selectedDepartureAndArrivalTimes(route).a;
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zN;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.rS;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.p3;
							},
							$elm$core$Basics$eq(departureTime))),
					A2(
						$elm$core$List$filterMap,
						function (status) {
							if (!status.$) {
								var trip = status.a;
								return $elm$core$Maybe$Just(trip);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						statuses)));
		};
		var preservedSailId = function () {
			var _v1 = session.tp;
			_v1$4:
			while (true) {
				switch (_v1.$) {
					case 0:
						switch (_v1.a.$) {
							case 2:
								var shopping = _v1.a.a;
								return $elm$core$Maybe$Just(
									sailIdFromCruiseMultiDepartureTrips(shopping));
							case 1:
								var route = _v1.a.a;
								return maybeSailIdFromRouteTrips(route);
							default:
								break _v1$4;
						}
					case 2:
						if (!_v1.a.$) {
							switch (_v1.a.a.$) {
								case 2:
									var shopping = _v1.a.a.a;
									return $elm$core$Maybe$Just(
										sailIdFromCruiseMultiDepartureTrips(shopping));
								case 1:
									var route = _v1.a.a.a;
									return maybeSailIdFromRouteTrips(route);
								default:
									break _v1$4;
							}
						} else {
							break _v1$4;
						}
					default:
						break _v1$4;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var trips = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$Trips$Failure(
				$author$project$Types$Trips$statusToMaybe(session.tp)),
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeL, $author$project$Types$Trips$Success, $author$project$Types$Trips$CruiseMultiDeparture),
				A3($author$project$Types$CruiseMultiDepartureTrips$init, preservedSailId, statuses, clubOneOnlyPromotion)));
		var _v0 = function (a) {
			return _Utils_Tuple2(
				a,
				$elm$core$Platform$Cmd$batch(
					A3(
						$author$project$Utils$List$addIf,
						_Utils_eq(
							$author$project$UrlRoute$parseLocation(model.n1),
							$author$project$UrlRoute$Timetable($author$project$UrlRoute$CruiseMultiDeparture)),
						$author$project$Ports$scrollToSelectedSail(0),
						A2(
							$author$project$Utils$List$maybeAdd,
							$author$project$Update$Trips$closeCalendar(a),
							_List_Nil))));
		}(
			$author$project$Update$Trips$resetSelectedCalendarDate(
				_Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{Ad: false, B9: $elm$core$Maybe$Nothing, Gz: false, tp: trips})
					})));
		var newModel = _v0.a;
		var cmd = _v0.b;
		return A2($author$project$Update$Trips$areSailIdsDifferent, model, newModel) ? A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$addSelectedSailRequests,
			_Utils_Tuple2(newModel, cmd)) : _Utils_Tuple2(
			_Utils_update(
				newModel,
				{
					j: function (a) {
						return _Utils_update(
							a,
							{pr: true});
					}(newModel.j)
				}),
			cmd);
	});
var $author$project$Update$Trips$isAnyCruiseMultiDepartureTripAvailable = $elm$core$List$any(
	function (status) {
		if (!status.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Update$Trips$isTimeAfterMarketUntilTime = F2(
	function (_v0, time) {
		var marketUntilDate = _v0.mI;
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(marketUntilDate),
			$elm$time$Time$posixToMillis(time)) < 0;
	});
var $author$project$Update$Trips$handleCruiseMultiDepartureTripsOkResponse = F2(
	function (model, _v0) {
		var session = model.j;
		var dateTo = _v0.a;
		var statuses = _v0.b;
		var clubOneOnlyPromotion = _v0.c;
		var isRefetchRequired = (!$author$project$Update$Trips$isAnyCruiseMultiDepartureTripAvailable(statuses)) && (!A2($author$project$Update$Trips$isTimeAfterMarketUntilTime, model.j, dateTo));
		return isRefetchRequired ? A2(
			$elm$core$Tuple$pair,
			model,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$GotCruiseMultiDepartureTrips,
				A2(
					$author$project$Types$CruiseMultiDepartureTrips$fetch,
					$author$project$Types$Date$fromPosix(dateTo),
					session))) : A3($author$project$Update$Trips$handleCruiseMultiDepartureTripsSuccess, model, statuses, clubOneOnlyPromotion);
	});
var $author$project$Update$Trips$handleError = F2(
	function (error, model) {
		var session = model.j;
		var newSession = _Utils_update(
			session,
			{
				Ad: false,
				tp: $author$project$Types$Trips$Failure(
					$author$project$Types$Trips$statusToMaybe(session.tp))
			});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{j: newSession}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Tracking$logHttpError, 'tripsResponse', error),
						_Utils_eq(error, $elm$http$Http$NetworkError) ? A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$ConnectionProblem) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Update$Trips$handleCruiseMultiDepartureTripsResponse = F2(
	function (result, model) {
		if (!result.$) {
			var response = result.a;
			return A2($author$project$Update$Trips$handleCruiseMultiDepartureTripsOkResponse, model, response);
		} else {
			var error = result.a;
			return A2($author$project$Update$Trips$handleError, error, model);
		}
	});
var $author$project$Tracking$logDecodingError = F2(
	function (kind, error) {
		var errorMessage = $author$project$Tracking$capitalizeString(kind) + (': ' + $elm$json$Json$Decode$errorToString(error));
		return $author$project$Tracking$logError(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string('DecoderError')),
						_Utils_Tuple2(
						'message',
						$elm$json$Json$Encode$string(errorMessage))
					])));
	});
var $author$project$Update$Trips$haveSelectedRouteTripSailIdsChanged = F2(
	function (a, b) {
		return !_Utils_eq(
			$author$project$Types$RouteTripSails$getSailIds(a),
			$author$project$Types$RouteTripSails$getSailIds(b));
	});
var $author$project$Update$Trips$removeSelectedBusTransfers = function (model) {
	var session = model.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{B0: $elm$core$Maybe$Nothing})
		});
};
var $author$project$Update$Trips$resetBusTransfersIfSelectedRouteTripSailIdsChanged = F2(
	function (previousModel, currentModel) {
		var hasIdChanged = function () {
			var _v0 = _Utils_Tuple2(previousModel.j.tp, currentModel.j.tp);
			if ((((!_v0.a.$) && (_v0.a.a.$ === 1)) && (!_v0.b.$)) && (_v0.b.a.$ === 1)) {
				var a = _v0.a.a.a;
				var b = _v0.b.a.a;
				return A2($author$project$Update$Trips$haveSelectedRouteTripSailIdsChanged, a, b);
			} else {
				return true;
			}
		}();
		return hasIdChanged ? $author$project$Update$Trips$removeSelectedBusTransfers(currentModel) : currentModel;
	});
var $author$project$Types$Trips$Route = function (a) {
	return {$: 1, a: a};
};
var $author$project$Update$Trips$updateRouteTripSails = F2(
	function (model, routeTripSails) {
		var session = model.j;
		return function (a) {
			return _Utils_Tuple2(
				a,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						$author$project$Update$Trips$closeCalendar(a))));
		}(
			$author$project$Update$Trips$resetSelectedCalendarDate(
				function (a) {
					return _Utils_update(
						model,
						{j: a});
				}(
					_Utils_update(
						session,
						{
							tp: $author$project$Types$Trips$Success(
								$author$project$Types$Trips$Route(routeTripSails))
						}))));
	});
var $author$project$Update$Trips$handleSuccessHotelPackagesResponse = F2(
	function (model, _v0) {
		var hotels = _v0.zH;
		var cities = _v0.vZ;
		var timetable = _v0.tc;
		var selectedSailWithoutHotels = _v0.Gp;
		var outwardSailHotelAvailabilityBorder = _v0.Dy;
		var disabledOutwardSails = _v0.yx;
		var _v1 = A2(
			$author$project$Update$Util$andThen,
			function (a) {
				return A2(
					$elm$core$Tuple$mapSecond,
					function (b) {
						return $elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$cons,
								b,
								A2(
									$elm$core$List$map,
									$author$project$Tracking$logDecodingError('tripsResponseDecode'),
									timetable.F)));
					},
					A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(a, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (trips) {
								return A2(
									$elm$core$Tuple$mapSecond,
									$elm$core$Platform$Cmd$batch,
									A2(
										$elm$core$Tuple$mapFirst,
										$author$project$Update$Trips$resetBusTransfersIfSelectedRouteTripSailIdsChanged(a),
										A2(
											$elm$core$Tuple$mapFirst,
											function (b) {
												var session = b.j;
												return _Utils_update(
													b,
													{
														j: _Utils_update(
															session,
															{Ad: false})
													});
											},
											A2($author$project$Update$Trips$updateRouteTripSails, a, trips))));
							},
							timetable.lA)));
			},
			A2(
				$author$project$Update$Util$andThen,
				function (a) {
					var _v2 = a.DF;
					if (_v2.$ === 1) {
						var pageModel = _v2.a;
						return _Utils_Tuple2(
							_Utils_update(
								a,
								{
									DF: $author$project$Model$Timetable(
										_Utils_update(
											pageModel,
											{Gp: selectedSailWithoutHotels}))
								}),
							(!_Utils_eq(selectedSailWithoutHotels, $elm$core$Maybe$Nothing)) ? $author$project$Ports$scrollTo(
								{zN: 'selectedSailWithoutHotelsTooltipContainer'}) : $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
					}
				},
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: function (a) {
								return _Utils_update(
									a,
									{
										yx: disabledOutwardSails,
										zI: {vZ: cities, zH: hotels},
										Ac: false,
										Dy: outwardSailHotelAvailabilityBorder
									});
							}(model.j)
						}),
					$elm$core$Platform$Cmd$none)));
		var newModel = _v1.a;
		var cmd = _v1.b;
		return A2($author$project$Update$Trips$areSailIdsDifferent, model, newModel) ? A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$addSelectedSailRequests,
			_Utils_Tuple2(newModel, cmd)) : _Utils_Tuple2(
			_Utils_update(
				newModel,
				{
					j: function (a) {
						return _Utils_update(
							a,
							{pr: true});
					}(newModel.j)
				}),
			cmd);
	});
var $author$project$Update$Trips$handleHotelPackagesResponse = F2(
	function (model, response) {
		if (!response.$) {
			var result = response.a;
			return A2($author$project$Update$Trips$handleSuccessHotelPackagesResponse, model, result);
		} else {
			var error = response.a;
			return A2($author$project$Update$Trips$handleError, error, model);
		}
	});
var $author$project$Update$Trips$fetchCruiseTripsStartingFromLastSailTimeInList = F3(
	function (model, currentDate, cruiseResponse) {
		var dateFrom = A2(
			$elm$core$Maybe$withDefault,
			A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, $elm$time$Time$utc, currentDate),
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						$elm$time$Time$posixToMillis,
						A2(
							$elm$core$List$filterMap,
							$author$project$Utils$Time$fromString,
							$elm$core$Dict$keys(cruiseResponse.tp))))));
		return _Utils_Tuple2(
			model,
			A2($author$project$Api$Timetable$getCruiseSailFromDate, model, dateFrom));
	});
var $author$project$Update$Trips$hasSelectedCruiseSailIdChanged = F2(
	function (a, b) {
		return !_Utils_eq(
			$author$project$Types$CruiseSails$getSailIds(a),
			$author$project$Types$CruiseSails$getSailIds(b));
	});
var $author$project$Update$Trips$resetBusTransfersIfSelectedCruiseSailIdsChanged = F2(
	function (previousModel, currentModel) {
		var hasIdChanged = function () {
			var _v0 = _Utils_Tuple2(previousModel.j.tp, currentModel.j.tp);
			if ((((!_v0.a.$) && (!_v0.a.a.$)) && (!_v0.b.$)) && (!_v0.b.a.$)) {
				var a = _v0.a.a.a;
				var b = _v0.b.a.a;
				return A2($author$project$Update$Trips$hasSelectedCruiseSailIdChanged, a, b);
			} else {
				return true;
			}
		}();
		return hasIdChanged ? $author$project$Update$Trips$removeSelectedBusTransfers(currentModel) : currentModel;
	});
var $author$project$Types$Trips$Cruise = function (a) {
	return {$: 0, a: a};
};
var $author$project$Update$Trips$getCruiseSailDateToRestore = function (trips) {
	switch (trips.$) {
		case 0:
			var cruise = trips.a;
			return $author$project$Types$CruiseSails$selectedDepartureAndArrivalTimes(cruise).a;
		case 1:
			var route = trips.a;
			return $author$project$Types$RouteTripSails$selected(route).a.nr;
		default:
			var shopping = trips.a;
			return $author$project$Types$CruiseMultiDepartureTrips$selected(shopping).rS.p3;
	}
};
var $author$project$Types$CruiseSails$CruiseSails = $elm$core$Basics$identity;
var $author$project$Types$CruiseSails$init = F4(
	function (metadata, selectedCruiseSail, dict, clubOneOnlyPromotion) {
		return {
			mg: clubOneOnlyPromotion,
			nu: A2($elm$core$Dict$remove, selectedCruiseSail.a, dict),
			mL: metadata,
			Gg: selectedCruiseSail
		};
	});
var $author$project$TimetablePage$Cruise$Util$timeBeforeDisable = 90;
var $author$project$TimetablePage$Cruise$Util$isDayNotExpired = F2(
	function (currentDateTime, outwardSailDate) {
		return _Utils_cmp(
			A4($justinmimbs$time_extra$Time$Extra$diff, 13, $elm$time$Time$utc, currentDateTime, outwardSailDate),
			$author$project$TimetablePage$Cruise$Util$timeBeforeDisable) > 0;
	});
var $author$project$TimetablePage$Cruise$Util$maybeGetSelectedSail = F4(
	function (cruiseSails, maybeSailPackageCode, maybePreviousSailId, dateTime) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var key = _v0.a;
					var sail = _v0.b;
					if (!sail.$) {
						var a = sail.a;
						return (A2($author$project$TimetablePage$Cruise$Util$isDayNotExpired, dateTime, a.rS.nr) && ((_Utils_eq(maybeSailPackageCode, $elm$core$Maybe$Nothing) || _Utils_eq(a.F4, maybeSailPackageCode)) && (_Utils_eq(maybePreviousSailId, $elm$core$Maybe$Nothing) || _Utils_eq(
							$elm$core$Maybe$Just(a.F3),
							maybePreviousSailId)))) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(key, a)) : $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				$elm$core$Dict$toList(cruiseSails)));
	});
var $author$project$Update$Trips$addNewCruiseSails = F4(
	function (session, response, times, maybePreviousSailId) {
		var metadata = response.mL;
		var getMaybeSelectedSail = F2(
			function (maybeSailPackageCode, dateTime) {
				return A4($author$project$TimetablePage$Cruise$Util$maybeGetSelectedSail, response.tp, maybeSailPackageCode, maybePreviousSailId, dateTime);
			});
		var defaultTimeToRestore = function () {
			var _v0 = session.tp;
			if (!_v0.$) {
				var trips = _v0.a;
				return A4(
					$justinmimbs$time_extra$Time$Extra$add,
					13,
					-91,
					$elm$time$Time$utc,
					$author$project$Update$Trips$getCruiseSailDateToRestore(trips));
			} else {
				return times.ld;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$Trips$Failure(
				$author$project$Types$Trips$statusToMaybe(session.tp)),
			A2(
				$elm$core$Maybe$map,
				function (dateSailPair) {
					var cruiseSails = A4($author$project$Types$CruiseSails$init, response.mL, dateSailPair, response.tp, response.mg);
					return $author$project$Types$Trips$Success(
						$author$project$Types$Trips$Cruise(cruiseSails));
				},
				A2(
					$author$project$Types$Maybe$Util$orElse,
					A2(getMaybeSelectedSail, $elm$core$Maybe$Nothing, times.ld),
					A2(
						$author$project$Types$Maybe$Util$orElse,
						A2(getMaybeSelectedSail, times.F4, times.ld),
						A2(
							getMaybeSelectedSail,
							times.F4,
							A2($elm$core$Maybe$withDefault, defaultTimeToRestore, times.mZ))))));
	});
var $author$project$Types$CruiseSails$append = F3(
	function (sailsDict, clubOneOnlyPromotion, _v0) {
		var cruiseSails = _v0;
		return A4(
			$author$project$Types$CruiseSails$init,
			cruiseSails.mL,
			cruiseSails.Gg,
			A2($elm$core$Dict$union, cruiseSails.nu, sailsDict),
			cruiseSails.mg || clubOneOnlyPromotion);
	});
var $author$project$Types$Maybe$Util$filter = F2(
	function (isGood, maybe) {
		var _v0 = A2($elm$core$Maybe$map, isGood, maybe);
		if ((!_v0.$) && _v0.a) {
			return maybe;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Types$CruiseSails$getMetadata = function (_v0) {
	var a = _v0;
	return a.mL;
};
var $author$project$Update$Trips$hasSelectedTripInResponse = F2(
	function (cruiseSails, response) {
		return !_Utils_eq(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (a) {
					if (!a.$) {
						var sailId = a.a.F3;
						return _Utils_eq(
							sailId,
							$author$project$Types$CruiseSails$selected(cruiseSails).b.F3);
					} else {
						return false;
					}
				},
				$elm$core$Dict$values(response)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Update$Trips$storeCruiseSails = F3(
	function (model, response, times) {
		var session = model.j;
		var maybePreviousSails = function () {
			var _v1 = session.tp;
			_v1$2:
			while (true) {
				switch (_v1.$) {
					case 0:
						if (!_v1.a.$) {
							var cruise = _v1.a.a;
							return $elm$core$Maybe$Just(cruise);
						} else {
							break _v1$2;
						}
					case 2:
						if ((!_v1.a.$) && (!_v1.a.a.$)) {
							var cruise = _v1.a.a.a;
							return $elm$core$Maybe$Just(cruise);
						} else {
							break _v1$2;
						}
					default:
						break _v1$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var maybePreviousSailId = A2(
			$elm$core$Maybe$andThen,
			function (previousSails) {
				return A2($author$project$Update$Trips$hasSelectedTripInResponse, previousSails, response.tp) ? $elm$core$Maybe$Just(
					$author$project$Types$CruiseSails$selected(previousSails).b.F3) : $elm$core$Maybe$Nothing;
			},
			maybePreviousSails);
		var isMetadataSame = function (currentSails) {
			return _Utils_eq(
				$author$project$Types$CruiseSails$getMetadata(currentSails),
				response.mL) && (!A2($author$project$Update$Trips$hasSelectedTripInResponse, currentSails, response.tp));
		};
		var trips = function () {
			var _v0 = A2($author$project$Types$Maybe$Util$filter, isMetadataSame, maybePreviousSails);
			if (_v0.$ === 1) {
				return A4($author$project$Update$Trips$addNewCruiseSails, session, response, times, maybePreviousSailId);
			} else {
				var sails = _v0.a;
				return A3(
					$elm$core$Basics$composeL,
					$author$project$Types$Trips$Success,
					$author$project$Types$Trips$Cruise,
					A3($author$project$Types$CruiseSails$append, response.tp, response.mg, sails));
			}
		}();
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{tp: trips})
			});
	});
var $author$project$Update$Trips$handleCruiseTripsSuccess = F3(
	function (model, response, times) {
		var errors = response.ku;
		var trackErrors = $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				$author$project$Tracking$logDecodingError('tripsResponseDecode'),
				errors));
		var _v0 = function (a) {
			return _Utils_Tuple2(a, trackErrors);
		}(
			A2(
				$author$project$Update$Trips$resetBusTransfersIfSelectedCruiseSailIdsChanged,
				model,
				function (a) {
					var session = a.j;
					return _Utils_update(
						a,
						{
							j: _Utils_update(
								session,
								{Ad: false})
						});
				}(
					A3($author$project$Update$Trips$storeCruiseSails, model, response, times))));
		var newModel = _v0.a;
		var cmd = _v0.b;
		return A2($author$project$Update$Trips$areSailIdsDifferent, model, newModel) ? A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$addSelectedSailRequests,
			_Utils_Tuple2(newModel, cmd)) : _Utils_Tuple2(
			_Utils_update(
				newModel,
				{
					j: function (a) {
						return _Utils_update(
							a,
							{pr: true});
					}(newModel.j)
				}),
			cmd);
	});
var $author$project$Types$CruiseSail$isAvailable = function (cruiseSail) {
	if (!cruiseSail.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Update$Trips$handleCruiseTripsResponse = F3(
	function (model, response, times) {
		var startTime = times.ld;
		var isAnySailAvailable = A2(
			$elm$core$List$any,
			$author$project$Types$CruiseSail$isAvailable,
			$elm$core$Dict$values(response.tp));
		return ((!isAnySailAvailable) && (!A2($author$project$Update$Trips$isTimeAfterMarketUntilTime, model.j, startTime))) ? A3($author$project$Update$Trips$fetchCruiseTripsStartingFromLastSailTimeInList, model, startTime, response) : A3($author$project$Update$Trips$handleCruiseTripsSuccess, model, response, times);
	});
var $author$project$Update$Trips$handleRouteTripsFailure = F3(
	function (model, direction, previousFetchRangeStartTime) {
		var session = model.j;
		var timeFrom = A4($justinmimbs$time_extra$Time$Extra$add, 3, $author$project$Api$Timetable$amountOfWeeksToFetch, $elm$time$Time$utc, previousFetchRangeStartTime);
		var timeTo = A4($justinmimbs$time_extra$Time$Extra$add, 3, 2 * $author$project$Api$Timetable$amountOfWeeksToFetch, $elm$time$Time$utc, timeFrom);
		var previousTrips = function () {
			var _v1 = session.tp;
			if (_v1.$ === 2) {
				var sails = _v1.a;
				return sails;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return (!A2($author$project$Update$Trips$isTimeAfterMarketUntilTime, model.j, timeFrom)) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: _Utils_update(
						session,
						{
							tp: $author$project$Types$Trips$Loading(previousTrips)
						})
				}),
			A8(
				$author$project$Api$Timetable$createRouteTripSailsRequest,
				session,
				timeFrom,
				timeTo,
				direction,
				$elm$core$Maybe$Nothing,
				A4($author$project$Utils$Route$isTurStoOvernightTrip, model.n1, session.mm, session.kS, session.le),
				$author$project$UrlRoute$bookingParamsFromLocation(model.n1).Iv,
				$author$project$Messages$GotTrips(
					$author$project$Update$RequestTimes$create(timeFrom)))) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: _Utils_update(
						session,
						{
							Ad: false,
							tp: function () {
								var _v0 = session.tp;
								if ((_v0.$ === 2) && (!_v0.a.$)) {
									var routeTripsSails = _v0.a.a;
									return $author$project$Types$Trips$Success(routeTripsSails);
								} else {
									return $author$project$Types$Trips$Failure($elm$core$Maybe$Nothing);
								}
							}()
						})
				}),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				$author$project$Update$Trips$closeCalendar(model)));
	});
var $author$project$Types$RouteTripSails$all = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return _Utils_Tuple2(
		outward.H,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.H;
			},
			_return));
};
var $author$project$Types$RouteTripSails$updateReturnSails = F3(
	function (bookingType, returnSailsList, _v0) {
		var outward = _v0.Ds;
		var _return = _v0.FL;
		var clubOneOnlyPromotion = _v0.mg;
		return A2(
			$elm$core$Maybe$withDefault,
			{mg: clubOneOnlyPromotion, Ds: outward, FL: _return},
			A2(
				$elm$core$Maybe$map,
				function (returnSail) {
					return {
						mg: clubOneOnlyPromotion,
						Ds: outward,
						FL: $elm$core$Maybe$Just(
							{H: returnSailsList, Gg: returnSail})
					};
				},
				A3($author$project$Types$RouteTripSails$findSelectableReturnSail, bookingType, outward.Gg, returnSailsList)));
	});
var $author$project$Update$Trips$storeRouteTripSails = F3(
	function (model, direction, sails) {
		var session = model.j;
		if (!direction) {
			return A2(
				$elm$core$Tuple$mapSecond,
				A2(
					$author$project$Utils$List$addIf,
					session.Gz,
					$author$project$Ports$scrollToSelectedSail(0)),
				A2($author$project$Update$Trips$updateRouteTripSails, model, sails));
		} else {
			var _v1 = _Utils_Tuple2(
				model.j.tp,
				$author$project$Types$RouteTripSails$all(sails).b);
			if ((((_v1.a.$ === 2) && (!_v1.a.a.$)) && (_v1.a.a.a.$ === 1)) && (!_v1.b.$)) {
				var route = _v1.a.a.a.a;
				var returnSails = _v1.b.a;
				return A2(
					$author$project$Update$Trips$updateRouteTripSails,
					model,
					A3($author$project$Types$RouteTripSails$updateReturnSails, session.vk, returnSails, route));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									tp: $author$project$Types$Trips$Failure($elm$core$Maybe$Nothing)
								})
						}),
					_List_Nil);
			}
		}
	});
var $author$project$Update$Trips$handleRouteTripsSuccess = F3(
	function (model, direction, sails) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$batch,
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Update$Trips$resetBusTransfersIfSelectedRouteTripSailIdsChanged(model),
				A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						var session = a.j;
						return _Utils_update(
							a,
							{
								j: _Utils_update(
									session,
									{Ad: false, Gz: false})
							});
					},
					A3($author$project$Update$Trips$storeRouteTripSails, model, direction, sails))));
		var newModel = _v0.a;
		var cmd = _v0.b;
		return A2($author$project$Update$Trips$areSailIdsDifferent, model, newModel) ? A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$addSelectedSailRequests,
			_Utils_Tuple2(newModel, cmd)) : _Utils_Tuple2(
			_Utils_update(
				newModel,
				{
					j: function (a) {
						return _Utils_update(
							a,
							{pr: true});
					}(newModel.j)
				}),
			cmd);
	});
var $author$project$Update$Trips$handleRouteTripsResponse = F4(
	function (model, direction, _v0, fetchRangeStartTime) {
		var maybeSails = _v0.lA;
		var decodingErrors = _v0.F;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (a) {
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$cons,
						a,
						A2(
							$elm$core$List$map,
							$author$project$Tracking$logDecodingError('tripsResponseDecode'),
							decodingErrors)));
			},
			A2(
				$elm$core$Maybe$withDefault,
				A3($author$project$Update$Trips$handleRouteTripsFailure, model, direction, fetchRangeStartTime),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Update$Trips$handleRouteTripsSuccess, model, direction),
					maybeSails)));
	});
var $author$project$Update$Trips$handleTripsResponse = F3(
	function (model, times, tripsResponse) {
		if (!tripsResponse.$) {
			if (!tripsResponse.a.$) {
				var response = tripsResponse.a.a;
				return A3($author$project$Update$Trips$handleCruiseTripsResponse, model, response, times);
			} else {
				var _v1 = tripsResponse.a;
				var direction = _v1.a;
				var response = _v1.b;
				return A4($author$project$Update$Trips$handleRouteTripsResponse, model, direction, response, times.ld);
			}
		} else {
			var error = tripsResponse.a;
			return A2($author$project$Update$Trips$handleError, error, model);
		}
	});
var $author$project$Update$handleVoucherValidationResponse = F2(
	function (model, data) {
		var session = model.j;
		switch (data.$) {
			case 3:
				var voucher = data.a.Ip;
				var isValid = data.a.Aw;
				return isValid ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									tw: _Utils_ap(
										session.tw,
										_List_fromArray(
											[voucher]))
								})
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var error = data.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$Tracking$logHttpError, 'voucherValidationResponse', error));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$RouteTripSails$hasReturnSails = function (_v0) {
	var _return = _v0.FL;
	return !_Utils_eq(_return, $elm$core$Maybe$Nothing);
};
var $author$project$Update$haveSelectedVehiclesChanged = F2(
	function (oldModel, newModel) {
		return !_Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$selectedVehiclesWithVoyageTypeList, oldModel.j.rp),
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$selectedVehiclesWithVoyageTypeList, newModel.j.rp));
	});
var $author$project$Price$View$hasTravelClassesSelected = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$author$project$Types$TravelClasses$getSelectedCodeCountPairLists,
			function (_v0) {
				var outbound = _v0.Dr;
				var inbound = _v0.zT;
				return (!$elm$core$List$isEmpty(outbound)) || (!$elm$core$List$isEmpty(inbound));
			})),
	$elm$core$Maybe$withDefault(false));
var $author$project$Price$View$isMinCabinPriceUnavailable = function (session) {
	var maybeSummary = session.B7;
	var travelClasses = session.to;
	var coversAllPassengers = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.qa;
			},
			maybeSummary));
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			function (trips) {
				if (!trips.$) {
					var cruise = trips.a;
					return (!coversAllPassengers) && $author$project$Types$CruiseSails$selected(cruise).b.Au;
				} else {
					return (!coversAllPassengers) && (!$author$project$Price$View$hasTravelClassesSelected(travelClasses));
				}
			},
			$author$project$Types$Trips$statusToMaybe(session.tp)));
};
var $author$project$Update$isTransitionFromModal = F2(
	function (prevUrl, newUrl) {
		return (!_Utils_eq(
			$author$project$Update$getModalTypeFromUrl(prevUrl),
			$elm$core$Maybe$Nothing)) && _Utils_eq(
			$author$project$Update$getModalTypeFromUrl(newUrl),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Update$isTransitionFromResetBookingModalWithRouteChange = F2(
	function (prevUrl, newUrl) {
		return _Utils_eq(
			$author$project$Update$getModalTypeFromUrl(prevUrl),
			$elm$core$Maybe$Just($author$project$Common$Modal$Model$ResetBooking)) && (_Utils_eq(
			$author$project$Update$getModalTypeFromUrl(newUrl),
			$elm$core$Maybe$Nothing) && (!_Utils_eq(prevUrl.Eh, newUrl.Eh)));
	});
var $author$project$Utils$Route$isVehicleRequiredForOnlyOneLeg = function (session) {
	var isOneWay = session.qW;
	return isOneWay ? false : (($author$project$Utils$Route$isVehicleRequiredHelper(
		$author$project$Utils$Route$outwardRequiredArguments(session)) && (!$author$project$Utils$Route$isVehicleRequiredHelper(
		$author$project$Utils$Route$returnRequiredArguments(session)))) || ($author$project$Utils$Route$isVehicleRequiredHelper(
		$author$project$Utils$Route$returnRequiredArguments(session)) && (!$author$project$Utils$Route$isVehicleRequiredHelper(
		$author$project$Utils$Route$outwardRequiredArguments(session)))));
};
var $author$project$Types$Summary$errorCodesToBeIgnored = _List_fromArray(
	[1501, 1502, 1019836, 1019856, 1019857, 1019977, 1019978, 1020376]);
var $author$project$Types$Summary$keepUniqueCriticalErrors = function (warnings) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (warning, accumulator) {
				return (A2($elm$core$List$member, warning.pQ, $author$project$Types$Summary$errorCodesToBeIgnored) || ((!_Utils_eq(
					warning.sO,
					$elm$core$Maybe$Just('ERROR'))) || (warning.pF || A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(warning.pQ)),
					accumulator)))) ? accumulator : A2($elm$core$List$cons, warning, accumulator);
			}),
		_List_Nil,
		warnings);
};
var $author$project$Types$Passenger$Util$countNotAdultPassengers = function (passengers) {
	return $elm$core$Array$length(passengers) - $author$project$Types$Passenger$Util$countAdultPassengers(passengers);
};
var $author$project$Types$SelectedOnboardServices$limitFriendshipBraceletsCount = F2(
	function (_v0, maxCount) {
		var selected = _v0;
		var limitCount = function (dict) {
			return A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, _v2) {
						var addon = _v2.a;
						var count = _v2.b;
						return _Utils_Tuple2(
							addon,
							A2($elm$core$Basics$min, count, maxCount));
					}),
				dict);
		};
		return _Utils_update(
			selected,
			{
				eV: limitCount(selected.eV),
				fy: limitCount(selected.fy)
			});
	});
var $author$project$Update$limitFriendshipBraceletsCount = function (_v0) {
	var model = _v0.a;
	var session = model.j;
	var cmd = _v0.b;
	var childrenAmount = $author$project$Types$Passenger$Util$countNotAdultPassengers(session.Eg);
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						Gm: A2($author$project$Types$SelectedOnboardServices$limitFriendshipBraceletsCount, session.Gm, childrenAmount)
					})
			}),
		cmd);
};
var $author$project$Constants$sessionExpiredErrorCode = 35001;
var $author$project$Tracking$logSummaryWarnings = function (warning) {
	var translations = $author$project$Translations$forLanguage(0);
	var warningMessage = _Utils_eq(warning.pQ, $author$project$Constants$sessionExpiredErrorCode) ? translations.FG : A2($elm$core$Maybe$withDefault, translations.FD, warning.Cv);
	return $author$project$Tracking$logError(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string('ResponseWarning')),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(warningMessage))
				])));
};
var $author$project$Tracking$encodeUIMessage = F2(
	function (kind, _v0) {
		var field = _v0.a;
		var message = _v0.b;
		var fullMessage = (field !== '') ? (field + (': ' + message)) : message;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(
						$author$project$Tracking$capitalizeString(kind) + ' UIMessage')),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(fullMessage))
				]));
	});
var $elm$regex$Regex$replaceAtMost = _Regex_replaceAtMost;
var $author$project$Translations$valueRegex = function (key) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('{\\s*' + (key + '\\s*}')));
};
var $author$project$Translations$replaceValue = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A3(
		$elm$regex$Regex$replaceAtMost,
		1,
		$author$project$Translations$valueRegex(key),
		function (_v1) {
			return value;
		});
};
var $author$project$Translations$injectValues = F2(
	function (pairs, translationBase) {
		return A3($elm$core$List$foldl, $author$project$Translations$replaceValue, translationBase, pairs);
	});
var $author$project$Common$Toast$typeToString = function (toastType) {
	switch (toastType) {
		case 0:
			return 'notification';
		case 1:
			return 'warning';
		default:
			return 'information';
	}
};
var $author$project$Tracking$logToastUIMessage = function (toast) {
	return $author$project$Tracking$logError(
		A2(
			$author$project$Tracking$encodeUIMessage,
			$author$project$Common$Toast$typeToString(toast.o8),
			A2(
				$elm$core$Tuple$pair,
				'',
				A2(
					$author$project$Translations$injectValues,
					toast.DH,
					toast.pa(
						$author$project$Translations$forLanguage(0))))));
};
var $author$project$Tracking$logUIMessage = F2(
	function (kind, message) {
		return $author$project$Tracking$logError(
			A2(
				$author$project$Tracking$encodeUIMessage,
				kind,
				_Utils_Tuple2('', message)));
	});
var $author$project$Update$Util$mapFailedResponse = F4(
	function (model, httpError, responseType, cmd) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (a) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							a,
							A2($author$project$Tracking$logHttpError, responseType, httpError)
						]));
			},
			function () {
				if (httpError.$ === 2) {
					return _Utils_Tuple2(
						model,
						A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$ConnectionProblem));
				} else {
					return _Utils_Tuple2(model, cmd);
				}
			}());
	});
var $author$project$Update$getTravelClassAvailability = F3(
	function (travelClasses, selectedCode, direction) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$getDirectionTravelClassInfo(direction),
					$elm$core$Maybe$map(
						function ($) {
							return $.uk;
						})),
				A2(
					$author$project$Types$TravelClasses$getTravelClass,
					selectedCode,
					$author$project$Types$TravelClasses$all(travelClasses))));
	});
var $author$project$Types$TravelClasses$selectedTravelClassesCount = F3(
	function (travelClasses, code, direction) {
		switch (travelClasses.$) {
			case 0:
				var selected = travelClasses.a.Gg;
				return _Utils_eq(selected, code) ? 1 : 0;
			case 1:
				var outward = travelClasses.a.Ds;
				var _return = travelClasses.a.FL;
				return function (selectedCode) {
					return _Utils_eq(code, selectedCode) ? 1 : 0;
				}(
					function () {
						if (!direction) {
							return outward;
						} else {
							return _return;
						}
					}());
			case 2:
				var selected = travelClasses.a.Gg;
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(code)),
							selected)));
			default:
				var outward = travelClasses.a.Ds;
				var _return = travelClasses.a.FL;
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(code)),
							function () {
								if (!direction) {
									return outward;
								} else {
									return _return;
								}
							}())));
		}
	});
var $author$project$Update$showLastTravelClassAddedToast = function (_v0) {
	var name = _v0.oh;
	return A2(
		$elm$core$Platform$Cmd$map,
		$author$project$Messages$ToastMsg,
		A4(
			$author$project$Common$Toast$showToastCmdWithParams,
			0,
			function ($) {
				return $.hp;
			},
			false,
			_List_fromArray(
				[
					_Utils_Tuple2('name', name)
				])));
};
var $author$project$Update$maybeShowLastTravelClassWasAddedToast = F3(
	function (selectedCode, direction, travelClasses) {
		var currentTravelClassSelectedCount = A3($author$project$Types$TravelClasses$selectedTravelClassesCount, travelClasses, selectedCode, direction);
		var availability = A3($author$project$Update$getTravelClassAvailability, travelClasses, selectedCode, direction);
		return A2(
			$elm$core$Maybe$andThen,
			_Utils_eq(availability, currentTravelClassSelectedCount) ? A2($elm$core$Basics$composeR, $author$project$Update$showLastTravelClassAddedToast, $elm$core$Maybe$Just) : function (_v0) {
				return $elm$core$Maybe$Nothing;
			},
			A2(
				$author$project$Types$TravelClasses$getTravelClass,
				selectedCode,
				$author$project$Types$TravelClasses$all(travelClasses)));
	});
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Api$Util$dateParam = function (input) {
	return A2($elm$url$Url$Builder$string, 'date', input);
};
var $author$project$Api$Util$experimentalParam = function (input) {
	return A2(
		$elm$url$Url$Builder$string,
		'experimental',
		$author$project$Utils$String$fromBool(input));
};
var $author$project$Api$Util$localeParamFromString = function (input) {
	return A2($elm$url$Url$Builder$string, 'locale', input);
};
var $author$project$Api$Util$marketParamFromString = function (input) {
	return A2($elm$url$Url$Builder$string, 'country', input);
};
var $author$project$Api$Util$nativeParam = function (input) {
	return A2(
		$elm$url$Url$Builder$string,
		'native',
		$author$project$Utils$String$fromBool(input));
};
var $author$project$UrlRoute$mikiRoot = function (currentUrl) {
	return function (_v0) {
		var locale = _v0.n0;
		var country = _v0.nm;
		var date = _v0.nn;
		var experimental = _v0.qi;
		var _native = _v0.oi;
		return A2(
			$elm$url$Url$Builder$absolute,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2($elm$url$Url$Builder$string, 'mobile', 'true'),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2($elm$core$Maybe$map, $author$project$Api$Util$localeParamFromString, locale),
							A2($elm$core$Maybe$map, $author$project$Api$Util$marketParamFromString, country),
							A2($elm$core$Maybe$map, $author$project$Api$Util$dateParam, date),
							A2($elm$core$Maybe$map, $author$project$Api$Util$experimentalParam, experimental),
							A2($elm$core$Maybe$map, $author$project$Api$Util$nativeParam, _native)
						]))));
	}(
		$author$project$UrlRoute$bookingParamsFromLocation(currentUrl));
};
var $author$project$Utils$Route$isAlandDayCruiseFromStockholmOrTurku = F2(
	function (outwardSail, returnSail) {
		return (outwardSail.v2 === 3) && (((outwardSail.v1 === 1) || (outwardSail.v1 === 5)) && A2($author$project$Utils$Time$isSameDay, outwardSail.nr, returnSail.nr));
	});
var $author$project$Types$RouteTripSails$dayTripNotification = function (sails) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(
			false,
			$elm$core$Basics$always('')),
		A2(
			$elm$core$Maybe$map,
			function (returnSail) {
				var outwardSail = $author$project$Types$RouteTripSails$selected(sails).a;
				var isTalHelDayTrip = A2($author$project$Utils$Route$isTalHelRoute, outwardSail.v1, returnSail.v1) && A2($author$project$Utils$Time$isSameDay, outwardSail.nr, returnSail.nr);
				var isStoTurDayTrip = $author$project$Utils$Route$isStoTurRoute(
					{kS: outwardSail.v1, le: returnSail.v1}) && A2($author$project$Utils$Time$isSameDay, outwardSail.ps, returnSail.nr);
				return isTalHelDayTrip ? _Utils_Tuple2(
					true,
					function ($) {
						return $.hk;
					}) : (isStoTurDayTrip ? (((outwardSail.v1 === 1) && (returnSail.v1 === 5)) ? _Utils_Tuple2(
					true,
					function ($) {
						return $.hn;
					}) : _Utils_Tuple2(
					true,
					function ($) {
						return $.ho;
					})) : (A2($author$project$Utils$Route$isAlandDayCruiseFromStockholmOrTurku, outwardSail, returnSail) ? _Utils_Tuple2(
					true,
					function ($) {
						return $.hk;
					}) : _Utils_Tuple2(
					false,
					$elm$core$Basics$always(''))));
			},
			$author$project$Types$RouteTripSails$selected(sails).b));
};
var $author$project$UrlRoute$getTimetableRoute = F3(
	function (voyageType, isTimetableFirstVisit, direction) {
		switch (voyageType.$) {
			case 1:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			case 0:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			case 2:
				return (isTimetableFirstVisit || (!direction)) ? $author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(0)) : $author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(2));
			case 3:
				return (!direction) ? $author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$RouteTrip(0)) : $author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$RouteTrip(2));
			case 4:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			case 5:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			default:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$CruiseMultiDeparture);
		}
	});
var $author$project$Update$Itinerary$onDirectionClick = F2(
	function (model, direction) {
		var session = model.j;
		var timetableRoute = A3($author$project$UrlRoute$getTimetableRoute, session.tx, model.Av, direction);
		var maybeRouteTripSails = $author$project$Types$Trips$toMaybeSuccessRouteTripSails(session.tp);
		var cruiseTripType = function () {
			var _v1 = session.tp;
			if ((!_v1.$) && (!_v1.a.$)) {
				var cruise = _v1.a.a;
				return $author$project$Types$CruiseSails$getMetadata(cruise).mm;
			} else {
				return session.mm;
			}
		}();
		var newSession = _Utils_update(
			session,
			{mm: cruiseTripType});
		var newModel = _Utils_update(
			model,
			{j: newSession});
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				A3(
					$author$project$Utils$List$maybeAddWithMap,
					maybeRouteTripSails,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$RouteTripSails$dayTripNotification,
						function (_v0) {
							var shouldShowDayTripNotification = _v0.a;
							var notification = _v0.b;
							return shouldShowDayTripNotification ? A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								A3($author$project$Common$Toast$showToastCmd, 0, notification, true)) : $elm$core$Platform$Cmd$none;
						}),
					A3(
						$author$project$Utils$List$addIf,
						A2(
							$elm$core$List$member,
							session.tx,
							_List_fromArray(
								[
									$author$project$Types$VoyageType$Shuttle,
									$author$project$Types$VoyageType$RouteTrip,
									$author$project$Types$VoyageType$CruiseMultiDeparture(1),
									$author$project$Types$VoyageType$CruiseMultiDeparture(0)
								])),
						$author$project$Ports$scrollToSelectedSail(0),
						_List_fromArray(
							[
								A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, timetableRoute)
							])))));
	});
var $author$project$Types$JoinClubOneState$RequestFailed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$JoinClubOneState$UserAlreadyExistsError = {$: 2};
var $author$project$Update$onJoinClubOneResponse = F2(
	function (response, model) {
		var session = model.j;
		var state = function () {
			if (!response.$) {
				if (response.a) {
					return $author$project$Types$JoinClubOneState$Joining;
				} else {
					return $author$project$Types$JoinClubOneState$UserAlreadyExistsError;
				}
			} else {
				var error = response.a;
				return $author$project$Types$JoinClubOneState$RequestFailed(error);
			}
		}();
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{AE: state})
			});
	});
var $author$project$Update$Meals$onMealPackagesResponse = F2(
	function (model, response) {
		var session = model.j;
		if (!response.$) {
			var mealPackage = response.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{B2: $elm$core$Maybe$Nothing, rs: mealPackage})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var httpError = response.a;
			return A4(
				$author$project$Update$Util$mapFailedResponse,
				_Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{
								rs: $author$project$Types$MealPackage$Regular(_List_Nil)
							})
					}),
				httpError,
				'mealPackagesResponse',
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$SelectedMeals$init = {vu: _List_Nil, vx: _List_Nil, yw: _List_Nil, Bz: _List_Nil};
var $author$project$Types$Meals$getMealType = function (_v0) {
	var maybeMealType = _v0.BU;
	var beginDateTime = _v0.ut;
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Types$MealType$fromPosix(beginDateTime),
		maybeMealType);
};
var $author$project$Types$SelectedMeals$toSelectedMeal = function (_v0) {
	var beginDateTime = _v0.ut;
	var restaurantCode = _v0.FJ;
	var title = _v0.HI;
	var maybeMealType = _v0.BU;
	return {tS: _List_Nil, ut: beginDateTime, wo: '', BU: maybeMealType, FJ: restaurantCode, HI: title};
};
var $author$project$Update$Meals$addSittingToSelectedMeals = F2(
	function (sitting, selectedMeals) {
		var mealType = $author$project$Types$Meals$getMealType(sitting);
		var meal = $author$project$Types$SelectedMeals$toSelectedMeal(sitting);
		switch (mealType) {
			case 0:
				return _Utils_update(
					selectedMeals,
					{
						vu: A2($elm$core$List$cons, meal, selectedMeals.vu)
					});
			case 1:
				return _Utils_update(
					selectedMeals,
					{
						vx: A2($elm$core$List$cons, meal, selectedMeals.vx)
					});
			case 2:
				return _Utils_update(
					selectedMeals,
					{
						Bz: A2($elm$core$List$cons, meal, selectedMeals.Bz)
					});
			default:
				return _Utils_update(
					selectedMeals,
					{
						yw: A2($elm$core$List$cons, meal, selectedMeals.yw)
					});
		}
	});
var $author$project$Update$Meals$matchesMealParam = F4(
	function (diningKind, restaurantCode, meal, sitting) {
		return sitting.zr && (A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$MealType$toString,
					$elm$core$Basics$eq(diningKind)),
				sitting.BU)) && (A2(
			$elm$core$String$contains,
			restaurantCode,
			$elm$core$String$toUpper(sitting.FJ)) || (A2(
			$elm$core$String$contains,
			restaurantCode,
			$elm$core$String$toUpper(meal.oh)) || A2(
			$elm$core$String$contains,
			restaurantCode,
			$elm$core$String$toUpper(meal.HI)))));
	});
var $author$project$Update$Meals$findMatchingSitting = F3(
	function (isOutward, meals, _v0) {
		var diningKind = _v0.p6;
		var restaurantCode = _v0.FJ;
		return $elm$core$List$head(
			A2(
				$elm$core$List$concatMap,
				function (meal) {
					return A2(
						$elm$core$List$filterMap,
						function (sitting) {
							return A4($author$project$Update$Meals$matchesMealParam, diningKind, restaurantCode, meal, sitting) ? $elm$core$Maybe$Just(sitting) : $elm$core$Maybe$Nothing;
						},
						isOutward ? meal.kC : meal.k4);
				},
				$author$project$Types$Meals$toList(meals)));
	});
var $author$project$Update$Meals$parseMealParam = function (param) {
	var _v0 = A2($elm$core$String$split, ':', param);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var diningKind = _v0.a;
		var _v1 = _v0.b;
		var restaurantCode = _v1.a;
		return $elm$core$Maybe$Just(
			{
				p6: $elm$core$String$trim(diningKind),
				FJ: $elm$core$String$trim(restaurantCode)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Update$Meals$preselectMeals = F2(
	function (params, meals) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($author$project$Types$SelectedMeals$init, $author$project$Types$SelectedMeals$init),
			A2(
				$elm$core$Maybe$map,
				function (mealCodesStr) {
					var toSelectedMeals = A2($elm$core$List$foldl, $author$project$Update$Meals$addSittingToSelectedMeals, $author$project$Types$SelectedMeals$init);
					var parsedParams = A2(
						$elm$core$List$filterMap,
						$author$project$Update$Meals$parseMealParam,
						A2(
							$elm$core$String$split,
							',',
							$elm$core$String$toUpper(mealCodesStr)));
					var findMatchingSittings = function (isOutward) {
						return A2(
							$elm$core$List$filterMap,
							A2($author$project$Update$Meals$findMatchingSitting, isOutward, meals),
							parsedParams);
					};
					return _Utils_Tuple2(
						toSelectedMeals(
							findMatchingSittings(true)),
						toSelectedMeals(
							findMatchingSittings(false)));
				},
				params.rv));
	});
var $author$project$Update$Meals$resetSelectedMealsAndPackage = function (a) {
	return _Utils_update(
		a,
		{B2: $elm$core$Maybe$Nothing, Gn: $author$project$Types$SelectedMeals$init, Go: $author$project$Types$SelectedMeals$init});
};
var $author$project$Update$Meals$onMealsResponse = F2(
	function (model, response) {
		var _v0 = model;
		var session = _v0.j;
		if (!response.$) {
			var meals = response.a;
			var sessionWithMeals = $elm$core$List$isEmpty(
				$author$project$Types$Meals$toList(meals)) ? _Utils_update(
				session,
				{ri: $elm$core$Maybe$Nothing}) : _Utils_update(
				session,
				{
					ri: $elm$core$Maybe$Just(meals)
				});
			var sessionReset = $author$project$Update$Meals$resetSelectedMealsAndPackage(sessionWithMeals);
			var _v2 = _Utils_eq(session.ri, $elm$core$Maybe$Nothing) ? A2(
				$author$project$Update$Meals$preselectMeals,
				$author$project$UrlRoute$bookingParamsFromLocation(model.n1),
				meals) : _Utils_Tuple2($author$project$Types$SelectedMeals$init, $author$project$Types$SelectedMeals$init);
			var preselectedOutward = _v2.a;
			var preselectedReturn = _v2.b;
			var finalSession = _Utils_update(
				sessionReset,
				{Gn: preselectedOutward, Go: preselectedReturn});
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{j: finalSession}),
				$elm$core$Platform$Cmd$none);
		} else {
			var httpError = response.a;
			var newModel = _Utils_update(
				model,
				{
					j: $author$project$Update$Meals$resetSelectedMealsAndPackage(
						_Utils_update(
							session,
							{ri: $elm$core$Maybe$Nothing}))
				});
			return A4($author$project$Update$Util$mapFailedResponse, newModel, httpError, 'mealsResponse', $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Update$User$onSignOut = function (model) {
	return $author$project$Update$User$removeUserData(model);
};
var $author$project$Types$ClubOneSlider$ClientCannotRedeemPoints = {$: 1};
var $author$project$Types$ClubOneSlider$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$ClubOneSlider$Enabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$ClubOneSlider$IncompatibleTargetOffer = {$: 2};
var $author$project$Types$ClubOneSlider$NotEnoughPoints = {$: 0};
var $author$project$Types$ClubOneSlider$OtherReason = function (a) {
	return {$: 3, a: a};
};
var $author$project$Update$Summary$getCouponsCoverage = F3(
	function (summary, vouchers, usedMoney) {
		var nonCouponsDiscount = $elm$core$List$sum(
			A2(
				$elm$core$List$filterMap,
				function ($) {
					return $.ub;
				},
				A2(
					$elm$core$List$filter,
					function (voucher) {
						return voucher.z4 && (!voucher.qO);
					},
					vouchers)));
		var priceWithoutCouponsDiscount = (summary.Fi - $elm$core$Basics$abs(summary.wd)) - nonCouponsDiscount;
		var priceWithMaxPossibleCouponsDiscount = A2(
			$elm$core$Basics$max,
			0,
			A3(
				$elm$core$List$foldl,
				F2(
					function (voucher, acc) {
						return acc - voucher.Fk;
					}),
				priceWithoutCouponsDiscount,
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.z4;
					},
					vouchers)));
		return A2($elm$core$Basics$max, usedMoney - priceWithMaxPossibleCouponsDiscount, 0);
	});
var $author$project$Types$ClubOneSlider$incompatibleTargetOfferCode = 'TARGET OFFERS';
var $author$project$Update$Summary$getMaybeClubOneSlider = F2(
	function (summary, vouchers) {
		var clubOne = summary.pN;
		var sliderInfoToEnabled = function (sliderInfo) {
			var used = sliderInfo.H8;
			var usedMoney = sliderInfo.H9;
			return {
				x4: A3($author$project$Update$Summary$getCouponsCoverage, summary, vouchers, usedMoney),
				mu: sliderInfo,
				E0: used,
				s8: used,
				He: summary.lN
			};
		};
		var sliderInfoToMaybeClubOneSlider = function (sliderInfo) {
			return (!sliderInfo.n6) ? $elm$core$Maybe$Just(
				$author$project$Types$ClubOneSlider$Disabled($author$project$Types$ClubOneSlider$NotEnoughPoints)) : $elm$core$Maybe$Just(
				$author$project$Types$ClubOneSlider$Enabled(
					sliderInfoToEnabled(sliderInfo)));
		};
		var _v0 = clubOne.B5;
		if (!_v0.$) {
			var sliderIncompatiblePromotionGroup = _v0.a;
			return _Utils_eq(sliderIncompatiblePromotionGroup, $author$project$Types$ClubOneSlider$incompatibleTargetOfferCode) ? $elm$core$Maybe$Just(
				$author$project$Types$ClubOneSlider$Disabled($author$project$Types$ClubOneSlider$IncompatibleTargetOffer)) : $elm$core$Maybe$Just(
				$author$project$Types$ClubOneSlider$Disabled(
					$author$project$Types$ClubOneSlider$OtherReason(sliderIncompatiblePromotionGroup)));
		} else {
			var _v1 = clubOne.B4;
			if (!_v1.$) {
				var sliderIncompatibilityReason = _v1.a;
				return (sliderIncompatibilityReason === 'CLIENT_CANNOT_REDEEM_POINTS') ? $elm$core$Maybe$Just(
					$author$project$Types$ClubOneSlider$Disabled($author$project$Types$ClubOneSlider$ClientCannotRedeemPoints)) : $elm$core$Maybe$Just(
					$author$project$Types$ClubOneSlider$Disabled(
						$author$project$Types$ClubOneSlider$OtherReason(sliderIncompatibilityReason)));
			} else {
				return A2($elm$core$Maybe$andThen, sliderInfoToMaybeClubOneSlider, clubOne.B6);
			}
		}
	});
var $author$project$Common$Modal$Model$toString = function (modalType) {
	switch (modalType.$) {
		case 0:
			if (!modalType.a) {
				var _v1 = modalType.a;
				return 'from';
			} else {
				var _v2 = modalType.a;
				return 'to';
			}
		case 1:
			return 'backToDesktop';
		case 2:
			return 'mealPackage';
		case 3:
			return 'resetBooking';
		case 4:
			return 'sessionError';
		case 5:
			return 'shoppingCruise';
		case 6:
			return 'summaryWarning';
		case 7:
			return 'suggestBuyingMeals';
		case 8:
			return 'suggestAddingVehicleToOtherLeg';
		case 9:
			return 'suggestTravellingViaDifferentCity';
		case 10:
			return 'selectVehicle';
		case 11:
			return 'nonRefundableTerms';
		default:
			return 'nonRefundableWarning';
	}
};
var $author$project$UrlRoute$openModal = F3(
	function (navKey, url, modalType) {
		if (!navKey.$) {
			var key = navKey.a;
			return A2(
				$elm$browser$Browser$Navigation$pushUrl,
				key,
				$elm$url$Url$toString(
					A2(
						F2(
							function (urlWithoutModal, param) {
								return function (a) {
									return _Utils_update(
										urlWithoutModal,
										{
											Fo: $elm$core$Maybe$Just(a)
										});
								}(
									A2(
										$elm$core$Maybe$withDefault,
										param,
										A2(
											$elm$core$Maybe$map,
											function (a) {
												return a + ('&' + param);
											},
											urlWithoutModal.Fo)));
							}),
						$author$project$UrlRoute$removeModalParam(url),
						'modal=' + $author$project$Common$Modal$Model$toString(modalType))));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Types$Hotel$SelectedHotelRooms = $elm$core$Basics$identity;
var $author$project$Types$Hotel$remapSelectedHotelRooms = F2(
	function (codesAndCounts, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, value, accumulator) {
					return A2(
						$elm$core$Maybe$withDefault,
						accumulator,
						A2(
							$elm$core$Maybe$map,
							function (room) {
								return A3($elm$core$Dict$insert, key, room, accumulator);
							},
							A2(
								$elm$core$Maybe$map,
								function (_v1) {
									var count = _v1.pZ;
									return _Utils_update(
										value,
										{pZ: count});
								},
								A2(
									$elm_community$list_extra$List$Extra$find,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.pQ;
										},
										$elm$core$Basics$eq(value.pQ)),
									codesAndCounts))));
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Types$Voucher$decodeFromSummary = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$decodeValue(
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'nonRefundable',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'amount',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$elm$json$Json$Decode$string,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'errorCode',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'applied',
								$elm$json$Json$Decode$bool,
								$elm$json$Json$Decode$succeed(
									F5(
										function (a, b, c, d, e) {
											return {ub: d, pQ: c, yQ: b, z4: a, Ak: e};
										}))))))))),
	$elm$core$Result$withDefault(_List_Nil));
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $elm_community$list_extra$List$Extra$span = F2(
	function (p, xs) {
		return _Utils_Tuple2(
			A2($elm_community$list_extra$List$Extra$takeWhile, p, xs),
			A2($elm_community$list_extra$List$Extra$dropWhile, p, xs));
	});
var $elm_community$list_extra$List$Extra$break = function (p) {
	return $elm_community$list_extra$List$Extra$span(
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, p));
};
var $author$project$Update$Summary$remapVoucher = F2(
	function (_v0, voucher) {
		var isApplied = _v0.z4;
		var errorCode = _v0.yQ;
		var amount = _v0.ub;
		var isNonRefundable = _v0.Ak;
		return _Utils_update(
			voucher,
			{ub: amount, yQ: errorCode, z4: isApplied, Ak: isNonRefundable, Ax: true});
	});
var $author$project$Update$Summary$remapVouchers = F2(
	function (aList, bList) {
		if (aList.b) {
			var a = aList.a;
			var a1 = aList.b;
			var _v1 = A2(
				$elm_community$list_extra$List$Extra$break,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$elm$core$Basics$eq(a.pQ)),
				bList);
			if (_v1.b.b) {
				var b1 = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				var b2 = _v2.b;
				return A2(
					$elm$core$List$cons,
					A2($author$project$Update$Summary$remapVoucher, b, a),
					A2(
						$author$project$Update$Summary$remapVouchers,
						a1,
						_Utils_ap(b1, b2)));
			} else {
				var b1 = _v1.a;
				return A2(
					$elm$core$List$cons,
					a,
					A2($author$project$Update$Summary$remapVouchers, a1, b1));
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Update$Summary$remapVouchersInModel = F2(
	function (list, model) {
		var session = model.j;
		var vouchers = A2(
			$author$project$Update$Summary$remapVouchers,
			session.tw,
			$author$project$Types$Voucher$decodeFromSummary(list));
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{tw: vouchers})
			});
	});
var $author$project$Types$SelectedExtraServices$ExtraServiceSet = $elm$core$Basics$identity;
var $author$project$Types$SelectedExtraServices$init = {DC: $elm$core$Dict$empty, lK: _List_Nil, FV: $elm$core$Dict$empty, lQ: _List_Nil};
var $author$project$Types$SelectedExtraServices$add = F2(
	function (code, _v0) {
		var set = _v0;
		return A3(
			$elm$core$Dict$insert,
			$author$project$Types$ExtraService$codeToString(code),
			code,
			set);
	});
var $author$project$Types$SelectedExtraServices$addForDirection = F3(
	function (code, direction, selectedExtraServices) {
		if (!direction) {
			return _Utils_update(
				selectedExtraServices,
				{
					DC: A2($author$project$Types$SelectedExtraServices$add, code, selectedExtraServices.DC)
				});
		} else {
			return _Utils_update(
				selectedExtraServices,
				{
					FV: A2($author$project$Types$SelectedExtraServices$add, code, selectedExtraServices.FV)
				});
		}
	});
var $author$project$Types$ExtraService$garageString = 'GARAGE';
var $author$project$Types$ExtraService$garageCode = $author$project$Types$ExtraService$garageString;
var $author$project$Types$ExtraService$priorityCarString = 'PRIORITY CAR';
var $author$project$Types$ExtraService$isPriorityCar = function (_v0) {
	var code = _v0;
	return _Utils_eq(code, $author$project$Types$ExtraService$priorityCarString);
};
var $author$project$Types$ExtraService$priorityCarFCString = 'PRIORITY CAR FC';
var $author$project$Types$ExtraService$isPriorityCarFC = function (_v0) {
	var code = _v0;
	return _Utils_eq(code, $author$project$Types$ExtraService$priorityCarFCString);
};
var $author$project$Types$ExtraService$priorityCarPLString = 'PRIORITY CAR PL';
var $author$project$Types$ExtraService$isPriorityCarPL = function (_v0) {
	var code = _v0;
	return _Utils_eq(code, $author$project$Types$ExtraService$priorityCarPLString);
};
var $author$project$Types$ExtraService$isAnyPriorityCarCode = function (code) {
	return $author$project$Types$ExtraService$isPriorityCar(code) || ($author$project$Types$ExtraService$isPriorityCarFC(code) || $author$project$Types$ExtraService$isPriorityCarPL(code));
};
var $author$project$Types$ExtraService$isGarage = function (_v0) {
	var code = _v0;
	return _Utils_eq(code, $author$project$Types$ExtraService$garageString);
};
var $author$project$Types$SelectedExtraServices$isSelected = F2(
	function (code, _v0) {
		var set = _v0;
		return A2(
			$elm$core$List$any,
			function (c) {
				return _Utils_eq(code, c);
			},
			$elm$core$Dict$values(set));
	});
var $author$project$Types$SelectedExtraServices$toSelected = function (direction) {
	if (!direction) {
		return function ($) {
			return $.DC;
		};
	} else {
		return function ($) {
			return $.FV;
		};
	}
};
var $author$project$Types$SelectedExtraServices$isSelectedInDirection = F3(
	function (direction, code, selectedExtraServices) {
		return A2(
			$author$project$Types$SelectedExtraServices$isSelected,
			code,
			A2($author$project$Types$SelectedExtraServices$toSelected, direction, selectedExtraServices));
	});
var $author$project$Types$ExtraService$priorityCarCode = $author$project$Types$ExtraService$priorityCarString;
var $author$project$Types$ExtraService$priorityCarFCCode = $author$project$Types$ExtraService$priorityCarFCString;
var $author$project$Types$ExtraService$priorityCarPLCode = $author$project$Types$ExtraService$priorityCarPLString;
var $author$project$Types$SelectedExtraServices$remove = F2(
	function (code, _v0) {
		var set = _v0.a;
		var unselected = _v0.b;
		return A2($author$project$Types$SelectedExtraServices$isSelected, code, set) ? _Utils_Tuple2(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (_v1, c) {
						return !_Utils_eq(code, c);
					}),
				set),
			A2($elm$core$List$cons, code, unselected)) : _Utils_Tuple2(set, unselected);
	});
var $author$project$Types$SelectedExtraServices$removeForDirection = F3(
	function (code, direction, selectedExtraServices) {
		if (!direction) {
			var _v1 = A2(
				$author$project$Types$SelectedExtraServices$remove,
				code,
				_Utils_Tuple2(selectedExtraServices.DC, selectedExtraServices.lK));
			var outwards = _v1.a;
			var outwardsUnselected = _v1.b;
			return _Utils_update(
				selectedExtraServices,
				{DC: outwards, lK: outwardsUnselected});
		} else {
			var _v2 = A2(
				$author$project$Types$SelectedExtraServices$remove,
				code,
				_Utils_Tuple2(selectedExtraServices.FV, selectedExtraServices.lQ));
			var returns = _v2.a;
			var returnsUnselected = _v2.b;
			return _Utils_update(
				selectedExtraServices,
				{FV: returns, lQ: returnsUnselected});
		}
	});
var $author$project$Types$SelectedExtraServices$toggle = F3(
	function (direction, code, selectedExtraServices) {
		return A3($author$project$Types$SelectedExtraServices$isSelectedInDirection, direction, code, selectedExtraServices) ? A3($author$project$Types$SelectedExtraServices$removeForDirection, code, direction, selectedExtraServices) : ($author$project$Types$ExtraService$isAnyPriorityCarCode(code) ? A3(
			$author$project$Types$SelectedExtraServices$removeForDirection,
			$author$project$Types$ExtraService$garageCode,
			direction,
			A3($author$project$Types$SelectedExtraServices$addForDirection, code, direction, selectedExtraServices)) : ($author$project$Types$ExtraService$isGarage(code) ? A3(
			$author$project$Types$SelectedExtraServices$removeForDirection,
			$author$project$Types$ExtraService$priorityCarFCCode,
			direction,
			A3(
				$author$project$Types$SelectedExtraServices$removeForDirection,
				$author$project$Types$ExtraService$priorityCarPLCode,
				direction,
				A3(
					$author$project$Types$SelectedExtraServices$removeForDirection,
					$author$project$Types$ExtraService$priorityCarCode,
					direction,
					A3($author$project$Types$SelectedExtraServices$addForDirection, code, direction, selectedExtraServices)))) : A3($author$project$Types$SelectedExtraServices$addForDirection, code, direction, selectedExtraServices)));
	});
var $author$project$Update$Summary$selectedExtraServicesFromSummary = F2(
	function (summary, selectedExtraServices) {
		var addServices = F3(
			function (direction, services, extraServices) {
				return A3(
					$elm$core$List$foldl,
					F2(
						function (_v0, acc) {
							var code = _v0.pQ;
							return A3($author$project$Types$SelectedExtraServices$toggle, direction, code, acc);
						}),
					extraServices,
					services);
			});
		return A3(
			addServices,
			0,
			summary.qk.rP,
			A3(
				addServices,
				1,
				summary.qk.st,
				function (a) {
					return _Utils_update(
						a,
						{lK: selectedExtraServices.lK, lQ: selectedExtraServices.lQ});
				}($author$project$Types$SelectedExtraServices$init)));
	});
var $author$project$Update$Summary$showGarageChangedToPriorityCarFCToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Messages$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		0,
		function ($) {
			return $.g0;
		},
		false));
var $author$project$Update$Summary$showPriorityCarChangedToPriorityCarFCToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Messages$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		0,
		function ($) {
			return $.g1;
		},
		false));
var $author$project$Types$SelectedExtraServices$toStringList = function (_v0) {
	var set = _v0;
	return $elm$core$Dict$keys(set);
};
var $author$project$Update$Summary$wasGarageChangedToPriorityCarFC = F2(
	function (oldExtraServices, newExtraServices) {
		return (A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($author$project$Types$ExtraService$garageString),
			$author$project$Types$SelectedExtraServices$toStringList(oldExtraServices.DC)) && A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.pQ;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$ExtraService$codeToString,
					$elm$core$Basics$eq($author$project$Types$ExtraService$priorityCarFCString))),
			newExtraServices.rP)) || (A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($author$project$Types$ExtraService$garageString),
			$author$project$Types$SelectedExtraServices$toStringList(oldExtraServices.FV)) && A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.pQ;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$ExtraService$codeToString,
					$elm$core$Basics$eq($author$project$Types$ExtraService$priorityCarFCString))),
			newExtraServices.st));
	});
var $author$project$Update$Summary$wasPriorityCarChangedToPriorityCarFC = F2(
	function (oldExtraServices, newExtraServices) {
		return (A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($author$project$Types$ExtraService$priorityCarString),
			$author$project$Types$SelectedExtraServices$toStringList(oldExtraServices.DC)) && A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.pQ;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$ExtraService$codeToString,
					$elm$core$Basics$eq($author$project$Types$ExtraService$priorityCarFCString))),
			newExtraServices.rP)) || (A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($author$project$Types$ExtraService$priorityCarString),
			$author$project$Types$SelectedExtraServices$toStringList(oldExtraServices.FV)) && A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.pQ;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$ExtraService$codeToString,
					$elm$core$Basics$eq($author$project$Types$ExtraService$priorityCarFCString))),
			newExtraServices.st));
	});
var $author$project$Update$Summary$onSummaryResponse = F2(
	function (model, summaryResponse) {
		var session = model.j;
		if (!summaryResponse.$) {
			var summary = summaryResponse.a.s4;
			var vouchers = summaryResponse.a.tw;
			var selectedHotelRooms = function (a) {
				return A2($author$project$Types$Hotel$remapSelectedHotelRooms, a, session.Gk);
			}(
				A2(
					$elm$core$List$map,
					function (a) {
						return {pQ: a.FY, pZ: a.FZ};
					},
					summary.Gk));
			return _Utils_Tuple2(
				function (newModel) {
					return _Utils_update(
						newModel,
						{
							j: function (newSession) {
								return _Utils_update(
									newSession,
									{
										n8: A2($author$project$Update$Summary$getMaybeClubOneSlider, summary, newSession.tw)
									});
							}(newModel.j)
						});
				}(
					A2(
						$author$project$Update$Summary$remapVouchersInModel,
						vouchers,
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{
										Af: false,
										B7: $elm$core$Maybe$Just(summary),
										Ez: false,
										Gi: A2($author$project$Update$Summary$selectedExtraServicesFromSummary, summary, session.Gi),
										Gk: selectedHotelRooms,
										Gl: (!summary.uh) ? _List_Nil : session.Gl,
										G4: summary.G4
									})
							}))),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Update$Summary$wasPriorityCarChangedToPriorityCarFC, session.Gi, summary.qk) ? $author$project$Update$Summary$showPriorityCarChangedToPriorityCarFCToast : (A2($author$project$Update$Summary$wasGarageChangedToPriorityCarFC, session.Gi, summary.qk) ? $author$project$Update$Summary$showGarageChangedToPriorityCarFCToast : $elm$core$Platform$Cmd$none)
						])));
		} else {
			var error = summaryResponse.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{Af: false, B7: $elm$core$Maybe$Nothing})
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$SessionError),
							A2($author$project$Tracking$logHttpError, 'summaryResponse', error.a)
						])));
		}
	});
var $author$project$Types$TravelClasses$addTravelClassSelectionsFromQueryParams = F4(
	function (travelClasses, passengers, count, code) {
		var adultCount = $author$project$Types$Passenger$Util$countAdultPassengers(passengers);
		switch (travelClasses.$) {
			case 0:
				var available = travelClasses.a.nb;
				return A2(
					$elm$core$Maybe$withDefault,
					travelClasses,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.DA;
							},
							$elm$core$Maybe$map(
								function (_v1) {
									var availability = _v1.uk;
									var maxAvailableCapacity = _v1.mJ;
									return (_Utils_cmp(availability * maxAvailableCapacity, adultCount) > -1) ? $author$project$Types$TravelClasses$OneWaySingle(
										{nb: available, k: $elm$core$Dict$empty, Gg: code}) : travelClasses;
								})),
						A2(
							$author$project$Types$TravelClasses$getTravelClass,
							code,
							$author$project$Types$TravelClasses$allFromAvailable(available))));
			case 1:
				var available = travelClasses.a.nb;
				var isCodeAvailableForBothDirections = F2(
					function (outwardInfo, returnInfo) {
						return (_Utils_cmp(outwardInfo.uk * outwardInfo.mJ, adultCount) > -1) && (_Utils_cmp(returnInfo.uk * returnInfo.mJ, adultCount) > -1);
					});
				return A2(
					$elm$core$Maybe$withDefault,
					travelClasses,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (outwardInfo, returnInfo) {
								return A2(isCodeAvailableForBothDirections, outwardInfo, returnInfo) ? $author$project$Types$TravelClasses$TwoWaySingle(
									{nb: available, Ds: code, m: $elm$core$Dict$empty, FL: code, t: $elm$core$Dict$empty}) : travelClasses;
							}),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.DA;
							},
							A2(
								$author$project$Types$TravelClasses$getTravelClass,
								code,
								$author$project$Types$TravelClasses$allFromAvailable(available))),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.FT;
							},
							A2(
								$author$project$Types$TravelClasses$getTravelClass,
								code,
								$author$project$Types$TravelClasses$allFromAvailable(available)))));
			case 2:
				var available = travelClasses.a.nb;
				return A2(
					$elm$core$Maybe$withDefault,
					travelClasses,
					A2(
						$elm$core$Maybe$map,
						function (outwardInfo) {
							return ((_Utils_cmp(count, adultCount) < 1) && (_Utils_cmp(count, outwardInfo.uk) < 1)) ? $author$project$Types$TravelClasses$OneWayMultiple(
								{
									nb: available,
									k: $elm$core$Dict$empty,
									Gg: _List_fromArray(
										[
											_Utils_Tuple2(code, count)
										])
								}) : travelClasses;
						},
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.DA;
							},
							A2(
								$author$project$Types$TravelClasses$getTravelClass,
								code,
								$author$project$Types$TravelClasses$allFromAvailable(available)))));
			default:
				var available = travelClasses.a.nb;
				var isCodeAvailableForBothDirections = F2(
					function (outwardInfo, returnInfo) {
						return (_Utils_cmp(count, adultCount) < 1) && ((_Utils_cmp(count, outwardInfo.uk) < 1) && (_Utils_cmp(count, returnInfo.uk) < 1));
					});
				return A2(
					$elm$core$Maybe$withDefault,
					travelClasses,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (outwardInfo, returnInfo) {
								return A2(isCodeAvailableForBothDirections, outwardInfo, returnInfo) ? $author$project$Types$TravelClasses$TwoWayMultiple(
									{
										nb: available,
										Ds: _List_fromArray(
											[
												_Utils_Tuple2(code, count)
											]),
										m: $elm$core$Dict$empty,
										FL: _List_fromArray(
											[
												_Utils_Tuple2(code, count)
											]),
										t: $elm$core$Dict$empty
									}) : travelClasses;
							}),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.DA;
							},
							A2(
								$author$project$Types$TravelClasses$getTravelClass,
								code,
								$author$project$Types$TravelClasses$allFromAvailable(available))),
						A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.FT;
							},
							A2(
								$author$project$Types$TravelClasses$getTravelClass,
								code,
								$author$project$Types$TravelClasses$allFromAvailable(available)))));
		}
	});
var $author$project$Types$TravelClasses$initOneWayMultiple = function (available) {
	return $author$project$Types$TravelClasses$OneWayMultiple(
		{nb: available, k: $elm$core$Dict$empty, Gg: _List_Nil});
};
var $author$project$Types$TravelClasses$initOneWayMultipleWithPreselection = F2(
	function (available, passengers) {
		var preselectedDeck = A4(
			$author$project$Types$TravelClasses$setAllPassengersInAlaDeck,
			_List_Nil,
			$author$project$Types$TravelClasses$allFromAvailable(available),
			passengers,
			0);
		return $author$project$Types$TravelClasses$OneWayMultiple(
			{nb: available, k: $elm$core$Dict$empty, Gg: preselectedDeck});
	});
var $author$project$Update$TravelClass$initOneWayMultiple = F2(
	function (session, available) {
		return $author$project$Utils$Route$isStoTurRoute(session) ? $author$project$Types$TravelClasses$initOneWayMultiple(available) : A2($author$project$Types$TravelClasses$initOneWayMultipleWithPreselection, available, session.Eg);
	});
var $author$project$Types$TravelClasses$initOneWaySingle = function (travelClasses) {
	return $author$project$Types$TravelClasses$OneWaySingle(
		{
			nb: travelClasses,
			k: $elm$core$Dict$empty,
			Gg: A2(
				$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
				$author$project$Types$TravelClasses$allFromAvailable(travelClasses),
				0)
		});
};
var $author$project$Types$TravelClasses$initTwoWayMultiple = function (available) {
	return $author$project$Types$TravelClasses$TwoWayMultiple(
		{nb: available, Ds: _List_Nil, m: $elm$core$Dict$empty, FL: _List_Nil, t: $elm$core$Dict$empty});
};
var $author$project$Types$TravelClasses$initTwoWayMultipleWithPreselection = F2(
	function (available, passengers) {
		var returnPreselectedDeck = A4(
			$author$project$Types$TravelClasses$setAllPassengersInAlaDeck,
			_List_Nil,
			$author$project$Types$TravelClasses$allFromAvailable(available),
			passengers,
			1);
		var outwardPreselectedDeck = A4(
			$author$project$Types$TravelClasses$setAllPassengersInAlaDeck,
			_List_Nil,
			$author$project$Types$TravelClasses$allFromAvailable(available),
			passengers,
			0);
		return $author$project$Types$TravelClasses$TwoWayMultiple(
			{nb: available, Ds: outwardPreselectedDeck, m: $elm$core$Dict$empty, FL: returnPreselectedDeck, t: $elm$core$Dict$empty});
	});
var $author$project$Update$TravelClass$initTwoWayMultiple = F2(
	function (session, available) {
		return $author$project$Utils$Route$isStoTurRoute(session) ? $author$project$Types$TravelClasses$initTwoWayMultiple(available) : A2($author$project$Types$TravelClasses$initTwoWayMultipleWithPreselection, available, session.Eg);
	});
var $author$project$Types$TravelClasses$initTwoWaySingle = function (travelClasses) {
	return $author$project$Types$TravelClasses$TwoWaySingle(
		{
			nb: travelClasses,
			Ds: A2(
				$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
				$author$project$Types$TravelClasses$allFromAvailable(travelClasses),
				0),
			m: $elm$core$Dict$empty,
			FL: A2(
				$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
				$author$project$Types$TravelClasses$allFromAvailable(travelClasses),
				1),
			t: $elm$core$Dict$empty
		});
};
var $author$project$Update$TravelClass$isNonStoTurToStoTurRoute = function (session) {
	var routeOfTravelClasses = session.F1;
	return $author$project$Utils$Route$isStoTurRoute(session) && (!$author$project$Utils$Route$isStoTurRoute(routeOfTravelClasses));
};
var $author$project$Types$TravelClasses$isTravelClassesWithDefaultSelection = function (oldTravelClasses) {
	switch (oldTravelClasses.$) {
		case 0:
			var selected = oldTravelClasses.a.Gg;
			var available = oldTravelClasses.a.nb;
			return _Utils_eq(
				selected,
				A2(
					$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
					$author$project$Types$TravelClasses$allFromAvailable(available),
					0));
		case 1:
			var outward = oldTravelClasses.a.Ds;
			var _return = oldTravelClasses.a.FL;
			var available = oldTravelClasses.a.nb;
			var returnFirstAvailable = A2(
				$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
				$author$project$Types$TravelClasses$allFromAvailable(available),
				1);
			var outwardFirstAvailable = A2(
				$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
				$author$project$Types$TravelClasses$allFromAvailable(available),
				0);
			return _Utils_eq(outward, outwardFirstAvailable) && _Utils_eq(_return, returnFirstAvailable);
		case 2:
			var selected = oldTravelClasses.a.Gg;
			return A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
				selected);
		default:
			var outward = oldTravelClasses.a.Ds;
			var _return = oldTravelClasses.a.FL;
			return A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
				outward) && A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
				_return);
	}
};
var $author$project$Utils$List$diffBy = F3(
	function (_function, aList, bList) {
		var newBList = A2($elm$core$List$map, _function, bList);
		return A2(
			$elm$core$List$filter,
			function (a) {
				return !A2(
					$elm$core$List$member,
					_function(a),
					newBList);
			},
			aList);
	});
var $author$project$Types$TravelClasses$wasAnyPreviouslySelectedTravelClassRemoved = F2(
	function (old, _new) {
		var _v0 = _Utils_Tuple2(old, _new);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return !_Utils_eq(a.Gg, b.Gg);
					} else {
						break _v0$4;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return ($elm$core$String$isEmpty(b.FL) && (!_Utils_eq(a.Ds, b.Ds))) || ((!_Utils_eq(a.Ds, b.Ds)) || (!_Utils_eq(a.FL, b.FL)));
					} else {
						break _v0$4;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return !$elm$core$List$isEmpty(
							A3($author$project$Utils$List$diffBy, $elm$core$Basics$identity, a.Gg, b.Gg));
					} else {
						break _v0$4;
					}
				default:
					if (_v0.b.$ === 3) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return $elm$core$List$isEmpty(b.FL) ? (!$elm$core$List$isEmpty(
							A3($author$project$Utils$List$diffBy, $elm$core$Basics$identity, a.Ds, b.Ds))) : ((!$elm$core$List$isEmpty(
							A3($author$project$Utils$List$diffBy, $elm$core$Basics$identity, a.Ds, b.Ds))) || (!$elm$core$List$isEmpty(
							A3($author$project$Utils$List$diffBy, $elm$core$Basics$identity, a.FL, b.FL))));
					} else {
						break _v0$4;
					}
			}
		}
		return false;
	});
var $author$project$Update$TravelClass$isPossibleToShowInformationToast = F2(
	function (_v0, newTravelClasses) {
		var session = _v0.j;
		var location = _v0.n1;
		var isShuttlePage = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(
				$author$project$UrlRoute$parseLocation(location)),
			_List_fromArray(
				[
					$author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(0)),
					$author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(2)),
					$author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(1)),
					$author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(3))
				]));
		var isOvernightSailOnShuttlePage = function () {
			var _v1 = session.tp;
			if ((!_v1.$) && (_v1.a.$ === 1)) {
				var route = _v1.a.a;
				return isShuttlePage && $author$project$Types$RouteTripSails$isReturnOvernightSail(route);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (oldTravelClasses) {
					return A2($author$project$Types$TravelClasses$wasAnyPreviouslySelectedTravelClassRemoved, oldTravelClasses, newTravelClasses) && ((!$author$project$Types$TravelClasses$isTravelClassesWithDefaultSelection(oldTravelClasses)) && ((!isOvernightSailOnShuttlePage) && (!$author$project$Update$TravelClass$isNonStoTurToStoTurRoute(session))));
				},
				session.to));
	});
var $author$project$Utils$Route$isShoppingCruise = function (voyageType) {
	if ((voyageType.$ === 6) && (voyageType.a === 1)) {
		var _v1 = voyageType.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Types$TravelClasses$isOutwardPetCageAvailable = F2(
	function (key, available) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Ds;
					},
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(key)))),
				available.EC));
	});
var $author$project$Types$TravelClasses$isOutwardTravelClassAvailable = F2(
	function (available, _v0) {
		var selectedCode = _v0.a;
		var count = _v0.b;
		return !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.DA;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function (_v1) {
								var code = _v1.pQ;
								var availability = _v1.uk;
								return _Utils_eq(selectedCode, code) && (_Utils_cmp(availability, count) > -1);
							}),
						$elm$core$Maybe$withDefault(false))),
				$author$project$Types$TravelClasses$allFromAvailable(available)));
	});
var $author$project$Types$TravelClasses$initOneWayMultipleWithSelections = F3(
	function (selected, pets, available) {
		var availableSelections = A2(
			$elm$core$List$filter,
			$author$project$Types$TravelClasses$isOutwardTravelClassAvailable(available),
			selected);
		return (!$elm$core$List$isEmpty(availableSelections)) ? A3(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Types$TravelClasses$OneWayMultiple),
			$elm$core$Basics$identity,
			{
				nb: available,
				k: A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v0) {
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Types$TravelClasses$isOutwardTravelClassAvailable(available),
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(key)),
										availableSelections))) || A2($author$project$Types$TravelClasses$isOutwardPetCageAvailable, key, available);
						}),
					pets),
				Gg: availableSelections
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Types$TravelClasses$restoreOneWayMultipleFromSelections = F2(
	function (available, travelClasses) {
		switch (travelClasses.$) {
			case 2:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				return A3($author$project$Types$TravelClasses$initOneWayMultipleWithSelections, selected, pets, available);
			case 3:
				var outward = travelClasses.a.Ds;
				var outwardPets = travelClasses.a.m;
				return A3($author$project$Types$TravelClasses$initOneWayMultipleWithSelections, outward, outwardPets, available);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Types$TravelClasses$preselectForEmptySelection = F4(
	function (available, passengers, direction, selection) {
		return $elm$core$List$isEmpty(selection) ? A4(
			$author$project$Types$TravelClasses$setAllPassengersInAlaDeck,
			_List_Nil,
			$author$project$Types$TravelClasses$allFromAvailable(available),
			passengers,
			direction) : selection;
	});
var $author$project$Types$TravelClasses$restoreOneWayMultipleFromSelectionsWithPreselection = F3(
	function (available, passengers, travelClasses) {
		switch (travelClasses.$) {
			case 2:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				return A3(
					$author$project$Types$TravelClasses$initOneWayMultipleWithSelections,
					A4($author$project$Types$TravelClasses$preselectForEmptySelection, available, passengers, 0, selected),
					pets,
					available);
			case 3:
				var outward = travelClasses.a.Ds;
				var outwardPets = travelClasses.a.m;
				return A3(
					$author$project$Types$TravelClasses$initOneWayMultipleWithSelections,
					A4($author$project$Types$TravelClasses$preselectForEmptySelection, available, passengers, 0, outward),
					outwardPets,
					available);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Update$TravelClass$restoreOneWayMultipleFromSelections = F2(
	function (session, available) {
		return $author$project$Update$TravelClass$isNonStoTurToStoTurRoute(session) ? function (_v0) {
			return $elm$core$Maybe$Just(
				$author$project$Types$TravelClasses$initOneWayMultiple(available));
		} : ($author$project$Utils$Route$isStoTurRoute(session) ? $author$project$Types$TravelClasses$restoreOneWayMultipleFromSelections(available) : A2($author$project$Types$TravelClasses$restoreOneWayMultipleFromSelectionsWithPreselection, available, session.Eg));
	});
var $author$project$Types$TravelClasses$initOneWaySingleWithSelections = F3(
	function (code, pets, available) {
		return A2(
			$author$project$Types$TravelClasses$isOutwardTravelClassAvailable,
			available,
			_Utils_Tuple2(code, 1)) ? A3(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Types$TravelClasses$OneWaySingle),
			$elm$core$Basics$identity,
			{
				nb: available,
				k: A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v0) {
							return A2(
								$author$project$Types$TravelClasses$isOutwardTravelClassAvailable,
								available,
								_Utils_Tuple2(key, 1)) || A2($author$project$Types$TravelClasses$isOutwardPetCageAvailable, key, available);
						}),
					pets),
				Gg: code
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Types$TravelClasses$restoreOneWaySingleFromSelections = F2(
	function (available, travelClasses) {
		switch (travelClasses.$) {
			case 0:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				return A3($author$project$Types$TravelClasses$initOneWaySingleWithSelections, selected, pets, available);
			case 1:
				var outward = travelClasses.a.Ds;
				var outwardPets = travelClasses.a.m;
				return A3($author$project$Types$TravelClasses$initOneWaySingleWithSelections, outward, outwardPets, available);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Types$TravelClasses$isReturnPetCageAvailable = F2(
	function (key, available) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.Ds;
					},
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(key)))),
				available.EC));
	});
var $author$project$Types$TravelClasses$isReturnTravelClassAvailable = F2(
	function (available, _v0) {
		var selectedCode = _v0.a;
		var count = _v0.b;
		return !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.FT;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function (_v1) {
								var code = _v1.pQ;
								var availability = _v1.uk;
								return _Utils_eq(selectedCode, code) && (_Utils_cmp(availability, count) > -1);
							}),
						$elm$core$Maybe$withDefault(false))),
				$author$project$Types$TravelClasses$allFromAvailable(available)));
	});
var $author$project$Types$TravelClasses$initTwoWayMultipleWithSelections = F3(
	function (twoWay, pets, available) {
		var availableReturnSelections = A2(
			$elm$core$List$filter,
			$author$project$Types$TravelClasses$isReturnTravelClassAvailable(available),
			twoWay.FL);
		var availableOutwardSelections = A2(
			$elm$core$List$filter,
			$author$project$Types$TravelClasses$isOutwardTravelClassAvailable(available),
			twoWay.Ds);
		return ((!$elm$core$List$isEmpty(availableOutwardSelections)) || (!$elm$core$List$isEmpty(availableReturnSelections))) ? A3(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Types$TravelClasses$TwoWayMultiple),
			$elm$core$Basics$identity,
			{
				nb: available,
				Ds: availableOutwardSelections,
				m: A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v0) {
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Types$TravelClasses$isOutwardTravelClassAvailable(available),
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(key)),
										availableOutwardSelections))) || A2($author$project$Types$TravelClasses$isOutwardPetCageAvailable, key, available);
						}),
					pets.Ds),
				FL: availableReturnSelections,
				t: A2(
					$elm$core$Dict$filter,
					F2(
						function (key, _v1) {
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Types$TravelClasses$isReturnTravelClassAvailable(available),
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Tuple$first,
											$elm$core$Basics$eq(key)),
										availableReturnSelections))) || A2($author$project$Types$TravelClasses$isReturnPetCageAvailable, key, available);
						}),
					pets.FL)
			}) : $elm$core$Maybe$Nothing;
	});
var $author$project$Types$TravelClasses$restoreTwoWayMultipleFromSelections = F2(
	function (available, travelClasses) {
		switch (travelClasses.$) {
			case 2:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				return A3(
					$author$project$Types$TravelClasses$initTwoWayMultipleWithSelections,
					{Ds: selected, FL: _List_Nil},
					{Ds: pets, FL: $elm$core$Dict$empty},
					available);
			case 3:
				var outward = travelClasses.a.Ds;
				var outwardPets = travelClasses.a.m;
				var _return = travelClasses.a.FL;
				var returnPets = travelClasses.a.t;
				return A3(
					$author$project$Types$TravelClasses$initTwoWayMultipleWithSelections,
					{Ds: outward, FL: _return},
					{Ds: outwardPets, FL: returnPets},
					available);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Types$TravelClasses$restoreTwoWayMultipleFromSelectionsWithPreselection = F3(
	function (available, passengers, travelClasses) {
		switch (travelClasses.$) {
			case 2:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				return A3(
					$author$project$Types$TravelClasses$initTwoWayMultipleWithSelections,
					{
						Ds: A4($author$project$Types$TravelClasses$preselectForEmptySelection, available, passengers, 0, selected),
						FL: A4(
							$author$project$Types$TravelClasses$setAllPassengersInAlaDeck,
							_List_Nil,
							$author$project$Types$TravelClasses$allFromAvailable(available),
							passengers,
							1)
					},
					{Ds: pets, FL: $elm$core$Dict$empty},
					available);
			case 3:
				var outward = travelClasses.a.Ds;
				var outwardPets = travelClasses.a.m;
				var _return = travelClasses.a.FL;
				var returnPets = travelClasses.a.t;
				return A3(
					$author$project$Types$TravelClasses$initTwoWayMultipleWithSelections,
					{
						Ds: A4($author$project$Types$TravelClasses$preselectForEmptySelection, available, passengers, 0, outward),
						FL: A4($author$project$Types$TravelClasses$preselectForEmptySelection, available, passengers, 1, _return)
					},
					{Ds: outwardPets, FL: returnPets},
					available);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Update$TravelClass$restoreTwoWayMultipleFromSelections = F2(
	function (session, available) {
		return $author$project$Update$TravelClass$isNonStoTurToStoTurRoute(session) ? function (_v0) {
			return $elm$core$Maybe$Just(
				$author$project$Types$TravelClasses$initTwoWayMultiple(available));
		} : ($author$project$Utils$Route$isStoTurRoute(session) ? $author$project$Types$TravelClasses$restoreTwoWayMultipleFromSelections(available) : A2($author$project$Types$TravelClasses$restoreTwoWayMultipleFromSelectionsWithPreselection, available, session.Eg));
	});
var $author$project$Types$TravelClasses$initTwoWaySingleWithSelections = F3(
	function (twoWay, pets, available) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var outward = _v0.Ds;
				var _return = _v0.FL;
				return A3(
					$elm$core$Basics$composeL,
					$author$project$Types$TravelClasses$TwoWaySingle,
					$elm$core$Basics$identity,
					{
						nb: available,
						Ds: outward,
						m: A2(
							$elm$core$Dict$filter,
							F2(
								function (key, _v1) {
									return A2(
										$author$project$Types$TravelClasses$isOutwardTravelClassAvailable,
										available,
										_Utils_Tuple2(key, 1)) || A2($author$project$Types$TravelClasses$isOutwardPetCageAvailable, key, available);
								}),
							pets.Ds),
						FL: _return,
						t: A2(
							$elm$core$Dict$filter,
							F2(
								function (key, _v2) {
									return A2(
										$author$project$Types$TravelClasses$isReturnTravelClassAvailable,
										available,
										_Utils_Tuple2(key, 1)) || A2($author$project$Types$TravelClasses$isReturnPetCageAvailable, key, available);
								}),
							pets.FL)
					});
			},
			(A2(
				$author$project$Types$TravelClasses$isOutwardTravelClassAvailable,
				available,
				_Utils_Tuple2(twoWay.Ds, 1)) && A2(
				$author$project$Types$TravelClasses$isReturnTravelClassAvailable,
				available,
				_Utils_Tuple2(twoWay.FL, 1))) ? $elm$core$Maybe$Just(
				{Ds: twoWay.Ds, FL: twoWay.FL}) : (A2(
				$author$project$Types$TravelClasses$isOutwardTravelClassAvailable,
				available,
				_Utils_Tuple2(twoWay.Ds, 1)) ? $elm$core$Maybe$Just(
				{
					Ds: twoWay.Ds,
					FL: A2(
						$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
						$author$project$Types$TravelClasses$allFromAvailable(available),
						1)
				}) : (A2(
				$author$project$Types$TravelClasses$isReturnTravelClassAvailable,
				available,
				_Utils_Tuple2(twoWay.FL, 1)) ? $elm$core$Maybe$Just(
				{
					Ds: A2(
						$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
						$author$project$Types$TravelClasses$allFromAvailable(available),
						0),
					FL: twoWay.FL
				}) : $elm$core$Maybe$Nothing)));
	});
var $author$project$Types$TravelClasses$restoreTwoWaySingleFromSelections = F2(
	function (available, travelClasses) {
		switch (travelClasses.$) {
			case 0:
				var selected = travelClasses.a.Gg;
				var pets = travelClasses.a.k;
				return A3(
					$author$project$Types$TravelClasses$initTwoWaySingleWithSelections,
					{
						Ds: selected,
						FL: A2(
							$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
							$author$project$Types$TravelClasses$allFromAvailable(available),
							1)
					},
					{Ds: pets, FL: $elm$core$Dict$empty},
					available);
			case 1:
				var outward = travelClasses.a.Ds;
				var outwardPets = travelClasses.a.m;
				var _return = travelClasses.a.FL;
				var returnPets = travelClasses.a.t;
				return A3(
					$author$project$Types$TravelClasses$initTwoWaySingleWithSelections,
					{Ds: outward, FL: _return},
					{Ds: outwardPets, FL: returnPets},
					available);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Update$TravelClass$onNormalResponse = F2(
	function (model, travelClassResponse) {
		var _v0 = model;
		var session = _v0.j;
		if ($elm$core$List$isEmpty(
			$author$project$Types$TravelClasses$allFromAvailable(travelClassResponse))) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{H0: $author$project$TravelClassPage$Model$init}),
				$elm$core$Platform$Cmd$none);
		} else {
			var urlParams = $author$project$UrlRoute$bookingParamsFromLocation(model.n1);
			var isRouteTripOneWayOrCruise = (_Utils_eq(session.tx, $author$project$Types$VoyageType$RouteTrip) && session.qW) || A2(
				$elm$core$List$member,
				session.tx,
				_List_fromArray(
					[
						$author$project$Types$VoyageType$Cruise,
						$author$project$Types$VoyageType$CruiseMultistop,
						$author$project$Types$VoyageType$CruiseMultiDeparture(0)
					]));
			var baseTravelClasses = (isRouteTripOneWayOrCruise ? A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					A2($author$project$Update$TravelClass$restoreOneWayMultipleFromSelections, session, travelClassResponse)),
				$elm$core$Maybe$withDefault(
					A2($author$project$Update$TravelClass$initOneWayMultiple, session, travelClassResponse))) : (((_Utils_eq(session.tx, $author$project$Types$VoyageType$Shuttle) && session.qW) || ($author$project$Utils$Route$isShoppingCruise(session.tx) || _Utils_eq(session.tx, $author$project$Types$VoyageType$CruiseParty))) ? A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					$author$project$Types$TravelClasses$restoreOneWaySingleFromSelections(travelClassResponse)),
				$elm$core$Maybe$withDefault(
					$author$project$Types$TravelClasses$initOneWaySingle(travelClassResponse))) : ((_Utils_eq(session.tx, $author$project$Types$VoyageType$Shuttle) && (!session.qW)) ? A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					$author$project$Types$TravelClasses$restoreTwoWaySingleFromSelections(travelClassResponse)),
				$elm$core$Maybe$withDefault(
					$author$project$Types$TravelClasses$initTwoWaySingle(travelClassResponse))) : A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					A2($author$project$Update$TravelClass$restoreTwoWayMultipleFromSelections, session, travelClassResponse)),
				$elm$core$Maybe$withDefault(
					A2($author$project$Update$TravelClass$initTwoWayMultiple, session, travelClassResponse))))))(session.to);
			var travelClasses = _Utils_eq(session.to, $elm$core$Maybe$Nothing) ? A2(
				$elm$core$Maybe$withDefault,
				baseTravelClasses,
				A2(
					$elm$core$Maybe$map,
					A3(
						$author$project$Types$TravelClasses$addTravelClassSelectionsFromQueryParams,
						baseTravelClasses,
						session.Eg,
						A2($elm$core$Maybe$withDefault, 1, urlParams.H$)),
					urlParams.m$)) : baseTravelClasses;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{
								to: $elm$core$Maybe$Just(travelClasses)
							}),
						H0: $author$project$TravelClassPage$Model$init
					}),
				A2($author$project$Update$TravelClass$isPossibleToShowInformationToast, model, travelClasses) ? A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Messages$ToastMsg,
					A3(
						$author$project$Common$Toast$showToastCmd,
						2,
						function ($) {
							return $.g2;
						},
						false)) : $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$TravelClasses$mergeAvailableTravelClasses = F2(
	function (travelClasses, newAvailable) {
		var addAvailableTravelClasses = function (available) {
			return {
				EB: newAvailable.EB,
				EC: newAvailable.EC,
				ED: newAvailable.ED,
				EE: newAvailable.EE,
				r1: newAvailable.r1,
				Fx: _Utils_ap(available.Fx, newAvailable.Fx),
				kI: newAvailable.kI,
				GN: newAvailable.GN
			};
		};
		var addToOneWay = function (_v2) {
			var oneWay = _v2;
			return _Utils_update(
				oneWay,
				{
					nb: addAvailableTravelClasses(oneWay.nb)
				});
		};
		var addToTwoWay = function (_v1) {
			var twoWay = _v1;
			return _Utils_update(
				twoWay,
				{
					nb: addAvailableTravelClasses(twoWay.nb)
				});
		};
		switch (travelClasses.$) {
			case 0:
				var oneWay = travelClasses.a;
				return $author$project$Types$TravelClasses$OneWaySingle(
					addToOneWay(oneWay));
			case 1:
				var twoWay = travelClasses.a;
				return $author$project$Types$TravelClasses$TwoWaySingle(
					addToTwoWay(twoWay));
			case 2:
				var oneWay = travelClasses.a;
				return $author$project$Types$TravelClasses$OneWayMultiple(
					addToOneWay(oneWay));
			default:
				var twoWay = travelClasses.a;
				return $author$project$Types$TravelClasses$TwoWayMultiple(
					addToTwoWay(twoWay));
		}
	});
var $author$project$Update$TravelClass$onSpecialResponse = F3(
	function (model, availableTravelClasses, travelClasses) {
		var _v0 = model;
		var session = _v0.j;
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						to: $elm$core$Maybe$Just(
							A2($author$project$Types$TravelClasses$mergeAvailableTravelClasses, travelClasses, availableTravelClasses))
					})
			});
	});
var $author$project$Update$TravelClass$updateRouteOfTravelClasses = function (model) {
	var _v0 = model;
	var session = _v0.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{
					F1: {kS: session.kS, le: session.le}
				})
		});
};
var $author$project$Update$TravelClass$updateVehiclesAndSailsOfTravelClasses = function (model) {
	var _v0 = model;
	var session = _v0.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{
					Ij: $author$project$Update$TravelClass$vehiclesAndSailsOf(session)
				})
		});
};
var $author$project$Update$TravelClass$onTravelClassResponse = F2(
	function (model, response) {
		if (!response.$) {
			var _v1 = response.a;
			var requestType = _v1.a;
			var decoded = _v1.b.yk;
			var value = _v1.b.Ib;
			return A2(
				$elm$core$Tuple$mapFirst,
				function (a) {
					return _Utils_update(
						a,
						{
							j: function (b) {
								return _Utils_update(
									b,
									{pr: true});
							}(a.j)
						});
				},
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Update$TravelClass$updateRouteOfTravelClasses,
					function () {
						switch (requestType) {
							case 0:
								return function (_v3) {
									var newModel = _v3.a;
									var cmds = _v3.b;
									return _Utils_Tuple2(
										newModel,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													$author$project$Update$TravelClass$isSpecialTravelClassRequestSupported(model.j) ? A2(
													$elm$core$Maybe$withDefault,
													$elm$core$Platform$Cmd$none,
													$author$project$Update$TravelClass$getSpecialTravelClasses(newModel)) : $elm$core$Platform$Cmd$none,
													cmds
												])));
								}(
									A2($author$project$Update$TravelClass$onNormalResponse, model, decoded));
							case 1:
								return A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Update$TravelClass$updateVehiclesAndSailsOfTravelClasses,
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												A2($author$project$Update$TravelClass$onSpecialResponse, model, decoded),
												function (a) {
													return A2(
														F2(
															function (_v4, b) {
																return _Utils_Tuple2(a, b);
															}),
														a,
														$elm$core$Platform$Cmd$none);
												}),
											model.j.to)));
							default:
								return A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Update$TravelClass$updateVehiclesAndSailsOfTravelClasses,
									A2($author$project$Update$TravelClass$onNormalResponse, model, decoded));
						}
					}()));
		} else {
			var httpError = response.a;
			return A4(
				$author$project$Update$Util$mapFailedResponse,
				_Utils_update(
					model,
					{H0: $author$project$TravelClassPage$Model$init}),
				httpError,
				'travelClassResponse',
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$SelectedVehicles$mapShopperAndParkedCarToTwoWay = function (selectedVehicle) {
	return ((selectedVehicle.jZ === 8) || ((selectedVehicle.jZ === 9) || (selectedVehicle.jZ === 6))) ? _Utils_update(
		selectedVehicle,
		{
			tx: $elm$core$Maybe$Just(0)
		}) : selectedVehicle;
};
var $author$project$Types$Passenger$Util$countUnderagePassengers = function (passengers) {
	return A2($author$project$Types$Passenger$Util$countPassengersOfAgeCategory, passengers, 3) + A2($author$project$Types$Passenger$Util$countPassengersOfAgeCategory, passengers, 1);
};
var $author$project$Types$SelectedVehicles$canAddCategoryToMultiVehicleRoute = F3(
	function (passengers, category, categories) {
		var underagesCount = $author$project$Types$Passenger$Util$countUnderagePassengers(passengers);
		var bicyclesCount = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				$elm$core$Basics$eq(0),
				categories));
		var allVehiclesCount = $elm$core$List$length(categories);
		var adultsCount = $author$project$Types$Passenger$Util$countAdultPassengers(passengers);
		return (!category) ? (_Utils_cmp(adultsCount + underagesCount, allVehiclesCount) > 0) : ((_Utils_cmp(adultsCount + underagesCount, allVehiclesCount) > 0) && (_Utils_cmp(adultsCount, allVehiclesCount - bicyclesCount) > 0));
	});
var $author$project$Types$SelectedVehicles$canAddCategory = F4(
	function (isExactlyOneVehicleRequiredForRoute, session, carCategory, categories) {
		return isExactlyOneVehicleRequiredForRoute(session) ? ($elm$core$List$length(categories) < 1) : A3($author$project$Types$SelectedVehicles$canAddCategoryToMultiVehicleRoute, session.Eg, carCategory, categories);
	});
var $author$project$Utils$Route$isExactlyOneVehicleRequiredForOutward = A2($elm$core$Basics$composeR, $author$project$Utils$Route$outwardRequiredArguments, $author$project$Utils$Route$isExactlyOneVehicleRequiredForSail);
var $author$project$Types$SelectedVehicles$canAddCategoryForOutward = $author$project$Types$SelectedVehicles$canAddCategory($author$project$Utils$Route$isExactlyOneVehicleRequiredForOutward);
var $author$project$Utils$Route$isExactlyOneVehicleRequiredForReturn = A2($elm$core$Basics$composeR, $author$project$Utils$Route$returnRequiredArguments, $author$project$Utils$Route$isExactlyOneVehicleRequiredForSail);
var $author$project$Types$SelectedVehicles$canAddCategoryForReturn = $author$project$Types$SelectedVehicles$canAddCategory($author$project$Utils$Route$isExactlyOneVehicleRequiredForReturn);
var $author$project$Types$SelectedVehicles$isVehicleWithAnyVoyageType = F2(
	function (voyageTypes, vehicle) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$eq(vehicle.tx),
				$elm$core$Maybe$Just),
			voyageTypes);
	});
var $author$project$Types$SelectedVehicles$getOutwardCategories = function (vehicles) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.jZ;
		},
		A2(
			$elm$core$List$filter,
			$author$project$Types$SelectedVehicles$isVehicleWithAnyVoyageType(
				_List_fromArray(
					[1, 0])),
			$author$project$Types$SelectedVehicles$toList(vehicles)));
};
var $author$project$Types$SelectedVehicles$getReturnCategories = function (vehicles) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.jZ;
		},
		A2(
			$elm$core$List$filter,
			$author$project$Types$SelectedVehicles$isVehicleWithAnyVoyageType(
				_List_fromArray(
					[2, 0])),
			$author$project$Types$SelectedVehicles$toList(vehicles)));
};
var $author$project$Types$SelectedVehicles$isMaxVehicleCountReached = F3(
	function (session, carCategory, maybeSelectedVehicles) {
		var passengers = session.Eg;
		var from = session.kS;
		var isOneWay = session.qW;
		var returnCategories = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$getReturnCategories, maybeSelectedVehicles));
		var outwardCategories = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$getOutwardCategories, maybeSelectedVehicles));
		return isOneWay ? (!A3($author$project$Types$SelectedVehicles$canAddCategoryForOutward, session, carCategory, outwardCategories)) : ((!A3($author$project$Types$SelectedVehicles$canAddCategoryForOutward, session, carCategory, outwardCategories)) && (!A3($author$project$Types$SelectedVehicles$canAddCategoryForReturn, session, carCategory, returnCategories)));
	});
var $author$project$Types$SelectedVehicles$getNumberOfSelectedVehiclesInDirection = F2(
	function (direction, selectedVehicles) {
		return A2(
			$elm_community$list_extra$List$Extra$count,
			(!direction) ? $author$project$Types$SelectedVehicles$isOutwardSelected : $author$project$Types$SelectedVehicles$isReturnSelected,
			selectedVehicles);
	});
var $author$project$Types$SelectedVehicles$getNumberOfSelectedVehiclesInDirectionByCategory = F3(
	function (direction, carCategory, selectedVehicles) {
		return A2(
			$author$project$Types$SelectedVehicles$getNumberOfSelectedVehiclesInDirection,
			direction,
			A2(
				$elm$core$List$filter,
				function (selectedVehicle) {
					return _Utils_eq(selectedVehicle.jZ, carCategory);
				},
				selectedVehicles));
	});
var $author$project$Types$SelectedVehicles$isVehicleSoldOutForNrOfSelectedVehiclesInDirection = F3(
	function (direction, _v0, numberOfSelectedVehiclesInDirection) {
		var outwardDetails = _v0.Du;
		var returnDetails = _v0.FN;
		var remainingAvailability = function (details) {
			return details.uk - numberOfSelectedVehiclesInDirection;
		};
		if (!direction) {
			return remainingAvailability(outwardDetails) < 1;
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, remainingAvailability, returnDetails)) < 1;
		}
	});
var $author$project$Types$SelectedVehicles$isVehicleSoldOut = F3(
	function (direction, vehicle, selectedVehicles) {
		return A3(
			$author$project$Types$SelectedVehicles$isVehicleSoldOutForNrOfSelectedVehiclesInDirection,
			direction,
			vehicle,
			A3($author$project$Types$SelectedVehicles$getNumberOfSelectedVehiclesInDirectionByCategory, direction, vehicle.jZ, selectedVehicles));
	});
var $author$project$Types$SelectedVehicles$remapAvailability = F3(
	function (session, selectedVehicle, selectedVehiclesList) {
		return A2(
			$elm$core$Maybe$withDefault,
			selectedVehiclesList,
			A2(
				$elm$core$Maybe$map,
				function (vehicleAvailability) {
					var returnSoldOut = A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 1, vehicleAvailability, selectedVehiclesList);
					var outwardSoldOut = A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 0, vehicleAvailability, selectedVehiclesList);
					var isMaxNumberOfSelectedVehiclesReached = A3(
						$author$project$Types$SelectedVehicles$isMaxVehicleCountReached,
						session,
						selectedVehicle.jZ,
						$author$project$Types$SelectedVehicles$fromList(selectedVehiclesList));
					if (isMaxNumberOfSelectedVehiclesReached) {
						return selectedVehiclesList;
					} else {
						var _v0 = selectedVehicle.tx;
						if (!_v0.$) {
							switch (_v0.a) {
								case 0:
									var _v1 = _v0.a;
									return (outwardSoldOut && returnSoldOut) ? selectedVehiclesList : (outwardSoldOut ? A2(
										$elm$core$List$append,
										selectedVehiclesList,
										_List_fromArray(
											[
												_Utils_update(
												selectedVehicle,
												{
													tx: $elm$core$Maybe$Just(2)
												})
											])) : (returnSoldOut ? A2(
										$elm$core$List$append,
										selectedVehiclesList,
										_List_fromArray(
											[
												_Utils_update(
												selectedVehicle,
												{
													tx: $elm$core$Maybe$Just(1)
												})
											])) : A2(
										$elm$core$List$append,
										selectedVehiclesList,
										_List_fromArray(
											[selectedVehicle]))));
								case 1:
									var _v2 = _v0.a;
									return outwardSoldOut ? selectedVehiclesList : A2(
										$elm$core$List$append,
										selectedVehiclesList,
										_List_fromArray(
											[selectedVehicle]));
								default:
									var _v3 = _v0.a;
									return returnSoldOut ? selectedVehiclesList : A2(
										$elm$core$List$append,
										selectedVehiclesList,
										_List_fromArray(
											[selectedVehicle]));
							}
						} else {
							return selectedVehiclesList;
						}
					}
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jZ;
						},
						$elm$core$Basics$eq(selectedVehicle.jZ)),
					session.tt)));
	});
var $author$project$Types$SelectedVehicles$getAvailableRemaps = function (category) {
	switch (category) {
		case 6:
			return _List_fromArray(
				[7, 1, 2, 8]);
		case 7:
			return _List_fromArray(
				[6, 1, 2, 8]);
		case 8:
			return _List_fromArray(
				[6, 7, 1, 2]);
		case 1:
			return _List_fromArray(
				[2, 6, 7, 8]);
		case 2:
			return _List_fromArray(
				[1, 6, 7, 8]);
		case 9:
			return _List_fromArray(
				[11]);
		default:
			return _List_Nil;
	}
};
var $author$project$Types$SelectedVehicles$getRemappedCarCategory = F2(
	function (vehicles, category) {
		return A2(
			$elm$core$Maybe$withDefault,
			category,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.jZ;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (a) {
						return A2(
							$elm$core$List$member,
							a.jZ,
							$author$project$Types$SelectedVehicles$getAvailableRemaps(category));
					},
					vehicles)));
	});
var $author$project$Types$SelectedVehicles$remapSelectedVehicleCategory = F2(
	function (vehicles, selectedVehicle) {
		return _Utils_update(
			selectedVehicle,
			{
				jZ: A2($author$project$Types$SelectedVehicles$getRemappedCarCategory, vehicles, selectedVehicle.jZ)
			});
	});
var $author$project$Types$SelectedVehicles$remapVehicleList = function (session) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$author$project$Types$SelectedVehicles$remapSelectedVehicleCategory(session.tt)),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($author$project$Types$SelectedVehicles$mapShopperAndParkedCarToTwoWay),
			A2(
				$elm$core$List$foldl,
				$author$project$Types$SelectedVehicles$remapAvailability(session),
				_List_Nil)));
};
var $author$project$Types$SelectedVehicles$remap = function (session) {
	return $author$project$Types$SelectedVehicles$fromList(
		A2($author$project$Types$SelectedVehicles$remapVehicleList, session, session.yq));
};
var $author$project$Update$Vehicles$defaultVehicle = function (voyageType) {
	return {
		jZ: 1,
		Ai: false,
		Aj: false,
		n_: $elm$core$Maybe$Nothing,
		n$: $elm$core$Maybe$Nothing,
		tx: $elm$core$Maybe$Just(voyageType)
	};
};
var $author$project$Types$Vehicle$isDefaultCarCategory = function (carCategory) {
	return A2(
		$elm$core$List$member,
		carCategory,
		_List_fromArray(
			[1, 2, 6, 7, 8]));
};
var $author$project$Update$Vehicles$desiredVehicle = F2(
	function (maybeMemorized, voyageType) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Update$Vehicles$defaultVehicle(voyageType),
			A2(
				$elm$core$Maybe$map,
				function (memorizedVehicle) {
					return $author$project$Types$Vehicle$isDefaultCarCategory(memorizedVehicle.jZ) ? _Utils_update(
						memorizedVehicle,
						{
							jZ: 1,
							Ai: true,
							tx: $elm$core$Maybe$Just(voyageType)
						}) : $author$project$Update$Vehicles$defaultVehicle(voyageType);
				},
				maybeMemorized));
	});
var $author$project$Update$Vehicles$remapForRouteWithRequiredVehicle = F2(
	function (vehiclePage, session) {
		var voyageType = session.qW ? 1 : ((($author$project$Utils$Route$isVehicleRequiredForOutward(session) && $author$project$Utils$Route$isVehicleRequiredForReturn(session)) || ($author$project$Utils$Route$isVehicleRequiredForOnlyOneLeg(session) && _Utils_eq(
			session.tL,
			$elm$core$Maybe$Just(true)))) ? 0 : ($author$project$Utils$Route$isVehicleRequiredForOutward(session) ? 1 : 2));
		return function (a) {
			return _Utils_update(
				session,
				{
					yq: _List_fromArray(
						[a])
				});
		}(
			A2(
				$elm$core$Maybe$withDefault,
				A2($author$project$Update$Vehicles$desiredVehicle, vehiclePage.BV, voyageType),
				$elm$core$List$head(
					A2(
						$elm$core$List$map,
						function (v) {
							return _Utils_update(
								v,
								{
									tx: (_Utils_eq(
										v.tx,
										$elm$core$Maybe$Just(0)) || ((_Utils_eq(
										v.tx,
										$elm$core$Maybe$Just(1)) && (voyageType === 2)) || (_Utils_eq(
										v.tx,
										$elm$core$Maybe$Just(2)) && (voyageType === 1)))) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Just(voyageType)
								});
						},
						A2(
							$elm$core$List$filter,
							function (v) {
								return A2(
									$elm$core$List$any,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.jZ;
										},
										$elm$core$Basics$eq(v.jZ)),
									session.tt);
							},
							session.yq)))));
	});
var $author$project$Types$SelectedVehicles$countSelected = function (selectedVehicles) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tx;
				},
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			$author$project$Types$SelectedVehicles$toList(selectedVehicles)));
};
var $author$project$Update$Vehicles$vehicleNotAvailableForDepartureToastCmd = F2(
	function (_v0, previousSelectedVehicles) {
		var desiredVehicles = _v0.yq;
		var maybeSelectedVehicles = _v0.rp;
		var count = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Types$SelectedVehicles$countSelected),
			$elm$core$Maybe$withDefault(0));
		var hasSelectedVehicleCountChanged = !_Utils_eq(
			count(previousSelectedVehicles),
			count(maybeSelectedVehicles));
		return (hasSelectedVehicleCountChanged && (_Utils_cmp(
			$elm$core$List$length(desiredVehicles),
			count(maybeSelectedVehicles)) > 0)) ? A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Messages$ToastMsg,
			A3(
				$author$project$Common$Toast$showToastCmd,
				1,
				function ($) {
					return $.hx;
				},
				false)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Update$Vehicles$onVehiclesResponse = F2(
	function (model, response) {
		var session = model.j;
		var vehiclePage = model.Ih;
		if (!response.$) {
			var vehicles = response.a;
			var newVehiclePage = function (a) {
				return _Utils_update(
					vehiclePage,
					{lr: a});
			}(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jZ;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jZ;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$Just,
								$elm$core$Basics$eq(vehiclePage.lr))),
						vehicles)));
			var hasCarAndCarAlaOvrngt = function (carCategories) {
				return A2($elm$core$List$member, 1, carCategories) && A2($elm$core$List$member, 2, carCategories);
			}(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.jZ;
					},
					vehicles));
			var vehiclesWithoutDuplicatedCars = A2(
				$elm$core$List$filter,
				function (vehicle) {
					return hasCarAndCarAlaOvrngt ? (vehicle.jZ !== 1) : true;
				},
				vehicles);
			var newSession = function (a) {
				return _Utils_update(
					a,
					{
						rp: $author$project$Types$SelectedVehicles$remap(a)
					});
			}(
				($author$project$Utils$Route$isVehicleRequired(session) ? $author$project$Update$Vehicles$remapForRouteWithRequiredVehicle(vehiclePage) : $elm$core$Basics$identity)(
					_Utils_update(
						session,
						{Ag: false, tt: vehiclesWithoutDuplicatedCars})));
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{j: newSession, Ih: newVehiclePage}),
				A2($author$project$Update$Vehicles$vehicleNotAvailableForDepartureToastCmd, newSession, session.rp));
		} else {
			var httpError = response.a;
			return A4($author$project$Update$Util$mapFailedResponse, model, httpError, 'vehiclesResponse', $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Session$openFirstTicketGroup = function (session) {
	var firstTicketGroup = $elm$core$List$head(
		A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var events = _v0.mq;
				var x = events.a;
				var xs = events.b;
				return _Utils_ap(
					x.Hu,
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.Hu;
						},
						xs));
			},
			A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, session.AZ)));
	return _Utils_update(
		session,
		{
			BX: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.zN;
				},
				firstTicketGroup)
		});
};
var $author$project$Messages$FinishedOpeningModal = F2(
	function (a, b) {
		return {$: 123, a: a, b: b};
	});
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $author$project$Update$Modal$opened = function (modalType) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$withDefault(0),
			$author$project$Messages$FinishedOpeningModal(modalType)),
		A2(
			$elm$core$Task$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.In;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.IE;
					},
					$elm$core$Task$succeed)),
			$elm$browser$Browser$Dom$getViewport));
};
var $author$project$Api$Endpoint$confirmReservation = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['confirmReservation']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Types$ContactPerson$encode = function (contactPerson) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(contactPerson.yI)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(
					$elm$core$String$toLower(contactPerson.y2))),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(
					$elm$core$String$toLower(contactPerson.A6))),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(contactPerson.ox)),
				_Utils_Tuple2(
				'zip',
				$elm$json$Json$Encode$string(contactPerson.jX))
			]));
};
var $author$project$Types$AgeCategory$toString = function (ageCategory) {
	switch (ageCategory) {
		case 0:
			return 'adult';
		case 1:
			return 'youth';
		case 2:
			return 'child';
		default:
			return 'junior';
	}
};
var $author$project$Types$AgeCategory$encode = A2($elm$core$Basics$composeR, $author$project$Types$AgeCategory$toString, $elm$json$Json$Encode$string);
var $author$project$Types$Gender$toString = function (gender) {
	if (!gender) {
		return 'F';
	} else {
		return 'M';
	}
};
var $author$project$Types$Gender$encode = function (gender) {
	return $elm$json$Json$Encode$string(
		$elm$core$String$toUpper(
			$author$project$Types$Gender$toString(gender)));
};
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $author$project$Types$Date$toString = function (_v0) {
	var year = _v0.h;
	var month = _v0.s;
	var day = _v0.q;
	return $elm$core$String$fromInt(year) + ('-' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$Utils$Time$monthToInt(month))) + ('-' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(day)))));
};
var $author$project$Api$Reservation$encodePassenger = function (passenger) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'ageCategory',
						$author$project$Types$AgeCategory$encode(passenger.tY))),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('birthday'),
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Types$Date$toString)),
					passenger.uw),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('citizenship'),
						$elm$json$Json$Encode$string),
					passenger.v_),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('clubOneNumber'),
						$elm$json$Json$Encode$string),
					passenger.we),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('gender'),
						$author$project$Types$Gender$encode),
					passenger.zf),
					$elm$core$String$isEmpty(passenger.y2) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					_Utils_Tuple2(
						'firstName',
						$elm$json$Json$Encode$string(
							$elm$core$String$toLower(passenger.y2)))),
					$elm$core$String$isEmpty(passenger.A6) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					_Utils_Tuple2(
						'lastName',
						$elm$json$Json$Encode$string(
							$elm$core$String$toLower(passenger.A6))))
				])));
};
var $author$project$Types$PaymentServiceProviderCode$toString = function (code) {
	switch (code) {
		case 0:
			return 'SWEDBANK';
		case 1:
			return 'ADYEN';
		default:
			return 'KLARNA';
	}
};
var $author$project$Api$Reservation$encodePayment = function (paymentType) {
	switch (paymentType.$) {
		case 0:
			var provider = paymentType.a;
			return A3(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$json$Json$Encode$object, $elm$core$List$singleton),
				$elm$core$Tuple$pair('type'),
				$elm$json$Json$Encode$string(
					$author$project$Types$PaymentServiceProviderCode$toString(provider)));
		case 1:
			return A3(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$json$Json$Encode$object, $elm$core$List$singleton),
				$elm$core$Tuple$pair('freeTrip'),
				$elm$json$Json$Encode$bool(true));
		default:
			return A3(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$json$Json$Encode$object, $elm$core$List$singleton),
				$elm$core$Tuple$pair('type'),
				$elm$json$Json$Encode$string('invoice'));
	}
};
var $author$project$Api$Reservation$isMyJourneySupported = function (_v0) {
	var maybeSummary = _v0.B7;
	var reservationData = _v0.Fz;
	var protractor = _v0.se;
	return (!protractor) && A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.qU;
				},
				reservationData),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Maybe$Just,
					function ($) {
						return $.qU;
					}),
				maybeSummary)));
};
var $author$project$Api$Reservation$queryString = function (_v0) {
	var isExperimental = _v0.Aa;
	var protractor = _v0.se;
	return function (list) {
		return (!$elm$core$List$isEmpty(list)) ? $elm$core$Maybe$Just(
			A2($elm$core$String$join, '&', list)) : $elm$core$Maybe$Nothing;
	}(
		A3(
			$author$project$Utils$List$addIf,
			protractor,
			'protractor',
			A3($author$project$Utils$List$addIf, isExperimental, 'experimental', _List_Nil)));
};
var $author$project$Api$Reservation$mobileCancelUrl = function (_v0) {
	var location = _v0.n1;
	var session = _v0.j;
	return $author$project$Api$Reservation$isMyJourneySupported(session) ? _Utils_ap(
		session.zM.Gs.og,
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$append('/?'),
				$author$project$Api$Reservation$queryString(session)))) : (session.zM.Gs.px + ('/payment?backendError=paymentRejected' + A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append('&'),
			$author$project$Api$Reservation$queryString(session)))));
};
var $author$project$Api$Reservation$mobileRejectUrl = function (_v0) {
	var location = _v0.n1;
	var session = _v0.j;
	return $author$project$Api$Reservation$isMyJourneySupported(session) ? _Utils_ap(
		session.zM.Gs.og,
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$append('/?'),
					$author$project$Api$Reservation$queryString(session))),
			session.Aa ? '#paymentRejected' : '')) : (session.zM.Gs.px + ('/payment?backendError=paymentRejected' + A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append('&'),
			$author$project$Api$Reservation$queryString(session)))));
};
var $author$project$Api$Reservation$mobileSuccessUrl = function (_v0) {
	var location = _v0.n1;
	var session = _v0.j;
	return $author$project$Api$Reservation$isMyJourneySupported(session) ? (session.zM.Gs.og + ('/?f' + A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append('&'),
			$author$project$Api$Reservation$queryString(session))))) : $elm$url$Url$toString(
		_Utils_update(
			location,
			{
				y8: $elm$core$Maybe$Just('f'),
				Eh: '/confirmation',
				Fo: $author$project$Api$Reservation$queryString(session)
			}));
};
var $author$project$Api$Reservation$encodeRedirectUrls = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'successUrl',
				$elm$json$Json$Encode$string(
					$author$project$Api$Reservation$mobileSuccessUrl(model))),
				_Utils_Tuple2(
				'rejectUrl',
				$elm$json$Json$Encode$string(
					$author$project$Api$Reservation$mobileRejectUrl(model))),
				_Utils_Tuple2(
				'cancelUrl',
				$elm$json$Json$Encode$string(
					$author$project$Api$Reservation$mobileCancelUrl(model)))
			]));
};
var $author$project$Types$TravelClasses$encodeSelected = function (travelClasses) {
	var isSameForAll = function () {
		switch (travelClasses.$) {
			case 0:
				return true;
			case 1:
				return true;
			default:
				return false;
		}
	}();
	return A3(
		$elm$core$Basics$composeR,
		$author$project$Types$TravelClasses$getSelectedCodeCountPairLists,
		function (_v0) {
			var outbound = _v0.Dr;
			var inbound = _v0.zT;
			return {
				As: isSameForAll,
				DC: $elm$json$Json$Encode$object(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond($elm$json$Json$Encode$int),
						outbound)),
				FV: $elm$json$Json$Encode$object(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond($elm$json$Json$Encode$int),
						inbound))
			};
		},
		travelClasses);
};
var $author$project$Api$Reservation$encodeTravelClasses = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$TravelClasses$encodeSelected,
	function (_v0) {
		var outwards = _v0.DC;
		var returns = _v0.FV;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('outwards', outwards),
					_Utils_Tuple2('returns', returns)
				]));
	});
var $author$project$Api$Reservation$encodeVehicleForReservation = function (_v0) {
	var carCategory = _v0.jZ;
	var licensePlate = _v0.n_;
	var licensePlateTrailer = _v0.n$;
	var vehicleVoyageType = _v0.l$;
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'code',
						$elm$json$Json$Encode$string(
							$author$project$Types$Vehicle$carCategoryToString(carCategory)))),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('licensePlate'),
						$elm$json$Json$Encode$string),
					licensePlate),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('licensePlateTrailer'),
						$elm$json$Json$Encode$string),
					licensePlateTrailer),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'voyageType',
						$elm$json$Json$Encode$string(
							$author$project$Types$Vehicle$vehicleVoyageTypeToString(
								$elm$core$Maybe$Just(vehicleVoyageType)))))
				])));
};
var $author$project$Api$Reservation$encodeVehicles = F2(
	function (vehicles, selectedVehicles) {
		return A2(
			$elm$json$Json$Encode$list,
			$author$project$Api$Reservation$encodeVehicleForReservation,
			A2(
				$elm$core$List$concatMap,
				function (vehicle) {
					var _v1 = _Utils_Tuple2(vehicle.jZ, vehicle.l$);
					_v1$2:
					while (true) {
						if (_v1.a === 2) {
							switch (_v1.b) {
								case 2:
									var _v2 = _v1.a;
									var _v3 = _v1.b;
									return _List_fromArray(
										[
											_Utils_update(
											vehicle,
											{jZ: 1})
										]);
								case 0:
									var _v4 = _v1.a;
									var _v5 = _v1.b;
									return _List_fromArray(
										[
											_Utils_update(
											vehicle,
											{jZ: 2, l$: 1}),
											_Utils_update(
											vehicle,
											{jZ: 1, l$: 2})
										]);
								default:
									break _v1$2;
							}
						} else {
							break _v1$2;
						}
					}
					return _List_fromArray(
						[vehicle]);
				},
				A2(
					$elm$core$List$filterMap,
					function (selectedVehicle) {
						var _v0 = selectedVehicle.tx;
						if (!_v0.$) {
							var vehicleVoyageType = _v0.a;
							return $elm$core$Maybe$Just(
								{jZ: selectedVehicle.jZ, n_: selectedVehicle.n_, n$: selectedVehicle.n$, l$: vehicleVoyageType});
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					A2(
						$elm$core$List$filter,
						function (selectedVehicle) {
							return A2(
								$elm$core$List$member,
								selectedVehicle.jZ,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.jZ;
									},
									vehicles));
						},
						selectedVehicles))));
	});
var $elm_community$list_extra$List$Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_v1, _v2) {
				var a1 = _v1.a;
				var i1 = _v1.b;
				var a2 = _v2.a;
				var i2 = _v2.b;
				var result = A2(pred, a1, a2);
				if (result === 1) {
					return A2($elm$core$Basics$compare, i1, i2);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, a) {
					return _Utils_Tuple2(a, i);
				}),
			list);
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2($elm$core$List$sortWith, predWithIndex, listWithIndex));
	});
var $author$project$Api$Reservation$encodeConfirmReservation = F3(
	function (model, contactPerson, paymentType) {
		var paymentCoupons = A2(
			$elm$core$List$filter,
			function (a) {
				return a.qO && a.z4;
			},
			model.j.tw);
		var isContactPersonJoiningClubOne = _Utils_eq(model.j.AE, $author$project$Types$JoinClubOneState$Joining);
		return $elm$json$Json$Encode$object(
			A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Tuple$pair('recaptcha'),
						$elm$json$Json$Encode$string),
					model.j.Fr.yh),
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Tuple$pair('referenceNumber'),
							$elm$json$Json$Encode$string),
						model.qL.sj),
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Tuple$pair('ssoToken'),
								$elm$json$Json$Encode$string),
							model.j.Ia.Cb),
						A2(
							$author$project$Utils$List$maybeAdd,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Tuple$pair('travelClasses'),
									$author$project$Api$Reservation$encodeTravelClasses),
								model.j.to),
							A2(
								$author$project$Utils$List$maybeAdd,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											$elm$core$Tuple$pair('vehicles'),
											$author$project$Api$Reservation$encodeVehicles(model.j.tt)),
										$author$project$Types$SelectedVehicles$toList),
									model.j.rp),
								A2(
									$author$project$Utils$List$maybeAdd,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												$elm$core$Tuple$pair('companyAgentId'),
												$elm$json$Json$Encode$int),
											function ($) {
												return $.zN;
											}),
										A2(
											$elm$core$Maybe$andThen,
											function ($) {
												return $.tZ;
											},
											model.j.xA)),
									A3(
										$author$project$Utils$List$addIf,
										!$elm$core$List$isEmpty(paymentCoupons),
										_Utils_Tuple2(
											'paymentCoupons',
											A2(
												$elm$json$Json$Encode$list,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.pQ;
													},
													$elm$json$Json$Encode$string),
												paymentCoupons)),
										_List_fromArray(
											[
												_Utils_Tuple2(
												'contactPerson',
												$author$project$Types$ContactPerson$encode(contactPerson)),
												_Utils_Tuple2(
												'passengers',
												A2(
													$elm$json$Json$Encode$list,
													$author$project$Api$Reservation$encodePassenger,
													A2(
														$elm_community$list_extra$List$Extra$stableSortWith,
														F2(
															function (a, b) {
																return A2($author$project$Types$AgeCategory$compare, b.tY, a.tY);
															}),
														$elm$core$Array$toList(model.j.Eg)))),
												_Utils_Tuple2(
												'payment',
												$author$project$Api$Reservation$encodePayment(paymentType)),
												_Utils_Tuple2(
												'joinClubOne',
												$elm$json$Json$Encode$bool(isContactPersonJoiningClubOne)),
												_Utils_Tuple2(
												'redirectUrls',
												$author$project$Api$Reservation$encodeRedirectUrls(model))
											])))))))));
	});
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$riskyTask = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{t9: true, ks: r.ks, j9: r.sp, lt: r.lt, lC: r.lC, lV: r.lV, th: $elm$core$Maybe$Nothing, jW: r.jW});
};
var $author$project$Api$Endpoint$riskyTask = function (config) {
	return $elm$http$Http$riskyTask(
		{
			ks: config.ks,
			lt: config.lt,
			lC: config.lC,
			sp: config.sp,
			lV: config.lV,
			jW: $author$project$Api$Endpoint$unwrapUrl(config.jW)
		});
};
var $author$project$Api$postRiskyTask = function (r) {
	return $author$project$Api$Endpoint$riskyTask(
		{ks: r.ks, lt: _List_Nil, lC: 'POST', sp: r.sp, lV: $elm$core$Maybe$Nothing, jW: r.jW});
};
var $author$project$Api$Reservation$rejectUrlParam = function (model) {
	return A2(
		$elm$url$Url$Builder$string,
		'mobileRejectUrl',
		$author$project$Api$Reservation$mobileRejectUrl(model));
};
var $author$project$Types$ErrorDetailed$BadBody = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$ErrorDetailed$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Types$ErrorDetailed$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$ErrorDetailed$NetworkError = {$: 2};
var $author$project$Types$ErrorDetailed$Timeout = {$: 1};
var $author$project$Api$Reservation$responseStringToResultWithErrorDetailed = F2(
	function (decoder, v) {
		switch (v.$) {
			case 0:
				var url = v.a;
				return $elm$core$Result$Err(
					$author$project$Types$ErrorDetailed$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Types$ErrorDetailed$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Types$ErrorDetailed$NetworkError);
			case 3:
				var metadata = v.a;
				var body = v.b;
				return $elm$core$Result$Err(
					A2($author$project$Types$ErrorDetailed$BadStatus, metadata, body));
			default:
				var body = v.b;
				return A2(
					$elm$core$Result$mapError,
					A2($elm$core$Basics$composeL, $author$project$Types$ErrorDetailed$BadBody, $elm$json$Json$Decode$errorToString),
					A2($elm$json$Json$Decode$decodeString, decoder, body));
		}
	});
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Api$Reservation$successUrlParam = function (model) {
	return A2(
		$elm$url$Url$Builder$string,
		'mobileSuccessUrl',
		$author$project$Api$Reservation$mobileSuccessUrl(model));
};
var $author$project$Api$Reservation$postConfirmReservationTask = function (_v0) {
	var model = _v0.eM;
	var paymentType = _v0.mP;
	var contactPerson = _v0.xU;
	var params = A2(
		$author$project$Api$Util$addExperimentalParamIf,
		model.j.Aa,
		_List_fromArray(
			[
				$author$project$Api$Reservation$sessionGUIDParam(model.j.zM),
				$author$project$Api$Reservation$countryParam(model.j.rb),
				$author$project$Api$Reservation$localeParam(model.j.A_),
				$author$project$Api$Reservation$rejectUrlParam(model),
				$author$project$Api$Reservation$successUrlParam(model)
			]));
	return $author$project$Api$postRiskyTask(
		{
			ks: $elm$http$Http$jsonBody(
				A3($author$project$Api$Reservation$encodeConfirmReservation, model, contactPerson, paymentType)),
			sp: $elm$http$Http$stringResolver(
				$author$project$Api$Reservation$responseStringToResultWithErrorDetailed($elm$json$Json$Decode$value)),
			jW: A2($author$project$Api$Endpoint$confirmReservation, model.j.zM.Gs, params)
		});
};
var $author$project$Update$Reservation$pay = F2(
	function (model, paymentType) {
		return A2(
			$elm$core$Maybe$map,
			function (contactPerson) {
				return $author$project$Api$Reservation$postConfirmReservationTask(
					{xU: contactPerson, eM: model, mP: paymentType});
			},
			model.j.BQ);
	});
var $author$project$Api$Endpoint$bookingChangeConfirm = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['bookingChange', 'confirm', 'v3']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Reservation$postBookingChangeConfirmTask = function (_arguments) {
	var params = A2(
		$author$project$Api$Util$addExperimentalParamIf,
		_arguments.eM.j.Aa,
		_List_fromArray(
			[
				$author$project$Api$Reservation$rejectUrlParam(_arguments.eM),
				$author$project$Api$Reservation$successUrlParam(_arguments.eM),
				$author$project$Api$Reservation$sessionGUIDParam(_arguments.eM.j.zM),
				$author$project$Api$Reservation$countryParam(_arguments.eM.j.rb),
				$author$project$Api$Reservation$localeParam(_arguments.eM.j.A_)
			]));
	return $author$project$Api$postRiskyTask(
		{
			ks: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$json$Json$Encode$string,
								$elm$core$Tuple$pair('referenceNumber')),
							_arguments.eM.qL.sj),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'payment',
								$author$project$Api$Reservation$encodePayment(_arguments.mP)),
								_Utils_Tuple2(
								'resToken',
								$elm$json$Json$Encode$string(_arguments.mS))
							])))),
			sp: $elm$http$Http$stringResolver(
				$author$project$Api$Reservation$responseStringToResultWithErrorDetailed($elm$json$Json$Decode$value)),
			jW: A2($author$project$Api$Endpoint$bookingChangeConfirm, _arguments.eM.j.zM.Gs, params)
		});
};
var $author$project$Api$Endpoint$bookingChangeSummary = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['bookingChange', 'summary']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Reservation$decodePinAndResId = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (pin, resId) {
			return {oy: pin, oG: resId};
		}),
	A2($elm$json$Json$Decode$field, 'pin', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'resId', $elm$json$Json$Decode$int));
var $author$project$Api$Reservation$postBookingChangeSummaryTask = function (_v0) {
	var model = _v0.eM;
	var resToken = _v0.mS;
	return $author$project$Api$postRiskyTask(
		{
			ks: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'resToken',
							$elm$json$Json$Encode$string(resToken))
						]))),
			sp: $elm$http$Http$stringResolver(
				$author$project$Api$Reservation$responseStringToResultWithErrorDetailed($author$project$Api$Reservation$decodePinAndResId)),
			jW: A2(
				$author$project$Api$Endpoint$bookingChangeSummary,
				model.j.zM.Gs,
				A2(
					$author$project$Api$Util$addExperimentalParamIf,
					model.j.Aa,
					_List_fromArray(
						[
							$author$project$Api$Reservation$sessionGUIDParam(model.j.zM),
							$author$project$Api$Reservation$countryParam(model.j.rb),
							$author$project$Api$Reservation$localeParam(model.j.A_)
						])))
		});
};
var $author$project$Api$Reservation$postConfirmExistingReservationTask = function (_arguments) {
	return A2(
		$elm$core$Task$andThen,
		function (_v0) {
			var pin = _v0.oy;
			var resId = _v0.oG;
			return $author$project$Api$Reservation$postBookingChangeConfirmTask(
				{eM: _arguments.eM, mP: _arguments.mP, oy: pin, oG: resId, mS: _arguments.mS});
		},
		$author$project$Api$Reservation$postBookingChangeSummaryTask(_arguments));
};
var $author$project$Update$Reservation$confirmExistingReservationIfExisting = F3(
	function (model, paymentType, confirmNew) {
		var maybeResToken = A2(
			$author$project$Types$Maybe$Util$orElse,
			model.j.B_,
			$author$project$UrlRoute$bookingParamsFromLocation(model.n1).mS);
		var isExistingReservation = !_Utils_eq(model.j.Fz, $elm$core$Maybe$Nothing);
		return isExistingReservation ? A2(
			$elm$core$Maybe$map,
			function (resToken) {
				return $author$project$Api$Reservation$postConfirmExistingReservationTask(
					{eM: model, mP: paymentType, mS: resToken});
			},
			maybeResToken) : confirmNew;
	});
var $author$project$Update$Reservation$payAndConfirmExistingReservationIfExisting = F2(
	function (model, paymentType) {
		return A3(
			$author$project$Update$Reservation$confirmExistingReservationIfExisting,
			model,
			paymentType,
			A2($author$project$Update$Reservation$pay, model, paymentType));
	});
var $author$project$Common$Toast$performAfterTimeout = F2(
	function (timeoutInMs, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(timeoutInMs));
	});
var $author$project$Messages$ClickedConfirmFreeTrip = {$: 112};
var $author$project$Messages$ClickedPay = function (a) {
	return {$: 113, a: a};
};
var $author$project$Update$getRecaptchaMsg = function (callback) {
	if (!callback.$) {
		var method = callback.a;
		return $author$project$Messages$ClickedPay(method);
	} else {
		return $author$project$Messages$ClickedConfirmFreeTrip;
	}
};
var $author$project$Update$performRecaptchaCallback = function (callback) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Update$getRecaptchaMsg(callback);
		},
		$elm$core$Task$succeed(0));
};
var $author$project$Messages$SelectedMemorizedVehicle = function (a) {
	return {$: 91, a: a};
};
var $author$project$Messages$SelectedVehicle = function (a) {
	return {$: 90, a: a};
};
var $author$project$Messages$ToggledVehicles = {$: 56};
var $author$project$Update$getSelectVehicleMsg = function (callback) {
	switch (callback.$) {
		case 0:
			return $author$project$Messages$ToggledVehicles;
		case 1:
			var vehicle = callback.a;
			return $author$project$Messages$SelectedVehicle(vehicle);
		default:
			var vehicle = callback.a;
			return $author$project$Messages$SelectedMemorizedVehicle(vehicle);
	}
};
var $author$project$Update$performSelectVehicleCallback = function (callback) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Update$getSelectVehicleMsg(callback);
		},
		$elm$core$Task$succeed(0));
};
var $author$project$Messages$GotSummary = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Summary$Summary = function (priceBeforeDiscount) {
	return function (pointsPrice) {
		return function (price) {
			return function (subtotal) {
				return function (isMyJourneySupported) {
					return function (termsAndConditionsType) {
						return function (outwardTravelClasses) {
							return function (returnTravelClasses) {
								return function (doAllPassengersHaveTravelClass) {
									return function (onboardServices) {
										return function (extraServices) {
											return function (warnings) {
												return function (clubOneDiscount) {
													return function (meals) {
														return function (areLandServicesValid) {
															return function (selectedHotelRooms) {
																return function (doAllPassengersHaveRoom) {
																	return function (suggestBuyingMeals) {
																		return function (surchargesContainer) {
																			return function (clubOne) {
																				return {uh: areLandServicesValid, pN: clubOne, wd: clubOneDiscount, yA: doAllPassengersHaveRoom, qa: doAllPassengersHaveTravelClass, qk: extraServices, qU: isMyJourneySupported, rv: meals, rI: onboardServices, DB: outwardTravelClasses, oA: pointsPrice, lN: price, Fi: priceBeforeDiscount, FU: returnTravelClasses, Gk: selectedHotelRooms, G3: subtotal, G4: suggestBuyingMeals, s6: surchargesContainer, s9: termsAndConditionsType, Iy: warnings};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$ClubOne$ClubOne = F4(
	function (discount, maybeSliderInfo, maybeSliderIncompatiblePromotionGroup, maybeSliderIncompatibilityReason) {
		return {dC: discount, B4: maybeSliderIncompatibilityReason, B5: maybeSliderIncompatiblePromotionGroup, B6: maybeSliderInfo};
	});
var $author$project$Types$ClubOne$SliderInfo = F6(
	function (balance, max, rate, step, used, usedMoney) {
		return {ur: balance, n6: max, Fp: rate, GW: step, H8: used, H9: usedMoney};
	});
var $author$project$Types$ClubOne$sliderInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'usedMoney',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'used',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'step',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rate',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'max',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'balance',
						$elm$json$Json$Decode$float,
						$elm$json$Json$Decode$succeed($author$project$Types$ClubOne$SliderInfo)))))));
var $author$project$Types$ClubOne$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sliderIncompatibilityReason',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sliderIncompatiblePromotionGroup',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sliderInfo',
			$elm$json$Json$Decode$maybe($author$project$Types$ClubOne$sliderInfoDecoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'discount',
				$elm$json$Json$Decode$float,
				0,
				$elm$json$Json$Decode$succeed($author$project$Types$ClubOne$ClubOne)))));
var $author$project$Types$SurchargesContainer$SurchargesContainer = F3(
	function (passengerCombined, vehicleCombined, maxAgeCategoryWithoutSurcharges) {
		return {BK: maxAgeCategoryWithoutSurcharges, DL: passengerCombined, Ic: vehicleCombined};
	});
var $author$project$Types$Surcharges$Surcharges = F2(
	function (outward, _return) {
		return {Ds: outward, FL: _return};
	});
var $author$project$Types$Surcharges$Surcharge = F2(
	function (price, count) {
		return {pZ: count, lN: price};
	});
var $author$project$Types$Surcharges$surchargeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Types$Surcharges$Surcharge)));
var $author$project$Types$Surcharges$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'return',
	$elm$json$Json$Decode$list($author$project$Types$Surcharges$surchargeDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'outward',
		$elm$json$Json$Decode$list($author$project$Types$Surcharges$surchargeDecoder),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Types$Surcharges$Surcharges)));
var $author$project$Types$SurchargesContainer$MaxAgeCategories = F2(
	function (outward, _return) {
		return {Ds: outward, FL: _return};
	});
var $author$project$Types$SurchargesContainer$maxAgeCategoriesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'return',
	$elm$json$Json$Decode$nullable($author$project$Types$AgeCategory$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'outward',
		$elm$json$Json$Decode$nullable($author$project$Types$AgeCategory$decoder),
		$elm$json$Json$Decode$succeed($author$project$Types$SurchargesContainer$MaxAgeCategories)));
var $author$project$Types$SurchargesContainer$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'maxAgeCategoryWithoutSurcharges',
	$author$project$Types$SurchargesContainer$maxAgeCategoriesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'vehicleCombined',
		$author$project$Types$Surcharges$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'passengerCombined',
			$author$project$Types$Surcharges$decoder,
			$elm$json$Json$Decode$succeed($author$project$Types$SurchargesContainer$SurchargesContainer))));
var $author$project$Types$SelectedExtraServices$SelectedService = F3(
	function (code, count, name) {
		return {pQ: code, pZ: count, oh: name};
	});
var $author$project$Types$SelectedExtraServices$selectedServiceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'code',
			$author$project$Types$ExtraService$codeDecoder,
			$elm$json$Json$Decode$succeed($author$project$Types$SelectedExtraServices$SelectedService))));
var $author$project$Types$Summary$extraServicesDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return {rP: a, st: b};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'outwardExtraServices',
		$elm$json$Json$Decode$list($author$project$Types$SelectedExtraServices$selectedServiceDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'returnExtraServices',
		$elm$json$Json$Decode$list($author$project$Types$SelectedExtraServices$selectedServiceDecoder)));
var $author$project$Types$Summary$mealsDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return {DC: a, FV: b};
		}),
	A2(
		$elm$json$Json$Decode$field,
		'outwardMeals',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Meal$decode)),
	A2(
		$elm$json$Json$Decode$field,
		'returnMeals',
		$elm$json$Json$Decode$list($author$project$Types$ReservationData$Meal$Meal$decode)));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Types$Hotel$SelectedHotelRoom = F5(
	function (checkInDate, checkOutDate, nightCount, roomCode, roomCount) {
		return {ln: checkInDate, lo: checkOutDate, CH: nightCount, FY: roomCode, FZ: roomCount};
	});
var $author$project$Types$Hotel$selectedHotelRoomsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'roomCount',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'roomCode',
		$author$project$Types$Hotel$roomCodeDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nightCount',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'checkOutDate',
				$author$project$Utils$Time$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'checkInDate',
					$author$project$Utils$Time$decoder,
					$elm$json$Json$Decode$succeed($author$project$Types$Hotel$SelectedHotelRoom))))));
var $author$project$Types$Summary$travelClassesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $elm$core$Dict$toList, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$dict(
		A2($elm$json$Json$Decode$field, 'count', $elm$json$Json$Decode$int)));
var $author$project$Types$Summary$Warning = F5(
	function (canBeStored, code, message, onStoreOnly, severity) {
		return {pF: canBeStored, pQ: code, Cv: message, C7: onStoreOnly, sO: severity};
	});
var $author$project$Types$Summary$warningDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'severity',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'onStoreOnly',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'message',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'code',
				$elm$json$Json$Decode$int,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'canBeStored',
					$elm$json$Json$Decode$bool,
					false,
					$elm$json$Json$Decode$succeed($author$project$Types$Summary$Warning))))));
var $author$project$Types$Summary$decoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (summary, vouchers) {
			return {s4: summary, tw: vouchers};
		}),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clubOne',
		$author$project$Types$ClubOne$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'surcharges',
			$author$project$Types$SurchargesContainer$decoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'suggestBuyingMeals',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['hotel', 'coversAllPassengers']),
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['hotel', 'rooms']),
						$elm$json$Json$Decode$list($author$project$Types$Hotel$selectedHotelRoomsDecoder),
						_List_Nil,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'validLandServices',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'meals',
								A2(
									$elm$json$Json$Decode$andThen,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Maybe$withDefault(
											{DC: _List_Nil, FV: _List_Nil}),
										$elm$json$Json$Decode$succeed),
									$elm$json$Json$Decode$maybe($author$project$Types$Summary$mealsDecoder)),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['clubOne', 'discount']),
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$float,
												$elm$json$Json$Decode$succeed(0)
											])),
									0,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'warnings',
										$elm$json$Json$Decode$list($author$project$Types$Summary$warningDecoder),
										_List_Nil,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'extraServices',
											A2(
												$elm$json$Json$Decode$andThen,
												A2(
													$elm$core$Basics$composeR,
													$elm$core$Maybe$withDefault(
														{rP: _List_Nil, st: _List_Nil}),
													$elm$json$Json$Decode$succeed),
												$elm$json$Json$Decode$maybe($author$project$Types$Summary$extraServicesDecoder)),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'onboardServices',
												A2(
													$elm$json$Json$Decode$andThen,
													A2(
														$elm$core$Basics$composeR,
														$elm$core$Maybe$withDefault(
															{ot: _List_Nil, oL: _List_Nil}),
														$elm$json$Json$Decode$succeed),
													$elm$json$Json$Decode$maybe($author$project$Types$Summary$onboardServicesDecoder)),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
													_List_fromArray(
														['travelClasses', 'coversAllPassengers']),
													$elm$json$Json$Decode$bool,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
														_List_fromArray(
															['travelClasses', 'returnSail']),
														$author$project$Types$Summary$travelClassesDecoder,
														_List_Nil,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
															_List_fromArray(
																['travelClasses', 'outwardSail']),
															$author$project$Types$Summary$travelClassesDecoder,
															_List_Nil,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'termsAndConditionsType',
																A2(
																	$elm$json$Json$Decode$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$core$Maybe$withDefault(0),
																		$elm$json$Json$Decode$succeed),
																	$elm$json$Json$Decode$maybe($author$project$Types$TermsAndConditions$decoder)),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'myJourneySupported',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'subtotal',
																		$elm$json$Json$Decode$oneOf(
																			_List_fromArray(
																				[
																					$elm$json$Json$Decode$float,
																					$elm$json$Json$Decode$null(0)
																				])),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'money',
																			$elm$json$Json$Decode$oneOf(
																				_List_fromArray(
																					[
																						$elm$json$Json$Decode$float,
																						$elm$json$Json$Decode$null(0)
																					])),
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																				_List_fromArray(
																					['clubOne', 'sliderInfo', 'used']),
																				A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float),
																				0,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'priceBeforeDiscount',
																					$elm$json$Json$Decode$oneOf(
																						_List_fromArray(
																							[
																								$elm$json$Json$Decode$float,
																								$elm$json$Json$Decode$null(0)
																							])),
																					$elm$json$Json$Decode$succeed($author$project$Types$Summary$Summary))))))))))))))))))))),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'discounts',
		$elm$json$Json$Decode$value,
		$elm$json$Json$Decode$succeed($elm$core$Basics$identity)));
var $author$project$Types$MealPackage$codeToString = function (_v0) {
	var code = _v0;
	return code;
};
var $author$project$Types$Bus$DetailedTransfer$DetailedBusTransfer = function (arrivalDateTime) {
	return function (cityFrom) {
		return function (cityTo) {
			return function (codeFrom) {
				return function (codeTo) {
					return function (departureDateTime) {
						return function (packageId) {
							return function (price) {
								return function (stationFrom) {
									return function (stationTo) {
										return {na: arrivalDateTime, v1: cityFrom, v2: cityTo, wn: codeFrom, pR: codeTo, nq: departureDateTime, rW: packageId, lN: price, GT: stationFrom, sW: stationTo};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Bus$AgeGroup$encode = function (v) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'adults',
				$elm$json$Json$Encode$int(v.pn)),
				_Utils_Tuple2(
				'underages',
				$elm$json$Json$Encode$int(v.H4)),
				_Utils_Tuple2(
				'infants',
				$elm$json$Json$Encode$int(v.zV))
			]));
};
var $author$project$Types$Bus$DetailedTransfer$encode = function (detailedBusTransfer) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'transferId',
			$elm$json$Json$Encode$int(detailedBusTransfer.rW)),
			_Utils_Tuple2(
			'fromBusStop',
			$elm$json$Json$Encode$string(detailedBusTransfer.wn)),
			_Utils_Tuple2(
			'toBusStop',
			$elm$json$Json$Encode$string(detailedBusTransfer.pR))
		]);
};
var $author$project$Types$Bus$SelectedTransferPair$encodeBusTransfer = function (busTransfer) {
	var detailedBusTransfer = $author$project$Types$Bus$DetailedTransfer$DetailedBusTransfer(busTransfer.na)(busTransfer.v1)(busTransfer.v2)(busTransfer.wn)(busTransfer.pR)(busTransfer.nq)(busTransfer.rW)(busTransfer.lN)(busTransfer.GT)(busTransfer.sW);
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			$author$project$Types$Bus$DetailedTransfer$encode(detailedBusTransfer),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'passengerTypes',
					$author$project$Types$Bus$AgeGroup$encode(busTransfer.po))
				])));
};
var $author$project$Types$Bus$SelectedTransferPair$encode = function () {
	var addIfHasPassengers = function (a) {
		return (!(!$author$project$Types$Bus$AgeGroup$sumAgeGroupCounts(a.po))) ? $elm$core$List$cons(a) : $elm$core$Basics$identity;
	};
	return A2(
		$elm$core$Basics$composeR,
		A2(
			$elm$core$Array$foldl,
			F2(
				function (_v0, accumulator) {
					var _v1 = _v0;
					var outward = _v1.a;
					var _return = _v1.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Basics$identity,
							A2($elm$core$Maybe$map, addIfHasPassengers, _return)),
						A2(
							$elm$core$Tuple$mapFirst,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Basics$identity,
								A2($elm$core$Maybe$map, addIfHasPassengers, outward)),
							accumulator));
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil)),
		function (_v2) {
			var outwards = _v2.a;
			var returns = _v2.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'outwardTransfers',
						A2($elm$json$Json$Encode$list, $author$project$Types$Bus$SelectedTransferPair$encodeBusTransfer, outwards)),
						_Utils_Tuple2(
						'returnTransfers',
						A2($elm$json$Json$Encode$list, $author$project$Types$Bus$SelectedTransferPair$encodeBusTransfer, returns))
					]));
		});
}();
var $author$project$Types$Bus$SelectedTransfers$encode = A2($elm$core$Basics$composeR, $author$project$Types$Bus$SelectedTransfers$toArray, $author$project$Types$Bus$SelectedTransferPair$encode);
var $author$project$Types$SelectedExtraServices$prepareCodeForSummary = function (selectedExtraServices) {
	return $elm$core$Dict$values(
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, code) {
					return $author$project$Types$ExtraService$isPriorityCar(code) ? function (a) {
						return a + '/money';
					}(
						$author$project$Types$ExtraService$codeToString(code)) : $author$project$Types$ExtraService$codeToString(code);
				}),
			selectedExtraServices));
};
var $author$project$Types$SelectedExtraServices$encode = function (selected) {
	var _v0 = _Utils_Tuple2(selected.DC, selected.FV);
	var outwards = _v0.a;
	var returns = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'outwardServices',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					$author$project$Types$SelectedExtraServices$prepareCodeForSummary(outwards))),
				_Utils_Tuple2(
				'returnServices',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					$author$project$Types$SelectedExtraServices$prepareCodeForSummary(returns)))
			]));
};
var $author$project$Types$SelectedOnboardServices$encodeOnboardService = function (onboardService) {
	var encodeAddon = function (addon) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(addon.pQ)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(addon.oh)),
					_Utils_Tuple2(
					'count',
					$elm$json$Json$Encode$int(addon.pZ))
				]));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(onboardService.pQ)),
				_Utils_Tuple2(
				'count',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, onboardService.pZ))),
				_Utils_Tuple2(
				'duration',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, onboardService.nv))),
				_Utils_Tuple2(
				'name',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, onboardService.oh))),
				_Utils_Tuple2(
				'beginDateTime',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, onboardService.ut))),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Types$OnboardServices$serviceTypeToString(onboardService.km))),
				_Utils_Tuple2(
				'freeAddons',
				A2($elm$json$Json$Encode$list, encodeAddon, onboardService.ms)),
				_Utils_Tuple2(
				'paidAddons',
				A2($elm$json$Json$Encode$list, encodeAddon, onboardService.kD))
			]));
};
var $author$project$Types$SelectedOnboardServices$add = F2(
	function (r1, r2) {
		return {
			ot: _Utils_ap(r1.ot, r2.ot),
			oL: _Utils_ap(r1.oL, r2.oL)
		};
	});
var $author$project$Types$OnboardServices$BubbleFairService$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedBubbleFairServices = F2(
	function (onboardServices, _v0) {
		var outwardBubbleFairServices = _v0.jO;
		var returnBubbleFairServices = _v0.jT;
		var toOnboardService = function (_v1) {
			var code = _v1.a;
			var count = _v1.b;
			return {
				ut: $elm$core$Maybe$Nothing,
				pQ: $author$project$Types$OnboardServices$BubbleFairService$codeToString(code),
				pZ: $elm$core$Maybe$Just(count),
				nv: $elm$core$Maybe$Nothing,
				ms: _List_Nil,
				oh: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.oh;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(code)),
						onboardServices.vz)),
				kD: _List_Nil,
				km: 0
			};
		};
		return {
			ot: A2(
				$elm$core$List$map,
				toOnboardService,
				$elm$core$Dict$values(outwardBubbleFairServices)),
			oL: A2(
				$elm$core$List$map,
				toOnboardService,
				$elm$core$Dict$values(returnBubbleFairServices))
		};
	});
var $author$project$Types$OnboardServices$CovidService$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedCovidServices = function (_v0) {
	var outwardCovidServices = _v0.ke;
	var returnCovidServices = _v0.kj;
	var toOnboardService = function (_v1) {
		var code = _v1.a;
		var count = _v1.b;
		return {
			ut: $elm$core$Maybe$Nothing,
			pQ: $author$project$Types$OnboardServices$CovidService$codeToString(code),
			pZ: $elm$core$Maybe$Just(count),
			nv: $elm$core$Maybe$Nothing,
			ms: _List_Nil,
			oh: $elm$core$Maybe$Nothing,
			kD: _List_Nil,
			km: 1
		};
	};
	return {
		ot: A2(
			$elm$core$List$map,
			toOnboardService,
			$elm$core$Dict$values(outwardCovidServices)),
		oL: A2(
			$elm$core$List$map,
			toOnboardService,
			$elm$core$Dict$values(returnCovidServices))
	};
};
var $author$project$Types$OnboardServices$Addon$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedFriendshipBracelets = function (_v0) {
	var outwardFriendshipBracelets = _v0.eV;
	var returnFriendshipBracelets = _v0.fy;
	var toOnboardService = function (pairs) {
		return A2(
			$elm$core$Maybe$map,
			function (code) {
				return {
					ut: $elm$core$Maybe$Nothing,
					pQ: $author$project$Types$OnboardServices$Addon$codeToString(code),
					pZ: $elm$core$Maybe$Nothing,
					nv: $elm$core$Maybe$Nothing,
					ms: _List_Nil,
					oh: $elm$core$Maybe$Nothing,
					kD: A2(
						$elm$core$List$map,
						function (_v2) {
							var addon = _v2.a;
							var count = _v2.b;
							return {
								pQ: $author$project$Types$OnboardServices$Addon$codeToString(addon.pQ),
								pZ: count,
								oh: addon.oh
							};
						},
						pairs),
					km: 4
				};
			},
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var addon = _v1.a;
					return addon.pQ;
				},
				$elm$core$List$head(pairs)));
	};
	var extractService = function (friendshipBracelets) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				toOnboardService(
					$elm$core$Dict$values(friendshipBracelets))));
	};
	return {
		ot: extractService(outwardFriendshipBracelets),
		oL: extractService(returnFriendshipBracelets)
	};
};
var $author$project$Utils$Time$toDateTimeString = function (dateTime) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('T'),
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		$elm$time$Time$utc,
		dateTime);
};
var $author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedMassages = F2(
	function (onboardServices, _v0) {
		var massageTimeSlots = _v0.y;
		var services = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var code = _v1.a;
					var selectedTimeSlots = _v1.b;
					return A2(
						$elm$core$List$map,
						function (_v2) {
							var startTime = _v2.ld;
							var duration = _v2.nv;
							return {
								ut: $elm$core$Maybe$Just(
									$author$project$Utils$Time$toDateTimeString(startTime)),
								pQ: code,
								pZ: $elm$core$Maybe$Just(1),
								nv: $elm$core$Maybe$Just(duration),
								ms: _List_Nil,
								oh: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.oh;
									},
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.pQ;
											},
											$elm$core$Basics$eq(code)),
										onboardServices.BI)),
								kD: _List_Nil,
								km: 6
							};
						},
						selectedTimeSlots);
				},
				$elm$core$Dict$toList(massageTimeSlots)));
		return {ot: services, oL: _List_Nil};
	});
var $author$project$Types$OnboardServices$PriorityBoarding$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedPriorityBoardings = F2(
	function (passengers, _v0) {
		var outwardPriorityBoardings = _v0.kf;
		var returnPriorityBoardings = _v0.kk;
		var toOnboardService = function (_v1) {
			var code = _v1.pQ;
			return {
				ut: $elm$core$Maybe$Nothing,
				pQ: $author$project$Types$OnboardServices$PriorityBoarding$codeToString(code),
				pZ: $elm$core$Maybe$Just(
					$elm$core$List$length(passengers)),
				nv: $elm$core$Maybe$Nothing,
				ms: _List_Nil,
				oh: $elm$core$Maybe$Nothing,
				kD: _List_Nil,
				km: 3
			};
		};
		return {
			ot: A2(
				$elm$core$List$map,
				toOnboardService,
				$elm$core$Dict$values(outwardPriorityBoardings)),
			oL: A2(
				$elm$core$List$map,
				toOnboardService,
				$elm$core$Dict$values(returnPriorityBoardings))
		};
	});
var $author$project$Types$SelectedOnboardServices$addPassengerCountsToKidBracelets = F2(
	function (passengers, kidBraceletes) {
		return function (passengerCount) {
			return A2(
				$elm$core$List$map,
				function (kidBracelet) {
					var _v0 = kidBracelet.tY;
					switch (_v0) {
						case 0:
							return _Utils_Tuple2(kidBracelet, passengerCount.tV);
						case 1:
							return _Utils_Tuple2(kidBracelet, passengerCount.IF);
						case 3:
							return _Utils_Tuple2(kidBracelet, passengerCount.AI);
						default:
							return _Utils_Tuple2(kidBracelet, passengerCount.vU);
					}
				},
				kidBraceletes);
		}(
			$author$project$Common$Passengers$passengerCount(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.tY;
					},
					passengers)));
	});
var $author$project$Types$OnboardServices$KidBracelet$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Types$SelectedOnboardServices$selectedServiceFromKidBracelet = F3(
	function (toInfo, count, onboardService) {
		return {
			ut: function () {
				var _v0 = toInfo(onboardService);
				if (!_v0.$) {
					var beginDateTime = _v0.a.ut;
					return beginDateTime;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			pQ: $author$project$Types$OnboardServices$KidBracelet$codeToString(onboardService.pQ),
			pZ: $elm$core$Maybe$Just(count),
			nv: $elm$core$Maybe$Nothing,
			ms: _List_Nil,
			oh: $elm$core$Maybe$Just(onboardService.oh),
			kD: _List_Nil,
			km: 5
		};
	});
var $author$project$Types$SelectedOnboardServices$selectedServicesFromKidBracelets = F3(
	function (passengers, _v0, _v1) {
		var kidBracelets = _v0.AL;
		var selected = _v1;
		var mapListToSelectedServices = function (toInfo) {
			return $elm$core$List$filterMap(
				function (_v3) {
					var code = _v3.a.pQ;
					var count = _v3.b;
					return A2(
						$elm$core$Maybe$map,
						A2($author$project$Types$SelectedOnboardServices$selectedServiceFromKidBracelet, toInfo, count),
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pQ;
								},
								$elm$core$Basics$eq(code)),
							kidBracelets));
				});
		};
		var _v2 = selected;
		var outwards = _v2.DC;
		var returns = _v2.FV;
		return {
			ot: A2(
				mapListToSelectedServices,
				function ($) {
					return $.rQ;
				},
				A2(
					$author$project$Types$SelectedOnboardServices$addPassengerCountsToKidBracelets,
					passengers,
					$elm$core$Dict$values(outwards))),
			oL: A2(
				mapListToSelectedServices,
				function ($) {
					return $.su;
				},
				A2(
					$author$project$Types$SelectedOnboardServices$addPassengerCountsToKidBracelets,
					passengers,
					$elm$core$Dict$values(returns)))
		};
	});
var $author$project$Types$OnboardServices$ShipMoney$codeToString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Types$SelectedOnboardServices$mapShipMoneyListToSelectedService = F3(
	function (_v0, selected, shipMoney) {
		var first = _v0.nx;
		var others = _v0.lH;
		return $elm$core$List$isEmpty(selected) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				ut: $elm$core$Maybe$Nothing,
				pQ: $author$project$Types$OnboardServices$ShipMoney$codeToString(shipMoney.pQ),
				pZ: $elm$core$Maybe$Nothing,
				nv: $elm$core$Maybe$Nothing,
				ms: _List_Nil,
				oh: $elm$core$Maybe$Nothing,
				kD: A2(
					$elm$core$List$filterMap,
					function (_v1) {
						var code = _v1.a;
						var count = _v1.b;
						return A2(
							$elm$core$Maybe$map,
							function (_v2) {
								var name = _v2.oh;
								return A3(
									$author$project$Types$SelectedOnboardServices$Addon,
									$author$project$Types$OnboardServices$ShipMoney$codeToString(code),
									name,
									count);
							},
							A2(
								$elm_community$list_extra$List$Extra$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.pQ;
									},
									$elm$core$Basics$eq(code)),
								A2($elm$core$List$cons, first, others)));
					},
					selected),
				km: 7
			});
	});
var $author$project$Types$SelectedOnboardServices$selectedServicesFromShipMoney = F2(
	function (shipMoney, _v0) {
		var outwardShipMoney = _v0.eW;
		var returnShipMoney = _v0.N;
		var _v1 = shipMoney.x3;
		if (!_v1.$) {
			var a = _v1.a;
			return {
				ot: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A3(
							$author$project$Types$SelectedOnboardServices$mapShipMoneyListToSelectedService,
							a,
							$elm$core$Dict$values(outwardShipMoney),
							shipMoney))),
				oL: _List_Nil
			};
		} else {
			var outward = _v1.a.Ds;
			var _return = _v1.a.FL;
			return {
				ot: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A3(
							$author$project$Types$SelectedOnboardServices$mapShipMoneyListToSelectedService,
							outward,
							$elm$core$Dict$values(outwardShipMoney),
							shipMoney))),
				oL: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A3(
							$author$project$Types$SelectedOnboardServices$mapShipMoneyListToSelectedService,
							_return,
							$elm$core$Dict$values(returnShipMoney),
							shipMoney)))
			};
		}
	});
var $author$project$Types$OnboardServices$diningCodeToString = function (_v0) {
	var code = _v0;
	return code;
};
var $author$project$Types$SelectedOnboardServices$diningOnboardService = F2(
	function (dining, service) {
		return {
			ut: $elm$core$Maybe$Just(
				$author$project$Utils$Time$toDateTimeString(service.nd)),
			pQ: $author$project$Types$OnboardServices$diningCodeToString(dining.pQ),
			pZ: $elm$core$Maybe$Just(1),
			nv: $elm$core$Maybe$Nothing,
			ms: _List_Nil,
			oh: $elm$core$Maybe$Just(dining.oh),
			kD: _List_Nil,
			km: 2
		};
	});
var $author$project$Types$SelectedOnboardServices$allOutwardDinings = F2(
	function (selected, dinings) {
		return A2(
			$elm$core$List$concatMap,
			function (dining) {
				return A2(
					$elm$core$List$filterMap,
					function (service) {
						return A2(
							$elm$core$List$member,
							_Utils_Tuple2(dining.pQ, service.nd),
							selected) ? $elm$core$Maybe$Just(
							A2($author$project$Types$SelectedOnboardServices$diningOnboardService, dining, service)) : $elm$core$Maybe$Nothing;
					},
					dining.ot);
			},
			dinings);
	});
var $author$project$Types$SelectedOnboardServices$allReturnDinings = F2(
	function (selected, dinings) {
		return A2(
			$elm$core$List$concatMap,
			function (dining) {
				return A2(
					$elm$core$List$filterMap,
					function (service) {
						return A2(
							$elm$core$List$member,
							_Utils_Tuple2(dining.pQ, service.nd),
							selected) ? $elm$core$Maybe$Just(
							A2($author$project$Types$SelectedOnboardServices$diningOnboardService, dining, service)) : $elm$core$Maybe$Nothing;
					},
					dining.oL);
			},
			dinings);
	});
var $author$project$Types$SelectedOnboardServices$selectedServicesFromTableReservations = F2(
	function (dinings, _v0) {
		var selected = _v0;
		var selectedDinings = $elm$core$Dict$values(selected.G5);
		return {
			ot: A2($author$project$Types$SelectedOnboardServices$allOutwardDinings, selectedDinings, dinings),
			oL: A2($author$project$Types$SelectedOnboardServices$allReturnDinings, selectedDinings, dinings)
		};
	});
var $author$project$Types$SelectedOnboardServices$onboardServicesFromSelected = F3(
	function (passengers, onboardServices, selected) {
		return function (_v0) {
			var outwardServices = _v0.ot;
			var returnServices = _v0.oL;
			return ($elm$core$List$isEmpty(outwardServices) && $elm$core$List$isEmpty(returnServices)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				{ot: outwardServices, oL: returnServices});
		}(
			A2(
				$author$project$Types$SelectedOnboardServices$add,
				A2($author$project$Types$SelectedOnboardServices$selectedServicesFromTableReservations, onboardServices.yv, selected),
				A2(
					$author$project$Types$SelectedOnboardServices$add,
					A2(
						$elm$core$Maybe$withDefault,
						{ot: _List_Nil, oL: _List_Nil},
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return A2($author$project$Types$SelectedOnboardServices$selectedServicesFromShipMoney, a, selected);
							},
							onboardServices.B3)),
					A2(
						$author$project$Types$SelectedOnboardServices$add,
						A2($author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedPriorityBoardings, passengers, selected),
						A2(
							$author$project$Types$SelectedOnboardServices$add,
							$author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedFriendshipBracelets(selected),
							A2(
								$author$project$Types$SelectedOnboardServices$add,
								A2($author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedBubbleFairServices, onboardServices, selected),
								A2(
									$author$project$Types$SelectedOnboardServices$add,
									$author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedCovidServices(selected),
									A2(
										$author$project$Types$SelectedOnboardServices$add,
										A2($author$project$Types$SelectedOnboardServices$onboardServicesFromSelectedMassages, onboardServices, selected),
										A3($author$project$Types$SelectedOnboardServices$selectedServicesFromKidBracelets, passengers, onboardServices, selected)))))))));
	});
var $author$project$Types$SelectedOnboardServices$encode = F3(
	function (passengers, onboardServices, selected) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var outwardServices = _v0.ot;
					var returnServices = _v0.oL;
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'outwardServices',
								A2($elm$json$Json$Encode$list, $author$project$Types$SelectedOnboardServices$encodeOnboardService, outwardServices)),
								_Utils_Tuple2(
								'returnServices',
								A2($elm$json$Json$Encode$list, $author$project$Types$SelectedOnboardServices$encodeOnboardService, returnServices))
							]));
				},
				A3($author$project$Types$SelectedOnboardServices$onboardServicesFromSelected, passengers, onboardServices, selected)));
	});
var $author$project$Api$Summary$encodeClubOne = function (_v0) {
	var passengers = _v0.Eg;
	var joinClubOneState = _v0.AE;
	var clubOnePoints = _v0.wf;
	var encodeClient = function (_v1) {
		var firstName = _v1.y2;
		var lastName = _v1.A6;
		var clientId = _v1.v5;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, clientId))),
					_Utils_Tuple2(
					'firstName',
					$elm$json$Json$Encode$string(firstName)),
					_Utils_Tuple2(
					'lastName',
					$elm$json$Json$Encode$string(lastName))
				]));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'clients',
				A2(
					$elm$json$Json$Encode$list,
					encodeClient,
					A2(
						$elm_community$list_extra$List$Extra$stableSortWith,
						F2(
							function (a, b) {
								return A2($author$project$Types$AgeCategory$compare, b.tY, a.tY);
							}),
						$elm$core$Array$toList(passengers)))),
				_Utils_Tuple2(
				'points',
				$elm$json$Json$Encode$int(clubOnePoints)),
				_Utils_Tuple2(
				'join',
				$elm$json$Json$Encode$bool(
					_Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Joining)))
			]));
};
var $author$project$Api$Summary$encodePassengerCount = function (passengerCount) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'adults',
				$elm$json$Json$Encode$int(passengerCount.tV)),
				_Utils_Tuple2(
				'children',
				$elm$json$Json$Encode$int(passengerCount.vU)),
				_Utils_Tuple2(
				'juniors',
				$elm$json$Json$Encode$int(passengerCount.AI)),
				_Utils_Tuple2(
				'youths',
				$elm$json$Json$Encode$int(passengerCount.IF))
			]));
};
var $author$project$Api$Summary$encodePassengerTypes = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$core$Array$foldl,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.tY;
			},
			$elm$core$List$cons),
		_List_Nil),
	A2($elm$core$Basics$composeR, $author$project$Common$Passengers$passengerCount, $author$project$Api$Summary$encodePassengerCount));
var $author$project$Api$Summary$encodeOutwardSailId = function (a) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'outwardSailId',
				$elm$json$Json$Encode$int(a))
			]));
};
var $author$project$Api$Summary$encodeCruiseMultiDepartureSailId = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$CruiseMultiDepartureTrips$selected,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.zN;
		},
		$author$project$Api$Summary$encodeOutwardSailId));
var $author$project$Api$Summary$encodeSailIdWithMaybeSecondSailId = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	return $elm$json$Json$Encode$object(
		A2(
			$author$project$Utils$List$maybeAdd,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Tuple$pair('returnSailId'),
					$elm$json$Json$Encode$int),
				b),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'outwardSailId',
					$elm$json$Json$Encode$int(a))
				])));
};
var $author$project$Api$Summary$encodeCruiseSailIds = A2($elm$core$Basics$composeR, $author$project$Types$CruiseSails$getSailIds, $author$project$Api$Summary$encodeSailIdWithMaybeSecondSailId);
var $author$project$Api$Summary$encodeRouteTripSailIds = A2($elm$core$Basics$composeR, $author$project$Types$RouteTripSails$getSailIds, $author$project$Api$Summary$encodeSailIdWithMaybeSecondSailId);
var $author$project$Api$Summary$encodeSailIds = function (_v0) {
	var trips = _v0.tp;
	var voyageType = _v0.tx;
	switch (trips.$) {
		case 0:
			switch (trips.a.$) {
				case 0:
					var cruise = trips.a.a;
					return $author$project$Api$Summary$encodeCruiseSailIds(cruise);
				case 2:
					var cruiseMultiDeparture = trips.a.a;
					return $author$project$Api$Summary$encodeCruiseMultiDepartureSailId(cruiseMultiDeparture);
				default:
					var route = trips.a.a;
					return $author$project$Api$Summary$encodeRouteTripSailIds(route);
			}
		case 1:
			return $elm$json$Json$Encode$null;
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$Types$LandService$encodeAge = function (age) {
	return _Utils_eq(age, $author$project$Utils$Range$infinity) ? $elm$json$Json$Encode$int($author$project$Types$Ticket$maxAge) : $elm$json$Json$Encode$int(age);
};
var $author$project$Types$Ticket$encodeId = function (id) {
	if (!id.$) {
		var ticketCode = id.a;
		return _Utils_Tuple2(
			'addonCode',
			$elm$json$Json$Encode$string(ticketCode));
	} else {
		var packageId = id.a;
		return _Utils_Tuple2(
			'packageId',
			$elm$json$Json$Encode$int(packageId));
	}
};
var $author$project$Types$LandService$encodeSelected = function (_v0) {
	var count = _v0.a;
	var ticket = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				$author$project$Types$Ticket$encodeId(ticket.zN),
				_Utils_Tuple2(
				'count',
				$elm$json$Json$Encode$int(count)),
				_Utils_Tuple2(
				'ageFrom',
				$author$project$Types$LandService$encodeAge(ticket.m4.a)),
				_Utils_Tuple2(
				'ageTo',
				$author$project$Types$LandService$encodeAge(ticket.m4.b)),
				_Utils_Tuple2(
				'ageCategory',
				A2($author$project$Utils$String$maybe, $elm$json$Json$Encode$string, ticket.tY)),
				_Utils_Tuple2(
				'otherAgeCategories',
				A2($author$project$Utils$String$maybe, $elm$json$Json$Encode$string, ticket.Dq))
			]));
};
var $author$project$Types$Hotel$hotelCodeToString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Types$Hotel$roomCodeToString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Types$Hotel$encodeSelectedRoom = function (_v0) {
	var cityCode = _v0.pK;
	var hotelCode = _v0.zx;
	var code = _v0.pQ;
	var date = _v0.nn;
	var count = _v0.pZ;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'cityCode',
				$elm$json$Json$Encode$string(
					$author$project$Types$Hotel$cityCodeToString(cityCode))),
				_Utils_Tuple2(
				'hotelCode',
				$elm$json$Json$Encode$string(
					$author$project$Types$Hotel$hotelCodeToString(hotelCode))),
				_Utils_Tuple2(
				'roomCode',
				$elm$json$Json$Encode$string(
					$author$project$Types$Hotel$roomCodeToString(code))),
				_Utils_Tuple2(
				'date',
				$elm$json$Json$Encode$string(
					$author$project$Utils$Time$toDateString(date))),
				_Utils_Tuple2(
				'roomCount',
				$elm$json$Json$Encode$int(count))
			]));
};
var $author$project$Types$Hotel$encodeSelectedRooms = function (_v0) {
	var dict = _v0;
	return A2(
		$elm$json$Json$Encode$list,
		$author$project$Types$Hotel$encodeSelectedRoom,
		A3(
			$elm$core$List$foldr,
			F2(
				function (_v1, acc) {
					var cityCode = _v1.pK;
					var hotelCode = _v1.zx;
					var code = _v1.pQ;
					var nights = _v1.CI;
					var count = _v1.pZ;
					return _Utils_ap(
						acc,
						A2(
							$elm$core$List$map,
							function (date) {
								return {pK: cityCode, pQ: code, pZ: count, nn: date, zx: hotelCode};
							},
							$author$project$Utils$OneOrMore$toList(nights)));
				}),
			_List_Nil,
			$elm$core$Dict$values(dict)));
};
var $author$project$Types$Meals$addonCodeToString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Types$Meals$encodeAddonCode = A2($elm$core$Basics$composeR, $author$project$Types$Meals$addonCodeToString, $elm$json$Json$Encode$string);
var $author$project$Api$Summary$encodeSittings = function (passengerSequence) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$SelectedMeals$toList,
		$elm$json$Json$Encode$list(
			function (_v0) {
				var beginDateTime = _v0.ut;
				var restaurantCode = _v0.FJ;
				var comment = _v0.wo;
				var addons = _v0.tS;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'beginDateTime',
							$elm$json$Json$Encode$string(
								$author$project$Utils$Time$toDateTimeString(beginDateTime))),
							_Utils_Tuple2(
							'passengerSeqNs',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, passengerSequence)),
							_Utils_Tuple2(
							'restaurantCode',
							$elm$json$Json$Encode$string(restaurantCode)),
							_Utils_Tuple2(
							'comments',
							$elm$json$Json$Encode$string(comment)),
							_Utils_Tuple2(
							'addons',
							A2(
								$elm$json$Json$Encode$list,
								function (_v1) {
									var code = _v1.a;
									var other = _v1.b;
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'code',
												$author$project$Types$Meals$encodeAddonCode(code)),
												_Utils_Tuple2(
												'count',
												$elm$json$Json$Encode$int(
													$elm$core$List$length(other) + 1))
											]));
								},
								$elm_community$list_extra$List$Extra$gatherEquals(addons)))
						]));
			}));
};
var $author$project$Api$Summary$encodeTravelClasses = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$TravelClasses$encodeSelected,
	function (_v0) {
		var outwards = _v0.DC;
		var returns = _v0.FV;
		var isSameForAll = _v0.As;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sameForAll',
					$elm$json$Json$Encode$bool(isSameForAll)),
					_Utils_Tuple2('outwards', outwards),
					_Utils_Tuple2('returns', returns)
				]));
	});
var $author$project$Api$Summary$getPassengerSequence = function (passengers) {
	return A2(
		$elm$core$List$range,
		1,
		$elm$core$Array$length(passengers));
};
var $author$project$Api$Summary$encodeSummaryBody = function (body) {
	var passengerSequence = $author$project$Api$Summary$getPassengerSequence(body.Eg);
	var countAndEncodeTravelClassSurprises = F3(
		function (travelClassCode, surprises, acc) {
			return A2(
				$elm$core$List$append,
				acc,
				A2(
					$elm$core$List$map,
					function (_v0) {
						var code = _v0.a;
						var list = _v0.b;
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(code)),
									_Utils_Tuple2(
									'count',
									$elm$json$Json$Encode$int(
										$elm$core$List$length(list) + 1)),
									_Utils_Tuple2(
									'travelClassCode',
									$elm$json$Json$Encode$string(travelClassCode))
								]));
					},
					A2($elm_community$list_extra$List$Extra$gatherWith, $elm$core$Basics$eq, surprises)));
		});
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$elm$core$Basics$neq($elm$json$Json$Encode$null)),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'passengerTypes',
					$author$project$Api$Summary$encodePassengerTypes(body.Eg)),
					_Utils_Tuple2(
					'sails',
					$author$project$Api$Summary$encodeSailIds(body)),
					_Utils_Tuple2(
					'outwardVehicleCodes',
					A2($author$project$Types$SelectedVehicles$encodeVehicleCodes, 0, body.rp)),
					_Utils_Tuple2(
					'returnVehicleCodes',
					A2($author$project$Types$SelectedVehicles$encodeVehicleCodes, 1, body.rp)),
					_Utils_Tuple2(
					'outwardSittings',
					A2($author$project$Api$Summary$encodeSittings, passengerSequence, body.Gn)),
					_Utils_Tuple2(
					'returnSittings',
					A2($author$project$Api$Summary$encodeSittings, passengerSequence, body.Go)),
					_Utils_Tuple2(
					'clubOne',
					$author$project$Api$Summary$encodeClubOne(body)),
					_Utils_Tuple2(
					'travelClasses',
					A2($author$project$DataTracking$Util$encodeMaybe, $author$project$Api$Summary$encodeTravelClasses, body.to)),
					_Utils_Tuple2(
					'travelClassServices',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'outwards',
								A2(
									$elm$json$Json$Encode$list,
									$elm$core$Basics$identity,
									A3($elm$core$Dict$foldl, countAndEncodeTravelClassSurprises, _List_Nil, body.pD.DC))),
								_Utils_Tuple2(
								'returns',
								A2(
									$elm$json$Json$Encode$list,
									$elm$core$Basics$identity,
									A3($elm$core$Dict$foldl, countAndEncodeTravelClassSurprises, _List_Nil, body.pD.FV)))
							]))),
					_Utils_Tuple2(
					'voyageType',
					$elm$json$Json$Encode$string(
						A2($author$project$Types$VoyageType$toStringWithBookingType, body.vk, body.tx))),
					_Utils_Tuple2(
					'voucherIds',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, body.Iw)),
					_Utils_Tuple2(
					'companyId',
					A2(
						$author$project$DataTracking$Util$encodeMaybe,
						$elm$json$Json$Encode$int,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.yt;
								},
								function ($) {
									return $.zN;
								}),
							body.xA))),
					_Utils_Tuple2(
					'companyAgentId',
					A2(
						$author$project$DataTracking$Util$encodeMaybe,
						$elm$json$Json$Encode$int,
						A2(
							$elm$core$Maybe$andThen,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.tZ;
								},
								$elm$core$Maybe$map(
									function ($) {
										return $.zN;
									})),
							body.xA))),
					_Utils_Tuple2(
					'isHotelPackage',
					$elm$json$Json$Encode$bool(body.vk === 1)),
					_Utils_Tuple2(
					'transfers',
					A2($author$project$DataTracking$Util$encodeMaybe, $author$project$Types$Bus$SelectedTransfers$encode, body.B0)),
					_Utils_Tuple2(
					'mealPackageCode',
					A2(
						$author$project$DataTracking$Util$encodeMaybe,
						A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Types$MealPackage$codeToString),
						body.B2)),
					_Utils_Tuple2(
					'onboardServices',
					A3(
						$author$project$Types$SelectedOnboardServices$encode,
						$elm$core$Array$toList(body.Eg),
						body.rI,
						body.Gm)),
					_Utils_Tuple2(
					'landServices',
					A2($elm$json$Json$Encode$list, $author$project$Types$LandService$encodeSelected, body.AZ)),
					_Utils_Tuple2(
					'extraServices',
					$author$project$Types$SelectedExtraServices$encode(body.Gi)),
					_Utils_Tuple2(
					'hotelRooms',
					$author$project$Types$Hotel$encodeSelectedRooms(body.Gk))
				])));
};
var $author$project$Api$Summary$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							_Utils_Tuple2(
								$elm$http$Http$BadUrl(url),
								$elm$core$Maybe$Nothing));
					case 1:
						return $elm$core$Result$Err(
							_Utils_Tuple2($elm$http$Http$Timeout, $elm$core$Maybe$Nothing));
					case 2:
						return $elm$core$Result$Err(
							_Utils_Tuple2($elm$http$Http$NetworkError, $elm$core$Maybe$Nothing));
					case 3:
						var metadata = response.a;
						var body = response.b;
						return $elm$core$Result$Err(
							_Utils_Tuple2(
								$elm$http$Http$BadStatus(metadata.GU),
								$elm$core$Maybe$Just(body)));
					default:
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								_Utils_Tuple2(
									$elm$http$Http$BadBody(
										$elm$json$Json$Decode$errorToString(err)),
									$elm$core$Maybe$Just(body)));
						}
				}
			});
	});
var $author$project$Api$Summary$getSummaryUrlParameters = F2(
	function (_v0, httpConfig) {
		var language = _v0.A_;
		var market = _v0.rb;
		var isExperimental = _v0.Aa;
		return A2(
			$author$project$Api$Util$addExperimentalParamIf,
			isExperimental,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				_List_fromArray(
					[
						$author$project$Api$Util$guidParam(httpConfig.Gt),
						$author$project$Api$Util$localeParam(language),
						$author$project$Api$Util$marketParam(market)
					])));
	});
var $author$project$Api$Endpoint$summary = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['reservation', 'summary', 'v2']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.s4));
	});
var $author$project$Api$Summary$postSummary = F3(
	function (body, params, httpConfig) {
		return A2(
			$author$project$Update$Util$cancelRequestAndRunCmd,
			$author$project$Api$Endpoint$trackers.s4,
			$author$project$Api$postWithCredentials(
				{
					ks: $elm$http$Http$jsonBody(
						$author$project$Api$Summary$encodeSummaryBody(body)),
					j9: A2($author$project$Api$Summary$expectJson, $author$project$Messages$GotSummary, $author$project$Types$Summary$decoder),
					jW: A2(
						$author$project$Api$Endpoint$summary,
						httpConfig.Gs,
						A2($author$project$Api$Summary$getSummaryUrlParameters, params, httpConfig))
				}));
	});
var $author$project$Types$SelectedExtraServices$filter = F2(
	function (condition, _v0) {
		var set = _v0;
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (_v1, code) {
					return condition(code);
				}),
			set);
	});
var $author$project$Update$ExtraServices$filterSelectedExtraServices = F2(
	function (extraServices, selectedExtraServices) {
		return _Utils_update(
			selectedExtraServices,
			{
				DC: A2(
					$author$project$Types$SelectedExtraServices$filter,
					function (code) {
						return A2(
							$elm$core$List$any,
							function (service) {
								return _Utils_eq(code, $author$project$Types$ExtraService$priorityCarFCCode) || (_Utils_eq(service.pQ, code) && service.nS);
							},
							extraServices);
					},
					selectedExtraServices.DC),
				FV: A2(
					$author$project$Types$SelectedExtraServices$filter,
					function (code) {
						return A2(
							$elm$core$List$any,
							function (service) {
								return _Utils_eq(service.pQ, code) && service.Aq;
							},
							extraServices);
					},
					selectedExtraServices.FV)
			});
	});
var $author$project$Types$ExtraService$isPreselectablePriorityCarCode = function (code) {
	return $author$project$Types$ExtraService$isPriorityCarPL(code) || $author$project$Types$ExtraService$isPriorityCarFC(code);
};
var $author$project$Types$SelectedExtraServices$toUnselected = function (direction) {
	if (!direction) {
		return function ($) {
			return $.lK;
		};
	} else {
		return function ($) {
			return $.lQ;
		};
	}
};
var $author$project$Types$SelectedExtraServices$preselectForDirection = F3(
	function (direction, extraServices, selectedExtraServices) {
		var isAvailable = function (extraService) {
			if (!direction) {
				return extraService.nS;
			} else {
				return extraService.Aq;
			}
		};
		var preselectableCode = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.pQ;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (es) {
					return $author$project$Types$ExtraService$isPreselectablePriorityCarCode(es.pQ) && isAvailable(es);
				},
				extraServices));
		if (!preselectableCode.$) {
			var code = preselectableCode.a;
			return ((!A3($author$project$Types$SelectedExtraServices$isSelectedInDirection, direction, code, selectedExtraServices)) && ((!A3($author$project$Types$SelectedExtraServices$isSelectedInDirection, direction, $author$project$Types$ExtraService$garageCode, selectedExtraServices)) && (!A2(
				$elm$core$List$member,
				code,
				A2($author$project$Types$SelectedExtraServices$toUnselected, direction, selectedExtraServices))))) ? A3($author$project$Types$SelectedExtraServices$toggle, direction, code, selectedExtraServices) : selectedExtraServices;
		} else {
			return selectedExtraServices;
		}
	});
var $author$project$Types$SelectedExtraServices$preselect = F2(
	function (extraServices, selectedExtraServices) {
		return A3(
			$author$project$Types$SelectedExtraServices$preselectForDirection,
			1,
			extraServices,
			A3($author$project$Types$SelectedExtraServices$preselectForDirection, 0, extraServices, selectedExtraServices));
	});
var $author$project$Update$ExtraServices$updateSelectedServices = F2(
	function (selectedExtraServices, model) {
		return _Utils_update(
			model,
			{
				j: function (session) {
					return _Utils_update(
						session,
						{Gi: selectedExtraServices});
				}(model.j)
			});
	});
var $author$project$Update$ExtraServices$received = F2(
	function (model, result) {
		var session = model.j;
		if (!result.$) {
			var extraServices = result.a;
			var validExtraServices = A2(
				$elm$core$List$filter,
				function (_v1) {
					var name = _v1.oh;
					var description = _v1.nt;
					return (!$elm$core$String$isEmpty(name)) && (!$elm$core$String$isEmpty(description));
				},
				extraServices);
			return function (a) {
				return _Utils_Tuple2(a, $elm$core$Platform$Cmd$none);
			}(
				A2(
					$author$project$Update$ExtraServices$updateSelectedServices,
					A2(
						$author$project$Types$SelectedExtraServices$preselect,
						validExtraServices,
						A2($author$project$Update$ExtraServices$filterSelectedExtraServices, validExtraServices, model.j.Gi)),
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{qk: validExtraServices})
						})));
		} else {
			var error = result.a;
			return _Utils_Tuple2(
				model,
				A2($author$project$Tracking$logHttpError, 'extraServicesDataResponse', error));
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $author$project$Types$TravelClasses$removeAllPetTravelClasses = F3(
	function (code, direction, travelClasses) {
		return A3(
			$author$project$Types$TravelClasses$updatePetsBasedOnDirection,
			direction,
			$elm$core$Dict$remove(code),
			travelClasses);
	});
var $author$project$Update$Passengers$removeAnimations = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				Ea: A2($author$project$PassengerPage$Model$Model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
			}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Ports$removeFirstVehicleFromLocalStorage = _Platform_outgoingPort(
	'removeFirstVehicleFromLocalStorage',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Update$Passengers$isDuplicatedClubOneClient = F2(
	function (passengers, passenger) {
		return (!_Utils_eq(passenger.we, $elm$core$Maybe$Nothing)) && ($elm$core$Array$length(
			A2(
				$elm$core$Array$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.we;
					},
					$elm$core$Basics$eq(passenger.we)),
				passengers)) > 1);
	});
var $author$project$Update$Passengers$isLastAdult = F2(
	function (passengers, _v0) {
		var ageCategory = _v0.tY;
		return (!ageCategory) && ($author$project$Types$Passenger$Util$countAdultPassengers(passengers) <= 1);
	});
var $author$project$Update$Passengers$isPassengerAnAffiliate = F2(
	function (clientWebData, passenger) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (client, clientId) {
						return A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(clientId),
							$author$project$Types$Client$getAffiliateIds(client));
					}),
				$krisajenkins$remotedata$RemoteData$toMaybe(clientWebData),
				passenger.v5));
	});
var $author$project$Update$Passengers$isPassengerSignedInClubOneClient = F2(
	function (passenger, clientWebData) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (passengerClientId, client) {
						return _Utils_eq(passengerClientId, client.v5);
					}),
				passenger.v5,
				$krisajenkins$remotedata$RemoteData$toMaybe(clientWebData)));
	});
var $author$project$Update$Passengers$isPassengerRemovable = F3(
	function (session, passengers, passenger) {
		var user = session.Ia;
		var company = session.xA;
		return _Utils_eq(company, $elm$core$Maybe$Nothing) ? ((!((A2($author$project$Update$Passengers$isPassengerSignedInClubOneClient, passenger, user.v4) && (!A2($author$project$Update$Passengers$isPassengerAnAffiliate, user.v4, passenger))) || ((A2($author$project$Update$Passengers$isLastAdult, passengers, passenger) && (!$author$project$Update$Passengers$isSoloYouthAllowed(session))) || A2($author$project$Update$Passengers$isDuplicatedClubOneClient, passengers, passenger)))) || A2($author$project$Update$Passengers$isPassengerAnAffiliate, user.v4, passenger)) : (!(A2($author$project$Update$Passengers$isLastAdult, passengers, passenger) && (!$author$project$Update$Passengers$isSoloYouthAllowed(session))));
	});
var $author$project$Types$SelectedVehicles$count = function (_v0) {
	var others = _v0.lH;
	return $elm$core$Array$length(others) + 1;
};
var $author$project$Types$JoinClubOneState$Loading = {$: 1};
var $author$project$Update$JoinClubOne$isPassengerContactPerson = F2(
	function (passenger, person) {
		var email = person.yI;
		var phone = person.ox;
		var zip = person.jX;
		return A2($author$project$Types$Passenger$areNamesEqualIgnoringCapitalization, person, passenger) && (_Utils_eq(
			$elm$core$String$toLower(
				A2($elm$core$Maybe$withDefault, '', passenger.yI)),
			$elm$core$String$toLower(email)) && (_Utils_eq(
			passenger.ox,
			$elm$core$Maybe$Just(phone)) && _Utils_eq(
			passenger.jX,
			$elm$core$Maybe$Just(zip))));
	});
var $author$project$Update$JoinClubOne$isJoining = F2(
	function (_v0, passenger) {
		var joinClubOneState = _v0.AE;
		var maybeContactPerson = _v0.BQ;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Update$JoinClubOne$isPassengerContactPerson(passenger),
				maybeContactPerson)) && (_Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Joining) || _Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Loading));
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						B: _List_Nil,
						x: 0,
						z: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $author$project$Common$Array$Util$remove = F2(
	function (index, array) {
		return ((index < 0) || (_Utils_cmp(
			index,
			$elm$core$Array$length(array)) > -1)) ? array : A2(
			$elm$core$Array$append,
			A3($elm$core$Array$slice, 0, index, array),
			A3(
				$elm$core$Array$slice,
				index + 1,
				$elm$core$Array$length(array),
				array));
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Utils$String$renderIf = F2(
	function (isVisible, component) {
		return isVisible ? component : $elm$html$Html$text('');
	});
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Types$AgeCategory$translate = function (ageCategory) {
	switch (ageCategory) {
		case 0:
			return function ($) {
				return $.b7;
			};
		case 1:
			return function ($) {
				return $.ca;
			};
		case 2:
			return function ($) {
				return $.b8;
			};
		default:
			return function ($) {
				return $.b9;
			};
	}
};
var $author$project$Update$Passengers$removedPassengerTile = F2(
	function (translations, passenger) {
		var okStatus = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('statusText')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Ee)
				]));
		var hasRequiredDataFilled = function (_v0) {
			var firstName = _v0.y2;
			var lastName = _v0.A6;
			var birthday = _v0.uw;
			return (!$elm$core$String$isEmpty(firstName)) && ((!$elm$core$String$isEmpty(lastName)) && (!_Utils_eq(birthday, $elm$core$Maybe$Nothing)));
		};
		var fillLater = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('status link3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Ed)
				]));
		var clubOneLogo = A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('clubOneLogo'),
					$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/club_one_logo.svg')
				]),
			_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerButton effect-list leave'),
					A2($elm$html$Html$Attributes$attribute, 'data-effect-type', 'expand-in')
				]),
			_List_fromArray(
				[
					($elm$core$String$isEmpty(passenger.y2) || $elm$core$String$isEmpty(passenger.A6)) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('passengerPlaceholder data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$AgeCategory$translate, passenger.tY, translations))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('passengerName data wordBreak')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(passenger.y2 + (' ' + passenger.A6))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status bodyNorm')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Utils$String$renderIf,
							hasRequiredDataFilled(passenger),
							okStatus),
							A2(
							$author$project$Utils$String$renderIf,
							(!_Utils_eq(passenger.pO, $elm$core$Maybe$Nothing)) && (!_Utils_eq(passenger.we, $elm$core$Maybe$Nothing)),
							clubOneLogo)
						])),
					A2(
					$author$project$Utils$String$renderIf,
					!hasRequiredDataFilled(passenger),
					fillLater)
				]));
	});
var $author$project$Update$Passengers$showMealsWereRemovedToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Messages$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		2,
		function ($) {
			return $.hh;
		},
		false));
var $author$project$Update$JoinClubOne$turnOff = function (model) {
	var session = model.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{AE: $author$project$Types$JoinClubOneState$NotJoining})
		});
};
var $author$project$Types$TravelClasses$wasDeckRemoved = F2(
	function (old, _new) {
		var decksCount = function (selected) {
			return $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
						selected)));
		};
		var _v0 = _Utils_Tuple2(old, _new);
		_v0$2:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return _Utils_cmp(
							decksCount(a.Gg),
							decksCount(b.Gg)) > 0;
					} else {
						break _v0$2;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return _Utils_cmp(
							decksCount(a.FL),
							decksCount(b.FL)) > 0;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	});
var $author$project$Update$Passengers$removePassengerInternal = F2(
	function (_v0, model) {
		var index = _v0.qH;
		var isWithAnimation = _v0.q2;
		var passenger = _v0.a;
		var session = model.j;
		var vehiclePage = model.Ih;
		var removedPassenger = $author$project$Update$Passengers$removedPassengerTile(
			$author$project$Translations$forLanguage(session.A_));
		var passengers = A2($author$project$Common$Array$Util$remove, index, session.Eg);
		var selectedOnboardServices = A3(
			$author$project$Types$SelectedOnboardServices$removeUnavailableKidBracelets,
			$elm$core$Array$toList(passengers),
			session.rI.AL,
			session.Gm);
		var passengerPageModel = A2(
			$author$project$PassengerPage$Model$Model,
			$elm$core$Maybe$Nothing,
			isWithAnimation ? $elm$core$Maybe$Just(
				_Utils_Tuple2(
					index,
					removedPassenger(passenger))) : $elm$core$Maybe$Nothing);
		var maybeTravelClasses = A2(
			$elm$core$Maybe$map,
			A3($author$project$Types$TravelClasses$remapWhenPassengersChanged, session.kS, session.Eg, passengers),
			session.to);
		var newSession = function (a) {
			return _Utils_update(
				a,
				{
					rp: $author$project$Types$SelectedVehicles$remap(a)
				});
		}(
			($author$project$Utils$Route$isVehicleRequired(session) ? $author$project$Update$Vehicles$remapForRouteWithRequiredVehicle(vehiclePage) : $elm$core$Basics$identity)(
				_Utils_update(
					session,
					{Eg: passengers, Gm: selectedOnboardServices, to: maybeTravelClasses})));
		var showRemovedCabinToast = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (oldTravelClasses) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (newTravelClasses) {
								return A2($author$project$Types$TravelClasses$wasAnyPreviouslySelectedTravelClassRemoved, oldTravelClasses, newTravelClasses) && (!A2($author$project$Types$TravelClasses$wasDeckRemoved, oldTravelClasses, newTravelClasses));
							},
							maybeTravelClasses));
				},
				session.to));
		var count = A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Types$SelectedVehicles$count),
			$elm$core$Maybe$withDefault(0));
		return (A2($author$project$Update$JoinClubOne$isJoining, session, passenger) ? $elm$core$Tuple$mapFirst($author$project$Update$JoinClubOne$turnOff) : $elm$core$Basics$identity)(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{Ea: passengerPageModel, j: newSession}),
				$elm$core$Platform$Cmd$batch(
					A3(
						$author$project$Utils$List$addIf,
						showRemovedCabinToast,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Messages$ToastMsg,
							A3(
								$author$project$Common$Toast$showToastCmd,
								0,
								function ($) {
									return $.hd;
								},
								false)),
						A3(
							$author$project$Utils$List$addIf,
							_Utils_cmp(
								count(newSession.rp),
								count(session.rp)) < 0,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								A3(
									$author$project$Common$Toast$showToastCmd,
									0,
									function ($) {
										return $.hi;
									},
									false)),
							A3(
								$author$project$Utils$List$addIf,
								isWithAnimation,
								$author$project$Update$Passengers$removeAnimationCmd,
								$author$project$Update$Passengers$hasMealsOrMealPackage(model) ? _List_fromArray(
									[$author$project$Update$Passengers$showMealsWereRemovedToast]) : _List_Nil))))));
	});
var $author$project$Update$Passengers$removePassenger = F3(
	function (model, index, isWithAnimation) {
		var session = model.j;
		var vehiclePage = model.Ih;
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return A3($author$project$Update$Passengers$isPassengerRemovable, session, session.Eg, a) ? A2(
						$author$project$Update$Passengers$removePassengerInternal,
						{qH: index, q2: isWithAnimation, a: a},
						model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				},
				A2($elm$core$Array$get, index, session.Eg)));
	});
var $author$project$Types$TravelClasses$removePetTravelClass = F3(
	function (code, direction, travelClasses) {
		return A3(
			$author$project$Types$TravelClasses$updatePetsBasedOnDirection,
			direction,
			A2(
				$elm$core$Dict$update,
				code,
				$elm$core$Maybe$andThen(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$add(-1),
						function (a) {
							return (!a) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(a);
						}))),
			travelClasses);
	});
var $author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClass = F2(
	function (selectedCabinSurprises, travelClasses) {
		var selectedTravelClasses = function () {
			if (travelClasses.$ === 2) {
				var oneWay = travelClasses.a;
				return A2(
					$elm$core$List$map,
					$elm$core$Tuple$first,
					$author$project$Types$TravelClasses$oneWaySelection(oneWay));
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (travelClassCode, _v0) {
					return A2(
						$elm$core$List$any,
						$elm$core$Basics$eq(travelClassCode),
						selectedTravelClasses);
				}),
			selectedCabinSurprises);
	});
var $author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClassFromModel = function (model) {
	var session = model.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{
					Gh: {
						DC: A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Dict$empty,
							A2(
								$elm$core$Maybe$map,
								$author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClass(session.Gh.DC),
								session.to)),
						FV: session.Gh.FV
					}
				})
		});
};
var $author$project$Update$Vehicles$clearVehiclesInSession = function (session) {
	return _Utils_update(
		session,
		{yq: _List_Nil, rp: $elm$core$Maybe$Nothing});
};
var $author$project$Types$SelectedVehicles$remove = F2(
	function (index, selectedVehicles) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$removeAt,
			index,
			$author$project$Types$SelectedVehicles$toList(selectedVehicles));
		if (_v0.b) {
			var first = _v0.a;
			var othersList = _v0.b;
			return $elm$core$Maybe$Just(
				{
					nx: first,
					lH: $elm$core$Array$fromList(othersList)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Update$Vehicles$removeSelectedVehicle = F2(
	function (model, index) {
		var _v0 = model.j.rp;
		if (!_v0.$) {
			var selectedVehicles = _v0.a;
			return function (a) {
				var vehiclePage = a.Ih;
				return _Utils_Tuple2(
					_Utils_update(
						a,
						{
							Ih: _Utils_update(
								vehiclePage,
								{n7: $elm$core$Maybe$Nothing})
						}),
					_Utils_eq(vehiclePage.BV, $elm$core$Maybe$Nothing) ? $author$project$Ports$removeFirstVehicleFromLocalStorage(0) : $elm$core$Platform$Cmd$none);
			}(
				function (a) {
					return _Utils_eq(a.rp, $elm$core$Maybe$Nothing) ? _Utils_update(
						model,
						{
							pz: function (page) {
								return _Utils_update(
									page,
									{Ay: false});
							}(model.pz),
							j: a,
							Ih: function (page) {
								return _Utils_update(
									page,
									{BV: $elm$core$Maybe$Nothing});
							}(model.Ih)
						}) : _Utils_update(
						model,
						{j: a});
				}(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Update$Vehicles$clearVehiclesInSession(model.j),
						A2(
							$elm$core$Maybe$map,
							$author$project$Update$Vehicles$setSelectedVehiclesToSession(model.j),
							A2($author$project$Types$SelectedVehicles$remove, index, selectedVehicles)))));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$TravelClasses$findAndDecreaseTravelClassCount = F2(
	function (selectedCodesAndCounts, selectedCode) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$elm$core$Basics$lt(0)),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var code = _v0.a;
					var count = _v0.b;
					return _Utils_eq(code, selectedCode) ? _Utils_Tuple2(code, count - 1) : _Utils_Tuple2(code, count);
				},
				selectedCodesAndCounts));
	});
var $author$project$Types$TravelClasses$removeSelection = F3(
	function (code, direction, travelClasses) {
		var removePetsForRemovedTravelClass = F2(
			function (selected, newTravelClasses) {
				var maybeSelectedTravelClass = A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(code)),
					selected);
				return (!_Utils_eq(maybeSelectedTravelClass, $elm$core$Maybe$Nothing)) ? A3(
					$author$project$Types$TravelClasses$updatePetsBasedOnDirection,
					direction,
					A2(
						$elm$core$Dict$update,
						code,
						$elm$core$Maybe$andThen(
							function (previousCount) {
								return A2(
									$elm$core$Maybe$map,
									function (_v2) {
										var count = _v2.b;
										return (_Utils_cmp(previousCount, count * $author$project$Types$TravelClasses$maxPetsPerCabin) > 0) ? (count * $author$project$Types$TravelClasses$maxPetsPerCabin) : previousCount;
									},
									maybeSelectedTravelClass);
							})),
					newTravelClasses) : A3($author$project$Types$TravelClasses$removeAllPetTravelClasses, code, direction, newTravelClasses);
			});
		switch (travelClasses.$) {
			case 2:
				var oneWay = travelClasses.a;
				return function (a) {
					return A2(
						removePetsForRemovedTravelClass,
						a,
						$author$project$Types$TravelClasses$OneWayMultiple(
							_Utils_update(
								oneWay,
								{Gg: a})));
				}(
					A2($author$project$Types$TravelClasses$findAndDecreaseTravelClassCount, oneWay.Gg, code));
			case 3:
				var twoWay = travelClasses.a;
				if (!direction) {
					return function (a) {
						return A2(
							removePetsForRemovedTravelClass,
							a,
							$author$project$Types$TravelClasses$TwoWayMultiple(
								_Utils_update(
									twoWay,
									{Ds: a})));
					}(
						A2($author$project$Types$TravelClasses$findAndDecreaseTravelClassCount, twoWay.Ds, code));
				} else {
					return function (a) {
						return A2(
							removePetsForRemovedTravelClass,
							a,
							$author$project$Types$TravelClasses$TwoWayMultiple(
								_Utils_update(
									twoWay,
									{FL: a})));
					}(
						A2($author$project$Types$TravelClasses$findAndDecreaseTravelClassCount, twoWay.FL, code));
				}
			default:
				return travelClasses;
		}
	});
var $author$project$Update$requestVehiclesIfNeeded = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		A2(
			$elm$core$Maybe$map,
			function (sailIds) {
				return (model.j.Ag || (!$elm$core$List$isEmpty(model.j.tt))) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : A2($author$project$Update$Trips$requestVehicles, sailIds, model);
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$Trips$sailIds,
				$author$project$Types$Trips$statusToMaybe(model.j.tp))));
};
var $author$project$TravelClassPage$Update$resetCabinSurpriseIndicator = F2(
	function (travelClassCode, model) {
		return function (a) {
			return _Utils_update(
				model,
				{pC: a});
		}(
			A2($elm$core$Dict$remove, travelClassCode, model.pC));
	});
var $author$project$Update$Meals$resetMenuOptionsForDirection = function (_v0) {
	var breakfast = _v0.vu;
	var brunch = _v0.vx;
	var lunch = _v0.Bz;
	var dinner = _v0.yw;
	return {
		vu: A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_update(
					a,
					{tS: _List_Nil, wo: ''});
			},
			breakfast),
		vx: A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_update(
					a,
					{tS: _List_Nil, wo: ''});
			},
			brunch),
		yw: A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_update(
					a,
					{tS: _List_Nil, wo: ''});
			},
			dinner),
		Bz: A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_update(
					a,
					{tS: _List_Nil, wo: ''});
			},
			lunch)
	};
};
var $author$project$Update$Meals$resetMenuOptions = function (model) {
	var session = model.j;
	return function (a) {
		return _Utils_update(
			model,
			{j: a});
	}(
		A2(
			F2(
				function (a, b) {
					return _Utils_update(
						session,
						{Gn: a, Go: b});
				}),
			$author$project$Update$Meals$resetMenuOptionsForDirection(session.Gn),
			$author$project$Update$Meals$resetMenuOptionsForDirection(session.Go)));
};
var $author$project$Types$SelectedOnboardServices$resetReturnSelections = function (_v0) {
	var a = _v0;
	return _Utils_update(
		a,
		{N: $elm$core$Dict$empty, FV: $elm$core$Dict$empty});
};
var $author$project$Update$Route$resetReturnOnboardServiceSelectionsOnOneWay = function (model) {
	return model.j.qW ? function (session) {
		return _Utils_update(
			model,
			{j: session});
	}(
		function (session) {
			return _Utils_update(
				session,
				{
					Gm: $author$project$Types$SelectedOnboardServices$resetReturnSelections(session.Gm)
				});
		}(model.j)) : model;
};
var $author$project$Types$SelectedOnboardServices$resetSelectedVehicleIncompatibleOnboardServices = F2(
	function (incompatibleCodes, _v0) {
		var selected = _v0;
		var resetInDict = function (dict) {
			return A2(
				$elm$core$Dict$filter,
				F2(
					function (k, _v1) {
						return !A2($elm$core$List$member, k, incompatibleCodes);
					}),
				dict);
		};
		return {
			y: resetInDict(selected.y),
			jO: resetInDict(selected.jO),
			ke: resetInDict(selected.ke),
			eV: resetInDict(selected.eV),
			kf: resetInDict(selected.kf),
			eW: resetInDict(selected.eW),
			DC: resetInDict(selected.DC),
			jT: resetInDict(selected.jT),
			kj: resetInDict(selected.kj),
			fy: resetInDict(selected.fy),
			kk: resetInDict(selected.kk),
			N: resetInDict(selected.N),
			FV: resetInDict(selected.FV),
			G5: resetInDict(selected.G5)
		};
	});
var $author$project$Update$resetSelectedVehicleIncompatibleOnboardServices = function (model) {
	var session = model.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{
					Gm: A2(
						$author$project$Types$SelectedOnboardServices$resetSelectedVehicleIncompatibleOnboardServices,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.pQ;
							},
							session.rI.Ig),
						session.Gm)
				})
		});
};
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Utils$Number$Round$roundWithPrecision = F2(
	function (precision, x) {
		var factor = A2($elm$core$Basics$pow, 10, precision);
		return $elm$core$Basics$round(x * factor) / factor;
	});
var $author$project$Types$CruiseMultiDepartureTrips$select = F2(
	function (id, _v0) {
		var trips = _v0;
		var selectedTrip = A2(
			$elm$core$Maybe$withDefault,
			trips.Gg,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.zN;
					},
					$elm$core$Basics$eq(id)),
				$author$project$Types$CruiseMultiDepartureTrips$toList(trips)));
		var others = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(
				$author$project$Types$CruiseMultiDepartureTrip$Ok(selectedTrip)),
			A2(
				$elm$core$List$cons,
				$author$project$Types$CruiseMultiDepartureTrip$Ok(trips.Gg),
				trips.lH));
		return {mg: trips.mg, lH: others, Gg: selectedTrip};
	});
var $author$project$Update$Trips$selectCruiseMultiDepartureTrip = F2(
	function (id, model) {
		var session = model.j;
		var _v0 = session.tp;
		if ((!_v0.$) && (_v0.a.$ === 2)) {
			var shopping = _v0.a.a;
			var newModel = $author$project$Update$Trips$resetSelectedCalendarDate(
				function (a) {
					return _Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{tp: a})
						});
				}(
					$author$project$Types$Trips$Success(
						$author$project$Types$Trips$CruiseMultiDeparture(
							A2($author$project$Types$CruiseMultiDepartureTrips$select, id, shopping)))));
			return $author$project$Update$Trips$addSelectedSailRequests(newModel);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$CruiseSails$all = function (_v0) {
	var cruiseSails = _v0;
	return A3(
		$elm$core$Dict$insert,
		cruiseSails.Gg.a,
		$author$project$Types$CruiseSail$Available(cruiseSails.Gg.b),
		cruiseSails.nu);
};
var $author$project$Types$CruiseSails$select = F2(
	function (selectedCruiseSail, _v0) {
		var cruiseSails = _v0;
		return A4(
			$author$project$Types$CruiseSails$init,
			cruiseSails.mL,
			selectedCruiseSail,
			$author$project$Types$CruiseSails$all(cruiseSails),
			cruiseSails.mg);
	});
var $author$project$Update$Trips$selectCruiseSail = F3(
	function (model, stringSailTuple, cruiseSails) {
		var session = model.j;
		var trips = $author$project$Types$Trips$Success(
			$author$project$Types$Trips$Cruise(
				A2($author$project$Types$CruiseSails$select, stringSailTuple, cruiseSails)));
		return $author$project$Update$Trips$addSelectedSailRequests(
			$author$project$Update$Trips$removeSelectedBusTransfers(
				_Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{tp: trips})
					})));
	});
var $author$project$Types$SelectedVehicles$addSelectedVehicle = F2(
	function (session, selectedVehicle) {
		return $author$project$Types$SelectedVehicles$fromList(
			A3(
				$elm$core$List$foldl,
				$author$project$Types$SelectedVehicles$remapAvailability(session),
				_List_Nil,
				A2(
					$elm$core$List$append,
					_List_fromArray(
						[selectedVehicle]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, session.rp)))));
	});
var $author$project$Update$Vehicles$selectVehicleSuccess = F2(
	function (selectedVehicles, model) {
		var session = model.j;
		var location = model.n1;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: A2($author$project$Update$Vehicles$setSelectedVehiclesToSession, session, selectedVehicles)
				}),
			(!_Utils_eq(
				$author$project$UrlRoute$parseLocation(location),
				$author$project$UrlRoute$Vehicle)) ? _List_fromArray(
				[
					A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$Vehicle)
				]) : _List_Nil);
	});
var $author$project$Update$Vehicles$selectMemorizedVehicle = F2(
	function (model, selectedVehicle) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$batch,
						A2($author$project$Update$Vehicles$selectVehicleSuccess, a, model));
				},
				A2($author$project$Types$SelectedVehicles$addSelectedVehicle, model.j, selectedVehicle)));
	});
var $author$project$Types$Hotel$init = $elm$core$Dict$empty;
var $author$project$Update$selectRegularBookingType = function (model) {
	var session = model.j;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						vk: 0,
						yx: _List_Nil,
						zw: $elm$core$Maybe$Nothing,
						zI: {vZ: _List_Nil, zH: _List_Nil},
						Ac: false,
						Dy: $elm$core$Maybe$Nothing,
						Gk: $author$project$Types$Hotel$init
					})
			}),
		A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$Root));
};
var $author$project$Types$RouteTripSails$isAvailableAndWithSameId = F2(
	function (previousSail, _v0) {
		var sailId = _v0.F3;
		var isDisabled = _v0.mA;
		var hasRoom = _v0.zr;
		return _Utils_eq(sailId, previousSail.F3) && ((!isDisabled) && hasRoom);
	});
var $author$project$Types$RouteTripSails$selectOutward = F4(
	function (bookingType, hotels, selectedSail, _v0) {
		var outward = _v0.Ds;
		var _return = _v0.FL;
		var clubOneOnlyPromotion = _v0.mg;
		return A2(
			$elm$core$Maybe$withDefault,
			{mg: clubOneOnlyPromotion, Ds: outward, FL: _return},
			A2(
				$elm$core$Maybe$map,
				function (sail) {
					return {
						mg: clubOneOnlyPromotion,
						Ds: _Utils_update(
							outward,
							{Gg: sail}),
						FL: A2(
							$elm$core$Maybe$andThen,
							function (justReturn) {
								var returnSelectedSailIsSuitable = function () {
									if (!bookingType) {
										return A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, selectedSail, justReturn.Gg);
									} else {
										return A3($author$project$Types$RouteTripSails$isReturnSailSuitableForHotelPackage, hotels, selectedSail, justReturn.Gg);
									}
								}();
								return A2(
									$elm$core$Maybe$map,
									function (s) {
										return _Utils_update(
											justReturn,
											{Gg: s});
									},
									returnSelectedSailIsSuitable ? $elm$core$Maybe$Just(justReturn.Gg) : A3($author$project$Types$RouteTripSails$findSelectableReturnSail, bookingType, sail, justReturn.H));
							},
							_return)
					};
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					$author$project$Types$RouteTripSails$isAvailableAndWithSameId(selectedSail),
					A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, outward.H))));
	});
var $author$project$Types$RouteTripSails$selectReturn = F2(
	function (selectedSail, _v0) {
		var routeTripSails = _v0;
		var select = F2(
			function (_v1, sail) {
				var outward = _v1.Ds;
				var _return = _v1.FL;
				var clubOneOnlyPromotion = _v1.mg;
				return {
					mg: clubOneOnlyPromotion,
					Ds: outward,
					FL: A2($author$project$Types$RouteTripSails$isTimeGapBetweenSailsLargeEnough, outward.Gg, sail) ? A2(
						$elm$core$Maybe$map,
						function (a) {
							return _Utils_update(
								a,
								{Gg: sail});
						},
						_return) : _return
				};
			});
		return A2(
			$elm$core$Maybe$withDefault,
			routeTripSails,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.H;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filterMap($author$project$Types$RouteTripSail$toReal),
							$elm_community$list_extra$List$Extra$find(
								$author$project$Types$RouteTripSails$isAvailableAndWithSameId(selectedSail)))),
					$elm$core$Maybe$map(
						select(routeTripSails))),
				routeTripSails.FL));
	});
var $author$project$Update$Trips$getNewSails = F4(
	function (_v0, direction, sail, sails) {
		var session = _v0.j;
		if (!direction) {
			return A4($author$project$Types$RouteTripSails$selectOutward, session.vk, session.zI.zH, sail, sails);
		} else {
			return A2($author$project$Types$RouteTripSails$selectReturn, sail, sails);
		}
	});
var $author$project$Update$Trips$selectRouteTripInModel = F4(
	function (model, direction, sail, sails) {
		var session = model.j;
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						tp: $author$project$Types$Trips$Success(
							$author$project$Types$Trips$Route(
								A4($author$project$Update$Trips$getNewSails, model, direction, sail, sails)))
					})
			});
	});
var $author$project$Types$RouteTripSails$isWithOvernightSail = function (sails) {
	return $author$project$Types$RouteTripSails$isOutwardOvernightSail(sails) || $author$project$Types$RouteTripSails$isReturnOvernightSail(sails);
};
var $author$project$Update$Trips$isNewRouteTripSelectionWithOvernightOneTalHelRoute = F2(
	function (old, _new) {
		var _v0 = $author$project$Types$RouteTripSails$selected(_new).a;
		var cityFrom = _v0.v1;
		var cityTo = _v0.v2;
		return (!_Utils_eq(
			$author$project$Types$RouteTripSails$getSailIds(old),
			$author$project$Types$RouteTripSails$getSailIds(_new))) && ($author$project$Types$RouteTripSails$isWithOvernightSail(_new) && ((!$author$project$Types$RouteTripSails$isWithOvernightSail(old)) && A2($author$project$Utils$Route$isTalHelRoute, cityFrom, cityTo)));
	});
var $author$project$Utils$Route$isTalStoRouteTrip = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return _Utils_eq(voyageType, $author$project$Types$VoyageType$RouteTrip) && (((!from) && (to === 1)) || ((from === 1) && (!to)));
};
var $author$project$Update$Trips$resetTravelClasses = function (model) {
	var session = model.j;
	return _Utils_update(
		model,
		{
			j: _Utils_update(
				session,
				{to: $elm$core$Maybe$Nothing})
		});
};
var $author$project$Ports$trackDateSelection = _Platform_outgoingPort('trackDateSelection', $elm$json$Json$Encode$bool);
var $author$project$Update$Trips$selectRouteTripSail = F4(
	function (model, direction, sail, sails) {
		var session = model.j;
		var wasPreviousSailOvernight = _Utils_eq(session.tx, $author$project$Types$VoyageType$Shuttle) && $author$project$Types$RouteTripSails$isWithOvernightSail(sails);
		var newSails = A4($author$project$Update$Trips$getNewSails, model, direction, sail, sails);
		return A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$addSelectedSailRequests,
			_Utils_Tuple2(
				(wasPreviousSailOvernight ? $author$project$Update$Trips$resetTravelClasses : $elm$core$Basics$identity)(
					$author$project$Update$Trips$removeSelectedBusTransfers(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{
										zw: $elm$core$Maybe$Nothing,
										Dy: ((session.vk === 1) && (!direction)) ? A2(
											$author$project$Types$Hotel$getHotelAvailabilityBorder,
											A4($justinmimbs$time_extra$Time$Extra$add, 12, $author$project$Constants$arrivalTimeHoursShift, $elm$time$Time$utc, sail.ps),
											session.zI.zH) : session.Dy,
										Gk: $author$project$Types$Hotel$init,
										tp: $author$project$Types$Trips$Success(
											$author$project$Types$Trips$Route(newSails))
									})
							}))),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Messages$ToastMsg,
							function (_v0) {
								var shouldShowDayTripNotification = _v0.a;
								var notification = _v0.b;
								return shouldShowDayTripNotification ? A3($author$project$Common$Toast$showToastCmd, 0, notification, true) : $author$project$Common$Toast$hideToastCmd(model.HT.zN);
							}(
								$author$project$Types$RouteTripSails$dayTripNotification(newSails))),
							A2($author$project$Update$Trips$isNewRouteTripSelectionWithOvernightOneTalHelRoute, sails, newSails) ? A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Messages$ToastMsg,
							A3(
								$author$project$Common$Toast$showToastCmd,
								0,
								function ($) {
									return $.hm;
								},
								false)) : $elm$core$Platform$Cmd$none,
							$author$project$Utils$Route$isTalStoRouteTrip(session) ? $author$project$Ports$trackDateSelection(!direction) : $elm$core$Platform$Cmd$none
						]))));
	});
var $author$project$Types$SelectedVehicles$LastAvailableVehicle = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$SelectedVehicles$MaxVehicleCountReached = {$: 5};
var $author$project$Types$SelectedVehicles$Ok = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$SelectedVehicles$OutwardSoldOut = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$SelectedVehicles$ReturnSoldOut = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$SelectedVehicle$SelectedVehicle = F6(
	function (carCategory, licensePlate, licensePlateTrailer, voyageType, isMemorized, isModified) {
		return {jZ: carCategory, Ai: isMemorized, Aj: isModified, n_: licensePlate, n$: licensePlateTrailer, tx: voyageType};
	});
var $author$project$Types$SelectedVehicles$SoldOut = {$: 4};
var $author$project$Types$SelectedVehicles$init = function (selectedVehicle) {
	return {nx: selectedVehicle, lH: $elm$core$Array$empty};
};
var $author$project$Types$SelectedVehicles$push = F2(
	function (selectedVehicle, _v0) {
		var first = _v0.nx;
		var others = _v0.lH;
		return {
			nx: first,
			lH: A2($elm$core$Array$push, selectedVehicle, others)
		};
	});
var $author$project$Types$SelectedVehicles$add = F2(
	function (session, vehicle) {
		var maybeSelectedVehicles = session.rp;
		var isOneWay = session.qW;
		var voyageType = session.tx;
		var returnSoldOut = A3(
			$author$project$Types$SelectedVehicles$isVehicleSoldOut,
			1,
			vehicle,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, maybeSelectedVehicles)));
		var returnAvailability = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.uk;
				},
				vehicle.FN));
		var outwardSoldOut = A3(
			$author$project$Types$SelectedVehicles$isVehicleSoldOut,
			0,
			vehicle,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, maybeSelectedVehicles)));
		var outwardAvailability = vehicle.Du.uk;
		var newSelectedVehicle = function (vehicleVoyageType) {
			return A6(
				$author$project$Types$SelectedVehicle$SelectedVehicle,
				vehicle.jZ,
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just(vehicleVoyageType),
				false,
				false);
		};
		var isMaxVehiclesCountAdded = A3($author$project$Types$SelectedVehicles$isMaxVehicleCountReached, session, vehicle.jZ, maybeSelectedVehicles);
		var isEnoughSpaceForReturn = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Types$SelectedVehicles$canAddCategoryForReturn, session, vehicle.jZ),
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$getReturnCategories, session.rp)));
		var isEnoughSpaceForOutward = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Types$SelectedVehicles$canAddCategoryForOutward, session, vehicle.jZ),
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$getOutwardCategories, session.rp)));
		var addVehicleWithVoyageType = function (vehicleVoyageType) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Types$SelectedVehicles$init(
					newSelectedVehicle(vehicleVoyageType)),
				A2(
					$elm$core$Maybe$map,
					$author$project$Types$SelectedVehicles$push(
						newSelectedVehicle(vehicleVoyageType)),
					maybeSelectedVehicles));
		};
		return (isMaxVehiclesCountAdded || (((!isEnoughSpaceForOutward) && returnSoldOut) || ((!isEnoughSpaceForReturn) && outwardSoldOut))) ? $author$project$Types$SelectedVehicles$MaxVehicleCountReached : (isOneWay ? (outwardSoldOut ? $author$project$Types$SelectedVehicles$SoldOut : ((outwardAvailability === 1) ? $author$project$Types$SelectedVehicles$LastAvailableVehicle(
			addVehicleWithVoyageType(1)) : $author$project$Types$SelectedVehicles$Ok(
			addVehicleWithVoyageType(1)))) : ((outwardSoldOut && returnSoldOut) ? $author$project$Types$SelectedVehicles$SoldOut : (outwardSoldOut ? $author$project$Types$SelectedVehicles$OutwardSoldOut(
			addVehicleWithVoyageType(2)) : (returnSoldOut ? $author$project$Types$SelectedVehicles$ReturnSoldOut(
			addVehicleWithVoyageType(1)) : (((outwardAvailability === 1) || (returnAvailability === 1)) ? $author$project$Types$SelectedVehicles$LastAvailableVehicle(
			addVehicleWithVoyageType(0)) : ((!isEnoughSpaceForOutward) ? $author$project$Types$SelectedVehicles$Ok(
			addVehicleWithVoyageType(2)) : ((!isEnoughSpaceForReturn) ? $author$project$Types$SelectedVehicles$Ok(
			addVehicleWithVoyageType(1)) : $author$project$Types$SelectedVehicles$Ok(
			addVehicleWithVoyageType(0)))))))));
	});
var $author$project$VehiclePage$Util$minimalWidthForDisplayingFourElements = 398;
var $author$project$VehiclePage$Util$maxVehiclesInList = function (bodyWidth) {
	return (_Utils_cmp(bodyWidth, $author$project$VehiclePage$Util$minimalWidthForDisplayingFourElements) > 0) ? 4 : 3;
};
var $author$project$Update$Vehicles$updateDynamicCarCategory = F2(
	function (model, carCategory) {
		var session = model.j;
		var vehiclePage = model.Ih;
		var location = model.n1;
		var isCurrentCarCategoryDynamic = _Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jZ;
					},
					$elm$core$Basics$eq(carCategory)),
				A2(
					$elm$core$List$take,
					$author$project$VehiclePage$Util$maxVehiclesInList(vehiclePage.uz) - 1,
					session.tt)));
		var maybeNewCarCategory = isCurrentCarCategoryDynamic ? $elm$core$Maybe$Just(carCategory) : vehiclePage.lr;
		var wasCategoryPushed = ((!_Utils_eq(
			$author$project$UrlRoute$parseLocation(location),
			$author$project$UrlRoute$Vehicle)) && isCurrentCarCategoryDynamic) ? A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$neq(carCategory),
				vehiclePage.lr)) : false;
		return _Utils_update(
			model,
			{
				Ih: _Utils_update(
					vehiclePage,
					{lr: maybeNewCarCategory, ty: wasCategoryPushed})
			});
	});
var $author$project$Update$Vehicles$selectVehicle = F2(
	function (model, vehicle) {
		var vehiclesCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$countSelected, model.j.rp));
		var canAddMemorizedVehicle = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$SelectedVehicles$toList,
					$elm$core$List$all(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.Ai;
							},
							$elm$core$Basics$not))),
				model.j.rp));
		var adultsCount = $author$project$Types$Passenger$Util$countAdultPassengers(model.j.Eg);
		return A2(
			$elm$core$Maybe$withDefault,
			function () {
				var _v0 = A2($author$project$Types$SelectedVehicles$add, model.j, vehicle);
				switch (_v0.$) {
					case 0:
						var selectedVehicles = _v0.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Utils$Route$isMugVssRoute(model.j.kS) ? $elm$core$List$cons(
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Messages$ToastMsg,
										$author$project$Common$Toast$hideToastCmd(model.HT.zN))) : $elm$core$Basics$identity,
								$elm$core$Platform$Cmd$batch),
							A2(
								$author$project$Update$Vehicles$selectVehicleSuccess,
								selectedVehicles,
								A2($author$project$Update$Vehicles$updateDynamicCarCategory, model, vehicle.jZ)));
					case 1:
						var selectedVehicles = _v0.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$cons(
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Messages$ToastMsg,
										A3(
											$author$project$Common$Toast$showToastCmd,
											0,
											function ($) {
												return $.hw;
											},
											false))),
								$elm$core$Platform$Cmd$batch),
							A2(
								$author$project$Update$Vehicles$selectVehicleSuccess,
								selectedVehicles,
								A2($author$project$Update$Vehicles$updateDynamicCarCategory, model, vehicle.jZ)));
					case 2:
						var selectedVehicles = _v0.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$cons(
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Messages$ToastMsg,
										A3(
											$author$project$Common$Toast$showToastCmd,
											0,
											function ($) {
												return $.hv;
											},
											false))),
								$elm$core$Platform$Cmd$batch),
							A2(
								$author$project$Update$Vehicles$selectVehicleSuccess,
								selectedVehicles,
								A2($author$project$Update$Vehicles$updateDynamicCarCategory, model, vehicle.jZ)));
					case 3:
						var selectedVehicles = _v0.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$cons(
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Messages$ToastMsg,
										A3(
											$author$project$Common$Toast$showToastCmd,
											0,
											function ($) {
												return $.hs;
											},
											false))),
								$elm$core$Platform$Cmd$batch),
							A2(
								$author$project$Update$Vehicles$selectVehicleSuccess,
								selectedVehicles,
								A2($author$project$Update$Vehicles$updateDynamicCarCategory, model, vehicle.jZ)));
					case 4:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								A3(
									$author$project$Common$Toast$showToastCmd,
									1,
									$author$project$Utils$Route$isExactlyOneVehicleRequired(model.j) ? function ($) {
										return $.aZ;
									} : function ($) {
										return $.S;
									},
									false)));
				}
			}(),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$SelectedVehicles$remapSelectedVehicleCategory(model.j.tt),
					function (memorizedVehicle) {
						return (canAddMemorizedVehicle && (_Utils_eq(memorizedVehicle.jZ, vehicle.jZ) && (_Utils_cmp(vehiclesCount, adultsCount) < 0))) ? $elm$core$Maybe$Just(
							A2(
								$author$project$Update$Vehicles$selectMemorizedVehicle,
								model,
								_Utils_update(
									memorizedVehicle,
									{Aj: true}))) : $elm$core$Maybe$Nothing;
					}),
				model.Ih.BV));
	});
var $author$project$Update$Util$sequentialCmds = F2(
	function (cmd, cmds) {
		if (!cmds.b) {
			return cmd;
		} else {
			var first = cmds.a;
			var others = cmds.b;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2(
						$elm$core$Task$perform,
						function (_v1) {
							return A2($author$project$Messages$SequentialCmds, first, others);
						},
						$elm$core$Task$succeed(0))
					]));
		}
	});
var $author$project$Types$TravelClasses$findAndIncreaseTravelClassCount = F2(
	function (selected, selectedCode) {
		return (!_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq(selectedCode)),
				selected))) ? A2(
			$elm$core$List$map,
			function (_v0) {
				var code = _v0.a;
				var count = _v0.b;
				return _Utils_eq(code, selectedCode) ? _Utils_Tuple2(code, count + 1) : _Utils_Tuple2(code, count);
			},
			selected) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2(selectedCode, 1),
			selected);
	});
var $author$project$Types$TravelClasses$setSelection = F3(
	function (travelClasses, code, direction) {
		switch (travelClasses.$) {
			case 0:
				var selected = travelClasses.a.Gg;
				var available = travelClasses.a.nb;
				var pets = travelClasses.a.k;
				return A3(
					$author$project$Types$TravelClasses$removeAllPetTravelClasses,
					selected,
					direction,
					$author$project$Types$TravelClasses$OneWaySingle(
						{nb: available, k: pets, Gg: code}));
			case 1:
				var twoWay = travelClasses.a;
				if (!direction) {
					return A3(
						$author$project$Types$TravelClasses$removeAllPetTravelClasses,
						twoWay.Ds,
						direction,
						$author$project$Types$TravelClasses$TwoWaySingle(
							_Utils_update(
								twoWay,
								{Ds: code})));
				} else {
					return A3(
						$author$project$Types$TravelClasses$removeAllPetTravelClasses,
						twoWay.FL,
						direction,
						$author$project$Types$TravelClasses$TwoWaySingle(
							_Utils_update(
								twoWay,
								{FL: code})));
				}
			case 2:
				var oneWay = travelClasses.a;
				return $author$project$Types$TravelClasses$OneWayMultiple(
					_Utils_update(
						oneWay,
						{
							Gg: A2($author$project$Types$TravelClasses$findAndIncreaseTravelClassCount, oneWay.Gg, code)
						}));
			default:
				var twoWay = travelClasses.a;
				if (!direction) {
					return $author$project$Types$TravelClasses$TwoWayMultiple(
						_Utils_update(
							twoWay,
							{
								Ds: A2($author$project$Types$TravelClasses$findAndIncreaseTravelClassCount, twoWay.Ds, code)
							}));
				} else {
					return $author$project$Types$TravelClasses$TwoWayMultiple(
						_Utils_update(
							twoWay,
							{
								FL: A2($author$project$Types$TravelClasses$findAndIncreaseTravelClassCount, twoWay.FL, code)
							}));
				}
		}
	});
var $author$project$Update$setVehicleImpcompatible = F2(
	function (vehicleIncompatible, model) {
		var session = model.j;
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{If: vehicleIncompatible})
			});
	});
var $author$project$Common$Recaptcha$isCompanyCustomer = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			session.xA)) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.xU;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.xA;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing))),
			session.Fz));
};
var $author$project$Common$Recaptcha$isLoggedInClient = function (session) {
	return $krisajenkins$remotedata$RemoteData$isSuccess(session.Ia.v4);
};
var $author$project$Common$Recaptcha$shouldRequestRecaptcha = function (session) {
	return (!session.Fr.yL) ? false : ((!$author$project$Common$Recaptcha$isLoggedInClient(session)) && (!$author$project$Common$Recaptcha$isCompanyCustomer(session)));
};
var $author$project$Price$View$showAddMoreTravelClassesNotice = function (model) {
	var coversAllPassengers = A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.qa;
			},
			model.j.B7));
	return ((!$author$project$Update$Summary$isRequiredTravelClassSelected(model)) && $author$project$Price$View$hasTravelClassesSelected(model.j.to)) || (!coversAllPassengers);
};
var $author$project$Update$BusTransfers$showBusTransferRemovedToastIfNeeded = F2(
	function (maybePreviousSelectedBusTransfers, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return ((!_Utils_eq(maybePreviousSelectedBusTransfers, $elm$core$Maybe$Nothing)) && _Utils_eq(model.j.B0, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Messages$ToastMsg,
						A3(
							$author$project$Common$Toast$showToastCmd,
							1,
							function ($) {
								return $.g5;
							},
							false))
					]))) : _Utils_Tuple2(model, cmd);
	});
var $author$project$Update$duplicateErrorMessageAndParams = F2(
	function (_v0, _v1) {
		var duplicatedReservation = _v0.dF;
		var httpConfig = _v1.zM;
		var language = _v1.A_;
		return A2(
			$elm$core$Maybe$map,
			function (_v2) {
				var currency = _v2.yd;
				var price = _v2.lN;
				var resId = _v2.oG;
				var resToken = _v2.mS;
				var link = httpConfig.Gs.og + ('?resToken=' + (resToken + ('&language=' + $elm$core$String$toLower(
					$author$project$Types$Language$toString(language)))));
				return _Utils_Tuple2(
					function ($) {
						return $.dF;
					},
					_List_fromArray(
						[
							_Utils_Tuple2('unit', currency),
							_Utils_Tuple2(
							'price',
							$elm$core$String$fromInt(price)),
							_Utils_Tuple2(
							'resId',
							$elm$core$String$fromInt(resId)),
							_Utils_Tuple2('resToken', resToken),
							_Utils_Tuple2('link', link)
						]));
			},
			duplicatedReservation);
	});
var $author$project$Update$ReservationConfirmationError = F3(
	function (message, errorType, duplicatedReservation) {
		return {dF: duplicatedReservation, qe: errorType, Cv: message};
	});
var $author$project$Update$DuplicatedReservation = F4(
	function (currency, price, resId, resToken) {
		return {yd: currency, lN: price, oG: resId, mS: resToken};
	});
var $author$project$Update$duplicatedReservationDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Update$DuplicatedReservation,
	A2($elm$json$Json$Decode$field, 'currency', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'resId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'resToken', $elm$json$Json$Decode$string));
var $author$project$Update$reservationConfirmationErrorDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Update$ReservationConfirmationError,
	A2(
		$elm$json$Json$Decode$field,
		'message',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'reservation',
		$elm$json$Json$Decode$maybe($author$project$Update$duplicatedReservationDecoder)));
var $author$project$Update$swrErrorMessageAndParams = function (_v0) {
	var message = _v0.Cv;
	return A2(
		$elm$core$Maybe$map,
		function (a) {
			return _Utils_Tuple2(
				function (_v1) {
					return a;
				},
				_List_Nil);
		},
		message);
};
var $author$project$Update$errorMessageAndParamsForConfirmationError = F2(
	function (error, session) {
		var unknownErrorMessageAndNoParams = _Utils_Tuple2(
			function ($) {
				return $.FH;
			},
			_List_Nil);
		var errorMessageFromError = function (error1) {
			var message = error1.Cv;
			var errorType = error1.qe;
			switch (errorType) {
				case 'swr':
					return $author$project$Update$swrErrorMessageAndParams(error1);
				case 'duplicate':
					return A2($author$project$Update$duplicateErrorMessageAndParams, error1, session);
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		if (error.$ === 3) {
			var body = error.b;
			return A2(
				$elm$core$Result$withDefault,
				unknownErrorMessageAndNoParams,
				A2(
					$elm$core$Result$map,
					A2(
						$elm$core$Basics$composeR,
						errorMessageFromError,
						$elm$core$Maybe$withDefault(unknownErrorMessageAndNoParams)),
					A2($elm$json$Json$Decode$decodeString, $author$project$Update$reservationConfirmationErrorDecoder, body)));
		} else {
			return unknownErrorMessageAndNoParams;
		}
	});
var $author$project$Common$Toast$showToastCmdWithParamsContainingHtml = F4(
	function (toastType, translate, isPermanent, params) {
		return $author$project$Common$Toast$performImmediately(
			A5($author$project$Common$Toast$showToastMsg, toastType, translate, isPermanent, true, params));
	});
var $author$project$Update$showConfirmationErrorToast = F2(
	function (error, session) {
		var _v0 = A2($author$project$Update$errorMessageAndParamsForConfirmationError, error, session);
		var translate = _v0.a;
		var params = _v0.b;
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Messages$ToastMsg,
			A4($author$project$Common$Toast$showToastCmdWithParamsContainingHtml, 1, translate, false, params));
	});
var $author$project$Ports$signOut = _Platform_outgoingPort(
	'signOut',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Update$User$signOut = function (model) {
	return _Utils_Tuple2(
		$author$project$Update$User$removeUserData(
			_Utils_update(
				model,
				{
					j: $author$project$Session$removeAffiliatesFromPassengers(model.j)
				})),
		$author$project$Ports$signOut(0));
};
var $author$project$Update$Passengers$storeClubOnePassenger = F3(
	function (model, index, passenger) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: function (a) {
						return _Utils_update(
							a,
							{
								Eg: A3($elm$core$Array$set, index, passenger, a.Eg)
							});
					}(model.j)
				}),
			$elm$core$Platform$Cmd$batch(
				A3(
					$author$project$Utils$List$addIf,
					!$elm$core$String$isEmpty(passenger.y2),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Messages$ToastMsg,
						$author$project$Common$Toast$showClubOneLoginSuccessToast(
							{zj: passenger.y2})),
					_List_fromArray(
						[
							$author$project$UrlRoute$back(model.AK)
						]))));
	});
var $author$project$Ports$submitFormData = _Platform_outgoingPort('submitFormData', $elm$core$Basics$identity);
var $author$project$Api$Reservation$submitFormData = F2(
	function (model, method) {
		return A2(
			$elm$core$Basics$composeL,
			$author$project$Ports$submitFormData,
			function (response) {
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2('response', response),
							_Utils_Tuple2(
							'voucherId',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.pQ;
										},
										$elm$json$Json$Encode$string),
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.qO;
											},
											$elm$core$Basics$not),
										model.j.tw)))),
							_Utils_Tuple2(
							'method',
							$elm$json$Json$Encode$string(method))
						]));
			});
	});
var $author$project$Types$ErrorDetailed$toHttpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return $elm$http$Http$BadUrl(url);
		case 1:
			return $elm$http$Http$Timeout;
		case 2:
			return $elm$http$Http$NetworkError;
		case 3:
			var metadata = error.a;
			return $elm$http$Http$BadStatus(metadata.GU);
		default:
			var body = error.a;
			return $elm$http$Http$BadBody(body);
	}
};
var $author$project$BookingPage$Update$toggleVehicle = function (model) {
	var hasMemorizedVehicle = A2(
		$elm$core$List$any,
		function (_v1) {
			var isMemorized = _v1.Ai;
			var carCategory = _v1.jZ;
			return isMemorized && $author$project$Types$Vehicle$isDefaultCarCategory(carCategory);
		},
		model.j.yq);
	var _v0 = model;
	var bookingPage = _v0.pz;
	return _Utils_update(
		model,
		{
			pz: _Utils_update(
				bookingPage,
				{Ay: hasMemorizedVehicle})
		});
};
var $author$project$Types$SelectedVehicles$canVehicleBeToggled = function (selectedVehicles) {
	if (selectedVehicles.b) {
		var first = selectedVehicles.a;
		var others = selectedVehicles.b;
		return $elm$core$List$isEmpty(others) && ((!first.Aj) && $author$project$Types$Vehicle$isDefaultCarCategory(first.jZ));
	} else {
		return true;
	}
};
var $author$project$Update$Vehicles$toggleVehicles = function (model) {
	var session = model.j;
	var canVehiclesBeToggled = $author$project$Types$SelectedVehicles$canVehicleBeToggled(session.yq);
	return (canVehiclesBeToggled && (_Utils_eq(session.rp, $elm$core$Maybe$Nothing) && (!$elm$core$List$length(session.yq)))) ? function (a) {
		return _Utils_update(
			model,
			{j: a});
	}(
		function (a) {
			return _Utils_update(
				a,
				{
					rp: $author$project$Types$SelectedVehicles$remap(a)
				});
		}(
			function (a) {
				return _Utils_update(
					session,
					{yq: a});
			}(
				$elm$core$List$singleton(
					A2($author$project$Update$Vehicles$desiredVehicle, model.Ih.BV, 0))))) : (canVehiclesBeToggled ? function (a) {
		return _Utils_update(
			model,
			{j: a});
	}(
		$author$project$Update$Vehicles$clearVehiclesInSession(session)) : model);
};
var $author$project$TimetablePage$Update$toggleVehicle = F2(
	function (session, model) {
		var hasMemorizedVehicle = A2(
			$elm$core$List$any,
			function (_v0) {
				var isMemorized = _v0.Ai;
				var carCategory = _v0.jZ;
				return isMemorized && $author$project$Types$Vehicle$isDefaultCarCategory(carCategory);
			},
			session.yq);
		return ((!model.nY) && hasMemorizedVehicle) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{nY: true}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$ToastMsg,
				A3(
					$author$project$Common$Toast$showToastCmd,
					2,
					function ($) {
						return $.HP;
					},
					false))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Update$toggleVehiclesOnTimetablePage = function (model) {
	var _v0 = model.DF;
	if (_v0.$ === 1) {
		var pageModel = _v0.a;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (a) {
				return _Utils_update(
					model,
					{
						DF: $author$project$Model$Timetable(a)
					});
			},
			A2($author$project$TimetablePage$Update$toggleVehicle, model.j, pageModel));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Ports$trackCombinedSailModalOpened = _Platform_outgoingPort('trackCombinedSailModalOpened', $elm$json$Json$Encode$bool);
var $author$project$Ports$trackCombinedSailStartBooking = _Platform_outgoingPort(
	'trackCombinedSailStartBooking',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'from',
					$elm$json$Json$Encode$string($.kS)),
					_Utils_Tuple2(
					'to',
					$elm$json$Json$Encode$string($.le))
				]));
	});
var $author$project$Ports$trackThanksForTheInfoClick = _Platform_outgoingPort(
	'trackThanksForTheInfoClick',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Types$JoinClubOneState$ContactPersonIsNotTravellingError = {$: 3};
var $author$project$Update$JoinClubOne$canContactPersonBeSavedAsPassenger = function (passengers) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.A6;
				},
				$elm$core$String$isEmpty),
			A2($elm$core$Array$get, 0, passengers)));
};
var $author$project$Update$JoinClubOne$isContactPersonInPassengers = F2(
	function (model, passengers) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return A2($author$project$Types$Passenger$areNamesEqualIgnoringCapitalization, a, model) && (!a.tY);
			},
			$elm$core$Array$toList(passengers));
	});
var $author$project$Update$JoinClubOne$isContactPersonTravelling = F2(
	function (_v0, model) {
		var passengers = _v0.Eg;
		return A2($author$project$Update$JoinClubOne$isContactPersonInPassengers, model, passengers) || $author$project$Update$JoinClubOne$canContactPersonBeSavedAsPassenger(passengers);
	});
var $author$project$Messages$GotJoinClubOnePossibility = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$ClubOne$decoder = A2($elm$json$Json$Decode$field, 'joinClubOneAllowed', $elm$json$Json$Decode$bool);
var $author$project$Api$Endpoint$joinClubOne = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['client', 'joinClubOneAllowed']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.q4));
	});
var $author$project$Api$ClubOne$join = F3(
	function (_v0, _v1, model) {
		var sessionGuid = _v0.Gt;
		var serverConfig = _v0.Gs;
		var market = _v1.rb;
		var language = _v1.A_;
		var isExperimental = _v1.Aa;
		var queryParams = A3(
			$author$project$Utils$List$addIf,
			isExperimental,
			A2($elm$url$Url$Builder$string, 'experimental', 'true'),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'sessionGUID', sessionGuid),
					A2(
					$elm$url$Url$Builder$string,
					'locale',
					$elm$core$String$toLower(
						$author$project$Types$Language$toString(language))),
					A2(
					$elm$url$Url$Builder$string,
					'country',
					$elm$core$String$toUpper(
						$author$project$Types$Market$toString(market))),
					A2($elm$url$Url$Builder$string, 'email', model.yI),
					A2(
					$elm$url$Url$Builder$string,
					'phone',
					A2($elm$core$String$startsWith, model.p$, model.ox) ? model.ox : _Utils_ap(model.p$, model.ox)),
					A2($elm$url$Url$Builder$string, 'lastName', model.A6),
					A2($elm$url$Url$Builder$string, 'firstName', model.y2)
				]));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, $author$project$Messages$GotJoinClubOnePossibility, $author$project$Api$ClubOne$decoder),
				jW: A2($author$project$Api$Endpoint$joinClubOne, serverConfig, queryParams)
			});
	});
var $author$project$Update$JoinClubOne$turnOn = F2(
	function (pageModel, model) {
		var session = model.j;
		return A2($author$project$Update$JoinClubOne$isContactPersonTravelling, session, pageModel) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					j: _Utils_update(
						session,
						{AE: $author$project$Types$JoinClubOneState$Loading})
				}),
			A3($author$project$Api$ClubOne$join, model.j.zM, session, pageModel)) : _Utils_Tuple2(
			function (a) {
				return _Utils_update(
					model,
					{
						j: _Utils_update(
							session,
							{AE: a})
					});
			}($author$project$Types$JoinClubOneState$ContactPersonIsNotTravellingError),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Common$Toast$Entered = 1;
var $author$project$Common$Toast$Entering = 0;
var $author$project$Common$Toast$HideAnimation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Toast$Leaving = 2;
var $author$project$Common$Toast$Remove = {$: 3};
var $author$project$Common$Toast$pause = 500;
var $author$project$Common$Toast$timeout = 5000;
var $author$project$Common$Toast$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var toast = msg.a;
				var isPermanent = msg.b;
				if (A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.mW;
							},
							$elm$core$Basics$eq(2)),
						model.L))) {
					var id = model.zN + 1;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								zN: id,
								L: $elm$core$Maybe$Just(
									{zN: id, mW: 0, HO: toast})
							}),
						isPermanent ? A2(
							$author$project$Common$Toast$performAfterTimeout,
							$author$project$Common$Toast$pause,
							$author$project$Common$Toast$HideAnimation(id)) : $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Common$Toast$performAfterTimeout,
									$author$project$Common$Toast$timeout,
									$author$project$Common$Toast$StartedRemove(id)),
									A2(
									$author$project$Common$Toast$performAfterTimeout,
									$author$project$Common$Toast$pause,
									$author$project$Common$Toast$HideAnimation(id))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								L: A2(
									$elm$core$Maybe$map,
									function (a) {
										return _Utils_update(
											a,
											{mW: 2});
									},
									model.L)
							}),
						A2(
							$author$project$Common$Toast$performAfterTimeout,
							$author$project$Common$Toast$pause,
							A2($author$project$Common$Toast$Show, toast, isPermanent)));
				}
			case 2:
				var id = msg.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$eq(id),
								function ($) {
									return $.zN;
								}),
							model.L)) ? function (a) {
						return _Utils_update(
							model,
							{L: a});
					}(
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return _Utils_update(
									a,
									{mW: 1});
							},
							model.L)) : model,
					$elm$core$Platform$Cmd$none);
			case 1:
				var id = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Basics$eq(id),
							function ($) {
								return $.zN;
							}),
						model.L)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							L: A2(
								$elm$core$Maybe$map,
								function (a) {
									return _Utils_update(
										a,
										{mW: 2});
								},
								model.L)
						}),
					A2($author$project$Common$Toast$performAfterTimeout, $author$project$Common$Toast$pause, $author$project$Common$Toast$Remove)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Session$removeTicketFromList = function (ticket) {
	return $elm$core$List$filterMap(
		function (pair) {
			return A2($author$project$Types$Ticket$areTicketsEqual, pair.b, ticket) ? $elm$core$Maybe$Just(
				A2(
					$elm$core$Tuple$mapFirst,
					function (count) {
						return count - 1;
					},
					pair)) : $elm$core$Maybe$Just(pair);
		});
};
var $author$project$LandServicePage$Update$removeTicket = F2(
	function (session, ticket) {
		return _Utils_update(
			session,
			{
				Gl: A2($author$project$Session$removeTicketFromList, ticket, session.Gl)
			});
	});
var $author$project$LandServicePage$Update$toggleLandServiceDescriptionVisibility = F2(
	function (session, id) {
		return _Utils_update(
			session,
			{
				BW: _Utils_eq(
					session.BW,
					$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
			});
	});
var $author$project$LandServicePage$Update$toggleLandServiceEventVisibility = F2(
	function (session, id) {
		return _Utils_update(
			session,
			{
				BX: _Utils_eq(
					session.BX,
					$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
			});
	});
var $author$project$LandServicePage$Update$update = F2(
	function (msg, session) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				return A2($author$project$Session$addTicket, session, code);
			case 1:
				var code = msg.a;
				return A2($author$project$LandServicePage$Update$removeTicket, session, code);
			case 2:
				var id = msg.a;
				return A2($author$project$LandServicePage$Update$toggleLandServiceEventVisibility, session, id);
			default:
				var id = msg.a;
				return A2($author$project$LandServicePage$Update$toggleLandServiceDescriptionVisibility, session, id);
		}
	});
var $author$project$MealPage$Messages$AddOption = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$MealPage$Messages$NoOp = {$: 5};
var $author$project$MealPage$Messages$OpenMealPackageModal = {$: 2};
var $author$project$MealPage$Messages$RemoveOption = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$MealPage$Messages$ToggleMealPackage = function (a) {
	return {$: 4, a: a};
};
var $author$project$MealPage$Messages$ToggleSitting = function (a) {
	return {$: 3, a: a};
};
var $author$project$MealPage$Common$maxCommentLength = 255;
var $author$project$MealPage$Update$update = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				var direction = msg.b;
				return _Utils_Tuple2(
					A3(
						$elm$core$Dict$update,
						name,
						$elm$core$Maybe$map(
							function (a) {
								return _Utils_update(
									a,
									{p7: direction});
							}),
						model),
					$author$project$MealPage$Messages$NoOp);
			case 1:
				var name = msg.a;
				var string = msg.b;
				return _Utils_Tuple2(
					A3(
						$elm$core$Dict$update,
						name,
						$elm$core$Maybe$map(
							function (a) {
								return _Utils_update(
									a,
									{
										wo: A2($elm$core$String$left, $author$project$MealPage$Common$maxCommentLength, string)
									});
							}),
						model),
					$author$project$MealPage$Messages$NoOp);
			case 2:
				var addonCode = msg.a;
				var direction = msg.b;
				var sitting = msg.c;
				return _Utils_Tuple2(
					model,
					A3($author$project$MealPage$Messages$AddOption, addonCode, direction, sitting));
			case 3:
				var addonCode = msg.a;
				var direction = msg.b;
				var sitting = msg.c;
				return _Utils_Tuple2(
					model,
					A3($author$project$MealPage$Messages$RemoveOption, addonCode, direction, sitting));
			case 4:
				var a = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$MealPage$Messages$ToggleSitting(a));
			case 5:
				var code = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$MealPage$Messages$ToggleMealPackage(code));
			default:
				return _Utils_Tuple2(model, $author$project$MealPage$Messages$OpenMealPackageModal);
		}
	});
var $author$project$Page$Company$AgentForm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Company$GotAgent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Company$Agent = F6(
	function (id, firstName, lastName, email, phone, secondaryEmail) {
		return {yI: email, y2: firstName, zN: id, A6: lastName, ox: phone, Gd: secondaryEmail};
	});
var $author$project$Types$Company$agentDecoder = function (id) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'secondaryEmail',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lastName',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'firstName',
						$elm$json$Json$Decode$string,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							id,
							$elm$json$Json$Decode$succeed($author$project$Types$Company$Agent)))))));
};
var $author$project$Api$Util$agentIdParam = function (agentId) {
	return _Utils_Tuple2(
		'agentId',
		$elm$core$String$fromInt(agentId));
};
var $author$project$Api$Endpoint$companyAgent = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['client', 'company', 'agent']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Util$companyIdParam = function (companyId) {
	return _Utils_Tuple2(
		'companyId',
		$elm$core$String$fromInt(companyId));
};
var $author$project$Types$Company$RawCompanyDetails = F2(
	function (isValid, details) {
		return {yt: details, Aw: isValid};
	});
var $author$project$Types$Company$validCompanyDetailsDecoder = function (aDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (rawValue) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, aDecoder, rawValue.yt);
			if (!_v0.$) {
				var details = _v0.a;
				return rawValue.Aw ? $elm$json$Json$Decode$succeed(details) : $elm$json$Json$Decode$fail('Invalid details');
			} else {
				var error = _v0.a;
				return $elm$json$Json$Decode$fail(
					$elm$json$Json$Decode$errorToString(error));
			}
		},
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'details',
			$elm$json$Json$Decode$value,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valid',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Types$Company$RawCompanyDetails))));
};
var $author$project$Page$Company$fetchAgent = F4(
	function (_v0, details, agentId, serverConfig) {
		var isExperimental = _v0.Aa;
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Company$GotAgent),
					$author$project$Types$Company$validCompanyDetailsDecoder(
						$author$project$Types$Company$agentDecoder(agentId))),
				jW: A2(
					$author$project$Api$Endpoint$companyAgent,
					serverConfig,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						isExperimental,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_List_fromArray(
								[
									$author$project$Api$Util$companyIdParam(details.zN),
									$author$project$Api$Util$agentIdParam(agentId)
								]))))
			});
	});
var $author$project$Page$Company$GotCompany = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Endpoint$company = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['client', 'company']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Types$Company$Details = F5(
	function (id, name, address, isInvoiceEnabled, isAgentRequired) {
		return {tT: address, zN: id, mw: isAgentRequired, qR: isInvoiceEnabled, oh: name};
	});
var $author$project$Types$Company$detailsDecoder = function (id) {
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'agentRequired',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hasAgent',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'address',
				$author$project$Types$Company$addressDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						id,
						$elm$json$Json$Decode$succeed($author$project$Types$Company$Details))))));
};
var $author$project$Page$Company$fetchCompany = F3(
	function (_v0, companyId, serverConfig) {
		var isExperimental = _v0.Aa;
		return $author$project$Api$getWithCredentials(
			{
				j9: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Company$GotCompany),
					$author$project$Types$Company$validCompanyDetailsDecoder(
						$author$project$Types$Company$detailsDecoder(companyId))),
				jW: A2(
					$author$project$Api$Endpoint$company,
					serverConfig,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						isExperimental,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var a = _v1.a;
								var b = _v1.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_List_fromArray(
								[
									$author$project$Api$Util$companyIdParam(companyId)
								]))))
			});
	});
var $author$project$Page$Company$handleCompanyAgentResponse = F4(
	function (navKey, url, response, model) {
		if (response.$ === 2) {
			if (response.a.$ === 2) {
				var _v1 = response.a;
				return _Utils_Tuple2(
					$author$project$Page$Company$AgentForm(
						_Utils_update(
							model,
							{tZ: response})),
					A3($author$project$UrlRoute$pushUrl, navKey, url, $author$project$UrlRoute$ConnectionProblem));
			} else {
				var error = response.a;
				return _Utils_Tuple2(
					$author$project$Page$Company$AgentForm(
						_Utils_update(
							model,
							{tZ: response})),
					A2($author$project$Tracking$logHttpError, 'agentDataResponse', error));
			}
		} else {
			return _Utils_Tuple2(
				$author$project$Page$Company$AgentForm(
					_Utils_update(
						model,
						{tZ: response})),
				$author$project$UrlRoute$back(navKey));
		}
	});
var $author$project$Page$Company$initAgentFormModel = function (details) {
	return {tZ: $krisajenkins$remotedata$RemoteData$NotAsked, yt: details, zN: ''};
};
var $author$project$Page$Company$handleCompanyResponse = F4(
	function (navKey, url, webData, model) {
		switch (webData.$) {
			case 3:
				var details = webData.a;
				var isInvoiceEnabled = details.qR;
				var isAgentRequired = details.mw;
				return _Utils_Tuple2(
					$author$project$Page$Company$AgentForm(
						$author$project$Page$Company$initAgentFormModel(details)),
					((!isInvoiceEnabled) && (!isAgentRequired)) ? $author$project$UrlRoute$back(navKey) : $elm$core$Platform$Cmd$none);
			case 2:
				if (webData.a.$ === 2) {
					var _v1 = webData.a;
					return _Utils_Tuple2(
						$author$project$Page$Company$CompanyForm(
							_Utils_update(
								model,
								{yt: webData})),
						A3($author$project$UrlRoute$pushUrl, navKey, url, $author$project$UrlRoute$ConnectionProblem));
				} else {
					var error = webData.a;
					return _Utils_Tuple2(
						$author$project$Page$Company$CompanyForm(
							_Utils_update(
								model,
								{yt: webData})),
						A2($author$project$Tracking$logHttpError, 'companyDataResponse', error));
				}
			default:
				return _Utils_Tuple2(
					$author$project$Page$Company$CompanyForm(
						_Utils_update(
							model,
							{yt: webData})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$Company$update = F5(
	function (navKey, url, session, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$9:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var id = _v0.a.a;
						var form = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Page$Company$CompanyForm(
								_Utils_update(
									form,
									{yt: $krisajenkins$remotedata$RemoteData$NotAsked, zN: id})),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v0$9;
					}
				case 4:
					if (!_v0.b.$) {
						var id = _v0.a.a;
						var form = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Page$Company$CompanyForm(
								_Utils_update(
									form,
									{yt: $krisajenkins$remotedata$RemoteData$Loading})),
							A3($author$project$Page$Company$fetchCompany, session, id, session.zM.Gs));
					} else {
						break _v0$9;
					}
				case 2:
					if (!_v0.b.$) {
						var details = _v0.a.a;
						var form = _v0.b.a;
						return A4($author$project$Page$Company$handleCompanyResponse, navKey, url, details, form);
					} else {
						break _v0$9;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var id = _v0.a.a;
						var form = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Page$Company$AgentForm(
								_Utils_update(
									form,
									{tZ: $krisajenkins$remotedata$RemoteData$NotAsked, zN: id})),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v0$9;
					}
				case 5:
					if (_v0.b.$ === 1) {
						var id = _v0.a.a;
						var form = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Page$Company$AgentForm(
								_Utils_update(
									form,
									{tZ: $krisajenkins$remotedata$RemoteData$Loading})),
							A4($author$project$Page$Company$fetchAgent, session, form.yt, id, session.zM.Gs));
					} else {
						break _v0$9;
					}
				case 3:
					if (_v0.b.$ === 1) {
						var agentWebData = _v0.a.a;
						var form = _v0.b.a;
						return A4($author$project$Page$Company$handleCompanyAgentResponse, navKey, url, agentWebData, form);
					} else {
						break _v0$9;
					}
				case 6:
					var _v1 = _v0.a;
					return _Utils_Tuple2(
						model,
						$author$project$UrlRoute$back(navKey));
				default:
					if (!_v0.b.$) {
						var _v2 = _v0.a;
						var form = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Page$Company$CompanyForm(
								_Utils_update(
									form,
									{yt: $krisajenkins$remotedata$RemoteData$NotAsked, zN: ''})),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v3 = _v0.a;
						var form = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Page$Company$AgentForm(
								_Utils_update(
									form,
									{tZ: $krisajenkins$remotedata$RemoteData$NotAsked, zN: ''})),
							$elm$core$Platform$Cmd$none);
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Page$Discount$Update$resetCodeAndValidation = function (model) {
	return _Utils_update(
		model,
		{pQ: '', ko: $krisajenkins$remotedata$RemoteData$NotAsked});
};
var $author$project$Page$Discount$Update$GotVoucherValidation = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Endpoint$voucher = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['voucher']),
			params,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Voucher$validate = F3(
	function (params, code, resultToMsg) {
		return $author$project$Api$postWithCredentials(
			{
				ks: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$string(code)),
				j9: A2(
					$elm$http$Http$expectJson,
					resultToMsg,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'priceLeft',
						$elm$json$Json$Decode$float,
						0,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'applicabilityEnd',
							$elm$json$Json$Decode$string,
							'',
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'type',
								A2(
									$elm$json$Json$Decode$andThen,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Basics$eq('COUPON'),
										$elm$json$Json$Decode$succeed),
									$elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'callToCallCenterNeeded',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'valid',
										$elm$json$Json$Decode$bool,
										$elm$json$Json$Decode$succeed(
											F5(
												function (isValid, isCallRequired, isCoupon, applicabilityEnd, priceLeft) {
													return {
														Aw: isValid,
														Ip: {ub: $elm$core$Maybe$Nothing, ug: applicabilityEnd, pQ: code, yQ: '', z4: false, z7: isCallRequired, qO: isCoupon, Ak: false, Ax: false, Fk: priceLeft}
													};
												})))))))),
				jW: A2(
					$author$project$Api$Endpoint$voucher,
					params.zM.Gs,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						params.Aa,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var a = _v0.a;
								var b = _v0.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_List_fromArray(
								[
									$author$project$Api$Util$guidParam(params.zM.Gt),
									$author$project$Api$Util$marketParam(params.rb),
									$author$project$Api$Util$localeParam(params.A_)
								]))))
			});
	});
var $author$project$Page$Discount$Update$validate = F2(
	function (session, code) {
		return A3(
			$author$project$Api$Voucher$validate,
			session,
			code,
			A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Discount$Update$GotVoucherValidation));
	});
var $author$project$Page$Discount$Update$update = F3(
	function (navKey, msg, _v0) {
		var session = _v0.j;
		var model = _v0.eM;
		switch (msg.$) {
			case 3:
				return _Utils_Tuple2(
					{
						eM: _Utils_update(
							model,
							{ko: $krisajenkins$remotedata$RemoteData$Loading}),
						j: session
					},
					A2($author$project$Page$Discount$Update$validate, session, model.pQ));
			case 4:
				var code = msg.a;
				return _Utils_Tuple2(
					{
						eM: _Utils_update(
							model,
							{
								pQ: $elm$core$String$toUpper(code),
								ko: $krisajenkins$remotedata$RemoteData$NotAsked
							}),
						j: session
					},
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					{
						eM: $author$project$Page$Discount$Update$resetCodeAndValidation(model),
						j: session
					},
					$elm$core$Platform$Cmd$none);
			case 6:
				var code = msg.a;
				return _Utils_eq(
					model.Ix,
					$elm$core$Maybe$Just(code)) ? _Utils_Tuple2(
					{
						eM: _Utils_update(
							model,
							{Ix: $elm$core$Maybe$Nothing}),
						j: session
					},
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					{
						eM: _Utils_update(
							model,
							{
								Ix: $elm$core$Maybe$Just(code)
							}),
						j: session
					},
					$elm$core$Platform$Cmd$none);
			case 2:
				var index = msg.a;
				var vouchers = A2($elm_community$list_extra$List$Extra$removeAt, index, session.tw);
				return _Utils_Tuple2(
					{
						eM: model,
						j: _Utils_update(
							session,
							{tw: vouchers})
					},
					$elm$core$Platform$Cmd$none);
			case 5:
				var data = msg.a;
				switch (data.$) {
					case 3:
						var voucher = data.a.Ip;
						var isValid = data.a.Aw;
						return isValid ? _Utils_Tuple2(
							{
								eM: $author$project$Page$Discount$Update$resetCodeAndValidation(model),
								j: _Utils_update(
									session,
									{
										tw: _Utils_ap(
											session.tw,
											_List_fromArray(
												[voucher]))
									})
							},
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							{
								eM: _Utils_update(
									model,
									{ko: data}),
								j: session
							},
							$elm$core$Platform$Cmd$none);
					case 2:
						var error = data.a;
						return _Utils_Tuple2(
							{
								eM: _Utils_update(
									model,
									{ko: data}),
								j: session
							},
							A2($author$project$Tracking$logHttpError, 'voucherValidationResponse', error));
					default:
						return _Utils_Tuple2(
							{
								eM: _Utils_update(
									model,
									{ko: data}),
								j: session
							},
							$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					{eM: model, j: session},
					$author$project$UrlRoute$back(navKey));
		}
	});
var $author$project$Page$Hotel$ToastMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$Hotel$create = F2(
	function (_v0, count) {
		var cityCode = _v0.pK;
		var hotelCode = _v0.zx;
		var roomCode = _v0.FY;
		var nights = _v0.CI;
		return {pK: cityCode, pQ: roomCode, pZ: count, zx: hotelCode, CI: nights};
	});
var $author$project$Types$Hotel$addRoom = F2(
	function (selectedRoom, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$update,
			$author$project$Types$Hotel$roomCodeToString(selectedRoom.FY),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					function (a) {
						return _Utils_update(
							a,
							{pZ: a.pZ + 1});
					}),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(
						A2($author$project$Types$Hotel$create, selectedRoom, 1)),
					$elm$core$Maybe$Just)),
			dict);
	});
var $author$project$Page$Hotel$findDatesInSelectedRange = F2(
	function (model, code) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var nights = _v0.CI;
				return $author$project$Utils$OneOrMore$fromList(
					A2(
						$elm$core$List$filter,
						function (date) {
							return (A2($author$project$Utils$Time$differenceInDays, model.zw.ln, date) >= 0) && (A2($author$project$Utils$Time$differenceInDays, model.zw.lo, date) < 0);
						},
						A2(
							$elm$core$List$map,
							function ($) {
								return $.nn;
							},
							$author$project$Utils$OneOrMore$toList(nights))));
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$elm$core$Basics$eq(code)),
				$author$project$Utils$OneOrMore$toList(model.zv.F_)));
	});
var $author$project$Types$Hotel$decreaseRoomCount = function (selectedRoom) {
	return (!(selectedRoom.pZ - 1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		_Utils_update(
			selectedRoom,
			{pZ: selectedRoom.pZ - 1}));
};
var $author$project$Types$Hotel$removeRoom = F2(
	function (code, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$update,
			$author$project$Types$Hotel$roomCodeToString(code),
			$elm$core$Maybe$andThen($author$project$Types$Hotel$decreaseRoomCount),
			dict);
	});
var $author$project$Page$Hotel$showHotelRoomCapacityWarningToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Page$Hotel$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		1,
		function ($) {
			return $.HS;
		},
		false));
var $author$project$Page$Hotel$update = F4(
	function (navKey, url, msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var toSelected = function (nights) {
					return {pK: model.zv.pK, zx: model.zv.pQ, CI: nights, FY: code};
				};
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (dates) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										Gk: A2(
											$author$project$Types$Hotel$addRoom,
											toSelected(dates),
											model.Gk)
									}),
								$elm$core$Platform$Cmd$none);
						},
						A2($author$project$Page$Hotel$findDatesInSelectedRange, model, code)));
			case 1:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Gk: A2($author$project$Types$Hotel$removeRoom, code, model.Gk)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var code = msg.a;
				return _Utils_eq(
					model.k6,
					$elm$core$Maybe$Just(code)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{k6: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							k6: $elm$core$Maybe$Just(code)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lv: !model.lv}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					model,
					A3($author$project$UrlRoute$pushUrl, navKey, url, $author$project$UrlRoute$HotelList));
			case 6:
				return _Utils_Tuple2(model, $author$project$Page$Hotel$showHotelRoomCapacityWarningToast);
			default:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Page$Hotel$ToastMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (a) {
							return _Utils_update(
								model,
								{HT: a});
						},
						A2($author$project$Common$Toast$update, subMsg, model.HT)));
		}
	});
var $author$project$Page$HotelLinks$defaultHotels = A3(
	$elm$core$List$foldl,
	F2(
		function (hotelTranslation, hotelTranslations) {
			return A3(
				$elm$core$Dict$insert,
				$author$project$Page$HotelLinks$hotelIdToString(hotelTranslation.zN),
				hotelTranslation,
				hotelTranslations);
		}),
	$elm$core$Dict$empty,
	_List_fromArray(
		[
			{zN: 0, Bx: '', k2: '', HI: 'TALLINK HOTEL RIGA'},
			{zN: 1, Bx: '', k2: '', HI: 'TALLINK EXPRESS HOTEL'},
			{zN: 2, Bx: '', k2: '', HI: 'TALLINK SPA & CONFERENCE HOTEL'},
			{zN: 3, Bx: '', k2: '', HI: 'TALLINK CITY HOTEL'}
		]));
var $author$project$Page$HotelLinks$update = F2(
	function (msg, model) {
		if (!msg.$) {
			if (!msg.a.$) {
				var hotel = msg.a.a;
				var hotels = A3(
					$elm$core$Dict$insert,
					$author$project$Page$HotelLinks$hotelIdToString(hotel.zN),
					hotel,
					model.zH);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{zH: hotels}),
					$elm$core$Platform$Cmd$none);
			} else {
				var error = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{zH: $author$project$Page$HotelLinks$defaultHotels}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Tracking$logHttpError, 'liferayHotelTranslations', error)
							])));
			}
		} else {
			var hotelId = msg.a;
			var hotelWithExpandedDescription = (_Utils_eq(model.kx, $elm$core$Maybe$Nothing) || (!_Utils_eq(
				model.kx,
				$elm$core$Maybe$Just(hotelId)))) ? $elm$core$Maybe$Just(hotelId) : $elm$core$Maybe$Nothing;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{kx: hotelWithExpandedDescription}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Page$HotelList$GotCitiesShadows = function (a) {
	return {$: 12, a: a};
};
var $author$project$Page$HotelList$Tooltip = F2(
	function (status, position) {
		return {oC: position, sX: status};
	});
var $author$project$Page$HotelList$calculateCitiesShadows = function (_v0) {
	var scene = _v0.F8;
	var viewport = _v0.In;
	if (_Utils_eq(scene.m2, viewport.m2)) {
		return {lR: false, lS: false};
	} else {
		var maxOffset = 15;
		var showLeftShadow = _Utils_cmp(viewport.tD, maxOffset) > 0;
		var showRightBorder = _Utils_cmp((scene.m2 - viewport.m2) - viewport.tD, maxOffset) > 0;
		return {lR: showLeftShadow, lS: showRightBorder};
	}
};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$Page$HotelList$update = F5(
	function (navKey, url, session, msg, model) {
		var calendar = model.w;
		switch (msg.$) {
			case 0:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kH: $elm$core$Maybe$Just(code)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var code = msg.a;
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$UrlRoute$replaceUrl,
						navKey,
						url,
						$author$project$UrlRoute$Hotel(code)));
			case 2:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lu: $elm$core$Maybe$Just(code)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lu: $elm$core$Maybe$Nothing, Gk: $author$project$Types$Hotel$init}),
					A3(
						$author$project$UrlRoute$replaceUrl,
						navKey,
						url,
						$author$project$UrlRoute$Hotel(
							$author$project$Types$Hotel$hotelCodeToString(code))));
			case 4:
				var tab = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: _Utils_update(
								calendar,
								{kl: tab})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var date = msg.a;
				var _v1 = calendar;
				var selectedDates = _v1.o;
				var newSelectedDates = (!calendar.kl) ? _Utils_update(
					selectedDates,
					{ln: date}) : _Utils_update(
					selectedDates,
					{lo: date});
				var availableCitiesForNewSelectedDates = A2(
					$author$project$Types$Hotel$filterCitiesByHotels,
					A2(
						$elm$core$List$filter,
						$author$project$Types$Hotel$hasAvailableRooms(newSelectedDates),
						session.zI.zH),
					session.zI.vZ);
				var newSelectedCity = A2(
					$elm$core$List$member,
					model.kH,
					A2($elm$core$List$map, $elm$core$Maybe$Just, availableCitiesForNewSelectedDates)) ? model.kH : $elm$core$List$head(availableCitiesForNewSelectedDates);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: _Utils_update(
								calendar,
								{o: newSelectedDates, lg: $elm$core$Maybe$Nothing}),
							kH: newSelectedCity,
							Gk: $author$project$Types$Hotel$init
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var status = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: _Utils_update(
								calendar,
								{
									lg: $elm$core$Maybe$Just(
										A2($author$project$Page$HotelList$Tooltip, status, index))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: _Utils_update(
								calendar,
								{lg: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var _v2 = function (a) {
					return _Utils_Tuple2(
						A2($elm$time$Time$toMonth, $elm$time$Time$utc, a),
						A2($elm$time$Time$toYear, $elm$time$Time$utc, a));
				}(
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						2,
						1,
						$elm$time$Time$utc,
						A2(
							$justinmimbs$time_extra$Time$Extra$partsToPosix,
							$elm$time$Time$utc,
							A7($justinmimbs$time_extra$Time$Extra$Parts, calendar.h, calendar.s, 1, 0, 0, 0, 0))));
				var month = _v2.a;
				var year = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: _Utils_update(
								calendar,
								{s: month, h: year})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var _v3 = function (a) {
					return _Utils_Tuple2(
						A2($elm$time$Time$toMonth, $elm$time$Time$utc, a),
						A2($elm$time$Time$toYear, $elm$time$Time$utc, a));
				}(
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						2,
						-1,
						$elm$time$Time$utc,
						A2(
							$justinmimbs$time_extra$Time$Extra$partsToPosix,
							$elm$time$Time$utc,
							A7($justinmimbs$time_extra$Time$Extra$Parts, calendar.h, calendar.s, 1, 0, 0, 0, 0))));
				var month = _v3.a;
				var year = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w: _Utils_update(
								calendar,
								{s: month, h: year})
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var code = msg.a;
				return _Utils_eq(
					model.kx,
					$elm$core$Maybe$Just(code)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{kx: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kx: $elm$core$Maybe$Just(code)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var timetableRoute = A3($author$project$UrlRoute$getTimetableRoute, session.tx, false, 0);
				return _Utils_Tuple2(
					model,
					A3($author$project$UrlRoute$pushUrl, navKey, url, timetableRoute));
			case 12:
				var citiesShadows = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{md: citiesShadows}),
					$elm$core$Platform$Cmd$none);
			default:
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Page$HotelList$GotCitiesShadows,
						A2(
							$elm$core$Task$onError,
							$elm$core$Basics$always(
								$elm$core$Task$succeed(
									{lR: false, lS: true})),
							A2(
								$elm$core$Task$map,
								$author$project$Page$HotelList$calculateCitiesShadows,
								$elm$browser$Browser$Dom$getViewportOf('cityButtons')))));
		}
	});
var $author$project$Page$OnboardService$Update$ToastMsg = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Types$SelectedOnboardServices$addCountInDict = F4(
	function (toKey, a, count, dict) {
		return A2(
			$elm$core$Dict$member,
			toKey(a),
			dict) ? A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, _v1) {
					var v = _v1.b;
					return v > 0;
				}),
			A3(
				$elm$core$Dict$update,
				toKey(a),
				$elm$core$Maybe$map(
					$elm$core$Tuple$mapSecond(
						$elm$core$Basics$add(count))),
				dict)) : A3(
			$elm$core$Dict$insert,
			toKey(a),
			_Utils_Tuple2(a, count),
			dict);
	});
var $author$project$Types$SelectedOnboardServices$countShipMoneyCoupons = function (_v0) {
	var outwardShipMoney = _v0.eW;
	var returnShipMoney = _v0.N;
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			_Utils_ap(
				$elm$core$Dict$values(outwardShipMoney),
				$elm$core$Dict$values(returnShipMoney))));
};
var $author$project$Types$SelectedOnboardServices$maxShipMoneyCouponsPerBooking = 24;
var $author$project$Types$SelectedOnboardServices$addOutwardShipMoney = F3(
	function (_int, shipMoneyCode, _v0) {
		var services = _v0;
		return ((_Utils_cmp(
			$author$project$Types$SelectedOnboardServices$countShipMoneyCoupons(services),
			$author$project$Types$SelectedOnboardServices$maxShipMoneyCouponsPerBooking) > -1) && (_int > 0)) ? services : _Utils_update(
			services,
			{
				eW: A4($author$project$Types$SelectedOnboardServices$addCountInDict, $author$project$Types$OnboardServices$ShipMoney$codeToString, shipMoneyCode, _int, services.eW)
			});
	});
var $author$project$Types$SelectedOnboardServices$addReturnShipMoney = F3(
	function (_int, shipMoneyCode, _v0) {
		var services = _v0;
		return ((_Utils_cmp(
			$author$project$Types$SelectedOnboardServices$countShipMoneyCoupons(services),
			$author$project$Types$SelectedOnboardServices$maxShipMoneyCouponsPerBooking) > -1) && (_int > 0)) ? services : _Utils_update(
			services,
			{
				N: A4($author$project$Types$SelectedOnboardServices$addCountInDict, $author$project$Types$OnboardServices$ShipMoney$codeToString, shipMoneyCode, _int, services.N)
			});
	});
var $author$project$Types$SelectedOnboardServices$tableReservationDictKey = function (beginTime) {
	return 'table-reservation-' + $elm$core$String$fromInt(
		$elm$time$Time$posixToMillis(beginTime));
};
var $author$project$Types$SelectedOnboardServices$addTableReservation = F2(
	function (_v0, _v1) {
		var code = _v0.a;
		var beginTime = _v0.b;
		var services = _v1;
		var selected = A3(
			$elm$core$Dict$insert,
			$author$project$Types$SelectedOnboardServices$tableReservationDictKey(beginTime),
			_Utils_Tuple2(code, beginTime),
			services.G5);
		return _Utils_update(
			services,
			{G5: selected});
	});
var $author$project$Types$SelectedOnboardServices$getSelectedMassageTimeSlots = F2(
	function (massage, _v0) {
		var massageTimeSlots = _v0.y;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, massage.pQ, massageTimeSlots));
	});
var $author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots = F2(
	function (massage, selectedOnboardServices) {
		var timeSlots = massage.mY;
		return A2(
			$elm$core$List$filter,
			function (timeSlot) {
				return !A2(
					$elm$core$List$member,
					timeSlot,
					A2($author$project$Types$SelectedOnboardServices$getSelectedMassageTimeSlots, massage, selectedOnboardServices));
			},
			timeSlots);
	});
var $author$project$Types$SelectedOnboardServices$addedMassageTimeSlot = F2(
	function (massage, selectedOnboardServices) {
		var selected = selectedOnboardServices;
		return A2(
			$elm$core$Maybe$withDefault,
			selectedOnboardServices,
			A2(
				$elm$core$Maybe$map,
				function (timeSlot) {
					return _Utils_update(
						selected,
						{
							y: A3(
								$elm$core$Dict$update,
								massage.pQ,
								$elm$core$Maybe$map(
									function (timeSlots) {
										return _Utils_ap(
											timeSlots,
											_List_fromArray(
												[timeSlot]));
									}),
								selected.y)
						});
				},
				$elm$core$List$head(
					A2($author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots, massage, selectedOnboardServices))));
	});
var $author$project$Types$SelectedOnboardServices$increaseOutwardBubbleFairServiceCount = F3(
	function (delta, code, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				jO: A4($author$project$Types$SelectedOnboardServices$addCountInDict, $author$project$Types$OnboardServices$BubbleFairService$codeToString, code, delta, services.jO)
			});
	});
var $author$project$Types$SelectedOnboardServices$increaseOutwardCovidServiceCount = F3(
	function (delta, code, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				ke: A4($author$project$Types$SelectedOnboardServices$addCountInDict, $author$project$Types$OnboardServices$CovidService$codeToString, code, delta, services.ke)
			});
	});
var $author$project$Types$SelectedOnboardServices$increaseOutwardFriendshipBraceletCount = F3(
	function (delta, addon, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				eV: A4(
					$author$project$Types$SelectedOnboardServices$addCountInDict,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$author$project$Types$OnboardServices$Addon$codeToString),
					addon,
					delta,
					services.eV)
			});
	});
var $author$project$Types$SelectedOnboardServices$increaseReturnBubbleFairServiceCount = F3(
	function (delta, code, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				jT: A4($author$project$Types$SelectedOnboardServices$addCountInDict, $author$project$Types$OnboardServices$BubbleFairService$codeToString, code, delta, services.jT)
			});
	});
var $author$project$Types$SelectedOnboardServices$increaseReturnCovidServiceCount = F3(
	function (delta, code, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				kj: A4($author$project$Types$SelectedOnboardServices$addCountInDict, $author$project$Types$OnboardServices$CovidService$codeToString, code, delta, services.kj)
			});
	});
var $author$project$Types$SelectedOnboardServices$increaseReturnFriendshipBraceletCount = F3(
	function (delta, addon, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				fy: A4(
					$author$project$Types$SelectedOnboardServices$addCountInDict,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$author$project$Types$OnboardServices$Addon$codeToString),
					addon,
					delta,
					services.fy)
			});
	});
var $author$project$Types$SelectedOnboardServices$removeTableReservation = F2(
	function (beginTime, _v0) {
		var services = _v0;
		var selected = A2(
			$elm$core$Dict$remove,
			$author$project$Types$SelectedOnboardServices$tableReservationDictKey(beginTime),
			services.G5);
		return _Utils_update(
			services,
			{G5: selected});
	});
var $author$project$Types$SelectedOnboardServices$getMassageTimeSlotIndex = F3(
	function (selectedOnboardServices, massage, timeSlot) {
		return A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (selectedTimeSlot) {
				return _Utils_eq(selectedTimeSlot.ld, timeSlot.ld);
			},
			A2($author$project$Types$SelectedOnboardServices$getSelectedMassageTimeSlots, massage, selectedOnboardServices));
	});
var $author$project$Types$SelectedOnboardServices$removedMassageTimeSlot = F3(
	function (massage, timeSlot, selectedOnboardServices) {
		var selected = selectedOnboardServices;
		return A2(
			$elm$core$Maybe$withDefault,
			selectedOnboardServices,
			A2(
				$elm$core$Maybe$map,
				function (index) {
					return _Utils_update(
						selected,
						{
							y: A3(
								$elm$core$Dict$update,
								massage.pQ,
								$elm$core$Maybe$map(
									$elm_community$list_extra$List$Extra$removeAt(index)),
								selected.y)
						});
				},
				A3($author$project$Types$SelectedOnboardServices$getMassageTimeSlotIndex, selectedOnboardServices, massage, timeSlot)));
	});
var $author$project$Utils$Time$Translations$toChineseMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('一月', '1月');
		case 1:
			return _Utils_Tuple2('二月', '2月');
		case 2:
			return _Utils_Tuple2('三月', '3月');
		case 3:
			return _Utils_Tuple2('四月', '4月');
		case 4:
			return _Utils_Tuple2('五月', '5月');
		case 5:
			return _Utils_Tuple2('六月', '6月');
		case 6:
			return _Utils_Tuple2('七月', '7月');
		case 7:
			return _Utils_Tuple2('八月', '8月');
		case 8:
			return _Utils_Tuple2('九月', '9月');
		case 9:
			return _Utils_Tuple2('十月', '10月');
		case 10:
			return _Utils_Tuple2('十一月', '11月');
		default:
			return _Utils_Tuple2('十二月', '12月');
	}
};
var $author$project$Utils$Time$Translations$toChineseWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return _Utils_Tuple2('星期一', '周一');
		case 1:
			return _Utils_Tuple2('星期二', '周二');
		case 2:
			return _Utils_Tuple2('星期三', '周三');
		case 3:
			return _Utils_Tuple2('星期四', '周四');
		case 4:
			return _Utils_Tuple2('星期五', '周五');
		case 5:
			return _Utils_Tuple2('星期六', '周六');
		default:
			return _Utils_Tuple2('星期日', '周日');
	}
};
var $author$project$Utils$Time$Translations$chinese = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toChineseMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toChineseMonthName, $elm$core$Tuple$second),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toChineseWeekdayName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toChineseWeekdayName, $elm$core$Tuple$second),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toEstonianMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('jaanuar', 'jaan');
		case 1:
			return _Utils_Tuple2('veebruar', 'veebr');
		case 2:
			return _Utils_Tuple2('märts', 'märts');
		case 3:
			return _Utils_Tuple2('aprill', 'apr');
		case 4:
			return _Utils_Tuple2('mai', 'mai');
		case 5:
			return _Utils_Tuple2('juuni', 'juuni');
		case 6:
			return _Utils_Tuple2('juuli', 'juuli');
		case 7:
			return _Utils_Tuple2('august', 'aug');
		case 8:
			return _Utils_Tuple2('september', 'sept');
		case 9:
			return _Utils_Tuple2('oktoober', 'okt');
		case 10:
			return _Utils_Tuple2('november', 'nov');
		default:
			return _Utils_Tuple2('detsember', 'dets');
	}
};
var $author$project$Utils$Time$Translations$toEstonianWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'esmaspäev';
		case 1:
			return 'teisipäev';
		case 2:
			return 'kolmapäev';
		case 3:
			return 'neljapäev';
		case 4:
			return 'reede';
		case 5:
			return 'laupäev';
		default:
			return 'pühapäev';
	}
};
var $author$project$Utils$Time$Translations$estonian = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toEstonianMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toEstonianMonthName, $elm$core$Tuple$second),
	$author$project$Utils$Time$Translations$toEstonianWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Time$Translations$toEstonianWeekdayName,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$left(1),
			$elm$core$String$toUpper)),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toFinnishMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('tammikuu', 'tammi');
		case 1:
			return _Utils_Tuple2('helmikuu', 'helmi');
		case 2:
			return _Utils_Tuple2('maaliskuu', 'maalis');
		case 3:
			return _Utils_Tuple2('huhtikuu', 'huhti');
		case 4:
			return _Utils_Tuple2('toukokuu', 'touko');
		case 5:
			return _Utils_Tuple2('kesäkuu', 'kesä');
		case 6:
			return _Utils_Tuple2('heinäkuu', 'heinä');
		case 7:
			return _Utils_Tuple2('elokuu', 'elo');
		case 8:
			return _Utils_Tuple2('syyskuu', 'syys');
		case 9:
			return _Utils_Tuple2('lokakuu', 'loka');
		case 10:
			return _Utils_Tuple2('marraskuu', 'marras');
		default:
			return _Utils_Tuple2('joulukuu', 'joulu');
	}
};
var $author$project$Utils$Time$Translations$toFinnishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'maanantai';
		case 1:
			return 'tiistai';
		case 2:
			return 'keskiviikko';
		case 3:
			return 'torstai';
		case 4:
			return 'perjantai';
		case 5:
			return 'lauantai';
		default:
			return 'sunnuntai';
	}
};
var $author$project$Utils$Time$Translations$finnish = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toFinnishMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toFinnishMonthName, $elm$core$Tuple$second),
	$author$project$Utils$Time$Translations$toFinnishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Time$Translations$toFinnishWeekdayName,
		$elm$core$String$left(2)),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toGermanMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('Januar', 'Jan.');
		case 1:
			return _Utils_Tuple2('Februar', 'Feb.');
		case 2:
			return _Utils_Tuple2('März', 'März');
		case 3:
			return _Utils_Tuple2('April', 'Apr.');
		case 4:
			return _Utils_Tuple2('Mai', 'Mai');
		case 5:
			return _Utils_Tuple2('Juni', 'Juni');
		case 6:
			return _Utils_Tuple2('Juli', 'Juli');
		case 7:
			return _Utils_Tuple2('August', 'Aug.');
		case 8:
			return _Utils_Tuple2('September', 'Sep.');
		case 9:
			return _Utils_Tuple2('Oktober', 'Okt.');
		case 10:
			return _Utils_Tuple2('November', 'Nov.');
		default:
			return _Utils_Tuple2('Dezember', 'Dez.');
	}
};
var $author$project$Utils$Time$Translations$toGermanWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return _Utils_Tuple2('Montag', 'Mo.');
		case 1:
			return _Utils_Tuple2('Dienstag', 'Di.');
		case 2:
			return _Utils_Tuple2('Mittwoch', 'Mi.');
		case 3:
			return _Utils_Tuple2('Donnerstag', 'Do.');
		case 4:
			return _Utils_Tuple2('Freitag', 'Fr.');
		case 5:
			return _Utils_Tuple2('Samstag', 'Sa.');
		default:
			return _Utils_Tuple2('Sonntag', 'So.');
	}
};
var $author$project$Utils$Time$Translations$german = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toGermanMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toGermanMonthName, $elm$core$Tuple$second),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toGermanWeekdayName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toGermanWeekdayName, $elm$core$Tuple$second),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toJapaneseMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('1月', '1');
		case 1:
			return _Utils_Tuple2('2月', '2');
		case 2:
			return _Utils_Tuple2('3月', '3');
		case 3:
			return _Utils_Tuple2('4月', '4');
		case 4:
			return _Utils_Tuple2('5月', '5');
		case 5:
			return _Utils_Tuple2('6月', '6');
		case 6:
			return _Utils_Tuple2('7月', '7');
		case 7:
			return _Utils_Tuple2('8月', '8');
		case 8:
			return _Utils_Tuple2('9月', '9');
		case 9:
			return _Utils_Tuple2('10月', '10');
		case 10:
			return _Utils_Tuple2('11月', '11');
		default:
			return _Utils_Tuple2('12月', '12');
	}
};
var $author$project$Utils$Time$Translations$toJapaneseWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return _Utils_Tuple2('月曜日', '月');
		case 1:
			return _Utils_Tuple2('火曜日', '火');
		case 2:
			return _Utils_Tuple2('水曜日', '水');
		case 3:
			return _Utils_Tuple2('木曜日', '木');
		case 4:
			return _Utils_Tuple2('金曜日', '金');
		case 5:
			return _Utils_Tuple2('土曜日', '土');
		default:
			return _Utils_Tuple2('日曜日', '日');
	}
};
var $author$project$Utils$Time$Translations$japanese = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toJapaneseMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toJapaneseMonthName, $elm$core$Tuple$second),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toJapaneseWeekdayName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toJapaneseWeekdayName, $elm$core$Tuple$second),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toKoreanMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('1월', '1월');
		case 1:
			return _Utils_Tuple2('2월', '2월');
		case 2:
			return _Utils_Tuple2('3월', '3월');
		case 3:
			return _Utils_Tuple2('4월', '4월');
		case 4:
			return _Utils_Tuple2('5월', '5월');
		case 5:
			return _Utils_Tuple2('6월', '6월');
		case 6:
			return _Utils_Tuple2('7월', '7월');
		case 7:
			return _Utils_Tuple2('8월', '8월');
		case 8:
			return _Utils_Tuple2('9월', '9');
		case 9:
			return _Utils_Tuple2('10월', '10월');
		case 10:
			return _Utils_Tuple2('11월', '11월');
		default:
			return _Utils_Tuple2('12월', '12월');
	}
};
var $author$project$Utils$Time$Translations$toKoreanWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return _Utils_Tuple2('월요일', '월');
		case 1:
			return _Utils_Tuple2('화요일', '화');
		case 2:
			return _Utils_Tuple2('수요일', '수');
		case 3:
			return _Utils_Tuple2('목요일', '목');
		case 4:
			return _Utils_Tuple2('금요일', '금');
		case 5:
			return _Utils_Tuple2('토요일', '토');
		default:
			return _Utils_Tuple2('일요일', '일');
	}
};
var $author$project$Utils$Time$Translations$korean = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toKoreanMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toKoreanMonthName, $elm$core$Tuple$second),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toKoreanWeekdayName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toKoreanWeekdayName, $elm$core$Tuple$second),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toLatvianMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('janvāris', 'janv.');
		case 1:
			return _Utils_Tuple2('februāris', 'febr.');
		case 2:
			return _Utils_Tuple2('marts', 'marts');
		case 3:
			return _Utils_Tuple2('aprīlis', 'apr.');
		case 4:
			return _Utils_Tuple2('maijs', 'maijs');
		case 5:
			return _Utils_Tuple2('jūnijs', 'jūn.');
		case 6:
			return _Utils_Tuple2('jūlijs', 'jūl.');
		case 7:
			return _Utils_Tuple2('augusts', 'aug.');
		case 8:
			return _Utils_Tuple2('septembris', 'sept.');
		case 9:
			return _Utils_Tuple2('oktobris', 'okt.');
		case 10:
			return _Utils_Tuple2('novembris', 'nov.');
		default:
			return _Utils_Tuple2('decembris', 'dec.');
	}
};
var $author$project$Utils$Time$Translations$toLatvianWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'pirmdiena';
		case 1:
			return 'otrdiena';
		case 2:
			return 'trešdiena';
		case 3:
			return 'ceturtdiena';
		case 4:
			return 'piektdiena';
		case 5:
			return 'sestdiena';
		default:
			return 'svētdiena';
	}
};
var $author$project$Utils$Time$Translations$latvian = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toLatvianMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toLatvianMonthName, $elm$core$Tuple$second),
	$author$project$Utils$Time$Translations$toLatvianWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$Time$Translations$toLatvianWeekdayName,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$left(2),
			$author$project$Utils$String$capitalize)),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $author$project$Utils$Time$Translations$toRussianMonthName = function (month) {
	switch (month) {
		case 0:
			return _Utils_Tuple2('январь', 'янв.');
		case 1:
			return _Utils_Tuple2('февраль', 'февр.');
		case 2:
			return _Utils_Tuple2('март', 'март');
		case 3:
			return _Utils_Tuple2('апрель', 'апр.');
		case 4:
			return _Utils_Tuple2('май', 'май');
		case 5:
			return _Utils_Tuple2('июнь', 'июнь');
		case 6:
			return _Utils_Tuple2('июль', 'июль');
		case 7:
			return _Utils_Tuple2('август', 'авг.');
		case 8:
			return _Utils_Tuple2('сентябрь', 'сент.');
		case 9:
			return _Utils_Tuple2('октябрь', 'окт.');
		case 10:
			return _Utils_Tuple2('ноябрь', 'нояб.');
		default:
			return _Utils_Tuple2('декабрь', 'дек.');
	}
};
var $author$project$Utils$Time$Translations$toRussianWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return _Utils_Tuple2('понедельник', 'пн');
		case 1:
			return _Utils_Tuple2('вторник', 'вт');
		case 2:
			return _Utils_Tuple2('среда', 'ср');
		case 3:
			return _Utils_Tuple2('четверг', 'чт');
		case 4:
			return _Utils_Tuple2('пятница', 'пт');
		case 5:
			return _Utils_Tuple2('суббота', 'сб');
		default:
			return _Utils_Tuple2('воскресенье', 'вс');
	}
};
var $author$project$Utils$Time$Translations$russian = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toRussianMonthName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toRussianMonthName, $elm$core$Tuple$second),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toRussianWeekdayName, $elm$core$Tuple$first),
	A2($elm$core$Basics$composeR, $author$project$Utils$Time$Translations$toRussianWeekdayName, $elm$core$Tuple$second),
	$elm$core$Basics$always(''),
	$elm$core$Basics$always(''));
var $ryan_haskell$date_format$DateFormat$Language$toSwedishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'januari';
		case 1:
			return 'februari';
		case 2:
			return 'mars';
		case 3:
			return 'april';
		case 4:
			return 'maj';
		case 5:
			return 'juni';
		case 6:
			return 'juli';
		case 7:
			return 'augusti';
		case 8:
			return 'september';
		case 9:
			return 'oktober';
		case 10:
			return 'november';
		default:
			return 'december';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toSwedishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'måndag';
		case 1:
			return 'tisdag';
		case 2:
			return 'onsdag';
		case 3:
			return 'torsdag';
		case 4:
			return 'fredag';
		case 5:
			return 'lördag';
		default:
			return 'söndag';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$swedish = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toSwedishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toSwedishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toSwedishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toSwedishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	function (_v0) {
		return '';
	});
var $author$project$Utils$Time$Translations$fromLanguage = function (language) {
	switch (language) {
		case 0:
			return $ryan_haskell$date_format$DateFormat$Language$english;
		case 1:
			return $author$project$Utils$Time$Translations$estonian;
		case 2:
			return $author$project$Utils$Time$Translations$finnish;
		case 3:
			return $author$project$Utils$Time$Translations$latvian;
		case 4:
			return $ryan_haskell$date_format$DateFormat$Language$swedish;
		case 5:
			return $author$project$Utils$Time$Translations$russian;
		case 6:
			return $author$project$Utils$Time$Translations$chinese;
		case 7:
			return $author$project$Utils$Time$Translations$japanese;
		case 8:
			return $author$project$Utils$Time$Translations$german;
		default:
			return $author$project$Utils$Time$Translations$korean;
	}
};
var $author$project$Utils$Time$Format$format = F2(
	function (locale, tokensFromLanguage) {
		return A3(
			$ryan_haskell$date_format$DateFormat$formatWithLanguage,
			$author$project$Utils$Time$Translations$fromLanguage(locale.A_),
			tokensFromLanguage(locale),
			$elm$time$Time$utc);
	});
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameAbbreviated = {$: 13};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated = $ryan_haskell$date_format$DateFormat$DayOfWeekNameAbbreviated;
var $ryan_haskell$date_format$DateFormat$MonthNumber = {$: 0};
var $ryan_haskell$date_format$DateFormat$monthNumber = $ryan_haskell$date_format$DateFormat$MonthNumber;
var $author$project$Utils$Time$Format$monthNumberDayWeekday = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	var _v1 = _Utils_Tuple2(language, market);
	_v1$0:
	while (true) {
		_v1$1:
		while (true) {
			switch (_v1.b) {
				case 0:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v4 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(', '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
									$ryan_haskell$date_format$DateFormat$text('.'),
									$ryan_haskell$date_format$DateFormat$monthFixed
								]);
					}
				case 1:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v5 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(' '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
									$ryan_haskell$date_format$DateFormat$text('.'),
									$ryan_haskell$date_format$DateFormat$monthNumber,
									$ryan_haskell$date_format$DateFormat$text('.')
								]);
					}
				case 2:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v6 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(', '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
									$ryan_haskell$date_format$DateFormat$text('.'),
									$ryan_haskell$date_format$DateFormat$monthFixed,
									$ryan_haskell$date_format$DateFormat$text('.')
								]);
					}
				case 3:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v7 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(' '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
									$ryan_haskell$date_format$DateFormat$text('/'),
									$ryan_haskell$date_format$DateFormat$monthNumber
								]);
					}
				case 4:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v8 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(' '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
									$ryan_haskell$date_format$DateFormat$text('/'),
									$ryan_haskell$date_format$DateFormat$monthNumber
								]);
					}
				case 5:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v9 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(', '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
									$ryan_haskell$date_format$DateFormat$text('/'),
									$ryan_haskell$date_format$DateFormat$monthNumber
								]);
					}
				case 6:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v10 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(', '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
									$ryan_haskell$date_format$DateFormat$text('.'),
									$ryan_haskell$date_format$DateFormat$monthFixed,
									$ryan_haskell$date_format$DateFormat$text('.')
								]);
					}
				default:
					switch (_v1.a) {
						case 6:
							break _v1$0;
						case 7:
							break _v1$1;
						default:
							var _v11 = _v1.b;
							return _List_fromArray(
								[
									$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
									$ryan_haskell$date_format$DateFormat$text(' '),
									$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
									$ryan_haskell$date_format$DateFormat$text('/'),
									$ryan_haskell$date_format$DateFormat$monthNumber
								]);
					}
			}
		}
		var _v3 = _v1.a;
		return _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$monthNumber,
				$ryan_haskell$date_format$DateFormat$text('/'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
			]);
	}
	var _v2 = _v1.a;
	return _List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNumber,
			$ryan_haskell$date_format$DateFormat$text('/'),
			$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated
		]);
};
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Types$SelectedOnboardServices$replaceSelectedMassageTimeSlot = F4(
	function (selectedOnboardServices, massage, oldTimeSlot, newTimeSlot) {
		var selected = selectedOnboardServices;
		return A2(
			$elm$core$Maybe$withDefault,
			selectedOnboardServices,
			A2(
				$elm$core$Maybe$map,
				function (index) {
					return _Utils_update(
						selected,
						{
							y: A3(
								$elm$core$Dict$update,
								massage.pQ,
								$elm$core$Maybe$map(
									A2($elm_community$list_extra$List$Extra$setAt, index, newTimeSlot)),
								selected.y)
						});
				},
				A3($author$project$Types$SelectedOnboardServices$getMassageTimeSlotIndex, selectedOnboardServices, massage, oldTimeSlot)));
	});
var $author$project$Types$SelectedOnboardServices$selectedMassageTimeSlotDate = F6(
	function (language, market, massage, timeSlot, date, selectedOnboardServices) {
		var maybeMatchingTimeSlot = A2(
			$elm_community$list_extra$List$Extra$find,
			function (availableTimeSlot) {
				return _Utils_eq(
					A3(
						$author$project$Utils$Time$Format$format,
						{A_: language, rb: market},
						$author$project$Utils$Time$Format$monthNumberDayWeekday,
						availableTimeSlot.ld),
					date);
			},
			A2($author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots, massage, selectedOnboardServices));
		return A2(
			$elm$core$Maybe$withDefault,
			selectedOnboardServices,
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Types$SelectedOnboardServices$replaceSelectedMassageTimeSlot, selectedOnboardServices, massage, timeSlot),
				maybeMatchingTimeSlot));
	});
var $ryan_haskell$date_format$DateFormat$HourMilitaryNumber = {$: 24};
var $ryan_haskell$date_format$DateFormat$hourMilitaryNumber = $ryan_haskell$date_format$DateFormat$HourMilitaryNumber;
var $author$project$Utils$Time$Format$hourMinute = _List_fromArray(
	[
		$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
		$ryan_haskell$date_format$DateFormat$text(':'),
		$ryan_haskell$date_format$DateFormat$minuteFixed
	]);
var $author$project$Utils$Time$Format$formatHourMinute = A2($ryan_haskell$date_format$DateFormat$format, $author$project$Utils$Time$Format$hourMinute, $elm$time$Time$utc);
var $author$project$Types$SelectedOnboardServices$selectedMassageTimeSlotTime = F4(
	function (massage, timeSlot, time, selectedOnboardServices) {
		var maybeMatchingTimeSlot = A2(
			$elm_community$list_extra$List$Extra$find,
			function (availableTimeSlot) {
				return A2($author$project$Utils$Time$isSameDay, availableTimeSlot.ld, timeSlot.ld) && _Utils_eq(
					$author$project$Utils$Time$Format$formatHourMinute(availableTimeSlot.ld),
					time);
			},
			A2($author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots, massage, selectedOnboardServices));
		return A2(
			$elm$core$Maybe$withDefault,
			selectedOnboardServices,
			A2(
				$elm$core$Maybe$map,
				A3($author$project$Types$SelectedOnboardServices$replaceSelectedMassageTimeSlot, selectedOnboardServices, massage, timeSlot),
				maybeMatchingTimeSlot));
	});
var $author$project$Page$OnboardService$Update$showUnavailableTimeToast = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Page$OnboardService$Update$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		2,
		function ($) {
			return $.Fy;
		},
		false));
var $author$project$Types$SelectedOnboardServices$tableReservations = function (_v0) {
	var services = _v0;
	return $elm$core$Dict$values(services.G5);
};
var $author$project$Types$SelectedOnboardServices$toggleInDict = F3(
	function (toKey, a, dict) {
		return A2(
			$elm$core$Dict$member,
			toKey(a),
			dict) ? A2(
			$elm$core$Dict$remove,
			toKey(a),
			dict) : A3(
			$elm$core$Dict$insert,
			toKey(a),
			a,
			dict);
	});
var $author$project$Types$SelectedOnboardServices$toggleOutwardKidBracelet = F2(
	function (a, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				DC: A3(
					$author$project$Types$SelectedOnboardServices$toggleInDict,
					function (b) {
						return $author$project$Types$OnboardServices$KidBracelet$codeToString(b.pQ);
					},
					a,
					services.DC)
			});
	});
var $author$project$Types$SelectedOnboardServices$toggleOutwardPriorityBoarding = F2(
	function (a, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				kf: A3(
					$author$project$Types$SelectedOnboardServices$toggleInDict,
					function (b) {
						return $author$project$Types$OnboardServices$PriorityBoarding$codeToString(b.pQ);
					},
					a,
					services.kf)
			});
	});
var $author$project$Types$SelectedOnboardServices$toggleReturnKidBracelet = F2(
	function (a, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				FV: A3(
					$author$project$Types$SelectedOnboardServices$toggleInDict,
					function (b) {
						return $author$project$Types$OnboardServices$KidBracelet$codeToString(b.pQ);
					},
					a,
					services.FV)
			});
	});
var $author$project$Types$SelectedOnboardServices$toggleReturnPriorityBoarding = F2(
	function (a, _v0) {
		var services = _v0;
		return _Utils_update(
			services,
			{
				kk: A3(
					$author$project$Types$SelectedOnboardServices$toggleInDict,
					function (b) {
						return $author$project$Types$OnboardServices$PriorityBoarding$codeToString(b.pQ);
					},
					a,
					services.kk)
			});
	});
var $author$project$Types$SelectedOnboardServices$isSomeMassageTimeSlotSelected = function (massage) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$SelectedOnboardServices$getSelectedMassageTimeSlots(massage),
		A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not));
};
var $author$project$Types$SelectedOnboardServices$toggledMassageTimeSlots = F2(
	function (massage, selectedOnboardServices) {
		var selected = selectedOnboardServices;
		return A2($author$project$Types$SelectedOnboardServices$isSomeMassageTimeSlotSelected, massage, selectedOnboardServices) ? _Utils_update(
			selected,
			{
				y: A2($elm$core$Dict$remove, massage.pQ, selected.y)
			}) : A2(
			$elm$core$Maybe$withDefault,
			selectedOnboardServices,
			A2(
				$elm$core$Maybe$map,
				function (timeSlot) {
					return _Utils_update(
						selected,
						{
							y: A3(
								$elm$core$Dict$insert,
								massage.pQ,
								_List_fromArray(
									[timeSlot]),
								selected.y)
						});
				},
				$elm$core$List$head(
					A2($author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots, massage, selectedOnboardServices))));
	});
var $author$project$Page$OnboardService$Update$updateSelectedOnboardServices = F2(
	function (model, selectedOnboardServices) {
		var session = model.j;
		return function (a) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{j: a}),
				$elm$core$Platform$Cmd$none);
		}(
			_Utils_update(
				session,
				{Gm: selectedOnboardServices}));
	});
var $author$project$Page$OnboardService$Update$update = F2(
	function (msg, model) {
		var session = model.j;
		var selected = session.Gm;
		switch (msg.$) {
			case 0:
				var kidBracelet = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$toggleOutwardKidBracelet, kidBracelet, selected));
			case 1:
				var kidBracelet = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$toggleReturnKidBracelet, kidBracelet, selected));
			case 2:
				var priorityBoarding = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$toggleOutwardPriorityBoarding, priorityBoarding, selected));
			case 3:
				var priorityBoarding = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$toggleReturnPriorityBoarding, priorityBoarding, selected));
			case 4:
				var count = msg.a;
				var code = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$addOutwardShipMoney, count, code, selected));
			case 5:
				var count = msg.a;
				var code = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$addReturnShipMoney, count, code, selected));
			case 6:
				var pair = msg.a;
				var isAnySelectedAtSameTime = A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$core$Basics$eq(pair.b)),
					$author$project$Types$SelectedOnboardServices$tableReservations(selected));
				return isAnySelectedAtSameTime ? _Utils_Tuple2(model, $author$project$Page$OnboardService$Update$showUnavailableTimeToast) : A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$addTableReservation, pair, selected));
			case 7:
				var beginTime = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$removeTableReservation, beginTime, selected));
			case 8:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Page$OnboardService$Update$ToastMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (a) {
							return _Utils_update(
								model,
								{HT: a});
						},
						A2($author$project$Common$Toast$update, subMsg, model.HT)));
			case 9:
				var code = msg.a;
				var delta = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$increaseOutwardCovidServiceCount, delta, code, selected));
			case 10:
				var code = msg.a;
				var delta = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$increaseReturnCovidServiceCount, delta, code, selected));
			case 11:
				var code = msg.a;
				var delta = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$increaseOutwardBubbleFairServiceCount, delta, code, selected));
			case 12:
				var code = msg.a;
				var delta = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$increaseReturnBubbleFairServiceCount, delta, code, selected));
			case 13:
				var addon = msg.a;
				var delta = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$increaseOutwardFriendshipBraceletCount, delta, addon, selected));
			case 14:
				var addon = msg.a;
				var delta = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$increaseReturnFriendshipBraceletCount, delta, addon, selected));
			case 15:
				var massage = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$toggledMassageTimeSlots, massage, selected));
			case 16:
				var massage = msg.a;
				var timeSlot = msg.b;
				var time = msg.c;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A6($author$project$Types$SelectedOnboardServices$selectedMassageTimeSlotDate, session.A_, session.rb, massage, timeSlot, time, selected));
			case 17:
				var massage = msg.a;
				var timeSlot = msg.b;
				var time = msg.c;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A4($author$project$Types$SelectedOnboardServices$selectedMassageTimeSlotTime, massage, timeSlot, time, selected));
			case 19:
				var massage = msg.a;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A2($author$project$Types$SelectedOnboardServices$addedMassageTimeSlot, massage, selected));
			default:
				var massage = msg.a;
				var timeSlot = msg.b;
				return A2(
					$author$project$Page$OnboardService$Update$updateSelectedOnboardServices,
					model,
					A3($author$project$Types$SelectedOnboardServices$removedMassageTimeSlot, massage, timeSlot, selected));
		}
	});
var $author$project$Messages$GotClubOnePassenger = function (a) {
	return {$: 11, a: a};
};
var $author$project$Messages$PassengerDetailsPageMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$PassengerDetailsPage$Messages$ValidateWithDebounce = function (a) {
	return {$: 10, a: a};
};
var $author$project$PassengerDetailsPage$Update$debounceTimeout = 1000;
var $author$project$PassengerDetailsPage$Update$debounce = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(msg),
		$elm$core$Process$sleep($author$project$PassengerDetailsPage$Update$debounceTimeout));
};
var $author$project$PassengerDetailsPage$Update$debounceValidation = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{tq: model.tq + 1}),
		$author$project$PassengerDetailsPage$Update$debounce(
			$author$project$PassengerDetailsPage$Messages$ValidateWithDebounce(model.tq + 1)));
};
var $author$project$Types$Passenger$InvalidCharacters = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Passenger$Required = {$: 0};
var $author$project$Types$Passenger$TooLong = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$Passenger$TooShort = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Passenger$clubOneNumberFromString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Result$Err($author$project$Types$Passenger$Required) : ((!A2($elm$core$String$all, $elm$core$Char$isDigit, string)) ? $elm$core$Result$Err(
		$author$project$Types$Passenger$InvalidCharacters(
			A2(
				$elm$core$String$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$Char$isDigit),
				string))) : (($elm$core$String$length(string) > 8) ? $elm$core$Result$Err(
		$author$project$Types$Passenger$TooLong(
			$elm$core$String$length(string))) : (($elm$core$String$length(string) < 8) ? $elm$core$Result$Err(
		$author$project$Types$Passenger$TooShort(
			$elm$core$String$length(string))) : $elm$core$Result$Ok(string))));
};
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Types$Passenger$InvalidFormat = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Validation$Util$personNameRegex = function () {
	var seawareCharSet = '[' + ($author$project$Constants$seawareChars + ']');
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{vO: true, CE: false},
			'^(' + (seawareCharSet + ('+){1}(?:\\s?-?\\s?' + (seawareCharSet + '+)*$')))));
}();
var $author$project$Types$Validation$Util$removeValidSeawareCharacters = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[' + ($author$project$Constants$seawareChars + '\\- ]'))),
	function (_v0) {
		return '';
	});
var $author$project$Types$Passenger$nameFromString = function (string) {
	if ($elm$core$String$isEmpty(string)) {
		return $elm$core$Result$Err($author$project$Types$Passenger$Required);
	} else {
		if ($elm$core$String$length(string) > 30) {
			return $elm$core$Result$Err(
				$author$project$Types$Passenger$TooLong(
					$elm$core$String$length(string)));
		} else {
			if (A2($elm$regex$Regex$contains, $author$project$Types$Validation$Util$personNameRegex, string)) {
				return $elm$core$Result$Ok(string);
			} else {
				var invalidCharacters = $author$project$Types$Validation$Util$removeValidSeawareCharacters(string);
				return (!$elm$core$String$isEmpty(invalidCharacters)) ? $elm$core$Result$Err(
					$author$project$Types$Passenger$InvalidCharacters(invalidCharacters)) : $elm$core$Result$Err(
					$author$project$Types$Passenger$InvalidFormat(''));
			}
		}
	}
};
var $author$project$PassengerDetailsPage$Update$getClubOneCredentials = function (model) {
	return A4(
		$elm$core$Maybe$map3,
		F3(
			function (givenName, familyName, clubOneNumber) {
				return {we: clubOneNumber, mr: familyName, zj: givenName};
			}),
		$elm$core$Result$toMaybe(
			$author$project$Types$Passenger$nameFromString(model.zj)),
		$elm$core$Result$toMaybe(
			$author$project$Types$Passenger$nameFromString(model.mr)),
		A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return $elm$core$String$isEmpty(a) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(a);
			},
			$elm$core$Result$toMaybe(
				$author$project$Types$Passenger$clubOneNumberFromString(model.we))));
};
var $author$project$Types$Passenger$isClubOneInfoSame = F2(
	function (a, b) {
		return _Utils_eq(
			$elm$core$String$toLower(a.zj),
			$elm$core$String$toLower(b.zj)) && (_Utils_eq(
			$elm$core$String$toLower(a.mr),
			$elm$core$String$toLower(b.mr)) && _Utils_eq(
			$elm$core$String$toLower(a.we),
			$elm$core$String$toLower(b.we)));
	});
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return A3(
		$elm$core$Array$foldr,
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$Types$Passenger$hasPassengerWithEqualClubOneInfo = F3(
	function (index, passengers, model) {
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var passengerIndex = _v0.a;
				var firstName = _v0.b.y2;
				var lastName = _v0.b.A6;
				var clubOneNumber = _v0.b.we;
				return (!_Utils_eq(index, passengerIndex)) && A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Types$Passenger$isClubOneInfoSame(model),
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return {we: a, mr: lastName, zj: firstName};
							},
							clubOneNumber)));
			},
			$elm$core$Array$toIndexedList(passengers));
	});
var $author$project$PassengerDetailsPage$Messages$LoginWithClubOne = function (a) {
	return {$: 12, a: a};
};
var $author$project$PassengerDetailsPage$Update$loginWithClubOneIfCredentialsPresent = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$elm$core$Maybe$withDefault,
			cmd,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Platform$Cmd$batch,
								$elm$core$List$cons(cmd)),
							$elm$core$List$singleton),
						$author$project$PassengerDetailsPage$Update$debounce),
					$author$project$PassengerDetailsPage$Messages$LoginWithClubOne),
				$author$project$PassengerDetailsPage$Update$getClubOneCredentials(model))));
};
var $author$project$PassengerDetailsPage$Messages$ReceivedClubOneResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Types$Passenger$Passenger = function (ageCategory) {
	return function (birthday) {
		return function (citizenship) {
			return function (clientId) {
				return function (clubOneLevel) {
					return function (clubOneNumber) {
						return function (clubOnePoints) {
							return function (email) {
								return function (firstName) {
									return function (gender) {
										return function (lastName) {
											return function (phone) {
												return function (zip) {
													return {tY: ageCategory, uw: birthday, v_: citizenship, v5: clientId, pO: clubOneLevel, we: clubOneNumber, wf: clubOnePoints, yI: email, y2: firstName, zf: gender, A6: lastName, ox: phone, jX: zip};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$AgeCategory$dateDecoder = function (currentDate) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Date$toPosix,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Utils$Time$differenceOfDatesInYears(currentDate),
				$author$project$Types$AgeCategory$fromAge)),
		$author$project$Types$Date$decoder);
};
var $author$project$PassengerDetailsPage$Update$clubOnePassengerDecoder = function (expectedDepartureTime) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'zip',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lastName',
				A2($elm$json$Json$Decode$map, $elm$core$String$toLower, $elm$json$Json$Decode$string),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'gender',
					$elm$json$Json$Decode$maybe($author$project$Types$Gender$decoder),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'firstName',
						A2($elm$json$Json$Decode$map, $elm$core$String$toLower, $elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'clubOnePoints',
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'clubOneNumber',
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$String$decodeNonEmpty),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'clubOneLevel',
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Types$ClubOneLevel$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'clientId',
											A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'citizenship',
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'birthday',
													$elm$json$Json$Decode$maybe($author$project$Types$Date$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'birthday',
														$author$project$Types$AgeCategory$dateDecoder(expectedDepartureTime),
														$elm$json$Json$Decode$succeed($author$project$Types$Passenger$Passenger))))))))))))));
};
var $author$project$Api$Endpoint$clientClubOneLogin = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['client', 'clubone']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.pN));
	});
var $author$project$Api$Util$clubOneNumberParam = function (input) {
	return _Utils_Tuple2('clubOneNumber', input);
};
var $author$project$Api$Util$firstNameParam = function (input) {
	return _Utils_Tuple2('firstName', input);
};
var $author$project$Api$Util$lastNameParam = function (input) {
	return _Utils_Tuple2('lastName', input);
};
var $author$project$Api$Client$fetchWithCredentials = F5(
	function (params, _v0, _v1, decoder, resultToMsg) {
		var firstName = _v0.y2;
		var lastName = _v0.A6;
		var clubOneNumber = _v0.we;
		var serverConfig = _v1.Gs;
		var sessionGuid = _v1.Gt;
		var queryParams = A2(
			$author$project$Api$Util$addExperimentalParamIf,
			params.Aa,
			A2(
				$elm$core$List$map,
				function (_v2) {
					var a = _v2.a;
					var b = _v2.b;
					return A2($elm$url$Url$Builder$string, a, b);
				},
				_List_fromArray(
					[
						$author$project$Api$Util$guidParam(sessionGuid),
						$author$project$Api$Util$localeParam(params.A_),
						$author$project$Api$Util$marketParam(params.rb),
						$author$project$Api$Util$clubOneNumberParam(clubOneNumber),
						$author$project$Api$Util$firstNameParam(firstName),
						$author$project$Api$Util$lastNameParam(lastName)
					])));
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, resultToMsg, decoder),
				jW: A2($author$project$Api$Endpoint$clientClubOneLogin, serverConfig, queryParams)
			});
	});
var $author$project$PassengerDetailsPage$Update$requestClubOneClient = F4(
	function (session, model, credentials, httpConfig) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{qP: true}),
			A5(
				$author$project$Api$Client$fetchWithCredentials,
				session,
				{we: credentials.we, y2: credentials.zj, A6: credentials.mr},
				httpConfig,
				$author$project$PassengerDetailsPage$Update$clubOnePassengerDecoder(
					A2(
						$elm$core$Maybe$withDefault,
						session.kJ,
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
							$author$project$Types$Trips$statusToMaybe(session.tp)))),
				$author$project$PassengerDetailsPage$Messages$ReceivedClubOneResponse));
	});
var $author$project$PassengerDetailsPage$Model$BirthdayError = function (a) {
	return {$: 3, a: a};
};
var $author$project$PassengerDetailsPage$Model$ClubOneNumberError = function (a) {
	return {$: 1, a: a};
};
var $author$project$PassengerDetailsPage$Model$DateError = function (a) {
	return {$: 2, a: a};
};
var $author$project$PassengerDetailsPage$Model$DuplicateClubOneInfoError = {$: 4};
var $author$project$PassengerDetailsPage$Model$NameError = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Result$map4 = F5(
	function (func, ra, rb, rc, rd) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				if (rc.$ === 1) {
					var x = rc.a;
					return $elm$core$Result$Err(x);
				} else {
					var c = rc.a;
					if (rd.$ === 1) {
						var x = rd.a;
						return $elm$core$Result$Err(x);
					} else {
						var d = rd.a;
						return $elm$core$Result$Ok(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Types$Passenger$LastAdultAgeCategoryChangeError = {$: 5};
var $author$project$Types$Passenger$LastAdultOrYouthAgeCategoryChangeError = {$: 6};
var $author$project$Types$Passenger$validateBirthday = F5(
	function (isSoloYouthAllowed, departureDate, index, passengers, birthday) {
		var newAgeCategory = $author$project$Types$AgeCategory$fromAge(
			A2(
				$author$project$Utils$Time$differenceOfDatesInYears,
				$author$project$Types$Date$toPosix(birthday),
				departureDate));
		var hasOtherAdult = function (a) {
			return a > 0;
		}(
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var p = _v0.b;
						return (!_Utils_eq(i, index)) && (!p.tY);
					},
					$elm$core$Array$toIndexedList(passengers))));
		return ((!hasOtherAdult) && (isSoloYouthAllowed && (!A2(
			$elm$core$List$member,
			newAgeCategory,
			_List_fromArray(
				[0, 1]))))) ? $elm$core$Result$Err($author$project$Types$Passenger$LastAdultOrYouthAgeCategoryChangeError) : (((!hasOtherAdult) && ((!isSoloYouthAllowed) && (!(!newAgeCategory)))) ? $elm$core$Result$Err($author$project$Types$Passenger$LastAdultAgeCategoryChangeError) : $elm$core$Result$Ok(birthday));
	});
var $author$project$Types$Date$YearNumberTooLarge = function (a) {
	return {$: 8, a: a};
};
var $author$project$Types$Date$YearNumberTooSmall = function (a) {
	return {$: 9, a: a};
};
var $author$project$Constants$maxAgeOfPerson = 120;
var $author$project$Types$Date$validateBirthdayYear = F2(
	function (timeNow, _v0) {
		var date = _v0;
		var yearNow = A2($elm$time$Time$toYear, $elm$time$Time$utc, timeNow);
		return (_Utils_cmp(date.h, yearNow) > 0) ? $elm$core$Result$Err(
			$author$project$Types$Date$YearNumberTooLarge(date.h)) : ((_Utils_cmp(date.h, yearNow - $author$project$Constants$maxAgeOfPerson) < 0) ? $elm$core$Result$Err(
			$author$project$Types$Date$YearNumberTooSmall(date.h)) : $elm$core$Result$Ok(date));
	});
var $author$project$PassengerDetailsPage$Update$validate = F3(
	function (departureDate, passengers, model) {
		var toValidationResult = function (toModelError) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$Result$mapError(toModelError),
				$elm$core$Result$map(
					function (_v5) {
						return 0;
					}));
		};
		var ignoreErrorIf = F2(
			function (condition, result) {
				return condition ? $elm$core$Result$Ok(0) : result;
			});
		return A2(
			$elm$core$Result$andThen,
			function (result) {
				return A3($author$project$Types$Passenger$hasPassengerWithEqualClubOneInfo, model.qH, passengers, model) ? $elm$core$Result$Err($author$project$PassengerDetailsPage$Model$DuplicateClubOneInfoError) : $elm$core$Result$Ok(result);
			},
			A5(
				$elm$core$Result$map4,
				F4(
					function (_v0, _v1, _v2, _v3) {
						return 0;
					}),
				A2(
					ignoreErrorIf,
					$elm$core$String$isEmpty(model.zj),
					A2(
						toValidationResult,
						$author$project$PassengerDetailsPage$Model$NameError,
						$author$project$Types$Passenger$nameFromString(model.zj))),
				A2(
					ignoreErrorIf,
					$elm$core$String$isEmpty(model.mr),
					A2(
						toValidationResult,
						$author$project$PassengerDetailsPage$Model$NameError,
						$author$project$Types$Passenger$nameFromString(model.mr))),
				A2(
					ignoreErrorIf,
					$elm$core$String$isEmpty(model.we),
					A2(
						toValidationResult,
						$author$project$PassengerDetailsPage$Model$ClubOneNumberError,
						$author$project$Types$Passenger$clubOneNumberFromString(model.we))),
				A2(
					ignoreErrorIf,
					$elm$core$String$isEmpty(model.l4) || ($elm$core$String$isEmpty(model.l5) || $elm$core$String$isEmpty(model.l6)),
					A2(
						$elm$core$Result$map,
						function (_v4) {
							return 0;
						},
						A2(
							$elm$core$Result$andThen,
							A2(
								$elm$core$Basics$composeR,
								A4($author$project$Types$Passenger$validateBirthday, model.q$, departureDate, model.qH, passengers),
								$elm$core$Result$mapError($author$project$PassengerDetailsPage$Model$BirthdayError)),
							A3(
								$elm$core$Basics$composeR,
								$elm$core$Result$andThen(
									$author$project$Types$Date$validateBirthdayYear(departureDate)),
								$elm$core$Result$mapError($author$project$PassengerDetailsPage$Model$DateError),
								$author$project$Types$Date$fromStringValues(
									{q: model.l4, s: model.l5, h: model.l6})))))));
	});
var $author$project$PassengerDetailsPage$Update$updateOnValidate = F3(
	function (departureDate, session, model) {
		return function (a) {
			return _Utils_update(
				a,
				{rf: $elm$core$Maybe$Nothing});
		}(
			function () {
				var _v0 = A3($author$project$PassengerDetailsPage$Update$validate, departureDate, session.Eg, model);
				if (!_v0.$) {
					return _Utils_update(
						model,
						{rr: $elm$core$Maybe$Nothing});
				} else {
					var error = _v0.a;
					return _Utils_update(
						model,
						{
							rr: $elm$core$Maybe$Just(error)
						});
				}
			}());
	});
var $author$project$PassengerDetailsPage$Update$update = F5(
	function (departureDate, session, httpConfig, msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					$author$project$PassengerDetailsPage$Update$loginWithClubOneIfCredentialsPresent(
						$author$project$PassengerDetailsPage$Update$debounceValidation(
							_Utils_update(
								model,
								{zj: string}))));
			case 1:
				var string = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					$author$project$PassengerDetailsPage$Update$loginWithClubOneIfCredentialsPresent(
						$author$project$PassengerDetailsPage$Update$debounceValidation(
							_Utils_update(
								model,
								{mr: string}))));
			case 2:
				var string = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					$author$project$PassengerDetailsPage$Update$loginWithClubOneIfCredentialsPresent(
						$author$project$PassengerDetailsPage$Update$debounceValidation(
							_Utils_update(
								model,
								{we: string}))));
			case 3:
				var gender = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{zf: gender}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var string = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					$author$project$PassengerDetailsPage$Update$debounceValidation(
						_Utils_update(
							model,
							{l4: string})));
			case 5:
				var string = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					$author$project$PassengerDetailsPage$Update$debounceValidation(
						_Utils_update(
							model,
							{l5: string})));
			case 6:
				var string = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					$author$project$PassengerDetailsPage$Update$debounceValidation(
						_Utils_update(
							model,
							{l6: string})));
			case 7:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{v_: string}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					A3($author$project$PassengerDetailsPage$Update$updateOnValidate, departureDate, session, model),
					$elm$core$Platform$Cmd$none);
			case 10:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_eq(model.tq, id) ? A3($author$project$PassengerDetailsPage$Update$updateOnValidate, departureDate, session, model) : model,
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					A5($author$project$PassengerDetailsPage$Model$init, model.q$, model.qH, session.rb, session.Eg, model.a),
					$elm$core$Platform$Cmd$none);
			case 8:
				if (!msg.a.$) {
					var passenger = msg.a.a;
					return function (newModel) {
						return _Utils_Tuple2(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$perform,
										function (_v1) {
											return $author$project$Messages$GotClubOnePassenger(newModel);
										},
										$elm$core$Task$succeed(0))
									])));
					}(
						A5($author$project$PassengerDetailsPage$Model$init, model.q$, model.qH, session.rb, session.Eg, passenger));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								qP: false,
								rf: $elm$core$Maybe$Just(error)
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var credentials = msg.a;
				return (!A3($author$project$Types$Passenger$hasPassengerWithEqualClubOneInfo, model.qH, session.Eg, credentials)) ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PassengerDetailsPageMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (a) {
							return _Utils_update(
								a,
								{rf: $elm$core$Maybe$Nothing, rr: $elm$core$Maybe$Nothing});
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$Basics$identity,
								A2(
									$elm$core$Maybe$map,
									function (newCredentials) {
										return _Utils_eq(newCredentials, credentials) ? $elm$core$Maybe$Just(
											A4($author$project$PassengerDetailsPage$Update$requestClubOneClient, session, model, newCredentials, httpConfig)) : $elm$core$Maybe$Nothing;
									},
									$author$project$PassengerDetailsPage$Update$getClubOneCredentials(model)))))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PaymentPage$Update$update = F2(
	function (msg, model) {
		var paymentMethod = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ro: $elm$core$Maybe$Just(paymentMethod)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$TimetablePage$Header$Update$update = F2(
	function (msg, isDescriptionVisible) {
		return _Utils_Tuple2(!isDescriptionVisible, $elm$core$Platform$Cmd$none);
	});
var $author$project$TimetablePage$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Gp: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var sail = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Gp: $elm$core$Maybe$Just(sail)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Gp: $elm$core$Maybe$Nothing}),
					$author$project$Ports$scrollTo(
						{zN: 'lastAvailableDate'}));
		}
	});
var $author$project$TravelClassPage$Messages$GotCabinSurpriseViewportPositions = function (a) {
	return {$: 3, a: a};
};
var $author$project$TravelClassPage$Update$calculateCabinSurpriseIndex = function (_v0) {
	var scene = _v0.F8;
	var viewport = _v0.In;
	return $elm$core$Basics$ceiling(((viewport.tD - 12) - ((viewport.m2 - 24) / 2)) / (viewport.m2 - 24));
};
var $author$project$Ports$hideTravelClassDescription = _Platform_outgoingPort('hideTravelClassDescription', $elm$json$Json$Encode$string);
var $author$project$TravelClassPage$CabinSurpriseList$listId = function (travelClassCode) {
	return 'cabin-surprise-list-' + $elm$core$String$toLower(travelClassCode);
};
var $author$project$Ports$showTravelClassDescription = _Platform_outgoingPort('showTravelClassDescription', $elm$json$Json$Encode$string);
var $author$project$TravelClassPage$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				return A2($elm$core$List$member, code, model.rJ) ? _Utils_Tuple2(
					model,
					$author$project$Ports$hideTravelClassDescription(code)) : _Utils_Tuple2(
					model,
					$author$project$Ports$showTravelClassDescription(code));
			case 1:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rJ: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(code),
								model.rJ)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var code = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							rJ: A2($elm$core$List$cons, code, model.rJ)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var indices = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pC: indices}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var travelClassCode = msg.a;
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$elm$core$Task$perform,
						function (index) {
							return $author$project$TravelClassPage$Messages$GotCabinSurpriseViewportPositions(
								A3($elm$core$Dict$insert, travelClassCode, index, model.pC));
						},
						A2(
							$elm$core$Task$onError,
							$elm$core$Basics$always(
								$elm$core$Task$succeed(0)),
							A2(
								$elm$core$Task$map,
								$author$project$TravelClassPage$Update$calculateCabinSurpriseIndex,
								$elm$browser$Browser$Dom$getViewportOf(
									$author$project$TravelClassPage$CabinSurpriseList$listId(travelClassCode))))));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pB: $elm$core$Dict$empty}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$Bus$SelectedTransferPair$mapOutward = F2(
	function (func, _v0) {
		var _v1 = _v0;
		var maybeOutward = _v1.a;
		var maybeReturn = _v1.b;
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$map(func),
			_Utils_Tuple2(maybeOutward, maybeReturn));
	});
var $author$project$Types$Bus$SelectedTransferPair$mapReturn = F2(
	function (func, _v0) {
		var _v1 = _v0;
		var maybeOutward = _v1.a;
		var maybeReturn = _v1.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Maybe$map(func),
			_Utils_Tuple2(maybeOutward, maybeReturn));
	});
var $author$project$Types$Bus$SelectedTransfers$maxSelectedBusTransfers = 2;
var $author$project$Types$Bus$SelectedTransfers$add = F3(
	function (passengers, selectedBusTransferPair, selectedBusTransfers) {
		var passengerCounts = $author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(passengers);
		var returnCounts = A2(
			$author$project$Types$Bus$AgeGroup$subtractPassengerCounts,
			passengerCounts,
			$author$project$Types$Bus$SelectedTransfers$sumReturnCounts(
				$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)));
		var outwardCounts = A2(
			$author$project$Types$Bus$AgeGroup$subtractPassengerCounts,
			passengerCounts,
			$author$project$Types$Bus$SelectedTransfers$sumOutwardCounts(
				$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)));
		var selectedBusTransferPairWithAgeGroupCounts = A2(
			$author$project$Types$Bus$SelectedTransferPair$mapReturn,
			function (a) {
				return $author$project$Types$Bus$AgeGroup$initAgeGroupCountsIfNoAdults(
					_Utils_update(
						a,
						{po: returnCounts}));
			},
			A2(
				$author$project$Types$Bus$SelectedTransferPair$mapOutward,
				function (a) {
					return $author$project$Types$Bus$AgeGroup$initAgeGroupCountsIfNoAdults(
						_Utils_update(
							a,
							{po: outwardCounts}));
				},
				selectedBusTransferPair));
		var _v0 = selectedBusTransfers;
		var first = _v0.nx;
		var others = _v0.lH;
		return (_Utils_cmp(
			$elm$core$Array$length(others),
			$author$project$Types$Bus$SelectedTransfers$maxSelectedBusTransfers - 1) > -1) ? selectedBusTransfers : {
			nx: first,
			lH: A2($elm$core$Array$push, selectedBusTransferPairWithAgeGroupCounts, others)
		};
	});
var $author$project$Types$Bus$SelectedTransferPair$map = F2(
	function (func, _v0) {
		var _v1 = _v0;
		var maybeOutward = _v1.a;
		var maybeReturn = _v1.b;
		return A2(
			$author$project$Types$Bus$SelectedTransferPair$mapBothTupleValues,
			$elm$core$Maybe$map(func),
			_Utils_Tuple2(maybeOutward, maybeReturn));
	});
var $author$project$Types$Bus$AgeGroup$ageGroupCountsDiffByAgeGroupAndAmount = F2(
	function (ageGroup, amount) {
		switch (ageGroup) {
			case 0:
				return A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, amount, 0, 0);
			case 1:
				return A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, amount, 0);
			default:
				return A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, amount);
		}
	});
var $author$project$Types$Bus$AgeGroup$haveCountsGotNegativeValues = function (_v0) {
	var adults = _v0.pn;
	var underages = _v0.H4;
	var infants = _v0.zV;
	return (adults < 0) || ((underages < 0) || (infants < 0));
};
var $author$project$Types$Bus$SelectedTransfers$updateAgeGroupCounts = F5(
	function (ageGroup, amount, maxCounts, countsSum, detailedBusTransfer) {
		var diffToAdd = A2($author$project$Types$Bus$AgeGroup$ageGroupCountsDiffByAgeGroupAndAmount, ageGroup, amount);
		var doesNewCountAddMorePassengersThanPossible = $author$project$Types$Bus$AgeGroup$haveCountsGotNegativeValues(
			A2(
				$author$project$Types$Bus$AgeGroup$subtractPassengerCounts,
				maxCounts,
				A2($author$project$Types$Bus$AgeGroup$addPassengerCounts, countsSum, diffToAdd)));
		var newAgeGroupCounts = A2($author$project$Types$Bus$AgeGroup$addPassengerCounts, detailedBusTransfer.po, diffToAdd);
		return ($author$project$Types$Bus$AgeGroup$haveCountsGotNegativeValues(newAgeGroupCounts) || doesNewCountAddMorePassengersThanPossible) ? detailedBusTransfer : _Utils_update(
			detailedBusTransfer,
			{po: newAgeGroupCounts});
	});
var $author$project$Types$Bus$SelectedTransfers$updateSelectedBusTransferAgeGroupCounts = F6(
	function (selectedBusTransfers, direction, ageGroup, amount, maxCounts, selectedBusTransferPair) {
		var _v0 = function () {
			if (!direction) {
				return _Utils_Tuple2(
					$author$project$Types$Bus$SelectedTransferPair$mapOutward,
					$author$project$Types$Bus$SelectedTransfers$sumOutwardCounts(
						$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)));
			} else {
				return _Utils_Tuple2(
					$author$project$Types$Bus$SelectedTransferPair$mapReturn,
					$author$project$Types$Bus$SelectedTransfers$sumReturnCounts(
						$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)));
			}
		}();
		var mapDirection = _v0.a;
		var countsSum = _v0.b;
		return A2(
			$author$project$Types$Bus$SelectedTransferPair$map,
			$author$project$Types$Bus$AgeGroup$initAgeGroupCountsIfNoAdults,
			A2(
				mapDirection,
				A4($author$project$Types$Bus$SelectedTransfers$updateAgeGroupCounts, ageGroup, amount, maxCounts, countsSum),
				selectedBusTransferPair));
	});
var $author$project$Types$Bus$SelectedTransfers$addPassengerToTransfer = F6(
	function (passengers, index, direction, ageGroup, amount, selectedBusTransfers) {
		return A2(
			$elm$core$Maybe$withDefault,
			selectedBusTransfers,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Array$set(index),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$apR(
							$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)),
						$author$project$Types$Bus$SelectedTransfers$fromArray)),
				A2(
					$elm$core$Maybe$map,
					A5(
						$author$project$Types$Bus$SelectedTransfers$updateSelectedBusTransferAgeGroupCounts,
						selectedBusTransfers,
						direction,
						ageGroup,
						amount,
						$author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(passengers)),
					A2(
						$elm$core$Array$get,
						index,
						$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)))));
	});
var $author$project$Types$Bus$SelectedTransfers$getTransportedPassengersCount = F2(
	function (selectedBusTransfers, key) {
		return A3(
			$elm$core$Array$foldl,
			A2(
				$elm$core$Basics$composeR,
				key,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.po;
							},
							$author$project$Types$Bus$AgeGroup$sumAgeGroupCounts)),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault(0),
						$elm$core$Basics$add))),
			0,
			$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers));
	});
var $author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransfer = F2(
	function (_v0, selectedBusTransfers) {
		var passengers = _v0.Eg;
		var isOneWay = _v0.qW;
		var voyageType = _v0.tx;
		var maxPossiblePassengers = $author$project$Types$Bus$AgeGroup$sumAgeGroupCounts(
			$author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(
				$elm$core$Array$toList(passengers)));
		var isOneWayRouteTrip = isOneWay && (_Utils_eq(voyageType, $author$project$Types$VoyageType$Shuttle) || _Utils_eq(voyageType, $author$project$Types$VoyageType$RouteTrip));
		var getCountFor = $author$project$Types$Bus$SelectedTransfers$getTransportedPassengersCount(selectedBusTransfers);
		return (_Utils_cmp(
			getCountFor($author$project$Types$Bus$SelectedTransferPair$selectedOutward),
			maxPossiblePassengers) < 0) || ((!isOneWayRouteTrip) && (_Utils_cmp(
			getCountFor($author$project$Types$Bus$SelectedTransferPair$selectedReturn),
			maxPossiblePassengers) < 0));
	});
var $author$project$Update$BusTransfers$notAllPassengersIncludedToastCmd = A2(
	$elm$core$Platform$Cmd$map,
	$author$project$Messages$ToastMsg,
	A3(
		$author$project$Common$Toast$showToastCmd,
		0,
		function ($) {
			return $.HR;
		},
		true));
var $author$project$Update$BusTransfers$detailedBusTransfersMessages = F2(
	function (model, newSelectedBusTransfers) {
		var session = model.j;
		var hasOldSelectedBusTransfersPassengersWithoutBusTransfer = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransfer(session),
				session.B0));
		return (A2($author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransfer, session, newSelectedBusTransfers) && (!hasOldSelectedBusTransfersPassengersWithoutBusTransfer)) ? $author$project$Update$BusTransfers$notAllPassengersIncludedToastCmd : ((A2($author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransfer, session, newSelectedBusTransfers) && hasOldSelectedBusTransfersPassengersWithoutBusTransfer) ? $elm$core$Platform$Cmd$none : A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Messages$ToastMsg,
			$author$project$Common$Toast$hideToastCmd(model.HT.zN)));
	});
var $author$project$Types$Bus$SelectedTransfers$init = F2(
	function (passengers, selectedBusTransferPair) {
		var passengersCounts = $author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(passengers);
		return {
			nx: A2(
				$author$project$Types$Bus$SelectedTransferPair$map,
				function (a) {
					return _Utils_update(
						a,
						{po: passengersCounts});
				},
				selectedBusTransferPair),
			lH: $elm$core$Array$empty
		};
	});
var $author$project$Types$Bus$SelectedTransfers$remove = F2(
	function (index, selectedBusTransfers) {
		var _v0 = $elm$core$Array$toList(
			A2(
				$author$project$Common$Array$Util$remove,
				index,
				$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)));
		if (_v0.b) {
			var first = _v0.a;
			var othersList = _v0.b;
			return $elm$core$Maybe$Just(
				{
					nx: first,
					lH: $elm$core$Array$fromList(othersList)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Messages$GotDetailedTransfers = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Bus$DetailedTransfer$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translationTo',
	A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split(','),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$drop(1),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$join(','),
					A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$json$Json$Decode$succeed)))),
		$elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'translationFrom',
		A2(
			$elm$json$Json$Decode$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$String$split(','),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$drop(1),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$join(','),
						A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$json$Json$Decode$succeed)))),
			$elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'price',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'packageId',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'departureDateTime',
					$author$project$Utils$Time$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'codeTo',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'codeFrom',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'translationTo',
								A2(
									$elm$json$Json$Decode$andThen,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$split(','),
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$take(1),
											A2(
												$elm$core$Basics$composeR,
												$elm$core$String$join(''),
												A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$json$Json$Decode$succeed)))),
									$elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'translationFrom',
									A2(
										$elm$json$Json$Decode$andThen,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$String$split(','),
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$take(1),
												A2(
													$elm$core$Basics$composeR,
													$elm$core$String$join(''),
													A2($elm$core$Basics$composeR, $elm$core$String$trim, $elm$json$Json$Decode$succeed)))),
										$elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'arrivalDateTime',
										$author$project$Utils$Time$decoder,
										$elm$json$Json$Decode$succeed($author$project$Types$Bus$DetailedTransfer$DetailedBusTransfer)))))))))));
var $author$project$Types$Bus$SelectedTransferPair$selectedBusTransferConstructor = F2(
	function (detailedBusTransfer, ageGroupCounts) {
		return {po: ageGroupCounts, na: detailedBusTransfer.na, v1: detailedBusTransfer.v1, v2: detailedBusTransfer.v2, wn: detailedBusTransfer.wn, pR: detailedBusTransfer.pR, nq: detailedBusTransfer.nq, rW: detailedBusTransfer.rW, lN: detailedBusTransfer.lN, GT: detailedBusTransfer.GT, sW: detailedBusTransfer.sW};
	});
var $author$project$Types$Bus$SelectedTransferPair$busTransferDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Types$Bus$SelectedTransferPair$selectedBusTransferConstructor,
		A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$succeed,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'ageGroupCounts',
				$author$project$Types$Bus$AgeGroup$decoder,
				A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, 0)))),
	$author$project$Types$Bus$DetailedTransfer$decoder);
var $author$project$Types$Bus$SelectedTransferPair$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Types$Bus$SelectedTransferPair$maybeInitSelectedBusTransferPair,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Both bus transfer legs are null.')))),
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['outwardTransfer']),
			$elm$json$Json$Decode$maybe($author$project$Types$Bus$SelectedTransferPair$busTransferDecoder)),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['returnTransfer']),
			$elm$json$Json$Decode$maybe($author$project$Types$Bus$SelectedTransferPair$busTransferDecoder))));
var $author$project$Api$Endpoint$detailedTransfers = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['transfers']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.p4));
	});
var $author$project$Api$Transfers$fromBusStopParam = function (fromBusStop) {
	return _Utils_Tuple2('fromBusStop', fromBusStop);
};
var $author$project$Api$Transfers$outwardSailDepartureDateParam = function (outwardSailDepartureDateTime) {
	return _Utils_Tuple2(
		'outwardSailDepartureDate',
		$author$project$Utils$Time$toDateTimeString(outwardSailDepartureDateTime));
};
var $author$project$Api$Transfers$returnSailArrivalDateParam = function (returnSailArrivalDateTime) {
	return _Utils_Tuple2(
		'returnSailArrivalDate',
		$author$project$Utils$Time$toDateTimeString(returnSailArrivalDateTime));
};
var $author$project$Api$Transfers$getDetailedBusTransfers = F3(
	function (config, params, resultToMsg) {
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, resultToMsg, $author$project$Types$Bus$SelectedTransferPair$decoder),
				jW: A2(
					$author$project$Api$Endpoint$detailedTransfers,
					config,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						params.Aa,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var a = _v0.a;
								var b = _v0.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Api$Util$guidParam(params.sN),
										$author$project$Api$Util$localeParam(params.A_),
										$author$project$Api$Util$marketParam(params.rb),
										$author$project$Api$Transfers$fromBusStopParam(params.qp),
										$author$project$Api$Transfers$outwardSailDepartureDateParam(params.rT)
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Api$Transfers$returnSailArrivalDateParam, $elm$core$List$singleton),
										params.rn))))))
			});
	});
var $author$project$Update$BusTransfers$selectTransfer = F2(
	function (model, transfer) {
		var session = model.j;
		var _v0 = session;
		var language = _v0.A_;
		var market = _v0.rb;
		var isExperimental = _v0.Aa;
		var maybeRequestParams = A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var outwardDepartureDateTime = _v1.a;
				var maybeReturnArrivalDateTime = _v1.b;
				return {qp: transfer, Aa: isExperimental, A_: language, rb: market, rn: maybeReturnArrivalDateTime, rT: outwardDepartureDateTime, sN: session.zM.Gt};
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$Trips$selectedDepartureAndArrivalTimes,
				$author$project$Types$Trips$statusToMaybe(session.tp)));
		var getTransferDetailsCmd = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (requestParams) {
					return A2(
						$author$project$Update$Util$cancelRequestAndRunCmd,
						$author$project$Api$Endpoint$trackers.p4,
						A3(
							$author$project$Api$Transfers$getDetailedBusTransfers,
							model.j.zM.Gs,
							requestParams,
							A2($elm$core$Basics$composeL, $author$project$Messages$BusTransfersMsg, $author$project$Messages$GotDetailedTransfers)));
				},
				maybeRequestParams));
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					getTransferDetailsCmd,
					_List_fromArray(
						[
							A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$BusTransfer)
						]))));
	});
var $author$project$Update$BusTransfers$update = F2(
	function (model, msg) {
		var _v0 = model;
		var session = _v0.j;
		var passengersList = $elm$core$Array$toList(session.Eg);
		switch (msg.$) {
			case 2:
				var hasPassengersWithoutBusTransfer = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						A3(
							$author$project$Utils$List$addIf,
							hasPassengersWithoutBusTransfer,
							$author$project$Update$BusTransfers$notAllPassengersIncludedToastCmd,
							_List_fromArray(
								[
									A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$BusTransfer)
								]))));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							HZ: {y1: ''}
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								$author$project$Common$Toast$hideToastCmd(model.HT.zN)),
								A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$BusTransferList)
							])));
			case 5:
				var transfer = msg.a;
				return A2($author$project$Update$BusTransfers$selectTransfer, model, transfer);
			case 4:
				var index = msg.a;
				var maybeSelectedBusTransfers = A2(
					$elm$core$Maybe$andThen,
					$author$project$Types$Bus$SelectedTransfers$remove(index),
					model.j.B0);
				var storeBusTransfersCmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								$author$project$Common$Toast$hideToastCmd(model.HT.zN)),
								A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$BusTransferList)
							])),
					A2(
						$elm$core$Maybe$map,
						$author$project$Update$BusTransfers$detailedBusTransfersMessages(model),
						maybeSelectedBusTransfers));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{B0: maybeSelectedBusTransfers})
						}),
					storeBusTransfersCmd);
			case 1:
				var response = msg.a;
				if (!response.$) {
					var detailedTransfers = response.a;
					var selectedBusTransfers = A2(
						$elm$core$Maybe$withDefault,
						A2($author$project$Types$Bus$SelectedTransfers$init, passengersList, detailedTransfers),
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Types$Bus$SelectedTransfers$add, passengersList, detailedTransfers),
							model.j.B0));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{
										B0: $elm$core$Maybe$Just(selectedBusTransfers)
									})
							}),
						A2($author$project$Update$BusTransfers$detailedBusTransfersMessages, model, selectedBusTransfers));
				} else {
					var httpError = response.a;
					var defaultCmd = $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								A3(
									$author$project$Common$Toast$showToastCmd,
									1,
									function ($) {
										return $.g4;
									},
									false)),
								A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$BusTransferList)
							]));
					return A4($author$project$Update$Util$mapFailedResponse, model, httpError, 'transferDetailsResponse', defaultCmd);
				}
			case 0:
				var response = msg.a;
				if (!response.$) {
					var transfers = response.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{H_: transfers})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var httpError = response.a;
					return A4($author$project$Update$Util$mapFailedResponse, model, httpError, 'transfersResponse', $elm$core$Platform$Cmd$none);
				}
			default:
				var index = msg.a;
				var direction = msg.b;
				var ageGroup = msg.c;
				var amount = msg.d;
				var newMaybeSelectedBusTransfers = A2(
					$elm$core$Maybe$map,
					A5($author$project$Types$Bus$SelectedTransfers$addPassengerToTransfer, passengersList, index, direction, ageGroup, amount),
					model.j.B0);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{B0: newMaybeSelectedBusTransfers})
						}),
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Messages$ToastMsg,
							$author$project$Common$Toast$hideToastCmd(model.HT.zN)),
						A2(
							$elm$core$Maybe$map,
							$author$project$Update$BusTransfers$detailedBusTransfersMessages(model),
							newMaybeSelectedBusTransfers)));
		}
	});
var $author$project$Utils$Route$hotelPackageDefaultRoute = _Utils_Tuple2(2, 0);
var $author$project$Utils$Route$isHotelPackageSupportedByRoute = F2(
	function (from, to) {
		var _v0 = _Utils_Tuple2(from, to);
		_v0$26:
		while (true) {
			switch (_v0.a) {
				case 3:
					switch (_v0.b) {
						case 2:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return true;
						case 13:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return true;
						case 1:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return true;
						case 0:
							var _v7 = _v0.a;
							var _v8 = _v0.b;
							return true;
						case 5:
							var _v9 = _v0.a;
							var _v10 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				case 2:
					switch (_v0.b) {
						case 3:
							var _v11 = _v0.a;
							var _v12 = _v0.b;
							return true;
						case 4:
							var _v13 = _v0.a;
							var _v14 = _v0.b;
							return true;
						case 1:
							var _v15 = _v0.a;
							var _v16 = _v0.b;
							return true;
						case 0:
							var _v17 = _v0.a;
							var _v18 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				case 13:
					switch (_v0.b) {
						case 3:
							var _v19 = _v0.a;
							var _v20 = _v0.b;
							return true;
						case 5:
							var _v21 = _v0.a;
							var _v22 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				case 4:
					switch (_v0.b) {
						case 2:
							var _v23 = _v0.a;
							var _v24 = _v0.b;
							return true;
						case 1:
							var _v25 = _v0.a;
							var _v26 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				case 1:
					switch (_v0.b) {
						case 3:
							var _v27 = _v0.a;
							var _v28 = _v0.b;
							return true;
						case 2:
							var _v29 = _v0.a;
							var _v30 = _v0.b;
							return true;
						case 4:
							var _v31 = _v0.a;
							var _v32 = _v0.b;
							return true;
						case 0:
							var _v33 = _v0.a;
							var _v34 = _v0.b;
							return true;
						case 5:
							var _v35 = _v0.a;
							var _v36 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				case 0:
					switch (_v0.b) {
						case 3:
							var _v37 = _v0.a;
							var _v38 = _v0.b;
							return true;
						case 2:
							var _v39 = _v0.a;
							var _v40 = _v0.b;
							return true;
						case 1:
							var _v41 = _v0.a;
							var _v42 = _v0.b;
							return true;
						case 5:
							var _v43 = _v0.a;
							var _v44 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				case 5:
					switch (_v0.b) {
						case 3:
							var _v45 = _v0.a;
							var _v46 = _v0.b;
							return true;
						case 13:
							var _v47 = _v0.a;
							var _v48 = _v0.b;
							return true;
						case 1:
							var _v49 = _v0.a;
							var _v50 = _v0.b;
							return true;
						case 0:
							var _v51 = _v0.a;
							var _v52 = _v0.b;
							return true;
						default:
							break _v0$26;
					}
				default:
					break _v0$26;
			}
		}
		return false;
	});
var $author$project$Update$Route$cancelOutdatedRequests = A2(
	$elm$core$List$map,
	$author$project$Api$Endpoint$cancel,
	_List_fromArray(
		[$author$project$Api$Endpoint$trackers.p4, $author$project$Api$Endpoint$trackers.tj, $author$project$Api$Endpoint$trackers.tt, $author$project$Api$Endpoint$trackers.rv, $author$project$Api$Endpoint$trackers.rs, $author$project$Api$Endpoint$trackers.pc, $author$project$Api$Endpoint$trackers.s4, $author$project$Api$Endpoint$trackers.rI, $author$project$Api$Endpoint$trackers.qk]));
var $author$project$Utils$Route$getHotelPackageVoyageTypeList = F2(
	function (from, to) {
		var _v0 = _Utils_Tuple2(from, to);
		_v0$30:
		while (true) {
			switch (_v0.a) {
				case 2:
					switch (_v0.b) {
						case 1:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Shuttle]);
						case 3:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 4:
							var _v7 = _v0.a;
							var _v8 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				case 5:
					switch (_v0.b) {
						case 0:
							var _v31 = _v0.a;
							var _v32 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 3:
							var _v33 = _v0.a;
							var _v34 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v35 = _v0.a;
							var _v36 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				case 3:
					switch (_v0.b) {
						case 1:
							var _v37 = _v0.a;
							var _v38 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 2:
							var _v39 = _v0.a;
							var _v40 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v41 = _v0.a;
							var _v42 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 4:
							var _v43 = _v0.a;
							var _v44 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				case 8:
					if (_v0.b === 7) {
						var _v45 = _v0.a;
						var _v46 = _v0.b;
						return _List_fromArray(
							[$author$project$Types$VoyageType$Shuttle]);
					} else {
						break _v0$30;
					}
				case 7:
					if (_v0.b === 8) {
						var _v47 = _v0.a;
						var _v48 = _v0.b;
						return _List_fromArray(
							[$author$project$Types$VoyageType$Shuttle]);
					} else {
						break _v0$30;
					}
				case 13:
					if (_v0.b === 12) {
						var _v51 = _v0.a;
						var _v52 = _v0.b;
						return _List_fromArray(
							[$author$project$Types$VoyageType$RouteTrip]);
					} else {
						break _v0$30;
					}
				case 12:
					switch (_v0.b) {
						case 13:
							var _v49 = _v0.a;
							var _v50 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v53 = _v0.a;
							var _v54 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				case 1:
					switch (_v0.b) {
						case 3:
							var _v13 = _v0.a;
							var _v14 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 2:
							var _v15 = _v0.a;
							var _v16 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 4:
							var _v17 = _v0.a;
							var _v18 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v19 = _v0.a;
							var _v20 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 5:
							var _v21 = _v0.a;
							var _v22 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 12:
							var _v55 = _v0.a;
							var _v56 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				case 0:
					switch (_v0.b) {
						case 2:
							var _v23 = _v0.a;
							var _v24 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Shuttle]);
						case 3:
							var _v25 = _v0.a;
							var _v26 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v27 = _v0.a;
							var _v28 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 5:
							var _v29 = _v0.a;
							var _v30 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 4:
							var _v57 = _v0.a;
							var _v58 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				case 4:
					switch (_v0.b) {
						case 1:
							var _v9 = _v0.a;
							var _v10 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 2:
							var _v11 = _v0.a;
							var _v12 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v59 = _v0.a;
							var _v60 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$30;
					}
				default:
					break _v0$30;
			}
		}
		return _List_Nil;
	});
var $author$project$Utils$Route$getHotelPackageDefaultVoyageType = F2(
	function (from, to) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$VoyageType$RouteTrip,
			$elm$core$List$head(
				A2($author$project$Utils$Route$getHotelPackageVoyageTypeList, from, to)));
	});
var $author$project$Utils$Route$isHotelPackageVoyageTypeSupportedByRoute = F3(
	function (from, to, voyageType) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, voyageType);
			},
			A2($author$project$Utils$Route$getHotelPackageVoyageTypeList, from, to));
	});
var $author$project$Update$Route$hotelPackageVoyageType = function (_v0) {
	var session = _v0.j;
	var voyageType = _v0.tx;
	var from = _v0.kS;
	var to = _v0.le;
	return (A3($author$project$Utils$Route$isHotelPackageVoyageTypeSupportedByRoute, from, to, voyageType) && (_Utils_eq(session.kS, from) && _Utils_eq(session.le, to))) ? voyageType : A2($author$project$Utils$Route$getHotelPackageDefaultVoyageType, from, to);
};
var $author$project$Utils$Route$isCruiseToShuttleTransition = F2(
	function (oldVoyageType, newVoyageType) {
		return $author$project$Utils$Route$isCruiseLikeVoyageType(oldVoyageType) && _Utils_eq(newVoyageType, $author$project$Types$VoyageType$Shuttle);
	});
var $author$project$Utils$Route$isMultiDepartureCruise = function (voyageType) {
	if (voyageType.$ === 6) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$Route$supportedDestinations = F2(
	function (bookingType, departure) {
		var supportedDestinationsForRegularBookingType = function () {
			switch (departure) {
				case 3:
					return _List_fromArray(
						[1, 5, 2, 0]);
				case 2:
					return _List_fromArray(
						[1, 0, 3, 4, 6]);
				case 1:
					return _List_fromArray(
						[2, 0, 5, 3]);
				case 0:
					return _List_fromArray(
						[2, 1, 3, 6]);
				case 5:
					return _List_fromArray(
						[1, 3, 0, 13]);
				default:
					return _List_Nil;
			}
		}();
		return (bookingType === 1) ? A2(
			$elm$core$List$filter,
			function (arrival) {
				return A2($author$project$Utils$Route$isHotelPackageSupportedByRoute, departure, arrival);
			},
			supportedDestinationsForRegularBookingType) : supportedDestinationsForRegularBookingType;
	});
var $author$project$Utils$Route$isRouteSupported = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var bookingType = _v0.vk;
	return A2(
		$elm$core$List$member,
		to,
		A2($author$project$Utils$Route$supportedDestinations, bookingType, from));
};
var $author$project$Types$Passenger$keepOneAdultPassenger = function (passengers) {
	return $elm$core$Array$fromList(
		A2(
			$elm$core$List$take,
			1,
			A2(
				$elm$core$List$sortWith,
				F2(
					function (a, b) {
						return A2($author$project$Types$AgeCategory$compare, b.tY, a.tY);
					}),
				$elm$core$Array$toList(passengers))));
};
var $author$project$Utils$Route$getRegularVoyageTypeList = F2(
	function (from, to) {
		var _v0 = _Utils_Tuple2(from, to);
		_v0$42:
		while (true) {
			switch (_v0.a) {
				case 3:
					switch (_v0.b) {
						case 2:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 13:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 4:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v7 = _v0.a;
							var _v8 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v9 = _v0.a;
							var _v10 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 5:
							var _v11 = _v0.a;
							var _v12 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$42;
					}
				case 15:
					if (_v0.b === 1) {
						var _v13 = _v0.a;
						var _v14 = _v0.b;
						return _List_fromArray(
							[$author$project$Types$VoyageType$Cruise]);
					} else {
						break _v0$42;
					}
				case 2:
					switch (_v0.b) {
						case 3:
							var _v15 = _v0.a;
							var _v16 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 4:
							var _v17 = _v0.a;
							var _v18 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise]);
						case 14:
							var _v19 = _v0.a;
							var _v20 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise]);
						case 1:
							var _v21 = _v0.a;
							var _v22 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v23 = _v0.a;
							var _v24 = _v0.b;
							return _List_fromArray(
								[
									$author$project$Types$VoyageType$Shuttle,
									$author$project$Types$VoyageType$CruiseMultiDeparture(1),
									$author$project$Types$VoyageType$Cruise
								]);
						default:
							break _v0$42;
					}
				case 13:
					switch (_v0.b) {
						case 3:
							var _v25 = _v0.a;
							var _v26 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 12:
							var _v27 = _v0.a;
							var _v28 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 5:
							var _v29 = _v0.a;
							var _v30 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$42;
					}
				case 8:
					if (_v0.b === 7) {
						var _v31 = _v0.a;
						var _v32 = _v0.b;
						return _List_fromArray(
							[$author$project$Types$VoyageType$Shuttle]);
					} else {
						break _v0$42;
					}
				case 12:
					switch (_v0.b) {
						case 13:
							var _v33 = _v0.a;
							var _v34 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v35 = _v0.a;
							var _v36 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$42;
					}
				case 4:
					switch (_v0.b) {
						case 3:
							var _v37 = _v0.a;
							var _v38 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 2:
							var _v39 = _v0.a;
							var _v40 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v41 = _v0.a;
							var _v42 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 0:
							var _v43 = _v0.a;
							var _v44 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$42;
					}
				case 1:
					switch (_v0.b) {
						case 3:
							var _v45 = _v0.a;
							var _v46 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 2:
							var _v47 = _v0.a;
							var _v48 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 15:
							var _v49 = _v0.a;
							var _v50 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise]);
						case 12:
							var _v51 = _v0.a;
							var _v52 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 4:
							var _v53 = _v0.a;
							var _v54 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 0:
							var _v55 = _v0.a;
							var _v56 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 5:
							var _v57 = _v0.a;
							var _v58 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 6:
							var _v59 = _v0.a;
							var _v60 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise]);
						case 16:
							var _v61 = _v0.a;
							var _v62 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$CruiseMultistop]);
						default:
							break _v0$42;
					}
				case 0:
					switch (_v0.b) {
						case 3:
							var _v63 = _v0.a;
							var _v64 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 2:
							var _v65 = _v0.a;
							var _v66 = _v0.b;
							return _List_fromArray(
								[
									$author$project$Types$VoyageType$Shuttle,
									$author$project$Types$VoyageType$CruiseMultiDeparture(1),
									$author$project$Types$VoyageType$CruiseMultiDeparture(0)
								]);
						case 17:
							var _v67 = _v0.a;
							var _v68 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$CruiseParty]);
						case 4:
							var _v69 = _v0.a;
							var _v70 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 1:
							var _v71 = _v0.a;
							var _v72 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip, $author$project$Types$VoyageType$Cruise]);
						case 5:
							var _v73 = _v0.a;
							var _v74 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						default:
							break _v0$42;
					}
				case 5:
					switch (_v0.b) {
						case 3:
							var _v75 = _v0.a;
							var _v76 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$RouteTrip]);
						case 13:
							var _v77 = _v0.a;
							var _v78 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise]);
						case 1:
							var _v79 = _v0.a;
							var _v80 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise, $author$project$Types$VoyageType$RouteTrip]);
						case 0:
							var _v81 = _v0.a;
							var _v82 = _v0.b;
							return _List_fromArray(
								[$author$project$Types$VoyageType$Cruise]);
						default:
							break _v0$42;
					}
				case 7:
					if (_v0.b === 8) {
						var _v83 = _v0.a;
						var _v84 = _v0.b;
						return _List_fromArray(
							[$author$project$Types$VoyageType$Shuttle]);
					} else {
						break _v0$42;
					}
				default:
					break _v0$42;
			}
		}
		return _List_Nil;
	});
var $author$project$Utils$Route$getRegularDefaultVoyageType = F4(
	function (from, to, market, maybeVoyageType) {
		var firstAvailableVoyageType = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$VoyageType$Cruise,
			$elm$core$List$head(
				A2($author$project$Utils$Route$getRegularVoyageTypeList, from, to)));
		var _v0 = _Utils_Tuple3(from, to, market);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				switch (_v0.b) {
					case 1:
						if (!_v0.c) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							var _v3 = _v0.c;
							return $author$project$Types$VoyageType$Cruise;
						} else {
							break _v0$2;
						}
					case 2:
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return _Utils_eq(
							maybeVoyageType,
							$elm$core$Maybe$Just($author$project$Types$VoyageType$Cruise)) ? $author$project$Types$VoyageType$CruiseMultiDeparture(0) : firstAvailableVoyageType;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return firstAvailableVoyageType;
	});
var $author$project$Utils$Route$isRegularVoyageTypeSupportedByRoute = F3(
	function (from, to, voyageType) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, voyageType);
			},
			A2($author$project$Utils$Route$getRegularVoyageTypeList, from, to));
	});
var $author$project$Update$Route$regularVoyageType = function (_v0) {
	var session = _v0.j;
	var voyageType = _v0.tx;
	var from = _v0.kS;
	var to = _v0.le;
	return (A3($author$project$Utils$Route$isRegularVoyageTypeSupportedByRoute, from, to, voyageType) && (_Utils_eq(session.kS, from) && _Utils_eq(session.le, to))) ? voyageType : A4(
		$author$project$Utils$Route$getRegularDefaultVoyageType,
		from,
		to,
		session.rb,
		$elm$core$Maybe$Just(voyageType));
};
var $author$project$Update$Route$removeVehiclesIfNotSupported = function (model) {
	return (!$author$project$Utils$Route$areVehiclesSupported(model.j)) ? _Utils_update(
		model,
		{
			j: function (session) {
				return _Utils_update(
					session,
					{rp: $elm$core$Maybe$Nothing});
			}(model.j)
		}) : model;
};
var $author$project$Types$SelectedOnboardServices$resetKidBracelets = function (_v0) {
	var a = _v0;
	return _Utils_update(
		a,
		{DC: $elm$core$Dict$empty, FV: $elm$core$Dict$empty});
};
var $author$project$Update$Route$resetKidBraceletsOnNonStoHelRoute = function (model) {
	var session = model.j;
	var newSession = _Utils_update(
		session,
		{
			rI: function (a) {
				return _Utils_update(
					a,
					{AL: _List_Nil});
			}(session.rI),
			Gm: $author$project$Types$SelectedOnboardServices$resetKidBracelets(session.Gm)
		});
	return (!$author$project$Utils$Route$isStoHelRoute(model.j)) ? _Utils_update(
		model,
		{j: newSession}) : model;
};
var $author$project$Update$Route$updateRoute = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var unvalidatedVoyageType = _v0.m1;
	var model = _v0.eM;
	var _v1 = model;
	var session = _v1.j;
	var bookingType = session.vk;
	var oldFrom = session.kS;
	var oldTo = session.le;
	var reversed = _Utils_eq(oldFrom, to) && _Utils_eq(oldTo, from);
	var shouldSelectFirstTurRoute = (oldFrom !== 5) && ((from === 5) && (!reversed));
	var adjustedTo = (shouldSelectFirstTurRoute || (!$author$project$Utils$Route$isRouteSupported(
		{vk: bookingType, kS: from, le: to}))) ? A2(
		$elm$core$Maybe$withDefault,
		to,
		$elm$core$List$head(
			A2($author$project$Utils$Route$supportedDestinations, bookingType, from))) : to;
	var passengers = ($author$project$Utils$Route$isMugVssRoute(from) && ($elm$core$Array$length(session.Eg) > 5)) ? $author$project$Types$Passenger$keepOneAdultPassenger(session.Eg) : session.Eg;
	var voyageType = function () {
		var _v4 = session.vk;
		if (!_v4) {
			return $author$project$Update$Route$regularVoyageType(
				{kS: from, j: session, le: adjustedTo, tx: unvalidatedVoyageType});
		} else {
			return $author$project$Update$Route$hotelPackageVoyageType(
				{kS: from, j: session, le: adjustedTo, tx: unvalidatedVoyageType});
		}
	}();
	var isOneWay = ((A2($author$project$Utils$Route$isCruiseToShuttleTransition, session.tx, voyageType) || ($author$project$Utils$Route$isCruiseLikeVoyageType(voyageType) || $author$project$Utils$Route$isMultiDepartureCruise(voyageType))) && (session.vk !== 1)) ? true : session.qW;
	var _v2 = _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) ? _Utils_Tuple2(session.pD, session.Gh) : _Utils_Tuple2($krisajenkins$remotedata$RemoteData$NotAsked, $author$project$Types$CabinSurprise$defaultSelectedSurprises);
	var cabinSurprises = _v2.a;
	var selectedCabinSurprises = _v2.b;
	var _v3 = _Utils_eq(voyageType, $author$project$Types$VoyageType$Shuttle) ? _Utils_Tuple2($author$project$Types$SelectedOnboardServices$init, $author$project$Types$OnboardServices$init) : _Utils_Tuple2(session.Gm, session.rI);
	var selectedOnboardServices = _v3.a;
	var onboardServices = _v3.b;
	return A2(
		$elm$core$Tuple$mapFirst,
		$author$project$Update$Route$removeVehiclesIfNotSupported,
		A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Update$Route$resetKidBraceletsOnNonStoHelRoute,
			_Utils_Tuple2(
				$author$project$Update$Route$resetReturnOnboardServiceSelectionsOnOneWay(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									pr: false,
									pD: cabinSurprises,
									mm: 1,
									qk: _List_Nil,
									kS: from,
									qW: isOneWay,
									AZ: $krisajenkins$remotedata$RemoteData$NotAsked,
									ri: $elm$core$Maybe$Nothing,
									B0: $elm$core$Maybe$Nothing,
									B7: $elm$core$Maybe$Nothing,
									rs: $author$project$Types$MealPackage$Regular(_List_Nil),
									rI: onboardServices,
									Eg: passengers,
									Gh: selectedCabinSurprises,
									Gi: $author$project$Types$SelectedExtraServices$init,
									Gm: selectedOnboardServices,
									le: adjustedTo,
									tx: voyageType
								})
						})),
				$elm$core$Platform$Cmd$batch(
					_Utils_ap(
						_List_fromArray(
							[
								(!_Utils_eq(passengers, session.Eg)) ? A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Messages$ToastMsg,
								A3(
									$author$project$Common$Toast$showToastCmd,
									1,
									function ($) {
										return $.hj;
									},
									false)) : $elm$core$Platform$Cmd$none
							]),
						$author$project$Update$Route$cancelOutdatedRequests)))));
};
var $author$project$Update$updateHotelPackageBookingType = function (model) {
	var session = model.j;
	var _v0 = session;
	var from = _v0.kS;
	var to = _v0.le;
	var _v1 = A2($author$project$Utils$Route$isHotelPackageSupportedByRoute, from, to) ? _Utils_Tuple2(from, to) : $author$project$Utils$Route$hotelPackageDefaultRoute;
	var newFrom = _v1.a;
	var newTo = _v1.b;
	return A2(
		$author$project$Update$Util$andThen,
		$author$project$Update$Trips$fetchHotelPackages,
		A2(
			$author$project$Update$BusTransfers$showBusTransferRemovedToastIfNeeded,
			session.B0,
			A2(
				$author$project$Update$Util$andThen,
				function (a) {
					return $author$project$Update$Route$updateRoute(
						{kS: newFrom, eM: a, le: newTo, m1: session.tx});
				},
				_Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{vk: 1, Ac: true, qW: false})
						}),
					A3($author$project$UrlRoute$replaceUrl, model.AK, model.n1, $author$project$UrlRoute$Root)))));
};
var $author$project$Update$updateRegularBookingType = function (model) {
	var session = model.j;
	return A2(
		$author$project$Update$Util$andThen,
		$author$project$Update$Trips$fetchTrips,
		A2(
			$author$project$Update$BusTransfers$showBusTransferRemovedToastIfNeeded,
			session.B0,
			A2(
				$author$project$Update$Util$andThen,
				function (a) {
					return $author$project$Update$Route$updateRoute(
						{kS: session.kS, eM: a, le: session.le, m1: session.tx});
				},
				$author$project$Update$selectRegularBookingType(model))));
};
var $author$project$Update$updateBookingType = F2(
	function (bookingType, model) {
		if (!bookingType) {
			return $author$project$Update$updateRegularBookingType(model);
		} else {
			return $author$project$Update$updateHotelPackageBookingType(model);
		}
	});
var $author$project$Types$Validation$ErrorCodes$toMessage = F2(
	function (translations, e) {
		switch (e) {
			case 0:
				return _Utils_Tuple2('Date', translations.DP);
			case 1:
				return _Utils_Tuple2('Email', translations.mh);
			case 2:
				return _Utils_Tuple2('Email', translations.wM);
			case 3:
				return _Utils_Tuple2('Phone', translations.mh);
			case 4:
				return _Utils_Tuple2('Phone', translations.wN);
			case 5:
				return _Utils_Tuple2('Name', translations.wX);
			case 6:
				return _Utils_Tuple2('Name', translations.wX);
			case 7:
				return _Utils_Tuple2('Day', translations.DO);
			case 8:
				return _Utils_Tuple2('Month', translations.DO);
			case 9:
				return _Utils_Tuple2('Year', translations.DO);
			case 10:
				return _Utils_Tuple2('Birthday', translations.xP);
			case 11:
				return _Utils_Tuple2('', '');
			case 16:
				return _Utils_Tuple2('Birthday', translations.DM);
			case 12:
				return _Utils_Tuple2('', '');
			case 13:
				return _Utils_Tuple2('Document Number', translations.mh);
			case 14:
				return _Utils_Tuple2('Document Date', translations.mh);
			default:
				return _Utils_Tuple2('Document Issued Date', translations.mh);
		}
	});
var $author$project$Tracking$logUIValidationError = F2(
	function (kind, errorCode) {
		return $author$project$Tracking$logError(
			A2(
				$author$project$Tracking$encodeUIMessage,
				kind,
				A2(
					$author$project$Types$Validation$ErrorCodes$toMessage,
					$author$project$Translations$forLanguage(0),
					errorCode)));
	});
var $author$project$Types$Validation$ErrorCodes$FirstNameWrong = 5;
var $author$project$Types$Validation$ErrorCodes$LastNameWrong = 6;
var $author$project$ContactPersonPage$Model$toDataTrackingValidation = function (_v0) {
	var firstName = _v0.y2;
	var lastName = _v0.A6;
	var isNameValid = function (name) {
		return $elm$core$String$isEmpty(name) || $author$project$Utils$String$isSeawareCharsOnlyAndWithoutUnwantedSymbols(name);
	};
	return (!isNameValid(firstName)) ? $elm$core$Maybe$Just(5) : ((!isNameValid(lastName)) ? $elm$core$Maybe$Just(6) : $elm$core$Maybe$Nothing);
};
var $author$project$Common$PhoneNumber$Update$getCountryCodeAndReducedPhoneNumberWithoutCountryCode = F2(
	function (phone, countryCode) {
		return _Utils_Tuple2(
			countryCode.pQ,
			A2(
				$elm$core$String$left,
				countryCode.BM,
				A3($elm$core$String$replace, countryCode.pQ, '', phone)));
	});
var $author$project$Common$PhoneNumber$Update$detectCountryCodeAndPhoneNumber = F2(
	function (countryCode, phoneNumber) {
		var sanitizedPhoneNumber = A3($elm$core$String$replace, ' ', '', phoneNumber);
		if ($author$project$Utils$String$isBlank(sanitizedPhoneNumber)) {
			return _Utils_Tuple2(countryCode, '');
		} else {
			var phoneWithPossibleCountryCode = ((countryCode === '+') && (!A2($elm$core$String$contains, '+', sanitizedPhoneNumber))) ? ('+' + sanitizedPhoneNumber) : sanitizedPhoneNumber;
			return A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(countryCode, sanitizedPhoneNumber),
					A2(
						$elm$core$Maybe$map,
						$author$project$Common$PhoneNumber$Update$getCountryCodeAndReducedPhoneNumberWithoutCountryCode(sanitizedPhoneNumber),
						A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pQ;
								},
								$elm$core$Basics$eq(countryCode)),
							$author$project$Types$Phone$infoList))),
				A2(
					$elm$core$Maybe$map,
					$author$project$Common$PhoneNumber$Update$getCountryCodeAndReducedPhoneNumberWithoutCountryCode(phoneWithPossibleCountryCode),
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (c) {
							return A2($elm$core$String$startsWith, c.pQ, phoneWithPossibleCountryCode);
						},
						$author$project$Types$Phone$infoList)));
		}
	});
var $author$project$Utils$String$trimAndRemoveDuplicateWhitespace = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$regex$Regex$replace,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\\s\\s+')),
		$elm$core$Basics$always(' ')),
	$elm$core$String$trim);
var $author$project$ContactPersonPage$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var firstName = msg.a;
				return _Utils_update(
					model,
					{y2: firstName});
			case 1:
				var lastName = $author$project$Utils$String$trimAndRemoveDuplicateWhitespace(model.A6);
				var firstName = $author$project$Utils$String$trimAndRemoveDuplicateWhitespace(model.y2);
				return _Utils_update(
					model,
					{y2: firstName, A6: lastName});
			case 2:
				var lastName = msg.a;
				return _Utils_update(
					model,
					{A6: lastName});
			case 3:
				var email = msg.a;
				return _Utils_update(
					model,
					{
						yI: $author$project$Utils$String$trimAndRemoveDuplicateWhitespace(email)
					});
			case 5:
				var countryCode = msg.a;
				return _Utils_update(
					model,
					{
						p$: countryCode,
						ox: $author$project$Utils$String$trimAndRemoveDuplicateWhitespace(
							A2(
								$elm$core$Maybe$withDefault,
								model.ox,
								A2(
									$elm$core$Maybe$map,
									function (a) {
										return A2(
											$elm$core$String$dropLeft,
											$elm$core$String$length(a.pQ),
											model.ox);
									},
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.pQ;
											},
											function (a) {
												return A2($elm$core$String$startsWith, a, model.ox);
											}),
										$author$project$Types$Phone$infoList))))
					});
			case 4:
				var newPhoneNumber = msg.a;
				var _v1 = A2($author$project$Common$PhoneNumber$Update$detectCountryCodeAndPhoneNumber, model.p$, newPhoneNumber);
				var countryCode = _v1.a;
				var phoneNumber = _v1.b;
				return _Utils_update(
					model,
					{p$: countryCode, ox: phoneNumber});
			default:
				var zipCode = msg.a;
				return _Utils_update(
					model,
					{
						jX: $author$project$Utils$String$trimAndRemoveDuplicateWhitespace(zipCode)
					});
		}
	});
var $author$project$Update$updateContactPersonPage = F3(
	function (subMsg, pageModel, model) {
		var session = model.j;
		var page = A2($author$project$ContactPersonPage$Update$update, subMsg, pageModel);
		var joinClubOneState = $author$project$Types$JoinClubOneState$resetErrorStates(session.AE);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					DF: $author$project$Model$ContactPersonPage(page),
					j: _Utils_update(
						session,
						{AE: joinClubOneState})
				}),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$author$project$Tracking$logUIValidationError('ContactPerson'),
					$author$project$ContactPersonPage$Model$toDataTrackingValidation(pageModel))));
	});
var $author$project$Update$updateEnabledClubOneSlider = F2(
	function (model, map) {
		var session = model.j;
		return _Utils_update(
			model,
			{
				j: _Utils_update(
					session,
					{
						n8: A2(
							$elm$core$Maybe$map,
							function (clubOneSlider) {
								if (!clubOneSlider.$) {
									var enabled = clubOneSlider.a;
									return $author$project$Types$ClubOneSlider$Enabled(
										map(enabled));
								} else {
									return clubOneSlider;
								}
							},
							session.n8)
					})
			});
	});
var $author$project$MealPage$Update$dictFilterMapEmptyValues = function (dict) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var k = _v0.a;
				var maybeV = _v0.b;
				if (!maybeV.$) {
					var v = maybeV.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(k, v));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$Dict$toList(dict)));
};
var $author$project$MealPage$Update$updateMenu = F2(
	function (session, menu) {
		var _v0 = function () {
			var toMaybeSitting = F2(
				function (sittings, selectedMeals) {
					return A2(
						$elm$core$Maybe$map,
						$author$project$MealPage$Update$toSitting,
						A2($author$project$MealPage$Update$findSelectedMealForOneOfTheSittings, sittings, selectedMeals));
				});
			var maybeMeal = A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.HI;
					},
					$elm$core$Basics$eq(menu.HI)),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Types$Meals$toList, session.ri)));
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				A2(
					$elm$core$Maybe$map,
					function (meal) {
						return _Utils_Tuple2(
							A2(toMaybeSitting, meal.kC, session.Gn),
							A2(toMaybeSitting, meal.k4, session.Go));
					},
					maybeMeal));
		}();
		var maybeOutwardSitting = _v0.a;
		var maybeReturnSitting = _v0.b;
		var maybeDirection = function () {
			var _v1 = _Utils_Tuple2(maybeOutwardSitting, maybeReturnSitting);
			if (!_v1.a.$) {
				if (_v1.b.$ === 1) {
					var _v2 = _v1.b;
					return $elm$core$Maybe$Just(0);
				} else {
					return $elm$core$Maybe$Just(menu.p7);
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					return $elm$core$Maybe$Just(1);
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		return A2(
			$elm$core$Maybe$map,
			function (direction) {
				return _Utils_update(
					menu,
					{p7: direction, BY: maybeOutwardSitting, B$: maybeReturnSitting});
			},
			maybeDirection);
	});
var $author$project$MealPage$Update$updateMenus = F2(
	function (session, model) {
		var newMenus = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2(
				$elm$core$Maybe$map,
				function (meals) {
					return $author$project$MealPage$Update$init(
						{rv: meals, Gn: session.Gn, Go: session.Go});
				},
				session.ri));
		var menuTitles = A2(
			$elm$core$List$map,
			function ($) {
				return $.HI;
			},
			_Utils_ap(
				$author$project$Types$SelectedMeals$toList(session.Gn),
				$author$project$Types$SelectedMeals$toList(session.Go)));
		var updatedMenus = $author$project$MealPage$Update$dictFilterMapEmptyValues(
			A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, v) {
						return A2($author$project$MealPage$Update$updateMenu, session, v);
					}),
				A2(
					$elm$core$Dict$filter,
					F2(
						function (k, _v0) {
							return A2($elm$core$List$member, k, menuTitles);
						}),
					model)));
		return A2($elm$core$Dict$union, updatedMenus, newMenus);
	});
var $author$project$Types$Passenger$DuplicateClubOneInfoError = {$: 7};
var $author$project$Types$Passenger$fromForm = F5(
	function (isSoloYouthAllowed, index, passengers, form, departureTime) {
		return A2(
			$elm$core$Result$andThen,
			function (passenger) {
				return A3(
					$author$project$Types$Passenger$hasPassengerWithEqualClubOneInfo,
					index,
					passengers,
					{we: form.we, mr: form.mr, zj: form.zj}) ? $elm$core$Result$Err($author$project$Types$Passenger$DuplicateClubOneInfoError) : $elm$core$Result$Ok(passenger);
			},
			A2(
				$elm$core$Result$map,
				function (a) {
					return a(
						(!$elm$core$String$isEmpty(form.v_)) ? $elm$core$Maybe$Just(form.v_) : $elm$core$Maybe$Nothing);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return a(
							$elm$core$Result$toMaybe(
								A2(
									$elm$core$Result$andThen,
									A2(
										$elm$core$Basics$composeR,
										A4($author$project$Types$Passenger$validateBirthday, isSoloYouthAllowed, departureTime, index, passengers),
										$elm$core$Result$mapError(
											$elm$core$Basics$always(0))),
									A2(
										$elm$core$Result$mapError,
										$elm$core$Basics$always(0),
										A2(
											$elm$core$Result$andThen,
											$author$project$Types$Date$validateBirthdayYear(departureTime),
											$author$project$Types$Date$fromStringValues(
												{q: form.l4, s: form.l5, h: form.l6}))))));
					},
					A2(
						$elm$core$Result$map,
						function (a) {
							return a(form.zf);
						},
						A2(
							$elm$core$Result$andThen,
							function (a) {
								return A2(
									$elm$core$Result$map,
									a,
									$author$project$Types$Passenger$nameFromString(form.mr));
							},
							function (a) {
								return A2(
									$elm$core$Result$map,
									a,
									$author$project$Types$Passenger$nameFromString(form.zj));
							}(
								F5(
									function (givenName, familyName, gender, maybeBirthday, maybeCitizenship) {
										var maybePassenger = A2($elm$core$Array$get, index, passengers);
										var ageCategory = A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$author$project$Types$Maybe$Util$orElse,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.tY;
													},
													maybePassenger),
												A2(
													$elm$core$Maybe$map,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Types$Date$toPosix,
														A2(
															$elm$core$Basics$composeR,
															function (a) {
																return A2($author$project$Utils$Time$differenceOfDatesInYears, a, departureTime);
															},
															$author$project$Types$AgeCategory$fromAge)),
													maybeBirthday)));
										return {
											tY: ageCategory,
											uw: A2(
												$author$project$Types$Maybe$Util$orElse,
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.uw;
													},
													maybePassenger),
												maybeBirthday),
											v_: maybeCitizenship,
											v5: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.v5;
												},
												maybePassenger),
											pO: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.pO;
												},
												maybePassenger),
											we: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.we;
												},
												maybePassenger),
											wf: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.wf;
												},
												maybePassenger),
											yI: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.yI;
												},
												maybePassenger),
											y2: givenName,
											zf: $elm$core$Maybe$Just(gender),
											A6: familyName,
											ox: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.ox;
												},
												maybePassenger),
											jX: A2(
												$elm$core$Maybe$andThen,
												function ($) {
													return $.jX;
												},
												maybePassenger)
										};
									})))))));
	});
var $author$project$PassengerDetailsPage$Model$modelToForm = function (model) {
	return {l4: model.l4, l5: model.l5, l6: model.l6, v_: model.v_, we: model.we, mr: model.mr, zf: model.zf, zj: model.zj};
};
var $author$project$Update$Passengers$showAgeCategoryChangeToast = F2(
	function (translations, _v0) {
		var old = _v0.C4;
		var _new = _v0.CG;
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Messages$ToastMsg,
			A4(
				$author$project$Common$Toast$showToastCmdWithParams,
				0,
				function ($) {
					return $.hc;
				},
				false,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'old',
						A2($author$project$Types$AgeCategory$translate, old, translations)),
						_Utils_Tuple2(
						'new',
						A2($author$project$Types$AgeCategory$translate, _new, translations))
					])));
	});
var $author$project$Update$Passengers$replacePassenger = F3(
	function (model, index, passenger) {
		return _Utils_Tuple2(
			function (a) {
				return _Utils_update(
					model,
					{j: a});
			}(
				function (a) {
					return _Utils_update(
						a,
						{
							Eg: A3($elm$core$Array$set, index, passenger, a.Eg)
						});
				}(model.j)),
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					$author$project$UrlRoute$back(model.AK),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								var ageCategory = _v0.tY;
								return (!_Utils_eq(ageCategory, passenger.tY)) ? _List_fromArray(
									[
										A2(
										$author$project$Update$Passengers$showAgeCategoryChangeToast,
										$author$project$Translations$forLanguage(model.j.A_),
										{CG: passenger.tY, C4: ageCategory})
									]) : _List_Nil;
							},
							A2($elm$core$Array$get, index, model.j.Eg))))));
	});
var $author$project$Update$Passengers$updatePassenger = F2(
	function (model, pageModel) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Types$Trips$selectedDepartureAndArrivalTimes,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					A2(
						$elm$core$Basics$composeR,
						A4(
							$author$project$Types$Passenger$fromForm,
							pageModel.q$,
							pageModel.qH,
							model.j.Eg,
							$author$project$PassengerDetailsPage$Model$modelToForm(pageModel)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$toMaybe,
							$elm$core$Maybe$map(
								A2($author$project$Update$Passengers$replacePassenger, model, pageModel.qH)))))),
			$author$project$Types$Trips$statusToMaybe(model.j.tp));
	});
var $author$project$Update$updateTravelClasses = F2(
	function (model, transformTravelClasses) {
		var _v0 = model;
		var session = _v0.j;
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					transformTravelClasses,
					function (a) {
						return _Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{
										to: $elm$core$Maybe$Just(a)
									})
							});
					}),
				model.j.to));
	});
var $author$project$UrlRoute$routeFromVoyageTypeAndDirection = F2(
	function (voyageType, direction) {
		var directionRoute = (!direction) ? 0 : 2;
		switch (voyageType.$) {
			case 2:
				return $author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$Shuttle(directionRoute));
			case 3:
				return $author$project$UrlRoute$Timetable(
					$author$project$UrlRoute$RouteTrip(directionRoute));
			case 0:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			case 6:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$CruiseMultiDeparture);
			case 4:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			case 5:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
			default:
				return $author$project$UrlRoute$Timetable($author$project$UrlRoute$Cruise);
		}
	});
var $author$project$Update$updateVoyageType = F2(
	function (voyageType, model) {
		var session = model.j;
		return A2(
			$author$project$Update$Util$andThen,
			$author$project$Update$Trips$fetchTrips,
			A2(
				$author$project$Update$BusTransfers$showBusTransferRemovedToastIfNeeded,
				model.j.B0,
				A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A3(
									$author$project$UrlRoute$replaceUrl,
									model.AK,
									model.n1,
									A2($author$project$UrlRoute$routeFromVoyageTypeAndDirection, voyageType, 0)),
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Messages$ToastMsg,
									$author$project$Common$Toast$hideToastCmd(model.HT.zN))
								]));
					},
					A2(
						$elm$core$Tuple$mapFirst,
						function (newModel) {
							return _Utils_update(
								newModel,
								{
									j: function (newSession) {
										return _Utils_update(
											newSession,
											{Gz: true});
									}(newModel.j)
								});
						},
						$author$project$Update$Route$updateRoute(
							{kS: session.kS, eM: model, le: session.le, m1: voyageType})))));
	});
var $author$project$Types$SelectedMeals$updateMealBasedOnPosix = F2(
	function (meal, meals) {
		var _v0 = $author$project$Types$Meals$getMealType(meal);
		switch (_v0) {
			case 0:
				return _Utils_update(
					meals,
					{
						vu: _List_fromArray(
							[meal])
					});
			case 1:
				return _Utils_update(
					meals,
					{
						vx: _List_fromArray(
							[meal])
					});
			case 2:
				return _Utils_update(
					meals,
					{
						Bz: _List_fromArray(
							[meal])
					});
			default:
				return _Utils_update(
					meals,
					{
						yw: _List_fromArray(
							[meal])
					});
		}
	});
var $author$project$Types$SelectedMeals$fromList = A2($elm$core$List$foldl, $author$project$Types$SelectedMeals$updateMealBasedOnPosix, $author$project$Types$SelectedMeals$init);
var $author$project$Types$SelectedMeals$addAddon = F2(
	function (code, sitting) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Types$SelectedMeals$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (a) {
						return A2($author$project$Types$Meals$isSameSitting, sitting, a) ? _Utils_update(
							a,
							{
								tS: A2($elm$core$List$cons, code, a.tS)
							}) : a;
					}),
				$author$project$Types$SelectedMeals$fromList));
	});
var $author$project$Update$Meals$addOption = F4(
	function (code, direction, sitting, model) {
		var session = model.j;
		return function (a) {
			return _Utils_update(
				model,
				{j: a});
		}(
			function () {
				if (!direction) {
					return function (a) {
						return _Utils_update(
							session,
							{Gn: a});
					}(
						A3($author$project$Types$SelectedMeals$addAddon, code, sitting, model.j.Gn));
				} else {
					return function (a) {
						return _Utils_update(
							session,
							{Go: a});
					}(
						A3($author$project$Types$SelectedMeals$addAddon, code, sitting, session.Go));
				}
			}());
	});
var $author$project$Types$SelectedMeals$removeAddon = F2(
	function (code, sitting) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Types$SelectedMeals$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (a) {
						return A2($author$project$Types$Meals$isSameSitting, sitting, a) ? _Utils_update(
							a,
							{
								tS: A2($elm_community$list_extra$List$Extra$remove, code, a.tS)
							}) : a;
					}),
				$author$project$Types$SelectedMeals$fromList));
	});
var $author$project$Update$Meals$removeOption = F4(
	function (code, direction, sitting, model) {
		var session = model.j;
		return function (a) {
			return _Utils_update(
				model,
				{j: a});
		}(
			function () {
				if (!direction) {
					return function (a) {
						return _Utils_update(
							session,
							{Gn: a});
					}(
						A3($author$project$Types$SelectedMeals$removeAddon, code, sitting, model.j.Gn));
				} else {
					return function (a) {
						return _Utils_update(
							session,
							{Go: a});
					}(
						A3($author$project$Types$SelectedMeals$removeAddon, code, sitting, session.Go));
				}
			}());
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Types$Meals$isBreakfast = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$Meals$getMealType,
	$elm$core$Basics$eq(0));
var $author$project$Types$MealPackage$isNotEventAndHasRoomAnd = F2(
	function (condition, sitting) {
		return (!sitting.z8) && (sitting.zr && condition(sitting));
	});
var $author$project$Types$MealPackage$listToPairList = function (sittings) {
	if (sittings.b) {
		var x = sittings.a;
		var xs = sittings.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(x, xs)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Types$MealPackage$takeSittings = F2(
	function (count, sittings) {
		if (count > 0) {
			if (sittings.b) {
				var _v1 = sittings.a;
				var y1 = _v1.a;
				var ys = _v1.b;
				var xs = sittings.b;
				return A2(
					$elm$core$List$cons,
					y1,
					A2(
						$author$project$Types$MealPackage$takeSittings,
						count - 1,
						_Utils_ap(
							xs,
							$author$project$Types$MealPackage$listToPairList(ys))));
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Types$MealPackage$takeSecondOfThreeAndThenOtherSittings = F2(
	function (count, sittings) {
		if (count > 0) {
			if ((sittings.b && sittings.b.b) && sittings.b.b.b) {
				var x1 = sittings.a;
				var _v1 = sittings.b;
				var _v2 = _v1.a;
				var y = _v2.a;
				var ys = _v2.b;
				var _v3 = _v1.b;
				var x3 = _v3.a;
				var xs = _v3.b;
				return A2(
					$elm$core$List$cons,
					y,
					A2(
						$author$project$Types$MealPackage$takeSittings,
						count - 1,
						A2(
							$elm$core$List$cons,
							x1,
							A2(
								$elm$core$List$cons,
								x3,
								_Utils_ap(
									xs,
									$author$project$Types$MealPackage$listToPairList(ys))))));
			} else {
				return A2($author$project$Types$MealPackage$takeSittings, count, sittings);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Types$MealPackage$getBreakfasts = F2(
	function (count, sittings) {
		var groupedByDay = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ut;
					},
					$elm$time$Time$posixToMillis)),
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ut;
					},
					$elm$time$Time$toDay($elm$time$Time$utc)),
				A2(
					$elm$core$List$filter,
					$author$project$Types$MealPackage$isNotEventAndHasRoomAnd($author$project$Types$Meals$isBreakfast),
					sittings)));
		return A2($author$project$Types$MealPackage$takeSecondOfThreeAndThenOtherSittings, count, groupedByDay);
	});
var $author$project$Types$Meals$isDinner = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$Meals$getMealType,
	$elm$core$Basics$eq(3));
var $author$project$Types$MealPackage$stoVisCruise = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return (from === 1) && ((to === 6) && _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise));
};
var $author$project$Types$MealPackage$stoYstCruiseMultistop = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return (from === 1) && ((to === 16) && _Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultistop));
};
var $author$project$Types$MealPackage$takeFirstAndThirdSitting = F2(
	function (count, sittings) {
		var _v0 = _Utils_Tuple2(count, sittings);
		if (((((_v0.a === 2) && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && (!_v0.b.b.b.b.b)) {
			var _v1 = _v0.b;
			var _v2 = _v1.a;
			var first = _v2.a;
			var _v3 = _v1.b;
			var _v4 = _v3.a;
			var _v5 = _v3.b;
			var _v6 = _v5.a;
			var third = _v6.a;
			return _List_fromArray(
				[first, third]);
		} else {
			return A2($author$project$Types$MealPackage$takeSecondOfThreeAndThenOtherSittings, count, sittings);
		}
	});
var $author$project$Types$MealPackage$getBuffets = F3(
	function (ship, count, sittings) {
		var groupedByDay = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ut;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$time$Time$posixToMillis,
						$elm$core$Basics$mul(-1)))),
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ut;
					},
					$elm$time$Time$toDay($elm$time$Time$utc)),
				A2(
					$elm$core$List$filter,
					$author$project$Types$MealPackage$isNotEventAndHasRoomAnd($author$project$Types$Meals$isDinner),
					sittings)));
		return ($author$project$Types$MealPackage$stoYstCruiseMultistop(ship) || $author$project$Types$MealPackage$stoVisCruise(ship)) ? A2($author$project$Types$MealPackage$takeFirstAndThirdSitting, count, groupedByDay) : A2($author$project$Types$MealPackage$takeSecondOfThreeAndThenOtherSittings, count, groupedByDay);
	});
var $author$project$Types$Meals$isLunch = A2(
	$elm$core$Basics$composeR,
	$author$project$Types$Meals$getMealType,
	$elm$core$Basics$eq(2));
var $author$project$Types$MealPackage$getLunches = F2(
	function (count, sittings) {
		var groupedByDay = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ut;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$time$Time$posixToMillis,
						$elm$core$Basics$mul(-1)))),
			A2(
				$elm_community$list_extra$List$Extra$gatherEqualsBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.ut;
					},
					$elm$time$Time$toDay($elm$time$Time$utc)),
				A2(
					$elm$core$List$filter,
					$author$project$Types$MealPackage$isNotEventAndHasRoomAnd($author$project$Types$Meals$isLunch),
					sittings)));
		return A2($author$project$Types$MealPackage$takeSecondOfThreeAndThenOtherSittings, count, groupedByDay);
	});
var $author$project$Types$MealPackage$getSelections = F3(
	function (ship, _package, sittings) {
		return _Utils_ap(
			A2($author$project$Types$MealPackage$getBreakfasts, _package.vv, sittings),
			_Utils_ap(
				A2($author$project$Types$MealPackage$getLunches, _package.BA, sittings),
				A3($author$project$Types$MealPackage$getBuffets, ship, _package.vA, sittings)));
	});
var $author$project$Update$Meals$isOutwardSitting = F2(
	function (meals, sitting) {
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(sitting),
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.kC;
				},
				$author$project$Types$Meals$toList(meals)));
	});
var $author$project$Update$Meals$isReturnSitting = F2(
	function (meals, sitting) {
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(sitting),
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.k4;
				},
				$author$project$Types$Meals$toList(meals)));
	});
var $author$project$Types$MealPackage$isTwoPlusOneCode = function (code) {
	var string = code;
	return string === 'MEAL PKG 2+1';
};
var $author$project$Types$SelectedMeals$areSame = F2(
	function (a, b) {
		return _Utils_eq(
			_Utils_update(
				a,
				{tS: _List_Nil, wo: ''}),
			_Utils_update(
				b,
				{tS: _List_Nil, wo: ''}));
	});
var $author$project$Update$Meals$toggleSelectedMeal = F2(
	function (oldMeals, meal) {
		var isMealSelected = A2(
			$elm$core$List$any,
			function (a) {
				return A2($author$project$Types$SelectedMeals$areSame, a, meal);
			},
			oldMeals);
		var hasMealForSelectedDay = A2(
			$elm$core$List$any,
			function (_v0) {
				var beginDateTime = _v0.ut;
				return _Utils_eq(
					A2($elm$time$Time$toDay, $elm$time$Time$utc, beginDateTime),
					A2($elm$time$Time$toDay, $elm$time$Time$utc, meal.ut));
			},
			oldMeals);
		return ((!isMealSelected) && (!hasMealForSelectedDay)) ? _Utils_Tuple2(
			A2($elm$core$List$cons, meal, oldMeals),
			$elm$core$Platform$Cmd$none) : (((!isMealSelected) && hasMealForSelectedDay) ? _Utils_Tuple2(
			oldMeals,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Messages$ToastMsg,
				A3(
					$author$project$Common$Toast$showToastCmd,
					2,
					function ($) {
						return $.ha;
					},
					false))) : _Utils_Tuple2(
			A2(
				$elm$core$List$filter,
				function (a) {
					return !A2($author$project$Types$SelectedMeals$areSame, a, meal);
				},
				oldMeals),
			$elm$core$Platform$Cmd$none));
	});
var $author$project$Update$Meals$toggleMeal = F2(
	function (selected, meal) {
		var _v0 = $author$project$Types$Meals$getMealType(meal);
		switch (_v0) {
			case 0:
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							selected,
							{vu: a});
					},
					A2($author$project$Update$Meals$toggleSelectedMeal, selected.vu, meal));
			case 1:
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							selected,
							{vx: a});
					},
					A2($author$project$Update$Meals$toggleSelectedMeal, selected.vx, meal));
			case 2:
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							selected,
							{Bz: a});
					},
					A2($author$project$Update$Meals$toggleSelectedMeal, selected.Bz, meal));
			default:
				return A2(
					$elm$core$Tuple$mapFirst,
					function (a) {
						return _Utils_update(
							selected,
							{yw: a});
					},
					A2($author$project$Update$Meals$toggleSelectedMeal, selected.yw, meal));
		}
	});
var $author$project$Update$Meals$toggleMealPackageWithoutMaybes = F3(
	function (_package, meals, model) {
		var session = model.j;
		var toggleMealPackageSelections = A2(
			$elm$core$List$foldl,
			F2(
				function (sitting, acc) {
					return A2($author$project$Update$Meals$toggleMeal, acc, sitting).a;
				}),
			$author$project$Types$SelectedMeals$init);
		var sittings = A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var outwardSittings = _v0.kC;
				var returnSittings = _v0.k4;
				return _Utils_ap(outwardSittings, returnSittings);
			},
			$author$project$Types$Meals$toList(meals));
		var adjustedPackage = $author$project$Types$MealPackage$isTwoPlusOneCode(_package.pQ) ? _Utils_update(
			_package,
			{vA: 1, BA: 1}) : _package;
		var packageSittings = A3(
			$author$project$Types$MealPackage$getSelections,
			{kS: session.kS, le: session.le, tx: session.tx},
			adjustedPackage,
			sittings);
		var selected = _Utils_Tuple2(
			toggleMealPackageSelections(
				A2(
					$elm$core$List$map,
					$author$project$Types$SelectedMeals$toSelectedMeal,
					A2(
						$elm$core$List$filter,
						$author$project$Update$Meals$isOutwardSitting(meals),
						packageSittings))),
			toggleMealPackageSelections(
				A2(
					$elm$core$List$map,
					$author$project$Types$SelectedMeals$toSelectedMeal,
					A2(
						$elm$core$List$filter,
						$author$project$Update$Meals$isReturnSitting(meals),
						packageSittings))));
		var newSession = _Utils_update(
			session,
			{
				B2: $elm$core$Maybe$Just(adjustedPackage.pQ),
				Gn: selected.a,
				Go: selected.b
			});
		return _Utils_update(
			model,
			{j: newSession});
	});
var $author$project$Update$Meals$toggleMealPackageInModel = function (_v0) {
	var code = _v0.pQ;
	var model = _v0.eM;
	var regularMealPackages = _v0.sk;
	return (!_Utils_eq(
		model.j.B2,
		$elm$core$Maybe$Just(code))) ? A2(
		$elm$core$Maybe$withDefault,
		_Utils_update(
			model,
			{
				j: $author$project$Update$Meals$resetSelectedMealsAndPackage(model.j)
			}),
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (_package, meals) {
					return A3($author$project$Update$Meals$toggleMealPackageWithoutMaybes, _package, meals, model);
				}),
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$elm$core$Basics$eq(code)),
				regularMealPackages),
			model.j.ri)) : _Utils_update(
		model,
		{
			j: $author$project$Update$Meals$resetSelectedMealsAndPackage(model.j)
		});
};
var $author$project$Update$Meals$toggleMealPackage = function (params) {
	var model = params.eM;
	var isModalOpen = !_Utils_eq(
		$author$project$UrlRoute$bookingParamsFromLocation(model.n1).CC,
		$elm$core$Maybe$Nothing);
	return isModalOpen ? _Utils_Tuple2(
		$author$project$Update$Meals$toggleMealPackageInModel(params),
		A2($author$project$UrlRoute$closeModal, model.AK, model.n1)) : _Utils_Tuple2(
		$author$project$Update$Meals$toggleMealPackageInModel(params),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Update$Meals$toggleSitting = F2(
	function (_v0, model) {
		var sitting = _v0.sR;
		var direction = _v0.p7;
		var session = model.j;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (a) {
				return _Utils_update(
					model,
					{j: a});
			},
			function () {
				if (!direction) {
					return A2(
						$elm$core$Tuple$mapFirst,
						function (a) {
							return _Utils_update(
								session,
								{Gn: a});
						},
						A2(
							$author$project$Update$Meals$toggleMeal,
							model.j.Gn,
							$author$project$Types$SelectedMeals$toSelectedMeal(sitting)));
				} else {
					return A2(
						$elm$core$Tuple$mapFirst,
						function (a) {
							return _Utils_update(
								session,
								{Go: a});
						},
						A2(
							$author$project$Update$Meals$toggleMeal,
							model.j.Go,
							$author$project$Types$SelectedMeals$toSelectedMeal(sitting)));
				}
			}());
	});
var $author$project$Update$updateWithMealPageExternalMsg = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var code = msg.a;
				var direction = msg.b;
				var sitting = msg.c;
				return _Utils_Tuple2(
					A4($author$project$Update$Meals$addOption, code, direction, sitting, model),
					$elm$core$Platform$Cmd$none);
			case 1:
				var code = msg.a;
				var direction = msg.b;
				var sitting = msg.c;
				return _Utils_Tuple2(
					A4($author$project$Update$Meals$removeOption, code, direction, sitting, model),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					model,
					A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$MealPackage));
			case 3:
				var a = msg.a;
				return A2($author$project$Update$Meals$toggleSitting, a, model);
			default:
				var code = msg.a;
				var _v1 = model.j.rs;
				if (!_v1.$) {
					var mealPackages = _v1.a;
					return $author$project$Update$Meals$toggleMealPackage(
						{pQ: code, eM: model, sk: mealPackages});
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$UrlRoute$withDateParam = F2(
	function (dateString, url) {
		return A2(
			$author$project$UrlRoute$addParam,
			A2($author$project$UrlRoute$removeParam, url, '\\bdate=[^&]*'),
			'date=' + dateString);
	});
var $author$project$Update$update = F2(
	function (msg, model) {
		var session = model.j;
		var translations = $author$project$Translations$forLanguage(session.A_);
		switch (msg.$) {
			case 34:
				var subMsg = msg.a;
				var _v1 = model.DF;
				if (_v1.$ === 10) {
					var pageModel = _v1.a;
					var _v2 = A2($author$project$MealPage$Update$update, pageModel, subMsg);
					var newPageModel = _v2.a;
					var externalMsg = _v2.b;
					var updateMenusInPage = function (newModel) {
						return function (a) {
							return _Utils_update(
								newModel,
								{
									DF: $author$project$Model$MealPage(a)
								});
						}(
							A2($author$project$MealPage$Update$updateMenus, newModel.j, newPageModel));
					};
					return A2(
						$elm$core$Tuple$mapFirst,
						updateMenusInPage,
						A2($author$project$Update$updateWithMealPageExternalMsg, externalMsg, model));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var response = msg.a;
				return A2($author$project$Update$Meals$onMealsResponse, model, response);
			case 4:
				var response = msg.a;
				return A2($author$project$Update$Meals$onMealPackagesResponse, model, response);
			case 70:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									A2($author$project$UrlRoute$replaceUrl, model.AK, model.n1),
									$author$project$UrlRoute$maybeCloseCalendarRouteFromRoute(
										$author$project$UrlRoute$parseLocation(model.n1))))
							])));
			case 67:
				var maybeRouteTripSails = $author$project$Types$Trips$toMaybeSuccessRouteTripSails(session.tp);
				var hasReturnSails = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Types$RouteTripSails$hasReturnSails, maybeRouteTripSails));
				return ((!hasReturnSails) ? $author$project$Update$Util$andThen($author$project$Update$Trips$fetchTrips) : $elm$core$Basics$identity)(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								Av: false,
								j: _Utils_update(
									session,
									{
										qW: false,
										Gz: hasReturnSails ? session.Gz : true
									})
							}),
						$elm$core$Platform$Cmd$batch(
							A3(
								$author$project$Utils$List$addIf,
								hasReturnSails,
								$author$project$Ports$scrollToSelectedSail(0),
								_List_fromArray(
									[
										A3(
										$author$project$UrlRoute$replaceUrl,
										model.AK,
										model.n1,
										$author$project$UrlRoute$changeToReturnTimetableRoute(
											$author$project$UrlRoute$parseLocation(model.n1)))
									])))));
			case 66:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$UrlRoute$replaceUrl,
								model.AK,
								model.n1,
								$author$project$UrlRoute$changeToOutwardTimetableRoute(
									$author$project$UrlRoute$parseLocation(model.n1))),
								$author$project$Ports$scrollToSelectedSail(0)
							])));
			case 68:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Av: false}),
					A3(
						$author$project$UrlRoute$replaceUrl,
						model.AK,
						model.n1,
						$author$project$UrlRoute$changeToReturnTimetableRoute(
							$author$project$UrlRoute$parseLocation(model.n1))));
			case 71:
				var selector = msg.a;
				var alignToTop = msg.b;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$scrollIntoView(
						{t7: alignToTop, Gq: selector}));
			case 72:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$scrollToTop(0));
			case 73:
				var isShown = msg.a;
				var _v3 = model.DF;
				if (_v3.$ === 1) {
					var pageModel = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								DF: $author$project$Model$Timetable(
									_Utils_update(
										pageModel,
										{sQ: isShown}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 74:
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$Trips$fetchTrips,
					_Utils_Tuple2(
						$author$project$Update$Route$resetReturnOnboardServiceSelectionsOnOneWay(
							_Utils_update(
								model,
								{
									j: _Utils_update(
										session,
										{qW: true})
								})),
						$elm$core$Platform$Cmd$batch(
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Update$scrollToTop,
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Messages$ToastMsg,
										$author$project$Common$Toast$hideToastCmd(model.HT.zN))
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											A2($author$project$UrlRoute$replaceUrl, model.AK, model.n1),
											$elm$core$List$singleton),
										$author$project$UrlRoute$maybeCloseCalendarRouteFromRoute(
											$author$project$UrlRoute$parseLocation(model.n1))))))));
			case 55:
				var seqN = msg.a;
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$UrlRoute$pushUrl,
						model.AK,
						model.n1,
						$author$project$UrlRoute$PassengerDetails(seqN)));
			case 23:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$PaymentPageMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (subModel) {
							return _Utils_update(
								model,
								{Ew: subModel});
						},
						A2($author$project$PaymentPage$Update$update, subMsg, model.Ew)));
			case 105:
				var number = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							qL: {
								sj: $elm$core$Maybe$Just(number)
							}
						}),
					$elm$core$Platform$Cmd$none);
			case 44:
				var direction = msg.a;
				return A2($author$project$Update$Itinerary$onDirectionClick, model, direction);
			case 39:
				var direction = msg.a;
				var dateFrom = msg.b;
				var routeTripSails = function () {
					var _v5 = session.tp;
					if ((!_v5.$) && (_v5.a.$ === 1)) {
						var route = _v5.a.a;
						return $elm$core$Maybe$Just(route);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var pageModel = function () {
					var _v4 = model.DF;
					if (_v4.$ === 1) {
						var a = _v4.a;
						return $author$project$Model$Timetable(
							_Utils_update(
								a,
								{
									oP: $elm$core$Maybe$Just(dateFrom)
								}));
					} else {
						return model.DF;
					}
				}();
				var dateTo = A4($justinmimbs$time_extra$Time$Extra$add, 3, $author$project$Api$Timetable$amountOfWeeksToFetch, $elm$time$Time$utc, dateFrom);
				return (model.j.vk === 1) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							DF: pageModel,
							j: _Utils_update(
								session,
								{
									pr: false,
									Ac: true,
									Ad: false,
									Af: true,
									B7: $elm$core$Maybe$Nothing,
									B8: $elm$core$Maybe$Nothing,
									tp: $author$project$Types$Trips$Loading(
										$author$project$Types$Trips$statusToMaybe(session.tp))
								})
						}),
					A8(
						$author$project$Api$Timetable$createHotelPackagesRequest,
						$author$project$UrlRoute$bookingParamsFromLocation(model.n1),
						session,
						(direction === 1) ? A2(
							$elm$core$Maybe$withDefault,
							session.kJ,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
								$author$project$Types$Trips$statusToMaybe(session.tp))) : dateFrom,
						dateTo,
						dateFrom,
						direction,
						A2($elm$core$Maybe$map, $author$project$Types$RouteTripSails$selected, routeTripSails),
						A4($author$project$Utils$Route$isTurStoOvernightTrip, model.n1, session.mm, session.kS, session.le))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							DF: pageModel,
							j: _Utils_update(
								session,
								{
									pr: false,
									Ad: false,
									Af: true,
									B7: $elm$core$Maybe$Nothing,
									B8: $elm$core$Maybe$Nothing,
									tp: $author$project$Types$Trips$Loading(
										$author$project$Types$Trips$statusToMaybe(session.tp))
								})
						}),
					A8(
						$author$project$Api$Timetable$createRouteTripSailsRequest,
						session,
						dateFrom,
						dateTo,
						direction,
						$elm$core$Maybe$Nothing,
						A4($author$project$Utils$Route$isTurStoOvernightTrip, model.n1, session.mm, session.kS, session.le),
						$elm$core$Maybe$Nothing,
						$author$project$Messages$GotTrips(
							$author$project$Update$RequestTimes$create(dateFrom))));
			case 47:
				var date = msg.a;
				return $author$project$Update$updateHotelPackageBookingType(
					_Utils_update(
						model,
						{
							n1: A2(
								$author$project$UrlRoute$withDateParam,
								$author$project$Utils$Time$toDateString(date),
								model.n1),
							j: _Utils_update(
								session,
								{
									tp: $author$project$Types$Trips$Loading(
										$author$project$Types$Trips$statusToMaybe(session.tp))
								})
						}));
			case 133:
				var time = msg.a;
				return A2($author$project$Update$getCruiseMultiDepartureTrips, time, model);
			case 2:
				var requestTimes = msg.a;
				var response = msg.b;
				return A3($author$project$Update$Trips$handleTripsResponse, model, requestTimes, response);
			case 20:
				var result = msg.a;
				return A2($author$project$Update$Trips$handleCruiseMultiDepartureTripsResponse, result, model);
			case 46:
				var stringSailTuple = msg.a;
				var _v6 = session.tp;
				if ((!_v6.$) && (!_v6.a.$)) {
					var cruise = _v6.a.a;
					return A3($author$project$Update$Trips$selectCruiseSail, model, stringSailTuple, cruise);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 40:
				var _v7 = model.DF;
				if (_v7.$ === 1) {
					var timetableModel = _v7.a;
					var _v8 = session.tp;
					if ((!_v8.$) && (_v8.a.$ === 1)) {
						var route = _v8.a.a;
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
							A2(
								$elm$core$Maybe$map,
								function (sail) {
									return A2(
										$author$project$Update$Util$andThen,
										$author$project$Update$Trips$fetchTrips,
										A2(
											$author$project$Update$Util$andThen,
											function (newModel) {
												return A4($author$project$Update$Trips$selectRouteTripSail, newModel, timetableModel.pk, sail, route);
											},
											$author$project$Update$selectRegularBookingType(model)));
								},
								timetableModel.Gp));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 48:
				var direction = msg.a;
				var sail = msg.b;
				var _v9 = session.tp;
				if ((!_v9.$) && (_v9.a.$ === 1)) {
					var route = _v9.a.a;
					return A4($author$project$Update$Trips$selectRouteTripSail, model, direction, sail, route);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 49:
				var direction = msg.a;
				var sail = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									B9: $elm$core$Maybe$Just(
										_Utils_Tuple2(direction, sail))
								})
						}),
					A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$ShoppingCruise));
			case 50:
				var direction = msg.a;
				var sail = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									B1: $elm$core$Maybe$Just(
										_Utils_Tuple2(direction, sail))
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$SuggestTravellingViaDifferentCity),
								$author$project$Ports$trackCombinedSailModalOpened(!direction)
							])));
			case 51:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (_v10) {
							var direction = _v10.a;
							var sail = _v10.b;
							var _v11 = session.tp;
							if ((!_v11.$) && (_v11.a.$ === 1)) {
								var route = _v11.a.a;
								return _Utils_Tuple2(
									A4($author$project$Update$Trips$selectRouteTripInModel, model, direction, sail, route),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Common$Toast$performAfterTimeout, 10, $author$project$Messages$ClosedModal),
												A2(
												$author$project$Common$Toast$performAfterTimeout,
												20,
												$author$project$Messages$ChangedVoyageType(
													$author$project$Types$VoyageType$CruiseMultiDeparture(1)))
											])));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						},
						session.B9));
			case 52:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{B9: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Common$Toast$performImmediately($author$project$Messages$ClosedModal),
								$author$project$Ports$scrollToSelectedSail(0)
							])));
			case 134:
				var id = msg.a;
				return A2($author$project$Update$Trips$selectCruiseMultiDepartureTrip, id, model);
			case 42:
				var dateFrom = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{Ad: true})
						}),
					A2($author$project$Api$Timetable$getCruiseSailFromDate, model, dateFrom));
			case 43:
				var cruiseTripType = msg.a;
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$Trips$fetchTrips,
					function (a) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{j: a}),
							$elm$core$Platform$Cmd$none);
					}(
						_Utils_update(
							session,
							{mm: cruiseTripType, B0: $elm$core$Maybe$Nothing})));
			case 41:
				var query = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							HZ: {y1: query}
						}),
					$elm$core$Platform$Cmd$none);
			case 30:
				var subMsg = msg.a;
				var _v12 = model.DF;
				if (_v12.$ === 1) {
					var pageModel = _v12.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Messages$TimetableHeaderMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (a) {
								return _Utils_update(
									model,
									{
										DF: $author$project$Model$Timetable(a)
									});
							},
							A2(
								$elm$core$Tuple$mapFirst,
								function (a) {
									return _Utils_update(
										pageModel,
										{GA: a});
								},
								A2($author$project$TimetablePage$Header$Update$update, subMsg, pageModel.GA))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 31:
				var subMsg = msg.a;
				var _v13 = model.DF;
				if (_v13.$ === 1) {
					var pageModel = _v13.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Messages$TimetableMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (a) {
								return _Utils_update(
									model,
									{
										DF: $author$project$Model$Timetable(a)
									});
							},
							A2($author$project$TimetablePage$Update$update, subMsg, pageModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 45:
				var date = msg.a;
				var _v14 = model.DF;
				if (_v14.$ === 1) {
					var pageModel = _v14.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								DF: $author$project$Model$Timetable(
									_Utils_update(
										pageModel,
										{qb: date}))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 69:
				return A2(
					$elm$core$Tuple$pair,
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							A2($author$project$UrlRoute$replaceUrl, model.AK, model.n1),
							function () {
								var _v15 = $author$project$UrlRoute$parseLocation(model.n1);
								_v15$5:
								while (true) {
									if (_v15.$ === 1) {
										switch (_v15.a.$) {
											case 3:
												switch (_v15.a.a) {
													case 0:
														var _v16 = _v15.a.a;
														return $elm$core$Maybe$Just(
															$author$project$UrlRoute$Timetable(
																$author$project$UrlRoute$Shuttle(1)));
													case 2:
														var _v18 = _v15.a.a;
														return $elm$core$Maybe$Just(
															$author$project$UrlRoute$Timetable(
																$author$project$UrlRoute$Shuttle(3)));
													default:
														break _v15$5;
												}
											case 4:
												switch (_v15.a.a) {
													case 0:
														var _v17 = _v15.a.a;
														return $elm$core$Maybe$Just(
															$author$project$UrlRoute$Timetable(
																$author$project$UrlRoute$RouteTrip(1)));
													case 2:
														var _v19 = _v15.a.a;
														return $elm$core$Maybe$Just(
															$author$project$UrlRoute$Timetable(
																$author$project$UrlRoute$RouteTrip(3)));
													default:
														break _v15$5;
												}
											case 1:
												var _v20 = _v15.a;
												return $elm$core$Maybe$Just(
													$author$project$UrlRoute$Timetable($author$project$UrlRoute$CruiseMultiDepartureCalendar));
											default:
												break _v15$5;
										}
									} else {
										break _v15$5;
									}
								}
								return $elm$core$Maybe$Nothing;
							}())));
			case 15:
				var reservationResponse = msg.a;
				switch (reservationResponse.$) {
					case 3:
						var reservationData = reservationResponse.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									j: _Utils_update(
										session,
										{
											Ao: true,
											Fz: $elm$core$Maybe$Just(reservationData)
										})
								}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var error = reservationResponse.a;
						return _Utils_Tuple2(
							model,
							A2($author$project$Tracking$logHttpError, 'reservationDataResponse', error));
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var paymentMethodsResponse = msg.a;
				if (!paymentMethodsResponse.$) {
					var paymentMethods = paymentMethodsResponse.a;
					var paymentPageModel = model.Ew;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Ev: $elm$core$Maybe$Just(paymentMethods),
								Ew: _Utils_update(
									paymentPageModel,
									{
										ro: A2($author$project$PaymentPage$Model$findSelectedPaymentMethod, session.rb, paymentMethods)
									})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var httpError = paymentMethodsResponse.a;
					return A4($author$project$Update$Util$mapFailedResponse, model, httpError, 'paymentMethodsResponse', $elm$core$Platform$Cmd$none);
				}
			case 24:
				var subMsg = msg.a;
				return A2($author$project$Update$BusTransfers$update, model, subMsg);
			case 107:
				var resToken = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{z5: true, Ao: false})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Api$Guid$createGuid,
								$author$project$Messages$ReceivedNewSessionGuid,
								session.zM.Gs,
								{Aa: session.Aa, A_: session.A_, rb: session.rb}),
								A3(
								$author$project$UrlRoute$redirectToPaymentMethodPage,
								model.AK,
								model.n1,
								{
									mS: $elm$core$Maybe$Just(resToken)
								})
							])));
			case 65:
				var route = msg.a;
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$UrlRoute$replaceUrl,
						model.AK,
						$author$project$UrlRoute$removeModalParam(model.n1),
						route));
			case 58:
				var route = msg.a;
				var _v23 = model;
				var vehiclePage = _v23.Ih;
				return _Utils_eq(
					$author$project$UrlRoute$parseLocation(model.n1),
					$author$project$UrlRoute$Vehicle) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Ih: _Utils_update(
								vehiclePage,
								{ty: false})
						}),
					A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, route)) : _Utils_Tuple2(
					model,
					A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, route));
			case 59:
				return A2(
					$author$project$Update$Util$andThen,
					function (a) {
						return _Utils_Tuple2(
							a,
							$author$project$Common$Toast$performImmediately(
								$author$project$Messages$ChangedLocation($author$project$UrlRoute$Vehicle)));
					},
					$author$project$Update$requestVehiclesIfNeeded(model));
			case 60:
				var shouldShowAddVehicleForOtherLegModal = $author$project$Utils$Route$isVehicleRequiredForOnlyOneLeg(session) && (_Utils_eq(session.tL, $elm$core$Maybe$Nothing) && (!_Utils_eq(
					$author$project$Types$SelectedVehicles$getVehicleVoyageTypeFromList(session.yq),
					$elm$core$Maybe$Just(0))));
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$Root),
								shouldShowAddVehicleForOtherLegModal ? A2(
								$elm$core$Task$perform,
								function (_v24) {
									return $author$project$Messages$OpenedSuggestAddingVehicleToOtherLegModal;
								},
								$elm$core$Process$sleep(0)) : $elm$core$Platform$Cmd$none
							])));
			case 61:
				return _Utils_Tuple2(
					model,
					A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$SuggestAddingVehicleToOtherLeg));
			case 62:
				var answer = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									tL: $elm$core$Maybe$Just(answer)
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Common$Toast$performImmediately($author$project$Messages$ClosedModal),
								answer ? $author$project$Common$Toast$performImmediately(
								A2(
									$author$project$Messages$ChangedVehicleVoyageType,
									0,
									$elm$core$Maybe$Just(0))) : $elm$core$Platform$Cmd$none
							])));
			case 63:
				var _v25 = session;
				var from = _v25.kS;
				var to = _v25.le;
				var maybeSelectedFakeRouteTripSail = _v25.B1;
				var newVoyage = function (direction) {
					var _v28 = _Utils_Tuple3(from, to, direction);
					_v28$4:
					while (true) {
						if (!_v28.c) {
							switch (_v28.a) {
								case 0:
									if (_v28.b === 1) {
										var _v29 = _v28.a;
										var _v30 = _v28.b;
										var _v31 = _v28.c;
										return $elm$core$Maybe$Just(
											_Utils_Tuple3(0, 2, $author$project$Types$VoyageType$Shuttle));
									} else {
										break _v28$4;
									}
								case 1:
									if (!_v28.b) {
										var _v35 = _v28.a;
										var _v36 = _v28.b;
										var _v37 = _v28.c;
										return $elm$core$Maybe$Just(
											_Utils_Tuple3(1, 2, $author$project$Types$VoyageType$RouteTrip));
									} else {
										break _v28$4;
									}
								default:
									break _v28$4;
							}
						} else {
							switch (_v28.a) {
								case 0:
									if (_v28.b === 1) {
										var _v32 = _v28.a;
										var _v33 = _v28.b;
										var _v34 = _v28.c;
										return $elm$core$Maybe$Just(
											_Utils_Tuple3(1, 2, $author$project$Types$VoyageType$RouteTrip));
									} else {
										break _v28$4;
									}
								case 1:
									if (!_v28.b) {
										var _v38 = _v28.a;
										var _v39 = _v28.b;
										var _v40 = _v28.c;
										return $elm$core$Maybe$Just(
											_Utils_Tuple3(0, 2, $author$project$Types$VoyageType$Shuttle));
									} else {
										break _v28$4;
									}
								default:
									break _v28$4;
							}
						}
					}
					return $elm$core$Maybe$Nothing;
				};
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$andThen,
							function (_v26) {
								var direction = _v26.a;
								var fakeRouteTripSail = _v26.b;
								return A2(
									$elm$core$Maybe$map,
									function (_v27) {
										var newFrom = _v27.a;
										var newTo = _v27.b;
										var newVoyageType = _v27.c;
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													$author$project$Ports$trackCombinedSailStartBooking(
													{
														kS: $author$project$Types$Port$toString(newFrom),
														le: $author$project$Types$Port$toString(newTo)
													}),
													$author$project$Common$Toast$performImmediately($author$project$Messages$ClosedModalAndBack),
													A2(
													$author$project$Common$Toast$performAfterTimeout,
													10,
													$author$project$Messages$ChangedVoyage(
														{kS: newFrom, Cd: $elm$core$Maybe$Nothing, le: newTo})),
													A2(
													$author$project$Common$Toast$performAfterTimeout,
													20,
													$author$project$Messages$ChangedVoyageType(newVoyageType)),
													A2(
													$author$project$Common$Toast$performAfterTimeout,
													50,
													A2($author$project$Messages$SelectedCalendarDay, 0, fakeRouteTripSail.nr))
												]));
									},
									newVoyage(direction));
							},
							maybeSelectedFakeRouteTripSail)));
			case 64:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$trackThanksForTheInfoClick(0),
								$author$project$Common$Toast$performImmediately($author$project$Messages$ClosedModalAndBack)
							])));
			case 93:
				return _Utils_Tuple2(
					model,
					model.j.Am ? $elm$core$Platform$Cmd$none : $author$project$UrlRoute$back(model.AK));
			case 57:
				var url = msg.a;
				return _Utils_eq(url, model.n1) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : function (_v41) {
					var newModel = _v41.a;
					var cmd = _v41.b;
					return A2($author$project$Update$isTransitionFromResetBookingModalWithRouteChange, model.n1, newModel.n1) ? _Utils_Tuple2(
						model,
						A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$ResetBooking)) : (A2($author$project$Update$isTransitionFromModal, model.n1, newModel.n1) ? A2(
						$elm$core$Tuple$mapSecond,
						function (closeCmd) {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[cmd, closeCmd]));
						},
						$author$project$Update$Modal$close(newModel)) : ((!_Utils_eq(
						$author$project$Update$getModalTypeFromUrl(newModel.n1),
						$elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
						newModel,
						A2(
							$elm$core$Maybe$withDefault,
							cmd,
							A2(
								$elm$core$Maybe$map,
								function (modal) {
									return $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												cmd,
												$author$project$Update$Modal$opened(modal)
											]));
								},
								$author$project$Update$getModalTypeFromUrl(newModel.n1)))) : (newModel.j.Am ? _Utils_Tuple2(
						model,
						A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$ResetBooking)) : _Utils_Tuple2(newModel, cmd))));
				}(
					A2($author$project$Update$changeLocationTo, url, model));
			case 25:
				var subMsg = msg.a;
				var _v42 = model.DF;
				if (_v42.$ === 11) {
					var pageModel = _v42.a;
					return A3($author$project$Update$updateContactPersonPage, subMsg, pageModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 130:
				var _v43 = model.DF;
				if (_v43.$ === 11) {
					var pageModel = _v43.a;
					return A2($author$project$Update$JoinClubOne$turnOn, pageModel, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 131:
				return _Utils_Tuple2(
					$author$project$Update$JoinClubOne$turnOff(model),
					$elm$core$Platform$Cmd$none);
			case 14:
				var response = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Update$onJoinClubOneResponse, response, model),
					$elm$core$Platform$Cmd$none);
			case 111:
				var _v44 = session.tp;
				if ((!_v44.$) && (_v44.a.$ === 1)) {
					var route = _v44.a.a;
					var outwardSelected = $author$project$Types$RouteTripSails$selected(route).a;
					var availableSails = A2(
						$elm$core$List$filter,
						function (sail) {
							return A2($author$project$Utils$Time$differenceInDays, outwardSelected.nr, sail.nr) >= 0;
						},
						A2(
							$elm$core$List$filterMap,
							$author$project$Types$RouteTripSail$toReal,
							A2($author$project$Types$RouteTripSails$available, 1, route).a));
					var maybeNewSail = outwardSelected.qY ? $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (sail) {
								return _Utils_cmp(
									$elm$time$Time$posixToMillis(sail.nr),
									$elm$time$Time$posixToMillis(outwardSelected.nr)) > 0;
							},
							availableSails)) : A2(
						$elm_community$list_extra$List$Extra$find,
						function ($) {
							return $.qY;
						},
						availableSails);
					if (!maybeNewSail.$) {
						var newSail = maybeNewSail.a;
						return A4($author$project$Update$Trips$selectRouteTripSail, model, 0, newSail, route);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 56:
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$addRequestsForDataAffectedByVehicleModification,
					A2(
						$author$project$Update$Util$andThen,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Update$Vehicles$toggleVehicles,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Update$toggleVehiclesOnTimetablePage,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$mapFirst($author$project$BookingPage$Update$toggleVehicle),
									$author$project$Utils$Route$isCruiseLikeVoyageType(session.tx) ? $elm$core$Basics$identity : $author$project$Update$Util$andThen($author$project$Update$Trips$fetchTrips)))),
						$author$project$Update$requestVehiclesIfNeeded(model)));
			case 81:
				var index = msg.a;
				return function (pair) {
					var newModel = pair.a;
					var cmds = pair.b;
					return (!$author$project$Session$isEveryPassengerWithVehicleSeat(newModel.j)) ? _Utils_Tuple2(
						newModel,
						$author$project$Utils$Route$isMugVssRoute(session.kS) ? $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmds,
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Messages$ToastMsg,
									A3(
										$author$project$Common$Toast$showToastCmd,
										1,
										function ($) {
											return $.aZ;
										},
										true))
								])) : cmds) : (A2($author$project$Update$haveSelectedVehiclesChanged, model, newModel) ? A2($author$project$Update$Util$andThen, $author$project$Update$addRequestsForDataAffectedByVehicleModification, pair) : pair);
				}(
					A2($author$project$Update$Vehicles$removeSelectedVehicle, model, index));
			case 82:
				var index = msg.a;
				return function (vehiclePage) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Ih: _Utils_update(
									vehiclePage,
									{
										n7: $elm$core$Maybe$Just(
											_Utils_Tuple2(index, 1))
									})
							}),
						A2(
							$elm$core$Task$perform,
							function (_v46) {
								return $author$project$Messages$RemovedSelectedVehicle(index);
							},
							$elm$core$Process$sleep(500)));
				}(model.Ih);
			case 83:
				return function (vehiclePage) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								Ih: _Utils_update(
									vehiclePage,
									{n7: $elm$core$Maybe$Nothing})
							}),
						$elm$core$Platform$Cmd$none);
				}(model.Ih);
			case 84:
				var index = msg.a;
				var voyageType = msg.b;
				return function (newModel) {
					return (!$author$project$Session$isEveryPassengerWithVehicleSeat(newModel.j)) ? _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none) : (A2($author$project$Update$haveSelectedVehiclesChanged, model, newModel) ? $author$project$Update$addRequestsForDataAffectedByVehicleModification(newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none));
				}(
					A3($author$project$Update$Vehicles$changeVehicleVoyageType, model, index, voyageType));
			case 85:
				var index = msg.a;
				var licensePlateType = msg.b;
				var licensePlateString = msg.c;
				return _Utils_Tuple2(
					A4($author$project$Update$Vehicles$changeLicensePlate, model, index, licensePlateType, licensePlateString),
					$elm$core$Platform$Cmd$none);
			case 86:
				return _Utils_Tuple2(
					function (a) {
						return _Utils_update(
							model,
							{Ih: a});
					}(
						function (a) {
							return _Utils_update(
								a,
								{BV: $elm$core$Maybe$Nothing});
						}(model.Ih)),
					$author$project$Ports$removeFirstVehicleFromLocalStorage(0));
			case 87:
				var callback = msg.a;
				var vehicleSelected = !_Utils_eq(session.rp, $elm$core$Maybe$Nothing);
				var vehicleIncompatibleOnboardServiceSelected = !_Utils_eq(
					A2($author$project$Types$SelectedOnboardServices$getMaybeFirstSelectedVehicleIncompatibleOnboardService, session.rI.Ig, session.Gm),
					$elm$core$Maybe$Nothing);
				return (vehicleIncompatibleOnboardServiceSelected && (!vehicleSelected)) ? (session.If.GG ? _Utils_Tuple2(
					$author$project$Update$resetSelectedVehicleIncompatibleOnboardServices(model),
					$author$project$Update$performSelectVehicleCallback(callback)) : _Utils_Tuple2(
					A2(
						$author$project$Update$setVehicleImpcompatible,
						{
							BO: $elm$core$Maybe$Just(callback),
							GG: true
						},
						model),
					A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$SelectVehicle))) : _Utils_Tuple2(
					model,
					$author$project$Update$performSelectVehicleCallback(callback));
			case 88:
				return _Utils_Tuple2(
					$author$project$Update$resetSelectedVehicleIncompatibleOnboardServices(model),
					$elm$core$Platform$Cmd$batch(
						A3(
							$author$project$Utils$List$maybeAddWithMap,
							session.If.BO,
							$author$project$Update$performSelectVehicleCallback,
							_List_fromArray(
								[
									A2($author$project$UrlRoute$closeModal, model.AK, model.n1)
								]))));
			case 89:
				return _Utils_Tuple2(
					model,
					A2($author$project$UrlRoute$closeModal, model.AK, model.n1));
			case 90:
				var vehicle = msg.a;
				return function (_v47) {
					var newModel = _v47.a;
					var vehiclePage = newModel.Ih;
					var cmds = _v47.b;
					return A2($author$project$Update$haveSelectedVehiclesChanged, model, newModel) ? A2(
						$author$project$Update$Util$andThen,
						$author$project$Update$addRequestsForDataAffectedByVehicleModification,
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(newModel, cmds),
							A2(
								$elm$core$Maybe$map,
								function (length) {
									return _Utils_Tuple2(
										_Utils_update(
											newModel,
											{
												Ih: _Utils_update(
													vehiclePage,
													{
														n7: $elm$core$Maybe$Just(
															_Utils_Tuple2(length, 0))
													})
											}),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													cmds,
													A2(
													$elm$core$Task$perform,
													function (_v48) {
														return $author$project$Messages$RemovedVehicleAnimation;
													},
													$elm$core$Process$sleep(500))
												])));
								},
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Types$SelectedVehicles$toList,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$length,
											$elm$core$Basics$add(-1))),
									newModel.j.rp)))) : _Utils_Tuple2(newModel, cmds);
				}(
					A2($author$project$Update$Vehicles$selectVehicle, model, vehicle));
			case 91:
				var selectedVehicle = msg.a;
				return function (_v49) {
					var newModel = _v49.a;
					var cmd = _v49.b;
					return A2($author$project$Update$haveSelectedVehiclesChanged, model, newModel) ? A2(
						$author$project$Update$Util$andThen,
						$author$project$Update$addRequestsForDataAffectedByVehicleModification,
						_Utils_Tuple2(newModel, cmd)) : _Utils_Tuple2(newModel, cmd);
				}(
					A2($author$project$Update$Vehicles$selectMemorizedVehicle, model, selectedVehicle));
			case 5:
				var response = msg.a;
				return A2(
					$author$project$Update$Util$andThen,
					function (newModel) {
						return (!_Utils_eq(newModel.j.rp, model.j.rp)) ? $author$project$Update$addRequestsForDataAffectedByVehicleModification(newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					},
					A2($author$project$Update$Vehicles$onVehiclesResponse, model, response));
			case 92:
				var width = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Ih: function (a) {
								return _Utils_update(
									a,
									{uz: width});
							}(model.Ih)
						}),
					$elm$core$Platform$Cmd$none);
			case 75:
				var passengersWithAdultAndYouthOnly = A2(
					$elm$core$Array$filter,
					function (passenger) {
						return A2(
							$elm$core$List$member,
							passenger.tY,
							_List_fromArray(
								[0, 1]));
					},
					session.Eg);
				var hasYouth = A2(
					$elm$core$List$any,
					function (passenger) {
						return passenger.tY === 1;
					},
					$elm$core$Array$toList(passengersWithAdultAndYouthOnly));
				var adultIndex = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm_community$list_extra$List$Extra$findIndex,
						function (passenger) {
							return !passenger.tY;
						},
						$elm$core$Array$toList(passengersWithAdultAndYouthOnly)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{Eg: passengersWithAdultAndYouthOnly})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$Common$Toast$performAfterTimeout,
								0,
								A2($author$project$Messages$RemovedPassenger, adultIndex, true)),
								hasYouth ? $elm$core$Platform$Cmd$none : A2(
								$author$project$Common$Toast$performAfterTimeout,
								1,
								$author$project$Messages$AddedPassenger(1))
							])));
			case 76:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$Common$Toast$performAfterTimeout,
								0,
								A2($author$project$Messages$RemovedPassenger, 0, false)),
								A2(
								$author$project$Common$Toast$performAfterTimeout,
								1,
								$author$project$Messages$AddedPassenger(0))
							])));
			case 77:
				var ageCategory = msg.a;
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$addOnboardServicesRequest,
					A2(
						$author$project$Update$cancelServicesRequestIfAgeCategoriesChangedOnStoHelRoute,
						model,
						A2($author$project$Update$Passengers$addPassenger, model, ageCategory)));
			case 78:
				var affiliate = msg.a;
				var clubOneInfo = msg.b;
				var ageCategory = msg.c;
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$addOnboardServicesRequest,
					A2(
						$author$project$Update$cancelServicesRequestIfAgeCategoriesChangedOnStoHelRoute,
						model,
						A4($author$project$Update$Passengers$addAffiliatePassenger, model, affiliate, clubOneInfo, ageCategory)));
			case 79:
				return $author$project$Update$Passengers$removeAnimations(model);
			case 80:
				var index = msg.a;
				var isWithAnimation = msg.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					function (newModel) {
						return (_Utils_cmp(
							$elm$core$Array$length(session.Eg),
							$elm$core$Array$length(newModel.j.Eg)) > 0) ? $author$project$Update$Meals$resetMenuOptions(newModel) : newModel;
					},
					A2(
						$author$project$Update$Util$andThen,
						$author$project$Update$addOnboardServicesRequest,
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClassFromModel,
							$author$project$Update$limitFriendshipBraceletsCount(
								A2(
									$author$project$Update$cancelServicesRequestIfAgeCategoriesChangedOnStoHelRoute,
									model,
									A3($author$project$Update$Passengers$removePassenger, model, index, isWithAnimation))))));
			case 53:
				var voyageType = msg.a;
				return A2($author$project$Update$updateVoyageType, voyageType, model);
			case 54:
				var bookingType = msg.a;
				return A2($author$project$Update$updateBookingType, bookingType, model);
			case 29:
				var subMsg = msg.a;
				var _v50 = model.DF;
				if (_v50.$ === 13) {
					var pageModel = _v50.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (a) {
							return _Utils_update(
								model,
								{
									DF: $author$project$Model$CompanyCustomer(a)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Messages$CompanyCustomerMsg),
						A5($author$project$Page$Company$update, model.AK, model.n1, session, subMsg, pageModel));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 97:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$batch,
					A2(
						$author$project$Update$User$clientResponse,
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{xA: $elm$core$Maybe$Nothing})
							}),
						session.Ia.v4));
			case 94:
				return $author$project$Update$User$signOut(model);
			case 95:
				return _Utils_Tuple2(
					$author$project$Update$User$onSignOut(model),
					$elm$core$Platform$Cmd$none);
			case 96:
				return $author$project$Update$User$goToSignInPage(model);
			case 9:
				var clientWebData = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$batch,
					A2($author$project$Update$User$clientResponse, model, clientWebData));
			case 8:
				var response = msg.a;
				return A2(
					$author$project$Update$Util$andThen,
					function (newModel) {
						var travelClassesChanged = A2(
							$elm$core$Maybe$withDefault,
							true,
							A3($elm$core$Maybe$map2, $author$project$Types$TravelClasses$wasAnyPreviouslySelectedTravelClassRemoved, model.j.to, newModel.j.to));
						return travelClassesChanged ? $author$project$Update$addOnboardServicesRequest(newModel) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					},
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClassFromModel,
						A2($author$project$Update$TravelClass$onTravelClassResponse, model, response)));
			case 99:
				var selectedCode = msg.a;
				var direction = msg.b;
				var _v51 = session.to;
				if (!_v51.$) {
					var travelClasses = _v51.a;
					var updatedTravelClasses = A3($author$project$Types$TravelClasses$setSelection, travelClasses, selectedCode, direction);
					return A2(
						$author$project$Update$Util$andThen,
						$author$project$Update$addOnboardServicesRequest,
						function (_v52) {
							var newModel = _v52.a;
							var cmd = _v52.b;
							return A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(newModel, cmd),
								A2(
									$elm$core$Maybe$map,
									function (newAndOldTravelClasses) {
										return A2(
											$elm$core$Tuple$mapSecond,
											function (a) {
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2($elm$core$Platform$Cmd$map, $author$project$Messages$TravelClassPageMsg, a),
															cmd
														]));
											},
											A2(
												$elm$core$Tuple$mapFirst,
												function (a) {
													return _Utils_update(
														newModel,
														{H0: a});
												},
												A3(
													$author$project$TravelClassPage$Update$addCabinSurpriseAnimations,
													newAndOldTravelClasses,
													A2($author$project$Types$CabinSurprise$getCabinSurprisesAvailabilityFlags, session, selectedCode),
													newModel.H0)));
									},
									A3(
										$elm$core$Maybe$map2,
										F2(
											function (old, _new) {
												return {CG: _new, C4: old};
											}),
										model.j.to,
										newModel.j.to)));
						}(
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										j: _Utils_update(
											session,
											{
												to: $elm$core$Maybe$Just(updatedTravelClasses)
											})
									}),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A3($author$project$Update$maybeShowLastTravelClassWasAddedToast, selectedCode, direction, updatedTravelClasses)))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 100:
				var selectedCode = msg.a;
				var direction = msg.b;
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$addOnboardServicesRequest,
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClassFromModel,
						A2(
							$elm$core$Tuple$mapFirst,
							function (newModel) {
								var travelClassPage = newModel.H0;
								return function (pageModel) {
									return _Utils_update(
										newModel,
										{H0: pageModel});
								}(
									A2($author$project$TravelClassPage$Update$resetCabinSurpriseIndicator, selectedCode, travelClassPage));
							},
							function (newModel) {
								return A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none),
									A2(
										$elm$core$Maybe$map,
										function (newAndOldTravelClasses) {
											return A2(
												$elm$core$Tuple$mapSecond,
												function (a) {
													return $elm$core$Platform$Cmd$batch(
														_List_fromArray(
															[
																A2($elm$core$Platform$Cmd$map, $author$project$Messages$TravelClassPageMsg, a),
																$elm$core$Platform$Cmd$none
															]));
												},
												A2(
													$elm$core$Tuple$mapFirst,
													function (a) {
														return _Utils_update(
															newModel,
															{H0: a});
													},
													A3(
														$author$project$TravelClassPage$Update$addCabinSurpriseAnimations,
														newAndOldTravelClasses,
														A2($author$project$Types$CabinSurprise$getCabinSurprisesAvailabilityFlags, session, selectedCode),
														newModel.H0)));
										},
										A3(
											$elm$core$Maybe$map2,
											F2(
												function (old, _new) {
													return {CG: _new, C4: old};
												}),
											model.j.to,
											newModel.j.to)));
							}(
								A2(
									$author$project$Update$updateTravelClasses,
									model,
									A2($author$project$Types$TravelClasses$removeSelection, selectedCode, direction))))));
			case 101:
				var code = msg.a;
				var direction = msg.b;
				return _Utils_Tuple2(
					A2(
						$author$project$Update$updateTravelClasses,
						model,
						A2($author$project$Types$TravelClasses$addPetTravelClass, code, direction)),
					$elm$core$Platform$Cmd$none);
			case 103:
				var code = msg.a;
				var direction = msg.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClassFromModel,
					_Utils_Tuple2(
						A2(
							$author$project$Update$updateTravelClasses,
							model,
							A2($author$project$Types$TravelClasses$removePetTravelClass, code, direction)),
						$elm$core$Platform$Cmd$none));
			case 102:
				var code = msg.a;
				var direction = msg.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Update$removeSelectedSurprisesWithoutMatchingTravelClassFromModel,
					_Utils_Tuple2(
						A2(
							$author$project$Update$updateTravelClasses,
							model,
							A2($author$project$Types$TravelClasses$removeAllPetTravelClasses, code, direction)),
						$elm$core$Platform$Cmd$none));
			case 98:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Messages$ToastMsg,
						A3(
							$author$project$Common$Toast$showToastCmd,
							1,
							function ($) {
								return $.hq;
							},
							false)));
			case 26:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Messages$TravelClassPageMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (subModel) {
							return _Utils_update(
								model,
								{H0: subModel});
						},
						A2($author$project$TravelClassPage$Update$update, subMsg, model.H0)));
			case 28:
				var subMsg = msg.a;
				var _v53 = _Utils_Tuple2(model.DF, subMsg);
				if (_v53.a.$ === 16) {
					var subModel = _v53.a.a;
					return A2(
						$author$project$Update$Util$andThen,
						function (newModel) {
							switch (subMsg.$) {
								case 2:
									return _Utils_Tuple2(
										newModel,
										A2(
											$author$project$Api$Timetable$fetch,
											$author$project$Update$RequestTimes$create(session.kJ),
											newModel));
								case 5:
									var data = subMsg.a;
									if (data.$ === 3) {
										return _Utils_Tuple2(
											newModel,
											A2(
												$author$project$Api$Timetable$fetch,
												$author$project$Update$RequestTimes$create(session.kJ),
												newModel));
									} else {
										return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
									}
								default:
									return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
							}
						},
						A3(
							$elm$core$Tuple$mapBoth,
							function (a) {
								return _Utils_update(
									model,
									{
										DF: $author$project$Model$DiscountPage(a.eM),
										j: a.j
									});
							},
							$elm$core$Platform$Cmd$map($author$project$Messages$DiscountMsg),
							A3(
								$author$project$Page$Discount$Update$update,
								model.AK,
								subMsg,
								{eM: subModel, j: session})));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 16:
				var data = msg.a;
				return A2($author$project$Update$handleVoucherValidationResponse, model, data);
			case 116:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (summary) {
							var warnings = $author$project$Types$Summary$keepUniqueCriticalErrors(summary.Iy);
							return $elm$core$List$isEmpty(warnings) ? (A2(
								$elm$core$List$any,
								function ($) {
									return $.Ak;
								},
								model.j.tw) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										j: function (a) {
											return _Utils_update(
												a,
												{GH: true});
										}(model.j)
									}),
								A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$NonRefundableWarning)) : ((model.j.G4 && ((!model.j.GF) && (!model.j.GH))) ? _Utils_Tuple2(
								_Utils_update(
									model,
									{
										j: function (a) {
											return _Utils_update(
												a,
												{GF: true});
										}(model.j)
									}),
								A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$SuggestBuyingMeals)) : _Utils_Tuple2(
								model,
								A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$ContactPerson)))) : _Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									A2(
										$elm$core$List$cons,
										A3($author$project$UrlRoute$openModal, model.AK, model.n1, $author$project$Common$Modal$Model$SummaryWarning),
										A2($elm$core$List$map, $author$project$Tracking$logSummaryWarnings, warnings))));
						},
						model.j.B7));
			case 117:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									tw: A2(
										$elm$core$List$filter,
										A2(
											$elm$core$Basics$composeL,
											$elm$core$Basics$not,
											function ($) {
												return $.Ak;
											}),
										session.tw)
								})
						}),
					A2($author$project$UrlRoute$closeModal, model.AK, model.n1));
			case 115:
				var body = msg.a;
				return _Utils_eq(
					model.j.B8,
					$elm$core$Maybe$Just(body)) ? _Utils_Tuple2(
					model,
					A3($author$project$Api$Summary$postSummary, body, session, model.j.zM)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var response = msg.a;
				return A2(
					$author$project$Update$Util$andThen,
					$author$project$Update$addSpecialTravelClassesRequestAfterSummary(response),
					A2(
						$author$project$Update$Util$andThen,
						$author$project$Update$addExtraServicesRequest,
						A2(
							$author$project$Update$Util$andThen,
							$author$project$Update$addCabinSurprisesRequest,
							function (_v56) {
								var newModel = _v56.a;
								var cmd = _v56.b;
								return _Utils_Tuple2(
									newModel,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												cmd,
												$author$project$Price$View$isMinCabinPriceUnavailable(newModel.j) ? A2($author$project$Tracking$logUIMessage, 'priceBar', translations.Fe) : ($author$project$Price$View$showAddMoreTravelClassesNotice(newModel) ? A2($author$project$Tracking$logUIMessage, 'priceBar', translations.Fd) : $elm$core$Platform$Cmd$none)
											])));
							}(
								A2($author$project$Update$Summary$onSummaryResponse, model, response)))));
			case 119:
				var modalType = msg.a;
				return _Utils_Tuple2(
					model,
					A3($author$project$UrlRoute$openModal, model.AK, model.n1, modalType));
			case 120:
				return _Utils_Tuple2(
					model,
					A2($author$project$UrlRoute$closeModal, model.AK, model.n1));
			case 121:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$UrlRoute$closeModal, model.AK, model.n1),
								$author$project$UrlRoute$back(model.AK)
							])));
			case 122:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{CC: $author$project$Common$Modal$Model$Closed}),
					$elm$core$Platform$Cmd$none);
			case 123:
				var modalType = msg.a;
				var position = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							CC: A2($author$project$Common$Modal$Model$Opened, modalType, position)
						}),
					$elm$core$Platform$Cmd$none);
			case 132:
				var voucherCode = msg.a;
				var pageModel = _Utils_eq(
					model.pz.Ix,
					$elm$core$Maybe$Just(voucherCode)) ? function (a) {
					return _Utils_update(
						a,
						{Ix: $elm$core$Maybe$Nothing});
				}(model.pz) : function (a) {
					return _Utils_update(
						a,
						{
							Ix: $elm$core$Maybe$Just(voucherCode)
						});
				}(model.pz);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pz: pageModel}),
					$elm$core$Platform$Cmd$none);
			case 38:
				var pageMsg = msg.a;
				var _v57 = model.DF;
				if (_v57.$ === 7) {
					var pageModel = _v57.a;
					return A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (outwardSailDate) {
								return function (_v58) {
									var newPageModel = _v58.a;
									var cmd = _v58.b;
									var _v59 = A3($author$project$PassengerDetailsPage$Update$getLastErrors, translations, newPageModel, pageModel);
									var validationError = _v59.a;
									var httpError = _v59.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												DF: $author$project$Model$PassengerDetailsPage(newPageModel)
											}),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													cmd,
													A2(
													$elm$core$Maybe$withDefault,
													$elm$core$Platform$Cmd$none,
													A2(
														$elm$core$Maybe$map,
														$author$project$Tracking$logHttpError('clubOneUserResponse'),
														httpError)),
													A2(
													$elm$core$Maybe$withDefault,
													$elm$core$Platform$Cmd$none,
													A2(
														$elm$core$Maybe$map,
														$author$project$Tracking$logUIMessage('passengerDetailsPage'),
														validationError))
												])));
								}(
									A5($author$project$PassengerDetailsPage$Update$update, outwardSailDate, session, model.j.zM, pageMsg, pageModel));
							},
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
								$author$project$Types$Trips$statusToMaybe(model.j.tp))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 11:
				var index = msg.a.qH;
				var passenger = msg.a.a;
				var isClubOneLevelHigherThanCurrentHighest = A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$eq(2),
						A3(
							$elm$core$Maybe$map2,
							$author$project$Types$ClubOneLevel$compare,
							passenger.pO,
							A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.pO;
								},
								$author$project$Types$Passenger$findWithHighestLevel(model.j.Eg)))));
				return (isClubOneLevelHigherThanCurrentHighest ? $author$project$Update$Util$andThen($author$project$Update$Trips$fetchTrips) : $elm$core$Basics$identity)(
					A3($author$project$Update$Passengers$storeClubOnePassenger, model, index, passenger));
			case 126:
				var pageModel = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2($author$project$Update$Passengers$updatePassenger, model, pageModel));
			case 17:
				var response = msg.a;
				if (!response.$) {
					var guid = response.a;
					return _Utils_Tuple2(
						A2($author$project$Update$replaceSessionGuid, guid, model),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 18:
				var guid = msg.a;
				return function (modelAndCmd) {
					var route = $author$project$UrlRoute$parseLocation(model.n1);
					return _Utils_eq(route, $author$project$UrlRoute$Payment) ? modelAndCmd : A2($author$project$Update$Util$andThen, $author$project$Update$Trips$fetchTrips, modelAndCmd);
				}(
					_Utils_Tuple2(
						A2($author$project$Update$replaceSessionGuid, guid, model),
						$elm$core$Platform$Cmd$none));
			case 1:
				var response = msg.a;
				return A2($author$project$Update$ExtraServices$received, model, response);
			case 108:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Update$ExtraServices$updateSelectedServices,
						A3($author$project$Types$SelectedExtraServices$toggle, 0, code, model.j.Gi),
						model),
					$elm$core$Platform$Cmd$none);
			case 109:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Update$ExtraServices$updateSelectedServices,
						A3($author$project$Types$SelectedExtraServices$toggle, 1, code, model.j.Gi),
						model),
					$elm$core$Platform$Cmd$none);
			case 110:
				var code = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Update$ExtraServices$updateSelectedServices,
						A3(
							$author$project$Types$SelectedExtraServices$toggle,
							1,
							code,
							A3($author$project$Types$SelectedExtraServices$toggle, 0, code, model.j.Gi)),
						model),
					$elm$core$Platform$Cmd$none);
			case 19:
				var result = msg.a;
				return A2($author$project$Update$gotOnboardServices, model, result);
			case 32:
				var subMsg = msg.a;
				var _v61 = model.DF;
				if (_v61.$ === 14) {
					var _v62 = A2(
						$author$project$Page$OnboardService$Update$update,
						subMsg,
						{j: session, HT: model.HT});
					var pageModel = _v62.a;
					var cmd = _v62.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{j: pageModel.j, HT: pageModel.HT}),
						A2($elm$core$Platform$Cmd$map, $author$project$Messages$OnboardServiceMsg, cmd));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 104:
				return _Utils_Tuple2(
					model,
					$author$project$Common$Ports$goBack(0));
			case 113:
				var paymentServiceProviderCode = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (task) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										j: _Utils_update(
											session,
											{Am: true})
									}),
								A2($elm$core$Task$attempt, $author$project$Messages$GotReservationConfirmation, task));
						},
						A2(
							$author$project$Update$Reservation$payAndConfirmExistingReservationIfExisting,
							model,
							$author$project$Api$Reservation$PaymentService(paymentServiceProviderCode))));
			case 112:
				var _v63 = model.DF;
				if (_v63.$ === 11) {
					var pageModel = _v63.a;
					return function (_v64) {
						var newModel = _v64.a;
						var cmds = _v64.b;
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(newModel, cmds),
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Tuple$pair(
										_Utils_update(
											newModel,
											{
												j: function (a) {
													return _Utils_update(
														a,
														{Am: true});
												}(newModel.j)
											})),
									function (a) {
										return $elm$core$Platform$Cmd$batch(
											A2(
												$elm$core$List$cons,
												cmds,
												_List_fromArray(
													[a])));
									}),
								A2(
									$elm$core$Maybe$map,
									$elm$core$Task$attempt($author$project$Messages$GotReservationConfirmation),
									A2($author$project$Update$Reservation$pay, newModel, $author$project$Api$Reservation$FreeTrip))));
					}(
						A2(
							$elm$core$Tuple$mapFirst,
							function (a) {
								return _Utils_update(
									model,
									{j: a});
							},
							A2($author$project$ContactPersonPage$Update$save, session, pageModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 114:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (task) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										j: _Utils_update(
											session,
											{Am: true})
									}),
								A2($elm$core$Task$attempt, $author$project$Messages$GotReservationConfirmation, task));
						},
						A2($author$project$Update$Reservation$payAndConfirmExistingReservationIfExisting, model, $author$project$Api$Reservation$Invoice)));
			case 13:
				var result = msg.a;
				if (!result.$) {
					var klarnaPage = result.a.AX;
					var resToken = result.a.mS;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{
										Am: false,
										BS: $elm$core$Maybe$Just(klarnaPage),
										B_: $elm$core$Maybe$Just(resToken)
									})
							}),
						A3($author$project$UrlRoute$pushUrl, model.AK, model.n1, $author$project$UrlRoute$KlarnaPayment));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{Am: false})
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Update$showConfirmationErrorToast, error, session),
									A2(
									$author$project$Tracking$logHttpError,
									'klarnaConfirmationReservationResponse',
									$author$project$Types$ErrorDetailed$toHttpError(error))
								])));
				}
			case 12:
				var result = msg.a;
				if (!result.$) {
					var value = result.a;
					var method = A2(
						$elm$core$Result$withDefault,
						'POST',
						A2(
							$elm$json$Json$Decode$decodeValue,
							A2($elm$json$Json$Decode$field, 'urlOpenMethod', $elm$json$Json$Decode$string),
							value));
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Reservation$submitFormData, model, method, value));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								j: _Utils_update(
									session,
									{Am: false})
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Update$showConfirmationErrorToast, error, session),
									A2(
									$author$project$Tracking$logHttpError,
									'paymentConfirmationReservationResponse',
									$author$project$Types$ErrorDetailed$toHttpError(error))
								])));
				}
			case 33:
				var subMsg = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					function () {
						if (!subMsg.$) {
							var toast = subMsg.a;
							return function (a) {
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											a,
											$author$project$Tracking$logToastUIMessage(toast)
										]));
							};
						} else {
							return $elm$core$Basics$identity;
						}
					}(),
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Messages$ToastMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (a) {
								return _Utils_update(
									model,
									{HT: a});
							},
							A2($author$project$Common$Toast$update, subMsg, model.HT))));
			case 10:
				var webData = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{v$: webData})
						}),
					$elm$core$Platform$Cmd$none);
			case 128:
				var travelClass = msg.a;
				var code = msg.b.pQ;
				var availability = msg.b.uk;
				var direction = msg.c;
				var _v68 = session;
				var selectedCabinSurprises = _v68.Gh;
				var addCabinSurprise = function (mapSelectedCabinSurprises) {
					return (_Utils_cmp(
						A2(
							$elm_community$list_extra$List$Extra$count,
							$elm$core$Basics$eq(code),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Dict$get,
									travelClass,
									mapSelectedCabinSurprises(selectedCabinSurprises)))),
						availability) < 0) ? A3(
						$elm$core$Dict$update,
						travelClass,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(_List_Nil),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$cons(code),
								$elm$core$Maybe$Just)),
						mapSelectedCabinSurprises(selectedCabinSurprises)) : mapSelectedCabinSurprises(selectedCabinSurprises);
				};
				var newSelectedCabinSurprises = (!direction) ? _Utils_update(
					selectedCabinSurprises,
					{
						DC: addCabinSurprise(
							function ($) {
								return $.DC;
							})
					}) : _Utils_update(
					selectedCabinSurprises,
					{
						FV: addCabinSurprise(
							function ($) {
								return $.FV;
							})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{Gh: newSelectedCabinSurprises})
						}),
					$elm$core$Platform$Cmd$none);
			case 129:
				var travelClass = msg.a;
				var code = msg.b.pQ;
				var direction = msg.c;
				var _v69 = session;
				var selectedCabinSurprises = _v69.Gh;
				var removeCabinSurprise = function (mapSelectedCabinSurprises) {
					return A3(
						$elm$core$Dict$update,
						travelClass,
						$elm$core$Maybe$map(
							$elm_community$list_extra$List$Extra$remove(code)),
						mapSelectedCabinSurprises(selectedCabinSurprises));
				};
				var newSelectedCabinSurprises = (!direction) ? _Utils_update(
					selectedCabinSurprises,
					{
						DC: removeCabinSurprise(
							function ($) {
								return $.DC;
							})
					}) : _Utils_update(
					selectedCabinSurprises,
					{
						FV: removeCabinSurprise(
							function ($) {
								return $.FV;
							})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{Gh: newSelectedCabinSurprises})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var cabinSurprises = msg.a;
				var isFirstLoad = _Utils_eq(session.pD, $krisajenkins$remotedata$RemoteData$NotAsked);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									pD: cabinSurprises,
									Gh: A2(
										$krisajenkins$remotedata$RemoteData$withDefault,
										$author$project$Types$CabinSurprise$defaultSelectedSurprises,
										A2(
											$krisajenkins$remotedata$RemoteData$map,
											A3(
												$author$project$Update$getSelectedCabinSurpises,
												isFirstLoad,
												session.Gh,
												$author$project$UrlRoute$bookingParamsFromLocation(model.n1)),
											cabinSurprises))
								})
						}),
					function () {
						if (cabinSurprises.$ === 2) {
							var error = cabinSurprises.a;
							return A2($author$project$Tracking$logHttpError, 'cabinSurpriseResponse', error);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 21:
				var result = msg.a;
				return _Utils_Tuple2(
					function (newSession) {
						return _Utils_update(
							model,
							{j: newSession});
					}(
						function (newSession) {
							return _Utils_update(
								newSession,
								{tR: _List_Nil});
						}(
							function (newSession) {
								return $author$project$Session$openFirstTicketGroup(newSession);
							}(
								function (newSession) {
									return A3($elm$core$List$foldl, $author$project$Session$addTicketWithAddonCode, newSession, newSession.tR);
								}(
									$author$project$Session$filterLandServiceEventsOutsideOfOnshoreTime(
										_Utils_update(
											session,
											{
												AZ: $krisajenkins$remotedata$RemoteData$fromResult(result)
											})))))),
					$elm$core$Platform$Cmd$none);
			case 35:
				var pageMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: A2($author$project$LandServicePage$Update$update, pageMsg, session)
						}),
					$elm$core$Platform$Cmd$none);
			case 27:
				var subMsg = msg.a;
				var _v71 = model.DF;
				if (_v71.$ === 18) {
					var pageModel = _v71.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Messages$HotelLinksMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (a) {
								return _Utils_update(
									model,
									{
										DF: $author$project$Model$HotelLinks(a)
									});
							},
							A2($author$project$Page$HotelLinks$update, subMsg, pageModel)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 22:
				var result = msg.a;
				return A2($author$project$Update$Trips$handleHotelPackagesResponse, model, result);
			case 36:
				var pageMsg = msg.a;
				var _v72 = model.DF;
				if (_v72.$ === 19) {
					var pageModel = _v72.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (a) {
							return _Utils_update(
								model,
								{
									DF: $author$project$Model$HotelList(a),
									j: A2($author$project$Page$HotelList$save, session, a)
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Messages$HotelListMsg),
						A5($author$project$Page$HotelList$update, model.AK, model.n1, session, pageMsg, pageModel));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 37:
				var pageMsg = msg.a;
				var _v73 = model.DF;
				if (_v73.$ === 20) {
					var pageModel = _v73.a;
					return A3(
						$elm$core$Tuple$mapBoth,
						function (a) {
							return _Utils_update(
								model,
								{
									DF: $author$project$Model$Hotel(a),
									j: A2($author$project$Page$Hotel$save, session, a),
									HT: a.HT
								});
						},
						$elm$core$Platform$Cmd$map($author$project$Messages$HotelMsg),
						A4($author$project$Page$Hotel$update, model.AK, model.n1, pageMsg, pageModel));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 106:
				var cmd = msg.a;
				var cmds = msg.b;
				return _Utils_Tuple2(
					model,
					A2($author$project$Update$Util$sequentialCmds, cmd, cmds));
			case 118:
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(
						$author$project$UrlRoute$mikiRoot(model.n1)));
			case 124:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								function (_v74) {
									return $author$project$Messages$ClosedModal;
								},
								$elm$core$Task$succeed(0)),
								$author$project$BookingPage$BackToDesktop$Update$goBackToDesktopCmd(model)
							])));
			case 125:
				var from = msg.a.kS;
				var to = msg.a.le;
				var maybeVoyageType = msg.a.Cd;
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$perform,
									function (_v75) {
										return $author$project$Messages$ClosedModal;
									},
									$elm$core$Task$succeed(0)),
									cmd
								]));
					},
					A3(
						$author$project$Update$Util$andThenIf,
						session.vk === 1,
						$author$project$Update$Trips$fetchHotelPackages,
						A3(
							$author$project$Update$Util$andThenIf,
							!session.vk,
							$author$project$Update$Trips$fetchTrips,
							A2(
								$author$project$Update$BusTransfers$showBusTransferRemovedToastIfNeeded,
								model.j.B0,
								$author$project$Update$Route$updateRoute(
									{
										kS: from,
										eM: model,
										le: to,
										m1: A2($elm$core$Maybe$withDefault, model.j.tx, maybeVoyageType)
									})))));
			case 127:
				var inset = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{Io: inset})
						}),
					$elm$core$Platform$Cmd$none);
			case 135:
				var callback = msg.a;
				return ($author$project$Common$Recaptcha$shouldRequestRecaptcha(session) && _Utils_eq(model.j.Fr.yh, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									Fr: function (a) {
										return _Utils_update(
											a,
											{
												vK: $elm$core$Maybe$Just(callback)
											});
									}(session.Fr)
								})
						}),
					$author$project$Ports$executeRecaptcha(0)) : _Utils_Tuple2(
					model,
					$author$project$Update$performRecaptchaCallback(callback));
			case 136:
				var data = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: _Utils_update(
								session,
								{
									Fr: function (a) {
										return _Utils_update(
											a,
											{yh: data});
									}(session.Fr)
								})
						}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$Update$performRecaptchaCallback, session.Fr.vK)));
			case 137:
				var value = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Update$updateEnabledClubOneSlider,
						model,
						function (clubOneSlider) {
							var tempPrice = A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$Number$Round$roundWithPrecision(2),
									A2(
										$elm$core$Maybe$map,
										function (summary) {
											var currentPrice = summary.lN + clubOneSlider.mu.H9;
											return currentPrice - (value / clubOneSlider.mu.Fp);
										},
										session.B7)));
							return _Utils_update(
								clubOneSlider,
								{s8: value, He: tempPrice});
						}),
					$elm$core$Platform$Cmd$none);
			case 138:
				return _Utils_Tuple2(
					function (newModel) {
						return _Utils_update(
							newModel,
							{
								j: function (newSession) {
									return _Utils_update(
										newSession,
										{Ez: true});
								}(newModel.j)
							});
					}(
						A2(
							$author$project$Update$updateEnabledClubOneSlider,
							model,
							function (clubOneSlider) {
								return _Utils_update(
									clubOneSlider,
									{E0: clubOneSlider.s8});
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateBooking = F2(
	function (msg, oldModel) {
		return function (_v1) {
			var newModel = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							$author$project$Tracking$logDigiData(newModel)
						])));
		}(
			function (_v0) {
				var model = _v0.a;
				var cmd = _v0.b;
				var newSummaryRequestValues = $author$project$Types$SummaryRequestValues$fromSession(model.j);
				var isRequiredAndPossible = A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						$author$project$Update$Summary$haveSummaryValuesChanged(newSummaryRequestValues),
						model.j.B8)) && (model.j.pr && $author$project$Update$Summary$isRequiredTravelClassSelected(model));
				var isBlocked = $author$project$Update$Summary$isSummaryRequestBlocked(model);
				var hasRequestValues = !_Utils_eq(model.j.B8, $elm$core$Maybe$Nothing);
				return (model.j.pr && (!$author$project$Update$Summary$isRequiredTravelClassSelected(model))) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							j: function (b) {
								return _Utils_update(
									b,
									{Af: false, B7: $elm$core$Maybe$Nothing, B8: $elm$core$Maybe$Nothing});
							}(model.j)
						}),
					cmd) : ((isBlocked && hasRequestValues) ? A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$cons(cmd),
							$elm$core$Platform$Cmd$batch)),
					$author$project$Update$Summary$cancelSummaryRequest(model)) : (isBlocked ? _Utils_Tuple2(model, cmd) : (isRequiredAndPossible ? A2(
					$author$project$Update$Summary$addSummaryRequest,
					_Utils_Tuple2(model, cmd),
					newSummaryRequestValues) : _Utils_Tuple2(model, cmd))));
			}(
				A2(
					$author$project$Main$remapPassengerAgeCategories,
					oldModel,
					A2($author$project$Update$update, msg, oldModel))));
	});
var $author$project$Messages$GotApiConfig = function (a) {
	return {$: 2, a: a};
};
var $author$project$Messages$GotSessionGuid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$configEndpoint = function (config) {
	return A5(
		$author$project$Api$Endpoint$url,
		config,
		config.d,
		_List_fromArray(
			['config']),
		_List_Nil,
		$elm$core$Maybe$Nothing);
};
var $author$project$Types$ApiConfig$ApiConfig = F3(
	function (marketUntilDate, recaptchaEnabled, recaptchaClientKey) {
		return {mI: marketUntilDate, oF: recaptchaClientKey, mR: recaptchaEnabled};
	});
var $author$project$Types$ApiConfig$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'recaptchaClientKey',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'isRecaptchaEnabled',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'marketUntilDate',
			$author$project$Utils$Time$decoder,
			$elm$json$Json$Decode$succeed($author$project$Types$ApiConfig$ApiConfig))));
var $author$project$Api$Config$get = F2(
	function (serverConfig, msg) {
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, msg, $author$project$Types$ApiConfig$decoder),
				jW: $author$project$Api$Endpoint$configEndpoint(serverConfig)
			});
	});
var $author$project$Messages$GotPaymentMethods = function (a) {
	return {$: 7, a: a};
};
var $author$project$Messages$GotVoucherValidation = function (a) {
	return {$: 16, a: a};
};
var $author$project$Types$MobileOperatingSystem$UNKNOWN = 3;
var $author$project$Types$Client$ClubOneCredentials = F3(
	function (firstName, lastName, clubOneNumber) {
		return {we: clubOneNumber, y2: firstName, A6: lastName};
	});
var $author$project$Types$Client$clubOneCredentialsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'clubone',
	$author$project$Utils$String$decodeNonEmpty,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lastName',
		$author$project$Utils$String$decodeNonEmpty,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'firstName',
			$author$project$Utils$String$decodeNonEmpty,
			$elm$json$Json$Decode$succeed($author$project$Types$Client$ClubOneCredentials))));
var $author$project$Types$MobileOperatingSystem$ANDROID = 0;
var $author$project$Types$MobileOperatingSystem$IOS = 1;
var $author$project$Types$MobileOperatingSystem$WINDOWS_PHONE = 2;
var $author$project$Types$MobileOperatingSystem$fromString = function (string) {
	switch (string) {
		case 'android':
			return 0;
		case 'ios':
			return 1;
		case 'windows-phone':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Types$MobileOperatingSystem$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $author$project$Types$MobileOperatingSystem$fromString, $elm$json$Json$Decode$succeed),
	$elm$json$Json$Decode$string);
var $author$project$Types$SelectedVehicle$failDecodeOnEmptyString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$json$Json$Decode$fail(string) : $elm$json$Json$Decode$succeed(string);
};
var $author$project$Types$SelectedVehicle$decodeEmptyOrNullString = $elm$json$Json$Decode$maybe(
	A2($elm$json$Json$Decode$andThen, $author$project$Types$SelectedVehicle$failDecodeOnEmptyString, $elm$json$Json$Decode$string));
var $author$project$Types$Vehicle$vehicleVoyageTypeDecoderHelp = function (input) {
	switch (input) {
		case 'ROUNDTRIP':
			return $elm$json$Json$Decode$succeed(0);
		case 'OUTWARD':
			return $elm$json$Json$Decode$succeed(1);
		case 'RETURN':
			return $elm$json$Json$Decode$succeed(2);
		default:
			var unknownString = input;
			return $elm$json$Json$Decode$fail(unknownString);
	}
};
var $author$project$Types$Vehicle$vehicleVoyageTypeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Types$Vehicle$vehicleVoyageTypeDecoderHelp, $elm$json$Json$Decode$string);
var $author$project$Types$SelectedVehicle$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		true,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'voyageType',
			$elm$json$Json$Decode$maybe($author$project$Types$Vehicle$vehicleVoyageTypeDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'licensePlateTrailer',
				$author$project$Types$SelectedVehicle$decodeEmptyOrNullString,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'licensePlate',
					$author$project$Types$SelectedVehicle$decodeEmptyOrNullString,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'code',
						$author$project$Types$Vehicle$carCategoryDecoder,
						$elm$json$Json$Decode$succeed($author$project$Types$SelectedVehicle$SelectedVehicle)))))));
var $author$project$Types$ServerConfig$encode = function (serverConfig) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'iki3',
				$elm$json$Json$Encode$string(serverConfig.d)),
				_Utils_Tuple2(
				'sso',
				$elm$json$Json$Encode$string(serverConfig.o2)),
				_Utils_Tuple2(
				'bookingChange',
				$elm$json$Json$Encode$string(serverConfig.px)),
				_Utils_Tuple2(
				'crab',
				$elm$json$Json$Encode$string(serverConfig.x7)),
				_Utils_Tuple2(
				'myJourney',
				$elm$json$Json$Encode$string(serverConfig.og)),
				_Utils_Tuple2(
				'beaver',
				$elm$json$Json$Encode$string(serverConfig.nc)),
				_Utils_Tuple2(
				'liferay',
				$elm$json$Json$Encode$string(serverConfig.Ba)),
				_Utils_Tuple2(
				'cookieConsent',
				$elm$json$Json$Encode$string(serverConfig.nl)),
				_Utils_Tuple2(
				'paymentService',
				$elm$json$Json$Encode$string(serverConfig.ou)),
				_Utils_Tuple2(
				'showGoToDesktopButton',
				$elm$json$Json$Encode$bool(serverConfig.GC))
			]));
};
var $author$project$Utils$CookieConsent$encode = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	var serverConfig = _v0.Gs;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'serverConfig',
				$author$project$Types$ServerConfig$encode(serverConfig)),
				_Utils_Tuple2(
				'language',
				$elm$json$Json$Encode$string(
					$author$project$Types$Language$toString(language))),
				_Utils_Tuple2(
				'market',
				$elm$json$Json$Encode$string(
					$author$project$Types$Market$toString(market)))
			]));
};
var $author$project$Types$CruiseSails$MorningDeparture = 0;
var $author$project$Utils$Route$isOvernightCruiseAvailable = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var _v1 = _Utils_Tuple3(from, to, voyageType);
	_v1$2:
	while (true) {
		if (!_v1.c.$) {
			switch (_v1.a) {
				case 4:
					if (_v1.b === 2) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var _v4 = _v1.c;
						return true;
					} else {
						break _v1$2;
					}
				case 1:
					if (_v1.b === 6) {
						var _v5 = _v1.a;
						var _v6 = _v1.b;
						var _v7 = _v1.c;
						return true;
					} else {
						break _v1$2;
					}
				default:
					break _v1$2;
			}
		} else {
			break _v1$2;
		}
	}
	return false;
};
var $author$project$Init$getCruiseTripType = F2(
	function (urlParams, route) {
		var isOvernightCruiseAndCorrespondingRoute = _Utils_eq(
			urlParams.DE,
			$elm$core$Maybe$Just(true)) && $author$project$Utils$Route$isOvernightCruiseAvailable(route);
		var isMorningCruiseAndCorrespondingRoute = _Utils_eq(
			urlParams.yR,
			$elm$core$Maybe$Just(false)) && $author$project$Utils$Route$areMorningAndEveningCruisesAvailable(route);
		return isMorningCruiseAndCorrespondingRoute ? 0 : (isOvernightCruiseAndCorrespondingRoute ? 2 : 1);
	});
var $author$project$Init$getDefaultRoute = function (market) {
	switch (market) {
		case 1:
			return _Utils_Tuple2(2, 0);
		case 4:
			return _Utils_Tuple2(1, 2);
		case 0:
			return _Utils_Tuple2(0, 2);
		case 3:
			return _Utils_Tuple2(1, 5);
		case 2:
			return _Utils_Tuple2(0, 2);
		case 6:
			return _Utils_Tuple2(1, 5);
		case 7:
			return _Utils_Tuple2(1, 0);
		default:
			return _Utils_Tuple2(2, 1);
	}
};
var $author$project$Types$PaymentMethods$PaymentMethods = function (paymentServiceProviders) {
	return {Ey: paymentServiceProviders};
};
var $author$project$Types$PaymentServiceProvider$PaymentServiceProvider = F2(
	function (code, methods) {
		return {pQ: code, Cw: methods};
	});
var $author$project$Types$PaymentServiceProviderCode$fromString = function (string) {
	switch (string) {
		case 'SWEDBANK':
			return $elm$core$Maybe$Just(0);
		case 'ADYEN':
			return $elm$core$Maybe$Just(1);
		case 'KLARNA':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$PaymentServiceProviderCode$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Types$PaymentServiceProviderCode$fromString(string);
		if (!_v0.$) {
			var code = _v0.a;
			return $elm$json$Json$Decode$succeed(code);
		} else {
			return $elm$json$Json$Decode$fail('Invalid payment service provider code');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$PaymentServiceProvider$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$PaymentServiceProvider$PaymentServiceProvider,
	A2($elm$json$Json$Decode$field, 'code', $author$project$Types$PaymentServiceProviderCode$decoder),
	A2(
		$elm$json$Json$Decode$field,
		'methods',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Types$PaymentMethods$decoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Types$PaymentMethods$PaymentMethods,
	A2(
		$elm$json$Json$Decode$field,
		'paymentServiceProviders',
		$elm$json$Json$Decode$list($author$project$Types$PaymentServiceProvider$decoder)));
var $author$project$Api$Endpoint$payment = F2(
	function (config, params) {
		return A5(
			$author$project$Api$Endpoint$url,
			config,
			config.d,
			_List_fromArray(
				['payment', 'v4']),
			params,
			$elm$core$Maybe$Just($author$project$Api$Endpoint$trackers.r_));
	});
var $author$project$Api$Payment$getPaymentMethods = F3(
	function (config, session, resultToMsg) {
		return $author$project$Api$getWithCredentials(
			{
				j9: A2($elm$http$Http$expectJson, resultToMsg, $author$project$Types$PaymentMethods$decoder),
				jW: A2(
					$author$project$Api$Endpoint$payment,
					config.Gs,
					A2(
						$author$project$Api$Util$addExperimentalParamIf,
						session.Aa,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var a = _v0.a;
								var b = _v0.b;
								return A2($elm$url$Url$Builder$string, a, b);
							},
							_List_fromArray(
								[
									$author$project$Api$Util$guidParam(config.Gt),
									$author$project$Api$Util$localeParam(session.A_),
									$author$project$Api$Util$marketParam(session.rb)
								]))))
			});
	});
var $author$project$Init$getRouteFromUrlParams = F2(
	function (urlParams, bookingType) {
		var _v0 = _Utils_Tuple2(urlParams.kS, urlParams.le);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var from = _v0.a.a;
			var to = _v0.b.a;
			return $author$project$Utils$Route$isRouteSupported(
				{vk: bookingType, kS: from, le: to}) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(from, to)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Common$Toast$init = {zN: 0, L: $elm$core$Maybe$Nothing};
var $author$project$InvoicePage$Model$init = {sj: $elm$core$Maybe$Nothing};
var $author$project$PaymentPage$Model$init = {ro: $elm$core$Maybe$Nothing};
var $author$project$VehiclePage$Model$init = function (maybeMemorizedFirstSelectedVehicle) {
	return {uz: 0.0, lr: $elm$core$Maybe$Nothing, n7: $elm$core$Maybe$Nothing, BV: maybeMemorizedFirstSelectedVehicle, ty: false};
};
var $author$project$Common$Ports$initCookieConsent = _Platform_outgoingPort('initCookieConsent', $elm$core$Basics$identity);
var $author$project$Ports$initRecaptcha = _Platform_outgoingPort(
	'initRecaptcha',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'clientKey',
					$elm$json$Json$Encode$string($.v6)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string($.A_))
				]));
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Init$initializePassengers = F2(
	function (_v0, _v1) {
		var adults = _v0.pn;
		var youth = _v0.IF;
		var children = _v0.vV;
		var juniors = _v0.AJ;
		var from = _v1.a;
		var to = _v1.b;
		var maxPassengers = $author$project$Utils$Route$getMaxNumberOfPassengers(
			{kS: from, le: to});
		var adultsCount = A2(
			$elm$core$Basics$min,
			maxPassengers,
			A2($elm$core$Maybe$withDefault, 1, adults));
		var youthCount = A2(
			$elm$core$Basics$min,
			maxPassengers - adultsCount,
			A2($elm$core$Maybe$withDefault, 0, youth));
		var childrenCount = A2(
			$elm$core$Basics$min,
			(maxPassengers - adultsCount) - youthCount,
			A2($elm$core$Maybe$withDefault, 0, children));
		var juniorsCount = A2(
			$elm$core$Basics$min,
			((maxPassengers - adultsCount) - youthCount) - childrenCount,
			A2($elm$core$Maybe$withDefault, 0, juniors));
		return $elm$core$Array$fromList(
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$repeat,
						adultsCount,
						$author$project$Types$Passenger$init(0)),
						A2(
						$elm$core$List$repeat,
						youthCount,
						$author$project$Types$Passenger$init(1)),
						A2(
						$elm$core$List$repeat,
						childrenCount,
						$author$project$Types$Passenger$init(2)),
						A2(
						$elm$core$List$repeat,
						juniorsCount,
						$author$project$Types$Passenger$init(3))
					])));
	});
var $author$project$Init$initBooking = F2(
	function (flags, _arguments) {
		var viewportSafeAreaInsetTop = A2(
			$elm$core$Result$withDefault,
			0,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'viewportSafeAreaInsetTop', $elm$json$Json$Decode$int),
				flags));
		var urlParams = $author$project$UrlRoute$bookingParamsFromLocation(_arguments.jW);
		var timeFrom = A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$Time$nothingIfBefore(_arguments.kJ),
			A2($elm$core$Maybe$andThen, $author$project$Utils$Time$fromDateString, urlParams.nn));
		var ssoTokenFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'ssoToken', $author$project$Utils$String$decodeNonEmpty),
			flags);
		var reservationDataFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'reservationData', $author$project$Types$ReservationData$reservationDataDecoder),
			flags);
		var mobileOperatingSystemFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'mobileOperatingSystem', $author$project$Types$MobileOperatingSystem$decoder),
			flags);
		var mobileOperatingSystem = A2($elm$core$Result$withDefault, 3, mobileOperatingSystemFromFlags);
		var memorizedFirstSelectedVehicleFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'memorizedFirstSelectedVehicle', $author$project$Types$SelectedVehicle$decoder),
			flags);
		var isNativeFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'isNative', $elm$json$Json$Decode$bool),
			flags);
		var isExperimental = A2($elm$core$Maybe$withDefault, false, urlParams.qi);
		var httpConfig = {Gs: _arguments.Gs, Gt: _arguments.Gt};
		var density = A2(
			$elm$core$Result$withDefault,
			0,
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					'devicePixelRatio',
					A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)),
				flags));
		var clubOneCredentialsFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'clubOneCredentials', $author$project$Types$Client$clubOneCredentialsDecoder),
			flags);
		var clientFromFlags = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'clubOneClient', $author$project$Types$Client$decoder),
			flags);
		var client = A2(
			$elm$core$Result$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($elm$core$Result$map, $krisajenkins$remotedata$RemoteData$Success, clientFromFlags));
		var user = {
			v4: client,
			Cb: $elm$core$Result$toMaybe(ssoTokenFromFlags)
		};
		var _v0 = $author$project$UrlRoute$getLocaleFromQueryParams(urlParams);
		var language = _v0.A_;
		var market = _v0.rb;
		var bookingType = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (bt) {
					return $author$project$Types$Language$supportsHotels(language) ? bt : 0;
				},
				urlParams.vk));
		var isOneWay = !bookingType;
		var _v1 = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Init$getDefaultRoute(market),
			A2($author$project$Init$getRouteFromUrlParams, urlParams, bookingType));
		var from = _v1.a;
		var to = _v1.b;
		var passengersFromUrlParams = A2(
			$author$project$Init$initializePassengers,
			urlParams,
			_Utils_Tuple2(from, to));
		var voyageType = A2(
			$elm$core$Maybe$withDefault,
			(bookingType === 1) ? A2($author$project$Utils$Route$getHotelPackageDefaultVoyageType, from, to) : A4($author$project$Utils$Route$getRegularDefaultVoyageType, from, to, market, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return A3($author$project$Utils$Route$isRegularVoyageTypeSupportedByRoute, from, to, a) ? a : A4(
						$author$project$Utils$Route$getRegularDefaultVoyageType,
						from,
						to,
						market,
						$elm$core$Maybe$Just(a));
				},
				urlParams.tx));
		var cruiseTripType = A2(
			$author$project$Init$getCruiseTripType,
			urlParams,
			{kS: from, le: to, tx: voyageType});
		var isWithVehicle = A2($elm$core$Maybe$withDefault, false, urlParams.Az) && $author$project$Utils$Route$areVehiclesSupported(
			{kS: from, le: to, tx: voyageType});
		var soloYouthAllowed = $author$project$Update$Passengers$isSoloYouthAllowed(
			{vk: bookingType, kS: from, le: to, tx: voyageType});
		var passengers = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			passengersFromUrlParams,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				A3(
					$author$project$Update$Passengers$addClubOneClient,
					soloYouthAllowed,
					A2($elm$core$Maybe$withDefault, _arguments.kJ, timeFrom),
					$elm$core$Array$toList(passengersFromUrlParams)),
				client));
		var session = {
			tL: $elm$core$Maybe$Nothing,
			tR: urlParams.tQ,
			pr: false,
			vk: bookingType,
			pD: $krisajenkins$remotedata$RemoteData$NotAsked,
			v$: $krisajenkins$remotedata$RemoteData$NotAsked,
			xA: $elm$core$Maybe$Nothing,
			mm: cruiseTripType,
			yn: density,
			yq: _List_Nil,
			yx: _List_Nil,
			qk: _List_Nil,
			kS: from,
			zn: false,
			zw: $elm$core$Maybe$Nothing,
			zI: {vZ: _List_Nil, zH: _List_Nil},
			zM: httpConfig,
			z5: A2($elm$core$Maybe$withDefault, false, urlParams.ux),
			Aa: isExperimental,
			Ac: false,
			Ad: false,
			Af: false,
			Ag: false,
			qW: isOneWay,
			nT: A2($elm$core$Maybe$withDefault, false, urlParams.nT),
			Am: false,
			Ao: true,
			AE: $author$project$Types$JoinClubOneState$NotJoining,
			AZ: $krisajenkins$remotedata$RemoteData$NotAsked,
			A_: language,
			rb: market,
			mI: _arguments.mI,
			n8: $elm$core$Maybe$Nothing,
			BQ: $elm$core$Maybe$Nothing,
			BS: $elm$core$Maybe$Nothing,
			ri: $elm$core$Maybe$Nothing,
			BW: $elm$core$Maybe$Nothing,
			BX: $elm$core$Maybe$Nothing,
			B_: $elm$core$Maybe$Nothing,
			B0: $elm$core$Maybe$Nothing,
			B1: $elm$core$Maybe$Nothing,
			B2: $elm$core$Maybe$Nothing,
			rp: $elm$core$Maybe$Nothing,
			B7: $elm$core$Maybe$Nothing,
			B8: $elm$core$Maybe$Nothing,
			B9: $elm$core$Maybe$Nothing,
			rs: $author$project$Types$MealPackage$Regular(_List_Nil),
			rI: $author$project$Types$OnboardServices$init,
			Dy: $elm$core$Maybe$Nothing,
			Eg: passengers,
			Ez: false,
			se: A2($elm$core$Maybe$withDefault, false, urlParams.se),
			Fr: {vK: $elm$core$Maybe$Nothing, yh: $elm$core$Maybe$Nothing, yL: _arguments.mR},
			Fz: $elm$core$Result$toMaybe(reservationDataFromFlags),
			F1: {kS: from, le: to},
			Gh: {DC: $elm$core$Dict$empty, FV: $elm$core$Dict$empty},
			Gi: $author$project$Types$SelectedExtraServices$init,
			Gk: $author$project$Types$Hotel$init,
			Gl: _List_Nil,
			Gm: $author$project$Types$SelectedOnboardServices$init,
			Gn: $author$project$Types$SelectedMeals$init,
			Go: $author$project$Types$SelectedMeals$init,
			Gz: false,
			GF: false,
			GH: false,
			G4: false,
			kJ: _arguments.kJ,
			le: to,
			H_: _List_Nil,
			to: $elm$core$Maybe$Nothing,
			tp: $author$project$Types$Trips$Failure($elm$core$Maybe$Nothing),
			Ia: user,
			If: {BO: $elm$core$Maybe$Nothing, GG: false},
			tt: _List_Nil,
			Ij: {F6: $elm$core$Maybe$Nothing, tt: _List_Nil},
			Io: viewportSafeAreaInsetTop,
			tw: _List_Nil,
			tx: voyageType
		};
		var initCookieConsent = $author$project$Common$Ports$initCookieConsent(
			$author$project$Utils$CookieConsent$encode(
				{A_: language, rb: market, Gs: session.zM.Gs}));
		var maybeFetchReservationCmd = A2(
			$elm$core$Maybe$map,
			function (resToken) {
				return A4($author$project$Api$Reservation$fetchReservation, session, resToken, $author$project$Messages$GotReservationData, httpConfig);
			},
			urlParams.mS);
		var model = function (newModel) {
			return isWithVehicle ? $author$project$Update$Vehicles$toggleVehicles(newModel) : newModel;
		}(
			{
				l1: _arguments.l1,
				pz: {Ay: false, GD: false, Ix: $elm$core$Maybe$Nothing},
				qL: $author$project$InvoicePage$Model$init,
				Ae: true,
				qV: A2($elm$core$Result$withDefault, false, isNativeFromFlags),
				Av: true,
				AK: _arguments.AK,
				n1: _arguments.jW,
				CB: mobileOperatingSystem,
				CC: $author$project$Common$Modal$Model$Closed,
				DF: $author$project$Model$Root,
				Ea: A2($author$project$PassengerPage$Model$Model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				Ev: $elm$core$Maybe$Nothing,
				Ew: $author$project$PaymentPage$Model$init,
				mR: false,
				j: session,
				HT: $author$project$Common$Toast$init,
				HZ: {y1: ''},
				H0: $author$project$TravelClassPage$Model$init,
				Ih: $author$project$VehiclePage$Model$init(
					$elm$core$Result$toMaybe(memorizedFirstSelectedVehicleFromFlags))
			});
		var didNotComeFromBooking = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$contains('resToken'),
				model.n1.Fo));
		var maybeInitRecaptcha = $author$project$Common$Recaptcha$shouldRequestRecaptcha(model.j) ? A2(
			$elm$core$Maybe$map,
			function (clientKey) {
				return $author$project$Ports$initRecaptcha(
					{
						v6: clientKey,
						A_: $author$project$Types$Language$toString(model.j.A_)
					});
			},
			_arguments.oF) : $elm$core$Maybe$Nothing;
		var paymentMethodsRequest = A3($author$project$Api$Payment$getPaymentMethods, httpConfig, session, $author$project$Messages$GotPaymentMethods);
		return (didNotComeFromBooking ? $elm$core$Basics$identity : ((session.vk === 1) ? $author$project$Update$Util$andThen($author$project$Update$Trips$fetchHotelPackages) : $author$project$Update$Util$andThen(
			$author$project$Update$Trips$fetchTripsWithTimes(
				{F4: urlParams.F4, ld: _arguments.kJ, mZ: timeFrom}))))(
			A2(
				$author$project$Update$Util$andThen,
				$author$project$Update$initPage(_arguments.jW),
				A3(
					$elm$core$Basics$apR,
					A2(
						$elm$core$Maybe$map,
						F2(
							function (token, _v2) {
								var newModel = _v2.a;
								var cmd = _v2.b;
								return A2(
									$elm$core$Tuple$mapSecond,
									function (a) {
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[a, cmd]));
									},
									A2($author$project$Update$User$fetchClient, newModel, token));
							}),
						_arguments.o9),
					$elm$core$Maybe$withDefault($elm$core$Basics$identity),
					_Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							A2(
								$author$project$Utils$List$maybeAdd,
								A2(
									$elm$core$Maybe$map,
									function (voucher) {
										return A3(
											$author$project$Api$Voucher$validate,
											session,
											$elm$core$String$toUpper(voucher),
											A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Messages$GotVoucherValidation));
									},
									urlParams.Iv),
								A2(
									$author$project$Utils$List$maybeAdd,
									A2(
										$elm$core$Maybe$map,
										function (credentials) {
											return A5(
												$author$project$Api$Client$fetchWithCredentials,
												session,
												credentials,
												httpConfig,
												$author$project$Types$Client$decoder,
												A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Messages$GotClient));
										},
										$elm$core$Result$toMaybe(clubOneCredentialsFromFlags)),
									A2(
										$author$project$Utils$List$maybeAdd,
										maybeFetchReservationCmd,
										A2(
											$author$project$Utils$List$maybeAdd,
											maybeInitRecaptcha,
											_List_fromArray(
												[
													$author$project$Ports$sendAppLoadedMessageToNativeWrapper(0),
													initCookieConsent,
													paymentMethodsRequest
												]))))))))));
	});
var $author$project$Main$initBookingIfAllValuesPresent = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(
			$author$project$Model$Initial(model),
			$elm$core$Platform$Cmd$none),
		A5(
			$elm$core$Maybe$map4,
			F4(
				function (sessionGuid, serverConfig, marketUntilDate, timeNow) {
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Messages$Booking),
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Model$Booking,
							A2(
								$author$project$Init$initBooking,
								model.y3,
								{l1: model.l1, AK: model.AK, mI: marketUntilDate, oF: model.oF, mR: model.mR, Gs: serverConfig, Gt: sessionGuid, kJ: timeNow, o9: model.o9, jW: model.jW})));
				}),
			model.Gt,
			model.Gs,
			model.mI,
			model.kJ));
};
var $author$project$Ports$init = _Platform_outgoingPort('init', $elm$core$Basics$identity);
var $author$project$Types$Language$toSSOLanguage = function (language) {
	switch (language) {
		case 0:
			return 'en-US';
		case 1:
			return 'et-EE';
		case 2:
			return 'fi-FI';
		case 3:
			return 'lv-LV';
		case 4:
			return 'sv-SE';
		case 5:
			return 'ru-RU';
		case 6:
			return 'zn-CH';
		case 7:
			return 'jp-US';
		case 8:
			return 'de-DE';
		default:
			return 'en-US';
	}
};
var $author$project$Ports$initJS = function (_v0) {
	var language = _v0.A_;
	var serverConfig = _v0.Gs;
	return $author$project$Ports$init(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'serverConfig',
					$author$project$Types$ServerConfig$encode(serverConfig)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$elm$core$String$toLower(
							$author$project$Types$Language$toString(language)))),
					_Utils_Tuple2(
					'ssoLanguage',
					$elm$json$Json$Encode$string(
						$author$project$Types$Language$toSSOLanguage(language)))
				])));
};
var $author$project$Main$updateInitial = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var serverConfig = result.a;
					return _Utils_Tuple2(
						$author$project$Model$Initial(
							_Utils_update(
								model,
								{
									Gs: $elm$core$Maybe$Just(serverConfig)
								})),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Messages$Initial,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$Api$Guid$createGuid,
										$author$project$Messages$GotSessionGuid,
										serverConfig,
										{Aa: model.Aa, A_: model.A_, rb: model.rb}),
										A2($author$project$Api$Config$get, serverConfig, $author$project$Messages$GotApiConfig),
										$author$project$Ports$initJS(
										{A_: model.A_, Gs: serverConfig})
									]))));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$author$project$Model$Initial(model),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$UrlRoute$pushUrl, model.AK, model.jW, $author$project$UrlRoute$ConnectionProblem),
									A2($author$project$Tracking$logHttpError, 'settingsResponse', error)
								])));
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var sessionGuid = result.a;
					return $author$project$Main$initBookingIfAllValuesPresent(
						_Utils_update(
							model,
							{
								Gt: $elm$core$Maybe$Just(sessionGuid)
							}));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$author$project$Model$Initial(model),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$UrlRoute$pushUrl, model.AK, model.jW, $author$project$UrlRoute$ConnectionProblem),
									A2($author$project$Tracking$logHttpError, 'openResponse', error)
								])));
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var marketUntilDate = result.a.mI;
					var recaptchaEnabled = result.a.mR;
					var recaptchaClientKey = result.a.oF;
					return $author$project$Main$initBookingIfAllValuesPresent(
						_Utils_update(
							model,
							{
								mI: $elm$core$Maybe$Just(marketUntilDate),
								oF: recaptchaClientKey,
								mR: recaptchaEnabled
							}));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						$author$project$Model$Initial(model),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$UrlRoute$pushUrl, model.AK, model.jW, $author$project$UrlRoute$ConnectionProblem),
									A2($author$project$Tracking$logHttpError, 'configResponse', error)
								])));
				}
			default:
				var time = msg.a;
				return $author$project$Main$initBookingIfAllValuesPresent(
					_Utils_update(
						model,
						{
							kJ: $elm$core$Maybe$Just(time)
						}));
		}
	});
var $author$project$Main$changeUrl = F2(
	function (url, model) {
		var _v3 = $author$project$UrlRoute$parseLocation(url);
		if (_v3.$ === 13) {
			return _Utils_Tuple2(
				$author$project$Main$initOffline(model),
				function () {
					if (!model.$) {
						return $author$project$Ports$sendAppLoadedMessageToNativeWrapper(0);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}());
		} else {
			switch (model.$) {
				case 2:
					var offlineModel = model.a;
					var _v6 = offlineModel.F7;
					if (!_v6.$) {
						var bookingModel = _v6.a;
						var didNotComeFromBooking = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$contains('resToken'),
								bookingModel.n1.Fo));
						return A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								model,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3($author$project$UrlRoute$pushUrl, bookingModel.AK, url, $author$project$UrlRoute$ConnectionProblem),
											A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Messages$Offline,
											$author$project$ConnectionProblemPage$Update$createGuid(bookingModel.j))
										]))),
							A2(
								$elm$core$Maybe$map,
								function (sessionGuid) {
									return A3(
										$elm$core$Tuple$mapBoth,
										$author$project$Model$Booking,
										$elm$core$Platform$Cmd$map($author$project$Messages$Booking),
										(didNotComeFromBooking ? $elm$core$Basics$identity : $author$project$Update$Util$andThen(
											$author$project$Update$Trips$fetchTripsWithTimes(
												$author$project$Update$RequestTimes$create(bookingModel.j.kJ))))(
											_Utils_Tuple2(
												A2($author$project$Update$replaceSessionGuid, sessionGuid, bookingModel),
												A2(
													$elm$core$Task$perform,
													$author$project$Messages$UrlChanged,
													$elm$core$Task$succeed(url)))));
								},
								offlineModel.Gt));
					} else {
						var flags = _v6.a.y3;
						var key = _v6.a.AK;
						return A3($author$project$Init$init, flags, url, key);
					}
				case 0:
					var initialModel = model.a;
					return _Utils_Tuple2(
						$author$project$Model$Initial(
							_Utils_update(
								initialModel,
								{jW: url})),
						$elm$core$Platform$Cmd$none);
				default:
					return A2(
						$author$project$Main$update,
						$author$project$Messages$Booking(
							$author$project$Messages$UrlChanged(url)),
						model);
			}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.b.$) {
						var initialMsg = _v0.a.a;
						var initialModel = _v0.b.a;
						return A2($author$project$Main$updateInitial, initialMsg, initialModel);
					} else {
						break _v0$7;
					}
				case 0:
					if (_v0.b.$ === 1) {
						var bookingMsg = _v0.a.a;
						var bookingModel = _v0.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Messages$Booking),
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Model$Booking,
								A2($author$project$Main$updateBooking, bookingMsg, bookingModel)));
					} else {
						break _v0$7;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var offlineMsg = _v0.a.a;
						var offlineModel = _v0.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Messages$Offline),
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Model$Offline,
								A2($author$project$ConnectionProblemPage$Update$update, offlineMsg, offlineModel)));
					} else {
						break _v0$7;
					}
				case 3:
					var url = _v0.a.a;
					return A2($author$project$Main$changeUrl, url, model);
				case 4:
					var urlRequest = _v0.a.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							function () {
								var _v2 = $author$project$Main$getKey(model);
								if (!_v2.$) {
									var key = _v2.a;
									return A2(
										$elm$browser$Browser$Navigation$pushUrl,
										key,
										$elm$url$Url$toString(url));
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}());
					} else {
						var href = urlRequest.a;
						return (href !== '') ? _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					switch (_v0.b.$) {
						case 0:
							var token = _v0.a.a.o9;
							var initialModel = _v0.b.a;
							return _Utils_Tuple2(
								$author$project$Model$Initial(
									_Utils_update(
										initialModel,
										{
											o9: $elm$core$Maybe$Just(token)
										})),
								$elm$core$Platform$Cmd$none);
						case 1:
							var token = _v0.a.a.o9;
							var bookingModel = _v0.b.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Messages$Booking),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Model$Booking,
									A2($author$project$Update$User$fetchClient, bookingModel, token)));
						default:
							break _v0$7;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Types$Market$translateRejectedPaymentPhoneNumber = function (market) {
	switch (market) {
		case 0:
			return function ($) {
				return $.Eo;
			};
		case 1:
			return function ($) {
				return $.Ep;
			};
		case 2:
			return function ($) {
				return $.Eq;
			};
		case 3:
			return function ($) {
				return $.Er;
			};
		case 4:
			return function ($) {
				return $.Es;
			};
		case 5:
			return function ($) {
				return $.Et;
			};
		case 6:
			return function ($) {
				return $.Em;
			};
		default:
			return function ($) {
				return $.En;
			};
	}
};
var $author$project$ConnectionProblemPage$View$customerSupportCallButton = F2(
	function (translations, market) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('outlineWhiteButton marginTopMedium'),
					$elm$html$Html$Attributes$href(
					'tel:' + A2($author$project$Types$Market$translateRejectedPaymentPhoneNumber, market, translations)),
					A2($elm$html$Html$Attributes$attribute, 'data-test-call-button', '')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Eu)
				]));
	});
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$version = _VirtualDom_attribute('version');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Common$Images$notificationExclamationMark = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('115px'),
			$elm$svg$Svg$Attributes$version('1.1'),
			$elm$svg$Svg$Attributes$viewBox('0 0 111 115'),
			$elm$svg$Svg$Attributes$width('111px')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$strokeWidth('1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill('#FFFFFF'),
							$elm$svg$Svg$Attributes$transform('translate(-105.000000, -92.000000)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$transform('translate(105.000000, 92.000000)')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M17.25,90.5 C21.254,90.5 24.5,87.254 24.5,83.25 C24.5,79.246 21.254,76 17.25,76 C13.246,76 10,79.246 10,83.25 C10,87.254 13.246,90.5 17.25,90.5')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M70.159,66.387 C73.061,66.387 75.448,64.13 75.448,61.227 C75.448,58.324 73.061,56.003 70.159,56.003 C67.192,56.003 64.87,58.324 64.87,61.227 C64.87,64.13 67.192,66.387 70.159,66.387 L70.159,66.387 Z M67.063,52.713 L73.255,52.713 L75.19,26.397 L75.19,20.85 L65.128,20.85 L65.128,26.397 L67.063,52.713 Z M69.5,83 C46.58,83 28,64.42 28,41.5 C28,18.58 46.58,0 69.5,0 C92.42,0 111,18.58 111,41.5 C111,64.42 92.42,83 69.5,83 L69.5,83 Z')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$d('M5,105 C7.761,105 10,107.239 10,110 C10,112.761 7.761,115 5,115 C2.239,115 0,112.761 0,110 C0,107.239 2.239,105 5,105')
										]),
									_List_Nil)
								]))
						]))
				]))
		]));
var $author$project$ConnectionProblemPage$View$exclamationMarkImg = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('notificationExclamationMark')
		]),
	_List_fromArray(
		[$author$project$Common$Images$notificationExclamationMark]));
var $author$project$ConnectionProblemPage$Messages$Retry = {$: 0};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$ConnectionProblemPage$View$retryButton = function (translations) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('outlineWhiteButton'),
				$elm$html$Html$Events$onClick($author$project$ConnectionProblemPage$Messages$Retry)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.xT)
			]));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $author$project$Common$Images$tallinkSiljaLogo = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('20'),
			$elm$svg$Svg$Attributes$width('62')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#FFF')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M17.3185456 15.044324L17.3089048 15.0422393C17.2669604 15.0422393 17.2304118 15.054029 17.1960217 15.0690538 16.3631037 15.192559 15.4936372 14.8607197 14.9015223 14.0918676L10.6462087 8.08626607C9.72299861 6.83899307 8.08946641 6.70261977 7.00401826 7.7872081L5.15069127 9.63913892 5.03082937 9.75825888C5.01305872 9.79370012 5.00341797 9.8302197 5.00341797 9.86832084 5.00341797 10.0057725 5.11464637 10.1136778 5.24846578 10.1239579 5.2860935 10.1136778 5.32904522 10.1067045 5.36667294 10.1003064 6.19743252 9.97629801 7.066899 10.3102221 7.65958952 11.0748328L11.9143995 17.079356C12.8358829 18.3277073 14.469487 18.4678188 15.5570935 17.3804987L17.4050246 15.5345347 17.5393476 15.393848C17.5528015 15.3632952 17.561435 15.3332457 17.561435 15.2983076 17.561435 15.160856 17.452365 15.0529507 17.3185456 15.044324M9.79060619 5.59366827C10.65036 5.41969705 11.5654402 5.73974658 12.1839593 6.53814507L16.2312772 12.2145671C16.2614226 12.2569816 16.2942299 12.3004744 16.3323612 12.3359157 16.6961198 12.6956479 17.2765076 12.6956479 17.636525 12.3359157 17.6488997 12.3235508 21.4571413 8.51890086 22.391575 7.5851355 22.4335194 7.54595603 22.4608589 7.5201479 22.4931626 7.48902 22.5097821 7.44768386 22.5291356 7.40692283 22.5291356 7.35588169 22.5291356 7.31936211 22.5215813 7.28449598 22.5081993 7.25228974L22.444743 7.15883413 20.512995 4.42698277 20.4275232 4.31037892C20.3850751 4.27817268 20.3319071 4.25509633 20.2733431 4.25509633 20.2287366 4.25509633 20.1867921 4.26746122 20.1486608 4.29053757L20.0588723 4.38557474 17.5343618 6.90161552 15.1479874 3.57373302C14.2324036 2.33451158 12.612757 2.19756317 11.536446 3.2763285L9.60520155 5.20438969 9.60088479 5.20654636C9.56059507 5.25219583 9.53426287 5.3069752 9.53426287 5.37030935 9.53426287 5.49431776 9.56707021 5.56901036 9.76319479 5.60064149L9.79060619 5.59366827zM46.936669 6.68299465C46.0661598 6.68299465 45.3576957 7.39089752 45.3576957 8.26071717L46.1726228 8.26071717C46.1726228 7.83967294 46.5152152 7.49735193 46.936669 7.49735193 47.358047 7.49735193 47.7006394 7.83967294 47.7006394 8.26071717L48.5156423 8.26071717C48.5156423 7.39089752 47.8071024 6.68299465 46.936669 6.68299465')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M56.4442371,9.86248854 C56.3309495,10.393321 55.9316376,10.9948452 55.0793272,11.4362711 L55.0793272,9.69958678 L56.4702462,9.69958678 C56.4646349,9.75330648 56.4560663,9.80763232 56.4442371,9.86248854 M56.3371675,7.55473881 L48.9717345,4.15766878 C47.4805704,3.50401598 46.0714526,3.41180601 44.8962652,3.89111603 C43.7385941,4.36247039 42.8545117,5.33927483 42.2678279,6.79304047 C41.4993078,8.7018703 40.9164913,10.2711068 39.9502867,12.8720039 C39.48417,14.1283175 38.928045,15.6267864 38.2184435,17.5186441 L39.784981,17.5186441 C40.403361,15.8673506 40.902918,14.5221609 41.3259642,13.3824547 C42.2876949,10.792847 42.8675541,9.23035393 43.6293255,7.34145115 C44.0614711,6.26842103 44.6742399,5.5644581 45.4501911,5.24865599 C46.2498767,4.92277669 47.3565153,5.07211593 48.4830209,5.54187916 C49.3749137,5.9142044 54.4065024,7.98032914 55.6807974,8.51851111 L52.145605,8.51851111 L52.145605,9.69958678 L53.8973152,9.69958678 L53.8973152,11.8731509 C53.4006396,11.9953651 52.8427706,12.0677996 52.2254522,12.0677996 C50.9080867,12.0677996 49.9934454,11.5737905 49.4769028,11.1850236 L48.5996449,12.0610562 C49.4877463,12.8227545 50.8277087,13.362073 52.2045236,13.362073 C52.4785672,13.362073 52.7419948,13.3507078 52.9956405,13.3304019 L54.2546941,17.5186441 L55.7860472,17.5186441 L54.4546534,13.0887011 C55.3047648,12.8629875 55.8801501,12.5114985 56.4107968,12.0893935 C57.2399037,11.4305885 57.7700195,10.4533294 57.7700195,9.52471363 C57.7700195,8.79127685 57.5207718,8.12519806 56.3371675,7.55473881')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$height('20'),
							$elm$svg$Svg$Attributes$width('1'),
							$elm$svg$Svg$Attributes$x('30')
						]),
					_List_Nil)
				]))
		]));
var $author$project$ConnectionProblemPage$View$tallinkLogo = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('tallinkLogo')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image')
				]),
			_List_fromArray(
				[$author$project$Common$Images$tallinkSiljaLogo]))
		]));
var $author$project$ConnectionProblemPage$View$view = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	var translations = $author$project$Translations$forLanguage(language);
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('connectionProblemPage')
			]),
		_List_fromArray(
			[
				$author$project$ConnectionProblemPage$View$tallinkLogo,
				$author$project$ConnectionProblemPage$View$exclamationMarkImg,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text bodyLargeBoldWhite')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.xS)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text bodyLargeWhite')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.xR)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginHorizontalMedium')
					]),
				_List_fromArray(
					[
						$author$project$ConnectionProblemPage$View$retryButton(translations),
						A2($author$project$ConnectionProblemPage$View$customerSupportCallButton, translations, market)
					]))
			]));
};
var $author$project$Messages$ClickedBookNow = {$: 116};
var $author$project$Messages$LandServiceMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Price$View$Button = $elm$core$Basics$identity;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Price$View$bookNowButton = F3(
	function (msg, disabled, translations) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('floatButton book'),
					$elm$html$Html$Attributes$disabled(disabled),
					$elm$html$Html$Events$onClick(msg),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'float-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(translations.E6)
						]))
				]));
	});
var $author$project$Messages$ClickedDoneButtonInTimetable = {$: 60};
var $author$project$Messages$ClosedCalendar = {$: 70};
var $author$project$Messages$OpenedReturnTab = {$: 68};
var $author$project$Price$View$cancelButton = F2(
	function (msg, translations) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('floatButton'),
					$elm$html$Html$Events$onClick(msg),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'float-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(translations.E7)
						]))
				]));
	});
var $author$project$Price$View$continueButton = F2(
	function (msg, translations) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('floatButton'),
					$elm$html$Html$Events$onClick(msg),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'float-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(translations.E8)
						]))
				]));
	});
var $author$project$Price$View$doneButton = F3(
	function (attributes, msg, translations) {
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('floatButton'),
						$elm$html$Html$Events$onClick(msg),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'float-button')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(translations.E9)
						]))
				]));
	});
var $author$project$Types$Trips$isFailure = function (status) {
	if (status.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Timetable$PriceBar$button = F2(
	function (url, _v0) {
		var isTimetableFirstVisit = _v0.Av;
		var location = _v0.n1;
		var session = _v0.j;
		var route = $author$project$UrlRoute$parseLocation(url);
		var directionRouteButton = function (timetableDirectionRoute) {
			switch (timetableDirectionRoute) {
				case 0:
					return (isTimetableFirstVisit && (!$author$project$Types$Trips$isFailure(session.tp))) ? $author$project$Price$View$continueButton($author$project$Messages$OpenedReturnTab) : A2($author$project$Price$View$doneButton, _List_Nil, $author$project$Messages$ClickedDoneButtonInTimetable);
				case 1:
					return $author$project$Price$View$cancelButton($author$project$Messages$ClosedCalendar);
				case 2:
					return A2($author$project$Price$View$doneButton, _List_Nil, $author$project$Messages$ClickedDoneButtonInTimetable);
				default:
					return $author$project$Price$View$cancelButton($author$project$Messages$ClosedCalendar);
			}
		};
		if (route.$ === 1) {
			switch (route.a.$) {
				case 0:
					var _v2 = route.a;
					var maybeSelectedCruiseSail = function () {
						var _v3 = session.tp;
						_v3$2:
						while (true) {
							switch (_v3.$) {
								case 0:
									if (!_v3.a.$) {
										var cruise = _v3.a.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$CruiseSails$selected(cruise).b);
									} else {
										break _v3$2;
									}
								case 2:
									if ((!_v3.a.$) && (!_v3.a.a.$)) {
										var cruise = _v3.a.a.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$CruiseSails$selected(cruise).b);
									} else {
										break _v3$2;
									}
								default:
									break _v3$2;
							}
						}
						return $elm$core$Maybe$Nothing;
					}();
					var isSelectedCruiseSailNonBookable = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.z6;
							},
							maybeSelectedCruiseSail));
					return A2(
						$author$project$Price$View$doneButton,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(isSelectedCruiseSailNonBookable)
							]),
						$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root));
				case 1:
					var _v4 = route.a;
					return A2(
						$author$project$Price$View$doneButton,
						_List_Nil,
						$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root));
				case 2:
					var _v5 = route.a;
					return $author$project$Price$View$cancelButton($author$project$Messages$ClosedCalendar);
				case 3:
					var timetableDirectionRoute = route.a.a;
					return directionRouteButton(timetableDirectionRoute);
				default:
					var timetableDirectionRoute = route.a.a;
					return directionRouteButton(timetableDirectionRoute);
			}
		} else {
			return A2(
				$author$project$Price$View$doneButton,
				_List_Nil,
				$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root));
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.c, s.sA, s.pS, s.GP);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.f)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, newOffset) < 0,
			0,
			{pS: newCol, f: s.f, l: s.l, c: newOffset, sA: newRow, GP: s.GP});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$comment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($hecrj$html_parser$Html$Parser$Comment),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {pS: s.pS + (newOffset - s.c), f: s.f, l: s.l, c: newOffset, sA: s.sA, GP: s.GP};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.GP);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.sA, s.pS - (floatOffset + s.c), invalid, s.f));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.GP));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.GP)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.GP) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.z3,
				c.qB,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.GP),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.GP) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.z3,
				c.rD,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.GP),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.GP) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.z3,
				c.pw,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.GP),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.z3,
				c.qh,
				c.qK,
				c.qm,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.z3,
				c.qh,
				c.qK,
				c.qm,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.GP),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				pw: $elm$core$Result$Err(invalid),
				qh: expecting,
				qm: $elm$core$Result$Err(invalid),
				qB: $elm$core$Result$Err(invalid),
				qK: $elm$core$Result$Ok($elm$core$Basics$identity),
				z3: invalid,
				rD: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Translations$toHtml = A2(
	$elm$core$Basics$composeR,
	$hecrj$html_parser$Html$Parser$run,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Result$map($hecrj$html_parser$Html$Parser$Util$toVirtualDom),
		$elm$core$Result$withDefault(_List_Nil)));
var $author$project$PaymentPage$View$errorView = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error bodyNorm')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				$author$project$Translations$toHtml(translations.CM))
			]));
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$View$freezeAttributes = function (modal) {
	if (!modal.$) {
		var position = modal.b;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed'),
				A2(
				$elm$html$Html$Attributes$style,
				'marginTop',
				$elm$core$String$fromFloat(-position) + 'px')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Types$ShipCode$getShipBackgroundClassName = function (shipCode) {
	switch (shipCode.$) {
		case 0:
			return 'europaBackground';
		case 1:
			return 'galaxyBackground';
		case 2:
			return 'isabelleBackground';
		case 3:
			return 'megastarBackground';
		case 4:
			return 'princessBackground';
		case 5:
			return 'queenBackground';
		case 6:
			return 'romantikaBackground';
		case 7:
			return 'seawindBackground';
		case 8:
			return 'serenadeBackground';
		case 9:
			return 'starBackground';
		case 10:
			return 'superBackground';
		case 11:
			return 'symphonyBackground';
		case 12:
			return 'victoriaBackground';
		case 13:
			return 'sailorBackground';
		case 14:
			return 'regalstarBackground';
		case 15:
			return 'mystarBackground';
		case 16:
			return 'superfastBackground';
		default:
			return 'fallbackBackground';
	}
};
var $author$project$Session$getShipCode = function (session) {
	return A2(
		$elm$core$Maybe$map,
		function (trips) {
			switch (trips.$) {
				case 0:
					var cruise = trips.a;
					return $author$project$Types$CruiseSails$selected(cruise).b.Dz;
				case 1:
					var route = trips.a;
					return $author$project$Types$RouteTripSails$selected(route).a.oX;
				default:
					var cruiseMultiDeparture = trips.a;
					return $author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture).oX;
			}
		},
		$author$project$Types$Trips$statusToMaybe(session.tp));
};
var $author$project$Session$getShipBackgroundClassName = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		'megastarBackground',
		A2(
			$elm$core$Maybe$map,
			$author$project$Types$ShipCode$getShipBackgroundClassName,
			$author$project$Session$getShipCode(session)));
};
var $author$project$Utils$SelectedMeals$hasAllRequiredAddonSelections = function (session) {
	var _v0 = $author$project$Utils$SelectedMeals$findMealWithIncompleteSelection(session);
	if (!_v0.$) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Types$Hotel$hasSelections = function (_v0) {
	var dict = _v0;
	return !$elm$core$Dict$isEmpty(dict);
};
var $author$project$Price$View$isBookNowButtonShown = function (model) {
	var session = model.j;
	var isHotelPackageSelected = (session.vk === 1) && $author$project$Types$Hotel$hasSelections(session.Gk);
	return function (a) {
		return (session.vk === 1) ? (a && isHotelPackageSelected) : a;
	}(
		(!_Utils_eq(session.B7, $elm$core$Maybe$Nothing)) && ((!($author$project$Price$View$isMinCabinPriceUnavailable(session) || $author$project$Price$View$showAddMoreTravelClassesNotice(model))) && $author$project$Utils$SelectedMeals$hasAllRequiredAddonSelections(session)));
};
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$View$a11yLink = F3(
	function (language, market, translations) {
		var isSupportedMarket = !A2(
			$elm$core$List$member,
			market,
			_List_fromArray(
				[5]));
		var isSupportedLanguage = !A2(
			$elm$core$List$member,
			language,
			_List_fromArray(
				[7, 9, 6]));
		return A2(
			$author$project$Utils$String$renderIf,
			isSupportedLanguage && isSupportedMarket,
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('a11yLink'),
						$elm$html$Html$Attributes$href(translations.Q),
						$elm$html$Html$Attributes$target('_blank'),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', translations.P)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src('/assets/images/common/accessibility.svg'),
								$elm$html$Html$Attributes$alt('')
							]),
						_List_Nil)
					])));
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Messages$ClickedSignOutFromCompany = {$: 97};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$BookingPage$Panel$User$View$signOutLink = F2(
	function (translations, msg) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('link1'),
					$elm$html$Html$Events$onClick(msg)
				]),
			$author$project$Translations$toHtml(translations.vg));
	});
var $author$project$BookingPage$Panel$User$View$companyCustomerSignedIn = F2(
	function (translations, details) {
		var _v0 = details.tT;
		var street = _v0.G0;
		var zipCode = _v0.IG;
		var city = _v0.v0;
		var addressInfo = $elm$core$String$toLower(street) + (', ' + (zipCode + (' ' + $elm$core$String$toLower(city))));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_Nil,
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('data companyName')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$String$capitalizeFirstLetters(details.oh))
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$BookingPage$Panel$User$View$signOutLink, translations, $author$project$Messages$ClickedSignOutFromCompany)
						]))),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm companyAddress')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$String$capitalizeFirstLetters(addressInfo))
							]))
					]))
			]);
	});
var $author$project$Common$Arrow$right = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('arrow')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text(' → ')
		]));
var $author$project$BookingPage$Panel$User$View$companyCustomer = F2(
	function (translations, company) {
		return A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('companyClientLink link1Book'),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$ChangedLocation($author$project$UrlRoute$CompanyCustomer))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.uI),
						$author$project$Common$Arrow$right
					])),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var details = _v0.yt;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel')
							]),
						A2($author$project$BookingPage$Panel$User$View$companyCustomerSignedIn, translations, details));
				},
				company));
	});
var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
	if (!data.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Common$Images$colors = {ev: '#004152', tl: '#D6DFDF', tv: '#6ecbd9', l0: '#fff'};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Common$Images$propeller = F2(
	function (className, color) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(className),
					$elm$svg$Svg$Attributes$width('616'),
					$elm$svg$Svg$Attributes$viewBox('0 0 616 616')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$fill(color),
							$elm$svg$Svg$Attributes$class('propeller'),
							$elm$svg$Svg$Attributes$d('m228.88327,288.700012c-24.810471,-9.100006 -66.227966,-14.900024 -105.944763,7.399994c-67.028347,37.199982 -130.755207,-19.800018 -121.651377,-82.700012c8.30351,-55.399994 43.018191,-112.499992 86.036356,-135.599991c65.327545,-33.900002 115.048584,-14.900002 153.064621,26.5c24.810471,27.300003 51.321701,75.300003 53.822739,120.699997c0.800354,21.5 25.61084,20.699997 32.31366,3.300003c9.103851,-24.800003 14.906311,-66.199997 -7.403137,-105.900002c-37.315765,-66.900002 19.80838,-130.600001 82.734955,-121.500001c55.423431,8.2 112.44751,42.1 135.657288,86.000001c33.914368,65.299995 14.906311,114.999992 -26.5112,152.999992c-27.311523,24.800018 -75.331818,51.300018 -120.750977,53.800018c-21.509064,0.799988 -20.70874,25.599976 -3.301422,32.299988c24.810486,9.100006 66.227997,14.899994 105.944763,-7.399994c67.02832,-37.200012 130.755249,19.799988 121.651367,82.699982c-8.303528,55.400024 -42.217834,112.5 -86.036316,135.600037c-65.327606,33.899963 -115.048584,14.899963 -153.064667,-26.500031c-24.810486,-27.299988 -51.321686,-75.299988 -53.822723,-120.699982c-0.800323,-21.5 -25.610809,-20.700012 -32.31366,-3.300018c-9.103851,24.800018 -14.906281,66.200012 7.403107,105.899994c37.21579,67 -19.80835,130.700012 -82.734909,121.600037c-55.423401,-8.300049 -112.547562,-42.200012 -135.657288,-86c-33.914356,-65.300018 -14.906338,-115.000031 26.5112,-153.000031c27.311523,-24.799988 75.331818,-51.299988 120.751007,-53.799988c20.708725,-1.800018 19.908401,-26.600006 3.301376,-32.399994l0,0l0,0zm78.633209,50.399994c17.407349,0 31.413269,-14.100006 31.413269,-31.399994c0,-17.400024 -14.105957,-31.400024 -31.413269,-31.400024c-17.407349,0 -31.413269,14.100006 -31.413269,31.400024c0,17.399994 14.00592,31.399994 31.413269,31.399994l0,0l0,0z')
						]),
					_List_Nil)
				]));
	});
var $author$project$Common$Images$darkPropellerWithClassName = function (className) {
	return A2($author$project$Common$Images$propeller, className, $author$project$Common$Images$colors.ev);
};
var $author$project$BookingPage$Panel$User$View$loader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loader'),
			A2($elm$html$Html$Attributes$attribute, 'data-test-sign-in-status', 'loading')
		]),
	_List_fromArray(
		[
			$author$project$Common$Images$darkPropellerWithClassName('animateSpinner')
		]));
var $author$project$Messages$ClickedSignOut = {$: 94};
var $author$project$BookingPage$Panel$User$View$clubOneCardSvgUrl = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$Basics$composeR, $author$project$Types$ClubOneLevel$toString, $elm$core$String$toLower),
	function (a) {
		return '/assets/images/clubOne/level_' + (a + '.png');
	});
var $author$project$Types$ClubOneLevel$translate = function (clubOneLevel) {
	switch (clubOneLevel) {
		case 0:
			return function ($) {
				return $.bC;
			};
		case 1:
			return function ($) {
				return $.bB;
			};
		case 2:
			return function ($) {
				return $.b$;
			};
		case 3:
			return function ($) {
				return $.bD;
			};
		case 4:
			return function ($) {
				return $.b_;
			};
		default:
			return function ($) {
				return $.bE;
			};
	}
};
var $author$project$BookingPage$Panel$User$View$clubOneStatus = F2(
	function (level, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('clubOneStatus')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$BookingPage$Panel$User$View$clubOneCardSvgUrl(level))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm'),
							A2($elm$html$Html$Attributes$attribute, 'data-test-sign-in-club-one-level', '')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$ClubOneLevel$translate, level, translations))
						]))
				]));
	});
var $author$project$Types$Market$formatIntegerPartOfPriceString = A2(
	$elm$regex$Regex$replace,
	A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(\\d)(?=(\\d{3})+(?!\\d))')),
	function (_v0) {
		var match = _v0.BJ;
		return match + ' ';
	});
var $elm$html$Html$wbr = _VirtualDom_node('wbr');
var $author$project$Types$Market$formattedPointsView = F2(
	function (translations, price) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('noWrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Types$Market$formatIntegerPartOfPriceString)(price))
					])),
				A2($elm$html$Html$wbr, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('noWrap')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(' ' + translations.b2)
					]))
			]);
	});
var $author$project$BookingPage$Panel$User$View$clubOneInfo = F2(
	function (translate, _v0) {
		var points = _v0.E0;
		var level = _v0.A8;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('clubOneInfo')
						]),
					_List_fromArray(
						[
							A2($author$project$BookingPage$Panel$User$View$clubOneStatus, level, translate),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('data clubOnePointsAmount')
								]),
							A2($author$project$Types$Market$formattedPointsView, translate, points))
						]))
				]));
	});
var $author$project$BookingPage$Panel$User$View$joinClubOneLink = function (translations) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('joinClubOneLink title1Medium'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-sign-in-join-club-one-link', ''),
				$elm$html$Html$Attributes$href(translations.vf),
				$elm$html$Html$Attributes$target('_blank')
			]),
		$author$project$Translations$toHtml(translations.ve));
};
var $author$project$BookingPage$Panel$User$View$signedIn = F3(
	function (translate, _v0, isNative) {
		var maybeClubOne = _v0.BP;
		var firstName = _v0.y2;
		var lastName = _v0.A6;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test-sign-in-status', 'signed-in')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					_List_Nil,
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('data'),
										A2($elm$html$Html$Attributes$attribute, 'data-test-sign-in-user-name', '')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$trim(
											$author$project$Utils$String$capitalizeFirstLetters(firstName + (' ' + lastName))))
									]))
							]),
						isNative ? _List_Nil : _List_fromArray(
							[
								A2($author$project$BookingPage$Panel$User$View$signOutLink, translate, $author$project$Messages$ClickedSignOut)
							]))),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$BookingPage$Panel$User$View$joinClubOneLink(translate),
					A2(
						$elm$core$Maybe$map,
						$author$project$BookingPage$Panel$User$View$clubOneInfo(translate),
						maybeClubOne))
				]));
	});
var $author$project$Messages$OpenedSignInPage = {$: 96};
var $author$project$Common$Images$AccountIcon$accountIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('22'),
			$elm$svg$Svg$Attributes$height('22'),
			$elm$svg$Svg$Attributes$viewBox('0 0 22 22')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M11 0C4.924 0 0 4.924 0 11s4.924 11 11 11 11-4.924 11-11S17.076 0 11 0zM3.667 17.983c.92-.69 2.037-1.185 3.65-1.89l.53-.23c1.56-1.632-.304-4.273-.468-4.5-.147-.158-.852-.993-.506-2.2-.177-.59-.82-3.096.403-4.77.71-.972 1.89-1.47 3.52-1.48 1.547-.366 2.74-.117 3.554.753 1.37 1.456 1.135 4.133.87 5.095.1.342.22 1.19-.457 2.528-.12.232-.252.477-.39.722-.917 1.635-1.422 2.79-.168 3.826.443.13 2.427.778 4.128 2.274a10.345 10.345 0 0 1-7.278 2.973c-2.9 0-5.52-1.193-7.388-3.1z')
				]),
			_List_Nil)
		]));
var $author$project$BookingPage$Panel$User$View$signedOut = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-test-sign-in-status', 'signed-out')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title bodyNorm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.vh)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('blueButton signIn'),
								$elm$html$Html$Events$onClick($author$project$Messages$OpenedSignInPage)
							]),
						_List_fromArray(
							[
								$author$project$Common$Images$AccountIcon$accountIcon,
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(translations.uJ)
									]))
							]))
					]))
			]));
};
var $author$project$BookingPage$Panel$User$View$root = F4(
	function (translations, clientWebData, isNative, company) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'view', 'userSection')
				]),
			$elm$core$List$singleton(
				(isNative && $krisajenkins$remotedata$RemoteData$isNotAsked(clientWebData)) ? A2($author$project$BookingPage$Panel$User$View$companyCustomer, translations, company) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel')
						]),
					function () {
						if (!company.$) {
							var details = company.a.yt;
							return A2($author$project$BookingPage$Panel$User$View$companyCustomerSignedIn, translations, details);
						} else {
							switch (clientWebData.$) {
								case 1:
									return _List_fromArray(
										[$author$project$BookingPage$Panel$User$View$loader]);
								case 3:
									var client = clientWebData.a;
									return _List_fromArray(
										[
											A3($author$project$BookingPage$Panel$User$View$signedIn, translations, client, isNative),
											A2($author$project$BookingPage$Panel$User$View$companyCustomer, translations, company)
										]);
								default:
									return _List_fromArray(
										[
											$author$project$BookingPage$Panel$User$View$signedOut(translations),
											A2($author$project$BookingPage$Panel$User$View$companyCustomer, translations, company)
										]);
							}
						}
					}())));
	});
var $author$project$Messages$ChangedBookingType = function (a) {
	return {$: 54, a: a};
};
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $author$project$Common$Images$bookingTypeImageBase = function (_v0) {
	var d = _v0.mn;
	var color = _v0.kt;
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$height('20'),
				$elm$svg$Svg$Attributes$width('20')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill(color),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d(d)
					]),
				_List_Nil)
			]));
};
var $author$project$Common$Images$ferry = function (color) {
	return $author$project$Common$Images$bookingTypeImageBase(
		{kt: color, mn: 'M2.712 16.396h.044c1.418-.063 2.739-.728 3.625-1.824.885 1.095 2.203 1.76 3.619 1.824 1.418-.06 2.74-.725 3.625-1.824.886 1.096 2.207 1.76 3.625 1.824h.044l1.718-6.084c.07-.236.05-.49-.057-.712-.11-.218-.306-.381-.543-.45l-1.156-.405V4.56c0-.995-.807-1.804-1.812-1.818h-2.716V0H7.284v2.742H4.57c-1.005.014-1.813.823-1.813 1.818v4.185l-1.174.387c-.236.07-.432.233-.543.45-.108.222-.126.476-.051.712l1.724 6.102zm1.85-11.78h10.875V8.2L10 6.427 4.562 8.201V4.616zm9.044 12.261c1.05.78 2.32 1.216 3.631 1.25l1.826-.013v1.873H17.25c-1.267 0-2.514-.31-3.631-.899-2.264 1.187-4.975 1.187-7.238 0-1.118.59-2.364.903-3.631.912H.937v-1.874h1.8c1.313-.033 2.582-.47 3.632-1.249 2.148 1.58 5.09 1.58 7.237 0z'});
};
var $author$project$Common$Images$ferryDark = $author$project$Common$Images$ferry($author$project$Common$Images$colors.ev);
var $author$project$Common$Images$hotel = function (color) {
	return $author$project$Common$Images$bookingTypeImageBase(
		{kt: color, mn: 'M.088 12.286l.77.93c.066.076.152.122.26.14h.037c.108 0 .194-.03.26-.089L10 6.006l8.584 7.261c.1.067.199.097.298.088.108-.017.194-.063.26-.138l.77-.931c.066-.084.095-.183.087-.296-.009-.114-.054-.204-.137-.27l-8.92-7.54c-.264-.217-.578-.326-.942-.326s-.678.109-.943.327L6.03 6.748l-3.175 2.68L.138 11.72c-.083.067-.128.158-.137.27-.008.114.021.213.087.296zm2.767 6.909v-6.041c0-.034.004-.059.012-.076L10 7.113l7.133 5.965c0 .009.002.021.006.038.004.017.006.03.006.038v6.04c0 .219-.078.408-.235.567-.157.16-.343.24-.558.24h-4.764v-4.834H8.412V20H3.65c-.216 0-.402-.08-.559-.24-.157-.159-.235-.347-.235-.565zM19.998 5.278c-.007-.03-.03-.052-.058-.059-.095-.02-.19-.045-.28-.075-.95-.301-1.683-1.019-2.013-1.967-.33-.95-.203-1.975.348-2.814.053-.08.111-.16.172-.237.019-.023.022-.055.01-.082-.014-.027-.04-.044-.07-.044-.32.004-.638.062-.943.171-1.536.55-2.344 2.266-1.802 3.824.543 1.558 2.234 2.379 3.77 1.828.305-.109.587-.266.839-.467.023-.018.034-.049.027-.078z'});
};
var $author$project$Common$Images$hotelDark = $author$project$Common$Images$hotel($author$project$Common$Images$colors.ev);
var $author$project$Common$Images$sun = function (color) {
	return $author$project$Common$Images$bookingTypeImageBase(
		{kt: color, mn: 'M16.347 9.994c.003-.857-.168-1.706-.502-2.494-.316-.768-.776-1.466-1.354-2.056-.582-.586-1.27-1.052-2.028-1.373-.778-.338-1.616-.511-2.463-.508-.847-.003-1.686.17-2.464.508-.757.321-1.445.787-2.028 1.373-.57.577-1.02 1.262-1.354 2.056-.334.788-.504 1.637-.502 2.494 0 .873.166 1.703.502 2.497.334.792.785 1.477 1.354 2.054.57.577 1.246 1.034 2.028 1.374.779.337 1.617.51 2.464.506.846.003 1.685-.17 2.463-.507.757-.322 1.446-.788 2.028-1.374.57-.577 1.02-1.263 1.354-2.055.334-.789.505-1.638.502-2.496v.001zm3.042 3.094c-.028.11-.112.196-.22.223l-3.218 1.072v3.42c.001.113-.052.22-.143.288-.11.075-.218.09-.32.045l-3.219-1.051-1.983 2.77c-.066.093-.173.147-.286.145-.113.002-.22-.052-.287-.145L7.73 17.087l-3.219 1.049c-.102.045-.209.03-.32-.045-.091-.068-.145-.176-.142-.29v-3.417L.83 13.31c-.108-.027-.193-.113-.22-.223-.038-.127-.025-.232.04-.324l1.985-2.768L.652 7.225C.586 7.13.57 7.008.609 6.899c.027-.11.112-.195.22-.223l3.218-1.07v-3.42c-.002-.114.051-.222.143-.29.11-.073.217-.088.32-.043l3.218 1.05L9.713.134C9.781.042 9.89-.008 10 0c.125 0 .22.045.286.133l1.985 2.77 3.219-1.05c.102-.044.209-.029.32.044.091.067.144.176.142.29v3.419l3.218 1.07c.108.028.193.114.22.224.04.11.023.23-.042.325l-1.985 2.768 1.985 2.77c.066.09.08.197.043.324h-.002z'});
};
var $author$project$Common$Images$sunDark = $author$project$Common$Images$sun($author$project$Common$Images$colors.ev);
var $author$project$Translations$t = F2(
	function (language, translate) {
		return translate(
			$author$project$Translations$forLanguage(language));
	});
var $author$project$BookingPage$Panel$BookingType$View$view = F2(
	function (url, session) {
		var language = session.A_;
		var isHotelLinksPage = _Utils_eq(
			$author$project$UrlRoute$parseLocation(url),
			$author$project$UrlRoute$HotelLinks);
		var isHotelPackage = (!isHotelLinksPage) && (session.vk === 1);
		var isRegular = (!isHotelLinksPage) && (!session.vk);
		return A2(
			$author$project$Utils$String$renderIf,
			$author$project$Types$Language$supportsHotels(language),
			A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'ui-view', 'bookingType'),
						$elm$html$Html$Attributes$class('panel')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bookingType ferry'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('active', isRegular)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$Messages$ChangedBookingType(0))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Common$Images$ferryDark,
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bodySmallBold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$toUpper(
															A2(
																$author$project$Translations$t,
																language,
																function ($) {
																	return $.y_;
																})))
													]))
											]))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bookingType hotelPackage '),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('active', isHotelPackage)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$Messages$ChangedBookingType(1))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Common$Images$sunDark,
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bodySmallBold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$toUpper(
															A2(
																$author$project$Translations$t,
																language,
																function ($) {
																	return $.y$;
																})))
													]))
											]))
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bookingType hotel'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('active', isHotelLinksPage)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$Messages$ChangedLocation($author$project$UrlRoute$HotelLinks))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Common$Images$hotelDark,
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('bodySmallBold')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$toUpper(
															A2(
																$author$project$Translations$t,
																language,
																function ($) {
																	return $.zv;
																})))
													]))
											]))
									]))
							])),
						A2(
						$author$project$Utils$String$renderIf,
						isHotelLinksPage,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm mediumPadding')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.zz;
										}))
								])))
					])));
	});
var $author$project$View$mainPageSkeleton = F3(
	function (model, withFixedButton, content) {
		var session = model.j;
		var translations = $author$project$Translations$forLanguage(session.A_);
		var backgroundImageClass = _Utils_eq(
			$author$project$UrlRoute$parseLocation(model.n1),
			$author$project$UrlRoute$HotelLinks) ? 'hotelBackground' : $author$project$Session$getShipBackgroundClassName(session);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('background ' + backgroundImageClass)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('safePaddingTop'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('native', model.qV)
							])),
						A2($elm$html$Html$Attributes$attribute, 'ui-view', 'header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Utils$String$renderIf,
						!model.qV,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tallinkLogo')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/logo_combined_tallink_silja_full.svg')
										]),
									_List_Nil)
								]))),
						A3($author$project$View$a11yLink, session.A_, session.rb, translations)
					])),
				A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('adobe-target-element')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('booking gradient page'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('withFixedButton', withFixedButton),
								_Utils_Tuple2(
								'withDynamicPriceBar',
								!_Utils_eq(model.j.B7, $elm$core$Maybe$Nothing))
							]))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A4($author$project$BookingPage$Panel$User$View$root, translations, session.Ia.v4, model.qV, model.j.xA),
							A2($author$project$BookingPage$Panel$BookingType$View$view, model.n1, session)
						]),
					content))
			]);
	});
var $author$project$Messages$MealPageMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Common$Section$header = function (attributes) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$html$Html$text,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$html$Html$div(
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('header title1Medium'),
					attributes))));
};
var $author$project$Common$Panel$block = function (elements) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mediumPadding')
			]),
		elements);
};
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$MealPage$Meal$includedMealPackageContent = function (_v0) {
	var translations = _v0.lY;
	var session = _v0.j;
	var mealPackage = _v0.lB;
	return $author$project$Common$Panel$block(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('disabledContent')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selectItem buttonTextSmall rotateActiveIcon active'),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'select-meal-button'),
								A2($elm$html$Html$Attributes$attribute, 'data-is-active', '')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selectItemContent')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(translations.wL)
									]))
							])),
						function (description) {
						return $elm$core$List$isEmpty(description) ? $elm$html$Html$text('') : A2(
							$elm$html$Html$pre,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm mealPackageDescription')
								]),
							description);
					}(
						$author$project$Translations$toHtml(mealPackage.nt)),
						A2(
						$elm$html$Html$pre,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mealPackageDescription bodyNorm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.rt)
							]))
					]))
			]));
};
var $author$project$Common$Panel$view = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel bodyNorm'),
				attributes),
			elements);
	});
var $author$project$Common$Section$view = function (attributes) {
	return $elm$html$Html$section(
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('section'),
			attributes));
};
var $author$project$MealPage$Meal$includedMealPackageView = function (params) {
	var translations = params.lY;
	var session = params.j;
	var mealPackage = params.lB;
	return A2(
		$author$project$Common$Section$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mealPackage'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'meal-package')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Common$Section$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginHorizontalSmall')
					]),
				translations.ru),
				A2(
				$author$project$Common$Panel$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mealCard marginHorizontalSmall')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('packageHeader')
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (url) {
										return _List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'background', 'url(' + (url + ')')),
												A2($elm$html$Html$Attributes$style, 'background-size', 'cover')
											]);
									},
									mealPackage.zP))),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('overlay')
									]),
								_List_Nil)
							])),
						$author$project$MealPage$Meal$includedMealPackageContent(params)
					]))
			]));
};
var $author$project$MealPage$Meal$Reservation = {$: 0};
var $author$project$MealPage$Meal$ReservationWithFee = function (a) {
	return {$: 1, a: a};
};
var $author$project$MealPage$Meal$findMaxOriginalPrice = A2(
	$elm$core$List$foldl,
	F2(
		function (_v0, maxPrice) {
			var originalPrice = _v0.rL;
			return A2($elm$core$Basics$max, originalPrice, maxPrice);
		}),
	0);
var $author$project$MealPage$Meal$AdditionalPrice = function (a) {
	return {$: 2, a: a};
};
var $author$project$MealPage$Meal$findMaxPrice = A2(
	$elm$core$List$foldl,
	F2(
		function (_v0, maxPrice) {
			var price = _v0.lN;
			return A2($elm$core$Basics$max, price, maxPrice);
		}),
	0);
var $author$project$MealPage$Meal$getAdditionalPrice = function (includedPrice) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$author$project$MealPage$Meal$AdditionalPrice,
			function (price) {
				return price - includedPrice;
			}),
		$author$project$MealPage$Meal$findMaxPrice);
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MealPage$Meal$getMinPrice = function (sittings) {
	return $elm$core$List$minimum(
		A2(
			$elm$core$List$filter,
			function (a) {
				return a > 0;
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.lN;
				},
				sittings)));
};
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$MealPage$Meal$getCheapestPrices = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return _Utils_Tuple2(
				$author$project$MealPage$Meal$getMinPrice(a.kC),
				$author$project$MealPage$Meal$getMinPrice(a.k4));
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$unzip,
		A2(
			$elm$core$Tuple$mapBoth,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap($elm$core$Basics$identity),
				$elm$core$List$minimum),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap($elm$core$Basics$identity),
				$elm$core$List$minimum))));
var $author$project$MealPage$Meal$Price = function (a) {
	return {$: 4, a: a};
};
var $author$project$MealPage$Meal$getPrice = A2($elm$core$Basics$composeL, $author$project$MealPage$Meal$Price, $author$project$MealPage$Meal$findMaxPrice);
var $author$project$MealPage$Meal$PricePerAdult = function (a) {
	return {$: 3, a: a};
};
var $author$project$MealPage$Meal$getPricePerAdult = A2($elm$core$Basics$composeL, $author$project$MealPage$Meal$PricePerAdult, $author$project$MealPage$Meal$findMaxPrice);
var $author$project$Types$MealPackage$isCampCode = function (code) {
	var string = code;
	return A2($elm$core$String$contains, 'CAMP', string);
};
var $author$project$Types$Date$init = F3(
	function (year, month, day) {
		return {
			q: A3(
				$elm$core$Basics$clamp,
				1,
				A2($author$project$Utils$Time$daysInMonth, year, month),
				day),
			s: month,
			h: year
		};
	});
var $author$project$MealPage$Meal$isChristmasTavalotaSitting = function (sitting) {
	return (sitting.FJ === 'A LA CARTE SYMP') && (_Utils_eq(
		sitting.BU,
		$elm$core$Maybe$Just(3)) && _Utils_eq(
		$author$project$Types$Date$fromPosix(sitting.ut),
		A3($author$project$Types$Date$init, 2024, 11, 24)));
};
var $author$project$MealPage$Meal$isMealUsedInMealPackage = F4(
	function (ship, meal, meals, _package) {
		return A2(
			$elm$core$List$any,
			function (sitting) {
				return A2(
					$elm$core$List$any,
					$author$project$Types$Meals$isSameSitting(sitting),
					_Utils_ap(meal.kC, meal.k4));
			},
			A3(
				$author$project$Types$MealPackage$getSelections,
				ship,
				_package,
				A2(
					$elm$core$List$concatMap,
					function (_v0) {
						var outwardSittings = _v0.kC;
						var returnSittings = _v0.k4;
						return _Utils_ap(outwardSittings, returnSittings);
					},
					$author$project$Types$Meals$toList(meals))));
	});
var $author$project$MealPage$Meal$minPassengersToWaiveTableReservationFee = 12;
var $author$project$MealPage$Meal$isTableReservationFeeWaived = function (_v0) {
	var passengers = _v0.Eg;
	return _Utils_cmp(
		$elm$core$Array$length(passengers),
		$author$project$MealPage$Meal$minPassengersToWaiveTableReservationFee) > -1;
};
var $author$project$Common$Panel$centeredTitle = function (string) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('centeredTitle title2')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Common$Panel$column = function (elements) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panelColumn')
			]),
		elements);
};
var $author$project$Types$Market$decimalSeparator = function (market) {
	return (market === 5) ? '.' : ',';
};
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $author$project$Types$Market$formatDecimalPartOfPriceString = F2(
	function (market, priceString) {
		var _v0 = A2($elm$core$String$split, '.', priceString);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var integerPart = _v0.a;
			var _v1 = _v0.b;
			var decimalPart = _v1.a;
			return _Utils_ap(
				integerPart,
				_Utils_ap(
					$elm$core$String$fromChar(
						$author$project$Types$Market$decimalSeparator(market)),
					A2(
						$elm$core$String$left,
						2,
						A3($elm$core$String$padRight, 2, '0', decimalPart))));
		} else {
			return priceString;
		}
	});
var $author$project$Types$Market$formatPrice = function (market) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromFloat,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Types$Market$formatIntegerPartOfPriceString,
			$author$project$Types$Market$formatDecimalPartOfPriceString(market)));
};
var $author$project$Types$Market$toCurrencySign = function (market) {
	switch (market) {
		case 3:
			return 'SEK';
		case 7:
			return 'SEK';
		case 4:
			return ':-';
		default:
			return '€';
	}
};
var $author$project$Types$Market$formatPriceWithSign = F2(
	function (market, price) {
		return A2($author$project$Types$Market$formatPrice, market, price) + (' ' + $author$project$Types$Market$toCurrencySign(market));
	});
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Common$Panel$graySeparator = function (attributes) {
	return A2(
		$elm$html$Html$hr,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('gray'),
			attributes),
		_List_Nil);
};
var $author$project$MealPage$Meal$hasBothLegs = F2(
	function (isOneWay, voyageType) {
		return ((!isOneWay) && A2(
			$elm$core$List$member,
			voyageType,
			_List_fromArray(
				[$author$project$Types$VoyageType$Shuttle, $author$project$Types$VoyageType$RouteTrip]))) || A2(
			$elm$core$List$member,
			voyageType,
			_List_fromArray(
				[
					$author$project$Types$VoyageType$Cruise,
					$author$project$Types$VoyageType$CruiseMultiship,
					$author$project$Types$VoyageType$CruiseMultistop,
					$author$project$Types$VoyageType$CruiseMultiDeparture(1),
					$author$project$Types$VoyageType$CruiseMultiDeparture(0),
					$author$project$Types$VoyageType$CruiseParty
				]));
	});
var $author$project$Common$Panel$imageHeader = F2(
	function (imageUrl, elements) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('imageHeader'),
					A2($elm$html$Html$Attributes$style, 'backgroundImage', 'url(\"' + (imageUrl + '\")'))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('imageHeaderContent mediumPadding')
						]),
					elements)
				]));
	});
var $author$project$Common$Panel$imageHeaderTitle = function (headerTitle) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title4')
			]),
		$author$project$Translations$toHtml(headerTitle));
};
var $author$project$MealPage$Meal$isSittingActive = F3(
	function (session, direction, sitting) {
		return A2(
			$elm$core$List$any,
			$author$project$Types$Meals$isSameSitting(sitting),
			$author$project$Types$SelectedMeals$toList(
				function () {
					if (!direction) {
						return session.Gn;
					} else {
						return session.Go;
					}
				}()));
	});
var $author$project$MealPage$Meal$isOutwardLegSelected = F2(
	function (session, meal) {
		return A2(
			$elm$core$List$any,
			A2($author$project$MealPage$Meal$isSittingActive, session, 0),
			meal.kC);
	});
var $author$project$MealPage$Meal$isReturnLegSelected = F2(
	function (session, meal) {
		return A2(
			$elm$core$List$any,
			A2($author$project$MealPage$Meal$isSittingActive, session, 1),
			meal.k4);
	});
var $author$project$MealPage$Meal$isSelected = F2(
	function (session, meal) {
		return A2($author$project$MealPage$Meal$isOutwardLegSelected, session, meal) || A2($author$project$MealPage$Meal$isReturnLegSelected, session, meal);
	});
var $author$project$Utils$Html$Render$maybeRender = F2(
	function (mapping, maybeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2($elm$core$Maybe$map, mapping, maybeValue));
	});
var $author$project$MealPage$Meal$translatePrice = F2(
	function (translations, price) {
		return A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2('price', price)
				]),
			translations.Ck);
	});
var $author$project$MealPage$Meal$translatePricePerAdult = F2(
	function (translations, price) {
		return A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2('price', price)
				]),
			translations.Ci);
	});
var $author$project$MealPage$Meal$priceView = F3(
	function (translations, market, priceType) {
		return function (a) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('price bodyNorm'),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'price')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(a)
					]));
		}(
			function () {
				switch (priceType.$) {
					case 0:
						return translations.Cp;
					case 1:
						var fee = priceType.a;
						return A2(
							$author$project$MealPage$Meal$translatePrice,
							translations,
							A2($author$project$Types$Market$formatPriceWithSign, market, fee));
					case 2:
						var additionalPrice = priceType.a;
						return '+' + A2(
							$author$project$MealPage$Meal$translatePrice,
							translations,
							A2($author$project$Types$Market$formatPriceWithSign, market, additionalPrice));
					case 4:
						var price = priceType.a;
						return A2(
							$author$project$MealPage$Meal$translatePrice,
							translations,
							A2($author$project$Types$Market$formatPriceWithSign, market, price));
					default:
						var price = priceType.a;
						return A2(
							$author$project$MealPage$Meal$translatePricePerAdult,
							translations,
							A2($author$project$Types$Market$formatPriceWithSign, market, price));
				}
			}());
	});
var $author$project$MealPage$Meal$reservationFee = F2(
	function (translations, fee) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('reservationFee'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'reservation-fee')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$injectValues,
								_List_fromArray(
									[
										_Utils_Tuple2('fee', fee)
									]),
								translations.FA))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm childrenRule')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.FB)
						]))
				]));
	});
var $author$project$Common$Panel$row = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panelRow'),
				attributes),
			elements);
	});
var $author$project$MealPage$Common$toShortPortString = function (a) {
	if (a === 16) {
		return 'YST/VIS';
	} else {
		return $author$project$Types$Port$toString(a);
	}
};
var $author$project$MealPage$Common$shortRouteString = F2(
	function (translations, ports) {
		_v0$2:
		while (true) {
			if ((ports.b && ports.b.b) && (!ports.b.b.b)) {
				switch (ports.a) {
					case 0:
						if (ports.b.a === 17) {
							var _v1 = ports.a;
							var _v2 = ports.b;
							var _v3 = _v2.a;
							return translations.G8;
						} else {
							break _v0$2;
						}
					case 17:
						if (!ports.b.a) {
							var _v4 = ports.a;
							var _v5 = ports.b;
							var _v6 = _v5.a;
							return translations.DJ;
						} else {
							break _v0$2;
						}
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$elm$core$String$join,
			' - ',
			A2($elm$core$List$map, $author$project$MealPage$Common$toShortPortString, ports));
	});
var $author$project$MealPage$Meal$mealsCanBeBookedOnBoard = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sittingNotServed')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wW)
			]));
};
var $author$project$Types$Port$translate = function (input) {
	switch (input) {
		case 0:
			return function ($) {
				return $.fY;
			};
		case 1:
			return function ($) {
				return $.fR;
			};
		case 2:
			return function ($) {
				return $.dR;
			};
		case 3:
			return function ($) {
				return $.T;
			};
		case 4:
			return function ($) {
				return $.fz;
			};
		case 5:
			return function ($) {
				return $.i0;
			};
		case 6:
			return function ($) {
				return $.jw;
			};
		case 8:
			return function ($) {
				return $.eN;
			};
		case 7:
			return function ($) {
				return $.jz;
			};
		case 9:
			return function ($) {
				return $.fQ;
			};
		case 10:
			return function ($) {
				return $.jy;
			};
		case 11:
			return function ($) {
				return $.fL;
			};
		case 12:
			return function ($) {
				return $.eY;
			};
		case 13:
			return function ($) {
				return $.ee;
			};
		case 14:
			return function ($) {
				return $.fP;
			};
		case 15:
			return function ($) {
				return $.dX;
			};
		case 16:
			return function ($) {
				return $.jx;
			};
		default:
			return function ($) {
				return $.DI;
			};
	}
};
var $author$project$MealPage$Common$toLongPortString = F2(
	function (translations, a) {
		return A2($author$project$Types$Port$translate, a, translations);
	});
var $author$project$MealPage$Common$longRouteString = F2(
	function (translations, ports) {
		_v0$2:
		while (true) {
			if ((ports.b && ports.b.b) && (!ports.b.b.b)) {
				switch (ports.a) {
					case 0:
						if (ports.b.a === 17) {
							var _v1 = ports.a;
							var _v2 = ports.b;
							var _v3 = _v2.a;
							return translations.G8;
						} else {
							break _v0$2;
						}
					case 17:
						if (!ports.b.a) {
							var _v4 = ports.a;
							var _v5 = ports.b;
							var _v6 = _v5.a;
							return translations.DJ;
						} else {
							break _v0$2;
						}
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$elm$core$String$join,
			' - ',
			A2(
				$elm$core$List$map,
				$author$project$MealPage$Common$toLongPortString(translations),
				ports));
	});
var $author$project$MealPage$Meal$mealsNotServed = F2(
	function (translations, route) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sittingNotServed')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'direction',
								A2($author$project$MealPage$Common$longRouteString, translations, route))
							]),
						translations.Cf))
				]));
	});
var $author$project$MealPage$Messages$ClickedToggleSitting = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$Locale$Locale = F2(
	function (language, market) {
		return {A_: language, rb: market};
	});
var $author$project$Utils$List$conditionalReverse = F2(
	function (doReverse, list) {
		return doReverse ? $elm$core$List$reverse(list) : list;
	});
var $author$project$Translations$pluralize = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A3(
		$elm$regex$Regex$replaceAtMost,
		1,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('{' + (key + ', plural, \\w+{([^}]+)}( \\w+{([^}]+)})?}'))),
		function (m) {
			return (!$elm$core$List$length(m.s2)) ? m.BJ : A2(
				$elm$core$String$join,
				$elm$core$String$fromInt(value),
				A2(
					$elm$core$String$split,
					'#',
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2(
								$author$project$Utils$List$conditionalReverse,
								value !== 1,
								A2($elm$core$List$filterMap, $elm$core$Basics$identity, m.s2))))));
		});
};
var $author$project$MealPage$Meal$buttonText = F2(
	function (translations, passengers) {
		return A2(
			$author$project$Translations$pluralize,
			_Utils_Tuple2(
				'count',
				$elm$core$Array$length(passengers)),
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'count',
						$elm$core$String$fromInt(
							$elm$core$Array$length(passengers)))
					]),
				translations.Cn));
	});
var $author$project$MealPage$Meal$getSameTypeSelectedMealsAsSitting = F2(
	function (selectedMeals, sitting) {
		var _v0 = $author$project$Types$Meals$getMealType(sitting);
		switch (_v0) {
			case 0:
				return selectedMeals.vu;
			case 1:
				return selectedMeals.vx;
			case 2:
				return selectedMeals.Bz;
			default:
				return selectedMeals.yw;
		}
	});
var $author$project$MealPage$Meal$hasSelectedSitting = F2(
	function (selected, sitting) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ut;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$time$Time$toDay($elm$time$Time$utc),
					$elm$core$Basics$eq(
						A2($elm$time$Time$toDay, $elm$time$Time$utc, sitting.ut)))),
			A2($author$project$MealPage$Meal$getSameTypeSelectedMealsAsSitting, selected, sitting));
	});
var $author$project$MealPage$Meal$isSittingSelected = F2(
	function (selected, sitting) {
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var restaurantCode = _v0.FJ;
				var beginDateTime = _v0.ut;
				return _Utils_eq(restaurantCode, sitting.FJ) && _Utils_eq(beginDateTime, sitting.ut);
			},
			A2($author$project$MealPage$Meal$getSameTypeSelectedMealsAsSitting, selected, sitting));
	});
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Common$Images$circlePlusMark = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('plusMark'),
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('iconBackground'),
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('iconForeground'),
					$elm$svg$Svg$Attributes$points('13.337 17 13.337 13.213 17 13.213 17 10.812 13.337 10.812 13.337 7 10.639 7 10.639 10.812 7 10.812 7 13.213 10.639 13.213 10.639 17')
				]),
			_List_Nil)
		]));
var $author$project$MealPage$Meal$selectMealButton = function (_v0) {
	var isActive = _v0.qM;
	var isDisabled = _v0.mA;
	var isFakeDisabled = _v0.nM;
	var message = _v0.Cv;
	var content = _v0.nk;
	return A2(
		$elm$html$Html$button,
		A3(
			$author$project$Utils$List$addIf,
			isActive,
			A2($elm$html$Html$Attributes$attribute, 'data-is-active', ''),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selectItem buttonTextSmall rotateActiveIcon'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', isActive),
							_Utils_Tuple2('disabled', isFakeDisabled)
						])),
					$elm$html$Html$Attributes$disabled(isDisabled),
					$elm$html$Html$Events$onClick(message),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'select-meal-button')
				])),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('selectItemContent')
					]),
				content),
				A2($author$project$Utils$String$renderIf, !isDisabled, $author$project$Common$Images$circlePlusMark)
			]));
};
var $author$project$Utils$Time$Format$weekdayHourMinute = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	return _Utils_ap(
		_List_fromArray(
			[$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated]),
		_Utils_ap(
			function () {
				var _v1 = _Utils_Tuple2(language, market);
				switch (_v1.a) {
					case 6:
						var _v2 = _v1.a;
						return _List_Nil;
					case 7:
						var _v3 = _v1.a;
						return _List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$text(' ')
							]);
					default:
						switch (_v1.b) {
							case 2:
								var _v4 = _v1.b;
								return _List_fromArray(
									[
										$ryan_haskell$date_format$DateFormat$text(', ')
									]);
							case 6:
								var _v5 = _v1.b;
								return _List_fromArray(
									[
										$ryan_haskell$date_format$DateFormat$text(', ')
									]);
							default:
								return _List_fromArray(
									[
										$ryan_haskell$date_format$DateFormat$text(' ')
									]);
						}
				}
			}(),
			$author$project$Utils$Time$Format$hourMinute));
};
var $author$project$MealPage$Meal$timeBlock = F2(
	function (locale, sitting) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('time bodyNorm')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function (beginTimeString) {
						return ($author$project$Types$Meals$isBreakfast(sitting) && (!sitting.zt)) ? _Utils_ap(
							beginTimeString + ' - ',
							$author$project$Utils$Time$Format$formatHourMinute(sitting.yM)) : beginTimeString;
					}(
						A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$weekdayHourMinute, sitting.ut)))
				]));
	});
var $author$project$MealPage$Meal$sittingToggle = F3(
	function (translations, session, _arguments) {
		var language = session.A_;
		var market = session.rb;
		var passengers = session.Eg;
		var direction = _arguments.p7;
		var sitting = _arguments.sR;
		var isActive = function () {
			if (!direction) {
				return A2($author$project$MealPage$Meal$isSittingSelected, session.Gn, sitting);
			} else {
				return A2($author$project$MealPage$Meal$isSittingSelected, session.Go, sitting);
			}
		}();
		var isFakeDisabled = function () {
			if (!direction) {
				return A2($author$project$MealPage$Meal$hasSelectedSitting, session.Gn, sitting);
			} else {
				return A2($author$project$MealPage$Meal$hasSelectedSitting, session.Go, sitting);
			}
		}() && (!isActive);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sitting'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'sitting'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-begin-time',
					$author$project$Utils$Time$toDateTimeString(sitting.ut)),
					A2($elm$html$Html$Attributes$attribute, 'data-restaurant-code', sitting.FJ)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$MealPage$Meal$timeBlock,
					A2($author$project$Types$Locale$Locale, language, market),
					sitting),
					$author$project$MealPage$Meal$selectMealButton(
					{
						nk: _List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$MealPage$Meal$buttonText, translations, passengers))
							]),
						qM: isActive,
						mA: !sitting.zr,
						nM: isFakeDisabled,
						Cv: $author$project$MealPage$Messages$ClickedToggleSitting(_arguments)
					})
				]));
	});
var $author$project$MealPage$Meal$sittingSelectors = F3(
	function (translations, session, _v0) {
		var sittings = _v0.mV;
		var route = _v0.F0;
		var direction = _v0.p7;
		var canBeBooked = _v0.l9;
		return $elm$core$List$isEmpty(sittings) ? _List_fromArray(
			[
				A2($author$project$MealPage$Meal$mealsNotServed, translations, route)
			]) : ((!canBeBooked) ? _List_fromArray(
			[
				$author$project$MealPage$Meal$mealsCanBeBookedOnBoard(translations)
			]) : A2(
			$elm$core$List$map,
			function (a) {
				return A3(
					$author$project$MealPage$Meal$sittingToggle,
					translations,
					session,
					{p7: direction, sR: a});
			},
			sittings));
	});
var $author$project$MealPage$Messages$SwitchDirection = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$MealPage$Menu$Menu$directions = F3(
	function (translations, _v0, menu) {
		var from = _v0.kS;
		var to = _v0.le;
		var direction = menu.p7;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('displayFlex paddingBottomSmall')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$MealPage$Messages$SwitchDirection, menu.HI, 0)),
							$elm$html$Html$Attributes$class('menuDirection buttonTextSmall'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('active', !direction)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$MealPage$Common$shortRouteString,
								translations,
								_List_fromArray(
									[from, to])))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$MealPage$Messages$SwitchDirection, menu.HI, 1)),
							$elm$html$Html$Attributes$class('menuDirection buttonTextSmall'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('active', direction === 1)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$MealPage$Common$shortRouteString,
								translations,
								_List_fromArray(
									[to, from])))
						]))
				]));
	});
var $author$project$MealPage$Messages$EnteredComment = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Common$Images$error = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('14'),
			$elm$svg$Svg$Attributes$height('13'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 14 13')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#D97E7E'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M11.092 6.171l2.688 4.758c.624 1.106-.156 2.488-1.405 2.488H1.625c-1.249 0-2.03-1.382-1.405-2.488L2.908 6.17l2.687-4.759c.625-1.105 2.186-1.105 2.81 0l2.688 4.759zM6.11 4.974c0-.492.4-.89.892-.89s.89.398.89.89V7.73c0 .493-.398.892-.89.892-.493 0-.892-.4-.892-.892V4.974zm.892 6.11c.492 0 .89-.4.89-.892s-.398-.891-.89-.891c-.493 0-.892.399-.892.891s.4.891.892.891z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Utils$Html$Render$renderIf = F2(
	function (isVisible, component) {
		return isVisible ? component : $elm$html$Html$text('');
	});
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$MealPage$Menu$Menu$foodRestrictions = F2(
	function (translations, menu) {
		var direction = menu.p7;
		var comment = menu.wo;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('commentLabel displayFlex marginTopMedium marginBottomSmall')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title1Medium')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.y7)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('charsLeft bodySmall')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$injectValues,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'chars',
											$elm$core$String$fromInt(
												$author$project$MealPage$Common$maxCommentLength - $elm$core$String$length(comment)))
										]),
									translations.vQ))
							]))
					])),
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('comment bodyBold'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'validationError',
								!$author$project$MealPage$Common$isCommentValid(comment))
							])),
						$elm$html$Html$Events$onInput(
						$author$project$MealPage$Messages$EnteredComment(menu.HI)),
						$elm$html$Html$Attributes$value(comment)
					]),
				_List_Nil),
				A2(
				$author$project$Utils$Html$Render$renderIf,
				!$author$project$MealPage$Common$isCommentValid(comment),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('errorMsg bodyNorm')
						]),
					_List_fromArray(
						[
							$author$project$Common$Images$error,
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(translations.wp)
								]))
						])))
			]);
	});
var $author$project$MealPage$Menu$Menu$title = $author$project$Common$Section$header(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('marginTopMedium menuTitle')
		]));
var $author$project$MealPage$Messages$ClickedAddMenuOption = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$MealPage$Messages$ClickedRemovedMenuOption = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$MealPage$Menu$MenuOption$getSelectedAddons = F3(
	function (session, direction, sitting) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tS;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					$author$project$Types$Meals$isSameSitting(sitting),
					$author$project$Types$SelectedMeals$toList(
						(!direction) ? session.Gn : session.Go))));
	});
var $author$project$MealPage$Menu$MenuOption$getCount = F4(
	function (session, code, direction, sitting) {
		return A2(
			$elm_community$list_extra$List$Extra$count,
			$elm$core$Basics$eq(code),
			A3($author$project$MealPage$Menu$MenuOption$getSelectedAddons, session, direction, sitting));
	});
var $author$project$MealPage$Menu$MenuOption$getOtherAddonsOfSameCategoryCount = F5(
	function (session, code, direction, sitting, addonsOfSameCategory) {
		var isAddonCodeOfSameType = function (addonCode) {
			return A2(
				$elm$core$List$member,
				addonCode,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.pQ;
					},
					addonsOfSameCategory));
		};
		var isDifferentAddonCodeOfSameType = function (addonCode) {
			return (!_Utils_eq(addonCode, code)) && isAddonCodeOfSameType(addonCode);
		};
		return A2(
			$elm_community$list_extra$List$Extra$count,
			isDifferentAddonCodeOfSameType,
			A3($author$project$MealPage$Menu$MenuOption$getSelectedAddons, session, direction, sitting));
	});
var $author$project$MealPage$Menu$MenuOption$getMaxCount = F6(
	function (session, meal, _v0, direction, sitting, addonsOfSameCategory) {
		var code = _v0.pQ;
		var adultOnly = _v0.tW;
		var passengersWithMenuCount = A2($author$project$MealPage$Menu$Util$getPassengersWithMenuCount, session, meal);
		var otherAddonsOfSameCategoryCount = A5($author$project$MealPage$Menu$MenuOption$getOtherAddonsOfSameCategoryCount, session, code, direction, sitting, addonsOfSameCategory);
		var adultsCount = $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg);
		return adultOnly ? A2($elm$core$Basics$min, passengersWithMenuCount - otherAddonsOfSameCategoryCount, adultsCount) : (passengersWithMenuCount - otherAddonsOfSameCategoryCount);
	});
var $author$project$Common$Button$disabledState = 'disabled';
var $author$project$Common$Button$hasMaxCountBeenReached = function (_v0) {
	var maybeMax = _v0.kZ;
	var count = _v0.pZ;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (max) {
				return _Utils_cmp(count, max) > -1;
			},
			maybeMax));
};
var $author$project$Common$Button$buttonsWithContent = F2(
	function (_v0, content) {
		var minusAttributes = _v0.rx;
		var plusAttributes = _v0.oz;
		var count = _v0.pZ;
		var maybeMax = _v0.kZ;
		var fakeDisable = _v0.nw;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('minus'),
					A2(
						$elm$core$List$cons,
						(fakeDisable && (!count)) ? $elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Common$Button$disabledState, !count)
								])) : $elm$html$Html$Attributes$disabled(!count),
						minusAttributes)),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('buttonContent')
					]),
				content),
				A2(
				$elm$html$Html$button,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('active', count > 0)
								])),
							$elm$html$Html$Attributes$class('plus')
						]),
					A2(
						$elm$core$List$cons,
						function (isDisabled) {
							return fakeDisable ? $elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2($author$project$Common$Button$disabledState, isDisabled)
									])) : $elm$html$Html$Attributes$disabled(isDisabled);
						}(
							$author$project$Common$Button$hasMaxCountBeenReached(
								{pZ: count, kZ: maybeMax})),
						plusAttributes)),
				_List_Nil)
			]);
	});
var $author$project$Common$Button$plusAndMinusButtons = F2(
	function (_arguments, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('plusMinusButtons'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('oneWay', _arguments.nQ),
							_Utils_Tuple2('twoWay', !_arguments.nQ)
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-selected',
					$author$project$Utils$String$fromBool(_arguments.pZ > 0))
				]),
			A2($author$project$Common$Button$buttonsWithContent, _arguments, content));
	});
var $author$project$MealPage$Menu$MenuOption$controls = F6(
	function (session, meal, addon, direction, sitting, addonsOfSameCategory) {
		var code = addon.pQ;
		var restaurantCode = sitting.FJ;
		var beginDateTime = sitting.ut;
		var maxCount = A6($author$project$MealPage$Menu$MenuOption$getMaxCount, session, meal, addon, direction, sitting, addonsOfSameCategory);
		var count = A4($author$project$MealPage$Menu$MenuOption$getCount, session, code, direction, sitting);
		return A2(
			$author$project$Common$Button$plusAndMinusButtons,
			{
				pZ: count,
				nw: false,
				nQ: false,
				q_: false,
				kZ: $elm$core$Maybe$Just(maxCount),
				rx: _List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('disabled', !count)
							])),
						$elm$html$Html$Events$onClick(
						A3($author$project$MealPage$Messages$ClickedRemovedMenuOption, code, direction, sitting))
					]),
				oz: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A3($author$project$MealPage$Messages$ClickedAddMenuOption, code, direction, sitting))
					])
			},
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(count))
						]))
				]));
	});
var $author$project$MealPage$Menu$MenuOption$view = F7(
	function (translations, session, meal, direction, sitting, addonsOfSameCategory, addon) {
		var description = addon.nt;
		var included = addon.zU;
		var code = addon.pQ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('menuOption bodySmall'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test',
					$author$project$Types$Meals$addonCodeToString(code))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(description)
						])),
					included ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('preselected')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.E5)
						])) : A6($author$project$MealPage$Menu$MenuOption$controls, session, meal, addon, direction, sitting, addonsOfSameCategory)
				]));
	});
var $author$project$MealPage$Menu$Menu$view = F6(
	function (translations, session, meal, addons, menu, sitting) {
		var maybeOutwardSitting = menu.BY;
		var maybeReturnSitting = menu.B$;
		var direction = menu.p7;
		var titleAndMenuOptions = F2(
			function (translateTitle, toAddonList) {
				return $elm$core$List$isEmpty(
					toAddonList(addons)) ? _List_Nil : A2(
					$elm$core$List$cons,
					$author$project$MealPage$Menu$Menu$title(
						translateTitle(translations)),
					A2(
						$elm$core$List$map,
						A6(
							$author$project$MealPage$Menu$MenuOption$view,
							translations,
							session,
							meal,
							direction,
							sitting,
							toAddonList(addons)),
						toAddonList(addons)));
			});
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('information bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$MealPage$Menu$Util$isWithAverageMenu(meal) ? translations.Cu : translations.zm)
						])),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					(!_Utils_eq(maybeOutwardSitting, $elm$core$Maybe$Nothing)) && (!_Utils_eq(maybeReturnSitting, $elm$core$Maybe$Nothing)),
					A3($author$project$MealPage$Menu$Menu$directions, translations, session, menu))
				]),
			_Utils_ap(
				A2(
					titleAndMenuOptions,
					function ($) {
						return $.y5;
					},
					function ($) {
						return $.y6;
					}),
				_Utils_ap(
					A2(
						titleAndMenuOptions,
						function ($) {
							return $.GQ;
						},
						function ($) {
							return $.GR;
						}),
					_Utils_ap(
						A2(
							titleAndMenuOptions,
							function ($) {
								return $.BC;
							},
							function ($) {
								return $.BD;
							}),
						_Utils_ap(
							A2(
								titleAndMenuOptions,
								function ($) {
									return $.yr;
								},
								function ($) {
									return $.ys;
								}),
							_Utils_ap(
								A2(
									titleAndMenuOptions,
									function ($) {
										return $.yD;
									},
									function ($) {
										return $.yE;
									}),
								A2($author$project$MealPage$Menu$Menu$foodRestrictions, translations, menu)))))));
	});
var $author$project$MealPage$Meal$mealCard = F7(
	function (translations, session, maybeMenu, maybeSitting, _v0, meal, _v1) {
		var outwardCanBeBookedOnline = _v0.Dt;
		var returnCanBeBookedOnline = _v0.FM;
		var outwardPrice = _v1.a;
		var returnPrice = _v1.b;
		var maybeReservationFee = function () {
			var _v2 = A2($elm_community$maybe_extra$Maybe$Extra$orElse, returnPrice, outwardPrice);
			if ((!_v2.$) && (_v2.a.$ === 1)) {
				var fee = _v2.a.a;
				return meal.Ap ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2($author$project$Types$Market$formatPriceWithSign, session.rb, fee));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mealCard marginHorizontalSmall'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'meal-panel'),
					A2($elm$html$Html$Attributes$attribute, 'data-title', meal.HI)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$imageHeader,
					meal.zP,
					_List_fromArray(
						[
							$author$project$Common$Panel$imageHeaderTitle(meal.HI)
						])),
					$author$project$Common$Panel$block(
					A3(
						$author$project$Utils$List$appendIf,
						A2($author$project$MealPage$Meal$isSelected, session, meal) && (A2($author$project$MealPage$Menu$Util$isGroupMenuAllowed, session, meal) || $author$project$MealPage$Menu$Util$isWithAverageMenu(meal)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A4(
								$elm$core$Maybe$map3,
								A3($author$project$MealPage$Menu$Menu$view, translations, session, meal),
								meal.BN,
								maybeMenu,
								maybeSitting)),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										$author$project$Translations$toHtml(meal.nt))
									])),
								A2(
								$author$project$Utils$Html$Render$maybeRender,
								$author$project$MealPage$Meal$reservationFee(translations),
								maybeReservationFee),
								A2(
								$author$project$Utils$String$renderIf,
								A2($author$project$MealPage$Menu$Util$isGroupMenuAllowed, session, meal) || $author$project$MealPage$Menu$Util$isWithAverageMenu(meal),
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('menuInvitation bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.Ct)
										]))),
								$author$project$Common$Panel$graySeparator(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('marginBottomMedium')
									])),
								(!A2($author$project$MealPage$Meal$hasBothLegs, session.qW, session.tx)) ? A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('oneWayMultiline'),
										A2($elm$html$Html$Attributes$attribute, 'data-test', 'sittings'),
										A2($elm$html$Html$Attributes$attribute, 'data-is-one-way', '')
									]),
								_Utils_ap(
									A3(
										$author$project$MealPage$Meal$sittingSelectors,
										translations,
										session,
										{
											l9: outwardCanBeBookedOnline,
											p7: 0,
											F0: _List_fromArray(
												[session.kS, session.le]),
											mV: meal.kC
										}),
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												A2($author$project$MealPage$Meal$priceView, translations, session.rb),
												$elm$core$List$singleton),
											outwardPrice)))) : A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-test', 'sittings'),
										$elm$html$Html$Attributes$class('twoWay')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										A2(
											$elm$core$List$cons,
											$author$project$Common$Panel$centeredTitle(
												A2(
													$author$project$MealPage$Common$shortRouteString,
													translations,
													_List_fromArray(
														[session.kS, session.le]))),
											_Utils_ap(
												A3(
													$author$project$MealPage$Meal$sittingSelectors,
													translations,
													session,
													{
														l9: outwardCanBeBookedOnline,
														p7: 0,
														F0: _List_fromArray(
															[session.kS, session.le]),
														mV: meal.kC
													}),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														A2(
															$elm$core$Basics$composeR,
															A2($author$project$MealPage$Meal$priceView, translations, session.rb),
															$elm$core$List$singleton),
														outwardPrice))))),
										$author$project$Common$Panel$column(
										A2(
											$elm$core$List$cons,
											$author$project$Common$Panel$centeredTitle(
												A2(
													$author$project$MealPage$Common$shortRouteString,
													translations,
													_List_fromArray(
														[session.le, session.kS]))),
											_Utils_ap(
												A3(
													$author$project$MealPage$Meal$sittingSelectors,
													translations,
													session,
													{
														l9: returnCanBeBookedOnline,
														p7: 1,
														F0: _List_fromArray(
															[session.le, session.kS]),
														mV: meal.k4
													}),
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													A2(
														$elm$core$Maybe$map,
														A2(
															$elm$core$Basics$composeR,
															A2($author$project$MealPage$Meal$priceView, translations, session.rb),
															$elm$core$List$singleton),
														returnPrice)))))
									]))
							])))
				]));
	});
var $author$project$MealPage$Meal$translateMealType = function (mealTypeString) {
	switch (mealTypeString) {
		case 'breakfast':
			return function ($) {
				return $.wQ;
			};
		case 'brunch':
			return function ($) {
				return $.wR;
			};
		case 'buffet':
			return function ($) {
				return $.wS;
			};
		case 'dinner':
			return function ($) {
				return $.wT;
			};
		case 'lunch':
			return function ($) {
				return $.wU;
			};
		case 'tableReservations':
			return function ($) {
				return $.wV;
			};
		default:
			return $elm$core$Basics$always(mealTypeString);
	}
};
var $author$project$MealPage$Meal$mealCardsList = F5(
	function (translations, session, menus, meals, _v0) {
		var selector = _v0.a;
		var mealTitleString = _v0.b;
		var showAdditionalPrice = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$MealPackage$isCampCode),
				session.B2));
		var mealsOfType = selector(meals);
		var areTableReservations = mealTitleString === 'tableReservations';
		var areBreakfastMeals = mealTitleString === 'breakfast';
		var cheapestPrices = areBreakfastMeals ? $author$project$MealPage$Meal$getCheapestPrices(mealsOfType) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		var mealCards = A2(
			$elm$core$List$map,
			function (meal) {
				var mealPackage = function () {
					var _v4 = session.rs;
					if (!_v4.$) {
						var mealPackages = _v4.a;
						return A2(
							$elm$core$Maybe$andThen,
							function (a) {
								return A2(
									$elm_community$list_extra$List$Extra$find,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.pQ;
										},
										$elm$core$Basics$eq(a)),
									mealPackages);
							},
							session.B2);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var maybeMenu = A2($elm$core$Dict$get, meal.HI, menus);
				var maybeSitting = A2(
					$elm$core$Maybe$andThen,
					function (menu) {
						var _v3 = menu.p7;
						if (!_v3) {
							return menu.BY;
						} else {
							return menu.B$;
						}
					},
					maybeMenu);
				var isInMealPackage = A2(
					$elm$core$Maybe$withDefault,
					false,
					A3(
						$elm$core$Maybe$map2,
						A2(
							$author$project$MealPage$Meal$isMealUsedInMealPackage,
							{kS: session.kS, le: session.le, tx: session.tx},
							meal),
						session.ri,
						mealPackage));
				var price = F2(
					function (sittings, maybeCheapestPrice) {
						return (isInMealPackage || $elm$core$List$isEmpty(sittings)) ? $elm$core$Maybe$Nothing : ((showAdditionalPrice && (!_Utils_eq(maybeCheapestPrice, $elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Just(
							A2(
								$author$project$MealPage$Meal$getAdditionalPrice,
								A2($elm$core$Maybe$withDefault, 0, maybeCheapestPrice),
								sittings)) : (($author$project$MealPage$Menu$Util$isWithAverageMenu(meal) || A2($author$project$MealPage$Menu$Util$isGroupMenuAllowed, session, meal)) ? $elm$core$Maybe$Just(
							$author$project$MealPage$Meal$getPricePerAdult(sittings)) : ((areTableReservations && (!(!$author$project$MealPage$Meal$findMaxOriginalPrice(sittings)))) ? $elm$core$Maybe$Just(
							$author$project$MealPage$Meal$isTableReservationFeeWaived(session) ? $author$project$MealPage$Meal$Reservation : $author$project$MealPage$Meal$ReservationWithFee(
								$author$project$MealPage$Meal$findMaxOriginalPrice(sittings))) : (A2($elm$core$List$all, $author$project$MealPage$Meal$isChristmasTavalotaSitting, sittings) ? $elm$core$Maybe$Just(
							$author$project$MealPage$Meal$getPrice(sittings)) : (A2(
							$elm$core$List$all,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.rL;
								},
								$elm$core$Basics$eq(0)),
							sittings) ? $elm$core$Maybe$Just($author$project$MealPage$Meal$Reservation) : $elm$core$Maybe$Just(
							$author$project$MealPage$Meal$getPrice(sittings)))))));
					});
				var _v2 = _Utils_Tuple2(
					A2(price, meal.kC, cheapestPrices.a),
					A2(price, meal.k4, cheapestPrices.b));
				var outwardPrice = _v2.a;
				var returnPrice = _v2.b;
				return A7(
					$author$project$MealPage$Meal$mealCard,
					translations,
					session,
					maybeMenu,
					maybeSitting,
					meals,
					meal,
					_Utils_Tuple2(outwardPrice, returnPrice));
			},
			selector(meals));
		return ((!$elm$core$List$isEmpty(mealsOfType)) ? $elm$core$List$singleton : function (_v1) {
			return _List_Nil;
		})(
			A2(
				$author$project$Common$Section$view,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'mealList'),
						A2($elm$html$Html$Attributes$attribute, 'data-test-mealtype', mealTitleString)
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Common$Section$header,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mealType marginHorizontalSmall')
							]),
						A2($author$project$MealPage$Meal$translateMealType, mealTitleString, translations)),
					mealCards)));
	});
var $author$project$MealPage$Meal$mealBlocks = F3(
	function (translations, session, menus) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (meals) {
					return $elm$core$List$concat(
						A2(
							$elm$core$List$map,
							A4($author$project$MealPage$Meal$mealCardsList, translations, session, menus, meals),
							_List_fromArray(
								[
									_Utils_Tuple2(
									function ($) {
										return $.vv;
									},
									'breakfast'),
									_Utils_Tuple2(
									function ($) {
										return $.vy;
									},
									'brunch'),
									_Utils_Tuple2(
									function ($) {
										return $.vA;
									},
									'buffet'),
									_Utils_Tuple2(
									function ($) {
										return $.G5;
									},
									'tableReservations')
								])));
				},
				session.ri));
	});
var $author$project$MealPage$Messages$ClickedToggleMealPackage = function (a) {
	return {$: 5, a: a};
};
var $author$project$MealPage$Messages$OpenedModal = {$: 6};
var $author$project$MealPage$Meal$isMealPriceHidden = function (session) {
	var _v0 = $author$project$Types$Trips$statusToMaybe(session.tp);
	if ((!_v0.$) && (!_v0.a.$)) {
		var cruiseSails = _v0.a.a;
		return $author$project$Types$CruiseSails$selected(cruiseSails).b.Ah;
	} else {
		return false;
	}
};
var $author$project$MealPage$Meal$mealPackageContent = function (_v0) {
	var translations = _v0.lY;
	var session = _v0.j;
	var selectedMealPackage = _v0.oR;
	var mealPackages = _v0.rs;
	var sittingPrice = A2(
		$author$project$MealPage$Meal$translatePrice,
		translations,
		A2($author$project$Types$Market$formatPriceWithSign, session.rb, selectedMealPackage.lN));
	var hasMoreThanOneMealPackage = function () {
		var _v3 = session.rs;
		if (!_v3.$) {
			var a = _v3.a;
			return $elm$core$List$length(a) > 1;
		} else {
			return false;
		}
	}();
	var hasActiveMealPackage = !_Utils_eq(session.B2, $elm$core$Maybe$Nothing);
	var mealPackageButtonText = (hasMoreThanOneMealPackage && hasActiveMealPackage) ? _List_fromArray(
		[
			$elm$html$Html$text(selectedMealPackage.oh)
		]) : ((hasMoreThanOneMealPackage && (!hasActiveMealPackage)) ? _List_fromArray(
		[
			$elm$html$Html$text(translations.Ch)
		]) : _List_fromArray(
		[
			$elm$html$Html$text(
			A2($author$project$MealPage$Meal$buttonText, translations, session.Eg))
		]));
	var message = function () {
		if (hasActiveMealPackage) {
			return $author$project$MealPage$Messages$ClickedToggleMealPackage(selectedMealPackage.pQ);
		} else {
			if (mealPackages.b && mealPackages.b.b) {
				var _v2 = mealPackages.b;
				return $author$project$MealPage$Messages$OpenedModal;
			} else {
				return $author$project$MealPage$Messages$ClickedToggleMealPackage(selectedMealPackage.pQ);
			}
		}
	}();
	return $author$project$Common$Panel$block(
		_List_fromArray(
			[
				$author$project$MealPage$Meal$selectMealButton(
				{nk: mealPackageButtonText, qM: hasActiveMealPackage, mA: false, nM: false, Cv: message}),
				((($elm$core$List$length(mealPackages) === 1) || hasActiveMealPackage) && (!$author$project$MealPage$Meal$isMealPriceHidden(session))) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('price bodyNorm '),
						A2($elm$html$Html$Attributes$attribute, 'data-test-price', '')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(sittingPrice)
					])) : $elm$html$Html$text(''),
				function (description) {
				return $elm$core$List$isEmpty(description) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$pre,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm mealPackageDescription')
						]),
					description);
			}(
				$author$project$Translations$toHtml(selectedMealPackage.nt)),
				A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mealPackageDescription bodyNorm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.rt)
					]))
			]));
};
var $author$project$Common$Images$breakfast = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('30'),
			$elm$svg$Svg$Attributes$height('13'),
			$elm$svg$Svg$Attributes$viewBox('0 0 30 13')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#FFF'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M26.196 2h1.338C28.896 2 30 3.08 30 4.41a2.4 2.4 0 0 1-1.196 2.066l-2.608 1.532V9a4 4 0 0 1-4 4H21.25a4 4 0 0 1-4-4V0h8.947v2zm0 .964v3.92l2.1-1.234a1.44 1.44 0 0 0 .718-1.24c0-.798-.663-1.446-1.48-1.446h-1.338zM3.2 5L.347 2.056a.501.501 0 0 1 .009-.707.496.496 0 0 1 .703.009L4.587 5h11.318v1a7 7 0 0 1-7 7H7a7 7 0 0 1-7-7V5h3.199z')
				]),
			_List_Nil)
		]));
var $author$project$Common$Images$dinner = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('30'),
			$elm$svg$Svg$Attributes$height('16'),
			$elm$svg$Svg$Attributes$viewBox('0 0 30 16')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#FFF'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M28.982 0h.509c.28 0 .509.224.509.5V15c0 .552-.456 1-1.018 1a1.01 1.01 0 0 1-1.019-1V9h-2.037c0-5.89 3.056-9 3.056-9zM4.583 0c.281 0 .51.224.51.5V4c0 1.024-.63 1.899-1.528 2.285V15c0 .518-.403.938-.916.99l-.103.01-.103-.01a1.003 1.003 0 0 1-.915-.99V6.285C.63 5.899 0 5.024 0 4V.5C0 .224.228 0 .51 0c.28 0 .508.224.508.5v3.382c0 .704.427 1.296 1.019 1.519V.5c0-.276.228-.5.51-.5.28 0 .508.224.508.5v4.901c.593-.223 1.019-.815 1.019-1.518V.5c0-.276.228-.5.51-.5zM15.3 16a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-3a5 5 0 1 0 0-10 5 5 0 0 0 0 10z')
				]),
			_List_Nil)
		]));
var $author$project$MealPage$Meal$packageDetails = function (_v0) {
	var translations = _v0.lY;
	var mealPackage = _v0.lB;
	var hasMoreThanOneMealPackage = _v0.qw;
	var prePersonContent = hasMoreThanOneMealPackage ? _List_fromArray(
		[$author$project$Common$Images$breakfast, $author$project$Common$Images$dinner]) : _List_fromArray(
		[
			$elm$html$Html$text(translations.Co)
		]);
	var packageInfoContent = hasMoreThanOneMealPackage ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyNorm packageInfo')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.Cg)
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('packageName')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(mealPackage.oh)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('packageDetails bodyLargeBold')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mealPackageTitle title3')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.Cm)
					])),
				packageInfoContent,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('perPerson')
					]),
				prePersonContent),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('savingsPercentage')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodySmall savingsPercentageText')
							]),
						$author$project$Translations$toHtml(translations.Cl))
					]))
			]));
};
var $author$project$MealPage$Meal$mealPackageView = function (params) {
	return A2(
		$author$project$Common$Section$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mealPackage'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'meal-package')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Common$Section$header,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginHorizontalSmall')
					]),
				params.lY.ru),
				A2(
				$author$project$Common$Panel$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mealCard marginHorizontalSmall')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('packageHeader')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('overlay')
									]),
								_List_Nil),
								$author$project$MealPage$Meal$packageDetails(
								{
									qw: $elm$core$List$length(params.rs) > 1,
									lB: params.oR,
									lY: params.lY
								})
							])),
						$author$project$MealPage$Meal$mealPackageContent(params)
					]))
			]));
};
var $author$project$MealPage$Meal$view = F3(
	function (translations, session, menus) {
		var maybeActiveDistributionCode = session.B2;
		var packageView = function () {
			var _v0 = session.rs;
			if (!_v0.$) {
				var mealPackages = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (mealPackage) {
							return $author$project$MealPage$Meal$mealPackageView(
								{rs: mealPackages, oR: mealPackage, j: session, lY: translations});
						},
						A2(
							$author$project$Types$Maybe$Util$orElse,
							$elm$core$List$head(mealPackages),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v1) {
									var code = _v1.pQ;
									return _Utils_eq(
										$elm$core$Maybe$Just(code),
										maybeActiveDistributionCode);
								},
								mealPackages))));
			} else {
				var _package = _v0.a;
				return $author$project$MealPage$Meal$includedMealPackageView(
					{lB: _package, j: session, lY: translations});
			}
		}();
		var hasActiveMealPackage = !_Utils_eq(session.B2, $elm$core$Maybe$Nothing);
		var pageTitle = hasActiveMealPackage ? translations.Cm : translations.Cq;
		var titleType = hasActiveMealPackage ? 'withMealPackageSelected' : 'withoutMealPackageSelected';
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mealPage page withFixedButton')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mealsHolder'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'withMealPackage',
									!_Utils_eq(session.B2, $elm$core$Maybe$Nothing))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('headerHolder')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title2 cell'),
													A2($elm$html$Html$Attributes$attribute, 'data-title', titleType)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(pageTitle)
												]))
										]))
								])),
							packageView,
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A3($author$project$MealPage$Meal$mealBlocks, translations, session, menus))
						]))
				]));
	});
var $author$project$Price$View$buttonToHtml = function (_v0) {
	var buttonView = _v0;
	return buttonView;
};
var $author$project$Price$View$addHotelNotice = F3(
	function (_v0, route, msg) {
		var language = _v0.A_;
		var hotelsAndCities = _v0.zI;
		var isActivePage = _Utils_eq(route, $author$project$UrlRoute$HotelList);
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyBold addMoreLink'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('isActivePage', isActivePage)
							]))
					]),
				(!_Utils_eq(route, $author$project$UrlRoute$HotelList)) ? _List_fromArray(
					[
						$elm$html$Html$Events$onClick(msg)
					]) : _List_Nil),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.vY;
						}) + ' '),
					A2(
					$author$project$Utils$String$renderIf,
					!_Utils_eq(route, $author$project$UrlRoute$HotelList),
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyBold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromChar(
									$elm$core$Char$fromCode(8594)))
							])))
				]));
	});
var $author$project$Price$View$addMoreTravelClassesNotice = F3(
	function (translations, route, msg) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold addMoreLink'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'isActivePage',
							_Utils_eq(route, $author$project$UrlRoute$TravelClass))
						])),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Fd + ' '),
					(!_Utils_eq(route, $author$project$UrlRoute$TravelClass)) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromChar(
								$elm$core$Char$fromCode(8594)))
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Price$View$cheapestCabinDataAttributes = F2(
	function (price, isClubOne) {
		return A3(
			$author$project$Utils$List$addIf,
			isClubOne,
			A2($elm$html$Html$Attributes$attribute, 'data-is-club-one', ''),
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'price'),
					A2($elm$html$Html$Attributes$attribute, 'data-cheapest-cabin', ''),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-price',
					$elm$core$String$fromFloat(price))
				]));
	});
var $author$project$Price$View$clubOneImage = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			function (imageUrl) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('clubOne'),
							$elm$html$Html$Attributes$src(imageUrl)
						]),
					_List_Nil);
			},
			function (level) {
				return '/assets/images/clubOne/level_' + (level + '.png');
			}),
		$elm$core$String$toLower),
	$author$project$Types$ClubOneLevel$toString);
var $author$project$Price$View$label = F3(
	function (translations, maybeLevel, translate) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold priceBarLabel'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'withClubOne',
							!_Utils_eq(maybeLevel, $elm$core$Maybe$Nothing))
						]))
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $elm$core$List$singleton, $author$project$Price$View$clubOneImage),
						maybeLevel)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('priceLabelText')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								translate(translations))
							]))
					])));
	});
var $author$project$Price$View$cheapestCabinLabel = F2(
	function (translations, maybeClubOneLevel) {
		return A3(
			$author$project$Price$View$label,
			translations,
			maybeClubOneLevel,
			A2(
				$elm$core$Maybe$withDefault,
				function ($) {
					return $.Fa;
				},
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						function ($) {
							return $.Fb;
						}),
					maybeClubOneLevel)));
	});
var $author$project$Common$Images$darkPropeller = A2($author$project$Common$Images$propeller, '', $author$project$Common$Images$colors.ev);
var $author$project$Price$View$AddHotel = {$: 8};
var $author$project$Price$View$AddMoreTravelClasses = {$: 3};
var $author$project$Price$View$CheapestCabin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Price$View$Loading = {$: 5};
var $author$project$Price$View$MinCabinPriceUnavailable = {$: 2};
var $author$project$Price$View$NoAvailableHotels = {$: 7};
var $author$project$Price$View$NoDeparturesChangeTripType = {$: 6};
var $author$project$Price$View$NotAllPassengersHaveRoomsInHotel = {$: 9};
var $author$project$Price$View$NotAllPassengersHaveSeatInVehicle = {$: 4};
var $author$project$Price$View$Price = function (a) {
	return {$: 0, a: a};
};
var $author$project$Price$View$priceFromSail = F2(
	function (hasVehiclesForSail, _v0) {
		var personPrice = _v0.ov;
		var vehiclePrice = _v0.pe;
		return hasVehiclesForSail ? (personPrice + A2($elm$core$Maybe$withDefault, 0, vehiclePrice)) : personPrice;
	});
var $author$project$Price$View$cheapestPrice = function (model) {
	var anySelectedVehicle = function (isMatch) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$SelectedVehicles$toList,
					$elm$core$List$any(isMatch)),
				model.j.rp));
	};
	var hasOutwardVehicles = anySelectedVehicle($author$project$Types$SelectedVehicles$isOutwardSelected);
	var hasReturnVehicles = anySelectedVehicle($author$project$Types$SelectedVehicles$isReturnSelected);
	return A2(
		$elm$core$Maybe$map,
		function (trips) {
			switch (trips.$) {
				case 0:
					var cruise = trips.a;
					return A2(
						$author$project$Price$View$priceFromSail,
						hasOutwardVehicles,
						$author$project$Types$CruiseSails$selected(cruise).b);
				case 1:
					var route = trips.a;
					return function (_v1) {
						var a = _v1.a;
						var maybeB = _v1.b;
						return A2($author$project$Price$View$priceFromSail, hasOutwardVehicles, a) + A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								$author$project$Price$View$priceFromSail(hasReturnVehicles),
								maybeB));
					}(
						$author$project$Types$RouteTripSails$selected(route));
				default:
					var cruiseMultiDeparture = trips.a;
					return A2(
						$author$project$Price$View$priceFromSail,
						hasOutwardVehicles,
						function (_v2) {
							var personPrice = _v2.ov;
							var vehiclePrice = _v2.pe;
							return {
								ov: personPrice,
								pe: $elm$core$Maybe$Just(vehiclePrice)
							};
						}(
							$author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture)));
			}
		},
		$author$project$Types$Trips$statusToMaybe(model.j.tp));
};
var $author$project$Price$View$showAddHotelNotice = function (_v0) {
	var maybeSummary = _v0.B7;
	var bookingType = _v0.vk;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var selectedHotelRooms = _v1.Gk;
				return $elm$core$List$isEmpty(selectedHotelRooms) && (bookingType === 1);
			},
			maybeSummary));
};
var $author$project$Price$View$showAddRoomInHotel = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.yA;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$not,
					$elm$core$Basics$and(session.vk === 1))),
			session.B7));
};
var $author$project$Price$View$showLoadingNotice = function (session) {
	return session.Af || ((session.vk === 1) && session.Ac);
};
var $author$project$Price$View$showNoAvailableHotelsNotice = function (session) {
	return (session.vk === 1) && ((!session.Ac) && $elm$core$List$isEmpty(session.zI.zH));
};
var $author$project$Price$View$getPriceView = function (model) {
	var session = model.j;
	return $author$project$Types$Trips$isFailure(session.tp) ? $author$project$Price$View$NoDeparturesChangeTripType : ($author$project$Price$View$showNoAvailableHotelsNotice(session) ? $author$project$Price$View$NoAvailableHotels : ($author$project$Price$View$showLoadingNotice(session) ? $author$project$Price$View$Loading : ($author$project$Price$View$isMinCabinPriceUnavailable(session) ? $author$project$Price$View$MinCabinPriceUnavailable : ($author$project$Price$View$showAddHotelNotice(session) ? $author$project$Price$View$AddHotel : ($author$project$Price$View$showAddRoomInHotel(session) ? $author$project$Price$View$NotAllPassengersHaveRoomsInHotel : ($author$project$Price$View$showAddMoreTravelClassesNotice(model) ? $author$project$Price$View$AddMoreTravelClasses : ((!$author$project$Session$isEveryPassengerWithVehicleSeat(session)) ? $author$project$Price$View$NotAllPassengersHaveSeatInVehicle : A2(
		$elm$core$Maybe$withDefault,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$Price$View$MinCabinPriceUnavailable,
			A2(
				$elm$core$Maybe$map,
				function (price) {
					return $author$project$Price$View$CheapestCabin(
						{lN: price});
				},
				$author$project$Price$View$cheapestPrice(model))),
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (summary, price) {
					return $author$project$Price$View$Price(
						{lN: price, s4: summary});
				}),
			session.B7,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.lN;
				},
				session.B7))))))))));
};
var $author$project$Price$View$minCabinPriceUnavailable = F2(
	function (translations, route) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold addMoreLink'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'isActivePage',
							_Utils_eq(route, $author$project$UrlRoute$TravelClass))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Fe)
				]));
	});
var $author$project$Price$View$priceAttributes = F3(
	function (_v0, price, isClubOne) {
		var pointsPrice = _v0.oA;
		return A3(
			$author$project$Utils$List$addIf,
			isClubOne,
			A2($elm$html$Html$Attributes$attribute, 'data-is-club-one', ''),
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'price'),
					A2($elm$html$Html$Attributes$attribute, 'data-total-price', ''),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-price',
					$elm$core$String$fromFloat(price)),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-points-price',
					$elm$core$String$fromInt(pointsPrice))
				]));
	});
var $author$project$Price$View$priceLabel = F2(
	function (translations, maybeClubOneLevel) {
		return A3(
			$author$project$Price$View$label,
			translations,
			maybeClubOneLevel,
			(!_Utils_eq(maybeClubOneLevel, $elm$core$Maybe$Nothing)) ? function (_v0) {
				return translations.Fc + ':';
			} : function ($) {
				return $.Fg;
			});
	});
var $author$project$Types$Market$formatPoints = F2(
	function (language, price) {
		return A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Types$Market$formatIntegerPartOfPriceString)(price) + (' ' + A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.b2;
			}));
	});
var $author$project$Price$View$total = F3(
	function (_v0, _v1, price) {
		var market = _v0.rb;
		var language = _v0.A_;
		var pointsPrice = _v1.oA;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('value title5Book price'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'price-value')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					(pointsPrice > 0) ? _Utils_ap(
						A2($author$project$Types$Market$formatPoints, language, pointsPrice),
						(price > 0) ? (' + ' + A2($author$project$Types$Market$formatPriceWithSign, market, price)) : '') : A2($author$project$Types$Market$formatPriceWithSign, market, price))
				]));
	});
var $author$project$Price$View$bar = F2(
	function (translations, model) {
		var session = model.j;
		var maybeClubOneLevel = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.pO;
			},
			$author$project$Types$Passenger$findWithHighestLevel(session.Eg));
		var isWithClubOne = !_Utils_eq(maybeClubOneLevel, $elm$core$Maybe$Nothing);
		var _v0 = $author$project$Price$View$getPriceView(model);
		switch (_v0.$) {
			case 6:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast informationToast bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$t,
								session.A_,
								function ($) {
									return $.CL;
								}))
						]));
			case 5:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bar'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'price'),
							A2($elm$html$Html$Attributes$attribute, 'data-price-loading', '')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyBold priceBarLabel')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.Fh)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spinner animateSpinner')
								]),
							_List_fromArray(
								[$author$project$Common$Images$darkPropeller]))
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast warningToast'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'price'),
							A2($elm$html$Html$Attributes$attribute, 'data-add-more-travelclasses', '')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Price$View$addMoreTravelClassesNotice,
							translations,
							$author$project$UrlRoute$parseLocation(model.n1),
							$author$project$Messages$ChangedLocation($author$project$UrlRoute$TravelClass))
						]));
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast warningToast bodyBold'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'price')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.yS)
						]));
			case 0:
				var summary = _v0.a.s4;
				var price = _v0.a.lN;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('priceBarWithDetails')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('bar'),
								A3($author$project$Price$View$priceAttributes, summary, price, isWithClubOne)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('displayFlex')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Price$View$priceLabel,
											translations,
											($elm$core$Basics$abs(summary.wd) > 0) ? maybeClubOneLevel : $elm$core$Maybe$Nothing)
										])),
									A3($author$project$Price$View$total, session, summary, price)
								]))
						]));
			case 1:
				var a = _v0.a;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('bar'),
						A2($author$project$Price$View$cheapestCabinDataAttributes, a.lN, isWithClubOne)),
					_List_fromArray(
						[
							A2($author$project$Price$View$cheapestCabinLabel, translations, maybeClubOneLevel),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('value title5Book price'),
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'price')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Types$Market$formatPriceWithSign, model.j.rb, a.lN))
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast informationToast'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'price'),
							A2($elm$html$Html$Attributes$attribute, 'data-min-unavailable', '')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Price$View$minCabinPriceUnavailable,
							translations,
							$author$project$UrlRoute$parseLocation(model.n1))
						]));
			case 8:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast informationToast'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'price'),
							A2($elm$html$Html$Attributes$attribute, 'data-add-hotel', '')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Price$View$addHotelNotice,
							session,
							$author$project$UrlRoute$parseLocation(model.n1),
							$author$project$Messages$ChangedLocation($author$project$UrlRoute$HotelList))
						]));
			case 9:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast informationToast bodyBold'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'price')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.tK)
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toast warningToast bodyBold'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'no-hotels-toast')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.zA)
						]));
		}
	});
var $author$project$Constants$fixedBottomBarId = 'fixed-bottom-bar';
var $author$project$Common$Toast$view = F4(
	function (translations, maybeMsg, _v0, state) {
		var translate = _v0.pa;
		var parameters = _v0.DH;
		var toastType = _v0.o8;
		var containsHtml = _v0.nj;
		var content = A2(
			$author$project$Translations$injectValues,
			parameters,
			translate(translations));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'toast', '')
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-effect-type', 'smooth-slide-up-down'),
								$elm$html$Html$Attributes$class(
								function () {
									switch (toastType) {
										case 0:
											return '';
										case 1:
											return 'warning';
										default:
											return 'information';
									}
								}())
							]),
						_Utils_ap(
							function () {
								switch (state) {
									case 0:
										return _List_fromArray(
											[
												$elm$html$Html$Attributes$class('enter')
											]);
									case 1:
										return _List_Nil;
									default:
										return _List_fromArray(
											[
												$elm$html$Html$Attributes$class('leave')
											]);
								}
							}(),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $elm$html$Html$Events$onClick, $elm$core$List$singleton),
									maybeMsg)))),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyBold')
								]),
							containsHtml ? $author$project$Translations$toHtml(content) : _List_fromArray(
								[
									$elm$html$Html$text(content)
								]))
						]))));
	});
var $author$project$Price$View$view = F3(
	function (translations, model, maybeView) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bar-bottom-fixed'),
					$elm$html$Html$Attributes$id($author$project$Constants$fixedBottomBarId),
					A2($elm$html$Html$Attributes$attribute, 'ui-view', 'price')
				]),
			_Utils_ap(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeView)),
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								var toast = _v0.HO;
								var state = _v0.mW;
								return _List_fromArray(
									[
										A4($author$project$Common$Toast$view, translations, $elm$core$Maybe$Nothing, toast, state)
									]);
							},
							model.HT.L)),
					_List_fromArray(
						[
							A2($author$project$Price$View$bar, translations, model)
						]))));
	});
var $author$project$Price$View$viewWithButton = F3(
	function (translations, model, buttonView) {
		return A3(
			$author$project$Price$View$view,
			translations,
			model,
			$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('buttonWrapper')
						]),
					_List_fromArray(
						[
							$author$project$Price$View$buttonToHtml(
							buttonView(translations))
						]))));
	});
var $author$project$View$mealPageView = F3(
	function (translations, model, pageModel) {
		var session = model.j;
		var hasInvalidComments = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.wo;
				},
				A2($elm$core$Basics$composeR, $author$project$MealPage$Common$isCommentValid, $elm$core$Basics$not)),
			$elm$core$Dict$values(pageModel));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Messages$MealPageMsg,
				A3($author$project$MealPage$Meal$view, translations, model.j, pageModel)),
				A3(
				$author$project$Price$View$viewWithButton,
				translations,
				model,
				A2(
					$author$project$Price$View$doneButton,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(hasInvalidComments)
						]),
					function () {
						var _v0 = $author$project$Utils$SelectedMeals$findMealWithIncompleteSelection(model.j);
						if (!_v0.$) {
							var meal = _v0.a;
							var translationKey = $author$project$MealPage$Menu$Util$isWithAverageMenu(meal) ? function ($) {
								return $.dE;
							} : function ($) {
								return $.dD;
							};
							return $author$project$Messages$ToastMsg(
								A5(
									$author$project$Common$Toast$showToastMsg,
									2,
									translationKey,
									false,
									false,
									_List_fromArray(
										[
											_Utils_Tuple2('restaurant', meal.HI)
										])));
						} else {
							return $author$project$Messages$ChangedLocation($author$project$UrlRoute$Root);
						}
					}()))
			]);
	});
var $author$project$Messages$CancelledKlarnaPayment = function (a) {
	return {$: 107, a: a};
};
var $author$project$Messages$ClickedGoBack = {$: 93};
var $author$project$Messages$ClickedGoBackInNativeApp = {$: 104};
var $author$project$Messages$OpenedModal = function (a) {
	return {$: 119, a: a};
};
var $author$project$Types$MikiSail$MikiSail = function (arrivalIsoDate) {
	return function (departureIsoDate) {
		return function (from) {
			return function (to) {
				return function (shipCode) {
					return function (marketingMessage) {
						return function (isSpecialCruise) {
							return function (ashorePeriod) {
								return function (sailPackageName) {
									return function (sailPackageCode) {
										return {ps: arrivalIsoDate, pt: ashorePeriod, nr: departureIsoDate, kS: from, Au: isSpecialCruise, rc: marketingMessage, F4: sailPackageCode, F5: sailPackageName, oX: shipCode, le: to};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$MikiSail$fromCruiseMultiDeparture = function (trip) {
	var toMikiSail = F2(
		function (tr, toCruiseMultiDepartureSail) {
			var cruiseMultiDepartureSail = toCruiseMultiDepartureSail(tr);
			return $author$project$Types$MikiSail$MikiSail(cruiseMultiDepartureSail.lm)(cruiseMultiDepartureSail.p3)(
				A2($author$project$Types$Port$Location, cruiseMultiDepartureSail.kF, cruiseMultiDepartureSail.EJ))(
				A2($author$project$Types$Port$Location, cruiseMultiDepartureSail.oB, cruiseMultiDepartureSail.EX))(trip.oX)($elm$core$Maybe$Nothing)(false)(trip.pt)(trip.F5)($elm$core$Maybe$Nothing);
		});
	return _Utils_Tuple2(
		A2(
			toMikiSail,
			trip,
			function ($) {
				return $.rS;
			}),
		A2(
			toMikiSail,
			trip,
			function ($) {
				return $.sw;
			}));
};
var $author$project$Types$MikiSail$fromCruiseSail = function (cruiseSail) {
	var marketingMessage = cruiseSail.rc;
	var isSpecialCruise = cruiseSail.Au;
	var ashorePeriod = cruiseSail.pt;
	var sailPackageName = cruiseSail.F5;
	var sailPackageCode = cruiseSail.F4;
	var toMikiSail = F2(
		function (shipCode, sail) {
			return $author$project$Types$MikiSail$MikiSail(sail.ps)(sail.nr)(sail.kS)(sail.le)(shipCode)(marketingMessage)(isSpecialCruise)(ashorePeriod)(sailPackageName)(sailPackageCode);
		});
	return _Utils_Tuple3(
		A2(toMikiSail, cruiseSail.Dz, cruiseSail.rS),
		A2(
			$elm$core$Maybe$map,
			toMikiSail(cruiseSail.FS),
			cruiseSail.z2),
		A2(toMikiSail, cruiseSail.FS, cruiseSail.sw));
};
var $author$project$Types$MikiSail$fromRouteTripSail = function (routeTripSail) {
	return $author$project$Types$MikiSail$MikiSail(routeTripSail.ps)(routeTripSail.nr)(
		A2($author$project$Types$Port$Location, routeTripSail.v1, routeTripSail.EJ))(
		A2($author$project$Types$Port$Location, routeTripSail.v2, routeTripSail.EX))(routeTripSail.oX)(routeTripSail.rc)(false)(
		A2($author$project$Types$AshorePeriod$AshorePeriod, 0, 0))(routeTripSail.F5)(
		$elm$core$Maybe$Just(routeTripSail.F4));
};
var $author$project$Types$InfographicData$isDisembarkationAvailable = F2(
	function (_v0, _v1) {
		var arrivalIsoDate = _v0.ps;
		var departureIsoDate = _v1.nr;
		return A4($justinmimbs$time_extra$Time$Extra$diff, 12, $elm$time$Time$utc, arrivalIsoDate, departureIsoDate) > 1;
	});
var $author$project$Types$InfographicData$NoSailData = {$: 6};
var $author$project$Types$InfographicData$OneDepartureSailData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$InfographicData$sailDataWithoutDisembarkationPort = F4(
	function (translations, outwardSail, returnSail, locale) {
		var route = _List_fromArray(
			[outwardSail.kS.j3, outwardSail.le.j3, returnSail.le.j3]);
		var name = _Utils_eq(
			route,
			_List_fromArray(
				[0, 17, 0])) ? translations.fZ : A2(
			$elm$core$String$join,
			' - ',
			A2($elm$core$List$map, $author$project$Types$Port$toString, route));
		return {
			l2: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, returnSail.ps),
			lm: $author$project$Utils$Time$Format$formatHourMinute(returnSail.ps),
			jI: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, outwardSail.nr),
			p3: $author$project$Utils$Time$Format$formatHourMinute(outwardSail.nr),
			oh: name
		};
	});
var $author$project$Types$InfographicData$sailDataWithoutDisembarkation = F3(
	function (translations, _v0, locale) {
		var outwardSail = _v0.a;
		var maybeReturnSail = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$InfographicData$NoSailData,
			A2(
				$elm$core$Maybe$map,
				function (returnSail) {
					return $author$project$Types$InfographicData$OneDepartureSailData(
						{
							kF: A4($author$project$Types$InfographicData$sailDataWithoutDisembarkationPort, translations, outwardSail, returnSail, locale)
						});
				},
				maybeReturnSail));
	});
var $author$project$Types$InfographicData$CruiseSailData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$InfographicData$OneDepartureRouteTripSailData = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$InfographicData$TurStoOneDepartureSailData = function (a) {
	return {$: 5, a: a};
};
var $author$project$Utils$Route$isTalPartyRoute = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return (!from) && (to === 17);
};
var $author$project$Types$InfographicData$toCruisePortFrom = F2(
	function (sail, locale) {
		return {
			l2: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps),
			lm: $author$project$Utils$Time$Format$formatHourMinute(sail.ps),
			jI: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr),
			p3: $author$project$Utils$Time$Format$formatHourMinute(sail.nr),
			oh: $author$project$Types$Port$toString(sail.kS.j3)
		};
	});
var $author$project$Types$InfographicData$toCruisePortTo = F2(
	function (sail, locale) {
		return {
			l2: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps),
			lm: $author$project$Utils$Time$Format$formatHourMinute(sail.ps),
			jI: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr),
			p3: $author$project$Utils$Time$Format$formatHourMinute(sail.nr),
			oh: $author$project$Types$Port$toString(sail.le.j3)
		};
	});
var $author$project$Types$InfographicData$initPort = {l2: '', lm: '', jI: '', p3: '', oh: ''};
var $author$project$Types$InfographicData$toPortStop = F2(
	function (sail, locale) {
		return _Utils_update(
			$author$project$Types$InfographicData$initPort,
			{
				jI: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps),
				oh: $author$project$Types$Port$toString(sail.le.j3)
			});
	});
var $author$project$Types$InfographicData$toPortTo = F3(
	function (sail, name, locale) {
		return {
			l2: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps),
			lm: $author$project$Utils$Time$Format$formatHourMinute(sail.ps),
			jI: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr),
			p3: $author$project$Utils$Time$Format$formatHourMinute(sail.nr),
			oh: $elm$core$String$isEmpty(name) ? A2(
				$elm$core$String$join,
				' - ',
				A2(
					$elm$core$List$map,
					$author$project$Types$Port$toString,
					_List_fromArray(
						[sail.kS.j3, sail.le.j3]))) : name
		};
	});
var $author$project$Types$InfographicData$toCruise = F3(
	function (translations, _v0, locale) {
		var outwardSail = _v0.a;
		var returnSail = _v0.b;
		var route = {kS: outwardSail.kS.j3, le: outwardSail.le.j3};
		return $author$project$Utils$Route$isStoTurRoute(route) ? $author$project$Types$InfographicData$TurStoOneDepartureSailData(
			{
				kF: A4($author$project$Types$InfographicData$sailDataWithoutDisembarkationPort, translations, outwardSail, returnSail, locale)
			}) : ($author$project$Utils$Route$isTalPartyRoute(route) ? $author$project$Types$InfographicData$OneDepartureRouteTripSailData(
			{
				kF: A3(
					$author$project$Types$InfographicData$toPortTo,
					outwardSail,
					function ($) {
						return $.fZ;
					}(translations),
					locale)
			}) : $author$project$Types$InfographicData$CruiseSailData(
			{
				kF: A2($author$project$Types$InfographicData$toCruisePortFrom, outwardSail, locale),
				E2: A2($author$project$Types$InfographicData$toPortStop, outwardSail, locale),
				oB: A2($author$project$Types$InfographicData$toCruisePortTo, returnSail, locale)
			}));
	});
var $author$project$Types$InfographicData$CruiseWithTwoStopsSailData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$InfographicData$toCruiseWithTwoStops = F2(
	function (_v0, locale) {
		var outwardSail = _v0.a;
		var intermediateSail = _v0.b;
		var returnSail = _v0.c;
		return $author$project$Types$InfographicData$CruiseWithTwoStopsSailData(
			{
				kF: A2($author$project$Types$InfographicData$toCruisePortFrom, outwardSail, locale),
				E3: A2($author$project$Types$InfographicData$toPortStop, outwardSail, locale),
				E4: A2($author$project$Types$InfographicData$toPortStop, intermediateSail, locale),
				oB: A2($author$project$Types$InfographicData$toCruisePortTo, returnSail, locale)
			});
	});
var $author$project$Types$InfographicData$toPortFrom = F2(
	function (sail, locale) {
		return {
			l2: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps),
			lm: $author$project$Utils$Time$Format$formatHourMinute(sail.ps),
			jI: A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr),
			p3: $author$project$Utils$Time$Format$formatHourMinute(sail.nr),
			oh: A2(
				$elm$core$String$join,
				' - ',
				A2(
					$elm$core$List$map,
					$author$project$Types$Port$toString,
					_List_fromArray(
						[sail.kS.j3, sail.le.j3])))
		};
	});
var $author$project$Types$InfographicData$toOneDeparture = F2(
	function (outwardSail, locale) {
		return $author$project$Types$InfographicData$OneDepartureSailData(
			{
				kF: A2($author$project$Types$InfographicData$toPortFrom, outwardSail, locale)
			});
	});
var $author$project$Types$InfographicData$toOneDepartureRouteTrip = F2(
	function (outwardSail, locale) {
		return $author$project$Types$InfographicData$OneDepartureRouteTripSailData(
			{
				kF: A2($author$project$Types$InfographicData$toPortFrom, outwardSail, locale)
			});
	});
var $author$project$Types$InfographicData$TwoDeparturesSailData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$InfographicData$toTwoDepartures = F2(
	function (_v0, locale) {
		var outwardSail = _v0.a;
		var maybeReturnSail = _v0.b;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$InfographicData$NoSailData,
			A2(
				$elm$core$Maybe$map,
				function (returnSail) {
					return $author$project$Types$InfographicData$TwoDeparturesSailData(
						{
							kF: A2($author$project$Types$InfographicData$toPortFrom, outwardSail, locale),
							oB: A3($author$project$Types$InfographicData$toPortTo, returnSail, '', locale)
						});
				},
				maybeReturnSail));
	});
var $author$project$Types$InfographicData$generateSailDataFromTrips = F2(
	function (translations, session) {
		var language = session.A_;
		var market = session.rb;
		var voyageType = session.tx;
		var locale = A2($author$project$Types$Locale$Locale, language, market);
		var _v0 = $author$project$Types$Trips$statusToMaybe(session.tp);
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var cruise = _v0.a.a;
					return $elm$core$Maybe$Just(
						function (_v1) {
							var outwardSail = _v1.a;
							var maybeIntermediateSail = _v1.b;
							var returnSail = _v1.c;
							return _Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseParty) ? A3(
								$author$project$Types$InfographicData$sailDataWithoutDisembarkation,
								translations,
								_Utils_Tuple2(
									outwardSail,
									$elm$core$Maybe$Just(returnSail)),
								locale) : A2(
								$elm$core$Maybe$withDefault,
								A3(
									$author$project$Types$InfographicData$toCruise,
									translations,
									_Utils_Tuple2(outwardSail, returnSail),
									locale),
								A2(
									$elm$core$Maybe$map,
									function (intermediateSail) {
										return A2(
											$author$project$Types$InfographicData$toCruiseWithTwoStops,
											_Utils_Tuple3(outwardSail, intermediateSail, returnSail),
											locale);
									},
									maybeIntermediateSail));
						}(
							$author$project$Types$MikiSail$fromCruiseSail(
								$author$project$Types$CruiseSails$selected(cruise).b)));
				case 1:
					var route = _v0.a.a;
					var _v2 = $author$project$Types$RouteTripSails$selected(route);
					var outwardSail = _v2.a;
					var maybeReturnSail = _v2.b;
					var isShuttleRoute = A2($author$project$Utils$Route$isTalHelRoute, outwardSail.v1, outwardSail.v2);
					if (!maybeReturnSail.$) {
						var returnSail = maybeReturnSail.a;
						return $elm$core$Maybe$Just(
							A2(
								$author$project$Types$InfographicData$toTwoDepartures,
								_Utils_Tuple2(
									$author$project$Types$MikiSail$fromRouteTripSail(outwardSail),
									$elm$core$Maybe$Just(
										$author$project$Types$MikiSail$fromRouteTripSail(returnSail))),
								locale));
					} else {
						return isShuttleRoute ? $elm$core$Maybe$Just(
							A2(
								$author$project$Types$InfographicData$toOneDeparture,
								$author$project$Types$MikiSail$fromRouteTripSail(outwardSail),
								locale)) : $elm$core$Maybe$Just(
							A2(
								$author$project$Types$InfographicData$toOneDepartureRouteTrip,
								$author$project$Types$MikiSail$fromRouteTripSail(outwardSail),
								locale));
					}
				default:
					var cruiseMultiDeparture = _v0.a.a;
					return $elm$core$Maybe$Just(
						function (_v4) {
							var outwardSail = _v4.a;
							var returnSail = _v4.b;
							return A2($author$project$Types$InfographicData$isDisembarkationAvailable, outwardSail, returnSail) ? A2(
								$author$project$Types$InfographicData$toTwoDepartures,
								_Utils_Tuple2(
									outwardSail,
									$elm$core$Maybe$Just(returnSail)),
								locale) : A3(
								$author$project$Types$InfographicData$sailDataWithoutDisembarkation,
								translations,
								_Utils_Tuple2(
									outwardSail,
									$elm$core$Maybe$Just(returnSail)),
								locale);
						}(
							$author$project$Types$MikiSail$fromCruiseMultiDeparture(
								$author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture))));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Types$MikiSail$fromReservationSail = function (input) {
	return $author$project$Types$MikiSail$MikiSail(input.na)(input.nq)(input.kS)(input.le)(input.oX)($elm$core$Maybe$Nothing)(false)(
		A2($author$project$Types$AshorePeriod$AshorePeriod, 0, 0))(input.F5)($elm$core$Maybe$Nothing);
};
var $author$project$Types$InfographicData$generateSailDataFromReservation = F4(
	function (translations, sails, productType, locale) {
		switch (productType) {
			case 0:
				switch (sails.$) {
					case 0:
						var outward = sails.a;
						return A2($author$project$Utils$Route$isTalHelRoute, outward.kS.j3, outward.le.j3) ? A2(
							$author$project$Types$InfographicData$toOneDeparture,
							$author$project$Types$MikiSail$fromReservationSail(outward),
							locale) : A2(
							$author$project$Types$InfographicData$toOneDepartureRouteTrip,
							$author$project$Types$MikiSail$fromReservationSail(outward),
							locale);
					case 1:
						var outward = sails.a.Ds;
						var _return = sails.a.FL;
						return A2(
							$author$project$Types$InfographicData$toTwoDepartures,
							_Utils_Tuple2(
								$author$project$Types$MikiSail$fromReservationSail(outward),
								$elm$core$Maybe$Just(
									$author$project$Types$MikiSail$fromReservationSail(_return))),
							locale);
					default:
						var outward = sails.a.Ds;
						var _return = sails.a.FL;
						return $author$project$Types$InfographicData$NoSailData;
				}
			case 1:
				switch (sails.$) {
					case 0:
						var outward = sails.a;
						return A2(
							$author$project$Types$InfographicData$toOneDepartureRouteTrip,
							$author$project$Types$MikiSail$fromReservationSail(outward),
							locale);
					case 1:
						var outward = sails.a.Ds;
						var _return = sails.a.FL;
						return A3(
							$author$project$Types$InfographicData$toCruise,
							translations,
							_Utils_Tuple2(
								$author$project$Types$MikiSail$fromReservationSail(outward),
								$author$project$Types$MikiSail$fromReservationSail(_return)),
							locale);
					default:
						var outward = sails.a.Ds;
						var intermediate = sails.a.z1;
						var _return = sails.a.FL;
						return A2(
							$author$project$Types$InfographicData$toCruiseWithTwoStops,
							_Utils_Tuple3(
								$author$project$Types$MikiSail$fromReservationSail(outward),
								$author$project$Types$MikiSail$fromReservationSail(intermediate),
								$author$project$Types$MikiSail$fromReservationSail(_return)),
							locale);
				}
			case 2:
				if (sails.$ === 1) {
					var outward = sails.a.Ds;
					var _return = sails.a.FL;
					return A3(
						$author$project$Types$InfographicData$sailDataWithoutDisembarkation,
						translations,
						_Utils_Tuple2(
							$author$project$Types$MikiSail$fromReservationSail(outward),
							$elm$core$Maybe$Just(
								$author$project$Types$MikiSail$fromReservationSail(_return))),
						locale);
				} else {
					return $author$project$Types$InfographicData$NoSailData;
				}
			default:
				switch (sails.$) {
					case 0:
						var outward = sails.a;
						return A2(
							$author$project$Types$InfographicData$toOneDepartureRouteTrip,
							$author$project$Types$MikiSail$fromReservationSail(outward),
							locale);
					case 1:
						var outward = sails.a.Ds;
						var _return = sails.a.FL;
						return A2(
							$author$project$Types$InfographicData$toTwoDepartures,
							_Utils_Tuple2(
								$author$project$Types$MikiSail$fromReservationSail(outward),
								$elm$core$Maybe$Just(
									$author$project$Types$MikiSail$fromReservationSail(_return))),
							locale);
					default:
						return $author$project$Types$InfographicData$NoSailData;
				}
		}
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Common$MiniSummary$direction = function (sailData) {
	var ports = function () {
		switch (sailData.$) {
			case 2:
				var data = sailData.a;
				var to = A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2($elm$core$String$split, ' - ', data.oB.oh)));
				var from = A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(
						A2($elm$core$String$split, ' - ', data.kF.oh)));
				return _List_fromArray(
					[from, to, from]);
			case 0:
				var data = sailData.a;
				return _List_fromArray(
					[data.kF.oh, data.E2.oh, data.oB.oh]);
			case 3:
				var data = sailData.a;
				return A2($elm$core$String$split, ' - ', data.kF.oh);
			case 4:
				var data = sailData.a;
				return A2($elm$core$String$split, ' - ', data.kF.oh);
			case 5:
				var data = sailData.a;
				return A2($elm$core$String$split, ' - ', data.kF.oh);
			case 6:
				return _List_Nil;
			default:
				var data = sailData.a;
				return _List_fromArray(
					[data.kF.oh, data.E3.oh, data.E4.oh, data.oB.oh]);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyNorm direction')
			]),
		A2(
			$elm$core$List$intersperse,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('arrow')
					]),
				_List_Nil),
			A2($elm$core$List$map, $elm$html$Html$text, ports)));
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$UrlRoute$onClickWithoutSideEffects = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		A2(
			$elm$json$Json$Decode$map,
			function (message) {
				return {Cv: message, r5: true, sZ: true};
			},
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Common$MiniSummary$nonRefundableWarning = F2(
	function (translations, openNonRefundableTermsModal) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nonRefundableWarning bodyNorm'),
					$author$project$UrlRoute$onClickWithoutSideEffects(openNonRefundableTermsModal)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.C_)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$Translations$toHtml(translations.CU))
				]));
	});
var $author$project$Types$Currency$toLongSign = function (currency) {
	if (currency === 1) {
		return 'SEK';
	} else {
		return '€';
	}
};
var $author$project$Common$MiniSummary$total = F3(
	function (translations, price, maybePointsPrice) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('total bodyNorm')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('totalKey')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.Fg)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('totalValue')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('totalPrice'),
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'paymentMoney')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(price)
								])),
							A2(
							$author$project$Utils$Html$Render$maybeRender,
							function (pointsPrice) {
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('totalPointsPrice'),
											A2($elm$html$Html$Attributes$attribute, 'data-test', 'paymentPoints')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' + ' + pointsPrice)
										]));
							},
							maybePointsPrice)
						]))
				]));
	});
var $author$project$Common$Infographic$Infographic$portNode = F3(
	function (className, title, date) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm'),
							A2($elm$html$Html$Attributes$attribute, 'data-test-portFrom', title)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm'),
							A2($elm$html$Html$Attributes$attribute, 'data-test-date', '')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(date)
						]))
				]));
	});
var $author$project$Common$Infographic$Infographic$portFrom = F2(
	function (title, date) {
		return A3($author$project$Common$Infographic$Infographic$portNode, 'portFrom', title, date);
	});
var $author$project$Common$Infographic$Infographic$portStop = F2(
	function (title, date) {
		return A3($author$project$Common$Infographic$Infographic$portNode, 'portStop', title, date);
	});
var $author$project$Common$Infographic$Infographic$portTo = F2(
	function (title, date) {
		return A3($author$project$Common$Infographic$Infographic$portNode, 'portTo', title, date);
	});
var $author$project$Common$Infographic$Infographic$cruiseBlock = F3(
	function (from, stop, to) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ports cruise')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Infographic$Infographic$portFrom, from.oh, from.jI),
					A2($author$project$Common$Infographic$Infographic$portStop, stop.oh, stop.jI),
					A2($author$project$Common$Infographic$Infographic$portTo, to.oh, to.l2)
				]));
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Common$Infographic$Infographic$createCircle = function () {
	var circleRadius = 4.5;
	var circleRadiusStringValue = $elm$core$String$fromFloat(circleRadius);
	var circleSideStringValue = $elm$core$String$fromFloat(circleRadius * 2);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(circleSideStringValue),
				$elm$svg$Svg$Attributes$height(circleSideStringValue),
				$elm$svg$Svg$Attributes$viewBox('0 0 ' + (circleSideStringValue + (' ' + circleSideStringValue)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx(circleRadiusStringValue),
						$elm$svg$Svg$Attributes$cy(circleRadiusStringValue),
						$elm$svg$Svg$Attributes$r(circleRadiusStringValue)
					]),
				_List_Nil)
			]));
}();
var $author$project$Common$Infographic$Infographic$waveColor = 'midnightBlue';
var $author$project$Common$Infographic$Infographic$wave = F3(
	function (className, departureTime, arrivalTime) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							$elm$core$String$concat(
								_List_fromArray(
									['wave ', $author$project$Common$Infographic$Infographic$waveColor])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('circle')
								]),
							_List_fromArray(
								[$author$project$Common$Infographic$Infographic$createCircle])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('middleSection')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('circle')
								]),
							_List_fromArray(
								[$author$project$Common$Infographic$Infographic$createCircle]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('leg departure bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(departureTime)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('leg arrival bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(arrivalTime)
						]))
				]));
	});
var $author$project$Common$Infographic$Infographic$cruiseWithTwoStopsBlock = F4(
	function (from, stop1, stop2, to) {
		var wavesBlock = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('waves withTwoOutwards')
				]),
			A2(
				$elm$core$List$intersperse,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('spacer')
						]),
					_List_Nil),
				_List_fromArray(
					[
						A3($author$project$Common$Infographic$Infographic$wave, 'outward', from.p3, stop1.lm),
						A3($author$project$Common$Infographic$Infographic$wave, 'outward', stop1.p3, stop2.lm),
						A3($author$project$Common$Infographic$Infographic$wave, 'outward', stop2.p3, to.lm)
					])));
		var portsBlock = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ports cruise withTwoOutwards')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Infographic$Infographic$portFrom, from.oh, from.jI),
					A2($author$project$Common$Infographic$Infographic$portStop, stop1.oh, stop1.jI),
					A2($author$project$Common$Infographic$Infographic$portStop, stop2.oh, stop2.jI),
					A2($author$project$Common$Infographic$Infographic$portTo, to.oh, to.l2)
				]));
		return _List_fromArray(
			[portsBlock, wavesBlock]);
	});
var $author$project$Common$Infographic$Infographic$oneDepartureBlock = function (from) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ports oneWayTrip')
			]),
		_List_fromArray(
			[
				A2($author$project$Common$Infographic$Infographic$portFrom, from.oh, from.jI)
			]));
};
var $author$project$Common$Infographic$Infographic$oneDepartureRouteTripBlock = function (from) {
	var names = A2($elm$core$String$split, '-', from.oh);
	var _v0 = function () {
		if ((names.b && names.b.b) && (!names.b.b.b)) {
			var a = names.a;
			var _v2 = names.b;
			var b = _v2.a;
			return _Utils_Tuple2(a, b);
		} else {
			return _Utils_Tuple2('', '');
		}
	}();
	var fromName = _v0.a;
	var toName = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ports oneWayRouteTrip')
			]),
		_List_fromArray(
			[
				A2($author$project$Common$Infographic$Infographic$portFrom, fromName, from.jI),
				A2($author$project$Common$Infographic$Infographic$portTo, toName, from.l2)
			]));
};
var $author$project$Common$Infographic$Infographic$turStoOneDeparture = function (from) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('ports cruise')
			]),
		_List_fromArray(
			[
				A2($author$project$Common$Infographic$Infographic$portFrom, '', from.jI),
				A2($author$project$Common$Infographic$Infographic$portStop, from.oh, ''),
				A2($author$project$Common$Infographic$Infographic$portTo, '', from.l2)
			]));
};
var $author$project$Common$Infographic$Infographic$twoDeparturesBlock = F2(
	function (from, to) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ports roundTripPorts')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Infographic$Infographic$portFrom, from.oh, from.jI),
					A2($author$project$Common$Infographic$Infographic$portTo, to.oh, to.jI)
				]));
	});
var $author$project$Common$Infographic$Infographic$waves = F2(
	function (from, maybeTo) {
		var secondWave = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (to) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('spacer')
								]),
							_List_Nil),
							A3($author$project$Common$Infographic$Infographic$wave, 'return', to.p3, to.lm)
						]);
				},
				maybeTo));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('waves')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A3($author$project$Common$Infographic$Infographic$wave, 'outward', from.p3, from.lm)
					]),
				secondWave));
	});
var $author$project$Common$Infographic$Infographic$view = function (sailData) {
	var block = function () {
		switch (sailData.$) {
			case 2:
				var data = sailData.a;
				var to = data.oB;
				var from = data.kF;
				return _List_fromArray(
					[
						A2($author$project$Common$Infographic$Infographic$twoDeparturesBlock, from, to),
						A2(
						$author$project$Common$Infographic$Infographic$waves,
						from,
						$elm$core$Maybe$Just(to))
					]);
			case 0:
				var data = sailData.a;
				var to = data.oB;
				var stop = data.E2;
				var from = data.kF;
				return _List_fromArray(
					[
						A3($author$project$Common$Infographic$Infographic$cruiseBlock, from, stop, to),
						A2(
						$author$project$Common$Infographic$Infographic$waves,
						from,
						$elm$core$Maybe$Just(to))
					]);
			case 1:
				var data = sailData.a;
				return A4($author$project$Common$Infographic$Infographic$cruiseWithTwoStopsBlock, data.kF, data.E3, data.E4, data.oB);
			case 3:
				var data = sailData.a;
				var from = data.kF;
				return _List_fromArray(
					[
						$author$project$Common$Infographic$Infographic$oneDepartureBlock(from),
						A2($author$project$Common$Infographic$Infographic$waves, from, $elm$core$Maybe$Nothing)
					]);
			case 4:
				var data = sailData.a;
				var from = data.kF;
				return _List_fromArray(
					[
						$author$project$Common$Infographic$Infographic$oneDepartureRouteTripBlock(from),
						A2($author$project$Common$Infographic$Infographic$waves, from, $elm$core$Maybe$Nothing)
					]);
			case 5:
				var data = sailData.a;
				return _List_fromArray(
					[
						$author$project$Common$Infographic$Infographic$turStoOneDeparture(data.kF),
						A2($author$project$Common$Infographic$Infographic$waves, data.kF, $elm$core$Maybe$Nothing)
					]);
			default:
				return _List_fromArray(
					[
						$elm$html$Html$text('')
					]);
		}
	}();
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('infographic'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'infographic')
			]),
		block);
};
var $author$project$Common$MiniSummary$miniSummaryView = F7(
	function (translations, sailData, passengersCount, price, maybePointsPrice, _v0, openNonRefundableTermsModal) {
		var market = _v0.rb;
		var language = _v0.A_;
		var vouchers = _v0.tw;
		var priceString = function (formattedPrice) {
			return formattedPrice + (' ' + $author$project$Types$Currency$toLongSign(
				$author$project$Types$Market$toCurrency(market)));
		}(
			A2($author$project$Types$Market$formatPrice, market, price));
		var passengersCountString = A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'count',
					$elm$core$String$fromInt(passengersCount))
				]),
			A2(
				$author$project$Translations$pluralize,
				_Utils_Tuple2('count', passengersCount),
				translations.xp));
		var maybePointsPriceString = A2(
			$elm$core$Maybe$map,
			$author$project$Types$Market$formatPoints(language),
			maybePointsPrice);
		var maybeNonRefundableVoucherCode = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.pQ;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.Ak;
					},
					vouchers)));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'view', 'miniSummary'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'minisummary')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('miniSummaryBlock')
						]),
					_List_fromArray(
						[
							$author$project$Common$MiniSummary$direction(sailData),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm passengersCount')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(passengersCountString)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('miniSummaryBlock')
						]),
					_List_fromArray(
						[
							$author$project$Common$Infographic$Infographic$view(sailData)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('miniSummaryBlock')
						]),
					_List_fromArray(
						[
							A3($author$project$Common$MiniSummary$total, translations, priceString, maybePointsPriceString)
						])),
					A2(
					$author$project$Utils$Html$Render$maybeRender,
					function (_v1) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('miniSummaryBlock')
								]),
							_List_fromArray(
								[
									A2($author$project$Common$MiniSummary$nonRefundableWarning, translations, openNonRefundableTermsModal)
								]));
					},
					maybeNonRefundableVoucherCode)
				]));
	});
var $author$project$Common$MiniSummary$view = F5(
	function (session, translations, model, showPointsPrice, openNonRefundableTermsModal) {
		var _v0 = session.Fz;
		if (!_v0.$) {
			var reservationData = _v0.a;
			var sailData = A4(
				$author$project$Types$InfographicData$generateSailDataFromReservation,
				translations,
				reservationData.F6,
				reservationData.Fn,
				A2($author$project$Types$Locale$Locale, session.A_, session.rb));
			var price = reservationData.lN - reservationData.DG;
			var passengersCount = $elm$core$List$length(reservationData.Eg);
			var maybePointsPrice = (showPointsPrice && (reservationData.oA > 0)) ? $elm$core$Maybe$Just(reservationData.oA) : $elm$core$Maybe$Nothing;
			return A7($author$project$Common$MiniSummary$miniSummaryView, translations, sailData, passengersCount, price, maybePointsPrice, session, openNonRefundableTermsModal);
		} else {
			var passengersCount = $elm$core$Array$length(session.Eg);
			var maybePointsPrice = A2(
				$elm$core$Maybe$andThen,
				function (priceInPoints) {
					return (showPointsPrice && (priceInPoints > 0)) ? $elm$core$Maybe$Just(priceInPoints) : $elm$core$Maybe$Nothing;
				},
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.oA;
					},
					session.B7));
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (sailData, price) {
							return A7($author$project$Common$MiniSummary$miniSummaryView, translations, sailData, passengersCount, price, maybePointsPrice, session, openNonRefundableTermsModal);
						}),
					model.ob,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.lN;
						},
						session.B7)));
		}
	});
var $author$project$View$paymentPageHeader = F2(
	function (translations, model) {
		var miniSummaryModel = {
			ob: A2($author$project$Types$InfographicData$generateSailDataFromTrips, translations, model.j)
		};
		var maybeTitle = function () {
			var _v1 = model.DF;
			switch (_v1.$) {
				case 4:
					return $elm$core$Maybe$Just(translations.Ei);
				case 12:
					return $elm$core$Maybe$Just(translations.eg);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var isUnfinishedPayment = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$contains('resToken'),
				model.n1.Fo));
		var hasReturnUrl = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$contains('returnUrl'),
				model.n1.Fo));
		var backButtonMsg = function () {
			var _v0 = model.DF;
			switch (_v0.$) {
				case 4:
					return (model.qV && (isUnfinishedPayment && hasReturnUrl)) ? $author$project$Messages$ClickedGoBackInNativeApp : ((isUnfinishedPayment || (!model.j.Ao)) ? $author$project$Messages$OpenedModal($author$project$Common$Modal$Model$ResetBooking) : $author$project$Messages$ClickedGoBack);
				case 12:
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Messages$ClickedGoBack,
						A2($elm$core$Maybe$map, $author$project$Messages$CancelledKlarnaPayment, model.j.B_));
				default:
					return $author$project$Messages$ClickedGoBack;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('headerHolder withSummary')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell')
								]),
							A2(
								$author$project$Utils$List$maybeAdd,
								A2(
									$elm$core$Maybe$map,
									function (title) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title2')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(title)
												]));
									},
									maybeTitle),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('backButton'),
												$elm$html$Html$Events$onClick(backButtonMsg)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('assets/images/_cacheCommon/icon_back_arrow.svg')
													]),
												_List_Nil)
											]))
									])))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					!_Utils_eq(model.DF, $author$project$Model$KlarnaPayment),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row miniSummary')
							]),
						_List_fromArray(
							[
								A5(
								$author$project$Common$MiniSummary$view,
								model.j,
								translations,
								miniSummaryModel,
								A2(
									$elm$core$Maybe$withDefault,
									true,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$String$contains('paymentRejected'),
											$elm$core$Basics$not),
										model.n1.Fo)),
								$author$project$Messages$OpenedModal($author$project$Common$Modal$Model$NonRefundableTerms))
							])))
				]));
	});
var $author$project$Messages$ClickedGoBackToDesktop = {$: 124};
var $author$project$Common$Modal$View$accept = F2(
	function (message, t) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('greenButton marginBottomSmall'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'confirm-button'),
					$elm$html$Html$Events$onClick(message)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(t)
				]));
	});
var $author$project$Common$Modal$View$decline = F2(
	function (message, t) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('outlineBigButton'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'cancel-button'),
					$elm$html$Html$Events$onClick(message)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(t)
				]));
	});
var $author$project$Common$Modal$View$description = function (t) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyNorm marginBottomLarge textAlignCenter modalDescription')
			]),
		t);
};
var $author$project$Common$Modal$View$title = function (t) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title2 marginBottomSmall textAlignCenter modalTitle')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(t)
			]));
};
var $author$project$Common$Modal$View$backToDesktopModal = F2(
	function (translations, _v0) {
		var voyageType = _v0.tx;
		var travelClasses = _v0.to;
		var passengers = _v0.Eg;
		var hasTravelClasses = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$BookingPage$BackToDesktop$Update$getTravelClassUrlParams, passengers, voyageType),
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				travelClasses));
		var descriptionText = $author$project$Translations$toHtml(
			(_Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) && hasTravelClasses) ? translations.up : translations.un);
		return _List_fromArray(
			[
				$author$project$Common$Modal$View$title(translations.uo),
				$author$project$Common$Modal$View$description(descriptionText),
				A2($author$project$Common$Modal$View$accept, $author$project$Messages$ClickedGoBackToDesktop, translations.um),
				A2($author$project$Common$Modal$View$decline, $author$project$Messages$ClosedModal, translations.ul)
			]);
	});
var $author$project$Types$Port$enum = function () {
	var nextPort = function (portCode) {
		switch (portCode) {
			case 2:
				return $elm$core$Maybe$Just(4);
			case 4:
				return $elm$core$Maybe$Just(1);
			case 1:
				return $elm$core$Maybe$Just(0);
			case 0:
				return $elm$core$Maybe$Just(5);
			case 5:
				return $elm$core$Maybe$Just(3);
			case 3:
				return $elm$core$Maybe$Just(7);
			case 7:
				return $elm$core$Maybe$Just(8);
			case 8:
				return $elm$core$Maybe$Just(12);
			case 12:
				return $elm$core$Maybe$Just(13);
			case 13:
				return $elm$core$Maybe$Just(6);
			case 6:
				return $elm$core$Maybe$Just(9);
			case 16:
				return $elm$core$Maybe$Just(6);
			case 9:
				return $elm$core$Maybe$Just(10);
			case 10:
				return $elm$core$Maybe$Just(11);
			case 11:
				return $elm$core$Maybe$Just(14);
			case 14:
				return $elm$core$Maybe$Just(15);
			case 15:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var enumerate = F2(
		function (toNext, value) {
			var _v0 = toNext(value);
			if (!_v0.$) {
				var next = _v0.a;
				return A2(
					$elm$core$List$cons,
					value,
					A2(enumerate, toNext, next));
			} else {
				return _List_fromArray(
					[value]);
			}
		});
	return A2(enumerate, nextPort, 2);
}();
var $author$project$Utils$Route$availableDepartures = function (bookingType) {
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			$author$project$Utils$Route$supportedDestinations(bookingType)),
		$author$project$Types$Port$enum);
};
var $author$project$Common$Modal$View$harborImageBase = 'assets/images/city/icon_destination_';
var $author$project$Common$Modal$View$harborImage = F2(
	function (harbor, ratio) {
		return $author$project$Common$Modal$View$harborImageBase + ($elm$core$String$toLower(
			$author$project$Types$Port$toString(harbor)) + ('@' + ($elm$core$String$fromInt(ratio) + 'x.png')));
	});
var $elm$svg$Svg$ellipse = $elm$svg$Svg$trustedNode('ellipse');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $author$project$Common$Images$tickMarkOutline = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('tickSvg'),
					$elm$svg$Svg$Attributes$fillRule('evenodd')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('tickOutline'),
							$elm$svg$Svg$Attributes$d('M12,22.5 C17.799,22.5 22.5,17.799 22.5,12 C22.5,6.201 17.799,1.5 12,1.5 C6.201,1.5 1.5,6.201 1.5,12 C1.5,17.799 6.201,22.5 12,22.5 M24,12 C24,18.686 18.686,24 12,24 C5.314,24 0,18.686 0,12 C0,5.314 5.314,0 12,0 C18.686,0 24,5.314 24,12')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$ellipse,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('tickCircle'),
							$elm$svg$Svg$Attributes$ry('10.648148'),
							$elm$svg$Svg$Attributes$rx('10.74074'),
							$elm$svg$Svg$Attributes$cy('11.999998'),
							$elm$svg$Svg$Attributes$cx('11.907404'),
							$elm$svg$Svg$Attributes$stroke('none'),
							$elm$svg$Svg$Attributes$fill('#ffffff')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$polygon,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('tickMark'),
							$elm$svg$Svg$Attributes$points('6.83 11.526 5 13.257 9.796 19 18 8.683 16.132 7 9.751 15.024')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Common$Modal$View$portButton = F5(
	function (translations, ratio, isActive, toMsg, harbor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('item'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-location',
					$author$project$Types$Port$toString(harbor)),
					$elm$html$Html$Events$onClick(
					toMsg(harbor))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							A2($author$project$Common$Modal$View$harborImage, harbor, ratio))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Types$Port$translate, harbor, translations)),
									A2(
									$author$project$Utils$String$renderIf,
									harbor === 17,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('wowTag')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(translations.IC)
											])))
								]))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					isActive,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('activeIcon tickMarkImageOutlined')
							]),
						_List_fromArray(
							[$author$project$Common$Images$tickMarkOutline])))
				]));
	});
var $author$project$Common$Modal$View$updatePorts = F2(
	function (from, to) {
		return $author$project$Messages$ChangedVoyage(
			{kS: from, Cd: $elm$core$Maybe$Nothing, le: to});
	});
var $author$project$Common$Modal$View$fromToModal = F3(
	function (translations, _v0, activeFromOrTo) {
		var density = _v0.yn;
		var from = _v0.kS;
		var to = _v0.le;
		var bookingType = _v0.vk;
		var titleTranslation = (!activeFromOrTo) ? translations.uR : translations.uS;
		var _v1 = (!activeFromOrTo) ? _Utils_Tuple3(
			from,
			$author$project$Utils$Route$availableDepartures(bookingType),
			function (p) {
				return A2($author$project$Common$Modal$View$updatePorts, p, to);
			}) : _Utils_Tuple3(
			to,
			A2($author$project$Utils$Route$supportedDestinations, bookingType, from),
			$author$project$Common$Modal$View$updatePorts(from));
		var currentPort = _v1.a;
		var departures = _v1.b;
		var changePort = _v1.c;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title2 marginBottomMedium')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(titleTranslation)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('citiesList')
					]),
				A2(
					$elm$core$List$intersperse,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('divider')
							]),
						_List_Nil),
					A2(
						$elm$core$List$map,
						function (a) {
							return A5(
								$author$project$Common$Modal$View$portButton,
								translations,
								density,
								_Utils_eq(currentPort, a),
								changePort,
								a);
						},
						departures)))
			]);
	});
var $author$project$Common$Modal$View$getModalClass = function (modalType) {
	switch (modalType.$) {
		case 0:
			return 'fromTo';
		case 1:
			return 'backToDesktop';
		case 2:
			return 'mealPackage';
		case 3:
			return 'resetBooking';
		case 4:
			return 'sessionError';
		case 5:
			return 'shoppingCruise';
		case 6:
			return 'httpError';
		case 7:
			return 'suggestBuyingMeals';
		case 8:
			return 'suggestAddingVehicleToOtherLeg';
		case 9:
			return 'suggestTravellingViaDifferentCity';
		case 10:
			return 'selectVehicle';
		case 11:
			return 'nonRefundableTerms';
		default:
			return 'nonRefundableWarning';
	}
};
var $author$project$Common$Modal$View$mealPackageItemIcon = function (_v0) {
	var breakfasts = _v0.vv;
	var lunches = _v0.BA;
	var buffets = _v0.vA;
	var selectionCounts = A2(
		$elm$core$List$filter,
		$elm$core$Basics$eq(0),
		_List_fromArray(
			[breakfasts, lunches, buffets]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'mealPackageItemIcon ' + (($elm$core$List$sum(selectionCounts) === 3) ? 'bodyBold' : 'title5'))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$String$join,
					'+',
					A2($elm$core$List$map, $elm$core$String$fromInt, selectionCounts)))
			]));
};
var $author$project$Common$Modal$View$mealPackageButton = F3(
	function (translations, session, _package) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mealPackage'),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$MealPageMsg(
						$author$project$MealPage$Messages$ClickedToggleMealPackage(_package.pQ)))
				]),
			_List_fromArray(
				[
					$author$project$Common$Modal$View$mealPackageItemIcon(_package),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mealPackageName title1Medium')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(_package.oh)
								])),
							A2(
							$author$project$Utils$String$renderIf,
							!$author$project$MealPage$Meal$isMealPriceHidden(session),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mealPackagePrice priceNormal')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$MealPage$Meal$translatePrice,
											translations,
											A2($author$project$Types$Market$formatPriceWithSign, session.rb, _package.lN)))
									])))
						]))
				]));
	});
var $author$project$Common$Modal$View$mealPackageModal = function (_v0) {
	var translations = _v0.lY;
	var session = _v0.j;
	var regularMealPackages = _v0.sk;
	return A2(
		$elm$core$List$cons,
		$author$project$Common$Modal$View$title(translations.Ch),
		A2(
			$elm$core$List$intersperse,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('divider')
					]),
				_List_Nil),
			A2(
				$elm$core$List$map,
				A2($author$project$Common$Modal$View$mealPackageButton, translations, session),
				regularMealPackages)));
};
var $author$project$Common$Modal$View$ngdialogId = 'ngdialog';
var $author$project$Common$Modal$View$shipImage = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-icon-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/images/common/ship.svg')
				]),
			_List_Nil)
		]));
var $author$project$Common$Modal$View$nonRefundableTermsModal = function (translations) {
	return _List_fromArray(
		[
			$author$project$Common$Modal$View$shipImage,
			$author$project$Common$Modal$View$title(translations.CW),
			$author$project$Common$Modal$View$description(
			$author$project$Translations$toHtml(translations.CV)),
			A2($author$project$Common$Modal$View$accept, $author$project$Messages$ClosedModal, translations.sq)
		]);
};
var $author$project$Messages$ChangedLocationWithClosingModal = function (a) {
	return {$: 65, a: a};
};
var $author$project$Messages$DeclinedNonRefundableVoucher = {$: 117};
var $author$project$Common$Modal$View$nonRefundableWarningModal = F2(
	function (session, translations) {
		var nonRefundableVoucherCode = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.pQ;
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function ($) {
							return $.Ak;
						},
						session.tw))));
		return _List_fromArray(
			[
				$author$project$Common$Modal$View$shipImage,
				$author$project$Common$Modal$View$title(translations.C_),
				$author$project$Common$Modal$View$description(
				$author$project$Translations$toHtml(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2('code', nonRefundableVoucherCode)
							]),
						translations.CZ))),
				A2(
				$author$project$Common$Modal$View$accept,
				$author$project$Messages$ChangedLocationWithClosingModal($author$project$UrlRoute$ContactPerson),
				translations.CX),
				A2($author$project$Common$Modal$View$decline, $author$project$Messages$DeclinedNonRefundableVoucher, translations.CY)
			]);
	});
var $author$project$Messages$LoadedRootPage = {$: 118};
var $author$project$Common$Modal$View$resetBookingModal = function (translations) {
	return _List_fromArray(
		[
			$author$project$Common$Modal$View$title(translations.C3),
			$author$project$Common$Modal$View$description(
			_List_fromArray(
				[
					$elm$html$Html$text(translations.C2)
				])),
			A2($author$project$Common$Modal$View$accept, $author$project$Messages$LoadedRootPage, translations.C1),
			A2($author$project$Common$Modal$View$decline, $author$project$Messages$ClosedModal, translations.C0)
		]);
};
var $author$project$Messages$AcceptedSelectVehicle = {$: 88};
var $author$project$Messages$DeclinedSelectVehicle = {$: 89};
var $author$project$Common$Modal$View$vehicleImage = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-icon-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/images/common/vehicle.svg')
				]),
			_List_Nil)
		]));
var $author$project$Common$Modal$View$selectVehicleModal = F2(
	function (translations, _v0) {
		var onboardServices = _v0.rI;
		var selectedOnboardServices = _v0.Gm;
		var vehicleIncompatibleServiceName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.oh;
				},
				A2($author$project$Types$SelectedOnboardServices$getMaybeFirstSelectedVehicleIncompatibleOnboardService, onboardServices.Ig, selectedOnboardServices)));
		var descriptionContent = $author$project$Translations$toHtml(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2('service', vehicleIncompatibleServiceName)
					]),
				translations.Ge));
		return _List_fromArray(
			[
				$author$project$Common$Modal$View$vehicleImage,
				$author$project$Common$Modal$View$title(translations.Gf),
				$author$project$Common$Modal$View$description(descriptionContent),
				A2($author$project$Common$Modal$View$accept, $author$project$Messages$AcceptedSelectVehicle, translations.sa),
				A2($author$project$Common$Modal$View$decline, $author$project$Messages$DeclinedSelectVehicle, translations.ol)
			]);
	});
var $author$project$Common$Modal$View$sessionErrorModal = function (translations) {
	return _List_fromArray(
		[
			$author$project$Common$Modal$View$title(translations.FE),
			$author$project$Common$Modal$View$description(
			_List_fromArray(
				[
					$elm$html$Html$text(translations.FG)
				])),
			A2($author$project$Common$Modal$View$accept, $author$project$Messages$LoadedRootPage, translations.FF)
		]);
};
var $author$project$Messages$NotSelectedEligibleShoppingCruiseSail = {$: 52};
var $author$project$Messages$SelectedEligibleShoppingCruiseSail = {$: 51};
var $author$project$Common$Modal$View$shoppingCruiseImage = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-icon-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/images/common/shopping-cruise.svg')
				]),
			_List_Nil)
		]));
var $author$project$Common$Modal$View$shoppingCruiseModal = function (translations) {
	return _List_fromArray(
		[
			$author$project$Common$Modal$View$shoppingCruiseImage,
			$author$project$Common$Modal$View$title(translations.Gv),
			$author$project$Common$Modal$View$description(
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Gy)
				])),
			A2($author$project$Common$Modal$View$accept, $author$project$Messages$SelectedEligibleShoppingCruiseSail, translations.sa),
			A2($author$project$Common$Modal$View$decline, $author$project$Messages$NotSelectedEligibleShoppingCruiseSail, translations.ol)
		]);
};
var $author$project$Messages$AnsweredAddingVehicleForOtherLeg = function (a) {
	return {$: 62, a: a};
};
var $author$project$Common$Modal$View$suggestAddingVehicleToOtherLegModal = F2(
	function (translations, session) {
		var from = session.kS;
		var to = session.le;
		var _v0 = _Utils_Tuple2(
			$author$project$Types$Port$toString(from) + ('-' + $author$project$Types$Port$toString(to)),
			$author$project$Types$Port$toString(to) + ('-' + $author$project$Types$Port$toString(from)));
		var outwardRoute = _v0.a;
		var returnRoute = _v0.b;
		var _v1 = $author$project$Utils$Route$isVehicleRequiredForOutward(session) ? _Utils_Tuple2(outwardRoute, returnRoute) : _Utils_Tuple2(returnRoute, outwardRoute);
		var routeWithRequiredVehicle = _v1.a;
		var routeWithNotRequiredVehicle = _v1.b;
		return _List_fromArray(
			[
				$author$project$Common$Modal$View$title(translations.tO),
				$author$project$Common$Modal$View$description(
				$author$project$Translations$toHtml(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2('route', routeWithRequiredVehicle)
							]),
						translations.tM))),
				$author$project$Common$Modal$View$description(
				$author$project$Translations$toHtml(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2('route', routeWithNotRequiredVehicle)
							]),
						translations.tN))),
				A2(
				$author$project$Common$Modal$View$accept,
				$author$project$Messages$AnsweredAddingVehicleForOtherLeg(true),
				translations.tJ),
				A2(
				$author$project$Common$Modal$View$decline,
				$author$project$Messages$AnsweredAddingVehicleForOtherLeg(false),
				translations.uL)
			]);
	});
var $author$project$Common$Modal$View$discountImage = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('modal-icon-container')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/images/common/discount.svg')
				]),
			_List_Nil)
		]));
var $author$project$Common$Modal$View$suggestBuyingMealsModal = function (translations) {
	return _List_fromArray(
		[
			$author$project$Common$Modal$View$discountImage,
			$author$project$Common$Modal$View$title(translations.yB),
			$author$project$Common$Modal$View$description(
			$author$project$Translations$toHtml(translations.Cs)),
			A2(
			$author$project$Common$Modal$View$accept,
			$author$project$Messages$ChangedLocationWithClosingModal($author$project$UrlRoute$Meal),
			translations.uB),
			A2(
			$author$project$Common$Modal$View$decline,
			$author$project$Messages$ChangedLocationWithClosingModal($author$project$UrlRoute$ContactPerson),
			translations.ol)
		]);
};
var $author$project$Messages$AgreedToTravelViaDifferentCity = {$: 63};
var $author$project$Messages$DisagreedToTravelViaDifferentCity = {$: 64};
var $author$project$Utils$Time$toDayMonthString = function (dateTime) {
	return A3(
		$ryan_haskell$date_format$DateFormat$format,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
				$ryan_haskell$date_format$DateFormat$text('.'),
				$ryan_haskell$date_format$DateFormat$monthFixed
			]),
		$elm$time$Time$utc,
		dateTime);
};
var $author$project$Common$Modal$View$toDepartures = F2(
	function (from, to) {
		var _v0 = _Utils_Tuple2(from, to);
		_v0$4:
		while (true) {
			switch (_v0.a) {
				case 0:
					if (_v0.b === 2) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return '(7:30, 10:30, 13:30)';
					} else {
						break _v0$4;
					}
				case 2:
					switch (_v0.b) {
						case 0:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return '(13:30, 16:30, 19:30)';
						case 1:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return '(17:00)';
						default:
							break _v0$4;
					}
				case 1:
					if (_v0.b === 2) {
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return '(16:45)';
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return 'not supported';
	});
var $author$project$Common$Modal$View$sailOption = F2(
	function (translations, _v0) {
		var from = _v0.a;
		var to = _v0.b;
		var time = _v0.c;
		var titleText = A2($author$project$Types$Port$translate, from, translations) + (' – ' + (A2($author$project$Types$Port$translate, to, translations) + (' ' + $author$project$Utils$Time$toDayMonthString(time))));
		var departures = A2($author$project$Common$Modal$View$toDepartures, from, to);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sailOption')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(titleText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(departures)
						]))
				]));
	});
var $author$project$Common$Modal$View$differentSailOptions = F2(
	function (translations, sailOptions) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm marginBottomSmall')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.uC)
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Common$Modal$View$sailOption(translations),
					sailOptions)));
	});
var $author$project$Common$Modal$View$notice = function (t) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('notice')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/assets/images/common/notice.svg')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyNorm')
					]),
				$author$project$Translations$toHtml(t))
			]));
};
var $author$project$Common$Modal$View$titleWithHtml = function (t) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title2 marginBottomSmall textAlignCenter modalTitle')
			]),
		$author$project$Translations$toHtml(t));
};
var $author$project$Common$Modal$View$suggestTravelingStoTalViaHel = F2(
	function (translations, fakeSailDepartureDate) {
		return _List_fromArray(
			[
				$author$project$Common$Modal$View$shipImage,
				$author$project$Common$Modal$View$titleWithHtml(translations.G$),
				$author$project$Common$Modal$View$description(
				_List_fromArray(
					[
						$elm$html$Html$text(translations.GZ)
					])),
				A2(
				$author$project$Common$Modal$View$differentSailOptions,
				translations,
				_List_fromArray(
					[
						_Utils_Tuple3(1, 2, fakeSailDepartureDate),
						_Utils_Tuple3(
						2,
						0,
						A4($justinmimbs$time_extra$Time$Extra$add, 11, 1, $elm$time$Time$utc, fakeSailDepartureDate))
					])),
				$author$project$Common$Modal$View$notice(translations.G_),
				A2($author$project$Common$Modal$View$accept, $author$project$Messages$AgreedToTravelViaDifferentCity, translations.GY),
				A2($author$project$Common$Modal$View$decline, $author$project$Messages$DisagreedToTravelViaDifferentCity, translations.tb)
			]);
	});
var $author$project$Common$Modal$View$suggestTravelingTalStoViaHel = F2(
	function (translations, fakeSailDepartureDate) {
		return _List_fromArray(
			[
				$author$project$Common$Modal$View$shipImage,
				$author$project$Common$Modal$View$titleWithHtml(translations.Hc),
				$author$project$Common$Modal$View$description(
				_List_fromArray(
					[
						$elm$html$Html$text(translations.Ha)
					])),
				A2(
				$author$project$Common$Modal$View$differentSailOptions,
				translations,
				_List_fromArray(
					[
						_Utils_Tuple3(0, 2, fakeSailDepartureDate),
						_Utils_Tuple3(2, 1, fakeSailDepartureDate)
					])),
				$author$project$Common$Modal$View$notice(translations.Hb),
				A2($author$project$Common$Modal$View$accept, $author$project$Messages$AgreedToTravelViaDifferentCity, translations.G9),
				A2($author$project$Common$Modal$View$decline, $author$project$Messages$DisagreedToTravelViaDifferentCity, translations.tb)
			]);
	});
var $author$project$Common$Modal$View$suggestTravelingViaDifferentCityModal = F2(
	function (translations, _v0) {
		var from = _v0.kS;
		var to = _v0.le;
		var maybeSelectedFakeRouteTripSail = _v0.B1;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var direction = _v1.a;
					var sail = _v1.b;
					var _v2 = _Utils_Tuple3(from, to, direction);
					_v2$4:
					while (true) {
						if (!_v2.c) {
							switch (_v2.a) {
								case 0:
									if (_v2.b === 1) {
										var _v3 = _v2.a;
										var _v4 = _v2.b;
										var _v5 = _v2.c;
										return A2($author$project$Common$Modal$View$suggestTravelingTalStoViaHel, translations, sail.nr);
									} else {
										break _v2$4;
									}
								case 1:
									if (!_v2.b) {
										var _v6 = _v2.a;
										var _v7 = _v2.b;
										var _v8 = _v2.c;
										return A2($author$project$Common$Modal$View$suggestTravelingStoTalViaHel, translations, sail.nr);
									} else {
										break _v2$4;
									}
								default:
									break _v2$4;
							}
						} else {
							switch (_v2.a) {
								case 0:
									if (_v2.b === 1) {
										var _v9 = _v2.a;
										var _v10 = _v2.b;
										var _v11 = _v2.c;
										return A2($author$project$Common$Modal$View$suggestTravelingStoTalViaHel, translations, sail.nr);
									} else {
										break _v2$4;
									}
								case 1:
									if (!_v2.b) {
										var _v12 = _v2.a;
										var _v13 = _v2.b;
										var _v14 = _v2.c;
										return A2($author$project$Common$Modal$View$suggestTravelingTalStoViaHel, translations, sail.nr);
									} else {
										break _v2$4;
									}
								default:
									break _v2$4;
							}
						}
					}
					return _List_fromArray(
						[
							$elm$html$Html$text('not supported yet')
						]);
				},
				maybeSelectedFakeRouteTripSail));
	});
var $author$project$Common$Modal$View$summaryWarningModal = F2(
	function (translations, warnings) {
		return _Utils_ap(
			_List_fromArray(
				[
					$author$project$Common$Modal$View$title(translations.FH)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Cv;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(translations.FD),
							A2(
								$elm$core$Basics$composeR,
								$elm$html$Html$text,
								A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Common$Modal$View$description)))),
					warnings),
				_List_fromArray(
					[
						A2($author$project$Common$Modal$View$accept, $author$project$Messages$ClosedModal, translations.sq)
					])));
	});
var $author$project$Common$Modal$View$dialog = F4(
	function (translations, session, modalType, isClosing) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'ngdialog mikiModal ' + ($author$project$Common$Modal$View$getModalClass(modalType) + 'Modal')),
					$elm$html$Html$Attributes$id($author$project$Common$Modal$View$ngdialogId),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('ngdialog-closing', isClosing)
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test',
					'modal-' + $author$project$Common$Modal$View$getModalClass(modalType))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ngdialog-overlay'),
							$elm$html$Html$Events$onClick($author$project$Messages$ClosedModal),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'modal-page-overlay')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ngdialog-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							function () {
								switch (modalType.$) {
									case 0:
										var fromOrTo = modalType.a;
										return A3($author$project$Common$Modal$View$fromToModal, translations, session, fromOrTo);
									case 1:
										return A2($author$project$Common$Modal$View$backToDesktopModal, translations, session);
									case 2:
										var _v1 = session.rs;
										if (!_v1.$) {
											var mealPackages = _v1.a;
											return $author$project$Common$Modal$View$mealPackageModal(
												{sk: mealPackages, j: session, lY: translations});
										} else {
											return _List_Nil;
										}
									case 3:
										return $author$project$Common$Modal$View$resetBookingModal(translations);
									case 4:
										return $author$project$Common$Modal$View$sessionErrorModal(translations);
									case 5:
										return $author$project$Common$Modal$View$shoppingCruiseModal(translations);
									case 6:
										var warnings = A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$author$project$Types$Summary$keepUniqueCriticalErrors,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.Iy;
													},
													session.B7)));
										return (A2(
											$elm$core$List$any,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pQ;
												},
												$elm$core$Basics$eq($author$project$Constants$sessionExpiredErrorCode)),
											warnings) || $elm$core$List$isEmpty(warnings)) ? $author$project$Common$Modal$View$sessionErrorModal(translations) : A2($author$project$Common$Modal$View$summaryWarningModal, translations, warnings);
									case 7:
										return $author$project$Common$Modal$View$suggestBuyingMealsModal(translations);
									case 8:
										return A2($author$project$Common$Modal$View$suggestAddingVehicleToOtherLegModal, translations, session);
									case 9:
										return A2($author$project$Common$Modal$View$suggestTravelingViaDifferentCityModal, translations, session);
									case 10:
										return A2($author$project$Common$Modal$View$selectVehicleModal, translations, session);
									case 11:
										return $author$project$Common$Modal$View$nonRefundableTermsModal(translations);
									default:
										return A2($author$project$Common$Modal$View$nonRefundableWarningModal, session, translations);
								}
							}())
						]))
				]));
	});
var $author$project$Common$Modal$View$root = F3(
	function (translations, session, model) {
		switch (model.$) {
			case 0:
				var modalType = model.a;
				return A4($author$project$Common$Modal$View$dialog, translations, session, modalType, false);
			case 1:
				var modalType = model.a;
				return A4($author$project$Common$Modal$View$dialog, translations, session, modalType, true);
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$KlarnaPaymentPage$View$root = A3(
	$elm$html$Html$Keyed$node,
	'div',
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('klarnaSnippet')
		]),
	_List_Nil);
var $author$project$PassengerPage$View$doNotForgetClubOneToast = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('doNotForgetClubOne priceNormal informationToast toast')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wE)
			]));
};
var $author$project$PassengerPage$View$delimiter = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('delimiter')
		]),
	_List_Nil);
var $author$project$Update$Passengers$isInSoloYouthMode = function (session) {
	return $author$project$Update$Passengers$isSoloYouthAllowed(session) && (!$author$project$Types$Passenger$Util$countAdultPassengers(session.Eg));
};
var $author$project$PassengerPage$View$ageCategoryToSelector = function (type_) {
	switch (type_) {
		case 0:
			return function ($) {
				return $.tV;
			};
		case 3:
			return function ($) {
				return $.AI;
			};
		case 1:
			return function ($) {
				return $.IF;
			};
		default:
			return function ($) {
				return $.vU;
			};
	}
};
var $author$project$Types$PassengerImages$images = {tV: '/assets/images/_cacheCommon/icon_adult.svg', vU: '/assets/images/_cacheCommon/icon_child.svg', AI: '/assets/images/_cacheCommon/icon_youth.svg', IF: '/assets/images/_cacheCommon/icon_junior.svg'};
var $author$project$Common$Images$plusImage = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('28'),
			$elm$svg$Svg$Attributes$height('28'),
			$elm$svg$Svg$Attributes$viewBox('0 0 28 28')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('14'),
					$elm$svg$Svg$Attributes$cy('14'),
					$elm$svg$Svg$Attributes$r('12'),
					$elm$svg$Svg$Attributes$fill('#004152'),
					$elm$svg$Svg$Attributes$strokeWidth('3')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#FFF'),
					$elm$svg$Svg$Attributes$points('15.337 19 15.337 15.213 19 15.213 19 12.812 15.337 12.812 15.337 9 12.639 9 12.639 12.812 9 12.812 9 15.213 12.639 15.213 12.639 19')
				]),
			_List_Nil)
		]));
var $author$project$PassengerPage$View$passengerButton = F3(
	function (translations, category, enabled) {
		var selector = $author$project$PassengerPage$View$ageCategoryToSelector(category);
		return A2(
			$elm$html$Html$div,
			A3(
				$author$project$Utils$List$addIf,
				enabled,
				$elm$html$Html$Events$onClick(
					$author$project$Messages$AddedPassenger(category)),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ageTypeButton itemTypeButton'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-age-category',
						$author$project$Types$AgeCategory$toString(category)),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'add-passenger-button'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('disabled', !enabled)
							]))
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('itemTypeIcon')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('icon'),
									$elm$html$Html$Attributes$src(
									selector($author$project$Types$PassengerImages$images))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ageType itemTypeTitle bodySmallBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$AgeCategory$translate, category, translations))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('plusTick')
						]),
					_List_fromArray(
						[$author$project$Common$Images$plusImage]))
				]));
	});
var $author$project$PassengerPage$View$headerHolder = F2(
	function (translations, session) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('headerHolder')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.Ef)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell bodyNorm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.wD)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ageTypeGroup typeGroupButtons')
								]),
							A2(
								$elm$core$List$intersperse,
								$author$project$PassengerPage$View$delimiter,
								_List_fromArray(
									[
										A3($author$project$PassengerPage$View$passengerButton, translations, 0, true),
										A3($author$project$PassengerPage$View$passengerButton, translations, 1, true),
										A3(
										$author$project$PassengerPage$View$passengerButton,
										translations,
										3,
										!$author$project$Update$Passengers$isInSoloYouthMode(session)),
										A3(
										$author$project$PassengerPage$View$passengerButton,
										translations,
										2,
										!$author$project$Update$Passengers$isInSoloYouthMode(session))
									])))
						]))
				]));
	});
var $author$project$Types$Passenger$isClubOneClient = function (_v0) {
	var clubOneLevel = _v0.pO;
	var clubOneNumber = _v0.we;
	return (!_Utils_eq(clubOneLevel, $elm$core$Maybe$Nothing)) && (!_Utils_eq(clubOneNumber, $elm$core$Maybe$Nothing));
};
var $author$project$PassengerPage$View$passengerCount = F2(
	function (translations, count) {
		var preparedTranslation = A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'count',
					$elm$core$String$fromInt(count))
				]),
			A2(
				$author$project$Translations$pluralize,
				_Utils_Tuple2('count', count),
				translations.Ec));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerCount bodyNorm')
				]),
			$author$project$Translations$toHtml(preparedTranslation));
	});
var $author$project$Messages$AddedAffiliatePassenger = F3(
	function (a, b, c) {
		return {$: 78, a: a, b: b, c: c};
	});
var $author$project$PassengerPage$View$affiliate = F4(
	function (translations, outwardSailDate, clubOneInfo, affiliateClient) {
		var _v0 = affiliateClient;
		var firstName = _v0.y2;
		var lastName = _v0.A6;
		var birthday = _v0.uw;
		var level = _v0.A8;
		var ageCategory = $author$project$Types$AgeCategory$fromAge(
			A2(
				$author$project$Utils$Time$differenceOfDatesInYears,
				$author$project$Types$Date$toPosix(birthday),
				outwardSailDate));
		var clubOneLevelImage = A2(
			$elm$core$Maybe$withDefault,
			'level_unkown.png',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$ClubOneLevel$toString,
					function (lvl) {
						return 'level_' + (lvl + '.png');
					}),
				level));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerButton inactive'),
					$elm$html$Html$Events$onClick(
					A3($author$project$Messages$AddedAffiliatePassenger, affiliateClient, clubOneInfo, ageCategory)),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'affiliated-passenger-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							'passengerName data wordBreak ' + $elm$core$String$toLower(
								$author$project$Types$AgeCategory$toString(ageCategory)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(firstName + (' ' + lastName))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status bodyNorm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('statusText link1Book')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('+ ' + translations.Eb)
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('clubOneLogo'),
									$elm$html$Html$Attributes$src('/assets/images/clubOne/' + clubOneLevelImage)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$PassengerPage$View$areBirthdaysFromSameAgeCategory = F3(
	function (firstBirthday, secondBirthday, outwardDate) {
		return _Utils_eq(
			$author$project$Types$AgeCategory$fromAge(
				A2(
					$author$project$Utils$Time$differenceOfDatesInYears,
					$author$project$Types$Date$toPosix(firstBirthday),
					outwardDate)),
			$author$project$Types$AgeCategory$fromAge(
				A2(
					$author$project$Utils$Time$differenceOfDatesInYears,
					$author$project$Types$Date$toPosix(secondBirthday),
					outwardDate)));
	});
var $author$project$PassengerPage$View$compareByAge = F3(
	function (outwardSailDate, a, b) {
		var passengerAge = function (birthday) {
			return A2(
				$author$project$Utils$Time$differenceOfDatesInYears,
				$author$project$Types$Date$toPosix(birthday),
				outwardSailDate);
		};
		return A2(
			$elm$core$Basics$compare,
			passengerAge(a.uw),
			passengerAge(b.uw));
	});
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $author$project$PassengerPage$View$getSortedAffiliateList = function (outwardDate) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortWith(
			$author$project$PassengerPage$View$compareByAge(outwardDate)),
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$groupWhile(
				F2(
					function (first, second) {
						return A3($author$project$PassengerPage$View$areBirthdaysFromSameAgeCategory, first.uw, second.uw, outwardDate);
					})),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (_v0) {
						var first = _v0.a;
						var others = _v0.b;
						return A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.y2;
							},
							A2($elm$core$List$cons, first, others));
					}),
				A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$core$List$concat))));
};
var $author$project$PassengerPage$View$isAffiliateAPassenger = F2(
	function (passengers, _v0) {
		var clientId = _v0.v5;
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.v5;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						$elm$core$Basics$eq(clientId)),
					$elm$core$Maybe$withDefault(false))),
			$elm$core$Array$toList(passengers));
	});
var $author$project$PassengerPage$View$affiliateList = F4(
	function (translations, _v0, passengers, outwardDate) {
		var user = _v0.Ia;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.BP;
					},
					$elm$core$Maybe$map(
						function (clubOne) {
							return A2(
								$elm$core$List$map,
								A3($author$project$PassengerPage$View$affiliate, translations, outwardDate, clubOne),
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$not,
										$author$project$PassengerPage$View$isAffiliateAPassenger(passengers)),
									A2($author$project$PassengerPage$View$getSortedAffiliateList, outwardDate, clubOne.tX)));
						})),
				$krisajenkins$remotedata$RemoteData$toMaybe(user.v4)));
	});
var $author$project$Messages$OpenedPassengerDetails = function (a) {
	return {$: 55, a: a};
};
var $author$project$Messages$RemovedLastAdultWhenSoloYouthAllowed = {$: 75};
var $author$project$Messages$RemovedLastYouthInSoloYouthMode = {$: 76};
var $author$project$PassengerPage$View$allMandatoryFilled = function (passenger) {
	return (!$elm$core$String$isEmpty(passenger.y2)) && ((!$elm$core$String$isEmpty(passenger.A6)) && (!_Utils_eq(passenger.uw, $elm$core$Maybe$Nothing)));
};
var $author$project$Common$Images$crossImage = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('#004152'),
			$elm$svg$Svg$Attributes$fillRule('evenodd'),
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M9.40960882,16.4806766 L12.0875132,13.8027722 L14.6779044,16.3931634 L16.3756608,14.695407 L13.7852696,12.1050159 L16.4806766,9.40960882 L14.5728885,7.50182072 L11.8774815,10.1972278 L9.30459296,7.62433923 L7.60683658,9.32209561 L10.1797251,11.8949841 L7.50182072,14.5728885 L9.40960882,16.4806766 Z')
				]),
			_List_Nil)
		]));
var $author$project$Update$Passengers$isLastYouth = F2(
	function (passengers, _v0) {
		var ageCategory = _v0.tY;
		return (ageCategory === 1) && (A2($author$project$Types$Passenger$Util$countPassengersOfAgeCategory, passengers, 1) <= 1);
	});
var $author$project$PassengerPage$View$isPassengerAnAffiliate = F2(
	function (client, passenger) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (affiliates, passengerClientId) {
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.v5;
								},
								$elm$core$Basics$eq(passengerClientId)),
							affiliates);
					}),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.BP;
						},
						$elm$core$Maybe$map(
							function ($) {
								return $.tX;
							})),
					$krisajenkins$remotedata$RemoteData$toMaybe(client)),
				passenger.v5));
	});
var $author$project$PassengerPage$View$passengerTile = F6(
	function (translations, session, model, passengers, index, passenger) {
		var passengerAgeCategory = $elm$core$String$toLower(
			$author$project$Types$AgeCategory$toString(passenger.tY));
		var okStatus = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('statusText')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Ee)
				]));
		var isRemovable = A3($author$project$Update$Passengers$isPassengerRemovable, session, passengers, passenger);
		var isAffiliate = A2($author$project$PassengerPage$View$isPassengerAnAffiliate, session.Ia.v4, passenger);
		var removePassenger = function () {
			var message = (A2($author$project$Update$Passengers$isLastAdult, passengers, passenger) && $author$project$Update$Passengers$isSoloYouthAllowed(session)) ? $author$project$Messages$RemovedLastAdultWhenSoloYouthAllowed : ((A2($author$project$Update$Passengers$isLastYouth, passengers, passenger) && $author$project$Update$Passengers$isInSoloYouthMode(session)) ? $author$project$Messages$RemovedLastYouthInSoloYouthMode : A2($author$project$Messages$RemovedPassenger, index, !isAffiliate));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('passengerButtonRightSide')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('crossIcon'),
								$author$project$UrlRoute$onClickWithoutSideEffects(message)
							]),
						_List_fromArray(
							[$author$project$Common$Images$crossImage]))
					]));
		}();
		var fillLater = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('status link3')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.Ed)
				]));
		var clubOneLogo = function (image) {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('clubOneLogo'),
						$elm$html$Html$Attributes$src('/assets/images/clubOne/' + image)
					]),
				_List_Nil);
		};
		return A2(
			$elm$html$Html$div,
			A3(
				$author$project$Utils$List$addIf,
				$author$project$Types$Passenger$isClubOneClient(passenger) || isAffiliate,
				A2($elm$html$Html$Attributes$attribute, 'data-is-club-one', ''),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('passengerButton effect-list'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enter',
								_Utils_eq(
									$elm$core$Maybe$Just(index),
									model.tP))
							])),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-passenger-index',
						$elm$core$String$fromInt(index)),
						A2($elm$html$Html$Attributes$attribute, 'data-effect-type', 'expand-in'),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'passenger-button'),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$OpenedPassengerDetails(index))
					])),
			_List_fromArray(
				[
					($elm$core$String$isEmpty(passenger.y2) || $elm$core$String$isEmpty(passenger.A6)) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('passengerPlaceholder data ' + passengerAgeCategory)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$AgeCategory$translate, passenger.tY, translations))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('passengerName data wordBreak ' + passengerAgeCategory)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(passenger.y2 + (' ' + passenger.A6))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status bodyNorm')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Utils$String$renderIf,
							$author$project$PassengerPage$View$allMandatoryFilled(passenger),
							okStatus),
							A2(
							$elm$core$Maybe$withDefault,
							isAffiliate ? clubOneLogo('level_unkown.png') : clubOneLogo('level_none.png'),
							A2(
								$elm$core$Maybe$map,
								function (level) {
									return clubOneLogo(
										'level_' + ($author$project$Types$ClubOneLevel$toString(level) + '.png'));
								},
								passenger.pO))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					!$author$project$PassengerPage$View$allMandatoryFilled(passenger),
					fillLater),
					A2($author$project$Utils$String$renderIf, isRemovable || isAffiliate, removePassenger)
				]));
	});
var $author$project$PassengerPage$View$spliceAnimationElement = F2(
	function (_v0, array) {
		var index = _v0.a;
		var element = _v0.b;
		return A2(
			$elm$core$Array$append,
			A2(
				$elm$core$Array$push,
				element,
				A3($elm$core$Array$slice, 0, index, array)),
			A3(
				$elm$core$Array$slice,
				index,
				$elm$core$Array$length(array),
				array));
	});
var $author$project$PassengerPage$View$passengerList = F5(
	function (translations, session, model, passengers, outwardSailDate) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerList')
				]),
			_Utils_ap(
				$elm$core$Array$toList(
					A3(
						$elm$core$Basics$apR,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$author$project$PassengerPage$View$spliceAnimationElement,
								$elm$core$Tuple$mapSecond(
									$elm$html$Html$map(
										function (_v0) {
											return $author$project$Messages$NoOp;
										}))),
							model.ud),
						$elm$core$Maybe$withDefault(
							function (a) {
								return a;
							}),
						A2(
							$elm$core$Array$indexedMap,
							A4($author$project$PassengerPage$View$passengerTile, translations, session, model, passengers),
							passengers))),
				_Utils_eq(session.xA, $elm$core$Maybe$Nothing) ? A4($author$project$PassengerPage$View$affiliateList, translations, session, passengers, outwardSailDate) : _List_Nil));
	});
var $author$project$PassengerPage$View$root = F3(
	function (translations, session, model) {
		var passengers = session.Eg;
		var outwardSailDate = A2(
			$elm$core$Maybe$withDefault,
			session.kJ,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
				$author$project$Types$Trips$statusToMaybe(session.tp)));
		var areAllPassengersClubOneUsers = A2(
			$elm$core$List$all,
			function (a) {
				return $author$project$Types$Passenger$isClubOneClient(a) || A2($author$project$Update$JoinClubOne$isJoining, session, a);
			},
			$elm$core$Array$toList(passengers));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerPage page withFixedButton')
				]),
			_List_fromArray(
				[
					A2($author$project$PassengerPage$View$headerHolder, translations, session),
					A2(
					$author$project$PassengerPage$View$passengerCount,
					translations,
					$elm$core$Array$length(passengers)),
					A2(
					$author$project$Utils$String$renderIf,
					!areAllPassengersClubOneUsers,
					$author$project$PassengerPage$View$doNotForgetClubOneToast(translations)),
					A5($author$project$PassengerPage$View$passengerList, translations, session, model, passengers, outwardSailDate)
				]));
	});
var $author$project$TravelClassPage$View$header = F2(
	function (translations, voyageType) {
		var headerText = A2(
			$elm$core$List$member,
			voyageType,
			_List_fromArray(
				[
					$author$project$Types$VoyageType$Shuttle,
					$author$project$Types$VoyageType$CruiseMultiDeparture(1),
					$author$project$Types$VoyageType$CruiseMultiDeparture(0)
				])) ? translations.hP : translations.H2;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('headerHolder')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(headerText)
										]))
								]))
						]))
				]));
	});
var $author$project$TravelClassPage$View$isSelectedCruiseSailSpecial = function (session) {
	var _v0 = session.tp;
	if ((!_v0.$) && (!_v0.a.$)) {
		var cruise = _v0.a.a;
		return $author$project$Types$CruiseSails$selected(cruise).b.Au;
	} else {
		return false;
	}
};
var $author$project$TravelClassPage$View$hasActiveTravelClassButton = F2(
	function (travelClasses, travelClass) {
		var isSelected = function (selection) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					function (_v1) {
						var code = _v1.pQ;
						return A2(
							$elm$core$List$any,
							function (_v2) {
								var selected = _v2.a;
								var count = _v2.b;
								return _Utils_eq(selected, code) && (count > 0);
							},
							selection);
					}),
				$elm$core$Maybe$withDefault(false));
		};
		var _v0 = $author$project$Types$TravelClasses$getSelectedCodeCountPairLists(travelClasses);
		var inbound = _v0.zT;
		var outbound = _v0.Dr;
		return A2(isSelected, outbound, travelClass.DA) || A2(isSelected, inbound, travelClass.FT);
	});
var $author$project$TravelClassPage$View$panelKey = function (travelClass) {
	return A2(
		$elm$core$Maybe$withDefault,
		travelClass.oh,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.pQ;
			},
			A2($author$project$Types$Maybe$Util$orElse, travelClass.FT, travelClass.DA)));
};
var $author$project$Messages$AddedPetTravelClass = F2(
	function (a, b) {
		return {$: 101, a: a, b: b};
	});
var $author$project$Messages$RemovedPetTravelClass = F2(
	function (a, b) {
		return {$: 103, a: a, b: b};
	});
var $author$project$TravelClassPage$View$addPetTravelClassButtonTestAttribute = A2($elm$html$Html$Attributes$attribute, 'data-test', 'add-pet-button');
var $author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground = F2(
	function (_arguments, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('plusMinusButtons withBorderAndBackground'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', _arguments.pZ > 0)
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-selected',
					$author$project$Utils$String$fromBool(_arguments.pZ > 0))
				]),
			A2($author$project$Common$Button$buttonsWithContent, _arguments, content));
	});
var $author$project$TravelClassPage$View$plusMinusButtonContent = function (_v0) {
	var translations = _v0.lY;
	var travelClassAvailability = _v0.lh;
	var isSpecialCruise = _v0.Au;
	var selectedCount = _v0.k9;
	return _Utils_eq(
		travelClassAvailability,
		$elm$core$Maybe$Just(0)) ? $elm$html$Html$text(
		$elm$core$String$toUpper(translations.wY)) : ((isSpecialCruise && (selectedCount < 1)) ? $elm$html$Html$text(
		$elm$core$String$toUpper(translations.xl)) : ((!selectedCount) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('upperCase')
			]),
		$author$project$Translations$toHtml(translations.tJ)) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyBold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(selectedCount))
			]))));
};
var $author$project$TravelClassPage$View$pricePer = F3(
	function (translation, market, price) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$Market$formatPriceWithSign, market, price))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodySmallBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(' / ' + translation)
						]))
				]));
	});
var $author$project$TravelClassPage$View$pricePerCage = function (translations) {
	return $author$project$TravelClassPage$View$pricePer(translations.hA);
};
var $author$project$TravelClassPage$View$pricePerPet = function (translations) {
	return $author$project$TravelClassPage$View$pricePer(translations.hR);
};
var $author$project$TravelClassPage$View$priceView = function (_v0) {
	var priceElement = _v0.ki;
	var isVoucherApplicable = _v0.q0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('price'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('discount', isVoucherApplicable)
					])),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'price')
			]),
		_List_fromArray(
			[priceElement]));
};
var $author$project$TravelClassPage$View$removePetTravelClassButtonTestAttribute = A2($elm$html$Html$Attributes$attribute, 'data-test', 'remove-pet-button');
var $author$project$TravelClassPage$View$petPanelSelectionView = F5(
	function (_arguments, petClass, info, count, direction) {
		var priceElement = function () {
			var _v0 = petClass.AM;
			switch (_v0) {
				case 3:
					return $author$project$TravelClassPage$View$pricePerCage;
				case 2:
					return $author$project$TravelClassPage$View$pricePerPet;
				case 0:
					return $author$project$TravelClassPage$View$pricePerPet;
				default:
					return $author$project$TravelClassPage$View$pricePerPet;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price')
						]),
					_List_fromArray(
						[
							$author$project$TravelClassPage$View$priceView(
							{
								q0: info.q0,
								ki: A3(priceElement, _arguments.lY, _arguments.j.rb, info.lN)
							})
						])),
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
							{
								pZ: count,
								nw: false,
								nQ: false,
								q_: info.q0,
								kZ: $elm$core$Maybe$Nothing,
								rx: _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										A2($author$project$Messages$RemovedPetTravelClass, info.pQ, direction)),
										$author$project$TravelClassPage$View$removePetTravelClassButtonTestAttribute
									]),
								oz: _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										A2($author$project$Messages$AddedPetTravelClass, info.pQ, direction)),
										$author$project$TravelClassPage$View$addPetTravelClassButtonTestAttribute
									])
							},
							_List_fromArray(
								[
									$author$project$TravelClassPage$View$plusMinusButtonContent(
									{Au: _arguments.Au, k9: count, lY: _arguments.lY, lh: $elm$core$Maybe$Nothing})
								]))
						]))
				]));
	});
var $author$project$Types$TravelClasses$selectedOutwardPets = function (travelClasses) {
	switch (travelClasses.$) {
		case 0:
			var oneWay = travelClasses.a;
			return oneWay.k;
		case 1:
			var twoWay = travelClasses.a;
			return twoWay.m;
		case 2:
			var oneWay = travelClasses.a;
			return oneWay.k;
		default:
			var twoWay = travelClasses.a;
			return twoWay.m;
	}
};
var $author$project$TravelClassPage$View$outwardPetPanelSelectionView = F3(
	function (_arguments, petClass, info) {
		var travelClasses = _arguments.to;
		var count = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Dict$get,
					code,
					$author$project$Types$TravelClasses$selectedOutwardPets(travelClasses)));
		};
		return A5(
			$author$project$TravelClassPage$View$petPanelSelectionView,
			_arguments,
			petClass,
			info,
			count(info.pQ),
			0);
	});
var $author$project$Common$Button$placeholder = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('placeholder')
		]),
	_List_Nil);
var $author$project$Types$TravelClasses$selectedReturnPets = function (travelClasses) {
	switch (travelClasses.$) {
		case 0:
			return $elm$core$Dict$empty;
		case 1:
			var twoWay = travelClasses.a;
			return twoWay.t;
		case 2:
			return $elm$core$Dict$empty;
		default:
			var twoWay = travelClasses.a;
			return twoWay.t;
	}
};
var $author$project$TravelClassPage$View$returnPetPanelSelectionView = F3(
	function (_arguments, petClass, info) {
		var travelClasses = _arguments.to;
		var count = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Dict$get,
					code,
					$author$project$Types$TravelClasses$selectedReturnPets(travelClasses)));
		};
		return A5(
			$author$project$TravelClassPage$View$petPanelSelectionView,
			_arguments,
			petClass,
			info,
			count(info.pQ),
			1);
	});
var $author$project$TravelClassPage$View$routeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($author$project$Types$Port$toString),
	$elm$core$String$join(' - '));
var $author$project$TravelClassPage$View$travelClassReserveType = F2(
	function (translations, reserveType) {
		var imageAndText = F2(
			function (imageUrl, translate) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(imageUrl)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginLeftSmall')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								translate(translations))
							]))
					]);
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginHorizontalMedium')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('travelClassReserveType marginVerticalSmall bodySmallBold')
						]),
					function () {
						switch (reserveType) {
							case 0:
								return A2(
									imageAndText,
									'assets/images/travelClass/pets.svg',
									function ($) {
										return $.hT;
									});
							case 1:
								return A2(
									imageAndText,
									'assets/images/travelClass/allergy.svg',
									function ($) {
										return $.hz;
									});
							default:
								return A2(
									imageAndText,
									'assets/images/travelClass/handicap.svg',
									function ($) {
										return $.hC;
									});
						}
					}()),
					$author$project$Common$Panel$graySeparator(_List_Nil)
				]));
	});
var $author$project$TravelClassPage$View$petPanel = F2(
	function (_arguments, petClass) {
		var translations = _arguments.lY;
		var session = _arguments.j;
		var placeholder = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[$author$project$Common$Button$placeholder]))
				]));
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('petCage marginHorizontalSmall')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$imageHeader,
					A2($elm$core$Maybe$withDefault, '', petClass.zP),
					_List_fromArray(
						[
							$author$project$Common$Panel$imageHeaderTitle(petClass.oh)
						])),
					A2($author$project$TravelClassPage$View$travelClassReserveType, translations, 0),
					$author$project$Common$Panel$block(
					_List_fromArray(
						[
							A2(
							$author$project$Common$Panel$row,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm')
								]),
							$author$project$Translations$toHtml(petClass.nt)),
							$author$project$Common$Panel$graySeparator(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginBottomMedium')
								])),
							session.qW ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('oneWay')
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									placeholder,
									A2(
										$elm$core$Maybe$map,
										A2($author$project$TravelClassPage$View$outwardPetPanelSelectionView, _arguments, petClass),
										petClass.Ds))
								])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('twoWay')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Common$Panel$row,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$author$project$Common$Panel$centeredTitle(
											$author$project$TravelClassPage$View$routeString(
												_List_fromArray(
													[session.kS, session.le]))),
											$author$project$Common$Panel$centeredTitle(
											$author$project$TravelClassPage$View$routeString(
												_List_fromArray(
													[session.le, session.kS])))
										])),
									A2(
									$author$project$Common$Panel$row,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Common$Panel$column(
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$withDefault,
													placeholder,
													A2(
														$elm$core$Maybe$map,
														A2($author$project$TravelClassPage$View$outwardPetPanelSelectionView, _arguments, petClass),
														petClass.Ds))
												])),
											$author$project$Common$Panel$column(
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$withDefault,
													placeholder,
													A2(
														$elm$core$Maybe$map,
														A2($author$project$TravelClassPage$View$returnPetPanelSelectionView, _arguments, petClass),
														petClass.FL))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$TravelClassPage$View$Pet = 1;
var $author$project$Messages$AddedTravelClass = F2(
	function (a, b) {
		return {$: 99, a: a, b: b};
	});
var $author$project$Messages$ClickedShowTravelClassWarningToast = {$: 98};
var $author$project$Messages$RemovedTravelClass = F2(
	function (a, b) {
		return {$: 100, a: a, b: b};
	});
var $author$project$TravelClassPage$View$addTravelClassButtonTestAttribute = A2($elm$html$Html$Attributes$attribute, 'data-test', 'add-travelclass-button');
var $author$project$TravelClassPage$View$calc = F3(
	function (adultsLeft, underAges, decksLeft) {
		calc:
		while (true) {
			if (!decksLeft) {
				return adultsLeft;
			} else {
				if (underAges > 0) {
					var $temp$adultsLeft = adultsLeft,
						$temp$underAges = underAges - 1,
						$temp$decksLeft = decksLeft - 1;
					adultsLeft = $temp$adultsLeft;
					underAges = $temp$underAges;
					decksLeft = $temp$decksLeft;
					continue calc;
				} else {
					var $temp$adultsLeft = adultsLeft - 1,
						$temp$underAges = underAges,
						$temp$decksLeft = decksLeft - 1;
					adultsLeft = $temp$adultsLeft;
					underAges = $temp$underAges;
					decksLeft = $temp$decksLeft;
					continue calc;
				}
			}
		}
	});
var $author$project$TravelClassPage$View$maxAvailableCabinsToAdd = function (_v0) {
	var adults = _v0.pn;
	var underAges = _v0.m0;
	var selectedDecks = _v0.sK;
	var selectedCountWithoutCurrentCabin = _v0.sH;
	var adultsLeft = adults - selectedCountWithoutCurrentCabin;
	return (selectedDecks > 0) ? A3($author$project$TravelClassPage$View$calc, adultsLeft - 1, underAges, selectedDecks - 1) : adultsLeft;
};
var $author$project$TravelClassPage$View$maxAvailableDecksToAdd = function (_v0) {
	var adults = _v0.pn;
	var underAges = _v0.m0;
	var selectedCountWithoutDeck = _v0.sI;
	var adultsLeft = adults - selectedCountWithoutDeck;
	return (adultsLeft > 0) ? (adultsLeft + underAges) : 0;
};
var $author$project$TravelClassPage$View$removeTravelClassButtonTestAttribute = A2($elm$html$Html$Attributes$attribute, 'data-test', 'remove-travelclass-button');
var $author$project$TravelClassPage$View$getCabinPlusMinusArguments = function (_v0) {
	var props = _v0.oE;
	var selectedTravelClasses = _v0.E;
	var direction = _v0.p7;
	var areButtonsLarge = _v0.m8;
	var travelClassInfo = _v0.n;
	var selectedDecks = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$eq($author$project$Types$TravelClasses$deckCode)),
				selectedTravelClasses)));
	var selectedCountWithoutDeck = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$first,
					$elm$core$Basics$neq($author$project$Types$TravelClasses$deckCode)),
				selectedTravelClasses)));
	var _v1 = props;
	var session = _v1.j;
	var travelClasses = _v1.to;
	var deckProps = {
		pn: $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg),
		sI: selectedCountWithoutDeck,
		m0: $elm$core$Array$length(session.Eg) - $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg)
	};
	var selectedCount = A3($author$project$Types$TravelClasses$selectedTravelClassesCount, travelClasses, travelClassInfo.pQ, direction);
	var cabinProps = {
		pn: $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg),
		sH: selectedCountWithoutDeck - selectedCount,
		sK: selectedDecks,
		m0: $elm$core$Array$length(session.Eg) - $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg)
	};
	var maxAvailableToAdd = A2(
		$elm$core$Basics$min,
		travelClassInfo.uk,
		_Utils_eq(travelClassInfo.pQ, $author$project$Types$TravelClasses$deckCode) ? $author$project$TravelClassPage$View$maxAvailableDecksToAdd(deckProps) : $author$project$TravelClassPage$View$maxAvailableCabinsToAdd(cabinProps));
	return {
		pZ: selectedCount,
		nw: true,
		nQ: areButtonsLarge,
		q_: travelClassInfo.q0,
		kZ: $elm$core$Maybe$Just(maxAvailableToAdd),
		rx: _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$Messages$RemovedTravelClass, travelClassInfo.pQ, direction)),
				$author$project$TravelClassPage$View$removeTravelClassButtonTestAttribute
			]),
		oz: _Utils_ap(
			(_Utils_cmp(maxAvailableToAdd, selectedCount) > 0) ? _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Messages$AddedTravelClass, travelClassInfo.pQ, direction))
				]) : ((!_Utils_eq(travelClassInfo.uk, selectedCount)) ? _List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$Messages$ClickedShowTravelClassWarningToast)
				]) : _List_Nil),
			_List_fromArray(
				[$author$project$TravelClassPage$View$addTravelClassButtonTestAttribute]))
	};
};
var $author$project$TravelClassPage$View$getPetPlacePlusMinusArguments = function (_v0) {
	var travelClasses = _v0.to;
	var direction = _v0.p7;
	var selectedTravelClassCode = _v0.oU;
	var petTravelClassInfo = _v0.ow;
	var selectedCount = A3($author$project$Types$TravelClasses$selectedTravelClassesCount, travelClasses, selectedTravelClassCode, direction);
	var count = function () {
		if (!direction) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Dict$get,
					selectedTravelClassCode,
					$author$project$Types$TravelClasses$selectedOutwardPets(travelClasses)));
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Dict$get,
					selectedTravelClassCode,
					$author$project$Types$TravelClasses$selectedReturnPets(travelClasses)));
		}
	}();
	var _v1 = petTravelClassInfo;
	var price = _v1.lN;
	var isVoucherApplicable = _v1.q0;
	return {
		pZ: count,
		nw: false,
		nQ: false,
		q_: isVoucherApplicable,
		kZ: $elm$core$Maybe$Just($author$project$Types$TravelClasses$maxPetsPerCabin * selectedCount),
		rx: _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$Messages$RemovedPetTravelClass, selectedTravelClassCode, direction)),
				$author$project$TravelClassPage$View$removePetTravelClassButtonTestAttribute
			]),
		oz: _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$Messages$AddedPetTravelClass, selectedTravelClassCode, direction)),
				$author$project$TravelClassPage$View$addPetTravelClassButtonTestAttribute
			])
	};
};
var $author$project$TravelClassPage$View$getPetTravelClassInfoByDirection = function (direction) {
	if (!direction) {
		return function ($) {
			return $.Ds;
		};
	} else {
		return function ($) {
			return $.FL;
		};
	}
};
var $author$project$TravelClassPage$View$petCabinButtonsWithMultipleSelections = function (_v0) {
	var panelArguments = _v0.i;
	var selectedTravelClasses = _v0.E;
	var direction = _v0.p7;
	var travelClassInfo = _v0.n;
	var _v1 = panelArguments;
	var translations = _v1.lY;
	var session = _v1.j;
	var isSpecialCruise = _v1.Au;
	var travelClasses = _v1.to;
	var petPlacePlusMinusArguments = function (petTravelClassInfo) {
		return $author$project$TravelClassPage$View$getPetPlacePlusMinusArguments(
			{p7: direction, ow: petTravelClassInfo, oU: travelClassInfo.pQ, to: travelClasses});
	};
	var selectedCount = A3($author$project$Types$TravelClasses$selectedTravelClassesCount, travelClasses, travelClassInfo.pQ, direction);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
							$author$project$TravelClassPage$View$getCabinPlusMinusArguments(
								{
									m8: false,
									p7: direction,
									oE: {Au: isSpecialCruise, j: session, lY: translations, to: travelClasses},
									E: selectedTravelClasses,
									n: travelClassInfo
								}),
							_List_fromArray(
								[
									$author$project$TravelClassPage$View$plusMinusButtonContent(
									{
										Au: isSpecialCruise,
										k9: A3($author$project$Types$TravelClasses$selectedTravelClassesCount, travelClasses, travelClassInfo.pQ, direction),
										lY: translations,
										lh: $elm$core$Maybe$Just(travelClassInfo.uk)
									})
								]))
						]))
				]),
			(selectedCount >= 1) ? A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A3(
					$elm$core$Basics$composeR,
					function ($) {
						return $.r1;
					},
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$andThen(
							$author$project$TravelClassPage$View$getPetTravelClassInfoByDirection(direction)),
						$elm$core$Maybe$map(
							function (info) {
								return _List_fromArray(
									[
										A2(
										$author$project$Common$Panel$row,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('price')
											]),
										_List_fromArray(
											[
												$author$project$TravelClassPage$View$priceView(
												{
													q0: info.q0,
													ki: A3($author$project$TravelClassPage$View$pricePerPet, translations, session.rb, info.lN)
												})
											])),
										A2(
										$author$project$Common$Panel$row,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
												petPlacePlusMinusArguments(info),
												_List_fromArray(
													[
														$author$project$TravelClassPage$View$plusMinusButtonContent(
														{
															Au: isSpecialCruise,
															k9: petPlacePlusMinusArguments(info).pZ,
															lY: translations,
															lh: $elm$core$Maybe$Just(travelClassInfo.uk)
														})
													]))
											]))
									]);
							})),
					$author$project$Types$TravelClasses$availableTravelClasses(travelClasses))) : _List_Nil));
};
var $author$project$Common$Button$outline = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('outlineButtonComponent bodyBold'),
				attributes),
			elements);
	});
var $author$project$Common$Button$text = function (string) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('outlineButtonContent')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$TravelClassPage$View$notAvailableButton = function (translations) {
	return A2(
		$author$project$Common$Button$outline,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('disabled')
			]),
		_List_fromArray(
			[
				$author$project$Common$Button$text(
				$elm$core$String$toUpper(translations.wY))
			]));
};
var $author$project$TravelClassPage$View$regularCabinButton = function (_v0) {
	var panelArguments = _v0.i;
	var selectedTravelClasses = _v0.E;
	var direction = _v0.p7;
	var travelClassInfo = _v0.n;
	var _v1 = panelArguments;
	var session = _v1.j;
	var translations = _v1.lY;
	var isSpecialCruise = _v1.Au;
	var travelClasses = _v1.to;
	var button = A2(
		$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
		$author$project$TravelClassPage$View$getCabinPlusMinusArguments(
			{m8: false, p7: direction, oE: panelArguments, E: selectedTravelClasses, n: travelClassInfo}),
		_List_fromArray(
			[
				$author$project$TravelClassPage$View$plusMinusButtonContent(
				{
					Au: isSpecialCruise,
					k9: A3($author$project$Types$TravelClasses$selectedTravelClassesCount, travelClasses, travelClassInfo.pQ, direction),
					lY: translations,
					lh: $elm$core$Maybe$Just(travelClassInfo.uk)
				})
			]));
	return (!travelClassInfo.uk) ? $author$project$TravelClassPage$View$notAvailableButton(translations) : button;
};
var $author$project$TravelClassPage$View$multipleSelectionsTravelClassButton = function (_v0) {
	var panelArguments = _v0.i;
	var selectedTravelClasses = _v0.E;
	var direction = _v0.p7;
	var travelClassInfo = _v0.n;
	var travelClassType = _v0.u;
	return (travelClassType === 1) ? $author$project$TravelClassPage$View$petCabinButtonsWithMultipleSelections(
		{p7: direction, i: panelArguments, E: selectedTravelClasses, n: travelClassInfo}) : $author$project$TravelClassPage$View$regularCabinButton(
		{p7: direction, i: panelArguments, E: selectedTravelClasses, n: travelClassInfo});
};
var $author$project$TravelClassPage$View$translateAddButtonText = F2(
	function (language, priceUnit) {
		if (priceUnit === 1) {
			return A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.r0;
				});
		} else {
			return A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.hD;
				});
		}
	});
var $author$project$TravelClassPage$View$regularCabinPrice = F2(
	function (session, info) {
		var language = session.A_;
		var translatePriceSubject = A2($author$project$TravelClassPage$View$translateAddButtonText, language, info.r7);
		return A2(
			$author$project$Utils$String$renderIf,
			info.uk > 0,
			A3(
				$author$project$TravelClassPage$View$pricePer,
				translatePriceSubject,
				session.rb,
				A2($elm$core$Maybe$withDefault, info.lN, info.r6)));
	});
var $author$project$TravelClassPage$View$sharedCabinPrice = F2(
	function (session, info) {
		var language = session.A_;
		return A2(
			$author$project$Utils$String$renderIf,
			info.uk > 0,
			A3(
				$author$project$TravelClassPage$View$pricePer,
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.r0;
					}),
				session.rb,
				A2($elm$core$Maybe$withDefault, info.lN, info.r6)));
	});
var $author$project$TravelClassPage$View$surcharge = F2(
	function (_v0, surchargePrice) {
		var language = _v0.A_;
		var market = _v0.rb;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surcharge')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'+ ' + (A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.fX;
								}) + ' '))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$Market$formatPriceWithSign, market, surchargePrice) + (' / ' + A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.hD;
								})))
						]))
				]));
	});
var $author$project$TravelClassPage$View$oneWayMultipleSelectionsCabinButton = function (_v0) {
	var panelArguments = _v0.i;
	var selectedTravelClasses = _v0.E;
	var travelClassInfo = _v0.n;
	var travelClassType = _v0.u;
	var shared = _v0.kI;
	var button = function (info) {
		return $author$project$TravelClassPage$View$multipleSelectionsTravelClassButton(
			{p7: 0, i: panelArguments, E: selectedTravelClasses, n: info, u: travelClassType});
	};
	var _v1 = panelArguments;
	var translations = _v1.lY;
	var session = _v1.j;
	var isSpecialCruise = _v1.Au;
	var price = function (info) {
		return $author$project$TravelClassPage$View$priceView(
			{
				q0: info.q0,
				ki: shared ? A2($author$project$TravelClassPage$View$sharedCabinPrice, session, info) : A2($author$project$TravelClassPage$View$regularCabinPrice, session, info)
			});
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('oneWay')
			]),
		isSpecialCruise ? _List_fromArray(
			[
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button')
					]),
				_List_fromArray(
					[
						button(travelClassInfo)
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('price')
					]),
				_List_fromArray(
					[
						price(travelClassInfo)
					])),
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button')
					]),
				_List_fromArray(
					[
						button(travelClassInfo)
					])),
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('surcharge')
					]),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$TravelClassPage$View$surcharge(session),
							travelClassInfo.jS))
					]))
			]));
};
var $author$project$TravelClassPage$View$preSelectedTravelClassPrice = F2(
	function (travelClasses, direction) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$getDirectionTravelClassInfo(direction),
					$elm$core$Maybe$map(
						function ($) {
							return $.lN;
						})),
				A2(
					$author$project$Types$TravelClasses$getTravelClass,
					A2(
						$author$project$Types$TravelClasses$findPreselectedTravelClassCode,
						$author$project$Types$TravelClasses$all(travelClasses),
						direction),
					$author$project$Types$TravelClasses$all(travelClasses))));
	});
var $author$project$TravelClassPage$View$shuttleCabinPrice = F3(
	function (session, info, preSelectedPrice) {
		var language = session.A_;
		return A2(
			$author$project$Utils$String$renderIf,
			info.uk > 0,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyBold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('+ ')
							])),
						A3(
						$author$project$TravelClassPage$View$pricePer,
						A2($author$project$TravelClassPage$View$translateAddButtonText, language, info.r7),
						session.rb,
						info.lN - preSelectedPrice)
					])));
	});
var $author$project$TravelClassPage$View$singleSelectionCabinButtonContent = F5(
	function (translations, session, travelClassInfo, travelClasses, direction) {
		return (A2(
			$elm$core$List$member,
			session.tx,
			_List_fromArray(
				[
					$author$project$Types$VoyageType$Shuttle,
					$author$project$Types$VoyageType$CruiseMultiDeparture(1)
				])) && A2(
			$elm$core$List$member,
			travelClassInfo.pQ,
			_List_fromArray(
				[$author$project$Types$TravelClasses$starDeckCode, $author$project$Types$TravelClasses$deckCode]))) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Utils$String$capitalize(translations.wL))
				])) : A3(
			$author$project$TravelClassPage$View$shuttleCabinPrice,
			session,
			travelClassInfo,
			A2($author$project$TravelClassPage$View$preSelectedTravelClassPrice, travelClasses, direction));
	});
var $author$project$Common$Button$activeState = 'active';
var $author$project$TravelClassPage$View$isDisabled = F2(
	function (travelClassInfo, passengers) {
		return ((travelClassInfo.uk * travelClassInfo.mJ) - $elm$core$Array$length(passengers)) < 0;
	});
var $author$project$Common$Images$tickMarkInWhiteCircle = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/icon_button_tick_mark_white.svg'),
			$elm$html$Html$Attributes$class('tickHolder tickMarkImage')
		]),
	_List_Nil);
var $author$project$Common$Button$toggleableTickMark = function (isActive) {
	return isActive ? $author$project$Common$Images$tickMarkInWhiteCircle : $author$project$Common$Images$circlePlusMark;
};
var $author$project$TravelClassPage$View$cabinButton = function (_v0) {
	var panelArguments = _v0.i;
	var selectedCode = _v0.oQ;
	var direction = _v0.p7;
	var travelClassInfo = _v0.n;
	var isActive = _Utils_eq(selectedCode, travelClassInfo.pQ);
	var _v1 = panelArguments;
	var translations = _v1.lY;
	var session = _v1.j;
	var travelClasses = _v1.to;
	var buttonText = A2($author$project$TravelClassPage$View$isDisabled, travelClassInfo, session.Eg) ? $elm$core$String$toUpper(translations.H1) : (isActive ? $elm$core$String$toUpper(translations.xm) : $elm$core$String$toUpper(translations.xl));
	return A2(
		$author$project$Common$Button$outline,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2($author$project$Common$Button$activeState, isActive)
					])),
				$elm$html$Html$Events$onClick(
				A2($author$project$Messages$AddedTravelClass, travelClassInfo.pQ, direction)),
				$elm$html$Html$Attributes$disabled(
				A2($author$project$TravelClassPage$View$isDisabled, travelClassInfo, session.Eg) || isActive),
				$author$project$TravelClassPage$View$addTravelClassButtonTestAttribute,
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-test-selected',
				$author$project$Utils$String$fromBool(isActive))
			]),
		_List_fromArray(
			[
				$author$project$Common$Button$text(buttonText),
				$author$project$Common$Button$toggleableTickMark(isActive)
			]));
};
var $author$project$TravelClassPage$View$petCabinButtons = F4(
	function (panelArguments, selectedCode, direction, travelClassInfo) {
		var _v0 = panelArguments;
		var translations = _v0.lY;
		var session = _v0.j;
		var isSpecialCruise = _v0.Au;
		var travelClasses = _v0.to;
		var plusMinusButtonProps = function (info) {
			return $author$project$TravelClassPage$View$getPetPlacePlusMinusArguments(
				{p7: direction, ow: info, oU: travelClassInfo.pQ, to: travelClasses});
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[
							$author$project$TravelClassPage$View$cabinButton(
							{p7: direction, i: panelArguments, oQ: selectedCode, n: travelClassInfo})
						])),
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_Utils_eq(selectedCode, travelClassInfo.pQ) ? A3(
						$elm$core$Basics$composeR,
						function ($) {
							return $.r1;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$andThen(
								$author$project$TravelClassPage$View$getPetTravelClassInfoByDirection(direction)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map(
									A2(
										$elm$core$Basics$composeL,
										function (a) {
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('marginTopMedium')
														]),
													a)
												]);
										},
										function (petClassInfo) {
											return _List_fromArray(
												[
													A2(
													$author$project$Common$Panel$row,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('price')
														]),
													_List_fromArray(
														[
															$author$project$TravelClassPage$View$priceView(
															{
																q0: petClassInfo.q0,
																ki: A3($author$project$TravelClassPage$View$pricePerPet, translations, session.rb, petClassInfo.lN)
															})
														])),
													A2(
													$author$project$Common$Panel$row,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('button')
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
															plusMinusButtonProps(petClassInfo),
															_List_fromArray(
																[
																	$author$project$TravelClassPage$View$plusMinusButtonContent(
																	{
																		Au: isSpecialCruise,
																		k9: plusMinusButtonProps(petClassInfo).pZ,
																		lY: translations,
																		lh: $elm$core$Maybe$Just(travelClassInfo.uk)
																	})
																]))
														]))
												]);
										})),
								$elm$core$Maybe$withDefault(_List_Nil))),
						$author$project$Types$TravelClasses$availableTravelClasses(travelClasses)) : _List_Nil)
				]));
	});
var $author$project$TravelClassPage$View$singleSelectionTravelClassButton = function (_v0) {
	var panelArguments = _v0.i;
	var selectedTravelClass = _v0.lb;
	var direction = _v0.p7;
	var travelClassInfo = _v0.n;
	var travelClassType = _v0.u;
	return (travelClassType === 1) ? A4($author$project$TravelClassPage$View$petCabinButtons, panelArguments, selectedTravelClass, direction, travelClassInfo) : $author$project$TravelClassPage$View$cabinButton(
		{p7: direction, i: panelArguments, oQ: selectedTravelClass, n: travelClassInfo});
};
var $author$project$TravelClassPage$View$oneWaySingleSelectionCabinButton = function (_v0) {
	var panelArguments = _v0.i;
	var selectedTravelClass = _v0.lb;
	var travelClassInfo = _v0.n;
	var travelClassType = _v0.u;
	var button = $author$project$TravelClassPage$View$singleSelectionTravelClassButton(
		{p7: 0, i: panelArguments, lb: selectedTravelClass, n: travelClassInfo, u: travelClassType});
	var _v1 = panelArguments;
	var translations = _v1.lY;
	var session = _v1.j;
	var isSpecialCruise = _v1.Au;
	var travelClasses = _v1.to;
	var price = function (info) {
		return $author$project$TravelClassPage$View$priceView(
			{
				q0: info.q0,
				ki: A5($author$project$TravelClassPage$View$singleSelectionCabinButtonContent, translations, session, info, travelClasses, 0)
			});
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('oneWay')
			]),
		isSpecialCruise ? _List_fromArray(
			[
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button')
					]),
				_List_fromArray(
					[button]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('price')
					]),
				_List_fromArray(
					[
						price(travelClassInfo)
					])),
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button')
					]),
				_List_fromArray(
					[button])),
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('surcharge')
					]),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$TravelClassPage$View$surcharge(session),
							travelClassInfo.jS))
					]))
			]));
};
var $author$project$TravelClassPage$View$routeTitles = F2(
	function (from, to) {
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('route')
				]),
			_List_fromArray(
				[
					$author$project$Common$Panel$centeredTitle(
					$author$project$TravelClassPage$View$routeString(
						_List_fromArray(
							[from, to]))),
					$author$project$Common$Panel$centeredTitle(
					$author$project$TravelClassPage$View$routeString(
						_List_fromArray(
							[to, from])))
				]));
	});
var $author$project$TravelClassPage$View$twoWayMultipleSelectionsCabinButtons = function (_v0) {
	var panelArguments = _v0.i;
	var outwardSelectedTravelClasses = _v0.os;
	var returnSelectedTravelClasses = _v0.oK;
	var outwardTravelClassInfo = _v0.k0;
	var returnTravelClassInfo = _v0.k5;
	var travelClassType = _v0.u;
	var shared = _v0.kI;
	var _v1 = panelArguments;
	var translations = _v1.lY;
	var session = _v1.j;
	var isSpecialCruise = _v1.Au;
	var travelClasses = _v1.to;
	var price = function (info) {
		return $author$project$TravelClassPage$View$priceView(
			{
				q0: info.q0,
				ki: shared ? A2($author$project$TravelClassPage$View$sharedCabinPrice, session, info) : A2($author$project$TravelClassPage$View$regularCabinPrice, session, info)
			});
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('twoWay')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2($author$project$TravelClassPage$View$routeTitles, session.kS, session.le)
				]),
			function () {
				var _v2 = _Utils_Tuple2(outwardTravelClassInfo, returnTravelClassInfo);
				if (!_v2.a.$) {
					if (!_v2.b.$) {
						var outward = _v2.a.a;
						var _return = _v2.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												price(outward)
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												price(_return)
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												$author$project$TravelClassPage$View$multipleSelectionsTravelClassButton(
												{p7: 0, i: panelArguments, E: outwardSelectedTravelClasses, n: outward, u: travelClassType})
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												$author$project$TravelClassPage$View$multipleSelectionsTravelClassButton(
												{p7: 1, i: panelArguments, E: returnSelectedTravelClasses, n: _return, u: travelClassType})
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('surcharge')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													outward.jS))
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													_return.jS))
											]))
									]))
							]);
					} else {
						var outward = _v2.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												price(outward)
											])),
										$author$project$Common$Panel$column(_List_Nil)
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												$author$project$TravelClassPage$View$multipleSelectionsTravelClassButton(
												{p7: 0, i: panelArguments, E: outwardSelectedTravelClasses, n: outward, u: travelClassType})
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('surcharge')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													outward.jS))
											])),
										$author$project$Common$Panel$column(_List_Nil)
									]))
							]);
					}
				} else {
					if (!_v2.b.$) {
						var _return = _v2.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(_List_Nil),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												price(_return)
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												$author$project$TravelClassPage$View$multipleSelectionsTravelClassButton(
												{p7: 1, i: panelArguments, E: returnSelectedTravelClasses, n: _return, u: travelClassType})
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('surcharge')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(_List_Nil),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													_return.jS))
											]))
									]))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder]))
									]))
							]);
					}
				}
			}()));
};
var $author$project$TravelClassPage$View$twoWaySingleSelectionCabinButton = function (_v0) {
	var panelArguments = _v0.i;
	var outwardSelectedTravelClass = _v0.or;
	var returnSelectedTravelClass = _v0.oJ;
	var outwardTravelClassInfo = _v0.k0;
	var returnTravelClassInfo = _v0.k5;
	var travelClassType = _v0.u;
	var button = F3(
		function (selectedTravelClass, direction, info) {
			return $author$project$TravelClassPage$View$singleSelectionTravelClassButton(
				{p7: direction, i: panelArguments, lb: selectedTravelClass, n: info, u: travelClassType});
		});
	var _v1 = panelArguments;
	var translations = _v1.lY;
	var session = _v1.j;
	var travelClasses = _v1.to;
	var price = F2(
		function (info, direction) {
			return $author$project$TravelClassPage$View$priceView(
				{
					q0: info.q0,
					ki: A5($author$project$TravelClassPage$View$singleSelectionCabinButtonContent, translations, session, info, travelClasses, direction)
				});
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('twoWay')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2($author$project$TravelClassPage$View$routeTitles, session.kS, session.le)
				]),
			function () {
				var _v2 = _Utils_Tuple2(outwardTravelClassInfo, returnTravelClassInfo);
				if (!_v2.a.$) {
					if (!_v2.b.$) {
						var outward = _v2.a.a;
						var _return = _v2.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(price, outward, 0)
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(price, _return, 1)
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A3(button, outwardSelectedTravelClass, 0, outward)
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A3(button, returnSelectedTravelClass, 1, _return)
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('surcharge')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													outward.jS))
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													_return.jS))
											]))
									]))
							]);
					} else {
						var outward = _v2.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(price, outward, 0)
											])),
										$author$project$Common$Panel$column(_List_Nil)
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A3(button, outwardSelectedTravelClass, 0, outward)
											])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('surcharge')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													outward.jS))
											])),
										$author$project$Common$Panel$column(_List_Nil)
									]))
							]);
					}
				} else {
					if (!_v2.b.$) {
						var _return = _v2.b.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(_List_Nil),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(price, _return, 1)
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A3(button, returnSelectedTravelClass, 1, _return)
											]))
									])),
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('surcharge')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(_List_Nil),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[
												A2(
												$elm$core$Maybe$withDefault,
												$elm$html$Html$text(''),
												A2(
													$elm$core$Maybe$map,
													$author$project$TravelClassPage$View$surcharge(session),
													_return.jS))
											]))
									]))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button')
									]),
								_List_fromArray(
									[
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder])),
										$author$project$Common$Panel$column(
										_List_fromArray(
											[$author$project$Common$Button$placeholder]))
									]))
							]);
					}
				}
			}()));
};
var $author$project$TravelClassPage$View$petPanelButtons = F2(
	function (_v0, travelClass) {
		var translations = _v0.lY;
		var session = _v0.j;
		var travelClasses = _v0.to;
		var isSpecialCruise = _v0.Au;
		var panelArguments = {Au: isSpecialCruise, j: session, lY: translations, to: travelClasses};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginHorizontalMedium marginBottomMedium')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$Common$Panel$graySeparator(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('marginBottomMedium')
						])),
				function () {
					switch (travelClasses.$) {
						case 2:
							var oneWay = travelClasses.a;
							return _List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Common$Button$placeholder,
									A2(
										$elm$core$Maybe$map,
										function (info) {
											return $author$project$TravelClassPage$View$oneWayMultipleSelectionsCabinButton(
												{
													i: panelArguments,
													E: $author$project$Types$TravelClasses$oneWaySelection(oneWay),
													kI: false,
													n: info,
													u: 1
												});
										},
										travelClass.DA))
								]);
						case 3:
							var twoWay = travelClasses.a;
							return _List_fromArray(
								[
									$author$project$TravelClassPage$View$twoWayMultipleSelectionsCabinButtons(
									{
										os: $author$project$Types$TravelClasses$twoWaySelection(twoWay).Ds,
										k0: travelClass.DA,
										i: panelArguments,
										oK: $author$project$Types$TravelClasses$twoWaySelection(twoWay).FL,
										k5: travelClass.FT,
										kI: false,
										u: 1
									})
								]);
						case 0:
							var oneWay = travelClasses.a;
							return _List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Common$Button$placeholder,
									A2(
										$elm$core$Maybe$map,
										function (info) {
											return $author$project$TravelClassPage$View$oneWaySingleSelectionCabinButton(
												{
													i: panelArguments,
													lb: $author$project$Types$TravelClasses$oneWaySelection(oneWay),
													n: info,
													u: 1
												});
										},
										travelClass.DA))
								]);
						default:
							var twoWay = travelClasses.a;
							return _List_fromArray(
								[
									$author$project$TravelClassPage$View$twoWaySingleSelectionCabinButton(
									{
										or: $author$project$Types$TravelClasses$twoWaySelection(twoWay).Ds,
										k0: travelClass.DA,
										i: panelArguments,
										oJ: $author$project$Types$TravelClasses$twoWaySelection(twoWay).FL,
										k5: travelClass.FT,
										u: 1
									})
								]);
					}
				}()));
	});
var $author$project$Utils$Translations$translateSharedCabinName = F4(
	function (translations, name, gender, maxOccupancy) {
		return A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2('name', name),
					_Utils_Tuple2(
					'genderPlace',
					(gender === 1) ? translations.hM : translations.hL),
					_Utils_Tuple2(
					'maxOccupancy',
					$elm$core$String$fromInt(maxOccupancy))
				]),
			translations.hN);
	});
var $author$project$Types$TravelClasses$adjustTravelClassName = F2(
	function (translations, travelClass) {
		var name = travelClass.oh;
		var gender = travelClass.zf;
		var maxOccupancy = travelClass.BL;
		var adjustedName = A3(
			$elm$core$Maybe$map2,
			A2($author$project$Utils$Translations$translateSharedCabinName, translations, name),
			gender,
			maxOccupancy);
		return _Utils_update(
			travelClass,
			{
				oh: A2($elm$core$Maybe$withDefault, name, adjustedName)
			});
	});
var $author$project$TravelClassPage$View$cabinSurpriseIndicator = F2(
	function (translations, count) {
		return function (a) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cabinSurpriseIndicator'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('surpriseCount', count > 0)
							]))
					]),
				_List_fromArray(
					[a]));
		}(
			$elm$html$Html$text(
				$elm$core$String$toUpper(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'count',
								$elm$core$String$fromInt(count))
							]),
						(count === 1) ? translations.bk : ((count > 1) ? translations.bj : translations.bh)))));
	});
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $author$project$TravelClassPage$View$cabinSurpriseIndicatorArrow = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('cabinSurpriseIndicatorArrow'),
			$elm$svg$Svg$Attributes$height('0.8rem'),
			$elm$svg$Svg$Attributes$width('100%')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('cabinSurpriseIndicatorArrowTriangle'),
					$elm$svg$Svg$Attributes$d('m8 0-8 8-8-8z'),
					$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.ev)
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.ev),
					$elm$svg$Svg$Attributes$height('1'),
					$elm$svg$Svg$Attributes$width('100%')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('cabinSurpriseIndicatorArrowTriangle'),
					$elm$svg$Svg$Attributes$style('transform: translateX(50%)'),
					$elm$svg$Svg$Attributes$d('m9 -2.41-9 9-9-9z'),
					$elm$svg$Svg$Attributes$fill('#fff')
				]),
			_List_Nil)
		]));
var $author$project$TravelClassPage$View$maybeOnlyLowerCapacityAvailableString = F5(
	function (translations, travelClass, isOneWay, from, to) {
		var translationWithoutRoute = function (_v3) {
			var maxAvailableCapacity = _v3.mJ;
			return A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'capacity',
						$elm$core$String$fromInt(maxAvailableCapacity))
					]),
				translations.hG);
		};
		var translationWithRoute = F3(
			function (portA, portB, _v2) {
				var maxAvailableCapacity = _v2.mJ;
				return A2(
					$author$project$Translations$injectValues,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'capacity',
							$elm$core$String$fromInt(maxAvailableCapacity)),
							_Utils_Tuple2(
							'from',
							$author$project$Types$Port$toString(portA)),
							_Utils_Tuple2(
							'to',
							$author$project$Types$Port$toString(portB))
						]),
					translations.hH);
			});
		var isOnlyLowerCapacityAvailable = function (_v1) {
			var maxAvailableCapacity = _v1.mJ;
			var capacity = _v1.vM;
			return _Utils_cmp(capacity, maxAvailableCapacity) > 0;
		};
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, isOnlyLowerCapacityAvailable, travelClass.DA)),
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, isOnlyLowerCapacityAvailable, travelClass.FT)));
		if (_v0.a) {
			if (_v0.b) {
				return A2($elm$core$Maybe$map, translationWithoutRoute, travelClass.DA);
			} else {
				return A2(
					$elm$core$Maybe$map,
					isOneWay ? translationWithoutRoute : A2(translationWithRoute, from, to),
					travelClass.DA);
			}
		} else {
			if (_v0.b) {
				return A2(
					$elm$core$Maybe$map,
					A2(translationWithRoute, to, from),
					travelClass.FT);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$TravelClassPage$View$capacityMessage = F2(
	function (_v0, travelClass) {
		var session = _v0.j;
		var translations = _v0.lY;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (message) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('capacityInformation priceNormal informationToast toast')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]));
				},
				A5($author$project$TravelClassPage$View$maybeOnlyLowerCapacityAvailableString, translations, travelClass, session.qW, session.kS, session.le)));
	});
var $author$project$TravelClassPage$Messages$ToggleTravelClassDescription = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Panel$expander = F2(
	function (_v0, content) {
		var isExpanded = _v0.z9;
		var expand = _v0.yT;
		var extraAttributes = _v0.yX;
		var language = _v0.A_;
		return A3(
			$elm$html$Html$node,
			'expandable-expander',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-is-expanded',
					$author$project$Utils$String$fromBool(isExpanded))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm expander'),
								$elm$html$Html$Events$onClick(expand)
							]),
						extraAttributes),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							content),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('expandableInfoToggle showMoreButton'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('open', isExpanded)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										isExpanded ? function ($) {
											return $.wz;
										} : function ($) {
											return $.wA;
										}))
								]))
						]))
				]));
	});
var $author$project$TravelClassPage$View$descriptionWithToggle = F4(
	function (language, travelClass, code, isDescriptionOpened) {
		var maybeLongDescription = A2(
			$elm$core$Maybe$andThen,
			function (longDescription) {
				return $elm$core$String$isEmpty(longDescription) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(longDescription);
			},
			travelClass.Bx);
		var description = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('')
					])),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Translations$toHtml,
					$elm$html$Html$p(_List_Nil)),
				travelClass.nt));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('description marginHorizontalMedium')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginTopMedium marginBottomMedium')
							]),
						_List_fromArray(
							[description]))
					]),
				A2(
					$elm$core$Maybe$map,
					function (longDescription) {
						return _List_fromArray(
							[
								A2(
								$author$project$Common$Panel$expander,
								{
									yT: $author$project$Messages$TravelClassPageMsg(
										$author$project$TravelClassPage$Messages$ToggleTravelClassDescription(code)),
									yX: _List_Nil,
									z9: isDescriptionOpened,
									A_: language
								},
								_List_fromArray(
									[description])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bodyNorm longDescription')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('longDescriptionText marginBottomMedium')
											]),
										$author$project$Translations$toHtml(longDescription))
									]))
							]);
					},
					maybeLongDescription)));
	});
var $author$project$TravelClassPage$View$getSelectedFlags = F2(
	function (travelClasses, travelClass) {
		var isSelected = function (selection) {
			return A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map(
					function (_v1) {
						var code = _v1.pQ;
						return A2(
							$elm$core$List$any,
							function (_v2) {
								var selected = _v2.a;
								var count = _v2.b;
								return _Utils_eq(selected, code) && (count > 0);
							},
							selection);
					}),
				$elm$core$Maybe$withDefault(false));
		};
		var _v0 = $author$project$Types$TravelClasses$getSelectedCodeCountPairLists(travelClasses);
		var inbound = _v0.zT;
		var outbound = _v0.Dr;
		var isReturnSelected = A2(isSelected, inbound, travelClass.FT);
		var isOutwardSelected = A2(isSelected, outbound, travelClass.DA);
		return {Al: isOutwardSelected, Ar: isReturnSelected};
	});
var $author$project$TravelClassPage$View$getSelectedSurprisesCount = F3(
	function (selectedCabinSurprises, _v0, travelClassCode) {
		var isOutwardSelected = _v0.Al;
		var isReturnSelected = _v0.Ar;
		var selectedSurprisesCount = function (mapSelectedCabinSurprises) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$length,
					A2(
						$elm$core$Dict$get,
						travelClassCode,
						mapSelectedCabinSurprises(selectedCabinSurprises))));
		};
		var _v1 = _Utils_Tuple2(isOutwardSelected, isReturnSelected);
		if (!_v1.a) {
			if (_v1.b) {
				return selectedSurprisesCount(
					function ($) {
						return $.FV;
					});
			} else {
				return 0;
			}
		} else {
			if (!_v1.b) {
				return selectedSurprisesCount(
					function ($) {
						return $.DC;
					});
			} else {
				return selectedSurprisesCount(
					function ($) {
						return $.DC;
					}) + selectedSurprisesCount(
					function ($) {
						return $.FV;
					});
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $author$project$TravelClassPage$View$getTravelClassCode = function (travelClass) {
	var returnCode = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.pQ;
		},
		travelClass.FT);
	var outwardCode = A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.pQ;
		},
		travelClass.DA);
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm_community$maybe_extra$Maybe$Extra$or, returnCode, outwardCode));
};
var $author$project$TravelClassPage$Gallery$view = function (_v0) {
	var title = _v0.HI;
	var images = _v0.zQ;
	return A3(
		$elm$html$Html$node,
		'image-gallery',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('imageHeaderContent travelClassTitle')
					]),
				_List_fromArray(
					[
						$author$project$Common$Panel$imageHeaderTitle(title)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('images')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, imageUrl) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('image'),
										A2($elm$html$Html$Attributes$style, 'backgroundImage', 'url(\"' + (imageUrl + '\")')),
										A2(
										$elm$html$Html$Attributes$attribute,
										'data-id',
										$elm$core$String$fromInt(index))
									]),
								_List_Nil);
						}),
					images))
			]));
};
var $author$project$TravelClassPage$View$travelClassImage = function (travelClass) {
	return ($elm$core$List$length(travelClass.zQ) > 1) ? A2(
		$elm$html$Html$map,
		$author$project$Messages$TravelClassPageMsg,
		$author$project$TravelClassPage$Gallery$view(
			{zQ: travelClass.zQ, HI: travelClass.oh})) : A2(
		$author$project$Common$Panel$imageHeader,
		A2($elm$core$Maybe$withDefault, '', travelClass.zP),
		_List_fromArray(
			[
				$author$project$Common$Panel$imageHeaderTitle(travelClass.oh)
			]));
};
var $author$project$Types$CabinSurprise$MergedCabinSurprise = F8(
	function (code, name, description, thumbnailUrl, outwardPrice, returnPrice, outwardAvailability, returnAvailability) {
		return {pQ: code, nt: description, oh: name, rM: outwardAvailability, Dx: outwardPrice, oI: returnAvailability, FQ: returnPrice, Ht: thumbnailUrl};
	});
var $author$project$Types$CabinSurprise$mergeCabinSurprises = function (cabinSurprisesPerTravelClass) {
	var outwardSurprises = A2(
		$elm$core$List$map,
		function (a) {
			return A8(
				$author$project$Types$CabinSurprise$MergedCabinSurprise,
				a.pQ,
				a.oh,
				a.nt,
				a.Ht,
				$elm$core$Maybe$Just(a.lN),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just(a.uk),
				$elm$core$Maybe$Nothing);
		},
		cabinSurprisesPerTravelClass.DC);
	var outwardAndReturnSurprises = A2(
		$elm$core$List$map,
		function (mergedOutwardSurprise) {
			return A2(
				$elm$core$Maybe$withDefault,
				mergedOutwardSurprise,
				A2(
					$elm$core$Maybe$map,
					function (returnSurprise) {
						return _Utils_update(
							mergedOutwardSurprise,
							{
								oI: $elm$core$Maybe$Just(returnSurprise.uk),
								FQ: $elm$core$Maybe$Just(returnSurprise.lN)
							});
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(mergedOutwardSurprise.pQ)),
						cabinSurprisesPerTravelClass.FV)));
		},
		outwardSurprises);
	var onlyReturnSurprises = A2(
		$elm$core$List$map,
		function (a) {
			return A8(
				$author$project$Types$CabinSurprise$MergedCabinSurprise,
				a.pQ,
				a.oh,
				a.nt,
				a.Ht,
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just(a.lN),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Just(a.uk));
		},
		A2(
			$elm$core$List$filter,
			function (a) {
				return !A2(
					$elm$core$List$member,
					a.pQ,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.pQ;
						},
						outwardAndReturnSurprises));
			},
			cabinSurprisesPerTravelClass.FV));
	return _Utils_ap(outwardAndReturnSurprises, onlyReturnSurprises);
};
var $author$project$TravelClassPage$CabinSurpriseList$getMergedCabinSurprises = F2(
	function (_v0, travelClassCode) {
		var cabinSurprises = _v0.pD;
		var selectedCabinSurprises = _v0.Gh;
		var initializeCabinSurprises = function (mapCabinSurprises) {
			return mapCabinSurprises(
				A2(
					$author$project$Types$CabinSurprise$getCabinSurprisesPerTravelClass,
					travelClassCode,
					A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Types$CabinSurprise$defaultSurprises, cabinSurprises)));
		};
		var initializedCabinSurprises = {
			DC: initializeCabinSurprises(
				function ($) {
					return $.DC;
				}),
			FV: initializeCabinSurprises(
				function ($) {
					return $.FV;
				})
		};
		return $author$project$Types$CabinSurprise$mergeCabinSurprises(initializedCabinSurprises);
	});
var $author$project$TravelClassPage$CabinSurpriseList$indicator = function (isActive) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('indicator'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('active', isActive)
					]))
			]),
		_List_Nil);
};
var $author$project$TravelClassPage$CabinSurpriseList$isFreeGift = function (surprise) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(0),
				surprise.FQ),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(0),
				surprise.Dx)));
};
var $author$project$TravelClassPage$CabinSurpriseList$getAvaliableLimitAndCount = F3(
	function (travelClassCode, dict, _v0) {
		var code = _v0.pQ;
		var availability = _v0.uk;
		var count = A2(
			$elm_community$list_extra$List$Extra$count,
			$elm$core$Basics$eq(code),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, travelClassCode, dict)));
		return _Utils_Tuple2(availability, count);
	});
var $author$project$Types$CabinSurprise$mergedToOutwardCabinSurpise = function (mergedCabinSurprise) {
	return A6(
		$author$project$Types$CabinSurprise$CabinSurprise,
		mergedCabinSurprise.pQ,
		mergedCabinSurprise.oh,
		mergedCabinSurprise.nt,
		mergedCabinSurprise.Ht,
		A2($elm$core$Maybe$withDefault, 0, mergedCabinSurprise.Dx),
		A2($elm$core$Maybe$withDefault, 0, mergedCabinSurprise.rM));
};
var $author$project$TravelClassPage$CabinSurpriseList$priceView = F3(
	function (market, shouldShowPrice, price) {
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('price')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textAlignCenter')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyBold')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Utils$String$renderIf,
									shouldShowPrice,
									$elm$html$Html$text(
										A2($author$project$Types$Market$formatPriceWithSign, market, price)))
								]))
						]))
				]));
	});
var $author$project$Messages$ClickedAddCabinSurprise = F3(
	function (a, b, c) {
		return {$: 128, a: a, b: b, c: c};
	});
var $author$project$Messages$ClickedRemoveCabinSurprise = F3(
	function (a, b, c) {
		return {$: 129, a: a, b: b, c: c};
	});
var $author$project$Common$Button$disabledPlusAndMinusButtons = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button outlineButtonComponent plusMinusButtons withBorderAndBackground disabled')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('minus disabled')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('buttonContent')
					]),
				content),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('plus disabled')
					]),
				_List_Nil)
			]));
};
var $author$project$TravelClassPage$CabinSurpriseList$selectButton = function (_v0) {
	var language = _v0.A_;
	var count = _v0.pZ;
	var availableLimit = _v0.l3;
	var cabinSurprise = _v0.l8;
	var direction = _v0.p7;
	var travelClassCode = _v0.m$;
	var isRouteSelected = _v0.mG;
	return A2(
		$author$project$Common$Panel$row,
		_List_Nil,
		_List_fromArray(
			[
				isRouteSelected ? A2(
				$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
				{
					pZ: count,
					nw: true,
					nQ: false,
					q_: false,
					kZ: $elm$core$Maybe$Just(availableLimit),
					rx: _List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A3($author$project$Messages$ClickedRemoveCabinSurprise, travelClassCode, cabinSurprise, direction))
						]),
					oz: _List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A3($author$project$Messages$ClickedAddCabinSurprise, travelClassCode, cabinSurprise, direction)),
							$elm$html$Html$Attributes$disabled(
							_Utils_cmp(count, availableLimit) > -1)
						])
				},
				_List_fromArray(
					[
						(count < 1) ? $elm$html$Html$text(
						$elm$core$String$toUpper(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.tJ;
								}))) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyBold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(count))
							]))
					])) : $author$project$Common$Button$disabledPlusAndMinusButtons(
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$toUpper(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.tJ;
								})))
					]))
			]));
};
var $author$project$TravelClassPage$CabinSurpriseList$oneWaySelect = F3(
	function (session, travelClassCode, mergedCabinSurprise) {
		var _v0 = session;
		var market = _v0.rb;
		var language = _v0.A_;
		var selectedCabinSurprises = _v0.Gh;
		var _v1 = A3(
			$author$project$TravelClassPage$CabinSurpriseList$getAvaliableLimitAndCount,
			travelClassCode,
			selectedCabinSurprises.DC,
			$author$project$Types$CabinSurprise$mergedToOutwardCabinSurpise(mergedCabinSurprise));
		var availableLimit = _v1.a;
		var count = _v1.b;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (price) {
					return $author$project$Common$Panel$column(
						_List_fromArray(
							[
								A3($author$project$TravelClassPage$CabinSurpriseList$priceView, market, true, price),
								$author$project$TravelClassPage$CabinSurpriseList$selectButton(
								{
									l3: availableLimit,
									l8: $author$project$Types$CabinSurprise$mergedToOutwardCabinSurpise(mergedCabinSurprise),
									pZ: count,
									p7: 0,
									mG: true,
									A_: language,
									m$: travelClassCode
								})
							]));
				},
				mergedCabinSurprise.Dx));
	});
var $author$project$Types$CabinSurprise$mergedToReturnCabinSurpise = function (mergedCabinSurprise) {
	return A6(
		$author$project$Types$CabinSurprise$CabinSurprise,
		mergedCabinSurprise.pQ,
		mergedCabinSurprise.oh,
		mergedCabinSurprise.nt,
		mergedCabinSurprise.Ht,
		A2($elm$core$Maybe$withDefault, 0, mergedCabinSurprise.FQ),
		A2($elm$core$Maybe$withDefault, 0, mergedCabinSurprise.oI));
};
var $author$project$TravelClassPage$CabinSurpriseList$notAvailableView = function (language) {
	return $author$project$Common$Panel$column(
		_List_fromArray(
			[
				A2(
				$author$project$Common$Panel$row,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('price')
					]),
				_List_Nil),
				A2(
				$author$project$Common$Button$outline,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('disabled')
					]),
				_List_fromArray(
					[
						$author$project$Common$Button$text(
						$elm$core$String$toUpper(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.wY;
								})))
					]))
			]));
};
var $author$project$TravelClassPage$CabinSurpriseList$routeTitleView = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('textAlignCenter title2')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Types$Port$toString(from) + (' - ' + $author$project$Types$Port$toString(to)))
			]));
};
var $author$project$TravelClassPage$CabinSurpriseList$twoWaySelect = F4(
	function (session, travelClassCode, _v0, mergedCabinSurprise) {
		var isOutwardSelected = _v0.Al;
		var isReturnSelected = _v0.Ar;
		var _v1 = session;
		var market = _v1.rb;
		var language = _v1.A_;
		var selectedCabinSurprises = _v1.Gh;
		var from = _v1.kS;
		var to = _v1.le;
		var _v2 = A3(
			$author$project$TravelClassPage$CabinSurpriseList$getAvaliableLimitAndCount,
			travelClassCode,
			selectedCabinSurprises.FV,
			$author$project$Types$CabinSurprise$mergedToReturnCabinSurpise(mergedCabinSurprise));
		var availableReturnLimit = _v2.a;
		var returnCount = _v2.b;
		var _v3 = A3(
			$author$project$TravelClassPage$CabinSurpriseList$getAvaliableLimitAndCount,
			travelClassCode,
			selectedCabinSurprises.DC,
			$author$project$Types$CabinSurprise$mergedToOutwardCabinSurpise(mergedCabinSurprise));
		var availableOutwardLimit = _v3.a;
		var outwardCount = _v3.b;
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('twoWay')
				]),
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							$author$project$TravelClassPage$CabinSurpriseList$routeTitleView(
							{kS: from, le: to}),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$TravelClassPage$CabinSurpriseList$notAvailableView(language),
							A2(
								$elm$core$Maybe$map,
								function (price) {
									return $author$project$Common$Panel$column(
										_List_fromArray(
											[
												A3($author$project$TravelClassPage$CabinSurpriseList$priceView, market, isOutwardSelected, price),
												$author$project$TravelClassPage$CabinSurpriseList$selectButton(
												{
													l3: availableOutwardLimit,
													l8: $author$project$Types$CabinSurprise$mergedToOutwardCabinSurpise(mergedCabinSurprise),
													pZ: outwardCount,
													p7: 0,
													mG: isOutwardSelected,
													A_: language,
													m$: travelClassCode
												})
											]));
								},
								mergedCabinSurprise.Dx))
						])),
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							$author$project$TravelClassPage$CabinSurpriseList$routeTitleView(
							{kS: to, le: from}),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$TravelClassPage$CabinSurpriseList$notAvailableView(language),
							A2(
								$elm$core$Maybe$map,
								function (price) {
									return $author$project$Common$Panel$column(
										_List_fromArray(
											[
												A3($author$project$TravelClassPage$CabinSurpriseList$priceView, market, isReturnSelected, price),
												$author$project$TravelClassPage$CabinSurpriseList$selectButton(
												{
													l3: $author$project$TravelClassPage$CabinSurpriseList$isFreeGift(mergedCabinSurprise) ? 0 : availableReturnLimit,
													l8: $author$project$Types$CabinSurprise$mergedToReturnCabinSurpise(mergedCabinSurprise),
													pZ: returnCount,
													p7: 1,
													mG: isReturnSelected,
													A_: language,
													m$: travelClassCode
												})
											]));
								},
								mergedCabinSurprise.FQ))
						]))
				]));
	});
var $author$project$TravelClassPage$CabinSurpriseList$listItem = F4(
	function (session, travelClassCode, selectedFlags, surprise) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('horizontalPanelListItem')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cabinSurprise')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cabinSurpriseContent')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(surprise.Ht)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cabinSurpriseText')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Utils$String$renderIf,
													$author$project$TravelClassPage$CabinSurpriseList$isFreeGift(surprise),
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('freeLabel bodyBold')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2(
																	$author$project$Translations$t,
																	session.A_,
																	function ($) {
																		return $.bi;
																	}))
															]))),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bodyBold surpriseTitle')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(surprise.oh)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('bodySmall cabinSurpriseDescription')
														]),
													$author$project$Translations$toHtml(surprise.nt))
												]))
										])),
									session.qW ? A3($author$project$TravelClassPage$CabinSurpriseList$oneWaySelect, session, travelClassCode, surprise) : A4($author$project$TravelClassPage$CabinSurpriseList$twoWaySelect, session, travelClassCode, selectedFlags, surprise)
								]))
						]))
				]));
	});
var $author$project$TravelClassPage$CabinSurpriseList$onScroll = function (message) {
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		$elm$json$Json$Decode$succeed(message));
};
var $author$project$TravelClassPage$Messages$ScrolledCabinSurpriseList = function (a) {
	return {$: 4, a: a};
};
var $author$project$TravelClassPage$CabinSurpriseList$scrolledList = A2($elm$core$Basics$composeL, $author$project$Messages$TravelClassPageMsg, $author$project$TravelClassPage$Messages$ScrolledCabinSurpriseList);
var $author$project$TravelClassPage$CabinSurpriseList$spacer = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('horizontalPanelListSpacer')
		]),
	_List_Nil);
var $author$project$TravelClassPage$CabinSurpriseList$view = F5(
	function (travelClassCode, index, animation, session, selectedFlags) {
		var mergedSurprises = A2($author$project$TravelClassPage$CabinSurpriseList$getMergedCabinSurprises, session, travelClassCode);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cabinSurprises'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opening',
							_Utils_eq(
								animation,
								$elm$core$Maybe$Just(0))),
							_Utils_Tuple2(
							'closing',
							_Utils_eq(
								animation,
								$elm$core$Maybe$Just(1)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('horizontalPanelList'),
							$elm$html$Html$Attributes$id(
							$author$project$TravelClassPage$CabinSurpriseList$listId(travelClassCode)),
							$author$project$TravelClassPage$CabinSurpriseList$onScroll(
							$author$project$TravelClassPage$CabinSurpriseList$scrolledList(travelClassCode))
						]),
					_Utils_ap(
						_List_fromArray(
							[$author$project$TravelClassPage$CabinSurpriseList$spacer]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A3($author$project$TravelClassPage$CabinSurpriseList$listItem, session, travelClassCode, selectedFlags),
								mergedSurprises),
							_List_fromArray(
								[$author$project$TravelClassPage$CabinSurpriseList$spacer])))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('indicators')
						]),
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$TravelClassPage$CabinSurpriseList$indicator,
							$elm$core$Basics$eq(index)),
						A2(
							$elm$core$List$range,
							0,
							(-1) + $elm$core$List$length(mergedSurprises))))
				]));
	});
var $author$project$TravelClassPage$View$travelClassPanel = F3(
	function (_arguments, travelClass, content) {
		var code = $author$project$TravelClassPage$View$getTravelClassCode(travelClass);
		var _v0 = _arguments;
		var cabinSurpriseAnimationStates = _v0.pB;
		var translations = _v0.lY;
		var openCardCodes = _v0.oo;
		var session = _v0.j;
		var travelClasses = _v0.to;
		var selectedFlags = A2($author$project$TravelClassPage$View$getSelectedFlags, travelClasses, travelClass);
		var _v1 = session;
		var cabinSurprises = _v1.pD;
		var selectedCabinSurprises = _v1.Gh;
		var _v2 = selectedFlags;
		var isOutwardSelected = _v2.Al;
		var isReturnSelected = _v2.Ar;
		var _v3 = A2($author$project$Types$CabinSurprise$getCabinSurprisesAvailabilityFlags, session, code);
		var hasOutwardCabinSurprises = _v3.zo;
		var hasReturnCabinSurprises = _v3.zq;
		var areCabinSurprisesShown = (!$author$project$Types$TravelClasses$isDeckCode(code)) && ((!_Utils_eq(cabinSurprises, $krisajenkins$remotedata$RemoteData$NotAsked)) && ((hasOutwardCabinSurprises && isOutwardSelected) || (hasReturnCabinSurprises && isReturnSelected)));
		return A3(
			$author$project$Utils$List$addIf,
			areCabinSurprisesShown || _Utils_eq(
				A2($elm$core$Dict$get, code, cabinSurpriseAnimationStates),
				$elm$core$Maybe$Just(1)),
			A5(
				$author$project$TravelClassPage$CabinSurpriseList$view,
				code,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Dict$get, code, _arguments.pC)),
				A2($elm$core$Dict$get, code, _arguments.pB),
				session,
				selectedFlags),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$view,
					A3(
						$author$project$Utils$List$addIf,
						isOutwardSelected || isReturnSelected,
						$elm$html$Html$Attributes$id($author$project$TravelClassPage$View$selectedTravelClassId),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('travelClassPanel marginHorizontalSmall'),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'travel-class-panel'),
								A2($elm$html$Html$Attributes$attribute, 'data-test-travel-class-code', code),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('withCabinSurprises', areCabinSurprisesShown)
									]))
							])),
					A3(
						$author$project$Utils$List$appendIf,
						areCabinSurprisesShown,
						_List_fromArray(
							[
								A2(
								$author$project$TravelClassPage$View$cabinSurpriseIndicator,
								translations,
								A3($author$project$TravelClassPage$View$getSelectedSurprisesCount, selectedCabinSurprises, selectedFlags, code)),
								$author$project$TravelClassPage$View$cabinSurpriseIndicatorArrow
							]),
						_List_fromArray(
							[
								$author$project$TravelClassPage$View$travelClassImage(
								A2($author$project$Types$TravelClasses$adjustTravelClassName, translations, travelClass)),
								A2($author$project$TravelClassPage$View$capacityMessage, _arguments, travelClass),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									$author$project$TravelClassPage$View$travelClassReserveType(translations),
									travelClass.FC)),
								A4(
								$author$project$TravelClassPage$View$descriptionWithToggle,
								session.A_,
								travelClass,
								code,
								A2($elm$core$List$member, code, openCardCodes)),
								content
							])))
				]));
	});
var $author$project$TravelClassPage$View$Regular = 0;
var $author$project$TravelClassPage$View$travelClassPanelButtons = F2(
	function (_v0, travelClass) {
		var translations = _v0.lY;
		var session = _v0.j;
		var travelClasses = _v0.to;
		var isSpecialCruise = _v0.Au;
		var shared = (!_Utils_eq(travelClass.zf, $elm$core$Maybe$Nothing)) && (!_Utils_eq(travelClass.BL, $elm$core$Maybe$Nothing));
		var panelArguments = {Au: isSpecialCruise, j: session, lY: translations, to: travelClasses};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginHorizontalMedium marginBottomMedium')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Common$Panel$graySeparator(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginBottomMedium')
							]))
					]),
				_List_fromArray(
					[
						function () {
						switch (travelClasses.$) {
							case 2:
								var oneWay = travelClasses.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Common$Button$placeholder,
									A2(
										$elm$core$Maybe$map,
										function (info) {
											return $author$project$TravelClassPage$View$oneWayMultipleSelectionsCabinButton(
												{
													i: panelArguments,
													E: $author$project$Types$TravelClasses$oneWaySelection(oneWay),
													kI: shared,
													n: info,
													u: 0
												});
										},
										travelClass.DA));
							case 3:
								var twoWay = travelClasses.a;
								return $author$project$TravelClassPage$View$twoWayMultipleSelectionsCabinButtons(
									{
										os: $author$project$Types$TravelClasses$twoWaySelection(twoWay).Ds,
										k0: travelClass.DA,
										i: panelArguments,
										oK: $author$project$Types$TravelClasses$twoWaySelection(twoWay).FL,
										k5: travelClass.FT,
										kI: shared,
										u: 0
									});
							case 0:
								var oneWay = travelClasses.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Common$Button$placeholder,
									A2(
										$elm$core$Maybe$map,
										function (info) {
											return $author$project$TravelClassPage$View$oneWaySingleSelectionCabinButton(
												{
													i: panelArguments,
													lb: $author$project$Types$TravelClasses$oneWaySelection(oneWay),
													n: info,
													u: 0
												});
										},
										travelClass.DA));
							default:
								var twoWay = travelClasses.a;
								return $author$project$TravelClassPage$View$twoWaySingleSelectionCabinButton(
									{
										or: $author$project$Types$TravelClasses$twoWaySelection(twoWay).Ds,
										k0: travelClass.DA,
										i: panelArguments,
										oJ: $author$project$Types$TravelClasses$twoWaySelection(twoWay).FL,
										k5: travelClass.FT,
										u: 0
									});
						}
					}()
					])));
	});
var $author$project$TravelClassPage$View$travelClassSections = function (_arguments) {
	var translations = _arguments.lY;
	var session = _arguments.j;
	var travelClasses = _arguments.to;
	var sectionWithHeader = F2(
		function (headerText, elements) {
			return A2(
				$author$project$Common$Section$view,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Common$Section$header,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginHorizontalSmall')
							]),
						headerText),
					elements));
		});
	var panel = F2(
		function (footer, travelClass) {
			return A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$TravelClassPage$View$panelKey(travelClass),
						A2(
							$elm$html$Html$div,
							_List_Nil,
							A3(
								$author$project$TravelClassPage$View$travelClassPanel,
								_arguments,
								travelClass,
								A2(footer, _arguments, travelClass))))
					]));
		});
	var isTravelClassWithDeckCode = function (_v2) {
		var outwardTravelClass = _v2.DA;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$author$project$Types$TravelClasses$isDeckCode),
				outwardTravelClass));
	};
	var foldPanels = function (footer) {
		return A2(
			$elm$core$Basics$composeR,
			A2(
				$elm$core$List$foldl,
				F2(
					function (travelClass, _v1) {
						var panels = _v1.a;
						var isFirstSelectedFound = _v1.b;
						return _Utils_Tuple2(
							_Utils_ap(
								panels,
								_List_fromArray(
									[
										A2(panel, footer, travelClass)
									])),
							(!isFirstSelectedFound) && A2($author$project$TravelClassPage$View$hasActiveTravelClassButton, travelClasses, travelClass));
					}),
				_Utils_Tuple2(_List_Nil, false)),
			$elm$core$Tuple$first);
	};
	var _v0 = $author$project$Types$TravelClasses$availableTravelClasses(travelClasses);
	var regular = _v0.Fx;
	var shared = _v0.kI;
	var petCabins = _v0.EB;
	var special = _v0.GN;
	var petCages = _v0.EC;
	var petInBag = _v0.ED;
	var petInCar = _v0.EE;
	return _List_fromArray(
		[
			A2(
			$author$project$Common$Section$view,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'regular')
				]),
			($author$project$Utils$Route$isMugVssRoute(session.kS) && ($elm$core$Array$length(session.Eg) === 1)) ? A2(
				foldPanels,
				$author$project$TravelClassPage$View$travelClassPanelButtons,
				A2($elm$core$List$filter, isTravelClassWithDeckCode, regular)) : A2(foldPanels, $author$project$TravelClassPage$View$travelClassPanelButtons, regular)),
			A2(
			$author$project$Utils$String$renderIf,
			$elm$core$List$length(shared) > 0,
			A2(
				sectionWithHeader,
				translations.hK,
				A2(foldPanels, $author$project$TravelClassPage$View$travelClassPanelButtons, shared))),
			A2(
			$author$project$Utils$String$renderIf,
			$elm$core$List$length(special) > 0,
			A2(
				sectionWithHeader,
				translations.hQ,
				A2(foldPanels, $author$project$TravelClassPage$View$travelClassPanelButtons, special))),
			function () {
			var petPanels = A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					$author$project$TravelClassPage$View$petPanel(_arguments),
					petInCar),
				A2(
					$author$project$Utils$List$maybeAdd,
					A2(
						$elm$core$Maybe$map,
						$author$project$TravelClassPage$View$petPanel(_arguments),
						petInBag),
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							$author$project$TravelClassPage$View$petPanel(_arguments),
							petCages),
						A2(foldPanels, $author$project$TravelClassPage$View$petPanelButtons, petCabins))));
			return ($elm$core$List$length(petPanels) > 0) ? A2(sectionWithHeader, translations.hI, petPanels) : $elm$html$Html$text('');
		}()
		]);
};
var $author$project$TravelClassPage$View$root = F3(
	function (translations, model, travelClasses) {
		var _arguments = {
			pB: model.H0.pB,
			pC: model.H0.pC,
			Au: $author$project$TravelClassPage$View$isSelectedCruiseSailSpecial(model.j),
			oo: model.H0.rJ,
			j: model.j,
			lY: translations,
			to: travelClasses
		};
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('travelClassPage page withFixedButton')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$TravelClassPage$View$header, translations, model.j.tx)
					]),
				$author$project$TravelClassPage$View$travelClassSections(_arguments)));
	});
var $author$project$Messages$GoToBusTransfersListPage = {$: 3};
var $author$project$Common$Panel$header = function (elements) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panelHeader')
			]),
		elements);
};
var $author$project$Common$Panel$title = function (elements) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title title2')
			]),
		elements);
};
var $author$project$SelectedBusTransferPage$View$addAnotherBusTransferButton = function (translations) {
	return A2(
		$author$project$Common$Panel$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mediumPadding'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-action', 'add-another-transfer'),
				$elm$html$Html$Events$onClick($author$project$Messages$GoToBusTransfersListPage)
			]),
		_List_fromArray(
			[
				$author$project$Common$Panel$header(
				_List_fromArray(
					[
						$author$project$Common$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text(translations.vB)
							])),
						$author$project$Common$Images$plusImage
					]))
			]));
};
var $author$project$Messages$AddPassengerToTransfer = F4(
	function (a, b, c, d) {
		return {$: 6, a: a, b: b, c: c, d: d};
	});
var $author$project$Types$Bus$AgeGroup$Adults = 0;
var $author$project$Types$Bus$AgeGroup$Infants = 2;
var $author$project$Types$Notification$Info = 1;
var $author$project$Types$Bus$AgeGroup$UnderAges = 1;
var $author$project$SelectedBusTransferPage$View$addOrRemovePassengerButtonGroup = F5(
	function (isPassengerAddingAllowed, canRemovePassenger, addNumberOfPassengers, attributes, content) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('addOrRemovePassengerButtonGroup'),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('minus'),
							$elm$html$Html$Attributes$disabled(!canRemovePassenger),
							$elm$html$Html$Events$onClick(
							addNumberOfPassengers(-1)),
							A2($elm$html$Html$Attributes$attribute, 'data-test-button', 'remove-passenger')
						]),
					_List_Nil),
					A2($elm$html$Html$span, _List_Nil, content),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('plus'),
							$elm$html$Html$Attributes$disabled(!isPassengerAddingAllowed),
							$elm$html$Html$Events$onClick(
							addNumberOfPassengers(1)),
							A2($elm$html$Html$Attributes$attribute, 'data-test-button', 'add-passenger')
						]),
					_List_Nil)
				]));
	});
var $author$project$SelectedBusTransferPage$View$ageGroupCountSpan = F3(
	function (translations, translate, count) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ageGroupCount')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'count',
								$elm$core$String$fromInt(count))
							]),
						A2(
							$author$project$Translations$pluralize,
							_Utils_Tuple2('count', count),
							translate(translations))))
				]));
	});
var $author$project$SelectedBusTransferPage$View$ageGroupRangeSpan = F2(
	function (translations, ageRange) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ageRange')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2('range', ageRange)
							]),
						translations.ww))
				]));
	});
var $author$project$SelectedBusTransferPage$View$arrivalTimeAndStation = F3(
	function (translations, date, station) {
		return function (dateTimeString) {
			return dateTimeString + (' ' + $author$project$Utils$String$capitalizeFirstLetters(station));
		}(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'time',
						$author$project$Utils$Time$Format$formatHourMinute(date))
					]),
				translations.wx));
	});
var $author$project$SelectedBusTransferPage$View$departureDateTimeAndStation = F5(
	function (translations, language, market, date, station) {
		return function (dateTimeString) {
			return _Utils_ap(
				dateTimeString + ' ',
				$author$project$Utils$String$capitalizeFirstLetters(station));
		}(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'time',
						$author$project$Utils$Time$Format$formatHourMinute(date))
					]),
				A2(
					$author$project$Translations$injectValues,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'date',
							A3(
								$author$project$Utils$Time$Format$format,
								A2($author$project$Types$Locale$Locale, language, market),
								$author$project$Utils$Time$Format$monthNumberDayWeekday,
								date))
						]),
					translations.xo)));
	});
var $author$project$Common$Panel$element = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panelElement'),
				attributes),
			elements);
	});
var $author$project$SelectedBusTransferPage$View$hasPassengerAgeCategory = F2(
	function (passengers, ageCategory) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tY;
				},
				$elm$core$Basics$eq(ageCategory)),
			passengers);
	});
var $author$project$Types$Bus$SelectedTransfers$getTransportedCountByCategory = F3(
	function (selectedBusTransfers, getMaybeDetails, getAgeGroup) {
		return A3(
			$elm$core$Array$foldl,
			A2(
				$elm$core$Basics$composeR,
				getMaybeDetails,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.po;
							},
							getAgeGroup)),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault(0),
						$elm$core$Basics$add))),
			0,
			$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers));
	});
var $author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransferByCategoryAndDirection = F4(
	function (passengers, getAgeGroup, direction, selectedBusTransfers) {
		var maxPossiblePassengersOfGroup = getAgeGroup(
			$author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(passengers));
		var getMaybeDetails = (!direction) ? $author$project$Types$Bus$SelectedTransferPair$selectedOutward : $author$project$Types$Bus$SelectedTransferPair$selectedReturn;
		return _Utils_cmp(
			A3($author$project$Types$Bus$SelectedTransfers$getTransportedCountByCategory, selectedBusTransfers, getMaybeDetails, getAgeGroup),
			maxPossiblePassengersOfGroup) < 0;
	});
var $author$project$SelectedBusTransferPage$View$maxWaitWithoutToastNotification = 4;
var $author$project$SelectedBusTransferPage$View$isTooLongWait = F4(
	function (transferDeparture, transferArrival, sailArrivalOrDeparture, direction) {
		if (!direction) {
			return _Utils_cmp(
				$author$project$SelectedBusTransferPage$View$maxWaitWithoutToastNotification,
				A4($justinmimbs$time_extra$Time$Extra$diff, 12, $elm$time$Time$utc, transferArrival, sailArrivalOrDeparture)) < 1;
		} else {
			return _Utils_cmp(
				$author$project$SelectedBusTransferPage$View$maxWaitWithoutToastNotification,
				A4($justinmimbs$time_extra$Time$Extra$diff, 12, $elm$time$Time$utc, sailArrivalOrDeparture, transferDeparture)) < 1;
		}
	});
var $author$project$SelectedBusTransferPage$View$needAdultForAddingTransfer = F4(
	function (passengers, selectedBusTransfers, ageGroupCounts, direction) {
		var hasZeroAdults = !ageGroupCounts.pn;
		var hasUnderagesWithoutBusTransfer = A4(
			$author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransferByCategoryAndDirection,
			passengers,
			function ($) {
				return $.H4;
			},
			direction,
			selectedBusTransfers);
		var hasInfantsWithoutBusTransfer = A4(
			$author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransferByCategoryAndDirection,
			passengers,
			function ($) {
				return $.zV;
			},
			direction,
			selectedBusTransfers);
		return hasZeroAdults && (hasUnderagesWithoutBusTransfer || hasInfantsWithoutBusTransfer);
	});
var $author$project$SelectedBusTransferPage$View$priceString = F3(
	function (translations, market, price) {
		return A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'price',
					A2($author$project$Types$Market$formatPriceWithSign, market, price))
				]),
			translations.tm);
	});
var $author$project$Common$MapLink$View$getLocationUrlByAddress = F2(
	function (os, address) {
		var encodedAddress = $elm$url$Url$percentEncode(address);
		return ($elm$core$String$length(address) < 1) ? '' : ((os === 1) ? ('https://maps.apple.com/?daddr=' + encodedAddress) : ('https://www.google.com/maps/dir/?api=1&destination=' + encodedAddress));
	});
var $author$project$Common$MapLink$View$view = F3(
	function (mobileOperatingSystem, address, title) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mapLink link1Book'),
					$elm$html$Html$Attributes$href(
					A2($author$project$Common$MapLink$View$getLocationUrlByAddress, mobileOperatingSystem, address)),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title),
					$author$project$Common$Arrow$right
				]));
	});
var $author$project$Types$Notification$getClassBasedOnNotificationType = function (notification) {
	if (notification === 1) {
		return 'informationToast';
	} else {
		return 'warningToast';
	}
};
var $author$project$Common$Toast$View$view = F2(
	function (notification, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Types$Notification$getClassBasedOnNotificationType(notification)),
					$elm$html$Html$Attributes$class('toast'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('enter', true),
							_Utils_Tuple2('leave', false)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	});
var $author$project$SelectedBusTransferPage$View$busTransferCard = F7(
	function (translations, model, selectedBusTransfers, index, direction, sailArrivalOrDepartureDateTime, detailedBusTransfer) {
		var _v0 = model;
		var session = _v0.j;
		var mobileOperatingSystem = _v0.CB;
		var _v1 = session;
		var passengers = _v1.Eg;
		var market = _v1.rb;
		var language = _v1.A_;
		var passengersList = $elm$core$Array$toList(passengers);
		var isPassengerAddingAllowed = function (getAgeGroup) {
			return A4($author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransferByCategoryAndDirection, passengersList, getAgeGroup, direction, selectedBusTransfers);
		};
		var _v2 = detailedBusTransfer;
		var price = _v2.lN;
		var cityFrom = _v2.v1;
		var cityTo = _v2.v2;
		var stationFrom = _v2.GT;
		var stationTo = _v2.sW;
		var ageGroupCounts = _v2.po;
		var departureDateTime = _v2.nq;
		var arrivalDateTime = _v2.na;
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mediumPadding')
				]),
			_List_fromArray(
				[
					$author$project$Common$Panel$header(
					_List_fromArray(
						[
							$author$project$Common$Panel$title(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title3')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(cityFrom)
										])),
									$author$project$Common$Arrow$right,
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title3')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(cityTo)
										]))
								]))
						])),
					A2(
					$author$project$Common$Panel$element,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('departureAndArrivalInfo')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A5($author$project$SelectedBusTransferPage$View$departureDateTimeAndStation, translations, language, market, departureDateTime, stationFrom))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bodySmall tripDetails')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$SelectedBusTransferPage$View$arrivalTimeAndStation, translations, arrivalDateTime, stationTo))
										]))
								])),
							A3($author$project$Common$MapLink$View$view, mobileOperatingSystem, cityFrom + (', ' + stationFrom), stationFrom)
						])),
					A5(
					$author$project$SelectedBusTransferPage$View$addOrRemovePassengerButtonGroup,
					isPassengerAddingAllowed(
						function ($) {
							return $.pn;
						}),
					ageGroupCounts.pn > 0,
					A3($author$project$Messages$AddPassengerToTransfer, index, direction, 0),
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-test-buttons', 'add-or-remove-passenger-over-eighteen')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ageGroup bodyBold')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$SelectedBusTransferPage$View$ageGroupCountSpan,
									translations,
									function ($) {
										return $.wv;
									},
									ageGroupCounts.pn),
									A2($author$project$SelectedBusTransferPage$View$ageGroupRangeSpan, translations, '12+')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodySmallBold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$SelectedBusTransferPage$View$priceString, translations, market, price))
								]))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					A2($author$project$SelectedBusTransferPage$View$hasPassengerAgeCategory, passengersList, 1) || A2($author$project$SelectedBusTransferPage$View$hasPassengerAgeCategory, passengersList, 3),
					A5(
						$author$project$SelectedBusTransferPage$View$addOrRemovePassengerButtonGroup,
						isPassengerAddingAllowed(
							function ($) {
								return $.H4;
							}) && (ageGroupCounts.pn > 0),
						ageGroupCounts.H4 > 0,
						A3($author$project$Messages$AddPassengerToTransfer, index, direction, 1),
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-test-buttons', 'add-or-remove-passenger-six-to-seventeen')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ageGroup bodyBold')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$SelectedBusTransferPage$View$ageGroupCountSpan,
										translations,
										function ($) {
											return $.pT;
										},
										ageGroupCounts.H4),
										A2($author$project$SelectedBusTransferPage$View$ageGroupRangeSpan, translations, '6-11')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bodySmallBold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3($author$project$SelectedBusTransferPage$View$priceString, translations, market, price / 2))
									]))
							]))),
					A2(
					$author$project$Utils$String$renderIf,
					A2($author$project$SelectedBusTransferPage$View$hasPassengerAgeCategory, passengersList, 2),
					A5(
						$author$project$SelectedBusTransferPage$View$addOrRemovePassengerButtonGroup,
						isPassengerAddingAllowed(
							function ($) {
								return $.zV;
							}) && (ageGroupCounts.pn > 0),
						ageGroupCounts.zV > 0,
						A3($author$project$Messages$AddPassengerToTransfer, index, direction, 2),
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-test-buttons', 'add-or-remove-passenger-up-to-five')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ageGroup bodyBold')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$SelectedBusTransferPage$View$ageGroupCountSpan,
										translations,
										function ($) {
											return $.pT;
										},
										ageGroupCounts.zV),
										A2($author$project$SelectedBusTransferPage$View$ageGroupRangeSpan, translations, '0-5')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bodySmallBold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(translations.wy)
									]))
							]))),
					A2(
					$author$project$Utils$String$renderIf,
					A4($author$project$SelectedBusTransferPage$View$isTooLongWait, departureDateTime, arrivalDateTime, sailArrivalOrDepartureDateTime, direction),
					A2($author$project$Common$Toast$View$view, 1, translations.HV)),
					A2(
					$author$project$Utils$String$renderIf,
					A4($author$project$SelectedBusTransferPage$View$needAdultForAddingTransfer, passengersList, selectedBusTransfers, ageGroupCounts, direction),
					A2($author$project$Common$Toast$View$view, 1, translations.HU))
				]));
	});
var $author$project$Messages$RemoveBusTransfer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Common$Panel$smallLink = F3(
	function (attributes, linkText, msg) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panelLink link1Book'),
						$elm$html$Html$Events$onClick(msg)
					]),
				attributes),
			_List_fromArray(
				[
					$elm$html$Html$text(linkText)
				]));
	});
var $author$project$SelectedBusTransferPage$View$busTransferCoupleHeader = F3(
	function (translations, index, city) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('busTransferCoupleHeader')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(city)
						])),
					A3(
					$author$project$Common$Panel$smallLink,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'remove-bus-transfer-button')
						]),
					translations.Ii,
					$author$project$Messages$RemoveBusTransfer(index))
				]));
	});
var $author$project$Types$Notification$Warning = 0;
var $author$project$SelectedBusTransferPage$View$busTransferForDirectionSoldOutCard = F3(
	function (translations, mobileOperatingSystem, maybeBusTransferForOppositeDirection) {
		if (!maybeBusTransferForOppositeDirection.$) {
			var oppositeBusTransfer = maybeBusTransferForOppositeDirection.a;
			var _v1 = oppositeBusTransfer;
			var cityFrom = _v1.v1;
			var cityTo = _v1.v2;
			var stationTo = _v1.sW;
			return A2(
				$author$project$Common$Panel$view,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mediumPadding notAvailable')
					]),
				_List_fromArray(
					[
						$author$project$Common$Panel$header(
						_List_fromArray(
							[
								$author$project$Common$Panel$title(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title3')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(cityTo)
											])),
										$author$project$Common$Arrow$right,
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title3')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(cityFrom)
											]))
									]))
							])),
						A2(
						$author$project$Common$Panel$element,
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$Common$MapLink$View$view, mobileOperatingSystem, cityTo + (', ' + stationTo), stationTo)
							])),
						A2($author$project$Common$Toast$View$view, 0, translations.wY)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Types$Bus$SelectedTransferPair$getMaybeDeparturePort = function (_v0) {
	var _v1 = _v0;
	var maybeOutward = _v1.a;
	var maybeReturn = _v1.b;
	var _v2 = _Utils_Tuple2(maybeOutward, maybeReturn);
	if (!_v2.a.$) {
		var outward = _v2.a.a;
		return $elm$core$Maybe$Just(outward.v1);
	} else {
		if (!_v2.b.$) {
			var _v3 = _v2.a;
			var _return = _v2.b.a;
			return $elm$core$Maybe$Just(_return.v2);
		} else {
			var _v4 = _v2.a;
			var _v5 = _v2.b;
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Utils$List$maybeAddWithDefault = F3(
	function (maybeThis, _default, aList) {
		return _Utils_ap(
			aList,
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[_default]),
				A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeThis)));
	});
var $author$project$SelectedBusTransferPage$View$busTransferToCard = F5(
	function (translations, model, outwardSailDepartureDatetime, maybeReturnSailArrivalDatetime, selectedBusTransfers) {
		return F2(
			function (index, busTransfer) {
				var transferCityHeader = A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
					A2(
						$elm$core$Maybe$map,
						A2($author$project$SelectedBusTransferPage$View$busTransferCoupleHeader, translations, index),
						$author$project$Types$Bus$SelectedTransferPair$getMaybeDeparturePort(busTransfer)));
				var selectedBusTransfersGetter = function (direction) {
					if (!direction) {
						return $author$project$Types$Bus$SelectedTransferPair$selectedOutward;
					} else {
						return $author$project$Types$Bus$SelectedTransferPair$selectedReturn;
					}
				};
				var busTransferCardWithSomeValues = F2(
					function (direction, sailDateTime) {
						return A2(
							$elm$core$Maybe$map,
							A6($author$project$SelectedBusTransferPage$View$busTransferCard, translations, model, selectedBusTransfers, index, direction, sailDateTime),
							A2(selectedBusTransfersGetter, direction, busTransfer));
					});
				return A3(
					$author$project$Utils$List$maybeAddWithDefault,
					A2(
						$elm$core$Maybe$andThen,
						busTransferCardWithSomeValues(1),
						maybeReturnSailArrivalDatetime),
					(!model.j.qW) ? A3(
						$author$project$SelectedBusTransferPage$View$busTransferForDirectionSoldOutCard,
						translations,
						model.CB,
						A2(selectedBusTransfersGetter, 0, busTransfer)) : $elm$html$Html$text(''),
					A3(
						$author$project$Utils$List$maybeAddWithDefault,
						A2(busTransferCardWithSomeValues, 0, outwardSailDepartureDatetime),
						A3(
							$author$project$SelectedBusTransferPage$View$busTransferForDirectionSoldOutCard,
							translations,
							model.CB,
							A2(selectedBusTransfersGetter, 1, busTransfer)),
						_List_fromArray(
							[transferCityHeader])));
			});
	});
var $author$project$Types$Bus$SelectedTransfers$getTransportedAdultsCount = F2(
	function (selectedBusTransfers, key) {
		return A3(
			$elm$core$Array$foldl,
			A2(
				$elm$core$Basics$composeR,
				key,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.po;
							},
							function ($) {
								return $.pn;
							})),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$withDefault(0),
						$elm$core$Basics$add))),
			0,
			$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers));
	});
var $author$project$Types$Bus$SelectedTransfers$hasAdultPassengersWithoutBusTransfer = F2(
	function (_v0, selectedBusTransfers) {
		var passengers = _v0.Eg;
		var isOneWay = _v0.qW;
		var voyageType = _v0.tx;
		var maxPossibleAdults = $author$project$Types$Bus$SelectedTransfers$countPassengerAgeGroups(
			$elm$core$Array$toList(passengers)).pn;
		var isOneWayRouteTrip = isOneWay && (_Utils_eq(voyageType, $author$project$Types$VoyageType$Shuttle) || _Utils_eq(voyageType, $author$project$Types$VoyageType$RouteTrip));
		var getAdultsCountFor = $author$project$Types$Bus$SelectedTransfers$getTransportedAdultsCount(selectedBusTransfers);
		return (_Utils_cmp(
			getAdultsCountFor($author$project$Types$Bus$SelectedTransferPair$selectedOutward),
			maxPossibleAdults) < 0) || ((!isOneWayRouteTrip) && (_Utils_cmp(
			getAdultsCountFor($author$project$Types$Bus$SelectedTransferPair$selectedReturn),
			maxPossibleAdults) < 0));
	});
var $author$project$SelectedBusTransferPage$View$root = F5(
	function (translations, model, outwardSailDepartureDatetime, maybeReturnSailArrivalDatetime, selectedBusTransfers) {
		var _v0 = model;
		var session = _v0.j;
		var isAddAnotherTripButtonVisible = ($elm$core$Array$length(
			$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers)) < 2) && A2($author$project$Types$Bus$SelectedTransfers$hasAdultPassengersWithoutBusTransfer, session, selectedBusTransfers);
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selectedBusTransfer')
				]),
			A3(
				$author$project$Utils$List$addIf,
				isAddAnotherTripButtonVisible,
				$author$project$SelectedBusTransferPage$View$addAnotherBusTransferButton(translations),
				$elm$core$List$concat(
					$elm$core$Array$toList(
						A2(
							$elm$core$Array$indexedMap,
							A5($author$project$SelectedBusTransferPage$View$busTransferToCard, translations, model, outwardSailDepartureDatetime, maybeReturnSailArrivalDatetime, selectedBusTransfers),
							$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers))))));
	});
var $author$project$BusTransferPage$View$transfer = F3(
	function (translate, model, _v0) {
		var departureDate = _v0.a;
		var maybeArrivalDate = _v0.b;
		var _v1 = model.j.B0;
		if (!_v1.$) {
			var selectedBusTransfers = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Messages$BusTransfersMsg,
				A5($author$project$SelectedBusTransferPage$View$root, translate, model, departureDate, maybeArrivalDate, selectedBusTransfers));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loadingSpinner')
					]),
				_List_fromArray(
					[
						$author$project$Common$Images$darkPropellerWithClassName('spinner animateSpinner')
					]));
		}
	});
var $author$project$Messages$ChangedBusTransferPageFilter = function (a) {
	return {$: 41, a: a};
};
var $author$project$BusTransferListPage$View$clearFilter = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('clearFilter'),
			$elm$html$Html$Events$onClick(
			$author$project$Messages$ChangedBusTransferPageFilter(''))
		]),
	_List_fromArray(
		[$author$project$Common$Images$plusImage]));
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$BusTransferListPage$View$filter = F2(
	function (translations, searchChars) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title1 searchLabel bodySmall')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.xL)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row withInput')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('data'),
									$elm$html$Html$Attributes$type_('text'),
									$elm$html$Html$Events$onInput($author$project$Messages$ChangedBusTransferPageFilter),
									$elm$html$Html$Attributes$value(searchChars),
									$elm$html$Html$Attributes$placeholder(translations.xJ)
								]),
							_List_Nil),
							A2($author$project$Utils$String$renderIf, searchChars !== '', $author$project$BusTransferListPage$View$clearFilter)
						]))
				]));
	});
var $author$project$Types$Bus$SelectedTransfers$getListOfCodeFromForSelectedBusTransfers = function (selectedBusTransfers) {
	return A3(
		$elm$core$Array$foldl,
		F2(
			function (a, b) {
				return A2(
					$elm$core$Maybe$withDefault,
					b,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.wn;
							},
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								$elm$core$Basics$append(b))),
						$author$project$Types$Bus$SelectedTransferPair$selectedOutward(a)));
			}),
		_List_Nil,
		$author$project$Types$Bus$SelectedTransfers$toArray(selectedBusTransfers));
};
var $author$project$BusTransferListPage$View$nothingFound = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('nothingFound title3')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.xK)
			]));
};
var $author$project$Messages$SelectTransfer = function (a) {
	return {$: 5, a: a};
};
var $author$project$BusTransferListPage$View$onClickAttributeListIfNotSelected = F2(
	function (isSelected, codeFrom) {
		return (!isSelected) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Messages$SelectTransfer(codeFrom))
			]) : _List_Nil;
	});
var $author$project$BusTransferListPage$View$transferCard = F4(
	function (codeFrom, city, station, isSelected) {
		var control = isSelected ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control selected'),
					A2($elm$html$Html$Attributes$attribute, 'data-city', city)
				]),
			_List_fromArray(
				[$author$project$Common$Images$tickMarkInWhiteCircle])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control add'),
					A2($elm$html$Html$Attributes$attribute, 'data-city', city)
				]),
			_List_fromArray(
				[$author$project$Common$Images$plusImage]));
		return A2(
			$elm$html$Html$map,
			$author$project$Messages$BusTransfersMsg,
			A2(
				$author$project$Common$Panel$view,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mediumPadding'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'transferListPanel'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected', isSelected)
								]))
						]),
					A2($author$project$BusTransferListPage$View$onClickAttributeListIfNotSelected, isSelected, codeFrom)),
				_List_fromArray(
					[
						A2(
						$author$project$Common$Panel$element,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('capitalized')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Common$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text(city)
											])),
										$elm$html$Html$text(station)
									])),
								control
							]))
					])));
	});
var $author$project$BusTransferListPage$View$transfersList = F4(
	function (translations, busTransfers, searchChars, maybeSelectedBusTransfers) {
		var isSelected = function (codeFrom) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$Bus$SelectedTransfers$getListOfCodeFromForSelectedBusTransfers,
						$elm$core$List$member(codeFrom)),
					maybeSelectedBusTransfers));
		};
		return $elm$core$List$isEmpty(busTransfers) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loadingSpinner')
				]),
			_List_fromArray(
				[
					$author$project$Common$Images$darkPropellerWithClassName('spinner animateSpinner')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('busTransferContent')
				]),
			function (nodes) {
				return $elm$core$List$isEmpty(nodes) ? _List_fromArray(
					[
						$author$project$BusTransferListPage$View$nothingFound(translations)
					]) : nodes;
			}(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var codeFrom = _v1.wn;
						var city = _v1.v0;
						var station = _v1.GS;
						return A4(
							$author$project$BusTransferListPage$View$transferCard,
							codeFrom,
							city,
							station,
							isSelected(codeFrom));
					},
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.v0;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.v0;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$String$toLower,
									$elm$core$String$contains(
										$elm$core$String$toLower(searchChars)))),
							A2(
								$elm$core$List$filter,
								function (_v0) {
									var city = _v0.v0;
									return $elm$core$String$toLower(city) !== 'not in use';
								},
								busTransfers))))));
	});
var $author$project$BusTransferListPage$View$root = F4(
	function (translations, busTransfers, searchChars, maybeSelectedBusTransfers) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('busTransfersListWrapper')
				]),
			_List_fromArray(
				[
					A2($author$project$BusTransferListPage$View$filter, translations, searchChars),
					A4($author$project$BusTransferListPage$View$transfersList, translations, busTransfers, searchChars, maybeSelectedBusTransfers)
				]));
	});
var $author$project$BusTransferPage$View$transferList = F2(
	function (translate, _v0) {
		var session = _v0.j;
		var transferPage = _v0.HZ;
		return A4($author$project$BusTransferListPage$View$root, translate, session.H_, transferPage.y1, session.B0);
	});
var $author$project$BusTransferPage$View$view = F2(
	function (translations, page) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('busTransferPage page withFixedButton')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('busTransferPageHeader')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cell title2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.xM)
										]))
								]))
						])),
					page
				]));
	});
var $author$project$Types$Recaptcha$ConfirmFreeTrip = {$: 1};
var $author$project$Messages$RequestedRecaptchaIfNeeded = function (a) {
	return {$: 135, a: a};
};
var $author$project$ContactPersonPage$View$canContinue = F2(
	function (_v0, model) {
		var market = _v0.rb;
		var company = _v0.xA;
		var isAllDataValidAndFilledIn = A2($author$project$ContactPersonPage$Model$isAllDataValid, model, market) && (!A2($author$project$ContactPersonPage$Model$isSomeDataEmpty, model, market));
		var isAgentPresent = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tZ;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				company));
		return isAllDataValidAndFilledIn || isAgentPresent;
	});
var $author$project$Common$Images$lightPropeller = A2($author$project$Common$Images$propeller, '', $author$project$Common$Images$colors.l0);
var $author$project$ContactPersonPage$View$loadingPropeller = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('spinner animateSpinner graySpinner')
		]),
	_List_fromArray(
		[$author$project$Common$Images$lightPropeller]));
var $author$project$ContactPersonPage$View$continueButton = F2(
	function (attributes, content) {
		return A2(
			$elm$html$Html$button,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('greenButton'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'continue-button'),
					attributes)),
			_Utils_ap(
				content,
				_List_fromArray(
					[$author$project$ContactPersonPage$View$loadingPropeller])));
	});
var $author$project$ContactPersonPage$View$continueButtonLoadingAttribute = function (isLoading) {
	return $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('loading', isLoading)
			]));
};
var $author$project$ContactPersonPage$View$injectZeroPrice = function (market) {
	return $author$project$Translations$injectValues(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'price',
				A2($author$project$Types$Market$formatPriceWithSign, market, 0))
			]));
};
var $author$project$ContactPersonPage$View$isContinueButtonLoading = function (_v0) {
	var joinClubOneState = _v0.AE;
	var isLoadingSummary = _v0.Af;
	var isProcessingPayment = _v0.Am;
	return _Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Loading) || (isLoadingSummary || isProcessingPayment);
};
var $author$project$UrlRoute$onClickPreventDefault = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		A2(
			$elm$json$Json$Decode$map,
			function (message) {
				return {Cv: message, r5: true, sZ: false};
			},
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$ContactPersonPage$View$confirmFreeTripButton = F3(
	function (translations, session, model) {
		var market = session.rb;
		var isProcessingPayment = session.Am;
		var isLoading = $author$project$ContactPersonPage$View$isContinueButtonLoading(session);
		var isDisabled = (!A2($author$project$ContactPersonPage$View$canContinue, session, model)) || isLoading;
		var buttonText = isProcessingPayment ? A2($author$project$ContactPersonPage$View$injectZeroPrice, market, translations.w0) : A2($author$project$ContactPersonPage$View$injectZeroPrice, market, translations.w$);
		return A2(
			$author$project$ContactPersonPage$View$continueButton,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(isDisabled),
					$author$project$UrlRoute$onClickPreventDefault(
					$author$project$Messages$RequestedRecaptchaIfNeeded($author$project$Types$Recaptcha$ConfirmFreeTrip)),
					$author$project$ContactPersonPage$View$continueButtonLoadingAttribute(isLoading),
					A2($elm$html$Html$Attributes$attribute, 'data-free-trip', '')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$ContactPersonPage$View$continueToPayText = F3(
	function (translations, market, summary) {
		var priceText = ' (' + (A2($author$project$Types$Market$formatPriceWithSign, market, summary.lN) + ')');
		return _Utils_ap(
			translations.xW,
			(!(!summary.wd)) ? priceText : '');
	});
var $author$project$ContactPersonPage$View$continueWithPaymentButton = F3(
	function (translations, session, model) {
		var maybeSummary = session.B7;
		var isLoading = $author$project$ContactPersonPage$View$isContinueButtonLoading(session);
		var isPriceDisplayed = _Utils_eq(session.AE, $author$project$Types$JoinClubOneState$Joining) && (!isLoading);
		var isDisabled = (!A2($author$project$ContactPersonPage$View$canContinue, session, model)) || isLoading;
		var buttonText = function () {
			var _v0 = _Utils_Tuple2(isPriceDisplayed, maybeSummary);
			if (_v0.a && (!_v0.b.$)) {
				var summary = _v0.b.a;
				return A3($author$project$ContactPersonPage$View$continueToPayText, translations, session.rb, summary);
			} else {
				return translations.xV;
			}
		}();
		return A2(
			$author$project$ContactPersonPage$View$continueButton,
			_List_fromArray(
				[
					$author$project$UrlRoute$onClickPreventDefault(
					$author$project$Messages$ChangedLocation($author$project$UrlRoute$Payment)),
					$elm$html$Html$Attributes$disabled(isDisabled),
					$author$project$ContactPersonPage$View$continueButtonLoadingAttribute(isLoading)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				]));
	});
var $author$project$ContactPersonPage$View$doesPassengerMatchModel = F2(
	function (model, passenger) {
		return A2($author$project$Types$Passenger$areNamesEqualIgnoringCapitalization, model, passenger);
	});
var $author$project$Messages$ContactPersonPageMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$ContactPersonPage$Messages$UpdateEmail = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$Utils$Html$Attributes$autocomplete = function (value) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'autocomplete', value),
			$elm$html$Html$Attributes$name(value)
		]);
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$ContactPersonPage$View$emailInput = F3(
	function (translations, _v0, elements) {
		var email = _v0.yI;
		var isReadOnly = _v0.An;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('formRow emailRow')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('labelTitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.pX)
							])),
						A2(
						$elm$html$Html$input,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('email'),
									$elm$html$Html$Attributes$class('data email'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'inputError',
											!($elm$core$String$isEmpty(email) || $author$project$Types$Validation$Util$isEmailValid(email)))
										])),
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$Messages$ContactPersonPageMsg, $author$project$ContactPersonPage$Messages$UpdateEmail)),
									$elm$html$Html$Attributes$value(email),
									$elm$html$Html$Attributes$maxlength($author$project$Types$Validation$Util$maxEmailLength),
									$elm$html$Html$Attributes$disabled(isReadOnly),
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'email-input')
								]),
							$author$project$Utils$Html$Attributes$autocomplete('email')),
						_List_Nil)
					]),
				elements));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$ContactPersonPage$View$infoMessageBlock = function (infoMessageText) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('infoMessage bodyNorm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(infoMessageText)
			]));
};
var $author$project$ContactPersonPage$View$isFormDataReadOnly = function (_v0) {
	var company = _v0.xA;
	var joinClubOneState = _v0.AE;
	var isAgent = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.tZ;
				},
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			company));
	return isAgent || (_Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Joining) || _Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Loading));
};
var $author$project$ContactPersonPage$Messages$TrimFirstAndLastName = {$: 1};
var $author$project$ContactPersonPage$Messages$UpdateFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$ContactPersonPage$View$isGivenNameValid = function (_v0) {
	var firstName = _v0.y2;
	return $elm$core$String$isEmpty(firstName) || $author$project$Utils$String$isSeawareCharsOnlyAndWithoutUnwantedSymbols(firstName);
};
var $elm$html$Html$Attributes$minlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'minLength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$ContactPersonPage$View$firstNameInput = F2(
	function (translations, model) {
		var firstName = model.y2;
		var isReadOnly = model.An;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('labelTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.wH)
						])),
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('data'),
								$elm$html$Html$Attributes$disabled(isReadOnly),
								$elm$html$Html$Attributes$minlength(1),
								$elm$html$Html$Attributes$maxlength(30),
								$elm$html$Html$Attributes$value(firstName),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Messages$ContactPersonPageMsg, $author$project$ContactPersonPage$Messages$UpdateFirstName)),
								$elm$html$Html$Events$onBlur(
								$author$project$Messages$ContactPersonPageMsg($author$project$ContactPersonPage$Messages$TrimFirstAndLastName)),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'inputError',
										!$author$project$ContactPersonPage$View$isGivenNameValid(model))
									])),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'given-name-input')
							]),
						$author$project$Utils$Html$Attributes$autocomplete('given-name')),
					_List_Nil)
				]));
	});
var $author$project$ContactPersonPage$View$invalidNameError = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('errorMessage bodyNorm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wX)
			]));
};
var $author$project$ContactPersonPage$View$isFamilyNameValid = function (_v0) {
	var lastName = _v0.A6;
	return $elm$core$String$isEmpty(lastName) || $author$project$Utils$String$isSeawareCharsOnlyAndWithoutUnwantedSymbols(lastName);
};
var $author$project$ContactPersonPage$View$isNameValid = function (model) {
	return $author$project$ContactPersonPage$View$isGivenNameValid(model) && $author$project$ContactPersonPage$View$isFamilyNameValid(model);
};
var $author$project$ContactPersonPage$Messages$UpdateLastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$ContactPersonPage$View$lastNameInput = F2(
	function (translations, model) {
		var lastName = model.A6;
		var isReadOnly = model.An;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('labelTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.wO)
						])),
					A2(
					$elm$html$Html$input,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$class('data'),
								$elm$html$Html$Attributes$disabled(isReadOnly),
								$elm$html$Html$Attributes$minlength(1),
								$elm$html$Html$Attributes$maxlength(30),
								$elm$html$Html$Attributes$value(lastName),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Messages$ContactPersonPageMsg, $author$project$ContactPersonPage$Messages$UpdateLastName)),
								$elm$html$Html$Events$onBlur(
								$author$project$Messages$ContactPersonPageMsg($author$project$ContactPersonPage$Messages$TrimFirstAndLastName)),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'inputError',
										!$author$project$ContactPersonPage$View$isFamilyNameValid(model))
									])),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'last-name-input')
							]),
						$author$project$Utils$Html$Attributes$autocomplete('family-name')),
					_List_Nil)
				]));
	});
var $author$project$ContactPersonPage$View$nameInput = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('formRow row2cols firstNameAndLastName')
				]),
			_List_fromArray(
				[
					A2($author$project$ContactPersonPage$View$firstNameInput, translations, model),
					A2($author$project$ContactPersonPage$View$lastNameInput, translations, model),
					(!$author$project$ContactPersonPage$View$isNameValid(model)) ? $author$project$ContactPersonPage$View$invalidNameError(translations) : $elm$html$Html$text('')
				]));
	});
var $author$project$Common$Terms$View$ageTerms = function (translations) {
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		$author$project$Translations$toHtml(translations.w8));
};
var $author$project$Common$Terms$View$generalTerms = F2(
	function (translations, _v0) {
		var joinClubOneState = _v0.AE;
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			$author$project$Translations$toHtml(
				_Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Joining) ? translations.w2 : translations.w3));
	});
var $author$project$Common$Terms$View$euRegulationTerms = function (translations) {
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		$author$project$Translations$toHtml(translations.w1));
};
var $author$project$Common$Terms$View$tallinkGroupTerms = function (translations) {
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		$author$project$Translations$toHtml(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2('name', translations.w4),
						_Utils_Tuple2('url', translations.w5)
					]),
				translations.pU)));
};
var $author$project$Common$Terms$View$tallinkSiljaTerms = function (translations) {
	return A2(
		$elm$html$Html$p,
		_List_Nil,
		$author$project$Translations$toHtml(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2('name', translations.w6),
						_Utils_Tuple2('url', translations.w7)
					]),
				translations.pU)));
};
var $author$project$Common$Terms$View$termsAndConditionsTypeFromSession = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$author$project$Types$Maybe$Util$orElse,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.s9;
				},
				session.Fz),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.s9;
				},
				session.B7)));
};
var $author$project$Common$Terms$View$specialTerms = F2(
	function (translations, session) {
		var _v0 = $author$project$Common$Terms$View$termsAndConditionsTypeFromSession(session);
		switch (_v0) {
			case 1:
				return $author$project$Common$Terms$View$tallinkGroupTerms(translations);
			case 2:
				return $author$project$Common$Terms$View$tallinkSiljaTerms(translations);
			case 3:
				return $author$project$Common$Terms$View$euRegulationTerms(translations);
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Common$Terms$View$paymentTerms = F2(
	function (translations, session) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodySmallNorm terms')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Terms$View$generalTerms, translations, session),
					A2($author$project$Common$Terms$View$specialTerms, translations, session),
					A2(
					$author$project$Utils$String$renderIf,
					!$author$project$Common$Recaptcha$isCompanyCustomer(session),
					$author$project$Common$Terms$View$ageTerms(translations))
				]));
	});
var $author$project$ContactPersonPage$Messages$UpdatePhoneNumber = function (a) {
	return {$: 4, a: a};
};
var $author$project$ContactPersonPage$Messages$GetNewCountryCode = function (a) {
	return {$: 5, a: a};
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Common$Form$countryCodeToOption = F3(
	function (translations, selectedCode, _v0) {
		var code = _v0.pQ;
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$selected(
					_Utils_eq(code, selectedCode)),
					$elm$html$Html$Attributes$value(code)
				]),
			_List_fromArray(
				[
					(code === '+') ? $elm$html$Html$text(translations.x$) : $elm$html$Html$text(code)
				]));
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Common$Form$customSelect = F2(
	function (attributes, options) {
		return A2(
			$elm$html$Html$select,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('formSelect data')
					]),
				attributes),
			options);
	});
var $author$project$Common$Form$countryCodeSelect = F3(
	function (translations, selectedCode, attributes) {
		return A2(
			$author$project$Common$Form$customSelect,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('countryCallingCode'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'country-code-input'),
					attributes)),
			A2(
				$elm$core$List$map,
				A2($author$project$Common$Form$countryCodeToOption, translations, selectedCode),
				$author$project$Types$Phone$infoList));
	});
var $author$project$ContactPersonPage$View$countryCodeInput = F3(
	function (translations, countryCode, isReadOnly) {
		return A3(
			$author$project$Common$Form$countryCodeSelect,
			translations,
			countryCode,
			_List_fromArray(
				[
					$elm$html$Html$Events$onInput(
					A2($elm$core$Basics$composeL, $author$project$Messages$ContactPersonPageMsg, $author$project$ContactPersonPage$Messages$GetNewCountryCode)),
					$elm$html$Html$Attributes$disabled(isReadOnly)
				]));
	});
var $author$project$Common$PhoneNumber$View$view = F5(
	function (translations, currentCountryCode, phoneNumber, isDisabled, msg) {
		var phoneNumberWithoutCountryCode = A2($author$project$ContactPersonPage$Util$removeCountryCode, currentCountryCode, phoneNumber);
		var phoneFieldClass = (currentCountryCode === '+') ? 'fullPhone' : 'phone';
		var isInvalid = (!A2($author$project$Types$Phone$isNumberValid, phoneNumberWithoutCountryCode, currentCountryCode)) && (!$elm$core$String$isEmpty(phoneNumberWithoutCountryCode));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(phoneFieldClass)
				]),
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (phone) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('phoneField')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Utils$String$renderIf,
										currentCountryCode === '+',
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('plus data')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('+')
												]))),
										A2(
										$elm$html$Html$input,
										_Utils_ap(
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('tel'),
													$elm$html$Html$Attributes$class('data'),
													$elm$html$Html$Attributes$minlength(phone.Cx),
													$elm$html$Html$Events$onInput(msg),
													$elm$html$Html$Attributes$value(phoneNumberWithoutCountryCode),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('inputError', isInvalid)
														])),
													$elm$html$Html$Attributes$disabled(isDisabled),
													A2($elm$html$Html$Attributes$attribute, 'data-test', 'phone-input')
												]),
											$author$project$Utils$Html$Attributes$autocomplete('tel')),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bodyNorm inputHint')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(translations.xX + (' ' + phone.EF))
									]))
							]);
					},
					A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.pQ;
							},
							$elm$core$Basics$eq(currentCountryCode)),
						$author$project$Types$Phone$infoList))));
	});
var $author$project$ContactPersonPage$View$phoneNumberInput = F2(
	function (translations, _v0) {
		var phone = _v0.ox;
		var countryCode = _v0.p$;
		var oldPhone = _v0.rE;
		var isClubOne = _v0.my;
		var isReadOnly = _v0.An;
		var phoneNumberWithCountryCode = _Utils_ap(
			countryCode,
			A2($author$project$ContactPersonPage$Util$removeCountryCode, countryCode, phone));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('formRow phoneNumberRow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('labelTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.pY)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('phoneInputGroup clearfix')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Utils$String$renderIf,
							countryCode !== '+',
							A3($author$project$ContactPersonPage$View$countryCodeInput, translations, countryCode, isReadOnly)),
							A5(
							$author$project$Common$PhoneNumber$View$view,
							translations,
							countryCode,
							phone,
							isReadOnly,
							A2($elm$core$Basics$composeL, $author$project$Messages$ContactPersonPageMsg, $author$project$ContactPersonPage$Messages$UpdatePhoneNumber))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					(!_Utils_eq(
						oldPhone,
						$elm$core$Maybe$Just(phoneNumberWithCountryCode))) && isClubOne,
					$author$project$ContactPersonPage$View$infoMessageBlock(translations.x_))
				]));
	});
var $author$project$ContactPersonPage$View$secondaryEmailNotification = F2(
	function (translations, secondaryEmail) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyNorm marginTopSmall')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2('email', secondaryEmail)
							]),
						translations.x0))
				]));
	});
var $author$project$Messages$TurnedOffJoinClubOne = {$: 131};
var $author$project$Messages$TurnedOnJoinClubOne = {$: 130};
var $author$project$Common$Panel$promptTopBorder = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('promptTopBorder'),
			$elm$svg$Svg$Attributes$width('100%'),
			$elm$svg$Svg$Attributes$height('10')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m24 0+8-8+8 8z'),
					$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.ev)
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.ev),
					$elm$svg$Svg$Attributes$height('1'),
					$elm$svg$Svg$Attributes$width('100%')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m23 2.41+9-9+9 9z'),
					$elm$svg$Svg$Attributes$class('promptTopBorderArrowFill')
				]),
			_List_Nil)
		]));
var $author$project$Common$Panel$errorPrompt = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel bodyNorm prompt error'),
				attributes),
			A2($elm$core$List$cons, $author$project$Common$Panel$promptTopBorder, elements));
	});
var $author$project$ContactPersonPage$JoinClubOne$View$contactPersonNotTravellingError = function (translations) {
	return A2(
		$author$project$Common$Panel$errorPrompt,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('marginTopMedium mediumPadding')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.AD)
			]));
};
var $author$project$ContactPersonPage$JoinClubOne$View$description = F2(
	function (translations, isDisabled) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyNorm'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('blocked', isDisabled)
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.AB)
				]));
	});
var $author$project$ContactPersonPage$JoinClubOne$View$isActive = function (response) {
	return _Utils_eq(response, $author$project$Types$JoinClubOneState$Joining) || _Utils_eq(response, $author$project$Types$JoinClubOneState$Loading);
};
var $author$project$ContactPersonPage$JoinClubOne$View$isViewDisabled = F2(
	function (_arguments, model) {
		var market = _arguments.rb;
		var joinClubOneState = _arguments.AE;
		return A2($author$project$ContactPersonPage$Model$isSomeDataEmpty, model, market) || ((!A2($author$project$ContactPersonPage$Model$isAllDataValid, model, market)) || (_Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$Loading) || (_Utils_eq(joinClubOneState, $author$project$Types$JoinClubOneState$UserAlreadyExistsError) || _arguments.Af)));
	});
var $author$project$Common$Panel$prompt = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel bodyNorm prompt'),
				attributes),
			A2($elm$core$List$cons, $author$project$Common$Panel$promptTopBorder, elements));
	});
var $author$project$ContactPersonPage$JoinClubOne$View$discounted = F2(
	function (translations, _v0) {
		var market = _v0.rb;
		var summary = _v0.s4;
		var priceWithoutDiscount = summary.lN + (summary.wd * (-1));
		return function (a) {
			return A2(
				$author$project$Common$Panel$prompt,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginTopMedium mediumPadding')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(a)
					]));
		}(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'priceBefore',
						A2($author$project$Types$Market$formatPriceWithSign, market, priceWithoutDiscount)),
						_Utils_Tuple2(
						'currentPrice',
						A2($author$project$Types$Market$formatPriceWithSign, market, summary.lN))
					]),
				translations.AG));
	});
var $author$project$ContactPersonPage$JoinClubOne$View$minSignificantDiscountInEur = 2;
var $author$project$ContactPersonPage$JoinClubOne$View$minSignificantDiscountInSek = 20;
var $author$project$ContactPersonPage$JoinClubOne$View$hasSignificantDiscount = F2(
	function (_v0, market) {
		var clubOneDiscount = _v0.wd;
		return (market === 4) ? (_Utils_cmp(clubOneDiscount, -$author$project$ContactPersonPage$JoinClubOne$View$minSignificantDiscountInSek) < 0) : (_Utils_cmp(clubOneDiscount, -$author$project$ContactPersonPage$JoinClubOne$View$minSignificantDiscountInEur) < 0);
	});
var $author$project$ContactPersonPage$JoinClubOne$View$welcomeView = function (translations) {
	return A2(
		$author$project$Common$Panel$prompt,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('marginTopMedium mediumPadding')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.AF)
			]));
};
var $author$project$ContactPersonPage$JoinClubOne$View$successView = F2(
	function (translations, _v0) {
		var maybeSummary = _v0.B7;
		var market = _v0.rb;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$ContactPersonPage$JoinClubOne$View$welcomeView(translations),
			A2(
				$elm$core$Maybe$andThen,
				function (summary) {
					return A2($author$project$ContactPersonPage$JoinClubOne$View$hasSignificantDiscount, summary, market) ? $elm$core$Maybe$Just(
						A2(
							$author$project$ContactPersonPage$JoinClubOne$View$discounted,
							translations,
							{rb: market, s4: summary})) : $elm$core$Maybe$Nothing;
				},
				maybeSummary));
	});
var $author$project$ContactPersonPage$JoinClubOne$View$userExistsError = function (translations) {
	return A2(
		$author$project$Common$Panel$errorPrompt,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('marginTopMedium mediumPadding')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.AH)
			]));
};
var $author$project$Common$Images$switcherLine = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('40'),
			$elm$svg$Svg$Attributes$height('20'),
			$elm$svg$Svg$Attributes$viewBox('0 0 40 20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$clipRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M40 10C40 4.47715 35.5228 0 30 0H10C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20H30C35.5228 20 40 15.5228 40 10Z'),
					$elm$svg$Svg$Attributes$fill('#C3CFCF')
				]),
			_List_Nil)
		]));
var $author$project$Common$ToggleSwitch$view = F3(
	function (isActive, msg, attr) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggleSwitch'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('on', isActive),
								_Utils_Tuple2('off', !isActive)
							])),
						$elm$html$Html$Events$onClick(msg)
					]),
				attr),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slider')
						]),
					_List_fromArray(
						[
							$author$project$Common$Images$switcherLine,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('circle')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$ContactPersonPage$JoinClubOne$View$view = F3(
	function (translations, _arguments, model) {
		var joinClubOneState = _arguments.AE;
		var isDisabled = A2($author$project$ContactPersonPage$JoinClubOne$View$isViewDisabled, _arguments, model);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('joinClubOne'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'join-club-one')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('toggleSwitchWithInlineLabel labelTitleNorm'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('blocked', isDisabled)
									]))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Common$ToggleSwitch$view,
								$author$project$ContactPersonPage$JoinClubOne$View$isActive(joinClubOneState),
								isDisabled ? $author$project$Messages$NoOp : ($author$project$ContactPersonPage$JoinClubOne$View$isActive(joinClubOneState) ? $author$project$Messages$TurnedOffJoinClubOne : $author$project$Messages$TurnedOnJoinClubOne),
								_List_fromArray(
									[
										$author$project$ContactPersonPage$JoinClubOne$View$isActive(joinClubOneState) ? A2($elm$html$Html$Attributes$attribute, 'data-test', 'join-club-one-toggle-on') : A2($elm$html$Html$Attributes$attribute, 'data-test', 'join-club-one-toggle-off')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(translations.q4)
									]))
							]))
					]),
				function () {
					switch (joinClubOneState.$) {
						case 0:
							return _List_fromArray(
								[
									A2($author$project$ContactPersonPage$JoinClubOne$View$description, translations, isDisabled)
								]);
						case 1:
							return _List_fromArray(
								[
									A2($author$project$ContactPersonPage$JoinClubOne$View$description, translations, isDisabled),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('spinner'),
											$elm$html$Html$Attributes$class('animateSpinner')
										]),
									_List_fromArray(
										[$author$project$Common$Images$darkPropeller]))
								]);
						case 2:
							return _List_fromArray(
								[
									$author$project$ContactPersonPage$JoinClubOne$View$userExistsError(translations)
								]);
						case 3:
							return _List_fromArray(
								[
									$author$project$ContactPersonPage$JoinClubOne$View$contactPersonNotTravellingError(translations)
								]);
						case 4:
							return _List_fromArray(
								[
									A2($author$project$ContactPersonPage$JoinClubOne$View$description, translations, isDisabled)
								]);
						default:
							return _List_fromArray(
								[
									A2($author$project$ContactPersonPage$JoinClubOne$View$successView, translations, _arguments)
								]);
					}
				}()));
	});
var $author$project$ContactPersonPage$Messages$UpdateZipCode = function (a) {
	return {$: 6, a: a};
};
var $author$project$Common$Form$zipCodeInput = function (attributes) {
	return A2(
		$elm$html$Html$input,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('tel'),
					$elm$html$Html$Attributes$class('data zip'),
					$elm$html$Html$Attributes$minlength($author$project$ContactPersonPage$Util$minZipCodeLength),
					$elm$html$Html$Attributes$maxlength($author$project$ContactPersonPage$Util$maxZipCodeLength),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'zip-input'),
					$elm$html$Html$Attributes$id('zip')
				]),
			_Utils_ap(
				$author$project$Utils$Html$Attributes$autocomplete('postal-code'),
				attributes)),
		_List_Nil);
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Common$Form$zipCodeLabel = function (translations) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labelTitle'),
				$elm$html$Html$Attributes$for('zip')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.AC)
			]));
};
var $author$project$ContactPersonPage$View$zipCodeInput = F2(
	function (translations, _v0) {
		var zip = _v0.jX;
		var oldZip = _v0.rF;
		var isReadOnly = _v0.An;
		var isClubOne = _v0.my;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('formRow zipCodeRow')
				]),
			_List_fromArray(
				[
					$author$project$Common$Form$zipCodeLabel(translations),
					$author$project$Common$Form$zipCodeInput(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'inputError',
									!($elm$core$String$isEmpty(zip) || $author$project$ContactPersonPage$Util$isZipCodeValid(zip)))
								])),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$Messages$ContactPersonPageMsg, $author$project$ContactPersonPage$Messages$UpdateZipCode)),
							$elm$html$Html$Attributes$value(zip),
							$elm$html$Html$Attributes$disabled(isReadOnly)
						])),
					A2(
					$author$project$Utils$String$renderIf,
					(!_Utils_eq(
						oldZip,
						$elm$core$Maybe$Just(zip))) && isClubOne,
					$author$project$ContactPersonPage$View$infoMessageBlock(translations.x_))
				]));
	});
var $author$project$ContactPersonPage$View$contactPersonForm = F3(
	function (translations, session, model) {
		var secondaryEmail = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tZ;
					},
					$elm$core$Maybe$map(
						function ($) {
							return $.Gd;
						})),
				session.xA));
		var matchingPassenger = A2(
			$elm_community$list_extra$List$Extra$find,
			$author$project$ContactPersonPage$View$doesPassengerMatchModel(model),
			$elm$core$Array$toList(session.Eg));
		var oldEmail = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.yI;
				},
				matchingPassenger));
		var isReadOnly = $author$project$ContactPersonPage$View$isFormDataReadOnly(session);
		var isFreeTrip = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.lN;
					},
					$elm$core$Basics$eq(0)),
				session.B7));
		var isClubOne = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pO;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				matchingPassenger));
		var isJoinClubOneDisabled = isClubOne || ($author$project$Update$Passengers$isInSoloYouthMode(session) || (!_Utils_eq(session.xA, $elm$core$Maybe$Nothing)));
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$name('contactPersonForm')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$ContactPersonPage$View$nameInput,
						translations,
						{y2: model.y2, An: isReadOnly, A6: model.A6}),
						A3(
						$author$project$ContactPersonPage$View$emailInput,
						translations,
						{yI: model.yI, An: isReadOnly},
						_List_fromArray(
							[
								(isClubOne && (!_Utils_eq(oldEmail, model.yI))) ? $author$project$ContactPersonPage$View$infoMessageBlock(translations.x_) : $elm$html$Html$text(''),
								(!$elm$core$String$isEmpty(secondaryEmail)) ? A2($author$project$ContactPersonPage$View$secondaryEmailNotification, translations, secondaryEmail) : $elm$html$Html$text('')
							])),
						A2(
						$author$project$ContactPersonPage$View$phoneNumberInput,
						translations,
						{
							p$: model.p$,
							my: isClubOne,
							An: isReadOnly,
							rE: A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.ox;
								},
								matchingPassenger),
							ox: model.ox
						}),
						A2(
						$author$project$Utils$String$renderIf,
						session.rb === 4,
						A2(
							$author$project$ContactPersonPage$View$zipCodeInput,
							translations,
							{
								my: isClubOne,
								An: isReadOnly,
								rF: A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.jX;
									},
									matchingPassenger),
								jX: model.jX
							})),
						A2(
						$author$project$Utils$String$renderIf,
						!isJoinClubOneDisabled,
						A3($author$project$ContactPersonPage$JoinClubOne$View$view, translations, session, model))
					]),
				isFreeTrip ? _List_fromArray(
					[
						A2($author$project$Common$Terms$View$paymentTerms, translations, session),
						A3($author$project$ContactPersonPage$View$confirmFreeTripButton, translations, session, model)
					]) : _List_fromArray(
					[
						A3($author$project$ContactPersonPage$View$continueWithPaymentButton, translations, session, model)
					])));
	});
var $author$project$ContactPersonPage$View$header = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('headerHolder')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('backButton'),
										$elm$html$Html$Events$onClick(
										$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/icon_back_arrow.svg')
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(translations.xY)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cell bodyNorm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.xZ)
							]))
					]))
			]));
};
var $author$project$ContactPersonPage$View$view = F3(
	function (translate, session, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('contactPersonPage page')
				]),
			_List_fromArray(
				[
					$author$project$ContactPersonPage$View$header(translate),
					A3($author$project$ContactPersonPage$View$contactPersonForm, translate, session, model)
				]));
	});
var $author$project$ExtraServicesPage$View$canBePriorityCar = function (carCategory) {
	return A2(
		$elm$core$List$all,
		$elm$core$Basics$neq(carCategory),
		_List_fromArray(
			[4, 5, 0]));
};
var $author$project$Messages$ToggledOutwardExtraServices = function (a) {
	return {$: 108, a: a};
};
var $author$project$Messages$ToggledReturnExtraServices = function (a) {
	return {$: 109, a: a};
};
var $author$project$ExtraServicesPage$View$disabledButton = function (_v0) {
	var model = _v0.eM;
	var isIncluded = _v0.kz;
	return _List_fromArray(
		[
			A2(
			$author$project$Common$Button$outline,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					$author$project$Common$Button$text(
					$elm$core$String$toUpper(
						A2(
							$author$project$Translations$t,
							model.A_,
							isIncluded ? function ($) {
								return $.wL;
							} : function ($) {
								return $.wY;
							})))
				]))
		]);
};
var $author$project$Types$ExtraService$isForVehicles = function (code) {
	return $author$project$Types$ExtraService$isGarage(code) || ($author$project$Types$ExtraService$isPriorityCar(code) || ($author$project$Types$ExtraService$isPriorityCarPL(code) || $author$project$Types$ExtraService$isPriorityCarFC(code)));
};
var $author$project$ExtraServicesPage$View$translateAddButtonText = function (_v0) {
	var isPricePerPerson = _v0.nW;
	var isPlural = _v0.nU;
	var _v1 = _Utils_Tuple2(isPricePerPerson, isPlural);
	if (_v1.a) {
		if (!_v1.b) {
			return function ($) {
				return $.r0;
			};
		} else {
			return function ($) {
				return $.EA;
			};
		}
	} else {
		if (!_v1.b) {
			return function ($) {
				return $.pV;
			};
		} else {
			return function ($) {
				return $.xz;
			};
		}
	}
};
var $author$project$ExtraServicesPage$View$buttonText = function (_v0) {
	var language = _v0.A_;
	var extraServiceCode = _v0.ls;
	var passengersCount = _v0.lL;
	var vehiclesCount = _v0.Ik;
	return $author$project$Common$Button$text(
		function (_v1) {
			var translation = _v1.a;
			var count = _v1.b;
			return $elm$core$String$fromInt(count) + (' ' + translation);
		}(
			A2(
				$elm$core$Tuple$mapFirst,
				function (a) {
					return $elm$core$String$toLower(
						A2(
							$author$project$Translations$t,
							language,
							$author$project$ExtraServicesPage$View$translateAddButtonText(a)));
				},
				$author$project$Types$ExtraService$isForVehicles(extraServiceCode) ? _Utils_Tuple2(
					{nU: vehiclesCount > 1, nW: false},
					vehiclesCount) : _Utils_Tuple2(
					{nU: passengersCount > 1, nW: true},
					passengersCount))));
};
var $author$project$ExtraServicesPage$View$extraServiceButton = function (_v0) {
	var model = _v0.eM;
	var message = _v0.Cv;
	var isSelected = _v0.lx;
	return _List_fromArray(
		[
			A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Button$outline,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							message(model.jK.pQ)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Common$Button$activeState, isSelected)
								])),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'add-extra-service-button')
						]),
					_List_fromArray(
						[
							$author$project$ExtraServicesPage$View$buttonText(
							{ls: model.jK.pQ, A_: model.A_, lL: model.lL, Ik: model.Ik}),
							$author$project$Common$Button$toggleableTickMark(isSelected)
						]))
				]))
		]);
};
var $author$project$Types$ExtraService$isInsurance = function (_v0) {
	var code = _v0;
	return (code === 'INSURANCE') || A2($elm$core$String$contains, 'CANCEL COVER', code);
};
var $author$project$ExtraServicesPage$View$getOneOrTwoWayClass = F2(
	function (isOneWay, extraServiceCode) {
		return (isOneWay || $author$project$Types$ExtraService$isInsurance(extraServiceCode)) ? 'oneWay' : 'twoWay';
	});
var $author$project$ExtraServicesPage$View$isExtraServiceAvailable = function (buttonArguments) {
	return buttonArguments.kV && (!buttonArguments.kz);
};
var $author$project$ExtraServicesPage$View$priceView = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	var price = _v0.lN;
	var extraServiceCode = _v0.ls;
	var translateSubject = $author$project$Types$ExtraService$isInsurance(extraServiceCode) ? A2(
		$author$project$Translations$t,
		language,
		function ($) {
			return $.xI;
		}) : ($author$project$Types$ExtraService$isForVehicles(extraServiceCode) ? A2(
		$author$project$Translations$t,
		language,
		function ($) {
			return $.pV;
		}) : A2(
		$author$project$Translations$t,
		language,
		function ($) {
			return $.r0;
		}));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('textAlignCenter')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Types$Market$formatPriceWithSign, market, price))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodySmallBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						' / ' + $elm$core$String$toLower(translateSubject))
					]))
			]));
};
var $author$project$ExtraServicesPage$View$route = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('textAlignCenter title2')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Types$Port$toString(from) + (' - ' + $author$project$Types$Port$toString(to)))
			]));
};
var $author$project$ExtraServicesPage$View$oneWayExtraServiceButton = function (outwardButtonProps) {
	var model = outwardButtonProps.eM;
	var price = $author$project$ExtraServicesPage$View$priceView(
		{
			ls: model.jK.pQ,
			A_: model.A_,
			rb: model.rb,
			lN: A2($elm$core$Maybe$withDefault, 0, model.jK.Dx)
		});
	return _List_fromArray(
		[
			A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							$author$project$ExtraServicesPage$View$route(
							{kS: model.kS, le: model.le})
						]))
				])),
			A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('price')
				]),
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							$author$project$ExtraServicesPage$View$isExtraServiceAvailable(outwardButtonProps) ? price : $elm$html$Html$text('')
						]))
				])),
			A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					(outwardButtonProps.kV && (!outwardButtonProps.kz)) ? $author$project$ExtraServicesPage$View$extraServiceButton(outwardButtonProps) : $author$project$ExtraServicesPage$View$disabledButton(outwardButtonProps))
				]))
		]);
};
var $author$project$ExtraServicesPage$View$twoWayExtraServiceButtons = function (_v0) {
	var model = _v0.eM;
	var outwardButtonProps = _v0.rN;
	var returnButtonProps = _v0.ss;
	var price = function (pr) {
		return $author$project$ExtraServicesPage$View$priceView(
			{ls: model.jK.pQ, A_: model.A_, rb: model.rb, lN: pr});
	};
	return _List_fromArray(
		[
			A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							$author$project$ExtraServicesPage$View$route(
							{kS: model.kS, le: model.le})
						])),
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							$author$project$ExtraServicesPage$View$route(
							{kS: model.le, le: model.kS})
						]))
				])),
			A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('price')
				]),
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							A2(
							$author$project$Utils$Html$Render$renderIf,
							$author$project$ExtraServicesPage$View$isExtraServiceAvailable(outwardButtonProps),
							A2($author$project$Utils$Html$Render$maybeRender, price, model.jK.Dx))
						])),
					$author$project$Common$Panel$column(
					_List_fromArray(
						[
							A2(
							$author$project$Utils$Html$Render$renderIf,
							$author$project$ExtraServicesPage$View$isExtraServiceAvailable(returnButtonProps),
							A2($author$project$Utils$Html$Render$maybeRender, price, model.jK.FQ))
						]))
				])),
			A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Common$Panel$column(
					$author$project$ExtraServicesPage$View$isExtraServiceAvailable(outwardButtonProps) ? $author$project$ExtraServicesPage$View$extraServiceButton(outwardButtonProps) : $author$project$ExtraServicesPage$View$disabledButton(outwardButtonProps)),
					$author$project$Common$Panel$column(
					$author$project$ExtraServicesPage$View$isExtraServiceAvailable(returnButtonProps) ? $author$project$ExtraServicesPage$View$extraServiceButton(returnButtonProps) : $author$project$ExtraServicesPage$View$disabledButton(returnButtonProps))
				]))
		]);
};
var $author$project$ExtraServicesPage$View$extraServiceCard = function (model) {
	var isOneWay = model.qW;
	var extraService = model.jK;
	var selectedServices = model.oT;
	var user = model.Ia;
	var language = model.A_;
	var returnButtonProps = function (isSelected) {
		return {kV: extraService.Aq, kz: false, lx: isSelected, Cv: $author$project$Messages$ToggledReturnExtraServices, eM: model};
	};
	var outwardButtonProps = function (isSelected) {
		return {kV: extraService.nS, kz: false, lx: isSelected, Cv: $author$project$Messages$ToggledOutwardExtraServices, eM: model};
	};
	var oneOrTwoWayClass = A2($author$project$ExtraServicesPage$View$getOneOrTwoWayClass, isOneWay, extraService.pQ);
	var isReturnSelected = A2($author$project$Types$SelectedExtraServices$isSelected, extraService.pQ, selectedServices.FV);
	var isOutwardSelected = A2($author$project$Types$SelectedExtraServices$isSelected, extraService.pQ, selectedServices.DC);
	var insuranceButton = function () {
		var isCancelCoverIncluded = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq('CANCEL COVER 0'),
			$author$project$Types$SelectedExtraServices$toStringList(selectedServices.DC));
		var props = {
			kV: extraService.nS,
			kz: isCancelCoverIncluded,
			lx: A2($author$project$Types$SelectedExtraServices$isSelected, extraService.pQ, selectedServices.DC),
			Cv: $author$project$Messages$ToggledOutwardExtraServices,
			eM: model
		};
		return (extraService.nS && (!isCancelCoverIncluded)) ? $author$project$ExtraServicesPage$View$extraServiceButton(props) : $author$project$ExtraServicesPage$View$disabledButton(props);
	}();
	return A2(
		$author$project$Common$Panel$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('extraServiceCard marginHorizontalSmall marginTopSmall ' + oneOrTwoWayClass),
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-test-extra-service-code',
				$author$project$Types$ExtraService$codeToString(extraService.pQ))
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				A2(
					$author$project$Common$Panel$element,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('extraServiceTitle')
						]),
					_List_fromArray(
						[
							$author$project$Common$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text(extraService.oh)
								]))
						])),
				A2(
					$elm$core$Maybe$map,
					function (imageUrl) {
						return A2(
							$author$project$Common$Panel$imageHeader,
							imageUrl,
							_List_fromArray(
								[
									$author$project$Common$Panel$imageHeaderTitle(extraService.oh)
								]));
					},
					extraService.zP)),
				$author$project$Common$Panel$block(
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$author$project$Utils$Html$Render$renderIf,
							$author$project$Types$ExtraService$isInsurance(extraService.pQ),
							A2(
								$author$project$Common$Panel$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('insuranceLabel bodyBold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Translations$t,
													language,
													function ($) {
														return $.uQ;
													}))
											]))
									]))),
							A2(
							$author$project$Common$Panel$row,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm')
								]),
							_List_fromArray(
								[
									$author$project$Common$Panel$column(
									$author$project$Translations$toHtml(extraService.nt))
								])),
							$author$project$Common$Panel$graySeparator(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginBottomMedium')
								]))
						]),
					$author$project$Types$ExtraService$isInsurance(extraService.pQ) ? insuranceButton : (isOneWay ? $author$project$ExtraServicesPage$View$oneWayExtraServiceButton(
						outwardButtonProps(isOutwardSelected)) : $author$project$ExtraServicesPage$View$twoWayExtraServiceButtons(
						{
							eM: model,
							rN: outwardButtonProps(isOutwardSelected),
							ss: returnButtonProps(isReturnSelected)
						}))))
			]));
};
var $author$project$ExtraServicesPage$View$headerView = function (language) {
	return A2(
		$elm$html$Html$header,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('headerSmall')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.uP;
											}))
									]))
							]))
					]))
			]));
};
var $author$project$ExtraServicesPage$View$isAllowedToGarage = function (carCategory) {
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$eq(carCategory),
		_List_fromArray(
			[1, 11, 3, 2]));
};
var $author$project$ExtraServicesPage$View$view = function (session) {
	var _v0 = session;
	var extraServices = _v0.qk;
	var selectedExtraServices = _v0.Gi;
	var isOneWay = _v0.qW;
	var from = _v0.kS;
	var to = _v0.le;
	var market = _v0.rb;
	var maybeSelectedVehicles = _v0.rp;
	var passengers = _v0.Eg;
	var user = _v0.Ia;
	var language = _v0.A_;
	var amountOfPlatinumPassengers = $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(
					p.pO,
					$elm$core$Maybe$Just(4));
			},
			$elm$core$Array$toList(passengers)));
	var vehiclesCount = function (code) {
		return function (list) {
			return $author$project$Types$ExtraService$isGarage(code) ? A2(
				$elm_community$list_extra$List$Extra$count,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jZ;
					},
					$author$project$ExtraServicesPage$View$isAllowedToGarage),
				list) : ($author$project$Types$ExtraService$isPriorityCar(code) ? (A2(
				$elm_community$list_extra$List$Extra$count,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jZ;
					},
					$author$project$ExtraServicesPage$View$canBePriorityCar),
				list) - amountOfPlatinumPassengers) : ($author$project$Types$ExtraService$isPriorityCarPL(code) ? A2(
				$elm$core$Basics$min,
				A2(
					$elm_community$list_extra$List$Extra$count,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jZ;
						},
						$author$project$ExtraServicesPage$View$canBePriorityCar),
					list),
				amountOfPlatinumPassengers) : ($author$project$Types$ExtraService$isPriorityCarFC(code) ? A2(
				$elm_community$list_extra$List$Extra$count,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jZ;
					},
					$author$project$ExtraServicesPage$View$canBePriorityCar),
				list) : 0)));
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, maybeSelectedVehicles)));
	};
	var model = function (extraService) {
		return {
			jK: extraService,
			kS: from,
			qW: isOneWay,
			A_: language,
			rb: market,
			lL: $elm$core$Array$length(passengers),
			oT: selectedExtraServices,
			le: to,
			Ia: user,
			Ik: vehiclesCount(extraService.pQ)
		};
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('extraServicesPage page withFixedButton'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-extra-services-page', '')
			]),
		_List_fromArray(
			[
				$author$project$ExtraServicesPage$View$headerView(language),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('extraServices')
					]),
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, model, $author$project$ExtraServicesPage$View$extraServiceCard),
					extraServices))
			]));
};
var $author$project$LandServicePage$View$header = function (language) {
	var titleCellRow = function (content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title2')
								]),
							content)
						]))
				]));
	};
	return A2(
		$elm$html$Html$header,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('headerSmall marginBottomMedium')
			]),
		_List_fromArray(
			[
				titleCellRow(
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.yO;
							}))
					]))
			]));
};
var $author$project$LandServicePage$Messages$ToggleEventDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$Time$Format$monthNumberDayWeekdayHourMinute = function (locale) {
	return _Utils_ap(
		$author$project$Utils$Time$Format$monthNumberDayWeekday(locale),
		_Utils_ap(
			function () {
				var _v0 = _Utils_Tuple2(locale.A_, locale.rb);
				switch (_v0.a) {
					case 6:
						var _v1 = _v0.a;
						return _List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$text('')
							]);
					case 7:
						var _v2 = _v0.a;
						return _List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$text(', ')
							]);
					default:
						switch (_v0.b) {
							case 5:
								var _v3 = _v0.b;
								return _List_fromArray(
									[
										$ryan_haskell$date_format$DateFormat$text(', ')
									]);
							case 6:
								var _v4 = _v0.b;
								return _List_fromArray(
									[
										$ryan_haskell$date_format$DateFormat$text(', ')
									]);
							default:
								return _List_fromArray(
									[
										$ryan_haskell$date_format$DateFormat$text(' ')
									]);
						}
				}
			}(),
			$author$project$Utils$Time$Format$hourMinute));
};
var $author$project$LandServicePage$Event$locationAndTimeView = F2(
	function (session, time) {
		var language = session.A_;
		var market = session.rb;
		var formatTime = A2(
			$author$project$Utils$Time$Format$format,
			A2($author$project$Types$Locale$Locale, language, market),
			$author$project$Utils$Time$Format$monthNumberDayWeekdayHourMinute);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center bodyBold marginBottomSmall')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(
								A2(
									$author$project$Translations$t,
									language,
									$author$project$Types$Port$translate(session.le))))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							formatTime(time))
						]))
				]));
	});
var $author$project$LandServicePage$Event$soldOutView = F2(
	function (language, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('buttonTextBorderGrey')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.H1;
						}))
				]));
	});
var $author$project$LandServicePage$Messages$ToggledTicketGroupVisibility = function (a) {
	return {$: 2, a: a};
};
var $author$project$LandServicePage$Messages$AddedTicket = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandServicePage$Messages$RemovedTicket = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandServicePage$Ticket$buttonContent = F2(
	function (language, count) {
		return (count < 1) ? $elm$html$Html$text(
			$elm$core$String$toUpper(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.tJ;
					}))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(count))
				]));
	});
var $author$project$LandServicePage$Ticket$buttonView = F2(
	function (session, ticket) {
		var language = session.A_;
		var selectedLandService = A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$author$project$Types$Ticket$areTicketsEqual(ticket)),
			session.Gl);
		var count = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$Tuple$first, selectedLandService));
		return A2(
			$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
			{
				pZ: count,
				nw: false,
				nQ: true,
				q_: false,
				kZ: $elm$core$Maybe$Just($author$project$Types$LandService$maxTicketCount),
				rx: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$LandServicePage$Messages$RemovedTicket(ticket))
					]),
				oz: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$LandServicePage$Messages$AddedTicket(ticket))
					])
			},
			_List_fromArray(
				[
					A2($author$project$LandServicePage$Ticket$buttonContent, session.A_, count)
				]));
	});
var $author$project$Types$Ticket$ageRangeToString = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	return $elm$core$String$fromInt(from) + ('-' + $elm$core$String$fromInt(to));
};
var $author$project$LandServicePage$Ticket$ticketName = F2(
	function (language, ticket) {
		var label = _Utils_eq(ticket.m4.b, $author$project$Utils$Range$infinity) ? A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.xN;
			}) : A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'range',
					$author$project$Types$Ticket$ageRangeToString(ticket.m4))
				]),
			A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.xO;
				}));
		var isFullRange = _Utils_eq(
			ticket.m4,
			_Utils_Tuple2(0, $author$project$Utils$Range$infinity));
		var _v0 = ticket.oh;
		if (!_v0.$) {
			var name = _v0.a;
			return isFullRange ? $author$project$Translations$toHtml(name) : A2(
				$elm$core$List$cons,
				$elm$html$Html$text(label + ', '),
				$author$project$Translations$toHtml(name));
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text(label)
				]);
		}
	});
var $author$project$Session$isClubOneUser = function (_v0) {
	var client = _v0.v4;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.BP;
				},
				$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
			$krisajenkins$remotedata$RemoteData$toMaybe(client)));
};
var $author$project$LandServicePage$Ticket$ticketPrice = F2(
	function (session, ticket) {
		var price = $author$project$Session$isClubOneUser(session.Ia) ? ticket.wc : ticket.lN;
		return $elm$html$Html$text(
			A2($author$project$Types$Market$formatPriceWithSign, session.rb, price));
	});
var $author$project$LandServicePage$Ticket$view = F2(
	function (session, ticket) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ticket')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textAlignCenter marginBottomSmall bodyLarge')
						]),
					A2($author$project$LandServicePage$Ticket$ticketName, session.A_, ticket)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textAlignCenter marginBottomSmall bodyBold')
						]),
					_List_fromArray(
						[
							A2($author$project$LandServicePage$Ticket$ticketPrice, session, ticket)
						])),
					A2($author$project$LandServicePage$Ticket$buttonView, session, ticket)
				]));
	});
var $author$project$LandServicePage$TicketGroup$ticketGroupView = F2(
	function (session, _v0) {
		var title = _v0.HI;
		var tickets = _v0.Hv;
		var id = _v0.zN;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('accordion'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'opened',
							_Utils_eq(
								session.BX,
								$elm$core$Maybe$Just(id)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('accordionHeader bodyLargeBold'),
							$elm$html$Html$Events$onClick(
							$author$project$LandServicePage$Messages$ToggledTicketGroupVisibility(id))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('accordionArrow')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('accordionContent')
						]),
					A2(
						$elm$core$List$map,
						$author$project$LandServicePage$Ticket$view(session),
						tickets))
				]));
	});
var $author$project$LandServicePage$TicketGroup$ticketsWithoutGroupView = F2(
	function (session, tickets) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('accordion opened')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('accordionContent')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Common$Panel$graySeparator(_List_Nil)
							]),
						A2(
							$elm$core$List$map,
							$author$project$LandServicePage$Ticket$view(session),
							tickets)))
				]));
	});
var $author$project$LandServicePage$Event$ticketsView = F2(
	function (session, _v0) {
		var ticketGroups = _v0.Hu;
		var ticketsWithoutGroup = _v0.Hw;
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$LandServicePage$TicketGroup$ticketGroupView(session),
				ticketGroups),
			_List_fromArray(
				[
					A2(
					$author$project$Utils$Html$Render$renderIf,
					$elm$core$List$length(ticketsWithoutGroup) > 0,
					A2($author$project$LandServicePage$TicketGroup$ticketsWithoutGroupView, session, ticketsWithoutGroup))
				]));
	});
var $author$project$LandServicePage$Event$view = F2(
	function (session, event) {
		var language = session.A_;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Utils$Html$Render$maybeRender,
					$author$project$LandServicePage$Event$locationAndTimeView(session),
					event.o5),
				event.zp ? A2($author$project$LandServicePage$Event$ticketsView, session, event) : _List_fromArray(
					[
						A2($author$project$LandServicePage$Event$soldOutView, language, event)
					])));
	});
var $author$project$LandServicePage$View$eventsView = F2(
	function (session, events) {
		return A2(
			$elm$core$List$intersperse,
			$author$project$Common$Panel$graySeparator(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginTopMedium marginBottomMedium')
					])),
			$author$project$Utils$OneOrMore$toList(
				A2(
					$author$project$Utils$OneOrMore$map,
					$author$project$LandServicePage$Event$view(session),
					events)));
	});
var $author$project$LandServicePage$View$panel = F2(
	function (session, service) {
		var headerWithoutImage = $author$project$Common$Panel$header(
			_List_fromArray(
				[
					$author$project$Common$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text(service.HI)
						]))
				]));
		var headerWithImage = function (url) {
			return A2(
				$author$project$Common$Panel$imageHeader,
				url,
				_List_fromArray(
					[
						$author$project$Common$Panel$imageHeaderTitle(service.HI)
					]));
		};
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginHorizontalSmall landServicePanel')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2($author$project$Utils$Html$Render$maybeRender, headerWithImage, service.zP),
						$author$project$Common$Panel$block(
						_List_fromArray(
							[
								A2(
								$author$project$Utils$Html$Render$renderIf,
								_Utils_eq(service.zP, $elm$core$Maybe$Nothing),
								headerWithoutImage),
								A2(
								$author$project$Common$Panel$expander,
								{
									yT: $author$project$LandServicePage$Messages$ToggleEventDescription(service.zN),
									yX: _List_Nil,
									z9: _Utils_eq(
										$elm$core$Maybe$Just(service.zN),
										session.BW),
									A_: session.A_
								},
								$author$project$Translations$toHtml(service.nt))
							]))
					]),
				A2($author$project$LandServicePage$View$eventsView, session, service.mq)));
	});
var $author$project$Types$LandService$filterTicketsFromGroup = F2(
	function (predicate, group) {
		return function (g) {
			return $elm$core$List$isEmpty(g.Hv) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(g);
		}(
			_Utils_update(
				group,
				{
					Hv: A2($elm$core$List$filter, predicate, group.Hv)
				}));
	});
var $author$project$Types$LandService$filterTicketsFromEvent = F2(
	function (predicate, event) {
		return function (e) {
			return ($elm$core$List$isEmpty(e.Hu) && $elm$core$List$isEmpty(e.Hw)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(e);
		}(
			_Utils_update(
				event,
				{
					Hu: A2(
						$elm$core$List$filterMap,
						$author$project$Types$LandService$filterTicketsFromGroup(predicate),
						event.Hu),
					Hw: A2($elm$core$List$filter, predicate, event.Hw)
				}));
	});
var $author$project$LandServicePage$Util$removeLandServiceWithRequiredHotel = function (landService) {
	var events = A2(
		$elm$core$List$filterMap,
		$author$project$Types$LandService$filterTicketsFromEvent(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Gj;
				},
				$elm$core$Basics$not)),
		$author$project$Utils$OneOrMore$toList(landService.mq));
	return A2(
		$elm$core$Maybe$map,
		function (e) {
			return _Utils_update(
				landService,
				{mq: e});
		},
		$author$project$Utils$OneOrMore$fromList(events));
};
var $author$project$Types$AgeCategory$toAgeRange = function (category) {
	switch (category) {
		case 0:
			return _Utils_Tuple2(
				18,
				$elm$core$Basics$floor(1 / 0));
		case 1:
			return _Utils_Tuple2(12, 17);
		case 2:
			return _Utils_Tuple2(0, 5);
		default:
			return _Utils_Tuple2(6, 11);
	}
};
var $author$project$Types$Passenger$getAgeRange = F2(
	function (departureTime, passenger) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$AgeCategory$toAgeRange(passenger.tY),
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (a, b) {
						return function (age) {
							return _Utils_Tuple2(age, age);
						}(
							A2($author$project$Utils$Time$differenceOfDatesInYears, a, b));
					}),
				departureTime,
				A2($elm$core$Maybe$map, $author$project$Types$Date$toPosix, passenger.uw)));
	});
var $author$project$Utils$Range$isIntersecting = F2(
	function (_v0, _v1) {
		var startA = _v0.a;
		var endA = _v0.b;
		var startB = _v1.a;
		var endB = _v1.b;
		return (_Utils_cmp(startA, endB) < 1) && (_Utils_cmp(startB, endA) < 1);
	});
var $author$project$LandServicePage$Util$removeUnavailableTicketsFromService = F2(
	function (session, service) {
		var departureTime = A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
			$author$project$Types$Trips$statusToMaybe(session.tp));
		var isAnyPassengerInAgeRange = function (range) {
			return A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Utils$Range$isIntersecting(range),
					$author$project$Types$Passenger$getAgeRange(departureTime)),
				$elm$core$Array$toList(session.Eg));
		};
		return A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_update(
					service,
					{mq: a});
			},
			$author$project$Utils$OneOrMore$fromList(
				A2(
					$elm$core$List$filterMap,
					$author$project$Types$LandService$filterTicketsFromEvent(
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.m4;
							},
							isAnyPassengerInAgeRange)),
					$author$project$Utils$OneOrMore$toList(service.mq))));
	});
var $author$project$LandServicePage$Util$removeUnavailableLandServices = F2(
	function (session, landServices) {
		return A2(
			$elm$core$List$filterMap,
			$author$project$LandServicePage$Util$removeUnavailableTicketsFromService(session),
			A2(
				$elm$core$List$filterMap,
				$author$project$Types$Hotel$hasSelections(session.Gk) ? $elm$core$Maybe$Just : $author$project$LandServicePage$Util$removeLandServiceWithRequiredHotel,
				landServices));
	});
var $author$project$LandServicePage$View$view = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page withFixedButton')
			]),
		A2(
			$elm$core$List$cons,
			$author$project$LandServicePage$View$header(session.A_),
			A2(
				$elm$core$List$map,
				$author$project$LandServicePage$View$panel(session),
				A2(
					$author$project$LandServicePage$Util$removeUnavailableLandServices,
					session,
					A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, session.AZ)))));
};
var $author$project$Page$Booking$crabBanner = F2(
	function (translations, session) {
		var crabVoyageType = function () {
			var _v0 = _Utils_Tuple2(session.tx, session.qW);
			_v0$3:
			while (true) {
				if (!_v0.b) {
					if (_v0.a.$ === 2) {
						var _v2 = _v0.a;
						return $elm$core$Maybe$Just('ROUND_TRIP');
					} else {
						break _v0$3;
					}
				} else {
					switch (_v0.a.$) {
						case 2:
							var _v1 = _v0.a;
							return $elm$core$Maybe$Just('ONE_WAY');
						case 6:
							if (_v0.a.a === 1) {
								var _v3 = _v0.a.a;
								return $elm$core$Maybe$Just('SHOPPING_CRUISE');
							} else {
								break _v0$3;
							}
						default:
							break _v0$3;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var crabLink = A3(
			$elm$url$Url$Builder$crossOrigin,
			session.zM.Gs.x7,
			_List_Nil,
			A3(
				$author$project$Utils$List$maybeAddWithMap,
				crabVoyageType,
				$elm$url$Url$Builder$string('voyageType'),
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'locale',
						$author$project$Types$Language$toString(session.A_)),
						A2(
						$elm$url$Url$Builder$string,
						'country',
						$author$project$Types$Market$toString(session.rb)),
						A2(
						$elm$url$Url$Builder$string,
						'from',
						$author$project$Types$Port$toString(session.kS)),
						A2(
						$elm$url$Url$Builder$string,
						'to',
						$author$project$Types$Port$toString(session.le))
					])));
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('crabBanner'),
					$elm$html$Html$Attributes$href(crabLink),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/images/common/idea.svg')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					$author$project$Translations$toHtml(translations.x8)),
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/images/common/arrow_wide.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$BookingPage$Panel$Hotel$View$titleView = F3(
	function (extraEditLinkClass, language, key) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sectionTitle title2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.zv;
								}))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('editLink ' + extraEditLinkClass)
						]),
					$author$project$Translations$toHtml(
						A2($author$project$Translations$t, language, key)))
				]));
	});
var $author$project$BookingPage$Panel$Hotel$View$view = F3(
	function (_v0, attributes, elements) {
		var language = _v0.A_;
		var hotelsAndCities = _v0.zI;
		var maybeSummary = _v0.B7;
		var isLoadingHotelsAndCities = _v0.Ac;
		var isDisabled = isLoadingHotelsAndCities || $elm$core$List$isEmpty(hotelsAndCities.zH);
		return A2(
			$author$project$Common$Panel$view,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mediumPadding'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('disabled', isDisabled)
							])),
						A2($elm$html$Html$Attributes$attribute, 'view', 'hotel'),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'hotel-panel'),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$ChangedLocation($author$project$UrlRoute$HotelList))
					]),
				attributes),
			elements);
	});
var $author$project$BookingPage$Panel$Hotel$View$emptyView = function (session) {
	var language = session.A_;
	return A3(
		$author$project$BookingPage$Panel$Hotel$View$view,
		session,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$BookingPage$Panel$Hotel$View$titleView,
				'dark',
				language,
				function ($) {
					return $.vW;
				})
			]));
};
var $author$project$Messages$ClickedOnItinerary = function (a) {
	return {$: 44, a: a};
};
var $author$project$Utils$Route$translateTripType = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var cruiseTripType = _v0.mm;
	var _v1 = _Utils_Tuple3(from, to, voyageType);
	_v1$24:
	while (true) {
		switch (_v1.c.$) {
			case 0:
				switch (_v1.a) {
					case 4:
						switch (_v1.b) {
							case 2:
								var _v14 = _v1.a;
								var _v15 = _v1.b;
								var _v16 = _v1.c;
								return function ($) {
									return $.ya;
								};
							case 1:
								var _v17 = _v1.a;
								var _v18 = _v1.b;
								var _v19 = _v1.c;
								return function ($) {
									return $.gQ;
								};
							default:
								break _v1$24;
						}
					case 1:
						switch (_v1.b) {
							case 2:
								var _v20 = _v1.a;
								var _v21 = _v1.b;
								var _v22 = _v1.c;
								return function ($) {
									return $.dA;
								};
							case 15:
								var _v23 = _v1.a;
								var _v24 = _v1.b;
								var _v25 = _v1.c;
								if (cruiseTripType === 2) {
									return function ($) {
										return $.uj;
									};
								} else {
									return function ($) {
										return $.IA;
									};
								}
							case 4:
								var _v27 = _v1.a;
								var _v28 = _v1.b;
								var _v29 = _v1.c;
								return function ($) {
									return $.dB;
								};
							case 0:
								var _v30 = _v1.a;
								var _v31 = _v1.b;
								var _v32 = _v1.c;
								return function ($) {
									return $.no;
								};
							case 5:
								var _v33 = _v1.a;
								var _v34 = _v1.b;
								var _v35 = _v1.c;
								return function ($) {
									return $.gR;
								};
							case 6:
								var _v36 = _v1.a;
								var _v37 = _v1.b;
								var _v38 = _v1.c;
								return function ($) {
									return $.yb;
								};
							default:
								break _v1$24;
						}
					case 5:
						switch (_v1.b) {
							case 13:
								var _v54 = _v1.a;
								var _v55 = _v1.b;
								var _v56 = _v1.c;
								return function ($) {
									return $.gV;
								};
							case 1:
								var _v57 = _v1.a;
								var _v58 = _v1.b;
								var _v59 = _v1.c;
								return function ($) {
									return $.gW;
								};
							case 0:
								var _v60 = _v1.a;
								var _v61 = _v1.b;
								var _v62 = _v1.c;
								return function ($) {
									return $.no;
								};
							default:
								break _v1$24;
						}
					case 2:
						switch (_v1.b) {
							case 4:
								var _v2 = _v1.a;
								var _v3 = _v1.b;
								var _v4 = _v1.c;
								return function ($) {
									return $.dB;
								};
							case 1:
								var _v5 = _v1.a;
								var _v6 = _v1.b;
								var _v7 = _v1.c;
								return function ($) {
									return $.gN;
								};
							case 0:
								var _v8 = _v1.a;
								var _v9 = _v1.b;
								var _v10 = _v1.c;
								return function ($) {
									return $.gO;
								};
							case 6:
								var _v11 = _v1.a;
								var _v12 = _v1.b;
								var _v13 = _v1.c;
								return function ($) {
									return $.dV;
								};
							case 3:
								var _v66 = _v1.a;
								var _v67 = _v1.b;
								var _v68 = _v1.c;
								return function ($) {
									return $.gM;
								};
							default:
								break _v1$24;
						}
					case 3:
						switch (_v1.b) {
							case 2:
								var _v63 = _v1.a;
								var _v64 = _v1.b;
								var _v65 = _v1.c;
								return function ($) {
									return $.gK;
								};
							case 0:
								var _v69 = _v1.a;
								var _v70 = _v1.b;
								var _v71 = _v1.c;
								return function ($) {
									return $.gL;
								};
							default:
								break _v1$24;
						}
					case 0:
						switch (_v1.b) {
							case 2:
								var _v39 = _v1.a;
								var _v40 = _v1.b;
								var _v41 = _v1.c;
								return function ($) {
									return $.gT;
								};
							case 4:
								var _v42 = _v1.a;
								var _v43 = _v1.b;
								var _v44 = _v1.c;
								return function ($) {
									return $.dB;
								};
							case 1:
								var _v45 = _v1.a;
								var _v46 = _v1.b;
								var _v47 = _v1.c;
								return function ($) {
									return $.gU;
								};
							case 5:
								var _v48 = _v1.a;
								var _v49 = _v1.b;
								var _v50 = _v1.c;
								return function ($) {
									return $.yj;
								};
							case 6:
								var _v51 = _v1.a;
								var _v52 = _v1.b;
								var _v53 = _v1.c;
								return function ($) {
									return $.f1;
								};
							case 3:
								var _v72 = _v1.a;
								var _v73 = _v1.b;
								var _v74 = _v1.c;
								return function ($) {
									return $.gS;
								};
							default:
								break _v1$24;
						}
					default:
						break _v1$24;
				}
			case 4:
				var _v76 = _v1.c;
				return function ($) {
					return $.tE;
				};
			case 6:
				if (_v1.c.a === 1) {
					var _v77 = _v1.c.a;
					return function ($) {
						return $.Gv;
					};
				} else {
					if ((!_v1.a) && (_v1.b === 2)) {
						var _v78 = _v1.a;
						var _v79 = _v1.b;
						var _v80 = _v1.c.a;
						return function ($) {
							return $.gP;
						};
					} else {
						var _v81 = _v1.c.a;
						return function ($) {
							return $.tg;
						};
					}
				}
			case 3:
				var _v82 = _v1.c;
				return function ($) {
					return $.g_;
				};
			case 2:
				var _v83 = _v1.c;
				return function ($) {
					return $.g_;
				};
			case 5:
				var _v84 = _v1.c;
				return function ($) {
					return $.gX;
				};
			default:
				var _v85 = _v1.c;
				return function ($) {
					return $.DI;
				};
		}
	}
	var _v75 = _v1.c;
	return function ($) {
		return $.tg;
	};
};
var $author$project$Common$Itinerary$failure = function (session) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('skeleton'),
					$author$project$UrlRoute$onClickWithoutSideEffects(
					$author$project$Messages$ClickedOnItinerary(0))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mediumPadding')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sectionTitle title2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Translations$t,
												session.A_,
												function ($) {
													return $.ne;
												}))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('editLink')
										]),
									$author$project$Translations$toHtml(
										A2(
											$author$project$Translations$t,
											session.A_,
											function ($) {
												return $.wG;
											})))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('halfOpacity')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('voyageType type data')
										]),
									$author$project$Translations$toHtml(
										A2(
											$author$project$Translations$t,
											session.A_,
											$author$project$Utils$Route$translateTripType(session)))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ports bodyLarge')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Translations$t,
														session.A_,
														$author$project$Types$Port$translate(session.kS)))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Translations$t,
														session.A_,
														$author$project$Types$Port$translate(session.le)))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('singleLine ' + $author$project$Common$Infographic$Infographic$waveColor)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[$author$project$Common$Infographic$Infographic$createCircle])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('line')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[$author$project$Common$Infographic$Infographic$createCircle]))
										]))
								]))
						]))
				])),
			A2(
			$author$project$Common$Toast$View$view,
			1,
			A2(
				$author$project$Translations$t,
				session.A_,
				function ($) {
					return $.CL;
				}))
		]);
};
var $author$project$Types$VoyageType$hasTimetable = function (voyageType) {
	if (voyageType.$ === 1) {
		return true;
	} else {
		return true;
	}
};
var $author$project$Common$Itinerary$modelFromTrips = F2(
	function (voyageType, trips) {
		switch (trips.$) {
			case 0:
				var cruiseSails = trips.a;
				return function (_v1) {
					var outwardSail = _v1.a;
					var maybeIntermediateSail = _v1.b;
					var returnSail = _v1.c;
					return {
						kY: maybeIntermediateSail,
						kd: $elm$core$Maybe$Just(returnSail),
						rS: outwardSail,
						tx: voyageType
					};
				}(
					A3(
						$elm$core$Basics$composeR,
						$author$project$Types$CruiseSails$selected,
						A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Types$MikiSail$fromCruiseSail),
						cruiseSails));
			case 1:
				var routeTripSails = trips.a;
				return function (_v2) {
					var outwardSail = _v2.a;
					var returnSail = _v2.b;
					return {
						kY: $elm$core$Maybe$Nothing,
						kd: A2($elm$core$Maybe$map, $author$project$Types$MikiSail$fromRouteTripSail, returnSail),
						rS: $author$project$Types$MikiSail$fromRouteTripSail(outwardSail),
						tx: voyageType
					};
				}(
					$author$project$Types$RouteTripSails$selected(routeTripSails));
			default:
				var cruiseMultiDeparture = trips.a;
				return function (_v3) {
					var outward = _v3.a;
					var _return = _v3.b;
					return {
						kY: $elm$core$Maybe$Nothing,
						kd: $elm$core$Maybe$Just(_return),
						rS: outward,
						tx: voyageType
					};
				}(
					$author$project$Types$MikiSail$fromCruiseMultiDeparture(
						$author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture)));
		}
	});
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $ryan_haskell$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryan_haskell$date_format$DateFormat$monthNameFull = $ryan_haskell$date_format$DateFormat$MonthNameFull;
var $author$project$Utils$Time$Format$largeDateView = F2(
	function (locale, time) {
		var formatTokens = function (tokens) {
			return A3(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$author$project$Utils$Time$Translations$fromLanguage(locale.A_),
				tokens,
				$elm$time$Time$utc);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('largeDate')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day dataSpecial')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								formatTokens,
								_List_fromArray(
									[$ryan_haskell$date_format$DateFormat$dayOfMonthNumber]),
								time))
						])),
				A3(
					$elm$core$Basics$composeL,
					$elm$core$List$singleton,
					$elm$html$Html$div(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('wrapper')
							])),
					function () {
						var _v0 = _Utils_Tuple2(locale.A_, locale.rb);
						if (_v0.a === 7) {
							var _v1 = _v0.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('month bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												formatTokens,
												_List_fromArray(
													[$ryan_haskell$date_format$DateFormat$monthNameFull]),
												time) + ',')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('year bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												formatTokens,
												_List_fromArray(
													[$ryan_haskell$date_format$DateFormat$yearNumber]),
												time))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('weekday bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												formatTokens,
												_List_fromArray(
													[$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated]),
												time))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('month bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												formatTokens,
												_List_fromArray(
													[$ryan_haskell$date_format$DateFormat$monthNameAbbreviated]),
												time) + ',')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('weekday bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												formatTokens,
												_List_fromArray(
													[$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated]),
												time))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('year bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												formatTokens,
												_List_fromArray(
													[$ryan_haskell$date_format$DateFormat$yearNumber]),
												time))
										]))
								]);
						}
					}())));
	});
var $author$project$Common$Itinerary$dateNode = F4(
	function (time, isOutward, locale, translations) {
		var translateDepartureOrArrival = isOutward ? function ($) {
			return $.u_;
		} : function ($) {
			return $.u0;
		};
		var dateTestDateAttributeName = 'data-test-' + ((isOutward ? 'outward' : 'return') + '-date');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('date clearfix'),
					A2(
					$elm$html$Html$Attributes$attribute,
					dateTestDateAttributeName,
					$author$project$Utils$Time$toDateTimeString(time))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							translateDepartureOrArrival(translations))
						])),
					A2($author$project$Utils$Time$Format$largeDateView, locale, time)
				]));
	});
var $author$project$Common$Itinerary$skeleton = function (_v0) {
	var currentDate = _v0.ye;
	var language = _v0.A_;
	var market = _v0.rb;
	var translations = _v0.lY;
	var locale = A2($author$project$Types$Locale$Locale, language, market);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('skeleton')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sectionTitle title2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(translations.ne)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voyageType type data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.Bb)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sectionBody')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column left')
										]),
									_List_fromArray(
										[
											A4($author$project$Common$Itinerary$dateNode, currentDate, true, locale, translations)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							$elm$core$String$concat(
								_List_fromArray(
									['singleLine ', $author$project$Common$Infographic$Infographic$waveColor])))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Common$Infographic$Infographic$createCircle])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('line')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Common$Infographic$Infographic$createCircle]))
						]))
				]))
		]);
};
var $author$project$Types$InfographicData$CruiseType = 1;
var $author$project$Types$InfographicData$CruiseWithTwoStopsType = 2;
var $author$project$Types$InfographicData$RouteTripOneDepartureType = 4;
var $author$project$Types$InfographicData$SailDataWithoutDisembarkationType = 5;
var $author$project$Types$InfographicData$ShuttleOneDepartureType = 3;
var $author$project$Types$InfographicData$TwoDeparturesType = 0;
var $author$project$Types$InfographicData$getDataType = F3(
	function (voyageType, isOneWay, isTimeOnShore) {
		var _v0 = _Utils_Tuple3(voyageType, isOneWay, isTimeOnShore);
		switch (_v0.a.$) {
			case 2:
				if (!_v0.b) {
					var _v1 = _v0.a;
					return 0;
				} else {
					var _v2 = _v0.a;
					return 3;
				}
			case 3:
				if (!_v0.b) {
					var _v3 = _v0.a;
					return 0;
				} else {
					var _v4 = _v0.a;
					return 4;
				}
			case 4:
				var _v5 = _v0.a;
				return 0;
			case 6:
				if (_v0.a.a === 1) {
					if (_v0.c) {
						var _v6 = _v0.a.a;
						return 0;
					} else {
						var _v7 = _v0.a.a;
						return 5;
					}
				} else {
					var _v8 = _v0.a.a;
					return 1;
				}
			case 0:
				var _v9 = _v0.a;
				return 1;
			case 5:
				var _v10 = _v0.a;
				return 2;
			default:
				var _v11 = _v0.a;
				return 5;
		}
	});
var $author$project$Types$MikiSail$isTimeOnShore = F2(
	function (outwardSail, maybeReturnSail) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nr;
					},
					A2(
						$elm$core$Basics$composeR,
						A3($justinmimbs$time_extra$Time$Extra$diff, 12, $elm$time$Time$utc, outwardSail.ps),
						$elm$core$Basics$lt(1))),
				maybeReturnSail));
	});
var $author$project$Types$InfographicData$generateSailData = F6(
	function (translations, outwardSail, intermediateSail, returnSail, voyageType, locale) {
		var isTimeOnShore = A2($author$project$Types$MikiSail$isTimeOnShore, outwardSail, returnSail);
		var dataType = A3(
			$author$project$Types$InfographicData$getDataType,
			voyageType,
			_Utils_eq(returnSail, $elm$core$Maybe$Nothing),
			isTimeOnShore);
		switch (dataType) {
			case 0:
				return A2(
					$author$project$Types$InfographicData$toTwoDepartures,
					_Utils_Tuple2(outwardSail, returnSail),
					locale);
			case 3:
				return A2($author$project$Types$InfographicData$toOneDeparture, outwardSail, locale);
			case 4:
				return A2($author$project$Types$InfographicData$toOneDepartureRouteTrip, outwardSail, locale);
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Types$InfographicData$NoSailData,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A3(
								$author$project$Types$InfographicData$toCruise,
								translations,
								_Utils_Tuple2(outwardSail, a),
								locale);
						},
						returnSail));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Types$InfographicData$NoSailData,
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (a, b) {
								return A2(
									$author$project$Types$InfographicData$toCruiseWithTwoStops,
									_Utils_Tuple3(outwardSail, a, b),
									locale);
							}),
						intermediateSail,
						returnSail));
			default:
				return A3(
					$author$project$Types$InfographicData$sailDataWithoutDisembarkation,
					translations,
					_Utils_Tuple2(outwardSail, returnSail),
					locale);
		}
	});
var $author$project$Common$Itinerary$timeBetweenStoAlaDayCruiseDeparturesInMinutes = 10;
var $author$project$Common$Itinerary$getCruiseMultiShipNotification = F2(
	function (sail, translations) {
		var minutes = (sail.pt.zJ * 60) + sail.pt.Cy;
		var translation = (_Utils_cmp(minutes, $author$project$Common$Itinerary$timeBetweenStoAlaDayCruiseDeparturesInMinutes) > 0) ? translations.uW : translations.py;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('itineraryNotification bodyBold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'minutes',
								$elm$core$String$fromInt(minutes))
							]),
						translation))
				]));
	});
var $author$project$Common$Itinerary$getRouteTripVoyageTypeKeys = F3(
	function (outwardSail, maybeReturnSail, translations) {
		var getStringForLocation = function (location) {
			var _v0 = _Utils_Tuple2(location.j3, location.kg);
			_v0$2:
			while (true) {
				if (_v0.a === 3) {
					switch (_v0.b) {
						case 'MHAM':
							var _v1 = _v0.a;
							return translations.t$;
						case 'LNAS':
							var _v2 = _v0.a;
							return translations.t_;
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return A2($author$project$Types$Port$translate, location.j3, translations);
		};
		var getStringForSail = function (sail) {
			return getStringForLocation(sail.kS) + (' – ' + getStringForLocation(sail.le));
		};
		return _Utils_Tuple2(
			getStringForSail(outwardSail),
			A2($elm$core$Maybe$map, getStringForSail, maybeReturnSail));
	});
var $author$project$Common$Itinerary$getVoyageTypeKey = F5(
	function (voyageType, from, to, isOneWay, maybeDepartureType) {
		switch (voyageType.$) {
			case 3:
				return isOneWay ? function ($) {
					return $.u1;
				} : function ($) {
					return $.u2;
				};
			case 0:
				var _v1 = _Utils_Tuple2(from.j3, to.j3);
				_v1$2:
				while (true) {
					_v1$3:
					while (true) {
						_v1$12:
						while (true) {
							switch (_v1.b) {
								case 5:
									switch (_v1.a) {
										case 0:
											var _v2 = _v1.a;
											var _v3 = _v1.b;
											return function ($) {
												return $.yj;
											};
										case 5:
											break _v1$2;
										default:
											break _v1$2;
									}
								case 0:
									switch (_v1.a) {
										case 5:
											var _v4 = _v1.a;
											var _v5 = _v1.b;
											return function ($) {
												return $.no;
											};
										case 2:
											var _v10 = _v1.a;
											var _v11 = _v1.b;
											return _Utils_eq(
												maybeDepartureType,
												$elm$core$Maybe$Just(0)) ? function ($) {
												return $.no;
											} : function ($) {
												return $.uT;
											};
										default:
											var _v12 = _v1.b;
											return function ($) {
												return $.no;
											};
									}
								case 1:
									if (_v1.a === 5) {
										break _v1$3;
									} else {
										var _v13 = _v1.b;
										return function ($) {
											return $.uZ;
										};
									}
								case 2:
									switch (_v1.a) {
										case 5:
											break _v1$3;
										case 4:
											var _v8 = _v1.a;
											var _v9 = _v1.b;
											return function ($) {
												return $.ya;
											};
										default:
											var _v14 = _v1.b;
											return function ($) {
												return $.uX;
											};
									}
								case 4:
									if (_v1.a === 5) {
										break _v1$3;
									} else {
										var _v15 = _v1.b;
										return function ($) {
											return $.uY;
										};
									}
								case 6:
									if (_v1.a === 5) {
										break _v1$3;
									} else {
										var _v16 = _v1.b;
										return function ($) {
											return $.yb;
										};
									}
								case 15:
									switch (_v1.a) {
										case 5:
											break _v1$3;
										case 1:
											var _v17 = _v1.a;
											var _v18 = _v1.b;
											return _Utils_eq(
												maybeDepartureType,
												$elm$core$Maybe$Just(2)) ? function ($) {
												return $.uj;
											} : function ($) {
												return $.IA;
											};
										default:
											break _v1$12;
									}
								default:
									if (_v1.a === 5) {
										break _v1$3;
									} else {
										break _v1$12;
									}
							}
						}
						return function ($) {
							return $.tg;
						};
					}
					var _v7 = _v1.a;
					return function ($) {
						return $.uU;
					};
				}
				var _v6 = _v1.b;
				return function ($) {
					return $.uV;
				};
			case 2:
				return isOneWay ? function ($) {
					return $.u3;
				} : function ($) {
					return $.u4;
				};
			case 6:
				if (voyageType.a === 1) {
					var _v19 = voyageType.a;
					return A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Gv;
						},
						$author$project$Utils$String$capitalize);
				} else {
					var _v20 = voyageType.a;
					return function ($) {
						return $.tg;
					};
				}
			case 4:
				return function ($) {
					return $.tE;
				};
			case 5:
				return function ($) {
					return $.yc;
				};
			default:
				return function ($) {
					return $.DI;
				};
		}
	});
var $author$project$Common$Itinerary$isTimeDiffLessThanOneHour = F2(
	function (a, b) {
		return $elm$core$Basics$abs(
			A4($justinmimbs$time_extra$Time$Extra$diff, 12, $elm$time$Time$utc, a, b)) <= 1;
	});
var $author$project$Common$Itinerary$isDisembarkationDisallowed = F3(
	function (voyageType, vehiclesCount, _v0) {
		var outward = _v0.a;
		var _return = _v0.b;
		var sailPackageCodesDisallowed = _List_fromArray(
			['TUR-STO-TUR', 'STO-TUR-STO']);
		var isShoppingCruise = _Utils_eq(
			voyageType,
			$author$project$Types$VoyageType$CruiseMultiDeparture(1));
		var isLessThanOneHourOnShore = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Common$Itinerary$isTimeDiffLessThanOneHour(outward.ps),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.nr;
					},
					_return)));
		var hasDisallowedSailPackageCode = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return A2($elm$core$List$member, a, sailPackageCodesDisallowed);
				},
				outward.F4));
		return (isShoppingCruise || hasDisallowedSailPackageCode) && ((vehiclesCount > 0) || isLessThanOneHourOnShore);
	});
var $author$project$Utils$Route$isPalKapRoute = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return ((from === 12) && (to === 13)) || ((from === 13) && (to === 12));
};
var $author$project$Common$Itinerary$maybeMessageForLNAS = F3(
	function (translations, outwardSail, maybeReturnSail) {
		var messageView = function (message) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('itineraryNotification bodyBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]));
		};
		var isReturnToLNAS = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.le;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.kg;
						},
						$elm$core$Basics$eq('LNAS'))),
				maybeReturnSail));
		var isReturnFromLNAS = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.kS;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.kg;
						},
						$elm$core$Basics$eq('LNAS'))),
				maybeReturnSail));
		return (((outwardSail.kS.kg === 'LNAS') && isReturnToLNAS) || ((outwardSail.le.kg === 'LNAS') && isReturnFromLNAS)) ? $elm$core$Maybe$Just(
			messageView(translations.xw)) : (((outwardSail.kS.kg === 'LNAS') || isReturnFromLNAS) ? $elm$core$Maybe$Just(
			messageView(translations.xx)) : (((outwardSail.le.kg === 'LNAS') || isReturnToLNAS) ? $elm$core$Maybe$Just(
			messageView(translations.xu)) : $elm$core$Maybe$Nothing));
	});
var $author$project$Common$Itinerary$mugVssNotification = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('itineraryNotification bodyBold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.u$)
			]));
};
var $author$project$Common$Itinerary$noAshoreTimeNotification = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('itineraryNotification bodyBold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.CJ)
			]));
};
var $author$project$Common$Itinerary$getSpecialCruiseTitle = F2(
	function (translations, sail) {
		return A2(
			$elm$core$Maybe$withDefault,
			translations.vD,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.oh;
				},
				sail.rc));
	});
var $author$project$Common$Itinerary$isSpecialCruise = function (sail) {
	return (!_Utils_eq(sail.rc, $elm$core$Maybe$Nothing)) && sail.Au;
};
var $author$project$Common$Itinerary$pageTitle = F4(
	function (voyageType, translations, _v0, sail) {
		var title = _v0.a;
		var maybeReturnTitle = _v0.b;
		var titleView = function (string) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('type data')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(string)
					]));
		};
		var specialCruiseTitleIfNeeded = A2(
			$author$project$Utils$String$renderIf,
			$author$project$Common$Itinerary$isSpecialCruise(sail),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyNorm specialCruiseTitle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Common$Itinerary$getSpecialCruiseTitle, translations, sail))
					])));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sectionTitle title2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(translations.ne)
								])),
							A2(
							$author$project$Utils$String$renderIf,
							$author$project$Types$VoyageType$hasTimetable(voyageType),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('editLink')
									]),
								$author$project$Translations$toHtml(translations.wG)))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voyageType')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							[
								titleView(title),
								specialCruiseTitleIfNeeded
							]),
						A2(
							$elm$core$Maybe$map,
							function (returnTitle) {
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('column left')
											]),
										_List_fromArray(
											[
												titleView(title)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('column right')
											]),
										_List_fromArray(
											[
												titleView(returnTitle)
											])),
										specialCruiseTitleIfNeeded
									]);
							},
							maybeReturnTitle)))
				]));
	});
var $author$project$Types$ShipCode$toViewString = function (shipCode) {
	switch (shipCode.$) {
		case 0:
			return 'Silja Europa';
		case 1:
			return 'Galaxy';
		case 2:
			return 'Isabelle';
		case 3:
			return 'Megastar';
		case 4:
			return 'Baltic Princess';
		case 5:
			return 'Baltic Queen';
		case 6:
			return 'Romantika';
		case 7:
			return 'Sea Wind';
		case 8:
			return 'Silja Serenade';
		case 9:
			return 'Star';
		case 10:
			return 'Superstar';
		case 11:
			return 'Silja Symphony';
		case 12:
			return 'Victoria I';
		case 13:
			return 'Sailor';
		case 14:
			return 'Regal Star';
		case 15:
			return 'MyStar';
		case 16:
			return 'Superfast IX';
		default:
			var string = shipCode.a;
			return string;
	}
};
var $author$project$Common$Itinerary$shipNode = F2(
	function (shipCode, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('rowNarrow clearfix')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.xn)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('data ship')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Types$ShipCode$toViewString(shipCode))
						]))
				]));
	});
var $author$project$Common$Itinerary$translatePier = function (pier) {
	switch (pier) {
		case 'DTER':
			return function ($) {
				return $.EH;
			};
		case 'FHAM':
			return function ($) {
				return $.EI;
			};
		case 'LNAS':
			return function ($) {
				return $.EL;
			};
		case 'LSA2':
			return function ($) {
				return $.EM;
			};
		case 'LSA6':
			return function ($) {
				return $.EN;
			};
		case 'LSAT':
			return function ($) {
				return $.EO;
			};
		case 'MHAM':
			return function ($) {
				return $.EQ;
			};
		case 'MUUG':
			return function ($) {
				return $.ER;
			};
		case 'OLYM':
			return function ($) {
				return $.ES;
			};
		case 'RIGA':
			return function ($) {
				return $.EU;
			};
		case 'TSAT':
			return function ($) {
				return $.EW;
			};
		case 'VHAM':
			return function ($) {
				return $.EY;
			};
		case 'VISH':
			return function ($) {
				return $.EZ;
			};
		case 'VSAA':
			return function ($) {
				return $.E$;
			};
		case 'SAS':
			return function ($) {
				return $.EV;
			};
		case 'VNT':
			return function ($) {
				return $.E_;
			};
		case 'PALD':
			return function ($) {
				return $.ET;
			};
		case 'KAPE':
			return function ($) {
				return $.EK;
			};
		case 'MFAC':
			return function ($) {
				return $.EP;
			};
		default:
			return $elm$core$Basics$always(pier);
	}
};
var $author$project$Common$Itinerary$terminalNode = F2(
	function (pier, translations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold rowNarrow')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Common$Itinerary$translatePier, pier, translations))
				]));
	});
var $author$project$Common$Itinerary$shipInfo = F3(
	function (sail, isWithTerminalNames, translations) {
		return _List_fromArray(
			[
				A2($author$project$Common$Itinerary$shipNode, sail.oX, translations),
				A2(
				$author$project$Utils$String$renderIf,
				isWithTerminalNames,
				A2($author$project$Common$Itinerary$terminalNode, sail.kS.kg, translations))
			]);
	});
var $author$project$Common$Itinerary$showLikeOneDeparture = F5(
	function (outwardSail, locale, translations, isWithTerminalNames, outwardAttributes) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sectionBody'),
						A2($elm$html$Html$Attributes$attribute, 'data-test-one-departure', '')
					]),
				outwardAttributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column left')
								]),
							_List_fromArray(
								[
									A4($author$project$Common$Itinerary$dateNode, outwardSail.nr, true, locale, translations)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column right')
								]),
							A3($author$project$Common$Itinerary$shipInfo, outwardSail, isWithTerminalNames, translations))
						]))
				]));
	});
var $author$project$Common$Itinerary$showLikeTwoDepartures = F7(
	function (outwardSail, returnSail, locale, translations, isWithTerminalNames, outwardAttributes, returnAttributes) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sectionBody'),
					A2($elm$html$Html$Attributes$attribute, 'data-test-two-departures', '')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column left')
									]),
								outwardAttributes),
							_List_fromArray(
								[
									A4($author$project$Common$Itinerary$dateNode, outwardSail.nr, true, locale, translations)
								])),
							A2(
							$elm$html$Html$div,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column right')
									]),
								returnAttributes),
							_List_fromArray(
								[
									A4($author$project$Common$Itinerary$dateNode, returnSail.nr, false, locale, translations)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column left')
									]),
								outwardAttributes),
							A3($author$project$Common$Itinerary$shipInfo, outwardSail, isWithTerminalNames, translations)),
							A2(
							$elm$html$Html$div,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column right')
									]),
								returnAttributes),
							A3($author$project$Common$Itinerary$shipInfo, returnSail, isWithTerminalNames, translations))
						]))
				]));
	});
var $author$project$Common$Itinerary$shipNameAndDatesView = function (params) {
	var _v0 = params;
	var translations = _v0.lY;
	var locale = _v0.n0;
	var voyageType = _v0.tx;
	var maybeReturnSail = _v0.kd;
	var outwardSail = _v0.rS;
	var isWithTerminalNames = _v0.nZ;
	var outwardAttributes = _v0.oq;
	var returnAttributes = _v0.oH;
	var isCruiseDeparture = A2(
		$elm$core$List$member,
		voyageType,
		_List_fromArray(
			[
				$author$project$Types$VoyageType$CruiseMultiDeparture(1),
				$author$project$Types$VoyageType$CruiseMultiDeparture(0),
				$author$project$Types$VoyageType$Cruise,
				$author$project$Types$VoyageType$CruiseParty
			]));
	return A2(
		$elm$core$Maybe$withDefault,
		A5($author$project$Common$Itinerary$showLikeOneDeparture, outwardSail, locale, translations, isWithTerminalNames, outwardAttributes),
		A2(
			$elm$core$Maybe$map,
			function (returnSail) {
				return isCruiseDeparture ? A5($author$project$Common$Itinerary$showLikeOneDeparture, outwardSail, locale, translations, isWithTerminalNames, outwardAttributes) : A7($author$project$Common$Itinerary$showLikeTwoDepartures, outwardSail, returnSail, locale, translations, isWithTerminalNames, outwardAttributes, returnAttributes);
			},
			maybeReturnSail));
};
var $author$project$Common$Itinerary$view = function (params) {
	var _v0 = params;
	var translations = _v0.lY;
	var locale = _v0.n0;
	var departureType = _v0.yo;
	var vehiclesCount = _v0.Ik;
	var isWithTerminalNames = _v0.nZ;
	var outwardAttributes = _v0.oq;
	var returnAttributes = _v0.oH;
	var model = _v0.eM;
	var _v1 = model;
	var outwardSail = _v1.rS;
	var maybeReturnSail = _v1.kd;
	var voyageType = _v1.tx;
	var maybeIntermediateSail = _v1.kY;
	var isStoAlaDayCruise = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v2) {
				var departureIsoDate = _v2.nr;
				return (_Utils_cmp(
					A4($justinmimbs$time_extra$Time$Extra$diff, 13, $elm$time$Time$utc, outwardSail.ps, departureIsoDate),
					$author$project$Common$Itinerary$timeBetweenStoAlaDayCruiseDeparturesInMinutes) < 1) && A2($author$project$Utils$Route$isStoAlaRoute, outwardSail.kS.j3, outwardSail.le.j3);
			},
			maybeReturnSail));
	var cruiseNotification = isStoAlaDayCruise ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('itineraryNotification bodyBold')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$author$project$Translations$injectValues,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'minutes',
							$elm$core$String$fromInt($author$project$Common$Itinerary$timeBetweenStoAlaDayCruiseDeparturesInMinutes))
						]),
					translations.py))
			])) : A2($author$project$Common$Itinerary$getCruiseMultiShipNotification, outwardSail, translations);
	var shipCodes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(outwardSail.oX),
				A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.oX;
				},
				maybeReturnSail)
			]));
	var calculatedVoyageTypeKey = isStoAlaDayCruise ? function ($) {
		return $.tE;
	} : A5(
		$author$project$Common$Itinerary$getVoyageTypeKey,
		voyageType,
		outwardSail.kS,
		outwardSail.le,
		_Utils_eq(maybeReturnSail, $elm$core$Maybe$Nothing),
		departureType);
	var newSailData = A6($author$project$Types$InfographicData$generateSailData, translations, outwardSail, maybeIntermediateSail, maybeReturnSail, voyageType, locale);
	var voyageTypeKeys = (_Utils_eq(voyageType, $author$project$Types$VoyageType$RouteTrip) || _Utils_eq(voyageType, $author$project$Types$VoyageType$Shuttle)) ? A3($author$project$Common$Itinerary$getRouteTripVoyageTypeKeys, outwardSail, maybeReturnSail, translations) : _Utils_Tuple2(
		A2(
			$elm$core$Maybe$withDefault,
			calculatedVoyageTypeKey(translations),
			model.rS.F5),
		$elm$core$Maybe$Nothing);
	return _Utils_ap(
		_List_fromArray(
			[
				A2(
				$author$project$Utils$String$renderIf,
				!isWithTerminalNames,
				A4($author$project$Common$Itinerary$pageTitle, voyageType, translations, voyageTypeKeys, outwardSail)),
				$author$project$Common$Itinerary$shipNameAndDatesView(
				{nZ: isWithTerminalNames, n0: locale, kd: maybeReturnSail, oq: outwardAttributes, rS: outwardSail, oH: returnAttributes, lY: translations, tx: voyageType}),
				$author$project$Common$Infographic$Infographic$view(newSailData),
				A2(
				$author$project$Utils$String$renderIf,
				_Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultiship) || isStoAlaDayCruise,
				cruiseNotification),
				A2(
				$author$project$Utils$String$renderIf,
				A3(
					$author$project$Common$Itinerary$isDisembarkationDisallowed,
					voyageType,
					vehiclesCount,
					_Utils_Tuple2(outwardSail, maybeReturnSail)),
				$author$project$Common$Itinerary$noAshoreTimeNotification(translations)),
				A2(
				$author$project$Utils$String$renderIf,
				($author$project$Utils$Route$isMugVssRoute(outwardSail.kS.j3) || $author$project$Utils$Route$isPalKapRoute(
					{kS: outwardSail.kS.j3, le: outwardSail.le.j3})) && (!A2(
					$elm$core$List$all,
					$elm$core$Basics$eq($author$project$Types$ShipCode$Star),
					shipCodes)),
				$author$project$Common$Itinerary$mugVssNotification(translations))
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A3($author$project$Common$Itinerary$maybeMessageForLNAS, translations, outwardSail, maybeReturnSail))));
};
var $author$project$Page$Booking$itineraryPanel = F2(
	function (translations, _v0) {
		var session = _v0.j;
		var commonAttributes = _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'ui-view', 'itinerary'),
				$elm$html$Html$Attributes$class('panel'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'itinerary'),
				$elm$html$Html$Attributes$id('itinerary-panel')
			]);
		var _v1 = session.tp;
		switch (_v1.$) {
			case 0:
				var trips = _v1.a;
				return A2(
					$elm$html$Html$section,
					A3(
						$author$project$Utils$List$addIf,
						$author$project$Types$VoyageType$hasTimetable(session.tx),
						$author$project$UrlRoute$onClickWithoutSideEffects(
							$author$project$Messages$ClickedOnItinerary(0)),
						_Utils_ap(
							commonAttributes,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id('itinerary-panel'),
									$elm$html$Html$Attributes$class('mediumPadding')
								]))),
					$author$project$Common$Itinerary$view(
						{
							yo: $elm$core$Maybe$Just(session.mm),
							nZ: false,
							n0: A2($author$project$Types$Locale$Locale, session.A_, session.rb),
							eM: A2($author$project$Common$Itinerary$modelFromTrips, session.tx, trips),
							oq: A3(
								$author$project$Utils$List$addIf,
								$author$project$Types$VoyageType$hasTimetable(session.tx),
								$author$project$UrlRoute$onClickWithoutSideEffects(
									$author$project$Messages$ClickedOnItinerary(0)),
								_List_Nil),
							oH: A3(
								$author$project$Utils$List$addIf,
								$author$project$Types$VoyageType$hasTimetable(session.tx),
								$author$project$UrlRoute$onClickWithoutSideEffects(
									$author$project$Messages$ClickedOnItinerary(1)),
								_List_Nil),
							lY: translations,
							Ik: A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$countSelected, session.rp))
						}));
			case 2:
				return A2(
					$elm$html$Html$section,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('loadingSection mediumPadding'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'itinerary-loading'),
							commonAttributes)),
					$author$project$Common$Itinerary$skeleton(
						{ye: session.kJ, A_: session.A_, rb: session.rb, lY: translations}));
			default:
				return A2(
					$elm$html$Html$section,
					commonAttributes,
					$author$project$Common$Itinerary$failure(session));
		}
	});
var $author$project$Utils$Route$isCrabSupported = F3(
	function (from, to, voyageType) {
		return A2($author$project$Utils$Route$isTalHelRoute, from, to) && A2(
			$elm$core$List$member,
			voyageType,
			_List_fromArray(
				[
					$author$project$Types$VoyageType$CruiseMultiDeparture(1),
					$author$project$Types$VoyageType$Shuttle
				]));
	});
var $author$project$Page$Booking$shouldRenderCrabBanner = function (_v0) {
	var session = _v0.j;
	var isNative = _v0.qV;
	return (!isNative) && A3($author$project$Utils$Route$isCrabSupported, session.kS, session.le, session.tx);
};
var $author$project$Types$Hotel$selectedHotelCode = function (_v0) {
	var dict = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.zx;
		},
		$elm$core$List$head(
			$elm$core$Dict$values(dict)));
};
var $author$project$BookingPage$Panel$Hotel$View$findSelectedHotel = function (session) {
	return $elm_community$list_extra$List$Extra$find(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.pQ;
			},
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$Just,
				$elm$core$Basics$eq(
					$author$project$Types$Hotel$selectedHotelCode(session.Gk)))));
};
var $author$project$Utils$OneOrMore$head = function (_v0) {
	var x = _v0.a;
	return x;
};
var $author$project$Types$Hotel$selectedRooms = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$values(dict);
};
var $author$project$Utils$OneOrMore$tail = function (_v0) {
	var xs = _v0.b;
	return xs;
};
var $author$project$BookingPage$Panel$Hotel$View$getBookingDates = function (selectedHotelRooms) {
	return A2(
		$elm$core$Maybe$map,
		function (_v0) {
			var nights = _v0.CI;
			var firstNight = $author$project$Utils$OneOrMore$head(nights);
			var lastNight = A2(
				$elm$core$Maybe$withDefault,
				firstNight,
				$elm$core$List$head(
					$elm$core$List$reverse(
						$author$project$Utils$OneOrMore$tail(nights))));
			return {
				ln: firstNight,
				lo: A4($justinmimbs$time_extra$Time$Extra$add, 11, 1, $elm$time$Time$utc, lastNight)
			};
		},
		$elm$core$List$head(
			$author$project$Types$Hotel$selectedRooms(selectedHotelRooms)));
};
var $author$project$BookingPage$Panel$Hotel$View$selectedRoomsToCountAndName = F3(
	function (session, hotels, selectedHotelRooms) {
		var toCountAndName = F2(
			function (count, name) {
				return {pZ: count, oh: name};
			});
		return A2(
			$elm$core$Maybe$map,
			function (hotel) {
				return A3(
					$elm$core$List$foldr,
					F2(
						function (room, acc) {
							return A2(
								$elm$core$Maybe$withDefault,
								acc,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										var name = _v0.oh;
										return A2(
											$elm$core$List$cons,
											A2(toCountAndName, room.pZ, name),
											acc);
									},
									A2(
										$elm_community$list_extra$List$Extra$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.pQ;
											},
											$elm$core$Basics$eq(room.pQ)),
										$author$project$Utils$OneOrMore$toList(hotel.F_))));
						}),
					_List_Nil,
					$author$project$Types$Hotel$selectedRooms(selectedHotelRooms));
			},
			A2($author$project$BookingPage$Panel$Hotel$View$findSelectedHotel, session, hotels));
	});
var $author$project$BookingPage$Panel$Hotel$View$toViewArguments = F3(
	function (session, hotels, selectedHotelRooms) {
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (hotel, _v0, selectedRooms) {
					var checkInDate = _v0.ln;
					var checkOutDate = _v0.lo;
					return {ln: checkInDate, mb: hotel.mb, lo: checkOutDate, mc: hotel.mc, nD: hotel.oh, n1: hotel.n1, mQ: hotel.mQ, oS: selectedRooms};
				}),
			A2($author$project$BookingPage$Panel$Hotel$View$findSelectedHotel, session, hotels),
			$author$project$BookingPage$Panel$Hotel$View$getBookingDates(selectedHotelRooms),
			A3($author$project$BookingPage$Panel$Hotel$View$selectedRoomsToCountAndName, session, hotels, selectedHotelRooms));
	});
var $author$project$Types$FromTo$toString = function (fromOrTo) {
	if (!fromOrTo) {
		return 'from';
	} else {
		return 'to';
	}
};
var $author$project$Types$FromTo$translate = function (fromOrTo) {
	if (!fromOrTo) {
		return function ($) {
			return $.kS;
		};
	} else {
		return function ($) {
			return $.le;
		};
	}
};
var $author$project$BookingPage$FromTo$View$location = F4(
	function (translations, maybeActiveFromOrTo, fromOrTo, harbor) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Messages$OpenedModal(
						$author$project$Common$Modal$Model$FromTo(fromOrTo))),
					$elm$html$Html$Attributes$class(
					'button ' + $author$project$Types$FromTo$toString(fromOrTo)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(
								maybeActiveFromOrTo,
								$elm$core$Maybe$Just(fromOrTo)))
						])),
					function () {
					if (!fromOrTo) {
						return A2($elm$html$Html$Attributes$attribute, 'data-test', 'departure-port-button');
					} else {
						return A2($elm$html$Html$Attributes$attribute, 'data-test', 'arrival-port-button');
					}
				}(),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-port',
					$author$project$Types$Port$toString(harbor))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fromToText bodyNorm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Types$FromTo$translate, fromOrTo, translations))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropDownArrow')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('portName data'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-test-port',
							$author$project$Types$Port$toString(harbor))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$Port$translate, harbor, translations))
						]))
				]));
	});
var $author$project$BookingPage$FromTo$View$updatePorts = F2(
	function (from, to) {
		return $author$project$Messages$ChangedVoyage(
			{kS: from, Cd: $elm$core$Maybe$Nothing, le: to});
	});
var $author$project$BookingPage$FromTo$View$view = F2(
	function (translations, model) {
		var session = model.j;
		var maybeFromOrTo = function () {
			var _v1 = model.CC;
			if ((!_v1.$) && (!_v1.a.$)) {
				var fromToType = _v1.a.a;
				return $elm$core$Maybe$Just(fromToType);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = session;
		var from = _v0.kS;
		var to = _v0.le;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'ui-view', 'fromTo'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'fromToButtons')
				]),
			A2(
				$elm$core$List$cons,
				A4($author$project$BookingPage$FromTo$View$location, translations, maybeFromOrTo, 0, from),
				_Utils_ap(
					$author$project$Utils$Route$isRouteSupported(
						{vk: session.vk, kS: to, le: from}) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('swapButtonContainer')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('swapButton'),
											$elm$html$Html$Events$onClick(
											A2($author$project$BookingPage$FromTo$View$updatePorts, to, from)),
											A2($elm$html$Html$Attributes$attribute, 'data-test-button', 'swap-from-to')
										]),
									_List_Nil)
								]))
						]) : _List_Nil,
					_List_fromArray(
						[
							A4($author$project$BookingPage$FromTo$View$location, translations, maybeFromOrTo, 1, to)
						]))));
	});
var $author$project$BookingPage$Panel$Passenger$Surcharges$adjustSurchargesForReturnTrip = function (_v0) {
	var outward = _v0.Ds;
	var _return = _v0.FL;
	return A2(
		$elm$core$List$map,
		function (surcharge) {
			var hasMatchingReturn = A2(
				$elm$core$List$any,
				function (ret) {
					return _Utils_eq(ret.lN, surcharge.lN) && _Utils_eq(ret.pZ, surcharge.pZ);
				},
				_return);
			return hasMatchingReturn ? _Utils_update(
				surcharge,
				{lN: surcharge.lN * 2}) : surcharge;
		},
		outward);
};
var $author$project$BookingPage$Panel$Passenger$Surcharges$getDescription = F2(
	function (translations, maybeAgeCategory) {
		var translationKey = function () {
			if ((!maybeAgeCategory.$) && (maybeAgeCategory.a === 3)) {
				var _v1 = maybeAgeCategory.a;
				return function ($) {
					return $.zc;
				};
			} else {
				return function ($) {
					return $.zb;
				};
			}
		}();
		return translationKey(translations);
	});
var $author$project$BookingPage$Panel$Passenger$Surcharges$getSurchargeText = F3(
	function (name, market, _v0) {
		var price = _v0.lN;
		var count = _v0.pZ;
		var formattedPrice = A2($author$project$Types$Market$formatPriceWithSign, market, price);
		return $elm$core$String$fromInt(count) + (' x ' + (name + (' ' + formattedPrice)));
	});
var $author$project$Common$Hint$hint = function (value) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hint')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hintIcon')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(value)
					]))
			]));
};
var $author$project$BookingPage$Panel$Passenger$Surcharges$surchargeItem = F3(
	function (showHint, translations, textString) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surcharge')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(textString),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					showHint,
					$author$project$Common$Hint$hint(translations.zd))
				]));
	});
var $author$project$BookingPage$Panel$Passenger$Surcharges$surchargeItems = F3(
	function (showHint, translations, market) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2($author$project$BookingPage$Panel$Passenger$Surcharges$getSurchargeText, translations.za, market)),
			$elm$core$List$map(
				A2($author$project$BookingPage$Panel$Passenger$Surcharges$surchargeItem, showHint, translations)));
	});
var $author$project$BookingPage$Panel$Passenger$Surcharges$column = F5(
	function (side, translations, market, surchargeList, maybeAgeCategory) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column ' + side)
				]),
			_Utils_ap(
				A4($author$project$BookingPage$Panel$Passenger$Surcharges$surchargeItems, false, translations, market, surchargeList),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('surchargesDescription')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$BookingPage$Panel$Passenger$Surcharges$getDescription, translations, maybeAgeCategory))
							]))
					])));
	});
var $author$project$BookingPage$Panel$Passenger$Surcharges$view = F2(
	function (columnViews, descriptionText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surcharges')
				]),
			_Utils_ap(
				columnViews,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('surchargesDescription')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(descriptionText)
							]))
					])));
	});
var $author$project$BookingPage$Panel$Passenger$Surcharges$root = F3(
	function (translations, _v0, summary) {
		var market = _v0.rb;
		var isOneWay = _v0.qW;
		var passengerSurcharges = summary.s6.DL;
		var maxAgeCategories = summary.s6.BK;
		var isOneWayVisual = isOneWay || _Utils_eq(maxAgeCategories.Ds, maxAgeCategories.FL);
		var hasSurcharges = isOneWayVisual ? (!$elm$core$List$isEmpty(passengerSurcharges.Ds)) : ((!$elm$core$List$isEmpty(passengerSurcharges.Ds)) || (!$elm$core$List$isEmpty(passengerSurcharges.FL)));
		return (!hasSurcharges) ? $elm$html$Html$text('') : (isOneWayVisual ? A2(
			$author$project$BookingPage$Panel$Passenger$Surcharges$view,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A4(
						$author$project$BookingPage$Panel$Passenger$Surcharges$surchargeItems,
						true,
						translations,
						market,
						$author$project$BookingPage$Panel$Passenger$Surcharges$adjustSurchargesForReturnTrip(passengerSurcharges)))
				]),
			A2($author$project$BookingPage$Panel$Passenger$Surcharges$getDescription, translations, maxAgeCategories.Ds)) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('surcharges')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('passengerRow')
						]),
					_List_fromArray(
						[
							A5($author$project$BookingPage$Panel$Passenger$Surcharges$column, 'left', translations, market, passengerSurcharges.Ds, maxAgeCategories.Ds),
							A5($author$project$BookingPage$Panel$Passenger$Surcharges$column, 'right', translations, market, passengerSurcharges.FL, maxAgeCategories.FL)
						]))
				])));
	});
var $author$project$Types$PassengerCount$encodePassengerCount = function (passengerCount) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'adult',
				$elm$json$Json$Encode$int(passengerCount.tV)),
				_Utils_Tuple2(
				'child',
				$elm$json$Json$Encode$int(passengerCount.vU)),
				_Utils_Tuple2(
				'junior',
				$elm$json$Json$Encode$int(passengerCount.AI)),
				_Utils_Tuple2(
				'youth',
				$elm$json$Json$Encode$int(passengerCount.IF))
			]));
};
var $author$project$Types$PassengerCount$toJson = A2(
	$elm$core$Basics$composeL,
	$elm$json$Json$Encode$encode(0),
	$author$project$Types$PassengerCount$encodePassengerCount);
var $author$project$Common$Counter$View$viewFromCountAsString = F2(
	function (count, elements) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('counter')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('number bodyLarge data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(count)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					elements)
				]));
	});
var $author$project$Common$Counter$View$view = function (count) {
	return $author$project$Common$Counter$View$viewFromCountAsString(
		$elm$core$String$fromInt(count));
};
var $author$project$Common$Passengers$view = F2(
	function (translations, count) {
		var cell = function (category) {
			var _v0 = function () {
				switch (category) {
					case 0:
						return _Utils_Tuple2(
							'adult',
							function ($) {
								return $.tV;
							});
					case 3:
						return _Utils_Tuple2(
							'junior',
							function ($) {
								return $.AI;
							});
					case 1:
						return _Utils_Tuple2(
							'youth',
							function ($) {
								return $.IF;
							});
					default:
						return _Utils_Tuple2(
							'child',
							function ($) {
								return $.vU;
							});
				}
			}();
			var className = _v0.a;
			var selector = _v0.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(className),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'inactive',
								!selector(count))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('icon'),
								$elm$html$Html$Attributes$src(
								selector($author$project$Types$PassengerImages$images))
							]),
						_List_Nil),
						A2(
						$author$project$Common$Counter$View$view,
						selector(count),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Types$AgeCategory$translate, category, translations))
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengersCategories')
				]),
			_List_fromArray(
				[
					cell(0),
					cell(3),
					cell(1),
					cell(2)
				]));
	});
var $author$project$BookingPage$Panel$Passenger$View$view = F2(
	function (translations, session) {
		var passengerCount = $author$project$Common$Passengers$passengerCount(
			A3(
				$elm$core$Array$foldl,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$List$cons),
				_List_Nil,
				session.Eg));
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerPanel mediumPadding'),
					A2($elm$html$Html$Attributes$attribute, 'view', 'passenger'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-passenger-count',
					$author$project$Types$PassengerCount$toJson(passengerCount)),
					$elm$html$Html$Attributes$id('passenger-panel'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'passenger-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$Messages$ChangedLocation($author$project$UrlRoute$PassengerList))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sectionTitle title2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(translations.vd)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('editLink')
										]),
									$author$project$Translations$toHtml(translations.wG))
								])),
							A2($author$project$Common$Passengers$view, translations, passengerCount)
						])),
					A2(
					$author$project$Utils$Html$Render$maybeRender,
					A2($author$project$BookingPage$Panel$Passenger$Surcharges$root, translations, session),
					session.B7)
				]));
	});
var $author$project$BookingPage$Panel$TravelClass$View$isPetTravelClassWithCode = F2(
	function (code, _v0) {
		var outward = _v0.Ds;
		var _return = _v0.FL;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$elm$core$Basics$eq(code)),
				outward)) || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$elm$core$Basics$eq(code)),
				_return));
	});
var $author$project$BookingPage$Panel$TravelClass$View$addNameToCodeAndCount = F3(
	function (translations, travelClasses, _v0) {
		var code = _v0.a;
		var count = _v0.b;
		var nameCodeAndCount = function (_v1) {
			var name = _v1.oh;
			return {pQ: code, pZ: count, oh: name};
		};
		return A2(
			$author$project$Types$Maybe$Util$orElse,
			A2(
				$elm$core$Maybe$map,
				nameCodeAndCount,
				A2(
					$elm_community$list_extra$List$Extra$find,
					$author$project$BookingPage$Panel$TravelClass$View$isPetTravelClassWithCode(code),
					$author$project$Types$TravelClasses$petTravelClasses(
						$author$project$Types$TravelClasses$availableTravelClasses(travelClasses)))),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$adjustTravelClassName(translations),
					nameCodeAndCount),
				A3(
					$elm$core$Basics$composeR,
					$author$project$Types$TravelClasses$all,
					$author$project$Types$TravelClasses$getTravelClass(code),
					travelClasses)));
	});
var $author$project$BookingPage$Panel$TravelClass$View$codesAndCountsFromSummary = F3(
	function (translations, travelClasses, summary) {
		var _return = A2(
			$elm$core$List$filterMap,
			A2($author$project$BookingPage$Panel$TravelClass$View$addNameToCodeAndCount, translations, travelClasses),
			summary.FU);
		var outward = A2(
			$elm$core$List$filterMap,
			A2($author$project$BookingPage$Panel$TravelClass$View$addNameToCodeAndCount, translations, travelClasses),
			summary.DB);
		return ($elm$core$List$isEmpty(outward) && $elm$core$List$isEmpty(_return)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{Ds: outward, FL: _return});
	});
var $author$project$BookingPage$Panel$TravelClass$View$codesAndCountsFromTravelClasses = F3(
	function (translations, travelClasses, maybeSummary) {
		return A2(
			$elm$core$Maybe$withDefault,
			function (_v0) {
				var outbound = _v0.Dr;
				var inbound = _v0.zT;
				return {
					Ds: A2(
						$elm$core$List$filterMap,
						A2($author$project$BookingPage$Panel$TravelClass$View$addNameToCodeAndCount, translations, travelClasses),
						outbound),
					FL: A2(
						$elm$core$List$filterMap,
						A2($author$project$BookingPage$Panel$TravelClass$View$addNameToCodeAndCount, translations, travelClasses),
						inbound)
				};
			}(
				$author$project$Types$TravelClasses$getSelectedCodeCountPairLists(travelClasses)),
			A2(
				$elm$core$Maybe$andThen,
				A2($author$project$BookingPage$Panel$TravelClass$View$codesAndCountsFromSummary, translations, travelClasses),
				maybeSummary));
	});
var $author$project$Common$TravelClasses$Model = F8(
	function (translations, outward, _return, from, to, isOneWay, outwardServices, returnServices) {
		return {kS: from, qW: isOneWay, Ds: outward, ot: outwardServices, FL: _return, oL: returnServices, le: to, lY: translations};
	});
var $author$project$BookingPage$Panel$TravelClass$View$createServiceForDirection = F3(
	function (session, mapSelectedCabinSurpirses, mapCabinSurpises) {
		return A2(
			$elm$core$Dict$map,
			F2(
				function (travelClassCode, list) {
					return A2(
						$elm$core$List$map,
						function (_v0) {
							var code = _v0.a;
							var selections = _v0.b;
							return {
								pQ: code,
								pZ: $elm$core$List$length(selections) + 1,
								oh: A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.oh;
										},
										A2(
											$elm_community$list_extra$List$Extra$find,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.pQ;
												},
												$elm$core$Basics$eq(code)),
											A3(
												$elm$core$Basics$composeR,
												$author$project$Types$CabinSurprise$getCabinSurprisesPerTravelClass(travelClassCode),
												mapCabinSurpises,
												A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Types$CabinSurprise$defaultSurprises, session.pD)))))
							};
						},
						A2($elm_community$list_extra$List$Extra$gatherWith, $elm$core$Basics$eq, list));
				}),
			mapSelectedCabinSurpirses(session.Gh));
	});
var $author$project$Common$Counter$View$grayView = F2(
	function (count, elements) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('counter gray')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('number data')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(count))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					elements)
				]));
	});
var $author$project$Common$Counter$View$viewWithZeroShownAsSpace = F2(
	function (count, elements) {
		var zeroToSpace = function (num) {
			return (!num) ? ' ' : $elm$core$String$fromInt(num);
		};
		return A2(
			$author$project$Common$Counter$View$viewFromCountAsString,
			zeroToSpace(count),
			elements);
	});
var $author$project$Common$TravelClasses$travelClassView = F2(
	function (services, _v0) {
		var name = _v0.oh;
		var code = _v0.pQ;
		var count = _v0.pZ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('travelClass'),
					A2($elm$html$Html$Attributes$attribute, 'data-test-travel-class-code', code),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-count',
					$elm$core$String$fromInt(count))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Common$Counter$View$viewWithZeroShownAsSpace,
						count,
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]),
				A2(
					$elm$core$List$map,
					function (service) {
						return A2(
							$author$project$Common$Counter$View$grayView,
							service.pZ,
							_List_fromArray(
								[
									$elm$html$Html$text(service.oh)
								]));
					},
					services)));
	});
var $author$project$Common$TravelClasses$mapTravelClassesToViews = function (services) {
	return A2(
		$elm$core$Basics$composeR,
		$elm_community$list_extra$List$Extra$gatherEqualsBy(
			function ($) {
				return $.pQ;
			}),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (_v0) {
					var first = _v0.a;
					var others = _v0.b;
					return A3(
						$elm$core$List$foldl,
						F2(
							function (a, b) {
								return _Utils_update(
									b,
									{pZ: a.pZ + b.pZ});
							}),
						first,
						others);
				}),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (a) {
						return A2(
							$author$project$Common$TravelClasses$travelClassView,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Dict$get, a.pQ, services)),
							a);
					}),
				function (a) {
					return $elm$core$List$isEmpty(a) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('data')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('- -')
								]))
						]) : a;
				})));
};
var $author$project$Common$FromTo$View$fromToNode = F2(
	function (from, to) {
		var portName = function (keyPart) {
			return $elm$html$Html$text(
				$author$project$Types$Port$toString(keyPart));
		};
		var toFrom = _List_fromArray(
			[
				portName(to),
				$elm$html$Html$text(' - '),
				portName(from)
			]);
		var fromTo = _List_fromArray(
			[
				portName(from),
				$elm$html$Html$text(' - '),
				portName(to)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fromTo')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('left bodyNorm')
						]),
					fromTo),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('right bodyNorm')
						]),
					toFrom)
				]));
	});
var $author$project$Common$FromTo$View$talPartyFromToNode = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fromTo')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('left bodyNorm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.G8)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('right bodyNorm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.DJ)
					]))
			]));
};
var $author$project$Common$FromTo$View$root = F4(
	function (translations, isOneWay, from, to) {
		return A2(
			$author$project$Utils$Html$Render$renderIf,
			!isOneWay,
			((!from) && (to === 17)) ? $author$project$Common$FromTo$View$talPartyFromToNode(translations) : A2($author$project$Common$FromTo$View$fromToNode, from, to));
	});
var $author$project$Utils$List$zipToMaybes = F2(
	function (aList, bList) {
		var _v0 = _Utils_Tuple2(aList, bList);
		if (_v0.a.b) {
			if (_v0.b.b) {
				var _v1 = _v0.a;
				var a = _v1.a;
				var l1 = _v1.b;
				var _v2 = _v0.b;
				var b = _v2.a;
				var l2 = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$elm$core$Maybe$Just(a),
						$elm$core$Maybe$Just(b)),
					A2($author$project$Utils$List$zipToMaybes, l1, l2));
			} else {
				var _v4 = _v0.a;
				var a = _v4.a;
				var l1 = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$elm$core$Maybe$Just(a),
						$elm$core$Maybe$Nothing),
					A2($author$project$Utils$List$zipToMaybes, l1, _List_Nil));
			}
		} else {
			if (_v0.b.b) {
				var _v3 = _v0.b;
				var b = _v3.a;
				var l2 = _v3.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(b)),
					A2($author$project$Utils$List$zipToMaybes, _List_Nil, l2));
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Common$TravelClasses$view = function (model) {
	return _Utils_ap(
		_List_fromArray(
			[
				A4($author$project$Common$FromTo$View$root, model.lY, model.qW, model.kS, model.le)
			]),
		model.qW ? A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$div(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						])),
				$elm$core$List$singleton),
			A2($author$project$Common$TravelClasses$mapTravelClassesToViews, model.ot, model.Ds)) : A2(
			$elm$core$List$map,
			function (_v0) {
				var maybeOutwardView = _v0.a;
				var maybeReturnView = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('outward')
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeOutwardView))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('return')
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2($elm$core$Maybe$map, $elm$core$List$singleton, maybeReturnView)))
						]));
			},
			A2(
				$author$project$Utils$List$zipToMaybes,
				A2($author$project$Common$TravelClasses$mapTravelClassesToViews, model.ot, model.Ds),
				A2($author$project$Common$TravelClasses$mapTravelClassesToViews, model.oL, model.FL))));
};
var $author$project$BookingPage$Panel$TravelClass$View$defaultViewContent = F3(
	function (translations, session, _v0) {
		var outward = _v0.Ds;
		var _return = _v0.FL;
		var _v1 = session;
		var voyageType = _v1.tx;
		var from = _v1.kS;
		var to = _v1.le;
		var isOneWay = session.qW && (!_Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultiship));
		var translateTitle = (_Utils_eq(voyageType, $author$project$Types$VoyageType$Shuttle) || _Utils_eq(voyageType, $author$project$Types$VoyageType$RouteTrip)) ? function ($) {
			return $.vi;
		} : function ($) {
			return $.vj;
		};
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sectionTitle title2')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								translateTitle(translations))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('editLink')
							]),
						$author$project$Translations$toHtml(translations.wG))
					])),
			$author$project$Common$TravelClasses$view(
				A8(
					$author$project$Common$TravelClasses$Model,
					translations,
					outward,
					_return,
					from,
					to,
					isOneWay,
					A3(
						$author$project$BookingPage$Panel$TravelClass$View$createServiceForDirection,
						session,
						function ($) {
							return $.DC;
						},
						function ($) {
							return $.DC;
						}),
					A3(
						$author$project$BookingPage$Panel$TravelClass$View$createServiceForDirection,
						session,
						function ($) {
							return $.FV;
						},
						function ($) {
							return $.FV;
						}))));
	});
var $author$project$BookingPage$Panel$TravelClass$View$emptyView = function (session) {
	var language = session.A_;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sectionTitle title2 emptyView')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							session.A_,
							function ($) {
								return $.H2;
							}))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('editLink dark')
					]),
				$author$project$Translations$toHtml(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.vW;
						})))
			]));
};
var $author$project$BookingPage$Panel$TravelClass$View$view = F2(
	function (translations, session) {
		var selectedTravelClasses = function () {
			var _v0 = session.to;
			if (!_v0.$) {
				var a = _v0.a;
				return function (selected) {
					return ($elm$core$List$isEmpty(selected.Ds) && $elm$core$List$isEmpty(selected.FL)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(selected);
				}(
					A3($author$project$BookingPage$Panel$TravelClass$View$codesAndCountsFromTravelClasses, translations, a, session.B7));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('travelClassPanel mediumPadding'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'notSelected',
							_Utils_eq(selectedTravelClasses, $elm$core$Maybe$Nothing))
						])),
					A2($elm$html$Html$Attributes$attribute, 'view', 'travelClassSelection'),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$ChangedLocation($author$project$UrlRoute$TravelClass)),
					$elm$html$Html$Attributes$id('travelclass-panel'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'travelclass-panel')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_fromArray(
					[
						$author$project$BookingPage$Panel$TravelClass$View$emptyView(session)
					]),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$BookingPage$Panel$TravelClass$View$defaultViewContent, translations, session),
					selectedTravelClasses)));
	});
var $author$project$BookingPage$Panel$Hotel$View$largeDateView = function (_v0) {
	var locale = _v0.n0;
	var date = _v0.nn;
	var time = _v0.o5;
	var formatTokens = function (tokens) {
		return A3(
			$ryan_haskell$date_format$DateFormat$formatWithLanguage,
			$author$project$Utils$Time$Translations$fromLanguage(locale.A_),
			tokens,
			$elm$time$Time$utc);
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('largeDate')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('day dataSpecial')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							formatTokens,
							_List_fromArray(
								[$ryan_haskell$date_format$DateFormat$dayOfMonthNumber]),
							date))
					])),
			A3(
				$elm$core$Basics$composeL,
				$elm$core$List$singleton,
				$elm$html$Html$div(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('wrapper')
						])),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('month bodyNorm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									formatTokens,
									_List_fromArray(
										[$ryan_haskell$date_format$DateFormat$monthNameAbbreviated]),
									date) + ',')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('weekday bodyNorm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									formatTokens,
									_List_fromArray(
										[$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated]),
									date))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('time bodyNorm')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(time)
							]))
					]))));
};
var $author$project$BookingPage$Panel$Hotel$View$bookingDatesView = F2(
	function (_v0, _arguments) {
		var language = _v0.A_;
		var market = _v0.rb;
		var locale = A2($author$project$Types$Locale$Locale, language, market);
		return A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panelColumn'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'hotels-check-in-summary')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginBottomSmall')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.vR;
										}))
								])),
							$author$project$BookingPage$Panel$Hotel$View$largeDateView(
							{nn: _arguments.ln, n0: locale, o5: _arguments.mb})
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panelColumn'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'hotels-check-out-summary')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginBottomSmall')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.vS;
										}))
								])),
							$author$project$BookingPage$Panel$Hotel$View$largeDateView(
							{nn: _arguments.lo, n0: locale, o5: _arguments.mc})
						]))
				]));
	});
var $author$project$Common$Images$locationMark = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('20'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.ev),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$clipRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M10 0c3.965 0 7.188 3.165 7.188 7.059C17.188 12.353 10 20 10 20S2.812 12.353 2.812 7.059C2.813 3.165 6.035 0 10 0zm0 4.706c-1.318 0-2.396 1.059-2.396 2.353 0 1.294 1.078 2.353 2.396 2.353 1.33 0 2.396-1.06 2.396-2.353 0-1.294-1.078-2.353-2.396-2.353z')
				]),
			_List_Nil)
		]));
var $author$project$Common$Hotel$locationWithMarkerView = function (_v0) {
	var location = _v0.n1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('withImage')
			]),
		_List_fromArray(
			[
				$author$project$Common$Images$locationMark,
				A2(
				$elm$html$Html$span,
				_List_Nil,
				$author$project$Translations$toHtml(location))
			]));
};
var $author$project$Common$Hotel$locationView = function (_v0) {
	var location = _v0.n1;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('location')
			]),
		_List_fromArray(
			[
				$author$project$Common$Hotel$locationWithMarkerView(
				{n1: location})
			]));
};
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Element$rgb255 = F3(
	function (red, green, blue) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, 1);
	});
var $author$project$UI$colors = {
	vJ: A3($mdgriffith$elm_ui$Element$rgb255, 0, 236, 201),
	qt: A3($mdgriffith$elm_ui$Element$rgb255, 221, 221, 221),
	ev: A3($mdgriffith$elm_ui$Element$rgb255, 0, 65, 82),
	s5: A3($mdgriffith$elm_ui$Element$rgb255, 255, 200, 190),
	l0: A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255)
};
var $author$project$UI$intToHex = function (n) {
	var getChr = function (c) {
		return (c < 10) ? $elm$core$String$fromInt(c) : $elm$core$String$fromChar(
			$elm$core$Char$fromCode(87 + c));
	};
	return (n < 16) ? getChr(n) : _Utils_ap(
		$author$project$UI$intToHex((n / 16) | 0),
		getChr(
			A2($elm$core$Basics$modBy, 16, n)));
};
var $mdgriffith$elm_ui$Element$toRgb = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {ua: a, uy: b, zk: g, Fu: r};
};
var $author$project$UI$colorToHex = function (color) {
	var _v0 = $mdgriffith$elm_ui$Element$toRgb(color);
	var red = _v0.Fu;
	var green = _v0.zk;
	var blue = _v0.uy;
	var alpha = _v0.ua;
	return '#' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$author$project$UI$intToHex(
			$elm$core$Basics$floor(red * 255))) + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$author$project$UI$intToHex(
			$elm$core$Basics$floor(green * 255))) + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$author$project$UI$intToHex(
			$elm$core$Basics$floor(blue * 255))) + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$author$project$UI$intToHex(
			$elm$core$Basics$floor(alpha * 255))))));
};
var $author$project$UI$starSvg = function (color) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$height('10'),
				$elm$svg$Svg$Attributes$viewBox('0 0 10 10'),
				$elm$svg$Svg$Attributes$width('10'),
				A2($elm$html$Html$Attributes$style, 'height', '8px'),
				A2($elm$html$Html$Attributes$style, 'width', '10px'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 1px'),
				A2($elm$html$Html$Attributes$style, 'transform', 'translateY(-2px)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.611.494c.135-.36.643-.36.778 0l.997 2.668c.059.156.205.262.371.269l2.845.124c.384.017.541.5.24.74L7.615 6.068c-.13.104-.186.275-.142.436l.761 2.744c.103.37-.309.67-.629.457L5.23 8.133c-.139-.092-.32-.092-.458 0L2.396 9.705c-.32.212-.732-.087-.63-.457l.762-2.744c.044-.16-.011-.332-.142-.436L.157 4.295c-.3-.24-.143-.723.24-.74l2.846-.124c.166-.007.312-.113.37-.27L4.612.495z'),
						$elm$svg$Svg$Attributes$fill(
						$author$project$UI$colorToHex(color))
					]),
				_List_Nil)
			]));
};
var $author$project$UI$nameWithRatingView = F2(
	function (name, rating) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-right', '8px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$repeat,
							rating,
							$author$project$UI$starSvg($author$project$UI$colors.ev)),
						A2(
							$elm$core$List$repeat,
							5 - rating,
							$author$project$UI$starSvg($author$project$UI$colors.qt))))
				]));
	});
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');
var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$Common$Images$bed = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 20 9'),
			$elm$svg$Svg$Attributes$height('9'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M2,7.99998671 L3.59660593,7.99998671 L3.59660593,12.9019682 L19.9679963,12.9019682 L19.9679963,10.0819268 L21.5945037,10.0819268 L21.5945037,16.8175998 L19.9945754,16.8175998 L19.9945754,15.1607922 L3.64152459,15.1607922 L3.64152459,16.8175998 L2,16.8175998 L2,7.99998671 Z M7.30926604,12.3868524 C7.45266023,11.0726493 8.24803949,10.2880345 9.46988025,10.2787319 C12.0372874,10.2593291 14.6049604,10.258266 17.1723676,10.2788648 C18.3940755,10.288699 19.253909,11.163284 19.2766341,12.3868524 L7.30926604,12.3868524 Z M5.43795193,12.4500574 C4.73214419,12.4586956 4.1975058,11.9410679 4.1830202,11.2352602 C4.16813591,10.5166945 4.67048071,9.97328496 5.36818182,9.95295196 C6.0898041,9.93195448 6.66617167,10.4837364 6.66723483,11.1963218 C6.6681651,11.8823281 6.11970558,12.4418179 5.43795193,12.4500574 Z'),
							$elm$svg$Svg$Attributes$id('path-1')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke('none'),
					$elm$svg$Svg$Attributes$strokeWidth('1'),
					$elm$svg$Svg$Attributes$fill('none'),
					$elm$svg$Svg$Attributes$fillRule('evenodd')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$transform('translate(-110.000000, -755.000000)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$transform('translate(108.000000, 747.000000)')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$mask,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$fill('white'),
											$elm$svg$Svg$Attributes$id('mask-2')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$use,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$xlinkHref('#path-1')
												]),
											_List_Nil)
										])),
									A2(
									$elm$svg$Svg$use,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$fill('#004152'),
											$elm$svg$Svg$Attributes$fillRule('nonzero'),
											$elm$svg$Svg$Attributes$xlinkHref('#path-1')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$mask('url(#mask-2)'),
											$elm$svg$Svg$Attributes$fill('#004152'),
											$elm$svg$Svg$Attributes$fillRule('evenodd'),
											$elm$svg$Svg$Attributes$id('bedImage')
										]),
									_List_fromArray(
										[
											A2(
											$elm$svg$Svg$rect,
											_List_fromArray(
												[
													$elm$svg$Svg$Attributes$x('0'),
													$elm$svg$Svg$Attributes$y('0'),
													$elm$svg$Svg$Attributes$width('24'),
													$elm$svg$Svg$Attributes$height('24')
												]),
											_List_Nil)
										]))
								]))
						]))
				]))
		]));
var $author$project$BookingPage$Panel$Hotel$View$selectedRoomsView = function (_arguments) {
	return A2(
		$author$project$Common$Panel$row,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('selections')
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var count = _v0.pZ;
				var name = _v0.oh;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('counterWithIcon'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'room-count')
						]),
					_List_fromArray(
						[
							$author$project$Common$Images$bed,
							A2(
							$author$project$Common$Counter$View$view,
							count,
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]))
						]));
			},
			_arguments.oS));
};
var $author$project$BookingPage$Panel$Hotel$View$selectedHotelAndRoomsDetails = F2(
	function (session, _arguments) {
		var language = session.A_;
		var market = session.rb;
		return A2(
			$author$project$Common$Panel$element,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('titleAndRating')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$nameWithRatingView, _arguments.nD, _arguments.mQ)
						])),
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('separator')
						]),
					_List_fromArray(
						[
							$author$project$Common$Panel$graySeparator(_List_Nil)
						])),
					A2($author$project$BookingPage$Panel$Hotel$View$bookingDatesView, session, _arguments),
					$author$project$BookingPage$Panel$Hotel$View$selectedRoomsView(_arguments),
					A2(
					$author$project$Common$Panel$row,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('separator')
						]),
					_List_fromArray(
						[
							$author$project$Common$Panel$graySeparator(_List_Nil)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return A2(
								$author$project$Common$Panel$row,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Common$Hotel$locationView(
										{n1: a})
									]));
						},
						_arguments.n1))
				]));
	});
var $author$project$BookingPage$Panel$Hotel$View$viewWithSelections = F2(
	function (session, _arguments) {
		var language = session.A_;
		var selectedHotelRooms = session.Gk;
		return A3(
			$author$project$BookingPage$Panel$Hotel$View$view,
			session,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hasSelectedHotelRooms',
							!$elm$core$List$isEmpty(
								$author$project$Types$Hotel$selectedRooms(selectedHotelRooms)))
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$BookingPage$Panel$Hotel$View$titleView,
					'',
					language,
					function ($) {
						return $.wG;
					}),
					A2($author$project$BookingPage$Panel$Hotel$View$selectedHotelAndRoomsDetails, session, _arguments)
				]));
	});
var $author$project$Page$Booking$compulsorySections = F2(
	function (translations, model) {
		var session = model.j;
		return A2(
			$author$project$Common$Section$view,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$BookingPage$FromTo$View$view, translations, model),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Page$Booking$shouldRenderCrabBanner(model),
					A2($author$project$Page$Booking$crabBanner, translations, session)),
					A2($author$project$Page$Booking$itineraryPanel, translations, model),
					A2($author$project$BookingPage$Panel$Passenger$View$view, translations, session),
					A2($author$project$BookingPage$Panel$TravelClass$View$view, translations, session),
					A2(
					$author$project$Utils$String$renderIf,
					session.vk === 1,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$BookingPage$Panel$Hotel$View$emptyView(session),
						A2(
							$elm$core$Maybe$map,
							$author$project$BookingPage$Panel$Hotel$View$viewWithSelections(session),
							A3($author$project$BookingPage$Panel$Hotel$View$toViewArguments, session, session.zI.zH, session.Gk))))
				]));
	});
var $author$project$Utils$Route$areBusTransfersSupported = function (_v0) {
	return false;
};
var $author$project$Utils$Route$areLandServicesSupported = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var _v1 = _Utils_Tuple3(from, to, voyageType);
	if (_v1.c.$ === 1) {
		var _v2 = _v1.c;
		return false;
	} else {
		return true;
	}
};
var $author$project$Page$Booking$backToDesktopSection = function (translations) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'back-to-desktop', '')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('backToDesktopText bodyNorm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.uF)
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('backToDesktopLink buttonText'),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$OpenedModal($author$project$Common$Modal$Model$BackToDesktop))
					]),
				$author$project$Translations$toHtml(translations.uE))
			]));
};
var $author$project$Types$OnboardServices$hasOnboardServices = function (onboardServices) {
	return !_Utils_eq(onboardServices, $author$project$Types$OnboardServices$init);
};
var $author$project$UrlRoute$getAbsoluteUrlStringForRoute = F2(
	function (route, url) {
		return A2(
			$author$project$Utils$Url$absolute,
			url,
			$author$project$UrlRoute$routeToPathSegments(route));
	});
var $author$project$UrlRoute$href = F2(
	function (url, targetRoute) {
		return $elm$html$Html$Attributes$href(
			A2($author$project$UrlRoute$getAbsoluteUrlStringForRoute, targetRoute, url));
	});
var $author$project$Common$SectionTitle$View$responsiveView = F2(
	function (language, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('responsiveSectionTitle')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('editLink link1')
						]),
					$author$project$Translations$toHtml(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.wG;
							})))
				]));
	});
var $author$project$Page$Booking$getLandServiceWithTickets = F2(
	function (selectedLandServices, service) {
		return function (list) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var others = list.b;
				return $elm$core$Maybe$Just(
					{
						Hv: A2($author$project$Utils$OneOrMore$OneOrMore, first, others),
						HI: service.HI
					});
			}
		}(
			A2(
				$elm$core$List$filterMap,
				function (_v2) {
					var maybeGroupTitle = _v2.a;
					var ticket = _v2.b;
					return A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var count = _v4.a;
							var t = _v4.b;
							return _Utils_Tuple3(count, maybeGroupTitle, t);
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (_v3) {
								var count = _v3.a;
								var t = _v3.b;
								return A2($author$project$Types$Ticket$areTicketsEqual, t, ticket) && (count > 0);
							},
							selectedLandServices));
				},
				A2(
					$elm$core$List$concatMap,
					function (_v0) {
						var ticketGroups = _v0.Hu;
						var ticketsWithoutGroup = _v0.Hw;
						var ticketsFromTicketGroups = A2(
							$elm$core$List$concatMap,
							function (_v1) {
								var title = _v1.HI;
								var tickets = _v1.Hv;
								return A2(
									$elm$core$List$map,
									function (ticket) {
										return _Utils_Tuple2(title, ticket);
									},
									tickets);
							},
							ticketGroups);
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$mapFirst($elm$core$Maybe$Just),
								ticketsFromTicketGroups),
							A2(
								$elm$core$List$map,
								function (ticket) {
									return _Utils_Tuple2($elm$core$Maybe$Nothing, ticket);
								},
								ticketsWithoutGroup));
					},
					$author$project$Utils$OneOrMore$toList(service.mq))));
	});
var $author$project$Page$Booking$ticketView = F2(
	function (language, _v0) {
		var count = _v0.a;
		var maybeGroupTitle = _v0.b;
		var ticket = _v0.c;
		var ticketNameWithGroupTitle = _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (groupTitle) {
						return _List_fromArray(
							[
								$elm$html$Html$text(groupTitle + ', ')
							]);
					},
					maybeGroupTitle)),
			A2($author$project$LandServicePage$Ticket$ticketName, language, ticket));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginTopSmall landServiceTicket')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Counter$View$view, count, ticketNameWithGroupTitle)
				]));
	});
var $author$project$Page$Booking$selectedLandServicesView = function (session) {
	var language = session.A_;
	var landServiceView = function (_v0) {
		var title = _v0.HI;
		var tickets = _v0.Hv;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyNorm marginTopMedium')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							]))
					]),
				$author$project$Utils$OneOrMore$toList(
					A2(
						$author$project$Utils$OneOrMore$map,
						$author$project$Page$Booking$ticketView(language),
						tickets))));
	};
	return A2(
		$elm$core$List$filterMap,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$map(landServiceView),
			$author$project$Page$Booking$getLandServiceWithTickets(session.Gl)),
		A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, session.AZ));
};
var $author$project$Common$ArrowLink$View$arrow = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('arrowLink')
		]),
	_List_Nil);
var $author$project$Common$ArrowLink$View$title = function (text) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('link3')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$Common$ArrowLink$View$wrapper = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('sectionWithArrowLink')
		]));
var $author$project$Common$ArrowLink$View$view = function (text) {
	return $author$project$Common$ArrowLink$View$wrapper(
		_List_fromArray(
			[
				$author$project$Common$ArrowLink$View$title(text),
				$author$project$Common$ArrowLink$View$arrow
			]));
};
var $author$project$Page$Booking$landServicePanel = function (model) {
	var session = model.j;
	var title = A2(
		$author$project$Translations$t,
		session.A_,
		(session.vk === 1) ? function ($) {
			return $.yP;
		} : function ($) {
			return $.yO;
		});
	var isDisabled = A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		true,
		A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$LandServicePage$Util$removeUnavailableLandServices(session),
				$elm$core$List$isEmpty),
			session.AZ));
	return A2(
		$author$project$Common$Panel$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('land-service-panel'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('disabledSection', isDisabled)
					]))
			]),
		_List_fromArray(
			[
				isDisabled ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mediumPadding')
					]),
				_List_fromArray(
					[
						$author$project$Common$ArrowLink$View$view(title)
					])) : (A2(
				$elm$core$List$all,
				function (_v0) {
					var count = _v0.a;
					return count <= 0;
				},
				session.Gl) ? A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mediumPadding'),
						A2($author$project$UrlRoute$href, model.n1, $author$project$UrlRoute$LandService)
					]),
				_List_fromArray(
					[
						$author$project$Common$ArrowLink$View$view(title)
					])) : A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mediumPadding'),
						A2($author$project$UrlRoute$href, model.n1, $author$project$UrlRoute$LandService)
					]),
				A2(
					$elm$core$List$cons,
					A2($author$project$Common$SectionTitle$View$responsiveView, session.A_, title),
					$author$project$Page$Booking$selectedLandServicesView(session))))
			]));
};
var $author$project$Messages$GoToSelectedTransfersPageFromBooking = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Bus$SelectedTransfers$busTransferFirstToArray = function (firstSelectedBusTransfers) {
	return A2(
		$elm$core$Array$initialize,
		1,
		function (_v0) {
			return firstSelectedBusTransfers;
		});
};
var $author$project$Types$Bus$SelectedTransfers$getFirst = function (_v0) {
	var first = _v0.nx;
	return first;
};
var $author$project$Types$Bus$SelectedTransfers$getOthers = function (_v0) {
	var others = _v0.lH;
	return others;
};
var $author$project$Common$BusTransfer$Adult = 0;
var $author$project$Common$BusTransfer$Child = 2;
var $author$project$Common$BusTransfer$Youth = 1;
var $author$project$Constants$dashString = '—';
var $author$project$BookingPage$Panel$BusTransfer$View$getBusTransfersTitleAndSeparator = function (busTransfer) {
	var _v0 = $author$project$Types$Bus$SelectedTransferPair$selectedOutward(busTransfer);
	if (!_v0.$) {
		var selectedOutwardTransfer = _v0.a;
		return A3(
			$elm$core$Basics$composeR,
			$elm$core$String$toLower,
			A2(
				$elm$core$Basics$composeR,
				$elm$html$Html$text,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					$elm$html$Html$span(_List_Nil))),
			selectedOutwardTransfer.v1);
	} else {
		var _v1 = $author$project$Types$Bus$SelectedTransferPair$selectedReturn(busTransfer);
		if (!_v1.$) {
			var selectedReturnTransfer = _v1.a;
			return A3(
				$elm$core$Basics$composeR,
				$elm$core$String$toLower,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$text,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$elm$html$Html$span(_List_Nil))),
				selectedReturnTransfer.v2);
		} else {
			return $elm$html$Html$text('');
		}
	}
};
var $author$project$Common$BusTransfer$className = function (category) {
	switch (category) {
		case 0:
			return 'adult';
		case 1:
			return 'youth';
		default:
			return 'child';
	}
};
var $author$project$Common$BusTransfer$imagePath = function (category) {
	switch (category) {
		case 0:
			return '/assets/images/passenger/icon_adult.svg';
		case 1:
			return '/assets/images/passenger/icon_youth.svg';
		default:
			return '/assets/images/passenger/icon_child.svg';
	}
};
var $author$project$Common$BusTransfer$translateCategory = F2(
	function (category, translations) {
		switch (category) {
			case 0:
				return translations.xq;
			case 1:
				return translations.xs;
			default:
				return translations.xr;
		}
	});
var $author$project$Common$BusTransfer$passengerCountView = F3(
	function (translations, count, category) {
		return (count > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Common$BusTransfer$className(category))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$Common$BusTransfer$imagePath(category)),
							$elm$html$Html$Attributes$class('icon')
						]),
					_List_Nil),
					A2(
					$author$project$Common$Counter$View$view,
					count,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Common$BusTransfer$translateCategory, category, translations))
						]))
				])) : $elm$html$Html$text('');
	});
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$BookingPage$Panel$BusTransfer$View$separator = function (isOneWayAndRouteTrip) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('separator')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' - '),
				A2(
				$author$project$Utils$String$renderIf,
				!isOneWayAndRouteTrip,
				A2($elm$html$Html$br, _List_Nil, _List_Nil))
			]));
};
var $author$project$BookingPage$Panel$BusTransfer$View$renderBlock = F5(
	function (translations, isOneWayAndRouteTrip, from, direction, busTransfer) {
		var passengersDistribution = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Types$Bus$AgeGroup$AgeGroupCounts, 0, 0, 0),
			(!direction) ? A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.po;
				},
				$author$project$Types$Bus$SelectedTransferPair$selectedOutward(busTransfer)) : A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.po;
				},
				$author$project$Types$Bus$SelectedTransferPair$selectedReturn(busTransfer)));
		var passengers = (passengersDistribution.pn > 0) ? function (_v0) {
			var adults = _v0.pn;
			var underages = _v0.H4;
			var infants = _v0.zV;
			return _List_fromArray(
				[
					A3($author$project$Common$BusTransfer$passengerCountView, translations, adults, 0),
					A3($author$project$Common$BusTransfer$passengerCountView, translations, underages, 1),
					A3($author$project$Common$BusTransfer$passengerCountView, translations, infants, 2)
				]);
		}(passengersDistribution) : _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				$author$project$Translations$toHtml($author$project$Constants$dashString))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('busTransferInfo')
				]),
			function (a) {
				return _Utils_ap(a, passengers);
			}(
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fromToBusStations')
							]),
						A2(
							$author$project$Utils$List$conditionalReverse,
							!direction,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Types$Port$translate, from, translations))
										])),
									$author$project$BookingPage$Panel$BusTransfer$View$separator(isOneWayAndRouteTrip),
									$author$project$BookingPage$Panel$BusTransfer$View$getBusTransfersTitleAndSeparator(busTransfer)
								]))))));
	});
var $author$project$BookingPage$Panel$BusTransfer$View$transfersList = F5(
	function (translations, isOneWayAndRouteTrip, from, direction, selectedBusTransfers) {
		var isOthersTransfersHasPassengers = A2(
			$elm$core$List$any,
			$elm$core$Basics$eq(true),
			$elm$core$Array$toList(
				A2(
					$elm$core$Array$map,
					$author$project$Types$Bus$SelectedTransferPair$hasPassengers,
					$author$project$Types$Bus$SelectedTransfers$getOthers(selectedBusTransfers))));
		var otherTransfers = isOthersTransfersHasPassengers ? A3(
			$elm$core$Array$foldl,
			F2(
				function (transfer, accumulator) {
					return _Utils_ap(
						accumulator,
						_List_fromArray(
							[
								A5($author$project$BookingPage$Panel$BusTransfer$View$renderBlock, translations, isOneWayAndRouteTrip, from, direction, transfer)
							]));
				}),
			_List_Nil,
			$author$project$Types$Bus$SelectedTransfers$getOthers(selectedBusTransfers)) : _List_Nil;
		var isFirstTransferHasPassengers = $author$project$Types$Bus$SelectedTransferPair$hasPassengers(
			$author$project$Types$Bus$SelectedTransfers$getFirst(selectedBusTransfers));
		var firstTransfers = isFirstTransferHasPassengers ? A3(
			$elm$core$Array$foldl,
			F2(
				function (transfer, accumulator) {
					return _Utils_ap(
						accumulator,
						_List_fromArray(
							[
								A5($author$project$BookingPage$Panel$BusTransfer$View$renderBlock, translations, isOneWayAndRouteTrip, from, direction, transfer)
							]));
				}),
			_List_Nil,
			$author$project$Types$Bus$SelectedTransfers$busTransferFirstToArray(
				$author$project$Types$Bus$SelectedTransfers$getFirst(selectedBusTransfers))) : _List_Nil;
		return _Utils_ap(firstTransfers, otherTransfers);
	});
var $author$project$BookingPage$Panel$BusTransfer$View$root = F2(
	function (translations, session) {
		var _v0 = session;
		var isOneWay = _v0.qW;
		var voyageType = _v0.tx;
		var from = _v0.kS;
		var maybeSelectedBusTransfers = _v0.B0;
		var areNotAllPassengersIncluded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$Bus$SelectedTransfers$hasPassengersWithoutBusTransfer(session),
				maybeSelectedBusTransfers));
		var isOneWayAndRouteTrip = isOneWay && _Utils_eq(voyageType, $author$project$Types$VoyageType$RouteTrip);
		var outwardTransfers = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$BookingPage$Panel$BusTransfer$View$transfersList, translations, isOneWayAndRouteTrip, from, 0),
				maybeSelectedBusTransfers));
		var returnTransfers = isOneWayAndRouteTrip ? _List_Nil : A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A4($author$project$BookingPage$Panel$BusTransfer$View$transfersList, translations, isOneWayAndRouteTrip, from, 1),
				maybeSelectedBusTransfers));
		var areAllTransfersEmpty = $elm$core$List$isEmpty(outwardTransfers) && $elm$core$List$isEmpty(returnTransfers);
		var hasPassengersWithoutBusTransfer = areNotAllPassengersIncluded && (!areAllTransfersEmpty);
		var sectionOnClickMessage = _Utils_eq(maybeSelectedBusTransfers, $elm$core$Maybe$Nothing) ? $author$project$Messages$ChangedLocation($author$project$UrlRoute$BusTransferList) : $author$project$Messages$BusTransfersMsg(
			$author$project$Messages$GoToSelectedTransfersPageFromBooking(hasPassengersWithoutBusTransfer));
		var content = (_Utils_eq(maybeSelectedBusTransfers, $elm$core$Maybe$Nothing) || areAllTransfersEmpty) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sectionWithArrowLink')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('link3')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.uG)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.uH)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('arrowLink')
						]),
					_List_Nil)
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sectionTitle title2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(translations.xM)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('editLink')
								]),
							$author$project$Translations$toHtml(translations.wG))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm busTransferInfoHolder')
						]),
					_Utils_ap(outwardTransfers, returnTransfers))
				]));
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'view', 'busTransfer'),
					$elm$html$Html$Events$onClick(sectionOnClickMessage),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'busTransfer'),
					$elm$html$Html$Attributes$id('bustransfer-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('busTransferSection mediumPadding'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('isOneWay', isOneWayAndRouteTrip),
									_Utils_Tuple2('isToastVisible', hasPassengersWithoutBusTransfer)
								]))
						]),
					_List_fromArray(
						[content])),
					A2(
					$author$project$Utils$String$renderIf,
					hasPassengersWithoutBusTransfer,
					A2($author$project$Common$Toast$View$view, 1, translations.HR))
				]));
	});
var $author$project$Common$ArrowLink$View$content = function (text) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyNorm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$Common$ArrowLink$View$viewWithContent = F2(
	function (titleText, contentText) {
		return $author$project$Common$ArrowLink$View$wrapper(
			_List_fromArray(
				[
					$author$project$Common$ArrowLink$View$title(titleText),
					$author$project$Common$ArrowLink$View$content(contentText),
					$author$project$Common$ArrowLink$View$arrow
				]));
	});
var $author$project$BookingPage$Panel$Sitting$View$arrowNodePartial = F2(
	function (language, str) {
		return A2(
			$author$project$Common$ArrowLink$View$viewWithContent,
			A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.u5;
				}),
			str);
	});
var $author$project$Types$Meals$canBookOnline = F2(
	function (isOneWay, _v0) {
		var outwardCanBeBookedOnline = _v0.Dt;
		var returnCanBeBookedOnline = _v0.FM;
		return isOneWay ? outwardCanBeBookedOnline : (outwardCanBeBookedOnline || returnCanBeBookedOnline);
	});
var $author$project$BookingPage$Panel$Sitting$View$canBookOnline = F2(
	function (isOneWay, maybeMeals) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$Meals$canBookOnline(isOneWay),
				maybeMeals));
	});
var $author$project$Types$TravelClasses$hasSelectedTravelClasses = function (travelClasses) {
	switch (travelClasses.$) {
		case 0:
			var selected = travelClasses.a.Gg;
			return !$elm$core$String$isEmpty(selected);
		case 1:
			var outward = travelClasses.a.Ds;
			var _return = travelClasses.a.FL;
			return (!$elm$core$String$isEmpty(outward)) && (!$elm$core$String$isEmpty(_return));
		case 2:
			var selected = travelClasses.a.Gg;
			return !$elm$core$List$isEmpty(selected);
		default:
			var outward = travelClasses.a.Ds;
			var _return = travelClasses.a.FL;
			return (!$elm$core$List$isEmpty(outward)) && (!$elm$core$List$isEmpty(_return));
	}
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Common$MealSection$View$coupon = function (_v0) {
	var title = _v0.HI;
	var count = _v0.pZ;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('row')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title bodyNorm')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Common$Counter$View$view,
						count,
						$author$project$Translations$toHtml(title))
					]))
			]));
};
var $author$project$Common$MealSection$View$coupons = function (_arguments) {
	return A2(
		$elm$core$List$map,
		$author$project$Common$MealSection$View$coupon,
		A2(
			$elm$core$List$filter,
			function (_v0) {
				var code = _v0.pQ;
				return !A2(
					$elm$core$List$any,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(code)),
					_Utils_ap(_arguments.Dv, _arguments.FO));
			},
			_arguments.Ce));
};
var $author$project$Common$MealSection$View$freeMealPackage = F2(
	function (attributes, _v0) {
		var passengers = _v0.Eg;
		var name = _v0.oh;
		var code = _v0.pQ;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'free-meal-package'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'data-restaurant-code', code),
					attributes)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title bodyNorm')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Common$Counter$View$view,
							passengers.pn + passengers.H4,
							$author$project$Translations$toHtml(name))
						]))
				]));
	});
var $author$project$Common$MealSection$View$hasOutwardMeals = function (_v0) {
	var outwards = _v0.DC;
	var outwardFreeMealPackages = _v0.Dv;
	return !($elm$core$List$isEmpty(outwards) && $elm$core$List$isEmpty(outwardFreeMealPackages));
};
var $author$project$Common$MealSection$View$mealsRow = F2(
	function (_arguments, _v0) {
		var maybeA = _v0.a;
		var maybeB = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row clearfix'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'hasOutward',
							$author$project$Common$MealSection$View$hasOutwardMeals(_arguments))
						]))
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[maybeA, maybeB])));
	});
var $author$project$Common$MealSection$View$freeMealPackages = function (_arguments) {
	var outwardFreeMealPackages = _arguments.Dv;
	var returnFreeMealPackages = _arguments.FO;
	return A2(
		$elm$core$List$map,
		$author$project$Common$MealSection$View$mealsRow(_arguments),
		A2(
			$author$project$Utils$List$zipToMaybes,
			A2(
				$elm$core$List$map,
				$author$project$Common$MealSection$View$freeMealPackage(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('outward')
						])),
				outwardFreeMealPackages),
			A2(
				$elm$core$List$map,
				$author$project$Common$MealSection$View$freeMealPackage(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('return')
						])),
				returnFreeMealPackages)));
};
var $author$project$Common$MealSection$View$hasReturnMeals = function (_v0) {
	var returns = _v0.FV;
	var returnFreeMealPackages = _v0.FO;
	return !($elm$core$List$isEmpty(returns) && $elm$core$List$isEmpty(returnFreeMealPackages));
};
var $author$project$Common$MealSection$View$fromTo = function (_arguments) {
	var from = _arguments.kS;
	var to = _arguments.le;
	var translations = _arguments.lY;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fromToNode bodyNorm')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Utils$Html$Render$renderIf,
				$author$project$Common$MealSection$View$hasOutwardMeals(_arguments),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fromTo')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$MealPage$Common$shortRouteString,
								translations,
								_List_fromArray(
									[from, to])))
						]))),
				A2(
				$author$project$Utils$Html$Render$renderIf,
				$author$project$Common$MealSection$View$hasReturnMeals(_arguments),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('toFrom')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$MealPage$Common$shortRouteString,
								translations,
								_List_fromArray(
									[to, from])))
						])))
			]));
};
var $author$project$Common$MealSection$View$mealPackageView = function (_v0) {
	var count = _v0.pZ;
	var title = _v0.HI;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mealPackageTitle')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Common$Counter$View$view,
				count,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]))
			]));
};
var $author$project$Common$MealSection$View$detailedAddon = function (_v0) {
	var count = _v0.pZ;
	var description = _v0.nt;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('detailedAddon')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Common$Counter$View$view,
				count,
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					]))
			]));
};
var $author$project$Common$MealSection$View$detailedAddons = function (addons) {
	var detailedAddonGroup = function (toAddons) {
		var addonList = toAddons(addons);
		return A2(
			$author$project$Utils$Html$Render$renderIf,
			!$elm$core$List$isEmpty(addonList),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('detailedAddonsGroup')
					]),
				A2($elm$core$List$map, $author$project$Common$MealSection$View$detailedAddon, addonList)));
	};
	return _List_fromArray(
		[
			detailedAddonGroup(
			function ($) {
				return $.y6;
			}),
			detailedAddonGroup(
			function ($) {
				return $.GR;
			}),
			detailedAddonGroup(
			function ($) {
				return $.BD;
			}),
			detailedAddonGroup(
			function ($) {
				return $.ys;
			}),
			detailedAddonGroup(
			function ($) {
				return $.yE;
			}),
			detailedAddonGroup(
			function ($) {
				return $.x3;
			})
		]);
};
var $author$project$Types$MealType$translate = function (mealType) {
	switch (mealType) {
		case 0:
			return function ($) {
				return $.wQ;
			};
		case 1:
			return function ($) {
				return $.wR;
			};
		case 2:
			return function ($) {
				return $.wU;
			};
		default:
			return function ($) {
				return $.wT;
			};
	}
};
var $author$project$Common$MealSection$View$meal = F3(
	function (attributes, _v0, _v1) {
		var translations = _v0.lY;
		var locale = _v0.n0;
		var showDetailedAddons = _v0.GB;
		var title = _v1.HI;
		var beginDateTime = _v1.ut;
		var restaurantCode = _v1.FJ;
		var addons = _v1.tS;
		var passengers = _v1.Eg;
		var maybeType = _v1.Cc;
		var mealType = $author$project$Types$Meals$getMealType(
			{ut: beginDateTime, BU: maybeType});
		var beginTimeString = A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekdayHourMinute, beginDateTime);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'sitting'),
						A2(
						$elm$html$Html$Attributes$attribute,
						'data-begin-time',
						$author$project$Utils$Time$toDateTimeString(beginDateTime)),
						A2($elm$html$Html$Attributes$attribute, 'data-restaurant-code', restaurantCode)
					]),
				attributes),
			A3(
				$author$project$Utils$List$appendIf,
				showDetailedAddons,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Common$MealSection$View$detailedAddons, addons)),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title bodyNorm')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Counter$View$view,
								passengers.pn + passengers.H4,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Types$MealType$translate, mealType, translations))
									]))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('type data')
							]),
						$author$project$Translations$toHtml(title)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('date bodyLight')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(beginTimeString)
							]))
					])));
	});
var $author$project$Common$MealSection$View$meals = function (_arguments) {
	var outwards = _arguments.DC;
	var returns = _arguments.FV;
	return A2(
		$elm$core$List$map,
		$author$project$Common$MealSection$View$mealsRow(_arguments),
		A2(
			$author$project$Utils$List$zipToMaybes,
			A2(
				$elm$core$List$map,
				A2(
					$author$project$Common$MealSection$View$meal,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('outward')
						]),
					_arguments),
				outwards),
			A2(
				$elm$core$List$map,
				A2(
					$author$project$Common$MealSection$View$meal,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('return')
						]),
					_arguments),
				returns)));
};
var $author$project$Common$MealSection$View$view = function (_arguments) {
	return A2(
		$elm$core$List$cons,
		A2($author$project$Utils$Html$Render$maybeRender, $author$project$Common$MealSection$View$mealPackageView, _arguments.BT),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				function (a) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm marginBottomMedium')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(a)
							]));
				},
				_arguments.wq),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Utils$Html$Render$renderIf,
						_arguments.IB,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm marginBottomMedium')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(_arguments.lY.zW)
								])))
					]),
				_Utils_ap(
					$author$project$Common$MealSection$View$coupons(_arguments),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$author$project$Utils$Html$Render$renderIf,
								($author$project$Common$MealSection$View$hasOutwardMeals(_arguments) || $author$project$Common$MealSection$View$hasReturnMeals(_arguments)) && (!_Utils_eq(_arguments.tx, $author$project$Types$VoyageType$CruiseMultistop)),
								$author$project$Common$MealSection$View$fromTo(_arguments))
							]),
						_Utils_ap(
							$author$project$Common$MealSection$View$meals(_arguments),
							$author$project$Common$MealSection$View$freeMealPackages(_arguments)))))));
};
var $author$project$Common$SectionTitle$View$view = F2(
	function (translations, translateTitle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sectionTitle title2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							translateTitle(translations))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('editLink')
						]),
					$author$project$Translations$toHtml(translations.wG))
				]));
	});
var $author$project$BookingPage$Panel$Sitting$View$mealListNode = function (_v0) {
	var translations = _v0.lY;
	var session = _v0.j;
	var outwardMeals = _v0.rR;
	var returnMeals = _v0.sv;
	var mealPackages = _v0.rs;
	var maybeMealPackage = A2(
		$elm$core$Maybe$map,
		function (title) {
			return {
				pZ: $elm$core$Array$length(session.Eg),
				HI: title
			};
		},
		A2(
			$elm$core$Maybe$map,
			function (_v2) {
				var name = _v2.oh;
				return A2(
					$author$project$Translations$t,
					session.A_,
					function ($) {
						return $.Cm;
					}) + (': ' + name);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return A2(
						$elm_community$list_extra$List$Extra$find,
						function (_v1) {
							var code = _v1.pQ;
							return _Utils_eq(code, a);
						},
						mealPackages);
				},
				session.B2)));
	var comments = $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.wo;
			},
			_Utils_ap(
				$author$project$Types$SelectedMeals$toList(session.Gn),
				$author$project$Types$SelectedMeals$toList(session.Go))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sittingsInfo')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Common$SectionTitle$View$view,
				translations,
				function ($) {
					return $.u8;
				}),
			$author$project$Common$MealSection$View$view(
				{
					wq: comments,
					kS: session.kS,
					n0: A2($author$project$Types$Locale$Locale, session.A_, session.rb),
					BT: maybeMealPackage,
					Ce: _List_Nil,
					Dv: _List_Nil,
					DC: outwardMeals,
					FO: _List_Nil,
					FV: returnMeals,
					GB: false,
					le: session.le,
					lY: translations,
					tx: session.tx,
					IB: false
				})));
};
var $author$project$BookingPage$Panel$Sitting$View$regular = function (_v0) {
	var translations = _v0.lY;
	var session = _v0.j;
	var mealPackages = _v0.rs;
	var returns = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rv;
				},
				function ($) {
					return $.FV;
				}),
			session.B7));
	var outwards = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rv;
				},
				function ($) {
					return $.DC;
				}),
			session.B7));
	var hasSelectedMeals = (!($elm$core$List$isEmpty(outwards) && $elm$core$List$isEmpty(returns))) || (!_Utils_eq(session.B2, $elm$core$Maybe$Nothing));
	var _v1 = session;
	var language = _v1.A_;
	var maybeMeals = _v1.ri;
	var isOneWay = _v1.qW;
	return _Utils_eq(maybeMeals, $elm$core$Maybe$Nothing) ? A2(
		$author$project$BookingPage$Panel$Sitting$View$arrowNodePartial,
		language,
		A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.u6;
			})) : ((!A2($author$project$BookingPage$Panel$Sitting$View$canBookOnline, isOneWay, maybeMeals)) ? A2(
		$author$project$BookingPage$Panel$Sitting$View$arrowNodePartial,
		language,
		A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.wW;
			})) : (((!hasSelectedMeals) && (!_Utils_eq(maybeMeals, $elm$core$Maybe$Nothing))) ? A2(
		$author$project$BookingPage$Panel$Sitting$View$arrowNodePartial,
		language,
		A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.u7;
			})) : $author$project$BookingPage$Panel$Sitting$View$mealListNode(
		{rs: mealPackages, rR: outwards, sv: returns, j: session, lY: translations})));
};
var $author$project$BookingPage$Panel$Sitting$View$mealsSectionInfo = F2(
	function (translations, session) {
		var _v0 = session.rs;
		if (_v0.$ === 1) {
			return A2(
				$author$project$BookingPage$Panel$Sitting$View$arrowNodePartial,
				session.A_,
				A2(
					$author$project$Translations$t,
					session.A_,
					function ($) {
						return $.Cr;
					}));
		} else {
			var mealPackage = _v0.a;
			return $author$project$BookingPage$Panel$Sitting$View$regular(
				{rs: mealPackage, j: session, lY: translations});
		}
	});
var $author$project$BookingPage$Panel$Sitting$View$root = F2(
	function (translations, session) {
		var maybeMeals = session.ri;
		var language = session.A_;
		var isOneWay = session.qW;
		var hasTravelClasses = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Types$TravelClasses$hasSelectedTravelClasses, session.to));
		var isDisabled = function () {
			var _v0 = session.rs;
			if (_v0.$ === 1) {
				return !hasTravelClasses;
			} else {
				return (!hasTravelClasses) || (_Utils_eq(maybeMeals, $elm$core$Maybe$Nothing) || (!A2($author$project$BookingPage$Panel$Sitting$View$canBookOnline, isOneWay, maybeMeals)));
			}
		}();
		var clickEventAttribute = hasTravelClasses ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Messages$ChangedLocation($author$project$UrlRoute$Meal))
			]) : _List_Nil;
		return A2(
			$author$project$Common$Panel$view,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mealPanel mediumPadding'),
						A2($elm$html$Html$Attributes$attribute, 'view', 'mealSelection'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('disabledSection', isDisabled)
							])),
						$elm$html$Html$Attributes$id('meal-panel'),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'meal-panel')
					]),
				clickEventAttribute),
			_List_fromArray(
				[
					(!hasTravelClasses) ? A2(
					$author$project$BookingPage$Panel$Sitting$View$arrowNodePartial,
					language,
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.xt;
						})) : A2($author$project$BookingPage$Panel$Sitting$View$mealsSectionInfo, translations, session)
				]));
	});
var $author$project$Messages$ClickedVehicles = {$: 59};
var $author$project$BookingPage$Panel$Vehicle$View$getLicencePlateCount = function (carCategory) {
	return A2(
		$elm$core$Basics$composeR,
		$elm_community$list_extra$List$Extra$find(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jZ;
				},
				$elm$core$Basics$eq(carCategory))),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				function ($) {
					return $.A9;
				}),
			$elm$core$Maybe$withDefault(0)));
};
var $author$project$BookingPage$Panel$Vehicle$View$hasEmptyLicensePlate = F2(
	function (licensePlateCount, selectedVehicle) {
		switch (licensePlateCount) {
			case 1:
				return _Utils_eq(selectedVehicle.n_, $elm$core$Maybe$Nothing);
			case 2:
				return _Utils_eq(selectedVehicle.n_, $elm$core$Maybe$Nothing) || _Utils_eq(selectedVehicle.n$, $elm$core$Maybe$Nothing);
			default:
				return false;
		}
	});
var $author$project$BookingPage$Panel$Vehicle$View$hasVehicleWithEmptyLicencePlate = function (vehicles) {
	var isAnyLicensePlateEmpty = function (vehicle) {
		return A2(
			$author$project$BookingPage$Panel$Vehicle$View$hasEmptyLicensePlate,
			A2($author$project$BookingPage$Panel$Vehicle$View$getLicencePlateCount, vehicle.jZ, vehicles),
			vehicle);
	};
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$SelectedVehicles$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$list_extra$List$Extra$find(isAnyLicensePlateEmpty),
			$elm$core$Basics$neq($elm$core$Maybe$Nothing)));
};
var $author$project$BookingPage$Panel$Vehicle$View$countVehiclesByCodeAndVoyageType = F3(
	function (vehicles, code, vehicleVoyageType) {
		return $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var voyageType = _v0.tx;
					var carCategory = _v0.jZ;
					return _Utils_eq(carCategory, code) && (_Utils_eq(
						voyageType,
						$elm$core$Maybe$Just(vehicleVoyageType)) || _Utils_eq(
						voyageType,
						$elm$core$Maybe$Just(0)));
				},
				vehicles));
	});
var $author$project$BookingPage$Panel$Vehicle$View$hasShopperVehicle = function (carCategory) {
	return (carCategory === 8) || (carCategory === 9);
};
var $author$project$Utils$List$maybeAppendWithMap = F3(
	function (maybeB, map, aList) {
		return A2(
			$elm$core$Maybe$withDefault,
			aList,
			A2(
				$elm$core$Maybe$map,
				function (b) {
					return _Utils_ap(
						aList,
						map(b));
				},
				maybeB));
	});
var $author$project$BookingPage$Panel$Vehicle$Surcharges$description = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('surchargesDescription bodyNorm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.Ie)
			]));
};
var $author$project$BookingPage$Panel$Vehicle$Surcharges$getSurchargeText = F3(
	function (name, market, _v0) {
		var price = _v0.lN;
		var count = _v0.pZ;
		var formattedPrice = A2($author$project$Types$Market$formatPriceWithSign, market, price);
		return $elm$core$String$fromInt(count) + (' x ' + (name + (' ' + formattedPrice)));
	});
var $author$project$BookingPage$Panel$Vehicle$Surcharges$surcharge = function (textString) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('surcharge bodyNorm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(textString)
			]));
};
var $author$project$BookingPage$Panel$Vehicle$Surcharges$surcharges = F2(
	function (translations, market) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2($author$project$BookingPage$Panel$Vehicle$Surcharges$getSurchargeText, translations.Id, market)),
			$elm$core$List$map($author$project$BookingPage$Panel$Vehicle$Surcharges$surcharge));
	});
var $author$project$BookingPage$Panel$Vehicle$Surcharges$root = F4(
	function (translations, _v0, isOneWayVisual, _v1) {
		var market = _v0.rb;
		var surchargesContainer = _v1.s6;
		var vehicleCombinedSurcharges = surchargesContainer.Ic;
		var hasSurcharges = isOneWayVisual ? (!$elm$core$List$isEmpty(vehicleCombinedSurcharges.Ds)) : ((!$elm$core$List$isEmpty(vehicleCombinedSurcharges.Ds)) || (!$elm$core$List$isEmpty(vehicleCombinedSurcharges.FL)));
		return (!hasSurcharges) ? _List_Nil : (isOneWayVisual ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('vehicleRow')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('surcharges')
							]),
						A3($author$project$BookingPage$Panel$Vehicle$Surcharges$surcharges, translations, market, vehicleCombinedSurcharges.Ds))
					])),
				$author$project$BookingPage$Panel$Vehicle$Surcharges$description(translations)
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('vehicleRow')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('column left')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Utils$Html$Render$renderIf,
								!$elm$core$List$isEmpty(vehicleCombinedSurcharges.Ds),
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('surcharges')
										]),
									A3($author$project$BookingPage$Panel$Vehicle$Surcharges$surcharges, translations, market, vehicleCombinedSurcharges.Ds)))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('column right')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Utils$Html$Render$renderIf,
								!$elm$core$List$isEmpty(vehicleCombinedSurcharges.FL),
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('surcharges')
										]),
									A3($author$project$BookingPage$Panel$Vehicle$Surcharges$surcharges, translations, market, vehicleCombinedSurcharges.FL)))
							]))
					])),
				$author$project$BookingPage$Panel$Vehicle$Surcharges$description(translations)
			]));
	});
var $author$project$BookingPage$Panel$Vehicle$View$isShoperOrParkedCarCategory = function (carCategory) {
	switch (carCategory) {
		case 8:
			return true;
		case 9:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 10:
			return true;
		default:
			return false;
	}
};
var $author$project$Types$Vehicle$translateCategory = function (category) {
	switch (category) {
		case 1:
			return function ($) {
				return $.a1;
			};
		case 2:
			return function ($) {
				return $.a1;
			};
		case 3:
			return function ($) {
				return $.a2;
			};
		case 15:
			return function ($) {
				return $.bf;
			};
		case 16:
			return function ($) {
				return $.bg;
			};
		case 13:
			return function ($) {
				return $.be;
			};
		case 14:
			return function ($) {
				return $.bd;
			};
		case 12:
			return function ($) {
				return $.bc;
			};
		case 11:
			return function ($) {
				return $.bb;
			};
		case 6:
			return function ($) {
				return $.a6;
			};
		case 7:
			return function ($) {
				return $.a6;
			};
		case 10:
			return function ($) {
				return $.eZ;
			};
		case 0:
			return function ($) {
				return $.a0;
			};
		case 4:
			return function ($) {
				return $.a4;
			};
		case 5:
			return function ($) {
				return $.a5;
			};
		case 8:
			return function ($) {
				return $.a8;
			};
		default:
			return function ($) {
				return $.a9;
			};
	}
};
var $author$project$Common$Images$Vehicles$vehicleImage = function (code) {
	var imgName = A2(
		$elm$core$String$join,
		'_',
		A2(
			$elm$core$String$split,
			' ',
			$elm$core$String$toLower(code)));
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/icon_' + (imgName + '.svg'))
			]),
		_List_Nil);
};
var $author$project$BookingPage$Panel$Vehicle$View$selectedVehicleInformationView = F3(
	function (translations, carCategory, count) {
		return (!count) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('data')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(' - - ')
					]))
			]) : A3(
			$author$project$Utils$List$addIf,
			$author$project$BookingPage$Panel$Vehicle$View$isShoperOrParkedCarCategory(carCategory),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('noCarDrivingInDestination bodyNorm')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.CK)
					])),
			_List_fromArray(
				[
					$author$project$Common$Images$Vehicles$vehicleImage(
					$author$project$Types$Vehicle$carCategoryToString(carCategory)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'selected-vehicle-node')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Common$Counter$View$view,
							count,
							$author$project$Translations$toHtml(
								A2($author$project$Types$Vehicle$translateCategory, carCategory, translations)))
						]))
				]));
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$BookingPage$Panel$Vehicle$View$selectedVehiclesView = F3(
	function (translations, session, selectedVehicles) {
		var voyageType = session.tx;
		var isOneWay = session.qW;
		var from = session.kS;
		var to = session.le;
		var maybeSummary = session.B7;
		var isWithShopperVehicle = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jZ;
				},
				$author$project$BookingPage$Panel$Vehicle$View$hasShopperVehicle),
			selectedVehicles);
		var isOneWayVisual = isOneWay || (_Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) || isWithShopperVehicle);
		return A3(
			$author$project$Utils$List$maybeAppendWithMap,
			maybeSummary,
			A3($author$project$BookingPage$Panel$Vehicle$Surcharges$root, translations, session, isOneWayVisual),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Common$SectionTitle$View$view,
						translations,
						function ($) {
							return $.xz;
						}),
						A4($author$project$Common$FromTo$View$root, translations, isOneWayVisual, from, to)
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var carCategory = _v0.jZ;
						var selectedVehicleInformationViewForCarCategory = A2($author$project$BookingPage$Panel$Vehicle$View$selectedVehicleInformationView, translations, carCategory);
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('vehicleRow'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-test-vehicle-code',
									$author$project$Types$Vehicle$carCategoryToString(carCategory)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('hasBottomPadding', (carCategory === 8) || ((carCategory === 9) || (carCategory === 6)))
										]))
								]),
							isOneWayVisual ? selectedVehicleInformationViewForCarCategory(
								A3($author$project$BookingPage$Panel$Vehicle$View$countVehiclesByCodeAndVoyageType, selectedVehicles, carCategory, 1)) : _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column left')
										]),
									selectedVehicleInformationViewForCarCategory(
										A3($author$project$BookingPage$Panel$Vehicle$View$countVehiclesByCodeAndVoyageType, selectedVehicles, carCategory, 1))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column right')
										]),
									selectedVehicleInformationViewForCarCategory(
										A3($author$project$BookingPage$Panel$Vehicle$View$countVehiclesByCodeAndVoyageType, selectedVehicles, carCategory, 2)))
								]));
					},
					A2(
						$elm_community$list_extra$List$Extra$uniqueBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jZ;
							},
							$author$project$Types$Vehicle$carCategoryToString),
						selectedVehicles))));
	});
var $author$project$BookingPage$Panel$Vehicle$View$root = F3(
	function (translations, session, isVehiclePrefilledToastVisible) {
		var hasVehicleWithoutLicencePlate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$BookingPage$Panel$Vehicle$View$hasVehicleWithEmptyLicencePlate(session.tt),
				session.rp));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'view', 'vehicleSelection'),
					$elm$html$Html$Attributes$class('panel'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'vehicle-section'),
					$elm$html$Html$Attributes$id('vehicle-panel'),
					$elm$html$Html$Events$onClick($author$project$Messages$ClickedVehicles)
				]),
			A3(
				$author$project$Utils$List$addIf,
				isVehiclePrefilledToastVisible && (!hasVehicleWithoutLicencePlate),
				A2($author$project$Common$Toast$View$view, 1, translations.HP),
				A3(
					$author$project$Utils$List$addIf,
					hasVehicleWithoutLicencePlate,
					A2($author$project$Common$Toast$View$view, 0, translations.vm),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_fromArray(
									[
										$author$project$Common$ArrowLink$View$view(translations.vl)
									]),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Types$SelectedVehicles$toList,
										A2($author$project$BookingPage$Panel$Vehicle$View$selectedVehiclesView, translations, session)),
									session.rp)))
						]))));
	});
var $author$project$BookingPage$Panel$ExtraServices$View$servicesOnlyIfBothDirectionsNotEmpty = function (extraServices) {
	return ((!$elm$core$List$isEmpty(extraServices.rP)) || (!$elm$core$List$isEmpty(extraServices.st))) ? $elm$core$Maybe$Just(extraServices) : $elm$core$Maybe$Nothing;
};
var $author$project$Types$SelectedExtraServices$withNameAndCountForDirection = F3(
	function (direction, _v0, available) {
		var selected = _v0;
		var create = function (code) {
			return A2(
				$elm$core$Maybe$andThen,
				function (service) {
					return ((!direction) && service.nS) ? $elm$core$Maybe$Just(
						{pQ: service.pQ, pZ: 1, oh: service.oh}) : $elm$core$Maybe$Nothing;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(code)),
					available));
		};
		return A3(
			$elm$core$List$foldl,
			F2(
				function (code, selectedServices) {
					return A2(
						$elm$core$Maybe$withDefault,
						selectedServices,
						A2(
							$elm$core$Maybe$map,
							function (a) {
								return A2($elm$core$List$cons, a, selectedServices);
							},
							create(code)));
				}),
			_List_Nil,
			$elm$core$Dict$values(selected));
	});
var $author$project$Types$SelectedExtraServices$withNameAndCount = F2(
	function (available, _v0) {
		var outwards = _v0.DC;
		var returns = _v0.FV;
		return {
			rP: A3($author$project$Types$SelectedExtraServices$withNameAndCountForDirection, 0, outwards, available),
			st: A3($author$project$Types$SelectedExtraServices$withNameAndCountForDirection, 1, returns, available)
		};
	});
var $author$project$BookingPage$Panel$ExtraServices$View$getServices = function (_v0) {
	var maybeSummary = _v0.B7;
	var extraServices = _v0.qk;
	var selectedExtraServices = _v0.Gi;
	return A2(
		$author$project$Types$Maybe$Util$orElse,
		$author$project$BookingPage$Panel$ExtraServices$View$servicesOnlyIfBothDirectionsNotEmpty(
			A2($author$project$Types$SelectedExtraServices$withNameAndCount, extraServices, selectedExtraServices)),
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeL,
				$author$project$BookingPage$Panel$ExtraServices$View$servicesOnlyIfBothDirectionsNotEmpty,
				function ($) {
					return $.qk;
				}),
			maybeSummary));
};
var $author$project$BookingPage$Panel$ExtraServices$View$servicesToNameCountAndCodeList = $elm$core$List$map(
	function (_v0) {
		var name = _v0.oh;
		var count = _v0.pZ;
		var code = _v0.pQ;
		return {pQ: code, pZ: count, oh: name};
	});
var $author$project$Common$ExtraServices$servicesView = function (services) {
	return function (viewList) {
		return $elm$core$List$isEmpty(viewList) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('data')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('- -')
					]))
			]) : viewList;
	}(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, serviceData) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'marginBottomSmall',
										!_Utils_eq(
											index,
											$elm$core$List$length(services) - 1))
									])),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-test-extra-service-code',
								$author$project$Types$ExtraService$codeToString(serviceData.pQ))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Common$Counter$View$view,
								serviceData.pZ,
								_List_fromArray(
									[
										$elm$html$Html$text(serviceData.oh)
									]))
							]));
				}),
			services));
};
var $author$project$Common$ExtraServices$view = F6(
	function (translations, outwards, returns, from, to, isOneWay) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$List$head,
			A2(
				$elm$core$List$partition,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$author$project$Types$ExtraService$isInsurance),
				returns));
		var maybeReturnInsurance = _v0.a;
		var otherReturnServices = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$List$head,
			A2(
				$elm$core$List$partition,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$author$project$Types$ExtraService$isInsurance),
				outwards));
		var maybeOutwardInsurance = _v1.a;
		var otherOutwardServices = _v1.b;
		var maybeInsurance = A2($author$project$Types$Maybe$Util$orElse, maybeReturnInsurance, maybeOutwardInsurance);
		var hasExtraServices = (!$elm$core$List$isEmpty(otherOutwardServices)) || (!$elm$core$List$isEmpty(otherReturnServices));
		var otherExtraServices = hasExtraServices ? (isOneWay ? $author$project$Common$ExtraServices$servicesView(otherOutwardServices) : _List_fromArray(
			[
				A4($author$project$Common$FromTo$View$root, translations, isOneWay, from, to),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('displayFlex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('paddingRightMedium flex1')
							]),
						$author$project$Common$ExtraServices$servicesView(otherOutwardServices)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('paddingLeftMedium flex1')
							]),
						$author$project$Common$ExtraServices$servicesView(otherReturnServices))
					]))
			])) : _List_Nil;
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var count = _v2.pZ;
						var name = _v2.oh;
						var code = _v2.pQ;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('marginBottomMedium', hasExtraServices && (!isOneWay)),
												_Utils_Tuple2('marginBottomSmall', hasExtraServices && isOneWay)
											])),
										A2(
										$elm$html$Html$Attributes$attribute,
										'data-test-extra-service-code',
										$author$project$Types$ExtraService$codeToString(code))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Common$Counter$View$view,
										count,
										_List_fromArray(
											[
												$elm$html$Html$text(name)
											]))
									]))
							]);
					},
					maybeInsurance)),
			otherExtraServices);
	});
var $author$project$BookingPage$Panel$ExtraServices$View$view = F2(
	function (session, translations) {
		var extraServices = function () {
			var _v1 = A2(
				$elm$core$List$map,
				function ($) {
					return $.oh;
				},
				session.qk);
			if (_v1.b) {
				var first = _v1.a;
				var others = _v1.b;
				return A2(
					$elm$core$String$join,
					', ',
					A2(
						$elm$core$List$cons,
						$author$project$Utils$String$capitalize(first),
						A2($elm$core$List$map, $elm$core$String$toLower, others)));
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('extraServices')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mediumPadding'),
							$elm$html$Html$Events$onClick(
							$author$project$Messages$ChangedLocation($author$project$UrlRoute$ExtraServices)),
							A2($elm$html$Html$Attributes$attribute, 'view', 'extraServices'),
							$elm$html$Html$Attributes$id('extraservices-panel')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							[
								A2($author$project$Common$ArrowLink$View$viewWithContent, translations.uP, extraServices)
							]),
						A2(
							$elm$core$Maybe$map,
							function (_v0) {
								var outwardExtraServices = _v0.rP;
								var returnExtraServices = _v0.st;
								return _Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('sectionTitle title2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(translations.yY)
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('editLink')
														]),
													$author$project$Translations$toHtml(translations.wG))
												]))
										]),
									A6(
										$author$project$Common$ExtraServices$view,
										translations,
										$author$project$BookingPage$Panel$ExtraServices$View$servicesToNameCountAndCodeList(outwardExtraServices),
										$author$project$BookingPage$Panel$ExtraServices$View$servicesToNameCountAndCodeList(returnExtraServices),
										session.kS,
										session.le,
										session.qW));
							},
							$author$project$BookingPage$Panel$ExtraServices$View$getServices(session))))
				]));
	});
var $author$project$Utils$List$appendIfListNotEmpty = F3(
	function (testableList, mapping, appendableList) {
		return $elm$core$List$isEmpty(testableList) ? appendableList : _Utils_ap(
			appendableList,
			_List_fromArray(
				[
					mapping(testableList)
				]));
	});
var $author$project$BookingPage$Panel$OnboardService$View$getOnboardServices = function (session) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var outwardServices = _v0.ot;
			var returnServices = _v0.oL;
			return ($elm$core$List$isEmpty(outwardServices) && $elm$core$List$isEmpty(returnServices)) ? $elm$core$Maybe$Nothing : ($author$project$Utils$Route$isShoppingCruise(session.tx) ? $elm$core$Maybe$Just(
				{
					ot: _Utils_ap(outwardServices, returnServices),
					oL: _List_Nil
				}) : $elm$core$Maybe$Just(
				{ot: outwardServices, oL: returnServices}));
		},
		A2(
			$elm$core$Maybe$withDefault,
			A3(
				$author$project$Types$SelectedOnboardServices$onboardServicesFromSelected,
				$elm$core$Array$toList(session.Eg),
				session.rI,
				session.Gm),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.rI;
					},
					$elm$core$Maybe$Just),
				session.B7)));
};
var $author$project$Utils$Route$isCruiseOrCruiseMultiship = function (voyageType) {
	return _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) || (_Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultiship) || _Utils_eq(
		voyageType,
		$author$project$Types$VoyageType$CruiseMultiDeparture(0)));
};
var $author$project$Common$SelectedOnboardServicesView$changeShipMoneyCouponName = F2(
	function (translations, service) {
		return (service.km === 7) ? _Utils_update(
			service,
			{
				kD: A2(
					$elm$core$List$map,
					function (addon) {
						return _Utils_update(
							addon,
							{oh: addon.oh + (' ' + translations.Df)});
					},
					service.kD)
			}) : service;
	});
var $author$project$Common$SelectedOnboardServicesView$diningView = function (model) {
	var language = model.A_;
	var market = model.rb;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('diningView')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title bodyNorm')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Common$Counter$View$view,
						model.pZ,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.Di;
									}))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('type data')
					]),
				$author$project$Translations$toHtml(model.oh)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('diningDate bodyBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3(
							$author$project$Utils$Time$Format$format,
							{A_: language, rb: market},
							$author$project$Utils$Time$Format$monthNumberDayWeekdayHourMinute,
							model.nd))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, addon) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('diningAddonCounter'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('marginTopSmall', !(!index))
											]))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Common$Counter$View$grayView,
										addon.pZ,
										_List_fromArray(
											[
												$elm$html$Html$text(addon.oh)
											]))
									]));
						}),
					_Utils_ap(model.ms, model.kD)))
			]));
};
var $author$project$Common$SelectedOnboardServicesView$diningViewModelFromService = F3(
	function (language, market, service) {
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (time, name, count) {
					return {nd: time, pZ: count, ms: service.ms, A_: language, rb: market, oh: name, kD: service.kD};
				}),
			A2($elm$core$Maybe$andThen, $author$project$Utils$Time$fromString, service.ut),
			service.oh,
			service.pZ);
	});
var $author$project$Common$SelectedOnboardServicesView$massageCounterView = F2(
	function (locale, _v0) {
		var count = _v0.pZ;
		var name = _v0.oh;
		var timeSlots = _v0.mY;
		var formatTimeSlot = A2(
			$elm$core$Basics$composeR,
			$author$project$Utils$Time$fromString,
			$elm$core$Maybe$map(
				function (time) {
					return A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, time) + (' ' + $author$project$Utils$Time$Format$formatHourMinute(time));
				}));
		return A2(
			$author$project$Common$Counter$View$view,
			count,
			_List_fromArray(
				[
					$elm$html$Html$text(name),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timeSlots')
						]),
					A2(
						$elm$core$List$map,
						function (timeSlot) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(timeSlot)
									]));
						},
						A2($elm$core$List$filterMap, formatTimeSlot, timeSlots)))
				]));
	});
var $author$project$Common$SelectedOnboardServicesView$shipMoneyNameToInt = A2(
	$elm$core$Basics$composeR,
	A2(
		$elm$regex$Regex$replace,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('\\D')),
		function (_v0) {
			return '';
		}),
	$elm$core$String$toInt);
var $author$project$Common$SelectedOnboardServicesView$sortShipMoney = $elm$core$List$sortWith(
	F2(
		function (a, b) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A3(
					$elm$core$Maybe$map2,
					$elm$core$Basics$compare,
					$author$project$Common$SelectedOnboardServicesView$shipMoneyNameToInt(a.oh),
					$author$project$Common$SelectedOnboardServicesView$shipMoneyNameToInt(b.oh)));
		}));
var $author$project$Common$SelectedOnboardServicesView$sortServices = A2(
	$elm$core$Basics$composeR,
	$elm_community$list_extra$List$Extra$groupWhile(
		F2(
			function (a, b) {
				return _Utils_eq(a.j4, b.j4);
			})),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortWith(
			F2(
				function (_v0, _v1) {
					var a = _v0.a;
					return (a.j4 === 5) ? 0 : 2;
				})),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (_v2) {
					var first = _v2.a;
					var others = _v2.b;
					return (first.j4 === 5) ? A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, a.oh, b.oh);
							}),
						A2($elm$core$List$cons, first, others)) : ((first.j4 === 7) ? $author$project$Common$SelectedOnboardServicesView$sortShipMoney(
						A2($elm$core$List$cons, first, others)) : A2(
						$elm$core$List$sortWith,
						F2(
							function (a, b) {
								return A2($elm$core$Basics$compare, a.oh, b.oh);
							}),
						A2($elm$core$List$cons, first, others)));
				}),
			$elm$core$List$concat)));
var $author$project$Common$SelectedOnboardServicesView$unifyMassageServices = A2(
	$elm$core$Basics$composeR,
	$elm_community$list_extra$List$Extra$gatherEqualsBy(
		function ($) {
			return $.pQ;
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (_v0) {
				var first = _v0.a;
				var others = _v0.b;
				return A2(
					$elm$core$Maybe$map,
					function (name) {
						return {
							pQ: first.pQ,
							pZ: $elm$core$List$length(others) + 1,
							oh: name,
							j4: 6,
							mY: A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_Utils_ap(
									_List_fromArray(
										[first.ut]),
									A2(
										$elm$core$List$map,
										function ($) {
											return $.ut;
										},
										others)))
						};
					},
					first.oh);
			}),
		$elm$core$List$filterMap($elm$core$Basics$identity)));
var $author$project$Common$SelectedOnboardServicesView$unifyServices = function (onboardServices) {
	return _Utils_ap(
		$author$project$Common$SelectedOnboardServicesView$unifyMassageServices(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.km;
					},
					$elm$core$Basics$eq(6)),
				onboardServices)),
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var code = _v0.pQ;
					var count = _v0.pZ;
					var name = _v0.oh;
					var type_ = _v0.km;
					var paidAddons = _v0.kD;
					var beginDateTime = _v0.ut;
					return _Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A3(
								$elm$core$Maybe$map2,
								F2(
									function (justCount, justName) {
										return _List_fromArray(
											[
												{pQ: code, pZ: justCount, oh: justName, j4: type_, mY: _List_Nil}
											]);
									}),
								count,
								name)),
						A2(
							$elm$core$List$map,
							function (addon) {
								return {pQ: addon.pQ, pZ: addon.pZ, oh: addon.oh, j4: type_, mY: _List_Nil};
							},
							paidAddons));
				},
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.km;
						},
						$elm$core$Basics$neq(6)),
					onboardServices))));
};
var $author$project$Common$SelectedOnboardServicesView$servicesView = function (locale) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Common$SelectedOnboardServicesView$unifyServices,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Common$SelectedOnboardServicesView$sortServices,
			A2(
				$elm$core$Basics$composeR,
				function (services) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, serviceData) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'marginBottomSmall',
													!_Utils_eq(
														index,
														$elm$core$List$length(services) - 1))
												])),
											A2($elm$html$Html$Attributes$attribute, 'data-test-service-code', serviceData.pQ),
											A2(
											$elm$html$Html$Attributes$attribute,
											'data-test-service-count',
											$elm$core$String$fromInt(serviceData.pZ)),
											$elm$html$Html$Attributes$class('service')
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = serviceData.j4;
											switch (_v0) {
												case 2:
													return A2(
														$author$project$Common$Counter$View$grayView,
														serviceData.pZ,
														_List_fromArray(
															[
																$elm$html$Html$text(serviceData.oh)
															]));
												case 6:
													return A2($author$project$Common$SelectedOnboardServicesView$massageCounterView, locale, serviceData);
												default:
													return A2(
														$author$project$Common$Counter$View$view,
														serviceData.pZ,
														_List_fromArray(
															[
																$elm$html$Html$text(serviceData.oh)
															]));
											}
										}()
										]));
							}),
						services);
				},
				function (viewList) {
					return $elm$core$List$isEmpty(viewList) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('data')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('- -')
								]))
						]) : viewList;
				})));
};
var $author$project$Common$SelectedOnboardServicesView$view = F3(
	function (translations, _v0, _v1) {
		var isOneWay = _v0.qW;
		var from = _v0.kS;
		var to = _v0.le;
		var locale = _v0.n0;
		var outwardServices = _v1.ot;
		var returnServices = _v1.oL;
		var _v2 = _Utils_Tuple2(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.km;
					},
					$elm$core$Basics$eq(2)),
				outwardServices),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.km;
					},
					$elm$core$Basics$eq(2)),
				returnServices));
		var outwardDinings = _v2.a;
		var returnDinings = _v2.b;
		var _v3 = _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				$author$project$Common$SelectedOnboardServicesView$changeShipMoneyCouponName(translations),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.km;
						},
						$elm$core$Basics$neq(2)),
					outwardServices)),
			A2(
				$elm$core$List$map,
				$author$project$Common$SelectedOnboardServicesView$changeShipMoneyCouponName(translations),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.km;
						},
						$elm$core$Basics$neq(2)),
					returnServices)));
		var outward = _v3.a;
		var _return = _v3.b;
		return _List_fromArray(
			[
				A4($author$project$Common$FromTo$View$root, translations, isOneWay, from, to),
				($elm$core$List$isEmpty(outward) && $elm$core$List$isEmpty(_return)) ? $elm$html$Html$text('') : ((isOneWay && ((!from) && (to === 2))) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$author$project$Common$SelectedOnboardServicesView$servicesView,
					locale,
					_Utils_ap(outward, _return))) : (isOneWay ? A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($author$project$Common$SelectedOnboardServicesView$servicesView, locale, outward)) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('displayFlex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('paddingRightMedium flex1')
							]),
						A2($author$project$Common$SelectedOnboardServicesView$servicesView, locale, outward)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('paddingLeftMedium flex1')
							]),
						A2($author$project$Common$SelectedOnboardServicesView$servicesView, locale, _return))
					])))),
				((!$elm$core$List$isEmpty(outwardDinings)) || (!$elm$core$List$isEmpty(returnDinings))) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'marginTopMedium',
								!($elm$core$List$isEmpty(outward) && $elm$core$List$isEmpty(_return)))
							]))
					]),
				_List_fromArray(
					[
						A4($author$project$Common$FromTo$View$root, translations, !isOneWay, from, to),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('displayFlex dinings')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('paddingRightMedium flex1')
									]),
								($elm$core$List$isEmpty(outwardDinings) && isOneWay) ? _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('data')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('- -')
											]))
									]) : A2(
									$elm$core$List$filterMap,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$map($author$project$Common$SelectedOnboardServicesView$diningView),
										A2($author$project$Common$SelectedOnboardServicesView$diningViewModelFromService, locale.A_, locale.rb)),
									outwardDinings)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('paddingLeftMedium flex1')
									]),
								($elm$core$List$isEmpty(returnDinings) && isOneWay) ? _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('data')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('- -')
											]))
									]) : A2(
									$elm$core$List$filterMap,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$map($author$project$Common$SelectedOnboardServicesView$diningView),
										A2($author$project$Common$SelectedOnboardServicesView$diningViewModelFromService, locale.A_, locale.rb)),
									returnDinings))
							]))
					])) : $elm$html$Html$text('')
			]);
	});
var $author$project$BookingPage$Panel$OnboardService$View$view = function (session) {
	var language = session.A_;
	var onboardServices = session.rI;
	var _v0 = onboardServices;
	var bubbleFairServices = _v0.vz;
	var covidServices = _v0.x5;
	var dining = _v0.yv;
	var friendshipBracelets = _v0.y9;
	var kidBracelets = _v0.AL;
	var maybeShipMoney = _v0.B3;
	var massages = _v0.BI;
	var priorityBoardings = _v0.Fm;
	var services = $author$project$Utils$String$capitalize(
		$elm$core$String$toLower(
			A2(
				$elm$core$String$join,
				', ',
				A3(
					$author$project$Utils$List$appendIfListNotEmpty,
					priorityBoardings,
					function (_v6) {
						return A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.Dd;
							});
					},
					A3(
						$author$project$Utils$List$appendIfListNotEmpty,
						massages,
						function (_v5) {
							return A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.vc;
								});
						},
						A3(
							$author$project$Utils$List$appendIfListNotEmpty,
							dining,
							function (_v4) {
								return A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.GE;
									});
							},
							A2(
								$author$project$Utils$List$maybeAdd,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.oh;
									},
									maybeShipMoney),
								A3(
									$author$project$Utils$List$appendIfListNotEmpty,
									kidBracelets,
									function (_v3) {
										return A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.vb;
											});
									},
									A3(
										$author$project$Utils$List$appendIfListNotEmpty,
										friendshipBracelets,
										function (_v2) {
											return A2(
												$author$project$Translations$t,
												language,
												function ($) {
													return $.Db;
												});
										},
										A3(
											$author$project$Utils$List$appendIfListNotEmpty,
											covidServices,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$List$map(
													function ($) {
														return $.oh;
													}),
												$elm$core$String$join(', ')),
											A3(
												$author$project$Utils$List$appendIfListNotEmpty,
												bubbleFairServices,
												function (_v1) {
													return A2(
														$author$project$Translations$t,
														language,
														function ($) {
															return $.Da;
														});
												},
												_List_Nil)))))))))));
	return A2(
		$author$project$Common$Panel$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mediumPadding'),
				$elm$html$Html$Attributes$id('onboardservices-panel'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'onboardservices-panel'),
				$elm$html$Html$Events$onClick(
				$author$project$Messages$ChangedLocation($author$project$UrlRoute$OnboardServices))
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					A2(
					$author$project$Common$ArrowLink$View$viewWithContent,
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.uD;
						}),
					services)
				]),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A2(
						$author$project$Common$SelectedOnboardServicesView$view,
						$author$project$Translations$forLanguage(language),
						{
							kS: session.kS,
							qW: $author$project$Utils$Route$isCruiseOrCruiseMultiship(session.tx) || session.qW,
							n0: A2($author$project$Types$Locale$Locale, session.A_, session.rb),
							le: session.le
						}),
					$elm$core$List$cons(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sectionTitle title2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Translations$t,
												language,
												function ($) {
													return $.De;
												}))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('editLink')
										]),
									$author$project$Translations$toHtml(
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.wG;
											})))
								])))),
				$author$project$BookingPage$Panel$OnboardService$View$getOnboardServices(session))));
};
var $author$project$Page$Booking$optionalSections = F2(
	function (translations, model) {
		var session = model.j;
		var bookingPage = model.pz;
		return A2(
			$author$project$Common$Section$view,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test-optional-services', '')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Section$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('white')
						]),
					translations.u9),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Utils$Route$areVehiclesSupported(session),
					A3($author$project$BookingPage$Panel$Vehicle$View$root, translations, session, bookingPage.Ay)),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Types$OnboardServices$hasOnboardServices(session.rI),
					$author$project$BookingPage$Panel$OnboardService$View$view(session)),
					A2($author$project$BookingPage$Panel$Sitting$View$root, translations, session),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Utils$Route$areBusTransfersSupported(session),
					A2($author$project$BookingPage$Panel$BusTransfer$View$root, translations, session)),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Utils$Route$areLandServicesSupported(session) && (!$author$project$Update$Passengers$isInSoloYouthMode(session)),
					$author$project$Page$Booking$landServicePanel(model)),
					A2(
					$author$project$Utils$String$renderIf,
					!$elm$core$List$isEmpty(session.qk),
					A2($author$project$BookingPage$Panel$ExtraServices$View$view, session, translations)),
					A2(
					$author$project$Utils$String$renderIf,
					session.zM.Gs.GC,
					$author$project$Page$Booking$backToDesktopSection(translations))
				]));
	});
var $author$project$Common$ClubOneSignIn$clubOneSignIn = function (translations) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('clubOneSignIn'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'clubOneSignIn')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src('/assets/images/clubOne/bubble.png')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Messages$OpenedSignInPage)
					]),
				$author$project$Translations$toHtml(translations.wg))
			]));
};
var $author$project$BookingPage$Panel$Total$View$header = F2(
	function (translations, session) {
		var withClubOneDiscount = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var clubOneDiscount = _v0.wd;
					return $elm$core$Basics$abs(clubOneDiscount) > 0;
				},
				session.B7));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('totalHeader')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							withClubOneDiscount ? translations.Fc : translations.xQ)
						])),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					$author$project$Price$View$showLoadingNotice(session),
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spinner animateSpinner')
							]),
						_List_fromArray(
							[$author$project$Common$Images$darkPropeller])))
				]));
	});
var $author$project$BookingPage$Panel$Total$View$methodToIcons = function (method) {
	switch (method) {
		case 'BANK':
			return _List_fromArray(
				['paytrail']);
		case 'CARD':
			return _List_fromArray(
				['visa', 'mastercard']);
		case 'APPLE_PAY':
			return _List_fromArray(
				['apple_pay']);
		case 'GOOGLE_PAY':
			return _List_fromArray(
				['google_pay']);
		case 'MOBILE_PAY':
			return _List_fromArray(
				['mobile_pay']);
		case 'KLARNA':
			return _List_fromArray(
				['klarna']);
		default:
			return _List_Nil;
	}
};
var $author$project$BookingPage$Panel$Total$View$getPaymentMethodsIconsNames = function (_v0) {
	var paymentServiceProviders = _v0.Ey;
	return A2(
		$elm$core$List$concatMap,
		$author$project$BookingPage$Panel$Total$View$methodToIcons,
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.Cw;
			},
			paymentServiceProviders));
};
var $author$project$BookingPage$Panel$Total$View$paymentIcon = function (name) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src('/assets/images/paymentMethod/' + (name + '.svg'))
			]),
		_List_Nil);
};
var $author$project$BookingPage$Panel$Total$View$paymentIcons = function (paymentMethods) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('paymentIcons')
			]),
		A2(
			$elm$core$List$map,
			$author$project$BookingPage$Panel$Total$View$paymentIcon,
			$author$project$BookingPage$Panel$Total$View$getPaymentMethodsIconsNames(paymentMethods)));
};
var $author$project$BookingPage$Panel$Total$View$values = F3(
	function (translations, session, summary) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, summary.lN),
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return _Utils_Tuple2(
						a.s8,
						A2($elm$core$Basics$max, a.He - a.x4, 0));
				},
				$author$project$Types$ClubOneSlider$toMaybeEnabled(session.n8)));
		var pointsPrice = _v0.a;
		var moneyPrice = _v0.b;
		var _v1 = _Utils_Tuple2(
			A2(
				$author$project$Translations$injectValues,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'points',
						$elm$core$String$fromInt(pointsPrice))
					]),
				translations.Ex),
			A2($author$project$Types$Market$formatPriceWithSign, session.rb, moneyPrice));
		var pointsPriceString = _v1.a;
		var moneyPriceString = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('totalValues')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('moneyValue'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'totalMoney')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(moneyPriceString)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pointsValue'),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'totalPoints')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(pointsPriceString)
						]))
				]));
	});
var $author$project$BookingPage$Panel$Total$Slider$disabilityReason = F2(
	function (reason, translations) {
		var reasonText = function () {
			switch (reason.$) {
				case 0:
					return translations.wl;
				case 2:
					return translations.wk;
				case 1:
					return translations.wh;
				default:
					var otherReason = reason.a;
					return A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2('reason', otherReason)
							]),
						translations.wm);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('notification sliderDisabilityReason')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(reasonText)
						]))
				]));
	});
var $author$project$BookingPage$Panel$Total$Slider$disabledInput = A2(
	$elm$html$Html$input,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$type_('range'),
			$elm$html$Html$Attributes$value('0'),
			$elm$html$Html$Attributes$disabled(true)
		]),
	_List_Nil);
var $author$project$BookingPage$Panel$Total$Slider$header = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sliderHeader')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(translations.wj)
					])),
				$author$project$Common$Hint$hint(translations.wi)
			]));
};
var $author$project$Messages$UpdatedClubOneSliderTempValue = function (a) {
	return {$: 137, a: a};
};
var $author$project$Messages$UpdatedClubOneSliderValue = {$: 138};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Common$Events$Touch = F2(
	function (clientX, clientY) {
		return {v7: clientX, v8: clientY};
	});
var $author$project$Common$Events$touchDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Common$Events$Touch,
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $author$project$Common$Events$eventDecoder = F2(
	function (msg, eventKey) {
		return A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				[eventKey, '0']),
			A2($elm$json$Json$Decode$map, msg, $author$project$Common$Events$touchDecoder));
	});
var $author$project$Common$Events$onTouchEnd = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'touchend',
		A2($author$project$Common$Events$eventDecoder, msg, 'changedTouches'));
};
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $author$project$BookingPage$Panel$Total$Slider$input = function (enabledSlider) {
	var filledPercentage = $elm$core$String$fromFloat((enabledSlider.s8 / enabledSlider.mu.n6) * 100);
	var background = 'linear-gradient(to right, #004152 ' + (filledPercentage + ('%, #eef1f1 ' + (filledPercentage + '%, #eef1f1 100%)')));
	return A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('range'),
				$elm$html$Html$Attributes$min(
				$elm$core$String$fromInt(0)),
				$elm$html$Html$Attributes$max(
				$elm$core$String$fromFloat(enabledSlider.mu.n6)),
				$elm$html$Html$Attributes$step(
				$elm$core$String$fromFloat(enabledSlider.mu.GW)),
				$elm$html$Html$Attributes$value(
				$elm$core$String$fromInt(enabledSlider.s8)),
				$elm$html$Html$Events$onInput(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$toFloat,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$core$Basics$round),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(0),
							$author$project$Messages$UpdatedClubOneSliderTempValue)))),
				$elm$html$Html$Events$onMouseUp($author$project$Messages$UpdatedClubOneSliderValue),
				$author$project$Common$Events$onTouchEnd(
				function (_v0) {
					return $author$project$Messages$UpdatedClubOneSliderValue;
				}),
				A2($elm$html$Html$Attributes$style, 'background', background)
			]),
		_List_Nil);
};
var $author$project$BookingPage$Panel$Total$Slider$minMaxValues = function (enabledSlider) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sliderMaxMinValues')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(0))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$elm$core$Basics$round(enabledSlider.mu.n6)))
					]))
			]));
};
var $author$project$BookingPage$Panel$Total$Slider$view = F2(
	function (translations, clubOneSlider) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('slider'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'clubOneSlider')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$BookingPage$Panel$Total$Slider$header(translations)
					]),
				function () {
					if (!clubOneSlider.$) {
						var enabledSlider = clubOneSlider.a;
						return _List_fromArray(
							[
								$author$project$BookingPage$Panel$Total$Slider$input(enabledSlider),
								$author$project$BookingPage$Panel$Total$Slider$minMaxValues(enabledSlider)
							]);
					} else {
						var reason = clubOneSlider.a;
						return _List_fromArray(
							[
								$author$project$BookingPage$Panel$Total$Slider$disabledInput,
								A2($author$project$BookingPage$Panel$Total$Slider$disabilityReason, reason, translations)
							]);
					}
				}()));
	});
var $author$project$BookingPage$Panel$Total$View$view = F4(
	function (translations, session, maybePaymentMethods, summary) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('paymentTotal'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'disabledPoints',
							A2(
								$elm$core$Maybe$withDefault,
								true,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return false;
									},
									$author$project$Types$ClubOneSlider$toMaybeEnabled(session.n8))))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$BookingPage$Panel$Total$View$header, translations, session),
					A3($author$project$BookingPage$Panel$Total$View$values, translations, session, summary),
					$author$project$Session$isClubOneUser(session.Ia) ? A2(
					$author$project$Utils$Html$Render$maybeRender,
					$author$project$BookingPage$Panel$Total$Slider$view(translations),
					session.n8) : $author$project$Common$ClubOneSignIn$clubOneSignIn(translations),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					session.rb === 1,
					A2($author$project$Utils$Html$Render$maybeRender, $author$project$BookingPage$Panel$Total$View$paymentIcons, maybePaymentMethods)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('buttonPlaceholder')
						]),
					_List_Nil)
				]));
	});
var $author$project$Common$PriceDetails$addAmount = F2(
	function (voucher, _v0) {
		var remainingAmount = _v0.a;
		var vouchers = _v0.b;
		var _v1 = voucher.ub;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				remainingAmount,
				_Utils_ap(
					vouchers,
					_List_fromArray(
						[voucher])));
		} else {
			var amount = _v1.a;
			var amountWhichCanBeAdded = A2($elm$core$Basics$min, voucher.Fk - amount, remainingAmount);
			var newRemainingAmount = remainingAmount - amountWhichCanBeAdded;
			var newVoucherAmount = amount + amountWhichCanBeAdded;
			return voucher.qO ? _Utils_Tuple2(
				newRemainingAmount,
				_Utils_ap(
					vouchers,
					_List_fromArray(
						[
							_Utils_update(
							voucher,
							{
								ub: $elm$core$Maybe$Just(newVoucherAmount)
							})
						]))) : _Utils_Tuple2(
				remainingAmount,
				_Utils_ap(
					vouchers,
					_List_fromArray(
						[voucher])));
		}
	});
var $author$project$Common$PriceDetails$removeAmount = F2(
	function (voucher, _v0) {
		var remainingAmount = _v0.a;
		var vouchers = _v0.b;
		var _v1 = voucher.ub;
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				remainingAmount,
				_Utils_ap(
					_List_fromArray(
						[voucher]),
					vouchers));
		} else {
			var amount = _v1.a;
			var newVoucherAmount = A2($elm$core$Basics$max, amount - remainingAmount, 0);
			var newRemainingAmount = A2($elm$core$Basics$max, remainingAmount - amount, 0);
			return voucher.qO ? _Utils_Tuple2(
				newRemainingAmount,
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_update(
							voucher,
							{
								ub: $elm$core$Maybe$Just(newVoucherAmount)
							})
						]),
					vouchers)) : _Utils_Tuple2(
				remainingAmount,
				_Utils_ap(
					_List_fromArray(
						[voucher]),
					vouchers));
		}
	});
var $author$project$Common$PriceDetails$recalculateVouchersAmount = F2(
	function (maybeClubOneSlider, vouchers) {
		if ((!maybeClubOneSlider.$) && (!maybeClubOneSlider.a.$)) {
			var tempPrice = maybeClubOneSlider.a.a.He;
			return (tempPrice >= 0) ? A3(
				$elm$core$List$foldl,
				$author$project$Common$PriceDetails$addAmount,
				_Utils_Tuple2(tempPrice, _List_Nil),
				vouchers).b : A3(
				$elm$core$List$foldr,
				$author$project$Common$PriceDetails$removeAmount,
				_Utils_Tuple2(-tempPrice, _List_Nil),
				vouchers).b;
		} else {
			return vouchers;
		}
	});
var $author$project$Page$Discount$View$hasAmount = function (voucher) {
	var _v0 = voucher.ub;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Page$Discount$View$shouldShowSubtotal = function (vouchers) {
	var appliedVouchers = A2(
		$elm$core$List$filter,
		function ($) {
			return $.z4;
		},
		vouchers);
	var hasAppliedVoucher = !$elm$core$List$isEmpty(appliedVouchers);
	var allAppliedVouchersHaveAmount = A2($elm$core$List$all, $author$project$Page$Discount$View$hasAmount, appliedVouchers);
	return hasAppliedVoucher && allAppliedVouchersHaveAmount;
};
var $author$project$Page$Discount$View$priceItem = F3(
	function (session, name, price) {
		var priceString = A2($author$project$Types$Market$formatPriceWithSign, session.rb, price);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('priceItem')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('price')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(priceString)
						]))
				]));
	});
var $author$project$Page$Discount$View$subtotal = F3(
	function (translations, session, summary) {
		return A3($author$project$Page$Discount$View$priceItem, session, translations.Ff, summary.G3);
	});
var $author$project$Page$Discount$Voucher$description = function (descriptionText) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('description')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(descriptionText)
			]));
};
var $author$project$Page$Discount$Voucher$isCabinSelectionRequired = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$TravelClasses$hasSelectedTravelClasses),
			session.to));
};
var $author$project$Types$CruiseMultiDepartureTrips$isClubOneOnlyPromotion = function (_v0) {
	var trips = _v0;
	return trips.mg;
};
var $author$project$Types$CruiseSails$isClubOneOnlyPromotion = function (_v0) {
	var cruiseSails = _v0;
	return cruiseSails.mg;
};
var $author$project$Types$RouteTripSails$isClubOneOnlyPromotion = function (_v0) {
	var clubOneOnlyPromotion = _v0.mg;
	return clubOneOnlyPromotion;
};
var $author$project$Types$Trips$isClubOneOnlyPromotion = function (tripsStatus) {
	if (!tripsStatus.$) {
		var trips = tripsStatus.a;
		switch (trips.$) {
			case 0:
				var cruise = trips.a;
				return $author$project$Types$CruiseSails$isClubOneOnlyPromotion(cruise);
			case 1:
				var route = trips.a;
				return $author$project$Types$RouteTripSails$isClubOneOnlyPromotion(route);
			default:
				var cruiseMultiDeparture = trips.a;
				return $author$project$Types$CruiseMultiDepartureTrips$isClubOneOnlyPromotion(cruiseMultiDeparture);
		}
	} else {
		return false;
	}
};
var $author$project$Page$Discount$Voucher$isClubOneOnlyVoucher = F2(
	function (session, voucher) {
		return (!voucher.qO) && ((!voucher.z4) && (voucher.Ax && $author$project$Types$Trips$isClubOneOnlyPromotion(session.tp)));
	});
var $author$project$Page$Discount$Voucher$getErrorTranslation = F3(
	function (session, firstVoucher, voucher) {
		if (A2($author$project$Page$Discount$Voucher$isClubOneOnlyVoucher, session, voucher) && firstVoucher) {
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Iq;
				});
		} else {
			if (voucher.z7) {
				return $elm$core$Maybe$Just(
					function ($) {
						return $.uO;
					});
			} else {
				if ($author$project$Page$Discount$Voucher$isCabinSelectionRequired(session)) {
					return $elm$core$Maybe$Just(
						function ($) {
							return $.uN;
						});
				} else {
					var _v0 = voucher.yQ;
					switch (_v0) {
						case 'DUPLICATE':
							return $elm$core$Maybe$Just(
								function ($) {
									return $.Ir;
								});
						case 'PRICE':
							return $elm$core$Maybe$Just(
								function ($) {
									return $.Iu;
								});
						case 'CURRENCY':
							return $elm$core$Maybe$Just(
								function ($) {
									return $.It;
								});
						case 'EXPIRED':
							return $elm$core$Maybe$Just(
								function ($) {
									return $.Is;
								});
						default:
							return ((!voucher.z4) && voucher.Ax) ? $elm$core$Maybe$Just(
								function ($) {
									return $.uK;
								}) : $elm$core$Maybe$Nothing;
					}
				}
			}
		}
	});
var $author$project$Page$Discount$Voucher$nameAndMaybeToggle = F4(
	function (translations, withWarning, maybeToggleDiscountDescription, voucher) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('name')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Utils$Html$Render$renderIf,
					withWarning,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('warning')
							]),
						_List_Nil)),
					voucher.qO ? $elm$html$Html$text(translations.zh) : $elm$html$Html$text(translations.Ip),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voucherCode')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(voucher.pQ)
						])),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					voucher.qO && voucher.z4,
					A2($author$project$Utils$Html$Render$maybeRender, $elm$core$Basics$identity, maybeToggleDiscountDescription))
				]));
	});
var $author$project$Page$Discount$Voucher$nonRefundableDescription = F2(
	function (translations, openNonRefundableTermsModal) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nonRefundableDescription'),
					$author$project$UrlRoute$onClickWithoutSideEffects(openNonRefundableTermsModal)
				]),
			$author$project$Translations$toHtml(translations.CU));
	});
var $author$project$Page$Discount$Voucher$priceAndMaybeRemove = F4(
	function (translations, session, maybeRemoveDiscount, voucher) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('priceAndRemove')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Utils$Html$Render$renderIf,
					voucher.z4,
					function () {
						var _v0 = voucher.ub;
						if (_v0.$ === 1) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price appliedOnly')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(translations.yy)
									]));
						} else {
							var amount = _v0.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Types$Market$formatPriceWithSign, session.rb, -amount))
									]));
						}
					}()),
					A2($author$project$Utils$Html$Render$maybeRender, $elm$core$Basics$identity, maybeRemoveDiscount)
				]));
	});
var $author$project$Page$Discount$Voucher$view = F6(
	function (translations, session, selected, _v0, firstVoucher, voucher) {
		var maybeToggleDiscountDescription = _v0.Ca;
		var maybeRemoveDiscount = _v0.BZ;
		var openNonRefundableTermsModal = _v0.Dm;
		var maybeErrorTranslation = A3($author$project$Page$Discount$Voucher$getErrorTranslation, session, firstVoucher, voucher);
		var descriptionIsVisible = voucher.z4 && selected;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('priceItem voucher')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Page$Discount$Voucher$nameAndMaybeToggle,
					translations,
					!_Utils_eq(maybeErrorTranslation, $elm$core$Maybe$Nothing),
					maybeToggleDiscountDescription,
					voucher),
					A4($author$project$Page$Discount$Voucher$priceAndMaybeRemove, translations, session, maybeRemoveDiscount, voucher),
					A2(
					$author$project$Utils$Html$Render$maybeRender,
					function (errorTranslation) {
						return $author$project$Page$Discount$Voucher$description(
							errorTranslation(translations));
					},
					maybeErrorTranslation),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					descriptionIsVisible,
					$author$project$Page$Discount$Voucher$description(
						A2(
							$author$project$Translations$injectValues,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'priceLeft',
									$elm$core$String$fromFloat(voucher.Fk)),
									_Utils_Tuple2('applicabilityEnd', voucher.ug)
								]),
							translations.zi))),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					voucher.Ak,
					A2($author$project$Page$Discount$Voucher$nonRefundableDescription, translations, openNonRefundableTermsModal))
				]));
	});
var $author$project$Common$PriceDetails$voucherView = F5(
	function (translations, session, firstVoucher, voucher, openNonRefundableTermsModal) {
		return A6(
			$author$project$Page$Discount$Voucher$view,
			translations,
			session,
			false,
			{BZ: $elm$core$Maybe$Nothing, Ca: $elm$core$Maybe$Nothing, Dm: openNonRefundableTermsModal},
			firstVoucher,
			voucher);
	});
var $author$project$Common$PriceDetails$discountView = F4(
	function (translations, session, maybeSummary, openNonRefundableTermsModal) {
		var vouchers = _Utils_ap(
			A2(
				$author$project$Common$PriceDetails$recalculateVouchersAmount,
				session.n8,
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.z4;
					},
					session.tw)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.z4;
					},
					$elm$core$Basics$not),
				session.tw));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('priceDetails')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Utils$Html$Render$maybeRender,
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Page$Discount$View$subtotal, translations, session),
							$author$project$Utils$Html$Render$renderIf(
								$author$project$Page$Discount$View$shouldShowSubtotal(vouchers))),
						maybeSummary)
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, voucher) {
							var firstVoucherIndex = A2(
								$elm_community$list_extra$List$Extra$findIndex,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.qO;
									},
									$elm$core$Basics$not),
								vouchers);
							return A5(
								$author$project$Common$PriceDetails$voucherView,
								translations,
								session,
								_Utils_eq(
									$elm$core$Maybe$Just(index),
									firstVoucherIndex),
								voucher,
								openNonRefundableTermsModal);
						}),
					vouchers)));
	});
var $author$project$BookingPage$Panel$Voucher$View$header = F2(
	function (translations, session) {
		var isPriceReduced = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (summary) {
					return _Utils_cmp(summary.Fi, summary.lN) > 0;
				},
				session.B7));
		var hasVouchers = !$elm$core$List$isEmpty(session.tw);
		return (isPriceReduced || hasVouchers) ? A2(
			$author$project$Common$SectionTitle$View$view,
			translations,
			function ($) {
				return $.p9;
			}) : A2($author$project$Common$ArrowLink$View$viewWithContent, translations.p9, '');
	});
var $author$project$BookingPage$Panel$Voucher$View$view = F2(
	function (translations, session) {
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voucher mediumPadding'),
					A2($elm$html$Html$Attributes$attribute, 'view-panel', 'voucher'),
					$elm$html$Html$Attributes$id('voucher-panel'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'closed',
							$elm$core$List$isEmpty(session.tw))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$ChangedLocation($author$project$UrlRoute$Discount))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$BookingPage$Panel$Voucher$View$header, translations, session),
							A4(
							$author$project$Common$PriceDetails$discountView,
							translations,
							session,
							session.B7,
							$author$project$Messages$OpenedModal($author$project$Common$Modal$Model$NonRefundableTerms))
						]))
				]));
	});
var $author$project$Page$Booking$Payment$section = F2(
	function (translations, _v0) {
		var session = _v0.j;
		var bookingPage = _v0.pz;
		var paymentMethods = _v0.Ev;
		return A2(
			$author$project$Common$Section$view,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test-payment', ''),
					$elm$html$Html$Attributes$id('payment')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Section$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('white')
						]),
					translations.Ei),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('paymentSectionContent')
						]),
					_List_fromArray(
						[
							A2($author$project$BookingPage$Panel$Voucher$View$view, translations, session),
							A2(
							$author$project$Utils$Html$Render$maybeRender,
							A3($author$project$BookingPage$Panel$Total$View$view, translations, session, paymentMethods),
							session.B7)
						]))
				]));
	});
var $author$project$Page$Booking$view = function (model) {
	var session = model.j;
	var bookingPage = model.pz;
	var translations = $author$project$Translations$forLanguage(session.A_);
	return _List_fromArray(
		[
			A2($author$project$Page$Booking$compulsorySections, translations, model),
			A2($author$project$Page$Booking$optionalSections, translations, model),
			A2($author$project$Page$Booking$Payment$section, translations, model)
		]);
};
var $author$project$Page$Company$ClickedGoBack = {$: 6};
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Button = {$: 8};
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Style$classes = {tH: 'a', m3: 'atv', t0: 'ab', t1: 'cx', t2: 'cy', t3: 'acb', t4: 'accx', t5: 'accy', t6: 'acr', pp: 'al', pq: 'ar', t8: 'at', m5: 'ah', m6: 'av', uf: 's', uu: 'bh', uv: 'b', uA: 'w7', vo: 'bd', vp: 'bdt', l7: 'bn', vq: 'bs', ma: 'cpe', v9: 'cp', wa: 'cpx', wb: 'cpy', j6: 'c', mi: 'ctr', mj: 'cb', mk: 'ccx', j7: 'ccy', lp: 'cl', ml: 'cr', x1: 'ct', yf: 'cptr', yg: 'ctxt', y4: 'fcs', qn: 'focus-within', ze: 'fs', zl: 'g', ny: 'hbh', nB: 'hc', qz: 'he', nC: 'hf', qA: 'hfp', zK: 'hv', zO: 'ic', zS: 'fr', mv: 'lbl', zY: 'iml', zZ: 'imlf', z_: 'imlp', z$: 'implw', z0: 'it', AA: 'i', ra: 'lnk', k_: 'nb', rB: 'notxt', C5: 'ol', C6: 'or', kB: 'oq', DD: 'oh', DF: 'pg', rX: 'p', DK: 'ppe', F$: 'ui', sA: 'r', F9: 'sb', Ga: 'sbx', Gb: 'sby', Gc: 'sbt', GI: 'e', GJ: 'cap', GL: 'sev', G1: 'sk', ta: 't', Hf: 'tc', Hg: 'w8', Hh: 'w2', Hi: 'w9', Hj: 'tj', mX: 'tja', Hk: 'tl', Hl: 'w3', Hm: 'w5', Hn: 'w4', Ho: 'tr', Hp: 'w6', Hq: 'w1', Hr: 'tun', tk: 'ts', kK: 'clr', H5: 'u', ph: 'wc', tB: 'we', pi: 'wf', tC: 'wfp', pj: 'wrp'};
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.j6);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.zl);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.DF);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.rX);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.sA);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.GI);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.F2)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.j_)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.GM.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.GM.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.sA) + ('-' + ($elm$core$String$fromInt(pos.pS) + ('-' + ($elm$core$String$fromInt(pos.m2) + ('-' + $elm$core$String$fromInt(pos.A)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.qJ ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.c.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.c.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.kO) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.sS) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.kt))
				])));
};
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.qn) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.vn),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.uq),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										kO: shadow.kO,
										kt: shadow.kt,
										qJ: false,
										c: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.c)),
										sS: shadow.sS
									}));
						},
						focus.Gu),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + (':focus .focusable, ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + '.focusable:focus')),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.vn),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.uq),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										kO: shadow.kO,
										kt: shadow.kt,
										qJ: false,
										c: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.c)),
										sS: shadow.sS
									}));
						},
						focus.Gu),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.x1);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mj);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ml);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lp);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mk);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j7);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t8);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t0);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pq);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pp);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t1);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t2);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ny),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uu),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Gc),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ta),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nB),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tC),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ph),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GI),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zO))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.F$),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zS),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k_),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k_),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GI),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tH),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uv),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.C6),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.C5),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zS),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uu),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.rB),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.yf),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.yg),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.DK),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ma),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kK),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kB),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.zK, $mdgriffith$elm_ui$Internal$Style$classes.kK)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.zK, $mdgriffith$elm_ui$Internal$Style$classes.kB)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.y4, $mdgriffith$elm_ui$Internal$Style$classes.kK)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.y4, $mdgriffith$elm_ui$Internal$Style$classes.kB)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.m3, $mdgriffith$elm_ui$Internal$Style$classes.kK)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.m3, $mdgriffith$elm_ui$Internal$Style$classes.kB)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tk),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.F9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Ga),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.sA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Gb),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j6),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GI),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.v9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.wa),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.wb),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ph),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.l7),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.vo),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.vp),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.vq),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ta),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.z0),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GI),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.sA),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tB),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ra),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.qA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t6,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t4,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t1),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t4,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t1),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t4,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t2),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.t4 + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.t6 + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.t4)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GL),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mv),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j6),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.pi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tC),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ph),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t3,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t5,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t2),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t5,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t2),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.t5,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.t2),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.t5 + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.t3 + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.t5)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GL),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zl),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.DF),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.uf + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.uf))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.uf + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.uf))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zY),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.z$),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GI),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.z_),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zZ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.rX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ny),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uu),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ta),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.rX),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.GI),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tB),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zS),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uu),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.tH),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uv),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.C6),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.C5),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ta),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.sA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j6),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.zl),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hq),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hh),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hl),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hn),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hm),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hp),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uA),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hg),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hi),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.AA),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.G1),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.H5),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.H5),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.G1)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hr),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hf),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Ho),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.Hk),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\"'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\" 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.uf + (' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.uf + ' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.sA) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.sA) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.uf) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mi) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {mf: closing, lH: _List_Nil, oE: _List_Nil, Gq: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								oE: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.oE)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								lH: A2(
									$elm$core$List$cons,
									{mf: '\n}', lH: _List_Nil, oE: props, Gq: '@supports (' + (prop + (':' + (value + (') {' + parent.Gq))))},
									rendered.lH)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								lH: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.Gq + (' + ' + selector), ''),
										adjRules),
									rendered.lH)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								lH: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.Gq + (' > ' + child), ''),
										childRules),
									rendered.lH)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								lH: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.Gq + (' ' + child), ''),
										childRules),
									rendered.lH)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								lH: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.Gq, descriptor),
											''),
										descriptorRules),
									rendered.lH)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								lH: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.Gq, ''),
										batched),
									rendered.lH)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.oE;
		if (!_v2.b) {
			return '';
		} else {
			return rule.Gq + ('{' + (renderValues(rule.oE) + (rule.mf + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.lH)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.CD;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\"' + (name + '\"');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\"' + (name + '\"');
		default:
			var name = font.a.oh;
			return '\"' + (name + '\"');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.tr);
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\n  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\n  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\n}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.zK;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\n}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\n}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[selector + ('-fs:focus {' + (renderedProps + '\n}')), ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.uf + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\n}'), (selector + '-fs:focus-within {') + (renderedProps + '\n}'), ('.focusable-parent:focus ~ ' + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + (selector + '-fs {'))))) + (renderedProps + '\n}')]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\n}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\"' + (name + '\"');
		case 1:
			var name = _var.a;
			return '\"' + (name + '\" 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\"' + (name + ('\" ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.tr)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.GI;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.sA;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.pj + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.pq;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.rX;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.DF;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.pp;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.j6;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.uf;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.GM.a);
				var ySpacing = toGridLength(template.GM.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.F2)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.j_)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.j_)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.GM.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.GM.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.j_)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.F2)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.j_)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.GM.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.GM.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.sA) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.A) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.pS) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.m2) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.sA) + (' / ' + ($elm$core$String$fromInt(position.sA + position.A) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.pS) + (' / ' + ($elm$core$String$fromInt(position.pS + position.m2) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.sA) + ('-' + ($elm$core$String$fromInt(position.pS) + ('-' + ($elm$core$String$fromInt(position.m2) + ('-' + $elm$core$String$fromInt(position.A)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.ta + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.ta)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.GJ, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.ze, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.GJ + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.GJ))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.GJ + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.ta + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.GJ + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.ta)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {A: height / size, sS: size, tu: vertical};
	});
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.vN, adjustment.us, adjustment.yp, adjustment.By]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.yp,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.us,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.vN,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		vN: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		qq: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.A)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.tu) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.sS) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.tU;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.qq;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.vN;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\'' + (url + '\');'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					mT: _Utils_ap(
						rendered.mT,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					lX: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.lX;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.lX);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{mT: _List_Nil, lX: _List_Nil},
			stylesheet);
		var topLevel = _v0.lX;
		var rules = _v0.mT;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.CD;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.y4)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.y4)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.GI))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.uf, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.mi, $mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.t6])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.uf, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.mi, $mdgriffith$elm_ui$Internal$Style$classes.j7, $mdgriffith$elm_ui$Internal$Style$classes.t4])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.uf, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.mi, $mdgriffith$elm_ui$Internal$Style$classes.t5])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.uf, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.mi, $mdgriffith$elm_ui$Internal$Style$classes.t3])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.ta + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.ph + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nB)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.uf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.ta + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.pi + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nC)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.zL, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.s0 : _Utils_ap(styled.s0, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.zL, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.s0 : _Utils_ap(styled.s0, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.zL, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.s0 : _Utils_ap(styled.s0, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.zL, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.s0 : _Utils_ap(styled.s0, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.s0 : _Utils_ap(rendered.s0, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.kw,
						rendered.rC,
						rendered.kq,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.vV)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						zL: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.kw,
							rendered.rC,
							rendered.kq,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.vV))),
						s0: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.s0 : _Utils_ap(rendered.s0, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.kw,
						rendered.rC,
						rendered.kq,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.vV)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						zL: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.kw,
							rendered.rC,
							rendered.kq,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.vV))),
						s0: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.k_, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.tH]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.k_, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.uv]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.k_, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.C6]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.k_, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.C5]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.k_, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.zS]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.k_, $mdgriffith$elm_ui$Internal$Style$classes.GI, $mdgriffith$elm_ui$Internal$Style$classes.uu]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.zL, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.m5 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.pp);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.m5 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.pq);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.m5 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.t1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.m6 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.t8);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.m6 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.t0);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.m6 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.t2);
	}
};
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.qz + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.nB,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.nC,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.qA + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.uf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.j6 + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.tB + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.ph,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.pi,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.tC + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.uf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.sA + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						kq: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						vV: children,
						kw: has,
						rC: node,
						s0: styles
					};
				} else {
					var _class = _v1.a;
					return {
						kq: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						vV: children,
						kw: has,
						rC: node,
						s0: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.tB + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ph),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.pi),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.tC + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.uf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.sA + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.qz + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.nB + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.nC + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.qA + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.uf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.j6 + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.s0);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Internal$Model$NoAttribute = {$: 0};
var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
	if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
		var _v1 = attr.b;
		var _v2 = _v1.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
	return A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
};
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onClick);
var $mdgriffith$elm_ui$Element$Input$enter = 'Enter';
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $mdgriffith$elm_ui$Element$Input$onKey = F2(
	function (desiredCode, msg) {
		var decode = function (code) {
			return _Utils_eq(code, desiredCode) ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not the enter key');
		};
		var isKey = A2(
			$elm$json$Json$Decode$andThen,
			decode,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
		return $mdgriffith$elm_ui$Internal$Model$Attr(
			A2(
				$elm$html$Html$Events$preventDefaultOn,
				'keyup',
				A2(
					$elm$json$Json$Decode$map,
					function (fired) {
						return _Utils_Tuple2(fired, true);
					},
					isKey)));
	});
var $mdgriffith$elm_ui$Element$Input$onEnter = function (msg) {
	return A2($mdgriffith$elm_ui$Element$Input$onKey, $mdgriffith$elm_ui$Element$Input$enter, msg);
};
var $mdgriffith$elm_ui$Internal$Model$Class = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
var $mdgriffith$elm_ui$Element$pointer = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.yf);
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $mdgriffith$elm_ui$Element$Input$button = F2(
	function (attrs, _v0) {
		var onPress = _v0.mN;
		var label = _v0.kX;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mk + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.j7 + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.Gc + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.rB)))))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$pointer,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Input$focusDefault(attrs),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											$elm$html$Html$Attributes$tabindex(0)),
										function () {
											if (onPress.$ === 1) {
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$Attr(
														$elm$html$Html$Attributes$disabled(true)),
													attrs);
											} else {
												var msg = onPress.a;
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$Events$onClick(msg),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$Input$onEnter(msg),
														attrs));
											}
										}()))))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $mdgriffith$elm_ui$Element$image = F2(
	function (attrs, _v0) {
		var src = _v0.GP;
		var description = _v0.nt;
		var imageAttributes = A2(
			$elm$core$List$filter,
			function (a) {
				switch (a.$) {
					case 7:
						return true;
					case 8:
						return true;
					default:
						return false;
				}
			},
			attrs);
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.zO),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('img'),
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$src(src)),
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$alt(description))
								]),
							imageAttributes),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
					])));
	});
var $author$project$Page$Company$backLink = A2(
	$mdgriffith$elm_ui$Element$Input$button,
	_List_Nil,
	{
		kX: A2(
			$mdgriffith$elm_ui$Element$image,
			_List_Nil,
			{nt: 'back link', GP: '/assets/images/common/icon_back_white_arrow.svg'}),
		mN: $elm$core$Maybe$Just($author$project$Page$Company$ClickedGoBack)
	});
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor),
			'color',
			fontColor));
};
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.x1 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.lp)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $elm$core$String$words = _String_words;
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.oh;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Element$Font$family = function (families) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontFamily,
		A2(
			$mdgriffith$elm_ui$Internal$Model$FontFamily,
			A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'ff-', families),
			families));
};
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Element$Font$sansSerif = $mdgriffith$elm_ui$Internal$Model$SansSerif;
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Element$Font$typeface = $mdgriffith$elm_ui$Internal$Model$Typeface;
var $author$project$UI$fontFamily = $mdgriffith$elm_ui$Element$Font$family(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$typeface('GTWalsheim'),
			$mdgriffith$elm_ui$Element$Font$typeface('Arial'),
			$mdgriffith$elm_ui$Element$Font$sansSerif
		]));
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	uq: $elm$core$Maybe$Nothing,
	vn: $elm$core$Maybe$Nothing,
	Gu: $elm$core$Maybe$Just(
		{
			kO: 0,
			kt: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			c: _Utils_Tuple2(0, 0),
			sS: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.zK;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								zK: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.y4;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								y4: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.CD;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								CD: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			y4: function () {
				var _v0 = record.y4;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			zK: function () {
				var _v1 = record.zK;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			CD: function () {
				var _v2 = record.CD;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{y4: $elm$core$Maybe$Nothing, zK: $elm$core$Maybe$Nothing, CD: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var styles = el.a.s0;
				var html = el.a.zL;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.CD;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.Dn;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.F$, $mdgriffith$elm_ui$Internal$Style$classes.uf, $mdgriffith$elm_ui$Internal$Style$classes.GI]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $author$project$Page$Company$ClickedGetAgent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$Company$EnteredAgentId = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $author$project$UI$fontSizeLarge = 18;
var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
var $mdgriffith$elm_ui$Element$Font$light = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.Hl);
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + $elm$core$String$fromInt(radius),
			'border-radius',
			$elm$core$String$fromInt(radius) + 'px'));
};
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $author$project$UI$button = F2(
	function (attrs, _v0) {
		var onPress = _v0.mN;
		var label = _v0.kX;
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(40)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeLarge),
						$mdgriffith$elm_ui$Element$Font$light,
						$mdgriffith$elm_ui$Element$Border$rounded(0),
						$mdgriffith$elm_ui$Element$centerX
					]),
				attrs),
			{kX: label, mN: onPress});
	});
var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'border-color',
			clr));
};
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Element$Border$width = function (v) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + $elm$core$String$fromInt(v),
			v,
			v,
			v,
			v));
};
var $author$project$Page$Company$cancelButton = function (language) {
	return A2(
		$author$project$UI$button,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Border$color($author$project$UI$colors.ev),
				$mdgriffith$elm_ui$Element$Border$width(1)
			]),
		{
			kX: A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$centerX]),
				$mdgriffith$elm_ui$Element$text(
					$elm$core$String$toUpper(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.E7;
							})))),
			mN: $elm$core$Maybe$Just($author$project$Page$Company$ClickedGoBack)
		});
};
var $author$project$Page$Company$capitalizeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toLower,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$split(' '),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (str) {
					var _v0 = $elm$core$String$uncons(str);
					if (!_v0.$) {
						var _v1 = _v0.a;
						var firstLetter = _v1.a;
						var others = _v1.b;
						return A2(
							$elm$core$String$cons,
							$elm$core$Char$toUpper(firstLetter),
							others);
					} else {
						return str;
					}
				}),
			$elm$core$String$join(' '))));
var $author$project$Page$Company$ClearedInput = {$: 7};
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $author$project$Common$Images$cancelCross = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.ev),
			$elm$svg$Svg$Attributes$viewBox('0 0 492 492')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M300.188 246L484.14 62.04c5.06-5.064 7.852-11.82 7.86-19.024 0-7.208-2.792-13.972-7.86-19.028L468.02 7.872C462.952 2.796 456.196.016 448.984.016c-7.2 0-13.956 2.78-19.024 7.856L246.008 191.82 62.048 7.872C56.988 2.796 50.228.016 43.02.016c-7.2 0-13.96 2.78-19.02 7.856L7.872 23.988c-10.496 10.496-10.496 27.568 0 38.052L191.828 246 7.872 429.952C2.808 435.024.02 441.78.02 448.984c0 7.204 2.788 13.96 7.852 19.028l16.124 16.116c5.06 5.072 11.824 7.856 19.02 7.856 7.208 0 13.968-2.784 19.028-7.856l183.96-183.952 183.952 183.952c5.068 5.072 11.824 7.856 19.024 7.856h.008c7.204 0 13.96-2.784 19.028-7.856l16.12-16.116c5.06-5.064 7.852-11.824 7.852-19.028 0-7.204-2.792-13.96-7.852-19.028L300.188 246z')
				]),
			_List_Nil)
		]));
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $author$project$UI$fontSizeExtraSmall = 10;
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $author$project$UI$spacerSmall = 8;
var $author$project$Page$Company$clearInputButton = A2(
	$mdgriffith$elm_ui$Element$Input$button,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$alignRight,
			$mdgriffith$elm_ui$Element$centerY,
			$mdgriffith$elm_ui$Element$padding($author$project$UI$spacerSmall)
		]),
	{
		kX: A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px($author$project$UI$fontSizeExtraSmall)),
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px($author$project$UI$fontSizeExtraSmall))
				]),
			$mdgriffith$elm_ui$Element$html($author$project$Common$Images$cancelCross)),
		mN: $elm$core$Maybe$Just($author$project$Page$Company$ClearedInput)
	});
var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$bgColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'background-color',
			clr));
};
var $mdgriffith$elm_ui$Internal$Model$Transparency = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
var $mdgriffith$elm_ui$Element$alpha = function (o) {
	var transparency = function (x) {
		return 1 - x;
	}(
		A2(
			$elm$core$Basics$min,
			1.0,
			A2($elm$core$Basics$max, 0.0, o)));
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Transparency,
			'transparency-' + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency),
			transparency));
};
var $author$project$Page$Company$continueButton = F2(
	function (language, _continue) {
		return A2(
			$author$project$UI$button,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$Background$color($author$project$UI$colors.vJ),
				_Utils_eq(_continue, $elm$core$Maybe$Nothing) ? _List_fromArray(
					[
						$mdgriffith$elm_ui$Element$alpha(0.5)
					]) : _List_Nil),
			{
				kX: A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$toUpper(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.E8;
								})))),
				mN: _continue
			});
	});
var $author$project$UI$fontSizeRegular = 14;
var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
var $mdgriffith$elm_ui$Internal$Model$Nearby = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$createNearby = F2(
	function (loc, element) {
		if (element.$ === 3) {
			return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
		} else {
			return A2($mdgriffith$elm_ui$Internal$Model$Nearby, loc, element);
		}
	});
var $mdgriffith$elm_ui$Element$inFront = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 4, element);
};
var $author$project$UI$fontSizeSmall = 12;
var $mdgriffith$elm_ui$Element$Input$Above = 2;
var $mdgriffith$elm_ui$Element$Input$Label = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Element$Input$labelAbove = $mdgriffith$elm_ui$Element$Input$Label(2);
var $author$project$Page$Company$inputLabel = function (labelText) {
	return A2(
		$mdgriffith$elm_ui$Element$Input$labelAbove,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeSmall),
				$mdgriffith$elm_ui$Element$Font$light
			]),
		$mdgriffith$elm_ui$Element$text(
			$elm$core$String$toUpper(labelText)));
};
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$paddingXY = F2(
	function (x, y) {
		if (_Utils_eq(x, y)) {
			var f = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + $elm$core$String$fromInt(x),
					f,
					f,
					f,
					f));
		} else {
			var yFloat = y;
			var xFloat = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
					yFloat,
					xFloat,
					yFloat,
					xFloat));
		}
	});
var $author$project$Page$Company$loadingSpinner = A2(
	$mdgriffith$elm_ui$Element$el,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$alignRight,
			$mdgriffith$elm_ui$Element$centerY,
			A2($mdgriffith$elm_ui$Element$paddingXY, $author$project$UI$spacerSmall, 0),
			$mdgriffith$elm_ui$Element$htmlAttribute(
			$elm$html$Html$Attributes$class('smallSpinner'))
		]),
	$mdgriffith$elm_ui$Element$html($author$project$Common$Images$darkPropeller));
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $author$project$Common$Images$infoCircle = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill($author$project$Common$Images$colors.tv)
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM10.91 9.68V19h2.18V9.68h-2.18zm-.52-3.4c0 .44.157.817.47 1.13.313.313.69.47 1.13.47.453 0 .837-.157 1.15-.47.313-.313.47-.69.47-1.13 0-.453-.157-.837-.47-1.15a1.564 1.564 0 0 0-1.15-.47c-.44 0-.817.157-1.13.47-.313.313-.47.697-.47 1.15z')
				]),
			_List_Nil)
		]));
var $mdgriffith$elm_ui$Internal$Model$Top = 0;
var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.lp + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.j7)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$Page$Company$messageWithIcon = F2(
	function (icon, message) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeSmall),
					$mdgriffith$elm_ui$Element$Font$light,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignTop,
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$UI$fontSizeSmall)),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px($author$project$UI$fontSizeSmall))
						]),
					icon),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							A2($mdgriffith$elm_ui$Element$paddingXY, $author$project$UI$spacerSmall, 0)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(message)
						]))
				]));
	});
var $author$project$Page$Company$notificationView = function (message) {
	return A2(
		$author$project$Page$Company$messageWithIcon,
		$mdgriffith$elm_ui$Element$html($author$project$Common$Images$infoCircle),
		message);
};
var $author$project$Page$Company$onEnter = function (msg) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2(
			$elm$html$Html$Events$on,
			'keyup',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('Not the enter key');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $elm$html$Html$Attributes$pattern = $elm$html$Html$Attributes$stringProperty('pattern');
var $author$project$Common$Images$warningTriangle = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 21.999')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m19.016 9.5793 4.608 8.1555c1.0695 1.896-0.2685 4.2645-2.409 4.2645h-18.429c-2.1405 0-3.48-2.3685-2.409-4.2645l4.608-8.1555 4.6065-8.1585c1.071-1.8945 3.747-1.8945 4.818 0zm-8.5425-2.052c0-0.843 0.684-1.527 1.5285-1.527 0.843 0 1.527 0.684 1.527 1.527v4.725c0 0.843-0.684 1.527-1.527 1.527-0.8445 0-1.5285-0.684-1.5285-1.527zm1.5285 10.473c0.843 0 1.527-0.684 1.527-1.5285 0-0.843-0.684-1.527-1.527-1.527-0.8445 0-1.5285 0.684-1.5285 1.527 0 0.8445 0.684 1.5285 1.5285 1.5285z'),
					$elm$svg$Svg$Attributes$fill('#d97e7e'),
					$elm$svg$Svg$Attributes$fillRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Page$Company$requestFailedView = function (message) {
	return A2(
		$author$project$Page$Company$messageWithIcon,
		$mdgriffith$elm_ui$Element$html($author$project$Common$Images$warningTriangle),
		message);
};
var $author$project$UI$spacer = 16;
var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Input$TextArea = {$: 1};
var $mdgriffith$elm_ui$Internal$Model$LivePolite = {$: 6};
var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
var $mdgriffith$elm_ui$Element$Input$applyLabel = F3(
	function (attrs, label, input) {
		if (label.$ === 1) {
			var labelText = label.a;
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asColumn,
				$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
				attrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[input])));
		} else {
			var position = label.a;
			var labelAttrs = label.b;
			var labelChild = label.c;
			var labelElement = A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				labelAttrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[labelChild])));
			switch (position) {
				case 2:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mv),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
				case 3:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mv),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				case 0:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mv),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				default:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.mv),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
			}
		}
	});
var $mdgriffith$elm_ui$Element$Input$autofill = A2(
	$elm$core$Basics$composeL,
	$mdgriffith$elm_ui$Internal$Model$Attr,
	$elm$html$Html$Attributes$attribute('autocomplete'));
var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
var $mdgriffith$elm_ui$Element$behindContent = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 5, element);
};
var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
var $mdgriffith$elm_ui$Element$moveUp = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(-y));
};
var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
	var gatherSpacing = F2(
		function (attr, found) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v2 = attr.b;
				var x = _v2.b;
				var y = _v2.c;
				if (found.$ === 1) {
					return $elm$core$Maybe$Just(y);
				} else {
					return found;
				}
			} else {
				return found;
			}
		});
	var _v0 = A3($elm$core$List$foldr, gatherSpacing, $elm$core$Maybe$Nothing, attrs);
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	} else {
		var vSpace = _v0.a;
		return $mdgriffith$elm_ui$Element$moveUp(
			$elm$core$Basics$floor(vSpace / 2));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
var $mdgriffith$elm_ui$Element$clip = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.v9);
var $mdgriffith$elm_ui$Element$rgb = F3(
	function (r, g, b) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, r, g, b, 1);
	});
var $mdgriffith$elm_ui$Element$Input$darkGrey = A3($mdgriffith$elm_ui$Element$rgb, 186 / 255, 189 / 255, 182 / 255);
var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12);
var $mdgriffith$elm_ui$Element$Input$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Input$defaultTextPadding,
		$mdgriffith$elm_ui$Element$Border$rounded(3),
		$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
		$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$spacing(5),
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
	]);
var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
	if (attr.$ === 8) {
		var h = attr.a;
		return $elm$core$Maybe$Just(h);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
	if (label.$ === 1) {
		var textLabel = label.a;
		return $mdgriffith$elm_ui$Internal$Model$Describe(
			$mdgriffith$elm_ui$Internal$Model$Label(textLabel));
	} else {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	}
};
var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
	isConstrained:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return true;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isConstrained;
			default:
				var l = len.b;
				return true;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
	if (label.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
	if (!label.$) {
		var loc = label.a;
		switch (loc) {
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return true;
			default:
				return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
	return {vr: -box.vr, A7: -box.A7, FX: -box.FX, HW: -box.HW};
};
var $mdgriffith$elm_ui$Internal$Model$paddingName = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left)))))));
	});
var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
	var top = _v0.HW;
	var right = _v0.FX;
	var bottom = _v0.vr;
	var left = _v0.A7;
	if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
		var topFloat = top;
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				'p-' + $elm$core$String$fromInt(top),
				topFloat,
				topFloat,
				topFloat,
				topFloat));
	} else {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				A4($mdgriffith$elm_ui$Internal$Model$paddingName, top, right, bottom, left),
				top,
				right,
				bottom,
				left));
	}
};
var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
	isFill:
	while (true) {
		switch (len.$) {
			case 2:
				return true;
			case 1:
				return false;
			case 0:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
	isPixel:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
		}
	}
};
var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
	});
var $mdgriffith$elm_ui$Element$Input$redistributeOver = F4(
	function (isMultiline, stacked, attr, els) {
		switch (attr.$) {
			case 9:
				return _Utils_update(
					els,
					{
						e: A2($elm$core$List$cons, attr, els.e)
					});
			case 7:
				var width = attr.a;
				return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r),
						D: A2($elm$core$List$cons, attr, els.D),
						e: A2($elm$core$List$cons, attr, els.e)
					}) : (stacked ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r)
					}) : _Utils_update(
					els,
					{
						e: A2($elm$core$List$cons, attr, els.e)
					}));
			case 8:
				var height = attr.a;
				return (!stacked) ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r),
						e: A2($elm$core$List$cons, attr, els.e)
					}) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r),
						e: A2($elm$core$List$cons, attr, els.e)
					}) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(
					els,
					{
						e: A2($elm$core$List$cons, attr, els.e)
					}) : _Utils_update(
					els,
					{
						e: A2($elm$core$List$cons, attr, els.e)
					})));
			case 6:
				return _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r)
					});
			case 5:
				return _Utils_update(
					els,
					{
						r: A2($elm$core$List$cons, attr, els.r)
					});
			case 4:
				switch (attr.b.$) {
					case 5:
						var _v1 = attr.b;
						return _Utils_update(
							els,
							{
								r: A2($elm$core$List$cons, attr, els.r),
								D: A2($elm$core$List$cons, attr, els.D),
								e: A2($elm$core$List$cons, attr, els.e),
								lk: A2($elm$core$List$cons, attr, els.lk)
							});
					case 7:
						var cls = attr.a;
						var _v2 = attr.b;
						var pad = _v2.a;
						var t = _v2.b;
						var r = _v2.c;
						var b = _v2.d;
						var l = _v2.e;
						if (isMultiline) {
							return _Utils_update(
								els,
								{
									$7: A2($elm$core$List$cons, attr, els.$7),
									e: A2($elm$core$List$cons, attr, els.e)
								});
						} else {
							var newTop = t - A2($elm$core$Basics$min, t, b);
							var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'line-height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newBottom = b - A2($elm$core$Basics$min, t, b);
							var reducedVerticalPadding = A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, r, newBottom, l),
									newTop,
									r,
									newBottom,
									l));
							return _Utils_update(
								els,
								{
									$7: A2($elm$core$List$cons, attr, els.$7),
									D: A2(
										$elm$core$List$cons,
										newHeight,
										A2($elm$core$List$cons, newLineHeight, els.D)),
									e: A2($elm$core$List$cons, reducedVerticalPadding, els.e)
								});
						}
					case 6:
						var _v3 = attr.b;
						return _Utils_update(
							els,
							{
								$7: A2($elm$core$List$cons, attr, els.$7),
								e: A2($elm$core$List$cons, attr, els.e)
							});
					case 10:
						return _Utils_update(
							els,
							{
								$7: A2($elm$core$List$cons, attr, els.$7),
								e: A2($elm$core$List$cons, attr, els.e)
							});
					case 2:
						return _Utils_update(
							els,
							{
								r: A2($elm$core$List$cons, attr, els.r)
							});
					case 1:
						var _v4 = attr.b;
						return _Utils_update(
							els,
							{
								r: A2($elm$core$List$cons, attr, els.r)
							});
					default:
						var flag = attr.a;
						var cls = attr.b;
						return _Utils_update(
							els,
							{
								e: A2($elm$core$List$cons, attr, els.e)
							});
				}
			case 0:
				return els;
			case 1:
				var a = attr.a;
				return _Utils_update(
					els,
					{
						D: A2($elm$core$List$cons, attr, els.D)
					});
			case 2:
				return _Utils_update(
					els,
					{
						D: A2($elm$core$List$cons, attr, els.D)
					});
			case 3:
				return _Utils_update(
					els,
					{
						e: A2($elm$core$List$cons, attr, els.e)
					});
			default:
				return _Utils_update(
					els,
					{
						D: A2($elm$core$List$cons, attr, els.D)
					});
		}
	});
var $mdgriffith$elm_ui$Element$Input$redistribute = F3(
	function (isMultiline, stacked, attrs) {
		return function (redist) {
			return {
				$7: $elm$core$List$reverse(redist.$7),
				r: $elm$core$List$reverse(redist.r),
				D: $elm$core$List$reverse(redist.D),
				e: $elm$core$List$reverse(redist.e),
				lk: $elm$core$List$reverse(redist.lk)
			};
		}(
			A3(
				$elm$core$List$foldl,
				A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked),
				{$7: _List_Nil, r: _List_Nil, D: _List_Nil, e: _List_Nil, lk: _List_Nil},
				attrs));
	});
var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
	var top = _v0.HW;
	var right = _v0.FX;
	var bottom = _v0.vr;
	var left = _v0.A7;
	return $elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px'))))));
};
var $mdgriffith$elm_ui$Element$Input$charcoal = A3($mdgriffith$elm_ui$Element$rgb, 136 / 255, 138 / 255, 133 / 255);
var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
var $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3(
	function (_v0, forPlaceholder, on) {
		var placeholderAttrs = _v0.a;
		var placeholderEl = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				forPlaceholder,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.rB + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.DK)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$Border$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$Background$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alpha(
							on ? 1 : 0)
						]),
					placeholderAttrs)),
			placeholderEl);
	});
var $mdgriffith$elm_ui$Element$scrollbarY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.Gb);
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$spellcheck);
var $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$value);
var $mdgriffith$elm_ui$Element$Input$textHelper = F3(
	function (textInput, attrs, textOptions) {
		var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
		var redistributed = A3(
			$mdgriffith$elm_ui$Element$Input$redistribute,
			_Utils_eq(textInput.km, $mdgriffith$elm_ui$Element$Input$TextArea),
			$mdgriffith$elm_ui$Element$Input$isStacked(textOptions.kX),
			withDefaults);
		var onlySpacing = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v9 = attr.b;
				return true;
			} else {
				return false;
			}
		};
		var heightConstrained = function () {
			var _v7 = textInput.km;
			if (!_v7.$) {
				var inputType = _v7.a;
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$mdgriffith$elm_ui$Element$Input$isConstrained,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
			}
		}();
		var getPadding = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 7)) {
				var cls = attr.a;
				var _v6 = attr.b;
				var pad = _v6.a;
				var t = _v6.b;
				var r = _v6.c;
				var b = _v6.d;
				var l = _v6.e;
				return $elm$core$Maybe$Just(
					{
						vr: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(b - 3)),
						A7: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(l - 3)),
						FX: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(r - 3)),
						HW: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(t - 3))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var parentPadding = A2(
			$elm$core$Maybe$withDefault,
			{vr: 0, A7: 0, FX: 0, HW: 0},
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$filterMap, getPadding, withDefaults))));
		var inputElement = A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			function () {
				var _v3 = textInput.km;
				if (!_v3.$) {
					var inputType = _v3.a;
					return $mdgriffith$elm_ui$Internal$Model$NodeName('input');
				} else {
					return $mdgriffith$elm_ui$Internal$Model$NodeName('textarea');
				}
			}(),
			_Utils_ap(
				function () {
					var _v4 = textInput.km;
					if (!_v4.$) {
						var inputType = _v4.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_(inputType)),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.z0)
							]);
					} else {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.zY),
								$mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
								$mdgriffith$elm_ui$Element$paddingEach(parentPadding),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2(
									$elm$html$Html$Attributes$style,
									'margin',
									$mdgriffith$elm_ui$Element$Input$renderBox(
										$mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'))
							]);
					}
				}(),
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Input$value(textOptions.ta),
							$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Events$onInput(textOptions.rG)),
							$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.kX),
							$mdgriffith$elm_ui$Element$Input$spellcheck(textInput.jV),
							A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Internal$Model$NoAttribute,
							A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$Input$autofill, textInput.jH))
						]),
					redistributed.D)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
		var wrappedInput = function () {
			var _v0 = textInput.km;
			if (_v0.$ === 1) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_Utils_ap(
						(heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.qn),
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.z$)
								])),
						redistributed.e),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asParagraph,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Element$inFront(inputElement),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.z_),
												redistributed.lk)))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(
									function () {
										if (textOptions.ta === '') {
											var _v1 = textOptions.r3;
											if (_v1.$ === 1) {
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('\u00A0')
													]);
											} else {
												var place = _v1.a;
												return _List_fromArray(
													[
														A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, _List_Nil, textOptions.ta === '')
													]);
											}
										} else {
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Internal$Model$unstyled(
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.zZ)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(textOptions.ta + '\u00A0')
															])))
												]);
										}
									}()))
							])));
			} else {
				var inputType = _v0.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2(
							$elm$core$List$cons,
							A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.qn),
							$elm$core$List$concat(
								_List_fromArray(
									[
										redistributed.e,
										function () {
										var _v2 = textOptions.r3;
										if (_v2.$ === 1) {
											return _List_Nil;
										} else {
											var place = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$behindContent(
													A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, redistributed.$7, textOptions.ta === ''))
												]);
										}
									}()
									])))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[inputElement])));
			}
		}();
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.yg),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.kX) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5),
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$Region$announce, redistributed.r))),
			textOptions.kX,
			wrappedInput);
	});
var $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		jH: $elm$core$Maybe$Nothing,
		jV: false,
		km: $mdgriffith$elm_ui$Element$Input$TextInputNode('text')
	});
var $author$project$Page$Company$textInputStyleAttributes = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$height(
		$mdgriffith$elm_ui$Element$px(40)),
		$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeLarge),
		$mdgriffith$elm_ui$Element$Border$width(0),
		$mdgriffith$elm_ui$Element$padding(0),
		$mdgriffith$elm_ui$Element$htmlAttribute(
		A2($elm$html$Html$Attributes$style, 'line-height', '40px')),
		$mdgriffith$elm_ui$Element$htmlAttribute(
		A2($elm$html$Html$Attributes$style, 'height', '40px')),
		$mdgriffith$elm_ui$Element$htmlAttribute(
		A2($elm$html$Html$Attributes$style, 'padding', '0 16px')),
		$mdgriffith$elm_ui$Element$htmlAttribute(
		$elm$html$Html$Attributes$class('elm-ui'))
	]);
var $author$project$Page$Company$agentForm = F2(
	function (_v0, model) {
		var language = _v0.A_;
		var isRequired = model.yt.mw;
		var agentId = $elm$core$String$toInt(
			$elm$core$String$trim(model.zN));
		var address = $author$project$Page$Company$capitalizeString(model.yt.tT.G0 + (', ' + (model.yt.tT.IG + (' ' + model.yt.tT.v0))));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacer),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacerSmall),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeLarge)
								]),
							$mdgriffith$elm_ui$Element$text(model.yt.oh)),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeRegular),
									$mdgriffith$elm_ui$Element$Font$light
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text(address)
								]))
						])),
					A2(
					$mdgriffith$elm_ui$Element$Input$text,
					_Utils_ap(
						function () {
							var _v1 = model.tZ;
							switch (_v1.$) {
								case 1:
									return _List_fromArray(
										[
											$mdgriffith$elm_ui$Element$inFront($author$project$Page$Company$loadingSpinner)
										]);
								case 2:
									return _List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Background$color($author$project$UI$colors.s5),
											$mdgriffith$elm_ui$Element$inFront($author$project$Page$Company$clearInputButton)
										]);
								default:
									return _List_Nil;
							}
						}(),
						_Utils_ap(
							$author$project$Page$Company$textInputStyleAttributes,
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (a) {
											return _List_fromArray(
												[
													$author$project$Page$Company$onEnter(
													$author$project$Page$Company$ClickedGetAgent(a))
												]);
										},
										agentId)),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$htmlAttribute(
										$elm$html$Html$Attributes$pattern('[0-9]*')),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'))
									])))),
					{
						kX: $author$project$Page$Company$inputLabel(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.xC;
								})),
						rG: $author$project$Page$Company$EnteredAgentId,
						r3: $elm$core$Maybe$Nothing,
						ta: model.zN
					}),
					isRequired ? $mdgriffith$elm_ui$Element$none : $author$project$Page$Company$notificationView(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.xE;
						})),
					$krisajenkins$remotedata$RemoteData$isFailure(model.tZ) ? $author$project$Page$Company$requestFailedView(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.xD;
						})) : $mdgriffith$elm_ui$Element$none,
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacerSmall),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$krisajenkins$remotedata$RemoteData$isFailure(model.tZ) ? A2($author$project$Page$Company$continueButton, language, $elm$core$Maybe$Nothing) : (((!isRequired) && $elm$core$String$isEmpty(model.zN)) ? A2(
							$author$project$Page$Company$continueButton,
							language,
							$elm$core$Maybe$Just($author$project$Page$Company$ClickedGoBack)) : A2(
							$author$project$Page$Company$continueButton,
							language,
							A2($elm$core$Maybe$map, $author$project$Page$Company$ClickedGetAgent, agentId))),
							$author$project$Page$Company$cancelButton(language)
						]))
				]));
	});
var $author$project$Page$Company$ClickedGetCompany = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$Company$EnteredCompanyId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Company$temporaryClubOneLogOutWarningToast = function (language) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeRegular),
				$mdgriffith$elm_ui$Element$Font$light
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.xF;
					}))
			]));
};
var $author$project$Page$Company$companyForm = F2(
	function (session, model) {
		var language = session.A_;
		var isClubOne = A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			false,
			A2($krisajenkins$remotedata$RemoteData$map, $author$project$Types$Client$isCluboneClient, session.Ia.v4));
		var companyId = $elm$core$String$toInt(
			$elm$core$String$trim(model.zN));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacer),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					isClubOne ? $author$project$Page$Company$temporaryClubOneLogOutWarningToast(language) : $mdgriffith$elm_ui$Element$none,
					A2(
					$mdgriffith$elm_ui$Element$Input$text,
					_Utils_ap(
						function () {
							var _v0 = model.yt;
							switch (_v0.$) {
								case 1:
									return _List_fromArray(
										[
											$mdgriffith$elm_ui$Element$inFront($author$project$Page$Company$loadingSpinner)
										]);
								case 2:
									return _List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Background$color($author$project$UI$colors.s5),
											$mdgriffith$elm_ui$Element$inFront($author$project$Page$Company$clearInputButton)
										]);
								default:
									return _List_Nil;
							}
						}(),
						_Utils_ap(
							$author$project$Page$Company$textInputStyleAttributes,
							_Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (a) {
											return _List_fromArray(
												[
													$author$project$Page$Company$onEnter(
													$author$project$Page$Company$ClickedGetCompany(a))
												]);
										},
										companyId)),
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$htmlAttribute(
										$elm$html$Html$Attributes$pattern('[0-9]*')),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric'))
									])))),
					{
						kX: $author$project$Page$Company$inputLabel(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.xG;
								})),
						rG: $author$project$Page$Company$EnteredCompanyId,
						r3: $elm$core$Maybe$Nothing,
						ta: model.zN
					}),
					$krisajenkins$remotedata$RemoteData$isFailure(model.yt) ? $author$project$Page$Company$requestFailedView(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.xH;
						})) : $mdgriffith$elm_ui$Element$none,
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacerSmall),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$krisajenkins$remotedata$RemoteData$isFailure(model.yt) ? A2($author$project$Page$Company$continueButton, language, $elm$core$Maybe$Nothing) : A2(
							$author$project$Page$Company$continueButton,
							language,
							A2($elm$core$Maybe$map, $author$project$Page$Company$ClickedGetCompany, companyId)),
							$author$project$Page$Company$cancelButton(language)
						]))
				]));
	});
var $author$project$Page$Company$pageTitle = function (language) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size($author$project$UI$fontSizeLarge)
			]),
		$mdgriffith$elm_ui$Element$text(
			$elm$core$String$toUpper(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.xB;
					}))));
};
var $author$project$Page$Company$panel = F2(
	function (session, model) {
		var language = session.A_;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Background$color($author$project$UI$colors.l0),
					$mdgriffith$elm_ui$Element$padding($author$project$UI$spacer),
					$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacer),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					$author$project$Page$Company$pageTitle(language),
					function () {
					if (!model.$) {
						var form = model.a;
						return A2($author$project$Page$Company$companyForm, session, form);
					} else {
						var form = model.a;
						return A2($author$project$Page$Company$agentForm, session, form);
					}
				}()
				]));
	});
var $author$project$Page$Company$view = F2(
	function (session, model) {
		return A3(
			$mdgriffith$elm_ui$Element$layoutWith,
			{Dn: _List_Nil},
			_List_Nil,
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$author$project$UI$fontFamily,
						$mdgriffith$elm_ui$Element$Font$color($author$project$UI$colors.ev),
						$mdgriffith$elm_ui$Element$spacing($author$project$UI$spacerSmall),
						$mdgriffith$elm_ui$Element$padding($author$project$UI$spacerSmall),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$Page$Company$backLink,
						A2($author$project$Page$Company$panel, session, model)
					])));
	});
var $author$project$Page$Discount$Update$GoBack = {$: 0};
var $author$project$Page$Discount$View$backButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('backButton'),
			$elm$html$Html$Events$onClick(
			$author$project$Messages$DiscountMsg($author$project$Page$Discount$Update$GoBack))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/images/common/icon_back_white_arrow.svg')
				]),
			_List_Nil)
		]));
var $author$project$Page$Discount$Update$Validate = {$: 3};
var $author$project$Page$Discount$View$addButton = F2(
	function (translations, code) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voucherButton outlineBigButton'),
					$elm$html$Html$Attributes$disabled(
					$elm$core$String$isEmpty(
						$elm$core$String$trim(code))),
					$elm$html$Html$Events$onClick($author$project$Page$Discount$Update$Validate)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.H7)
				]));
	});
var $author$project$Page$Discount$View$discountFormTitle = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title2')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.yz)
			]));
};
var $author$project$Page$Discount$Update$DeleteCode = {$: 1};
var $author$project$Page$Discount$Update$EnteredCode = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Common$Images$crossImage2 = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('#004152'),
			$elm$svg$Svg$Attributes$fillRule('evenodd'),
			$elm$svg$Svg$Attributes$width('10'),
			$elm$svg$Svg$Attributes$height('10'),
			$elm$svg$Svg$Attributes$viewBox('0 0 10 10')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M9.2883 0.122527C9.12559 -0.0401914 8.86177 -0.0401913 8.69905 0.122527L4.99999 3.82158L1.30094 0.122534C1.13823 -0.0401845 0.874407 -0.0401846 0.711689 0.122534L0.122433 0.71179C-0.0402854 0.874508 -0.0402854 1.13833 0.122433 1.30105L3.82148 5.00009L0.122432 8.69914C-0.0402867 8.86186 -0.0402867 9.12568 0.122432 9.2884L0.711687 9.87766C0.874406 10.0404 1.13822 10.0404 1.30094 9.87766L4.99999 6.17861L8.69905 9.87766C8.86177 10.0404 9.12559 10.0404 9.2883 9.87766L9.87756 9.28841C10.0403 9.12569 10.0403 8.86187 9.87756 8.69915L6.1785 5.00009L9.87756 1.30104C10.0403 1.13832 10.0403 0.874501 9.87756 0.711783L9.2883 0.122527Z')
				]),
			_List_Nil)
		]));
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Page$Discount$View$discountInput = F2(
	function (voucherIsValid, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inputRow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('data'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('validationError', !voucherIsValid)
								])),
							$elm$html$Html$Attributes$tabindex(0),
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$maxlength(30),
							$elm$html$Html$Attributes$required(true),
							$elm$html$Html$Attributes$autofocus(true),
							$elm$html$Html$Attributes$disabled(
							$krisajenkins$remotedata$RemoteData$isLoading(model.ko)),
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'voucher-input'),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-test-voucher-is-valid',
							$author$project$Utils$String$fromBool(voucherIsValid)),
							$elm$html$Html$Events$onInput($author$project$Page$Discount$Update$EnteredCode),
							$elm$html$Html$Attributes$value(model.pQ)
						]),
					_List_Nil),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					(model.pQ !== '') && (!$krisajenkins$remotedata$RemoteData$isLoading(model.ko)),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('clear'),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'clear-input'),
								$elm$html$Html$Events$onClick($author$project$Page$Discount$Update$DeleteCode)
							]),
						_List_fromArray(
							[$author$project$Common$Images$crossImage2]))),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					$krisajenkins$remotedata$RemoteData$isLoading(model.ko),
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spinner'),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'input-spinner')
							]),
						_List_fromArray(
							[
								$author$project$Common$Images$darkPropellerWithClassName('animateSpinner')
							])))
				]));
	});
var $author$project$Page$Discount$View$validationMessage = function (string) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyNorm message'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-validation-message', '')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Page$Discount$View$discountInputForm = F2(
	function (translations, model) {
		var voucherIsValid = function () {
			var _v0 = model.ko;
			switch (_v0.$) {
				case 2:
					return false;
				case 3:
					var isValid = _v0.a.Aw;
					return isValid;
				default:
					return true;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('discountInputForm'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'voucher-form')
				]),
			_List_fromArray(
				[
					$author$project$Page$Discount$View$discountFormTitle(translations),
					A2($author$project$Page$Discount$View$discountInput, voucherIsValid, model),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					!voucherIsValid,
					$author$project$Page$Discount$View$validationMessage(translations.uM)),
					A2($author$project$Page$Discount$View$addButton, translations, model.pQ)
				]));
	});
var $author$project$Page$Discount$View$title = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title2 marginBottomMedium')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.p9)
			]));
};
var $author$project$Page$Discount$View$discountInputPanel = F2(
	function (translations, model) {
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voucherInputPanel mediumPadding')
				]),
			_List_fromArray(
				[
					$author$project$Page$Discount$View$title(translations),
					A2($author$project$Page$Discount$View$discountInputForm, translations, model)
				]));
	});
var $author$project$Page$Discount$View$isCabinSelectionRequired = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Types$TravelClasses$hasSelectedTravelClasses),
			session.to));
};
var $author$project$Page$Discount$Update$Remove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Discount$View$removeDiscount = function (index) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('remove'),
				$elm$html$Html$Events$onClick(
				$author$project$Page$Discount$Update$Remove(index)),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'remove-discount')
			]),
		_List_Nil);
};
var $author$project$Page$Discount$Update$ToggleToolTip = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Discount$View$toggleDiscountDescription = F2(
	function (selected, voucher) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toggle'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', selected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Discount$Update$ToggleToolTip(voucher.pQ))
				]),
			_List_Nil);
	});
var $author$project$Page$Discount$View$voucherView = F6(
	function (translations, session, model, index, firstVoucher, voucher) {
		var selected = _Utils_eq(
			$elm$core$Maybe$Just(voucher.pQ),
			model.Ix);
		return A6(
			$author$project$Page$Discount$Voucher$view,
			translations,
			session,
			selected,
			{
				BZ: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$map,
						$author$project$Messages$DiscountMsg,
						$author$project$Page$Discount$View$removeDiscount(index))),
				Ca: $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$map,
						$author$project$Messages$DiscountMsg,
						A2($author$project$Page$Discount$View$toggleDiscountDescription, selected, voucher))),
				Dm: $author$project$Messages$OpenedModal($author$project$Common$Modal$Model$NonRefundableTerms)
			},
			firstVoucher,
			voucher);
	});
var $author$project$Page$Discount$View$discountsPanel = F3(
	function (translations, session, model) {
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('discountsPanel mediumPadding')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$author$project$Utils$Html$Render$renderIf,
						!$author$project$Session$isClubOneUser(session.Ia),
						$author$project$Common$ClubOneSignIn$clubOneSignIn(translations)),
						A2(
						$author$project$Utils$Html$Render$renderIf,
						session.Af,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('priceDetailsSpinnerContainer'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'withClubOne',
											$author$project$Session$isClubOneUser(session.Ia))
										])),
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'discounts-spinner')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('spinner animateSpinner')
										]),
									_List_fromArray(
										[$author$project$Common$Images$darkPropeller]))
								]))),
						A2(
						$author$project$Utils$Html$Render$maybeRender,
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Page$Discount$View$subtotal, translations, session),
							$author$project$Utils$Html$Render$renderIf(
								$author$project$Page$Discount$View$shouldShowSubtotal(session.tw))),
						session.B7)
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, voucher) {
							var firstVoucherIndex = A2(
								$elm_community$list_extra$List$Extra$findIndex,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.qO;
									},
									$elm$core$Basics$not),
								session.tw);
							return A6(
								$author$project$Page$Discount$View$voucherView,
								translations,
								session,
								model,
								index,
								_Utils_eq(
									$elm$core$Maybe$Just(index),
									firstVoucherIndex),
								voucher);
						}),
					A2(
						$elm$core$List$filter,
						$author$project$Page$Discount$View$isCabinSelectionRequired(session) ? function (_v0) {
							return true;
						} : function ($) {
							return $.Ax;
						},
						session.tw))));
	});
var $author$project$Page$Discount$View$view = F3(
	function (translations, session, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('discountPage')
				]),
			_List_fromArray(
				[
					$author$project$Page$Discount$View$backButton,
					A2(
					$elm$html$Html$map,
					$author$project$Messages$DiscountMsg,
					A2($author$project$Page$Discount$View$discountInputPanel, translations, model)),
					A3($author$project$Page$Discount$View$discountsPanel, translations, session, model)
				]));
	});
var $author$project$Page$Hotel$areAllNightAvailableInSelectedRange = F2(
	function (model, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var nights = _v0.CI;
					return A2(
						$elm$core$List$all,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.At;
							},
							$elm$core$Basics$eq(false)),
						A2(
							$elm$core$List$filter,
							function (_v1) {
								var date = _v1.nn;
								return (A2($author$project$Utils$Time$differenceInDays, model.zw.ln, date) >= 0) && (A2($author$project$Utils$Time$differenceInDays, model.zw.lo, date) < 0);
							},
							$author$project$Utils$OneOrMore$toList(nights)));
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.pQ;
						},
						$elm$core$Basics$eq(code)),
					$author$project$Utils$OneOrMore$toList(model.zv.F_))));
	});
var $author$project$Page$Hotel$NavigateBack = {$: 4};
var $author$project$Page$Hotel$ToggledHotelDescription = {$: 3};
var $author$project$Common$Hotel$descriptionWithBottomSeparatorView = function (_v0) {
	var description = _v0.nt;
	return A2(
		$author$project$Common$Panel$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Common$Panel$element,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('longDescription')
					]),
				$author$project$Translations$toHtml(description)),
				$author$project$Common$Panel$graySeparator(_List_Nil)
			]));
};
var $author$project$Page$Hotel$expandableElement = F2(
	function (isExpanded, children) {
		return A3(
			$elm$html$Html$node,
			'expandable-description',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-is-expanded',
					$author$project$Utils$String$fromBool(isExpanded))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('expandableDescription')
						]),
					children)
				]));
	});
var $author$project$Page$Hotel$hotelCardView = F2(
	function (session, model) {
		var language = session.A_;
		var hotel = model.zv;
		var isDescriptionExpanded = model.lv;
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotelCard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (imageUrl) {
							return $author$project$Common$Panel$header(
								_List_fromArray(
									[
										A2(
										$author$project$Common$Panel$imageHeader,
										imageUrl,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('safePaddingTop')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('backButton'),
																$elm$html$Html$Events$onClick($author$project$Page$Hotel$NavigateBack)
															]),
														_List_Nil)
													]))
											]))
									]));
						},
						hotel.zP)),
					$author$project$Common$Panel$block(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('titleAndRating')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$nameWithRatingView,
									$elm$core$String$toUpper(hotel.oh),
									hotel.mQ)
								])),
							$author$project$Common$Panel$graySeparator(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginTopSmall')
								])),
							A2(
							$author$project$Page$Hotel$expandableElement,
							isDescriptionExpanded,
							_List_fromArray(
								[
									$author$project$Common$Hotel$descriptionWithBottomSeparatorView(hotel)
								])),
							A2(
							$author$project$Common$Panel$expander,
							{yT: $author$project$Page$Hotel$ToggledHotelDescription, yX: _List_Nil, z9: isDescriptionExpanded, A_: language},
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										function (a) {
											return $author$project$Common$Hotel$locationView(
												{n1: a});
										},
										hotel.n1))
								]))
						]))
				]));
	});
var $author$project$Page$Hotel$ToggledDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$Common$Hotel$descriptionWithTopSeparatorView = function (_v0) {
	var longDescription = _v0.Bx;
	return A2(
		$author$project$Common$Panel$row,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Common$Panel$graySeparator(_List_Nil),
				A2(
				$author$project$Common$Panel$element,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('longDescription')
					]),
				$author$project$Translations$toHtml(longDescription))
			]));
};
var $author$project$Page$Hotel$AddedRoom = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Hotel$ClickedShowHotelRoomCapacityWarningToast = {$: 6};
var $author$project$Page$Hotel$RemovedRoom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Hotel$allSelectionsCount = function (_v0) {
	var dict = _v0;
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				function ($) {
					return $.pZ;
				}),
			$elm$core$Dict$toList(dict)));
};
var $author$project$Page$Hotel$hasMaxCountBeenReached = F2(
	function (passengers, selectedRooms) {
		return _Utils_cmp(
			$author$project$Types$Passenger$Util$countAdultPassengers(passengers),
			$author$project$Types$Hotel$allSelectionsCount(selectedRooms)) < 1;
	});
var $author$project$Types$Hotel$selectedRoomCount = F2(
	function (code, _v0) {
		var dict = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.pZ;
				},
				A2(
					$elm$core$Dict$get,
					$author$project$Types$Hotel$roomCodeToString(code),
					dict)));
	});
var $author$project$Page$Hotel$plusMinusButtonContent = F3(
	function (_v0, model, room) {
		var language = _v0.A_;
		var selectedRoomsCount = A2($author$project$Types$Hotel$selectedRoomCount, room.pQ, model.Gk);
		return (selectedRoomsCount < 1) ? $elm$html$Html$text(
			$elm$core$String$toUpper(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.xl;
					}))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(selectedRoomsCount))
				]));
	});
var $author$project$Page$Hotel$roomButtonView = F4(
	function (session, model, hotel, room) {
		var passengers = session.Eg;
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button roomButton')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
					{
						pZ: A2($author$project$Types$Hotel$selectedRoomCount, room.pQ, model.Gk),
						nw: true,
						nQ: false,
						q_: false,
						kZ: $elm$core$Maybe$Just(
							$author$project$Types$Passenger$Util$countAdultPassengers(passengers)),
						rx: _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Page$Hotel$RemovedRoom(room.pQ)),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'remove-room')
							]),
						oz: _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								A2($author$project$Page$Hotel$hasMaxCountBeenReached, passengers, model.Gk) ? $author$project$Page$Hotel$ClickedShowHotelRoomCapacityWarningToast : $author$project$Page$Hotel$AddedRoom(room.pQ)),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'add-room')
							])
					},
					_List_fromArray(
						[
							A3($author$project$Page$Hotel$plusMinusButtonContent, session, model, room)
						]))
				]));
	});
var $author$project$Page$Hotel$roomView = F4(
	function (session, model, hotel, room) {
		var language = session.A_;
		var passengers = session.Eg;
		var isDescriptionExpanded = _Utils_eq(
			model.k6,
			$elm$core$Maybe$Just(room.pQ));
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('roomCard marginHorizontalSmall')
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (imageUrl) {
							return A2(
								$author$project$Common$Panel$imageHeader,
								imageUrl,
								_List_fromArray(
									[
										$author$project$Common$Panel$imageHeaderTitle(room.oh)
									]));
						},
						room.zP)),
					$author$project$Common$Panel$block(
					_List_fromArray(
						[
							A2(
							$author$project$Common$Panel$expander,
							{
								yT: $author$project$Page$Hotel$ToggledDescription(room.pQ),
								yX: _List_Nil,
								z9: isDescriptionExpanded,
								A_: language
							},
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									$author$project$Translations$toHtml(room.nt))
								])),
							A2(
							$author$project$Page$Hotel$expandableElement,
							isDescriptionExpanded,
							_List_fromArray(
								[
									$author$project$Common$Hotel$descriptionWithTopSeparatorView(room)
								])),
							A2(
							$author$project$Common$Panel$row,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('separator')
								]),
							_List_fromArray(
								[
									$author$project$Common$Panel$graySeparator(_List_Nil)
								])),
							A2(
							$author$project$Common$Panel$row,
							_List_Nil,
							_List_fromArray(
								[
									A4($author$project$Page$Hotel$roomButtonView, session, model, hotel, room)
								]))
						]))
				]));
	});
var $author$project$Page$Hotel$sectionWithHeader = F2(
	function (headerText, elements) {
		return A2(
			$author$project$Common$Section$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Common$Section$header,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chooseYourRoom')
						]),
					headerText),
				elements));
	});
var $author$project$Page$Hotel$view = F2(
	function (session, model) {
		var hotel = model.zv;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotelPage page withFixedButton')
				]),
			_List_fromArray(
				[
					A2($author$project$Page$Hotel$hotelCardView, session, model),
					A2(
					$author$project$Page$Hotel$sectionWithHeader,
					A2(
						$author$project$Translations$t,
						session.A_,
						function ($) {
							return $.vX;
						}),
					A2(
						$elm$core$List$map,
						A3($author$project$Page$Hotel$roomView, session, model, hotel),
						A2(
							$elm$core$List$filter,
							function (room) {
								return A2($author$project$Page$Hotel$areAllNightAvailableInSelectedRange, model, room.pQ);
							},
							$author$project$Utils$OneOrMore$toList(hotel.F_))))
				]));
	});
var $author$project$Page$HotelLinks$hotelBookingUrl = F2(
	function (_v0, id) {
		var config = _v0.nh;
		var language = _v0.A_;
		var hobsSupportedLanguageCode = function () {
			switch (language) {
				case 0:
					return 'en';
				case 1:
					return 'et';
				case 2:
					return 'fi';
				case 3:
					return 'lv';
				case 5:
					return 'ru';
				default:
					return 'en';
			}
		}();
		var hobsHotelCode = function () {
			switch (id) {
				case 0:
					return 12;
				case 1:
					return 8;
				case 2:
					return 4;
				default:
					return 6;
			}
		}();
		return config.zu + ('/search' + (('/' + hobsSupportedLanguageCode) + (('/hotels/' + $elm$core$String$fromInt(hobsHotelCode)) + '/?theme=seaweb')));
	});
var $author$project$Page$HotelLinks$hotelButtonView = F2(
	function (language, link) {
		return A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hotelButton outlineButtonComponent bodyBold'),
							$elm$html$Html$Attributes$href(link),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$author$project$Common$Button$text(
							$elm$core$String$toUpper(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.vX;
									})))
						]))
				]));
	});
var $author$project$Page$HotelLinks$hotelRating = function (id) {
	switch (id) {
		case 0:
			return 4;
		case 1:
			return 3;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $author$project$Page$HotelLinks$ToggleHotelDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$HotelLinks$hotelAddress = function (id) {
	switch (id) {
		case 0:
			return 'Elizabetes iela 24, Riga';
		case 1:
			return 'Sadama 9, Tallinn';
		case 2:
			return 'Sadama 11A, Tallinn';
		default:
			return 'A.Laikmaa 5, Tallinn';
	}
};
var $author$project$Page$HotelLinks$informationView = F2(
	function (model, hotelId) {
		var isDescriptionExpanded = _Utils_eq(
			model.kx,
			$elm$core$Maybe$Just(hotelId));
		var address = $author$project$Page$HotelLinks$hotelAddress(hotelId);
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('locationAndShowMoreButton')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$expander,
					{
						yT: $author$project$Page$HotelLinks$ToggleHotelDescription(hotelId),
						yX: _List_Nil,
						z9: isDescriptionExpanded,
						A_: model.A_
					},
					_List_fromArray(
						[
							$author$project$Common$Hotel$locationView(
							{n1: address})
						]))
				]));
	});
var $author$project$Common$Hotel$expandableElement = F2(
	function (isExpanded, children) {
		return A3(
			$elm$html$Html$node,
			'expandable-description',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-is-expanded',
					$author$project$Utils$String$fromBool(isExpanded))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('expandableDescription')
						]),
					children)
				]));
	});
var $author$project$Common$Hotel$nameAndRatingView = function (_v0) {
	var name = _v0.oh;
	var rating = _v0.mQ;
	return A2(
		$author$project$Common$Panel$row,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('titleAndRating')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$UI$nameWithRatingView,
				$elm$core$String$toUpper(name),
				rating)
			]));
};
var $author$project$Common$Hotel$nameRatingDescriptionView = function (_v0) {
	var description = _v0.nt;
	var name = _v0.oh;
	var rating = _v0.mQ;
	var showDescription = _v0.GA;
	return _List_fromArray(
		[
			$author$project$Common$Hotel$nameAndRatingView(
			{oh: name, mQ: rating}),
			$author$project$Common$Panel$graySeparator(_List_Nil),
			A2(
			$author$project$Common$Hotel$expandableElement,
			showDescription,
			_List_fromArray(
				[
					$author$project$Common$Hotel$descriptionWithBottomSeparatorView(
					{nt: description})
				]))
		]);
};
var $author$project$Page$HotelLinks$hotelView = F2(
	function (model, hotel) {
		var isDescriptionExpanded = _Utils_eq(
			model.kx,
			$elm$core$Maybe$Just(hotel.zN));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginTopSmall'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hasInformation', isDescriptionExpanded)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hotelCard')
						]),
					_List_fromArray(
						[
							$author$project$Common$Panel$header(
							_List_fromArray(
								[
									A2($author$project$Common$Panel$imageHeader, hotel.k2, _List_Nil)
								])),
							$author$project$Common$Panel$block(
							_Utils_ap(
								$author$project$Common$Hotel$nameRatingDescriptionView(
									{
										nt: hotel.Bx,
										oh: hotel.HI,
										mQ: $author$project$Page$HotelLinks$hotelRating(hotel.zN),
										GA: isDescriptionExpanded
									}),
								_List_fromArray(
									[
										A2($author$project$Page$HotelLinks$informationView, model, hotel.zN),
										A2(
										$author$project$Page$HotelLinks$hotelButtonView,
										model.A_,
										A2($author$project$Page$HotelLinks$hotelBookingUrl, model, hotel.zN))
									])))
						]))
				]));
	});
var $author$project$Page$HotelLinks$hotelsOrderForMarket = function (market) {
	if (market === 2) {
		return _List_fromArray(
			[0, 2, 3, 1]);
	} else {
		return _List_fromArray(
			[2, 3, 1, 0]);
	}
};
var $author$project$Page$HotelLinks$view = function (model) {
	var hotels = model.zH;
	var market = model.rb;
	var sortedHotels = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$map,
			function (a) {
				return A2($elm$core$Dict$get, a, hotels);
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$HotelLinks$hotelIdToString,
				$author$project$Page$HotelLinks$hotelsOrderForMarket(market))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hotels hotelListPage')
			]),
		A2(
			$elm$core$List$map,
			$author$project$Page$HotelLinks$hotelView(model),
			sortedHotels));
};
var $author$project$Page$HotelList$NavigateToTimetable = {$: 11};
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Page$HotelList$dayOfWeekNames = function (_v0) {
	var language = _v0.A_;
	var weekDayNames = A2(
		$elm$core$List$map,
		function (a) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(a)
					]));
		},
		A2(
			$elm$core$List$map,
			$author$project$Utils$Time$Translations$fromLanguage(language).HM,
			_List_fromArray(
				[0, 1, 2, 3, 4, 5, 6])));
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('weekDayNames bodySmall')
					]),
				weekDayNames)
			]));
};
var $justinmimbs$time_extra$Time$Extra$Monday = 4;
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $author$project$Page$HotelList$AfterReturn = 1;
var $author$project$Page$HotelList$BeforeOutward = 0;
var $author$project$Page$HotelList$AfterCheckOutOnCheckInTab = 5;
var $author$project$Page$HotelList$BeforeCheckInOnCheckOutTab = 3;
var $author$project$Page$HotelList$CheckInOnCheckOutTab = 2;
var $author$project$Page$HotelList$CheckOut = 1;
var $author$project$Page$HotelList$CheckOutOnCheckInTab = 4;
var $author$project$Page$HotelList$OutwardOvernightSail = 6;
var $author$project$Page$HotelList$ReturnOvernightSail = 7;
var $author$project$Page$HotelList$getUnselectableDateStatus = F2(
	function (_v0, dayTime) {
		var selectedDates = _v0.o;
		var outwardDate = _v0.jP;
		var outwardOvernight = _v0.lI;
		var returnDate = _v0.jU;
		var returnOvernight = _v0.lP;
		var tab = _v0.kl;
		return (outwardOvernight && A2(
			$author$project$Utils$Time$isSameDay,
			dayTime,
			A4($justinmimbs$time_extra$Time$Extra$add, 11, -1, $elm$time$Time$utc, outwardDate))) ? $elm$core$Maybe$Just(6) : ((returnOvernight && A2(
			$author$project$Utils$Time$isSameDay,
			dayTime,
			A4($justinmimbs$time_extra$Time$Extra$add, 11, 1, $elm$time$Time$utc, returnDate))) ? $elm$core$Maybe$Just(7) : ((!A2($author$project$Utils$Time$daysStatus, dayTime, outwardDate)) ? $elm$core$Maybe$Just(0) : ((A2($author$project$Utils$Time$daysStatus, dayTime, returnDate) === 1) ? $elm$core$Maybe$Just(1) : ((tab === 1) ? ((A2($author$project$Utils$Time$daysStatus, dayTime, selectedDates.ln) === 2) ? $elm$core$Maybe$Just(2) : ((!A2($author$project$Utils$Time$daysStatus, dayTime, selectedDates.ln)) ? $elm$core$Maybe$Just(3) : $elm$core$Maybe$Nothing)) : ((!tab) ? ((A2($author$project$Utils$Time$daysStatus, dayTime, selectedDates.lo) === 2) ? $elm$core$Maybe$Just(4) : ((A2($author$project$Utils$Time$daysStatus, dayTime, selectedDates.lo) === 1) ? $elm$core$Maybe$Just(5) : $elm$core$Maybe$Nothing)) : $elm$core$Maybe$Nothing)))));
	});
var $author$project$Utils$Time$isAfter = F2(
	function (date1, date2) {
		return A2($author$project$Utils$Time$differenceInDays, date1, date2) < 0;
	});
var $author$project$Page$HotelList$createDay = F3(
	function (calendar, day, indexInCalendar) {
		var unselectableDateStatus = A2($author$project$Page$HotelList$getUnselectableDateStatus, calendar, day);
		var isFromOutwardReturnPeriod = (!_Utils_eq(
			unselectableDateStatus,
			$elm$core$Maybe$Just(0))) && (!_Utils_eq(
			unselectableDateStatus,
			$elm$core$Maybe$Just(1)));
		var isFromCheckinCheckoutPeriod = (A2($author$project$Utils$Time$isAfter, day, calendar.o.ln) || A2($author$project$Utils$Time$isSameDay, day, calendar.o.ln)) && (A2($author$project$Utils$Time$isBefore, day, calendar.o.lo) || A2($author$project$Utils$Time$isSameDay, day, calendar.o.lo));
		var isFromAnotherMonth = !_Utils_eq(
			$author$project$Utils$Time$monthToInt(
				A2($elm$time$Time$toMonth, $elm$time$Time$utc, day)),
			$author$project$Utils$Time$monthToInt(calendar.s));
		var dates = (!calendar.kl) ? {Dp: calendar.o.lo, Gg: calendar.o.ln} : {Dp: calendar.o.ln, Gg: calendar.o.lo};
		var isSelected = A2($author$project$Utils$Time$isSameDay, dates.Gg, day) && (!isFromAnotherMonth);
		return {nn: day, nL: indexInCalendar, ky: isFromAnotherMonth, nN: isFromCheckinCheckoutPeriod, nO: isFromOutwardReturnPeriod, lx: isSelected, li: unselectableDateStatus};
	});
var $elm_community$list_extra$List$Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var thisGroup = A2($elm$core$List$take, size, xs);
		var okayLength = _Utils_eq(
			size,
			$elm$core$List$length(thisGroup));
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayLength) ? A2(
			$elm$core$List$cons,
			thisGroup,
			A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$groupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, size, xs);
	});
var $justinmimbs$time_extra$Time$Extra$rangeHelp = F6(
	function (interval, step, zone, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$time$Time$posixToMillis(current),
				$elm$time$Time$posixToMillis(until)) < 0) {
				var $temp$interval = interval,
					$temp$step = step,
					$temp$zone = zone,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = A4($justinmimbs$time_extra$Time$Extra$add, interval, step, zone, current);
				interval = $temp$interval;
				step = $temp$step;
				zone = $temp$zone;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$range = F5(
	function (interval, step, zone, start, until) {
		return A6(
			$justinmimbs$time_extra$Time$Extra$rangeHelp,
			interval,
			A2($elm$core$Basics$max, 1, step),
			zone,
			until,
			_List_Nil,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, start));
	});
var $author$project$Page$HotelList$generateAllWeeksInMonth = function (calendar) {
	var firstOfMonth = A3(
		$justinmimbs$time_extra$Time$Extra$floor,
		3,
		$elm$time$Time$utc,
		A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			$elm$time$Time$utc,
			A7($justinmimbs$time_extra$Time$Extra$Parts, calendar.h, calendar.s, 1, 0, 0, 0, 0)));
	var firstOfNextMonth = A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, $elm$time$Time$utc, firstOfMonth);
	var weeksInMonth = A5(
		$justinmimbs$time_extra$Time$Extra$range,
		11,
		1,
		$elm$time$Time$utc,
		A3($justinmimbs$time_extra$Time$Extra$floor, 4, $elm$time$Time$utc, firstOfMonth),
		A3($justinmimbs$time_extra$Time$Extra$ceiling, 4, $elm$time$Time$utc, firstOfNextMonth));
	return A2(
		$elm_community$list_extra$List$Extra$groupsOf,
		7,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var index = _v0.a;
				var date = _v0.b;
				return A3($author$project$Page$HotelList$createDay, calendar, date, index);
			},
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, weeksInMonth)));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $author$project$Page$HotelList$SelectedSelectableDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Page$HotelList$SelectedUnselectableDate = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Constants$selectedDateId = 'selected-date';
var $author$project$Page$HotelList$visualizeDay = function (day) {
	var overnightSail = _Utils_eq(
		day.li,
		$elm$core$Maybe$Just(6)) || _Utils_eq(
		day.li,
		$elm$core$Maybe$Just(7));
	var onClickMsg = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Page$HotelList$SelectedSelectableDate(day.nn),
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return A2($author$project$Page$HotelList$SelectedUnselectableDate, day.nL, status);
			},
			day.li));
	var dayNumber = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dayTopPart title3')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							A2($elm$time$Time$toDay, $elm$time$Time$utc, day.nn)))
					]))
			]));
	return A2(
		$elm$html$Html$td,
		A3(
			$author$project$Utils$List$appendIf,
			day.lx,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'selected', ''),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'selected-day'),
					$elm$html$Html$Attributes$id($author$project$Constants$selectedDateId)
				]),
			A3(
				$author$project$Utils$List$appendIf,
				!day.ky,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(onClickMsg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('day'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('overnight-sail', overnightSail),
								_Utils_Tuple2('from-outward-return-period', day.nO && (!day.ky)),
								_Utils_Tuple2('from-checkin-checkout-period', day.nN && (!day.ky)),
								_Utils_Tuple2(
								'selectable',
								_Utils_eq(day.li, $elm$core$Maybe$Nothing) && (!day.ky)),
								_Utils_Tuple2('selected', day.lx)
							]))
					]))),
		_List_fromArray(
			[
				A2($author$project$Utils$String$renderIf, !(day.ky || overnightSail), dayNumber)
			]));
};
var $author$project$Page$HotelList$monthView = F2(
	function (session, calendar) {
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Page$HotelList$dayOfWeekNames(
					A2($author$project$Types$Locale$Locale, session.A_, session.rb)),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$concatMap,
						function (daysInWeek) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Page$HotelList$visualizeDay, daysInWeek))
								]);
						},
						$author$project$Page$HotelList$generateAllWeeksInMonth(calendar)))
				]));
	});
var $author$project$Page$HotelList$CloseTooltip = {$: 7};
var $author$project$Page$HotelList$getTooltipMessage = F2(
	function (language, status) {
		var translationKey = function () {
			switch (status) {
				case 0:
					return function ($) {
						return $.qF;
					};
				case 1:
					return function ($) {
						return $.qF;
					};
				case 2:
					return function ($) {
						return $.zD;
					};
				case 3:
					return function ($) {
						return $.zC;
					};
				case 4:
					return function ($) {
						return $.zE;
					};
				case 5:
					return function ($) {
						return $.zB;
					};
				case 6:
					return function ($) {
						return $.zF;
					};
				default:
					return function ($) {
						return $.zG;
					};
			}
		}();
		return A2($author$project$Translations$t, language, translationKey);
	});
var $author$project$Page$HotelList$tooltipView = F2(
	function (language, tooltip) {
		var row = (tooltip.oC / 7) | 0;
		var top = $elm$core$String$fromFloat(40 + (39.5 * row)) + 'px';
		var message = A2($author$project$Page$HotelList$getTooltipMessage, language, tooltip.sX);
		var column = A2($elm$core$Basics$modBy, 7, tooltip.oC);
		var left = 'calc(16px + ' + ($elm$core$String$fromFloat((column + 0.5) / 7) + '*(100% - 32px)');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip bodyNorm'),
					A2($elm$html$Html$Attributes$style, 'top', top)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(message),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip-arrow '),
							A2($elm$html$Html$Attributes$style, 'left', left)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip-close-button'),
							$elm$html$Html$Events$onClick($author$project$Page$HotelList$CloseTooltip)
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$HotelList$calendarPanelView = function (_v0) {
	var session = _v0.j;
	var calendar = _v0.w;
	var outwardDate = _v0.jP;
	var returnDate = _v0.jU;
	var selectedDates = _v0.o;
	return A2(
		$author$project$Common$Panel$view,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('calendar-wrapper')
			]),
		_List_fromArray(
			[
				$author$project$Common$Panel$block(
				_List_fromArray(
					[
						A2(
						$author$project$Common$Panel$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'view', 'calendar')
									]),
								_List_fromArray(
									[
										A2($author$project$Page$HotelList$monthView, session, calendar)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mediumPadding blueGreyColor calendar-description'),
						$elm$html$Html$Events$onClick($author$project$Page$HotelList$NavigateToTimetable)
					]),
				$author$project$Translations$toHtml(
					A2(
						$author$project$Translations$t,
						session.A_,
						function ($) {
							return $.zy;
						}))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					$author$project$Page$HotelList$tooltipView(session.A_),
					calendar.lg))
			]));
};
var $author$project$Page$HotelList$SwitchedToNextMonth = {$: 8};
var $author$project$Page$HotelList$SwitchedToPreviousMonth = {$: 9};
var $author$project$Common$Images$arrow = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$height('24'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#FFF'),
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M6 12.5L16.5 2l2 2-8.5 8.5 8.5 8.5-2 2z')
				]),
			_List_Nil)
		]));
var $author$project$Page$HotelList$monthNameView = F2(
	function (session, calendar) {
		var isReturnButtonDisabled = _Utils_eq(
			calendar.s,
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, calendar.jU));
		var isOutwardButtonDisabled = _Utils_eq(
			calendar.s,
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, calendar.jP));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('monthSelector')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Utils$String$renderIf,
					(!isOutwardButtonDisabled) || (!isReturnButtonDisabled),
					A2(
						$author$project$Common$Panel$element,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title2')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Utils$String$renderIf,
								!isOutwardButtonDisabled,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('previousButton'),
											$elm$html$Html$Events$onClick($author$project$Page$HotelList$SwitchedToPreviousMonth)
										]),
									_List_fromArray(
										[$author$project$Common$Images$arrow]))),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										function (a) {
											return a.HL(calendar.s);
										}(
											$author$project$Utils$Time$Translations$fromLanguage(session.A_)))
									])),
								A2(
								$author$project$Utils$String$renderIf,
								!isReturnButtonDisabled,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('nextButton'),
											$elm$html$Html$Events$onClick($author$project$Page$HotelList$SwitchedToNextMonth)
										]),
									_List_fromArray(
										[$author$project$Common$Images$arrow])))
							])))
				]));
	});
var $author$project$Page$HotelList$SelectedTab = function (a) {
	return {$: 4, a: a};
};
var $author$project$Page$HotelList$tabsView = function (_v0) {
	var session = _v0.j;
	var calendar = _v0.w;
	var selectedDates = _v0.o;
	var formatTokens = function (tokens) {
		return A3(
			$ryan_haskell$date_format$DateFormat$formatWithLanguage,
			$author$project$Utils$Time$Translations$fromLanguage(session.A_),
			tokens,
			$elm$time$Time$utc);
	};
	var format = _List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthFixed,
			$ryan_haskell$date_format$DateFormat$text('.'),
			$ryan_haskell$date_format$DateFormat$monthFixed,
			$ryan_haskell$date_format$DateFormat$text('.'),
			$ryan_haskell$date_format$DateFormat$yearNumber
		]);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tabs')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tab'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('active', !calendar.kl)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'check-in-tab'),
						$elm$html$Html$Events$onClick(
						$author$project$Page$HotelList$SelectedTab(0))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm tab-description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$toUpper(
									A2(
										$author$project$Translations$t,
										session.A_,
										function ($) {
											return $.vR;
										})))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm tab-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(formatTokens, format, selectedDates.ln))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tab'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('active', calendar.kl === 1)
							])),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'check-out-tab'),
						$elm$html$Html$Events$onClick(
						$author$project$Page$HotelList$SelectedTab(1))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm tab-description')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$toUpper(
									A2(
										$author$project$Translations$t,
										session.A_,
										function ($) {
											return $.vS;
										})))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm tab-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(formatTokens, format, selectedDates.lo))
							]))
					]))
			]));
};
var $author$project$Page$HotelList$calendarView = F2(
	function (session, calendar) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginHorizontalSmall marginTopSmall')
				]),
			_List_fromArray(
				[
					$author$project$Page$HotelList$tabsView(
					{w: calendar, o: calendar.o, j: session}),
					A2($author$project$Page$HotelList$monthNameView, session, calendar),
					$author$project$Page$HotelList$calendarPanelView(
					{w: calendar, jP: calendar.jP, jU: calendar.jU, o: calendar.o, j: session})
				]));
	});
var $author$project$Page$HotelList$header = function (language) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('headerHolder')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title2 cell')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.zv;
									}))
							]))
					]))
			]));
};
var $author$project$Page$HotelList$SelectedCity = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$HotelList$cityButtonView = function (_v0) {
	var language = _v0.A_;
	var cityNameKey = _v0.pL;
	var selectedCityCode = _v0.sG;
	var cityCode = _v0.pK;
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodyBold'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'active',
						_Utils_eq(
							$author$project$Types$Hotel$cityCodeToString(selectedCityCode),
							$author$project$Types$Hotel$cityCodeToString(cityCode)))
					])),
				$elm$html$Html$Events$onClick(
				$author$project$Page$HotelList$SelectedCity(cityCode)),
				A2(
				$elm$html$Html$Attributes$attribute,
				'data-city',
				$author$project$Types$Hotel$cityCodeToString(cityCode))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$toUpper(
					A2($author$project$Translations$t, language, cityNameKey)))
			]));
};
var $author$project$Page$HotelList$cityCodeToCityName = function (cityCode) {
	var _v0 = $author$project$Types$Hotel$cityCodeToString(cityCode);
	switch (_v0) {
		case 'HEL':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bc;
				});
		case 'TLL':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bs;
				});
		case 'PAR':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bl;
				});
		case 'TAR':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bq;
				});
		case 'KUR':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bf;
				});
		case 'JUR':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bd;
				});
		case 'KOM':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Be;
				});
		case 'LAL':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bg;
				});
		case 'MHQ':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bh;
				});
		case 'NAR':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bi;
				});
		case 'NRK':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bj;
				});
		case 'OTE':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bk;
				});
		case 'RAK':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bm;
				});
		case 'RIX':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bn;
				});
		case 'SOE':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bo;
				});
		case 'STO':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bp;
				});
		case 'TKU':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Br;
				});
		case 'TMP':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bt;
				});
		case 'UPP':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bu;
				});
		case 'VAN':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bv;
				});
		case 'VIH':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Bw;
				});
		case 'OTHER':
			return $elm$core$Maybe$Just(
				function ($) {
					return $.Dp;
				});
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$HotelList$citiesView = F4(
	function (selectedCityCode, cities, language, _v0) {
		var showLeftShadow = _v0.lR;
		var showRightShadow = _v0.lS;
		var cityButton = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (cityNameKey) {
						return $author$project$Page$HotelList$cityButtonView(
							{pK: code, pL: cityNameKey, A_: language, sG: selectedCityCode});
					},
					$author$project$Page$HotelList$cityCodeToCityName(code)));
		};
		var _v1 = $author$project$Page$HotelList$citiesToVisibleAndOther(cities);
		var visible = _v1.pf;
		var other = _v1.Dp;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cities'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('withLeftShadow', showLeftShadow),
							_Utils_Tuple2('withRightShadow', showRightShadow)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cityButtons'),
							$elm$html$Html$Attributes$id('cityButtons'),
							A2(
							$elm$html$Html$Events$on,
							'touchmove',
							$elm$json$Json$Decode$succeed($author$project$Page$HotelList$DraggedCities))
						]),
					_Utils_ap(
						A2($elm$core$List$map, cityButton, visible),
						_List_fromArray(
							[
								(!$elm$core$List$isEmpty(other)) ? cityButton($author$project$Types$Hotel$otherCityCode) : $elm$html$Html$text('')
							])))
				]));
	});
var $author$project$Page$HotelList$findCityRelatedHotels = function (_v0) {
	var hotels = _v0.zH;
	var city = _v0.v0;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Dict$get,
			$author$project$Types$Hotel$cityCodeToString(city),
			hotels));
};
var $author$project$Page$HotelList$filterByCity = function (_v0) {
	var hotels = _v0.zH;
	var cityCode = _v0.pK;
	return A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.pK;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$Types$Hotel$cityCodeToString,
				$elm$core$Basics$eq(
					$author$project$Types$Hotel$cityCodeToString(cityCode)))),
		hotels);
};
var $author$project$Page$HotelList$groupByCities = function (_v0) {
	var hotels = _v0.zH;
	var cities = _v0.vZ;
	var visibleAndOtherCities = $author$project$Page$HotelList$citiesToVisibleAndOther(cities);
	var visible = A2(
		$elm$core$List$map,
		function (cityCode) {
			return _Utils_Tuple2(
				$author$project$Types$Hotel$cityCodeToString(cityCode),
				$author$project$Page$HotelList$filterByCity(
					{pK: cityCode, zH: hotels}));
		},
		visibleAndOtherCities.pf);
	var other = function (otherHotels) {
		return _Utils_Tuple2(
			$author$project$Types$Hotel$cityCodeToString($author$project$Types$Hotel$otherCityCode),
			otherHotels);
	}(
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (cityCode) {
					return $author$project$Page$HotelList$filterByCity(
						{pK: cityCode, zH: hotels});
				},
				visibleAndOtherCities.Dp)));
	return $elm$core$Dict$fromList(
		_Utils_ap(
			visible,
			_List_fromArray(
				[other])));
};
var $author$project$Page$HotelList$ClearedHotelAndRoomsSelections = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$HotelList$clearAndSelectInformationView = F2(
	function (language, hotel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('information hotelSelection mediumPadding')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text bodyBold marginBottomSmall')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.ue;
								}))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('clearAndSelect bodyBold marginBottomSmall'),
							$elm$html$Html$Events$onClick(
							$author$project$Page$HotelList$ClearedHotelAndRoomsSelections(hotel.pQ))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$toUpper(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.v3;
									})))
						]))
				]));
	});
var $author$project$Page$HotelList$OpenedHotelPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$HotelList$ShowedResetRoomsNotification = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Hotel$isHotelSelected = F2(
	function (code, _v0) {
		var dict = _v0;
		return !_Utils_eq(
			$elm$core$Maybe$Nothing,
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.zx;
					},
					$elm$core$Basics$eq(code)),
				$elm$core$Dict$values(dict)));
	});
var $author$project$Page$HotelList$hotelButtonText = F2(
	function (_v0, hotel) {
		var language = _v0.A_;
		var selectedHotelRooms = _v0.Gk;
		var isSelected = A2($author$project$Types$Hotel$isHotelSelected, hotel.pQ, selectedHotelRooms);
		var isMultipleRoomsSelected = $author$project$Types$Hotel$allSelectionsCount(selectedHotelRooms) > 1;
		return A2(
			$author$project$Translations$t,
			language,
			isSelected ? (isMultipleRoomsSelected ? function ($) {
				return $.yG;
			} : function ($) {
				return $.yF;
			}) : function ($) {
				return $.vX;
			});
	});
var $author$project$Page$HotelList$hotelButtonView = F2(
	function (session, hotel) {
		var language = session.A_;
		var selectedHotelRooms = session.Gk;
		var isSelected = A2($author$project$Types$Hotel$isHotelSelected, hotel.pQ, selectedHotelRooms);
		var hasSelectedHotel = !_Utils_eq(
			$elm$core$Maybe$Nothing,
			$author$project$Types$Hotel$selectedHotelCode(selectedHotelRooms));
		var event = (hasSelectedHotel && (!isSelected)) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Page$HotelList$ShowedResetRoomsNotification(hotel.pQ))
			]) : _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$Page$HotelList$OpenedHotelPage(
					$author$project$Types$Hotel$hotelCodeToString(hotel.pQ)))
			]);
		return A2(
			$author$project$Common$Panel$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Button$outline,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('hotelButton'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2($author$project$Common$Button$activeState, isSelected)
									])),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'hotel-button')
							]),
						event),
					_List_fromArray(
						[
							$author$project$Common$Button$text(
							$elm$core$String$toUpper(
								A2($author$project$Page$HotelList$hotelButtonText, session, hotel)))
						]))
				]));
	});
var $author$project$Page$HotelList$ToggledDescription = function (a) {
	return {$: 10, a: a};
};
var $author$project$Page$HotelList$informationView = F3(
	function (model, language, hotel) {
		var isDescriptionExpanded = _Utils_eq(
			model.kx,
			$elm$core$Maybe$Just(hotel.pQ));
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('locationAndShowMoreButton')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$expander,
					{
						yT: $author$project$Page$HotelList$ToggledDescription(hotel.pQ),
						yX: _List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'hotel-show-more-less')
							]),
						z9: isDescriptionExpanded,
						A_: language
					},
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('')
									])),
							A2(
								$elm$core$Maybe$map,
								function (a) {
									return $author$project$Common$Hotel$locationView(
										{n1: a});
								},
								hotel.n1))
						]))
				]));
	});
var $author$project$Page$HotelList$getRoomName = F2(
	function (rooms, roomCode) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.oh;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$elm$core$Basics$eq(roomCode)),
				$author$project$Utils$OneOrMore$toList(rooms)));
	});
var $author$project$Page$HotelList$roomCountAndNameView = F2(
	function (room, roomName) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selectedRoomsCountAndName')
				]),
			_List_fromArray(
				[
					$author$project$Common$Images$bed,
					A2(
					$author$project$Common$Counter$View$viewWithZeroShownAsSpace,
					room.pZ,
					_List_fromArray(
						[
							$elm$html$Html$text(roomName)
						]))
				]));
	});
var $author$project$Page$HotelList$selectedRoomsView = F2(
	function (selectedRooms, rooms) {
		return A2(
			$author$project$Common$Panel$row,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selections')
				]),
			_List_fromArray(
				[
					$author$project$Common$Panel$graySeparator(_List_Nil),
					A2(
					$author$project$Common$Panel$element,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (room) {
							return A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									$author$project$Page$HotelList$roomCountAndNameView(room),
									A2($author$project$Page$HotelList$getRoomName, rooms, room.pQ)));
						},
						$author$project$Types$Hotel$selectedRooms(selectedRooms)))
				]));
	});
var $author$project$Page$HotelList$hotelView = F3(
	function (session, model, hotel) {
		var language = session.A_;
		var isDescriptionExpanded = _Utils_eq(
			model.kx,
			$elm$core$Maybe$Just(hotel.pQ));
		var hasInformation = _Utils_eq(
			model.lu,
			$elm$core$Maybe$Just(hotel.pQ));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginTopSmall'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hasInformation', hasInformation)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$view,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hotelCard')
						]),
					_List_fromArray(
						[
							$author$project$Common$Panel$header(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										function (imageUrl) {
											return A2($author$project$Common$Panel$imageHeader, imageUrl, _List_Nil);
										},
										hotel.zP))
								])),
							$author$project$Common$Panel$block(
							_Utils_ap(
								$author$project$Common$Hotel$nameRatingDescriptionView(
									{nt: hotel.nt, oh: hotel.oh, mQ: hotel.mQ, GA: isDescriptionExpanded}),
								_List_fromArray(
									[
										A3($author$project$Page$HotelList$informationView, model, language, hotel),
										A2(
										$author$project$Utils$String$renderIf,
										A2($author$project$Types$Hotel$isHotelSelected, hotel.pQ, model.Gk),
										A2($author$project$Page$HotelList$selectedRoomsView, model.Gk, hotel.F_)),
										A2($author$project$Page$HotelList$hotelButtonView, session, hotel)
									])))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					hasInformation,
					A2($author$project$Page$HotelList$clearAndSelectInformationView, language, hotel))
				]));
	});
var $author$project$Page$HotelList$hotelsView = F3(
	function (session, model, hotels) {
		var selectedHotelsFirst = F2(
			function (_v0, _v1) {
				var code = _v0.pQ;
				return A2($author$project$Types$Hotel$isHotelSelected, code, model.Gk) ? 0 : 2;
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotels')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Page$HotelList$hotelView, session, model),
				A2(
					$elm$core$List$sortWith,
					selectedHotelsFirst,
					A2(
						$elm$core$List$filter,
						$author$project$Types$Hotel$hasAvailableRooms(model.w.o),
						hotels))));
	});
var $author$project$Page$HotelList$noHotelsView = function (language) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('marginHorizontalSmall marginVerticalSmall mediumPadding bodyNorm'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'no-hotels-message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.zA;
					}))
			]));
};
var $author$project$Page$HotelList$successView = F3(
	function (session, model, _v0) {
		var hotels = _v0.zH;
		var cities = _v0.vZ;
		var hotelsWithAvailableRooms = A2(
			$elm$core$List$filter,
			$author$project$Types$Hotel$hasAvailableRooms(model.w.o),
			hotels);
		var citiesOfHotelsWithAvailableRooms = A2($author$project$Types$Hotel$filterCitiesByHotels, hotelsWithAvailableRooms, cities);
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Page$HotelList$noHotelsView(session.A_),
			A2(
				$elm$core$Maybe$map,
				function (selectedCity) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('citiesAndHotels marginHorizontalSmall')
							]),
						_List_fromArray(
							[
								A4($author$project$Page$HotelList$citiesView, selectedCity, citiesOfHotelsWithAvailableRooms, session.A_, model.md),
								A3(
								$author$project$Page$HotelList$hotelsView,
								session,
								model,
								$author$project$Page$HotelList$findCityRelatedHotels(
									{
										v0: selectedCity,
										zH: $author$project$Page$HotelList$groupByCities(
											{vZ: citiesOfHotelsWithAvailableRooms, zH: hotelsWithAvailableRooms})
									}))
							]));
				},
				model.kH));
	});
var $author$project$Page$HotelList$view = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotelListPage page withFixedButton')
				]),
			_List_fromArray(
				[
					$author$project$Page$HotelList$header(session.A_),
					A2(
					$author$project$Utils$String$renderIf,
					A2($author$project$Utils$Time$differenceInDays, model.w.jP, model.w.jU) > 1,
					A2($author$project$Page$HotelList$calendarView, session, model.w)),
					A3($author$project$Page$HotelList$successView, session, model, session.zI)
				]));
	});
var $author$project$Page$OnboardService$View$compareServiceAgeGroups = F2(
	function (a, b) {
		return A2($author$project$Types$AgeCategory$compare, a.tY, b.tY);
	});
var $author$project$Page$OnboardService$View$header = function (_v0) {
	var language = _v0.A_;
	return A2(
		$elm$html$Html$header,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('headerSmall marginBottomMedium')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('cell')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.De;
											}))
									]))
							]))
					]))
			]));
};
var $author$project$Page$OnboardService$Update$AddedOutwardBubbleFairService = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Page$OnboardService$Update$AddedReturnBubbleFairService = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Types$SelectedOnboardServices$bubbleFairServiceCount = F2(
	function (_v0, code) {
		var outwardBubbleFairServices = _v0.jO;
		var returnBubbleFairServices = _v0.jT;
		var countFromDict = function (dict) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Dict$get,
						$author$project$Types$OnboardServices$BubbleFairService$codeToString(code),
						dict)));
		};
		return _Utils_Tuple2(
			countFromDict(outwardBubbleFairServices),
			countFromDict(returnBubbleFairServices));
	});
var $author$project$Page$OnboardService$Common$isOneWay = function (_arguments) {
	return $author$project$Utils$Route$isCruiseOrCruiseMultiship(_arguments.tx) || _arguments.qW;
};
var $author$project$Page$OnboardService$Common$onboardService = F3(
	function (_v0, attributes, content) {
		var imageUrl = _v0.zP;
		var name = _v0.oh;
		var description = _v0.nt;
		return A2(
			$author$project$Common$Panel$view,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginHorizontalSmall')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$imageHeader,
					A2($elm$core$Maybe$withDefault, '', imageUrl),
					_List_fromArray(
						[
							$author$project$Common$Panel$imageHeaderTitle(name)
						])),
					$author$project$Common$Panel$block(
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$author$project$Common$Panel$row,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bodyNorm onboardServiceDescription')
									]),
								$author$project$Translations$toHtml(description)),
								$author$project$Common$Panel$graySeparator(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('marginBottomMedium')
									]))
							]),
						content))
				]));
	});
var $author$project$Page$OnboardService$Common$plusMinusButton = function (_v0) {
	var language = _v0.A_;
	var info = _v0.mu;
	var count = _v0.pZ;
	var maxCount = _v0.rd;
	var onClickMsg = _v0.rH;
	if (!info.$) {
		return A2(
			$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
			{
				pZ: count,
				nw: false,
				nQ: false,
				q_: false,
				kZ: $elm$core$Maybe$Just(maxCount),
				rx: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						onClickMsg(-1))
					]),
				oz: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						onClickMsg(1))
					])
			},
			_List_fromArray(
				[
					$elm$html$Html$text(
					(count > 0) ? $elm$core$String$fromInt(count) : A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.tJ;
						}))
				]));
	} else {
		return A2(
			$author$project$Common$Button$outline,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$toUpper(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.H1;
							})))
				]));
	}
};
var $author$project$Page$OnboardService$Common$priceView = F3(
	function (_v0, pricePerEntityTranslation, price) {
		var language = _v0.A_;
		var market = _v0.rb;
		var formatPrice = function (p) {
			return '<b>' + (A2($author$project$Types$Market$formatPriceWithSign, market, p) + '</b>');
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textAlignCenter marginTopSmall priceView')
				]),
			(!price) ? _List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.wy;
						}))
				]) : $author$project$Translations$toHtml(
				A2(
					$author$project$Translations$injectValues,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'price',
							formatPrice(price))
						]),
					A2($author$project$Translations$t, language, pricePerEntityTranslation))));
	});
var $author$project$Page$OnboardService$BubbleFairService$price = F3(
	function (session, bubbleFairService, toInfo) {
		var _v0 = toInfo(bubbleFairService);
		if (!_v0.$) {
			var availableData = _v0.a;
			return A3(
				$author$project$Page$OnboardService$Common$priceView,
				session,
				function ($) {
					return $.Cj;
				},
				availableData.lN);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$OnboardService$Common$route = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('textAlignCenter marginBottomSmall title2')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Types$Port$toString(from) + (' - ' + $author$project$Types$Port$toString(to)))
			]));
};
var $author$project$Page$OnboardService$Common$roundTripContent = F3(
	function (session, outwardContent, returnContent) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('displayFlex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginRightSmall flex1')
							]),
						A2(
							$elm$core$List$cons,
							$author$project$Page$OnboardService$Common$route(
								{kS: session.kS, le: session.le}),
							outwardContent)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginLeftSmall flex1')
							]),
						A2(
							$elm$core$List$cons,
							$author$project$Page$OnboardService$Common$route(
								{kS: session.le, le: session.kS}),
							returnContent))
					]))
			]);
	});
var $author$project$Page$OnboardService$BubbleFairService$panel = F2(
	function (session, bubbleFairService) {
		var returnPrice = A3(
			$author$project$Page$OnboardService$BubbleFairService$price,
			session,
			bubbleFairService,
			function ($) {
				return $.su;
			});
		var outwardPrice = A3(
			$author$project$Page$OnboardService$BubbleFairService$price,
			session,
			bubbleFairService,
			function ($) {
				return $.rQ;
			});
		var adultsCount = $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg);
		var _v0 = A2($author$project$Types$SelectedOnboardServices$bubbleFairServiceCount, session.Gm, bubbleFairService.pQ);
		var outwardCount = _v0.a;
		var returnCount = _v0.b;
		var outwardButton = $author$project$Page$OnboardService$Common$plusMinusButton(
			{
				pZ: outwardCount,
				mu: bubbleFairService.rQ,
				A_: session.A_,
				rd: adultsCount,
				rH: $author$project$Page$OnboardService$Update$AddedOutwardBubbleFairService(bubbleFairService.pQ)
			});
		var outwardButtonAndPrice = _List_fromArray(
			[outwardButton, outwardPrice]);
		var returnButton = $author$project$Page$OnboardService$Common$plusMinusButton(
			{
				pZ: returnCount,
				mu: bubbleFairService.su,
				A_: session.A_,
				rd: adultsCount,
				rH: $author$project$Page$OnboardService$Update$AddedReturnBubbleFairService(bubbleFairService.pQ)
			});
		var returnButtonAndPrice = _List_fromArray(
			[returnButton, returnPrice]);
		var content = $author$project$Page$OnboardService$Common$isOneWay(
			{qW: session.qW, tx: session.tx}) ? outwardButtonAndPrice : A3($author$project$Page$OnboardService$Common$roundTripContent, session, outwardButtonAndPrice, returnButtonAndPrice);
		return A3($author$project$Page$OnboardService$Common$onboardService, bubbleFairService, _List_Nil, content);
	});
var $author$project$Page$OnboardService$Common$section = F3(
	function (_v0, headerTranslation, content) {
		var language = _v0.A_;
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header title1Medium marginHorizontalSmall')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Translations$t, language, headerTranslation))
						])),
				content));
	});
var $author$project$Page$OnboardService$BubbleFairService$section = F2(
	function (session, bubbleFairServices) {
		var language = session.A_;
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.Da;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$BubbleFairService$panel(session),
				bubbleFairServices));
	});
var $author$project$Page$OnboardService$Update$AddedOutwardCovidService = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Page$OnboardService$Update$AddedReturnCovidService = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Types$SelectedOnboardServices$covidServiceCount = F2(
	function (_v0, code) {
		var outwardCovidServices = _v0.ke;
		var returnCovidServices = _v0.kj;
		var countFromDict = function (dict) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Dict$get,
						$author$project$Types$OnboardServices$CovidService$codeToString(code),
						dict)));
		};
		return _Utils_Tuple2(
			countFromDict(outwardCovidServices),
			countFromDict(returnCovidServices));
	});
var $author$project$Page$OnboardService$CovidService$covidSprayMaxCount = 99;
var $author$project$Page$OnboardService$CovidService$price = F3(
	function (session, covidService, toCovidServiceInfo) {
		var _v0 = toCovidServiceInfo(covidService);
		if (!_v0.$) {
			var availableData = _v0.a;
			var pricePerEntityTranslation = ($author$project$Types$OnboardServices$CovidService$codeToString(covidService.pQ) === 'COVID SPRAY') ? function ($) {
				return $.Fl;
			} : ((covidService.j4 === 1) ? function ($) {
				return $.Cj;
			} : ((!covidService.j4) ? function ($) {
				return $.x6;
			} : function ($) {
				return $.tm;
			}));
			return A3($author$project$Page$OnboardService$Common$priceView, session, pricePerEntityTranslation, availableData.lN);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Page$OnboardService$CovidService$panel = F2(
	function (session, covidService) {
		var returnPrice = A3(
			$author$project$Page$OnboardService$CovidService$price,
			session,
			covidService,
			function ($) {
				return $.su;
			});
		var outwardPrice = A3(
			$author$project$Page$OnboardService$CovidService$price,
			session,
			covidService,
			function ($) {
				return $.rQ;
			});
		var maxCount = ($author$project$Types$OnboardServices$CovidService$codeToString(covidService.pQ) === 'COVID SPRAY') ? $author$project$Page$OnboardService$CovidService$covidSprayMaxCount : ((!covidService.j4) ? $elm$core$Array$length(session.Eg) : $author$project$Types$Passenger$Util$countAdultPassengers(session.Eg));
		var _v0 = A2($author$project$Types$SelectedOnboardServices$covidServiceCount, session.Gm, covidService.pQ);
		var outwardCount = _v0.a;
		var returnCount = _v0.b;
		var outwardButton = $author$project$Page$OnboardService$Common$plusMinusButton(
			{
				pZ: outwardCount,
				mu: covidService.rQ,
				A_: session.A_,
				rd: maxCount,
				rH: $author$project$Page$OnboardService$Update$AddedOutwardCovidService(covidService.pQ)
			});
		var outwardButtonAndPrice = _List_fromArray(
			[outwardButton, outwardPrice]);
		var returnButton = $author$project$Page$OnboardService$Common$plusMinusButton(
			{
				pZ: returnCount,
				mu: covidService.su,
				A_: session.A_,
				rd: maxCount,
				rH: $author$project$Page$OnboardService$Update$AddedReturnCovidService(covidService.pQ)
			});
		var returnButtonAndPrice = _List_fromArray(
			[returnButton, returnPrice]);
		var content = function () {
			if (!$author$project$Page$OnboardService$Common$isOneWay(
				{qW: session.qW, tx: session.tx})) {
				return A3($author$project$Page$OnboardService$Common$roundTripContent, session, outwardButtonAndPrice, returnButtonAndPrice);
			} else {
				if ($author$project$Utils$Route$isShoppingCruise(session.tx) && (covidService.j4 === 1)) {
					var _v1 = covidService.rQ;
					if (!_v1.$) {
						return outwardButtonAndPrice;
					} else {
						return returnButtonAndPrice;
					}
				} else {
					return outwardButtonAndPrice;
				}
			}
		}();
		return A3($author$project$Page$OnboardService$Common$onboardService, covidService, _List_Nil, content);
	});
var $author$project$Page$OnboardService$CovidService$section = F2(
	function (session, covidServices) {
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.va;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$CovidService$panel(session),
				covidServices));
	});
var $author$project$Page$OnboardService$Update$AddedTableReservation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$OnboardService$Update$RemovedTableReservation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Page$OnboardService$Dining$buttonText = function (_v0) {
	var language = _v0.A_;
	var passengers = _v0.Eg;
	var count = $elm$core$Array$length(passengers);
	return $author$project$Common$Button$text(
		$elm$core$String$toUpper(
			_Utils_ap(
				$elm$core$String$fromInt(count) + ' ',
				(count > 1) ? A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.EA;
					}) : A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.r0;
					}))));
};
var $author$project$Page$OnboardService$Dining$priceView = F2(
	function (_v0, price) {
		var language = _v0.A_;
		var market = _v0.rb;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textAlignCenter marginTopSmall')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'price',
								A2($author$project$Types$Market$formatPriceWithSign, market, price))
							]),
						'+ ' + A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.tm;
							})))
				]));
	});
var $author$project$Page$OnboardService$Dining$timeView = F2(
	function (_v0, _v1) {
		var language = _v0.A_;
		var market = _v0.rb;
		var beginTime = _v1.nd;
		var formatTime = function (time) {
			return A3(
				$author$project$Utils$Time$Format$format,
				{A_: language, rb: market},
				$author$project$Utils$Time$Format$weekdayHourMinute,
				time);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textAlignCenter marginBottomSmall')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					formatTime(beginTime))
				]));
	});
var $author$project$Page$OnboardService$Dining$button = F3(
	function (session, code, service) {
		var language = session.A_;
		var isSelected = A2(
			$elm$core$List$member,
			_Utils_Tuple2(code, service.nd),
			$author$project$Types$SelectedOnboardServices$tableReservations(session.Gm));
		var isAnySelectedAtSameTime = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				$elm$core$Basics$eq(service.nd)),
			$author$project$Types$SelectedOnboardServices$tableReservations(session.Gm));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Page$OnboardService$Dining$timeView, session, service),
					A2(
					$author$project$Common$Button$outline,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							isSelected ? $author$project$Page$OnboardService$Update$RemovedTableReservation(service.nd) : $author$project$Page$OnboardService$Update$AddedTableReservation(
								_Utils_Tuple2(code, service.nd))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Common$Button$activeState, isSelected),
									_Utils_Tuple2($author$project$Common$Button$disabledState, isAnySelectedAtSameTime)
								])),
							$elm$html$Html$Attributes$disabled(!service.kV)
						]),
					_List_fromArray(
						[
							isSelected ? $author$project$Page$OnboardService$Dining$buttonText(session) : $author$project$Common$Button$text(
							$elm$core$String$toUpper(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.pl;
									}))),
							$author$project$Common$Button$toggleableTickMark(isSelected)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeL,
							$author$project$Page$OnboardService$Dining$priceView(session),
							$author$project$Utils$Number$Positive$toNumber),
						service.lN))
				]));
	});
var $author$project$Page$OnboardService$Dining$unavailableButton = function (language) {
	return A2(
		$author$project$Common$Button$outline,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$disabled(true)
			]),
		_List_fromArray(
			[
				$author$project$Common$Button$text(
				$elm$core$String$toUpper(
					A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.pl;
						})))
			]));
};
var $author$project$Page$OnboardService$Dining$panel = F2(
	function (session, dining) {
		var returnServices = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, service) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('marginTopMedium', !(!index))
									]))
							]),
						_List_fromArray(
							[
								A3($author$project$Page$OnboardService$Dining$button, session, dining.pQ, service)
							]));
				}),
			dining.oL);
		var outwardServices = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, service) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('marginTopMedium', !(!index))
									]))
							]),
						_List_fromArray(
							[
								A3($author$project$Page$OnboardService$Dining$button, session, dining.pQ, service)
							]));
				}),
			dining.ot);
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginHorizontalSmall')
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginTopMedium marginHorizontalMedium')
							]),
						_List_fromArray(
							[
								$author$project$Common$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(dining.oh)
									]))
							])),
					A2(
						$elm$core$Maybe$map,
						function (url) {
							return A2(
								$author$project$Common$Panel$imageHeader,
								url,
								_List_fromArray(
									[
										$author$project$Common$Panel$imageHeaderTitle(dining.oh)
									]));
						},
						dining.zP)),
					$author$project$Common$Panel$block(
					_List_fromArray(
						[
							A2(
							$author$project$Common$Panel$row,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm')
								]),
							$author$project$Translations$toHtml(dining.nt)),
							$author$project$Common$Panel$graySeparator(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginBottomMedium')
								])),
							($elm$core$List$isEmpty(outwardServices) && $elm$core$List$isEmpty(returnServices)) ? $author$project$Page$OnboardService$Dining$unavailableButton(session.A_) : ($elm$core$List$isEmpty(outwardServices) ? A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								$author$project$Page$OnboardService$Common$route(
									{kS: session.le, le: session.kS}),
								returnServices)) : ($elm$core$List$isEmpty(returnServices) ? A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								$author$project$Page$OnboardService$Common$route(
									{kS: session.kS, le: session.le}),
								outwardServices)) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('displayFlex')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('marginRightSmall flex1')
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Page$OnboardService$Common$route(
											{kS: session.kS, le: session.le}),
										outwardServices)),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('marginLeftSmall flex1')
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Page$OnboardService$Common$route(
											{kS: session.le, le: session.kS}),
										returnServices))
								]))))
						]))
				]));
	});
var $author$project$Page$OnboardService$Dining$section = F2(
	function (session, dinings) {
		var language = session.A_;
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.GE;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$Dining$panel(session),
				dinings));
	});
var $author$project$Page$OnboardService$Update$AddOutwardFriendshipBracelet = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Page$OnboardService$Update$AddReturnFriendshipBracelet = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Page$OnboardService$Common$directions = function (session) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('displayFlex')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginRightSmall flex1')
					]),
				_List_fromArray(
					[
						$author$project$Page$OnboardService$Common$route(
						{kS: session.kS, le: session.le})
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginLeftSmall flex1')
					]),
				_List_fromArray(
					[
						$author$project$Page$OnboardService$Common$route(
						{kS: session.le, le: session.kS})
					]))
			]));
};
var $author$project$Types$SelectedOnboardServices$friendshipBraceletCount = F2(
	function (_v0, addon) {
		var outwardFriendshipBracelets = _v0.eV;
		var returnFriendshipBracelets = _v0.fy;
		var countFromDict = function (dict) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$Dict$get,
						$author$project$Types$OnboardServices$Addon$codeToString(addon.pQ),
						dict)));
		};
		return _Utils_Tuple2(
			countFromDict(outwardFriendshipBracelets),
			countFromDict(returnFriendshipBracelets));
	});
var $author$project$Page$OnboardService$Addon$buttonContent = F2(
	function (language, count) {
		return (count < 1) ? $elm$html$Html$text(
			$elm$core$String$toUpper(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.tJ;
					}))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyBold')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(count))
				]));
	});
var $author$project$Page$OnboardService$Addon$buttonView = F5(
	function (session, count, maxCount, handlePlusClick, handleMinusClick) {
		var language = session.A_;
		return A2(
			$author$project$Common$Button$plusAndMinusButtonsWithBorderAndBackground,
			{
				pZ: count,
				nw: false,
				nQ: true,
				q_: false,
				kZ: $elm$core$Maybe$Just(maxCount),
				rx: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(handleMinusClick)
					]),
				oz: _List_fromArray(
					[
						$elm$html$Html$Events$onClick(handlePlusClick)
					])
			},
			_List_fromArray(
				[
					A2($author$project$Page$OnboardService$Addon$buttonContent, session.A_, count)
				]));
	});
var $author$project$Page$OnboardService$Addon$view = F3(
	function (session, addon, button) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('addon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textAlignCenter marginBottomSmall bodyLarge')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(addon.oh)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('textAlignCenter marginBottomSmall bodyBold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Types$Market$formatPriceWithSign, session.rb, addon.lN))
								])),
							button
						]))
				]));
	});
var $author$project$Page$OnboardService$FriendshipBracelet$renderAddonList = F5(
	function (session, getCount, plusAction, minusAction, maybeAddons) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				]),
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$map(
					function (addon) {
						var maxCount = $author$project$Types$Passenger$Util$countNotAdultPassengers(session.Eg);
						var count = getCount(addon);
						var button = A5(
							$author$project$Page$OnboardService$Addon$buttonView,
							session,
							count,
							maxCount,
							plusAction(addon),
							minusAction(addon));
						return A3($author$project$Page$OnboardService$Addon$view, session, addon, button);
					}),
				maybeAddons));
	});
var $author$project$Page$OnboardService$FriendshipBracelet$renderOutwardAndReturnContent = F2(
	function (outward, _return) {
		var maxLen = A2(
			$elm$core$Basics$max,
			$elm$core$List$length(outward),
			$elm$core$List$length(_return));
		var indices = A2($elm$core$List$range, 0, maxLen - 1);
		var getAtOrEmpty = F2(
			function (i, list) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					$elm$core$List$head(
						A2($elm$core$List$drop, i, list)));
			});
		return A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('displayFlex addonRow')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginRightSmall flex1')
								]),
							_List_fromArray(
								[
									A2(getAtOrEmpty, i, outward)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginLeftSmall flex1')
								]),
							_List_fromArray(
								[
									A2(getAtOrEmpty, i, _return)
								]))
						]));
			},
			indices);
	});
var $author$project$Page$OnboardService$FriendshipBracelet$rowWrapper = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('addonRow')
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Page$OnboardService$FriendshipBracelet$panel = F2(
	function (session, friendshipBracelet) {
		var outwardInfo = friendshipBracelet.rQ;
		var returnInfo = friendshipBracelet.su;
		var code = friendshipBracelet.pQ;
		var returnContent = A5(
			$author$project$Page$OnboardService$FriendshipBracelet$renderAddonList,
			session,
			function (addon) {
				return A2($author$project$Types$SelectedOnboardServices$friendshipBraceletCount, session.Gm, addon).b;
			},
			function (addon) {
				return A2($author$project$Page$OnboardService$Update$AddReturnFriendshipBracelet, addon, 1);
			},
			function (addon) {
				return A2($author$project$Page$OnboardService$Update$AddReturnFriendshipBracelet, addon, -1);
			},
			$author$project$Types$OnboardServices$InfoWithAddons$toMaybeAddons(friendshipBracelet.su));
		var outwardContent = A5(
			$author$project$Page$OnboardService$FriendshipBracelet$renderAddonList,
			session,
			function (addon) {
				return A2($author$project$Types$SelectedOnboardServices$friendshipBraceletCount, session.Gm, addon).a;
			},
			function (addon) {
				return A2($author$project$Page$OnboardService$Update$AddOutwardFriendshipBracelet, addon, 1);
			},
			function (addon) {
				return A2($author$project$Page$OnboardService$Update$AddOutwardFriendshipBracelet, addon, -1);
			},
			$author$project$Types$OnboardServices$InfoWithAddons$toMaybeAddons(friendshipBracelet.rQ));
		var content = $author$project$Page$OnboardService$Common$isOneWay(
			{qW: session.qW, tx: session.tx}) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Page$OnboardService$FriendshipBracelet$rowWrapper, outwardContent))
			]) : _Utils_ap(
			_List_fromArray(
				[
					$author$project$Page$OnboardService$Common$directions(session)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($author$project$Page$OnboardService$FriendshipBracelet$renderOutwardAndReturnContent, outwardContent, returnContent))
				]));
		return A3($author$project$Page$OnboardService$Common$onboardService, friendshipBracelet, _List_Nil, content);
	});
var $author$project$Page$OnboardService$FriendshipBracelet$section = F2(
	function (session, bracelets) {
		var language = session.A_;
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.Db;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$FriendshipBracelet$panel(session),
				bracelets));
	});
var $author$project$Page$OnboardService$Update$ToggledOutwardKidBracelet = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$OnboardService$Update$ToggledReturnKidBracelet = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$OnboardService$KidBracelet$passengerCountForKidBracelet = F2(
	function (passengers, kidBracelet) {
		var passengerCount = $author$project$Common$Passengers$passengerCount(
			A3(
				$elm$core$Array$foldl,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.tY;
					},
					$elm$core$List$cons),
				_List_Nil,
				passengers));
		var _v0 = kidBracelet.tY;
		switch (_v0) {
			case 0:
				return passengerCount.tV;
			case 1:
				return passengerCount.IF;
			case 3:
				return passengerCount.AI;
			default:
				return passengerCount.vU;
		}
	});
var $author$project$Page$OnboardService$KidBracelet$buttonText = F2(
	function (_v0, kidBracelet) {
		var language = _v0.A_;
		var passengers = _v0.Eg;
		var count = A2($author$project$Page$OnboardService$KidBracelet$passengerCountForKidBracelet, passengers, kidBracelet);
		return $author$project$Common$Button$text(
			$elm$core$String$toUpper(
				_Utils_ap(
					$elm$core$String$fromInt(count) + ' ',
					(count > 1) ? A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.EA;
						}) : A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.r0;
						}))));
	});
var $author$project$Utils$Route$isCruiseMultiship = function (voyageType) {
	return _Utils_eq(voyageType, $author$project$Types$VoyageType$CruiseMultiship);
};
var $author$project$Page$OnboardService$KidBracelet$isCertainMultishipCruise = function (_v0) {
	var voyageType = _v0.tx;
	var from = _v0.kS;
	var to = _v0.le;
	var turAla = (from === 5) && (to === 3);
	var stoAla = (from === 1) && (to === 3);
	return $author$project$Utils$Route$isCruiseMultiship(voyageType) && (stoAla || turAla);
};
var $author$project$Types$SelectedOnboardServices$isSelected = F2(
	function (dict, item) {
		return A2(
			$elm$core$List$member,
			item.pQ,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.pQ;
				},
				$elm$core$Dict$values(dict)));
	});
var $author$project$Types$SelectedOnboardServices$kidBraceletSelected = F2(
	function (_v0, kidBracelet) {
		var selected = _v0;
		return _Utils_Tuple2(
			A2($author$project$Types$SelectedOnboardServices$isSelected, selected.DC, kidBracelet),
			A2($author$project$Types$SelectedOnboardServices$isSelected, selected.FV, kidBracelet));
	});
var $author$project$Page$OnboardService$Common$selectForPassengersButtonText = F2(
	function (language, count) {
		return $author$project$Common$Button$text(
			$elm$core$String$toUpper(
				_Utils_ap(
					$elm$core$String$fromInt(count) + ' ',
					(count > 1) ? A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.EA;
						}) : A2(
						$author$project$Translations$t,
						language,
						function ($) {
							return $.r0;
						}))));
	});
var $author$project$Page$OnboardService$Common$selectForPassengersButtonAndPrice = function (_v0) {
	var session = _v0.j;
	var info = _v0.mu;
	var count = _v0.pZ;
	var selected = _v0.Gg;
	var onClickMsg = _v0.rH;
	if (!info.$) {
		var price = info.a.lN;
		return _List_fromArray(
			[
				A2(
				$author$project$Common$Button$outline,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(onClickMsg),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Common$Button$activeState, selected)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$Page$OnboardService$Common$selectForPassengersButtonText, session.A_, count),
						$author$project$Common$Button$toggleableTickMark(selected)
					])),
				A3(
				$author$project$Page$OnboardService$Common$priceView,
				session,
				function ($) {
					return $.tm;
				},
				price)
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$author$project$Common$Button$outline,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						A2($author$project$Page$OnboardService$Common$selectForPassengersButtonText, session.A_, count)
					]))
			]);
	}
};
var $author$project$Page$OnboardService$KidBracelet$panel = F2(
	function (session, kidBracelet) {
		var code = kidBracelet.pQ;
		var outwardInfo = kidBracelet.rQ;
		var returnInfo = kidBracelet.su;
		var disabledButton = _List_fromArray(
			[
				A2(
				$author$project$Common$Button$outline,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_fromArray(
					[
						A2($author$project$Page$OnboardService$KidBracelet$buttonText, session, kidBracelet)
					]))
			]);
		var count = A2($author$project$Page$OnboardService$KidBracelet$passengerCountForKidBracelet, session.Eg, kidBracelet);
		var _v0 = A2($author$project$Types$SelectedOnboardServices$kidBraceletSelected, session.Gm, kidBracelet);
		var outwardSelected = _v0.a;
		var returnSelected = _v0.b;
		var outwardButtonAndPrice = $author$project$Page$OnboardService$Common$selectForPassengersButtonAndPrice(
			{
				pZ: count,
				mu: outwardInfo,
				rH: $author$project$Page$OnboardService$Update$ToggledOutwardKidBracelet(kidBracelet),
				Gg: outwardSelected,
				j: session
			});
		var returnButtonAndPrice = $author$project$Page$OnboardService$Common$selectForPassengersButtonAndPrice(
			{
				pZ: count,
				mu: returnInfo,
				rH: $author$project$Page$OnboardService$Update$ToggledReturnKidBracelet(kidBracelet),
				Gg: returnSelected,
				j: session
			});
		return A3(
			$author$project$Page$OnboardService$Common$onboardService,
			kidBracelet,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-kid-bracelet',
					$author$project$Types$OnboardServices$KidBracelet$codeToString(kidBracelet.pQ))
				]),
			((!$author$project$Page$OnboardService$Common$isOneWay(
				{qW: session.qW, tx: session.tx})) || $author$project$Page$OnboardService$KidBracelet$isCertainMultishipCruise(session)) ? A3(
				$author$project$Page$OnboardService$Common$roundTripContent,
				session,
				outwardButtonAndPrice,
				$author$project$Page$OnboardService$KidBracelet$isCertainMultishipCruise(session) ? disabledButton : returnButtonAndPrice) : outwardButtonAndPrice);
	});
var $author$project$Page$OnboardService$KidBracelet$section = F2(
	function (session, services) {
		var language = session.A_;
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.Dc;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$KidBracelet$panel(session),
				services));
	});
var $author$project$Page$OnboardService$Update$AddedMassageTimeSlot = function (a) {
	return {$: 19, a: a};
};
var $author$project$Page$OnboardService$Massage$addButton = F2(
	function (session, massage) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('addMassageButton'),
					$elm$html$Html$Events$onClick(
					$author$project$Page$OnboardService$Update$AddedMassageTimeSlot(massage))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'+ ' + A2(
						$author$project$Translations$t,
						session.A_,
						function ($) {
							return $.BE;
						}))
				]));
	});
var $author$project$Types$SelectedOnboardServices$hasAvailableMassageTimeSlots = function (massage) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots(massage),
		A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not));
};
var $author$project$Page$OnboardService$Update$ToggledMassageTimeSlots = function (a) {
	return {$: 15, a: a};
};
var $author$project$Common$Images$xMarkInWhiteCircle = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/icon_button_x_mark_white.svg'),
			$elm$html$Html$Attributes$class('tickHolder tickMarkImage')
		]),
	_List_Nil);
var $author$project$Common$Button$toggleableXMark = function (isActive) {
	return isActive ? $author$project$Common$Images$xMarkInWhiteCircle : $author$project$Common$Images$circlePlusMark;
};
var $author$project$Page$OnboardService$Massage$selectButton = F3(
	function (_v0, massage, selected) {
		var language = _v0.A_;
		var buttonText = selected ? $elm$core$String$toUpper(
			A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.xm;
				})) : $elm$core$String$toUpper(
			A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.xl;
				}));
		return A2(
			$author$project$Common$Button$outline,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selectMassageButton'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2($author$project$Common$Button$activeState, selected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Page$OnboardService$Update$ToggledMassageTimeSlots(massage))
				]),
			_List_fromArray(
				[
					$author$project$Common$Button$text(buttonText),
					$author$project$Common$Button$toggleableXMark(selected)
				]));
	});
var $author$project$Page$OnboardService$Update$SelectedMassageTimeSlotDate = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Confirmation$Page$PassengerDetails$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $author$project$Page$OnboardService$Massage$selectInput = F4(
	function (labelText, msg, selectedOption, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selectInputContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selectInputLabel')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selectInput'),
							$author$project$Confirmation$Page$PassengerDetails$onChange(msg)
						]),
					A2(
						$elm$core$List$map,
						function (optionText) {
							return A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(optionText),
										$elm$html$Html$Attributes$selected(
										_Utils_eq(optionText, selectedOption))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(optionText)
									]));
						},
						options))
				]));
	});
var $author$project$Page$OnboardService$Massage$dateSelectInput = F4(
	function (_v0, massage, selectedTimeSlot, timeSlotOptions) {
		var language = _v0.A_;
		var market = _v0.rb;
		var labelText = A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.BF;
			});
		var formatDate = function (_v1) {
			var startTime = _v1.ld;
			return A3(
				$author$project$Utils$Time$Format$format,
				{A_: language, rb: market},
				$author$project$Utils$Time$Format$monthNumberDayWeekday,
				startTime);
		};
		return A4(
			$author$project$Page$OnboardService$Massage$selectInput,
			labelText,
			A2($author$project$Page$OnboardService$Update$SelectedMassageTimeSlotDate, massage, selectedTimeSlot),
			formatDate(selectedTimeSlot),
			$elm_community$list_extra$List$Extra$unique(
				A2($elm$core$List$map, formatDate, timeSlotOptions)));
	});
var $author$project$Page$OnboardService$Update$RemovedMassageTimeSlot = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Page$OnboardService$Massage$removeButton = F2(
	function (massage, selectedTimeSlot) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('removeMassageButton'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$OnboardService$Update$RemovedMassageTimeSlot, massage, selectedTimeSlot))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/images/common/icon_button_cross_mark_filled.svg')
						]),
					_List_Nil)
				]));
	});
var $author$project$Page$OnboardService$Update$SelectedMassageTimeSlotTime = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Page$OnboardService$Massage$timeSelectInput = F4(
	function (_v0, massage, selectedTimeSlot, timeSlotOptions) {
		var language = _v0.A_;
		var labelText = A2(
			$author$project$Translations$t,
			language,
			function ($) {
				return $.BH;
			});
		var formatTime = function (_v1) {
			var startTime = _v1.ld;
			return $author$project$Utils$Time$Format$formatHourMinute(startTime);
		};
		return A4(
			$author$project$Page$OnboardService$Massage$selectInput,
			labelText,
			A2($author$project$Page$OnboardService$Update$SelectedMassageTimeSlotTime, massage, selectedTimeSlot),
			formatTime(selectedTimeSlot),
			A2(
				$elm$core$List$map,
				formatTime,
				A2(
					$elm$core$List$filter,
					function (option) {
						return A2($author$project$Utils$Time$isSameDay, option.ld, selectedTimeSlot.ld);
					},
					timeSlotOptions)));
	});
var $author$project$Page$OnboardService$Massage$timeSlot = F4(
	function (session, massage, selectedTimeSlot, timeSlotOptions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeSlot')
				]),
			_List_fromArray(
				[
					A4($author$project$Page$OnboardService$Massage$dateSelectInput, session, massage, selectedTimeSlot, timeSlotOptions),
					A4($author$project$Page$OnboardService$Massage$timeSelectInput, session, massage, selectedTimeSlot, timeSlotOptions),
					A2($author$project$Page$OnboardService$Massage$removeButton, massage, selectedTimeSlot)
				]));
	});
var $author$project$Page$OnboardService$Massage$timeSlots = F2(
	function (session, massage) {
		var selectedOnboardServices = session.Gm;
		var onboardServices = session.rI;
		var selectedTimeSlots = A2($author$project$Types$SelectedOnboardServices$getSelectedMassageTimeSlots, massage, selectedOnboardServices);
		var availableTimeSlots = A2($author$project$Types$SelectedOnboardServices$getAvailableMassageTimeSlots, massage, selectedOnboardServices);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeSlots')
				]),
			A2(
				$elm$core$List$map,
				function (selectedTimeSlot) {
					return A4(
						$author$project$Page$OnboardService$Massage$timeSlot,
						session,
						massage,
						selectedTimeSlot,
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.ld;
								},
								$elm$time$Time$posixToMillis),
							_Utils_ap(
								availableTimeSlots,
								_List_fromArray(
									[selectedTimeSlot]))));
				},
				selectedTimeSlots));
	});
var $author$project$Page$OnboardService$Massage$panel = F2(
	function (session, massage) {
		var selectedOnboardServices = session.Gm;
		var someSelected = A2($author$project$Types$SelectedOnboardServices$isSomeMassageTimeSlotSelected, massage, selectedOnboardServices);
		return A3(
			$author$project$Page$OnboardService$Common$onboardService,
			massage,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('massagePanel')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Page$OnboardService$Common$priceView,
					session,
					function ($) {
						return $.BG;
					},
					massage.lN),
					A3($author$project$Page$OnboardService$Massage$selectButton, session, massage, someSelected),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					someSelected,
					A2($author$project$Page$OnboardService$Massage$timeSlots, session, massage)),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					someSelected && A2($author$project$Types$SelectedOnboardServices$hasAvailableMassageTimeSlots, massage, selectedOnboardServices),
					A2($author$project$Page$OnboardService$Massage$addButton, session, massage))
				]));
	});
var $author$project$Page$OnboardService$Massage$section = F2(
	function (session, massages) {
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.vc;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$Massage$panel(session),
				massages));
	});
var $author$project$Page$OnboardService$Update$ToggledOutwardPriorityBoarding = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$OnboardService$Update$ToggledReturnPriorityBoarding = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$SelectedOnboardServices$priorityBoardingSelected = F2(
	function (_v0, priorityBoarding) {
		var selected = _v0;
		return _Utils_Tuple2(
			A2($author$project$Types$SelectedOnboardServices$isSelected, selected.kf, priorityBoarding),
			A2($author$project$Types$SelectedOnboardServices$isSelected, selected.kk, priorityBoarding));
	});
var $author$project$Page$OnboardService$PriorityBoarding$route = F3(
	function (language, from, to) {
		return A2(
			$author$project$Translations$t,
			language,
			$author$project$Types$Port$translate(from)) + (' - ' + A2(
			$author$project$Translations$t,
			language,
			$author$project$Types$Port$translate(to)));
	});
var $author$project$Page$OnboardService$Common$selectForPassengersButtonAndPriceWithUnavailableText = function (_arguments) {
	var session = _arguments.j;
	var info = _arguments.mu;
	var count = _arguments.pZ;
	var selected = _arguments.Gg;
	var onClickMsg = _arguments.rH;
	if (!info.$) {
		var price = info.a.lN;
		return _List_fromArray(
			[
				A2(
				$author$project$Common$Button$outline,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(onClickMsg),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Common$Button$activeState, selected)
							]))
					]),
				_List_fromArray(
					[
						A2($author$project$Page$OnboardService$Common$selectForPassengersButtonText, session.A_, count),
						$author$project$Common$Button$toggleableTickMark(selected)
					])),
				A3(
				$author$project$Page$OnboardService$Common$priceView,
				session,
				function ($) {
					return $.tm;
				},
				price)
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('unavailableOnboardService')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$injectValues,
							_List_fromArray(
								[
									_Utils_Tuple2('route', _arguments.F0)
								]),
							A2(
								$author$project$Translations$t,
								session.A_,
								function ($) {
									return $.Dj;
								})))
					]))
			]);
	}
};
var $author$project$Page$OnboardService$PriorityBoarding$panel = F2(
	function (session, priorityBoarding) {
		var count = $elm$core$Array$length(session.Eg);
		var _v0 = A2($author$project$Types$SelectedOnboardServices$priorityBoardingSelected, session.Gm, priorityBoarding);
		var outwardSelected = _v0.a;
		var returnSelected = _v0.b;
		var outwardButtonAndPrice = $author$project$Page$OnboardService$Common$selectForPassengersButtonAndPriceWithUnavailableText(
			{
				pZ: count,
				mu: priorityBoarding.rQ,
				rH: $author$project$Page$OnboardService$Update$ToggledOutwardPriorityBoarding(priorityBoarding),
				F0: A3($author$project$Page$OnboardService$PriorityBoarding$route, session.A_, session.kS, session.le),
				Gg: outwardSelected,
				j: session
			});
		var returnButtonAndPrice = $author$project$Page$OnboardService$Common$selectForPassengersButtonAndPriceWithUnavailableText(
			{
				pZ: count,
				mu: priorityBoarding.su,
				rH: $author$project$Page$OnboardService$Update$ToggledReturnPriorityBoarding(priorityBoarding),
				F0: A3($author$project$Page$OnboardService$PriorityBoarding$route, session.A_, session.le, session.kS),
				Gg: returnSelected,
				j: session
			});
		var content = $author$project$Page$OnboardService$Common$isOneWay(
			{qW: session.qW, tx: session.tx}) ? outwardButtonAndPrice : A3($author$project$Page$OnboardService$Common$roundTripContent, session, outwardButtonAndPrice, returnButtonAndPrice);
		return A3($author$project$Page$OnboardService$Common$onboardService, priorityBoarding, _List_Nil, content);
	});
var $author$project$Page$OnboardService$PriorityBoarding$section = F2(
	function (session, priorityBoardingSerivces) {
		return A3(
			$author$project$Page$OnboardService$Common$section,
			session,
			function ($) {
				return $.Dd;
			},
			A2(
				$elm$core$List$map,
				$author$project$Page$OnboardService$PriorityBoarding$panel(session),
				priorityBoardingSerivces));
	});
var $author$project$Page$OnboardService$Update$AddedOutwardShipMoney = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Page$OnboardService$Update$AddedReturnShipMoney = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$OnboardService$ShipMoney$isNotLastShipMoneyCoupon = F2(
	function (others, coupon) {
		return !_Utils_eq(
			$elm$core$List$head(
				$elm$core$List$reverse(others)),
			$elm$core$Maybe$Just(coupon));
	});
var $author$project$Common$Images$ribbonImage = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/assets/images/discountCode/ribbon_discount.svg'),
			$elm$html$Html$Attributes$class('ribbon')
		]),
	_List_Nil);
var $author$project$Common$Button$plusMinus = F2(
	function (_arguments, content) {
		return (_arguments.pZ <= 0) ? A2(
			$author$project$Common$Button$outline,
			A2(
				$elm$core$List$cons,
				function (isDisabled) {
					return _arguments.nw ? $elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2($author$project$Common$Button$disabledState, isDisabled)
							])) : $elm$html$Html$Attributes$disabled(isDisabled);
				}(
					$author$project$Common$Button$hasMaxCountBeenReached(
						{pZ: _arguments.pZ, kZ: _arguments.kZ})),
				_arguments.oz),
			_arguments.q_ ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('outlineButtonContent')
						]),
					content),
					$author$project$Common$Images$ribbonImage
				]) : _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('outlineButtonContent')
						]),
					content)
				])) : A2($author$project$Common$Button$plusAndMinusButtons, _arguments, content);
	});
var $author$project$Page$OnboardService$ShipMoney$plusMinusButton = F2(
	function (isMarginVisible, _arguments) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('marginBottomMedium', isMarginVisible)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Common$Button$plusMinus,
					{pZ: _arguments.pZ, nw: _arguments.nw, nQ: _arguments.nQ, q_: _arguments.q_, kZ: _arguments.kZ, rx: _arguments.rx, oz: _arguments.oz},
					_List_fromArray(
						[
							(!_arguments.pZ) ? $elm$html$Html$text(_arguments.lN) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyBold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									_Utils_ap(
										$elm$core$String$fromInt(_arguments.pZ),
										_Utils_ap(_arguments.sL, _arguments.s1)))
								]))
						]))
				]));
	});
var $author$project$Constants$crossMarkString = '×';
var $author$project$Page$OnboardService$ShipMoney$plusMinusButtonArguments = F5(
	function (session, selected, isLarge, toMsg, coupon) {
		var language = session.A_;
		var dataTestCouponCode = A2(
			$elm$html$Html$Attributes$attribute,
			'data-test-ship-money-coupon',
			$author$project$Types$OnboardServices$ShipMoney$codeToString(coupon.pQ));
		var dataTestButton = $elm$html$Html$Attributes$attribute('data-test-button');
		var count = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(coupon.pQ)),
					selected)));
		var max = $author$project$Types$SelectedOnboardServices$maxShipMoneyCouponsPerBooking - ($author$project$Types$SelectedOnboardServices$countShipMoneyCoupons(session.Gm) - count);
		return {
			pZ: count,
			nw: false,
			nQ: isLarge,
			q_: false,
			kZ: $elm$core$Maybe$Just(max),
			rx: _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2(toMsg, -1, coupon.pQ)),
					dataTestCouponCode,
					dataTestButton('minus')
				]),
			oz: _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2(toMsg, 1, coupon.pQ)),
					dataTestCouponCode,
					dataTestButton('plus')
				]),
			lN: coupon.oh + (' ' + $elm$core$String$toUpper(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.Dg;
					}))),
			sL: ' ' + ($author$project$Constants$crossMarkString + ' '),
			s1: coupon.oh
		};
	});
var $author$project$Types$SelectedOnboardServices$shipMoneyLists = function (_v0) {
	var selected = _v0;
	return _Utils_Tuple2(
		$elm$core$Dict$values(selected.eW),
		$elm$core$Dict$values(selected.N));
};
var $author$project$Page$OnboardService$ShipMoney$panel = F2(
	function (session, shipMoney) {
		var language = session.A_;
		var shipMoneyButtonArguments = $author$project$Page$OnboardService$ShipMoney$plusMinusButtonArguments(session);
		var _v0 = $author$project$Types$SelectedOnboardServices$shipMoneyLists(session.Gm);
		var outwardSelected = _v0.a;
		var returnSelected = _v0.b;
		return A3(
			$author$project$Page$OnboardService$Common$onboardService,
			{
				nt: shipMoney.nt,
				zP: $elm$core$Maybe$Just(shipMoney.zP),
				oh: A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.Dh;
					})
			},
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'ship-money-panel')
				]),
			function () {
				var _v1 = shipMoney.x3;
				if (!_v1.$) {
					var first = _v1.a.nx;
					var others = _v1.a.lH;
					return A2(
						$elm$core$List$map,
						function (coupon) {
							return A3(
								$elm$core$Basics$composeR,
								A3(shipMoneyButtonArguments, outwardSelected, true, $author$project$Page$OnboardService$Update$AddedOutwardShipMoney),
								$author$project$Page$OnboardService$ShipMoney$plusMinusButton(
									A2($author$project$Page$OnboardService$ShipMoney$isNotLastShipMoneyCoupon, others, coupon)),
								coupon);
						},
						A2($elm$core$List$cons, first, others));
				} else {
					var outward = _v1.a.Ds;
					var _return = _v1.a.FL;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('displayFlex')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('marginRightSmall flex1')
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Page$OnboardService$Common$route(
											{kS: session.kS, le: session.le}),
										A2(
											$elm$core$List$map,
											function (coupon) {
												return A3(
													$elm$core$Basics$composeR,
													A3(shipMoneyButtonArguments, outwardSelected, false, $author$project$Page$OnboardService$Update$AddedOutwardShipMoney),
													$author$project$Page$OnboardService$ShipMoney$plusMinusButton(
														A2($author$project$Page$OnboardService$ShipMoney$isNotLastShipMoneyCoupon, outward.lH, coupon)),
													coupon);
											},
											A2($elm$core$List$cons, outward.nx, outward.lH)))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('marginLeftSmall flex1')
										]),
									A2(
										$elm$core$List$cons,
										$author$project$Page$OnboardService$Common$route(
											{kS: session.le, le: session.kS}),
										A2(
											$elm$core$List$map,
											function (coupon) {
												return A3(
													$elm$core$Basics$composeR,
													A3(shipMoneyButtonArguments, returnSelected, false, $author$project$Page$OnboardService$Update$AddedReturnShipMoney),
													$author$project$Page$OnboardService$ShipMoney$plusMinusButton(
														A2($author$project$Page$OnboardService$ShipMoney$isNotLastShipMoneyCoupon, _return.lH, coupon)),
													coupon);
											},
											A2($elm$core$List$cons, _return.nx, _return.lH))))
								]))
						]);
				}
			}());
	});
var $author$project$Page$OnboardService$ShipMoney$section = F2(
	function (session, shipMoney) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('header title1Medium marginHorizontalSmall')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(shipMoney.oh)
						])),
					A2($author$project$Page$OnboardService$ShipMoney$panel, session, shipMoney)
				]));
	});
var $author$project$Page$OnboardService$View$view = function (session) {
	var onboardServices = session.rI;
	var _v0 = onboardServices;
	var covidServices = _v0.x5;
	var kidBracelets = _v0.AL;
	var friendshipBracelets = _v0.y9;
	var maybeShipMoney = _v0.B3;
	var dining = _v0.yv;
	var massages = _v0.BI;
	var bubbleFairServices = _v0.vz;
	var priorityBoardings = _v0.Fm;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('page withFixedButton')
			]),
		A3(
			$author$project$Utils$List$appendIfListNotEmpty,
			priorityBoardings,
			$author$project$Page$OnboardService$PriorityBoarding$section(session),
			A3(
				$author$project$Utils$List$appendIfListNotEmpty,
				massages,
				$author$project$Page$OnboardService$Massage$section(session),
				A3(
					$author$project$Utils$List$appendIfListNotEmpty,
					dining,
					$author$project$Page$OnboardService$Dining$section(session),
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							$author$project$Page$OnboardService$ShipMoney$section(session),
							maybeShipMoney),
						A3(
							$author$project$Utils$List$appendIfListNotEmpty,
							kidBracelets,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$sortWith($author$project$Page$OnboardService$View$compareServiceAgeGroups),
								$author$project$Page$OnboardService$KidBracelet$section(session)),
							A3(
								$author$project$Utils$List$appendIfListNotEmpty,
								friendshipBracelets,
								$author$project$Page$OnboardService$FriendshipBracelet$section(session),
								A3(
									$author$project$Utils$List$appendIfListNotEmpty,
									covidServices,
									$author$project$Page$OnboardService$CovidService$section(session),
									A3(
										$author$project$Utils$List$appendIfListNotEmpty,
										bubbleFairServices,
										$author$project$Page$OnboardService$BubbleFairService$section(session),
										_List_fromArray(
											[
												$author$project$Page$OnboardService$View$header(session)
											]))))))))));
};
var $author$project$PassengerDetailsPage$Messages$EnteredBirthDay = function (a) {
	return {$: 4, a: a};
};
var $author$project$PassengerDetailsPage$Messages$EnteredBirthMonth = function (a) {
	return {$: 5, a: a};
};
var $author$project$PassengerDetailsPage$Messages$EnteredBirthYear = function (a) {
	return {$: 6, a: a};
};
var $author$project$PassengerDetailsPage$Messages$Validate = {$: 9};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Common$Form$birthDayInput = function (attributes) {
	return A2(
		$elm$html$Html$input,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dateOfBirth data'),
					$elm$html$Html$Attributes$type_('tel'),
					$elm$html$Html$Attributes$name('bday-day'),
					$elm$html$Html$Attributes$autocomplete(true),
					$elm$html$Html$Attributes$maxlength(2),
					$elm$html$Html$Attributes$id('date-of-birth-day')
				]),
			attributes),
		_List_Nil);
};
var $author$project$Common$Form$birthDayInputLabel = function (translations) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dateOfBirth bodyNorm'),
				$elm$html$Html$Attributes$for('date-of-birth-day')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.ws)
			]));
};
var $author$project$Common$Form$birthMonthInput = function (attributes) {
	return A2(
		$elm$html$Html$input,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dateOfBirth data'),
					$elm$html$Html$Attributes$type_('tel'),
					$elm$html$Html$Attributes$name('bday-month'),
					$elm$html$Html$Attributes$autocomplete(true),
					$elm$html$Html$Attributes$maxlength(2),
					$elm$html$Html$Attributes$id('date-of-birth-month')
				]),
			attributes),
		_List_Nil);
};
var $author$project$Common$Form$birthMonthInputLabel = function (translations) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dateOfBirth bodyNorm'),
				$elm$html$Html$Attributes$for('date-of-birth-month')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wt)
			]));
};
var $author$project$Common$Form$birthYearInput = function (attributes) {
	return A2(
		$elm$html$Html$input,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dateOfBirth data'),
					$elm$html$Html$Attributes$type_('tel'),
					$elm$html$Html$Attributes$name('bday-year'),
					$elm$html$Html$Attributes$autocomplete(true),
					$elm$html$Html$Attributes$maxlength(4),
					$elm$html$Html$Attributes$id('date-of-birth-year')
				]),
			attributes),
		_List_Nil);
};
var $author$project$Common$Form$birthYearInputLabel = function (translations) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dateOfBirth bodyNorm'),
				$elm$html$Html$Attributes$for('date-of-birth-year')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wu)
			]));
};
var $author$project$Constants$bulletString = '•';
var $author$project$Common$Form$dateInputSpacer = A2(
	$elm$html$Html$td,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('dateInputSpacer')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text($author$project$Constants$bulletString)
		]));
var $author$project$PassengerDetailsPage$View$hasBirthDayYearError = function (_v0) {
	var maybeValidationError = _v0.rr;
	_v1$5:
	while (true) {
		if (!maybeValidationError.$) {
			switch (maybeValidationError.a.$) {
				case 3:
					switch (maybeValidationError.a.a.$) {
						case 5:
							var _v2 = maybeValidationError.a.a;
							return true;
						case 6:
							var _v3 = maybeValidationError.a.a;
							return true;
						default:
							break _v1$5;
					}
				case 2:
					switch (maybeValidationError.a.a.$) {
						case 8:
							return true;
						case 9:
							return true;
						case 3:
							return true;
						default:
							break _v1$5;
					}
				default:
					break _v1$5;
			}
		} else {
			break _v1$5;
		}
	}
	return false;
};
var $author$project$PassengerDetailsPage$View$hasBirthdayDayError = function (_v0) {
	var maybeValidationError = _v0.rr;
	_v1$4:
	while (true) {
		if (!maybeValidationError.$) {
			switch (maybeValidationError.a.$) {
				case 3:
					switch (maybeValidationError.a.a.$) {
						case 5:
							var _v2 = maybeValidationError.a.a;
							return true;
						case 6:
							var _v3 = maybeValidationError.a.a;
							return true;
						default:
							break _v1$4;
					}
				case 2:
					switch (maybeValidationError.a.a.$) {
						case 2:
							return true;
						case 3:
							return true;
						default:
							break _v1$4;
					}
				default:
					break _v1$4;
			}
		} else {
			break _v1$4;
		}
	}
	return false;
};
var $author$project$PassengerDetailsPage$View$hasBirthdayMonthError = function (_v0) {
	var maybeValidationError = _v0.rr;
	_v1$4:
	while (true) {
		if (!maybeValidationError.$) {
			switch (maybeValidationError.a.$) {
				case 3:
					switch (maybeValidationError.a.a.$) {
						case 5:
							var _v2 = maybeValidationError.a.a;
							return true;
						case 6:
							var _v3 = maybeValidationError.a.a;
							return true;
						default:
							break _v1$4;
					}
				case 2:
					switch (maybeValidationError.a.a.$) {
						case 5:
							return true;
						case 3:
							return true;
						default:
							break _v1$4;
					}
				default:
					break _v1$4;
			}
		} else {
			break _v1$4;
		}
	}
	return false;
};
var $author$project$PassengerDetailsPage$View$isReadOnly = function (model) {
	return model.qP || $author$project$Types$Passenger$isClubOneClient(model.a);
};
var $author$project$PassengerDetailsPage$View$canNotConvertLastAdultError = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('errorMsg bodyNorm'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-error', 'cannot-convert-last-adult')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.DM)
			]));
};
var $author$project$PassengerDetailsPage$View$canNotConvertLastAdultOrYouthError = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('errorMsg bodyNorm'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-error', 'cannot-convert-last-adult-or-youth')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.DN)
			]));
};
var $author$project$PassengerDetailsPage$View$invalidDateError = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('errorMsg bodyNorm'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-error', 'invalid-date')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.DO)
			]));
};
var $author$project$PassengerDetailsPage$View$nonDigitCharactersError = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('errorMsg bodyNorm'),
				A2($elm$html$Html$Attributes$attribute, 'data-test-error', 'non-digit-chars')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.DP)
			]));
};
var $author$project$PassengerDetailsPage$View$maybeBirthdayErrorView = F2(
	function (translations, _v0) {
		var maybeValidationError = _v0.rr;
		_v1$6:
		while (true) {
			if (!maybeValidationError.$) {
				switch (maybeValidationError.a.$) {
					case 2:
						switch (maybeValidationError.a.a.$) {
							case 0:
								return $elm$core$Maybe$Just(
									$author$project$PassengerDetailsPage$View$nonDigitCharactersError(translations));
							case 3:
								return $elm$core$Maybe$Just(
									$author$project$PassengerDetailsPage$View$nonDigitCharactersError(translations));
							case 6:
								return $elm$core$Maybe$Just(
									$author$project$PassengerDetailsPage$View$nonDigitCharactersError(translations));
							default:
								return $elm$core$Maybe$Just(
									$author$project$PassengerDetailsPage$View$invalidDateError(translations));
						}
					case 3:
						switch (maybeValidationError.a.a.$) {
							case 5:
								var _v2 = maybeValidationError.a.a;
								return $elm$core$Maybe$Just(
									$author$project$PassengerDetailsPage$View$canNotConvertLastAdultError(translations));
							case 6:
								var _v3 = maybeValidationError.a.a;
								return $elm$core$Maybe$Just(
									$author$project$PassengerDetailsPage$View$canNotConvertLastAdultOrYouthError(translations));
							default:
								break _v1$6;
						}
					default:
						break _v1$6;
				}
			} else {
				break _v1$6;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$PassengerDetailsPage$View$birthdayInput = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('formRow birthday marginTopMedium')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('labelTitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.wr)
							])),
						A2(
						$elm$html$Html$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Common$Form$birthDayInput(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'validationError',
																$author$project$PassengerDetailsPage$View$hasBirthdayDayError(model))
															])),
														$elm$html$Html$Attributes$value(model.l4),
														$elm$html$Html$Attributes$disabled(
														$author$project$PassengerDetailsPage$View$isReadOnly(model)),
														$elm$html$Html$Events$onInput($author$project$PassengerDetailsPage$Messages$EnteredBirthDay),
														$elm$html$Html$Events$onBlur($author$project$PassengerDetailsPage$Messages$Validate)
													])),
												$author$project$Common$Form$birthDayInputLabel(translations)
											])),
										$author$project$Common$Form$dateInputSpacer,
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Common$Form$birthMonthInput(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'validationError',
																$author$project$PassengerDetailsPage$View$hasBirthdayMonthError(model))
															])),
														$elm$html$Html$Attributes$value(model.l5),
														$elm$html$Html$Attributes$disabled(
														$author$project$PassengerDetailsPage$View$isReadOnly(model)),
														$elm$html$Html$Events$onInput($author$project$PassengerDetailsPage$Messages$EnteredBirthMonth),
														$elm$html$Html$Events$onBlur($author$project$PassengerDetailsPage$Messages$Validate)
													])),
												$author$project$Common$Form$birthMonthInputLabel(translations)
											])),
										$author$project$Common$Form$dateInputSpacer,
										A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Common$Form$birthYearInput(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'validationError',
																$author$project$PassengerDetailsPage$View$hasBirthDayYearError(model))
															])),
														$elm$html$Html$Attributes$value(model.l6),
														$elm$html$Html$Attributes$disabled(
														$author$project$PassengerDetailsPage$View$isReadOnly(model)),
														$elm$html$Html$Events$onInput($author$project$PassengerDetailsPage$Messages$EnteredBirthYear),
														$elm$html$Html$Events$onBlur($author$project$PassengerDetailsPage$Messages$Validate)
													])),
												$author$project$Common$Form$birthYearInputLabel(translations)
											]))
									]))
							]))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$singleton,
						A2($author$project$PassengerDetailsPage$View$maybeBirthdayErrorView, translations, model)))));
	});
var $author$project$PassengerDetailsPage$Messages$SelectedCitizenship = function (a) {
	return {$: 7, a: a};
};
var $author$project$Common$Form$citizenshipInputGroupLabel = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labelTitle')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wB)
			]));
};
var $elm$html$Html$optgroup = _VirtualDom_node('optgroup');
var $author$project$Common$Form$citizenshipSelect = F3(
	function (translations, model, attributes) {
		var optionView = function (citizenship) {
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(citizenship),
							model.v_)),
						$elm$html$Html$Attributes$value(citizenship.pQ)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(citizenship.oh)
					]));
		};
		var citizenships = model.v$;
		var _v0 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.E1;
				},
				$elm$core$Basics$eq(true)),
			citizenships);
		var popular = _v0.a;
		var other = _v0.b;
		return A2(
			$author$project$Common$Form$customSelect,
			attributes,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(model.v_, $elm$core$Maybe$Nothing)),
							$elm$html$Html$Attributes$value('')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.xl)
						])),
					A2(
					$elm$html$Html$optgroup,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'label', translations.wC)
						]),
					A2($elm$core$List$map, optionView, popular)),
					A2(
					$elm$html$Html$optgroup,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'label', translations.Dp)
						]),
					A2($elm$core$List$map, optionView, other))
				]));
	});
var $author$project$Common$Form$invertedSelectClass = 'inverted';
var $author$project$PassengerDetailsPage$View$citizenshipSelect = F3(
	function (translations, session, model) {
		var citizenships = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, session.v$);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('formRow')
				]),
			_List_fromArray(
				[
					$author$project$Common$Form$citizenshipInputGroupLabel(translations),
					A3(
					$author$project$Common$Form$citizenshipSelect,
					translations,
					{
						v_: A2(
							$elm_community$list_extra$List$Extra$find,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.pQ;
								},
								$elm$core$Basics$eq(model.v_)),
							citizenships),
						v$: citizenships
					},
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2($author$project$Common$Form$invertedSelectClass, model.v_ === '')
								])),
							$elm$html$Html$Attributes$disabled(
							$author$project$PassengerDetailsPage$View$isReadOnly(model)),
							A2(
							$elm$html$Html$Events$on,
							'change',
							A2($elm$json$Json$Decode$map, $author$project$PassengerDetailsPage$Messages$SelectedCitizenship, $elm$html$Html$Events$targetValue))
						]))
				]));
	});
var $author$project$PassengerDetailsPage$Messages$EnteredClubOneNumber = function (a) {
	return {$: 2, a: a};
};
var $author$project$PassengerDetailsPage$View$hasClubOneNumberError = function (model) {
	var _v0 = model.rr;
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$PassengerDetailsPage$View$isPassengerJoiningClubOne = F2(
	function (session, _v0) {
		var givenName = _v0.zj;
		var familyName = _v0.mr;
		var passenger = _v0.a;
		return function (a) {
			return A2($author$project$Update$JoinClubOne$isJoining, session, a);
		}(
			{yI: passenger.yI, y2: givenName, A6: familyName, ox: passenger.ox, jX: passenger.jX});
	});
var $author$project$PassengerDetailsPage$Messages$ResetForm = {$: 11};
var $author$project$PassengerDetailsPage$View$userAlreadyAddedMessage = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bodyNorm errorMsg'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'user-already-added-error')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('userName')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(model.zj + (' ' + model.mr))
						])),
					$elm$html$Html$text(' ' + (translations.DU + (' ' + (translations.DV + ' ')))),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$PassengerDetailsPage$Messages$ResetForm)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.DW)
						]))
				]));
	});
var $author$project$PassengerDetailsPage$View$clubOneNumberInput = F3(
	function (translations, session, model) {
		var isDisabled = $author$project$PassengerDetailsPage$View$isReadOnly(model) || A2($author$project$PassengerDetailsPage$View$isPassengerJoiningClubOne, session, model);
		var hasLoginError = !_Utils_eq(model.rf, $elm$core$Maybe$Nothing);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginTopMedium clubOneNumber')
				]),
			A3(
				$author$project$Utils$List$addIf,
				model.qP,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('spinner animateSpinner')
						]),
					_List_fromArray(
						[$author$project$Common$Images$darkPropeller])),
				A3(
					$author$project$Utils$List$addIf,
					_Utils_eq(
						model.rr,
						$elm$core$Maybe$Just($author$project$PassengerDetailsPage$Model$DuplicateClubOneInfoError)),
					A2($author$project$PassengerDetailsPage$View$userAlreadyAddedMessage, translations, model),
					A3(
						$author$project$Utils$List$addIf,
						(!model.qP) && hasLoginError,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('errorMsg bodyNorm marginTopSmall')
								]),
							$author$project$Translations$toHtml(translations.DS)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('labelTitle'),
												$elm$html$Html$Attributes$for('clubOneNumberInput')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(translations.DT)
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$id('clubOneNumberInput'),
												$elm$html$Html$Attributes$class('data clubOne'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'validationError',
														hasLoginError || $author$project$PassengerDetailsPage$View$hasClubOneNumberError(model))
													])),
												$elm$html$Html$Attributes$type_('tel'),
												$elm$html$Html$Attributes$maxlength(8),
												$elm$html$Html$Attributes$name('family-name'),
												$elm$html$Html$Attributes$autocomplete(true),
												$elm$html$Html$Attributes$disabled(isDisabled),
												$elm$html$Html$Attributes$value(model.we),
												$elm$html$Html$Events$onInput($author$project$PassengerDetailsPage$Messages$EnteredClubOneNumber),
												$elm$html$Html$Events$onBlur($author$project$PassengerDetailsPage$Messages$Validate),
												A2($elm$html$Html$Attributes$attribute, 'data-test', 'club-one-input')
											]),
										_List_Nil)
									]))
							])))));
	});
var $author$project$Messages$ClickedPassengerSave = function (a) {
	return {$: 126, a: a};
};
var $author$project$PassengerDetailsPage$View$doneButton = F4(
	function (translations, departureDate, passengers, model) {
		var isAvailableToSave = !_Utils_eq(
			$elm$core$Maybe$Nothing,
			$elm$core$Result$toMaybe(
				A5(
					$author$project$Types$Passenger$fromForm,
					model.q$,
					model.qH,
					passengers,
					$author$project$PassengerDetailsPage$Model$modelToForm(model),
					departureDate)));
		return ($author$project$Types$Passenger$isClubOneClient(model.a) && (!model.qP)) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('greenButton'),
					A2($elm$html$Html$Attributes$attribute, 'data-test-done-button', ''),
					$author$project$UrlRoute$onClickWithoutSideEffects(
					_Utils_eq(
						A2($elm$core$Array$get, model.qH, passengers),
						$elm$core$Maybe$Just(model.a)) ? $author$project$Messages$ClickedGoBack : $author$project$Messages$GotClubOnePassenger(model))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.wF)
				])) : ((isAvailableToSave && (!model.qP)) ? A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('greenButton'),
					A2($elm$html$Html$Attributes$attribute, 'data-test-save-button', ''),
					$author$project$UrlRoute$onClickWithoutSideEffects(
					$author$project$Messages$ClickedPassengerSave(model))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.DR)
				])) : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('outlineBigButton'),
					A2($elm$html$Html$Attributes$attribute, 'data-test-close-button', ''),
					$author$project$UrlRoute$onClickWithoutSideEffects($author$project$Messages$ClickedGoBack)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(translations.DQ)
				])));
	});
var $author$project$PassengerDetailsPage$Messages$ChangedGender = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $author$project$Common$Button$radio = F2(
	function (isReadOnly, a) {
		var isActive = a.qM;
		var msg = a.rz;
		return A2(
			$elm$html$Html$label,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('outlineButtonComponent bodyBold'),
						$elm$html$Html$Attributes$for(a.zN)
					]),
				_Utils_ap(
					isActive ? _List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Common$Button$activeState)
						]) : _List_Nil,
					isReadOnly ? _List_fromArray(
						[
							$elm$html$Html$Attributes$class($author$project$Common$Button$disabledState)
						]) : _List_Nil)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$disabled(isReadOnly),
							$elm$html$Html$Attributes$id(a.zN),
							$elm$html$Html$Attributes$hidden(true),
							$elm$html$Html$Attributes$checked(isActive),
							$elm$html$Html$Events$onClick(msg)
						]),
					_List_Nil),
					$author$project$Common$Button$text(
					$elm$core$String$toUpper(a.ta)),
					isActive ? $author$project$Common$Images$tickMarkInWhiteCircle : $elm$html$Html$text('')
				]));
	});
var $author$project$Common$Button$radioGroup = F2(
	function (attributes, elements) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('radioGroup'),
				attributes),
			elements);
	});
var $author$project$Common$Form$genderInput = F2(
	function (translations, _v0) {
		var selected = _v0.Gg;
		var isReadOnly = _v0.An;
		var male = {zN: 'male', qM: selected === 1, rz: 1, ta: translations.wK};
		var female = {zN: 'female', qM: !selected, rz: 0, ta: translations.wJ};
		return A2(
			$author$project$Common$Button$radioGroup,
			_List_fromArray(
				[
					isReadOnly ? A2($elm$html$Html$Attributes$attribute, 'data-test', 'disabled-gender-toggle') : A2($elm$html$Html$Attributes$attribute, 'data-test', 'enabled-gender-toggle')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Button$radio, isReadOnly, male),
					A2($author$project$Common$Button$radio, isReadOnly, female)
				]));
	});
var $author$project$Common$Form$genderLabel = function (translations) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('labelTitle')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wI)
			]));
};
var $author$project$PassengerDetailsPage$View$genderInput = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('marginTopMedium')
				]),
			_List_fromArray(
				[
					$author$project$Common$Form$genderLabel(translations),
					A2(
					$elm$html$Html$map,
					$author$project$PassengerDetailsPage$Messages$ChangedGender,
					A2(
						$author$project$Common$Form$genderInput,
						translations,
						{
							An: $author$project$PassengerDetailsPage$View$isReadOnly(model),
							Gg: model.zf
						}))
				]));
	});
var $author$project$PassengerDetailsPage$View$logInWithClubOneBeforeBookingMessage = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('doNotForgetClubOne priceNormal informationToast toast marginTopMedium')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(translations.wE)
			]));
};
var $author$project$PassengerDetailsPage$Messages$EnteredFamilyName = function (a) {
	return {$: 1, a: a};
};
var $author$project$PassengerDetailsPage$Messages$EnteredGivenName = function (a) {
	return {$: 0, a: a};
};
var $author$project$PassengerDetailsPage$View$hasNameError = function (model) {
	var _v0 = model.rr;
	if ((!_v0.$) && (!_v0.a.$)) {
		return true;
	} else {
		return false;
	}
};
var $author$project$PassengerDetailsPage$View$nameInput = F3(
	function (translations, session, model) {
		var isDisabled = $author$project$PassengerDetailsPage$View$isReadOnly(model) || A2($author$project$PassengerDetailsPage$View$isPassengerJoiningClubOne, session, model);
		var hasLoginError = !_Utils_eq(model.rf, $elm$core$Maybe$Nothing);
		return A3(
			$author$project$Utils$List$addIf,
			$author$project$PassengerDetailsPage$View$hasNameError(model),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('errorMsg bodyNorm marginTopSmall')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.wX)
					])),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('displayFlex')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex1 marginRightSmall')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('labelTitle'),
											$elm$html$Html$Attributes$for('firstNameInput')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.wH)
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('firstNameInput'),
											$elm$html$Html$Attributes$class('data firstName'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('validationError', hasLoginError)
												])),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$name('given-name'),
											$elm$html$Html$Attributes$autocomplete(true),
											$elm$html$Html$Attributes$disabled(isDisabled),
											$elm$html$Html$Attributes$value(model.zj),
											$elm$html$Html$Attributes$maxlength(30),
											$elm$html$Html$Events$onInput($author$project$PassengerDetailsPage$Messages$EnteredGivenName),
											$elm$html$Html$Events$onBlur($author$project$PassengerDetailsPage$Messages$Validate),
											A2($elm$html$Html$Attributes$attribute, 'data-test', 'given-name-input')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex1 marginLeftSmall')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('labelTitle'),
											$elm$html$Html$Attributes$for('lastNameInput')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.wO)
										])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('lastNameInput'),
											$elm$html$Html$Attributes$class('data lastName'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('validationError', hasLoginError)
												])),
											$elm$html$Html$Attributes$type_('text'),
											$elm$html$Html$Attributes$name('family-name'),
											$elm$html$Html$Attributes$autocomplete(true),
											$elm$html$Html$Attributes$disabled(isDisabled),
											$elm$html$Html$Attributes$value(model.mr),
											$elm$html$Html$Attributes$maxlength(30),
											$elm$html$Html$Events$onInput($author$project$PassengerDetailsPage$Messages$EnteredFamilyName),
											$elm$html$Html$Events$onBlur($author$project$PassengerDetailsPage$Messages$Validate),
											A2($elm$html$Html$Attributes$attribute, 'data-test', 'family-name-input')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $author$project$PassengerDetailsPage$View$formView = F4(
	function (translations, departureDate, session, model) {
		var passengers = session.Eg;
		var isAffiliate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (clubOne) {
					return _Utils_eq(clubOne.k$, model.we) && (!$elm$core$List$isEmpty(
						A2(
							$elm$core$List$filter,
							function (affiliate) {
								var equals = F2(
									function (string1, string2) {
										return _Utils_eq(
											$elm$core$String$toLower(string1),
											$elm$core$String$toLower(string2));
									});
								return A2(equals, affiliate.A6, model.mr) && A2(equals, affiliate.y2, model.zj);
							},
							clubOne.tX)));
				},
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.BP;
					},
					$krisajenkins$remotedata$RemoteData$toMaybe(session.Ia.v4))));
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$novalidate(true),
					$elm$html$Html$Attributes$name('passengerDetails'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'outward-sail-date',
					$author$project$Utils$Time$toDateString(departureDate))
				]),
			_Utils_ap(
				A3(
					$author$project$Utils$List$addIf,
					(!$author$project$Types$Passenger$isClubOneClient(model.a)) && (!A2($author$project$PassengerDetailsPage$View$isPassengerJoiningClubOne, session, model)),
					$author$project$PassengerDetailsPage$View$logInWithClubOneBeforeBookingMessage(translations),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($author$project$Messages$PassengerDetailsPageMsg),
						A3($author$project$PassengerDetailsPage$View$nameInput, translations, session, model))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Messages$PassengerDetailsPageMsg,
						A3($author$project$PassengerDetailsPage$View$clubOneNumberInput, translations, session, model)),
						A2(
						$author$project$Utils$Html$Render$renderIf,
						!isAffiliate,
						A2(
							$elm$html$Html$map,
							$author$project$Messages$PassengerDetailsPageMsg,
							A2($author$project$PassengerDetailsPage$View$genderInput, translations, model))),
						A2(
						$author$project$Utils$Html$Render$renderIf,
						!isAffiliate,
						A2(
							$elm$html$Html$map,
							$author$project$Messages$PassengerDetailsPageMsg,
							A2($author$project$PassengerDetailsPage$View$birthdayInput, translations, model))),
						A2(
						$author$project$Utils$Html$Render$renderIf,
						!isAffiliate,
						A2(
							$elm$html$Html$map,
							$author$project$Messages$PassengerDetailsPageMsg,
							A3($author$project$PassengerDetailsPage$View$citizenshipSelect, translations, session, model))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('marginTopMedium')
							]),
						_List_fromArray(
							[
								A4($author$project$PassengerDetailsPage$View$doneButton, translations, departureDate, passengers, model)
							]))
					])));
	});
var $author$project$Types$Passenger$isLastAdult = F2(
	function (index, passengers) {
		var maybePassenger = A2($elm$core$Array$get, index, passengers);
		var isAdult = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.tY;
				},
				maybePassenger),
			$elm$core$Maybe$Just(0));
		return isAdult && ($elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (passenger) {
					return !passenger.tY;
				},
				$elm$core$Array$toList(passengers))) === 1);
	});
var $author$project$PassengerDetailsPage$View$getViewAgeCategory = F3(
	function (departureDate, passengers, model) {
		return A2(
			$elm$core$Result$withDefault,
			model.a.tY,
			A2(
				$elm$core$Result$map,
				function (a) {
					return ((!(!a)) && A2($author$project$Types$Passenger$isLastAdult, model.qH, passengers)) ? 0 : a;
				},
				A2(
					$elm$core$Result$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$Date$toPosix,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Utils$Time$differenceOfDatesInYears(departureDate),
							$author$project$Types$AgeCategory$fromAge)),
					$author$project$Types$Date$fromStringValues(
						{q: model.l4, s: model.l5, h: model.l6}))));
	});
var $author$project$PassengerDetailsPage$View$header = F4(
	function (translations, departureDate, _v0, model) {
		var passengers = _v0.Eg;
		var ageCategory = A3($author$project$PassengerDetailsPage$View$getViewAgeCategory, departureDate, passengers, model);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('headerHolder')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell title2'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-age-category',
									$author$project$Types$AgeCategory$toString(ageCategory)),
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'age-category-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Types$AgeCategory$translate, ageCategory, translations))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell bodyNorm')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.wD)
								]))
						]))
				]));
	});
var $author$project$PassengerDetailsPage$View$view = F3(
	function (translations, session, model) {
		var departureDate = A2(
			$elm$core$Maybe$withDefault,
			session.kJ,
			A2(
				$elm$core$Maybe$map,
				A2($elm$core$Basics$composeR, $author$project$Types$Trips$selectedDepartureAndArrivalTimes, $elm$core$Tuple$first),
				$author$project$Types$Trips$statusToMaybe(session.tp)));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerDetailsPage page')
				]),
			_List_fromArray(
				[
					A4($author$project$PassengerDetailsPage$View$header, translations, departureDate, session, model),
					A4($author$project$PassengerDetailsPage$View$formView, translations, departureDate, session, model)
				]));
	});
var $author$project$Messages$ClickedPayWithInvoice = {$: 114};
var $author$project$InvoicePage$View$invoiceAddress = function (_v0) {
	var name = _v0.oh;
	var address = _v0.tT;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('addressInfo bodyNorm')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$toLower(name)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				$elm$html$Html$text(
				$elm$core$String$toLower(address.G0)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				$elm$html$Html$text(
				$elm$core$String$toLower(address.IG + (' ' + address.v0)))
			]));
};
var $author$project$Messages$ChangedInvoiceReferenceNumber = function (a) {
	return {$: 105, a: a};
};
var $author$project$InvoicePage$View$referenceNumberInput = F2(
	function (translations, referenceNumber) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('referenceNumber')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('labelTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.El)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('data'),
							$elm$html$Html$Attributes$value(
							A2($elm$core$Maybe$withDefault, '', referenceNumber)),
							$elm$html$Html$Events$onInput($author$project$Messages$ChangedInvoiceReferenceNumber),
							$elm$html$Html$Attributes$maxlength(30)
						]),
					_List_Nil)
				]));
	});
var $author$project$InvoicePage$View$invoice = F3(
	function (translations, referenceNumber, companyInfo) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.Ek)
						])),
					$author$project$InvoicePage$View$invoiceAddress(companyInfo),
					A2($author$project$InvoicePage$View$referenceNumberInput, translations, referenceNumber)
				]));
	});
var $author$project$Common$ButtonWithSpinner$payButtonText = F4(
	function (translations, market, currency, price) {
		return A2(
			$author$project$Translations$injectValues,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'price',
					A2($author$project$Types$Market$formatPrice, market, price) + (' ' + $author$project$Types$Currency$toLongSign(currency)))
				]),
			translations.w_);
	});
var $author$project$Common$ButtonWithSpinner$getButtonPriceFromSession = F2(
	function (translations, _v0) {
		var reservationData = _v0.Fz;
		var maybeSummary = _v0.B7;
		var market = _v0.rb;
		return A2(
			$elm$core$Maybe$withDefault,
			'The price is missing',
			A2(
				$author$project$Types$Maybe$Util$orElse,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A3(
							$author$project$Common$ButtonWithSpinner$payButtonText,
							translations,
							market,
							$author$project$Types$Market$toCurrency(market)),
						function ($) {
							return $.lN;
						}),
					maybeSummary),
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var currency = _v1.yd;
						var paidTotal = _v1.DG;
						var price = _v1.lN;
						return A4($author$project$Common$ButtonWithSpinner$payButtonText, translations, market, currency, price - paidTotal);
					},
					reservationData)));
	});
var $author$project$Common$ButtonWithSpinner$initialState = {mA: false, nP: false, mF: false, ta: ''};
var $author$project$Common$ButtonWithSpinner$initModel = {n2: 'greenButton', mW: $author$project$Common$ButtonWithSpinner$initialState};
var $author$project$Common$ButtonWithSpinner$updatedModel = F3(
	function (translations, session, isDisabled) {
		return _Utils_update(
			$author$project$Common$ButtonWithSpinner$initModel,
			{
				mW: _Utils_update(
					$author$project$Common$ButtonWithSpinner$initialState,
					{
						mA: isDisabled,
						mF: session.Am,
						ta: A2($author$project$Common$ButtonWithSpinner$getButtonPriceFromSession, translations, session)
					})
			});
	});
var $author$project$Common$ButtonWithSpinner$view = F2(
	function (model, msg) {
		var _v0 = model.mW;
		var isDisabled = _v0.mA;
		var isProcessing = _v0.mF;
		var isHidden = _v0.nP;
		var text = _v0.ta;
		var spinner = isProcessing ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('spinner'),
					$elm$html$Html$Attributes$class('animateSpinner'),
					$elm$html$Html$Attributes$class('graySpinner')
				]),
			_List_fromArray(
				[$author$project$Common$Images$lightPropeller])) : $elm$html$Html$text('');
		return isHidden ? $elm$html$Html$text('') : A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(model.n2),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('processing', isProcessing),
							_Utils_Tuple2('disabled', isDisabled)
						])),
					$elm$html$Html$Attributes$disabled(isDisabled || isProcessing),
					A2($elm$html$Html$Attributes$attribute, 'data-test-pay-button', ''),
					$elm$html$Html$Attributes$id('pay-button'),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text),
					spinner
				]));
	});
var $author$project$InvoicePage$View$view = F4(
	function (translations, session, referenceNumber, companyInfo) {
		var newButtonWithSpinnerModel = A3($author$project$Common$ButtonWithSpinner$updatedModel, translations, session, false);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoicePageContent')
				]),
			_List_fromArray(
				[
					A3($author$project$InvoicePage$View$invoice, translations, referenceNumber, companyInfo),
					A2($author$project$Common$Terms$View$paymentTerms, translations, session),
					A2($author$project$Common$ButtonWithSpinner$view, newButtonWithSpinnerModel, $author$project$Messages$ClickedPayWithInvoice)
				]));
	});
var $author$project$InvoicePage$View$root = F3(
	function (translations, session, _v0) {
		var referenceNumber = _v0.sj;
		var _v1 = session.xA;
		if (!_v1.$) {
			var company = _v1.a;
			return A4($author$project$InvoicePage$View$view, translations, session, referenceNumber, company.yt);
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.xU;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.xA;
							},
							$elm$core$Maybe$map(
								A3($author$project$InvoicePage$View$view, translations, session, referenceNumber)))),
					session.Fz));
		}
	});
var $author$project$Types$Recaptcha$Pay = function (a) {
	return {$: 0, a: a};
};
var $author$project$Common$Images$klarnaLogo = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$version('1.1'),
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('0px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 452.9 101.1'),
			$elm$svg$Svg$Attributes$style('enable-background:new 0 0 452.9 101.1;')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M79.7,0H57.4c0,18.3-8.4,35-23,46l-8.8,6.6l34.2,46.6h28.1L56.4,56.3C71.3,41.5,79.7,21.5,79.7,0z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('22.8'),
					$elm$svg$Svg$Attributes$height('99.2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$rect,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x('94.5'),
					$elm$svg$Svg$Attributes$width('21.5'),
					$elm$svg$Svg$Attributes$height('99.2')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M304.6,28.7c-8.2,0-16,2.5-21.2,9.6v-7.7H263v68.6h20.7v-36c0-10.4,7-15.5,15.4-15.5c9,0,14.2,5.4,14.2,15.4v36.2h20.5V55.6 C333.8,39.6,321.1,28.7,304.6,28.7z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M181,30.6V35c-5.8-4-12.8-6.3-20.4-6.3c-20,0-36.2,16.2-36.2,36.2s16.2,36.2,36.2,36.2c7.6,0,14.6-2.3,20.4-6.3v4.4h20.5 V30.6H181z M162.3,82.5c-10.3,0-18.6-7.9-18.6-17.6s8.3-17.6,18.6-17.6c10.3,0,18.6,7.9,18.6,17.6S172.6,82.5,162.3,82.5z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M233.3,39.5v-8.9h-21v68.6h21.1v-32c0-10.8,11.7-16.6,19.8-16.6c0.1,0,0.2,0,0.2,0v-20C245.1,30.6,237.4,34.2,233.3,39.5z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M397.6,30.6V35c-5.8-4-12.8-6.3-20.4-6.3c-20,0-36.2,16.2-36.2,36.2s16.2,36.2,36.2,36.2c7.6,0,14.6-2.3,20.4-6.3v4.4h20.5 V30.6H397.6z M378.9,82.5c-10.3,0-18.6-7.9-18.6-17.6s8.3-17.6,18.6-17.6c10.3,0,18.6,7.9,18.6,17.6 C397.6,74.6,389.2,82.5,378.9,82.5z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M434,32.6c0-1-0.7-1.6-1.8-1.6h-1.9v5.2h0.9v-1.9h1l0.8,1.9h1l-0.9-2.1C433.7,33.8,434,33.3,434,32.6z M432.2,33.4h-1v-1.6 h1c0.6,0,0.9,0.3,0.9,0.8S432.9,33.4,432.2,33.4z')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M431.9,28.8c-2.7,0-4.9,2.2-4.9,4.9c0.1,2.7,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9C436.8,31,434.6,28.8,431.9,28.8z M431.9,37.7 c-2.2,0-3.9-1.8-3.9-4c0-2.2,1.8-4,3.9-4c2.2,0,3.9,1.8,3.9,4C435.8,35.9,434,37.7,431.9,37.7z')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M440,74.9c-7.1,0-12.9,5.8-12.9,12.9c0,7.1,5.8,12.9,12.9,12.9c7.1,0,12.9-5.8,12.9-12.9C452.9,80.6,447.1,74.9,440,74.9z')
				]),
			_List_Nil)
		]));
var $author$project$Common$Images$listDot = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 18 18')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$transform('translate(-79.000000, -40.000000)'),
					$elm$svg$Svg$Attributes$fill('#004152')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$transform('translate(79.000000, 39.000000)')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id('Oval-6'),
									$elm$svg$Svg$Attributes$cx('9'),
									$elm$svg$Svg$Attributes$cy('10'),
									$elm$svg$Svg$Attributes$r('9')
								]),
							_List_Nil)
						]))
				]))
		]));
var $author$project$Common$Terms$View$recaptchaTerms = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bodySmallNorm terms recaptcha')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				$author$project$Translations$toHtml(translations.Fs))
			]));
};
var $author$project$KlarnaTermsPage$View$root = F2(
	function (translations, session) {
		var newButtonWithSpinnerModel = A3($author$project$Common$ButtonWithSpinner$updatedModel, translations, session, !session.Ao);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('wrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('klarnaServiceDescription')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('klarnaOptionsTitle')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.AW)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('klarnaOptionsList')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Utils$String$renderIf,
											session.rb === 4,
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('optionsListDot')
													]),
												_List_fromArray(
													[$author$project$Common$Images$listDot]))),
											A2(
											$author$project$Utils$String$renderIf,
											session.rb === 4,
											A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(translations.AV)
													]))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('optionsListDot')
												]),
											_List_fromArray(
												[$author$project$Common$Images$listDot])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(translations.AT)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('optionsListDot')
												]),
											_List_fromArray(
												[$author$project$Common$Images$listDot])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(translations.AU)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('klarnaLogo')
										]),
									_List_fromArray(
										[$author$project$Common$Images$klarnaLogo])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('klarnaAgreements')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.AN),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$href(translations.AO),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(translations.AP)
												]))
										]))
								]))
						])),
					A2($author$project$Common$Terms$View$paymentTerms, translations, session),
					A2(
					$author$project$Common$ButtonWithSpinner$view,
					newButtonWithSpinnerModel,
					$author$project$Messages$RequestedRecaptchaIfNeeded(
						$author$project$Types$Recaptcha$Pay(2))),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Common$Recaptcha$shouldRequestRecaptcha(session),
					$author$project$Common$Terms$View$recaptchaTerms(translations))
				]));
	});
var $author$project$PaymentService$View$root = F3(
	function (translations, session, paymentServiceProviderCode) {
		var newButtonWithSpinnerModel = A3($author$project$Common$ButtonWithSpinner$updatedModel, translations, session, !session.Ao);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('wrapper')
				]),
			_List_fromArray(
				[
					A2($author$project$Common$Terms$View$paymentTerms, translations, session),
					A2(
					$author$project$Common$ButtonWithSpinner$view,
					newButtonWithSpinnerModel,
					$author$project$Messages$RequestedRecaptchaIfNeeded(
						$author$project$Types$Recaptcha$Pay(paymentServiceProviderCode))),
					A2(
					$author$project$Utils$Html$Render$renderIf,
					$author$project$Common$Recaptcha$shouldRequestRecaptcha(session),
					$author$project$Common$Terms$View$recaptchaTerms(translations))
				]));
	});
var $author$project$PaymentPage$View$content = F4(
	function (translations, session, invoicePage, selectedPaymentMethod) {
		if (!selectedPaymentMethod.$) {
			var paymentServiceProviderCode = selectedPaymentMethod.a;
			return (paymentServiceProviderCode === 2) ? A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('klarnaTermsAndConditions')
					]),
				_List_fromArray(
					[
						A2($author$project$KlarnaTermsPage$View$root, translations, session)
					])) : A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('paymentService')
					]),
				_List_fromArray(
					[
						A3($author$project$PaymentService$View$root, translations, session, paymentServiceProviderCode)
					]));
		} else {
			return A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('invoicePage')
					]),
				_List_fromArray(
					[
						A3($author$project$InvoicePage$View$root, translations, session, invoicePage)
					]));
		}
	});
var $author$project$Utils$String$capitalizeFirstLetter = function (string) {
	return _Utils_ap(
		$elm$core$String$toUpper(
			A2($elm$core$String$left, 1, string)),
		A2($elm$core$String$dropLeft, 1, string));
};
var $author$project$PaymentPage$Messages$SelectPaymentMethod = $elm$core$Basics$identity;
var $author$project$PaymentPage$Model$toTestId = function (tab) {
	if (!tab.$) {
		switch (tab.a) {
			case 1:
				var _v1 = tab.a;
				return 'payment-service-adyen';
			case 0:
				var _v2 = tab.a;
				return 'payment-service-swedbank';
			default:
				var _v3 = tab.a;
				return 'payment-service-klarna';
		}
	} else {
		return 'invoice';
	}
};
var $author$project$PaymentPage$View$paymentMethodView = F5(
	function (isProcessingPayment, title, maybeDescription, paymentMethod, maybeSelectedPaymentMethod) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('paymentMethod'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test',
					$author$project$PaymentPage$Model$toTestId(paymentMethod)),
					$elm$html$Html$Attributes$disabled(isProcessingPayment),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$PaymentPageMsg(paymentMethod))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-indicator'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'selected',
									_Utils_eq(
										maybeSelectedPaymentMethod,
										$elm$core$Maybe$Just(paymentMethod)))
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title bodyBold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Utils$Html$Render$maybeRender,
							function (description) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('description bodyNorm')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(description)
										]));
							},
							maybeDescription)
						]))
				]));
	});
var $author$project$PaymentPage$View$translateAdyenMethod = F2(
	function (translations, method) {
		switch (method) {
			case 'BANK':
				return translations.xb;
			case 'CARD':
				return translations.xc;
			case 'APPLE_PAY':
				return translations.xa;
			case 'GOOGLE_PAY':
				return translations.xd;
			case 'ALIPAY':
				return translations.w9;
			case 'WECHAT_PAY':
				return translations.xg;
			case 'MOBILE_PAY':
				return translations.xe;
			default:
				return method;
		}
	});
var $author$project$PaymentPage$View$paymentMethodListView = F5(
	function (_v0, _v1, translations, isProcessingPayment, maybeSelectedPaymentMethod) {
		var paymentServiceProviders = _v0.Ey;
		var company = _v1.xA;
		var reservationData = _v1.Fz;
		var market = _v1.rb;
		var paymentMethodViewWithParams = F3(
			function (title, maybeDescription, paymentMethod) {
				return A5($author$project$PaymentPage$View$paymentMethodView, isProcessingPayment, title, maybeDescription, paymentMethod, maybeSelectedPaymentMethod);
			});
		var swedbankPaymentMethodView = A2(
			$elm$core$Maybe$map,
			function (_v7) {
				return A3(
					paymentMethodViewWithParams,
					translations.xj,
					$elm$core$Maybe$Just(translations.xi),
					$author$project$PaymentPage$Model$PaymentService(0));
			},
			A2($author$project$Types$PaymentServiceProvider$findServiceProviderByCode, 0, paymentServiceProviders));
		var klarnaPaymentMethodView = A2(
			$elm$core$Maybe$map,
			function (klarna) {
				var title = A2($elm$core$List$member, 'SWISH', klarna.Cw) ? translations.AQ : translations.AS;
				return A3(
					paymentMethodViewWithParams,
					title,
					$elm$core$Maybe$Just(translations.AR),
					$author$project$PaymentPage$Model$PaymentService(2));
			},
			A2($author$project$Types$PaymentServiceProvider$findServiceProviderByCode, 2, paymentServiceProviders));
		var invoiceView = function () {
			var available = A2(
				$elm$core$Maybe$withDefault,
				A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.xU;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.xA;
								},
								$elm$core$Maybe$map(
									function ($) {
										return $.qR;
									}))),
						reservationData)),
				A2(
					$elm$core$Maybe$map,
					function (_v6) {
						var details = _v6.yt;
						var agent = _v6.tZ;
						return details.qR && (!_Utils_eq(agent, $elm$core$Maybe$Nothing));
					},
					company));
			return available ? $elm$core$Maybe$Just(
				A3(paymentMethodViewWithParams, translations.Ej, $elm$core$Maybe$Nothing, $author$project$PaymentPage$Model$Invoice)) : $elm$core$Maybe$Nothing;
		}();
		var adyenPaymentMethodView = A2(
			$elm$core$Maybe$map,
			function (adyen) {
				var title = A2($elm$core$List$member, 'BANK', adyen.Cw) ? translations.xh : translations.xf;
				var description = $author$project$Utils$String$capitalizeFirstLetter(
					A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							$author$project$PaymentPage$View$translateAdyenMethod(translations),
							adyen.Cw)));
				return A3(
					paymentMethodViewWithParams,
					title,
					$elm$core$Maybe$Just(description),
					$author$project$PaymentPage$Model$PaymentService(1));
			},
			A2($author$project$Types$PaymentServiceProvider$findServiceProviderByCode, 1, paymentServiceProviders));
		var paymentMethodViews = A2(
			$elm$core$List$filterMap,
			function (a) {
				if (!a.$) {
					switch (a.a) {
						case 1:
							var _v3 = a.a;
							return adyenPaymentMethodView;
						case 0:
							var _v4 = a.a;
							return swedbankPaymentMethodView;
						default:
							var _v5 = a.a;
							return klarnaPaymentMethodView;
					}
				} else {
					return invoiceView;
				}
			},
			$author$project$PaymentPage$Model$paymentMethodsOrder);
		return A2(
			$author$project$Utils$Html$Render$renderIf,
			$elm$core$List$length(paymentMethodViews) > 1,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('paymentMethodsList')
					]),
				paymentMethodViews));
	});
var $author$project$PaymentPage$View$view = F5(
	function (translations, session, paymentMethods, invoicePageModel, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('paymentMethods')
				]),
			_List_fromArray(
				[
					A5($author$project$PaymentPage$View$paymentMethodListView, paymentMethods, session, translations, session.Am, model.ro),
					A2(
					$author$project$Utils$Html$Render$maybeRender,
					A3($author$project$PaymentPage$View$content, translations, session, invoicePageModel),
					model.ro)
				]));
	});
var $author$project$Messages$SelectedCruiseMultiDepartureTripDay = function (a) {
	return {$: 133, a: a};
};
var $author$project$Types$Trips$isLoading = function (status) {
	if (status.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$TimetablePage$View$loaderOverlay = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loader-overlay')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loader-wrapper animateSpinner')
				]),
			_List_fromArray(
				[$author$project$Common$Images$darkPropeller]))
		]));
var $author$project$TimetablePage$Calendar$View$generateMonthRange = F2(
	function (start, end) {
		return A5(
			$justinmimbs$time_extra$Time$Extra$range,
			2,
			1,
			$elm$time$Time$utc,
			A3($justinmimbs$time_extra$Time$Extra$floor, 2, $elm$time$Time$utc, start),
			end);
	});
var $author$project$TimetablePage$Calendar$View$dayOfWeekNames = function (_v0) {
	var language = _v0.A_;
	var weekDayNames = A2(
		$elm$core$List$map,
		function (a) {
			return A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(a)
					]));
		},
		A2(
			$elm$core$List$map,
			$author$project$Utils$Time$Translations$fromLanguage(language).HM,
			_List_fromArray(
				[0, 1, 2, 3, 4, 5, 6])));
	return A2(
		$elm$html$Html$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('weekDayNames bodySmall')
					]),
				weekDayNames)
			]));
};
var $author$project$TimetablePage$Calendar$View$createDay = F4(
	function (monthNumber, selectedDate, firstPossibleDate, day) {
		var isPreviousWeek = A4(
			$justinmimbs$time_extra$Time$Extra$diff,
			11,
			$elm$time$Time$utc,
			A3($justinmimbs$time_extra$Time$Extra$floor, 4, $elm$time$Time$utc, firstPossibleDate),
			A3($justinmimbs$time_extra$Time$Extra$floor, 4, $elm$time$Time$utc, day)) < 0;
		var isPast = A2($author$project$Utils$Time$differenceInDays, firstPossibleDate, day) < 0;
		var isFromAnotherMonth = !_Utils_eq(
			$author$project$Utils$Time$monthToInt(
				A2($elm$time$Time$toMonth, $elm$time$Time$utc, day)),
			monthNumber);
		var isSelected = A2($author$project$Utils$Time$isSameDay, selectedDate, day) && (!isFromAnotherMonth);
		var isDisabled = (A2($author$project$Utils$Time$differenceInDays, firstPossibleDate, day) < 0) && (!isFromAnotherMonth);
		return {nn: day, mA: isDisabled, ky: isFromAnotherMonth, mD: isPast, nV: isPreviousWeek, lx: isSelected, sJ: selectedDate};
	});
var $author$project$TimetablePage$Calendar$View$generateAllWeeksInMonth = F3(
	function (firstOfMonth, firstPossibleDate, selectedDate) {
		var monthNumber = $author$project$Utils$Time$monthToInt(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, firstOfMonth));
		var firstOfNextMonth = A4($justinmimbs$time_extra$Time$Extra$add, 2, 1, $elm$time$Time$utc, firstOfMonth);
		var weeksInMonth = A5(
			$justinmimbs$time_extra$Time$Extra$range,
			11,
			1,
			$elm$time$Time$utc,
			A3($justinmimbs$time_extra$Time$Extra$floor, 4, $elm$time$Time$utc, firstOfMonth),
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 4, $elm$time$Time$utc, firstOfNextMonth));
		return A2(
			$elm_community$list_extra$List$Extra$groupsOf,
			7,
			A2(
				$elm$core$List$map,
				A3($author$project$TimetablePage$Calendar$View$createDay, monthNumber, selectedDate, firstPossibleDate),
				weeksInMonth));
	});
var $author$project$Utils$Time$Format$yearMonth = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	var _v1 = _Utils_Tuple2(language, market);
	if (_v1.a === 6) {
		var _v2 = _v1.a;
		return _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('年'),
				$ryan_haskell$date_format$DateFormat$monthNameFull
			]);
	} else {
		return _List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$monthNameFull,
				$ryan_haskell$date_format$DateFormat$text(' '),
				$ryan_haskell$date_format$DateFormat$yearNumber
			]);
	}
};
var $author$project$TimetablePage$Calendar$View$monthHeader = F2(
	function (locale, firstOfMonth) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('monthHeader title2')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$yearMonth, firstOfMonth))
				]));
	});
var $author$project$TimetablePage$Calendar$View$visualizeDay = function (day) {
	var dayNumber = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dayTopPart title2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							A2($elm$time$Time$toDay, $elm$time$Time$utc, day.nn)))
					]))
			]));
	return A2(
		$elm$html$Html$td,
		A3(
			$author$project$Utils$List$addIf,
			!(day.mD || (day.ky || (day.lx || day.mA))),
			$elm$html$Html$Events$onClick(day.nn),
			A3(
				$author$project$Utils$List$appendIf,
				day.lx,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'selected', ''),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'selected-day'),
						$elm$html$Html$Attributes$id($author$project$Constants$selectedDateId)
					]),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('day'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('blank', day.ky),
								_Utils_Tuple2('disabled', day.mA || day.mD),
								_Utils_Tuple2('active', day.lx)
							]))
					]))),
		_List_fromArray(
			[
				A2($author$project$Utils$String$renderIf, !day.ky, dayNumber)
			]));
};
var $author$project$TimetablePage$Calendar$View$visualizeWeek = function (daysOfWeek) {
	return _Utils_eq(
		A2(
			$elm_community$list_extra$List$Extra$find,
			function ($) {
				return $.nV;
			},
			daysOfWeek),
		$elm$core$Maybe$Nothing) ? A2($elm$core$List$map, $author$project$TimetablePage$Calendar$View$visualizeDay, daysOfWeek) : _List_Nil;
};
var $author$project$TimetablePage$Calendar$View$weekRow = function (daysInWeek) {
	var weekCells = $author$project$TimetablePage$Calendar$View$visualizeWeek(daysInWeek);
	return _List_fromArray(
		[
			A2(
			$author$project$Utils$String$renderIf,
			!$elm$core$List$isEmpty(weekCells),
			A2($elm$html$Html$tr, _List_Nil, weekCells))
		]);
};
var $author$project$TimetablePage$Calendar$View$month = F2(
	function (a, startOfMonthTime) {
		var weeksInMonth = A3($author$project$TimetablePage$Calendar$View$generateAllWeeksInMonth, startOfMonthTime, a.kS, a.Gg);
		var week = A2(
			$elm$html$Html$tbody,
			_List_Nil,
			A2($elm$core$List$concatMap, $author$project$TimetablePage$Calendar$View$weekRow, weeksInMonth));
		var isMonthWithSelection = _Utils_eq(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, a.Gg),
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, startOfMonthTime)) && _Utils_eq(
			A2($elm$time$Time$toYear, $elm$time$Time$utc, a.Gg),
			A2($elm$time$Time$toYear, $elm$time$Time$utc, startOfMonthTime));
		return _List_fromArray(
			[
				A2($author$project$TimetablePage$Calendar$View$monthHeader, a.n0, startOfMonthTime),
				A2(
				$elm$html$Html$table,
				isMonthWithSelection ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'data-scroll-to', '')
					]) : _List_Nil,
				_List_fromArray(
					[
						$author$project$TimetablePage$Calendar$View$dayOfWeekNames(a.n0),
						week
					]))
			]);
	});
var $author$project$TimetablePage$Calendar$View$view = function (a) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'view', 'calendar'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('hotelPackage', a.qD)
					]))
			]),
		A2(
			$elm$core$List$concatMap,
			$author$project$TimetablePage$Calendar$View$month(a),
			A2($author$project$TimetablePage$Calendar$View$generateMonthRange, a.kS, a.le)));
};
var $author$project$TimetablePage$View$cruiseMultiDepartureCalendarView = F2(
	function (session, model) {
		var defaultTime = function () {
			var _v0 = session.tp;
			_v0$2:
			while (true) {
				switch (_v0.$) {
					case 2:
						if ((!_v0.a.$) && (_v0.a.a.$ === 2)) {
							var cruiseMultiDeparture = _v0.a.a.a;
							return $author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture).rS.p3;
						} else {
							break _v0$2;
						}
					case 0:
						if (_v0.a.$ === 2) {
							var cruiseMultiDeparture = _v0.a.a;
							return $author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture).rS.p3;
						} else {
							break _v0$2;
						}
					default:
						break _v0$2;
				}
			}
			return session.kJ;
		}();
		return _List_fromArray(
			[
				$author$project$Types$Trips$isLoading(session.tp) ? $author$project$TimetablePage$View$loaderOverlay : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$map,
				$author$project$Messages$SelectedCruiseMultiDepartureTripDay,
				$author$project$TimetablePage$Calendar$View$view(
					{
						kS: session.kJ,
						qD: false,
						n0: A2($author$project$Types$Locale$Locale, session.A_, session.rb),
						Gg: A2($elm$core$Maybe$withDefault, defaultTime, model.oP),
						le: session.mI
					}))
			]);
	});
var $author$project$Types$MikiSail$isDayTrip = F2(
	function (outwardSail, returnSailMaybe) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					A3(
						$justinmimbs$time_extra$Time$Extra$diff,
						11,
						$elm$time$Time$utc,
						A3($justinmimbs$time_extra$Time$Extra$floor, 11, $elm$time$Time$utc, outwardSail.nr)),
					$elm$core$Basics$eq(0)),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.nr;
						},
						A2($justinmimbs$time_extra$Time$Extra$floor, 11, $elm$time$Time$utc)),
					returnSailMaybe)));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$TimetablePage$Cruise$Model$CalendarMonth = F3(
	function (month, year, dates) {
		return {yi: dates, s: month, h: year};
	});
var $author$project$TimetablePage$Cruise$Util$getDatesForMonthFlooredToTheBeginningOfTheWeek = function (startDate) {
	return A5(
		$justinmimbs$time_extra$Time$Extra$range,
		11,
		1,
		$elm$time$Time$utc,
		A3($justinmimbs$time_extra$Time$Extra$floor, 3, $elm$time$Time$utc, startDate),
		A3(
			$justinmimbs$time_extra$Time$Extra$ceiling,
			3,
			$elm$time$Time$utc,
			A3(
				$justinmimbs$time_extra$Time$Extra$ceiling,
				2,
				$elm$time$Time$utc,
				A4($justinmimbs$time_extra$Time$Extra$add, 15, 1, $elm$time$Time$utc, startDate))));
};
var $author$project$TimetablePage$Cruise$Util$getCalendarMonths = F2(
	function (initialDate, numberOfMonths) {
		var rangeStartDate = A3($justinmimbs$time_extra$Time$Extra$floor, 2, $elm$time$Time$utc, initialDate);
		var rangeEndDate = A3(
			$justinmimbs$time_extra$Time$Extra$floor,
			2,
			$elm$time$Time$utc,
			A4($justinmimbs$time_extra$Time$Extra$add, 2, numberOfMonths, $elm$time$Time$utc, rangeStartDate));
		return A2(
			$elm$core$List$map,
			function (date) {
				var monthStartDate = (A2($author$project$Utils$Time$differenceInDays, initialDate, date) < 0) ? initialDate : date;
				return A3(
					$author$project$TimetablePage$Cruise$Model$CalendarMonth,
					A2($elm$time$Time$toMonth, $elm$time$Time$utc, date),
					A2($elm$time$Time$toYear, $elm$time$Time$utc, date),
					$author$project$TimetablePage$Cruise$Util$getDatesForMonthFlooredToTheBeginningOfTheWeek(monthStartDate));
			},
			A5($justinmimbs$time_extra$Time$Extra$range, 2, 1, $elm$time$Time$utc, rangeStartDate, rangeEndDate));
	});
var $author$project$TimetablePage$Cruise$Util$getCurrentMonthCount = F2(
	function (sails, startDate) {
		var maybeLastSailDateFromSails = A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$Time$fromDateString,
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Dict$keys,
				A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$core$List$head),
				$author$project$Types$CruiseSails$all(sails)));
		return A2(
			$elm$core$Maybe$withDefault,
			2,
			A2(
				$elm$core$Maybe$map,
				A3($justinmimbs$time_extra$Time$Extra$diff, 2, $elm$time$Time$utc, startDate),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						A3($justinmimbs$time_extra$Time$Extra$add, 2, 1, $elm$time$Time$utc),
						A2($justinmimbs$time_extra$Time$Extra$ceiling, 2, $elm$time$Time$utc)),
					maybeLastSailDateFromSails)));
	});
var $author$project$Messages$ClickedLoadMoreSails = function (a) {
	return {$: 42, a: a};
};
var $author$project$TimetablePage$Cruise$View$loadMoreButton = F3(
	function (language, endDate, isLoading) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('loadMoreButton button outlineBigButtonFilled'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('loading', isLoading)
						])),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'load-more-button'),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$ClickedLoadMoreSails(endDate))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('loadMoreButtonText')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.vC;
								}))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					isLoading,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('spinner animateSpinner graySpinner'),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'load-more-spinner')
							]),
						_List_fromArray(
							[$author$project$Common$Images$lightPropeller])))
				]));
	});
var $author$project$Types$Currency$toShortSign = function (currency) {
	if (!currency) {
		return '€';
	} else {
		return ':-';
	}
};
var $author$project$TimetablePage$Cruise$View$datePriceText = F2(
	function (market, sail) {
		return function (_v0) {
			var personPrice = _v0.ov;
			return _Utils_ap(
				$elm$core$String$fromFloat(personPrice),
				$author$project$Types$Currency$toShortSign(
					$author$project$Types$Market$toCurrency(market)));
		}(sail);
	});
var $author$project$Messages$SelectedCruiseSail = function (a) {
	return {$: 46, a: a};
};
var $author$project$TimetablePage$Cruise$Util$dateToIsoString = function (date) {
	return $author$project$Utils$Time$toDateString(date);
};
var $author$project$TimetablePage$Cruise$View$getButtonProperties = F5(
	function (isSelected, isHidden, isDisabled, date, sail) {
		var isAvailableForSelect = (!isDisabled) && (!isHidden);
		return A3(
			$author$project$Utils$List$addIf,
			isAvailableForSelect && (!isSelected),
			$elm$html$Html$Events$onClick(
				$author$project$Messages$SelectedCruiseSail(
					_Utils_Tuple2(
						$author$project$TimetablePage$Cruise$Util$dateToIsoString(date),
						sail))),
			A3(
				$author$project$Utils$List$addIf,
				isAvailableForSelect,
				A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-date',
					$author$project$Utils$Time$toDateString(date)),
				A3(
					$author$project$Utils$List$addIf,
					sail.Au,
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'special-cruise'),
					A3(
						$author$project$Utils$List$addIf,
						isSelected && isAvailableForSelect,
						$elm$html$Html$Attributes$id($author$project$Constants$selectedDateId),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dateButtonWrapper'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('hasDiscount', sail.q0),
										_Utils_Tuple2('active', isSelected && isAvailableForSelect),
										_Utils_Tuple2('isSpecialCruise', sail.Au)
									])),
								$elm$html$Html$Attributes$disabled(isDisabled && (!isHidden))
							])))));
	});
var $author$project$TimetablePage$Cruise$View$dateButton = F9(
	function (language, sail, date, market, isSailExpired, maybeMinimumPrice, isSelected, isWithVehicle, areVehiclesSupported) {
		var soldOutVehicleBlock = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('soldOutVehicle')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/images/timetable/icon_soldout_vehicle.svg')
						]),
					_List_Nil)
				]));
		var priceBlock = A2(
			$author$project$Utils$String$renderIf,
			!isSailExpired,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('price bodySmallBold'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'lowest',
								A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										$elm$core$Basics$eq(sail.ov),
										maybeMinimumPrice)))
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$TimetablePage$Cruise$View$datePriceText, market, sail))
					])));
		var buttonProperties = A5($author$project$TimetablePage$Cruise$View$getButtonProperties, isSelected, false, isSailExpired, date, sail);
		return A2(
			$elm$html$Html$button,
			buttonProperties,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('calendarDate title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2($elm$time$Time$toDay, $elm$time$Time$utc, date)))
								])),
							(_Utils_eq(sail.pe, $elm$core$Maybe$Nothing) && (isWithVehicle && areVehiclesSupported)) ? soldOutVehicleBlock : ((sail.Au || sail.z6) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('specialCruise bodyExtraSmallBoldAndUppercase')
								]),
							$author$project$Translations$toHtml(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.vH;
									}))) : priceBlock),
							A2(
							$author$project$Utils$String$renderIf,
							sail.q0,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ribbon')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/assets/images/discountCode/ribbon_discount.svg')
											]),
										_List_Nil)
									])))
						]))
				]));
	});
var $author$project$Messages$SwitchToHotelPackageOnDate = function (a) {
	return {$: 47, a: a};
};
var $author$project$TimetablePage$Cruise$View$hotelTripButton = F3(
	function (language, date, hotelSail) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotelTrip'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-hotel-trip',
					$author$project$Utils$Time$toDateString(date)),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$SwitchToHotelPackageOnDate(hotelSail.nr))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('calendarDate title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2($elm$time$Time$toDay, $elm$time$Time$utc, date)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tripWithHotel bodyExtraSmallBoldAndUppercase')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('label')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Translations$t,
												language,
												function ($) {
													return $.HH;
												}))
										]))
								]))
						]))
				]));
	});
var $author$project$Utils$Route$isTurKapCruise = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) && ((from === 5) && (to === 13));
};
var $author$project$TimetablePage$Cruise$View$calendarDate = F5(
	function (session, model, month, minimumPrice, date) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$CruiseSail$Disabled,
			A2(
				$elm$core$Dict$get,
				$author$project$TimetablePage$Cruise$Util$dateToIsoString(date),
				$author$project$Types$CruiseSails$all(model.F6)));
		switch (_v0.$) {
			case 0:
				var sail = _v0.a;
				var isSelected = _Utils_eq(
					$author$project$TimetablePage$Cruise$Util$dateToIsoString(date),
					$author$project$Types$CruiseSails$selected(model.F6).a);
				var isSailExpired = !A2($author$project$TimetablePage$Cruise$Util$isDayNotExpired, model.lT, sail.rS.nr);
				return _Utils_eq(
					month,
					A2($elm$time$Time$toMonth, $elm$time$Time$utc, date)) ? A2(
					$elm$html$Html$div,
					(isSelected && (!isSailExpired)) ? _List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected'),
							A2($elm$html$Html$Attributes$attribute, 'data-sail', 'selected')
						]) : _List_Nil,
					_List_fromArray(
						[
							A9(
							$author$project$TimetablePage$Cruise$View$dateButton,
							session.A_,
							sail,
							date,
							session.rb,
							isSailExpired,
							minimumPrice,
							isSelected,
							A3($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty, session.yq),
							model.m9 && (!$author$project$Utils$Route$isTurKapCruise(session)))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('blank title2')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Utils$String$renderIf,
							_Utils_eq(
								month,
								A2($elm$time$Time$toMonth, $elm$time$Time$utc, date)),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('calendarDate')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											A2($elm$time$Time$toDay, $elm$time$Time$utc, date)))
									])))
						]));
			case 3:
				var hotelSail = _v0.a;
				return _Utils_eq(
					month,
					A2($elm$time$Time$toMonth, $elm$time$Time$utc, date)) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$TimetablePage$Cruise$View$hotelTripButton, session.A_, date, hotelSail)
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('blank title2')
						]),
					_List_Nil);
			default:
				var status = _v0;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('blank title2')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Utils$String$renderIf,
							_Utils_eq(
								month,
								A2($elm$time$Time$toMonth, $elm$time$Time$utc, date)),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('calendarDate')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											A2($elm$time$Time$toDay, $elm$time$Time$utc, date)))
									]))),
							A2(
							$author$project$Utils$String$renderIf,
							_Utils_eq(status, $author$project$Types$CruiseSail$SoldOut),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('price bodySmallBold soldOut')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src('/assets/images/common/sold_out.svg')
											]),
										_List_Nil)
									])))
						]));
		}
	});
var $author$project$TimetablePage$Cruise$Util$getSmallestNumber = F2(
	function (maybeA, b) {
		return A2(
			$elm$core$Maybe$withDefault,
			b,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$min(b),
				maybeA));
	});
var $author$project$TimetablePage$Cruise$Util$yearAndMonthString = function (_v0) {
	var year = _v0.h;
	var month = _v0.s;
	return $elm$core$String$fromInt(year) + ('-' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$Utils$Time$monthToInt(month))));
};
var $author$project$TimetablePage$Cruise$Util$findMinimumPersonPrice = F2(
	function (sails, calendarMonthToProcess) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (sail, maybeCurrentSmallestPrice) {
					return $elm$core$Maybe$Just(
						A2($author$project$TimetablePage$Cruise$Util$getSmallestNumber, maybeCurrentSmallestPrice, sail.ov));
				}),
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.Au;
					}),
				A2(
					$elm$core$List$filterMap,
					function (sail) {
						if (!sail.$) {
							var a = sail.a;
							return $elm$core$Maybe$Just(a);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					$elm$core$Dict$values(
						A2(
							$elm$core$Dict$filter,
							F2(
								function (key, _v0) {
									return A2(
										$elm$core$String$contains,
										$author$project$TimetablePage$Cruise$Util$yearAndMonthString(calendarMonthToProcess),
										key);
								}),
							$author$project$Types$CruiseSails$all(sails))))));
	});
var $author$project$Types$CruiseSails$isTimeInMonthAndYear = F2(
	function (_v0, time) {
		var month = _v0.s;
		var year = _v0.h;
		return _Utils_eq(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time),
			month) && _Utils_eq(
			A2($elm$time$Time$toYear, $elm$time$Time$utc, time),
			year);
	});
var $author$project$Types$CruiseSail$toMaybe = function (cruiseSail) {
	if (!cruiseSail.$) {
		var sail = cruiseSail.a;
		return $elm$core$Maybe$Just(sail);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$CruiseSails$isAnyAvailableInMonthAndYear = F2(
	function (monthAndYear, sails) {
		return A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rS;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.nr;
					},
					$author$project$Types$CruiseSails$isTimeInMonthAndYear(monthAndYear))),
			A2(
				$elm$core$List$filterMap,
				$author$project$Types$CruiseSail$toMaybe,
				$elm$core$Dict$values(
					$author$project$Types$CruiseSails$all(sails))));
	});
var $author$project$TimetablePage$Cruise$View$isStoHndCruise = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return (from === 1) && ((to === 15) && _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise));
};
var $author$project$TimetablePage$Cruise$View$isStoVisCruise = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	return (from === 1) && ((to === 6) && _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise));
};
var $author$project$TimetablePage$Common$noDeparturesToast = function (_v0) {
	var language = _v0.A_;
	var from = _v0.kS;
	var to = _v0.le;
	return ((from === 5) && (to === 1)) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toast bodyNorm informationToast priceNormal'),
				$elm$html$Html$Events$onClick(
				$author$project$Messages$ChangedVoyage(
					{
						kS: 5,
						Cd: $elm$core$Maybe$Just($author$project$Types$VoyageType$Cruise),
						le: 13
					}))
			]),
		$author$project$Translations$toHtml(
			A2(
				$author$project$Translations$t,
				language,
				function ($) {
					return $.vG;
				}))) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toast bodyNorm informationToast priceNormal')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$author$project$Translations$t,
					language,
					function ($) {
						return $.vF;
					}))
			]));
};
var $author$project$Utils$List$toGroupsOf = F3(
	function (groupedList, groupLength, list) {
		toGroupsOf:
		while (true) {
			if (_Utils_cmp(
				$elm$core$List$length(list),
				groupLength) < 1) {
				return _Utils_ap(
					groupedList,
					_List_fromArray(
						[list]));
			} else {
				var $temp$groupedList = _Utils_ap(
					groupedList,
					_List_fromArray(
						[
							A2($elm$core$List$take, groupLength, list)
						])),
					$temp$groupLength = groupLength,
					$temp$list = A2($elm$core$List$drop, groupLength, list);
				groupedList = $temp$groupedList;
				groupLength = $temp$groupLength;
				list = $temp$list;
				continue toGroupsOf;
			}
		}
	});
var $author$project$TimetablePage$MarketingMessage$View$view = function (_v0) {
	var name = _v0.oh;
	var imageUrl = _v0.zP;
	var description = _v0.nt;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('marketingMessage'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'marketing-message')
			]),
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (title) {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title1Medium title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									]))
							]);
					},
					name)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (url) {
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(url)
												]),
											_List_Nil)
										]);
								},
								imageUrl)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('bodyNorm')
									]),
								$author$project$Translations$toHtml(description))
							])))
				])));
};
var $author$project$TimetablePage$Cruise$View$weekDayNames = function (language) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('weekDayNames')
			]),
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Utils$Time$Translations$fromLanguage(language).HM,
				A2(
					$elm$core$Basics$composeR,
					$elm$html$Html$text,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$elm$html$Html$div(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('weekDayName bodySmall')
								]))))),
			_List_fromArray(
				[0, 1, 2, 3, 4, 5, 6])));
};
var $author$project$TimetablePage$Cruise$View$monthContent = F3(
	function (session, viewModel, calendarMonth) {
		var language = session.A_;
		var selectedSail = $author$project$Types$CruiseSails$selected(viewModel.F6);
		var minimumPrice = A2($author$project$TimetablePage$Cruise$Util$findMinimumPersonPrice, viewModel.F6, calendarMonth);
		var maybeSelectedDate = $author$project$Utils$Time$fromDateString(selectedSail.a);
		var isMarketingMessageSupported = (!$author$project$TimetablePage$Cruise$View$isStoVisCruise(session)) && (!$author$project$TimetablePage$Cruise$View$isStoHndCruise(session));
		var isAnySailAvailable = A2(
			$author$project$Types$CruiseSails$isAnyAvailableInMonthAndYear,
			{s: calendarMonth.s, h: calendarMonth.h},
			viewModel.F6);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('calendar'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hasNoSails', !isAnySailAvailable)
						]))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$TimetablePage$Cruise$View$weekDayNames(session.A_)
						]),
						_List_fromArray(
						[
							(!isAnySailAvailable) ? $author$project$TimetablePage$Common$noDeparturesToast(session) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dateTable')
								]),
							A3(
								$elm$core$List$foldl,
								F2(
									function (weekList, accumulator) {
										var isCurrentlySelectedWeek = A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												function (selectedDate) {
													return A2($elm$core$List$member, selectedDate, weekList) && _Utils_eq(
														calendarMonth.s,
														A2($elm$time$Time$toMonth, $elm$time$Time$utc, selectedDate));
												},
												maybeSelectedDate));
										return A3(
											$author$project$Utils$List$appendIf,
											isCurrentlySelectedWeek && isMarketingMessageSupported,
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												A2(
													$elm$core$Maybe$map,
													A2($elm$core$Basics$composeR, $author$project$TimetablePage$MarketingMessage$View$view, $elm$core$List$singleton),
													selectedSail.b.rc)),
											_Utils_ap(
												accumulator,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('row')
															]),
														A2(
															$elm$core$List$map,
															A4($author$project$TimetablePage$Cruise$View$calendarDate, session, viewModel, calendarMonth.s, minimumPrice),
															weekList))
													])));
									}),
								_List_Nil,
								A3($author$project$Utils$List$toGroupsOf, _List_Nil, 7, calendarMonth.yi)))
						])
					])));
	});
var $author$project$TimetablePage$Cruise$Util$findMinimumVehiclePrice = F2(
	function (sails, calendarToProcess) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (_v1, sail, maybeCurrentSmallestPrice) {
					if (!sail.$) {
						var vehiclePrice = sail.a.pe;
						return A2(
							$elm$core$Maybe$map,
							$author$project$TimetablePage$Cruise$Util$getSmallestNumber(maybeCurrentSmallestPrice),
							vehiclePrice);
					} else {
						return maybeCurrentSmallestPrice;
					}
				}),
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v0) {
						return A2(
							$elm$core$String$contains,
							$author$project$TimetablePage$Cruise$Util$yearAndMonthString(calendarToProcess),
							key);
					}),
				$author$project$Types$CruiseSails$all(sails)));
	});
var $author$project$TimetablePage$Cruise$View$lowestPriceText = F3(
	function (priceText, market, minimumPrice) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('price bodySmall')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Translations$injectValues,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'price',
								A2($author$project$Types$Market$formatPriceWithSign, market, minimumPrice))
							]),
						priceText))
				]));
	});
var $author$project$Common$VehicleToggle$View$Addable = 0;
var $author$project$Common$VehicleToggle$View$Blocked = 2;
var $author$project$Common$VehicleToggle$View$Loading = 3;
var $author$project$Common$VehicleToggle$View$Removable = 1;
var $author$project$Common$VehicleToggle$View$vehicleToggleViewState = function (session) {
	var desiredVehicles = session.yq;
	var isLoadingVehicles = session.Ag;
	var from = session.kS;
	var vehicles = session.tt;
	var isWithVehicles = A3($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty, desiredVehicles);
	var canVehicleBeToggled = $author$project$Types$SelectedVehicles$canVehicleBeToggled(desiredVehicles);
	return $author$project$Utils$Route$isVehicleRequired(session) ? 2 : (isWithVehicles ? (isLoadingVehicles ? 3 : (canVehicleBeToggled ? 1 : 2)) : 0);
};
var $author$project$Common$Images$Vehicles$addVehicle = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/vehicle_add_car.svg')
		]),
	_List_Nil);
var $author$project$Common$Images$Vehicles$notClickableVehicle = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/icon_vehicle_plain.svg')
		]),
	_List_Nil);
var $author$project$Common$Images$Vehicles$removeVehicle = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$src('/assets/images/_cacheCommon/icon_remove_vehicle.svg')
		]),
	_List_Nil);
var $author$project$Common$VehicleToggle$View$view = F2(
	function (msg, state) {
		var dataTestIsToggled = A2(
			$elm$core$Basics$composeL,
			$elm$html$Html$Attributes$attribute('data-test-is-toggled'),
			$author$project$Utils$String$fromBool);
		var attributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('vehicleToggle'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'vehicle-toggle')
			]);
		switch (state) {
			case 0:
				return A2(
					$elm$html$Html$button,
					_Utils_ap(
						attributes,
						_List_fromArray(
							[
								dataTestIsToggled(false),
								$elm$html$Html$Events$onClick(msg)
							])),
					_List_fromArray(
						[$author$project$Common$Images$Vehicles$addVehicle]));
			case 1:
				return A2(
					$elm$html$Html$button,
					_Utils_ap(
						attributes,
						_List_fromArray(
							[
								dataTestIsToggled(true),
								$elm$html$Html$Events$onClick(msg)
							])),
					_List_fromArray(
						[$author$project$Common$Images$Vehicles$removeVehicle]));
			case 2:
				return A2(
					$elm$html$Html$button,
					_Utils_ap(
						attributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(true)
							])),
					_List_fromArray(
						[$author$project$Common$Images$Vehicles$notClickableVehicle]));
			default:
				return A2(
					$elm$html$Html$button,
					_Utils_ap(
						attributes,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('loading'),
								$elm$html$Html$Attributes$disabled(true)
							])),
					_List_fromArray(
						[$author$project$Common$Images$Vehicles$removeVehicle]));
		}
	});
var $author$project$TimetablePage$Cruise$View$monthHeaderToggles = F2(
	function (session, calendarModel) {
		var language = session.A_;
		var _v0 = calendarModel;
		var areVehiclesSupported = _v0.m9;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('monthHeaderToggles')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Utils$String$renderIf,
					areVehiclesSupported && (!$author$project$Utils$Route$isTurKapCruise(session)),
					A2(
						$author$project$Common$VehicleToggle$View$view,
						$author$project$Messages$ToggledVehicles,
						$author$project$Common$VehicleToggle$View$vehicleToggleViewState(session)))
				]));
	});
var $author$project$TimetablePage$Cruise$View$monthHeader = F3(
	function (session, model, calendarMonth) {
		var language = session.A_;
		var translations = $author$project$Translations$forLanguage(language);
		var monthBeginTime = A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			$elm$time$Time$utc,
			A7($justinmimbs$time_extra$Time$Extra$Parts, calendarMonth.h, calendarMonth.s, 1, 0, 0, 0, 0));
		var minimumVehiclePrice = A2($author$project$TimetablePage$Cruise$Util$findMinimumVehiclePrice, model.F6, calendarMonth);
		var minimumPersonPrice = A2($author$project$TimetablePage$Cruise$Util$findMinimumPersonPrice, model.F6, calendarMonth);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title title1Bold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3(
										$author$project$Utils$Time$Format$format,
										A2($author$project$Types$Locale$Locale, session.A_, session.rb),
										$author$project$Utils$Time$Format$yearMonth,
										monthBeginTime))
								])),
							A2(
							$author$project$Utils$Html$Render$maybeRender,
							A2($author$project$TimetablePage$Cruise$View$lowestPriceText, translations.vE, session.rb),
							minimumPersonPrice),
							A2(
							$author$project$Utils$Html$Render$maybeRender,
							A2($author$project$TimetablePage$Cruise$View$lowestPriceText, translations.vI, session.rb),
							minimumVehiclePrice)
						])),
					A2($author$project$TimetablePage$Cruise$View$monthHeaderToggles, session, model)
				]));
	});
var $author$project$TimetablePage$Cruise$View$monthView = F3(
	function (session, viewModel, calendarMonth) {
		var isMonthWithSelection = function (date) {
			return _Utils_eq(
				A2($elm$time$Time$toMonth, $elm$time$Time$utc, date),
				calendarMonth.s) && _Utils_eq(
				A2($elm$time$Time$toYear, $elm$time$Time$utc, date),
				calendarMonth.h);
		}(
			A3(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$second,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.rS;
					},
					function ($) {
						return $.nr;
					}),
				$author$project$Types$CruiseSails$selected(viewModel.F6)));
		return A2(
			$elm$html$Html$div,
			A3(
				$author$project$Utils$List$addIf,
				isMonthWithSelection,
				A2($elm$html$Html$Attributes$attribute, 'data-scroll-to', ''),
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('monthWrapper'),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'month')
					])),
			_List_fromArray(
				[
					A3($author$project$TimetablePage$Cruise$View$monthHeader, session, viewModel, calendarMonth),
					A3($author$project$TimetablePage$Cruise$View$monthContent, session, viewModel, calendarMonth)
				]));
	});
var $author$project$TimetablePage$Cruise$View$calendar = F2(
	function (session, viewModel) {
		var language = session.A_;
		var currentMonthCount = A2($author$project$TimetablePage$Cruise$Util$getCurrentMonthCount, viewModel.F6, viewModel.lT);
		var endDate = A3(
			$justinmimbs$time_extra$Time$Extra$floor,
			2,
			$elm$time$Time$utc,
			A4($justinmimbs$time_extra$Time$Extra$add, 2, currentMonthCount, $elm$time$Time$utc, viewModel.lT));
		var calendarMonths = A2($author$project$TimetablePage$Cruise$Util$getCalendarMonths, viewModel.lT, currentMonthCount);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cruiseCalendarHolder'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'calendar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('priceIncludesSurcharges bodySmall')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.Fj;
								}))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cruiseMonthsHolder')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$TimetablePage$Cruise$View$monthView, session, viewModel),
						calendarMonths)),
					A2(
					$author$project$Utils$String$renderIf,
					A2($author$project$Utils$Time$differenceInDays, endDate, viewModel.qd) > 0,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('loadMoreButtonHolder')
							]),
						_List_fromArray(
							[
								A3($author$project$TimetablePage$Cruise$View$loadMoreButton, language, endDate, viewModel.qS)
							])))
				]));
	});
var $author$project$TimetablePage$Cruise$View$CruiseCalendarViewModel = F7(
	function (sails, cruiseTripType, endOfSaleDate, isLoading, startDate, voyageType, areVehiclesSupported) {
		return {m9: areVehiclesSupported, mm: cruiseTripType, qd: endOfSaleDate, qS: isLoading, F6: sails, lT: startDate, tx: voyageType};
	});
var $author$project$TimetablePage$Cruise$View$createCruiseCalendarViewModel = F2(
	function (session, sails) {
		return A7(
			$author$project$TimetablePage$Cruise$View$CruiseCalendarViewModel,
			sails,
			session.mm,
			session.mI,
			session.Ad,
			session.kJ,
			session.tx,
			$author$project$Utils$Route$areVehiclesSupported(session));
	});
var $author$project$Messages$ChangedCruiseTripType = function (a) {
	return {$: 43, a: a};
};
var $author$project$Common$Images$DepartureType$afternoon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('departureTypeSvg'),
			$elm$svg$Svg$Attributes$viewBox('0 0 8 11')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 7.899568,9.062937 C 7.742106,9.028957 7.584972,8.987647 7.432865,8.939786 5.854204,8.444891 4.633739,7.268135 4.084098,5.711438 3.534348,4.154632 3.745353,2.472381 4.663242,1.095984 4.751972,0.9628898 4.848132,0.8320906 4.949209,0.7070828 4.980239,0.6687278 4.986249,0.6159498 4.964839,0.5715848 4.943199,0.5273298 4.898069,0.4993558 4.848791,0.5000118 4.31565,0.5070018 3.787973,0.6014167 3.280293,0.7806237 0.723752,1.683325 -0.62183,4.49764 0.280871,7.054179 c 0.9027,2.55665 3.717124,3.902233 6.273774,2.999532 0.507571,-0.179207 0.977443,-0.436981 1.396831,-0.766438 0.03868,-0.03038 0.05639,-0.08053 0.04524,-0.128614 -0.01115,-0.04808 -0.04895,-0.08534 -0.09714,-0.09572 z')
				]),
			_List_Nil)
		]));
var $author$project$Common$Images$DepartureType$morning = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('departureTypeSvg'),
			$elm$svg$Svg$Attributes$viewBox('0 0 12 12')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 9.857143,5.993304 C 9.857143,5.47098 9.755581,4.972101 9.552455,4.496652 9.349329,4.021203 9.074778,3.610493 8.728795,3.264509 8.382811,2.918525 7.972101,2.643974 7.496652,2.440848 7.021203,2.237722 6.522324,2.136161 6,2.136161 5.477676,2.136161 4.978797,2.237722 4.503348,2.440848 4.027899,2.643974 3.617189,2.918525 3.271205,3.264509 2.925221,3.610493 2.650671,4.021203 2.447545,4.496652 2.244419,4.972101 2.142857,5.47098 2.142857,5.993304 c 0,0.522324 0.101562,1.021203 0.304688,1.496651 0.203126,0.475449 0.477676,0.886159 0.82366,1.232143 C 3.617189,9.068082 4.027899,9.342633 4.503348,9.545759 4.978797,9.748885 5.477676,9.850446 6,9.850446 c 0.522324,0 1.021203,-0.101561 1.496652,-0.304687 C 7.972101,9.342633 8.382811,9.068082 8.728795,8.722098 9.074778,8.376114 9.349329,7.965404 9.552455,7.489955 9.755581,7.014507 9.857143,6.515628 9.857143,5.993304 Z m 1.848214,1.85491 c -0.01786,0.06696 -0.0625,0.111607 -0.133928,0.133929 L 9.616071,8.625 v 2.049107 c 0,0.07143 -0.02902,0.129464 -0.08705,0.174107 -0.06696,0.04464 -0.131696,0.05357 -0.194197,0.02679 L 7.379467,10.24554 6.17411,11.906254 c -0.04464,0.05804 -0.102678,0.08705 -0.174107,0.08705 -0.07143,0 -0.129464,-0.02902 -0.174107,-0.08705 L 4.620536,10.245536 2.665179,10.875 c -0.0625,0.02679 -0.127232,0.01786 -0.194197,-0.02679 -0.05804,-0.04464 -0.08705,-0.102678 -0.08705,-0.174107 V 8.625 L 0.428574,7.982143 C 0.357144,7.959823 0.312503,7.915183 0.294646,7.848214 0.272326,7.772324 0.281256,7.70759 0.321436,7.654018 L 1.526793,5.993304 0.321436,4.332589 C 0.281256,4.274549 0.272326,4.209822 0.294646,4.138393 0.312506,4.071423 0.357146,4.026786 0.428574,4.004464 L 2.383932,3.361607 V 1.3125 c 0,-0.071429 0.02902,-0.1294641 0.08705,-0.1741071 0.06696,-0.044643 0.131696,-0.053572 0.194197,-0.026786 L 4.620536,1.7410712 5.825893,0.0803569 C 5.866072,0.0267855 5.924107,0 6,0 6.07589,0 6.133928,0.026786 6.174107,0.080357 L 7.379464,1.7410713 9.334821,1.111607 c 0.0625,-0.026786 0.127232,-0.017857 0.194197,0.026786 0.05804,0.044643 0.08705,0.1026782 0.08705,0.1741071 V 3.361607 l 1.955358,0.642857 c 0.07143,0.02232 0.116071,0.06696 0.133928,0.133929 0.02232,0.07143 0.01339,0.13616 -0.02679,0.194196 l -1.205357,1.660715 1.205357,1.660714 c 0.04018,0.05357 0.04911,0.118303 0.02679,0.194196 z')
				]),
			_List_Nil)
		]));
var $author$project$TimetablePage$Cruise$View$departureTypeSliderToggle = function (_v0) {
	var language = _v0.A_;
	var cruiseTripType = _v0.mm;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sliderToggle')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodySmallBold'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', !cruiseTripType)
							])),
						$elm$html$Html$Attributes$disabled(!cruiseTripType),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$ChangedCruiseTripType(0))
					]),
				_List_fromArray(
					[
						$author$project$Common$Images$DepartureType$morning,
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.Hz;
									}))
							]))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodySmallBold'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', cruiseTripType === 1)
							])),
						$elm$html$Html$Attributes$disabled(cruiseTripType === 1),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$ChangedCruiseTripType(1))
					]),
				_List_fromArray(
					[
						$author$project$Common$Images$DepartureType$afternoon,
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.Hy;
									}))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('slider'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('end', cruiseTripType === 1)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$TimetablePage$Common$loadingView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('loadingSpinner')
		]),
	_List_fromArray(
		[
			$author$project$Common$Images$darkPropellerWithClassName('spinner animateSpinner')
		]));
var $author$project$TimetablePage$Cruise$View$overnightSliderToggle = function (_v0) {
	var language = _v0.A_;
	var cruiseTripType = _v0.mm;
	var isOvernightAtDestination = cruiseTripType === 2;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sliderToggle')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodySmallBold'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', !isOvernightAtDestination)
							])),
						$elm$html$Html$Attributes$disabled(!isOvernightAtDestination),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$ChangedCruiseTripType(1))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.Dk;
							}))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodySmallBold'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('selected', isOvernightAtDestination)
							])),
						$elm$html$Html$Attributes$disabled(isOvernightAtDestination),
						$elm$html$Html$Events$onClick(
						$author$project$Messages$ChangedCruiseTripType(2))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.H3;
							}))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('slider'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('end', isOvernightAtDestination)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$TimetablePage$Cruise$View$root = function (session) {
	var language = session.A_;
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cruise')
			]),
		_List_fromArray(
			[
				$author$project$Utils$Route$areMorningAndEveningCruisesAvailable(session) ? $author$project$TimetablePage$Cruise$View$departureTypeSliderToggle(session) : ($author$project$Utils$Route$isOvernightCruiseAvailable(session) ? $author$project$TimetablePage$Cruise$View$overnightSliderToggle(session) : $elm$html$Html$text('')),
				function () {
				var _v0 = session.tp;
				switch (_v0.$) {
					case 2:
						return $author$project$TimetablePage$Common$loadingView;
					case 1:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('marginHorizontalSmall marginTopSmall')
								]),
							_List_fromArray(
								[
									$author$project$TimetablePage$Common$noDeparturesToast(session)
								]));
					default:
						if (!_v0.a.$) {
							var cruise = _v0.a.a;
							return A2(
								$author$project$TimetablePage$Cruise$View$calendar,
								session,
								A2($author$project$TimetablePage$Cruise$View$createCruiseCalendarViewModel, session, cruise));
						} else {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('marginHorizontalSmall marginTopSmall')
									]),
								_List_fromArray(
									[
										$author$project$TimetablePage$Common$noDeparturesToast(session)
									]));
						}
				}
			}()
			]));
};
var $author$project$TimetablePage$Header$View$getPortsString = F2(
	function (from, to) {
		return _Utils_ap(
			$elm$core$String$toLower(
				$author$project$Types$Port$toString(from)),
			$author$project$Utils$String$capitalizeFirstLetters(
				$author$project$Types$Port$toString(to)));
	});
var $author$project$TimetablePage$Header$View$getTripTypeExtensionString = F5(
	function (voyageType, from, to, isDayTrip, cruiseTripType) {
		var isTurStoOrStoTur = ((from === 1) && (to === 5)) || ((from === 5) && (to === 1));
		var isHelTalOrTalHel = ((from === 2) && (!to)) || ((from === 2) && (!to));
		var isCruise = $author$project$Utils$Route$isCruiseOrCruiseMultiship(voyageType);
		if ($author$project$Utils$Route$isShoppingCruise(voyageType)) {
			return 'shoppingCruise';
		} else {
			if (isDayTrip && ((!isCruise) && isHelTalOrTalHel)) {
				return 'dayTrip';
			} else {
				if (isCruise && isTurStoOrStoTur) {
					switch (cruiseTripType) {
						case 1:
							return 'cruise23evening';
						case 0:
							return 'cruise23morning';
						default:
							return '';
					}
				} else {
					return '';
				}
			}
		}
	});
var $author$project$TimetablePage$Header$View$getTripTypeString = function (voyageType) {
	return $author$project$Utils$Route$isCruiseOrCruiseMultiship(voyageType) ? 'cruise' : 'routeTrip';
};
var $author$project$TimetablePage$Header$View$getTripKey = F6(
	function (voyageType, from, to, isDayTrip, cruiseTripType, delimiter) {
		var tripTypeExtensionString = A5($author$project$TimetablePage$Header$View$getTripTypeExtensionString, voyageType, from, to, isDayTrip, cruiseTripType);
		return $elm$core$String$concat(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$TimetablePage$Header$View$getTripTypeString(voyageType),
						delimiter,
						A2($author$project$TimetablePage$Header$View$getPortsString, from, to)
					]),
				(!$elm$core$String$isEmpty(tripTypeExtensionString)) ? _List_fromArray(
					[delimiter, tripTypeExtensionString]) : _List_Nil));
	});
var $author$project$TimetablePage$Header$View$hasVoyageTypeSelector = function (_v0) {
	var bookingType = _v0.vk;
	var from = _v0.kS;
	var to = _v0.le;
	return 2 <= $elm$core$List$length(
		function () {
			if (!bookingType) {
				return A2($author$project$Utils$Route$getRegularVoyageTypeList, from, to);
			} else {
				return A2($author$project$Utils$Route$getHotelPackageVoyageTypeList, from, to);
			}
		}());
};
var $author$project$TimetablePage$Header$Messages$ToggleShowDescription = 0;
var $author$project$Utils$Route$translateShortTripDescription = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var voyageType = _v0.tx;
	var cruiseTripType = _v0.mm;
	var _v1 = _Utils_Tuple3(from, to, voyageType);
	_v1$60:
	while (true) {
		_v1$62:
		while (true) {
			switch (_v1.c.$) {
				case 4:
					if (_v1.b === 3) {
						switch (_v1.a) {
							case 1:
								var _v21 = _v1.a;
								var _v22 = _v1.b;
								var _v23 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.ip;
									});
							case 5:
								var _v82 = _v1.a;
								var _v83 = _v1.b;
								var _v84 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.iv;
									});
							default:
								break _v1$62;
						}
					} else {
						break _v1$62;
					}
				case 6:
					if (_v1.c.a === 1) {
						var _v116 = _v1.c.a;
						return A2(
							$elm$core$Basics$composeL,
							$elm$core$Maybe$Just,
							function ($) {
								return $.fO;
							});
					} else {
						if ((!_v1.a) && (_v1.b === 2)) {
							var _v117 = _v1.a;
							var _v118 = _v1.b;
							var _v119 = _v1.c.a;
							return A2(
								$elm$core$Basics$composeL,
								$elm$core$Maybe$Just,
								function ($) {
									return $.io;
								});
						} else {
							break _v1$62;
						}
					}
				case 5:
					if ((_v1.a === 1) && (_v1.b === 16)) {
						var _v132 = _v1.a;
						var _v133 = _v1.b;
						var _v134 = _v1.c;
						return A2(
							$elm$core$Basics$composeL,
							$elm$core$Maybe$Just,
							function ($) {
								return $.fW;
							});
					} else {
						break _v1$62;
					}
				case 2:
					switch (_v1.a) {
						case 2:
							if (!_v1.b) {
								var _v113 = _v1.a;
								var _v114 = _v1.b;
								var _v115 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.iH;
									});
							} else {
								break _v1$62;
							}
						case 8:
							if (_v1.b === 7) {
								var _v120 = _v1.a;
								var _v121 = _v1.b;
								var _v122 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.iM;
									});
							} else {
								break _v1$62;
							}
						case 0:
							if (_v1.b === 2) {
								var _v147 = _v1.a;
								var _v148 = _v1.b;
								var _v149 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.iV;
									});
							} else {
								break _v1$62;
							}
						case 7:
							if (_v1.b === 8) {
								var _v159 = _v1.a;
								var _v160 = _v1.b;
								var _v161 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.i$;
									});
							} else {
								break _v1$62;
							}
						default:
							break _v1$62;
					}
				case 0:
					switch (_v1.a) {
						case 5:
							switch (_v1.b) {
								case 1:
									var _v46 = _v1.a;
									var _v47 = _v1.b;
									var _v48 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ix;
										});
								case 13:
									var _v49 = _v1.a;
									var _v50 = _v1.b;
									var _v51 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iw;
										});
								case 0:
									var _v73 = _v1.a;
									var _v74 = _v1.b;
									var _v75 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.i1;
										});
								default:
									break _v1$62;
							}
						case 2:
							switch (_v1.b) {
								case 1:
									var _v2 = _v1.a;
									var _v3 = _v1.b;
									var _v4 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ja;
										});
								case 0:
									var _v5 = _v1.a;
									var _v6 = _v1.b;
									var _v7 = _v1.c;
									if (!cruiseTripType) {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.dU;
											});
									} else {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.dT;
											});
									}
								case 14:
									var _v9 = _v1.a;
									var _v10 = _v1.b;
									var _v11 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.i9;
										});
								case 3:
									var _v12 = _v1.a;
									var _v13 = _v1.b;
									var _v14 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.im;
										});
								case 6:
									var _v15 = _v1.a;
									var _v16 = _v1.b;
									var _v17 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.dW;
										});
								case 4:
									var _v89 = _v1.a;
									var _v90 = _v1.b;
									var _v91 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.dS;
										});
								default:
									break _v1$62;
							}
						case 0:
							switch (_v1.b) {
								case 4:
									var _v30 = _v1.a;
									var _v31 = _v1.b;
									var _v32 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.f_;
										});
								case 1:
									var _v64 = _v1.a;
									var _v65 = _v1.b;
									var _v66 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ja;
										});
								case 5:
									var _v67 = _v1.a;
									var _v68 = _v1.b;
									var _v69 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.f$;
										});
								case 6:
									var _v70 = _v1.a;
									var _v71 = _v1.b;
									var _v72 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.f2;
										});
								case 3:
									var _v92 = _v1.a;
									var _v93 = _v1.b;
									var _v94 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.i5;
										});
								default:
									break _v1$62;
							}
						case 4:
							switch (_v1.b) {
								case 1:
									var _v18 = _v1.a;
									var _v19 = _v1.b;
									var _v20 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ja;
										});
								case 2:
									var _v85 = _v1.a;
									var _v86 = _v1.b;
									var _v87 = _v1.c;
									if (cruiseTripType === 2) {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.i4;
											});
									} else {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.i7;
											});
									}
								case 3:
									var _v162 = _v1.a;
									var _v163 = _v1.b;
									var _v164 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.i5;
										});
								default:
									break _v1$62;
							}
						case 1:
							switch (_v1.b) {
								case 2:
									var _v24 = _v1.a;
									var _v25 = _v1.b;
									var _v26 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iq;
										});
								case 4:
									var _v27 = _v1.a;
									var _v28 = _v1.b;
									var _v29 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ir;
										});
								case 3:
									var _v33 = _v1.a;
									var _v34 = _v1.b;
									var _v35 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ip;
										});
								case 0:
									var _v36 = _v1.a;
									var _v37 = _v1.b;
									var _v38 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.is;
										});
								case 6:
									var _v39 = _v1.a;
									var _v40 = _v1.b;
									var _v41 = _v1.c;
									if (cruiseTripType === 2) {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.fU;
											});
									} else {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.fT;
											});
									}
								case 5:
									var _v43 = _v1.a;
									var _v44 = _v1.b;
									var _v45 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iu;
										});
								case 15:
									var _v171 = _v1.a;
									var _v172 = _v1.b;
									var _v173 = _v1.c;
									if (cruiseTripType === 2) {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.i3;
											});
									} else {
										return A2(
											$elm$core$Basics$composeL,
											$elm$core$Maybe$Just,
											function ($) {
												return $.i6;
											});
									}
								default:
									break _v1$62;
							}
						case 15:
							if (_v1.b === 1) {
								var _v175 = _v1.a;
								var _v176 = _v1.b;
								var _v177 = _v1.c;
								return A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$Just,
									function ($) {
										return $.ja;
									});
							} else {
								break _v1$62;
							}
						case 3:
							switch (_v1.b) {
								case 2:
									var _v178 = _v1.a;
									var _v179 = _v1.b;
									var _v180 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.ik;
										});
								case 0:
									var _v181 = _v1.a;
									var _v182 = _v1.b;
									var _v183 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.il;
										});
								default:
									break _v1$62;
							}
						default:
							break _v1$62;
					}
				case 3:
					switch (_v1.a) {
						case 13:
							switch (_v1.b) {
								case 5:
									var _v55 = _v1.a;
									var _v56 = _v1.b;
									var _v57 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iL;
										});
								case 3:
									var _v58 = _v1.a;
									var _v59 = _v1.b;
									var _v60 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iK;
										});
								default:
									break _v1$60;
							}
						case 2:
							switch (_v1.b) {
								case 3:
									var _v107 = _v1.a;
									var _v108 = _v1.b;
									var _v109 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iF;
										});
								case 1:
									var _v110 = _v1.a;
									var _v111 = _v1.b;
									var _v112 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iG;
										});
								default:
									break _v1$60;
							}
						case 1:
							switch (_v1.b) {
								case 3:
									var _v126 = _v1.a;
									var _v127 = _v1.b;
									var _v128 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iP;
										});
								case 2:
									var _v129 = _v1.a;
									var _v130 = _v1.b;
									var _v131 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iQ;
										});
								case 4:
									var _v135 = _v1.a;
									var _v136 = _v1.b;
									var _v137 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iR;
										});
								case 0:
									var _v138 = _v1.a;
									var _v139 = _v1.b;
									var _v140 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iS;
										});
								case 5:
									var _v141 = _v1.a;
									var _v142 = _v1.b;
									var _v143 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iT;
										});
								default:
									break _v1$60;
							}
						case 0:
							switch (_v1.b) {
								case 5:
									var _v76 = _v1.a;
									var _v77 = _v1.b;
									var _v78 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.f0;
										});
								case 3:
									var _v144 = _v1.a;
									var _v145 = _v1.b;
									var _v146 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iU;
										});
								case 1:
									var _v150 = _v1.a;
									var _v151 = _v1.b;
									var _v152 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iX;
										});
								default:
									break _v1$60;
							}
						case 5:
							switch (_v1.b) {
								case 13:
									var _v52 = _v1.a;
									var _v53 = _v1.b;
									var _v54 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iZ;
										});
								case 0:
									var _v79 = _v1.a;
									var _v80 = _v1.b;
									var _v81 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.i2;
										});
								case 3:
									var _v153 = _v1.a;
									var _v154 = _v1.b;
									var _v155 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iY;
										});
								case 1:
									var _v156 = _v1.a;
									var _v157 = _v1.b;
									var _v158 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.i_;
										});
								default:
									break _v1$60;
							}
						case 4:
							switch (_v1.b) {
								case 1:
									var _v123 = _v1.a;
									var _v124 = _v1.b;
									var _v125 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iO;
										});
								case 3:
									var _v165 = _v1.a;
									var _v166 = _v1.b;
									var _v167 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iN;
										});
								default:
									break _v1$60;
							}
						case 3:
							switch (_v1.b) {
								case 13:
									var _v61 = _v1.a;
									var _v62 = _v1.b;
									var _v63 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iA;
										});
								case 2:
									var _v95 = _v1.a;
									var _v96 = _v1.b;
									var _v97 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iz;
										});
								case 1:
									var _v98 = _v1.a;
									var _v99 = _v1.b;
									var _v100 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iC;
										});
								case 0:
									var _v101 = _v1.a;
									var _v102 = _v1.b;
									var _v103 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iD;
										});
								case 5:
									var _v104 = _v1.a;
									var _v105 = _v1.b;
									var _v106 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iE;
										});
								case 4:
									var _v168 = _v1.a;
									var _v169 = _v1.b;
									var _v170 = _v1.c;
									return A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$Just,
										function ($) {
											return $.iB;
										});
								default:
									break _v1$60;
							}
						default:
							break _v1$60;
					}
				default:
					var _v185 = _v1.c;
					return A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						function ($) {
							return $.DI;
						});
			}
		}
		return $elm$core$Basics$always($elm$core$Maybe$Nothing);
	}
	var _v184 = _v1.c;
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$Just,
		function ($) {
			return $.eT;
		});
};
var $author$project$TimetablePage$Header$View$routeInfoSection = F3(
	function (translations, showDescription, model) {
		var from = model.kS;
		var to = model.le;
		var voyageType = model.tx;
		var translateLessOrMoreToggle = showDescription ? function ($) {
			return $.wz;
		} : function ($) {
			return $.wA;
		};
		var routeTitle = $author$project$Utils$Route$isCruiseOrCruiseMultiship(voyageType) ? A2($author$project$Utils$Route$translateTripType, model, translations) : (A2($author$project$Types$Port$translate, from, translations) + (' - ' + A2($author$project$Types$Port$translate, to, translations)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('routeInfo'),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$TimetableHeaderMsg(0))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('routeTitle bodyLargeBold colorWhite')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(routeTitle)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('shortInfo')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('shortDescription bodySmall colorWhite')
								]),
							$author$project$Translations$toHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($author$project$Utils$Route$translateShortTripDescription, model, translations)))),
							A2(
							$author$project$Utils$String$renderIf,
							$author$project$Utils$Route$isShoppingCruise(voyageType),
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('expandableInfoToggle'),
										A2($elm$html$Html$Attributes$attribute, 'data-test', 'descriptionToggle'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('open', showDescription)
											]))
									]),
								$author$project$Translations$toHtml(
									translateLessOrMoreToggle(translations))))
						])),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Utils$Route$isShoppingCruise(voyageType),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('detailedInfo')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('description bodyLight colorWhite')
									]),
								$author$project$Translations$toHtml(
									A2(
										$elm$core$String$join,
										'<br><br>',
										A2(
											$elm$core$String$split,
											'\n',
											$elm$core$String$trim(translations.Gw)))))
							])))
				]));
	});
var $author$project$TimetablePage$Header$View$getSelectedTabIndex = F2(
	function (voyageTypes, selectedVoyageType) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (voyageType) {
				return _Utils_eq(voyageType, selectedVoyageType);
			},
			voyageTypes);
		if (!_v0.$) {
			var index = _v0.a;
			return index;
		} else {
			return 0;
		}
	});
var $author$project$TimetablePage$Header$View$dataTestAttribute = function (voyageType) {
	var title = function () {
		switch (voyageType.$) {
			case 1:
				return 'data-test-switch-to-cruise-party';
			case 2:
				return 'data-test-switch-to-routetrip-or-shuttle';
			case 0:
				return 'data-test-switch-to-cruise';
			case 5:
				return 'data-test-switch-to-yst-cruise';
			case 3:
				return 'data-test-switch-to-routetrip-or-shuttle';
			case 4:
				return 'data-test-switch-to-cruise-multiship';
			default:
				if (!voyageType.a) {
					var _v1 = voyageType.a;
					return 'data-test-switch-to-regular-cruise-multi-departure';
				} else {
					var _v2 = voyageType.a;
					return 'data-test-switch-to-shopping-cruise-multi-departure';
				}
		}
	}();
	return A2($elm$html$Html$Attributes$attribute, title, '');
};
var $author$project$TimetablePage$Header$View$getSliderClass = function (selectedTabIndex) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$class(
			'translateSlider' + $elm$core$String$fromInt(selectedTabIndex * 100))
		]);
};
var $author$project$Common$Images$VoyageType$cruise = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('29'),
			$elm$svg$Svg$Attributes$height('19'),
			$elm$svg$Svg$Attributes$viewBox('0 0 29 19'),
			$elm$svg$Svg$Attributes$y('0'),
			$elm$svg$Svg$Attributes$x('0')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$d('m 9.9,2 1.2,4.5 h -2 l -1.2,2 H 4.3 L 2.2,11.7 H 17.6 L 19.3,10 h 6.5 l -1,-1.6 H 14.5 l 0.4,-0.8 h 7.5 L 21.4,6 H 15.7 L 13.6,2 Z m 9.9,9 -1.6,1.6 H 0 L 1.8,17 h 23 L 29,11 Z M 9.7,13.5 h 1 l -0.6,1.2 h -1 z m -1.7,0 h 1 l -0.6,1.2 h -1 z m -1.8,0 h 1 l -0.6,1.2 h -1 z')
				]),
			_List_Nil)
		]));
var $author$project$Common$Images$VoyageType$routeTrip = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('29'),
			$elm$svg$Svg$Attributes$height('19'),
			$elm$svg$Svg$Attributes$viewBox('0 0 29 19'),
			$elm$svg$Svg$Attributes$y('0'),
			$elm$svg$Svg$Attributes$x('0')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$d('M 25,12.7 V 15 c 0,0.1 0,0.2 -0.1,0.3 -0.1,0.1 -0.2,0.1 -0.3,0.1 H 8.5 v 2.3 c 0,0.1 0,0.2 -0.1,0.3 C 8.3,18 8.2,18 8.1,18 8,18 7.9,18 7.8,17.9 L 4.1,14.1 C 4,14 4,13.9 4,13.8 4,13.7 4,13.6 4.1,13.5 L 7.8,9.7 C 7.9,9.6 8,9.6 8.1,9.6 c 0.1,0 0.2,0 0.3,0.1 0.1,0.1 0.1,0.2 0.1,0.3 v 2.3 h 16.1 c 0.1,0 0.2,0 0.3,0.1 0.1,0.1 0.1,0.2 0.1,0.3 z m 0,-6.5 c 0,0.1 0,0.2 -0.1,0.3 l -3.7,3.8 c -0.1,0.1 -0.2,0.1 -0.3,0.1 -0.1,0 -0.2,0 -0.3,-0.1 C 20.5,10.2 20.5,10.1 20.5,10 V 7.7 H 4.4 C 4.3,7.7 4.2,7.7 4.1,7.6 4,7.5 4,7.4 4,7.3 V 5 C 4,4.9 4,4.8 4.1,4.7 4.2,4.6 4.3,4.6 4.4,4.6 H 20.5 V 2.4 c 0,-0.1 0,-0.2 0.1,-0.3 C 20.7,2 20.8,2 20.9,2 21,2 21.1,2 21.2,2.1 l 3.7,3.8 C 25,6 25,6.1 25,6.2 Z')
				]),
			_List_Nil)
		]));
var $author$project$Common$Images$VoyageType$shopping = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('29'),
			$elm$svg$Svg$Attributes$height('19'),
			$elm$svg$Svg$Attributes$viewBox('0 0 29 19'),
			$elm$svg$Svg$Attributes$y('0'),
			$elm$svg$Svg$Attributes$x('0')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$d('m 24.1,7.5 c 0.1,0 0.3,0.1 0.4,0.2 0.1,0.1 0.1,0.3 0,0.4 l -1,3.6 c -0.1,0.2 -0.2,0.4 -0.4,0.4 h -0.3 l -1.2,5.4 c 0,0.2 -0.2,0.4 -0.4,0.4 H 7.8 C 7.6,17.9 7.4,17.8 7.4,17.5 L 6.2,12.1 H 5.9 C 5.7,12.1 5.5,12 5.5,11.7 L 4.5,8.1 C 4.5,8 4.5,7.8 4.6,7.7 4.7,7.6 4.8,7.5 5,7.5 h 7.5 L 13.1,1.4 C 13.1,1.1 13.3,1 13.5,1 h 2 c 0.2,0 0.4,0.2 0.4,0.4 l 0.9,6.1 z M 22,10.4 22.5,9 h -16 l 0.4,1.3 z M 14.1,1.9 13.6,7.5 h 1.9 L 15,1.9 Z m -3.7,14.2 c 0.4,0 0.7,-0.3 0.7,-0.5 v -2.7 c 0,-0.4 -0.3,-0.5 -0.7,-0.5 -0.4,0 -0.7,0.3 -0.7,0.5 v 2.7 c -0.1,0.3 0.2,0.5 0.7,0.5 z m 3.9,0 c 0.5,0 0.7,-0.3 0.7,-0.5 v -2.7 c 0,-0.4 -0.3,-0.5 -0.7,-0.5 -0.4,0 -0.7,0.3 -0.7,0.5 v 2.7 c 0,0.3 0.4,0.5 0.7,0.5 z m 4.5,0 c 0.4,0 0.6,-0.3 0.6,-0.5 v -2.7 c 0,-0.4 -0.3,-0.5 -0.6,-0.5 -0.3,0 -0.6,0.3 -0.6,0.5 v 2.7 c -0.1,0.3 0.2,0.5 0.6,0.5 z')
				]),
			_List_Nil)
		]));
var $author$project$TimetablePage$Header$View$voyageTypeImage = function (voyageType) {
	switch (voyageType.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('voyageTypeImage')
					]),
				_List_fromArray(
					[$author$project$Common$Images$VoyageType$cruise]));
		case 4:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('voyageTypeImage')
					]),
				_List_fromArray(
					[$author$project$Common$Images$VoyageType$cruise]));
		case 6:
			if (voyageType.a === 1) {
				var _v1 = voyageType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voyageTypeImage')
						]),
					_List_fromArray(
						[$author$project$Common$Images$VoyageType$shopping]));
			} else {
				var _v2 = voyageType.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voyageTypeImage')
						]),
					_List_fromArray(
						[$author$project$Common$Images$VoyageType$cruise]));
			}
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('voyageTypeImage')
					]),
				_List_fromArray(
					[$author$project$Common$Images$VoyageType$cruise]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('voyageTypeImage')
					]),
				_List_fromArray(
					[$author$project$Common$Images$VoyageType$routeTrip]));
	}
};
var $author$project$TimetablePage$Header$View$voyageTypeButton = F5(
	function (voyageType, isSelected, title, index, selectedTabIndex) {
		var dataAttribute = $author$project$TimetablePage$Header$View$dataTestAttribute(voyageType);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voyageTypeButton voyageType'),
					dataAttribute,
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected active', isSelected)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$ChangedVoyageType(voyageType)),
					$elm$html$Html$Attributes$disabled(isSelected)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Utils$String$renderIf,
					!index,
					A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('backgroundSlider')
								]),
							$author$project$TimetablePage$Header$View$getSliderClass(selectedTabIndex)),
						_List_Nil)),
					$author$project$TimetablePage$Header$View$voyageTypeImage(voyageType),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voyageTypeTitle')
						]),
					$author$project$Translations$toHtml(title))
				]));
	});
var $author$project$TimetablePage$Header$View$voyageTypeSelector = F3(
	function (voyageTypes, translations, model) {
		var from = model.kS;
		var to = model.le;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voyageTypeSelectorContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voyageTypeSelector')
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, voyageType) {
								return A5(
									$author$project$TimetablePage$Header$View$voyageTypeButton,
									voyageType,
									_Utils_eq(voyageType, model.tx),
									A2(
										$author$project$Utils$Route$translateTripType,
										_Utils_update(
											model,
											{tx: voyageType}),
										translations),
									index,
									A2($author$project$TimetablePage$Header$View$getSelectedTabIndex, voyageTypes, model.tx));
							}),
						voyageTypes))
				]));
	});
var $author$project$TimetablePage$Header$View$root = F4(
	function (session, showDescription, isDayTrip, translations) {
		var _v0 = session;
		var from = _v0.kS;
		var to = _v0.le;
		var cruiseTripType = _v0.mm;
		var bookingType = _v0.vk;
		var properties = _List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				'timetableHeader ' + A6($author$project$TimetablePage$Header$View$getTripKey, session.tx, from, to, isDayTrip, cruiseTripType, ' ')),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('descriptionVisible', showDescription),
						_Utils_Tuple2('detailedInfoVisible backgroundOverlayVisible', showDescription)
					]))
			]);
		return A2(
			$elm$html$Html$div,
			properties,
			_List_fromArray(
				[
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$Utils$Route$isShoppingCruise(session.tx),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('backgroundOverlay')
							]),
						_List_Nil)),
					A2(
					$author$project$Utils$String$renderIf,
					$author$project$TimetablePage$Header$View$hasVoyageTypeSelector(
						{vk: bookingType, kS: from, le: to}),
					A3(
						$author$project$TimetablePage$Header$View$voyageTypeSelector,
						A2($author$project$Utils$Route$getRegularVoyageTypeList, from, to),
						translations,
						{mm: cruiseTripType, kS: from, le: to, tx: session.tx})),
					A3(
					$author$project$TimetablePage$Header$View$routeInfoSection,
					translations,
					showDescription,
					{mm: cruiseTripType, kS: from, le: to, tx: session.tx})
				]));
	});
var $author$project$Messages$OpenedReturnTimetable = {$: 67};
var $author$project$TimetablePage$View$addReturnTicketSection = function (language) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('addReturnTicketSection')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('outlineBigButton'),
						$elm$html$Html$Events$onClick($author$project$Messages$OpenedReturnTimetable),
						A2($elm$html$Html$Attributes$attribute, 'data-test-add-leg-button', '')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.td;
							}))
					]))
			]));
};
var $author$project$Messages$ChangedDynamicDate = function (a) {
	return {$: 45, a: a};
};
var $author$project$Messages$OpenedOutwardTimetable = {$: 66};
var $author$project$Messages$ToggledScrollToTopVisibility = function (a) {
	return {$: 73, a: a};
};
var $author$project$Constants$directionSwitcherFooterId = 'direction-switcher-footer';
var $author$project$Constants$directionSwitcherTabsId = 'direction-switcher-tabs';
var $author$project$Messages$OpenedCalendarPage = {$: 69};
var $author$project$TimetablePage$Common$dateSelectionView = F2(
	function (_v0, title) {
		var language = _v0.A_;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('directionSwitcherFooter'),
					$elm$html$Html$Attributes$id($author$project$Constants$directionSwitcherFooterId)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dynamicDate title1Bold')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chooseDepartureDateButton'),
							$elm$html$Html$Events$onClick($author$project$Messages$OpenedCalendarPage)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('link1')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.Hx;
										}))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('calendarIcon')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/assets/images/_cacheBooking/calendar_icon.svg')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Utils$Time$Format$monthAbbreviatedDayWeekday = function (_v0) {
	var language = _v0.A_;
	var market = _v0.rb;
	var _v1 = _Utils_Tuple2(language, market);
	switch (_v1.a) {
		case 6:
			var _v2 = _v1.a;
			return _List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
					$ryan_haskell$date_format$DateFormat$text('日'),
					$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated
				]);
		case 7:
			var _v3 = _v1.a;
			return _List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$text(' '),
					$ryan_haskell$date_format$DateFormat$monthNumber,
					$ryan_haskell$date_format$DateFormat$text('/'),
					$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
				]);
		default:
			return _List_fromArray(
				[
					$ryan_haskell$date_format$DateFormat$dayOfWeekNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$text(', '),
					$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
					$ryan_haskell$date_format$DateFormat$text(' '),
					$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
				]);
	}
};
var $author$project$TimetablePage$CruiseMultiDeparture$formatTime = F2(
	function (session, time) {
		return A3(
			$author$project$Utils$Time$Format$format,
			A2($author$project$Types$Locale$Locale, session.A_, session.rb),
			$author$project$Utils$Time$Format$monthAbbreviatedDayWeekday,
			time);
	});
var $author$project$TimetablePage$Common$getFormattedDynamicDate = F3(
	function (_v0, isShuttleLikeView, startDate) {
		var language = _v0.A_;
		var market = _v0.rb;
		if (isShuttleLikeView) {
			return A3(
				$author$project$Utils$Time$Format$format,
				A2($author$project$Types$Locale$Locale, language, market),
				$author$project$Utils$Time$Format$monthAbbreviatedDayWeekday,
				startDate);
		} else {
			var weekEndDate = A4(
				$justinmimbs$time_extra$Time$Extra$add,
				11,
				6,
				$elm$time$Time$utc,
				A3($justinmimbs$time_extra$Time$Extra$floor, 3, $elm$time$Time$utc, startDate));
			var timeString = A2(
				$author$project$Utils$Time$Format$format,
				A2($author$project$Types$Locale$Locale, language, market),
				$author$project$Utils$Time$Format$monthNumberDayWeekday);
			return timeString(startDate) + (' - ' + timeString(weekEndDate));
		}
	});
var $author$project$TimetablePage$DirectionSwitcher$View$dynamicDate = F4(
	function (session, model, isShuttleLikeView, sailDate) {
		var sailWithoutHotelsDateString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var departureIsoDate = _v0.nr;
					return A2($author$project$TimetablePage$CruiseMultiDeparture$formatTime, session, departureIsoDate);
				},
				model.Gp));
		var dynamicDateString = (!$elm$core$String$isEmpty(model.qb)) ? model.qb : ((!$elm$core$String$isEmpty(sailWithoutHotelsDateString)) ? sailWithoutHotelsDateString : A3($author$project$TimetablePage$Common$getFormattedDynamicDate, session, isShuttleLikeView, sailDate));
		return A2($author$project$TimetablePage$Common$dateSelectionView, session, dynamicDateString);
	});
var $author$project$Messages$ToggledFirstNightOnShip = {$: 111};
var $author$project$TimetablePage$DirectionSwitcher$View$firstNightOnShipSection = F2(
	function (language, isFirstNightOnShipModeOn) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('firstNightOnShip')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Common$ToggleSwitch$view, isFirstNightOnShipModeOn, $author$project$Messages$ToggledFirstNightOnShip, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodySmall bodyBold')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.HB;
										}))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Translations$t,
								language,
								function ($) {
									return $.HA;
								}))
						]))
				]));
	});
var $author$project$Utils$Route$isTimetableWithDetailedSailView = F3(
	function (from, to, voyageType) {
		return _Utils_eq(voyageType, $author$project$Types$VoyageType$Shuttle) || (((from === 3) && (to === 1)) || ((from === 1) && (to === 3)));
	});
var $author$project$TimetablePage$DirectionSwitcher$View$addTripButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('addTripButton'),
			A2($elm$html$Html$Attributes$attribute, 'data-test-add-trip', '')
		]),
	_List_fromArray(
		[$author$project$Common$Images$plusImage]));
var $author$project$Messages$RemovedReturnSail = {$: 74};
var $author$project$TimetablePage$DirectionSwitcher$View$removeTripButton = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('removeTripButton'),
			$elm$html$Html$Events$onClick($author$project$Messages$RemovedReturnSail),
			A2($elm$html$Html$Attributes$attribute, 'data-test-remove-trip', '')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/images/common/icon_button_cross_mark_filled.svg')
				]),
			_List_Nil)
		]));
var $author$project$TimetablePage$DirectionSwitcher$View$routeString = F2(
	function (from, to) {
		return $author$project$Types$Port$toString(from) + (' - ' + $author$project$Types$Port$toString(to));
	});
var $author$project$TimetablePage$DirectionSwitcher$View$returnTab = F5(
	function (session, direction, maybeSail, from, to) {
		var language = session.A_;
		var testAttribute = session.qW ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-test-translation-key', 'timetable.addReturnTicket')
			]) : A3(
			$author$project$Utils$List$maybeAddWithMap,
			maybeSail,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.nr;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Utils$Time$toDateTimeString,
					$elm$html$Html$Attributes$attribute('data-date'))),
			_List_Nil);
		var hasRemoveTripButton = ((!_Utils_eq(maybeSail, $elm$core$Maybe$Nothing)) || $author$project$Types$Trips$isLoading(session.tp)) && ((direction === 1) && ((!session.qW) && (session.vk !== 1)));
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tab return'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('active', direction === 1)
							]))
					]),
				(direction !== 1) ? _List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Messages$OpenedReturnTimetable)
					]) : _List_Nil),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('route bodyLarge')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$TimetablePage$DirectionSwitcher$View$routeString, to, from))
								])),
							A2($author$project$Utils$String$renderIf, hasRemoveTripButton, $author$project$TimetablePage$DirectionSwitcher$View$removeTripButton),
							A2($author$project$Utils$String$renderIf, session.qW && (direction !== 1), $author$project$TimetablePage$DirectionSwitcher$View$addTripButton),
							A2(
							$elm$html$Html$div,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('date bodyBold')
									]),
								testAttribute),
							_List_fromArray(
								[
									session.qW ? $elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.td;
										})) : $elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.td;
											}),
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.nr;
												},
												A2(
													$author$project$Utils$Time$Format$format,
													A2($author$project$Types$Locale$Locale, session.A_, session.rb),
													$author$project$Utils$Time$Format$monthNumberDayWeekdayHourMinute)),
											maybeSail)))
								]))
						]))
				]));
	});
var $author$project$Messages$ClickedScrollToTop = {$: 72};
var $author$project$TimetablePage$Common$scrollToTopView = function (_v0) {
	var language = _v0.A_;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scrollToTop'),
				$elm$html$Html$Events$onClick($author$project$Messages$ClickedScrollToTop)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.xk;
							}))
					]))
			]));
};
var $author$project$Types$RouteTripSails$hasOvernightSailOnFirstDay = function (routeTripSails) {
	var outwardSails = A2(
		$elm$core$List$sortBy,
		A2($elm$core$Basics$composeR, $author$project$Types$RouteTripSail$toDepartureIsoDate, $elm$time$Time$posixToMillis),
		A3($elm$core$Basics$composeR, $author$project$Types$RouteTripSails$all, $elm$core$Tuple$first, routeTripSails));
	var firstDayDate = A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $author$project$Types$RouteTripSail$toDepartureIsoDate, $author$project$Utils$Time$toDateString),
		$elm$core$List$head(outwardSails));
	if (firstDayDate.$ === 1) {
		return false;
	} else {
		var date = firstDayDate.a;
		return A2(
			$elm$core$List$any,
			function (sail) {
				return sail.qY && (sail.zr && (!sail.mA));
			},
			A2(
				$elm$core$List$filterMap,
				$author$project$Types$RouteTripSail$toReal,
				A2(
					$elm$core$List$filter,
					function (sail) {
						return _Utils_eq(
							date,
							$author$project$Utils$Time$toDateString(
								$author$project$Types$RouteTripSail$toDepartureIsoDate(sail)));
					},
					outwardSails)));
	}
};
var $author$project$Utils$Route$isHelTalHotelPackage = function (_v0) {
	var from = _v0.kS;
	var to = _v0.le;
	var bookingType = _v0.vk;
	return ((from === 2) && (!to)) && (bookingType === 1);
};
var $author$project$TimetablePage$DirectionSwitcher$View$showFirstNightOnShipSection = F2(
	function (session, viewDirection) {
		return $author$project$Utils$Route$isHelTalHotelPackage(session) && ((!viewDirection) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$RouteTripSails$hasOvernightSailOnFirstDay,
				$author$project$Types$Trips$toMaybeSuccessRouteTripSails(session.tp))));
	});
var $author$project$TimetablePage$DirectionSwitcher$View$root = F6(
	function (session, pageModel, isOnCalendarView, viewDirection, sails, showScrollToTop) {
		var language = session.A_;
		var bookingType = session.vk;
		var _v0 = A2($author$project$Types$RouteTripSails$available, bookingType, sails);
		var outwardSails = _v0.a;
		var maybeReturnSails = _v0.b;
		var maybeDynamicDate = (!viewDirection) ? A3(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			$elm$core$Maybe$map($author$project$Types$RouteTripSail$toDepartureIsoDate),
			outwardSails) : A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$head,
				$elm$core$Maybe$map($author$project$Types$RouteTripSail$toDepartureIsoDate)),
			maybeReturnSails);
		var _v1 = $author$project$Types$RouteTripSails$selected(sails);
		var outwardSail = _v1.a;
		var maybeReturnSail = _v1.b;
		var _v2 = _Utils_Tuple2(outwardSail.v1, outwardSail.v2);
		var from = _v2.a;
		var to = _v2.b;
		var isShuttleLikeView = A3($author$project$Utils$Route$isTimetableWithDetailedSailView, from, to, session.tx);
		var dynamicDateBlock = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				A3($author$project$TimetablePage$DirectionSwitcher$View$dynamicDate, session, pageModel, isShuttleLikeView),
				maybeDynamicDate));
		var isVoyageTypeSelectable = $elm$core$List$length(
			A2($author$project$Utils$Route$getRegularVoyageTypeList, from, to)) > 1;
		return A3(
			$elm$html$Html$node,
			'sticky-header',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Events$on,
					'showScrollToTop',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Messages$ToggledScrollToTopVisibility,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['detail']),
							$elm$json$Json$Decode$bool))),
					A2(
					$elm$html$Html$Events$on,
					'setDynamicDate',
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Messages$ChangedDynamicDate,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['detail']),
							$elm$json$Json$Decode$string)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directionSwitcher'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fixed safePaddingTop', showScrollToTop)
								]))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$author$project$Utils$String$renderIf,
								showScrollToTop && isVoyageTypeSelectable,
								$author$project$TimetablePage$Common$scrollToTopView(session)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('tabs'),
										$elm$html$Html$Attributes$id($author$project$Constants$directionSwitcherTabsId)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_Utils_ap(
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('tab outward'),
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('active', !viewDirection)
														]))
												]),
											(!(!viewDirection)) ? _List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$Messages$OpenedOutwardTimetable)
												]) : _List_Nil),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('route bodyLarge')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2($author$project$TimetablePage$DirectionSwitcher$View$routeString, from, to))
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('date bodyBold'),
																A2(
																$elm$html$Html$Attributes$attribute,
																'data-date',
																$author$project$Utils$Time$toDateTimeString(outwardSail.nr))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A3(
																	$author$project$Utils$Time$Format$format,
																	A2($author$project$Types$Locale$Locale, session.A_, session.rb),
																	$author$project$Utils$Time$Format$monthNumberDayWeekdayHourMinute,
																	outwardSail.nr))
															]))
													]))
											])),
										A5($author$project$TimetablePage$DirectionSwitcher$View$returnTab, session, viewDirection, maybeReturnSail, from, to)
									])),
								A2(
								$author$project$Utils$String$renderIf,
								(!bookingType) && (!((viewDirection === 1) && _Utils_eq(maybeReturnSails, $elm$core$Maybe$Nothing))),
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('priceIncludesSurcharges bodySmall')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Translations$t,
												language,
												function ($) {
													return $.Fj;
												}))
										]))),
								A2(
								$author$project$Utils$String$renderIf,
								A2($author$project$TimetablePage$DirectionSwitcher$View$showFirstNightOnShipSection, session, viewDirection) && (!isOnCalendarView),
								A2(
									$author$project$TimetablePage$DirectionSwitcher$View$firstNightOnShipSection,
									language,
									$author$project$Types$RouteTripSails$selected(sails).a.qY))
							]),
						isOnCalendarView ? _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('directionSwitcherFooter title1'),
										$elm$html$Html$Attributes$id($author$project$Constants$directionSwitcherFooterId)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.Hx;
											}))
									]))
							]) : ((!(session.qW && (viewDirection === 1))) ? _List_fromArray(
							[dynamicDateBlock]) : _List_Nil)))
				]));
	});
var $author$project$TimetablePage$View$directionSwitcher = F5(
	function (session, model, direction, isOnCalendarView, sails) {
		return A6($author$project$TimetablePage$DirectionSwitcher$View$root, session, model, isOnCalendarView, direction, sails, model.sQ);
	});
var $author$project$TimetablePage$View$getDatePickerCalendar = F4(
	function (session, model, direction, routeTripSails) {
		var maybeSelectedDate = _Utils_eq(model.oP, $elm$core$Maybe$Nothing) ? A2(
			$elm$core$Maybe$map,
			A2($justinmimbs$time_extra$Time$Extra$floor, 11, $elm$time$Time$utc),
			function () {
				if (!direction) {
					return $elm$core$Maybe$Just(
						$author$project$Types$RouteTripSails$selected(routeTripSails).a.nr);
				} else {
					return A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.nr;
						},
						$author$project$Types$RouteTripSails$selected(routeTripSails).b);
				}
			}()) : model.oP;
		var _v0 = session;
		var language = _v0.A_;
		var market = _v0.rb;
		var marketUntilDate = _v0.mI;
		var timeNow = _v0.kJ;
		var firstPossibleDate = A3(
			$justinmimbs$time_extra$Time$Extra$floor,
			11,
			$elm$time$Time$utc,
			function () {
				if (!direction) {
					return timeNow;
				} else {
					return function (_v2) {
						var outward = _v2.a;
						var maybeReturn = _v2.b;
						return A2(
							$elm$core$Maybe$withDefault,
							outward.ps,
							A2(
								$elm$core$Maybe$map,
								function (_return) {
									return A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										A4($author$project$Utils$Route$minimumRouteTripGapInMinutes, outward.v1, _return.v1, outward.EX, _return.EJ),
										$elm$time$Time$utc,
										outward.ps);
								},
								maybeReturn));
					}(
						$author$project$Types$RouteTripSails$selected(routeTripSails));
				}
			}());
		return function (selectedSail) {
			return A2(
				$elm$html$Html$map,
				$author$project$Messages$SelectedCalendarDay(direction),
				$author$project$TimetablePage$Calendar$View$view(
					{
						kS: firstPossibleDate,
						qD: session.vk === 1,
						n0: A2($author$project$Types$Locale$Locale, language, market),
						Gg: selectedSail,
						le: marketUntilDate
					}));
		}(
			A2($elm$core$Maybe$withDefault, session.kJ, maybeSelectedDate));
	});
var $author$project$Types$Trips$isCruiseMultiDeparture = function (trips) {
	if (trips.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$TimetablePage$MarketingMessage$View$isArrivalInLNAS = function (routeTripSail) {
	return routeTripSail.EX === 'LNAS';
};
var $author$project$TimetablePage$MarketingMessage$View$isDepartureFromLNAS = function (routeTripSail) {
	return routeTripSail.EJ === 'LNAS';
};
var $author$project$TimetablePage$MarketingMessage$View$maybeMessageForLNAS = F2(
	function (translations, sail) {
		return $author$project$TimetablePage$MarketingMessage$View$isDepartureFromLNAS(sail) ? $elm$core$Maybe$Just(
			$author$project$TimetablePage$MarketingMessage$View$view(
				{
					nt: translations.xx,
					zP: $elm$core$Maybe$Nothing,
					oh: $elm$core$Maybe$Just(translations.xy)
				})) : ($author$project$TimetablePage$MarketingMessage$View$isArrivalInLNAS(sail) ? $elm$core$Maybe$Just(
			$author$project$TimetablePage$MarketingMessage$View$view(
				{
					nt: translations.xu,
					zP: $elm$core$Maybe$Nothing,
					oh: $elm$core$Maybe$Just(translations.xv)
				})) : $elm$core$Maybe$Nothing);
	});
var $author$project$TimetablePage$MarketingMessage$View$maybeSelectedRouteTripMessage = F3(
	function (translations, direction, sails) {
		var _v0 = $author$project$Types$RouteTripSails$selected(sails);
		var outwardSail = _v0.a;
		var maybeReturnSail = _v0.b;
		if (direction === 1) {
			return A2(
				$author$project$Types$Maybe$Util$orElse,
				A2(
					$elm$core$Maybe$andThen,
					$author$project$TimetablePage$MarketingMessage$View$maybeMessageForLNAS(translations),
					maybeReturnSail),
				A2(
					$elm$core$Maybe$map,
					$author$project$TimetablePage$MarketingMessage$View$view,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.rc;
						},
						maybeReturnSail)));
		} else {
			return A2(
				$author$project$Types$Maybe$Util$orElse,
				A2($author$project$TimetablePage$MarketingMessage$View$maybeMessageForLNAS, translations, outwardSail),
				A2($elm$core$Maybe$map, $author$project$TimetablePage$MarketingMessage$View$view, outwardSail.rc));
		}
	});
var $author$project$TimetablePage$SailsList$View$groupSailsByPeriod = F3(
	function (isShuttleLikeView, direction, sails) {
		var period = isShuttleLikeView ? 11 : 3;
		var floorDate = function (sail) {
			return A3(
				$justinmimbs$time_extra$Time$Extra$floor,
				period,
				$elm$time$Time$utc,
				$author$project$Types$RouteTripSail$toDepartureIsoDate(sail));
		};
		var amountOfOutwardSailsToHide = isShuttleLikeView ? 7 : 2;
		return function (sortedSails) {
			return ((!direction) && (($elm$core$List$length(sortedSails) - amountOfOutwardSailsToHide) > 0)) ? A2(
				$elm$core$List$take,
				$elm$core$List$length(sortedSails) - amountOfOutwardSailsToHide,
				sortedSails) : sortedSails;
		}(
			A3(
				$elm$core$List$foldl,
				F2(
					function (group, accumulator) {
						return A3(
							$elm$core$Basics$composeR,
							$author$project$Types$RouteTripSail$toDepartureIsoDate,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Utils$Time$toDateString,
								A2(
									$elm$core$Basics$composeR,
									function (a) {
										return _List_fromArray(
											[
												_Utils_Tuple2(
												a,
												A2($elm$core$List$cons, group.a, group.b))
											]);
									},
									$elm$core$List$append(accumulator))),
							group.a);
					}),
				_List_Nil,
				A2(
					$elm_community$list_extra$List$Extra$groupWhile,
					F2(
						function (firstSail, secondSail) {
							return _Utils_eq(
								floorDate(firstSail),
								floorDate(secondSail));
						}),
					A2(
						$elm$core$List$sortBy,
						A2($elm$core$Basics$composeR, $author$project$Types$RouteTripSail$toDepartureIsoDate, $elm$time$Time$posixToMillis),
						sails))));
	});
var $author$project$TimetablePage$SailsList$View$getIsDisabledReturn = F2(
	function (session, returnDepartureTime) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return _Utils_cmp(
						$elm$time$Time$posixToMillis(a),
						$elm$time$Time$posixToMillis(returnDepartureTime)) < 0;
				},
				session.Dy));
	});
var $author$project$Messages$ClickedOnFakeRouteTripSail = F2(
	function (a, b) {
		return {$: 50, a: a, b: b};
	});
var $author$project$TimetablePage$SailsList$View$viaHelsinkiView = function (language) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('viaHelsinkiContainer')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('viaHelsinki bodyBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.Il;
							}))
					]))
			]));
};
var $author$project$TimetablePage$SailsList$View$fakeSailView = F3(
	function (session, direction, sail) {
		var locale = A2($author$project$Types$Locale$Locale, session.A_, session.rb);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row sail'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-sail-date',
					$author$project$Utils$Time$toDateTimeString(sail.nr)),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'sail'),
					$elm$html$Html$Events$onClick(
					A2($author$project$Messages$ClickedOnFakeRouteTripSail, direction, sail))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('regular routeTripDetails')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell departure bodyNorm textAlignLeft')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('date')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('time')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Time$Format$formatHourMinute(sail.nr))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell arrival bodyNorm textAlignLeft')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('date')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('time')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Time$Format$formatHourMinute(sail.ps))
										]))
								])),
							$author$project$TimetablePage$SailsList$View$viaHelsinkiView(session.A_)
						]))
				]));
	});
var $author$project$Messages$ClickedOnEligibleShoppingCruiseSail = F2(
	function (a, b) {
		return {$: 49, a: a, b: b};
	});
var $author$project$TimetablePage$Messages$ClickedOnSailWithoutHotels = function (a) {
	return {$: 0, a: a};
};
var $author$project$Messages$SelectedRouteTripSail = F2(
	function (a, b) {
		return {$: 48, a: a, b: b};
	});
var $author$project$TimetablePage$SailsList$View$isEligibleForShoppingCruise = F2(
	function (sail, maybeOppositeSelectedSail) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(sail.F3),
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Gx;
					},
					maybeOppositeSelectedSail)));
	});
var $author$project$TimetablePage$SailsList$View$hotelPackagesRouteTripSailDetailsView = F2(
	function (locale, sail) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotelPackage routeTripDetails')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell departure bodyNorm textAlignCenter')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('time data')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(sail.nr))
								])),
							A2($author$project$Utils$String$renderIf, sail.q0 && sail.zr, $author$project$Common$Images$ribbonImage)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyLargeBold shipName')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Types$ShipCode$toViewString(sail.oX))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyLargeBold duration'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('bed', sail.qY)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									_Utils_ap(
										$elm$core$String$fromFloat(sail.nv),
										A2(
											$author$project$Translations$t,
											locale.A_,
											function ($) {
												return $.tf;
											})))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell arrival bodyNorm textAlignCenter')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('time data')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(sail.ps))
								]))
						]))
				]));
	});
var $author$project$TimetablePage$SailsList$View$hotelPackagesShuttleSailDetailsView = F2(
	function (language, sail) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hotelPackage shuttleDetails')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('departureTime title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(sail.nr))
								])),
							A2($author$project$Utils$String$renderIf, sail.q0 && sail.zr, $author$project$Common$Images$ribbonImage)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyBold shipName')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Types$ShipCode$toViewString(sail.oX))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyLargeBold duration'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('bed', sail.qY)
										]))
								]),
							_List_fromArray(
								[
									(!sail.qY) ? $elm$html$Html$text(
									_Utils_ap(
										$elm$core$String$fromFloat(sail.nv),
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.tf;
											}))) : $author$project$Common$Images$bed
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('arrivalTime title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(sail.ps))
								]))
						]))
				]));
	});
var $author$project$TimetablePage$SailsList$View$formatPrice = F2(
	function (market, price) {
		return A2($author$project$Types$Market$formatPrice, market, price) + (' ' + $author$project$Types$Currency$toShortSign(
			$author$project$Types$Market$toCurrency(market)));
	});
var $author$project$TimetablePage$SailsList$View$getMinPrice = function (prices) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (price, maybeCurrentSmallestPrice) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$TimetablePage$Cruise$Util$getSmallestNumber(maybeCurrentSmallestPrice),
					price);
			}),
		$elm$core$Maybe$Nothing,
		prices);
};
var $author$project$TimetablePage$SailsList$View$minimalPersonPrice = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter(
		function ($) {
			return $.zr;
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ov;
				},
				$elm$core$Maybe$Just)),
		$author$project$TimetablePage$SailsList$View$getMinPrice));
var $author$project$TimetablePage$SailsList$View$personPriceView = function (_v0) {
	var session = _v0.j;
	var sail = _v0.k7;
	var _arguments = _v0.kp;
	var routeTripSails = _v0.oN;
	var isMinPrice = _Utils_eq(
		$author$project$TimetablePage$SailsList$View$minimalPersonPrice(routeTripSails),
		$elm$core$Maybe$Just(sail.ov));
	var _v1 = _arguments;
	var selectedSailId = _v1.la;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cell data personPrice price'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('cheapestPrice', isMinPrice)
					]))
			]),
		_List_fromArray(
			[
				sail.zr ? $elm$html$Html$text(
				A2($author$project$TimetablePage$SailsList$View$formatPrice, session.rb, sail.ov)) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('soldOutSailSection')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('crossMark'),
								$elm$html$Html$Attributes$src('/assets/images/timetable/icon_soldout_crossmark.svg')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									session.A_,
									function ($) {
										return $.HG;
									}))
							]))
					]))
			]));
};
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $author$project$Common$Images$moon = function (color) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$height('16'),
				$elm$svg$Svg$Attributes$width('16'),
				$elm$svg$Svg$Attributes$fill('none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8.00365 8.11379C7.11931 6.53429 7.32263 4.5695 8.51165 3.20455C8.59035 3.10307 8.60375 2.96541 8.5461 2.85066C8.48845 2.73591 8.37 2.66449 8.24161 2.66706C7.26074 2.65771 6.29525 2.91107 5.44536 3.40084C2.82833 4.86653 1.8946 8.17598 3.35964 10.7934C4.89363 13.371 8.22648 14.2174 10.8044 12.684C11.6538 12.1934 12.3562 11.4842 12.8385 10.6301C12.9052 10.5201 12.9025 10.3815 12.8318 10.2741C12.7611 10.1667 12.6348 10.1095 12.5074 10.1273C10.7316 10.4744 8.92918 9.66857 8.00365 8.11379Z'),
						$elm$svg$Svg$Attributes$stroke(color),
						$elm$svg$Svg$Attributes$strokeWidth('1.5'),
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round')
					]),
				_List_Nil)
			]));
};
var $author$project$TimetablePage$SailsList$View$tripWithHotelView = function (language) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tripWithHotelContainer'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'trip-with-hotel')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tripWithHotel bodyBold')
					]),
				_List_fromArray(
					[
						$author$project$Common$Images$moon($author$project$Common$Images$colors.ev),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.HH;
									}))
							]))
					]))
			]));
};
var $author$project$TimetablePage$SailsList$View$minimalVehiclePrice = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$filter(
		function ($) {
			return $.zr;
		}),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function ($) {
				return $.pe;
			}),
		$author$project$TimetablePage$SailsList$View$getMinPrice));
var $author$project$TimetablePage$SailsList$View$vehiclePriceView = function (_v0) {
	var session = _v0.j;
	var sail = _v0.k7;
	var _arguments = _v0.kp;
	var routeTripSails = _v0.oN;
	var isMinVehiclePrice = _Utils_eq(
		sail.pe,
		$author$project$TimetablePage$SailsList$View$minimalVehiclePrice(routeTripSails));
	var _v1 = _arguments;
	var selectedSailId = _v1.la;
	var direction = _v1.p7;
	var isLoadingTrips = _v1.nR;
	var isWithVehicleInThisDirection = function () {
		if (!direction) {
			return $author$project$Utils$Route$isVehicleRequiredForOutward(session) || A2($elm$core$List$any, $author$project$Types$SelectedVehicles$isOutwardSelected, session.yq);
		} else {
			return $author$project$Utils$Route$isVehicleRequiredForReturn(session) || A2($elm$core$List$any, $author$project$Types$SelectedVehicles$isReturnSelected, session.yq);
		}
	}();
	var isVehicleSoldOut = sail.zr && ((!isLoadingTrips) && (isWithVehicleInThisDirection && _Utils_eq(sail.pe, $elm$core$Maybe$Nothing)));
	var isVehicleSoldOutAndSelected = isVehicleSoldOut && _Utils_eq(sail.F3, selectedSailId);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cell data vehiclePrice'),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'vehicle-price'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('cheapestPrice', isMinVehiclePrice && isWithVehicleInThisDirection),
						_Utils_Tuple2(
						'vehicleSoldOut',
						isVehicleSoldOut && (!_Utils_eq(sail.F3, selectedSailId))),
						_Utils_Tuple2('selectedVehicleSoldOut', isVehicleSoldOutAndSelected)
					]))
			]),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$TimetablePage$SailsList$View$formatPrice(session.rb),
					A2(
						$elm$core$Basics$composeR,
						$elm$html$Html$text,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Utils$String$renderIf(isWithVehicleInThisDirection),
							$elm$core$List$singleton))),
				sail.pe)));
};
var $author$project$TimetablePage$SailsList$View$routeTripLikeSailDetailsView = function (_arguments) {
	var session = _arguments.j;
	var sail = _arguments.k7;
	var locale = A2($author$project$Types$Locale$Locale, session.A_, session.rb);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('regular routeTripDetails')
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell departure bodyNorm textAlignLeft')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.nr))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('time')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(sail.nr))
								])),
							A2($author$project$Utils$String$renderIf, sail.q0 && sail.zr, $author$project$Common$Images$ribbonImage)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell arrival bodyNorm textAlignLeft')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Utils$Time$Format$format, locale, $author$project$Utils$Time$Format$monthNumberDayWeekday, sail.ps))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('time')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(sail.ps))
								]))
						]))
				]),
			sail.kT ? _List_fromArray(
				[
					$author$project$TimetablePage$SailsList$View$tripWithHotelView(session.A_)
				]) : _List_fromArray(
				[
					$author$project$TimetablePage$SailsList$View$vehiclePriceView(_arguments),
					$author$project$TimetablePage$SailsList$View$personPriceView(_arguments)
				])));
};
var $author$project$TimetablePage$SailsList$View$shuttleLikeSailDetailsView = function (args) {
	var session = args.j;
	var sail = args.k7;
	var _arguments = args.kp;
	var shoppingCruiseText = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cell shoppingCruiseText')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyBold')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							session.A_,
							function ($) {
								return $.Gv;
							}))
					]))
			]));
	var shipNameAndDuration = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cell')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyNorm shipName')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Types$ShipCode$toViewString(sail.oX))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodySmall duration'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('bed', sail.qY)
							]))
					]),
				_List_fromArray(
					[
						sail.qY ? $author$project$Common$Images$bed : $elm$html$Html$text(
						_Utils_ap(
							$elm$core$String$fromFloat(sail.nv),
							A2(
								$author$project$Translations$t,
								session.A_,
								function ($) {
									return $.tf;
								})))
					]))
			]));
	var departureAndArrivalTime = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cell')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('departureTime title2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Time$Format$formatHourMinute(sail.nr))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('arrivalTime bodySmall')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Time$Format$formatHourMinute(sail.ps))
					])),
				A2($author$project$Utils$String$renderIf, sail.q0 && sail.zr, $author$project$Common$Images$ribbonImage)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('regular shuttleDetails')
			]),
		_Utils_ap(
			_List_fromArray(
				[departureAndArrivalTime]),
			A2($author$project$TimetablePage$SailsList$View$isEligibleForShoppingCruise, sail, _arguments.mK) ? _List_fromArray(
				[shoppingCruiseText]) : (sail.kT ? _List_fromArray(
				[
					shipNameAndDuration,
					$author$project$TimetablePage$SailsList$View$tripWithHotelView(session.A_)
				]) : _List_fromArray(
				[
					shipNameAndDuration,
					$author$project$TimetablePage$SailsList$View$vehiclePriceView(args),
					$author$project$TimetablePage$SailsList$View$personPriceView(args)
				]))));
};
var $author$project$TimetablePage$SailsList$View$sailDetailsBlocks = function (args) {
	var session = args.j;
	var sail = args.k7;
	var _arguments = args.kp;
	var _v0 = _arguments;
	var isShuttleLikeView = _v0.ly;
	return (isShuttleLikeView && (session.vk === 1)) ? A2($author$project$TimetablePage$SailsList$View$hotelPackagesShuttleSailDetailsView, session.A_, sail) : (isShuttleLikeView ? $author$project$TimetablePage$SailsList$View$shuttleLikeSailDetailsView(args) : (((session.vk === 1) && (!isShuttleLikeView)) ? A2(
		$author$project$TimetablePage$SailsList$View$hotelPackagesRouteTripSailDetailsView,
		A2($author$project$Types$Locale$Locale, session.A_, session.rb),
		sail) : $author$project$TimetablePage$SailsList$View$routeTripLikeSailDetailsView(args)));
};
var $author$project$Types$Direction$toString = function (direction) {
	if (!direction) {
		return 'outward';
	} else {
		return 'return';
	}
};
var $author$project$TimetablePage$Messages$ClosedNotification = {$: 1};
var $author$project$TimetablePage$Messages$NavigateToLastAvailableDate = {$: 2};
var $author$project$Messages$SelectedOnlyShip = {$: 40};
var $author$project$TimetablePage$SailsList$View$tooltip = F2(
	function (language, direction) {
		var message = (!direction) ? function ($) {
			return $.HC;
		} : function ($) {
			return $.HD;
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('selectedSailWithoutHotelsTooltipContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tooltip bodyNorm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Translations$t, language, message)),
							A2(
							$author$project$Common$Button$outline,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'data-test', 'selectOnlyShip'),
									$author$project$UrlRoute$onClickWithoutSideEffects($author$project$Messages$SelectedOnlyShip)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Translations$t,
										language,
										function ($) {
											return $.HF;
										}))
								])),
							A2(
							$author$project$Utils$String$renderIf,
							direction === 1,
							A2(
								$author$project$Common$Button$outline,
								_List_fromArray(
									[
										$author$project$UrlRoute$onClickWithoutSideEffects(
										$author$project$Messages$TimetableMsg($author$project$TimetablePage$Messages$NavigateToLastAvailableDate))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Translations$t,
											language,
											function ($) {
												return $.HE;
											}))
									]))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip-close-button'),
									$author$project$UrlRoute$onClickWithoutSideEffects(
									$author$project$Messages$TimetableMsg($author$project$TimetablePage$Messages$ClosedNotification))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tooltip-arrow')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$TimetablePage$SailsList$View$sailView = F4(
	function (session, props, routeTripSails, sail) {
		var language = session.A_;
		var selected = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (selectedSail) {
					return _Utils_eq(selectedSail, sail);
				},
				props.Gp));
		var disabledReturn = (props.p7 === 1) && A2($author$project$TimetablePage$SailsList$View$getIsDisabledReturn, session, sail.nr);
		var disabledOutward = A2(
			$elm$core$List$member,
			sail.F3,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.F3;
				},
				session.yx));
		var _v0 = props;
		var selectedSailId = _v0.la;
		var direction = _v0.p7;
		var isShoppingCruise = _v0.nX;
		var maybeOppositeSelectedSail = _v0.mK;
		var onClickMsg = (sail.kT && (session.vk !== 1)) ? $author$project$Messages$SwitchToHotelPackageOnDate(sail.nr) : ((disabledReturn || disabledOutward) ? $author$project$Messages$TimetableMsg(
			$author$project$TimetablePage$Messages$ClickedOnSailWithoutHotels(sail)) : (A2($author$project$TimetablePage$SailsList$View$isEligibleForShoppingCruise, sail, maybeOppositeSelectedSail) ? A2($author$project$Messages$ClickedOnEligibleShoppingCruiseSail, direction, sail) : A2($author$project$Messages$SelectedRouteTripSail, direction, sail)));
		return A2(
			$elm$html$Html$div,
			A3(
				$author$project$Utils$List$addIf,
				sail.zr && (!_Utils_eq(sail.rc, $elm$core$Maybe$Nothing)),
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'special-trip'),
				A3(
					$author$project$Utils$List$addIf,
					(sail.kT && (session.vk !== 1)) || ((!_Utils_eq(sail.F3, selectedSailId)) && sail.zr),
					$elm$html$Html$Events$onClick(onClickMsg),
					A3(
						$author$project$Utils$List$appendIf,
						_Utils_eq(sail.F3, selectedSailId),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(
								$author$project$Constants$selectedDateId + ('-' + $elm$core$String$toLower(
									$author$project$Types$Direction$toString(direction)))),
								$elm$html$Html$Attributes$class('active'),
								A2($elm$html$Html$Attributes$attribute, 'data-sail', 'selected')
							]),
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row sail'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('soldOutSail', (!sail.zr) && (!sail.kT)),
										_Utils_Tuple2('overnight', sail.qY),
										_Utils_Tuple2('withoutHotels', disabledOutward || disabledReturn),
										_Utils_Tuple2('selected', selected),
										_Utils_Tuple2('hasNoCruise', sail.kT)
									])),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-sail-date',
								$author$project$Utils$Time$toDateTimeString(sail.nr)),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-sail-ship',
								$author$project$Types$ShipCode$toString(sail.oX)),
								A2($elm$html$Html$Attributes$attribute, 'data-test', 'sail'),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-test-is-sold-out',
								$author$project$Utils$String$fromBool(!sail.zr)),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-test-has-discount',
								$author$project$Utils$String$fromBool(sail.q0 && sail.zr))
							])))),
			_List_fromArray(
				[
					$author$project$TimetablePage$SailsList$View$sailDetailsBlocks(
					{kp: props, oN: routeTripSails, k7: sail, j: session}),
					A2(
					$author$project$Utils$String$renderIf,
					selected,
					A2($author$project$TimetablePage$SailsList$View$tooltip, language, props.p7))
				]));
	});
var $author$project$TimetablePage$SailsList$View$sailsTable = F3(
	function (session, props, period) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (sail) {
					if (!sail.$) {
						var realSail = sail.a;
						return _List_fromArray(
							[
								A4(
								$author$project$TimetablePage$SailsList$View$sailView,
								session,
								props,
								A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, period),
								realSail),
								A2(
								$author$project$Utils$String$renderIf,
								_Utils_eq(realSail.F3, props.la),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									props.n9))
							]);
					} else {
						var fakeSail = sail.a;
						return _List_fromArray(
							[
								A3($author$project$TimetablePage$SailsList$View$fakeSailView, session, props.p7, fakeSail)
							]);
					}
				},
				period));
	});
var $author$project$TimetablePage$Common$hotelPackageGroupControls = function (_v0) {
	var language = _v0.A_;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('routeTripControls bodySmall')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.o7;
							}))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.xn;
							}))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.te;
							}))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.o6;
							}))
					]))
			]));
};
var $author$project$TimetablePage$Common$priceIcon = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('control personPrice')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('passengerIcon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/images/_cacheBooking/passenger_adult.svg')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Messages$ClickedSelectVehicle = function (a) {
	return {$: 87, a: a};
};
var $author$project$Types$SelectVehicleCallback$ToggledVehicles = {$: 0};
var $author$project$TimetablePage$Common$vehicleControl = function (session) {
	var language = session.A_;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('control vehiclePrice')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Utils$Html$Render$renderIf,
				$author$project$Utils$Route$areVehiclesSupported(session),
				A2(
					$author$project$Common$VehicleToggle$View$view,
					$author$project$Messages$ClickedSelectVehicle($author$project$Types$SelectVehicleCallback$ToggledVehicles),
					$author$project$Common$VehicleToggle$View$vehicleToggleViewState(session)))
			]));
};
var $author$project$TimetablePage$Common$regularRouteTripGroupControls = function (session) {
	var language = session.A_;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('routeTripControls bodySmall')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control primaryTitle textAlignLeft')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.o7;
							}))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control secondaryTitle textAlignLeft')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Translations$t,
							language,
							function ($) {
								return $.o6;
							}))
					])),
				$author$project$TimetablePage$Common$vehicleControl(session),
				$author$project$TimetablePage$Common$priceIcon
			]));
};
var $author$project$TimetablePage$Common$regularShuttleGroupControls = function (session) {
	var language = session.A_;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('routeTripControls bodySmall')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primaryTitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.o7;
									}))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondaryTitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.o6;
									}))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('primaryTitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.xn;
									}))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('secondaryTitle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Translations$t,
									language,
									function ($) {
										return $.te;
									}))
							]))
					])),
				$author$project$TimetablePage$Common$vehicleControl(session),
				$author$project$TimetablePage$Common$priceIcon
			]));
};
var $author$project$TimetablePage$SailsList$View$timetableHeaderView = F2(
	function (session, _v0) {
		var bookingType = session.vk;
		var isShuttleLikeView = _v0.ly;
		var direction = _v0.p7;
		var _v1 = _Utils_Tuple2(bookingType, isShuttleLikeView);
		if (_v1.a === 1) {
			if (_v1.b) {
				var _v2 = _v1.a;
				return $author$project$TimetablePage$Common$hotelPackageGroupControls(session);
			} else {
				var _v3 = _v1.a;
				return $author$project$TimetablePage$Common$hotelPackageGroupControls(session);
			}
		} else {
			if (_v1.b) {
				var _v4 = _v1.a;
				return $author$project$TimetablePage$Common$regularShuttleGroupControls(session);
			} else {
				var _v5 = _v1.a;
				return $author$project$TimetablePage$Common$regularRouteTripGroupControls(session);
			}
		}
	});
var $author$project$TimetablePage$SailsList$View$sailsTableView = F2(
	function (_v0, departureDate) {
		var session = _v0.j;
		var _arguments = _v0.kp;
		var sailsTables = _v0.sD;
		var dateString = _v0.p0;
		var sailsList = _v0.sC;
		var nextDate = _v0.rA;
		var disabledReturn = ((session.vk === 1) && (_arguments.p7 === 1)) ? A2($author$project$TimetablePage$SailsList$View$getIsDisabledReturn, session, departureDate) : false;
		var lastAvailableDate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return (_arguments.p7 === 1) && ((!disabledReturn) && A2($author$project$TimetablePage$SailsList$View$getIsDisabledReturn, session, a));
				},
				nextDate));
		var allOutwardsDisabled = ((session.vk === 1) && (!_arguments.p7)) ? A2(
			$elm$core$List$all,
			function (a) {
				return A2($elm$core$List$member, a, session.yx);
			},
			A2($elm$core$List$filterMap, $author$project$Types$RouteTripSail$toReal, sailsList)) : false;
		var tableHeader = _List_fromArray(
			[
				A2(
				$author$project$Utils$String$renderIf,
				!$elm$core$List$isEmpty(sailsTables),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dayHeader title1Bold'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('withoutHotels', disabledReturn || allOutwardsDisabled)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3($author$project$TimetablePage$Common$getFormattedDynamicDate, session, _arguments.ly, departureDate))
						]))),
				A2(
				$author$project$Utils$String$renderIf,
				lastAvailableDate,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('lastAvailableDate')
						]),
					_List_Nil)),
				A2($author$project$TimetablePage$SailsList$View$timetableHeaderView, session, _arguments)
			]);
		return _Utils_ap(
			sailsTables,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table'),
							A2($elm$html$Html$Attributes$attribute, 'data-date', dateString)
						]),
					_Utils_ap(
						tableHeader,
						A3($author$project$TimetablePage$SailsList$View$sailsTable, session, _arguments, sailsList)))
				]));
	});
var $author$project$TimetablePage$SailsList$View$tablesList = F3(
	function (session, props, sails) {
		var sailsArray = $elm$core$Array$fromList(sails);
		return A3(
			$elm$core$Array$foldl,
			F2(
				function (_v0, accumulator) {
					var dateString = _v0.a;
					var sailsList = _v0.b;
					var nextDate = _v0.c;
					return A2(
						$elm$core$Maybe$withDefault,
						accumulator,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Types$RouteTripSail$toDepartureIsoDate,
								$author$project$TimetablePage$SailsList$View$sailsTableView(
									{kp: props, p0: dateString, rA: nextDate, sC: sailsList, sD: accumulator, j: session})),
							$elm$core$List$head(sailsList)));
				}),
			_List_Nil,
			A2(
				$elm$core$Array$indexedMap,
				F2(
					function (index, a) {
						return _Utils_Tuple3(
							a.a,
							a.b,
							A2(
								$elm$core$Maybe$map,
								$author$project$Types$RouteTripSail$toDepartureIsoDate,
								$elm$core$List$head(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											$elm$core$Tuple$second,
											A2($elm$core$Array$get, index + 1, sailsArray))))));
					}),
				sailsArray));
	});
var $author$project$TimetablePage$SailsList$View$root = F8(
	function (session, timetablePage, isShoppingCruise, maybeOppositeSelectedSail, sail, sails, direction, maybeMessage) {
		var isShuttleLikeView = A3($author$project$Utils$Route$isTimetableWithDetailedSailView, sail.v1, sail.v2, session.tx);
		var content = A3(
			$author$project$TimetablePage$SailsList$View$tablesList,
			session,
			{
				m9: $author$project$Utils$Route$areVehiclesSupported(session),
				p7: direction,
				nR: $author$project$Types$Trips$isLoading(session.tp),
				nX: isShoppingCruise,
				ly: isShuttleLikeView,
				n9: maybeMessage,
				mK: maybeOppositeSelectedSail,
				la: sail.F3,
				Gp: timetablePage.Gp
			},
			A3($author$project$TimetablePage$SailsList$View$groupSailsByPeriod, isShuttleLikeView, direction, sails));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'sailsList ' + ($elm$core$String$toLower(
						$author$project$Types$Direction$toString(direction)) + 'Direction')),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'overflowHidden',
							(!timetablePage.qX) && (!_Utils_eq(timetablePage.pk, direction))),
							_Utils_Tuple2(
							'firstNightOnShip',
							A2($author$project$TimetablePage$DirectionSwitcher$View$showFirstNightOnShipSection, session, direction)),
							_Utils_Tuple2('hotelPackage', session.vk === 1)
						])),
					$elm$html$Html$Attributes$id(
					$elm$core$String$toLower(
						$author$project$Types$Direction$toString(direction)) + '-slide')
				]),
			content);
	});
var $author$project$TimetablePage$View$routeTripSailsList = F8(
	function (session, model, isShoppingCruiseSail, direction, maybeMessage, maybeOppositeSelectedSail, selectedSail, sails) {
		return A8($author$project$TimetablePage$SailsList$View$root, session, model, isShoppingCruiseSail, maybeOppositeSelectedSail, selectedSail, sails, direction, maybeMessage);
	});
var $author$project$TimetablePage$View$routeTripSuccessBlocks = F4(
	function (session, model, timetableDirectionRoute, sails) {
		var language = session.A_;
		var maybeMessage = function (direction) {
			return A3(
				$author$project$TimetablePage$MarketingMessage$View$maybeSelectedRouteTripMessage,
				$author$project$Translations$forLanguage(language),
				direction,
				sails);
		};
		var directionSwitcherView = F2(
			function (direction, isOnCalendarView) {
				return A5($author$project$TimetablePage$View$directionSwitcher, session, model, direction, isOnCalendarView, sails);
			});
		if ((!timetableDirectionRoute) || (timetableDirectionRoute === 2)) {
			var returnSails = A2($author$project$Types$RouteTripSails$available, session.vk, sails).b;
			var isCruiseMultiDepartureSail = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Types$Trips$isCruiseMultiDeparture,
					$author$project$Types$Trips$statusToMaybe(session.tp)));
			var direction = (!timetableDirectionRoute) ? 0 : 1;
			return _List_fromArray(
				[
					A2(directionSwitcherView, direction, false),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('displayFlex slideContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide outward'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('active', !model.pk)
										]))
								]),
							_List_fromArray(
								[
									A8(
									$author$project$TimetablePage$View$routeTripSailsList,
									session,
									model,
									false,
									0,
									maybeMessage(0),
									$author$project$Types$RouteTripSails$selected(sails).b,
									$author$project$Types$RouteTripSails$selected(sails).a,
									A2($author$project$Types$RouteTripSails$available, session.vk, sails).a)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide return'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('active', model.pk === 1),
											_Utils_Tuple2(
											'loading',
											$author$project$Types$Trips$isLoading(session.tp) && _Utils_eq(returnSails, $elm$core$Maybe$Nothing)),
											_Utils_Tuple2(
											'loaded',
											!_Utils_eq(returnSails, $elm$core$Maybe$Nothing))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$TimetablePage$View$addReturnTicketSection(language),
									A2(
										$elm$core$Maybe$andThen,
										function (a) {
											return session.qW ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(a);
										},
										A3(
											$elm$core$Maybe$map2,
											A6(
												$author$project$TimetablePage$View$routeTripSailsList,
												session,
												model,
												isCruiseMultiDepartureSail,
												1,
												maybeMessage(1),
												$elm$core$Maybe$Just(
													$author$project$Types$RouteTripSails$selected(sails).a)),
											$author$project$Types$RouteTripSails$selected(sails).b,
											A2($author$project$Types$RouteTripSails$available, session.vk, sails).b)))
								]))
						]))
				]);
		} else {
			var direction = (timetableDirectionRoute === 1) ? 0 : 1;
			return _List_fromArray(
				[
					A2(directionSwitcherView, direction, true),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('displayFlex slideContainer')
						]),
					_List_fromArray(
						[
							$author$project$Types$Trips$isLoading(session.tp) ? $author$project$TimetablePage$View$loaderOverlay : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide outward'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('active', !model.pk)
										]))
								]),
							_List_fromArray(
								[
									A4($author$project$TimetablePage$View$getDatePickerCalendar, session, model, 0, sails)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('slide return'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('active', model.pk === 1)
										]))
								]),
							session.qW ? _List_fromArray(
								[
									$author$project$TimetablePage$View$addReturnTicketSection(language)
								]) : _List_fromArray(
								[
									A4($author$project$TimetablePage$View$getDatePickerCalendar, session, model, 1, sails)
								]))
						]))
				]);
		}
	});
var $author$project$TimetablePage$View$routeTripBlocks = F3(
	function (session, model, timetableDirectionRoute) {
		var _v0 = session.tp;
		_v0$3:
		while (true) {
			switch (_v0.$) {
				case 0:
					if (_v0.a.$ === 1) {
						var route = _v0.a.a;
						return A4($author$project$TimetablePage$View$routeTripSuccessBlocks, session, model, timetableDirectionRoute, route);
					} else {
						break _v0$3;
					}
				case 2:
					if ((!_v0.a.$) && (_v0.a.a.$ === 1)) {
						var route = _v0.a.a.a;
						return A4($author$project$TimetablePage$View$routeTripSuccessBlocks, session, model, timetableDirectionRoute, route);
					} else {
						return _List_fromArray(
							[$author$project$TimetablePage$Common$loadingView]);
					}
				default:
					break _v0$3;
			}
		}
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('marginTopSmall marginHorizontalSmall')
					]),
				_List_fromArray(
					[
						$author$project$TimetablePage$Common$noDeparturesToast(session)
					]))
			]);
	});
var $author$project$TimetablePage$View$scrollToTop = F2(
	function (translations, showScrollToTop) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('scrollToTop safePaddingTop cruise'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('show', showScrollToTop)
						])),
					$elm$html$Html$Events$onClick($author$project$Messages$ClickedScrollToTop)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyBold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.xk)
						]))
				]));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$getDefaultDynamicDate = function (session) {
	var _v0 = session.tp;
	if ((!_v0.$) && (_v0.a.$ === 2)) {
		var cruiseMultiDeparture = _v0.a.a;
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$TimetablePage$CruiseMultiDeparture$formatTime, session, session.kJ),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.rS;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.p3;
						},
						$author$project$TimetablePage$CruiseMultiDeparture$formatTime(session))),
				$elm$core$List$head(
					$author$project$Types$CruiseMultiDepartureTrips$toList(cruiseMultiDeparture))));
	} else {
		return A2($author$project$TimetablePage$CruiseMultiDeparture$formatTime, session, session.kJ);
	}
};
var $author$project$Messages$SelectedCruiseMultiDepartureTrip = function (a) {
	return {$: 134, a: a};
};
var $author$project$Types$CruiseMultiDepartureTrip$durationInHours = F2(
	function (departureTime, arrivalTime) {
		var durationInMinutes = A4($justinmimbs$time_extra$Time$Extra$diff, 13, $elm$time$Time$utc, departureTime, arrivalTime);
		return ((durationInMinutes / 30) | 0) / 2;
	});
var $author$project$TimetablePage$CruiseMultiDeparture$formatPrice = F2(
	function (market, price) {
		return A2($author$project$Types$Market$formatPrice, market, price) + (' ' + $author$project$Types$Currency$toShortSign(
			$author$project$Types$Market$toCurrency(market)));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$sameDayTrips = F2(
	function (trip, trips) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.rS;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.p3;
					},
					$author$project$Utils$Time$isSameDay(trip.rS.p3))),
			$author$project$Types$CruiseMultiDepartureTrips$toList(trips));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$isWithMinPersonPriceForDay = F2(
	function (trip, trips) {
		return !A2(
			$elm$core$List$any,
			function (_v0) {
				var personPrice = _v0.ov;
				return _Utils_cmp(personPrice, trip.ov) > 0;
			},
			A2($author$project$TimetablePage$CruiseMultiDeparture$sameDayTrips, trip, trips));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$priceCell = F3(
	function (session, trips, trip) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cell data personPrice price'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cheapestPrice',
							A2($author$project$TimetablePage$CruiseMultiDeparture$isWithMinPersonPriceForDay, trip, trips))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$TimetablePage$CruiseMultiDeparture$formatPrice, session.rb, trip.ov))
				]));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$isWithMinVehiclePriceForDay = F2(
	function (trip, trips) {
		return !A2(
			$elm$core$List$any,
			function (_v0) {
				var vehiclePrice = _v0.pe;
				return _Utils_cmp(vehiclePrice, trip.pe) > 0;
			},
			A2($author$project$TimetablePage$CruiseMultiDeparture$sameDayTrips, trip, trips));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$vehicleCell = F3(
	function (session, trips, trip) {
		var selectedId = $author$project$Types$CruiseMultiDepartureTrips$selected(trips).zN;
		var isWithVehicle = A2($elm$core$List$any, $author$project$Types$SelectedVehicles$isOutwardSelected, session.yq) || A2($elm$core$List$any, $author$project$Types$SelectedVehicles$isReturnSelected, session.yq);
		var isVehicleSoldOut = (!$author$project$Types$Trips$isLoading(session.tp)) && (isWithVehicle && (!trip.pe));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cell data vehiclePrice'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'vehicle-price'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'cheapestPrice',
							A2($author$project$TimetablePage$CruiseMultiDeparture$isWithMinVehiclePriceForDay, trip, trips) && isWithVehicle),
							_Utils_Tuple2(
							'vehicleSoldOut',
							isVehicleSoldOut && (!_Utils_eq(trip.zN, selectedId))),
							_Utils_Tuple2(
							'selectedVehicleSoldOut',
							isVehicleSoldOut && _Utils_eq(trip.zN, selectedId))
						]))
				]),
			(isWithVehicle && (trip.pe > 0)) ? _List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$TimetablePage$CruiseMultiDeparture$formatPrice, session.rb, trip.pe))
				]) : _List_Nil);
	});
var $author$project$TimetablePage$CruiseMultiDeparture$sailView = F3(
	function (session, trips, trip) {
		var translations = $author$project$Translations$forLanguage(session.A_);
		var selectedId = $author$project$Types$CruiseMultiDepartureTrips$selected(trips).zN;
		var selected = _Utils_eq(trip.zN, selectedId);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A3(
						$author$project$Utils$List$addIf,
						!selected,
						$elm$html$Html$Events$onClick(
							$author$project$Messages$SelectedCruiseMultiDepartureTrip(trip.zN)),
						A3(
							$author$project$Utils$List$appendIf,
							selected,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(
									$author$project$Constants$selectedDateId + ('-' + $elm$core$String$toLower(
										$author$project$Types$Direction$toString(0)))),
									$elm$html$Html$Attributes$class('active'),
									A2($elm$html$Html$Attributes$attribute, 'data-sail', 'selected')
								]),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row sail'),
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-sail-date',
									$author$project$Utils$Time$toDateTimeString(trip.rS.p3))
								]))),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('departureTime title2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Time$Format$formatHourMinute(trip.rS.p3))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('arrivalTime bodySmall')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Time$Format$formatHourMinute(trip.sw.lm))
										])),
									A2($author$project$Utils$String$renderIf, trip.q0, $author$project$Common$Images$ribbonImage)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bodyNorm shipName')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Types$ShipCode$toViewString(trip.oX))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bodySmall duration'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('bed', trip.qY)
												]))
										]),
									_List_fromArray(
										[
											trip.qY ? $author$project$Common$Images$bed : $elm$html$Html$text(
											_Utils_ap(
												$elm$core$String$fromFloat(
													A2($author$project$Types$CruiseMultiDepartureTrip$durationInHours, trip.rS.p3, trip.sw.lm)),
												translations.tf))
										]))
								])),
							A3($author$project$TimetablePage$CruiseMultiDeparture$vehicleCell, session, trips, trip),
							A3($author$project$TimetablePage$CruiseMultiDeparture$priceCell, session, trips, trip)
						])),
					A2(
					$author$project$Utils$String$renderIf,
					selected,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2($elm$core$Maybe$map, $author$project$TimetablePage$MarketingMessage$View$view, trip.rc)))
				]));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$soldOutSailView = F2(
	function (_v0, trip) {
		var language = _v0.A_;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row sail soldOutSail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('departureTime title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(trip.rO))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('arrivalTime bodySmall')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Time$Format$formatHourMinute(trip.sr))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyNorm shipName')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Types$ShipCode$toViewString(trip.oX))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodySmall duration')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									_Utils_ap(
										$elm$core$String$fromFloat(
											A2($author$project$Types$CruiseMultiDepartureTrip$durationInHours, trip.rO, trip.sr)),
										$author$project$Translations$forLanguage(language).tf))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cell data personPrice price')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('soldOutSailSection')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('crossMark'),
											$elm$html$Html$Attributes$src('/assets/images/timetable/icon_soldout_crossmark.svg')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Translations$t,
												language,
												function ($) {
													return $.HG;
												}))
										]))
								]))
						]))
				]));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$tripsView = F2(
	function (session, trips) {
		return function (a) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('slide active')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sailsList')
							]),
						a)
					]));
		}(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var first = _v0.a;
					var others = _v0.b;
					var time = $author$project$Types$CruiseMultiDepartureTrips$toDepartureTime(first);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table'),
								A2(
								$elm$html$Html$Attributes$attribute,
								'data-date',
								$author$project$Types$Date$toString(
									$author$project$Types$Date$fromPosix(time)))
							]),
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dayHeader title1Bold')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$TimetablePage$CruiseMultiDeparture$formatTime, session, time))
										])),
									$author$project$TimetablePage$Common$regularShuttleGroupControls(session)
								]),
							A2(
								$elm$core$List$map,
								function (status) {
									if (!status.$) {
										var trip = status.a;
										return A3($author$project$TimetablePage$CruiseMultiDeparture$sailView, session, trips, trip);
									} else {
										var trip = status.a;
										return A2($author$project$TimetablePage$CruiseMultiDeparture$soldOutSailView, session, trip);
									}
								},
								A2($elm$core$List$cons, first, others))));
				},
				A2(
					$elm_community$list_extra$List$Extra$gatherEqualsBy,
					A2($elm$core$Basics$composeR, $author$project$Types$CruiseMultiDepartureTrips$toDepartureTime, $author$project$Types$Date$fromPosix),
					$author$project$Types$CruiseMultiDepartureTrips$toStatusList(trips))));
	});
var $author$project$TimetablePage$CruiseMultiDeparture$view = F2(
	function (pageModel, session) {
		var dynamicDate = (!$elm$core$String$isEmpty(pageModel.qb)) ? pageModel.qb : $author$project$TimetablePage$CruiseMultiDeparture$getDefaultDynamicDate(session);
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cruiseMultiDeparture')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directionSwitcher'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('fixed safePaddingTop', pageModel.sQ)
								]))
						]),
					_List_fromArray(
						[
							pageModel.sQ ? $author$project$TimetablePage$Common$scrollToTopView(session) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id($author$project$Constants$directionSwitcherTabsId)
								]),
							_List_Nil),
							A2(
							$author$project$Utils$Html$Render$renderIf,
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Types$Trips$isCruiseMultiDeparture,
									$author$project$Types$Trips$statusToMaybe(session.tp))),
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('priceIncludesSurcharges bodySmall')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Translations$t,
											session.A_,
											function ($) {
												return $.Fj;
											}))
									]))),
							A2($author$project$TimetablePage$Common$dateSelectionView, session, dynamicDate)
						])),
					function () {
					var _v0 = session.tp;
					switch (_v0.$) {
						case 2:
							return $author$project$TimetablePage$Common$loadingView;
						case 1:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('failure marginHorizontalSmall')
									]),
								_List_fromArray(
									[
										$author$project$TimetablePage$Common$noDeparturesToast(session)
									]));
						default:
							if (_v0.a.$ === 2) {
								var cruiseMultiDeparture = _v0.a.a;
								return A2($author$project$TimetablePage$CruiseMultiDeparture$tripsView, session, cruiseMultiDeparture);
							} else {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('failure marginHorizontalSmall')
										]),
									_List_fromArray(
										[
											$author$project$TimetablePage$Common$noDeparturesToast(session)
										]));
							}
					}
				}()
				]));
	});
var $author$project$TimetablePage$View$view = F3(
	function (url, session, model) {
		var translations = $author$project$Translations$forLanguage(session.A_);
		var route = $author$project$UrlRoute$parseLocation(url);
		var isVoyageTypeSelectable = $elm$core$List$length(
			A2($author$project$Utils$Route$getRegularVoyageTypeList, session.kS, session.le)) > 1;
		var isScrollToTopVisible = model.sQ && isVoyageTypeSelectable;
		var isDayTrip = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (trips) {
					switch (trips.$) {
						case 0:
							var cruiseSails = trips.a;
							return function (_v3) {
								var outwardSail = _v3.a;
								var returnSail = _v3.c;
								return A2(
									$author$project$Types$MikiSail$isDayTrip,
									outwardSail,
									$elm$core$Maybe$Just(returnSail));
							}(
								A3(
									$elm$core$Basics$composeR,
									$author$project$Types$CruiseSails$selected,
									A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Types$MikiSail$fromCruiseSail),
									cruiseSails));
						case 1:
							var routeTripSails = trips.a;
							return function (_v4) {
								var outwardSail = _v4.a;
								var maybeReturnSail = _v4.b;
								return A2(
									$author$project$Types$MikiSail$isDayTrip,
									$author$project$Types$MikiSail$fromRouteTripSail(outwardSail),
									A2($elm$core$Maybe$map, $author$project$Types$MikiSail$fromRouteTripSail, maybeReturnSail));
							}(
								$author$project$Types$RouteTripSails$selected(routeTripSails));
						default:
							var cruiseMultiDeparture = trips.a;
							return function (_v5) {
								var outwardSail = _v5.a;
								var returnSail = _v5.b;
								return A2(
									$author$project$Types$MikiSail$isDayTrip,
									outwardSail,
									$elm$core$Maybe$Just(returnSail));
							}(
								$author$project$Types$MikiSail$fromCruiseMultiDeparture(
									$author$project$Types$CruiseMultiDepartureTrips$selected(cruiseMultiDeparture)));
					}
				},
				$author$project$Types$Trips$statusToMaybe(session.tp)));
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('page timetable withFixedButton')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$section,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$property,
								'ui-view',
								$elm$json$Json$Encode$string('timetableHeader'))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('timetableHeaderTopPart safePaddingTop')
									]),
								_List_fromArray(
									[
										A4($author$project$TimetablePage$Header$View$root, session, model.GA, isDayTrip, translations)
									]))
							]))
					]),
				function () {
					if (route.$ === 1) {
						var timetableRoute = route.a;
						switch (timetableRoute.$) {
							case 0:
								return _List_fromArray(
									[
										A2($author$project$TimetablePage$View$scrollToTop, translations, isScrollToTopVisible),
										$author$project$TimetablePage$Cruise$View$root(session)
									]);
							case 1:
								return _List_fromArray(
									[
										A2($author$project$TimetablePage$CruiseMultiDeparture$view, model, session)
									]);
							case 2:
								return A2(
									$elm$core$List$cons,
									A2($author$project$TimetablePage$View$scrollToTop, translations, isScrollToTopVisible),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$section,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cruiseMultiDeparture')
												]),
											A2($author$project$TimetablePage$View$cruiseMultiDepartureCalendarView, session, model))
										]));
							case 3:
								var timetableDirectionRoute = timetableRoute.a;
								return A3($author$project$TimetablePage$View$routeTripBlocks, session, model, timetableDirectionRoute);
							default:
								var timetableDirectionRoute = timetableRoute.a;
								return A3($author$project$TimetablePage$View$routeTripBlocks, session, model, timetableDirectionRoute);
						}
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Types$SelectVehicleCallback$SelectedVehicle = function (a) {
	return {$: 1, a: a};
};
var $author$project$VehiclePage$List$directionNode = F5(
	function (translations, session, direction, maybeDetails, isSoldOut) {
		var _v0 = session;
		var market = _v0.rb;
		var isOneWay = _v0.qW;
		var from = _v0.kS;
		var to = _v0.le;
		var isReturnPriceHidden = isOneWay && (direction === 1);
		var _v1 = _Utils_Tuple3(isSoldOut, maybeDetails, isReturnPriceHidden);
		_v1$2:
		while (true) {
			if (_v1.a) {
				if (!_v1.c) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bodyBold soldOut')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.bx)
								]))
						]);
				} else {
					break _v1$2;
				}
			} else {
				if ((!_v1.b.$) && (!_v1.c)) {
					var details = _v1.b.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('direction bodySmall')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									(direction === 1) ? ($author$project$Types$Port$toString(to) + (' - ' + $author$project$Types$Port$toString(from))) : ($author$project$Types$Port$toString(from) + (' - ' + $author$project$Types$Port$toString(to))))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('price priceNormal')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Types$Market$formatPriceWithSign, market, details.lN))
								]))
						]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_fromArray(
			[
				$elm$html$Html$text(' ')
			]);
	});
var $author$project$Types$Vehicle$getVehicleSizeInMetres = function (carCategory) {
	switch (carCategory) {
		case 1:
			return {A: 1.9, m2: 5.0};
		case 2:
			return {A: 1.9, m2: 5.0};
		case 3:
			return {A: 2.4, m2: 5.5};
		case 15:
			return {A: 1.9, m2: 12.0};
		case 16:
			return {A: 2.4, m2: 12.0};
		case 13:
			return {A: 4.4, m2: 12.0};
		case 14:
			return {A: 4.4, m2: 14.0};
		case 12:
			return {A: 4.4, m2: 8.0};
		case 11:
			return {A: 2.4, m2: 7.0};
		case 6:
			return {A: 1.9, m2: 5.0};
		case 7:
			return {A: 1.9, m2: 5.0};
		case 10:
			return {A: 2.3, m2: 7.0};
		case 0:
			return {A: 1.5, m2: 3.0};
		case 4:
			return {A: 1.5, m2: 3.0};
		case 5:
			return {A: 1.9, m2: 4.0};
		case 8:
			return {A: 1.9, m2: 5.0};
		default:
			return {A: 2.3, m2: 7.0};
	}
};
var $author$project$Common$Images$Vehicles$height = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('13'),
			$elm$svg$Svg$Attributes$viewBox('0 0 6 13'),
			$elm$svg$Svg$Attributes$width('6')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5 9.34H3.75V3.1H5c.27 0 .54.02.7-.13.17-.16.17-.4 0-.56L3.24.1c-.1-.07-.2-.1-.32-.1-.1 0-.22.03-.3.1L.12 2.4c-.16.17-.16.4 0 .57.17.15.42.14.72.14H2.1v6.26H.83c-.27 0-.55 0-.72.14-.14.15-.14.4 0 .55l2.5 2.3c.08.08.2.12.3.1.13.02.24-.02.33-.1l2.48-2.3c.18-.16.18-.4 0-.56-.15-.17-.4-.16-.7-.16'),
					$elm$svg$Svg$Attributes$fill('#004152'),
					$elm$svg$Svg$Attributes$fillRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Common$Images$Vehicles$width = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$height('6'),
			$elm$svg$Svg$Attributes$viewBox('0 0 15 6'),
			$elm$svg$Svg$Attributes$width('15')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M14.15 2.6L11.5.12c-.17-.16-.45-.16-.62 0-.18.17-.17.45-.17.72V2.1H3.6V.83c0-.27 0-.55-.17-.72-.16-.14-.45-.14-.62 0L.14 2.6c-.1.08-.14.2-.13.3 0 .13.03.25.13.33L2.77 5.7c.17.17.46.17.63 0 .18-.16.17-.53.17-.7V3.75h7.14V5c0 .27 0 .54.2.7.17.17.45.17.63 0l2.65-2.47c.1-.08.13-.2.13-.32 0-.1-.03-.2-.12-.3'),
					$elm$svg$Svg$Attributes$fill('#004152'),
					$elm$svg$Svg$Attributes$fillRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$VehiclePage$Common$vehicleDimensions = F3(
	function (translations, attributes, carCategory) {
		var fromFloat = function (_float) {
			return function (floatString) {
				return A2($elm$core$String$contains, '.', floatString) ? floatString : (floatString + '.0');
			}(
				$elm$core$String$fromFloat(_float));
		};
		var _v0 = $author$project$Types$Vehicle$getVehicleSizeInMetres(carCategory);
		var height = _v0.A;
		var width = _v0.m2;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dimensions')
					]),
				attributes),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('height')
						]),
					_List_fromArray(
						[
							$author$project$Common$Images$Vehicles$height,
							$elm$html$Html$text(
							fromFloat(height) + (' ' + translations.jj))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('width')
						]),
					_List_fromArray(
						[
							$author$project$Common$Images$Vehicles$width,
							$elm$html$Html$text(
							fromFloat(width) + (' ' + translations.jj))
						]))
				]));
	});
var $author$project$VehiclePage$List$vehicleImg = F2(
	function (vehicle, isSoldOut) {
		var vehicleImgSrc = A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.jZ;
			},
			A2(
				$elm$core$Basics$composeR,
				$author$project$Types$Vehicle$carCategoryToString,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split(' '),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$join('_'),
						$elm$core$String$toLower))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicleIcon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							'/assets/images/_cacheCommon/icon_' + (vehicleImgSrc(vehicle) + '.svg'))
						]),
					_List_Nil),
					isSoldOut ? A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/images/timetable/icon_soldout_crossmark.svg')
						]),
					_List_Nil) : $elm$html$Html$text('')
				]));
	});
var $author$project$VehiclePage$List$vehicleListButton = F3(
	function (translations, session, vehicle) {
		var selectedVehicles = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, session.rp));
		var isVehicleForReturnDirectionSoldOut = A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 1, vehicle, selectedVehicles);
		var isVehicleForOutwardDirectionSoldOut = A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 0, vehicle, selectedVehicles);
		var isVehicleForBothDirectionSoldOut = isVehicleForOutwardDirectionSoldOut && isVehicleForReturnDirectionSoldOut;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicle'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('soldOut', isVehicleForBothDirectionSoldOut)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$Messages$ClickedSelectVehicle(
						$author$project$Types$SelectVehicleCallback$SelectedVehicle(vehicle))),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-vehicle-code',
					$author$project$Types$Vehicle$carCategoryToString(vehicle.jZ))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('titleRow')
						]),
					_List_fromArray(
						[
							A2($author$project$VehiclePage$List$vehicleImg, vehicle, isVehicleForBothDirectionSoldOut),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title2')
								]),
							$author$project$Translations$toHtml(
								A2($author$project$Types$Vehicle$translateCategory, vehicle.jZ, translations)))
						])),
					A3(
					$author$project$VehiclePage$Common$vehicleDimensions,
					translations,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bodyLarge')
						]),
					vehicle.jZ),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directionPrice outward')
						]),
					A5(
						$author$project$VehiclePage$List$directionNode,
						translations,
						session,
						0,
						$elm$core$Maybe$Just(vehicle.Du),
						isVehicleForOutwardDirectionSoldOut)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('directionPrice return')
						]),
					A5($author$project$VehiclePage$List$directionNode, translations, session, 1, vehicle.FN, isVehicleForReturnDirectionSoldOut)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('plusTick')
						]),
					_List_fromArray(
						[$author$project$Common$Images$plusImage]))
				]));
	});
var $author$project$VehiclePage$List$view = F2(
	function (translations, session) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicleListPage page withFixedButton')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('headerHolder')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cell title2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(translations.vl)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicleCards')
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$VehiclePage$List$vehicleListButton, translations, session),
						session.tt))
				]));
	});
var $author$project$VehiclePage$View$extraServicePageLinkToast = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('informationToast green toast priceNormal'),
			$elm$html$Html$Events$onClick(
			$author$project$Messages$ChangedLocation($author$project$UrlRoute$ExtraServices))
		]));
var $author$project$Session$ParkedVehicle = 2;
var $author$project$Session$RegularVehicle = 0;
var $author$project$Session$ShopperVehicle = 1;
var $author$project$Utils$Route$isParkedCarSupported = F3(
	function (voyageType, from, to) {
		return _Utils_eq(voyageType, $author$project$Types$VoyageType$Cruise) && ((from === 2) && (!to));
	});
var $author$project$Session$getVehicleType = function (_v0) {
	var voyageType = _v0.tx;
	var from = _v0.kS;
	var to = _v0.le;
	return $author$project$Utils$Route$isShoppingCruise(voyageType) ? 1 : (A3($author$project$Utils$Route$isParkedCarSupported, voyageType, from, to) ? 2 : 0);
};
var $author$project$Types$SelectedExtraServices$hasVehicleExtraService = function (selected) {
	var _v0 = _Utils_Tuple2(selected.DC, selected.FV);
	var outwards = _v0.a;
	var returns = _v0.b;
	return A2(
		$elm$core$List$any,
		$author$project$Types$ExtraService$isForVehicles,
		$elm$core$Dict$values(
			A2($elm$core$Dict$union, outwards, returns)));
};
var $author$project$Types$SelectedVehicles$isVehicleSoldOutForVoyageType = F3(
	function (selectedVehicles, vehicleVoyageType, vehicleAvailability) {
		var returnSoldOut = A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 1, vehicleAvailability, selectedVehicles);
		var outwardSoldOut = A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 0, vehicleAvailability, selectedVehicles);
		switch (vehicleVoyageType) {
			case 0:
				return outwardSoldOut && returnSoldOut;
			case 1:
				return outwardSoldOut;
			default:
				return returnSoldOut;
		}
	});
var $author$project$VehiclePage$View$isVehicleSoldOut = F2(
	function (session, vehicle) {
		return A3(
			$author$project$Types$SelectedVehicles$isVehicleSoldOutForVoyageType,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, session.rp)),
			session.qW ? 1 : 0,
			vehicle);
	});
var $author$project$Messages$RemovedMemorizedVehicle = {$: 86};
var $author$project$Types$Market$licensePlateHint = function (market) {
	switch (market) {
		case 1:
			return 'ABC123';
		case 4:
			return 'ABC123';
		case 0:
			return '123ABC';
		case 3:
			return 'ABC123';
		case 2:
			return 'AB1234';
		case 6:
			return 'AA BB 1234';
		case 5:
			return '123ABC';
		default:
			return 'AA12345';
	}
};
var $author$project$VehiclePage$Card$licensePlate = F3(
	function (translations, market, licensePlateString) {
		return A2(
			$author$project$Common$Panel$element,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehicleRegistration')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('labelTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(translations.jt)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('data withShadow'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'empty',
									$elm$core$String$isEmpty(licensePlateString))
								])),
							$elm$html$Html$Attributes$disabled(true),
							$elm$html$Html$Attributes$placeholder(
							$author$project$Types$Market$licensePlateHint(market)),
							$elm$html$Html$Attributes$value(licensePlateString)
						]),
					_List_Nil)
				]));
	});
var $author$project$VehiclePage$Card$directionToVoyageType = function (direction) {
	if (!direction) {
		return 1;
	} else {
		return 2;
	}
};
var $author$project$VehiclePage$Card$routeTitle = function (route) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('title3 direction')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$String$join,
					' - ',
					A2($elm$core$List$map, $author$project$Types$Port$toString, route)))
			]));
};
var $author$project$VehiclePage$Card$isDirectionActive = F2(
	function (direction, voyageType) {
		return _Utils_eq(
			voyageType,
			$author$project$VehiclePage$Card$directionToVoyageType(direction)) || (!voyageType);
	});
var $author$project$VehiclePage$Card$selectItem = F2(
	function (attributes, content) {
		return A2(
			$elm$html$Html$button,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('selectItem bodyLargeBold rotateActiveIcon'),
						A2($elm$html$Html$Attributes$attribute, 'data-test-toggle-vehicle-direction', '')
					]),
				attributes),
			content);
	});
var $author$project$Common$Images$Vehicles$soldOutVehicle = A2(
	$elm$html$Html$img,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('soldOutVehicle'),
			$elm$html$Html$Attributes$src('/assets/images/timetable/icon_soldout_vehicle.svg')
		]),
	_List_Nil);
var $author$project$VehiclePage$Card$selectDirectionButton = F6(
	function (session, carCategory, _v0, maybeVehicleVoyageType, direction, message) {
		var availability = _v0.uk;
		var price = _v0.lN;
		var selectedVehicleCount = A3(
			$author$project$Types$SelectedVehicles$getNumberOfSelectedVehiclesInDirectionByCategory,
			direction,
			carCategory,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, session.rp)));
		var isSoldOut = (availability - selectedVehicleCount) <= 0;
		var isEnoughSpace = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (selectedVehicles) {
					return (!direction) ? A3(
						$author$project$Types$SelectedVehicles$canAddCategoryForOutward,
						session,
						carCategory,
						$author$project$Types$SelectedVehicles$getOutwardCategories(selectedVehicles)) : A3(
						$author$project$Types$SelectedVehicles$canAddCategoryForReturn,
						session,
						carCategory,
						$author$project$Types$SelectedVehicles$getReturnCategories(selectedVehicles));
				},
				session.rp));
		var isActive = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$VehiclePage$Card$isDirectionActive(direction),
				maybeVehicleVoyageType));
		var isDisabled = (!isActive) && (isSoldOut || (!isEnoughSpace));
		return A2(
			$author$project$VehiclePage$Card$selectItem,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', isActive && (!isDisabled))
						])),
					$elm$html$Html$Attributes$disabled(isDisabled),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-price',
					A2($author$project$Types$Market$formatPriceWithSign, session.rb, price)),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-direction',
					$author$project$Types$Direction$toString(direction)),
					$elm$html$Html$Events$onClick(message)
				]),
			isSoldOut ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selectItemContent'),
							A2($elm$html$Html$Attributes$attribute, 'data-test-sold-out', '')
						]),
					_List_fromArray(
						[$author$project$Common$Images$Vehicles$soldOutVehicle]))
				]) : _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selectItemContent')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Types$Market$formatPriceWithSign, session.rb, price))
						])),
					$author$project$Common$Images$circlePlusMark
				]));
	});
var $author$project$VehiclePage$Card$renderMemorizedVehicleToggles = F4(
	function (session, vehicleType, selectedVehicle, vehicle) {
		var selectMemorizedVehicle = function (vehicleVoyageType) {
			return $author$project$Messages$SelectedMemorizedVehicle(
				_Utils_update(
					selectedVehicle,
					{
						tx: $elm$core$Maybe$Just(vehicleVoyageType)
					}));
		};
		var oneWaySelectItem = F2(
			function (route, price) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehiclePrice')
						]),
					_List_fromArray(
						[
							$author$project$VehiclePage$Card$routeTitle(route),
							A2(
							$author$project$VehiclePage$Card$selectItem,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									selectMemorizedVehicle(0)),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('centerContent', session.qW)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('selectItemContent')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Types$Market$formatPriceWithSign, session.rb, price))
										])),
									$author$project$Common$Images$circlePlusMark
								]))
						]));
			});
		switch (vehicleType) {
			case 0:
				return session.qW ? A2(
					oneWaySelectItem,
					_List_fromArray(
						[session.kS, session.le]),
					vehicle.Du.lN) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehiclePrice')
						]),
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							function (details) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('return')
										]),
									_List_fromArray(
										[
											$author$project$VehiclePage$Card$routeTitle(
											_List_fromArray(
												[session.le, session.kS])),
											A6(
											$author$project$VehiclePage$Card$selectDirectionButton,
											session,
											vehicle.jZ,
											details,
											$elm$core$Maybe$Nothing,
											1,
											selectMemorizedVehicle(
												$author$project$VehiclePage$Card$directionToVoyageType(1)))
										]));
							},
							vehicle.FN),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('outward')
									]),
								_List_fromArray(
									[
										$author$project$VehiclePage$Card$routeTitle(
										_List_fromArray(
											[session.kS, session.le])),
										A6(
										$author$project$VehiclePage$Card$selectDirectionButton,
										session,
										vehicle.jZ,
										vehicle.Du,
										$elm$core$Maybe$Nothing,
										0,
										selectMemorizedVehicle(
											$author$project$VehiclePage$Card$directionToVoyageType(0)))
									]))
							])));
			case 1:
				return A2(
					oneWaySelectItem,
					_List_fromArray(
						[session.kS, session.le, session.kS]),
					A2(
						$elm$core$Maybe$withDefault,
						vehicle.Du.lN,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lN;
								},
								$elm$core$Basics$add(vehicle.Du.lN)),
							vehicle.FN)));
			default:
				return A2(
					oneWaySelectItem,
					_List_fromArray(
						[session.kS, session.le, session.kS]),
					vehicle.Du.lN);
		}
	});
var $author$project$VehiclePage$Card$vehicleCardHeader = F3(
	function (translations, carCategory, removeMessage) {
		return $author$project$Common$Panel$header(
			_List_fromArray(
				[
					$author$project$Common$Panel$title(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$attribute,
									'data-test-vehicle-code',
									$author$project$Types$Vehicle$carCategoryToString(carCategory))
								]),
							$author$project$Translations$toHtml(
								A2($author$project$Types$Vehicle$translateCategory, carCategory, translations)))
						])),
					A3(
					$author$project$Common$Panel$smallLink,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'data-test', 'remove-vehicle-button')
						]),
					translations.Ii,
					removeMessage)
				]));
	});
var $author$project$VehiclePage$Card$memorizedVehicle = F5(
	function (translations, session, vehicleType, vehicle, selectedVehicle) {
		var licensePlates = A2(
			$elm$core$List$take,
			vehicle.A9,
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(''),
					A2($author$project$VehiclePage$Card$licensePlate, translations, session.rb)),
				_List_fromArray(
					[selectedVehicle.n_, selectedVehicle.n$])));
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('unselected mediumPadding'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-car-category',
					$author$project$Types$Vehicle$carCategoryToString(selectedVehicle.jZ))
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Common$Panel$element,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$VehiclePage$Card$vehicleCardHeader, translations, selectedVehicle.jZ, $author$project$Messages$RemovedMemorizedVehicle),
									A3(
									$author$project$VehiclePage$Common$vehicleDimensions,
									translations,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bayouBlue bodyLarge')
										]),
									selectedVehicle.jZ)
								]))
						]),
						licensePlates,
						_List_fromArray(
						[
							A2(
							$author$project$Common$Panel$element,
							_List_Nil,
							_List_fromArray(
								[
									A4($author$project$VehiclePage$Card$renderMemorizedVehicleToggles, session, vehicleType, selectedVehicle, vehicle)
								]))
						])
					])));
	});
var $author$project$Messages$ChangedLicensePlate = F3(
	function (a, b, c) {
		return {$: 85, a: a, b: b, c: c};
	});
var $author$project$Messages$RemovedVehicleWithAnimation = function (a) {
	return {$: 82, a: a};
};
var $author$project$Types$LicensePlate$Regular = 0;
var $author$project$Types$LicensePlate$Trailer = 1;
var $author$project$VehiclePage$Common$licencePlateInput = F5(
	function (licensePlateHint, errorMessage, licencePlateLabel, licensePlateNumber, message) {
		var hasError = A2($elm$regex$Regex$contains, $author$project$Types$SelectedVehicles$licensePlateRegex, licensePlateNumber);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('labelTitle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(licencePlateLabel)
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('data'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('validationError', hasError)
							])),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$maxlength(20),
						$elm$html$Html$Events$onInput(message),
						$elm$html$Html$Attributes$value(licensePlateNumber),
						$elm$html$Html$Attributes$placeholder(licensePlateHint),
						A2($elm$html$Html$Attributes$attribute, 'data-test', 'licence-plate')
					]),
				_List_Nil),
				A2(
				$author$project$Utils$String$renderIf,
				hasError,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('errorMessage')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(errorMessage)
						])))
			]);
	});
var $author$project$VehiclePage$Common$licencePlateInputGroup = F6(
	function (translations, licencePlateHint, allowedNumber, licencePlate, licencePlateTrailer, messageBase) {
		return A2(
			$elm$core$List$take,
			allowedNumber,
			_List_fromArray(
				[
					A2(
					$author$project$Common$Panel$element,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicleRegistration')
						]),
					A5(
						$author$project$VehiclePage$Common$licencePlateInput,
						licencePlateHint,
						translations.jq,
						translations.jt,
						A2($elm$core$Maybe$withDefault, '', licencePlate),
						messageBase(0))),
					A2(
					$author$project$Common$Panel$element,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('trailerRegistration')
						]),
					A5(
						$author$project$VehiclePage$Common$licencePlateInput,
						licencePlateHint,
						translations.jq,
						translations.jp,
						A2($elm$core$Maybe$withDefault, '', licencePlateTrailer),
						messageBase(1)))
				]));
	});
var $author$project$VehiclePage$Card$oneWayPrice = F2(
	function (market, price) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title6 text-center oneWayPrice')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Types$Market$formatPriceWithSign, market, price))
				]));
	});
var $author$project$VehiclePage$Card$toggleVehicleVoyageTypeByDirection = F2(
	function (direction, maybeVehicleVoyageType) {
		if (!direction) {
			return _Utils_eq(
				maybeVehicleVoyageType,
				$elm$core$Maybe$Just(2)) ? $elm$core$Maybe$Just(0) : (_Utils_eq(
				maybeVehicleVoyageType,
				$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just(2) : (_Utils_eq(
				maybeVehicleVoyageType,
				$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(1)));
		} else {
			return _Utils_eq(
				maybeVehicleVoyageType,
				$elm$core$Maybe$Just(2)) ? $elm$core$Maybe$Nothing : (_Utils_eq(
				maybeVehicleVoyageType,
				$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just(1) : (_Utils_eq(
				maybeVehicleVoyageType,
				$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Just(2)));
		}
	});
var $author$project$VehiclePage$Card$renderPrice = F5(
	function (session, vehicleType, index, selectedVehicle, _v0) {
		var carCategory = _v0.jZ;
		var outwardDetails = _v0.Du;
		var returnDetails = _v0.FN;
		var message = function (direction) {
			return A2(
				$author$project$Messages$ChangedVehicleVoyageType,
				index,
				A2($author$project$VehiclePage$Card$toggleVehicleVoyageTypeByDirection, direction, selectedVehicle.tx));
		};
		switch (vehicleType) {
			case 0:
				return (session.qW || _Utils_eq(returnDetails, $elm$core$Maybe$Nothing)) ? A2($author$project$VehiclePage$Card$oneWayPrice, session.rb, outwardDetails.lN) : ($author$project$Utils$Route$isMugVssRoute(session.kS) ? A2(
					$author$project$VehiclePage$Card$oneWayPrice,
					session.rb,
					outwardDetails.lN + A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.lN;
							},
							returnDetails))) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehiclePrice')
						]),
					A2(
						$author$project$Utils$List$maybeAdd,
						A2(
							$elm$core$Maybe$map,
							function (details) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('return')
										]),
									_List_fromArray(
										[
											$author$project$VehiclePage$Card$routeTitle(
											_List_fromArray(
												[session.le, session.kS])),
											A6(
											$author$project$VehiclePage$Card$selectDirectionButton,
											session,
											carCategory,
											details,
											selectedVehicle.tx,
											1,
											message(1))
										]));
							},
							returnDetails),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('outward')
									]),
								_List_fromArray(
									[
										$author$project$VehiclePage$Card$routeTitle(
										_List_fromArray(
											[session.kS, session.le])),
										A6(
										$author$project$VehiclePage$Card$selectDirectionButton,
										session,
										carCategory,
										outwardDetails,
										selectedVehicle.tx,
										0,
										message(0))
									]))
							]))));
			case 1:
				return A2(
					$author$project$VehiclePage$Card$oneWayPrice,
					session.rb,
					A2(
						$elm$core$Maybe$withDefault,
						outwardDetails.lN,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.lN;
								},
								$elm$core$Basics$add(outwardDetails.lN)),
							returnDetails)));
			default:
				return A2($author$project$VehiclePage$Card$oneWayPrice, session.rb, outwardDetails.lN);
		}
	});
var $author$project$VehiclePage$Card$view = F5(
	function (translations, session, maybeAnimated, index, selectedVehicle) {
		var vehicleType = $author$project$Session$getVehicleType(session);
		var currentVehicle = A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jZ;
				},
				$elm$core$Basics$eq(selectedVehicle.jZ)),
			session.tt);
		var panelClass = function (licensePlates) {
			return _List_fromArray(
				[
					_Utils_Tuple2('defaultPanel', licensePlates === 1),
					_Utils_Tuple2('extendedPanel', licensePlates === 2),
					_Utils_Tuple2('shortPanel', !licensePlates)
				]);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.A9;
					},
					currentVehicle)));
		var classListAttr = $elm$html$Html$Attributes$classList(
			_Utils_ap(
				panelClass,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var i = _v0.a;
							var type_ = _v0.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'enter',
									(!type_) && _Utils_eq(index, i)),
									_Utils_Tuple2(
									'leave',
									(type_ === 1) && _Utils_eq(index, i))
								]);
						},
						maybeAnimated))));
		return A2(
			$author$project$Common$Panel$view,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mediumPadding effect-list'),
					A2($elm$html$Html$Attributes$attribute, 'data-test', 'vehiclePanel'),
					A2($elm$html$Html$Attributes$attribute, 'data-effect-type', 'expand-in'),
					classListAttr
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Common$Panel$element,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$VehiclePage$Card$vehicleCardHeader,
									translations,
									selectedVehicle.jZ,
									$author$project$Messages$RemovedVehicleWithAnimation(index)),
									A3(
									$author$project$VehiclePage$Common$vehicleDimensions,
									translations,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('bodyLarge')
										]),
									selectedVehicle.jZ)
								]))
						]),
						A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							[
								A2(
								$author$project$Common$Panel$element,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('vehicleLoader animateSpinner')
													]),
												_List_fromArray(
													[$author$project$Common$Images$darkPropeller]))
											]))
									]))
							]),
						A2(
							$elm$core$Maybe$map,
							function (vehicle) {
								return _Utils_ap(
									A6(
										$author$project$VehiclePage$Common$licencePlateInputGroup,
										translations,
										$author$project$Types$Market$licensePlateHint(session.rb),
										vehicle.A9,
										selectedVehicle.n_,
										selectedVehicle.n$,
										$author$project$Messages$ChangedLicensePlate(index)),
									_List_fromArray(
										[
											A2(
											$author$project$Common$Panel$element,
											_List_Nil,
											_List_fromArray(
												[
													A5($author$project$VehiclePage$Card$renderPrice, session, vehicleType, index, selectedVehicle, vehicle)
												]))
										]));
							},
							currentVehicle))
					])));
	});
var $author$project$VehiclePage$View$selectedVehicleCards = F3(
	function (translations, session, maybeAnimated) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Types$SelectedVehicles$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$indexedMap(
					A3($author$project$VehiclePage$Card$view, translations, session, maybeAnimated)),
				$elm$core$List$reverse));
	});
var $author$project$VehiclePage$View$vehicleCounter = F2(
	function (translations, vehicleCount) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('bodyNorm vehicleCounterText')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(translations.ju)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('data vehicleCounterData')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(vehicleCount))
					]))
			]);
	});
var $author$project$VehiclePage$View$subTitle = F3(
	function (translations, session, maybeMemorizedVehicleAndAvailability) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('subTitle bodyNorm')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				((!session.Ag) && A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$second,
							A2(
								$elm$core$Basics$composeR,
								$author$project$VehiclePage$View$isVehicleSoldOut(session),
								$elm$core$Basics$not)),
						maybeMemorizedVehicleAndAvailability))) ? _List_fromArray(
					[
						$elm$html$Html$text(translations.jm)
					]) : ($author$project$Utils$Route$isVehicleRequired(session) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bodyNorm vehicleCounterText')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(translations.fN)
							]))
					]) : A2($author$project$VehiclePage$View$vehicleCounter, translations, 0)),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Types$SelectedVehicles$countSelected,
						$author$project$VehiclePage$View$vehicleCounter(translations)),
					session.rp)));
	});
var $author$project$VehiclePage$View$content = F4(
	function (translations, session, maybeMemorizedFirstSelectedVehicle, maybeAnimated) {
		var vehicleType = $author$project$Session$getVehicleType(session);
		var maybeMemorizedVehicleAndAvailability = A2(
			$elm$core$Maybe$andThen,
			function (vehicle) {
				return A2(
					$elm$core$Maybe$map,
					function (b) {
						return _Utils_Tuple2(vehicle, b);
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jZ;
							},
							$elm$core$Basics$eq(vehicle.jZ)),
						session.tt));
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Types$SelectedVehicles$remapSelectedVehicleCategory(session.tt),
				maybeMemorizedFirstSelectedVehicle));
		var isToastVisible = A2($elm$core$Basics$composeR, $author$project$Types$SelectedExtraServices$hasVehicleExtraService, $elm$core$Basics$not);
		var maybeExtraServicePageLinkToast = isToastVisible(session.Gi) ? A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var code = _v1.pQ;
				return $author$project$VehiclePage$View$extraServicePageLinkToast(
					$author$project$Translations$toHtml(
						$author$project$Types$ExtraService$isGarage(code) ? translations.jg : translations.jh));
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pQ;
					},
					$author$project$Types$ExtraService$isForVehicles),
				session.qk)) : $elm$core$Maybe$Nothing;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			A2(
				$author$project$Utils$List$maybeAdd,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var selectedVehicle = _v0.a;
						var vehicle = _v0.b;
						return A2(
							$author$project$Utils$String$renderIf,
							_Utils_eq(session.rp, $elm$core$Maybe$Nothing) && ((!A2($author$project$VehiclePage$View$isVehicleSoldOut, session, vehicle)) && (!session.Ag)),
							A5($author$project$VehiclePage$Card$memorizedVehicle, translations, session, vehicleType, vehicle, selectedVehicle));
					},
					maybeMemorizedVehicleAndAvailability),
				_Utils_ap(
					_List_fromArray(
						[
							A3($author$project$VehiclePage$View$subTitle, translations, session, maybeMemorizedVehicleAndAvailability)
						]),
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (selectedVehicles) {
								return A3(
									$elm$core$Basics$apR,
									A2($elm$core$Maybe$map, $elm$core$List$cons, maybeExtraServicePageLinkToast),
									$elm$core$Maybe$withDefault($elm$core$Basics$identity),
									A4($author$project$VehiclePage$View$selectedVehicleCards, translations, session, maybeAnimated, selectedVehicles));
							},
							session.rp)))));
	});
var $author$project$VehiclePage$Header$vehicleButton = F4(
	function (translations, category, isSoldOut, attributes) {
		return A2(
			$elm$html$Html$div,
			A3(
				$author$project$Utils$List$addIf,
				!isSoldOut,
				A2($elm$html$Html$Attributes$attribute, 'data-test', 'available'),
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicleTypeButton itemTypeButton'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('vehicleSoldOut disabledIcon', isSoldOut)
								])),
							A2(
							$elm$html$Html$Attributes$attribute,
							'data-car-category',
							$author$project$Types$Vehicle$carCategoryToString(category))
						]),
					attributes)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicleTypeIcon itemTypeIcon')
						]),
					_List_fromArray(
						[
							$author$project$Common$Images$Vehicles$vehicleImage(
							$author$project$Types$Vehicle$carCategoryToString(category))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicleTypeTitle itemTypeTitle bodySmallBold')
						]),
					$author$project$Translations$toHtml(
						A2($author$project$Types$Vehicle$translateCategory, category, translations))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('plusTick')
						]),
					_List_fromArray(
						[$author$project$Common$Images$plusImage]))
				]));
	});
var $author$project$VehiclePage$Header$dynamicVehicleButton = F5(
	function (translations, didDynamicVehicleChange, isSoldOut, vehicleMsg, vehicle) {
		return A4(
			$author$project$VehiclePage$Header$vehicleButton,
			translations,
			vehicle.jZ,
			isSoldOut,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dynamicVehicleChanged', didDynamicVehicleChange)
						])),
					$elm$html$Html$Events$onClick(
					vehicleMsg(vehicle)),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-test-dynamic-vehicle-changed',
					$author$project$Utils$String$fromBool(didDynamicVehicleChange))
				]));
	});
var $author$project$VehiclePage$Header$getInitialMaybeDynamicVehicle = F2(
	function (vehicles, staticVehicles) {
		var vehiclesWithoutStaticVehicles = A3(
			$author$project$Utils$List$diffBy,
			function ($) {
				return $.jZ;
			},
			vehicles,
			staticVehicles);
		return $elm$core$List$head(vehiclesWithoutStaticVehicles);
	});
var $author$project$VehiclePage$Header$getMaybeDynamicVehicle = F3(
	function (vehicles, staticVehicles, previousCarCategory) {
		var vehiclesWithoutStaticVehicles = A3(
			$author$project$Utils$List$diffBy,
			function ($) {
				return $.jZ;
			},
			vehicles,
			staticVehicles);
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jZ;
				},
				$elm$core$Basics$eq(previousCarCategory)),
			vehiclesWithoutStaticVehicles);
	});
var $author$project$VehiclePage$Header$isVehicleCompletelySoldOut = F2(
	function (selectedVehicles, vehicle) {
		return A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 0, vehicle, selectedVehicles) && A3($author$project$Types$SelectedVehicles$isVehicleSoldOut, 1, vehicle, selectedVehicles);
	});
var $author$project$VehiclePage$Header$regularVehicleButton = F3(
	function (translations, selectedVehicles, vehicle) {
		return A4(
			$author$project$VehiclePage$Header$vehicleButton,
			translations,
			vehicle.jZ,
			A2($author$project$VehiclePage$Header$isVehicleCompletelySoldOut, selectedVehicles, vehicle),
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Messages$ClickedSelectVehicle(
						$author$project$Types$SelectVehicleCallback$SelectedVehicle(vehicle)))
				]));
	});
var $author$project$VehiclePage$Header$showAllVehicles = 'SHOW ALL VEHICLES';
var $author$project$VehiclePage$Header$showAllButton = function (translations) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('vehicleTypeButton itemTypeButton'),
				A2($elm$html$Html$Attributes$attribute, 'data-car-category', $author$project$VehiclePage$Header$showAllVehicles),
				$elm$html$Html$Events$onClick(
				$author$project$Messages$ChangedLocation($author$project$UrlRoute$VehicleList))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('vehicleTypeIcon itemTypeIcon')
					]),
				_List_fromArray(
					[
						$author$project$Common$Images$Vehicles$vehicleImage($author$project$VehiclePage$Header$showAllVehicles)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('vehicleTypeTitle itemTypeTitle bodySmallBold')
					]),
				$author$project$Translations$toHtml(translations.ba)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('plusTick')
					]),
				_List_fromArray(
					[$author$project$Common$Images$plusImage]))
			]));
};
var $author$project$VehiclePage$Header$view = F3(
	function (translations, session, model) {
		var maybeSelectedVehicles = session.rp;
		var vehicles = session.tt;
		var isLoadingVehicles = session.Ag;
		var vehiclesForCorrectAgeCategory = $author$project$Update$Passengers$isInSoloYouthMode(session) ? A2(
			$elm$core$List$filter,
			function (vehicle) {
				return !vehicle.jZ;
			},
			vehicles) : vehicles;
		var selectedVehiclesArray = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Types$SelectedVehicles$toList, maybeSelectedVehicles));
		var maxVehiclesInList = $author$project$VehiclePage$Util$maxVehiclesInList(model.uz);
		var staticVehicles = A2($elm$core$List$take, maxVehiclesInList - 1, vehiclesForCorrectAgeCategory);
		var maybeDynamicVehicle = _Utils_eq(model.lr, $elm$core$Maybe$Nothing) ? A2($author$project$VehiclePage$Header$getInitialMaybeDynamicVehicle, vehiclesForCorrectAgeCategory, staticVehicles) : A2(
			$elm$core$Maybe$andThen,
			A2($author$project$VehiclePage$Header$getMaybeDynamicVehicle, vehiclesForCorrectAgeCategory, staticVehicles),
			model.lr);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('headerHolder')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cell title2')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.pV)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('row')
						]),
					_List_fromArray(
						[
							((!$elm$core$List$isEmpty(vehiclesForCorrectAgeCategory)) && (!isLoadingVehicles)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('vehicleTypeGroup typeGroupButtons')
								]),
							A3(
								$author$project$Utils$List$addIf,
								_Utils_cmp(
									$elm$core$List$length(vehiclesForCorrectAgeCategory),
									maxVehiclesInList) > 0,
								$author$project$VehiclePage$Header$showAllButton(translations),
								A2(
									$author$project$Utils$List$maybeAdd,
									A2(
										$elm$core$Maybe$map,
										function (vehicle) {
											return A5(
												$author$project$VehiclePage$Header$dynamicVehicleButton,
												translations,
												model.ty,
												A2($author$project$VehiclePage$Header$isVehicleCompletelySoldOut, selectedVehiclesArray, vehicle),
												$author$project$Messages$SelectedVehicle,
												vehicle);
										},
										maybeDynamicVehicle),
									A2(
										$elm$core$List$map,
										A2($author$project$VehiclePage$Header$regularVehicleButton, translations, selectedVehiclesArray),
										staticVehicles)))) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('vehiclesLoading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(translations.jv),
									$author$project$Common$Images$darkPropellerWithClassName('animateSpinner')
								]))
						]))
				]));
	});
var $author$project$VehiclePage$View$view = F3(
	function (translations, session, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('vehiclePage page withFixedButton')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('vehicleHeader')
						]),
					_List_fromArray(
						[
							A3($author$project$VehiclePage$Header$view, translations, session, model)
						])),
					A4($author$project$VehiclePage$View$content, translations, session, model.BV, model.n7)
				]));
	});
var $author$project$Price$View$soloYouthPermitToast = function (translations) {
	var toast = {
		nj: true,
		DH: _List_Nil,
		o8: 2,
		pa: function ($) {
			return $.GK;
		}
	};
	return A4($author$project$Common$Toast$view, translations, $elm$core$Maybe$Nothing, toast, 1);
};
var $author$project$Price$View$viewWithButtonAndSoloYouthPermitToast = F3(
	function (translations, model, maybeButtonView) {
		return A3(
			$author$project$Price$View$view,
			translations,
			model,
			$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Utils$Html$Render$maybeRender,
							function (buttonView) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('buttonWrapper')
										]),
									_List_fromArray(
										[
											$author$project$Price$View$buttonToHtml(
											buttonView(translations))
										]));
							},
							maybeButtonView),
							A2(
							$author$project$Utils$Html$Render$renderIf,
							$author$project$Update$Passengers$isInSoloYouthMode(model.j),
							$author$project$Price$View$soloYouthPermitToast(translations))
						]))));
	});
var $author$project$Price$View$viewWithToastOnly = F2(
	function (translations, model) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bar-bottom-fixed'),
					$elm$html$Html$Attributes$id($author$project$Constants$fixedBottomBarId),
					A2($elm$html$Html$Attributes$attribute, 'ui-view', 'price')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var toast = _v0.HO;
						var state = _v0.mW;
						return _List_fromArray(
							[
								A4($author$project$Common$Toast$view, translations, $elm$core$Maybe$Nothing, toast, state)
							]);
					},
					model.HT.L)));
	});
var $author$project$View$view = function (model) {
	var _v0 = model;
	var session = _v0.j;
	var translations = $author$project$Translations$forLanguage(session.A_);
	var _v1 = session;
	var passengers = _v1.Eg;
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('root')
				]),
			$author$project$View$freezeAttributes(model.CC)),
		_Utils_ap(
			function () {
				var _v2 = model.DF;
				switch (_v2.$) {
					case 0:
						return _Utils_ap(
							A3(
								$author$project$View$mainPageSkeleton,
								model,
								true,
								$author$project$Page$Booking$view(model)),
							_List_fromArray(
								[
									A2(
									$author$project$Utils$String$renderIf,
									model.pz.GD,
									A3(
										$author$project$Price$View$viewWithButtonAndSoloYouthPermitToast,
										translations,
										model,
										$author$project$Price$View$isBookNowButtonShown(model) ? $elm$core$Maybe$Just(
											A2($author$project$Price$View$bookNowButton, $author$project$Messages$ClickedBookNow, model.j.Af)) : $elm$core$Maybe$Nothing))
								]));
					case 8:
						return _Utils_ap(
							_List_fromArray(
								[
									A3($author$project$PassengerPage$View$root, translations, session, model.Ea)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Price$View$viewWithButtonAndSoloYouthPermitToast,
									translations,
									model,
									$elm$core$Maybe$Just(
										A2(
											$author$project$Price$View$doneButton,
											_List_Nil,
											$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root))))
								]));
					case 7:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A3($author$project$PassengerDetailsPage$View$view, translations, session, pageModel)
							]);
					case 1:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A3($author$project$TimetablePage$View$view, model.n1, session, pageModel),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2($author$project$Page$Timetable$PriceBar$button, model.n1, model))
							]);
					case 10:
						var pageModel = _v2.a;
						return A3($author$project$View$mealPageView, translations, model, pageModel);
					case 4:
						var _v3 = model.Ev;
						if (!_v3.$) {
							var paymentMethods = _v3.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('paymentPage page')
										]),
									_List_fromArray(
										[
											A2($author$project$View$paymentPageHeader, translations, model),
											A5($author$project$PaymentPage$View$view, translations, model.j, paymentMethods, model.qL, model.Ew)
										])),
									A2($author$project$Price$View$viewWithToastOnly, translations, model)
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('paymentPage page')
										]),
									_List_fromArray(
										[
											A2($author$project$View$paymentPageHeader, translations, model),
											$author$project$PaymentPage$View$errorView(translations)
										]))
								]);
						}
					case 12:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$section,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('klarnaPage page')
									]),
								_List_fromArray(
									[
										A2($author$project$View$paymentPageHeader, translations, model),
										$author$project$KlarnaPaymentPage$View$root
									])),
								A2($author$project$Price$View$viewWithToastOnly, translations, model)
							]);
					case 9:
						return _List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									A2($author$project$TravelClassPage$View$root, translations, model),
									model.j.to)),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 11:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A3($author$project$ContactPersonPage$View$view, translations, session, pageModel)
							]);
					case 5:
						return _List_fromArray(
							[
								A2(
								$author$project$BusTransferPage$View$view,
								translations,
								A2($author$project$BusTransferPage$View$transferList, translations, model)),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 6:
						return _List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Types$Trips$selectedDepartureAndArrivalTimes,
										A2(
											$elm$core$Basics$composeL,
											$author$project$BusTransferPage$View$view(translations),
											A2($author$project$BusTransferPage$View$transfer, translations, model))),
									$author$project$Types$Trips$statusToMaybe(model.j.tp))),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 2:
						return _List_fromArray(
							[
								A3($author$project$VehiclePage$View$view, translations, session, model.Ih),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 3:
						return _List_fromArray(
							[
								A2($author$project$VehiclePage$List$view, translations, session),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 13:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('safePaddingTop')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'background ' + $author$project$Session$getShipBackgroundClassName(session))
											]),
										_List_Nil),
										A2(
										$elm$html$Html$map,
										$author$project$Messages$CompanyCustomerMsg,
										A2($author$project$Page$Company$view, session, pageModel))
									]))
							]);
					case 14:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Messages$OnboardServiceMsg,
								$author$project$Page$OnboardService$View$view(session)),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 15:
						return _List_fromArray(
							[
								$author$project$ExtraServicesPage$View$view(session),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 16:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('safePaddingTop')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												'background ' + $author$project$Session$getShipBackgroundClassName(session))
											]),
										_List_Nil),
										A3($author$project$Page$Discount$View$view, translations, session, pageModel)
									])),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					case 17:
						return A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Messages$LandServiceMsg,
								A2($elm$html$Html$Lazy$lazy, $author$project$LandServicePage$View$view, model.j)),
							_List_fromArray(
								[
									A3(
									$author$project$Price$View$viewWithButton,
									translations,
									model,
									A2(
										$author$project$Price$View$doneButton,
										_List_Nil,
										$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
								]));
					case 18:
						var pageModel = _v2.a;
						return A3(
							$author$project$View$mainPageSkeleton,
							model,
							false,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Messages$HotelLinksMsg,
									$author$project$Page$HotelLinks$view(pageModel))
								]));
					case 19:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Messages$HotelListMsg,
								A2($author$project$Page$HotelList$view, session, pageModel)),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
					default:
						var pageModel = _v2.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Messages$HotelMsg,
								A2($author$project$Page$Hotel$view, session, pageModel)),
								A3(
								$author$project$Price$View$viewWithButton,
								translations,
								model,
								A2(
									$author$project$Price$View$doneButton,
									_List_Nil,
									$author$project$Messages$ChangedLocation($author$project$UrlRoute$Root)))
							]);
				}
			}(),
			_List_fromArray(
				[
					A3($author$project$Common$Modal$View$root, translations, session, model.CC)
				])));
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		zX: F3(
			function (flags, url, key) {
				return A3(
					$author$project$Init$init,
					flags,
					url,
					$author$project$Types$NavKey$realKey(key));
			}),
		C8: $author$project$Messages$UrlChange,
		C9: $author$project$Messages$UrlRequest,
		G2: function (a) {
			return $elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$cons,
					A2(
						$elm$core$Platform$Sub$map,
						$author$project$Messages$GotSingleSignOnToken,
						$author$project$Ports$gotSingleSignOnToken($elm$core$Basics$identity)),
					function () {
						if (a.$ === 1) {
							var model = a.a;
							return _List_fromArray(
								[
									A2(
									$elm$core$Platform$Sub$map,
									$author$project$Messages$Booking,
									$author$project$Subscriptions$subscriptions(model))
								]);
						} else {
							return _List_Nil;
						}
					}()));
		},
		H6: $author$project$Main$update,
		Im: function (a) {
			return {
				ks: _List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sso-component-container')
							]),
						_List_Nil),
						function () {
						switch (a.$) {
							case 1:
								var model = a.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Messages$Booking,
									$author$project$View$view(model));
							case 2:
								var model = a.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Messages$Offline,
									$author$project$ConnectionProblemPage$View$view(model));
							default:
								return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('recaptcha')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('cms-web-consent-root')
							]),
						_List_Nil)
					]),
				HI: 'Online Booking - Tallink Silja Line'
			};
		}
	});
_Platform_export({'Main':{'init':$author$project$Main$main($elm$json$Json$Decode$value)(0)}});}(this));